import { verify_measurement_transparency } from "delta-transparency-verification-wasm";
import require$$4 from "crypto";
var commonjsGlobal = typeof globalThis < "u" ? globalThis : typeof window < "u" ? window : typeof global < "u" ? global : typeof self < "u" ? self : {}, indexMinimal = {}, minimal$1 = {}, aspromise = asPromise;
function asPromise(u, r) {
  for (var a = new Array(arguments.length - 1), e = 0, n = 2, o = !0; n < arguments.length; )
    a[e++] = arguments[n++];
  return new Promise(function(l, d) {
    a[e] = function(h) {
      if (o)
        if (o = !1, h)
          d(h);
        else {
          for (var g = new Array(arguments.length - 1), y = 0; y < g.length; )
            g[y++] = arguments[y];
          l.apply(null, g);
        }
    };
    try {
      u.apply(r || null, a);
    } catch (p) {
      o && (o = !1, d(p));
    }
  });
}
var base64$1 = {};
(function(u) {
  var r = u;
  r.length = function(l) {
    var d = l.length;
    if (!d)
      return 0;
    for (var p = 0; --d % 4 > 1 && l.charAt(d) === "="; )
      ++p;
    return Math.ceil(l.length * 3) / 4 - p;
  };
  for (var a = new Array(64), e = new Array(123), n = 0; n < 64; )
    e[a[n] = n < 26 ? n + 65 : n < 52 ? n + 71 : n < 62 ? n - 4 : n - 59 | 43] = n++;
  r.encode = function(l, d, p) {
    for (var h = null, g = [], y = 0, v = 0, m; d < p; ) {
      var b = l[d++];
      switch (v) {
        case 0:
          g[y++] = a[b >> 2], m = (b & 3) << 4, v = 1;
          break;
        case 1:
          g[y++] = a[m | b >> 4], m = (b & 15) << 2, v = 2;
          break;
        case 2:
          g[y++] = a[m | b >> 6], g[y++] = a[b & 63], v = 0;
          break;
      }
      y > 8191 && ((h || (h = [])).push(String.fromCharCode.apply(String, g)), y = 0);
    }
    return v && (g[y++] = a[m], g[y++] = 61, v === 1 && (g[y++] = 61)), h ? (y && h.push(String.fromCharCode.apply(String, g.slice(0, y))), h.join("")) : String.fromCharCode.apply(String, g.slice(0, y));
  };
  var o = "invalid encoding";
  r.decode = function(l, d, p) {
    for (var h = p, g = 0, y, v = 0; v < l.length; ) {
      var m = l.charCodeAt(v++);
      if (m === 61 && g > 1)
        break;
      if ((m = e[m]) === void 0)
        throw Error(o);
      switch (g) {
        case 0:
          y = m, g = 1;
          break;
        case 1:
          d[p++] = y << 2 | (m & 48) >> 4, y = m, g = 2;
          break;
        case 2:
          d[p++] = (y & 15) << 4 | (m & 60) >> 2, y = m, g = 3;
          break;
        case 3:
          d[p++] = (y & 3) << 6 | m, g = 0;
          break;
      }
    }
    if (g === 1)
      throw Error(o);
    return p - h;
  }, r.test = function(l) {
    return /^(?:[A-Za-z0-9+/]{4})*(?:[A-Za-z0-9+/]{2}==|[A-Za-z0-9+/]{3}=)?$/.test(l);
  };
})(base64$1);
var eventemitter = EventEmitter;
function EventEmitter() {
  this._listeners = {};
}
EventEmitter.prototype.on = function(r, a, e) {
  return (this._listeners[r] || (this._listeners[r] = [])).push({
    fn: a,
    ctx: e || this
  }), this;
};
EventEmitter.prototype.off = function(r, a) {
  if (r === void 0)
    this._listeners = {};
  else if (a === void 0)
    this._listeners[r] = [];
  else
    for (var e = this._listeners[r], n = 0; n < e.length; )
      e[n].fn === a ? e.splice(n, 1) : ++n;
  return this;
};
EventEmitter.prototype.emit = function(r) {
  var a = this._listeners[r];
  if (a) {
    for (var e = [], n = 1; n < arguments.length; )
      e.push(arguments[n++]);
    for (n = 0; n < a.length; )
      a[n].fn.apply(a[n++].ctx, e);
  }
  return this;
};
var float = factory(factory);
function factory(u) {
  return typeof Float32Array < "u" ? function() {
    var r = new Float32Array([-0]), a = new Uint8Array(r.buffer), e = a[3] === 128;
    function n(d, p, h) {
      r[0] = d, p[h] = a[0], p[h + 1] = a[1], p[h + 2] = a[2], p[h + 3] = a[3];
    }
    function o(d, p, h) {
      r[0] = d, p[h] = a[3], p[h + 1] = a[2], p[h + 2] = a[1], p[h + 3] = a[0];
    }
    u.writeFloatLE = e ? n : o, u.writeFloatBE = e ? o : n;
    function c(d, p) {
      return a[0] = d[p], a[1] = d[p + 1], a[2] = d[p + 2], a[3] = d[p + 3], r[0];
    }
    function l(d, p) {
      return a[3] = d[p], a[2] = d[p + 1], a[1] = d[p + 2], a[0] = d[p + 3], r[0];
    }
    u.readFloatLE = e ? c : l, u.readFloatBE = e ? l : c;
  }() : function() {
    function r(e, n, o, c) {
      var l = n < 0 ? 1 : 0;
      if (l && (n = -n), n === 0)
        e(1 / n > 0 ? (
          /* positive */
          0
        ) : (
          /* negative 0 */
          2147483648
        ), o, c);
      else if (isNaN(n))
        e(2143289344, o, c);
      else if (n > 34028234663852886e22)
        e((l << 31 | 2139095040) >>> 0, o, c);
      else if (n < 11754943508222875e-54)
        e((l << 31 | Math.round(n / 1401298464324817e-60)) >>> 0, o, c);
      else {
        var d = Math.floor(Math.log(n) / Math.LN2), p = Math.round(n * Math.pow(2, -d) * 8388608) & 8388607;
        e((l << 31 | d + 127 << 23 | p) >>> 0, o, c);
      }
    }
    u.writeFloatLE = r.bind(null, writeUintLE), u.writeFloatBE = r.bind(null, writeUintBE);
    function a(e, n, o) {
      var c = e(n, o), l = (c >> 31) * 2 + 1, d = c >>> 23 & 255, p = c & 8388607;
      return d === 255 ? p ? NaN : l * (1 / 0) : d === 0 ? l * 1401298464324817e-60 * p : l * Math.pow(2, d - 150) * (p + 8388608);
    }
    u.readFloatLE = a.bind(null, readUintLE), u.readFloatBE = a.bind(null, readUintBE);
  }(), typeof Float64Array < "u" ? function() {
    var r = new Float64Array([-0]), a = new Uint8Array(r.buffer), e = a[7] === 128;
    function n(d, p, h) {
      r[0] = d, p[h] = a[0], p[h + 1] = a[1], p[h + 2] = a[2], p[h + 3] = a[3], p[h + 4] = a[4], p[h + 5] = a[5], p[h + 6] = a[6], p[h + 7] = a[7];
    }
    function o(d, p, h) {
      r[0] = d, p[h] = a[7], p[h + 1] = a[6], p[h + 2] = a[5], p[h + 3] = a[4], p[h + 4] = a[3], p[h + 5] = a[2], p[h + 6] = a[1], p[h + 7] = a[0];
    }
    u.writeDoubleLE = e ? n : o, u.writeDoubleBE = e ? o : n;
    function c(d, p) {
      return a[0] = d[p], a[1] = d[p + 1], a[2] = d[p + 2], a[3] = d[p + 3], a[4] = d[p + 4], a[5] = d[p + 5], a[6] = d[p + 6], a[7] = d[p + 7], r[0];
    }
    function l(d, p) {
      return a[7] = d[p], a[6] = d[p + 1], a[5] = d[p + 2], a[4] = d[p + 3], a[3] = d[p + 4], a[2] = d[p + 5], a[1] = d[p + 6], a[0] = d[p + 7], r[0];
    }
    u.readDoubleLE = e ? c : l, u.readDoubleBE = e ? l : c;
  }() : function() {
    function r(e, n, o, c, l, d) {
      var p = c < 0 ? 1 : 0;
      if (p && (c = -c), c === 0)
        e(0, l, d + n), e(1 / c > 0 ? (
          /* positive */
          0
        ) : (
          /* negative 0 */
          2147483648
        ), l, d + o);
      else if (isNaN(c))
        e(0, l, d + n), e(2146959360, l, d + o);
      else if (c > 17976931348623157e292)
        e(0, l, d + n), e((p << 31 | 2146435072) >>> 0, l, d + o);
      else {
        var h;
        if (c < 22250738585072014e-324)
          h = c / 5e-324, e(h >>> 0, l, d + n), e((p << 31 | h / 4294967296) >>> 0, l, d + o);
        else {
          var g = Math.floor(Math.log(c) / Math.LN2);
          g === 1024 && (g = 1023), h = c * Math.pow(2, -g), e(h * 4503599627370496 >>> 0, l, d + n), e((p << 31 | g + 1023 << 20 | h * 1048576 & 1048575) >>> 0, l, d + o);
        }
      }
    }
    u.writeDoubleLE = r.bind(null, writeUintLE, 0, 4), u.writeDoubleBE = r.bind(null, writeUintBE, 4, 0);
    function a(e, n, o, c, l) {
      var d = e(c, l + n), p = e(c, l + o), h = (p >> 31) * 2 + 1, g = p >>> 20 & 2047, y = 4294967296 * (p & 1048575) + d;
      return g === 2047 ? y ? NaN : h * (1 / 0) : g === 0 ? h * 5e-324 * y : h * Math.pow(2, g - 1075) * (y + 4503599627370496);
    }
    u.readDoubleLE = a.bind(null, readUintLE, 0, 4), u.readDoubleBE = a.bind(null, readUintBE, 4, 0);
  }(), u;
}
function writeUintLE(u, r, a) {
  r[a] = u & 255, r[a + 1] = u >>> 8 & 255, r[a + 2] = u >>> 16 & 255, r[a + 3] = u >>> 24;
}
function writeUintBE(u, r, a) {
  r[a] = u >>> 24, r[a + 1] = u >>> 16 & 255, r[a + 2] = u >>> 8 & 255, r[a + 3] = u & 255;
}
function readUintLE(u, r) {
  return (u[r] | u[r + 1] << 8 | u[r + 2] << 16 | u[r + 3] << 24) >>> 0;
}
function readUintBE(u, r) {
  return (u[r] << 24 | u[r + 1] << 16 | u[r + 2] << 8 | u[r + 3]) >>> 0;
}
var inquire_1 = inquire;
function inquire(moduleName) {
  try {
    var mod = eval("quire".replace(/^/, "re"))(moduleName);
    if (mod && (mod.length || Object.keys(mod).length))
      return mod;
  } catch (u) {
  }
  return null;
}
var utf8$2 = {};
(function(u) {
  var r = u;
  r.length = function(e) {
    for (var n = 0, o = 0, c = 0; c < e.length; ++c)
      o = e.charCodeAt(c), o < 128 ? n += 1 : o < 2048 ? n += 2 : (o & 64512) === 55296 && (e.charCodeAt(c + 1) & 64512) === 56320 ? (++c, n += 4) : n += 3;
    return n;
  }, r.read = function(e, n, o) {
    var c = o - n;
    if (c < 1)
      return "";
    for (var l = null, d = [], p = 0, h; n < o; )
      h = e[n++], h < 128 ? d[p++] = h : h > 191 && h < 224 ? d[p++] = (h & 31) << 6 | e[n++] & 63 : h > 239 && h < 365 ? (h = ((h & 7) << 18 | (e[n++] & 63) << 12 | (e[n++] & 63) << 6 | e[n++] & 63) - 65536, d[p++] = 55296 + (h >> 10), d[p++] = 56320 + (h & 1023)) : d[p++] = (h & 15) << 12 | (e[n++] & 63) << 6 | e[n++] & 63, p > 8191 && ((l || (l = [])).push(String.fromCharCode.apply(String, d)), p = 0);
    return l ? (p && l.push(String.fromCharCode.apply(String, d.slice(0, p))), l.join("")) : String.fromCharCode.apply(String, d.slice(0, p));
  }, r.write = function(e, n, o) {
    for (var c = o, l, d, p = 0; p < e.length; ++p)
      l = e.charCodeAt(p), l < 128 ? n[o++] = l : l < 2048 ? (n[o++] = l >> 6 | 192, n[o++] = l & 63 | 128) : (l & 64512) === 55296 && ((d = e.charCodeAt(p + 1)) & 64512) === 56320 ? (l = 65536 + ((l & 1023) << 10) + (d & 1023), ++p, n[o++] = l >> 18 | 240, n[o++] = l >> 12 & 63 | 128, n[o++] = l >> 6 & 63 | 128, n[o++] = l & 63 | 128) : (n[o++] = l >> 12 | 224, n[o++] = l >> 6 & 63 | 128, n[o++] = l & 63 | 128);
    return o - c;
  };
})(utf8$2);
var pool_1 = pool;
function pool(u, r, a) {
  var e = a || 8192, n = e >>> 1, o = null, c = e;
  return function(d) {
    if (d < 1 || d > n)
      return u(d);
    c + d > e && (o = u(e), c = 0);
    var p = r.call(o, c, c += d);
    return c & 7 && (c = (c | 7) + 1), p;
  };
}
var longbits, hasRequiredLongbits;
function requireLongbits() {
  if (hasRequiredLongbits)
    return longbits;
  hasRequiredLongbits = 1, longbits = r;
  var u = requireMinimal();
  function r(o, c) {
    this.lo = o >>> 0, this.hi = c >>> 0;
  }
  var a = r.zero = new r(0, 0);
  a.toNumber = function() {
    return 0;
  }, a.zzEncode = a.zzDecode = function() {
    return this;
  }, a.length = function() {
    return 1;
  };
  var e = r.zeroHash = "\0\0\0\0\0\0\0\0";
  r.fromNumber = function(c) {
    if (c === 0)
      return a;
    var l = c < 0;
    l && (c = -c);
    var d = c >>> 0, p = (c - d) / 4294967296 >>> 0;
    return l && (p = ~p >>> 0, d = ~d >>> 0, ++d > 4294967295 && (d = 0, ++p > 4294967295 && (p = 0))), new r(d, p);
  }, r.from = function(c) {
    if (typeof c == "number")
      return r.fromNumber(c);
    if (u.isString(c))
      if (u.Long)
        c = u.Long.fromString(c);
      else
        return r.fromNumber(parseInt(c, 10));
    return c.low || c.high ? new r(c.low >>> 0, c.high >>> 0) : a;
  }, r.prototype.toNumber = function(c) {
    if (!c && this.hi >>> 31) {
      var l = ~this.lo + 1 >>> 0, d = ~this.hi >>> 0;
      return l || (d = d + 1 >>> 0), -(l + d * 4294967296);
    }
    return this.lo + this.hi * 4294967296;
  }, r.prototype.toLong = function(c) {
    return u.Long ? new u.Long(this.lo | 0, this.hi | 0, !!c) : { low: this.lo | 0, high: this.hi | 0, unsigned: !!c };
  };
  var n = String.prototype.charCodeAt;
  return r.fromHash = function(c) {
    return c === e ? a : new r(
      (n.call(c, 0) | n.call(c, 1) << 8 | n.call(c, 2) << 16 | n.call(c, 3) << 24) >>> 0,
      (n.call(c, 4) | n.call(c, 5) << 8 | n.call(c, 6) << 16 | n.call(c, 7) << 24) >>> 0
    );
  }, r.prototype.toHash = function() {
    return String.fromCharCode(
      this.lo & 255,
      this.lo >>> 8 & 255,
      this.lo >>> 16 & 255,
      this.lo >>> 24,
      this.hi & 255,
      this.hi >>> 8 & 255,
      this.hi >>> 16 & 255,
      this.hi >>> 24
    );
  }, r.prototype.zzEncode = function() {
    var c = this.hi >> 31;
    return this.hi = ((this.hi << 1 | this.lo >>> 31) ^ c) >>> 0, this.lo = (this.lo << 1 ^ c) >>> 0, this;
  }, r.prototype.zzDecode = function() {
    var c = -(this.lo & 1);
    return this.lo = ((this.lo >>> 1 | this.hi << 31) ^ c) >>> 0, this.hi = (this.hi >>> 1 ^ c) >>> 0, this;
  }, r.prototype.length = function() {
    var c = this.lo, l = (this.lo >>> 28 | this.hi << 4) >>> 0, d = this.hi >>> 24;
    return d === 0 ? l === 0 ? c < 16384 ? c < 128 ? 1 : 2 : c < 2097152 ? 3 : 4 : l < 16384 ? l < 128 ? 5 : 6 : l < 2097152 ? 7 : 8 : d < 128 ? 9 : 10;
  }, longbits;
}
var hasRequiredMinimal;
function requireMinimal() {
  return hasRequiredMinimal || (hasRequiredMinimal = 1, function(u) {
    var r = u;
    r.asPromise = aspromise, r.base64 = base64$1, r.EventEmitter = eventemitter, r.float = float, r.inquire = inquire_1, r.utf8 = utf8$2, r.pool = pool_1, r.LongBits = requireLongbits(), r.isNode = !!(typeof commonjsGlobal < "u" && commonjsGlobal && commonjsGlobal.process && commonjsGlobal.process.versions && commonjsGlobal.process.versions.node), r.global = r.isNode && commonjsGlobal || typeof window < "u" && window || typeof self < "u" && self || commonjsGlobal, r.emptyArray = Object.freeze ? Object.freeze([]) : (
      /* istanbul ignore next */
      []
    ), r.emptyObject = Object.freeze ? Object.freeze({}) : (
      /* istanbul ignore next */
      {}
    ), r.isInteger = Number.isInteger || /* istanbul ignore next */
    function(o) {
      return typeof o == "number" && isFinite(o) && Math.floor(o) === o;
    }, r.isString = function(o) {
      return typeof o == "string" || o instanceof String;
    }, r.isObject = function(o) {
      return o && typeof o == "object";
    }, r.isset = /**
     * Checks if a property on a message is considered to be present.
     * @param {Object} obj Plain object or message instance
     * @param {string} prop Property name
     * @returns {boolean} `true` if considered to be present, otherwise `false`
     */
    r.isSet = function(o, c) {
      var l = o[c];
      return l != null && o.hasOwnProperty(c) ? typeof l != "object" || (Array.isArray(l) ? l.length : Object.keys(l).length) > 0 : !1;
    }, r.Buffer = function() {
      try {
        var n = r.inquire("buffer").Buffer;
        return n.prototype.utf8Write ? n : (
          /* istanbul ignore next */
          null
        );
      } catch {
        return null;
      }
    }(), r._Buffer_from = null, r._Buffer_allocUnsafe = null, r.newBuffer = function(o) {
      return typeof o == "number" ? r.Buffer ? r._Buffer_allocUnsafe(o) : new r.Array(o) : r.Buffer ? r._Buffer_from(o) : typeof Uint8Array > "u" ? o : new Uint8Array(o);
    }, r.Array = typeof Uint8Array < "u" ? Uint8Array : Array, r.Long = /* istanbul ignore next */
    r.global.dcodeIO && /* istanbul ignore next */
    r.global.dcodeIO.Long || /* istanbul ignore next */
    r.global.Long || r.inquire("long"), r.key2Re = /^true|false|0|1$/, r.key32Re = /^-?(?:0|[1-9][0-9]*)$/, r.key64Re = /^(?:[\\x00-\\xff]{8}|-?(?:0|[1-9][0-9]*))$/, r.longToHash = function(o) {
      return o ? r.LongBits.from(o).toHash() : r.LongBits.zeroHash;
    }, r.longFromHash = function(o, c) {
      var l = r.LongBits.fromHash(o);
      return r.Long ? r.Long.fromBits(l.lo, l.hi, c) : l.toNumber(!!c);
    };
    function a(n, o, c) {
      for (var l = Object.keys(o), d = 0; d < l.length; ++d)
        (n[l[d]] === void 0 || !c) && (n[l[d]] = o[l[d]]);
      return n;
    }
    r.merge = a, r.lcFirst = function(o) {
      return o.charAt(0).toLowerCase() + o.substring(1);
    };
    function e(n) {
      function o(c, l) {
        if (!(this instanceof o))
          return new o(c, l);
        Object.defineProperty(this, "message", { get: function() {
          return c;
        } }), Error.captureStackTrace ? Error.captureStackTrace(this, o) : Object.defineProperty(this, "stack", { value: new Error().stack || "" }), l && a(this, l);
      }
      return o.prototype = Object.create(Error.prototype, {
        constructor: {
          value: o,
          writable: !0,
          enumerable: !1,
          configurable: !0
        },
        name: {
          get: function() {
            return n;
          },
          set: void 0,
          enumerable: !1,
          // configurable: false would accurately preserve the behavior of
          // the original, but I'm guessing that was not intentional.
          // For an actual error subclass, this property would
          // be configurable.
          configurable: !0
        },
        toString: {
          value: function() {
            return this.name + ": " + this.message;
          },
          writable: !0,
          enumerable: !1,
          configurable: !0
        }
      }), o;
    }
    r.newError = e, r.ProtocolError = e("ProtocolError"), r.oneOfGetter = function(o) {
      for (var c = {}, l = 0; l < o.length; ++l)
        c[o[l]] = 1;
      return function() {
        for (var d = Object.keys(this), p = d.length - 1; p > -1; --p)
          if (c[d[p]] === 1 && this[d[p]] !== void 0 && this[d[p]] !== null)
            return d[p];
      };
    }, r.oneOfSetter = function(o) {
      return function(c) {
        for (var l = 0; l < o.length; ++l)
          o[l] !== c && delete this[o[l]];
      };
    }, r.toJSONOptions = {
      longs: String,
      enums: String,
      bytes: String,
      json: !0
    }, r._configure = function() {
      var n = r.Buffer;
      if (!n) {
        r._Buffer_from = r._Buffer_allocUnsafe = null;
        return;
      }
      r._Buffer_from = n.from !== Uint8Array.from && n.from || /* istanbul ignore next */
      function(c, l) {
        return new n(c, l);
      }, r._Buffer_allocUnsafe = n.allocUnsafe || /* istanbul ignore next */
      function(c) {
        return new n(c);
      };
    };
  }(minimal$1)), minimal$1;
}
var writer = Writer$1, util$6 = requireMinimal(), BufferWriter$1, LongBits$1 = util$6.LongBits, base64 = util$6.base64, utf8$1 = util$6.utf8;
function Op(u, r, a) {
  this.fn = u, this.len = r, this.next = void 0, this.val = a;
}
function noop() {
}
function State(u) {
  this.head = u.head, this.tail = u.tail, this.len = u.len, this.next = u.states;
}
function Writer$1() {
  this.len = 0, this.head = new Op(noop, 0, 0), this.tail = this.head, this.states = null;
}
var create$3 = function u() {
  return util$6.Buffer ? function() {
    return (Writer$1.create = function() {
      return new BufferWriter$1();
    })();
  } : function() {
    return new Writer$1();
  };
};
Writer$1.create = create$3();
Writer$1.alloc = function u(r) {
  return new util$6.Array(r);
};
util$6.Array !== Array && (Writer$1.alloc = util$6.pool(Writer$1.alloc, util$6.Array.prototype.subarray));
Writer$1.prototype._push = function u(r, a, e) {
  return this.tail = this.tail.next = new Op(r, a, e), this.len += a, this;
};
function writeByte(u, r, a) {
  r[a] = u & 255;
}
function writeVarint32(u, r, a) {
  for (; u > 127; )
    r[a++] = u & 127 | 128, u >>>= 7;
  r[a] = u;
}
function VarintOp(u, r) {
  this.len = u, this.next = void 0, this.val = r;
}
VarintOp.prototype = Object.create(Op.prototype);
VarintOp.prototype.fn = writeVarint32;
Writer$1.prototype.uint32 = function u(r) {
  return this.len += (this.tail = this.tail.next = new VarintOp(
    (r = r >>> 0) < 128 ? 1 : r < 16384 ? 2 : r < 2097152 ? 3 : r < 268435456 ? 4 : 5,
    r
  )).len, this;
};
Writer$1.prototype.int32 = function u(r) {
  return r < 0 ? this._push(writeVarint64, 10, LongBits$1.fromNumber(r)) : this.uint32(r);
};
Writer$1.prototype.sint32 = function u(r) {
  return this.uint32((r << 1 ^ r >> 31) >>> 0);
};
function writeVarint64(u, r, a) {
  for (; u.hi; )
    r[a++] = u.lo & 127 | 128, u.lo = (u.lo >>> 7 | u.hi << 25) >>> 0, u.hi >>>= 7;
  for (; u.lo > 127; )
    r[a++] = u.lo & 127 | 128, u.lo = u.lo >>> 7;
  r[a++] = u.lo;
}
Writer$1.prototype.uint64 = function u(r) {
  var a = LongBits$1.from(r);
  return this._push(writeVarint64, a.length(), a);
};
Writer$1.prototype.int64 = Writer$1.prototype.uint64;
Writer$1.prototype.sint64 = function u(r) {
  var a = LongBits$1.from(r).zzEncode();
  return this._push(writeVarint64, a.length(), a);
};
Writer$1.prototype.bool = function u(r) {
  return this._push(writeByte, 1, r ? 1 : 0);
};
function writeFixed32(u, r, a) {
  r[a] = u & 255, r[a + 1] = u >>> 8 & 255, r[a + 2] = u >>> 16 & 255, r[a + 3] = u >>> 24;
}
Writer$1.prototype.fixed32 = function u(r) {
  return this._push(writeFixed32, 4, r >>> 0);
};
Writer$1.prototype.sfixed32 = Writer$1.prototype.fixed32;
Writer$1.prototype.fixed64 = function u(r) {
  var a = LongBits$1.from(r);
  return this._push(writeFixed32, 4, a.lo)._push(writeFixed32, 4, a.hi);
};
Writer$1.prototype.sfixed64 = Writer$1.prototype.fixed64;
Writer$1.prototype.float = function u(r) {
  return this._push(util$6.float.writeFloatLE, 4, r);
};
Writer$1.prototype.double = function u(r) {
  return this._push(util$6.float.writeDoubleLE, 8, r);
};
var writeBytes = util$6.Array.prototype.set ? function u(r, a, e) {
  a.set(r, e);
} : function u(r, a, e) {
  for (var n = 0; n < r.length; ++n)
    a[e + n] = r[n];
};
Writer$1.prototype.bytes = function u(r) {
  var a = r.length >>> 0;
  if (!a)
    return this._push(writeByte, 1, 0);
  if (util$6.isString(r)) {
    var e = Writer$1.alloc(a = base64.length(r));
    base64.decode(r, e, 0), r = e;
  }
  return this.uint32(a)._push(writeBytes, a, r);
};
Writer$1.prototype.string = function u(r) {
  var a = utf8$1.length(r);
  return a ? this.uint32(a)._push(utf8$1.write, a, r) : this._push(writeByte, 1, 0);
};
Writer$1.prototype.fork = function u() {
  return this.states = new State(this), this.head = this.tail = new Op(noop, 0, 0), this.len = 0, this;
};
Writer$1.prototype.reset = function u() {
  return this.states ? (this.head = this.states.head, this.tail = this.states.tail, this.len = this.states.len, this.states = this.states.next) : (this.head = this.tail = new Op(noop, 0, 0), this.len = 0), this;
};
Writer$1.prototype.ldelim = function u() {
  var r = this.head, a = this.tail, e = this.len;
  return this.reset().uint32(e), e && (this.tail.next = r.next, this.tail = a, this.len += e), this;
};
Writer$1.prototype.finish = function u() {
  for (var r = this.head.next, a = this.constructor.alloc(this.len), e = 0; r; )
    r.fn(r.val, a, e), e += r.len, r = r.next;
  return a;
};
Writer$1._configure = function(u) {
  BufferWriter$1 = u, Writer$1.create = create$3(), BufferWriter$1._configure();
};
var writer_buffer = BufferWriter, Writer = writer;
(BufferWriter.prototype = Object.create(Writer.prototype)).constructor = BufferWriter;
var util$5 = requireMinimal();
function BufferWriter() {
  Writer.call(this);
}
BufferWriter._configure = function() {
  BufferWriter.alloc = util$5._Buffer_allocUnsafe, BufferWriter.writeBytesBuffer = util$5.Buffer && util$5.Buffer.prototype instanceof Uint8Array && util$5.Buffer.prototype.set.name === "set" ? function(r, a, e) {
    a.set(r, e);
  } : function(r, a, e) {
    if (r.copy)
      r.copy(a, e, 0, r.length);
    else
      for (var n = 0; n < r.length; )
        a[e++] = r[n++];
  };
};
BufferWriter.prototype.bytes = function u(r) {
  util$5.isString(r) && (r = util$5._Buffer_from(r, "base64"));
  var a = r.length >>> 0;
  return this.uint32(a), a && this._push(BufferWriter.writeBytesBuffer, a, r), this;
};
function writeStringBuffer(u, r, a) {
  u.length < 40 ? util$5.utf8.write(u, r, a) : r.utf8Write ? r.utf8Write(u, a) : r.write(u, a);
}
BufferWriter.prototype.string = function u(r) {
  var a = util$5.Buffer.byteLength(r);
  return this.uint32(a), a && this._push(writeStringBuffer, a, r), this;
};
BufferWriter._configure();
var reader = Reader$1, util$4 = requireMinimal(), BufferReader$1, LongBits = util$4.LongBits, utf8 = util$4.utf8;
function indexOutOfRange(u, r) {
  return RangeError("index out of range: " + u.pos + " + " + (r || 1) + " > " + u.len);
}
function Reader$1(u) {
  this.buf = u, this.pos = 0, this.len = u.length;
}
var create_array = typeof Uint8Array < "u" ? function u(r) {
  if (r instanceof Uint8Array || Array.isArray(r))
    return new Reader$1(r);
  throw Error("illegal buffer");
} : function u(r) {
  if (Array.isArray(r))
    return new Reader$1(r);
  throw Error("illegal buffer");
}, create$2 = function u() {
  return util$4.Buffer ? function(a) {
    return (Reader$1.create = function(n) {
      return util$4.Buffer.isBuffer(n) ? new BufferReader$1(n) : create_array(n);
    })(a);
  } : create_array;
};
Reader$1.create = create$2();
Reader$1.prototype._slice = util$4.Array.prototype.subarray || /* istanbul ignore next */
util$4.Array.prototype.slice;
Reader$1.prototype.uint32 = /* @__PURE__ */ function u() {
  var r = 4294967295;
  return function() {
    if (r = (this.buf[this.pos] & 127) >>> 0, this.buf[this.pos++] < 128 || (r = (r | (this.buf[this.pos] & 127) << 7) >>> 0, this.buf[this.pos++] < 128) || (r = (r | (this.buf[this.pos] & 127) << 14) >>> 0, this.buf[this.pos++] < 128) || (r = (r | (this.buf[this.pos] & 127) << 21) >>> 0, this.buf[this.pos++] < 128) || (r = (r | (this.buf[this.pos] & 15) << 28) >>> 0, this.buf[this.pos++] < 128))
      return r;
    if ((this.pos += 5) > this.len)
      throw this.pos = this.len, indexOutOfRange(this, 10);
    return r;
  };
}();
Reader$1.prototype.int32 = function u() {
  return this.uint32() | 0;
};
Reader$1.prototype.sint32 = function u() {
  var r = this.uint32();
  return r >>> 1 ^ -(r & 1) | 0;
};
function readLongVarint() {
  var u = new LongBits(0, 0), r = 0;
  if (this.len - this.pos > 4) {
    for (; r < 4; ++r)
      if (u.lo = (u.lo | (this.buf[this.pos] & 127) << r * 7) >>> 0, this.buf[this.pos++] < 128)
        return u;
    if (u.lo = (u.lo | (this.buf[this.pos] & 127) << 28) >>> 0, u.hi = (u.hi | (this.buf[this.pos] & 127) >> 4) >>> 0, this.buf[this.pos++] < 128)
      return u;
    r = 0;
  } else {
    for (; r < 3; ++r) {
      if (this.pos >= this.len)
        throw indexOutOfRange(this);
      if (u.lo = (u.lo | (this.buf[this.pos] & 127) << r * 7) >>> 0, this.buf[this.pos++] < 128)
        return u;
    }
    return u.lo = (u.lo | (this.buf[this.pos++] & 127) << r * 7) >>> 0, u;
  }
  if (this.len - this.pos > 4) {
    for (; r < 5; ++r)
      if (u.hi = (u.hi | (this.buf[this.pos] & 127) << r * 7 + 3) >>> 0, this.buf[this.pos++] < 128)
        return u;
  } else
    for (; r < 5; ++r) {
      if (this.pos >= this.len)
        throw indexOutOfRange(this);
      if (u.hi = (u.hi | (this.buf[this.pos] & 127) << r * 7 + 3) >>> 0, this.buf[this.pos++] < 128)
        return u;
    }
  throw Error("invalid varint encoding");
}
Reader$1.prototype.bool = function u() {
  return this.uint32() !== 0;
};
function readFixed32_end(u, r) {
  return (u[r - 4] | u[r - 3] << 8 | u[r - 2] << 16 | u[r - 1] << 24) >>> 0;
}
Reader$1.prototype.fixed32 = function u() {
  if (this.pos + 4 > this.len)
    throw indexOutOfRange(this, 4);
  return readFixed32_end(this.buf, this.pos += 4);
};
Reader$1.prototype.sfixed32 = function u() {
  if (this.pos + 4 > this.len)
    throw indexOutOfRange(this, 4);
  return readFixed32_end(this.buf, this.pos += 4) | 0;
};
function readFixed64() {
  if (this.pos + 8 > this.len)
    throw indexOutOfRange(this, 8);
  return new LongBits(readFixed32_end(this.buf, this.pos += 4), readFixed32_end(this.buf, this.pos += 4));
}
Reader$1.prototype.float = function u() {
  if (this.pos + 4 > this.len)
    throw indexOutOfRange(this, 4);
  var r = util$4.float.readFloatLE(this.buf, this.pos);
  return this.pos += 4, r;
};
Reader$1.prototype.double = function u() {
  if (this.pos + 8 > this.len)
    throw indexOutOfRange(this, 4);
  var r = util$4.float.readDoubleLE(this.buf, this.pos);
  return this.pos += 8, r;
};
Reader$1.prototype.bytes = function u() {
  var r = this.uint32(), a = this.pos, e = this.pos + r;
  if (e > this.len)
    throw indexOutOfRange(this, r);
  if (this.pos += r, Array.isArray(this.buf))
    return this.buf.slice(a, e);
  if (a === e) {
    var n = util$4.Buffer;
    return n ? n.alloc(0) : new this.buf.constructor(0);
  }
  return this._slice.call(this.buf, a, e);
};
Reader$1.prototype.string = function u() {
  var r = this.bytes();
  return utf8.read(r, 0, r.length);
};
Reader$1.prototype.skip = function u(r) {
  if (typeof r == "number") {
    if (this.pos + r > this.len)
      throw indexOutOfRange(this, r);
    this.pos += r;
  } else
    do
      if (this.pos >= this.len)
        throw indexOutOfRange(this);
    while (this.buf[this.pos++] & 128);
  return this;
};
Reader$1.prototype.skipType = function(u) {
  switch (u) {
    case 0:
      this.skip();
      break;
    case 1:
      this.skip(8);
      break;
    case 2:
      this.skip(this.uint32());
      break;
    case 3:
      for (; (u = this.uint32() & 7) !== 4; )
        this.skipType(u);
      break;
    case 5:
      this.skip(4);
      break;
    default:
      throw Error("invalid wire type " + u + " at offset " + this.pos);
  }
  return this;
};
Reader$1._configure = function(u) {
  BufferReader$1 = u, Reader$1.create = create$2(), BufferReader$1._configure();
  var r = util$4.Long ? "toLong" : (
    /* istanbul ignore next */
    "toNumber"
  );
  util$4.merge(Reader$1.prototype, {
    int64: function() {
      return readLongVarint.call(this)[r](!1);
    },
    uint64: function() {
      return readLongVarint.call(this)[r](!0);
    },
    sint64: function() {
      return readLongVarint.call(this).zzDecode()[r](!1);
    },
    fixed64: function() {
      return readFixed64.call(this)[r](!0);
    },
    sfixed64: function() {
      return readFixed64.call(this)[r](!1);
    }
  });
};
var reader_buffer = BufferReader, Reader = reader;
(BufferReader.prototype = Object.create(Reader.prototype)).constructor = BufferReader;
var util$3 = requireMinimal();
function BufferReader(u) {
  Reader.call(this, u);
}
BufferReader._configure = function() {
  util$3.Buffer && (BufferReader.prototype._slice = util$3.Buffer.prototype.slice);
};
BufferReader.prototype.string = function u() {
  var r = this.uint32();
  return this.buf.utf8Slice ? this.buf.utf8Slice(this.pos, this.pos = Math.min(this.pos + r, this.len)) : this.buf.toString("utf-8", this.pos, this.pos = Math.min(this.pos + r, this.len));
};
BufferReader._configure();
var rpc = {}, service = Service, util$2 = requireMinimal();
(Service.prototype = Object.create(util$2.EventEmitter.prototype)).constructor = Service;
function Service(u, r, a) {
  if (typeof u != "function")
    throw TypeError("rpcImpl must be a function");
  util$2.EventEmitter.call(this), this.rpcImpl = u, this.requestDelimited = !!r, this.responseDelimited = !!a;
}
Service.prototype.rpcCall = function u(r, a, e, n, o) {
  if (!n)
    throw TypeError("request must be specified");
  var c = this;
  if (!o)
    return util$2.asPromise(u, c, r, a, e, n);
  if (!c.rpcImpl) {
    setTimeout(function() {
      o(Error("already ended"));
    }, 0);
    return;
  }
  try {
    return c.rpcImpl(
      r,
      a[c.requestDelimited ? "encodeDelimited" : "encode"](n).finish(),
      function(d, p) {
        if (d)
          return c.emit("error", d, r), o(d);
        if (p === null) {
          c.end(
            /* endedByRPC */
            !0
          );
          return;
        }
        if (!(p instanceof e))
          try {
            p = e[c.responseDelimited ? "decodeDelimited" : "decode"](p);
          } catch (h) {
            return c.emit("error", h, r), o(h);
          }
        return c.emit("data", p, r), o(null, p);
      }
    );
  } catch (l) {
    c.emit("error", l, r), setTimeout(function() {
      o(l);
    }, 0);
    return;
  }
};
Service.prototype.end = function u(r) {
  return this.rpcImpl && (r || this.rpcImpl(null, null, null), this.rpcImpl = null, this.emit("end").off()), this;
};
(function(u) {
  var r = u;
  r.Service = service;
})(rpc);
var roots = {};
(function(u) {
  var r = u;
  r.build = "minimal", r.Writer = writer, r.BufferWriter = writer_buffer, r.Reader = reader, r.BufferReader = reader_buffer, r.util = requireMinimal(), r.rpc = rpc, r.roots = roots, r.configure = a;
  function a() {
    r.util._configure(), r.Writer._configure(r.BufferWriter), r.Reader._configure(r.BufferReader);
  }
  a();
})(indexMinimal);
var minimal = indexMinimal;
const $Reader = minimal.Reader, $Writer = minimal.Writer, $util = minimal.util, $root = minimal.roots.default || (minimal.roots.default = {}), attestation = $root.attestation = (() => {
  const u = {};
  return u.Fatquote = function() {
    function r(e) {
      if (e)
        for (let n = Object.keys(e), o = 0; o < n.length; ++o)
          e[n[o]] != null && (this[n[o]] = e[n[o]]);
    }
    r.prototype.epid = null, r.prototype.dcap = null, r.prototype.nitro = null, r.prototype.snp = null, r.prototype.dcapMrsigner = null;
    let a;
    return Object.defineProperty(r.prototype, "fatquote", {
      get: $util.oneOfGetter(a = ["epid", "dcap", "nitro", "snp", "dcapMrsigner"]),
      set: $util.oneOfSetter(a)
    }), r.create = function(n) {
      return new r(n);
    }, r.encode = function(n, o) {
      return o || (o = $Writer.create()), n.epid != null && Object.hasOwnProperty.call(n, "epid") && $root.attestation.FatquoteEpid.encode(n.epid, o.uint32(
        /* id 1, wireType 2 =*/
        10
      ).fork()).ldelim(), n.dcap != null && Object.hasOwnProperty.call(n, "dcap") && $root.attestation.FatquoteDcap.encode(n.dcap, o.uint32(
        /* id 2, wireType 2 =*/
        18
      ).fork()).ldelim(), n.nitro != null && Object.hasOwnProperty.call(n, "nitro") && $root.attestation.FatquoteNitro.encode(n.nitro, o.uint32(
        /* id 3, wireType 2 =*/
        26
      ).fork()).ldelim(), n.snp != null && Object.hasOwnProperty.call(n, "snp") && $root.attestation.FatquoteSnp.encode(n.snp, o.uint32(
        /* id 4, wireType 2 =*/
        34
      ).fork()).ldelim(), n.dcapMrsigner != null && Object.hasOwnProperty.call(n, "dcapMrsigner") && $root.attestation.FatquoteDcapMrsigner.encode(n.dcapMrsigner, o.uint32(
        /* id 5, wireType 2 =*/
        42
      ).fork()).ldelim(), o;
    }, r.encodeDelimited = function(n, o) {
      return this.encode(n, o).ldelim();
    }, r.decode = function(n, o) {
      n instanceof $Reader || (n = $Reader.create(n));
      let c = o === void 0 ? n.len : n.pos + o, l = new $root.attestation.Fatquote();
      for (; n.pos < c; ) {
        let d = n.uint32();
        switch (d >>> 3) {
          case 1: {
            l.epid = $root.attestation.FatquoteEpid.decode(n, n.uint32());
            break;
          }
          case 2: {
            l.dcap = $root.attestation.FatquoteDcap.decode(n, n.uint32());
            break;
          }
          case 3: {
            l.nitro = $root.attestation.FatquoteNitro.decode(n, n.uint32());
            break;
          }
          case 4: {
            l.snp = $root.attestation.FatquoteSnp.decode(n, n.uint32());
            break;
          }
          case 5: {
            l.dcapMrsigner = $root.attestation.FatquoteDcapMrsigner.decode(n, n.uint32());
            break;
          }
          default:
            n.skipType(d & 7);
            break;
        }
      }
      return l;
    }, r.decodeDelimited = function(n) {
      return n instanceof $Reader || (n = new $Reader(n)), this.decode(n, n.uint32());
    }, r.verify = function(n) {
      if (typeof n != "object" || n === null)
        return "object expected";
      let o = {};
      if (n.epid != null && n.hasOwnProperty("epid")) {
        o.fatquote = 1;
        {
          let c = $root.attestation.FatquoteEpid.verify(n.epid);
          if (c)
            return "epid." + c;
        }
      }
      if (n.dcap != null && n.hasOwnProperty("dcap")) {
        if (o.fatquote === 1)
          return "fatquote: multiple values";
        o.fatquote = 1;
        {
          let c = $root.attestation.FatquoteDcap.verify(n.dcap);
          if (c)
            return "dcap." + c;
        }
      }
      if (n.nitro != null && n.hasOwnProperty("nitro")) {
        if (o.fatquote === 1)
          return "fatquote: multiple values";
        o.fatquote = 1;
        {
          let c = $root.attestation.FatquoteNitro.verify(n.nitro);
          if (c)
            return "nitro." + c;
        }
      }
      if (n.snp != null && n.hasOwnProperty("snp")) {
        if (o.fatquote === 1)
          return "fatquote: multiple values";
        o.fatquote = 1;
        {
          let c = $root.attestation.FatquoteSnp.verify(n.snp);
          if (c)
            return "snp." + c;
        }
      }
      if (n.dcapMrsigner != null && n.hasOwnProperty("dcapMrsigner")) {
        if (o.fatquote === 1)
          return "fatquote: multiple values";
        o.fatquote = 1;
        {
          let c = $root.attestation.FatquoteDcapMrsigner.verify(n.dcapMrsigner);
          if (c)
            return "dcapMrsigner." + c;
        }
      }
      return null;
    }, r.fromObject = function(n) {
      if (n instanceof $root.attestation.Fatquote)
        return n;
      let o = new $root.attestation.Fatquote();
      if (n.epid != null) {
        if (typeof n.epid != "object")
          throw TypeError(".attestation.Fatquote.epid: object expected");
        o.epid = $root.attestation.FatquoteEpid.fromObject(n.epid);
      }
      if (n.dcap != null) {
        if (typeof n.dcap != "object")
          throw TypeError(".attestation.Fatquote.dcap: object expected");
        o.dcap = $root.attestation.FatquoteDcap.fromObject(n.dcap);
      }
      if (n.nitro != null) {
        if (typeof n.nitro != "object")
          throw TypeError(".attestation.Fatquote.nitro: object expected");
        o.nitro = $root.attestation.FatquoteNitro.fromObject(n.nitro);
      }
      if (n.snp != null) {
        if (typeof n.snp != "object")
          throw TypeError(".attestation.Fatquote.snp: object expected");
        o.snp = $root.attestation.FatquoteSnp.fromObject(n.snp);
      }
      if (n.dcapMrsigner != null) {
        if (typeof n.dcapMrsigner != "object")
          throw TypeError(".attestation.Fatquote.dcapMrsigner: object expected");
        o.dcapMrsigner = $root.attestation.FatquoteDcapMrsigner.fromObject(n.dcapMrsigner);
      }
      return o;
    }, r.toObject = function(n, o) {
      o || (o = {});
      let c = {};
      return n.epid != null && n.hasOwnProperty("epid") && (c.epid = $root.attestation.FatquoteEpid.toObject(n.epid, o), o.oneofs && (c.fatquote = "epid")), n.dcap != null && n.hasOwnProperty("dcap") && (c.dcap = $root.attestation.FatquoteDcap.toObject(n.dcap, o), o.oneofs && (c.fatquote = "dcap")), n.nitro != null && n.hasOwnProperty("nitro") && (c.nitro = $root.attestation.FatquoteNitro.toObject(n.nitro, o), o.oneofs && (c.fatquote = "nitro")), n.snp != null && n.hasOwnProperty("snp") && (c.snp = $root.attestation.FatquoteSnp.toObject(n.snp, o), o.oneofs && (c.fatquote = "snp")), n.dcapMrsigner != null && n.hasOwnProperty("dcapMrsigner") && (c.dcapMrsigner = $root.attestation.FatquoteDcapMrsigner.toObject(n.dcapMrsigner, o), o.oneofs && (c.fatquote = "dcapMrsigner")), c;
    }, r.prototype.toJSON = function() {
      return this.constructor.toObject(this, minimal.util.toJSONOptions);
    }, r.getTypeUrl = function(n) {
      return n === void 0 && (n = "type.googleapis.com"), n + "/attestation.Fatquote";
    }, r;
  }(), u.FatquoteEpid = function() {
    function r(a) {
      if (a)
        for (let e = Object.keys(a), n = 0; n < e.length; ++n)
          a[e[n]] != null && (this[e[n]] = a[e[n]]);
    }
    return r.prototype.iasResponseBody = $util.newBuffer([]), r.prototype.iasCertificate = $util.newBuffer([]), r.prototype.iasSignature = $util.newBuffer([]), r.prototype.iasRootCaDer = $util.newBuffer([]), r.create = function(e) {
      return new r(e);
    }, r.encode = function(e, n) {
      return n || (n = $Writer.create()), e.iasResponseBody != null && Object.hasOwnProperty.call(e, "iasResponseBody") && n.uint32(
        /* id 1, wireType 2 =*/
        10
      ).bytes(e.iasResponseBody), e.iasCertificate != null && Object.hasOwnProperty.call(e, "iasCertificate") && n.uint32(
        /* id 2, wireType 2 =*/
        18
      ).bytes(e.iasCertificate), e.iasSignature != null && Object.hasOwnProperty.call(e, "iasSignature") && n.uint32(
        /* id 3, wireType 2 =*/
        26
      ).bytes(e.iasSignature), e.iasRootCaDer != null && Object.hasOwnProperty.call(e, "iasRootCaDer") && n.uint32(
        /* id 4, wireType 2 =*/
        34
      ).bytes(e.iasRootCaDer), n;
    }, r.encodeDelimited = function(e, n) {
      return this.encode(e, n).ldelim();
    }, r.decode = function(e, n) {
      e instanceof $Reader || (e = $Reader.create(e));
      let o = n === void 0 ? e.len : e.pos + n, c = new $root.attestation.FatquoteEpid();
      for (; e.pos < o; ) {
        let l = e.uint32();
        switch (l >>> 3) {
          case 1: {
            c.iasResponseBody = e.bytes();
            break;
          }
          case 2: {
            c.iasCertificate = e.bytes();
            break;
          }
          case 3: {
            c.iasSignature = e.bytes();
            break;
          }
          case 4: {
            c.iasRootCaDer = e.bytes();
            break;
          }
          default:
            e.skipType(l & 7);
            break;
        }
      }
      return c;
    }, r.decodeDelimited = function(e) {
      return e instanceof $Reader || (e = new $Reader(e)), this.decode(e, e.uint32());
    }, r.verify = function(e) {
      return typeof e != "object" || e === null ? "object expected" : e.iasResponseBody != null && e.hasOwnProperty("iasResponseBody") && !(e.iasResponseBody && typeof e.iasResponseBody.length == "number" || $util.isString(e.iasResponseBody)) ? "iasResponseBody: buffer expected" : e.iasCertificate != null && e.hasOwnProperty("iasCertificate") && !(e.iasCertificate && typeof e.iasCertificate.length == "number" || $util.isString(e.iasCertificate)) ? "iasCertificate: buffer expected" : e.iasSignature != null && e.hasOwnProperty("iasSignature") && !(e.iasSignature && typeof e.iasSignature.length == "number" || $util.isString(e.iasSignature)) ? "iasSignature: buffer expected" : e.iasRootCaDer != null && e.hasOwnProperty("iasRootCaDer") && !(e.iasRootCaDer && typeof e.iasRootCaDer.length == "number" || $util.isString(e.iasRootCaDer)) ? "iasRootCaDer: buffer expected" : null;
    }, r.fromObject = function(e) {
      if (e instanceof $root.attestation.FatquoteEpid)
        return e;
      let n = new $root.attestation.FatquoteEpid();
      return e.iasResponseBody != null && (typeof e.iasResponseBody == "string" ? $util.base64.decode(e.iasResponseBody, n.iasResponseBody = $util.newBuffer($util.base64.length(e.iasResponseBody)), 0) : e.iasResponseBody.length >= 0 && (n.iasResponseBody = e.iasResponseBody)), e.iasCertificate != null && (typeof e.iasCertificate == "string" ? $util.base64.decode(e.iasCertificate, n.iasCertificate = $util.newBuffer($util.base64.length(e.iasCertificate)), 0) : e.iasCertificate.length >= 0 && (n.iasCertificate = e.iasCertificate)), e.iasSignature != null && (typeof e.iasSignature == "string" ? $util.base64.decode(e.iasSignature, n.iasSignature = $util.newBuffer($util.base64.length(e.iasSignature)), 0) : e.iasSignature.length >= 0 && (n.iasSignature = e.iasSignature)), e.iasRootCaDer != null && (typeof e.iasRootCaDer == "string" ? $util.base64.decode(e.iasRootCaDer, n.iasRootCaDer = $util.newBuffer($util.base64.length(e.iasRootCaDer)), 0) : e.iasRootCaDer.length >= 0 && (n.iasRootCaDer = e.iasRootCaDer)), n;
    }, r.toObject = function(e, n) {
      n || (n = {});
      let o = {};
      return n.defaults && (n.bytes === String ? o.iasResponseBody = "" : (o.iasResponseBody = [], n.bytes !== Array && (o.iasResponseBody = $util.newBuffer(o.iasResponseBody))), n.bytes === String ? o.iasCertificate = "" : (o.iasCertificate = [], n.bytes !== Array && (o.iasCertificate = $util.newBuffer(o.iasCertificate))), n.bytes === String ? o.iasSignature = "" : (o.iasSignature = [], n.bytes !== Array && (o.iasSignature = $util.newBuffer(o.iasSignature))), n.bytes === String ? o.iasRootCaDer = "" : (o.iasRootCaDer = [], n.bytes !== Array && (o.iasRootCaDer = $util.newBuffer(o.iasRootCaDer)))), e.iasResponseBody != null && e.hasOwnProperty("iasResponseBody") && (o.iasResponseBody = n.bytes === String ? $util.base64.encode(e.iasResponseBody, 0, e.iasResponseBody.length) : n.bytes === Array ? Array.prototype.slice.call(e.iasResponseBody) : e.iasResponseBody), e.iasCertificate != null && e.hasOwnProperty("iasCertificate") && (o.iasCertificate = n.bytes === String ? $util.base64.encode(e.iasCertificate, 0, e.iasCertificate.length) : n.bytes === Array ? Array.prototype.slice.call(e.iasCertificate) : e.iasCertificate), e.iasSignature != null && e.hasOwnProperty("iasSignature") && (o.iasSignature = n.bytes === String ? $util.base64.encode(e.iasSignature, 0, e.iasSignature.length) : n.bytes === Array ? Array.prototype.slice.call(e.iasSignature) : e.iasSignature), e.iasRootCaDer != null && e.hasOwnProperty("iasRootCaDer") && (o.iasRootCaDer = n.bytes === String ? $util.base64.encode(e.iasRootCaDer, 0, e.iasRootCaDer.length) : n.bytes === Array ? Array.prototype.slice.call(e.iasRootCaDer) : e.iasRootCaDer), o;
    }, r.prototype.toJSON = function() {
      return this.constructor.toObject(this, minimal.util.toJSONOptions);
    }, r.getTypeUrl = function(e) {
      return e === void 0 && (e = "type.googleapis.com"), e + "/attestation.FatquoteEpid";
    }, r;
  }(), u.FatquoteDcap = function() {
    function r(a) {
      if (a)
        for (let e = Object.keys(a), n = 0; n < e.length; ++n)
          a[e[n]] != null && (this[e[n]] = a[e[n]]);
    }
    return r.prototype.dcapQuote = $util.newBuffer([]), r.prototype.tcbInfo = $util.newBuffer([]), r.prototype.qeIdentity = $util.newBuffer([]), r.prototype.tcbSignCert = $util.newBuffer([]), r.prototype.qeSignCert = $util.newBuffer([]), r.prototype.dcapRootCaDer = $util.newBuffer([]), r.create = function(e) {
      return new r(e);
    }, r.encode = function(e, n) {
      return n || (n = $Writer.create()), e.dcapQuote != null && Object.hasOwnProperty.call(e, "dcapQuote") && n.uint32(
        /* id 1, wireType 2 =*/
        10
      ).bytes(e.dcapQuote), e.tcbInfo != null && Object.hasOwnProperty.call(e, "tcbInfo") && n.uint32(
        /* id 2, wireType 2 =*/
        18
      ).bytes(e.tcbInfo), e.qeIdentity != null && Object.hasOwnProperty.call(e, "qeIdentity") && n.uint32(
        /* id 3, wireType 2 =*/
        26
      ).bytes(e.qeIdentity), e.tcbSignCert != null && Object.hasOwnProperty.call(e, "tcbSignCert") && n.uint32(
        /* id 4, wireType 2 =*/
        34
      ).bytes(e.tcbSignCert), e.qeSignCert != null && Object.hasOwnProperty.call(e, "qeSignCert") && n.uint32(
        /* id 5, wireType 2 =*/
        42
      ).bytes(e.qeSignCert), e.dcapRootCaDer != null && Object.hasOwnProperty.call(e, "dcapRootCaDer") && n.uint32(
        /* id 6, wireType 2 =*/
        50
      ).bytes(e.dcapRootCaDer), n;
    }, r.encodeDelimited = function(e, n) {
      return this.encode(e, n).ldelim();
    }, r.decode = function(e, n) {
      e instanceof $Reader || (e = $Reader.create(e));
      let o = n === void 0 ? e.len : e.pos + n, c = new $root.attestation.FatquoteDcap();
      for (; e.pos < o; ) {
        let l = e.uint32();
        switch (l >>> 3) {
          case 1: {
            c.dcapQuote = e.bytes();
            break;
          }
          case 2: {
            c.tcbInfo = e.bytes();
            break;
          }
          case 3: {
            c.qeIdentity = e.bytes();
            break;
          }
          case 4: {
            c.tcbSignCert = e.bytes();
            break;
          }
          case 5: {
            c.qeSignCert = e.bytes();
            break;
          }
          case 6: {
            c.dcapRootCaDer = e.bytes();
            break;
          }
          default:
            e.skipType(l & 7);
            break;
        }
      }
      return c;
    }, r.decodeDelimited = function(e) {
      return e instanceof $Reader || (e = new $Reader(e)), this.decode(e, e.uint32());
    }, r.verify = function(e) {
      return typeof e != "object" || e === null ? "object expected" : e.dcapQuote != null && e.hasOwnProperty("dcapQuote") && !(e.dcapQuote && typeof e.dcapQuote.length == "number" || $util.isString(e.dcapQuote)) ? "dcapQuote: buffer expected" : e.tcbInfo != null && e.hasOwnProperty("tcbInfo") && !(e.tcbInfo && typeof e.tcbInfo.length == "number" || $util.isString(e.tcbInfo)) ? "tcbInfo: buffer expected" : e.qeIdentity != null && e.hasOwnProperty("qeIdentity") && !(e.qeIdentity && typeof e.qeIdentity.length == "number" || $util.isString(e.qeIdentity)) ? "qeIdentity: buffer expected" : e.tcbSignCert != null && e.hasOwnProperty("tcbSignCert") && !(e.tcbSignCert && typeof e.tcbSignCert.length == "number" || $util.isString(e.tcbSignCert)) ? "tcbSignCert: buffer expected" : e.qeSignCert != null && e.hasOwnProperty("qeSignCert") && !(e.qeSignCert && typeof e.qeSignCert.length == "number" || $util.isString(e.qeSignCert)) ? "qeSignCert: buffer expected" : e.dcapRootCaDer != null && e.hasOwnProperty("dcapRootCaDer") && !(e.dcapRootCaDer && typeof e.dcapRootCaDer.length == "number" || $util.isString(e.dcapRootCaDer)) ? "dcapRootCaDer: buffer expected" : null;
    }, r.fromObject = function(e) {
      if (e instanceof $root.attestation.FatquoteDcap)
        return e;
      let n = new $root.attestation.FatquoteDcap();
      return e.dcapQuote != null && (typeof e.dcapQuote == "string" ? $util.base64.decode(e.dcapQuote, n.dcapQuote = $util.newBuffer($util.base64.length(e.dcapQuote)), 0) : e.dcapQuote.length >= 0 && (n.dcapQuote = e.dcapQuote)), e.tcbInfo != null && (typeof e.tcbInfo == "string" ? $util.base64.decode(e.tcbInfo, n.tcbInfo = $util.newBuffer($util.base64.length(e.tcbInfo)), 0) : e.tcbInfo.length >= 0 && (n.tcbInfo = e.tcbInfo)), e.qeIdentity != null && (typeof e.qeIdentity == "string" ? $util.base64.decode(e.qeIdentity, n.qeIdentity = $util.newBuffer($util.base64.length(e.qeIdentity)), 0) : e.qeIdentity.length >= 0 && (n.qeIdentity = e.qeIdentity)), e.tcbSignCert != null && (typeof e.tcbSignCert == "string" ? $util.base64.decode(e.tcbSignCert, n.tcbSignCert = $util.newBuffer($util.base64.length(e.tcbSignCert)), 0) : e.tcbSignCert.length >= 0 && (n.tcbSignCert = e.tcbSignCert)), e.qeSignCert != null && (typeof e.qeSignCert == "string" ? $util.base64.decode(e.qeSignCert, n.qeSignCert = $util.newBuffer($util.base64.length(e.qeSignCert)), 0) : e.qeSignCert.length >= 0 && (n.qeSignCert = e.qeSignCert)), e.dcapRootCaDer != null && (typeof e.dcapRootCaDer == "string" ? $util.base64.decode(e.dcapRootCaDer, n.dcapRootCaDer = $util.newBuffer($util.base64.length(e.dcapRootCaDer)), 0) : e.dcapRootCaDer.length >= 0 && (n.dcapRootCaDer = e.dcapRootCaDer)), n;
    }, r.toObject = function(e, n) {
      n || (n = {});
      let o = {};
      return n.defaults && (n.bytes === String ? o.dcapQuote = "" : (o.dcapQuote = [], n.bytes !== Array && (o.dcapQuote = $util.newBuffer(o.dcapQuote))), n.bytes === String ? o.tcbInfo = "" : (o.tcbInfo = [], n.bytes !== Array && (o.tcbInfo = $util.newBuffer(o.tcbInfo))), n.bytes === String ? o.qeIdentity = "" : (o.qeIdentity = [], n.bytes !== Array && (o.qeIdentity = $util.newBuffer(o.qeIdentity))), n.bytes === String ? o.tcbSignCert = "" : (o.tcbSignCert = [], n.bytes !== Array && (o.tcbSignCert = $util.newBuffer(o.tcbSignCert))), n.bytes === String ? o.qeSignCert = "" : (o.qeSignCert = [], n.bytes !== Array && (o.qeSignCert = $util.newBuffer(o.qeSignCert))), n.bytes === String ? o.dcapRootCaDer = "" : (o.dcapRootCaDer = [], n.bytes !== Array && (o.dcapRootCaDer = $util.newBuffer(o.dcapRootCaDer)))), e.dcapQuote != null && e.hasOwnProperty("dcapQuote") && (o.dcapQuote = n.bytes === String ? $util.base64.encode(e.dcapQuote, 0, e.dcapQuote.length) : n.bytes === Array ? Array.prototype.slice.call(e.dcapQuote) : e.dcapQuote), e.tcbInfo != null && e.hasOwnProperty("tcbInfo") && (o.tcbInfo = n.bytes === String ? $util.base64.encode(e.tcbInfo, 0, e.tcbInfo.length) : n.bytes === Array ? Array.prototype.slice.call(e.tcbInfo) : e.tcbInfo), e.qeIdentity != null && e.hasOwnProperty("qeIdentity") && (o.qeIdentity = n.bytes === String ? $util.base64.encode(e.qeIdentity, 0, e.qeIdentity.length) : n.bytes === Array ? Array.prototype.slice.call(e.qeIdentity) : e.qeIdentity), e.tcbSignCert != null && e.hasOwnProperty("tcbSignCert") && (o.tcbSignCert = n.bytes === String ? $util.base64.encode(e.tcbSignCert, 0, e.tcbSignCert.length) : n.bytes === Array ? Array.prototype.slice.call(e.tcbSignCert) : e.tcbSignCert), e.qeSignCert != null && e.hasOwnProperty("qeSignCert") && (o.qeSignCert = n.bytes === String ? $util.base64.encode(e.qeSignCert, 0, e.qeSignCert.length) : n.bytes === Array ? Array.prototype.slice.call(e.qeSignCert) : e.qeSignCert), e.dcapRootCaDer != null && e.hasOwnProperty("dcapRootCaDer") && (o.dcapRootCaDer = n.bytes === String ? $util.base64.encode(e.dcapRootCaDer, 0, e.dcapRootCaDer.length) : n.bytes === Array ? Array.prototype.slice.call(e.dcapRootCaDer) : e.dcapRootCaDer), o;
    }, r.prototype.toJSON = function() {
      return this.constructor.toObject(this, minimal.util.toJSONOptions);
    }, r.getTypeUrl = function(e) {
      return e === void 0 && (e = "type.googleapis.com"), e + "/attestation.FatquoteDcap";
    }, r;
  }(), u.FatquoteDcapMrsigner = function() {
    function r(a) {
      if (a)
        for (let e = Object.keys(a), n = 0; n < e.length; ++n)
          a[e[n]] != null && (this[e[n]] = a[e[n]]);
    }
    return r.prototype.dcapQuote = $util.newBuffer([]), r.prototype.tcbInfo = $util.newBuffer([]), r.prototype.qeIdentity = $util.newBuffer([]), r.prototype.tcbSignCert = $util.newBuffer([]), r.prototype.qeSignCert = $util.newBuffer([]), r.prototype.dcapRootCaDer = $util.newBuffer([]), r.prototype.sigstoreEvidence = null, r.create = function(e) {
      return new r(e);
    }, r.encode = function(e, n) {
      return n || (n = $Writer.create()), e.dcapQuote != null && Object.hasOwnProperty.call(e, "dcapQuote") && n.uint32(
        /* id 1, wireType 2 =*/
        10
      ).bytes(e.dcapQuote), e.tcbInfo != null && Object.hasOwnProperty.call(e, "tcbInfo") && n.uint32(
        /* id 2, wireType 2 =*/
        18
      ).bytes(e.tcbInfo), e.qeIdentity != null && Object.hasOwnProperty.call(e, "qeIdentity") && n.uint32(
        /* id 3, wireType 2 =*/
        26
      ).bytes(e.qeIdentity), e.tcbSignCert != null && Object.hasOwnProperty.call(e, "tcbSignCert") && n.uint32(
        /* id 4, wireType 2 =*/
        34
      ).bytes(e.tcbSignCert), e.qeSignCert != null && Object.hasOwnProperty.call(e, "qeSignCert") && n.uint32(
        /* id 5, wireType 2 =*/
        42
      ).bytes(e.qeSignCert), e.dcapRootCaDer != null && Object.hasOwnProperty.call(e, "dcapRootCaDer") && n.uint32(
        /* id 6, wireType 2 =*/
        50
      ).bytes(e.dcapRootCaDer), e.sigstoreEvidence != null && Object.hasOwnProperty.call(e, "sigstoreEvidence") && $root.attestation.SigstoreEvidence.encode(e.sigstoreEvidence, n.uint32(
        /* id 7, wireType 2 =*/
        58
      ).fork()).ldelim(), n;
    }, r.encodeDelimited = function(e, n) {
      return this.encode(e, n).ldelim();
    }, r.decode = function(e, n) {
      e instanceof $Reader || (e = $Reader.create(e));
      let o = n === void 0 ? e.len : e.pos + n, c = new $root.attestation.FatquoteDcapMrsigner();
      for (; e.pos < o; ) {
        let l = e.uint32();
        switch (l >>> 3) {
          case 1: {
            c.dcapQuote = e.bytes();
            break;
          }
          case 2: {
            c.tcbInfo = e.bytes();
            break;
          }
          case 3: {
            c.qeIdentity = e.bytes();
            break;
          }
          case 4: {
            c.tcbSignCert = e.bytes();
            break;
          }
          case 5: {
            c.qeSignCert = e.bytes();
            break;
          }
          case 6: {
            c.dcapRootCaDer = e.bytes();
            break;
          }
          case 7: {
            c.sigstoreEvidence = $root.attestation.SigstoreEvidence.decode(e, e.uint32());
            break;
          }
          default:
            e.skipType(l & 7);
            break;
        }
      }
      return c;
    }, r.decodeDelimited = function(e) {
      return e instanceof $Reader || (e = new $Reader(e)), this.decode(e, e.uint32());
    }, r.verify = function(e) {
      if (typeof e != "object" || e === null)
        return "object expected";
      if (e.dcapQuote != null && e.hasOwnProperty("dcapQuote") && !(e.dcapQuote && typeof e.dcapQuote.length == "number" || $util.isString(e.dcapQuote)))
        return "dcapQuote: buffer expected";
      if (e.tcbInfo != null && e.hasOwnProperty("tcbInfo") && !(e.tcbInfo && typeof e.tcbInfo.length == "number" || $util.isString(e.tcbInfo)))
        return "tcbInfo: buffer expected";
      if (e.qeIdentity != null && e.hasOwnProperty("qeIdentity") && !(e.qeIdentity && typeof e.qeIdentity.length == "number" || $util.isString(e.qeIdentity)))
        return "qeIdentity: buffer expected";
      if (e.tcbSignCert != null && e.hasOwnProperty("tcbSignCert") && !(e.tcbSignCert && typeof e.tcbSignCert.length == "number" || $util.isString(e.tcbSignCert)))
        return "tcbSignCert: buffer expected";
      if (e.qeSignCert != null && e.hasOwnProperty("qeSignCert") && !(e.qeSignCert && typeof e.qeSignCert.length == "number" || $util.isString(e.qeSignCert)))
        return "qeSignCert: buffer expected";
      if (e.dcapRootCaDer != null && e.hasOwnProperty("dcapRootCaDer") && !(e.dcapRootCaDer && typeof e.dcapRootCaDer.length == "number" || $util.isString(e.dcapRootCaDer)))
        return "dcapRootCaDer: buffer expected";
      if (e.sigstoreEvidence != null && e.hasOwnProperty("sigstoreEvidence")) {
        let n = $root.attestation.SigstoreEvidence.verify(e.sigstoreEvidence);
        if (n)
          return "sigstoreEvidence." + n;
      }
      return null;
    }, r.fromObject = function(e) {
      if (e instanceof $root.attestation.FatquoteDcapMrsigner)
        return e;
      let n = new $root.attestation.FatquoteDcapMrsigner();
      if (e.dcapQuote != null && (typeof e.dcapQuote == "string" ? $util.base64.decode(e.dcapQuote, n.dcapQuote = $util.newBuffer($util.base64.length(e.dcapQuote)), 0) : e.dcapQuote.length >= 0 && (n.dcapQuote = e.dcapQuote)), e.tcbInfo != null && (typeof e.tcbInfo == "string" ? $util.base64.decode(e.tcbInfo, n.tcbInfo = $util.newBuffer($util.base64.length(e.tcbInfo)), 0) : e.tcbInfo.length >= 0 && (n.tcbInfo = e.tcbInfo)), e.qeIdentity != null && (typeof e.qeIdentity == "string" ? $util.base64.decode(e.qeIdentity, n.qeIdentity = $util.newBuffer($util.base64.length(e.qeIdentity)), 0) : e.qeIdentity.length >= 0 && (n.qeIdentity = e.qeIdentity)), e.tcbSignCert != null && (typeof e.tcbSignCert == "string" ? $util.base64.decode(e.tcbSignCert, n.tcbSignCert = $util.newBuffer($util.base64.length(e.tcbSignCert)), 0) : e.tcbSignCert.length >= 0 && (n.tcbSignCert = e.tcbSignCert)), e.qeSignCert != null && (typeof e.qeSignCert == "string" ? $util.base64.decode(e.qeSignCert, n.qeSignCert = $util.newBuffer($util.base64.length(e.qeSignCert)), 0) : e.qeSignCert.length >= 0 && (n.qeSignCert = e.qeSignCert)), e.dcapRootCaDer != null && (typeof e.dcapRootCaDer == "string" ? $util.base64.decode(e.dcapRootCaDer, n.dcapRootCaDer = $util.newBuffer($util.base64.length(e.dcapRootCaDer)), 0) : e.dcapRootCaDer.length >= 0 && (n.dcapRootCaDer = e.dcapRootCaDer)), e.sigstoreEvidence != null) {
        if (typeof e.sigstoreEvidence != "object")
          throw TypeError(".attestation.FatquoteDcapMrsigner.sigstoreEvidence: object expected");
        n.sigstoreEvidence = $root.attestation.SigstoreEvidence.fromObject(e.sigstoreEvidence);
      }
      return n;
    }, r.toObject = function(e, n) {
      n || (n = {});
      let o = {};
      return n.defaults && (n.bytes === String ? o.dcapQuote = "" : (o.dcapQuote = [], n.bytes !== Array && (o.dcapQuote = $util.newBuffer(o.dcapQuote))), n.bytes === String ? o.tcbInfo = "" : (o.tcbInfo = [], n.bytes !== Array && (o.tcbInfo = $util.newBuffer(o.tcbInfo))), n.bytes === String ? o.qeIdentity = "" : (o.qeIdentity = [], n.bytes !== Array && (o.qeIdentity = $util.newBuffer(o.qeIdentity))), n.bytes === String ? o.tcbSignCert = "" : (o.tcbSignCert = [], n.bytes !== Array && (o.tcbSignCert = $util.newBuffer(o.tcbSignCert))), n.bytes === String ? o.qeSignCert = "" : (o.qeSignCert = [], n.bytes !== Array && (o.qeSignCert = $util.newBuffer(o.qeSignCert))), n.bytes === String ? o.dcapRootCaDer = "" : (o.dcapRootCaDer = [], n.bytes !== Array && (o.dcapRootCaDer = $util.newBuffer(o.dcapRootCaDer))), o.sigstoreEvidence = null), e.dcapQuote != null && e.hasOwnProperty("dcapQuote") && (o.dcapQuote = n.bytes === String ? $util.base64.encode(e.dcapQuote, 0, e.dcapQuote.length) : n.bytes === Array ? Array.prototype.slice.call(e.dcapQuote) : e.dcapQuote), e.tcbInfo != null && e.hasOwnProperty("tcbInfo") && (o.tcbInfo = n.bytes === String ? $util.base64.encode(e.tcbInfo, 0, e.tcbInfo.length) : n.bytes === Array ? Array.prototype.slice.call(e.tcbInfo) : e.tcbInfo), e.qeIdentity != null && e.hasOwnProperty("qeIdentity") && (o.qeIdentity = n.bytes === String ? $util.base64.encode(e.qeIdentity, 0, e.qeIdentity.length) : n.bytes === Array ? Array.prototype.slice.call(e.qeIdentity) : e.qeIdentity), e.tcbSignCert != null && e.hasOwnProperty("tcbSignCert") && (o.tcbSignCert = n.bytes === String ? $util.base64.encode(e.tcbSignCert, 0, e.tcbSignCert.length) : n.bytes === Array ? Array.prototype.slice.call(e.tcbSignCert) : e.tcbSignCert), e.qeSignCert != null && e.hasOwnProperty("qeSignCert") && (o.qeSignCert = n.bytes === String ? $util.base64.encode(e.qeSignCert, 0, e.qeSignCert.length) : n.bytes === Array ? Array.prototype.slice.call(e.qeSignCert) : e.qeSignCert), e.dcapRootCaDer != null && e.hasOwnProperty("dcapRootCaDer") && (o.dcapRootCaDer = n.bytes === String ? $util.base64.encode(e.dcapRootCaDer, 0, e.dcapRootCaDer.length) : n.bytes === Array ? Array.prototype.slice.call(e.dcapRootCaDer) : e.dcapRootCaDer), e.sigstoreEvidence != null && e.hasOwnProperty("sigstoreEvidence") && (o.sigstoreEvidence = $root.attestation.SigstoreEvidence.toObject(e.sigstoreEvidence, n)), o;
    }, r.prototype.toJSON = function() {
      return this.constructor.toObject(this, minimal.util.toJSONOptions);
    }, r.getTypeUrl = function(e) {
      return e === void 0 && (e = "type.googleapis.com"), e + "/attestation.FatquoteDcapMrsigner";
    }, r;
  }(), u.SigstoreFile = function() {
    function r(a) {
      if (a)
        for (let e = Object.keys(a), n = 0; n < e.length; ++n)
          a[e[n]] != null && (this[e[n]] = a[e[n]]);
    }
    return r.prototype.name = "", r.prototype.contents = $util.newBuffer([]), r.create = function(e) {
      return new r(e);
    }, r.encode = function(e, n) {
      return n || (n = $Writer.create()), e.name != null && Object.hasOwnProperty.call(e, "name") && n.uint32(
        /* id 1, wireType 2 =*/
        10
      ).string(e.name), e.contents != null && Object.hasOwnProperty.call(e, "contents") && n.uint32(
        /* id 2, wireType 2 =*/
        18
      ).bytes(e.contents), n;
    }, r.encodeDelimited = function(e, n) {
      return this.encode(e, n).ldelim();
    }, r.decode = function(e, n) {
      e instanceof $Reader || (e = $Reader.create(e));
      let o = n === void 0 ? e.len : e.pos + n, c = new $root.attestation.SigstoreFile();
      for (; e.pos < o; ) {
        let l = e.uint32();
        switch (l >>> 3) {
          case 1: {
            c.name = e.string();
            break;
          }
          case 2: {
            c.contents = e.bytes();
            break;
          }
          default:
            e.skipType(l & 7);
            break;
        }
      }
      return c;
    }, r.decodeDelimited = function(e) {
      return e instanceof $Reader || (e = new $Reader(e)), this.decode(e, e.uint32());
    }, r.verify = function(e) {
      return typeof e != "object" || e === null ? "object expected" : e.name != null && e.hasOwnProperty("name") && !$util.isString(e.name) ? "name: string expected" : e.contents != null && e.hasOwnProperty("contents") && !(e.contents && typeof e.contents.length == "number" || $util.isString(e.contents)) ? "contents: buffer expected" : null;
    }, r.fromObject = function(e) {
      if (e instanceof $root.attestation.SigstoreFile)
        return e;
      let n = new $root.attestation.SigstoreFile();
      return e.name != null && (n.name = String(e.name)), e.contents != null && (typeof e.contents == "string" ? $util.base64.decode(e.contents, n.contents = $util.newBuffer($util.base64.length(e.contents)), 0) : e.contents.length >= 0 && (n.contents = e.contents)), n;
    }, r.toObject = function(e, n) {
      n || (n = {});
      let o = {};
      return n.defaults && (o.name = "", n.bytes === String ? o.contents = "" : (o.contents = [], n.bytes !== Array && (o.contents = $util.newBuffer(o.contents)))), e.name != null && e.hasOwnProperty("name") && (o.name = e.name), e.contents != null && e.hasOwnProperty("contents") && (o.contents = n.bytes === String ? $util.base64.encode(e.contents, 0, e.contents.length) : n.bytes === Array ? Array.prototype.slice.call(e.contents) : e.contents), o;
    }, r.prototype.toJSON = function() {
      return this.constructor.toObject(this, minimal.util.toJSONOptions);
    }, r.getTypeUrl = function(e) {
      return e === void 0 && (e = "type.googleapis.com"), e + "/attestation.SigstoreFile";
    }, r;
  }(), u.SigstoreEvidence = function() {
    function r(e) {
      if (e)
        for (let n = Object.keys(e), o = 0; o < n.length; ++o)
          e[n[o]] != null && (this[n[o]] = e[n[o]]);
    }
    r.prototype.v1 = null;
    let a;
    return Object.defineProperty(r.prototype, "sigstoreEvidence", {
      get: $util.oneOfGetter(a = ["v1"]),
      set: $util.oneOfSetter(a)
    }), r.create = function(n) {
      return new r(n);
    }, r.encode = function(n, o) {
      return o || (o = $Writer.create()), n.v1 != null && Object.hasOwnProperty.call(n, "v1") && $root.attestation.SigstoreEvidenceV1.encode(n.v1, o.uint32(
        /* id 1, wireType 2 =*/
        10
      ).fork()).ldelim(), o;
    }, r.encodeDelimited = function(n, o) {
      return this.encode(n, o).ldelim();
    }, r.decode = function(n, o) {
      n instanceof $Reader || (n = $Reader.create(n));
      let c = o === void 0 ? n.len : n.pos + o, l = new $root.attestation.SigstoreEvidence();
      for (; n.pos < c; ) {
        let d = n.uint32();
        switch (d >>> 3) {
          case 1: {
            l.v1 = $root.attestation.SigstoreEvidenceV1.decode(n, n.uint32());
            break;
          }
          default:
            n.skipType(d & 7);
            break;
        }
      }
      return l;
    }, r.decodeDelimited = function(n) {
      return n instanceof $Reader || (n = new $Reader(n)), this.decode(n, n.uint32());
    }, r.verify = function(n) {
      if (typeof n != "object" || n === null)
        return "object expected";
      if (n.v1 != null && n.hasOwnProperty("v1")) {
        let o = $root.attestation.SigstoreEvidenceV1.verify(n.v1);
        if (o)
          return "v1." + o;
      }
      return null;
    }, r.fromObject = function(n) {
      if (n instanceof $root.attestation.SigstoreEvidence)
        return n;
      let o = new $root.attestation.SigstoreEvidence();
      if (n.v1 != null) {
        if (typeof n.v1 != "object")
          throw TypeError(".attestation.SigstoreEvidence.v1: object expected");
        o.v1 = $root.attestation.SigstoreEvidenceV1.fromObject(n.v1);
      }
      return o;
    }, r.toObject = function(n, o) {
      o || (o = {});
      let c = {};
      return n.v1 != null && n.hasOwnProperty("v1") && (c.v1 = $root.attestation.SigstoreEvidenceV1.toObject(n.v1, o), o.oneofs && (c.sigstoreEvidence = "v1")), c;
    }, r.prototype.toJSON = function() {
      return this.constructor.toObject(this, minimal.util.toJSONOptions);
    }, r.getTypeUrl = function(n) {
      return n === void 0 && (n = "type.googleapis.com"), n + "/attestation.SigstoreEvidence";
    }, r;
  }(), u.SigstoreEvidenceV1 = function() {
    function r(a) {
      if (this.files = [], a)
        for (let e = Object.keys(a), n = 0; n < e.length; ++n)
          a[e[n]] != null && (this[e[n]] = a[e[n]]);
    }
    return r.prototype.files = $util.emptyArray, r.prototype.rekorLogEntryJson = $util.newBuffer([]), r.create = function(e) {
      return new r(e);
    }, r.encode = function(e, n) {
      if (n || (n = $Writer.create()), e.files != null && e.files.length)
        for (let o = 0; o < e.files.length; ++o)
          $root.attestation.SigstoreFile.encode(e.files[o], n.uint32(
            /* id 1, wireType 2 =*/
            10
          ).fork()).ldelim();
      return e.rekorLogEntryJson != null && Object.hasOwnProperty.call(e, "rekorLogEntryJson") && n.uint32(
        /* id 2, wireType 2 =*/
        18
      ).bytes(e.rekorLogEntryJson), n;
    }, r.encodeDelimited = function(e, n) {
      return this.encode(e, n).ldelim();
    }, r.decode = function(e, n) {
      e instanceof $Reader || (e = $Reader.create(e));
      let o = n === void 0 ? e.len : e.pos + n, c = new $root.attestation.SigstoreEvidenceV1();
      for (; e.pos < o; ) {
        let l = e.uint32();
        switch (l >>> 3) {
          case 1: {
            c.files && c.files.length || (c.files = []), c.files.push($root.attestation.SigstoreFile.decode(e, e.uint32()));
            break;
          }
          case 2: {
            c.rekorLogEntryJson = e.bytes();
            break;
          }
          default:
            e.skipType(l & 7);
            break;
        }
      }
      return c;
    }, r.decodeDelimited = function(e) {
      return e instanceof $Reader || (e = new $Reader(e)), this.decode(e, e.uint32());
    }, r.verify = function(e) {
      if (typeof e != "object" || e === null)
        return "object expected";
      if (e.files != null && e.hasOwnProperty("files")) {
        if (!Array.isArray(e.files))
          return "files: array expected";
        for (let n = 0; n < e.files.length; ++n) {
          let o = $root.attestation.SigstoreFile.verify(e.files[n]);
          if (o)
            return "files." + o;
        }
      }
      return e.rekorLogEntryJson != null && e.hasOwnProperty("rekorLogEntryJson") && !(e.rekorLogEntryJson && typeof e.rekorLogEntryJson.length == "number" || $util.isString(e.rekorLogEntryJson)) ? "rekorLogEntryJson: buffer expected" : null;
    }, r.fromObject = function(e) {
      if (e instanceof $root.attestation.SigstoreEvidenceV1)
        return e;
      let n = new $root.attestation.SigstoreEvidenceV1();
      if (e.files) {
        if (!Array.isArray(e.files))
          throw TypeError(".attestation.SigstoreEvidenceV1.files: array expected");
        n.files = [];
        for (let o = 0; o < e.files.length; ++o) {
          if (typeof e.files[o] != "object")
            throw TypeError(".attestation.SigstoreEvidenceV1.files: object expected");
          n.files[o] = $root.attestation.SigstoreFile.fromObject(e.files[o]);
        }
      }
      return e.rekorLogEntryJson != null && (typeof e.rekorLogEntryJson == "string" ? $util.base64.decode(e.rekorLogEntryJson, n.rekorLogEntryJson = $util.newBuffer($util.base64.length(e.rekorLogEntryJson)), 0) : e.rekorLogEntryJson.length >= 0 && (n.rekorLogEntryJson = e.rekorLogEntryJson)), n;
    }, r.toObject = function(e, n) {
      n || (n = {});
      let o = {};
      if ((n.arrays || n.defaults) && (o.files = []), n.defaults && (n.bytes === String ? o.rekorLogEntryJson = "" : (o.rekorLogEntryJson = [], n.bytes !== Array && (o.rekorLogEntryJson = $util.newBuffer(o.rekorLogEntryJson)))), e.files && e.files.length) {
        o.files = [];
        for (let c = 0; c < e.files.length; ++c)
          o.files[c] = $root.attestation.SigstoreFile.toObject(e.files[c], n);
      }
      return e.rekorLogEntryJson != null && e.hasOwnProperty("rekorLogEntryJson") && (o.rekorLogEntryJson = n.bytes === String ? $util.base64.encode(e.rekorLogEntryJson, 0, e.rekorLogEntryJson.length) : n.bytes === Array ? Array.prototype.slice.call(e.rekorLogEntryJson) : e.rekorLogEntryJson), o;
    }, r.prototype.toJSON = function() {
      return this.constructor.toObject(this, minimal.util.toJSONOptions);
    }, r.getTypeUrl = function(e) {
      return e === void 0 && (e = "type.googleapis.com"), e + "/attestation.SigstoreEvidenceV1";
    }, r;
  }(), u.FatquoteNitro = function() {
    function r(a) {
      if (a)
        for (let e = Object.keys(a), n = 0; n < e.length; ++n)
          a[e[n]] != null && (this[e[n]] = a[e[n]]);
    }
    return r.prototype.cose = $util.newBuffer([]), r.prototype.nitroRootCaDer = $util.newBuffer([]), r.create = function(e) {
      return new r(e);
    }, r.encode = function(e, n) {
      return n || (n = $Writer.create()), e.cose != null && Object.hasOwnProperty.call(e, "cose") && n.uint32(
        /* id 1, wireType 2 =*/
        10
      ).bytes(e.cose), e.nitroRootCaDer != null && Object.hasOwnProperty.call(e, "nitroRootCaDer") && n.uint32(
        /* id 2, wireType 2 =*/
        18
      ).bytes(e.nitroRootCaDer), n;
    }, r.encodeDelimited = function(e, n) {
      return this.encode(e, n).ldelim();
    }, r.decode = function(e, n) {
      e instanceof $Reader || (e = $Reader.create(e));
      let o = n === void 0 ? e.len : e.pos + n, c = new $root.attestation.FatquoteNitro();
      for (; e.pos < o; ) {
        let l = e.uint32();
        switch (l >>> 3) {
          case 1: {
            c.cose = e.bytes();
            break;
          }
          case 2: {
            c.nitroRootCaDer = e.bytes();
            break;
          }
          default:
            e.skipType(l & 7);
            break;
        }
      }
      return c;
    }, r.decodeDelimited = function(e) {
      return e instanceof $Reader || (e = new $Reader(e)), this.decode(e, e.uint32());
    }, r.verify = function(e) {
      return typeof e != "object" || e === null ? "object expected" : e.cose != null && e.hasOwnProperty("cose") && !(e.cose && typeof e.cose.length == "number" || $util.isString(e.cose)) ? "cose: buffer expected" : e.nitroRootCaDer != null && e.hasOwnProperty("nitroRootCaDer") && !(e.nitroRootCaDer && typeof e.nitroRootCaDer.length == "number" || $util.isString(e.nitroRootCaDer)) ? "nitroRootCaDer: buffer expected" : null;
    }, r.fromObject = function(e) {
      if (e instanceof $root.attestation.FatquoteNitro)
        return e;
      let n = new $root.attestation.FatquoteNitro();
      return e.cose != null && (typeof e.cose == "string" ? $util.base64.decode(e.cose, n.cose = $util.newBuffer($util.base64.length(e.cose)), 0) : e.cose.length >= 0 && (n.cose = e.cose)), e.nitroRootCaDer != null && (typeof e.nitroRootCaDer == "string" ? $util.base64.decode(e.nitroRootCaDer, n.nitroRootCaDer = $util.newBuffer($util.base64.length(e.nitroRootCaDer)), 0) : e.nitroRootCaDer.length >= 0 && (n.nitroRootCaDer = e.nitroRootCaDer)), n;
    }, r.toObject = function(e, n) {
      n || (n = {});
      let o = {};
      return n.defaults && (n.bytes === String ? o.cose = "" : (o.cose = [], n.bytes !== Array && (o.cose = $util.newBuffer(o.cose))), n.bytes === String ? o.nitroRootCaDer = "" : (o.nitroRootCaDer = [], n.bytes !== Array && (o.nitroRootCaDer = $util.newBuffer(o.nitroRootCaDer)))), e.cose != null && e.hasOwnProperty("cose") && (o.cose = n.bytes === String ? $util.base64.encode(e.cose, 0, e.cose.length) : n.bytes === Array ? Array.prototype.slice.call(e.cose) : e.cose), e.nitroRootCaDer != null && e.hasOwnProperty("nitroRootCaDer") && (o.nitroRootCaDer = n.bytes === String ? $util.base64.encode(e.nitroRootCaDer, 0, e.nitroRootCaDer.length) : n.bytes === Array ? Array.prototype.slice.call(e.nitroRootCaDer) : e.nitroRootCaDer), o;
    }, r.prototype.toJSON = function() {
      return this.constructor.toObject(this, minimal.util.toJSONOptions);
    }, r.getTypeUrl = function(e) {
      return e === void 0 && (e = "type.googleapis.com"), e + "/attestation.FatquoteNitro";
    }, r;
  }(), u.FatquoteSnp = function() {
    function r(a) {
      if (a)
        for (let e = Object.keys(a), n = 0; n < e.length; ++n)
          a[e[n]] != null && (this[e[n]] = a[e[n]]);
    }
    return r.prototype.reportBin = $util.newBuffer([]), r.prototype.amdArkDer = $util.newBuffer([]), r.prototype.amdSevDer = $util.newBuffer([]), r.prototype.vcekCrtDer = $util.newBuffer([]), r.prototype.reportData = $util.newBuffer([]), r.prototype.roughtimePubKey = $util.newBuffer([]), r.prototype.roughtimeNonce = $util.newBuffer([]), r.prototype.signedTimestamp = $util.newBuffer([]), r.prototype.decentriqDer = $util.newBuffer([]), r.prototype.chipDer = $util.newBuffer([]), r.create = function(e) {
      return new r(e);
    }, r.encode = function(e, n) {
      return n || (n = $Writer.create()), e.reportBin != null && Object.hasOwnProperty.call(e, "reportBin") && n.uint32(
        /* id 1, wireType 2 =*/
        10
      ).bytes(e.reportBin), e.amdArkDer != null && Object.hasOwnProperty.call(e, "amdArkDer") && n.uint32(
        /* id 2, wireType 2 =*/
        18
      ).bytes(e.amdArkDer), e.amdSevDer != null && Object.hasOwnProperty.call(e, "amdSevDer") && n.uint32(
        /* id 3, wireType 2 =*/
        26
      ).bytes(e.amdSevDer), e.vcekCrtDer != null && Object.hasOwnProperty.call(e, "vcekCrtDer") && n.uint32(
        /* id 4, wireType 2 =*/
        34
      ).bytes(e.vcekCrtDer), e.reportData != null && Object.hasOwnProperty.call(e, "reportData") && n.uint32(
        /* id 5, wireType 2 =*/
        42
      ).bytes(e.reportData), e.roughtimePubKey != null && Object.hasOwnProperty.call(e, "roughtimePubKey") && n.uint32(
        /* id 6, wireType 2 =*/
        50
      ).bytes(e.roughtimePubKey), e.roughtimeNonce != null && Object.hasOwnProperty.call(e, "roughtimeNonce") && n.uint32(
        /* id 7, wireType 2 =*/
        58
      ).bytes(e.roughtimeNonce), e.signedTimestamp != null && Object.hasOwnProperty.call(e, "signedTimestamp") && n.uint32(
        /* id 8, wireType 2 =*/
        66
      ).bytes(e.signedTimestamp), e.decentriqDer != null && Object.hasOwnProperty.call(e, "decentriqDer") && n.uint32(
        /* id 9, wireType 2 =*/
        74
      ).bytes(e.decentriqDer), e.chipDer != null && Object.hasOwnProperty.call(e, "chipDer") && n.uint32(
        /* id 10, wireType 2 =*/
        82
      ).bytes(e.chipDer), n;
    }, r.encodeDelimited = function(e, n) {
      return this.encode(e, n).ldelim();
    }, r.decode = function(e, n) {
      e instanceof $Reader || (e = $Reader.create(e));
      let o = n === void 0 ? e.len : e.pos + n, c = new $root.attestation.FatquoteSnp();
      for (; e.pos < o; ) {
        let l = e.uint32();
        switch (l >>> 3) {
          case 1: {
            c.reportBin = e.bytes();
            break;
          }
          case 2: {
            c.amdArkDer = e.bytes();
            break;
          }
          case 3: {
            c.amdSevDer = e.bytes();
            break;
          }
          case 4: {
            c.vcekCrtDer = e.bytes();
            break;
          }
          case 5: {
            c.reportData = e.bytes();
            break;
          }
          case 6: {
            c.roughtimePubKey = e.bytes();
            break;
          }
          case 7: {
            c.roughtimeNonce = e.bytes();
            break;
          }
          case 8: {
            c.signedTimestamp = e.bytes();
            break;
          }
          case 9: {
            c.decentriqDer = e.bytes();
            break;
          }
          case 10: {
            c.chipDer = e.bytes();
            break;
          }
          default:
            e.skipType(l & 7);
            break;
        }
      }
      return c;
    }, r.decodeDelimited = function(e) {
      return e instanceof $Reader || (e = new $Reader(e)), this.decode(e, e.uint32());
    }, r.verify = function(e) {
      return typeof e != "object" || e === null ? "object expected" : e.reportBin != null && e.hasOwnProperty("reportBin") && !(e.reportBin && typeof e.reportBin.length == "number" || $util.isString(e.reportBin)) ? "reportBin: buffer expected" : e.amdArkDer != null && e.hasOwnProperty("amdArkDer") && !(e.amdArkDer && typeof e.amdArkDer.length == "number" || $util.isString(e.amdArkDer)) ? "amdArkDer: buffer expected" : e.amdSevDer != null && e.hasOwnProperty("amdSevDer") && !(e.amdSevDer && typeof e.amdSevDer.length == "number" || $util.isString(e.amdSevDer)) ? "amdSevDer: buffer expected" : e.vcekCrtDer != null && e.hasOwnProperty("vcekCrtDer") && !(e.vcekCrtDer && typeof e.vcekCrtDer.length == "number" || $util.isString(e.vcekCrtDer)) ? "vcekCrtDer: buffer expected" : e.reportData != null && e.hasOwnProperty("reportData") && !(e.reportData && typeof e.reportData.length == "number" || $util.isString(e.reportData)) ? "reportData: buffer expected" : e.roughtimePubKey != null && e.hasOwnProperty("roughtimePubKey") && !(e.roughtimePubKey && typeof e.roughtimePubKey.length == "number" || $util.isString(e.roughtimePubKey)) ? "roughtimePubKey: buffer expected" : e.roughtimeNonce != null && e.hasOwnProperty("roughtimeNonce") && !(e.roughtimeNonce && typeof e.roughtimeNonce.length == "number" || $util.isString(e.roughtimeNonce)) ? "roughtimeNonce: buffer expected" : e.signedTimestamp != null && e.hasOwnProperty("signedTimestamp") && !(e.signedTimestamp && typeof e.signedTimestamp.length == "number" || $util.isString(e.signedTimestamp)) ? "signedTimestamp: buffer expected" : e.decentriqDer != null && e.hasOwnProperty("decentriqDer") && !(e.decentriqDer && typeof e.decentriqDer.length == "number" || $util.isString(e.decentriqDer)) ? "decentriqDer: buffer expected" : e.chipDer != null && e.hasOwnProperty("chipDer") && !(e.chipDer && typeof e.chipDer.length == "number" || $util.isString(e.chipDer)) ? "chipDer: buffer expected" : null;
    }, r.fromObject = function(e) {
      if (e instanceof $root.attestation.FatquoteSnp)
        return e;
      let n = new $root.attestation.FatquoteSnp();
      return e.reportBin != null && (typeof e.reportBin == "string" ? $util.base64.decode(e.reportBin, n.reportBin = $util.newBuffer($util.base64.length(e.reportBin)), 0) : e.reportBin.length >= 0 && (n.reportBin = e.reportBin)), e.amdArkDer != null && (typeof e.amdArkDer == "string" ? $util.base64.decode(e.amdArkDer, n.amdArkDer = $util.newBuffer($util.base64.length(e.amdArkDer)), 0) : e.amdArkDer.length >= 0 && (n.amdArkDer = e.amdArkDer)), e.amdSevDer != null && (typeof e.amdSevDer == "string" ? $util.base64.decode(e.amdSevDer, n.amdSevDer = $util.newBuffer($util.base64.length(e.amdSevDer)), 0) : e.amdSevDer.length >= 0 && (n.amdSevDer = e.amdSevDer)), e.vcekCrtDer != null && (typeof e.vcekCrtDer == "string" ? $util.base64.decode(e.vcekCrtDer, n.vcekCrtDer = $util.newBuffer($util.base64.length(e.vcekCrtDer)), 0) : e.vcekCrtDer.length >= 0 && (n.vcekCrtDer = e.vcekCrtDer)), e.reportData != null && (typeof e.reportData == "string" ? $util.base64.decode(e.reportData, n.reportData = $util.newBuffer($util.base64.length(e.reportData)), 0) : e.reportData.length >= 0 && (n.reportData = e.reportData)), e.roughtimePubKey != null && (typeof e.roughtimePubKey == "string" ? $util.base64.decode(e.roughtimePubKey, n.roughtimePubKey = $util.newBuffer($util.base64.length(e.roughtimePubKey)), 0) : e.roughtimePubKey.length >= 0 && (n.roughtimePubKey = e.roughtimePubKey)), e.roughtimeNonce != null && (typeof e.roughtimeNonce == "string" ? $util.base64.decode(e.roughtimeNonce, n.roughtimeNonce = $util.newBuffer($util.base64.length(e.roughtimeNonce)), 0) : e.roughtimeNonce.length >= 0 && (n.roughtimeNonce = e.roughtimeNonce)), e.signedTimestamp != null && (typeof e.signedTimestamp == "string" ? $util.base64.decode(e.signedTimestamp, n.signedTimestamp = $util.newBuffer($util.base64.length(e.signedTimestamp)), 0) : e.signedTimestamp.length >= 0 && (n.signedTimestamp = e.signedTimestamp)), e.decentriqDer != null && (typeof e.decentriqDer == "string" ? $util.base64.decode(e.decentriqDer, n.decentriqDer = $util.newBuffer($util.base64.length(e.decentriqDer)), 0) : e.decentriqDer.length >= 0 && (n.decentriqDer = e.decentriqDer)), e.chipDer != null && (typeof e.chipDer == "string" ? $util.base64.decode(e.chipDer, n.chipDer = $util.newBuffer($util.base64.length(e.chipDer)), 0) : e.chipDer.length >= 0 && (n.chipDer = e.chipDer)), n;
    }, r.toObject = function(e, n) {
      n || (n = {});
      let o = {};
      return n.defaults && (n.bytes === String ? o.reportBin = "" : (o.reportBin = [], n.bytes !== Array && (o.reportBin = $util.newBuffer(o.reportBin))), n.bytes === String ? o.amdArkDer = "" : (o.amdArkDer = [], n.bytes !== Array && (o.amdArkDer = $util.newBuffer(o.amdArkDer))), n.bytes === String ? o.amdSevDer = "" : (o.amdSevDer = [], n.bytes !== Array && (o.amdSevDer = $util.newBuffer(o.amdSevDer))), n.bytes === String ? o.vcekCrtDer = "" : (o.vcekCrtDer = [], n.bytes !== Array && (o.vcekCrtDer = $util.newBuffer(o.vcekCrtDer))), n.bytes === String ? o.reportData = "" : (o.reportData = [], n.bytes !== Array && (o.reportData = $util.newBuffer(o.reportData))), n.bytes === String ? o.roughtimePubKey = "" : (o.roughtimePubKey = [], n.bytes !== Array && (o.roughtimePubKey = $util.newBuffer(o.roughtimePubKey))), n.bytes === String ? o.roughtimeNonce = "" : (o.roughtimeNonce = [], n.bytes !== Array && (o.roughtimeNonce = $util.newBuffer(o.roughtimeNonce))), n.bytes === String ? o.signedTimestamp = "" : (o.signedTimestamp = [], n.bytes !== Array && (o.signedTimestamp = $util.newBuffer(o.signedTimestamp))), n.bytes === String ? o.decentriqDer = "" : (o.decentriqDer = [], n.bytes !== Array && (o.decentriqDer = $util.newBuffer(o.decentriqDer))), n.bytes === String ? o.chipDer = "" : (o.chipDer = [], n.bytes !== Array && (o.chipDer = $util.newBuffer(o.chipDer)))), e.reportBin != null && e.hasOwnProperty("reportBin") && (o.reportBin = n.bytes === String ? $util.base64.encode(e.reportBin, 0, e.reportBin.length) : n.bytes === Array ? Array.prototype.slice.call(e.reportBin) : e.reportBin), e.amdArkDer != null && e.hasOwnProperty("amdArkDer") && (o.amdArkDer = n.bytes === String ? $util.base64.encode(e.amdArkDer, 0, e.amdArkDer.length) : n.bytes === Array ? Array.prototype.slice.call(e.amdArkDer) : e.amdArkDer), e.amdSevDer != null && e.hasOwnProperty("amdSevDer") && (o.amdSevDer = n.bytes === String ? $util.base64.encode(e.amdSevDer, 0, e.amdSevDer.length) : n.bytes === Array ? Array.prototype.slice.call(e.amdSevDer) : e.amdSevDer), e.vcekCrtDer != null && e.hasOwnProperty("vcekCrtDer") && (o.vcekCrtDer = n.bytes === String ? $util.base64.encode(e.vcekCrtDer, 0, e.vcekCrtDer.length) : n.bytes === Array ? Array.prototype.slice.call(e.vcekCrtDer) : e.vcekCrtDer), e.reportData != null && e.hasOwnProperty("reportData") && (o.reportData = n.bytes === String ? $util.base64.encode(e.reportData, 0, e.reportData.length) : n.bytes === Array ? Array.prototype.slice.call(e.reportData) : e.reportData), e.roughtimePubKey != null && e.hasOwnProperty("roughtimePubKey") && (o.roughtimePubKey = n.bytes === String ? $util.base64.encode(e.roughtimePubKey, 0, e.roughtimePubKey.length) : n.bytes === Array ? Array.prototype.slice.call(e.roughtimePubKey) : e.roughtimePubKey), e.roughtimeNonce != null && e.hasOwnProperty("roughtimeNonce") && (o.roughtimeNonce = n.bytes === String ? $util.base64.encode(e.roughtimeNonce, 0, e.roughtimeNonce.length) : n.bytes === Array ? Array.prototype.slice.call(e.roughtimeNonce) : e.roughtimeNonce), e.signedTimestamp != null && e.hasOwnProperty("signedTimestamp") && (o.signedTimestamp = n.bytes === String ? $util.base64.encode(e.signedTimestamp, 0, e.signedTimestamp.length) : n.bytes === Array ? Array.prototype.slice.call(e.signedTimestamp) : e.signedTimestamp), e.decentriqDer != null && e.hasOwnProperty("decentriqDer") && (o.decentriqDer = n.bytes === String ? $util.base64.encode(e.decentriqDer, 0, e.decentriqDer.length) : n.bytes === Array ? Array.prototype.slice.call(e.decentriqDer) : e.decentriqDer), e.chipDer != null && e.hasOwnProperty("chipDer") && (o.chipDer = n.bytes === String ? $util.base64.encode(e.chipDer, 0, e.chipDer.length) : n.bytes === Array ? Array.prototype.slice.call(e.chipDer) : e.chipDer), o;
    }, r.prototype.toJSON = function() {
      return this.constructor.toObject(this, minimal.util.toJSONOptions);
    }, r.getTypeUrl = function(e) {
      return e === void 0 && (e = "type.googleapis.com"), e + "/attestation.FatquoteSnp";
    }, r;
  }(), u.AttestationSpecification = function() {
    function r(e) {
      if (e)
        for (let n = Object.keys(e), o = 0; o < n.length; ++o)
          e[n[o]] != null && (this[n[o]] = e[n[o]]);
    }
    r.prototype.intelEpid = null, r.prototype.intelDcap = null, r.prototype.awsNitro = null, r.prototype.amdSnp = null, r.prototype.intelDcapMrsigner = null;
    let a;
    return Object.defineProperty(r.prototype, "attestationSpecification", {
      get: $util.oneOfGetter(a = ["intelEpid", "intelDcap", "awsNitro", "amdSnp", "intelDcapMrsigner"]),
      set: $util.oneOfSetter(a)
    }), r.create = function(n) {
      return new r(n);
    }, r.encode = function(n, o) {
      return o || (o = $Writer.create()), n.intelEpid != null && Object.hasOwnProperty.call(n, "intelEpid") && $root.attestation.AttestationSpecificationIntelEpid.encode(n.intelEpid, o.uint32(
        /* id 1, wireType 2 =*/
        10
      ).fork()).ldelim(), n.intelDcap != null && Object.hasOwnProperty.call(n, "intelDcap") && $root.attestation.AttestationSpecificationIntelDcap.encode(n.intelDcap, o.uint32(
        /* id 2, wireType 2 =*/
        18
      ).fork()).ldelim(), n.awsNitro != null && Object.hasOwnProperty.call(n, "awsNitro") && $root.attestation.AttestationSpecificationAwsNitro.encode(n.awsNitro, o.uint32(
        /* id 3, wireType 2 =*/
        26
      ).fork()).ldelim(), n.amdSnp != null && Object.hasOwnProperty.call(n, "amdSnp") && $root.attestation.AttestationSpecificationAmdSnp.encode(n.amdSnp, o.uint32(
        /* id 4, wireType 2 =*/
        34
      ).fork()).ldelim(), n.intelDcapMrsigner != null && Object.hasOwnProperty.call(n, "intelDcapMrsigner") && $root.attestation.AttestationSpecificationIntelDcapMrsigner.encode(n.intelDcapMrsigner, o.uint32(
        /* id 5, wireType 2 =*/
        42
      ).fork()).ldelim(), o;
    }, r.encodeDelimited = function(n, o) {
      return this.encode(n, o).ldelim();
    }, r.decode = function(n, o) {
      n instanceof $Reader || (n = $Reader.create(n));
      let c = o === void 0 ? n.len : n.pos + o, l = new $root.attestation.AttestationSpecification();
      for (; n.pos < c; ) {
        let d = n.uint32();
        switch (d >>> 3) {
          case 1: {
            l.intelEpid = $root.attestation.AttestationSpecificationIntelEpid.decode(n, n.uint32());
            break;
          }
          case 2: {
            l.intelDcap = $root.attestation.AttestationSpecificationIntelDcap.decode(n, n.uint32());
            break;
          }
          case 3: {
            l.awsNitro = $root.attestation.AttestationSpecificationAwsNitro.decode(n, n.uint32());
            break;
          }
          case 4: {
            l.amdSnp = $root.attestation.AttestationSpecificationAmdSnp.decode(n, n.uint32());
            break;
          }
          case 5: {
            l.intelDcapMrsigner = $root.attestation.AttestationSpecificationIntelDcapMrsigner.decode(n, n.uint32());
            break;
          }
          default:
            n.skipType(d & 7);
            break;
        }
      }
      return l;
    }, r.decodeDelimited = function(n) {
      return n instanceof $Reader || (n = new $Reader(n)), this.decode(n, n.uint32());
    }, r.verify = function(n) {
      if (typeof n != "object" || n === null)
        return "object expected";
      let o = {};
      if (n.intelEpid != null && n.hasOwnProperty("intelEpid")) {
        o.attestationSpecification = 1;
        {
          let c = $root.attestation.AttestationSpecificationIntelEpid.verify(n.intelEpid);
          if (c)
            return "intelEpid." + c;
        }
      }
      if (n.intelDcap != null && n.hasOwnProperty("intelDcap")) {
        if (o.attestationSpecification === 1)
          return "attestationSpecification: multiple values";
        o.attestationSpecification = 1;
        {
          let c = $root.attestation.AttestationSpecificationIntelDcap.verify(n.intelDcap);
          if (c)
            return "intelDcap." + c;
        }
      }
      if (n.awsNitro != null && n.hasOwnProperty("awsNitro")) {
        if (o.attestationSpecification === 1)
          return "attestationSpecification: multiple values";
        o.attestationSpecification = 1;
        {
          let c = $root.attestation.AttestationSpecificationAwsNitro.verify(n.awsNitro);
          if (c)
            return "awsNitro." + c;
        }
      }
      if (n.amdSnp != null && n.hasOwnProperty("amdSnp")) {
        if (o.attestationSpecification === 1)
          return "attestationSpecification: multiple values";
        o.attestationSpecification = 1;
        {
          let c = $root.attestation.AttestationSpecificationAmdSnp.verify(n.amdSnp);
          if (c)
            return "amdSnp." + c;
        }
      }
      if (n.intelDcapMrsigner != null && n.hasOwnProperty("intelDcapMrsigner")) {
        if (o.attestationSpecification === 1)
          return "attestationSpecification: multiple values";
        o.attestationSpecification = 1;
        {
          let c = $root.attestation.AttestationSpecificationIntelDcapMrsigner.verify(n.intelDcapMrsigner);
          if (c)
            return "intelDcapMrsigner." + c;
        }
      }
      return null;
    }, r.fromObject = function(n) {
      if (n instanceof $root.attestation.AttestationSpecification)
        return n;
      let o = new $root.attestation.AttestationSpecification();
      if (n.intelEpid != null) {
        if (typeof n.intelEpid != "object")
          throw TypeError(".attestation.AttestationSpecification.intelEpid: object expected");
        o.intelEpid = $root.attestation.AttestationSpecificationIntelEpid.fromObject(n.intelEpid);
      }
      if (n.intelDcap != null) {
        if (typeof n.intelDcap != "object")
          throw TypeError(".attestation.AttestationSpecification.intelDcap: object expected");
        o.intelDcap = $root.attestation.AttestationSpecificationIntelDcap.fromObject(n.intelDcap);
      }
      if (n.awsNitro != null) {
        if (typeof n.awsNitro != "object")
          throw TypeError(".attestation.AttestationSpecification.awsNitro: object expected");
        o.awsNitro = $root.attestation.AttestationSpecificationAwsNitro.fromObject(n.awsNitro);
      }
      if (n.amdSnp != null) {
        if (typeof n.amdSnp != "object")
          throw TypeError(".attestation.AttestationSpecification.amdSnp: object expected");
        o.amdSnp = $root.attestation.AttestationSpecificationAmdSnp.fromObject(n.amdSnp);
      }
      if (n.intelDcapMrsigner != null) {
        if (typeof n.intelDcapMrsigner != "object")
          throw TypeError(".attestation.AttestationSpecification.intelDcapMrsigner: object expected");
        o.intelDcapMrsigner = $root.attestation.AttestationSpecificationIntelDcapMrsigner.fromObject(n.intelDcapMrsigner);
      }
      return o;
    }, r.toObject = function(n, o) {
      o || (o = {});
      let c = {};
      return n.intelEpid != null && n.hasOwnProperty("intelEpid") && (c.intelEpid = $root.attestation.AttestationSpecificationIntelEpid.toObject(n.intelEpid, o), o.oneofs && (c.attestationSpecification = "intelEpid")), n.intelDcap != null && n.hasOwnProperty("intelDcap") && (c.intelDcap = $root.attestation.AttestationSpecificationIntelDcap.toObject(n.intelDcap, o), o.oneofs && (c.attestationSpecification = "intelDcap")), n.awsNitro != null && n.hasOwnProperty("awsNitro") && (c.awsNitro = $root.attestation.AttestationSpecificationAwsNitro.toObject(n.awsNitro, o), o.oneofs && (c.attestationSpecification = "awsNitro")), n.amdSnp != null && n.hasOwnProperty("amdSnp") && (c.amdSnp = $root.attestation.AttestationSpecificationAmdSnp.toObject(n.amdSnp, o), o.oneofs && (c.attestationSpecification = "amdSnp")), n.intelDcapMrsigner != null && n.hasOwnProperty("intelDcapMrsigner") && (c.intelDcapMrsigner = $root.attestation.AttestationSpecificationIntelDcapMrsigner.toObject(n.intelDcapMrsigner, o), o.oneofs && (c.attestationSpecification = "intelDcapMrsigner")), c;
    }, r.prototype.toJSON = function() {
      return this.constructor.toObject(this, minimal.util.toJSONOptions);
    }, r.getTypeUrl = function(n) {
      return n === void 0 && (n = "type.googleapis.com"), n + "/attestation.AttestationSpecification";
    }, r;
  }(), u.AttestationSpecificationIntelEpid = function() {
    function r(a) {
      if (a)
        for (let e = Object.keys(a), n = 0; n < e.length; ++n)
          a[e[n]] != null && (this[e[n]] = a[e[n]]);
    }
    return r.prototype.mrenclave = $util.newBuffer([]), r.prototype.iasRootCaDer = $util.newBuffer([]), r.prototype.acceptDebug = !1, r.prototype.acceptGroupOutOfDate = !1, r.prototype.acceptConfigurationNeeded = !1, r.create = function(e) {
      return new r(e);
    }, r.encode = function(e, n) {
      return n || (n = $Writer.create()), e.mrenclave != null && Object.hasOwnProperty.call(e, "mrenclave") && n.uint32(
        /* id 1, wireType 2 =*/
        10
      ).bytes(e.mrenclave), e.iasRootCaDer != null && Object.hasOwnProperty.call(e, "iasRootCaDer") && n.uint32(
        /* id 2, wireType 2 =*/
        18
      ).bytes(e.iasRootCaDer), e.acceptDebug != null && Object.hasOwnProperty.call(e, "acceptDebug") && n.uint32(
        /* id 3, wireType 0 =*/
        24
      ).bool(e.acceptDebug), e.acceptGroupOutOfDate != null && Object.hasOwnProperty.call(e, "acceptGroupOutOfDate") && n.uint32(
        /* id 4, wireType 0 =*/
        32
      ).bool(e.acceptGroupOutOfDate), e.acceptConfigurationNeeded != null && Object.hasOwnProperty.call(e, "acceptConfigurationNeeded") && n.uint32(
        /* id 5, wireType 0 =*/
        40
      ).bool(e.acceptConfigurationNeeded), n;
    }, r.encodeDelimited = function(e, n) {
      return this.encode(e, n).ldelim();
    }, r.decode = function(e, n) {
      e instanceof $Reader || (e = $Reader.create(e));
      let o = n === void 0 ? e.len : e.pos + n, c = new $root.attestation.AttestationSpecificationIntelEpid();
      for (; e.pos < o; ) {
        let l = e.uint32();
        switch (l >>> 3) {
          case 1: {
            c.mrenclave = e.bytes();
            break;
          }
          case 2: {
            c.iasRootCaDer = e.bytes();
            break;
          }
          case 3: {
            c.acceptDebug = e.bool();
            break;
          }
          case 4: {
            c.acceptGroupOutOfDate = e.bool();
            break;
          }
          case 5: {
            c.acceptConfigurationNeeded = e.bool();
            break;
          }
          default:
            e.skipType(l & 7);
            break;
        }
      }
      return c;
    }, r.decodeDelimited = function(e) {
      return e instanceof $Reader || (e = new $Reader(e)), this.decode(e, e.uint32());
    }, r.verify = function(e) {
      return typeof e != "object" || e === null ? "object expected" : e.mrenclave != null && e.hasOwnProperty("mrenclave") && !(e.mrenclave && typeof e.mrenclave.length == "number" || $util.isString(e.mrenclave)) ? "mrenclave: buffer expected" : e.iasRootCaDer != null && e.hasOwnProperty("iasRootCaDer") && !(e.iasRootCaDer && typeof e.iasRootCaDer.length == "number" || $util.isString(e.iasRootCaDer)) ? "iasRootCaDer: buffer expected" : e.acceptDebug != null && e.hasOwnProperty("acceptDebug") && typeof e.acceptDebug != "boolean" ? "acceptDebug: boolean expected" : e.acceptGroupOutOfDate != null && e.hasOwnProperty("acceptGroupOutOfDate") && typeof e.acceptGroupOutOfDate != "boolean" ? "acceptGroupOutOfDate: boolean expected" : e.acceptConfigurationNeeded != null && e.hasOwnProperty("acceptConfigurationNeeded") && typeof e.acceptConfigurationNeeded != "boolean" ? "acceptConfigurationNeeded: boolean expected" : null;
    }, r.fromObject = function(e) {
      if (e instanceof $root.attestation.AttestationSpecificationIntelEpid)
        return e;
      let n = new $root.attestation.AttestationSpecificationIntelEpid();
      return e.mrenclave != null && (typeof e.mrenclave == "string" ? $util.base64.decode(e.mrenclave, n.mrenclave = $util.newBuffer($util.base64.length(e.mrenclave)), 0) : e.mrenclave.length >= 0 && (n.mrenclave = e.mrenclave)), e.iasRootCaDer != null && (typeof e.iasRootCaDer == "string" ? $util.base64.decode(e.iasRootCaDer, n.iasRootCaDer = $util.newBuffer($util.base64.length(e.iasRootCaDer)), 0) : e.iasRootCaDer.length >= 0 && (n.iasRootCaDer = e.iasRootCaDer)), e.acceptDebug != null && (n.acceptDebug = !!e.acceptDebug), e.acceptGroupOutOfDate != null && (n.acceptGroupOutOfDate = !!e.acceptGroupOutOfDate), e.acceptConfigurationNeeded != null && (n.acceptConfigurationNeeded = !!e.acceptConfigurationNeeded), n;
    }, r.toObject = function(e, n) {
      n || (n = {});
      let o = {};
      return n.defaults && (n.bytes === String ? o.mrenclave = "" : (o.mrenclave = [], n.bytes !== Array && (o.mrenclave = $util.newBuffer(o.mrenclave))), n.bytes === String ? o.iasRootCaDer = "" : (o.iasRootCaDer = [], n.bytes !== Array && (o.iasRootCaDer = $util.newBuffer(o.iasRootCaDer))), o.acceptDebug = !1, o.acceptGroupOutOfDate = !1, o.acceptConfigurationNeeded = !1), e.mrenclave != null && e.hasOwnProperty("mrenclave") && (o.mrenclave = n.bytes === String ? $util.base64.encode(e.mrenclave, 0, e.mrenclave.length) : n.bytes === Array ? Array.prototype.slice.call(e.mrenclave) : e.mrenclave), e.iasRootCaDer != null && e.hasOwnProperty("iasRootCaDer") && (o.iasRootCaDer = n.bytes === String ? $util.base64.encode(e.iasRootCaDer, 0, e.iasRootCaDer.length) : n.bytes === Array ? Array.prototype.slice.call(e.iasRootCaDer) : e.iasRootCaDer), e.acceptDebug != null && e.hasOwnProperty("acceptDebug") && (o.acceptDebug = e.acceptDebug), e.acceptGroupOutOfDate != null && e.hasOwnProperty("acceptGroupOutOfDate") && (o.acceptGroupOutOfDate = e.acceptGroupOutOfDate), e.acceptConfigurationNeeded != null && e.hasOwnProperty("acceptConfigurationNeeded") && (o.acceptConfigurationNeeded = e.acceptConfigurationNeeded), o;
    }, r.prototype.toJSON = function() {
      return this.constructor.toObject(this, minimal.util.toJSONOptions);
    }, r.getTypeUrl = function(e) {
      return e === void 0 && (e = "type.googleapis.com"), e + "/attestation.AttestationSpecificationIntelEpid";
    }, r;
  }(), u.AttestationSpecificationIntelDcap = function() {
    function r(a) {
      if (a)
        for (let e = Object.keys(a), n = 0; n < e.length; ++n)
          a[e[n]] != null && (this[e[n]] = a[e[n]]);
    }
    return r.prototype.mrenclave = $util.newBuffer([]), r.prototype.dcapRootCaDer = $util.newBuffer([]), r.prototype.acceptDebug = !1, r.prototype.acceptOutOfDate = !1, r.prototype.acceptConfigurationNeeded = !1, r.prototype.acceptRevoked = !1, r.create = function(e) {
      return new r(e);
    }, r.encode = function(e, n) {
      return n || (n = $Writer.create()), e.mrenclave != null && Object.hasOwnProperty.call(e, "mrenclave") && n.uint32(
        /* id 1, wireType 2 =*/
        10
      ).bytes(e.mrenclave), e.dcapRootCaDer != null && Object.hasOwnProperty.call(e, "dcapRootCaDer") && n.uint32(
        /* id 2, wireType 2 =*/
        18
      ).bytes(e.dcapRootCaDer), e.acceptDebug != null && Object.hasOwnProperty.call(e, "acceptDebug") && n.uint32(
        /* id 3, wireType 0 =*/
        24
      ).bool(e.acceptDebug), e.acceptOutOfDate != null && Object.hasOwnProperty.call(e, "acceptOutOfDate") && n.uint32(
        /* id 4, wireType 0 =*/
        32
      ).bool(e.acceptOutOfDate), e.acceptConfigurationNeeded != null && Object.hasOwnProperty.call(e, "acceptConfigurationNeeded") && n.uint32(
        /* id 5, wireType 0 =*/
        40
      ).bool(e.acceptConfigurationNeeded), e.acceptRevoked != null && Object.hasOwnProperty.call(e, "acceptRevoked") && n.uint32(
        /* id 6, wireType 0 =*/
        48
      ).bool(e.acceptRevoked), n;
    }, r.encodeDelimited = function(e, n) {
      return this.encode(e, n).ldelim();
    }, r.decode = function(e, n) {
      e instanceof $Reader || (e = $Reader.create(e));
      let o = n === void 0 ? e.len : e.pos + n, c = new $root.attestation.AttestationSpecificationIntelDcap();
      for (; e.pos < o; ) {
        let l = e.uint32();
        switch (l >>> 3) {
          case 1: {
            c.mrenclave = e.bytes();
            break;
          }
          case 2: {
            c.dcapRootCaDer = e.bytes();
            break;
          }
          case 3: {
            c.acceptDebug = e.bool();
            break;
          }
          case 4: {
            c.acceptOutOfDate = e.bool();
            break;
          }
          case 5: {
            c.acceptConfigurationNeeded = e.bool();
            break;
          }
          case 6: {
            c.acceptRevoked = e.bool();
            break;
          }
          default:
            e.skipType(l & 7);
            break;
        }
      }
      return c;
    }, r.decodeDelimited = function(e) {
      return e instanceof $Reader || (e = new $Reader(e)), this.decode(e, e.uint32());
    }, r.verify = function(e) {
      return typeof e != "object" || e === null ? "object expected" : e.mrenclave != null && e.hasOwnProperty("mrenclave") && !(e.mrenclave && typeof e.mrenclave.length == "number" || $util.isString(e.mrenclave)) ? "mrenclave: buffer expected" : e.dcapRootCaDer != null && e.hasOwnProperty("dcapRootCaDer") && !(e.dcapRootCaDer && typeof e.dcapRootCaDer.length == "number" || $util.isString(e.dcapRootCaDer)) ? "dcapRootCaDer: buffer expected" : e.acceptDebug != null && e.hasOwnProperty("acceptDebug") && typeof e.acceptDebug != "boolean" ? "acceptDebug: boolean expected" : e.acceptOutOfDate != null && e.hasOwnProperty("acceptOutOfDate") && typeof e.acceptOutOfDate != "boolean" ? "acceptOutOfDate: boolean expected" : e.acceptConfigurationNeeded != null && e.hasOwnProperty("acceptConfigurationNeeded") && typeof e.acceptConfigurationNeeded != "boolean" ? "acceptConfigurationNeeded: boolean expected" : e.acceptRevoked != null && e.hasOwnProperty("acceptRevoked") && typeof e.acceptRevoked != "boolean" ? "acceptRevoked: boolean expected" : null;
    }, r.fromObject = function(e) {
      if (e instanceof $root.attestation.AttestationSpecificationIntelDcap)
        return e;
      let n = new $root.attestation.AttestationSpecificationIntelDcap();
      return e.mrenclave != null && (typeof e.mrenclave == "string" ? $util.base64.decode(e.mrenclave, n.mrenclave = $util.newBuffer($util.base64.length(e.mrenclave)), 0) : e.mrenclave.length >= 0 && (n.mrenclave = e.mrenclave)), e.dcapRootCaDer != null && (typeof e.dcapRootCaDer == "string" ? $util.base64.decode(e.dcapRootCaDer, n.dcapRootCaDer = $util.newBuffer($util.base64.length(e.dcapRootCaDer)), 0) : e.dcapRootCaDer.length >= 0 && (n.dcapRootCaDer = e.dcapRootCaDer)), e.acceptDebug != null && (n.acceptDebug = !!e.acceptDebug), e.acceptOutOfDate != null && (n.acceptOutOfDate = !!e.acceptOutOfDate), e.acceptConfigurationNeeded != null && (n.acceptConfigurationNeeded = !!e.acceptConfigurationNeeded), e.acceptRevoked != null && (n.acceptRevoked = !!e.acceptRevoked), n;
    }, r.toObject = function(e, n) {
      n || (n = {});
      let o = {};
      return n.defaults && (n.bytes === String ? o.mrenclave = "" : (o.mrenclave = [], n.bytes !== Array && (o.mrenclave = $util.newBuffer(o.mrenclave))), n.bytes === String ? o.dcapRootCaDer = "" : (o.dcapRootCaDer = [], n.bytes !== Array && (o.dcapRootCaDer = $util.newBuffer(o.dcapRootCaDer))), o.acceptDebug = !1, o.acceptOutOfDate = !1, o.acceptConfigurationNeeded = !1, o.acceptRevoked = !1), e.mrenclave != null && e.hasOwnProperty("mrenclave") && (o.mrenclave = n.bytes === String ? $util.base64.encode(e.mrenclave, 0, e.mrenclave.length) : n.bytes === Array ? Array.prototype.slice.call(e.mrenclave) : e.mrenclave), e.dcapRootCaDer != null && e.hasOwnProperty("dcapRootCaDer") && (o.dcapRootCaDer = n.bytes === String ? $util.base64.encode(e.dcapRootCaDer, 0, e.dcapRootCaDer.length) : n.bytes === Array ? Array.prototype.slice.call(e.dcapRootCaDer) : e.dcapRootCaDer), e.acceptDebug != null && e.hasOwnProperty("acceptDebug") && (o.acceptDebug = e.acceptDebug), e.acceptOutOfDate != null && e.hasOwnProperty("acceptOutOfDate") && (o.acceptOutOfDate = e.acceptOutOfDate), e.acceptConfigurationNeeded != null && e.hasOwnProperty("acceptConfigurationNeeded") && (o.acceptConfigurationNeeded = e.acceptConfigurationNeeded), e.acceptRevoked != null && e.hasOwnProperty("acceptRevoked") && (o.acceptRevoked = e.acceptRevoked), o;
    }, r.prototype.toJSON = function() {
      return this.constructor.toObject(this, minimal.util.toJSONOptions);
    }, r.getTypeUrl = function(e) {
      return e === void 0 && (e = "type.googleapis.com"), e + "/attestation.AttestationSpecificationIntelDcap";
    }, r;
  }(), u.AttestationSpecificationAwsNitro = function() {
    function r(a) {
      if (a)
        for (let e = Object.keys(a), n = 0; n < e.length; ++n)
          a[e[n]] != null && (this[e[n]] = a[e[n]]);
    }
    return r.prototype.nitroRootCaDer = $util.newBuffer([]), r.prototype.pcr0 = $util.newBuffer([]), r.prototype.pcr1 = $util.newBuffer([]), r.prototype.pcr2 = $util.newBuffer([]), r.prototype.pcr8 = $util.newBuffer([]), r.create = function(e) {
      return new r(e);
    }, r.encode = function(e, n) {
      return n || (n = $Writer.create()), e.nitroRootCaDer != null && Object.hasOwnProperty.call(e, "nitroRootCaDer") && n.uint32(
        /* id 1, wireType 2 =*/
        10
      ).bytes(e.nitroRootCaDer), e.pcr0 != null && Object.hasOwnProperty.call(e, "pcr0") && n.uint32(
        /* id 2, wireType 2 =*/
        18
      ).bytes(e.pcr0), e.pcr1 != null && Object.hasOwnProperty.call(e, "pcr1") && n.uint32(
        /* id 3, wireType 2 =*/
        26
      ).bytes(e.pcr1), e.pcr2 != null && Object.hasOwnProperty.call(e, "pcr2") && n.uint32(
        /* id 4, wireType 2 =*/
        34
      ).bytes(e.pcr2), e.pcr8 != null && Object.hasOwnProperty.call(e, "pcr8") && n.uint32(
        /* id 5, wireType 2 =*/
        42
      ).bytes(e.pcr8), n;
    }, r.encodeDelimited = function(e, n) {
      return this.encode(e, n).ldelim();
    }, r.decode = function(e, n) {
      e instanceof $Reader || (e = $Reader.create(e));
      let o = n === void 0 ? e.len : e.pos + n, c = new $root.attestation.AttestationSpecificationAwsNitro();
      for (; e.pos < o; ) {
        let l = e.uint32();
        switch (l >>> 3) {
          case 1: {
            c.nitroRootCaDer = e.bytes();
            break;
          }
          case 2: {
            c.pcr0 = e.bytes();
            break;
          }
          case 3: {
            c.pcr1 = e.bytes();
            break;
          }
          case 4: {
            c.pcr2 = e.bytes();
            break;
          }
          case 5: {
            c.pcr8 = e.bytes();
            break;
          }
          default:
            e.skipType(l & 7);
            break;
        }
      }
      return c;
    }, r.decodeDelimited = function(e) {
      return e instanceof $Reader || (e = new $Reader(e)), this.decode(e, e.uint32());
    }, r.verify = function(e) {
      return typeof e != "object" || e === null ? "object expected" : e.nitroRootCaDer != null && e.hasOwnProperty("nitroRootCaDer") && !(e.nitroRootCaDer && typeof e.nitroRootCaDer.length == "number" || $util.isString(e.nitroRootCaDer)) ? "nitroRootCaDer: buffer expected" : e.pcr0 != null && e.hasOwnProperty("pcr0") && !(e.pcr0 && typeof e.pcr0.length == "number" || $util.isString(e.pcr0)) ? "pcr0: buffer expected" : e.pcr1 != null && e.hasOwnProperty("pcr1") && !(e.pcr1 && typeof e.pcr1.length == "number" || $util.isString(e.pcr1)) ? "pcr1: buffer expected" : e.pcr2 != null && e.hasOwnProperty("pcr2") && !(e.pcr2 && typeof e.pcr2.length == "number" || $util.isString(e.pcr2)) ? "pcr2: buffer expected" : e.pcr8 != null && e.hasOwnProperty("pcr8") && !(e.pcr8 && typeof e.pcr8.length == "number" || $util.isString(e.pcr8)) ? "pcr8: buffer expected" : null;
    }, r.fromObject = function(e) {
      if (e instanceof $root.attestation.AttestationSpecificationAwsNitro)
        return e;
      let n = new $root.attestation.AttestationSpecificationAwsNitro();
      return e.nitroRootCaDer != null && (typeof e.nitroRootCaDer == "string" ? $util.base64.decode(e.nitroRootCaDer, n.nitroRootCaDer = $util.newBuffer($util.base64.length(e.nitroRootCaDer)), 0) : e.nitroRootCaDer.length >= 0 && (n.nitroRootCaDer = e.nitroRootCaDer)), e.pcr0 != null && (typeof e.pcr0 == "string" ? $util.base64.decode(e.pcr0, n.pcr0 = $util.newBuffer($util.base64.length(e.pcr0)), 0) : e.pcr0.length >= 0 && (n.pcr0 = e.pcr0)), e.pcr1 != null && (typeof e.pcr1 == "string" ? $util.base64.decode(e.pcr1, n.pcr1 = $util.newBuffer($util.base64.length(e.pcr1)), 0) : e.pcr1.length >= 0 && (n.pcr1 = e.pcr1)), e.pcr2 != null && (typeof e.pcr2 == "string" ? $util.base64.decode(e.pcr2, n.pcr2 = $util.newBuffer($util.base64.length(e.pcr2)), 0) : e.pcr2.length >= 0 && (n.pcr2 = e.pcr2)), e.pcr8 != null && (typeof e.pcr8 == "string" ? $util.base64.decode(e.pcr8, n.pcr8 = $util.newBuffer($util.base64.length(e.pcr8)), 0) : e.pcr8.length >= 0 && (n.pcr8 = e.pcr8)), n;
    }, r.toObject = function(e, n) {
      n || (n = {});
      let o = {};
      return n.defaults && (n.bytes === String ? o.nitroRootCaDer = "" : (o.nitroRootCaDer = [], n.bytes !== Array && (o.nitroRootCaDer = $util.newBuffer(o.nitroRootCaDer))), n.bytes === String ? o.pcr0 = "" : (o.pcr0 = [], n.bytes !== Array && (o.pcr0 = $util.newBuffer(o.pcr0))), n.bytes === String ? o.pcr1 = "" : (o.pcr1 = [], n.bytes !== Array && (o.pcr1 = $util.newBuffer(o.pcr1))), n.bytes === String ? o.pcr2 = "" : (o.pcr2 = [], n.bytes !== Array && (o.pcr2 = $util.newBuffer(o.pcr2))), n.bytes === String ? o.pcr8 = "" : (o.pcr8 = [], n.bytes !== Array && (o.pcr8 = $util.newBuffer(o.pcr8)))), e.nitroRootCaDer != null && e.hasOwnProperty("nitroRootCaDer") && (o.nitroRootCaDer = n.bytes === String ? $util.base64.encode(e.nitroRootCaDer, 0, e.nitroRootCaDer.length) : n.bytes === Array ? Array.prototype.slice.call(e.nitroRootCaDer) : e.nitroRootCaDer), e.pcr0 != null && e.hasOwnProperty("pcr0") && (o.pcr0 = n.bytes === String ? $util.base64.encode(e.pcr0, 0, e.pcr0.length) : n.bytes === Array ? Array.prototype.slice.call(e.pcr0) : e.pcr0), e.pcr1 != null && e.hasOwnProperty("pcr1") && (o.pcr1 = n.bytes === String ? $util.base64.encode(e.pcr1, 0, e.pcr1.length) : n.bytes === Array ? Array.prototype.slice.call(e.pcr1) : e.pcr1), e.pcr2 != null && e.hasOwnProperty("pcr2") && (o.pcr2 = n.bytes === String ? $util.base64.encode(e.pcr2, 0, e.pcr2.length) : n.bytes === Array ? Array.prototype.slice.call(e.pcr2) : e.pcr2), e.pcr8 != null && e.hasOwnProperty("pcr8") && (o.pcr8 = n.bytes === String ? $util.base64.encode(e.pcr8, 0, e.pcr8.length) : n.bytes === Array ? Array.prototype.slice.call(e.pcr8) : e.pcr8), o;
    }, r.prototype.toJSON = function() {
      return this.constructor.toObject(this, minimal.util.toJSONOptions);
    }, r.getTypeUrl = function(e) {
      return e === void 0 && (e = "type.googleapis.com"), e + "/attestation.AttestationSpecificationAwsNitro";
    }, r;
  }(), u.AttestationSpecificationAmdSnp = function() {
    function r(a) {
      if (this.authorizedChipIds = [], a)
        for (let e = Object.keys(a), n = 0; n < e.length; ++n)
          a[e[n]] != null && (this[e[n]] = a[e[n]]);
    }
    return r.prototype.amdArkDer = $util.newBuffer([]), r.prototype.measurement = $util.newBuffer([]), r.prototype.roughtimePubKey = $util.newBuffer([]), r.prototype.authorizedChipIds = $util.emptyArray, r.prototype.decentriqDer = $util.newBuffer([]), r.create = function(e) {
      return new r(e);
    }, r.encode = function(e, n) {
      if (n || (n = $Writer.create()), e.amdArkDer != null && Object.hasOwnProperty.call(e, "amdArkDer") && n.uint32(
        /* id 1, wireType 2 =*/
        10
      ).bytes(e.amdArkDer), e.measurement != null && Object.hasOwnProperty.call(e, "measurement") && n.uint32(
        /* id 2, wireType 2 =*/
        18
      ).bytes(e.measurement), e.roughtimePubKey != null && Object.hasOwnProperty.call(e, "roughtimePubKey") && n.uint32(
        /* id 3, wireType 2 =*/
        26
      ).bytes(e.roughtimePubKey), e.authorizedChipIds != null && e.authorizedChipIds.length)
        for (let o = 0; o < e.authorizedChipIds.length; ++o)
          n.uint32(
            /* id 4, wireType 2 =*/
            34
          ).bytes(e.authorizedChipIds[o]);
      return e.decentriqDer != null && Object.hasOwnProperty.call(e, "decentriqDer") && n.uint32(
        /* id 5, wireType 2 =*/
        42
      ).bytes(e.decentriqDer), n;
    }, r.encodeDelimited = function(e, n) {
      return this.encode(e, n).ldelim();
    }, r.decode = function(e, n) {
      e instanceof $Reader || (e = $Reader.create(e));
      let o = n === void 0 ? e.len : e.pos + n, c = new $root.attestation.AttestationSpecificationAmdSnp();
      for (; e.pos < o; ) {
        let l = e.uint32();
        switch (l >>> 3) {
          case 1: {
            c.amdArkDer = e.bytes();
            break;
          }
          case 2: {
            c.measurement = e.bytes();
            break;
          }
          case 3: {
            c.roughtimePubKey = e.bytes();
            break;
          }
          case 4: {
            c.authorizedChipIds && c.authorizedChipIds.length || (c.authorizedChipIds = []), c.authorizedChipIds.push(e.bytes());
            break;
          }
          case 5: {
            c.decentriqDer = e.bytes();
            break;
          }
          default:
            e.skipType(l & 7);
            break;
        }
      }
      return c;
    }, r.decodeDelimited = function(e) {
      return e instanceof $Reader || (e = new $Reader(e)), this.decode(e, e.uint32());
    }, r.verify = function(e) {
      if (typeof e != "object" || e === null)
        return "object expected";
      if (e.amdArkDer != null && e.hasOwnProperty("amdArkDer") && !(e.amdArkDer && typeof e.amdArkDer.length == "number" || $util.isString(e.amdArkDer)))
        return "amdArkDer: buffer expected";
      if (e.measurement != null && e.hasOwnProperty("measurement") && !(e.measurement && typeof e.measurement.length == "number" || $util.isString(e.measurement)))
        return "measurement: buffer expected";
      if (e.roughtimePubKey != null && e.hasOwnProperty("roughtimePubKey") && !(e.roughtimePubKey && typeof e.roughtimePubKey.length == "number" || $util.isString(e.roughtimePubKey)))
        return "roughtimePubKey: buffer expected";
      if (e.authorizedChipIds != null && e.hasOwnProperty("authorizedChipIds")) {
        if (!Array.isArray(e.authorizedChipIds))
          return "authorizedChipIds: array expected";
        for (let n = 0; n < e.authorizedChipIds.length; ++n)
          if (!(e.authorizedChipIds[n] && typeof e.authorizedChipIds[n].length == "number" || $util.isString(e.authorizedChipIds[n])))
            return "authorizedChipIds: buffer[] expected";
      }
      return e.decentriqDer != null && e.hasOwnProperty("decentriqDer") && !(e.decentriqDer && typeof e.decentriqDer.length == "number" || $util.isString(e.decentriqDer)) ? "decentriqDer: buffer expected" : null;
    }, r.fromObject = function(e) {
      if (e instanceof $root.attestation.AttestationSpecificationAmdSnp)
        return e;
      let n = new $root.attestation.AttestationSpecificationAmdSnp();
      if (e.amdArkDer != null && (typeof e.amdArkDer == "string" ? $util.base64.decode(e.amdArkDer, n.amdArkDer = $util.newBuffer($util.base64.length(e.amdArkDer)), 0) : e.amdArkDer.length >= 0 && (n.amdArkDer = e.amdArkDer)), e.measurement != null && (typeof e.measurement == "string" ? $util.base64.decode(e.measurement, n.measurement = $util.newBuffer($util.base64.length(e.measurement)), 0) : e.measurement.length >= 0 && (n.measurement = e.measurement)), e.roughtimePubKey != null && (typeof e.roughtimePubKey == "string" ? $util.base64.decode(e.roughtimePubKey, n.roughtimePubKey = $util.newBuffer($util.base64.length(e.roughtimePubKey)), 0) : e.roughtimePubKey.length >= 0 && (n.roughtimePubKey = e.roughtimePubKey)), e.authorizedChipIds) {
        if (!Array.isArray(e.authorizedChipIds))
          throw TypeError(".attestation.AttestationSpecificationAmdSnp.authorizedChipIds: array expected");
        n.authorizedChipIds = [];
        for (let o = 0; o < e.authorizedChipIds.length; ++o)
          typeof e.authorizedChipIds[o] == "string" ? $util.base64.decode(e.authorizedChipIds[o], n.authorizedChipIds[o] = $util.newBuffer($util.base64.length(e.authorizedChipIds[o])), 0) : e.authorizedChipIds[o].length >= 0 && (n.authorizedChipIds[o] = e.authorizedChipIds[o]);
      }
      return e.decentriqDer != null && (typeof e.decentriqDer == "string" ? $util.base64.decode(e.decentriqDer, n.decentriqDer = $util.newBuffer($util.base64.length(e.decentriqDer)), 0) : e.decentriqDer.length >= 0 && (n.decentriqDer = e.decentriqDer)), n;
    }, r.toObject = function(e, n) {
      n || (n = {});
      let o = {};
      if ((n.arrays || n.defaults) && (o.authorizedChipIds = []), n.defaults && (n.bytes === String ? o.amdArkDer = "" : (o.amdArkDer = [], n.bytes !== Array && (o.amdArkDer = $util.newBuffer(o.amdArkDer))), n.bytes === String ? o.measurement = "" : (o.measurement = [], n.bytes !== Array && (o.measurement = $util.newBuffer(o.measurement))), n.bytes === String ? o.roughtimePubKey = "" : (o.roughtimePubKey = [], n.bytes !== Array && (o.roughtimePubKey = $util.newBuffer(o.roughtimePubKey))), n.bytes === String ? o.decentriqDer = "" : (o.decentriqDer = [], n.bytes !== Array && (o.decentriqDer = $util.newBuffer(o.decentriqDer)))), e.amdArkDer != null && e.hasOwnProperty("amdArkDer") && (o.amdArkDer = n.bytes === String ? $util.base64.encode(e.amdArkDer, 0, e.amdArkDer.length) : n.bytes === Array ? Array.prototype.slice.call(e.amdArkDer) : e.amdArkDer), e.measurement != null && e.hasOwnProperty("measurement") && (o.measurement = n.bytes === String ? $util.base64.encode(e.measurement, 0, e.measurement.length) : n.bytes === Array ? Array.prototype.slice.call(e.measurement) : e.measurement), e.roughtimePubKey != null && e.hasOwnProperty("roughtimePubKey") && (o.roughtimePubKey = n.bytes === String ? $util.base64.encode(e.roughtimePubKey, 0, e.roughtimePubKey.length) : n.bytes === Array ? Array.prototype.slice.call(e.roughtimePubKey) : e.roughtimePubKey), e.authorizedChipIds && e.authorizedChipIds.length) {
        o.authorizedChipIds = [];
        for (let c = 0; c < e.authorizedChipIds.length; ++c)
          o.authorizedChipIds[c] = n.bytes === String ? $util.base64.encode(e.authorizedChipIds[c], 0, e.authorizedChipIds[c].length) : n.bytes === Array ? Array.prototype.slice.call(e.authorizedChipIds[c]) : e.authorizedChipIds[c];
      }
      return e.decentriqDer != null && e.hasOwnProperty("decentriqDer") && (o.decentriqDer = n.bytes === String ? $util.base64.encode(e.decentriqDer, 0, e.decentriqDer.length) : n.bytes === Array ? Array.prototype.slice.call(e.decentriqDer) : e.decentriqDer), o;
    }, r.prototype.toJSON = function() {
      return this.constructor.toObject(this, minimal.util.toJSONOptions);
    }, r.getTypeUrl = function(e) {
      return e === void 0 && (e = "type.googleapis.com"), e + "/attestation.AttestationSpecificationAmdSnp";
    }, r;
  }(), u.AttestationSpecificationIntelDcapMrsigner = function() {
    function r(a) {
      if (a)
        for (let e = Object.keys(a), n = 0; n < e.length; ++n)
          a[e[n]] != null && (this[e[n]] = a[e[n]]);
    }
    return r.prototype.mrsigner = $util.newBuffer([]), r.prototype.dcapRootCaDer = $util.newBuffer([]), r.prototype.acceptDebug = !1, r.prototype.acceptOutOfDate = !1, r.prototype.acceptConfigurationNeeded = !1, r.prototype.acceptRevoked = !1, r.prototype.isvprodid = 0, r.prototype.sigstoreRootOlpcJson = $util.newBuffer([]), r.create = function(e) {
      return new r(e);
    }, r.encode = function(e, n) {
      return n || (n = $Writer.create()), e.mrsigner != null && Object.hasOwnProperty.call(e, "mrsigner") && n.uint32(
        /* id 1, wireType 2 =*/
        10
      ).bytes(e.mrsigner), e.dcapRootCaDer != null && Object.hasOwnProperty.call(e, "dcapRootCaDer") && n.uint32(
        /* id 2, wireType 2 =*/
        18
      ).bytes(e.dcapRootCaDer), e.acceptDebug != null && Object.hasOwnProperty.call(e, "acceptDebug") && n.uint32(
        /* id 3, wireType 0 =*/
        24
      ).bool(e.acceptDebug), e.acceptOutOfDate != null && Object.hasOwnProperty.call(e, "acceptOutOfDate") && n.uint32(
        /* id 4, wireType 0 =*/
        32
      ).bool(e.acceptOutOfDate), e.acceptConfigurationNeeded != null && Object.hasOwnProperty.call(e, "acceptConfigurationNeeded") && n.uint32(
        /* id 5, wireType 0 =*/
        40
      ).bool(e.acceptConfigurationNeeded), e.acceptRevoked != null && Object.hasOwnProperty.call(e, "acceptRevoked") && n.uint32(
        /* id 6, wireType 0 =*/
        48
      ).bool(e.acceptRevoked), e.isvprodid != null && Object.hasOwnProperty.call(e, "isvprodid") && n.uint32(
        /* id 7, wireType 0 =*/
        56
      ).uint32(e.isvprodid), e.sigstoreRootOlpcJson != null && Object.hasOwnProperty.call(e, "sigstoreRootOlpcJson") && n.uint32(
        /* id 8, wireType 2 =*/
        66
      ).bytes(e.sigstoreRootOlpcJson), n;
    }, r.encodeDelimited = function(e, n) {
      return this.encode(e, n).ldelim();
    }, r.decode = function(e, n) {
      e instanceof $Reader || (e = $Reader.create(e));
      let o = n === void 0 ? e.len : e.pos + n, c = new $root.attestation.AttestationSpecificationIntelDcapMrsigner();
      for (; e.pos < o; ) {
        let l = e.uint32();
        switch (l >>> 3) {
          case 1: {
            c.mrsigner = e.bytes();
            break;
          }
          case 2: {
            c.dcapRootCaDer = e.bytes();
            break;
          }
          case 3: {
            c.acceptDebug = e.bool();
            break;
          }
          case 4: {
            c.acceptOutOfDate = e.bool();
            break;
          }
          case 5: {
            c.acceptConfigurationNeeded = e.bool();
            break;
          }
          case 6: {
            c.acceptRevoked = e.bool();
            break;
          }
          case 7: {
            c.isvprodid = e.uint32();
            break;
          }
          case 8: {
            c.sigstoreRootOlpcJson = e.bytes();
            break;
          }
          default:
            e.skipType(l & 7);
            break;
        }
      }
      return c;
    }, r.decodeDelimited = function(e) {
      return e instanceof $Reader || (e = new $Reader(e)), this.decode(e, e.uint32());
    }, r.verify = function(e) {
      return typeof e != "object" || e === null ? "object expected" : e.mrsigner != null && e.hasOwnProperty("mrsigner") && !(e.mrsigner && typeof e.mrsigner.length == "number" || $util.isString(e.mrsigner)) ? "mrsigner: buffer expected" : e.dcapRootCaDer != null && e.hasOwnProperty("dcapRootCaDer") && !(e.dcapRootCaDer && typeof e.dcapRootCaDer.length == "number" || $util.isString(e.dcapRootCaDer)) ? "dcapRootCaDer: buffer expected" : e.acceptDebug != null && e.hasOwnProperty("acceptDebug") && typeof e.acceptDebug != "boolean" ? "acceptDebug: boolean expected" : e.acceptOutOfDate != null && e.hasOwnProperty("acceptOutOfDate") && typeof e.acceptOutOfDate != "boolean" ? "acceptOutOfDate: boolean expected" : e.acceptConfigurationNeeded != null && e.hasOwnProperty("acceptConfigurationNeeded") && typeof e.acceptConfigurationNeeded != "boolean" ? "acceptConfigurationNeeded: boolean expected" : e.acceptRevoked != null && e.hasOwnProperty("acceptRevoked") && typeof e.acceptRevoked != "boolean" ? "acceptRevoked: boolean expected" : e.isvprodid != null && e.hasOwnProperty("isvprodid") && !$util.isInteger(e.isvprodid) ? "isvprodid: integer expected" : e.sigstoreRootOlpcJson != null && e.hasOwnProperty("sigstoreRootOlpcJson") && !(e.sigstoreRootOlpcJson && typeof e.sigstoreRootOlpcJson.length == "number" || $util.isString(e.sigstoreRootOlpcJson)) ? "sigstoreRootOlpcJson: buffer expected" : null;
    }, r.fromObject = function(e) {
      if (e instanceof $root.attestation.AttestationSpecificationIntelDcapMrsigner)
        return e;
      let n = new $root.attestation.AttestationSpecificationIntelDcapMrsigner();
      return e.mrsigner != null && (typeof e.mrsigner == "string" ? $util.base64.decode(e.mrsigner, n.mrsigner = $util.newBuffer($util.base64.length(e.mrsigner)), 0) : e.mrsigner.length >= 0 && (n.mrsigner = e.mrsigner)), e.dcapRootCaDer != null && (typeof e.dcapRootCaDer == "string" ? $util.base64.decode(e.dcapRootCaDer, n.dcapRootCaDer = $util.newBuffer($util.base64.length(e.dcapRootCaDer)), 0) : e.dcapRootCaDer.length >= 0 && (n.dcapRootCaDer = e.dcapRootCaDer)), e.acceptDebug != null && (n.acceptDebug = !!e.acceptDebug), e.acceptOutOfDate != null && (n.acceptOutOfDate = !!e.acceptOutOfDate), e.acceptConfigurationNeeded != null && (n.acceptConfigurationNeeded = !!e.acceptConfigurationNeeded), e.acceptRevoked != null && (n.acceptRevoked = !!e.acceptRevoked), e.isvprodid != null && (n.isvprodid = e.isvprodid >>> 0), e.sigstoreRootOlpcJson != null && (typeof e.sigstoreRootOlpcJson == "string" ? $util.base64.decode(e.sigstoreRootOlpcJson, n.sigstoreRootOlpcJson = $util.newBuffer($util.base64.length(e.sigstoreRootOlpcJson)), 0) : e.sigstoreRootOlpcJson.length >= 0 && (n.sigstoreRootOlpcJson = e.sigstoreRootOlpcJson)), n;
    }, r.toObject = function(e, n) {
      n || (n = {});
      let o = {};
      return n.defaults && (n.bytes === String ? o.mrsigner = "" : (o.mrsigner = [], n.bytes !== Array && (o.mrsigner = $util.newBuffer(o.mrsigner))), n.bytes === String ? o.dcapRootCaDer = "" : (o.dcapRootCaDer = [], n.bytes !== Array && (o.dcapRootCaDer = $util.newBuffer(o.dcapRootCaDer))), o.acceptDebug = !1, o.acceptOutOfDate = !1, o.acceptConfigurationNeeded = !1, o.acceptRevoked = !1, o.isvprodid = 0, n.bytes === String ? o.sigstoreRootOlpcJson = "" : (o.sigstoreRootOlpcJson = [], n.bytes !== Array && (o.sigstoreRootOlpcJson = $util.newBuffer(o.sigstoreRootOlpcJson)))), e.mrsigner != null && e.hasOwnProperty("mrsigner") && (o.mrsigner = n.bytes === String ? $util.base64.encode(e.mrsigner, 0, e.mrsigner.length) : n.bytes === Array ? Array.prototype.slice.call(e.mrsigner) : e.mrsigner), e.dcapRootCaDer != null && e.hasOwnProperty("dcapRootCaDer") && (o.dcapRootCaDer = n.bytes === String ? $util.base64.encode(e.dcapRootCaDer, 0, e.dcapRootCaDer.length) : n.bytes === Array ? Array.prototype.slice.call(e.dcapRootCaDer) : e.dcapRootCaDer), e.acceptDebug != null && e.hasOwnProperty("acceptDebug") && (o.acceptDebug = e.acceptDebug), e.acceptOutOfDate != null && e.hasOwnProperty("acceptOutOfDate") && (o.acceptOutOfDate = e.acceptOutOfDate), e.acceptConfigurationNeeded != null && e.hasOwnProperty("acceptConfigurationNeeded") && (o.acceptConfigurationNeeded = e.acceptConfigurationNeeded), e.acceptRevoked != null && e.hasOwnProperty("acceptRevoked") && (o.acceptRevoked = e.acceptRevoked), e.isvprodid != null && e.hasOwnProperty("isvprodid") && (o.isvprodid = e.isvprodid), e.sigstoreRootOlpcJson != null && e.hasOwnProperty("sigstoreRootOlpcJson") && (o.sigstoreRootOlpcJson = n.bytes === String ? $util.base64.encode(e.sigstoreRootOlpcJson, 0, e.sigstoreRootOlpcJson.length) : n.bytes === Array ? Array.prototype.slice.call(e.sigstoreRootOlpcJson) : e.sigstoreRootOlpcJson), o;
    }, r.prototype.toJSON = function() {
      return this.constructor.toObject(this, minimal.util.toJSONOptions);
    }, r.getTypeUrl = function(e) {
      return e === void 0 && (e = "type.googleapis.com"), e + "/attestation.AttestationSpecificationIntelDcapMrsigner";
    }, r;
  }(), u;
})();
$root.azure_blob_storage = (() => {
  const u = {};
  return u.ImportRole = function() {
    function r(a) {
      if (a)
        for (let e = Object.keys(a), n = 0; n < e.length; ++n)
          a[e[n]] != null && (this[e[n]] = a[e[n]]);
    }
    return r.create = function(e) {
      return new r(e);
    }, r.encode = function(e, n) {
      return n || (n = $Writer.create()), n;
    }, r.encodeDelimited = function(e, n) {
      return this.encode(e, n).ldelim();
    }, r.decode = function(e, n) {
      e instanceof $Reader || (e = $Reader.create(e));
      let o = n === void 0 ? e.len : e.pos + n, c = new $root.azure_blob_storage.ImportRole();
      for (; e.pos < o; ) {
        let l = e.uint32();
        switch (l >>> 3) {
          default:
            e.skipType(l & 7);
            break;
        }
      }
      return c;
    }, r.decodeDelimited = function(e) {
      return e instanceof $Reader || (e = new $Reader(e)), this.decode(e, e.uint32());
    }, r.verify = function(e) {
      return typeof e != "object" || e === null ? "object expected" : null;
    }, r.fromObject = function(e) {
      return e instanceof $root.azure_blob_storage.ImportRole ? e : new $root.azure_blob_storage.ImportRole();
    }, r.toObject = function() {
      return {};
    }, r.prototype.toJSON = function() {
      return this.constructor.toObject(this, minimal.util.toJSONOptions);
    }, r.getTypeUrl = function(e) {
      return e === void 0 && (e = "type.googleapis.com"), e + "/azure_blob_storage.ImportRole";
    }, r;
  }(), u.ExportRole = function() {
    function r(a) {
      if (a)
        for (let e = Object.keys(a), n = 0; n < e.length; ++n)
          a[e[n]] != null && (this[e[n]] = a[e[n]]);
    }
    return r.prototype.input = null, r.create = function(e) {
      return new r(e);
    }, r.encode = function(e, n) {
      return n || (n = $Writer.create()), e.input != null && Object.hasOwnProperty.call(e, "input") && $root.azure_blob_storage.SinkInput.encode(e.input, n.uint32(
        /* id 1, wireType 2 =*/
        10
      ).fork()).ldelim(), n;
    }, r.encodeDelimited = function(e, n) {
      return this.encode(e, n).ldelim();
    }, r.decode = function(e, n) {
      e instanceof $Reader || (e = $Reader.create(e));
      let o = n === void 0 ? e.len : e.pos + n, c = new $root.azure_blob_storage.ExportRole();
      for (; e.pos < o; ) {
        let l = e.uint32();
        switch (l >>> 3) {
          case 1: {
            c.input = $root.azure_blob_storage.SinkInput.decode(e, e.uint32());
            break;
          }
          default:
            e.skipType(l & 7);
            break;
        }
      }
      return c;
    }, r.decodeDelimited = function(e) {
      return e instanceof $Reader || (e = new $Reader(e)), this.decode(e, e.uint32());
    }, r.verify = function(e) {
      if (typeof e != "object" || e === null)
        return "object expected";
      if (e.input != null && e.hasOwnProperty("input")) {
        let n = $root.azure_blob_storage.SinkInput.verify(e.input);
        if (n)
          return "input." + n;
      }
      return null;
    }, r.fromObject = function(e) {
      if (e instanceof $root.azure_blob_storage.ExportRole)
        return e;
      let n = new $root.azure_blob_storage.ExportRole();
      if (e.input != null) {
        if (typeof e.input != "object")
          throw TypeError(".azure_blob_storage.ExportRole.input: object expected");
        n.input = $root.azure_blob_storage.SinkInput.fromObject(e.input);
      }
      return n;
    }, r.toObject = function(e, n) {
      n || (n = {});
      let o = {};
      return n.defaults && (o.input = null), e.input != null && e.hasOwnProperty("input") && (o.input = $root.azure_blob_storage.SinkInput.toObject(e.input, n)), o;
    }, r.prototype.toJSON = function() {
      return this.constructor.toObject(this, minimal.util.toJSONOptions);
    }, r.getTypeUrl = function(e) {
      return e === void 0 && (e = "type.googleapis.com"), e + "/azure_blob_storage.ExportRole";
    }, r;
  }(), u.SingleFile = function() {
    function r(a) {
      if (a)
        for (let e = Object.keys(a), n = 0; n < e.length; ++n)
          a[e[n]] != null && (this[e[n]] = a[e[n]]);
    }
    return r.prototype.name = "", r.create = function(e) {
      return new r(e);
    }, r.encode = function(e, n) {
      return n || (n = $Writer.create()), e.name != null && Object.hasOwnProperty.call(e, "name") && n.uint32(
        /* id 1, wireType 2 =*/
        10
      ).string(e.name), n;
    }, r.encodeDelimited = function(e, n) {
      return this.encode(e, n).ldelim();
    }, r.decode = function(e, n) {
      e instanceof $Reader || (e = $Reader.create(e));
      let o = n === void 0 ? e.len : e.pos + n, c = new $root.azure_blob_storage.SingleFile();
      for (; e.pos < o; ) {
        let l = e.uint32();
        switch (l >>> 3) {
          case 1: {
            c.name = e.string();
            break;
          }
          default:
            e.skipType(l & 7);
            break;
        }
      }
      return c;
    }, r.decodeDelimited = function(e) {
      return e instanceof $Reader || (e = new $Reader(e)), this.decode(e, e.uint32());
    }, r.verify = function(e) {
      return typeof e != "object" || e === null ? "object expected" : e.name != null && e.hasOwnProperty("name") && !$util.isString(e.name) ? "name: string expected" : null;
    }, r.fromObject = function(e) {
      if (e instanceof $root.azure_blob_storage.SingleFile)
        return e;
      let n = new $root.azure_blob_storage.SingleFile();
      return e.name != null && (n.name = String(e.name)), n;
    }, r.toObject = function(e, n) {
      n || (n = {});
      let o = {};
      return n.defaults && (o.name = ""), e.name != null && e.hasOwnProperty("name") && (o.name = e.name), o;
    }, r.prototype.toJSON = function() {
      return this.constructor.toObject(this, minimal.util.toJSONOptions);
    }, r.getTypeUrl = function(e) {
      return e === void 0 && (e = "type.googleapis.com"), e + "/azure_blob_storage.SingleFile";
    }, r;
  }(), u.RawFile = function() {
    function r(a) {
      if (a)
        for (let e = Object.keys(a), n = 0; n < e.length; ++n)
          a[e[n]] != null && (this[e[n]] = a[e[n]]);
    }
    return r.create = function(e) {
      return new r(e);
    }, r.encode = function(e, n) {
      return n || (n = $Writer.create()), n;
    }, r.encodeDelimited = function(e, n) {
      return this.encode(e, n).ldelim();
    }, r.decode = function(e, n) {
      e instanceof $Reader || (e = $Reader.create(e));
      let o = n === void 0 ? e.len : e.pos + n, c = new $root.azure_blob_storage.RawFile();
      for (; e.pos < o; ) {
        let l = e.uint32();
        switch (l >>> 3) {
          default:
            e.skipType(l & 7);
            break;
        }
      }
      return c;
    }, r.decodeDelimited = function(e) {
      return e instanceof $Reader || (e = new $Reader(e)), this.decode(e, e.uint32());
    }, r.verify = function(e) {
      return typeof e != "object" || e === null ? "object expected" : null;
    }, r.fromObject = function(e) {
      return e instanceof $root.azure_blob_storage.RawFile ? e : new $root.azure_blob_storage.RawFile();
    }, r.toObject = function() {
      return {};
    }, r.prototype.toJSON = function() {
      return this.constructor.toObject(this, minimal.util.toJSONOptions);
    }, r.getTypeUrl = function(e) {
      return e === void 0 && (e = "type.googleapis.com"), e + "/azure_blob_storage.RawFile";
    }, r;
  }(), u.ZipFile = function() {
    function r(e) {
      if (e)
        for (let n = Object.keys(e), o = 0; o < n.length; ++o)
          e[n[o]] != null && (this[n[o]] = e[n[o]]);
    }
    r.prototype.singleFile = null;
    let a;
    return Object.defineProperty(r.prototype, "selection", {
      get: $util.oneOfGetter(a = ["singleFile"]),
      set: $util.oneOfSetter(a)
    }), r.create = function(n) {
      return new r(n);
    }, r.encode = function(n, o) {
      return o || (o = $Writer.create()), n.singleFile != null && Object.hasOwnProperty.call(n, "singleFile") && $root.azure_blob_storage.SingleFile.encode(n.singleFile, o.uint32(
        /* id 1, wireType 2 =*/
        10
      ).fork()).ldelim(), o;
    }, r.encodeDelimited = function(n, o) {
      return this.encode(n, o).ldelim();
    }, r.decode = function(n, o) {
      n instanceof $Reader || (n = $Reader.create(n));
      let c = o === void 0 ? n.len : n.pos + o, l = new $root.azure_blob_storage.ZipFile();
      for (; n.pos < c; ) {
        let d = n.uint32();
        switch (d >>> 3) {
          case 1: {
            l.singleFile = $root.azure_blob_storage.SingleFile.decode(n, n.uint32());
            break;
          }
          default:
            n.skipType(d & 7);
            break;
        }
      }
      return l;
    }, r.decodeDelimited = function(n) {
      return n instanceof $Reader || (n = new $Reader(n)), this.decode(n, n.uint32());
    }, r.verify = function(n) {
      if (typeof n != "object" || n === null)
        return "object expected";
      if (n.singleFile != null && n.hasOwnProperty("singleFile")) {
        let o = $root.azure_blob_storage.SingleFile.verify(n.singleFile);
        if (o)
          return "singleFile." + o;
      }
      return null;
    }, r.fromObject = function(n) {
      if (n instanceof $root.azure_blob_storage.ZipFile)
        return n;
      let o = new $root.azure_blob_storage.ZipFile();
      if (n.singleFile != null) {
        if (typeof n.singleFile != "object")
          throw TypeError(".azure_blob_storage.ZipFile.singleFile: object expected");
        o.singleFile = $root.azure_blob_storage.SingleFile.fromObject(n.singleFile);
      }
      return o;
    }, r.toObject = function(n, o) {
      o || (o = {});
      let c = {};
      return n.singleFile != null && n.hasOwnProperty("singleFile") && (c.singleFile = $root.azure_blob_storage.SingleFile.toObject(n.singleFile, o), o.oneofs && (c.selection = "singleFile")), c;
    }, r.prototype.toJSON = function() {
      return this.constructor.toObject(this, minimal.util.toJSONOptions);
    }, r.getTypeUrl = function(n) {
      return n === void 0 && (n = "type.googleapis.com"), n + "/azure_blob_storage.ZipFile";
    }, r;
  }(), u.SinkInput = function() {
    function r(e) {
      if (e)
        for (let n = Object.keys(e), o = 0; o < n.length; ++o)
          e[n[o]] != null && (this[n[o]] = e[n[o]]);
    }
    r.prototype.dependency = "", r.prototype.name = "", r.prototype.raw = null, r.prototype.zip = null;
    let a;
    return Object.defineProperty(r.prototype, "file", {
      get: $util.oneOfGetter(a = ["raw", "zip"]),
      set: $util.oneOfSetter(a)
    }), r.create = function(n) {
      return new r(n);
    }, r.encode = function(n, o) {
      return o || (o = $Writer.create()), n.dependency != null && Object.hasOwnProperty.call(n, "dependency") && o.uint32(
        /* id 1, wireType 2 =*/
        10
      ).string(n.dependency), n.name != null && Object.hasOwnProperty.call(n, "name") && o.uint32(
        /* id 2, wireType 2 =*/
        18
      ).string(n.name), n.raw != null && Object.hasOwnProperty.call(n, "raw") && $root.azure_blob_storage.RawFile.encode(n.raw, o.uint32(
        /* id 3, wireType 2 =*/
        26
      ).fork()).ldelim(), n.zip != null && Object.hasOwnProperty.call(n, "zip") && $root.azure_blob_storage.ZipFile.encode(n.zip, o.uint32(
        /* id 4, wireType 2 =*/
        34
      ).fork()).ldelim(), o;
    }, r.encodeDelimited = function(n, o) {
      return this.encode(n, o).ldelim();
    }, r.decode = function(n, o) {
      n instanceof $Reader || (n = $Reader.create(n));
      let c = o === void 0 ? n.len : n.pos + o, l = new $root.azure_blob_storage.SinkInput();
      for (; n.pos < c; ) {
        let d = n.uint32();
        switch (d >>> 3) {
          case 1: {
            l.dependency = n.string();
            break;
          }
          case 2: {
            l.name = n.string();
            break;
          }
          case 3: {
            l.raw = $root.azure_blob_storage.RawFile.decode(n, n.uint32());
            break;
          }
          case 4: {
            l.zip = $root.azure_blob_storage.ZipFile.decode(n, n.uint32());
            break;
          }
          default:
            n.skipType(d & 7);
            break;
        }
      }
      return l;
    }, r.decodeDelimited = function(n) {
      return n instanceof $Reader || (n = new $Reader(n)), this.decode(n, n.uint32());
    }, r.verify = function(n) {
      if (typeof n != "object" || n === null)
        return "object expected";
      let o = {};
      if (n.dependency != null && n.hasOwnProperty("dependency") && !$util.isString(n.dependency))
        return "dependency: string expected";
      if (n.name != null && n.hasOwnProperty("name") && !$util.isString(n.name))
        return "name: string expected";
      if (n.raw != null && n.hasOwnProperty("raw")) {
        o.file = 1;
        {
          let c = $root.azure_blob_storage.RawFile.verify(n.raw);
          if (c)
            return "raw." + c;
        }
      }
      if (n.zip != null && n.hasOwnProperty("zip")) {
        if (o.file === 1)
          return "file: multiple values";
        o.file = 1;
        {
          let c = $root.azure_blob_storage.ZipFile.verify(n.zip);
          if (c)
            return "zip." + c;
        }
      }
      return null;
    }, r.fromObject = function(n) {
      if (n instanceof $root.azure_blob_storage.SinkInput)
        return n;
      let o = new $root.azure_blob_storage.SinkInput();
      if (n.dependency != null && (o.dependency = String(n.dependency)), n.name != null && (o.name = String(n.name)), n.raw != null) {
        if (typeof n.raw != "object")
          throw TypeError(".azure_blob_storage.SinkInput.raw: object expected");
        o.raw = $root.azure_blob_storage.RawFile.fromObject(n.raw);
      }
      if (n.zip != null) {
        if (typeof n.zip != "object")
          throw TypeError(".azure_blob_storage.SinkInput.zip: object expected");
        o.zip = $root.azure_blob_storage.ZipFile.fromObject(n.zip);
      }
      return o;
    }, r.toObject = function(n, o) {
      o || (o = {});
      let c = {};
      return o.defaults && (c.dependency = "", c.name = ""), n.dependency != null && n.hasOwnProperty("dependency") && (c.dependency = n.dependency), n.name != null && n.hasOwnProperty("name") && (c.name = n.name), n.raw != null && n.hasOwnProperty("raw") && (c.raw = $root.azure_blob_storage.RawFile.toObject(n.raw, o), o.oneofs && (c.file = "raw")), n.zip != null && n.hasOwnProperty("zip") && (c.zip = $root.azure_blob_storage.ZipFile.toObject(n.zip, o), o.oneofs && (c.file = "zip")), c;
    }, r.prototype.toJSON = function() {
      return this.constructor.toObject(this, minimal.util.toJSONOptions);
    }, r.getTypeUrl = function(n) {
      return n === void 0 && (n = "type.googleapis.com"), n + "/azure_blob_storage.SinkInput";
    }, r;
  }(), u.AzureBlobStorageWorkerConfiguration = function() {
    function r(e) {
      if (e)
        for (let n = Object.keys(e), o = 0; o < n.length; ++o)
          e[n[o]] != null && (this[n[o]] = e[n[o]]);
    }
    r.prototype.credentialsDependency = "", r.prototype.importRole = null, r.prototype.exportRole = null;
    let a;
    return Object.defineProperty(r.prototype, "role", {
      get: $util.oneOfGetter(a = ["importRole", "exportRole"]),
      set: $util.oneOfSetter(a)
    }), r.create = function(n) {
      return new r(n);
    }, r.encode = function(n, o) {
      return o || (o = $Writer.create()), n.credentialsDependency != null && Object.hasOwnProperty.call(n, "credentialsDependency") && o.uint32(
        /* id 1, wireType 2 =*/
        10
      ).string(n.credentialsDependency), n.importRole != null && Object.hasOwnProperty.call(n, "importRole") && $root.azure_blob_storage.ImportRole.encode(n.importRole, o.uint32(
        /* id 2, wireType 2 =*/
        18
      ).fork()).ldelim(), n.exportRole != null && Object.hasOwnProperty.call(n, "exportRole") && $root.azure_blob_storage.ExportRole.encode(n.exportRole, o.uint32(
        /* id 3, wireType 2 =*/
        26
      ).fork()).ldelim(), o;
    }, r.encodeDelimited = function(n, o) {
      return this.encode(n, o).ldelim();
    }, r.decode = function(n, o) {
      n instanceof $Reader || (n = $Reader.create(n));
      let c = o === void 0 ? n.len : n.pos + o, l = new $root.azure_blob_storage.AzureBlobStorageWorkerConfiguration();
      for (; n.pos < c; ) {
        let d = n.uint32();
        switch (d >>> 3) {
          case 1: {
            l.credentialsDependency = n.string();
            break;
          }
          case 2: {
            l.importRole = $root.azure_blob_storage.ImportRole.decode(n, n.uint32());
            break;
          }
          case 3: {
            l.exportRole = $root.azure_blob_storage.ExportRole.decode(n, n.uint32());
            break;
          }
          default:
            n.skipType(d & 7);
            break;
        }
      }
      return l;
    }, r.decodeDelimited = function(n) {
      return n instanceof $Reader || (n = new $Reader(n)), this.decode(n, n.uint32());
    }, r.verify = function(n) {
      if (typeof n != "object" || n === null)
        return "object expected";
      let o = {};
      if (n.credentialsDependency != null && n.hasOwnProperty("credentialsDependency") && !$util.isString(n.credentialsDependency))
        return "credentialsDependency: string expected";
      if (n.importRole != null && n.hasOwnProperty("importRole")) {
        o.role = 1;
        {
          let c = $root.azure_blob_storage.ImportRole.verify(n.importRole);
          if (c)
            return "importRole." + c;
        }
      }
      if (n.exportRole != null && n.hasOwnProperty("exportRole")) {
        if (o.role === 1)
          return "role: multiple values";
        o.role = 1;
        {
          let c = $root.azure_blob_storage.ExportRole.verify(n.exportRole);
          if (c)
            return "exportRole." + c;
        }
      }
      return null;
    }, r.fromObject = function(n) {
      if (n instanceof $root.azure_blob_storage.AzureBlobStorageWorkerConfiguration)
        return n;
      let o = new $root.azure_blob_storage.AzureBlobStorageWorkerConfiguration();
      if (n.credentialsDependency != null && (o.credentialsDependency = String(n.credentialsDependency)), n.importRole != null) {
        if (typeof n.importRole != "object")
          throw TypeError(".azure_blob_storage.AzureBlobStorageWorkerConfiguration.importRole: object expected");
        o.importRole = $root.azure_blob_storage.ImportRole.fromObject(n.importRole);
      }
      if (n.exportRole != null) {
        if (typeof n.exportRole != "object")
          throw TypeError(".azure_blob_storage.AzureBlobStorageWorkerConfiguration.exportRole: object expected");
        o.exportRole = $root.azure_blob_storage.ExportRole.fromObject(n.exportRole);
      }
      return o;
    }, r.toObject = function(n, o) {
      o || (o = {});
      let c = {};
      return o.defaults && (c.credentialsDependency = ""), n.credentialsDependency != null && n.hasOwnProperty("credentialsDependency") && (c.credentialsDependency = n.credentialsDependency), n.importRole != null && n.hasOwnProperty("importRole") && (c.importRole = $root.azure_blob_storage.ImportRole.toObject(n.importRole, o), o.oneofs && (c.role = "importRole")), n.exportRole != null && n.hasOwnProperty("exportRole") && (c.exportRole = $root.azure_blob_storage.ExportRole.toObject(n.exportRole, o), o.oneofs && (c.role = "exportRole")), c;
    }, r.prototype.toJSON = function() {
      return this.constructor.toObject(this, minimal.util.toJSONOptions);
    }, r.getTypeUrl = function(n) {
      return n === void 0 && (n = "type.googleapis.com"), n + "/azure_blob_storage.AzureBlobStorageWorkerConfiguration";
    }, r;
  }(), u;
})();
$root.compute_container = (() => {
  const u = {};
  return u.ContainerWorkerConfiguration = function() {
    function r(e) {
      if (e)
        for (let n = Object.keys(e), o = 0; o < n.length; ++o)
          e[n[o]] != null && (this[n[o]] = e[n[o]]);
    }
    r.prototype.static = null;
    let a;
    return Object.defineProperty(r.prototype, "configuration", {
      get: $util.oneOfGetter(a = ["static"]),
      set: $util.oneOfSetter(a)
    }), r.create = function(n) {
      return new r(n);
    }, r.encode = function(n, o) {
      return o || (o = $Writer.create()), n.static != null && Object.hasOwnProperty.call(n, "static") && $root.compute_container.StaticImage.encode(n.static, o.uint32(
        /* id 1, wireType 2 =*/
        10
      ).fork()).ldelim(), o;
    }, r.encodeDelimited = function(n, o) {
      return this.encode(n, o).ldelim();
    }, r.decode = function(n, o) {
      n instanceof $Reader || (n = $Reader.create(n));
      let c = o === void 0 ? n.len : n.pos + o, l = new $root.compute_container.ContainerWorkerConfiguration();
      for (; n.pos < c; ) {
        let d = n.uint32();
        switch (d >>> 3) {
          case 1: {
            l.static = $root.compute_container.StaticImage.decode(n, n.uint32());
            break;
          }
          default:
            n.skipType(d & 7);
            break;
        }
      }
      return l;
    }, r.decodeDelimited = function(n) {
      return n instanceof $Reader || (n = new $Reader(n)), this.decode(n, n.uint32());
    }, r.verify = function(n) {
      if (typeof n != "object" || n === null)
        return "object expected";
      if (n.static != null && n.hasOwnProperty("static")) {
        let o = $root.compute_container.StaticImage.verify(n.static);
        if (o)
          return "static." + o;
      }
      return null;
    }, r.fromObject = function(n) {
      if (n instanceof $root.compute_container.ContainerWorkerConfiguration)
        return n;
      let o = new $root.compute_container.ContainerWorkerConfiguration();
      if (n.static != null) {
        if (typeof n.static != "object")
          throw TypeError(".compute_container.ContainerWorkerConfiguration.static: object expected");
        o.static = $root.compute_container.StaticImage.fromObject(n.static);
      }
      return o;
    }, r.toObject = function(n, o) {
      o || (o = {});
      let c = {};
      return n.static != null && n.hasOwnProperty("static") && (c.static = $root.compute_container.StaticImage.toObject(n.static, o), o.oneofs && (c.configuration = "static")), c;
    }, r.prototype.toJSON = function() {
      return this.constructor.toObject(this, minimal.util.toJSONOptions);
    }, r.getTypeUrl = function(n) {
      return n === void 0 && (n = "type.googleapis.com"), n + "/compute_container.ContainerWorkerConfiguration";
    }, r;
  }(), u.StaticImage = function() {
    function r(e) {
      if (this.command = [], this.mountPoints = [], e)
        for (let n = Object.keys(e), o = 0; o < n.length; ++o)
          e[n[o]] != null && (this[n[o]] = e[n[o]]);
    }
    r.prototype.command = $util.emptyArray, r.prototype.mountPoints = $util.emptyArray, r.prototype.outputPath = "", r.prototype.includeContainerLogsOnError = !1, r.prototype.includeContainerLogsOnSuccess = !1, r.prototype.minimumContainerMemorySize = null, r.prototype.extraChunkCacheSizeToAvailableMemoryRatio = null, r.prototype.proxyConfiguration = null;
    let a;
    return Object.defineProperty(r.prototype, "_minimumContainerMemorySize", {
      get: $util.oneOfGetter(a = ["minimumContainerMemorySize"]),
      set: $util.oneOfSetter(a)
    }), Object.defineProperty(r.prototype, "_extraChunkCacheSizeToAvailableMemoryRatio", {
      get: $util.oneOfGetter(a = ["extraChunkCacheSizeToAvailableMemoryRatio"]),
      set: $util.oneOfSetter(a)
    }), Object.defineProperty(r.prototype, "_proxyConfiguration", {
      get: $util.oneOfGetter(a = ["proxyConfiguration"]),
      set: $util.oneOfSetter(a)
    }), r.create = function(n) {
      return new r(n);
    }, r.encode = function(n, o) {
      if (o || (o = $Writer.create()), n.command != null && n.command.length)
        for (let c = 0; c < n.command.length; ++c)
          o.uint32(
            /* id 1, wireType 2 =*/
            10
          ).string(n.command[c]);
      if (n.mountPoints != null && n.mountPoints.length)
        for (let c = 0; c < n.mountPoints.length; ++c)
          $root.compute_container.MountPoint.encode(n.mountPoints[c], o.uint32(
            /* id 2, wireType 2 =*/
            18
          ).fork()).ldelim();
      return n.outputPath != null && Object.hasOwnProperty.call(n, "outputPath") && o.uint32(
        /* id 3, wireType 2 =*/
        26
      ).string(n.outputPath), n.includeContainerLogsOnError != null && Object.hasOwnProperty.call(n, "includeContainerLogsOnError") && o.uint32(
        /* id 4, wireType 0 =*/
        32
      ).bool(n.includeContainerLogsOnError), n.includeContainerLogsOnSuccess != null && Object.hasOwnProperty.call(n, "includeContainerLogsOnSuccess") && o.uint32(
        /* id 5, wireType 0 =*/
        40
      ).bool(n.includeContainerLogsOnSuccess), n.minimumContainerMemorySize != null && Object.hasOwnProperty.call(n, "minimumContainerMemorySize") && o.uint32(
        /* id 6, wireType 0 =*/
        48
      ).uint64(n.minimumContainerMemorySize), n.extraChunkCacheSizeToAvailableMemoryRatio != null && Object.hasOwnProperty.call(n, "extraChunkCacheSizeToAvailableMemoryRatio") && o.uint32(
        /* id 7, wireType 5 =*/
        61
      ).float(n.extraChunkCacheSizeToAvailableMemoryRatio), n.proxyConfiguration != null && Object.hasOwnProperty.call(n, "proxyConfiguration") && $root.compute_container.ProxyConfiguration.encode(n.proxyConfiguration, o.uint32(
        /* id 8, wireType 2 =*/
        66
      ).fork()).ldelim(), o;
    }, r.encodeDelimited = function(n, o) {
      return this.encode(n, o).ldelim();
    }, r.decode = function(n, o) {
      n instanceof $Reader || (n = $Reader.create(n));
      let c = o === void 0 ? n.len : n.pos + o, l = new $root.compute_container.StaticImage();
      for (; n.pos < c; ) {
        let d = n.uint32();
        switch (d >>> 3) {
          case 1: {
            l.command && l.command.length || (l.command = []), l.command.push(n.string());
            break;
          }
          case 2: {
            l.mountPoints && l.mountPoints.length || (l.mountPoints = []), l.mountPoints.push($root.compute_container.MountPoint.decode(n, n.uint32()));
            break;
          }
          case 3: {
            l.outputPath = n.string();
            break;
          }
          case 4: {
            l.includeContainerLogsOnError = n.bool();
            break;
          }
          case 5: {
            l.includeContainerLogsOnSuccess = n.bool();
            break;
          }
          case 6: {
            l.minimumContainerMemorySize = n.uint64();
            break;
          }
          case 7: {
            l.extraChunkCacheSizeToAvailableMemoryRatio = n.float();
            break;
          }
          case 8: {
            l.proxyConfiguration = $root.compute_container.ProxyConfiguration.decode(n, n.uint32());
            break;
          }
          default:
            n.skipType(d & 7);
            break;
        }
      }
      return l;
    }, r.decodeDelimited = function(n) {
      return n instanceof $Reader || (n = new $Reader(n)), this.decode(n, n.uint32());
    }, r.verify = function(n) {
      if (typeof n != "object" || n === null)
        return "object expected";
      if (n.command != null && n.hasOwnProperty("command")) {
        if (!Array.isArray(n.command))
          return "command: array expected";
        for (let o = 0; o < n.command.length; ++o)
          if (!$util.isString(n.command[o]))
            return "command: string[] expected";
      }
      if (n.mountPoints != null && n.hasOwnProperty("mountPoints")) {
        if (!Array.isArray(n.mountPoints))
          return "mountPoints: array expected";
        for (let o = 0; o < n.mountPoints.length; ++o) {
          let c = $root.compute_container.MountPoint.verify(n.mountPoints[o]);
          if (c)
            return "mountPoints." + c;
        }
      }
      if (n.outputPath != null && n.hasOwnProperty("outputPath") && !$util.isString(n.outputPath))
        return "outputPath: string expected";
      if (n.includeContainerLogsOnError != null && n.hasOwnProperty("includeContainerLogsOnError") && typeof n.includeContainerLogsOnError != "boolean")
        return "includeContainerLogsOnError: boolean expected";
      if (n.includeContainerLogsOnSuccess != null && n.hasOwnProperty("includeContainerLogsOnSuccess") && typeof n.includeContainerLogsOnSuccess != "boolean")
        return "includeContainerLogsOnSuccess: boolean expected";
      if (n.minimumContainerMemorySize != null && n.hasOwnProperty("minimumContainerMemorySize") && !$util.isInteger(n.minimumContainerMemorySize) && !(n.minimumContainerMemorySize && $util.isInteger(n.minimumContainerMemorySize.low) && $util.isInteger(n.minimumContainerMemorySize.high)))
        return "minimumContainerMemorySize: integer|Long expected";
      if (n.extraChunkCacheSizeToAvailableMemoryRatio != null && n.hasOwnProperty("extraChunkCacheSizeToAvailableMemoryRatio") && typeof n.extraChunkCacheSizeToAvailableMemoryRatio != "number")
        return "extraChunkCacheSizeToAvailableMemoryRatio: number expected";
      if (n.proxyConfiguration != null && n.hasOwnProperty("proxyConfiguration")) {
        let o = $root.compute_container.ProxyConfiguration.verify(n.proxyConfiguration);
        if (o)
          return "proxyConfiguration." + o;
      }
      return null;
    }, r.fromObject = function(n) {
      if (n instanceof $root.compute_container.StaticImage)
        return n;
      let o = new $root.compute_container.StaticImage();
      if (n.command) {
        if (!Array.isArray(n.command))
          throw TypeError(".compute_container.StaticImage.command: array expected");
        o.command = [];
        for (let c = 0; c < n.command.length; ++c)
          o.command[c] = String(n.command[c]);
      }
      if (n.mountPoints) {
        if (!Array.isArray(n.mountPoints))
          throw TypeError(".compute_container.StaticImage.mountPoints: array expected");
        o.mountPoints = [];
        for (let c = 0; c < n.mountPoints.length; ++c) {
          if (typeof n.mountPoints[c] != "object")
            throw TypeError(".compute_container.StaticImage.mountPoints: object expected");
          o.mountPoints[c] = $root.compute_container.MountPoint.fromObject(n.mountPoints[c]);
        }
      }
      if (n.outputPath != null && (o.outputPath = String(n.outputPath)), n.includeContainerLogsOnError != null && (o.includeContainerLogsOnError = !!n.includeContainerLogsOnError), n.includeContainerLogsOnSuccess != null && (o.includeContainerLogsOnSuccess = !!n.includeContainerLogsOnSuccess), n.minimumContainerMemorySize != null && ($util.Long ? (o.minimumContainerMemorySize = $util.Long.fromValue(n.minimumContainerMemorySize)).unsigned = !0 : typeof n.minimumContainerMemorySize == "string" ? o.minimumContainerMemorySize = parseInt(n.minimumContainerMemorySize, 10) : typeof n.minimumContainerMemorySize == "number" ? o.minimumContainerMemorySize = n.minimumContainerMemorySize : typeof n.minimumContainerMemorySize == "object" && (o.minimumContainerMemorySize = new $util.LongBits(n.minimumContainerMemorySize.low >>> 0, n.minimumContainerMemorySize.high >>> 0).toNumber(!0))), n.extraChunkCacheSizeToAvailableMemoryRatio != null && (o.extraChunkCacheSizeToAvailableMemoryRatio = Number(n.extraChunkCacheSizeToAvailableMemoryRatio)), n.proxyConfiguration != null) {
        if (typeof n.proxyConfiguration != "object")
          throw TypeError(".compute_container.StaticImage.proxyConfiguration: object expected");
        o.proxyConfiguration = $root.compute_container.ProxyConfiguration.fromObject(n.proxyConfiguration);
      }
      return o;
    }, r.toObject = function(n, o) {
      o || (o = {});
      let c = {};
      if ((o.arrays || o.defaults) && (c.command = [], c.mountPoints = []), o.defaults && (c.outputPath = "", c.includeContainerLogsOnError = !1, c.includeContainerLogsOnSuccess = !1), n.command && n.command.length) {
        c.command = [];
        for (let l = 0; l < n.command.length; ++l)
          c.command[l] = n.command[l];
      }
      if (n.mountPoints && n.mountPoints.length) {
        c.mountPoints = [];
        for (let l = 0; l < n.mountPoints.length; ++l)
          c.mountPoints[l] = $root.compute_container.MountPoint.toObject(n.mountPoints[l], o);
      }
      return n.outputPath != null && n.hasOwnProperty("outputPath") && (c.outputPath = n.outputPath), n.includeContainerLogsOnError != null && n.hasOwnProperty("includeContainerLogsOnError") && (c.includeContainerLogsOnError = n.includeContainerLogsOnError), n.includeContainerLogsOnSuccess != null && n.hasOwnProperty("includeContainerLogsOnSuccess") && (c.includeContainerLogsOnSuccess = n.includeContainerLogsOnSuccess), n.minimumContainerMemorySize != null && n.hasOwnProperty("minimumContainerMemorySize") && (typeof n.minimumContainerMemorySize == "number" ? c.minimumContainerMemorySize = o.longs === String ? String(n.minimumContainerMemorySize) : n.minimumContainerMemorySize : c.minimumContainerMemorySize = o.longs === String ? $util.Long.prototype.toString.call(n.minimumContainerMemorySize) : o.longs === Number ? new $util.LongBits(n.minimumContainerMemorySize.low >>> 0, n.minimumContainerMemorySize.high >>> 0).toNumber(!0) : n.minimumContainerMemorySize, o.oneofs && (c._minimumContainerMemorySize = "minimumContainerMemorySize")), n.extraChunkCacheSizeToAvailableMemoryRatio != null && n.hasOwnProperty("extraChunkCacheSizeToAvailableMemoryRatio") && (c.extraChunkCacheSizeToAvailableMemoryRatio = o.json && !isFinite(n.extraChunkCacheSizeToAvailableMemoryRatio) ? String(n.extraChunkCacheSizeToAvailableMemoryRatio) : n.extraChunkCacheSizeToAvailableMemoryRatio, o.oneofs && (c._extraChunkCacheSizeToAvailableMemoryRatio = "extraChunkCacheSizeToAvailableMemoryRatio")), n.proxyConfiguration != null && n.hasOwnProperty("proxyConfiguration") && (c.proxyConfiguration = $root.compute_container.ProxyConfiguration.toObject(n.proxyConfiguration, o), o.oneofs && (c._proxyConfiguration = "proxyConfiguration")), c;
    }, r.prototype.toJSON = function() {
      return this.constructor.toObject(this, minimal.util.toJSONOptions);
    }, r.getTypeUrl = function(n) {
      return n === void 0 && (n = "type.googleapis.com"), n + "/compute_container.StaticImage";
    }, r;
  }(), u.ProxyConfiguration = function() {
    function r(e) {
      if (e)
        for (let n = Object.keys(e), o = 0; o < n.length; ++o)
          e[n[o]] != null && (this[n[o]] = e[n[o]]);
    }
    r.prototype.liberal = null, r.prototype.domainAllowlist = null;
    let a;
    return Object.defineProperty(r.prototype, "configuration", {
      get: $util.oneOfGetter(a = ["liberal", "domainAllowlist"]),
      set: $util.oneOfSetter(a)
    }), r.create = function(n) {
      return new r(n);
    }, r.encode = function(n, o) {
      return o || (o = $Writer.create()), n.liberal != null && Object.hasOwnProperty.call(n, "liberal") && $root.compute_container.ProxyConfigurationLiberal.encode(n.liberal, o.uint32(
        /* id 1, wireType 2 =*/
        10
      ).fork()).ldelim(), n.domainAllowlist != null && Object.hasOwnProperty.call(n, "domainAllowlist") && $root.compute_container.ProxyConfigurationDomainAllowlist.encode(n.domainAllowlist, o.uint32(
        /* id 2, wireType 2 =*/
        18
      ).fork()).ldelim(), o;
    }, r.encodeDelimited = function(n, o) {
      return this.encode(n, o).ldelim();
    }, r.decode = function(n, o) {
      n instanceof $Reader || (n = $Reader.create(n));
      let c = o === void 0 ? n.len : n.pos + o, l = new $root.compute_container.ProxyConfiguration();
      for (; n.pos < c; ) {
        let d = n.uint32();
        switch (d >>> 3) {
          case 1: {
            l.liberal = $root.compute_container.ProxyConfigurationLiberal.decode(n, n.uint32());
            break;
          }
          case 2: {
            l.domainAllowlist = $root.compute_container.ProxyConfigurationDomainAllowlist.decode(n, n.uint32());
            break;
          }
          default:
            n.skipType(d & 7);
            break;
        }
      }
      return l;
    }, r.decodeDelimited = function(n) {
      return n instanceof $Reader || (n = new $Reader(n)), this.decode(n, n.uint32());
    }, r.verify = function(n) {
      if (typeof n != "object" || n === null)
        return "object expected";
      let o = {};
      if (n.liberal != null && n.hasOwnProperty("liberal")) {
        o.configuration = 1;
        {
          let c = $root.compute_container.ProxyConfigurationLiberal.verify(n.liberal);
          if (c)
            return "liberal." + c;
        }
      }
      if (n.domainAllowlist != null && n.hasOwnProperty("domainAllowlist")) {
        if (o.configuration === 1)
          return "configuration: multiple values";
        o.configuration = 1;
        {
          let c = $root.compute_container.ProxyConfigurationDomainAllowlist.verify(n.domainAllowlist);
          if (c)
            return "domainAllowlist." + c;
        }
      }
      return null;
    }, r.fromObject = function(n) {
      if (n instanceof $root.compute_container.ProxyConfiguration)
        return n;
      let o = new $root.compute_container.ProxyConfiguration();
      if (n.liberal != null) {
        if (typeof n.liberal != "object")
          throw TypeError(".compute_container.ProxyConfiguration.liberal: object expected");
        o.liberal = $root.compute_container.ProxyConfigurationLiberal.fromObject(n.liberal);
      }
      if (n.domainAllowlist != null) {
        if (typeof n.domainAllowlist != "object")
          throw TypeError(".compute_container.ProxyConfiguration.domainAllowlist: object expected");
        o.domainAllowlist = $root.compute_container.ProxyConfigurationDomainAllowlist.fromObject(n.domainAllowlist);
      }
      return o;
    }, r.toObject = function(n, o) {
      o || (o = {});
      let c = {};
      return n.liberal != null && n.hasOwnProperty("liberal") && (c.liberal = $root.compute_container.ProxyConfigurationLiberal.toObject(n.liberal, o), o.oneofs && (c.configuration = "liberal")), n.domainAllowlist != null && n.hasOwnProperty("domainAllowlist") && (c.domainAllowlist = $root.compute_container.ProxyConfigurationDomainAllowlist.toObject(n.domainAllowlist, o), o.oneofs && (c.configuration = "domainAllowlist")), c;
    }, r.prototype.toJSON = function() {
      return this.constructor.toObject(this, minimal.util.toJSONOptions);
    }, r.getTypeUrl = function(n) {
      return n === void 0 && (n = "type.googleapis.com"), n + "/compute_container.ProxyConfiguration";
    }, r;
  }(), u.ProxyConfigurationLiberal = function() {
    function r(a) {
      if (a)
        for (let e = Object.keys(a), n = 0; n < e.length; ++n)
          a[e[n]] != null && (this[e[n]] = a[e[n]]);
    }
    return r.create = function(e) {
      return new r(e);
    }, r.encode = function(e, n) {
      return n || (n = $Writer.create()), n;
    }, r.encodeDelimited = function(e, n) {
      return this.encode(e, n).ldelim();
    }, r.decode = function(e, n) {
      e instanceof $Reader || (e = $Reader.create(e));
      let o = n === void 0 ? e.len : e.pos + n, c = new $root.compute_container.ProxyConfigurationLiberal();
      for (; e.pos < o; ) {
        let l = e.uint32();
        switch (l >>> 3) {
          default:
            e.skipType(l & 7);
            break;
        }
      }
      return c;
    }, r.decodeDelimited = function(e) {
      return e instanceof $Reader || (e = new $Reader(e)), this.decode(e, e.uint32());
    }, r.verify = function(e) {
      return typeof e != "object" || e === null ? "object expected" : null;
    }, r.fromObject = function(e) {
      return e instanceof $root.compute_container.ProxyConfigurationLiberal ? e : new $root.compute_container.ProxyConfigurationLiberal();
    }, r.toObject = function() {
      return {};
    }, r.prototype.toJSON = function() {
      return this.constructor.toObject(this, minimal.util.toJSONOptions);
    }, r.getTypeUrl = function(e) {
      return e === void 0 && (e = "type.googleapis.com"), e + "/compute_container.ProxyConfigurationLiberal";
    }, r;
  }(), u.ProxyConfigurationDomainAllowlist = function() {
    function r(a) {
      if (this.domain = [], a)
        for (let e = Object.keys(a), n = 0; n < e.length; ++n)
          a[e[n]] != null && (this[e[n]] = a[e[n]]);
    }
    return r.prototype.domain = $util.emptyArray, r.create = function(e) {
      return new r(e);
    }, r.encode = function(e, n) {
      if (n || (n = $Writer.create()), e.domain != null && e.domain.length)
        for (let o = 0; o < e.domain.length; ++o)
          n.uint32(
            /* id 1, wireType 2 =*/
            10
          ).string(e.domain[o]);
      return n;
    }, r.encodeDelimited = function(e, n) {
      return this.encode(e, n).ldelim();
    }, r.decode = function(e, n) {
      e instanceof $Reader || (e = $Reader.create(e));
      let o = n === void 0 ? e.len : e.pos + n, c = new $root.compute_container.ProxyConfigurationDomainAllowlist();
      for (; e.pos < o; ) {
        let l = e.uint32();
        switch (l >>> 3) {
          case 1: {
            c.domain && c.domain.length || (c.domain = []), c.domain.push(e.string());
            break;
          }
          default:
            e.skipType(l & 7);
            break;
        }
      }
      return c;
    }, r.decodeDelimited = function(e) {
      return e instanceof $Reader || (e = new $Reader(e)), this.decode(e, e.uint32());
    }, r.verify = function(e) {
      if (typeof e != "object" || e === null)
        return "object expected";
      if (e.domain != null && e.hasOwnProperty("domain")) {
        if (!Array.isArray(e.domain))
          return "domain: array expected";
        for (let n = 0; n < e.domain.length; ++n)
          if (!$util.isString(e.domain[n]))
            return "domain: string[] expected";
      }
      return null;
    }, r.fromObject = function(e) {
      if (e instanceof $root.compute_container.ProxyConfigurationDomainAllowlist)
        return e;
      let n = new $root.compute_container.ProxyConfigurationDomainAllowlist();
      if (e.domain) {
        if (!Array.isArray(e.domain))
          throw TypeError(".compute_container.ProxyConfigurationDomainAllowlist.domain: array expected");
        n.domain = [];
        for (let o = 0; o < e.domain.length; ++o)
          n.domain[o] = String(e.domain[o]);
      }
      return n;
    }, r.toObject = function(e, n) {
      n || (n = {});
      let o = {};
      if ((n.arrays || n.defaults) && (o.domain = []), e.domain && e.domain.length) {
        o.domain = [];
        for (let c = 0; c < e.domain.length; ++c)
          o.domain[c] = e.domain[c];
      }
      return o;
    }, r.prototype.toJSON = function() {
      return this.constructor.toObject(this, minimal.util.toJSONOptions);
    }, r.getTypeUrl = function(e) {
      return e === void 0 && (e = "type.googleapis.com"), e + "/compute_container.ProxyConfigurationDomainAllowlist";
    }, r;
  }(), u.MountPoint = function() {
    function r(a) {
      if (a)
        for (let e = Object.keys(a), n = 0; n < e.length; ++n)
          a[e[n]] != null && (this[e[n]] = a[e[n]]);
    }
    return r.prototype.path = "", r.prototype.dependency = "", r.create = function(e) {
      return new r(e);
    }, r.encode = function(e, n) {
      return n || (n = $Writer.create()), e.path != null && Object.hasOwnProperty.call(e, "path") && n.uint32(
        /* id 1, wireType 2 =*/
        10
      ).string(e.path), e.dependency != null && Object.hasOwnProperty.call(e, "dependency") && n.uint32(
        /* id 2, wireType 2 =*/
        18
      ).string(e.dependency), n;
    }, r.encodeDelimited = function(e, n) {
      return this.encode(e, n).ldelim();
    }, r.decode = function(e, n) {
      e instanceof $Reader || (e = $Reader.create(e));
      let o = n === void 0 ? e.len : e.pos + n, c = new $root.compute_container.MountPoint();
      for (; e.pos < o; ) {
        let l = e.uint32();
        switch (l >>> 3) {
          case 1: {
            c.path = e.string();
            break;
          }
          case 2: {
            c.dependency = e.string();
            break;
          }
          default:
            e.skipType(l & 7);
            break;
        }
      }
      return c;
    }, r.decodeDelimited = function(e) {
      return e instanceof $Reader || (e = new $Reader(e)), this.decode(e, e.uint32());
    }, r.verify = function(e) {
      return typeof e != "object" || e === null ? "object expected" : e.path != null && e.hasOwnProperty("path") && !$util.isString(e.path) ? "path: string expected" : e.dependency != null && e.hasOwnProperty("dependency") && !$util.isString(e.dependency) ? "dependency: string expected" : null;
    }, r.fromObject = function(e) {
      if (e instanceof $root.compute_container.MountPoint)
        return e;
      let n = new $root.compute_container.MountPoint();
      return e.path != null && (n.path = String(e.path)), e.dependency != null && (n.dependency = String(e.dependency)), n;
    }, r.toObject = function(e, n) {
      n || (n = {});
      let o = {};
      return n.defaults && (o.path = "", o.dependency = ""), e.path != null && e.hasOwnProperty("path") && (o.path = e.path), e.dependency != null && e.hasOwnProperty("dependency") && (o.dependency = e.dependency), o;
    }, r.prototype.toJSON = function() {
      return this.constructor.toObject(this, minimal.util.toJSONOptions);
    }, r.getTypeUrl = function(e) {
      return e === void 0 && (e = "type.googleapis.com"), e + "/compute_container.MountPoint";
    }, r;
  }(), u;
})();
$root.compute_post = (() => {
  const u = {};
  return u.PostWorkerConfiguration = function() {
    function r(a) {
      if (a)
        for (let e = Object.keys(a), n = 0; n < e.length; ++n)
          a[e[n]] != null && (this[e[n]] = a[e[n]]);
    }
    return r.prototype.useMockBackend = !1, r.create = function(e) {
      return new r(e);
    }, r.encode = function(e, n) {
      return n || (n = $Writer.create()), e.useMockBackend != null && Object.hasOwnProperty.call(e, "useMockBackend") && n.uint32(
        /* id 1, wireType 0 =*/
        8
      ).bool(e.useMockBackend), n;
    }, r.encodeDelimited = function(e, n) {
      return this.encode(e, n).ldelim();
    }, r.decode = function(e, n) {
      e instanceof $Reader || (e = $Reader.create(e));
      let o = n === void 0 ? e.len : e.pos + n, c = new $root.compute_post.PostWorkerConfiguration();
      for (; e.pos < o; ) {
        let l = e.uint32();
        switch (l >>> 3) {
          case 1: {
            c.useMockBackend = e.bool();
            break;
          }
          default:
            e.skipType(l & 7);
            break;
        }
      }
      return c;
    }, r.decodeDelimited = function(e) {
      return e instanceof $Reader || (e = new $Reader(e)), this.decode(e, e.uint32());
    }, r.verify = function(e) {
      return typeof e != "object" || e === null ? "object expected" : e.useMockBackend != null && e.hasOwnProperty("useMockBackend") && typeof e.useMockBackend != "boolean" ? "useMockBackend: boolean expected" : null;
    }, r.fromObject = function(e) {
      if (e instanceof $root.compute_post.PostWorkerConfiguration)
        return e;
      let n = new $root.compute_post.PostWorkerConfiguration();
      return e.useMockBackend != null && (n.useMockBackend = !!e.useMockBackend), n;
    }, r.toObject = function(e, n) {
      n || (n = {});
      let o = {};
      return n.defaults && (o.useMockBackend = !1), e.useMockBackend != null && e.hasOwnProperty("useMockBackend") && (o.useMockBackend = e.useMockBackend), o;
    }, r.prototype.toJSON = function() {
      return this.constructor.toObject(this, minimal.util.toJSONOptions);
    }, r.getTypeUrl = function(e) {
      return e === void 0 && (e = "type.googleapis.com"), e + "/compute_post.PostWorkerConfiguration";
    }, r;
  }(), u;
})();
$root.compute_s3_sink = (() => {
  const u = {};
  return u.S3Provider = function() {
    const r = {}, a = Object.create(r);
    return a[r[0] = "AWS"] = 0, a[r[1] = "GCS"] = 1, a;
  }(), u.S3SinkWorkerConfiguration = function() {
    function r(e) {
      if (this.objects = [], e)
        for (let n = Object.keys(e), o = 0; o < n.length; ++o)
          e[n[o]] != null && (this[n[o]] = e[n[o]]);
    }
    r.prototype.endpoint = "", r.prototype.region = "", r.prototype.objects = $util.emptyArray, r.prototype.s3Provider = 0, r.prototype.userDefinedCredentials = null, r.prototype.dqDspCredentials = null, r.prototype.contentType = null;
    let a;
    return Object.defineProperty(r.prototype, "credentials", {
      get: $util.oneOfGetter(a = ["userDefinedCredentials", "dqDspCredentials"]),
      set: $util.oneOfSetter(a)
    }), Object.defineProperty(r.prototype, "_contentType", {
      get: $util.oneOfGetter(a = ["contentType"]),
      set: $util.oneOfSetter(a)
    }), r.create = function(n) {
      return new r(n);
    }, r.encode = function(n, o) {
      if (o || (o = $Writer.create()), n.endpoint != null && Object.hasOwnProperty.call(n, "endpoint") && o.uint32(
        /* id 1, wireType 2 =*/
        10
      ).string(n.endpoint), n.region != null && Object.hasOwnProperty.call(n, "region") && o.uint32(
        /* id 2, wireType 2 =*/
        18
      ).string(n.region), n.objects != null && n.objects.length)
        for (let c = 0; c < n.objects.length; ++c)
          $root.compute_s3_sink.S3Object.encode(n.objects[c], o.uint32(
            /* id 4, wireType 2 =*/
            34
          ).fork()).ldelim();
      return n.s3Provider != null && Object.hasOwnProperty.call(n, "s3Provider") && o.uint32(
        /* id 5, wireType 0 =*/
        40
      ).int32(n.s3Provider), n.userDefinedCredentials != null && Object.hasOwnProperty.call(n, "userDefinedCredentials") && $root.compute_s3_sink.UserDefinedCredentials.encode(n.userDefinedCredentials, o.uint32(
        /* id 6, wireType 2 =*/
        50
      ).fork()).ldelim(), n.dqDspCredentials != null && Object.hasOwnProperty.call(n, "dqDspCredentials") && $root.compute_s3_sink.DqDspCredentials.encode(n.dqDspCredentials, o.uint32(
        /* id 7, wireType 2 =*/
        58
      ).fork()).ldelim(), n.contentType != null && Object.hasOwnProperty.call(n, "contentType") && o.uint32(
        /* id 8, wireType 2 =*/
        66
      ).string(n.contentType), o;
    }, r.encodeDelimited = function(n, o) {
      return this.encode(n, o).ldelim();
    }, r.decode = function(n, o) {
      n instanceof $Reader || (n = $Reader.create(n));
      let c = o === void 0 ? n.len : n.pos + o, l = new $root.compute_s3_sink.S3SinkWorkerConfiguration();
      for (; n.pos < c; ) {
        let d = n.uint32();
        switch (d >>> 3) {
          case 1: {
            l.endpoint = n.string();
            break;
          }
          case 2: {
            l.region = n.string();
            break;
          }
          case 4: {
            l.objects && l.objects.length || (l.objects = []), l.objects.push($root.compute_s3_sink.S3Object.decode(n, n.uint32()));
            break;
          }
          case 5: {
            l.s3Provider = n.int32();
            break;
          }
          case 6: {
            l.userDefinedCredentials = $root.compute_s3_sink.UserDefinedCredentials.decode(n, n.uint32());
            break;
          }
          case 7: {
            l.dqDspCredentials = $root.compute_s3_sink.DqDspCredentials.decode(n, n.uint32());
            break;
          }
          case 8: {
            l.contentType = n.string();
            break;
          }
          default:
            n.skipType(d & 7);
            break;
        }
      }
      return l;
    }, r.decodeDelimited = function(n) {
      return n instanceof $Reader || (n = new $Reader(n)), this.decode(n, n.uint32());
    }, r.verify = function(n) {
      if (typeof n != "object" || n === null)
        return "object expected";
      let o = {};
      if (n.endpoint != null && n.hasOwnProperty("endpoint") && !$util.isString(n.endpoint))
        return "endpoint: string expected";
      if (n.region != null && n.hasOwnProperty("region") && !$util.isString(n.region))
        return "region: string expected";
      if (n.objects != null && n.hasOwnProperty("objects")) {
        if (!Array.isArray(n.objects))
          return "objects: array expected";
        for (let c = 0; c < n.objects.length; ++c) {
          let l = $root.compute_s3_sink.S3Object.verify(n.objects[c]);
          if (l)
            return "objects." + l;
        }
      }
      if (n.s3Provider != null && n.hasOwnProperty("s3Provider"))
        switch (n.s3Provider) {
          default:
            return "s3Provider: enum value expected";
          case 0:
          case 1:
            break;
        }
      if (n.userDefinedCredentials != null && n.hasOwnProperty("userDefinedCredentials")) {
        o.credentials = 1;
        {
          let c = $root.compute_s3_sink.UserDefinedCredentials.verify(n.userDefinedCredentials);
          if (c)
            return "userDefinedCredentials." + c;
        }
      }
      if (n.dqDspCredentials != null && n.hasOwnProperty("dqDspCredentials")) {
        if (o.credentials === 1)
          return "credentials: multiple values";
        o.credentials = 1;
        {
          let c = $root.compute_s3_sink.DqDspCredentials.verify(n.dqDspCredentials);
          if (c)
            return "dqDspCredentials." + c;
        }
      }
      return n.contentType != null && n.hasOwnProperty("contentType") && (o._contentType = 1, !$util.isString(n.contentType)) ? "contentType: string expected" : null;
    }, r.fromObject = function(n) {
      if (n instanceof $root.compute_s3_sink.S3SinkWorkerConfiguration)
        return n;
      let o = new $root.compute_s3_sink.S3SinkWorkerConfiguration();
      if (n.endpoint != null && (o.endpoint = String(n.endpoint)), n.region != null && (o.region = String(n.region)), n.objects) {
        if (!Array.isArray(n.objects))
          throw TypeError(".compute_s3_sink.S3SinkWorkerConfiguration.objects: array expected");
        o.objects = [];
        for (let c = 0; c < n.objects.length; ++c) {
          if (typeof n.objects[c] != "object")
            throw TypeError(".compute_s3_sink.S3SinkWorkerConfiguration.objects: object expected");
          o.objects[c] = $root.compute_s3_sink.S3Object.fromObject(n.objects[c]);
        }
      }
      switch (n.s3Provider) {
        default:
          if (typeof n.s3Provider == "number") {
            o.s3Provider = n.s3Provider;
            break;
          }
          break;
        case "AWS":
        case 0:
          o.s3Provider = 0;
          break;
        case "GCS":
        case 1:
          o.s3Provider = 1;
          break;
      }
      if (n.userDefinedCredentials != null) {
        if (typeof n.userDefinedCredentials != "object")
          throw TypeError(".compute_s3_sink.S3SinkWorkerConfiguration.userDefinedCredentials: object expected");
        o.userDefinedCredentials = $root.compute_s3_sink.UserDefinedCredentials.fromObject(n.userDefinedCredentials);
      }
      if (n.dqDspCredentials != null) {
        if (typeof n.dqDspCredentials != "object")
          throw TypeError(".compute_s3_sink.S3SinkWorkerConfiguration.dqDspCredentials: object expected");
        o.dqDspCredentials = $root.compute_s3_sink.DqDspCredentials.fromObject(n.dqDspCredentials);
      }
      return n.contentType != null && (o.contentType = String(n.contentType)), o;
    }, r.toObject = function(n, o) {
      o || (o = {});
      let c = {};
      if ((o.arrays || o.defaults) && (c.objects = []), o.defaults && (c.endpoint = "", c.region = "", c.s3Provider = o.enums === String ? "AWS" : 0), n.endpoint != null && n.hasOwnProperty("endpoint") && (c.endpoint = n.endpoint), n.region != null && n.hasOwnProperty("region") && (c.region = n.region), n.objects && n.objects.length) {
        c.objects = [];
        for (let l = 0; l < n.objects.length; ++l)
          c.objects[l] = $root.compute_s3_sink.S3Object.toObject(n.objects[l], o);
      }
      return n.s3Provider != null && n.hasOwnProperty("s3Provider") && (c.s3Provider = o.enums === String ? $root.compute_s3_sink.S3Provider[n.s3Provider] === void 0 ? n.s3Provider : $root.compute_s3_sink.S3Provider[n.s3Provider] : n.s3Provider), n.userDefinedCredentials != null && n.hasOwnProperty("userDefinedCredentials") && (c.userDefinedCredentials = $root.compute_s3_sink.UserDefinedCredentials.toObject(n.userDefinedCredentials, o), o.oneofs && (c.credentials = "userDefinedCredentials")), n.dqDspCredentials != null && n.hasOwnProperty("dqDspCredentials") && (c.dqDspCredentials = $root.compute_s3_sink.DqDspCredentials.toObject(n.dqDspCredentials, o), o.oneofs && (c.credentials = "dqDspCredentials")), n.contentType != null && n.hasOwnProperty("contentType") && (c.contentType = n.contentType, o.oneofs && (c._contentType = "contentType")), c;
    }, r.prototype.toJSON = function() {
      return this.constructor.toObject(this, minimal.util.toJSONOptions);
    }, r.getTypeUrl = function(n) {
      return n === void 0 && (n = "type.googleapis.com"), n + "/compute_s3_sink.S3SinkWorkerConfiguration";
    }, r;
  }(), u.UserDefinedCredentials = function() {
    function r(a) {
      if (a)
        for (let e = Object.keys(a), n = 0; n < e.length; ++n)
          a[e[n]] != null && (this[e[n]] = a[e[n]]);
    }
    return r.prototype.userDefinedCredentials = "", r.create = function(e) {
      return new r(e);
    }, r.encode = function(e, n) {
      return n || (n = $Writer.create()), e.userDefinedCredentials != null && Object.hasOwnProperty.call(e, "userDefinedCredentials") && n.uint32(
        /* id 1, wireType 2 =*/
        10
      ).string(e.userDefinedCredentials), n;
    }, r.encodeDelimited = function(e, n) {
      return this.encode(e, n).ldelim();
    }, r.decode = function(e, n) {
      e instanceof $Reader || (e = $Reader.create(e));
      let o = n === void 0 ? e.len : e.pos + n, c = new $root.compute_s3_sink.UserDefinedCredentials();
      for (; e.pos < o; ) {
        let l = e.uint32();
        switch (l >>> 3) {
          case 1: {
            c.userDefinedCredentials = e.string();
            break;
          }
          default:
            e.skipType(l & 7);
            break;
        }
      }
      return c;
    }, r.decodeDelimited = function(e) {
      return e instanceof $Reader || (e = new $Reader(e)), this.decode(e, e.uint32());
    }, r.verify = function(e) {
      return typeof e != "object" || e === null ? "object expected" : e.userDefinedCredentials != null && e.hasOwnProperty("userDefinedCredentials") && !$util.isString(e.userDefinedCredentials) ? "userDefinedCredentials: string expected" : null;
    }, r.fromObject = function(e) {
      if (e instanceof $root.compute_s3_sink.UserDefinedCredentials)
        return e;
      let n = new $root.compute_s3_sink.UserDefinedCredentials();
      return e.userDefinedCredentials != null && (n.userDefinedCredentials = String(e.userDefinedCredentials)), n;
    }, r.toObject = function(e, n) {
      n || (n = {});
      let o = {};
      return n.defaults && (o.userDefinedCredentials = ""), e.userDefinedCredentials != null && e.hasOwnProperty("userDefinedCredentials") && (o.userDefinedCredentials = e.userDefinedCredentials), o;
    }, r.prototype.toJSON = function() {
      return this.constructor.toObject(this, minimal.util.toJSONOptions);
    }, r.getTypeUrl = function(e) {
      return e === void 0 && (e = "type.googleapis.com"), e + "/compute_s3_sink.UserDefinedCredentials";
    }, r;
  }(), u.DqDspCredentials = function() {
    function r(a) {
      if (a)
        for (let e = Object.keys(a), n = 0; n < e.length; ++n)
          a[e[n]] != null && (this[e[n]] = a[e[n]]);
    }
    return r.prototype.dspType = 0, r.create = function(e) {
      return new r(e);
    }, r.encode = function(e, n) {
      return n || (n = $Writer.create()), e.dspType != null && Object.hasOwnProperty.call(e, "dspType") && n.uint32(
        /* id 1, wireType 0 =*/
        8
      ).int32(e.dspType), n;
    }, r.encodeDelimited = function(e, n) {
      return this.encode(e, n).ldelim();
    }, r.decode = function(e, n) {
      e instanceof $Reader || (e = $Reader.create(e));
      let o = n === void 0 ? e.len : e.pos + n, c = new $root.compute_s3_sink.DqDspCredentials();
      for (; e.pos < o; ) {
        let l = e.uint32();
        switch (l >>> 3) {
          case 1: {
            c.dspType = e.int32();
            break;
          }
          default:
            e.skipType(l & 7);
            break;
        }
      }
      return c;
    }, r.decodeDelimited = function(e) {
      return e instanceof $Reader || (e = new $Reader(e)), this.decode(e, e.uint32());
    }, r.verify = function(e) {
      if (typeof e != "object" || e === null)
        return "object expected";
      if (e.dspType != null && e.hasOwnProperty("dspType"))
        switch (e.dspType) {
          default:
            return "dspType: enum value expected";
          case 0:
            break;
        }
      return null;
    }, r.fromObject = function(e) {
      if (e instanceof $root.compute_s3_sink.DqDspCredentials)
        return e;
      let n = new $root.compute_s3_sink.DqDspCredentials();
      switch (e.dspType) {
        default:
          if (typeof e.dspType == "number") {
            n.dspType = e.dspType;
            break;
          }
          break;
        case "SPLICKY":
        case 0:
          n.dspType = 0;
          break;
      }
      return n;
    }, r.toObject = function(e, n) {
      n || (n = {});
      let o = {};
      return n.defaults && (o.dspType = n.enums === String ? "SPLICKY" : 0), e.dspType != null && e.hasOwnProperty("dspType") && (o.dspType = n.enums === String ? $root.compute_s3_sink.DspCredentialsType[e.dspType] === void 0 ? e.dspType : $root.compute_s3_sink.DspCredentialsType[e.dspType] : e.dspType), o;
    }, r.prototype.toJSON = function() {
      return this.constructor.toObject(this, minimal.util.toJSONOptions);
    }, r.getTypeUrl = function(e) {
      return e === void 0 && (e = "type.googleapis.com"), e + "/compute_s3_sink.DqDspCredentials";
    }, r;
  }(), u.DspCredentialsType = function() {
    const r = {}, a = Object.create(r);
    return a[r[0] = "SPLICKY"] = 0, a;
  }(), u.S3Object = function() {
    function r(e) {
      if (e)
        for (let n = Object.keys(e), o = 0; o < n.length; ++o)
          e[n[o]] != null && (this[n[o]] = e[n[o]]);
    }
    r.prototype.dependency = "", r.prototype.zip = null, r.prototype.raw = null;
    let a;
    return Object.defineProperty(r.prototype, "format", {
      get: $util.oneOfGetter(a = ["zip", "raw"]),
      set: $util.oneOfSetter(a)
    }), r.create = function(n) {
      return new r(n);
    }, r.encode = function(n, o) {
      return o || (o = $Writer.create()), n.dependency != null && Object.hasOwnProperty.call(n, "dependency") && o.uint32(
        /* id 1, wireType 2 =*/
        10
      ).string(n.dependency), n.zip != null && Object.hasOwnProperty.call(n, "zip") && $root.compute_s3_sink.ZipObject.encode(n.zip, o.uint32(
        /* id 2, wireType 2 =*/
        18
      ).fork()).ldelim(), n.raw != null && Object.hasOwnProperty.call(n, "raw") && $root.compute_s3_sink.RawObject.encode(n.raw, o.uint32(
        /* id 3, wireType 2 =*/
        26
      ).fork()).ldelim(), o;
    }, r.encodeDelimited = function(n, o) {
      return this.encode(n, o).ldelim();
    }, r.decode = function(n, o) {
      n instanceof $Reader || (n = $Reader.create(n));
      let c = o === void 0 ? n.len : n.pos + o, l = new $root.compute_s3_sink.S3Object();
      for (; n.pos < c; ) {
        let d = n.uint32();
        switch (d >>> 3) {
          case 1: {
            l.dependency = n.string();
            break;
          }
          case 2: {
            l.zip = $root.compute_s3_sink.ZipObject.decode(n, n.uint32());
            break;
          }
          case 3: {
            l.raw = $root.compute_s3_sink.RawObject.decode(n, n.uint32());
            break;
          }
          default:
            n.skipType(d & 7);
            break;
        }
      }
      return l;
    }, r.decodeDelimited = function(n) {
      return n instanceof $Reader || (n = new $Reader(n)), this.decode(n, n.uint32());
    }, r.verify = function(n) {
      if (typeof n != "object" || n === null)
        return "object expected";
      let o = {};
      if (n.dependency != null && n.hasOwnProperty("dependency") && !$util.isString(n.dependency))
        return "dependency: string expected";
      if (n.zip != null && n.hasOwnProperty("zip")) {
        o.format = 1;
        {
          let c = $root.compute_s3_sink.ZipObject.verify(n.zip);
          if (c)
            return "zip." + c;
        }
      }
      if (n.raw != null && n.hasOwnProperty("raw")) {
        if (o.format === 1)
          return "format: multiple values";
        o.format = 1;
        {
          let c = $root.compute_s3_sink.RawObject.verify(n.raw);
          if (c)
            return "raw." + c;
        }
      }
      return null;
    }, r.fromObject = function(n) {
      if (n instanceof $root.compute_s3_sink.S3Object)
        return n;
      let o = new $root.compute_s3_sink.S3Object();
      if (n.dependency != null && (o.dependency = String(n.dependency)), n.zip != null) {
        if (typeof n.zip != "object")
          throw TypeError(".compute_s3_sink.S3Object.zip: object expected");
        o.zip = $root.compute_s3_sink.ZipObject.fromObject(n.zip);
      }
      if (n.raw != null) {
        if (typeof n.raw != "object")
          throw TypeError(".compute_s3_sink.S3Object.raw: object expected");
        o.raw = $root.compute_s3_sink.RawObject.fromObject(n.raw);
      }
      return o;
    }, r.toObject = function(n, o) {
      o || (o = {});
      let c = {};
      return o.defaults && (c.dependency = ""), n.dependency != null && n.hasOwnProperty("dependency") && (c.dependency = n.dependency), n.zip != null && n.hasOwnProperty("zip") && (c.zip = $root.compute_s3_sink.ZipObject.toObject(n.zip, o), o.oneofs && (c.format = "zip")), n.raw != null && n.hasOwnProperty("raw") && (c.raw = $root.compute_s3_sink.RawObject.toObject(n.raw, o), o.oneofs && (c.format = "raw")), c;
    }, r.prototype.toJSON = function() {
      return this.constructor.toObject(this, minimal.util.toJSONOptions);
    }, r.getTypeUrl = function(n) {
      return n === void 0 && (n = "type.googleapis.com"), n + "/compute_s3_sink.S3Object";
    }, r;
  }(), u.RawObject = function() {
    function r(a) {
      if (a)
        for (let e = Object.keys(a), n = 0; n < e.length; ++n)
          a[e[n]] != null && (this[e[n]] = a[e[n]]);
    }
    return r.prototype.key = "", r.create = function(e) {
      return new r(e);
    }, r.encode = function(e, n) {
      return n || (n = $Writer.create()), e.key != null && Object.hasOwnProperty.call(e, "key") && n.uint32(
        /* id 1, wireType 2 =*/
        10
      ).string(e.key), n;
    }, r.encodeDelimited = function(e, n) {
      return this.encode(e, n).ldelim();
    }, r.decode = function(e, n) {
      e instanceof $Reader || (e = $Reader.create(e));
      let o = n === void 0 ? e.len : e.pos + n, c = new $root.compute_s3_sink.RawObject();
      for (; e.pos < o; ) {
        let l = e.uint32();
        switch (l >>> 3) {
          case 1: {
            c.key = e.string();
            break;
          }
          default:
            e.skipType(l & 7);
            break;
        }
      }
      return c;
    }, r.decodeDelimited = function(e) {
      return e instanceof $Reader || (e = new $Reader(e)), this.decode(e, e.uint32());
    }, r.verify = function(e) {
      return typeof e != "object" || e === null ? "object expected" : e.key != null && e.hasOwnProperty("key") && !$util.isString(e.key) ? "key: string expected" : null;
    }, r.fromObject = function(e) {
      if (e instanceof $root.compute_s3_sink.RawObject)
        return e;
      let n = new $root.compute_s3_sink.RawObject();
      return e.key != null && (n.key = String(e.key)), n;
    }, r.toObject = function(e, n) {
      n || (n = {});
      let o = {};
      return n.defaults && (o.key = ""), e.key != null && e.hasOwnProperty("key") && (o.key = e.key), o;
    }, r.prototype.toJSON = function() {
      return this.constructor.toObject(this, minimal.util.toJSONOptions);
    }, r.getTypeUrl = function(e) {
      return e === void 0 && (e = "type.googleapis.com"), e + "/compute_s3_sink.RawObject";
    }, r;
  }(), u.ZipObject = function() {
    function r(e) {
      if (e)
        for (let n = Object.keys(e), o = 0; o < n.length; ++o)
          e[n[o]] != null && (this[n[o]] = e[n[o]]);
    }
    r.prototype.singleFile = null, r.prototype.fullContent = null;
    let a;
    return Object.defineProperty(r.prototype, "kind", {
      get: $util.oneOfGetter(a = ["singleFile", "fullContent"]),
      set: $util.oneOfSetter(a)
    }), r.create = function(n) {
      return new r(n);
    }, r.encode = function(n, o) {
      return o || (o = $Writer.create()), n.singleFile != null && Object.hasOwnProperty.call(n, "singleFile") && $root.compute_s3_sink.SingleFile.encode(n.singleFile, o.uint32(
        /* id 1, wireType 2 =*/
        10
      ).fork()).ldelim(), n.fullContent != null && Object.hasOwnProperty.call(n, "fullContent") && $root.compute_s3_sink.FullContent.encode(n.fullContent, o.uint32(
        /* id 2, wireType 2 =*/
        18
      ).fork()).ldelim(), o;
    }, r.encodeDelimited = function(n, o) {
      return this.encode(n, o).ldelim();
    }, r.decode = function(n, o) {
      n instanceof $Reader || (n = $Reader.create(n));
      let c = o === void 0 ? n.len : n.pos + o, l = new $root.compute_s3_sink.ZipObject();
      for (; n.pos < c; ) {
        let d = n.uint32();
        switch (d >>> 3) {
          case 1: {
            l.singleFile = $root.compute_s3_sink.SingleFile.decode(n, n.uint32());
            break;
          }
          case 2: {
            l.fullContent = $root.compute_s3_sink.FullContent.decode(n, n.uint32());
            break;
          }
          default:
            n.skipType(d & 7);
            break;
        }
      }
      return l;
    }, r.decodeDelimited = function(n) {
      return n instanceof $Reader || (n = new $Reader(n)), this.decode(n, n.uint32());
    }, r.verify = function(n) {
      if (typeof n != "object" || n === null)
        return "object expected";
      let o = {};
      if (n.singleFile != null && n.hasOwnProperty("singleFile")) {
        o.kind = 1;
        {
          let c = $root.compute_s3_sink.SingleFile.verify(n.singleFile);
          if (c)
            return "singleFile." + c;
        }
      }
      if (n.fullContent != null && n.hasOwnProperty("fullContent")) {
        if (o.kind === 1)
          return "kind: multiple values";
        o.kind = 1;
        {
          let c = $root.compute_s3_sink.FullContent.verify(n.fullContent);
          if (c)
            return "fullContent." + c;
        }
      }
      return null;
    }, r.fromObject = function(n) {
      if (n instanceof $root.compute_s3_sink.ZipObject)
        return n;
      let o = new $root.compute_s3_sink.ZipObject();
      if (n.singleFile != null) {
        if (typeof n.singleFile != "object")
          throw TypeError(".compute_s3_sink.ZipObject.singleFile: object expected");
        o.singleFile = $root.compute_s3_sink.SingleFile.fromObject(n.singleFile);
      }
      if (n.fullContent != null) {
        if (typeof n.fullContent != "object")
          throw TypeError(".compute_s3_sink.ZipObject.fullContent: object expected");
        o.fullContent = $root.compute_s3_sink.FullContent.fromObject(n.fullContent);
      }
      return o;
    }, r.toObject = function(n, o) {
      o || (o = {});
      let c = {};
      return n.singleFile != null && n.hasOwnProperty("singleFile") && (c.singleFile = $root.compute_s3_sink.SingleFile.toObject(n.singleFile, o), o.oneofs && (c.kind = "singleFile")), n.fullContent != null && n.hasOwnProperty("fullContent") && (c.fullContent = $root.compute_s3_sink.FullContent.toObject(n.fullContent, o), o.oneofs && (c.kind = "fullContent")), c;
    }, r.prototype.toJSON = function() {
      return this.constructor.toObject(this, minimal.util.toJSONOptions);
    }, r.getTypeUrl = function(n) {
      return n === void 0 && (n = "type.googleapis.com"), n + "/compute_s3_sink.ZipObject";
    }, r;
  }(), u.SingleFile = function() {
    function r(a) {
      if (a)
        for (let e = Object.keys(a), n = 0; n < e.length; ++n)
          a[e[n]] != null && (this[e[n]] = a[e[n]]);
    }
    return r.prototype.key = "", r.prototype.path = "", r.create = function(e) {
      return new r(e);
    }, r.encode = function(e, n) {
      return n || (n = $Writer.create()), e.key != null && Object.hasOwnProperty.call(e, "key") && n.uint32(
        /* id 1, wireType 2 =*/
        10
      ).string(e.key), e.path != null && Object.hasOwnProperty.call(e, "path") && n.uint32(
        /* id 2, wireType 2 =*/
        18
      ).string(e.path), n;
    }, r.encodeDelimited = function(e, n) {
      return this.encode(e, n).ldelim();
    }, r.decode = function(e, n) {
      e instanceof $Reader || (e = $Reader.create(e));
      let o = n === void 0 ? e.len : e.pos + n, c = new $root.compute_s3_sink.SingleFile();
      for (; e.pos < o; ) {
        let l = e.uint32();
        switch (l >>> 3) {
          case 1: {
            c.key = e.string();
            break;
          }
          case 2: {
            c.path = e.string();
            break;
          }
          default:
            e.skipType(l & 7);
            break;
        }
      }
      return c;
    }, r.decodeDelimited = function(e) {
      return e instanceof $Reader || (e = new $Reader(e)), this.decode(e, e.uint32());
    }, r.verify = function(e) {
      return typeof e != "object" || e === null ? "object expected" : e.key != null && e.hasOwnProperty("key") && !$util.isString(e.key) ? "key: string expected" : e.path != null && e.hasOwnProperty("path") && !$util.isString(e.path) ? "path: string expected" : null;
    }, r.fromObject = function(e) {
      if (e instanceof $root.compute_s3_sink.SingleFile)
        return e;
      let n = new $root.compute_s3_sink.SingleFile();
      return e.key != null && (n.key = String(e.key)), e.path != null && (n.path = String(e.path)), n;
    }, r.toObject = function(e, n) {
      n || (n = {});
      let o = {};
      return n.defaults && (o.key = "", o.path = ""), e.key != null && e.hasOwnProperty("key") && (o.key = e.key), e.path != null && e.hasOwnProperty("path") && (o.path = e.path), o;
    }, r.prototype.toJSON = function() {
      return this.constructor.toObject(this, minimal.util.toJSONOptions);
    }, r.getTypeUrl = function(e) {
      return e === void 0 && (e = "type.googleapis.com"), e + "/compute_s3_sink.SingleFile";
    }, r;
  }(), u.FullContent = function() {
    function r(a) {
      if (a)
        for (let e = Object.keys(a), n = 0; n < e.length; ++n)
          a[e[n]] != null && (this[e[n]] = a[e[n]]);
    }
    return r.create = function(e) {
      return new r(e);
    }, r.encode = function(e, n) {
      return n || (n = $Writer.create()), n;
    }, r.encodeDelimited = function(e, n) {
      return this.encode(e, n).ldelim();
    }, r.decode = function(e, n) {
      e instanceof $Reader || (e = $Reader.create(e));
      let o = n === void 0 ? e.len : e.pos + n, c = new $root.compute_s3_sink.FullContent();
      for (; e.pos < o; ) {
        let l = e.uint32();
        switch (l >>> 3) {
          default:
            e.skipType(l & 7);
            break;
        }
      }
      return c;
    }, r.decodeDelimited = function(e) {
      return e instanceof $Reader || (e = new $Reader(e)), this.decode(e, e.uint32());
    }, r.verify = function(e) {
      return typeof e != "object" || e === null ? "object expected" : null;
    }, r.fromObject = function(e) {
      return e instanceof $root.compute_s3_sink.FullContent ? e : new $root.compute_s3_sink.FullContent();
    }, r.toObject = function() {
      return {};
    }, r.prototype.toJSON = function() {
      return this.constructor.toObject(this, minimal.util.toJSONOptions);
    }, r.getTypeUrl = function(e) {
      return e === void 0 && (e = "type.googleapis.com"), e + "/compute_s3_sink.FullContent";
    }, r;
  }(), u.S3Credentials = function() {
    function r(a) {
      if (a)
        for (let e = Object.keys(a), n = 0; n < e.length; ++n)
          a[e[n]] != null && (this[e[n]] = a[e[n]]);
    }
    return r.prototype.accessKey = "", r.prototype.secretKey = "", r.create = function(e) {
      return new r(e);
    }, r.encode = function(e, n) {
      return n || (n = $Writer.create()), e.accessKey != null && Object.hasOwnProperty.call(e, "accessKey") && n.uint32(
        /* id 1, wireType 2 =*/
        10
      ).string(e.accessKey), e.secretKey != null && Object.hasOwnProperty.call(e, "secretKey") && n.uint32(
        /* id 2, wireType 2 =*/
        18
      ).string(e.secretKey), n;
    }, r.encodeDelimited = function(e, n) {
      return this.encode(e, n).ldelim();
    }, r.decode = function(e, n) {
      e instanceof $Reader || (e = $Reader.create(e));
      let o = n === void 0 ? e.len : e.pos + n, c = new $root.compute_s3_sink.S3Credentials();
      for (; e.pos < o; ) {
        let l = e.uint32();
        switch (l >>> 3) {
          case 1: {
            c.accessKey = e.string();
            break;
          }
          case 2: {
            c.secretKey = e.string();
            break;
          }
          default:
            e.skipType(l & 7);
            break;
        }
      }
      return c;
    }, r.decodeDelimited = function(e) {
      return e instanceof $Reader || (e = new $Reader(e)), this.decode(e, e.uint32());
    }, r.verify = function(e) {
      return typeof e != "object" || e === null ? "object expected" : e.accessKey != null && e.hasOwnProperty("accessKey") && !$util.isString(e.accessKey) ? "accessKey: string expected" : e.secretKey != null && e.hasOwnProperty("secretKey") && !$util.isString(e.secretKey) ? "secretKey: string expected" : null;
    }, r.fromObject = function(e) {
      if (e instanceof $root.compute_s3_sink.S3Credentials)
        return e;
      let n = new $root.compute_s3_sink.S3Credentials();
      return e.accessKey != null && (n.accessKey = String(e.accessKey)), e.secretKey != null && (n.secretKey = String(e.secretKey)), n;
    }, r.toObject = function(e, n) {
      n || (n = {});
      let o = {};
      return n.defaults && (o.accessKey = "", o.secretKey = ""), e.accessKey != null && e.hasOwnProperty("accessKey") && (o.accessKey = e.accessKey), e.secretKey != null && e.hasOwnProperty("secretKey") && (o.secretKey = e.secretKey), o;
    }, r.prototype.toJSON = function() {
      return this.constructor.toObject(this, minimal.util.toJSONOptions);
    }, r.getTypeUrl = function(e) {
      return e === void 0 && (e = "type.googleapis.com"), e + "/compute_s3_sink.S3Credentials";
    }, r;
  }(), u;
})();
$root.compute_sql = (() => {
  const u = {};
  return u.SqlWorkerConfiguration = function() {
    function r(e) {
      if (e)
        for (let n = Object.keys(e), o = 0; o < n.length; ++o)
          e[n[o]] != null && (this[n[o]] = e[n[o]]);
    }
    r.prototype.validation = null, r.prototype.computation = null;
    let a;
    return Object.defineProperty(r.prototype, "configuration", {
      get: $util.oneOfGetter(a = ["validation", "computation"]),
      set: $util.oneOfSetter(a)
    }), r.create = function(n) {
      return new r(n);
    }, r.encode = function(n, o) {
      return o || (o = $Writer.create()), n.validation != null && Object.hasOwnProperty.call(n, "validation") && $root.compute_sql.ValidationConfiguration.encode(n.validation, o.uint32(
        /* id 1, wireType 2 =*/
        10
      ).fork()).ldelim(), n.computation != null && Object.hasOwnProperty.call(n, "computation") && $root.compute_sql.ComputationConfiguration.encode(n.computation, o.uint32(
        /* id 2, wireType 2 =*/
        18
      ).fork()).ldelim(), o;
    }, r.encodeDelimited = function(n, o) {
      return this.encode(n, o).ldelim();
    }, r.decode = function(n, o) {
      n instanceof $Reader || (n = $Reader.create(n));
      let c = o === void 0 ? n.len : n.pos + o, l = new $root.compute_sql.SqlWorkerConfiguration();
      for (; n.pos < c; ) {
        let d = n.uint32();
        switch (d >>> 3) {
          case 1: {
            l.validation = $root.compute_sql.ValidationConfiguration.decode(n, n.uint32());
            break;
          }
          case 2: {
            l.computation = $root.compute_sql.ComputationConfiguration.decode(n, n.uint32());
            break;
          }
          default:
            n.skipType(d & 7);
            break;
        }
      }
      return l;
    }, r.decodeDelimited = function(n) {
      return n instanceof $Reader || (n = new $Reader(n)), this.decode(n, n.uint32());
    }, r.verify = function(n) {
      if (typeof n != "object" || n === null)
        return "object expected";
      let o = {};
      if (n.validation != null && n.hasOwnProperty("validation")) {
        o.configuration = 1;
        {
          let c = $root.compute_sql.ValidationConfiguration.verify(n.validation);
          if (c)
            return "validation." + c;
        }
      }
      if (n.computation != null && n.hasOwnProperty("computation")) {
        if (o.configuration === 1)
          return "configuration: multiple values";
        o.configuration = 1;
        {
          let c = $root.compute_sql.ComputationConfiguration.verify(n.computation);
          if (c)
            return "computation." + c;
        }
      }
      return null;
    }, r.fromObject = function(n) {
      if (n instanceof $root.compute_sql.SqlWorkerConfiguration)
        return n;
      let o = new $root.compute_sql.SqlWorkerConfiguration();
      if (n.validation != null) {
        if (typeof n.validation != "object")
          throw TypeError(".compute_sql.SqlWorkerConfiguration.validation: object expected");
        o.validation = $root.compute_sql.ValidationConfiguration.fromObject(n.validation);
      }
      if (n.computation != null) {
        if (typeof n.computation != "object")
          throw TypeError(".compute_sql.SqlWorkerConfiguration.computation: object expected");
        o.computation = $root.compute_sql.ComputationConfiguration.fromObject(n.computation);
      }
      return o;
    }, r.toObject = function(n, o) {
      o || (o = {});
      let c = {};
      return n.validation != null && n.hasOwnProperty("validation") && (c.validation = $root.compute_sql.ValidationConfiguration.toObject(n.validation, o), o.oneofs && (c.configuration = "validation")), n.computation != null && n.hasOwnProperty("computation") && (c.computation = $root.compute_sql.ComputationConfiguration.toObject(n.computation, o), o.oneofs && (c.configuration = "computation")), c;
    }, r.prototype.toJSON = function() {
      return this.constructor.toObject(this, minimal.util.toJSONOptions);
    }, r.getTypeUrl = function(n) {
      return n === void 0 && (n = "type.googleapis.com"), n + "/compute_sql.SqlWorkerConfiguration";
    }, r;
  }(), u.ValidationConfiguration = function() {
    function r(a) {
      if (a)
        for (let e = Object.keys(a), n = 0; n < e.length; ++n)
          a[e[n]] != null && (this[e[n]] = a[e[n]]);
    }
    return r.prototype.tableSchema = null, r.create = function(e) {
      return new r(e);
    }, r.encode = function(e, n) {
      return n || (n = $Writer.create()), e.tableSchema != null && Object.hasOwnProperty.call(e, "tableSchema") && $root.compute_sql.TableSchema.encode(e.tableSchema, n.uint32(
        /* id 1, wireType 2 =*/
        10
      ).fork()).ldelim(), n;
    }, r.encodeDelimited = function(e, n) {
      return this.encode(e, n).ldelim();
    }, r.decode = function(e, n) {
      e instanceof $Reader || (e = $Reader.create(e));
      let o = n === void 0 ? e.len : e.pos + n, c = new $root.compute_sql.ValidationConfiguration();
      for (; e.pos < o; ) {
        let l = e.uint32();
        switch (l >>> 3) {
          case 1: {
            c.tableSchema = $root.compute_sql.TableSchema.decode(e, e.uint32());
            break;
          }
          default:
            e.skipType(l & 7);
            break;
        }
      }
      return c;
    }, r.decodeDelimited = function(e) {
      return e instanceof $Reader || (e = new $Reader(e)), this.decode(e, e.uint32());
    }, r.verify = function(e) {
      if (typeof e != "object" || e === null)
        return "object expected";
      if (e.tableSchema != null && e.hasOwnProperty("tableSchema")) {
        let n = $root.compute_sql.TableSchema.verify(e.tableSchema);
        if (n)
          return "tableSchema." + n;
      }
      return null;
    }, r.fromObject = function(e) {
      if (e instanceof $root.compute_sql.ValidationConfiguration)
        return e;
      let n = new $root.compute_sql.ValidationConfiguration();
      if (e.tableSchema != null) {
        if (typeof e.tableSchema != "object")
          throw TypeError(".compute_sql.ValidationConfiguration.tableSchema: object expected");
        n.tableSchema = $root.compute_sql.TableSchema.fromObject(e.tableSchema);
      }
      return n;
    }, r.toObject = function(e, n) {
      n || (n = {});
      let o = {};
      return n.defaults && (o.tableSchema = null), e.tableSchema != null && e.hasOwnProperty("tableSchema") && (o.tableSchema = $root.compute_sql.TableSchema.toObject(e.tableSchema, n)), o;
    }, r.prototype.toJSON = function() {
      return this.constructor.toObject(this, minimal.util.toJSONOptions);
    }, r.getTypeUrl = function(e) {
      return e === void 0 && (e = "type.googleapis.com"), e + "/compute_sql.ValidationConfiguration";
    }, r;
  }(), u.TableSchema = function() {
    function r(a) {
      if (this.namedColumns = [], a)
        for (let e = Object.keys(a), n = 0; n < e.length; ++n)
          a[e[n]] != null && (this[e[n]] = a[e[n]]);
    }
    return r.prototype.namedColumns = $util.emptyArray, r.create = function(e) {
      return new r(e);
    }, r.encode = function(e, n) {
      if (n || (n = $Writer.create()), e.namedColumns != null && e.namedColumns.length)
        for (let o = 0; o < e.namedColumns.length; ++o)
          $root.compute_sql.NamedColumn.encode(e.namedColumns[o], n.uint32(
            /* id 1, wireType 2 =*/
            10
          ).fork()).ldelim();
      return n;
    }, r.encodeDelimited = function(e, n) {
      return this.encode(e, n).ldelim();
    }, r.decode = function(e, n) {
      e instanceof $Reader || (e = $Reader.create(e));
      let o = n === void 0 ? e.len : e.pos + n, c = new $root.compute_sql.TableSchema();
      for (; e.pos < o; ) {
        let l = e.uint32();
        switch (l >>> 3) {
          case 1: {
            c.namedColumns && c.namedColumns.length || (c.namedColumns = []), c.namedColumns.push($root.compute_sql.NamedColumn.decode(e, e.uint32()));
            break;
          }
          default:
            e.skipType(l & 7);
            break;
        }
      }
      return c;
    }, r.decodeDelimited = function(e) {
      return e instanceof $Reader || (e = new $Reader(e)), this.decode(e, e.uint32());
    }, r.verify = function(e) {
      if (typeof e != "object" || e === null)
        return "object expected";
      if (e.namedColumns != null && e.hasOwnProperty("namedColumns")) {
        if (!Array.isArray(e.namedColumns))
          return "namedColumns: array expected";
        for (let n = 0; n < e.namedColumns.length; ++n) {
          let o = $root.compute_sql.NamedColumn.verify(e.namedColumns[n]);
          if (o)
            return "namedColumns." + o;
        }
      }
      return null;
    }, r.fromObject = function(e) {
      if (e instanceof $root.compute_sql.TableSchema)
        return e;
      let n = new $root.compute_sql.TableSchema();
      if (e.namedColumns) {
        if (!Array.isArray(e.namedColumns))
          throw TypeError(".compute_sql.TableSchema.namedColumns: array expected");
        n.namedColumns = [];
        for (let o = 0; o < e.namedColumns.length; ++o) {
          if (typeof e.namedColumns[o] != "object")
            throw TypeError(".compute_sql.TableSchema.namedColumns: object expected");
          n.namedColumns[o] = $root.compute_sql.NamedColumn.fromObject(e.namedColumns[o]);
        }
      }
      return n;
    }, r.toObject = function(e, n) {
      n || (n = {});
      let o = {};
      if ((n.arrays || n.defaults) && (o.namedColumns = []), e.namedColumns && e.namedColumns.length) {
        o.namedColumns = [];
        for (let c = 0; c < e.namedColumns.length; ++c)
          o.namedColumns[c] = $root.compute_sql.NamedColumn.toObject(e.namedColumns[c], n);
      }
      return o;
    }, r.prototype.toJSON = function() {
      return this.constructor.toObject(this, minimal.util.toJSONOptions);
    }, r.getTypeUrl = function(e) {
      return e === void 0 && (e = "type.googleapis.com"), e + "/compute_sql.TableSchema";
    }, r;
  }(), u.NamedColumn = function() {
    function r(e) {
      if (e)
        for (let n = Object.keys(e), o = 0; o < n.length; ++o)
          e[n[o]] != null && (this[n[o]] = e[n[o]]);
    }
    r.prototype.name = null, r.prototype.columnType = null;
    let a;
    return Object.defineProperty(r.prototype, "_name", {
      get: $util.oneOfGetter(a = ["name"]),
      set: $util.oneOfSetter(a)
    }), r.create = function(n) {
      return new r(n);
    }, r.encode = function(n, o) {
      return o || (o = $Writer.create()), n.name != null && Object.hasOwnProperty.call(n, "name") && o.uint32(
        /* id 1, wireType 2 =*/
        10
      ).string(n.name), n.columnType != null && Object.hasOwnProperty.call(n, "columnType") && $root.compute_sql.ColumnType.encode(n.columnType, o.uint32(
        /* id 2, wireType 2 =*/
        18
      ).fork()).ldelim(), o;
    }, r.encodeDelimited = function(n, o) {
      return this.encode(n, o).ldelim();
    }, r.decode = function(n, o) {
      n instanceof $Reader || (n = $Reader.create(n));
      let c = o === void 0 ? n.len : n.pos + o, l = new $root.compute_sql.NamedColumn();
      for (; n.pos < c; ) {
        let d = n.uint32();
        switch (d >>> 3) {
          case 1: {
            l.name = n.string();
            break;
          }
          case 2: {
            l.columnType = $root.compute_sql.ColumnType.decode(n, n.uint32());
            break;
          }
          default:
            n.skipType(d & 7);
            break;
        }
      }
      return l;
    }, r.decodeDelimited = function(n) {
      return n instanceof $Reader || (n = new $Reader(n)), this.decode(n, n.uint32());
    }, r.verify = function(n) {
      if (typeof n != "object" || n === null)
        return "object expected";
      if (n.name != null && n.hasOwnProperty("name") && !$util.isString(n.name))
        return "name: string expected";
      if (n.columnType != null && n.hasOwnProperty("columnType")) {
        let o = $root.compute_sql.ColumnType.verify(n.columnType);
        if (o)
          return "columnType." + o;
      }
      return null;
    }, r.fromObject = function(n) {
      if (n instanceof $root.compute_sql.NamedColumn)
        return n;
      let o = new $root.compute_sql.NamedColumn();
      if (n.name != null && (o.name = String(n.name)), n.columnType != null) {
        if (typeof n.columnType != "object")
          throw TypeError(".compute_sql.NamedColumn.columnType: object expected");
        o.columnType = $root.compute_sql.ColumnType.fromObject(n.columnType);
      }
      return o;
    }, r.toObject = function(n, o) {
      o || (o = {});
      let c = {};
      return o.defaults && (c.columnType = null), n.name != null && n.hasOwnProperty("name") && (c.name = n.name, o.oneofs && (c._name = "name")), n.columnType != null && n.hasOwnProperty("columnType") && (c.columnType = $root.compute_sql.ColumnType.toObject(n.columnType, o)), c;
    }, r.prototype.toJSON = function() {
      return this.constructor.toObject(this, minimal.util.toJSONOptions);
    }, r.getTypeUrl = function(n) {
      return n === void 0 && (n = "type.googleapis.com"), n + "/compute_sql.NamedColumn";
    }, r;
  }(), u.ColumnType = function() {
    function r(a) {
      if (a)
        for (let e = Object.keys(a), n = 0; n < e.length; ++n)
          a[e[n]] != null && (this[e[n]] = a[e[n]]);
    }
    return r.prototype.primitiveType = 0, r.prototype.nullable = !1, r.create = function(e) {
      return new r(e);
    }, r.encode = function(e, n) {
      return n || (n = $Writer.create()), e.primitiveType != null && Object.hasOwnProperty.call(e, "primitiveType") && n.uint32(
        /* id 1, wireType 0 =*/
        8
      ).int32(e.primitiveType), e.nullable != null && Object.hasOwnProperty.call(e, "nullable") && n.uint32(
        /* id 2, wireType 0 =*/
        16
      ).bool(e.nullable), n;
    }, r.encodeDelimited = function(e, n) {
      return this.encode(e, n).ldelim();
    }, r.decode = function(e, n) {
      e instanceof $Reader || (e = $Reader.create(e));
      let o = n === void 0 ? e.len : e.pos + n, c = new $root.compute_sql.ColumnType();
      for (; e.pos < o; ) {
        let l = e.uint32();
        switch (l >>> 3) {
          case 1: {
            c.primitiveType = e.int32();
            break;
          }
          case 2: {
            c.nullable = e.bool();
            break;
          }
          default:
            e.skipType(l & 7);
            break;
        }
      }
      return c;
    }, r.decodeDelimited = function(e) {
      return e instanceof $Reader || (e = new $Reader(e)), this.decode(e, e.uint32());
    }, r.verify = function(e) {
      if (typeof e != "object" || e === null)
        return "object expected";
      if (e.primitiveType != null && e.hasOwnProperty("primitiveType"))
        switch (e.primitiveType) {
          default:
            return "primitiveType: enum value expected";
          case 0:
          case 1:
          case 2:
            break;
        }
      return e.nullable != null && e.hasOwnProperty("nullable") && typeof e.nullable != "boolean" ? "nullable: boolean expected" : null;
    }, r.fromObject = function(e) {
      if (e instanceof $root.compute_sql.ColumnType)
        return e;
      let n = new $root.compute_sql.ColumnType();
      switch (e.primitiveType) {
        default:
          if (typeof e.primitiveType == "number") {
            n.primitiveType = e.primitiveType;
            break;
          }
          break;
        case "INT64":
        case 0:
          n.primitiveType = 0;
          break;
        case "STRING":
        case 1:
          n.primitiveType = 1;
          break;
        case "FLOAT64":
        case 2:
          n.primitiveType = 2;
          break;
      }
      return e.nullable != null && (n.nullable = !!e.nullable), n;
    }, r.toObject = function(e, n) {
      n || (n = {});
      let o = {};
      return n.defaults && (o.primitiveType = n.enums === String ? "INT64" : 0, o.nullable = !1), e.primitiveType != null && e.hasOwnProperty("primitiveType") && (o.primitiveType = n.enums === String ? $root.compute_sql.PrimitiveType[e.primitiveType] === void 0 ? e.primitiveType : $root.compute_sql.PrimitiveType[e.primitiveType] : e.primitiveType), e.nullable != null && e.hasOwnProperty("nullable") && (o.nullable = e.nullable), o;
    }, r.prototype.toJSON = function() {
      return this.constructor.toObject(this, minimal.util.toJSONOptions);
    }, r.getTypeUrl = function(e) {
      return e === void 0 && (e = "type.googleapis.com"), e + "/compute_sql.ColumnType";
    }, r;
  }(), u.PrimitiveType = function() {
    const r = {}, a = Object.create(r);
    return a[r[0] = "INT64"] = 0, a[r[1] = "STRING"] = 1, a[r[2] = "FLOAT64"] = 2, a;
  }(), u.TableDependencyMapping = function() {
    function r(a) {
      if (a)
        for (let e = Object.keys(a), n = 0; n < e.length; ++n)
          a[e[n]] != null && (this[e[n]] = a[e[n]]);
    }
    return r.prototype.table = "", r.prototype.dependency = "", r.create = function(e) {
      return new r(e);
    }, r.encode = function(e, n) {
      return n || (n = $Writer.create()), e.table != null && Object.hasOwnProperty.call(e, "table") && n.uint32(
        /* id 1, wireType 2 =*/
        10
      ).string(e.table), e.dependency != null && Object.hasOwnProperty.call(e, "dependency") && n.uint32(
        /* id 2, wireType 2 =*/
        18
      ).string(e.dependency), n;
    }, r.encodeDelimited = function(e, n) {
      return this.encode(e, n).ldelim();
    }, r.decode = function(e, n) {
      e instanceof $Reader || (e = $Reader.create(e));
      let o = n === void 0 ? e.len : e.pos + n, c = new $root.compute_sql.TableDependencyMapping();
      for (; e.pos < o; ) {
        let l = e.uint32();
        switch (l >>> 3) {
          case 1: {
            c.table = e.string();
            break;
          }
          case 2: {
            c.dependency = e.string();
            break;
          }
          default:
            e.skipType(l & 7);
            break;
        }
      }
      return c;
    }, r.decodeDelimited = function(e) {
      return e instanceof $Reader || (e = new $Reader(e)), this.decode(e, e.uint32());
    }, r.verify = function(e) {
      return typeof e != "object" || e === null ? "object expected" : e.table != null && e.hasOwnProperty("table") && !$util.isString(e.table) ? "table: string expected" : e.dependency != null && e.hasOwnProperty("dependency") && !$util.isString(e.dependency) ? "dependency: string expected" : null;
    }, r.fromObject = function(e) {
      if (e instanceof $root.compute_sql.TableDependencyMapping)
        return e;
      let n = new $root.compute_sql.TableDependencyMapping();
      return e.table != null && (n.table = String(e.table)), e.dependency != null && (n.dependency = String(e.dependency)), n;
    }, r.toObject = function(e, n) {
      n || (n = {});
      let o = {};
      return n.defaults && (o.table = "", o.dependency = ""), e.table != null && e.hasOwnProperty("table") && (o.table = e.table), e.dependency != null && e.hasOwnProperty("dependency") && (o.dependency = e.dependency), o;
    }, r.prototype.toJSON = function() {
      return this.constructor.toObject(this, minimal.util.toJSONOptions);
    }, r.getTypeUrl = function(e) {
      return e === void 0 && (e = "type.googleapis.com"), e + "/compute_sql.TableDependencyMapping";
    }, r;
  }(), u.ComputationConfiguration = function() {
    function r(a) {
      if (this.constraints = [], this.tableDependencyMappings = [], a)
        for (let e = Object.keys(a), n = 0; n < e.length; ++n)
          a[e[n]] != null && (this[e[n]] = a[e[n]]);
    }
    return r.prototype.sqlStatement = "", r.prototype.privacySettings = null, r.prototype.constraints = $util.emptyArray, r.prototype.tableDependencyMappings = $util.emptyArray, r.create = function(e) {
      return new r(e);
    }, r.encode = function(e, n) {
      if (n || (n = $Writer.create()), e.sqlStatement != null && Object.hasOwnProperty.call(e, "sqlStatement") && n.uint32(
        /* id 1, wireType 2 =*/
        10
      ).string(e.sqlStatement), e.privacySettings != null && Object.hasOwnProperty.call(e, "privacySettings") && $root.compute_sql.PrivacySettings.encode(e.privacySettings, n.uint32(
        /* id 2, wireType 2 =*/
        18
      ).fork()).ldelim(), e.constraints != null && e.constraints.length)
        for (let o = 0; o < e.constraints.length; ++o)
          $root.compute_sql.Constraint.encode(e.constraints[o], n.uint32(
            /* id 3, wireType 2 =*/
            26
          ).fork()).ldelim();
      if (e.tableDependencyMappings != null && e.tableDependencyMappings.length)
        for (let o = 0; o < e.tableDependencyMappings.length; ++o)
          $root.compute_sql.TableDependencyMapping.encode(e.tableDependencyMappings[o], n.uint32(
            /* id 4, wireType 2 =*/
            34
          ).fork()).ldelim();
      return n;
    }, r.encodeDelimited = function(e, n) {
      return this.encode(e, n).ldelim();
    }, r.decode = function(e, n) {
      e instanceof $Reader || (e = $Reader.create(e));
      let o = n === void 0 ? e.len : e.pos + n, c = new $root.compute_sql.ComputationConfiguration();
      for (; e.pos < o; ) {
        let l = e.uint32();
        switch (l >>> 3) {
          case 1: {
            c.sqlStatement = e.string();
            break;
          }
          case 2: {
            c.privacySettings = $root.compute_sql.PrivacySettings.decode(e, e.uint32());
            break;
          }
          case 3: {
            c.constraints && c.constraints.length || (c.constraints = []), c.constraints.push($root.compute_sql.Constraint.decode(e, e.uint32()));
            break;
          }
          case 4: {
            c.tableDependencyMappings && c.tableDependencyMappings.length || (c.tableDependencyMappings = []), c.tableDependencyMappings.push($root.compute_sql.TableDependencyMapping.decode(e, e.uint32()));
            break;
          }
          default:
            e.skipType(l & 7);
            break;
        }
      }
      return c;
    }, r.decodeDelimited = function(e) {
      return e instanceof $Reader || (e = new $Reader(e)), this.decode(e, e.uint32());
    }, r.verify = function(e) {
      if (typeof e != "object" || e === null)
        return "object expected";
      if (e.sqlStatement != null && e.hasOwnProperty("sqlStatement") && !$util.isString(e.sqlStatement))
        return "sqlStatement: string expected";
      if (e.privacySettings != null && e.hasOwnProperty("privacySettings")) {
        let n = $root.compute_sql.PrivacySettings.verify(e.privacySettings);
        if (n)
          return "privacySettings." + n;
      }
      if (e.constraints != null && e.hasOwnProperty("constraints")) {
        if (!Array.isArray(e.constraints))
          return "constraints: array expected";
        for (let n = 0; n < e.constraints.length; ++n) {
          let o = $root.compute_sql.Constraint.verify(e.constraints[n]);
          if (o)
            return "constraints." + o;
        }
      }
      if (e.tableDependencyMappings != null && e.hasOwnProperty("tableDependencyMappings")) {
        if (!Array.isArray(e.tableDependencyMappings))
          return "tableDependencyMappings: array expected";
        for (let n = 0; n < e.tableDependencyMappings.length; ++n) {
          let o = $root.compute_sql.TableDependencyMapping.verify(e.tableDependencyMappings[n]);
          if (o)
            return "tableDependencyMappings." + o;
        }
      }
      return null;
    }, r.fromObject = function(e) {
      if (e instanceof $root.compute_sql.ComputationConfiguration)
        return e;
      let n = new $root.compute_sql.ComputationConfiguration();
      if (e.sqlStatement != null && (n.sqlStatement = String(e.sqlStatement)), e.privacySettings != null) {
        if (typeof e.privacySettings != "object")
          throw TypeError(".compute_sql.ComputationConfiguration.privacySettings: object expected");
        n.privacySettings = $root.compute_sql.PrivacySettings.fromObject(e.privacySettings);
      }
      if (e.constraints) {
        if (!Array.isArray(e.constraints))
          throw TypeError(".compute_sql.ComputationConfiguration.constraints: array expected");
        n.constraints = [];
        for (let o = 0; o < e.constraints.length; ++o) {
          if (typeof e.constraints[o] != "object")
            throw TypeError(".compute_sql.ComputationConfiguration.constraints: object expected");
          n.constraints[o] = $root.compute_sql.Constraint.fromObject(e.constraints[o]);
        }
      }
      if (e.tableDependencyMappings) {
        if (!Array.isArray(e.tableDependencyMappings))
          throw TypeError(".compute_sql.ComputationConfiguration.tableDependencyMappings: array expected");
        n.tableDependencyMappings = [];
        for (let o = 0; o < e.tableDependencyMappings.length; ++o) {
          if (typeof e.tableDependencyMappings[o] != "object")
            throw TypeError(".compute_sql.ComputationConfiguration.tableDependencyMappings: object expected");
          n.tableDependencyMappings[o] = $root.compute_sql.TableDependencyMapping.fromObject(e.tableDependencyMappings[o]);
        }
      }
      return n;
    }, r.toObject = function(e, n) {
      n || (n = {});
      let o = {};
      if ((n.arrays || n.defaults) && (o.constraints = [], o.tableDependencyMappings = []), n.defaults && (o.sqlStatement = "", o.privacySettings = null), e.sqlStatement != null && e.hasOwnProperty("sqlStatement") && (o.sqlStatement = e.sqlStatement), e.privacySettings != null && e.hasOwnProperty("privacySettings") && (o.privacySettings = $root.compute_sql.PrivacySettings.toObject(e.privacySettings, n)), e.constraints && e.constraints.length) {
        o.constraints = [];
        for (let c = 0; c < e.constraints.length; ++c)
          o.constraints[c] = $root.compute_sql.Constraint.toObject(e.constraints[c], n);
      }
      if (e.tableDependencyMappings && e.tableDependencyMappings.length) {
        o.tableDependencyMappings = [];
        for (let c = 0; c < e.tableDependencyMappings.length; ++c)
          o.tableDependencyMappings[c] = $root.compute_sql.TableDependencyMapping.toObject(e.tableDependencyMappings[c], n);
      }
      return o;
    }, r.prototype.toJSON = function() {
      return this.constructor.toObject(this, minimal.util.toJSONOptions);
    }, r.getTypeUrl = function(e) {
      return e === void 0 && (e = "type.googleapis.com"), e + "/compute_sql.ComputationConfiguration";
    }, r;
  }(), u.PrivacySettings = function() {
    function r(a) {
      if (a)
        for (let e = Object.keys(a), n = 0; n < e.length; ++n)
          a[e[n]] != null && (this[e[n]] = a[e[n]]);
    }
    return r.prototype.minAggregationGroupSize = $util.Long ? $util.Long.fromBits(0, 0, !1) : 0, r.create = function(e) {
      return new r(e);
    }, r.encode = function(e, n) {
      return n || (n = $Writer.create()), e.minAggregationGroupSize != null && Object.hasOwnProperty.call(e, "minAggregationGroupSize") && n.uint32(
        /* id 1, wireType 0 =*/
        8
      ).int64(e.minAggregationGroupSize), n;
    }, r.encodeDelimited = function(e, n) {
      return this.encode(e, n).ldelim();
    }, r.decode = function(e, n) {
      e instanceof $Reader || (e = $Reader.create(e));
      let o = n === void 0 ? e.len : e.pos + n, c = new $root.compute_sql.PrivacySettings();
      for (; e.pos < o; ) {
        let l = e.uint32();
        switch (l >>> 3) {
          case 1: {
            c.minAggregationGroupSize = e.int64();
            break;
          }
          default:
            e.skipType(l & 7);
            break;
        }
      }
      return c;
    }, r.decodeDelimited = function(e) {
      return e instanceof $Reader || (e = new $Reader(e)), this.decode(e, e.uint32());
    }, r.verify = function(e) {
      return typeof e != "object" || e === null ? "object expected" : e.minAggregationGroupSize != null && e.hasOwnProperty("minAggregationGroupSize") && !$util.isInteger(e.minAggregationGroupSize) && !(e.minAggregationGroupSize && $util.isInteger(e.minAggregationGroupSize.low) && $util.isInteger(e.minAggregationGroupSize.high)) ? "minAggregationGroupSize: integer|Long expected" : null;
    }, r.fromObject = function(e) {
      if (e instanceof $root.compute_sql.PrivacySettings)
        return e;
      let n = new $root.compute_sql.PrivacySettings();
      return e.minAggregationGroupSize != null && ($util.Long ? (n.minAggregationGroupSize = $util.Long.fromValue(e.minAggregationGroupSize)).unsigned = !1 : typeof e.minAggregationGroupSize == "string" ? n.minAggregationGroupSize = parseInt(e.minAggregationGroupSize, 10) : typeof e.minAggregationGroupSize == "number" ? n.minAggregationGroupSize = e.minAggregationGroupSize : typeof e.minAggregationGroupSize == "object" && (n.minAggregationGroupSize = new $util.LongBits(e.minAggregationGroupSize.low >>> 0, e.minAggregationGroupSize.high >>> 0).toNumber())), n;
    }, r.toObject = function(e, n) {
      n || (n = {});
      let o = {};
      if (n.defaults)
        if ($util.Long) {
          let c = new $util.Long(0, 0, !1);
          o.minAggregationGroupSize = n.longs === String ? c.toString() : n.longs === Number ? c.toNumber() : c;
        } else
          o.minAggregationGroupSize = n.longs === String ? "0" : 0;
      return e.minAggregationGroupSize != null && e.hasOwnProperty("minAggregationGroupSize") && (typeof e.minAggregationGroupSize == "number" ? o.minAggregationGroupSize = n.longs === String ? String(e.minAggregationGroupSize) : e.minAggregationGroupSize : o.minAggregationGroupSize = n.longs === String ? $util.Long.prototype.toString.call(e.minAggregationGroupSize) : n.longs === Number ? new $util.LongBits(e.minAggregationGroupSize.low >>> 0, e.minAggregationGroupSize.high >>> 0).toNumber() : e.minAggregationGroupSize), o;
    }, r.prototype.toJSON = function() {
      return this.constructor.toObject(this, minimal.util.toJSONOptions);
    }, r.getTypeUrl = function(e) {
      return e === void 0 && (e = "type.googleapis.com"), e + "/compute_sql.PrivacySettings";
    }, r;
  }(), u.Constraint = function() {
    function r(a) {
      if (a)
        for (let e = Object.keys(a), n = 0; n < e.length; ++n)
          a[e[n]] != null && (this[e[n]] = a[e[n]]);
    }
    return r.prototype.description = "", r.create = function(e) {
      return new r(e);
    }, r.encode = function(e, n) {
      return n || (n = $Writer.create()), e.description != null && Object.hasOwnProperty.call(e, "description") && n.uint32(
        /* id 1, wireType 2 =*/
        10
      ).string(e.description), n;
    }, r.encodeDelimited = function(e, n) {
      return this.encode(e, n).ldelim();
    }, r.decode = function(e, n) {
      e instanceof $Reader || (e = $Reader.create(e));
      let o = n === void 0 ? e.len : e.pos + n, c = new $root.compute_sql.Constraint();
      for (; e.pos < o; ) {
        let l = e.uint32();
        switch (l >>> 3) {
          case 1: {
            c.description = e.string();
            break;
          }
          default:
            e.skipType(l & 7);
            break;
        }
      }
      return c;
    }, r.decodeDelimited = function(e) {
      return e instanceof $Reader || (e = new $Reader(e)), this.decode(e, e.uint32());
    }, r.verify = function(e) {
      return typeof e != "object" || e === null ? "object expected" : e.description != null && e.hasOwnProperty("description") && !$util.isString(e.description) ? "description: string expected" : null;
    }, r.fromObject = function(e) {
      if (e instanceof $root.compute_sql.Constraint)
        return e;
      let n = new $root.compute_sql.Constraint();
      return e.description != null && (n.description = String(e.description)), n;
    }, r.toObject = function(e, n) {
      n || (n = {});
      let o = {};
      return n.defaults && (o.description = ""), e.description != null && e.hasOwnProperty("description") && (o.description = e.description), o;
    }, r.prototype.toJSON = function() {
      return this.constructor.toObject(this, minimal.util.toJSONOptions);
    }, r.getTypeUrl = function(e) {
      return e === void 0 && (e = "type.googleapis.com"), e + "/compute_sql.Constraint";
    }, r;
  }(), u;
})();
$root.data_room = (() => {
  const u = {};
  return u.DataRoom = function() {
    function r(a) {
      if (a)
        for (let e = Object.keys(a), n = 0; n < e.length; ++n)
          a[e[n]] != null && (this[e[n]] = a[e[n]]);
    }
    return r.prototype.id = "", r.prototype.name = "", r.prototype.description = "", r.prototype.governanceProtocol = null, r.prototype.initialConfiguration = null, r.create = function(e) {
      return new r(e);
    }, r.encode = function(e, n) {
      return n || (n = $Writer.create()), e.id != null && Object.hasOwnProperty.call(e, "id") && n.uint32(
        /* id 1, wireType 2 =*/
        10
      ).string(e.id), e.name != null && Object.hasOwnProperty.call(e, "name") && n.uint32(
        /* id 2, wireType 2 =*/
        18
      ).string(e.name), e.description != null && Object.hasOwnProperty.call(e, "description") && n.uint32(
        /* id 3, wireType 2 =*/
        26
      ).string(e.description), e.governanceProtocol != null && Object.hasOwnProperty.call(e, "governanceProtocol") && $root.data_room.GovernanceProtocol.encode(e.governanceProtocol, n.uint32(
        /* id 4, wireType 2 =*/
        34
      ).fork()).ldelim(), e.initialConfiguration != null && Object.hasOwnProperty.call(e, "initialConfiguration") && $root.data_room.DataRoomConfiguration.encode(e.initialConfiguration, n.uint32(
        /* id 5, wireType 2 =*/
        42
      ).fork()).ldelim(), n;
    }, r.encodeDelimited = function(e, n) {
      return this.encode(e, n).ldelim();
    }, r.decode = function(e, n) {
      e instanceof $Reader || (e = $Reader.create(e));
      let o = n === void 0 ? e.len : e.pos + n, c = new $root.data_room.DataRoom();
      for (; e.pos < o; ) {
        let l = e.uint32();
        switch (l >>> 3) {
          case 1: {
            c.id = e.string();
            break;
          }
          case 2: {
            c.name = e.string();
            break;
          }
          case 3: {
            c.description = e.string();
            break;
          }
          case 4: {
            c.governanceProtocol = $root.data_room.GovernanceProtocol.decode(e, e.uint32());
            break;
          }
          case 5: {
            c.initialConfiguration = $root.data_room.DataRoomConfiguration.decode(e, e.uint32());
            break;
          }
          default:
            e.skipType(l & 7);
            break;
        }
      }
      return c;
    }, r.decodeDelimited = function(e) {
      return e instanceof $Reader || (e = new $Reader(e)), this.decode(e, e.uint32());
    }, r.verify = function(e) {
      if (typeof e != "object" || e === null)
        return "object expected";
      if (e.id != null && e.hasOwnProperty("id") && !$util.isString(e.id))
        return "id: string expected";
      if (e.name != null && e.hasOwnProperty("name") && !$util.isString(e.name))
        return "name: string expected";
      if (e.description != null && e.hasOwnProperty("description") && !$util.isString(e.description))
        return "description: string expected";
      if (e.governanceProtocol != null && e.hasOwnProperty("governanceProtocol")) {
        let n = $root.data_room.GovernanceProtocol.verify(e.governanceProtocol);
        if (n)
          return "governanceProtocol." + n;
      }
      if (e.initialConfiguration != null && e.hasOwnProperty("initialConfiguration")) {
        let n = $root.data_room.DataRoomConfiguration.verify(e.initialConfiguration);
        if (n)
          return "initialConfiguration." + n;
      }
      return null;
    }, r.fromObject = function(e) {
      if (e instanceof $root.data_room.DataRoom)
        return e;
      let n = new $root.data_room.DataRoom();
      if (e.id != null && (n.id = String(e.id)), e.name != null && (n.name = String(e.name)), e.description != null && (n.description = String(e.description)), e.governanceProtocol != null) {
        if (typeof e.governanceProtocol != "object")
          throw TypeError(".data_room.DataRoom.governanceProtocol: object expected");
        n.governanceProtocol = $root.data_room.GovernanceProtocol.fromObject(e.governanceProtocol);
      }
      if (e.initialConfiguration != null) {
        if (typeof e.initialConfiguration != "object")
          throw TypeError(".data_room.DataRoom.initialConfiguration: object expected");
        n.initialConfiguration = $root.data_room.DataRoomConfiguration.fromObject(e.initialConfiguration);
      }
      return n;
    }, r.toObject = function(e, n) {
      n || (n = {});
      let o = {};
      return n.defaults && (o.id = "", o.name = "", o.description = "", o.governanceProtocol = null, o.initialConfiguration = null), e.id != null && e.hasOwnProperty("id") && (o.id = e.id), e.name != null && e.hasOwnProperty("name") && (o.name = e.name), e.description != null && e.hasOwnProperty("description") && (o.description = e.description), e.governanceProtocol != null && e.hasOwnProperty("governanceProtocol") && (o.governanceProtocol = $root.data_room.GovernanceProtocol.toObject(e.governanceProtocol, n)), e.initialConfiguration != null && e.hasOwnProperty("initialConfiguration") && (o.initialConfiguration = $root.data_room.DataRoomConfiguration.toObject(e.initialConfiguration, n)), o;
    }, r.prototype.toJSON = function() {
      return this.constructor.toObject(this, minimal.util.toJSONOptions);
    }, r.getTypeUrl = function(e) {
      return e === void 0 && (e = "type.googleapis.com"), e + "/data_room.DataRoom";
    }, r;
  }(), u.GovernanceProtocol = function() {
    function r(e) {
      if (e)
        for (let n = Object.keys(e), o = 0; o < n.length; ++o)
          e[n[o]] != null && (this[n[o]] = e[n[o]]);
    }
    r.prototype.staticDataRoomPolicy = null, r.prototype.affectedDataOwnersApprovePolicy = null;
    let a;
    return Object.defineProperty(r.prototype, "policy", {
      get: $util.oneOfGetter(a = ["staticDataRoomPolicy", "affectedDataOwnersApprovePolicy"]),
      set: $util.oneOfSetter(a)
    }), r.create = function(n) {
      return new r(n);
    }, r.encode = function(n, o) {
      return o || (o = $Writer.create()), n.staticDataRoomPolicy != null && Object.hasOwnProperty.call(n, "staticDataRoomPolicy") && $root.data_room.StaticDataRoomPolicy.encode(n.staticDataRoomPolicy, o.uint32(
        /* id 1, wireType 2 =*/
        10
      ).fork()).ldelim(), n.affectedDataOwnersApprovePolicy != null && Object.hasOwnProperty.call(n, "affectedDataOwnersApprovePolicy") && $root.data_room.AffectedDataOwnersApprovePolicy.encode(n.affectedDataOwnersApprovePolicy, o.uint32(
        /* id 2, wireType 2 =*/
        18
      ).fork()).ldelim(), o;
    }, r.encodeDelimited = function(n, o) {
      return this.encode(n, o).ldelim();
    }, r.decode = function(n, o) {
      n instanceof $Reader || (n = $Reader.create(n));
      let c = o === void 0 ? n.len : n.pos + o, l = new $root.data_room.GovernanceProtocol();
      for (; n.pos < c; ) {
        let d = n.uint32();
        switch (d >>> 3) {
          case 1: {
            l.staticDataRoomPolicy = $root.data_room.StaticDataRoomPolicy.decode(n, n.uint32());
            break;
          }
          case 2: {
            l.affectedDataOwnersApprovePolicy = $root.data_room.AffectedDataOwnersApprovePolicy.decode(n, n.uint32());
            break;
          }
          default:
            n.skipType(d & 7);
            break;
        }
      }
      return l;
    }, r.decodeDelimited = function(n) {
      return n instanceof $Reader || (n = new $Reader(n)), this.decode(n, n.uint32());
    }, r.verify = function(n) {
      if (typeof n != "object" || n === null)
        return "object expected";
      let o = {};
      if (n.staticDataRoomPolicy != null && n.hasOwnProperty("staticDataRoomPolicy")) {
        o.policy = 1;
        {
          let c = $root.data_room.StaticDataRoomPolicy.verify(n.staticDataRoomPolicy);
          if (c)
            return "staticDataRoomPolicy." + c;
        }
      }
      if (n.affectedDataOwnersApprovePolicy != null && n.hasOwnProperty("affectedDataOwnersApprovePolicy")) {
        if (o.policy === 1)
          return "policy: multiple values";
        o.policy = 1;
        {
          let c = $root.data_room.AffectedDataOwnersApprovePolicy.verify(n.affectedDataOwnersApprovePolicy);
          if (c)
            return "affectedDataOwnersApprovePolicy." + c;
        }
      }
      return null;
    }, r.fromObject = function(n) {
      if (n instanceof $root.data_room.GovernanceProtocol)
        return n;
      let o = new $root.data_room.GovernanceProtocol();
      if (n.staticDataRoomPolicy != null) {
        if (typeof n.staticDataRoomPolicy != "object")
          throw TypeError(".data_room.GovernanceProtocol.staticDataRoomPolicy: object expected");
        o.staticDataRoomPolicy = $root.data_room.StaticDataRoomPolicy.fromObject(n.staticDataRoomPolicy);
      }
      if (n.affectedDataOwnersApprovePolicy != null) {
        if (typeof n.affectedDataOwnersApprovePolicy != "object")
          throw TypeError(".data_room.GovernanceProtocol.affectedDataOwnersApprovePolicy: object expected");
        o.affectedDataOwnersApprovePolicy = $root.data_room.AffectedDataOwnersApprovePolicy.fromObject(n.affectedDataOwnersApprovePolicy);
      }
      return o;
    }, r.toObject = function(n, o) {
      o || (o = {});
      let c = {};
      return n.staticDataRoomPolicy != null && n.hasOwnProperty("staticDataRoomPolicy") && (c.staticDataRoomPolicy = $root.data_room.StaticDataRoomPolicy.toObject(n.staticDataRoomPolicy, o), o.oneofs && (c.policy = "staticDataRoomPolicy")), n.affectedDataOwnersApprovePolicy != null && n.hasOwnProperty("affectedDataOwnersApprovePolicy") && (c.affectedDataOwnersApprovePolicy = $root.data_room.AffectedDataOwnersApprovePolicy.toObject(n.affectedDataOwnersApprovePolicy, o), o.oneofs && (c.policy = "affectedDataOwnersApprovePolicy")), c;
    }, r.prototype.toJSON = function() {
      return this.constructor.toObject(this, minimal.util.toJSONOptions);
    }, r.getTypeUrl = function(n) {
      return n === void 0 && (n = "type.googleapis.com"), n + "/data_room.GovernanceProtocol";
    }, r;
  }(), u.StaticDataRoomPolicy = function() {
    function r(a) {
      if (a)
        for (let e = Object.keys(a), n = 0; n < e.length; ++n)
          a[e[n]] != null && (this[e[n]] = a[e[n]]);
    }
    return r.create = function(e) {
      return new r(e);
    }, r.encode = function(e, n) {
      return n || (n = $Writer.create()), n;
    }, r.encodeDelimited = function(e, n) {
      return this.encode(e, n).ldelim();
    }, r.decode = function(e, n) {
      e instanceof $Reader || (e = $Reader.create(e));
      let o = n === void 0 ? e.len : e.pos + n, c = new $root.data_room.StaticDataRoomPolicy();
      for (; e.pos < o; ) {
        let l = e.uint32();
        switch (l >>> 3) {
          default:
            e.skipType(l & 7);
            break;
        }
      }
      return c;
    }, r.decodeDelimited = function(e) {
      return e instanceof $Reader || (e = new $Reader(e)), this.decode(e, e.uint32());
    }, r.verify = function(e) {
      return typeof e != "object" || e === null ? "object expected" : null;
    }, r.fromObject = function(e) {
      return e instanceof $root.data_room.StaticDataRoomPolicy ? e : new $root.data_room.StaticDataRoomPolicy();
    }, r.toObject = function() {
      return {};
    }, r.prototype.toJSON = function() {
      return this.constructor.toObject(this, minimal.util.toJSONOptions);
    }, r.getTypeUrl = function(e) {
      return e === void 0 && (e = "type.googleapis.com"), e + "/data_room.StaticDataRoomPolicy";
    }, r;
  }(), u.AffectedDataOwnersApprovePolicy = function() {
    function r(a) {
      if (a)
        for (let e = Object.keys(a), n = 0; n < e.length; ++n)
          a[e[n]] != null && (this[e[n]] = a[e[n]]);
    }
    return r.create = function(e) {
      return new r(e);
    }, r.encode = function(e, n) {
      return n || (n = $Writer.create()), n;
    }, r.encodeDelimited = function(e, n) {
      return this.encode(e, n).ldelim();
    }, r.decode = function(e, n) {
      e instanceof $Reader || (e = $Reader.create(e));
      let o = n === void 0 ? e.len : e.pos + n, c = new $root.data_room.AffectedDataOwnersApprovePolicy();
      for (; e.pos < o; ) {
        let l = e.uint32();
        switch (l >>> 3) {
          default:
            e.skipType(l & 7);
            break;
        }
      }
      return c;
    }, r.decodeDelimited = function(e) {
      return e instanceof $Reader || (e = new $Reader(e)), this.decode(e, e.uint32());
    }, r.verify = function(e) {
      return typeof e != "object" || e === null ? "object expected" : null;
    }, r.fromObject = function(e) {
      return e instanceof $root.data_room.AffectedDataOwnersApprovePolicy ? e : new $root.data_room.AffectedDataOwnersApprovePolicy();
    }, r.toObject = function() {
      return {};
    }, r.prototype.toJSON = function() {
      return this.constructor.toObject(this, minimal.util.toJSONOptions);
    }, r.getTypeUrl = function(e) {
      return e === void 0 && (e = "type.googleapis.com"), e + "/data_room.AffectedDataOwnersApprovePolicy";
    }, r;
  }(), u.DataRoomConfiguration = function() {
    function r(a) {
      if (this.elements = [], a)
        for (let e = Object.keys(a), n = 0; n < e.length; ++n)
          a[e[n]] != null && (this[e[n]] = a[e[n]]);
    }
    return r.prototype.elements = $util.emptyArray, r.create = function(e) {
      return new r(e);
    }, r.encode = function(e, n) {
      if (n || (n = $Writer.create()), e.elements != null && e.elements.length)
        for (let o = 0; o < e.elements.length; ++o)
          $root.data_room.ConfigurationElement.encode(e.elements[o], n.uint32(
            /* id 1, wireType 2 =*/
            10
          ).fork()).ldelim();
      return n;
    }, r.encodeDelimited = function(e, n) {
      return this.encode(e, n).ldelim();
    }, r.decode = function(e, n) {
      e instanceof $Reader || (e = $Reader.create(e));
      let o = n === void 0 ? e.len : e.pos + n, c = new $root.data_room.DataRoomConfiguration();
      for (; e.pos < o; ) {
        let l = e.uint32();
        switch (l >>> 3) {
          case 1: {
            c.elements && c.elements.length || (c.elements = []), c.elements.push($root.data_room.ConfigurationElement.decode(e, e.uint32()));
            break;
          }
          default:
            e.skipType(l & 7);
            break;
        }
      }
      return c;
    }, r.decodeDelimited = function(e) {
      return e instanceof $Reader || (e = new $Reader(e)), this.decode(e, e.uint32());
    }, r.verify = function(e) {
      if (typeof e != "object" || e === null)
        return "object expected";
      if (e.elements != null && e.hasOwnProperty("elements")) {
        if (!Array.isArray(e.elements))
          return "elements: array expected";
        for (let n = 0; n < e.elements.length; ++n) {
          let o = $root.data_room.ConfigurationElement.verify(e.elements[n]);
          if (o)
            return "elements." + o;
        }
      }
      return null;
    }, r.fromObject = function(e) {
      if (e instanceof $root.data_room.DataRoomConfiguration)
        return e;
      let n = new $root.data_room.DataRoomConfiguration();
      if (e.elements) {
        if (!Array.isArray(e.elements))
          throw TypeError(".data_room.DataRoomConfiguration.elements: array expected");
        n.elements = [];
        for (let o = 0; o < e.elements.length; ++o) {
          if (typeof e.elements[o] != "object")
            throw TypeError(".data_room.DataRoomConfiguration.elements: object expected");
          n.elements[o] = $root.data_room.ConfigurationElement.fromObject(e.elements[o]);
        }
      }
      return n;
    }, r.toObject = function(e, n) {
      n || (n = {});
      let o = {};
      if ((n.arrays || n.defaults) && (o.elements = []), e.elements && e.elements.length) {
        o.elements = [];
        for (let c = 0; c < e.elements.length; ++c)
          o.elements[c] = $root.data_room.ConfigurationElement.toObject(e.elements[c], n);
      }
      return o;
    }, r.prototype.toJSON = function() {
      return this.constructor.toObject(this, minimal.util.toJSONOptions);
    }, r.getTypeUrl = function(e) {
      return e === void 0 && (e = "type.googleapis.com"), e + "/data_room.DataRoomConfiguration";
    }, r;
  }(), u.ConfigurationElement = function() {
    function r(e) {
      if (e)
        for (let n = Object.keys(e), o = 0; o < n.length; ++o)
          e[n[o]] != null && (this[n[o]] = e[n[o]]);
    }
    r.prototype.id = "", r.prototype.computeNode = null, r.prototype.attestationSpecification = null, r.prototype.userPermission = null, r.prototype.authenticationMethod = null;
    let a;
    return Object.defineProperty(r.prototype, "element", {
      get: $util.oneOfGetter(a = ["computeNode", "attestationSpecification", "userPermission", "authenticationMethod"]),
      set: $util.oneOfSetter(a)
    }), r.create = function(n) {
      return new r(n);
    }, r.encode = function(n, o) {
      return o || (o = $Writer.create()), n.id != null && Object.hasOwnProperty.call(n, "id") && o.uint32(
        /* id 1, wireType 2 =*/
        10
      ).string(n.id), n.computeNode != null && Object.hasOwnProperty.call(n, "computeNode") && $root.data_room.ComputeNode.encode(n.computeNode, o.uint32(
        /* id 2, wireType 2 =*/
        18
      ).fork()).ldelim(), n.attestationSpecification != null && Object.hasOwnProperty.call(n, "attestationSpecification") && $root.attestation.AttestationSpecification.encode(n.attestationSpecification, o.uint32(
        /* id 3, wireType 2 =*/
        26
      ).fork()).ldelim(), n.userPermission != null && Object.hasOwnProperty.call(n, "userPermission") && $root.data_room.UserPermission.encode(n.userPermission, o.uint32(
        /* id 4, wireType 2 =*/
        34
      ).fork()).ldelim(), n.authenticationMethod != null && Object.hasOwnProperty.call(n, "authenticationMethod") && $root.data_room.AuthenticationMethod.encode(n.authenticationMethod, o.uint32(
        /* id 5, wireType 2 =*/
        42
      ).fork()).ldelim(), o;
    }, r.encodeDelimited = function(n, o) {
      return this.encode(n, o).ldelim();
    }, r.decode = function(n, o) {
      n instanceof $Reader || (n = $Reader.create(n));
      let c = o === void 0 ? n.len : n.pos + o, l = new $root.data_room.ConfigurationElement();
      for (; n.pos < c; ) {
        let d = n.uint32();
        switch (d >>> 3) {
          case 1: {
            l.id = n.string();
            break;
          }
          case 2: {
            l.computeNode = $root.data_room.ComputeNode.decode(n, n.uint32());
            break;
          }
          case 3: {
            l.attestationSpecification = $root.attestation.AttestationSpecification.decode(n, n.uint32());
            break;
          }
          case 4: {
            l.userPermission = $root.data_room.UserPermission.decode(n, n.uint32());
            break;
          }
          case 5: {
            l.authenticationMethod = $root.data_room.AuthenticationMethod.decode(n, n.uint32());
            break;
          }
          default:
            n.skipType(d & 7);
            break;
        }
      }
      return l;
    }, r.decodeDelimited = function(n) {
      return n instanceof $Reader || (n = new $Reader(n)), this.decode(n, n.uint32());
    }, r.verify = function(n) {
      if (typeof n != "object" || n === null)
        return "object expected";
      let o = {};
      if (n.id != null && n.hasOwnProperty("id") && !$util.isString(n.id))
        return "id: string expected";
      if (n.computeNode != null && n.hasOwnProperty("computeNode")) {
        o.element = 1;
        {
          let c = $root.data_room.ComputeNode.verify(n.computeNode);
          if (c)
            return "computeNode." + c;
        }
      }
      if (n.attestationSpecification != null && n.hasOwnProperty("attestationSpecification")) {
        if (o.element === 1)
          return "element: multiple values";
        o.element = 1;
        {
          let c = $root.attestation.AttestationSpecification.verify(n.attestationSpecification);
          if (c)
            return "attestationSpecification." + c;
        }
      }
      if (n.userPermission != null && n.hasOwnProperty("userPermission")) {
        if (o.element === 1)
          return "element: multiple values";
        o.element = 1;
        {
          let c = $root.data_room.UserPermission.verify(n.userPermission);
          if (c)
            return "userPermission." + c;
        }
      }
      if (n.authenticationMethod != null && n.hasOwnProperty("authenticationMethod")) {
        if (o.element === 1)
          return "element: multiple values";
        o.element = 1;
        {
          let c = $root.data_room.AuthenticationMethod.verify(n.authenticationMethod);
          if (c)
            return "authenticationMethod." + c;
        }
      }
      return null;
    }, r.fromObject = function(n) {
      if (n instanceof $root.data_room.ConfigurationElement)
        return n;
      let o = new $root.data_room.ConfigurationElement();
      if (n.id != null && (o.id = String(n.id)), n.computeNode != null) {
        if (typeof n.computeNode != "object")
          throw TypeError(".data_room.ConfigurationElement.computeNode: object expected");
        o.computeNode = $root.data_room.ComputeNode.fromObject(n.computeNode);
      }
      if (n.attestationSpecification != null) {
        if (typeof n.attestationSpecification != "object")
          throw TypeError(".data_room.ConfigurationElement.attestationSpecification: object expected");
        o.attestationSpecification = $root.attestation.AttestationSpecification.fromObject(n.attestationSpecification);
      }
      if (n.userPermission != null) {
        if (typeof n.userPermission != "object")
          throw TypeError(".data_room.ConfigurationElement.userPermission: object expected");
        o.userPermission = $root.data_room.UserPermission.fromObject(n.userPermission);
      }
      if (n.authenticationMethod != null) {
        if (typeof n.authenticationMethod != "object")
          throw TypeError(".data_room.ConfigurationElement.authenticationMethod: object expected");
        o.authenticationMethod = $root.data_room.AuthenticationMethod.fromObject(n.authenticationMethod);
      }
      return o;
    }, r.toObject = function(n, o) {
      o || (o = {});
      let c = {};
      return o.defaults && (c.id = ""), n.id != null && n.hasOwnProperty("id") && (c.id = n.id), n.computeNode != null && n.hasOwnProperty("computeNode") && (c.computeNode = $root.data_room.ComputeNode.toObject(n.computeNode, o), o.oneofs && (c.element = "computeNode")), n.attestationSpecification != null && n.hasOwnProperty("attestationSpecification") && (c.attestationSpecification = $root.attestation.AttestationSpecification.toObject(n.attestationSpecification, o), o.oneofs && (c.element = "attestationSpecification")), n.userPermission != null && n.hasOwnProperty("userPermission") && (c.userPermission = $root.data_room.UserPermission.toObject(n.userPermission, o), o.oneofs && (c.element = "userPermission")), n.authenticationMethod != null && n.hasOwnProperty("authenticationMethod") && (c.authenticationMethod = $root.data_room.AuthenticationMethod.toObject(n.authenticationMethod, o), o.oneofs && (c.element = "authenticationMethod")), c;
    }, r.prototype.toJSON = function() {
      return this.constructor.toObject(this, minimal.util.toJSONOptions);
    }, r.getTypeUrl = function(n) {
      return n === void 0 && (n = "type.googleapis.com"), n + "/data_room.ConfigurationElement";
    }, r;
  }(), u.ConfigurationModification = function() {
    function r(e) {
      if (e)
        for (let n = Object.keys(e), o = 0; o < n.length; ++o)
          e[n[o]] != null && (this[n[o]] = e[n[o]]);
    }
    r.prototype.add = null, r.prototype.change = null, r.prototype.delete = null;
    let a;
    return Object.defineProperty(r.prototype, "modification", {
      get: $util.oneOfGetter(a = ["add", "change", "delete"]),
      set: $util.oneOfSetter(a)
    }), r.create = function(n) {
      return new r(n);
    }, r.encode = function(n, o) {
      return o || (o = $Writer.create()), n.add != null && Object.hasOwnProperty.call(n, "add") && $root.data_room.AddModification.encode(n.add, o.uint32(
        /* id 1, wireType 2 =*/
        10
      ).fork()).ldelim(), n.change != null && Object.hasOwnProperty.call(n, "change") && $root.data_room.ChangeModification.encode(n.change, o.uint32(
        /* id 2, wireType 2 =*/
        18
      ).fork()).ldelim(), n.delete != null && Object.hasOwnProperty.call(n, "delete") && $root.data_room.DeleteModification.encode(n.delete, o.uint32(
        /* id 3, wireType 2 =*/
        26
      ).fork()).ldelim(), o;
    }, r.encodeDelimited = function(n, o) {
      return this.encode(n, o).ldelim();
    }, r.decode = function(n, o) {
      n instanceof $Reader || (n = $Reader.create(n));
      let c = o === void 0 ? n.len : n.pos + o, l = new $root.data_room.ConfigurationModification();
      for (; n.pos < c; ) {
        let d = n.uint32();
        switch (d >>> 3) {
          case 1: {
            l.add = $root.data_room.AddModification.decode(n, n.uint32());
            break;
          }
          case 2: {
            l.change = $root.data_room.ChangeModification.decode(n, n.uint32());
            break;
          }
          case 3: {
            l.delete = $root.data_room.DeleteModification.decode(n, n.uint32());
            break;
          }
          default:
            n.skipType(d & 7);
            break;
        }
      }
      return l;
    }, r.decodeDelimited = function(n) {
      return n instanceof $Reader || (n = new $Reader(n)), this.decode(n, n.uint32());
    }, r.verify = function(n) {
      if (typeof n != "object" || n === null)
        return "object expected";
      let o = {};
      if (n.add != null && n.hasOwnProperty("add")) {
        o.modification = 1;
        {
          let c = $root.data_room.AddModification.verify(n.add);
          if (c)
            return "add." + c;
        }
      }
      if (n.change != null && n.hasOwnProperty("change")) {
        if (o.modification === 1)
          return "modification: multiple values";
        o.modification = 1;
        {
          let c = $root.data_room.ChangeModification.verify(n.change);
          if (c)
            return "change." + c;
        }
      }
      if (n.delete != null && n.hasOwnProperty("delete")) {
        if (o.modification === 1)
          return "modification: multiple values";
        o.modification = 1;
        {
          let c = $root.data_room.DeleteModification.verify(n.delete);
          if (c)
            return "delete." + c;
        }
      }
      return null;
    }, r.fromObject = function(n) {
      if (n instanceof $root.data_room.ConfigurationModification)
        return n;
      let o = new $root.data_room.ConfigurationModification();
      if (n.add != null) {
        if (typeof n.add != "object")
          throw TypeError(".data_room.ConfigurationModification.add: object expected");
        o.add = $root.data_room.AddModification.fromObject(n.add);
      }
      if (n.change != null) {
        if (typeof n.change != "object")
          throw TypeError(".data_room.ConfigurationModification.change: object expected");
        o.change = $root.data_room.ChangeModification.fromObject(n.change);
      }
      if (n.delete != null) {
        if (typeof n.delete != "object")
          throw TypeError(".data_room.ConfigurationModification.delete: object expected");
        o.delete = $root.data_room.DeleteModification.fromObject(n.delete);
      }
      return o;
    }, r.toObject = function(n, o) {
      o || (o = {});
      let c = {};
      return n.add != null && n.hasOwnProperty("add") && (c.add = $root.data_room.AddModification.toObject(n.add, o), o.oneofs && (c.modification = "add")), n.change != null && n.hasOwnProperty("change") && (c.change = $root.data_room.ChangeModification.toObject(n.change, o), o.oneofs && (c.modification = "change")), n.delete != null && n.hasOwnProperty("delete") && (c.delete = $root.data_room.DeleteModification.toObject(n.delete, o), o.oneofs && (c.modification = "delete")), c;
    }, r.prototype.toJSON = function() {
      return this.constructor.toObject(this, minimal.util.toJSONOptions);
    }, r.getTypeUrl = function(n) {
      return n === void 0 && (n = "type.googleapis.com"), n + "/data_room.ConfigurationModification";
    }, r;
  }(), u.AddModification = function() {
    function r(a) {
      if (a)
        for (let e = Object.keys(a), n = 0; n < e.length; ++n)
          a[e[n]] != null && (this[e[n]] = a[e[n]]);
    }
    return r.prototype.element = null, r.create = function(e) {
      return new r(e);
    }, r.encode = function(e, n) {
      return n || (n = $Writer.create()), e.element != null && Object.hasOwnProperty.call(e, "element") && $root.data_room.ConfigurationElement.encode(e.element, n.uint32(
        /* id 1, wireType 2 =*/
        10
      ).fork()).ldelim(), n;
    }, r.encodeDelimited = function(e, n) {
      return this.encode(e, n).ldelim();
    }, r.decode = function(e, n) {
      e instanceof $Reader || (e = $Reader.create(e));
      let o = n === void 0 ? e.len : e.pos + n, c = new $root.data_room.AddModification();
      for (; e.pos < o; ) {
        let l = e.uint32();
        switch (l >>> 3) {
          case 1: {
            c.element = $root.data_room.ConfigurationElement.decode(e, e.uint32());
            break;
          }
          default:
            e.skipType(l & 7);
            break;
        }
      }
      return c;
    }, r.decodeDelimited = function(e) {
      return e instanceof $Reader || (e = new $Reader(e)), this.decode(e, e.uint32());
    }, r.verify = function(e) {
      if (typeof e != "object" || e === null)
        return "object expected";
      if (e.element != null && e.hasOwnProperty("element")) {
        let n = $root.data_room.ConfigurationElement.verify(e.element);
        if (n)
          return "element." + n;
      }
      return null;
    }, r.fromObject = function(e) {
      if (e instanceof $root.data_room.AddModification)
        return e;
      let n = new $root.data_room.AddModification();
      if (e.element != null) {
        if (typeof e.element != "object")
          throw TypeError(".data_room.AddModification.element: object expected");
        n.element = $root.data_room.ConfigurationElement.fromObject(e.element);
      }
      return n;
    }, r.toObject = function(e, n) {
      n || (n = {});
      let o = {};
      return n.defaults && (o.element = null), e.element != null && e.hasOwnProperty("element") && (o.element = $root.data_room.ConfigurationElement.toObject(e.element, n)), o;
    }, r.prototype.toJSON = function() {
      return this.constructor.toObject(this, minimal.util.toJSONOptions);
    }, r.getTypeUrl = function(e) {
      return e === void 0 && (e = "type.googleapis.com"), e + "/data_room.AddModification";
    }, r;
  }(), u.ChangeModification = function() {
    function r(a) {
      if (a)
        for (let e = Object.keys(a), n = 0; n < e.length; ++n)
          a[e[n]] != null && (this[e[n]] = a[e[n]]);
    }
    return r.prototype.element = null, r.create = function(e) {
      return new r(e);
    }, r.encode = function(e, n) {
      return n || (n = $Writer.create()), e.element != null && Object.hasOwnProperty.call(e, "element") && $root.data_room.ConfigurationElement.encode(e.element, n.uint32(
        /* id 1, wireType 2 =*/
        10
      ).fork()).ldelim(), n;
    }, r.encodeDelimited = function(e, n) {
      return this.encode(e, n).ldelim();
    }, r.decode = function(e, n) {
      e instanceof $Reader || (e = $Reader.create(e));
      let o = n === void 0 ? e.len : e.pos + n, c = new $root.data_room.ChangeModification();
      for (; e.pos < o; ) {
        let l = e.uint32();
        switch (l >>> 3) {
          case 1: {
            c.element = $root.data_room.ConfigurationElement.decode(e, e.uint32());
            break;
          }
          default:
            e.skipType(l & 7);
            break;
        }
      }
      return c;
    }, r.decodeDelimited = function(e) {
      return e instanceof $Reader || (e = new $Reader(e)), this.decode(e, e.uint32());
    }, r.verify = function(e) {
      if (typeof e != "object" || e === null)
        return "object expected";
      if (e.element != null && e.hasOwnProperty("element")) {
        let n = $root.data_room.ConfigurationElement.verify(e.element);
        if (n)
          return "element." + n;
      }
      return null;
    }, r.fromObject = function(e) {
      if (e instanceof $root.data_room.ChangeModification)
        return e;
      let n = new $root.data_room.ChangeModification();
      if (e.element != null) {
        if (typeof e.element != "object")
          throw TypeError(".data_room.ChangeModification.element: object expected");
        n.element = $root.data_room.ConfigurationElement.fromObject(e.element);
      }
      return n;
    }, r.toObject = function(e, n) {
      n || (n = {});
      let o = {};
      return n.defaults && (o.element = null), e.element != null && e.hasOwnProperty("element") && (o.element = $root.data_room.ConfigurationElement.toObject(e.element, n)), o;
    }, r.prototype.toJSON = function() {
      return this.constructor.toObject(this, minimal.util.toJSONOptions);
    }, r.getTypeUrl = function(e) {
      return e === void 0 && (e = "type.googleapis.com"), e + "/data_room.ChangeModification";
    }, r;
  }(), u.DeleteModification = function() {
    function r(a) {
      if (a)
        for (let e = Object.keys(a), n = 0; n < e.length; ++n)
          a[e[n]] != null && (this[e[n]] = a[e[n]]);
    }
    return r.prototype.id = "", r.create = function(e) {
      return new r(e);
    }, r.encode = function(e, n) {
      return n || (n = $Writer.create()), e.id != null && Object.hasOwnProperty.call(e, "id") && n.uint32(
        /* id 1, wireType 2 =*/
        10
      ).string(e.id), n;
    }, r.encodeDelimited = function(e, n) {
      return this.encode(e, n).ldelim();
    }, r.decode = function(e, n) {
      e instanceof $Reader || (e = $Reader.create(e));
      let o = n === void 0 ? e.len : e.pos + n, c = new $root.data_room.DeleteModification();
      for (; e.pos < o; ) {
        let l = e.uint32();
        switch (l >>> 3) {
          case 1: {
            c.id = e.string();
            break;
          }
          default:
            e.skipType(l & 7);
            break;
        }
      }
      return c;
    }, r.decodeDelimited = function(e) {
      return e instanceof $Reader || (e = new $Reader(e)), this.decode(e, e.uint32());
    }, r.verify = function(e) {
      return typeof e != "object" || e === null ? "object expected" : e.id != null && e.hasOwnProperty("id") && !$util.isString(e.id) ? "id: string expected" : null;
    }, r.fromObject = function(e) {
      if (e instanceof $root.data_room.DeleteModification)
        return e;
      let n = new $root.data_room.DeleteModification();
      return e.id != null && (n.id = String(e.id)), n;
    }, r.toObject = function(e, n) {
      n || (n = {});
      let o = {};
      return n.defaults && (o.id = ""), e.id != null && e.hasOwnProperty("id") && (o.id = e.id), o;
    }, r.prototype.toJSON = function() {
      return this.constructor.toObject(this, minimal.util.toJSONOptions);
    }, r.getTypeUrl = function(e) {
      return e === void 0 && (e = "type.googleapis.com"), e + "/data_room.DeleteModification";
    }, r;
  }(), u.ConfigurationCommit = function() {
    function r(a) {
      if (this.modifications = [], a)
        for (let e = Object.keys(a), n = 0; n < e.length; ++n)
          a[e[n]] != null && (this[e[n]] = a[e[n]]);
    }
    return r.prototype.id = "", r.prototype.name = "", r.prototype.dataRoomId = $util.newBuffer([]), r.prototype.dataRoomHistoryPin = $util.newBuffer([]), r.prototype.modifications = $util.emptyArray, r.create = function(e) {
      return new r(e);
    }, r.encode = function(e, n) {
      if (n || (n = $Writer.create()), e.id != null && Object.hasOwnProperty.call(e, "id") && n.uint32(
        /* id 1, wireType 2 =*/
        10
      ).string(e.id), e.name != null && Object.hasOwnProperty.call(e, "name") && n.uint32(
        /* id 2, wireType 2 =*/
        18
      ).string(e.name), e.dataRoomId != null && Object.hasOwnProperty.call(e, "dataRoomId") && n.uint32(
        /* id 3, wireType 2 =*/
        26
      ).bytes(e.dataRoomId), e.dataRoomHistoryPin != null && Object.hasOwnProperty.call(e, "dataRoomHistoryPin") && n.uint32(
        /* id 4, wireType 2 =*/
        34
      ).bytes(e.dataRoomHistoryPin), e.modifications != null && e.modifications.length)
        for (let o = 0; o < e.modifications.length; ++o)
          $root.data_room.ConfigurationModification.encode(e.modifications[o], n.uint32(
            /* id 5, wireType 2 =*/
            42
          ).fork()).ldelim();
      return n;
    }, r.encodeDelimited = function(e, n) {
      return this.encode(e, n).ldelim();
    }, r.decode = function(e, n) {
      e instanceof $Reader || (e = $Reader.create(e));
      let o = n === void 0 ? e.len : e.pos + n, c = new $root.data_room.ConfigurationCommit();
      for (; e.pos < o; ) {
        let l = e.uint32();
        switch (l >>> 3) {
          case 1: {
            c.id = e.string();
            break;
          }
          case 2: {
            c.name = e.string();
            break;
          }
          case 3: {
            c.dataRoomId = e.bytes();
            break;
          }
          case 4: {
            c.dataRoomHistoryPin = e.bytes();
            break;
          }
          case 5: {
            c.modifications && c.modifications.length || (c.modifications = []), c.modifications.push($root.data_room.ConfigurationModification.decode(e, e.uint32()));
            break;
          }
          default:
            e.skipType(l & 7);
            break;
        }
      }
      return c;
    }, r.decodeDelimited = function(e) {
      return e instanceof $Reader || (e = new $Reader(e)), this.decode(e, e.uint32());
    }, r.verify = function(e) {
      if (typeof e != "object" || e === null)
        return "object expected";
      if (e.id != null && e.hasOwnProperty("id") && !$util.isString(e.id))
        return "id: string expected";
      if (e.name != null && e.hasOwnProperty("name") && !$util.isString(e.name))
        return "name: string expected";
      if (e.dataRoomId != null && e.hasOwnProperty("dataRoomId") && !(e.dataRoomId && typeof e.dataRoomId.length == "number" || $util.isString(e.dataRoomId)))
        return "dataRoomId: buffer expected";
      if (e.dataRoomHistoryPin != null && e.hasOwnProperty("dataRoomHistoryPin") && !(e.dataRoomHistoryPin && typeof e.dataRoomHistoryPin.length == "number" || $util.isString(e.dataRoomHistoryPin)))
        return "dataRoomHistoryPin: buffer expected";
      if (e.modifications != null && e.hasOwnProperty("modifications")) {
        if (!Array.isArray(e.modifications))
          return "modifications: array expected";
        for (let n = 0; n < e.modifications.length; ++n) {
          let o = $root.data_room.ConfigurationModification.verify(e.modifications[n]);
          if (o)
            return "modifications." + o;
        }
      }
      return null;
    }, r.fromObject = function(e) {
      if (e instanceof $root.data_room.ConfigurationCommit)
        return e;
      let n = new $root.data_room.ConfigurationCommit();
      if (e.id != null && (n.id = String(e.id)), e.name != null && (n.name = String(e.name)), e.dataRoomId != null && (typeof e.dataRoomId == "string" ? $util.base64.decode(e.dataRoomId, n.dataRoomId = $util.newBuffer($util.base64.length(e.dataRoomId)), 0) : e.dataRoomId.length >= 0 && (n.dataRoomId = e.dataRoomId)), e.dataRoomHistoryPin != null && (typeof e.dataRoomHistoryPin == "string" ? $util.base64.decode(e.dataRoomHistoryPin, n.dataRoomHistoryPin = $util.newBuffer($util.base64.length(e.dataRoomHistoryPin)), 0) : e.dataRoomHistoryPin.length >= 0 && (n.dataRoomHistoryPin = e.dataRoomHistoryPin)), e.modifications) {
        if (!Array.isArray(e.modifications))
          throw TypeError(".data_room.ConfigurationCommit.modifications: array expected");
        n.modifications = [];
        for (let o = 0; o < e.modifications.length; ++o) {
          if (typeof e.modifications[o] != "object")
            throw TypeError(".data_room.ConfigurationCommit.modifications: object expected");
          n.modifications[o] = $root.data_room.ConfigurationModification.fromObject(e.modifications[o]);
        }
      }
      return n;
    }, r.toObject = function(e, n) {
      n || (n = {});
      let o = {};
      if ((n.arrays || n.defaults) && (o.modifications = []), n.defaults && (o.id = "", o.name = "", n.bytes === String ? o.dataRoomId = "" : (o.dataRoomId = [], n.bytes !== Array && (o.dataRoomId = $util.newBuffer(o.dataRoomId))), n.bytes === String ? o.dataRoomHistoryPin = "" : (o.dataRoomHistoryPin = [], n.bytes !== Array && (o.dataRoomHistoryPin = $util.newBuffer(o.dataRoomHistoryPin)))), e.id != null && e.hasOwnProperty("id") && (o.id = e.id), e.name != null && e.hasOwnProperty("name") && (o.name = e.name), e.dataRoomId != null && e.hasOwnProperty("dataRoomId") && (o.dataRoomId = n.bytes === String ? $util.base64.encode(e.dataRoomId, 0, e.dataRoomId.length) : n.bytes === Array ? Array.prototype.slice.call(e.dataRoomId) : e.dataRoomId), e.dataRoomHistoryPin != null && e.hasOwnProperty("dataRoomHistoryPin") && (o.dataRoomHistoryPin = n.bytes === String ? $util.base64.encode(e.dataRoomHistoryPin, 0, e.dataRoomHistoryPin.length) : n.bytes === Array ? Array.prototype.slice.call(e.dataRoomHistoryPin) : e.dataRoomHistoryPin), e.modifications && e.modifications.length) {
        o.modifications = [];
        for (let c = 0; c < e.modifications.length; ++c)
          o.modifications[c] = $root.data_room.ConfigurationModification.toObject(e.modifications[c], n);
      }
      return o;
    }, r.prototype.toJSON = function() {
      return this.constructor.toObject(this, minimal.util.toJSONOptions);
    }, r.getTypeUrl = function(e) {
      return e === void 0 && (e = "type.googleapis.com"), e + "/data_room.ConfigurationCommit";
    }, r;
  }(), u.WindowRateLimitingConfig = function() {
    function r(a) {
      if (a)
        for (let e = Object.keys(a), n = 0; n < e.length; ++n)
          a[e[n]] != null && (this[e[n]] = a[e[n]]);
    }
    return r.prototype.timeWindowSeconds = 0, r.prototype.numMaxExecutions = 0, r.create = function(e) {
      return new r(e);
    }, r.encode = function(e, n) {
      return n || (n = $Writer.create()), e.timeWindowSeconds != null && Object.hasOwnProperty.call(e, "timeWindowSeconds") && n.uint32(
        /* id 1, wireType 0 =*/
        8
      ).uint32(e.timeWindowSeconds), e.numMaxExecutions != null && Object.hasOwnProperty.call(e, "numMaxExecutions") && n.uint32(
        /* id 2, wireType 0 =*/
        16
      ).uint32(e.numMaxExecutions), n;
    }, r.encodeDelimited = function(e, n) {
      return this.encode(e, n).ldelim();
    }, r.decode = function(e, n) {
      e instanceof $Reader || (e = $Reader.create(e));
      let o = n === void 0 ? e.len : e.pos + n, c = new $root.data_room.WindowRateLimitingConfig();
      for (; e.pos < o; ) {
        let l = e.uint32();
        switch (l >>> 3) {
          case 1: {
            c.timeWindowSeconds = e.uint32();
            break;
          }
          case 2: {
            c.numMaxExecutions = e.uint32();
            break;
          }
          default:
            e.skipType(l & 7);
            break;
        }
      }
      return c;
    }, r.decodeDelimited = function(e) {
      return e instanceof $Reader || (e = new $Reader(e)), this.decode(e, e.uint32());
    }, r.verify = function(e) {
      return typeof e != "object" || e === null ? "object expected" : e.timeWindowSeconds != null && e.hasOwnProperty("timeWindowSeconds") && !$util.isInteger(e.timeWindowSeconds) ? "timeWindowSeconds: integer expected" : e.numMaxExecutions != null && e.hasOwnProperty("numMaxExecutions") && !$util.isInteger(e.numMaxExecutions) ? "numMaxExecutions: integer expected" : null;
    }, r.fromObject = function(e) {
      if (e instanceof $root.data_room.WindowRateLimitingConfig)
        return e;
      let n = new $root.data_room.WindowRateLimitingConfig();
      return e.timeWindowSeconds != null && (n.timeWindowSeconds = e.timeWindowSeconds >>> 0), e.numMaxExecutions != null && (n.numMaxExecutions = e.numMaxExecutions >>> 0), n;
    }, r.toObject = function(e, n) {
      n || (n = {});
      let o = {};
      return n.defaults && (o.timeWindowSeconds = 0, o.numMaxExecutions = 0), e.timeWindowSeconds != null && e.hasOwnProperty("timeWindowSeconds") && (o.timeWindowSeconds = e.timeWindowSeconds), e.numMaxExecutions != null && e.hasOwnProperty("numMaxExecutions") && (o.numMaxExecutions = e.numMaxExecutions), o;
    }, r.prototype.toJSON = function() {
      return this.constructor.toObject(this, minimal.util.toJSONOptions);
    }, r.getTypeUrl = function(e) {
      return e === void 0 && (e = "type.googleapis.com"), e + "/data_room.WindowRateLimitingConfig";
    }, r;
  }(), u.RateLimitingConfig = function() {
    function r(e) {
      if (e)
        for (let n = Object.keys(e), o = 0; o < n.length; ++o)
          e[n[o]] != null && (this[n[o]] = e[n[o]]);
    }
    r.prototype.window = null;
    let a;
    return Object.defineProperty(r.prototype, "method", {
      get: $util.oneOfGetter(a = ["window"]),
      set: $util.oneOfSetter(a)
    }), r.create = function(n) {
      return new r(n);
    }, r.encode = function(n, o) {
      return o || (o = $Writer.create()), n.window != null && Object.hasOwnProperty.call(n, "window") && $root.data_room.WindowRateLimitingConfig.encode(n.window, o.uint32(
        /* id 1, wireType 2 =*/
        10
      ).fork()).ldelim(), o;
    }, r.encodeDelimited = function(n, o) {
      return this.encode(n, o).ldelim();
    }, r.decode = function(n, o) {
      n instanceof $Reader || (n = $Reader.create(n));
      let c = o === void 0 ? n.len : n.pos + o, l = new $root.data_room.RateLimitingConfig();
      for (; n.pos < c; ) {
        let d = n.uint32();
        switch (d >>> 3) {
          case 1: {
            l.window = $root.data_room.WindowRateLimitingConfig.decode(n, n.uint32());
            break;
          }
          default:
            n.skipType(d & 7);
            break;
        }
      }
      return l;
    }, r.decodeDelimited = function(n) {
      return n instanceof $Reader || (n = new $Reader(n)), this.decode(n, n.uint32());
    }, r.verify = function(n) {
      if (typeof n != "object" || n === null)
        return "object expected";
      if (n.window != null && n.hasOwnProperty("window")) {
        let o = $root.data_room.WindowRateLimitingConfig.verify(n.window);
        if (o)
          return "window." + o;
      }
      return null;
    }, r.fromObject = function(n) {
      if (n instanceof $root.data_room.RateLimitingConfig)
        return n;
      let o = new $root.data_room.RateLimitingConfig();
      if (n.window != null) {
        if (typeof n.window != "object")
          throw TypeError(".data_room.RateLimitingConfig.window: object expected");
        o.window = $root.data_room.WindowRateLimitingConfig.fromObject(n.window);
      }
      return o;
    }, r.toObject = function(n, o) {
      o || (o = {});
      let c = {};
      return n.window != null && n.hasOwnProperty("window") && (c.window = $root.data_room.WindowRateLimitingConfig.toObject(n.window, o), o.oneofs && (c.method = "window")), c;
    }, r.prototype.toJSON = function() {
      return this.constructor.toObject(this, minimal.util.toJSONOptions);
    }, r.getTypeUrl = function(n) {
      return n === void 0 && (n = "type.googleapis.com"), n + "/data_room.RateLimitingConfig";
    }, r;
  }(), u.ComputeNode = function() {
    function r(e) {
      if (e)
        for (let n = Object.keys(e), o = 0; o < n.length; ++o)
          e[n[o]] != null && (this[n[o]] = e[n[o]]);
    }
    r.prototype.nodeName = "", r.prototype.leaf = null, r.prototype.parameter = null, r.prototype.branch = null, r.prototype.airlock = null, r.prototype.rateLimiting = null;
    let a;
    return Object.defineProperty(r.prototype, "node", {
      get: $util.oneOfGetter(a = ["leaf", "parameter", "branch", "airlock"]),
      set: $util.oneOfSetter(a)
    }), Object.defineProperty(r.prototype, "_rateLimiting", {
      get: $util.oneOfGetter(a = ["rateLimiting"]),
      set: $util.oneOfSetter(a)
    }), r.create = function(n) {
      return new r(n);
    }, r.encode = function(n, o) {
      return o || (o = $Writer.create()), n.nodeName != null && Object.hasOwnProperty.call(n, "nodeName") && o.uint32(
        /* id 1, wireType 2 =*/
        10
      ).string(n.nodeName), n.leaf != null && Object.hasOwnProperty.call(n, "leaf") && $root.data_room.ComputeNodeLeaf.encode(n.leaf, o.uint32(
        /* id 2, wireType 2 =*/
        18
      ).fork()).ldelim(), n.branch != null && Object.hasOwnProperty.call(n, "branch") && $root.data_room.ComputeNodeBranch.encode(n.branch, o.uint32(
        /* id 3, wireType 2 =*/
        26
      ).fork()).ldelim(), n.parameter != null && Object.hasOwnProperty.call(n, "parameter") && $root.data_room.ComputeNodeParameter.encode(n.parameter, o.uint32(
        /* id 4, wireType 2 =*/
        34
      ).fork()).ldelim(), n.rateLimiting != null && Object.hasOwnProperty.call(n, "rateLimiting") && $root.data_room.RateLimitingConfig.encode(n.rateLimiting, o.uint32(
        /* id 5, wireType 2 =*/
        42
      ).fork()).ldelim(), n.airlock != null && Object.hasOwnProperty.call(n, "airlock") && $root.data_room.ComputeNodeAirlock.encode(n.airlock, o.uint32(
        /* id 6, wireType 2 =*/
        50
      ).fork()).ldelim(), o;
    }, r.encodeDelimited = function(n, o) {
      return this.encode(n, o).ldelim();
    }, r.decode = function(n, o) {
      n instanceof $Reader || (n = $Reader.create(n));
      let c = o === void 0 ? n.len : n.pos + o, l = new $root.data_room.ComputeNode();
      for (; n.pos < c; ) {
        let d = n.uint32();
        switch (d >>> 3) {
          case 1: {
            l.nodeName = n.string();
            break;
          }
          case 2: {
            l.leaf = $root.data_room.ComputeNodeLeaf.decode(n, n.uint32());
            break;
          }
          case 4: {
            l.parameter = $root.data_room.ComputeNodeParameter.decode(n, n.uint32());
            break;
          }
          case 3: {
            l.branch = $root.data_room.ComputeNodeBranch.decode(n, n.uint32());
            break;
          }
          case 6: {
            l.airlock = $root.data_room.ComputeNodeAirlock.decode(n, n.uint32());
            break;
          }
          case 5: {
            l.rateLimiting = $root.data_room.RateLimitingConfig.decode(n, n.uint32());
            break;
          }
          default:
            n.skipType(d & 7);
            break;
        }
      }
      return l;
    }, r.decodeDelimited = function(n) {
      return n instanceof $Reader || (n = new $Reader(n)), this.decode(n, n.uint32());
    }, r.verify = function(n) {
      if (typeof n != "object" || n === null)
        return "object expected";
      let o = {};
      if (n.nodeName != null && n.hasOwnProperty("nodeName") && !$util.isString(n.nodeName))
        return "nodeName: string expected";
      if (n.leaf != null && n.hasOwnProperty("leaf")) {
        o.node = 1;
        {
          let c = $root.data_room.ComputeNodeLeaf.verify(n.leaf);
          if (c)
            return "leaf." + c;
        }
      }
      if (n.parameter != null && n.hasOwnProperty("parameter")) {
        if (o.node === 1)
          return "node: multiple values";
        o.node = 1;
        {
          let c = $root.data_room.ComputeNodeParameter.verify(n.parameter);
          if (c)
            return "parameter." + c;
        }
      }
      if (n.branch != null && n.hasOwnProperty("branch")) {
        if (o.node === 1)
          return "node: multiple values";
        o.node = 1;
        {
          let c = $root.data_room.ComputeNodeBranch.verify(n.branch);
          if (c)
            return "branch." + c;
        }
      }
      if (n.airlock != null && n.hasOwnProperty("airlock")) {
        if (o.node === 1)
          return "node: multiple values";
        o.node = 1;
        {
          let c = $root.data_room.ComputeNodeAirlock.verify(n.airlock);
          if (c)
            return "airlock." + c;
        }
      }
      if (n.rateLimiting != null && n.hasOwnProperty("rateLimiting")) {
        o._rateLimiting = 1;
        {
          let c = $root.data_room.RateLimitingConfig.verify(n.rateLimiting);
          if (c)
            return "rateLimiting." + c;
        }
      }
      return null;
    }, r.fromObject = function(n) {
      if (n instanceof $root.data_room.ComputeNode)
        return n;
      let o = new $root.data_room.ComputeNode();
      if (n.nodeName != null && (o.nodeName = String(n.nodeName)), n.leaf != null) {
        if (typeof n.leaf != "object")
          throw TypeError(".data_room.ComputeNode.leaf: object expected");
        o.leaf = $root.data_room.ComputeNodeLeaf.fromObject(n.leaf);
      }
      if (n.parameter != null) {
        if (typeof n.parameter != "object")
          throw TypeError(".data_room.ComputeNode.parameter: object expected");
        o.parameter = $root.data_room.ComputeNodeParameter.fromObject(n.parameter);
      }
      if (n.branch != null) {
        if (typeof n.branch != "object")
          throw TypeError(".data_room.ComputeNode.branch: object expected");
        o.branch = $root.data_room.ComputeNodeBranch.fromObject(n.branch);
      }
      if (n.airlock != null) {
        if (typeof n.airlock != "object")
          throw TypeError(".data_room.ComputeNode.airlock: object expected");
        o.airlock = $root.data_room.ComputeNodeAirlock.fromObject(n.airlock);
      }
      if (n.rateLimiting != null) {
        if (typeof n.rateLimiting != "object")
          throw TypeError(".data_room.ComputeNode.rateLimiting: object expected");
        o.rateLimiting = $root.data_room.RateLimitingConfig.fromObject(n.rateLimiting);
      }
      return o;
    }, r.toObject = function(n, o) {
      o || (o = {});
      let c = {};
      return o.defaults && (c.nodeName = ""), n.nodeName != null && n.hasOwnProperty("nodeName") && (c.nodeName = n.nodeName), n.leaf != null && n.hasOwnProperty("leaf") && (c.leaf = $root.data_room.ComputeNodeLeaf.toObject(n.leaf, o), o.oneofs && (c.node = "leaf")), n.branch != null && n.hasOwnProperty("branch") && (c.branch = $root.data_room.ComputeNodeBranch.toObject(n.branch, o), o.oneofs && (c.node = "branch")), n.parameter != null && n.hasOwnProperty("parameter") && (c.parameter = $root.data_room.ComputeNodeParameter.toObject(n.parameter, o), o.oneofs && (c.node = "parameter")), n.rateLimiting != null && n.hasOwnProperty("rateLimiting") && (c.rateLimiting = $root.data_room.RateLimitingConfig.toObject(n.rateLimiting, o), o.oneofs && (c._rateLimiting = "rateLimiting")), n.airlock != null && n.hasOwnProperty("airlock") && (c.airlock = $root.data_room.ComputeNodeAirlock.toObject(n.airlock, o), o.oneofs && (c.node = "airlock")), c;
    }, r.prototype.toJSON = function() {
      return this.constructor.toObject(this, minimal.util.toJSONOptions);
    }, r.getTypeUrl = function(n) {
      return n === void 0 && (n = "type.googleapis.com"), n + "/data_room.ComputeNode";
    }, r;
  }(), u.ComputeNodeLeaf = function() {
    function r(a) {
      if (a)
        for (let e = Object.keys(a), n = 0; n < e.length; ++n)
          a[e[n]] != null && (this[e[n]] = a[e[n]]);
    }
    return r.prototype.isRequired = !1, r.create = function(e) {
      return new r(e);
    }, r.encode = function(e, n) {
      return n || (n = $Writer.create()), e.isRequired != null && Object.hasOwnProperty.call(e, "isRequired") && n.uint32(
        /* id 1, wireType 0 =*/
        8
      ).bool(e.isRequired), n;
    }, r.encodeDelimited = function(e, n) {
      return this.encode(e, n).ldelim();
    }, r.decode = function(e, n) {
      e instanceof $Reader || (e = $Reader.create(e));
      let o = n === void 0 ? e.len : e.pos + n, c = new $root.data_room.ComputeNodeLeaf();
      for (; e.pos < o; ) {
        let l = e.uint32();
        switch (l >>> 3) {
          case 1: {
            c.isRequired = e.bool();
            break;
          }
          default:
            e.skipType(l & 7);
            break;
        }
      }
      return c;
    }, r.decodeDelimited = function(e) {
      return e instanceof $Reader || (e = new $Reader(e)), this.decode(e, e.uint32());
    }, r.verify = function(e) {
      return typeof e != "object" || e === null ? "object expected" : e.isRequired != null && e.hasOwnProperty("isRequired") && typeof e.isRequired != "boolean" ? "isRequired: boolean expected" : null;
    }, r.fromObject = function(e) {
      if (e instanceof $root.data_room.ComputeNodeLeaf)
        return e;
      let n = new $root.data_room.ComputeNodeLeaf();
      return e.isRequired != null && (n.isRequired = !!e.isRequired), n;
    }, r.toObject = function(e, n) {
      n || (n = {});
      let o = {};
      return n.defaults && (o.isRequired = !1), e.isRequired != null && e.hasOwnProperty("isRequired") && (o.isRequired = e.isRequired), o;
    }, r.prototype.toJSON = function() {
      return this.constructor.toObject(this, minimal.util.toJSONOptions);
    }, r.getTypeUrl = function(e) {
      return e === void 0 && (e = "type.googleapis.com"), e + "/data_room.ComputeNodeLeaf";
    }, r;
  }(), u.ComputeNodeParameter = function() {
    function r(a) {
      if (a)
        for (let e = Object.keys(a), n = 0; n < e.length; ++n)
          a[e[n]] != null && (this[e[n]] = a[e[n]]);
    }
    return r.prototype.isRequired = !1, r.create = function(e) {
      return new r(e);
    }, r.encode = function(e, n) {
      return n || (n = $Writer.create()), e.isRequired != null && Object.hasOwnProperty.call(e, "isRequired") && n.uint32(
        /* id 1, wireType 0 =*/
        8
      ).bool(e.isRequired), n;
    }, r.encodeDelimited = function(e, n) {
      return this.encode(e, n).ldelim();
    }, r.decode = function(e, n) {
      e instanceof $Reader || (e = $Reader.create(e));
      let o = n === void 0 ? e.len : e.pos + n, c = new $root.data_room.ComputeNodeParameter();
      for (; e.pos < o; ) {
        let l = e.uint32();
        switch (l >>> 3) {
          case 1: {
            c.isRequired = e.bool();
            break;
          }
          default:
            e.skipType(l & 7);
            break;
        }
      }
      return c;
    }, r.decodeDelimited = function(e) {
      return e instanceof $Reader || (e = new $Reader(e)), this.decode(e, e.uint32());
    }, r.verify = function(e) {
      return typeof e != "object" || e === null ? "object expected" : e.isRequired != null && e.hasOwnProperty("isRequired") && typeof e.isRequired != "boolean" ? "isRequired: boolean expected" : null;
    }, r.fromObject = function(e) {
      if (e instanceof $root.data_room.ComputeNodeParameter)
        return e;
      let n = new $root.data_room.ComputeNodeParameter();
      return e.isRequired != null && (n.isRequired = !!e.isRequired), n;
    }, r.toObject = function(e, n) {
      n || (n = {});
      let o = {};
      return n.defaults && (o.isRequired = !1), e.isRequired != null && e.hasOwnProperty("isRequired") && (o.isRequired = e.isRequired), o;
    }, r.prototype.toJSON = function() {
      return this.constructor.toObject(this, minimal.util.toJSONOptions);
    }, r.getTypeUrl = function(e) {
      return e === void 0 && (e = "type.googleapis.com"), e + "/data_room.ComputeNodeParameter";
    }, r;
  }(), u.ComputeNodeAirlock = function() {
    function r(a) {
      if (a)
        for (let e = Object.keys(a), n = 0; n < e.length; ++n)
          a[e[n]] != null && (this[e[n]] = a[e[n]]);
    }
    return r.prototype.quotaBytes = $util.Long ? $util.Long.fromBits(0, 0, !0) : 0, r.prototype.airlockedDependency = "", r.create = function(e) {
      return new r(e);
    }, r.encode = function(e, n) {
      return n || (n = $Writer.create()), e.quotaBytes != null && Object.hasOwnProperty.call(e, "quotaBytes") && n.uint32(
        /* id 1, wireType 0 =*/
        8
      ).uint64(e.quotaBytes), e.airlockedDependency != null && Object.hasOwnProperty.call(e, "airlockedDependency") && n.uint32(
        /* id 2, wireType 2 =*/
        18
      ).string(e.airlockedDependency), n;
    }, r.encodeDelimited = function(e, n) {
      return this.encode(e, n).ldelim();
    }, r.decode = function(e, n) {
      e instanceof $Reader || (e = $Reader.create(e));
      let o = n === void 0 ? e.len : e.pos + n, c = new $root.data_room.ComputeNodeAirlock();
      for (; e.pos < o; ) {
        let l = e.uint32();
        switch (l >>> 3) {
          case 1: {
            c.quotaBytes = e.uint64();
            break;
          }
          case 2: {
            c.airlockedDependency = e.string();
            break;
          }
          default:
            e.skipType(l & 7);
            break;
        }
      }
      return c;
    }, r.decodeDelimited = function(e) {
      return e instanceof $Reader || (e = new $Reader(e)), this.decode(e, e.uint32());
    }, r.verify = function(e) {
      return typeof e != "object" || e === null ? "object expected" : e.quotaBytes != null && e.hasOwnProperty("quotaBytes") && !$util.isInteger(e.quotaBytes) && !(e.quotaBytes && $util.isInteger(e.quotaBytes.low) && $util.isInteger(e.quotaBytes.high)) ? "quotaBytes: integer|Long expected" : e.airlockedDependency != null && e.hasOwnProperty("airlockedDependency") && !$util.isString(e.airlockedDependency) ? "airlockedDependency: string expected" : null;
    }, r.fromObject = function(e) {
      if (e instanceof $root.data_room.ComputeNodeAirlock)
        return e;
      let n = new $root.data_room.ComputeNodeAirlock();
      return e.quotaBytes != null && ($util.Long ? (n.quotaBytes = $util.Long.fromValue(e.quotaBytes)).unsigned = !0 : typeof e.quotaBytes == "string" ? n.quotaBytes = parseInt(e.quotaBytes, 10) : typeof e.quotaBytes == "number" ? n.quotaBytes = e.quotaBytes : typeof e.quotaBytes == "object" && (n.quotaBytes = new $util.LongBits(e.quotaBytes.low >>> 0, e.quotaBytes.high >>> 0).toNumber(!0))), e.airlockedDependency != null && (n.airlockedDependency = String(e.airlockedDependency)), n;
    }, r.toObject = function(e, n) {
      n || (n = {});
      let o = {};
      if (n.defaults) {
        if ($util.Long) {
          let c = new $util.Long(0, 0, !0);
          o.quotaBytes = n.longs === String ? c.toString() : n.longs === Number ? c.toNumber() : c;
        } else
          o.quotaBytes = n.longs === String ? "0" : 0;
        o.airlockedDependency = "";
      }
      return e.quotaBytes != null && e.hasOwnProperty("quotaBytes") && (typeof e.quotaBytes == "number" ? o.quotaBytes = n.longs === String ? String(e.quotaBytes) : e.quotaBytes : o.quotaBytes = n.longs === String ? $util.Long.prototype.toString.call(e.quotaBytes) : n.longs === Number ? new $util.LongBits(e.quotaBytes.low >>> 0, e.quotaBytes.high >>> 0).toNumber(!0) : e.quotaBytes), e.airlockedDependency != null && e.hasOwnProperty("airlockedDependency") && (o.airlockedDependency = e.airlockedDependency), o;
    }, r.prototype.toJSON = function() {
      return this.constructor.toObject(this, minimal.util.toJSONOptions);
    }, r.getTypeUrl = function(e) {
      return e === void 0 && (e = "type.googleapis.com"), e + "/data_room.ComputeNodeAirlock";
    }, r;
  }(), u.ComputeNodeFormat = function() {
    const r = {}, a = Object.create(r);
    return a[r[0] = "RAW"] = 0, a[r[1] = "ZIP"] = 1, a;
  }(), u.ComputeNodeProtocol = function() {
    function r(a) {
      if (a)
        for (let e = Object.keys(a), n = 0; n < e.length; ++n)
          a[e[n]] != null && (this[e[n]] = a[e[n]]);
    }
    return r.prototype.version = 0, r.create = function(e) {
      return new r(e);
    }, r.encode = function(e, n) {
      return n || (n = $Writer.create()), e.version != null && Object.hasOwnProperty.call(e, "version") && n.uint32(
        /* id 1, wireType 0 =*/
        8
      ).uint32(e.version), n;
    }, r.encodeDelimited = function(e, n) {
      return this.encode(e, n).ldelim();
    }, r.decode = function(e, n) {
      e instanceof $Reader || (e = $Reader.create(e));
      let o = n === void 0 ? e.len : e.pos + n, c = new $root.data_room.ComputeNodeProtocol();
      for (; e.pos < o; ) {
        let l = e.uint32();
        switch (l >>> 3) {
          case 1: {
            c.version = e.uint32();
            break;
          }
          default:
            e.skipType(l & 7);
            break;
        }
      }
      return c;
    }, r.decodeDelimited = function(e) {
      return e instanceof $Reader || (e = new $Reader(e)), this.decode(e, e.uint32());
    }, r.verify = function(e) {
      return typeof e != "object" || e === null ? "object expected" : e.version != null && e.hasOwnProperty("version") && !$util.isInteger(e.version) ? "version: integer expected" : null;
    }, r.fromObject = function(e) {
      if (e instanceof $root.data_room.ComputeNodeProtocol)
        return e;
      let n = new $root.data_room.ComputeNodeProtocol();
      return e.version != null && (n.version = e.version >>> 0), n;
    }, r.toObject = function(e, n) {
      n || (n = {});
      let o = {};
      return n.defaults && (o.version = 0), e.version != null && e.hasOwnProperty("version") && (o.version = e.version), o;
    }, r.prototype.toJSON = function() {
      return this.constructor.toObject(this, minimal.util.toJSONOptions);
    }, r.getTypeUrl = function(e) {
      return e === void 0 && (e = "type.googleapis.com"), e + "/data_room.ComputeNodeProtocol";
    }, r;
  }(), u.ComputeNodeBranch = function() {
    function r(a) {
      if (this.dependencies = [], a)
        for (let e = Object.keys(a), n = 0; n < e.length; ++n)
          a[e[n]] != null && (this[e[n]] = a[e[n]]);
    }
    return r.prototype.config = $util.newBuffer([]), r.prototype.dependencies = $util.emptyArray, r.prototype.outputFormat = 0, r.prototype.protocol = null, r.prototype.attestationSpecificationId = "", r.create = function(e) {
      return new r(e);
    }, r.encode = function(e, n) {
      if (n || (n = $Writer.create()), e.config != null && Object.hasOwnProperty.call(e, "config") && n.uint32(
        /* id 1, wireType 2 =*/
        10
      ).bytes(e.config), e.dependencies != null && e.dependencies.length)
        for (let o = 0; o < e.dependencies.length; ++o)
          n.uint32(
            /* id 2, wireType 2 =*/
            18
          ).string(e.dependencies[o]);
      return e.outputFormat != null && Object.hasOwnProperty.call(e, "outputFormat") && n.uint32(
        /* id 3, wireType 0 =*/
        24
      ).int32(e.outputFormat), e.protocol != null && Object.hasOwnProperty.call(e, "protocol") && $root.data_room.ComputeNodeProtocol.encode(e.protocol, n.uint32(
        /* id 4, wireType 2 =*/
        34
      ).fork()).ldelim(), e.attestationSpecificationId != null && Object.hasOwnProperty.call(e, "attestationSpecificationId") && n.uint32(
        /* id 5, wireType 2 =*/
        42
      ).string(e.attestationSpecificationId), n;
    }, r.encodeDelimited = function(e, n) {
      return this.encode(e, n).ldelim();
    }, r.decode = function(e, n) {
      e instanceof $Reader || (e = $Reader.create(e));
      let o = n === void 0 ? e.len : e.pos + n, c = new $root.data_room.ComputeNodeBranch();
      for (; e.pos < o; ) {
        let l = e.uint32();
        switch (l >>> 3) {
          case 1: {
            c.config = e.bytes();
            break;
          }
          case 2: {
            c.dependencies && c.dependencies.length || (c.dependencies = []), c.dependencies.push(e.string());
            break;
          }
          case 3: {
            c.outputFormat = e.int32();
            break;
          }
          case 4: {
            c.protocol = $root.data_room.ComputeNodeProtocol.decode(e, e.uint32());
            break;
          }
          case 5: {
            c.attestationSpecificationId = e.string();
            break;
          }
          default:
            e.skipType(l & 7);
            break;
        }
      }
      return c;
    }, r.decodeDelimited = function(e) {
      return e instanceof $Reader || (e = new $Reader(e)), this.decode(e, e.uint32());
    }, r.verify = function(e) {
      if (typeof e != "object" || e === null)
        return "object expected";
      if (e.config != null && e.hasOwnProperty("config") && !(e.config && typeof e.config.length == "number" || $util.isString(e.config)))
        return "config: buffer expected";
      if (e.dependencies != null && e.hasOwnProperty("dependencies")) {
        if (!Array.isArray(e.dependencies))
          return "dependencies: array expected";
        for (let n = 0; n < e.dependencies.length; ++n)
          if (!$util.isString(e.dependencies[n]))
            return "dependencies: string[] expected";
      }
      if (e.outputFormat != null && e.hasOwnProperty("outputFormat"))
        switch (e.outputFormat) {
          default:
            return "outputFormat: enum value expected";
          case 0:
          case 1:
            break;
        }
      if (e.protocol != null && e.hasOwnProperty("protocol")) {
        let n = $root.data_room.ComputeNodeProtocol.verify(e.protocol);
        if (n)
          return "protocol." + n;
      }
      return e.attestationSpecificationId != null && e.hasOwnProperty("attestationSpecificationId") && !$util.isString(e.attestationSpecificationId) ? "attestationSpecificationId: string expected" : null;
    }, r.fromObject = function(e) {
      if (e instanceof $root.data_room.ComputeNodeBranch)
        return e;
      let n = new $root.data_room.ComputeNodeBranch();
      if (e.config != null && (typeof e.config == "string" ? $util.base64.decode(e.config, n.config = $util.newBuffer($util.base64.length(e.config)), 0) : e.config.length >= 0 && (n.config = e.config)), e.dependencies) {
        if (!Array.isArray(e.dependencies))
          throw TypeError(".data_room.ComputeNodeBranch.dependencies: array expected");
        n.dependencies = [];
        for (let o = 0; o < e.dependencies.length; ++o)
          n.dependencies[o] = String(e.dependencies[o]);
      }
      switch (e.outputFormat) {
        default:
          if (typeof e.outputFormat == "number") {
            n.outputFormat = e.outputFormat;
            break;
          }
          break;
        case "RAW":
        case 0:
          n.outputFormat = 0;
          break;
        case "ZIP":
        case 1:
          n.outputFormat = 1;
          break;
      }
      if (e.protocol != null) {
        if (typeof e.protocol != "object")
          throw TypeError(".data_room.ComputeNodeBranch.protocol: object expected");
        n.protocol = $root.data_room.ComputeNodeProtocol.fromObject(e.protocol);
      }
      return e.attestationSpecificationId != null && (n.attestationSpecificationId = String(e.attestationSpecificationId)), n;
    }, r.toObject = function(e, n) {
      n || (n = {});
      let o = {};
      if ((n.arrays || n.defaults) && (o.dependencies = []), n.defaults && (n.bytes === String ? o.config = "" : (o.config = [], n.bytes !== Array && (o.config = $util.newBuffer(o.config))), o.outputFormat = n.enums === String ? "RAW" : 0, o.protocol = null, o.attestationSpecificationId = ""), e.config != null && e.hasOwnProperty("config") && (o.config = n.bytes === String ? $util.base64.encode(e.config, 0, e.config.length) : n.bytes === Array ? Array.prototype.slice.call(e.config) : e.config), e.dependencies && e.dependencies.length) {
        o.dependencies = [];
        for (let c = 0; c < e.dependencies.length; ++c)
          o.dependencies[c] = e.dependencies[c];
      }
      return e.outputFormat != null && e.hasOwnProperty("outputFormat") && (o.outputFormat = n.enums === String ? $root.data_room.ComputeNodeFormat[e.outputFormat] === void 0 ? e.outputFormat : $root.data_room.ComputeNodeFormat[e.outputFormat] : e.outputFormat), e.protocol != null && e.hasOwnProperty("protocol") && (o.protocol = $root.data_room.ComputeNodeProtocol.toObject(e.protocol, n)), e.attestationSpecificationId != null && e.hasOwnProperty("attestationSpecificationId") && (o.attestationSpecificationId = e.attestationSpecificationId), o;
    }, r.prototype.toJSON = function() {
      return this.constructor.toObject(this, minimal.util.toJSONOptions);
    }, r.getTypeUrl = function(e) {
      return e === void 0 && (e = "type.googleapis.com"), e + "/data_room.ComputeNodeBranch";
    }, r;
  }(), u.UserPermission = function() {
    function r(a) {
      if (this.permissions = [], a)
        for (let e = Object.keys(a), n = 0; n < e.length; ++n)
          a[e[n]] != null && (this[e[n]] = a[e[n]]);
    }
    return r.prototype.email = "", r.prototype.permissions = $util.emptyArray, r.prototype.authenticationMethodId = "", r.create = function(e) {
      return new r(e);
    }, r.encode = function(e, n) {
      if (n || (n = $Writer.create()), e.email != null && Object.hasOwnProperty.call(e, "email") && n.uint32(
        /* id 1, wireType 2 =*/
        10
      ).string(e.email), e.permissions != null && e.permissions.length)
        for (let o = 0; o < e.permissions.length; ++o)
          $root.data_room.Permission.encode(e.permissions[o], n.uint32(
            /* id 2, wireType 2 =*/
            18
          ).fork()).ldelim();
      return e.authenticationMethodId != null && Object.hasOwnProperty.call(e, "authenticationMethodId") && n.uint32(
        /* id 3, wireType 2 =*/
        26
      ).string(e.authenticationMethodId), n;
    }, r.encodeDelimited = function(e, n) {
      return this.encode(e, n).ldelim();
    }, r.decode = function(e, n) {
      e instanceof $Reader || (e = $Reader.create(e));
      let o = n === void 0 ? e.len : e.pos + n, c = new $root.data_room.UserPermission();
      for (; e.pos < o; ) {
        let l = e.uint32();
        switch (l >>> 3) {
          case 1: {
            c.email = e.string();
            break;
          }
          case 2: {
            c.permissions && c.permissions.length || (c.permissions = []), c.permissions.push($root.data_room.Permission.decode(e, e.uint32()));
            break;
          }
          case 3: {
            c.authenticationMethodId = e.string();
            break;
          }
          default:
            e.skipType(l & 7);
            break;
        }
      }
      return c;
    }, r.decodeDelimited = function(e) {
      return e instanceof $Reader || (e = new $Reader(e)), this.decode(e, e.uint32());
    }, r.verify = function(e) {
      if (typeof e != "object" || e === null)
        return "object expected";
      if (e.email != null && e.hasOwnProperty("email") && !$util.isString(e.email))
        return "email: string expected";
      if (e.permissions != null && e.hasOwnProperty("permissions")) {
        if (!Array.isArray(e.permissions))
          return "permissions: array expected";
        for (let n = 0; n < e.permissions.length; ++n) {
          let o = $root.data_room.Permission.verify(e.permissions[n]);
          if (o)
            return "permissions." + o;
        }
      }
      return e.authenticationMethodId != null && e.hasOwnProperty("authenticationMethodId") && !$util.isString(e.authenticationMethodId) ? "authenticationMethodId: string expected" : null;
    }, r.fromObject = function(e) {
      if (e instanceof $root.data_room.UserPermission)
        return e;
      let n = new $root.data_room.UserPermission();
      if (e.email != null && (n.email = String(e.email)), e.permissions) {
        if (!Array.isArray(e.permissions))
          throw TypeError(".data_room.UserPermission.permissions: array expected");
        n.permissions = [];
        for (let o = 0; o < e.permissions.length; ++o) {
          if (typeof e.permissions[o] != "object")
            throw TypeError(".data_room.UserPermission.permissions: object expected");
          n.permissions[o] = $root.data_room.Permission.fromObject(e.permissions[o]);
        }
      }
      return e.authenticationMethodId != null && (n.authenticationMethodId = String(e.authenticationMethodId)), n;
    }, r.toObject = function(e, n) {
      n || (n = {});
      let o = {};
      if ((n.arrays || n.defaults) && (o.permissions = []), n.defaults && (o.email = "", o.authenticationMethodId = ""), e.email != null && e.hasOwnProperty("email") && (o.email = e.email), e.permissions && e.permissions.length) {
        o.permissions = [];
        for (let c = 0; c < e.permissions.length; ++c)
          o.permissions[c] = $root.data_room.Permission.toObject(e.permissions[c], n);
      }
      return e.authenticationMethodId != null && e.hasOwnProperty("authenticationMethodId") && (o.authenticationMethodId = e.authenticationMethodId), o;
    }, r.prototype.toJSON = function() {
      return this.constructor.toObject(this, minimal.util.toJSONOptions);
    }, r.getTypeUrl = function(e) {
      return e === void 0 && (e = "type.googleapis.com"), e + "/data_room.UserPermission";
    }, r;
  }(), u.AuthenticationMethod = function() {
    function r(a) {
      if (a)
        for (let e = Object.keys(a), n = 0; n < e.length; ++n)
          a[e[n]] != null && (this[e[n]] = a[e[n]]);
    }
    return r.prototype.personalPki = null, r.prototype.dqPki = null, r.prototype.dcrSecret = null, r.create = function(e) {
      return new r(e);
    }, r.encode = function(e, n) {
      return n || (n = $Writer.create()), e.personalPki != null && Object.hasOwnProperty.call(e, "personalPki") && $root.data_room.PkiPolicy.encode(e.personalPki, n.uint32(
        /* id 1, wireType 2 =*/
        10
      ).fork()).ldelim(), e.dqPki != null && Object.hasOwnProperty.call(e, "dqPki") && $root.data_room.PkiPolicy.encode(e.dqPki, n.uint32(
        /* id 2, wireType 2 =*/
        18
      ).fork()).ldelim(), e.dcrSecret != null && Object.hasOwnProperty.call(e, "dcrSecret") && $root.data_room.DcrSecretPolicy.encode(e.dcrSecret, n.uint32(
        /* id 3, wireType 2 =*/
        26
      ).fork()).ldelim(), n;
    }, r.encodeDelimited = function(e, n) {
      return this.encode(e, n).ldelim();
    }, r.decode = function(e, n) {
      e instanceof $Reader || (e = $Reader.create(e));
      let o = n === void 0 ? e.len : e.pos + n, c = new $root.data_room.AuthenticationMethod();
      for (; e.pos < o; ) {
        let l = e.uint32();
        switch (l >>> 3) {
          case 1: {
            c.personalPki = $root.data_room.PkiPolicy.decode(e, e.uint32());
            break;
          }
          case 2: {
            c.dqPki = $root.data_room.PkiPolicy.decode(e, e.uint32());
            break;
          }
          case 3: {
            c.dcrSecret = $root.data_room.DcrSecretPolicy.decode(e, e.uint32());
            break;
          }
          default:
            e.skipType(l & 7);
            break;
        }
      }
      return c;
    }, r.decodeDelimited = function(e) {
      return e instanceof $Reader || (e = new $Reader(e)), this.decode(e, e.uint32());
    }, r.verify = function(e) {
      if (typeof e != "object" || e === null)
        return "object expected";
      if (e.personalPki != null && e.hasOwnProperty("personalPki")) {
        let n = $root.data_room.PkiPolicy.verify(e.personalPki);
        if (n)
          return "personalPki." + n;
      }
      if (e.dqPki != null && e.hasOwnProperty("dqPki")) {
        let n = $root.data_room.PkiPolicy.verify(e.dqPki);
        if (n)
          return "dqPki." + n;
      }
      if (e.dcrSecret != null && e.hasOwnProperty("dcrSecret")) {
        let n = $root.data_room.DcrSecretPolicy.verify(e.dcrSecret);
        if (n)
          return "dcrSecret." + n;
      }
      return null;
    }, r.fromObject = function(e) {
      if (e instanceof $root.data_room.AuthenticationMethod)
        return e;
      let n = new $root.data_room.AuthenticationMethod();
      if (e.personalPki != null) {
        if (typeof e.personalPki != "object")
          throw TypeError(".data_room.AuthenticationMethod.personalPki: object expected");
        n.personalPki = $root.data_room.PkiPolicy.fromObject(e.personalPki);
      }
      if (e.dqPki != null) {
        if (typeof e.dqPki != "object")
          throw TypeError(".data_room.AuthenticationMethod.dqPki: object expected");
        n.dqPki = $root.data_room.PkiPolicy.fromObject(e.dqPki);
      }
      if (e.dcrSecret != null) {
        if (typeof e.dcrSecret != "object")
          throw TypeError(".data_room.AuthenticationMethod.dcrSecret: object expected");
        n.dcrSecret = $root.data_room.DcrSecretPolicy.fromObject(e.dcrSecret);
      }
      return n;
    }, r.toObject = function(e, n) {
      n || (n = {});
      let o = {};
      return n.defaults && (o.personalPki = null, o.dqPki = null, o.dcrSecret = null), e.personalPki != null && e.hasOwnProperty("personalPki") && (o.personalPki = $root.data_room.PkiPolicy.toObject(e.personalPki, n)), e.dqPki != null && e.hasOwnProperty("dqPki") && (o.dqPki = $root.data_room.PkiPolicy.toObject(e.dqPki, n)), e.dcrSecret != null && e.hasOwnProperty("dcrSecret") && (o.dcrSecret = $root.data_room.DcrSecretPolicy.toObject(e.dcrSecret, n)), o;
    }, r.prototype.toJSON = function() {
      return this.constructor.toObject(this, minimal.util.toJSONOptions);
    }, r.getTypeUrl = function(e) {
      return e === void 0 && (e = "type.googleapis.com"), e + "/data_room.AuthenticationMethod";
    }, r;
  }(), u.PkiPolicy = function() {
    function r(a) {
      if (a)
        for (let e = Object.keys(a), n = 0; n < e.length; ++n)
          a[e[n]] != null && (this[e[n]] = a[e[n]]);
    }
    return r.prototype.rootCertificatePem = $util.newBuffer([]), r.create = function(e) {
      return new r(e);
    }, r.encode = function(e, n) {
      return n || (n = $Writer.create()), e.rootCertificatePem != null && Object.hasOwnProperty.call(e, "rootCertificatePem") && n.uint32(
        /* id 1, wireType 2 =*/
        10
      ).bytes(e.rootCertificatePem), n;
    }, r.encodeDelimited = function(e, n) {
      return this.encode(e, n).ldelim();
    }, r.decode = function(e, n) {
      e instanceof $Reader || (e = $Reader.create(e));
      let o = n === void 0 ? e.len : e.pos + n, c = new $root.data_room.PkiPolicy();
      for (; e.pos < o; ) {
        let l = e.uint32();
        switch (l >>> 3) {
          case 1: {
            c.rootCertificatePem = e.bytes();
            break;
          }
          default:
            e.skipType(l & 7);
            break;
        }
      }
      return c;
    }, r.decodeDelimited = function(e) {
      return e instanceof $Reader || (e = new $Reader(e)), this.decode(e, e.uint32());
    }, r.verify = function(e) {
      return typeof e != "object" || e === null ? "object expected" : e.rootCertificatePem != null && e.hasOwnProperty("rootCertificatePem") && !(e.rootCertificatePem && typeof e.rootCertificatePem.length == "number" || $util.isString(e.rootCertificatePem)) ? "rootCertificatePem: buffer expected" : null;
    }, r.fromObject = function(e) {
      if (e instanceof $root.data_room.PkiPolicy)
        return e;
      let n = new $root.data_room.PkiPolicy();
      return e.rootCertificatePem != null && (typeof e.rootCertificatePem == "string" ? $util.base64.decode(e.rootCertificatePem, n.rootCertificatePem = $util.newBuffer($util.base64.length(e.rootCertificatePem)), 0) : e.rootCertificatePem.length >= 0 && (n.rootCertificatePem = e.rootCertificatePem)), n;
    }, r.toObject = function(e, n) {
      n || (n = {});
      let o = {};
      return n.defaults && (n.bytes === String ? o.rootCertificatePem = "" : (o.rootCertificatePem = [], n.bytes !== Array && (o.rootCertificatePem = $util.newBuffer(o.rootCertificatePem)))), e.rootCertificatePem != null && e.hasOwnProperty("rootCertificatePem") && (o.rootCertificatePem = n.bytes === String ? $util.base64.encode(e.rootCertificatePem, 0, e.rootCertificatePem.length) : n.bytes === Array ? Array.prototype.slice.call(e.rootCertificatePem) : e.rootCertificatePem), o;
    }, r.prototype.toJSON = function() {
      return this.constructor.toObject(this, minimal.util.toJSONOptions);
    }, r.getTypeUrl = function(e) {
      return e === void 0 && (e = "type.googleapis.com"), e + "/data_room.PkiPolicy";
    }, r;
  }(), u.DcrSecretPolicy = function() {
    function r(a) {
      if (a)
        for (let e = Object.keys(a), n = 0; n < e.length; ++n)
          a[e[n]] != null && (this[e[n]] = a[e[n]]);
    }
    return r.prototype.dcrSecretId = $util.newBuffer([]), r.create = function(e) {
      return new r(e);
    }, r.encode = function(e, n) {
      return n || (n = $Writer.create()), e.dcrSecretId != null && Object.hasOwnProperty.call(e, "dcrSecretId") && n.uint32(
        /* id 1, wireType 2 =*/
        10
      ).bytes(e.dcrSecretId), n;
    }, r.encodeDelimited = function(e, n) {
      return this.encode(e, n).ldelim();
    }, r.decode = function(e, n) {
      e instanceof $Reader || (e = $Reader.create(e));
      let o = n === void 0 ? e.len : e.pos + n, c = new $root.data_room.DcrSecretPolicy();
      for (; e.pos < o; ) {
        let l = e.uint32();
        switch (l >>> 3) {
          case 1: {
            c.dcrSecretId = e.bytes();
            break;
          }
          default:
            e.skipType(l & 7);
            break;
        }
      }
      return c;
    }, r.decodeDelimited = function(e) {
      return e instanceof $Reader || (e = new $Reader(e)), this.decode(e, e.uint32());
    }, r.verify = function(e) {
      return typeof e != "object" || e === null ? "object expected" : e.dcrSecretId != null && e.hasOwnProperty("dcrSecretId") && !(e.dcrSecretId && typeof e.dcrSecretId.length == "number" || $util.isString(e.dcrSecretId)) ? "dcrSecretId: buffer expected" : null;
    }, r.fromObject = function(e) {
      if (e instanceof $root.data_room.DcrSecretPolicy)
        return e;
      let n = new $root.data_room.DcrSecretPolicy();
      return e.dcrSecretId != null && (typeof e.dcrSecretId == "string" ? $util.base64.decode(e.dcrSecretId, n.dcrSecretId = $util.newBuffer($util.base64.length(e.dcrSecretId)), 0) : e.dcrSecretId.length >= 0 && (n.dcrSecretId = e.dcrSecretId)), n;
    }, r.toObject = function(e, n) {
      n || (n = {});
      let o = {};
      return n.defaults && (n.bytes === String ? o.dcrSecretId = "" : (o.dcrSecretId = [], n.bytes !== Array && (o.dcrSecretId = $util.newBuffer(o.dcrSecretId)))), e.dcrSecretId != null && e.hasOwnProperty("dcrSecretId") && (o.dcrSecretId = n.bytes === String ? $util.base64.encode(e.dcrSecretId, 0, e.dcrSecretId.length) : n.bytes === Array ? Array.prototype.slice.call(e.dcrSecretId) : e.dcrSecretId), o;
    }, r.prototype.toJSON = function() {
      return this.constructor.toObject(this, minimal.util.toJSONOptions);
    }, r.getTypeUrl = function(e) {
      return e === void 0 && (e = "type.googleapis.com"), e + "/data_room.DcrSecretPolicy";
    }, r;
  }(), u.Permission = function() {
    function r(e) {
      if (e)
        for (let n = Object.keys(e), o = 0; o < n.length; ++o)
          e[n[o]] != null && (this[n[o]] = e[n[o]]);
    }
    r.prototype.executeComputePermission = null, r.prototype.leafCrudPermission = null, r.prototype.retrieveDataRoomPermission = null, r.prototype.retrieveAuditLogPermission = null, r.prototype.retrieveDataRoomStatusPermission = null, r.prototype.updateDataRoomStatusPermission = null, r.prototype.retrievePublishedDatasetsPermission = null, r.prototype.dryRunPermission = null, r.prototype.generateMergeSignaturePermission = null, r.prototype.executeDevelopmentComputePermission = null, r.prototype.mergeConfigurationCommitPermission = null, r.prototype.retrieveComputeResultPermission = null, r.prototype.casAuxiliaryStatePermission = null, r.prototype.readAuxiliaryStatePermission = null;
    let a;
    return Object.defineProperty(r.prototype, "permission", {
      get: $util.oneOfGetter(a = ["executeComputePermission", "leafCrudPermission", "retrieveDataRoomPermission", "retrieveAuditLogPermission", "retrieveDataRoomStatusPermission", "updateDataRoomStatusPermission", "retrievePublishedDatasetsPermission", "dryRunPermission", "generateMergeSignaturePermission", "executeDevelopmentComputePermission", "mergeConfigurationCommitPermission", "retrieveComputeResultPermission", "casAuxiliaryStatePermission", "readAuxiliaryStatePermission"]),
      set: $util.oneOfSetter(a)
    }), r.create = function(n) {
      return new r(n);
    }, r.encode = function(n, o) {
      return o || (o = $Writer.create()), n.executeComputePermission != null && Object.hasOwnProperty.call(n, "executeComputePermission") && $root.data_room.ExecuteComputePermission.encode(n.executeComputePermission, o.uint32(
        /* id 1, wireType 2 =*/
        10
      ).fork()).ldelim(), n.leafCrudPermission != null && Object.hasOwnProperty.call(n, "leafCrudPermission") && $root.data_room.LeafCrudPermission.encode(n.leafCrudPermission, o.uint32(
        /* id 2, wireType 2 =*/
        18
      ).fork()).ldelim(), n.retrieveDataRoomPermission != null && Object.hasOwnProperty.call(n, "retrieveDataRoomPermission") && $root.data_room.RetrieveDataRoomPermission.encode(n.retrieveDataRoomPermission, o.uint32(
        /* id 3, wireType 2 =*/
        26
      ).fork()).ldelim(), n.retrieveAuditLogPermission != null && Object.hasOwnProperty.call(n, "retrieveAuditLogPermission") && $root.data_room.RetrieveAuditLogPermission.encode(n.retrieveAuditLogPermission, o.uint32(
        /* id 4, wireType 2 =*/
        34
      ).fork()).ldelim(), n.retrieveDataRoomStatusPermission != null && Object.hasOwnProperty.call(n, "retrieveDataRoomStatusPermission") && $root.data_room.RetrieveDataRoomStatusPermission.encode(n.retrieveDataRoomStatusPermission, o.uint32(
        /* id 5, wireType 2 =*/
        42
      ).fork()).ldelim(), n.updateDataRoomStatusPermission != null && Object.hasOwnProperty.call(n, "updateDataRoomStatusPermission") && $root.data_room.UpdateDataRoomStatusPermission.encode(n.updateDataRoomStatusPermission, o.uint32(
        /* id 6, wireType 2 =*/
        50
      ).fork()).ldelim(), n.retrievePublishedDatasetsPermission != null && Object.hasOwnProperty.call(n, "retrievePublishedDatasetsPermission") && $root.data_room.RetrievePublishedDatasetsPermission.encode(n.retrievePublishedDatasetsPermission, o.uint32(
        /* id 7, wireType 2 =*/
        58
      ).fork()).ldelim(), n.dryRunPermission != null && Object.hasOwnProperty.call(n, "dryRunPermission") && $root.data_room.DryRunPermission.encode(n.dryRunPermission, o.uint32(
        /* id 8, wireType 2 =*/
        66
      ).fork()).ldelim(), n.generateMergeSignaturePermission != null && Object.hasOwnProperty.call(n, "generateMergeSignaturePermission") && $root.data_room.GenerateMergeSignaturePermission.encode(n.generateMergeSignaturePermission, o.uint32(
        /* id 9, wireType 2 =*/
        74
      ).fork()).ldelim(), n.executeDevelopmentComputePermission != null && Object.hasOwnProperty.call(n, "executeDevelopmentComputePermission") && $root.data_room.ExecuteDevelopmentComputePermission.encode(n.executeDevelopmentComputePermission, o.uint32(
        /* id 10, wireType 2 =*/
        82
      ).fork()).ldelim(), n.mergeConfigurationCommitPermission != null && Object.hasOwnProperty.call(n, "mergeConfigurationCommitPermission") && $root.data_room.MergeConfigurationCommitPermission.encode(n.mergeConfigurationCommitPermission, o.uint32(
        /* id 11, wireType 2 =*/
        90
      ).fork()).ldelim(), n.retrieveComputeResultPermission != null && Object.hasOwnProperty.call(n, "retrieveComputeResultPermission") && $root.data_room.RetrieveComputeResultPermission.encode(n.retrieveComputeResultPermission, o.uint32(
        /* id 12, wireType 2 =*/
        98
      ).fork()).ldelim(), n.casAuxiliaryStatePermission != null && Object.hasOwnProperty.call(n, "casAuxiliaryStatePermission") && $root.data_room.CasAuxiliaryStatePermission.encode(n.casAuxiliaryStatePermission, o.uint32(
        /* id 13, wireType 2 =*/
        106
      ).fork()).ldelim(), n.readAuxiliaryStatePermission != null && Object.hasOwnProperty.call(n, "readAuxiliaryStatePermission") && $root.data_room.ReadAuxiliaryStatePermission.encode(n.readAuxiliaryStatePermission, o.uint32(
        /* id 14, wireType 2 =*/
        114
      ).fork()).ldelim(), o;
    }, r.encodeDelimited = function(n, o) {
      return this.encode(n, o).ldelim();
    }, r.decode = function(n, o) {
      n instanceof $Reader || (n = $Reader.create(n));
      let c = o === void 0 ? n.len : n.pos + o, l = new $root.data_room.Permission();
      for (; n.pos < c; ) {
        let d = n.uint32();
        switch (d >>> 3) {
          case 1: {
            l.executeComputePermission = $root.data_room.ExecuteComputePermission.decode(n, n.uint32());
            break;
          }
          case 2: {
            l.leafCrudPermission = $root.data_room.LeafCrudPermission.decode(n, n.uint32());
            break;
          }
          case 3: {
            l.retrieveDataRoomPermission = $root.data_room.RetrieveDataRoomPermission.decode(n, n.uint32());
            break;
          }
          case 4: {
            l.retrieveAuditLogPermission = $root.data_room.RetrieveAuditLogPermission.decode(n, n.uint32());
            break;
          }
          case 5: {
            l.retrieveDataRoomStatusPermission = $root.data_room.RetrieveDataRoomStatusPermission.decode(n, n.uint32());
            break;
          }
          case 6: {
            l.updateDataRoomStatusPermission = $root.data_room.UpdateDataRoomStatusPermission.decode(n, n.uint32());
            break;
          }
          case 7: {
            l.retrievePublishedDatasetsPermission = $root.data_room.RetrievePublishedDatasetsPermission.decode(n, n.uint32());
            break;
          }
          case 8: {
            l.dryRunPermission = $root.data_room.DryRunPermission.decode(n, n.uint32());
            break;
          }
          case 9: {
            l.generateMergeSignaturePermission = $root.data_room.GenerateMergeSignaturePermission.decode(n, n.uint32());
            break;
          }
          case 10: {
            l.executeDevelopmentComputePermission = $root.data_room.ExecuteDevelopmentComputePermission.decode(n, n.uint32());
            break;
          }
          case 11: {
            l.mergeConfigurationCommitPermission = $root.data_room.MergeConfigurationCommitPermission.decode(n, n.uint32());
            break;
          }
          case 12: {
            l.retrieveComputeResultPermission = $root.data_room.RetrieveComputeResultPermission.decode(n, n.uint32());
            break;
          }
          case 13: {
            l.casAuxiliaryStatePermission = $root.data_room.CasAuxiliaryStatePermission.decode(n, n.uint32());
            break;
          }
          case 14: {
            l.readAuxiliaryStatePermission = $root.data_room.ReadAuxiliaryStatePermission.decode(n, n.uint32());
            break;
          }
          default:
            n.skipType(d & 7);
            break;
        }
      }
      return l;
    }, r.decodeDelimited = function(n) {
      return n instanceof $Reader || (n = new $Reader(n)), this.decode(n, n.uint32());
    }, r.verify = function(n) {
      if (typeof n != "object" || n === null)
        return "object expected";
      let o = {};
      if (n.executeComputePermission != null && n.hasOwnProperty("executeComputePermission")) {
        o.permission = 1;
        {
          let c = $root.data_room.ExecuteComputePermission.verify(n.executeComputePermission);
          if (c)
            return "executeComputePermission." + c;
        }
      }
      if (n.leafCrudPermission != null && n.hasOwnProperty("leafCrudPermission")) {
        if (o.permission === 1)
          return "permission: multiple values";
        o.permission = 1;
        {
          let c = $root.data_room.LeafCrudPermission.verify(n.leafCrudPermission);
          if (c)
            return "leafCrudPermission." + c;
        }
      }
      if (n.retrieveDataRoomPermission != null && n.hasOwnProperty("retrieveDataRoomPermission")) {
        if (o.permission === 1)
          return "permission: multiple values";
        o.permission = 1;
        {
          let c = $root.data_room.RetrieveDataRoomPermission.verify(n.retrieveDataRoomPermission);
          if (c)
            return "retrieveDataRoomPermission." + c;
        }
      }
      if (n.retrieveAuditLogPermission != null && n.hasOwnProperty("retrieveAuditLogPermission")) {
        if (o.permission === 1)
          return "permission: multiple values";
        o.permission = 1;
        {
          let c = $root.data_room.RetrieveAuditLogPermission.verify(n.retrieveAuditLogPermission);
          if (c)
            return "retrieveAuditLogPermission." + c;
        }
      }
      if (n.retrieveDataRoomStatusPermission != null && n.hasOwnProperty("retrieveDataRoomStatusPermission")) {
        if (o.permission === 1)
          return "permission: multiple values";
        o.permission = 1;
        {
          let c = $root.data_room.RetrieveDataRoomStatusPermission.verify(n.retrieveDataRoomStatusPermission);
          if (c)
            return "retrieveDataRoomStatusPermission." + c;
        }
      }
      if (n.updateDataRoomStatusPermission != null && n.hasOwnProperty("updateDataRoomStatusPermission")) {
        if (o.permission === 1)
          return "permission: multiple values";
        o.permission = 1;
        {
          let c = $root.data_room.UpdateDataRoomStatusPermission.verify(n.updateDataRoomStatusPermission);
          if (c)
            return "updateDataRoomStatusPermission." + c;
        }
      }
      if (n.retrievePublishedDatasetsPermission != null && n.hasOwnProperty("retrievePublishedDatasetsPermission")) {
        if (o.permission === 1)
          return "permission: multiple values";
        o.permission = 1;
        {
          let c = $root.data_room.RetrievePublishedDatasetsPermission.verify(n.retrievePublishedDatasetsPermission);
          if (c)
            return "retrievePublishedDatasetsPermission." + c;
        }
      }
      if (n.dryRunPermission != null && n.hasOwnProperty("dryRunPermission")) {
        if (o.permission === 1)
          return "permission: multiple values";
        o.permission = 1;
        {
          let c = $root.data_room.DryRunPermission.verify(n.dryRunPermission);
          if (c)
            return "dryRunPermission." + c;
        }
      }
      if (n.generateMergeSignaturePermission != null && n.hasOwnProperty("generateMergeSignaturePermission")) {
        if (o.permission === 1)
          return "permission: multiple values";
        o.permission = 1;
        {
          let c = $root.data_room.GenerateMergeSignaturePermission.verify(n.generateMergeSignaturePermission);
          if (c)
            return "generateMergeSignaturePermission." + c;
        }
      }
      if (n.executeDevelopmentComputePermission != null && n.hasOwnProperty("executeDevelopmentComputePermission")) {
        if (o.permission === 1)
          return "permission: multiple values";
        o.permission = 1;
        {
          let c = $root.data_room.ExecuteDevelopmentComputePermission.verify(n.executeDevelopmentComputePermission);
          if (c)
            return "executeDevelopmentComputePermission." + c;
        }
      }
      if (n.mergeConfigurationCommitPermission != null && n.hasOwnProperty("mergeConfigurationCommitPermission")) {
        if (o.permission === 1)
          return "permission: multiple values";
        o.permission = 1;
        {
          let c = $root.data_room.MergeConfigurationCommitPermission.verify(n.mergeConfigurationCommitPermission);
          if (c)
            return "mergeConfigurationCommitPermission." + c;
        }
      }
      if (n.retrieveComputeResultPermission != null && n.hasOwnProperty("retrieveComputeResultPermission")) {
        if (o.permission === 1)
          return "permission: multiple values";
        o.permission = 1;
        {
          let c = $root.data_room.RetrieveComputeResultPermission.verify(n.retrieveComputeResultPermission);
          if (c)
            return "retrieveComputeResultPermission." + c;
        }
      }
      if (n.casAuxiliaryStatePermission != null && n.hasOwnProperty("casAuxiliaryStatePermission")) {
        if (o.permission === 1)
          return "permission: multiple values";
        o.permission = 1;
        {
          let c = $root.data_room.CasAuxiliaryStatePermission.verify(n.casAuxiliaryStatePermission);
          if (c)
            return "casAuxiliaryStatePermission." + c;
        }
      }
      if (n.readAuxiliaryStatePermission != null && n.hasOwnProperty("readAuxiliaryStatePermission")) {
        if (o.permission === 1)
          return "permission: multiple values";
        o.permission = 1;
        {
          let c = $root.data_room.ReadAuxiliaryStatePermission.verify(n.readAuxiliaryStatePermission);
          if (c)
            return "readAuxiliaryStatePermission." + c;
        }
      }
      return null;
    }, r.fromObject = function(n) {
      if (n instanceof $root.data_room.Permission)
        return n;
      let o = new $root.data_room.Permission();
      if (n.executeComputePermission != null) {
        if (typeof n.executeComputePermission != "object")
          throw TypeError(".data_room.Permission.executeComputePermission: object expected");
        o.executeComputePermission = $root.data_room.ExecuteComputePermission.fromObject(n.executeComputePermission);
      }
      if (n.leafCrudPermission != null) {
        if (typeof n.leafCrudPermission != "object")
          throw TypeError(".data_room.Permission.leafCrudPermission: object expected");
        o.leafCrudPermission = $root.data_room.LeafCrudPermission.fromObject(n.leafCrudPermission);
      }
      if (n.retrieveDataRoomPermission != null) {
        if (typeof n.retrieveDataRoomPermission != "object")
          throw TypeError(".data_room.Permission.retrieveDataRoomPermission: object expected");
        o.retrieveDataRoomPermission = $root.data_room.RetrieveDataRoomPermission.fromObject(n.retrieveDataRoomPermission);
      }
      if (n.retrieveAuditLogPermission != null) {
        if (typeof n.retrieveAuditLogPermission != "object")
          throw TypeError(".data_room.Permission.retrieveAuditLogPermission: object expected");
        o.retrieveAuditLogPermission = $root.data_room.RetrieveAuditLogPermission.fromObject(n.retrieveAuditLogPermission);
      }
      if (n.retrieveDataRoomStatusPermission != null) {
        if (typeof n.retrieveDataRoomStatusPermission != "object")
          throw TypeError(".data_room.Permission.retrieveDataRoomStatusPermission: object expected");
        o.retrieveDataRoomStatusPermission = $root.data_room.RetrieveDataRoomStatusPermission.fromObject(n.retrieveDataRoomStatusPermission);
      }
      if (n.updateDataRoomStatusPermission != null) {
        if (typeof n.updateDataRoomStatusPermission != "object")
          throw TypeError(".data_room.Permission.updateDataRoomStatusPermission: object expected");
        o.updateDataRoomStatusPermission = $root.data_room.UpdateDataRoomStatusPermission.fromObject(n.updateDataRoomStatusPermission);
      }
      if (n.retrievePublishedDatasetsPermission != null) {
        if (typeof n.retrievePublishedDatasetsPermission != "object")
          throw TypeError(".data_room.Permission.retrievePublishedDatasetsPermission: object expected");
        o.retrievePublishedDatasetsPermission = $root.data_room.RetrievePublishedDatasetsPermission.fromObject(n.retrievePublishedDatasetsPermission);
      }
      if (n.dryRunPermission != null) {
        if (typeof n.dryRunPermission != "object")
          throw TypeError(".data_room.Permission.dryRunPermission: object expected");
        o.dryRunPermission = $root.data_room.DryRunPermission.fromObject(n.dryRunPermission);
      }
      if (n.generateMergeSignaturePermission != null) {
        if (typeof n.generateMergeSignaturePermission != "object")
          throw TypeError(".data_room.Permission.generateMergeSignaturePermission: object expected");
        o.generateMergeSignaturePermission = $root.data_room.GenerateMergeSignaturePermission.fromObject(n.generateMergeSignaturePermission);
      }
      if (n.executeDevelopmentComputePermission != null) {
        if (typeof n.executeDevelopmentComputePermission != "object")
          throw TypeError(".data_room.Permission.executeDevelopmentComputePermission: object expected");
        o.executeDevelopmentComputePermission = $root.data_room.ExecuteDevelopmentComputePermission.fromObject(n.executeDevelopmentComputePermission);
      }
      if (n.mergeConfigurationCommitPermission != null) {
        if (typeof n.mergeConfigurationCommitPermission != "object")
          throw TypeError(".data_room.Permission.mergeConfigurationCommitPermission: object expected");
        o.mergeConfigurationCommitPermission = $root.data_room.MergeConfigurationCommitPermission.fromObject(n.mergeConfigurationCommitPermission);
      }
      if (n.retrieveComputeResultPermission != null) {
        if (typeof n.retrieveComputeResultPermission != "object")
          throw TypeError(".data_room.Permission.retrieveComputeResultPermission: object expected");
        o.retrieveComputeResultPermission = $root.data_room.RetrieveComputeResultPermission.fromObject(n.retrieveComputeResultPermission);
      }
      if (n.casAuxiliaryStatePermission != null) {
        if (typeof n.casAuxiliaryStatePermission != "object")
          throw TypeError(".data_room.Permission.casAuxiliaryStatePermission: object expected");
        o.casAuxiliaryStatePermission = $root.data_room.CasAuxiliaryStatePermission.fromObject(n.casAuxiliaryStatePermission);
      }
      if (n.readAuxiliaryStatePermission != null) {
        if (typeof n.readAuxiliaryStatePermission != "object")
          throw TypeError(".data_room.Permission.readAuxiliaryStatePermission: object expected");
        o.readAuxiliaryStatePermission = $root.data_room.ReadAuxiliaryStatePermission.fromObject(n.readAuxiliaryStatePermission);
      }
      return o;
    }, r.toObject = function(n, o) {
      o || (o = {});
      let c = {};
      return n.executeComputePermission != null && n.hasOwnProperty("executeComputePermission") && (c.executeComputePermission = $root.data_room.ExecuteComputePermission.toObject(n.executeComputePermission, o), o.oneofs && (c.permission = "executeComputePermission")), n.leafCrudPermission != null && n.hasOwnProperty("leafCrudPermission") && (c.leafCrudPermission = $root.data_room.LeafCrudPermission.toObject(n.leafCrudPermission, o), o.oneofs && (c.permission = "leafCrudPermission")), n.retrieveDataRoomPermission != null && n.hasOwnProperty("retrieveDataRoomPermission") && (c.retrieveDataRoomPermission = $root.data_room.RetrieveDataRoomPermission.toObject(n.retrieveDataRoomPermission, o), o.oneofs && (c.permission = "retrieveDataRoomPermission")), n.retrieveAuditLogPermission != null && n.hasOwnProperty("retrieveAuditLogPermission") && (c.retrieveAuditLogPermission = $root.data_room.RetrieveAuditLogPermission.toObject(n.retrieveAuditLogPermission, o), o.oneofs && (c.permission = "retrieveAuditLogPermission")), n.retrieveDataRoomStatusPermission != null && n.hasOwnProperty("retrieveDataRoomStatusPermission") && (c.retrieveDataRoomStatusPermission = $root.data_room.RetrieveDataRoomStatusPermission.toObject(n.retrieveDataRoomStatusPermission, o), o.oneofs && (c.permission = "retrieveDataRoomStatusPermission")), n.updateDataRoomStatusPermission != null && n.hasOwnProperty("updateDataRoomStatusPermission") && (c.updateDataRoomStatusPermission = $root.data_room.UpdateDataRoomStatusPermission.toObject(n.updateDataRoomStatusPermission, o), o.oneofs && (c.permission = "updateDataRoomStatusPermission")), n.retrievePublishedDatasetsPermission != null && n.hasOwnProperty("retrievePublishedDatasetsPermission") && (c.retrievePublishedDatasetsPermission = $root.data_room.RetrievePublishedDatasetsPermission.toObject(n.retrievePublishedDatasetsPermission, o), o.oneofs && (c.permission = "retrievePublishedDatasetsPermission")), n.dryRunPermission != null && n.hasOwnProperty("dryRunPermission") && (c.dryRunPermission = $root.data_room.DryRunPermission.toObject(n.dryRunPermission, o), o.oneofs && (c.permission = "dryRunPermission")), n.generateMergeSignaturePermission != null && n.hasOwnProperty("generateMergeSignaturePermission") && (c.generateMergeSignaturePermission = $root.data_room.GenerateMergeSignaturePermission.toObject(n.generateMergeSignaturePermission, o), o.oneofs && (c.permission = "generateMergeSignaturePermission")), n.executeDevelopmentComputePermission != null && n.hasOwnProperty("executeDevelopmentComputePermission") && (c.executeDevelopmentComputePermission = $root.data_room.ExecuteDevelopmentComputePermission.toObject(n.executeDevelopmentComputePermission, o), o.oneofs && (c.permission = "executeDevelopmentComputePermission")), n.mergeConfigurationCommitPermission != null && n.hasOwnProperty("mergeConfigurationCommitPermission") && (c.mergeConfigurationCommitPermission = $root.data_room.MergeConfigurationCommitPermission.toObject(n.mergeConfigurationCommitPermission, o), o.oneofs && (c.permission = "mergeConfigurationCommitPermission")), n.retrieveComputeResultPermission != null && n.hasOwnProperty("retrieveComputeResultPermission") && (c.retrieveComputeResultPermission = $root.data_room.RetrieveComputeResultPermission.toObject(n.retrieveComputeResultPermission, o), o.oneofs && (c.permission = "retrieveComputeResultPermission")), n.casAuxiliaryStatePermission != null && n.hasOwnProperty("casAuxiliaryStatePermission") && (c.casAuxiliaryStatePermission = $root.data_room.CasAuxiliaryStatePermission.toObject(n.casAuxiliaryStatePermission, o), o.oneofs && (c.permission = "casAuxiliaryStatePermission")), n.readAuxiliaryStatePermission != null && n.hasOwnProperty("readAuxiliaryStatePermission") && (c.readAuxiliaryStatePermission = $root.data_room.ReadAuxiliaryStatePermission.toObject(n.readAuxiliaryStatePermission, o), o.oneofs && (c.permission = "readAuxiliaryStatePermission")), c;
    }, r.prototype.toJSON = function() {
      return this.constructor.toObject(this, minimal.util.toJSONOptions);
    }, r.getTypeUrl = function(n) {
      return n === void 0 && (n = "type.googleapis.com"), n + "/data_room.Permission";
    }, r;
  }(), u.ExecuteComputePermission = function() {
    function r(a) {
      if (a)
        for (let e = Object.keys(a), n = 0; n < e.length; ++n)
          a[e[n]] != null && (this[e[n]] = a[e[n]]);
    }
    return r.prototype.computeNodeId = "", r.create = function(e) {
      return new r(e);
    }, r.encode = function(e, n) {
      return n || (n = $Writer.create()), e.computeNodeId != null && Object.hasOwnProperty.call(e, "computeNodeId") && n.uint32(
        /* id 1, wireType 2 =*/
        10
      ).string(e.computeNodeId), n;
    }, r.encodeDelimited = function(e, n) {
      return this.encode(e, n).ldelim();
    }, r.decode = function(e, n) {
      e instanceof $Reader || (e = $Reader.create(e));
      let o = n === void 0 ? e.len : e.pos + n, c = new $root.data_room.ExecuteComputePermission();
      for (; e.pos < o; ) {
        let l = e.uint32();
        switch (l >>> 3) {
          case 1: {
            c.computeNodeId = e.string();
            break;
          }
          default:
            e.skipType(l & 7);
            break;
        }
      }
      return c;
    }, r.decodeDelimited = function(e) {
      return e instanceof $Reader || (e = new $Reader(e)), this.decode(e, e.uint32());
    }, r.verify = function(e) {
      return typeof e != "object" || e === null ? "object expected" : e.computeNodeId != null && e.hasOwnProperty("computeNodeId") && !$util.isString(e.computeNodeId) ? "computeNodeId: string expected" : null;
    }, r.fromObject = function(e) {
      if (e instanceof $root.data_room.ExecuteComputePermission)
        return e;
      let n = new $root.data_room.ExecuteComputePermission();
      return e.computeNodeId != null && (n.computeNodeId = String(e.computeNodeId)), n;
    }, r.toObject = function(e, n) {
      n || (n = {});
      let o = {};
      return n.defaults && (o.computeNodeId = ""), e.computeNodeId != null && e.hasOwnProperty("computeNodeId") && (o.computeNodeId = e.computeNodeId), o;
    }, r.prototype.toJSON = function() {
      return this.constructor.toObject(this, minimal.util.toJSONOptions);
    }, r.getTypeUrl = function(e) {
      return e === void 0 && (e = "type.googleapis.com"), e + "/data_room.ExecuteComputePermission";
    }, r;
  }(), u.LeafCrudPermission = function() {
    function r(a) {
      if (a)
        for (let e = Object.keys(a), n = 0; n < e.length; ++n)
          a[e[n]] != null && (this[e[n]] = a[e[n]]);
    }
    return r.prototype.leafNodeId = "", r.create = function(e) {
      return new r(e);
    }, r.encode = function(e, n) {
      return n || (n = $Writer.create()), e.leafNodeId != null && Object.hasOwnProperty.call(e, "leafNodeId") && n.uint32(
        /* id 1, wireType 2 =*/
        10
      ).string(e.leafNodeId), n;
    }, r.encodeDelimited = function(e, n) {
      return this.encode(e, n).ldelim();
    }, r.decode = function(e, n) {
      e instanceof $Reader || (e = $Reader.create(e));
      let o = n === void 0 ? e.len : e.pos + n, c = new $root.data_room.LeafCrudPermission();
      for (; e.pos < o; ) {
        let l = e.uint32();
        switch (l >>> 3) {
          case 1: {
            c.leafNodeId = e.string();
            break;
          }
          default:
            e.skipType(l & 7);
            break;
        }
      }
      return c;
    }, r.decodeDelimited = function(e) {
      return e instanceof $Reader || (e = new $Reader(e)), this.decode(e, e.uint32());
    }, r.verify = function(e) {
      return typeof e != "object" || e === null ? "object expected" : e.leafNodeId != null && e.hasOwnProperty("leafNodeId") && !$util.isString(e.leafNodeId) ? "leafNodeId: string expected" : null;
    }, r.fromObject = function(e) {
      if (e instanceof $root.data_room.LeafCrudPermission)
        return e;
      let n = new $root.data_room.LeafCrudPermission();
      return e.leafNodeId != null && (n.leafNodeId = String(e.leafNodeId)), n;
    }, r.toObject = function(e, n) {
      n || (n = {});
      let o = {};
      return n.defaults && (o.leafNodeId = ""), e.leafNodeId != null && e.hasOwnProperty("leafNodeId") && (o.leafNodeId = e.leafNodeId), o;
    }, r.prototype.toJSON = function() {
      return this.constructor.toObject(this, minimal.util.toJSONOptions);
    }, r.getTypeUrl = function(e) {
      return e === void 0 && (e = "type.googleapis.com"), e + "/data_room.LeafCrudPermission";
    }, r;
  }(), u.RetrieveDataRoomPermission = function() {
    function r(a) {
      if (a)
        for (let e = Object.keys(a), n = 0; n < e.length; ++n)
          a[e[n]] != null && (this[e[n]] = a[e[n]]);
    }
    return r.create = function(e) {
      return new r(e);
    }, r.encode = function(e, n) {
      return n || (n = $Writer.create()), n;
    }, r.encodeDelimited = function(e, n) {
      return this.encode(e, n).ldelim();
    }, r.decode = function(e, n) {
      e instanceof $Reader || (e = $Reader.create(e));
      let o = n === void 0 ? e.len : e.pos + n, c = new $root.data_room.RetrieveDataRoomPermission();
      for (; e.pos < o; ) {
        let l = e.uint32();
        switch (l >>> 3) {
          default:
            e.skipType(l & 7);
            break;
        }
      }
      return c;
    }, r.decodeDelimited = function(e) {
      return e instanceof $Reader || (e = new $Reader(e)), this.decode(e, e.uint32());
    }, r.verify = function(e) {
      return typeof e != "object" || e === null ? "object expected" : null;
    }, r.fromObject = function(e) {
      return e instanceof $root.data_room.RetrieveDataRoomPermission ? e : new $root.data_room.RetrieveDataRoomPermission();
    }, r.toObject = function() {
      return {};
    }, r.prototype.toJSON = function() {
      return this.constructor.toObject(this, minimal.util.toJSONOptions);
    }, r.getTypeUrl = function(e) {
      return e === void 0 && (e = "type.googleapis.com"), e + "/data_room.RetrieveDataRoomPermission";
    }, r;
  }(), u.RetrieveAuditLogPermission = function() {
    function r(a) {
      if (a)
        for (let e = Object.keys(a), n = 0; n < e.length; ++n)
          a[e[n]] != null && (this[e[n]] = a[e[n]]);
    }
    return r.create = function(e) {
      return new r(e);
    }, r.encode = function(e, n) {
      return n || (n = $Writer.create()), n;
    }, r.encodeDelimited = function(e, n) {
      return this.encode(e, n).ldelim();
    }, r.decode = function(e, n) {
      e instanceof $Reader || (e = $Reader.create(e));
      let o = n === void 0 ? e.len : e.pos + n, c = new $root.data_room.RetrieveAuditLogPermission();
      for (; e.pos < o; ) {
        let l = e.uint32();
        switch (l >>> 3) {
          default:
            e.skipType(l & 7);
            break;
        }
      }
      return c;
    }, r.decodeDelimited = function(e) {
      return e instanceof $Reader || (e = new $Reader(e)), this.decode(e, e.uint32());
    }, r.verify = function(e) {
      return typeof e != "object" || e === null ? "object expected" : null;
    }, r.fromObject = function(e) {
      return e instanceof $root.data_room.RetrieveAuditLogPermission ? e : new $root.data_room.RetrieveAuditLogPermission();
    }, r.toObject = function() {
      return {};
    }, r.prototype.toJSON = function() {
      return this.constructor.toObject(this, minimal.util.toJSONOptions);
    }, r.getTypeUrl = function(e) {
      return e === void 0 && (e = "type.googleapis.com"), e + "/data_room.RetrieveAuditLogPermission";
    }, r;
  }(), u.RetrieveDataRoomStatusPermission = function() {
    function r(a) {
      if (a)
        for (let e = Object.keys(a), n = 0; n < e.length; ++n)
          a[e[n]] != null && (this[e[n]] = a[e[n]]);
    }
    return r.create = function(e) {
      return new r(e);
    }, r.encode = function(e, n) {
      return n || (n = $Writer.create()), n;
    }, r.encodeDelimited = function(e, n) {
      return this.encode(e, n).ldelim();
    }, r.decode = function(e, n) {
      e instanceof $Reader || (e = $Reader.create(e));
      let o = n === void 0 ? e.len : e.pos + n, c = new $root.data_room.RetrieveDataRoomStatusPermission();
      for (; e.pos < o; ) {
        let l = e.uint32();
        switch (l >>> 3) {
          default:
            e.skipType(l & 7);
            break;
        }
      }
      return c;
    }, r.decodeDelimited = function(e) {
      return e instanceof $Reader || (e = new $Reader(e)), this.decode(e, e.uint32());
    }, r.verify = function(e) {
      return typeof e != "object" || e === null ? "object expected" : null;
    }, r.fromObject = function(e) {
      return e instanceof $root.data_room.RetrieveDataRoomStatusPermission ? e : new $root.data_room.RetrieveDataRoomStatusPermission();
    }, r.toObject = function() {
      return {};
    }, r.prototype.toJSON = function() {
      return this.constructor.toObject(this, minimal.util.toJSONOptions);
    }, r.getTypeUrl = function(e) {
      return e === void 0 && (e = "type.googleapis.com"), e + "/data_room.RetrieveDataRoomStatusPermission";
    }, r;
  }(), u.UpdateDataRoomStatusPermission = function() {
    function r(a) {
      if (a)
        for (let e = Object.keys(a), n = 0; n < e.length; ++n)
          a[e[n]] != null && (this[e[n]] = a[e[n]]);
    }
    return r.create = function(e) {
      return new r(e);
    }, r.encode = function(e, n) {
      return n || (n = $Writer.create()), n;
    }, r.encodeDelimited = function(e, n) {
      return this.encode(e, n).ldelim();
    }, r.decode = function(e, n) {
      e instanceof $Reader || (e = $Reader.create(e));
      let o = n === void 0 ? e.len : e.pos + n, c = new $root.data_room.UpdateDataRoomStatusPermission();
      for (; e.pos < o; ) {
        let l = e.uint32();
        switch (l >>> 3) {
          default:
            e.skipType(l & 7);
            break;
        }
      }
      return c;
    }, r.decodeDelimited = function(e) {
      return e instanceof $Reader || (e = new $Reader(e)), this.decode(e, e.uint32());
    }, r.verify = function(e) {
      return typeof e != "object" || e === null ? "object expected" : null;
    }, r.fromObject = function(e) {
      return e instanceof $root.data_room.UpdateDataRoomStatusPermission ? e : new $root.data_room.UpdateDataRoomStatusPermission();
    }, r.toObject = function() {
      return {};
    }, r.prototype.toJSON = function() {
      return this.constructor.toObject(this, minimal.util.toJSONOptions);
    }, r.getTypeUrl = function(e) {
      return e === void 0 && (e = "type.googleapis.com"), e + "/data_room.UpdateDataRoomStatusPermission";
    }, r;
  }(), u.RetrievePublishedDatasetsPermission = function() {
    function r(a) {
      if (a)
        for (let e = Object.keys(a), n = 0; n < e.length; ++n)
          a[e[n]] != null && (this[e[n]] = a[e[n]]);
    }
    return r.create = function(e) {
      return new r(e);
    }, r.encode = function(e, n) {
      return n || (n = $Writer.create()), n;
    }, r.encodeDelimited = function(e, n) {
      return this.encode(e, n).ldelim();
    }, r.decode = function(e, n) {
      e instanceof $Reader || (e = $Reader.create(e));
      let o = n === void 0 ? e.len : e.pos + n, c = new $root.data_room.RetrievePublishedDatasetsPermission();
      for (; e.pos < o; ) {
        let l = e.uint32();
        switch (l >>> 3) {
          default:
            e.skipType(l & 7);
            break;
        }
      }
      return c;
    }, r.decodeDelimited = function(e) {
      return e instanceof $Reader || (e = new $Reader(e)), this.decode(e, e.uint32());
    }, r.verify = function(e) {
      return typeof e != "object" || e === null ? "object expected" : null;
    }, r.fromObject = function(e) {
      return e instanceof $root.data_room.RetrievePublishedDatasetsPermission ? e : new $root.data_room.RetrievePublishedDatasetsPermission();
    }, r.toObject = function() {
      return {};
    }, r.prototype.toJSON = function() {
      return this.constructor.toObject(this, minimal.util.toJSONOptions);
    }, r.getTypeUrl = function(e) {
      return e === void 0 && (e = "type.googleapis.com"), e + "/data_room.RetrievePublishedDatasetsPermission";
    }, r;
  }(), u.DryRunPermission = function() {
    function r(a) {
      if (a)
        for (let e = Object.keys(a), n = 0; n < e.length; ++n)
          a[e[n]] != null && (this[e[n]] = a[e[n]]);
    }
    return r.create = function(e) {
      return new r(e);
    }, r.encode = function(e, n) {
      return n || (n = $Writer.create()), n;
    }, r.encodeDelimited = function(e, n) {
      return this.encode(e, n).ldelim();
    }, r.decode = function(e, n) {
      e instanceof $Reader || (e = $Reader.create(e));
      let o = n === void 0 ? e.len : e.pos + n, c = new $root.data_room.DryRunPermission();
      for (; e.pos < o; ) {
        let l = e.uint32();
        switch (l >>> 3) {
          default:
            e.skipType(l & 7);
            break;
        }
      }
      return c;
    }, r.decodeDelimited = function(e) {
      return e instanceof $Reader || (e = new $Reader(e)), this.decode(e, e.uint32());
    }, r.verify = function(e) {
      return typeof e != "object" || e === null ? "object expected" : null;
    }, r.fromObject = function(e) {
      return e instanceof $root.data_room.DryRunPermission ? e : new $root.data_room.DryRunPermission();
    }, r.toObject = function() {
      return {};
    }, r.prototype.toJSON = function() {
      return this.constructor.toObject(this, minimal.util.toJSONOptions);
    }, r.getTypeUrl = function(e) {
      return e === void 0 && (e = "type.googleapis.com"), e + "/data_room.DryRunPermission";
    }, r;
  }(), u.GenerateMergeSignaturePermission = function() {
    function r(a) {
      if (a)
        for (let e = Object.keys(a), n = 0; n < e.length; ++n)
          a[e[n]] != null && (this[e[n]] = a[e[n]]);
    }
    return r.create = function(e) {
      return new r(e);
    }, r.encode = function(e, n) {
      return n || (n = $Writer.create()), n;
    }, r.encodeDelimited = function(e, n) {
      return this.encode(e, n).ldelim();
    }, r.decode = function(e, n) {
      e instanceof $Reader || (e = $Reader.create(e));
      let o = n === void 0 ? e.len : e.pos + n, c = new $root.data_room.GenerateMergeSignaturePermission();
      for (; e.pos < o; ) {
        let l = e.uint32();
        switch (l >>> 3) {
          default:
            e.skipType(l & 7);
            break;
        }
      }
      return c;
    }, r.decodeDelimited = function(e) {
      return e instanceof $Reader || (e = new $Reader(e)), this.decode(e, e.uint32());
    }, r.verify = function(e) {
      return typeof e != "object" || e === null ? "object expected" : null;
    }, r.fromObject = function(e) {
      return e instanceof $root.data_room.GenerateMergeSignaturePermission ? e : new $root.data_room.GenerateMergeSignaturePermission();
    }, r.toObject = function() {
      return {};
    }, r.prototype.toJSON = function() {
      return this.constructor.toObject(this, minimal.util.toJSONOptions);
    }, r.getTypeUrl = function(e) {
      return e === void 0 && (e = "type.googleapis.com"), e + "/data_room.GenerateMergeSignaturePermission";
    }, r;
  }(), u.ExecuteDevelopmentComputePermission = function() {
    function r(a) {
      if (a)
        for (let e = Object.keys(a), n = 0; n < e.length; ++n)
          a[e[n]] != null && (this[e[n]] = a[e[n]]);
    }
    return r.create = function(e) {
      return new r(e);
    }, r.encode = function(e, n) {
      return n || (n = $Writer.create()), n;
    }, r.encodeDelimited = function(e, n) {
      return this.encode(e, n).ldelim();
    }, r.decode = function(e, n) {
      e instanceof $Reader || (e = $Reader.create(e));
      let o = n === void 0 ? e.len : e.pos + n, c = new $root.data_room.ExecuteDevelopmentComputePermission();
      for (; e.pos < o; ) {
        let l = e.uint32();
        switch (l >>> 3) {
          default:
            e.skipType(l & 7);
            break;
        }
      }
      return c;
    }, r.decodeDelimited = function(e) {
      return e instanceof $Reader || (e = new $Reader(e)), this.decode(e, e.uint32());
    }, r.verify = function(e) {
      return typeof e != "object" || e === null ? "object expected" : null;
    }, r.fromObject = function(e) {
      return e instanceof $root.data_room.ExecuteDevelopmentComputePermission ? e : new $root.data_room.ExecuteDevelopmentComputePermission();
    }, r.toObject = function() {
      return {};
    }, r.prototype.toJSON = function() {
      return this.constructor.toObject(this, minimal.util.toJSONOptions);
    }, r.getTypeUrl = function(e) {
      return e === void 0 && (e = "type.googleapis.com"), e + "/data_room.ExecuteDevelopmentComputePermission";
    }, r;
  }(), u.MergeConfigurationCommitPermission = function() {
    function r(a) {
      if (a)
        for (let e = Object.keys(a), n = 0; n < e.length; ++n)
          a[e[n]] != null && (this[e[n]] = a[e[n]]);
    }
    return r.create = function(e) {
      return new r(e);
    }, r.encode = function(e, n) {
      return n || (n = $Writer.create()), n;
    }, r.encodeDelimited = function(e, n) {
      return this.encode(e, n).ldelim();
    }, r.decode = function(e, n) {
      e instanceof $Reader || (e = $Reader.create(e));
      let o = n === void 0 ? e.len : e.pos + n, c = new $root.data_room.MergeConfigurationCommitPermission();
      for (; e.pos < o; ) {
        let l = e.uint32();
        switch (l >>> 3) {
          default:
            e.skipType(l & 7);
            break;
        }
      }
      return c;
    }, r.decodeDelimited = function(e) {
      return e instanceof $Reader || (e = new $Reader(e)), this.decode(e, e.uint32());
    }, r.verify = function(e) {
      return typeof e != "object" || e === null ? "object expected" : null;
    }, r.fromObject = function(e) {
      return e instanceof $root.data_room.MergeConfigurationCommitPermission ? e : new $root.data_room.MergeConfigurationCommitPermission();
    }, r.toObject = function() {
      return {};
    }, r.prototype.toJSON = function() {
      return this.constructor.toObject(this, minimal.util.toJSONOptions);
    }, r.getTypeUrl = function(e) {
      return e === void 0 && (e = "type.googleapis.com"), e + "/data_room.MergeConfigurationCommitPermission";
    }, r;
  }(), u.RetrieveComputeResultPermission = function() {
    function r(a) {
      if (a)
        for (let e = Object.keys(a), n = 0; n < e.length; ++n)
          a[e[n]] != null && (this[e[n]] = a[e[n]]);
    }
    return r.prototype.computeNodeId = "", r.create = function(e) {
      return new r(e);
    }, r.encode = function(e, n) {
      return n || (n = $Writer.create()), e.computeNodeId != null && Object.hasOwnProperty.call(e, "computeNodeId") && n.uint32(
        /* id 1, wireType 2 =*/
        10
      ).string(e.computeNodeId), n;
    }, r.encodeDelimited = function(e, n) {
      return this.encode(e, n).ldelim();
    }, r.decode = function(e, n) {
      e instanceof $Reader || (e = $Reader.create(e));
      let o = n === void 0 ? e.len : e.pos + n, c = new $root.data_room.RetrieveComputeResultPermission();
      for (; e.pos < o; ) {
        let l = e.uint32();
        switch (l >>> 3) {
          case 1: {
            c.computeNodeId = e.string();
            break;
          }
          default:
            e.skipType(l & 7);
            break;
        }
      }
      return c;
    }, r.decodeDelimited = function(e) {
      return e instanceof $Reader || (e = new $Reader(e)), this.decode(e, e.uint32());
    }, r.verify = function(e) {
      return typeof e != "object" || e === null ? "object expected" : e.computeNodeId != null && e.hasOwnProperty("computeNodeId") && !$util.isString(e.computeNodeId) ? "computeNodeId: string expected" : null;
    }, r.fromObject = function(e) {
      if (e instanceof $root.data_room.RetrieveComputeResultPermission)
        return e;
      let n = new $root.data_room.RetrieveComputeResultPermission();
      return e.computeNodeId != null && (n.computeNodeId = String(e.computeNodeId)), n;
    }, r.toObject = function(e, n) {
      n || (n = {});
      let o = {};
      return n.defaults && (o.computeNodeId = ""), e.computeNodeId != null && e.hasOwnProperty("computeNodeId") && (o.computeNodeId = e.computeNodeId), o;
    }, r.prototype.toJSON = function() {
      return this.constructor.toObject(this, minimal.util.toJSONOptions);
    }, r.getTypeUrl = function(e) {
      return e === void 0 && (e = "type.googleapis.com"), e + "/data_room.RetrieveComputeResultPermission";
    }, r;
  }(), u.CasAuxiliaryStatePermission = function() {
    function r(a) {
      if (a)
        for (let e = Object.keys(a), n = 0; n < e.length; ++n)
          a[e[n]] != null && (this[e[n]] = a[e[n]]);
    }
    return r.create = function(e) {
      return new r(e);
    }, r.encode = function(e, n) {
      return n || (n = $Writer.create()), n;
    }, r.encodeDelimited = function(e, n) {
      return this.encode(e, n).ldelim();
    }, r.decode = function(e, n) {
      e instanceof $Reader || (e = $Reader.create(e));
      let o = n === void 0 ? e.len : e.pos + n, c = new $root.data_room.CasAuxiliaryStatePermission();
      for (; e.pos < o; ) {
        let l = e.uint32();
        switch (l >>> 3) {
          default:
            e.skipType(l & 7);
            break;
        }
      }
      return c;
    }, r.decodeDelimited = function(e) {
      return e instanceof $Reader || (e = new $Reader(e)), this.decode(e, e.uint32());
    }, r.verify = function(e) {
      return typeof e != "object" || e === null ? "object expected" : null;
    }, r.fromObject = function(e) {
      return e instanceof $root.data_room.CasAuxiliaryStatePermission ? e : new $root.data_room.CasAuxiliaryStatePermission();
    }, r.toObject = function() {
      return {};
    }, r.prototype.toJSON = function() {
      return this.constructor.toObject(this, minimal.util.toJSONOptions);
    }, r.getTypeUrl = function(e) {
      return e === void 0 && (e = "type.googleapis.com"), e + "/data_room.CasAuxiliaryStatePermission";
    }, r;
  }(), u.ReadAuxiliaryStatePermission = function() {
    function r(a) {
      if (a)
        for (let e = Object.keys(a), n = 0; n < e.length; ++n)
          a[e[n]] != null && (this[e[n]] = a[e[n]]);
    }
    return r.create = function(e) {
      return new r(e);
    }, r.encode = function(e, n) {
      return n || (n = $Writer.create()), n;
    }, r.encodeDelimited = function(e, n) {
      return this.encode(e, n).ldelim();
    }, r.decode = function(e, n) {
      e instanceof $Reader || (e = $Reader.create(e));
      let o = n === void 0 ? e.len : e.pos + n, c = new $root.data_room.ReadAuxiliaryStatePermission();
      for (; e.pos < o; ) {
        let l = e.uint32();
        switch (l >>> 3) {
          default:
            e.skipType(l & 7);
            break;
        }
      }
      return c;
    }, r.decodeDelimited = function(e) {
      return e instanceof $Reader || (e = new $Reader(e)), this.decode(e, e.uint32());
    }, r.verify = function(e) {
      return typeof e != "object" || e === null ? "object expected" : null;
    }, r.fromObject = function(e) {
      return e instanceof $root.data_room.ReadAuxiliaryStatePermission ? e : new $root.data_room.ReadAuxiliaryStatePermission();
    }, r.toObject = function() {
      return {};
    }, r.prototype.toJSON = function() {
      return this.constructor.toObject(this, minimal.util.toJSONOptions);
    }, r.getTypeUrl = function(e) {
      return e === void 0 && (e = "type.googleapis.com"), e + "/data_room.ReadAuxiliaryStatePermission";
    }, r;
  }(), u;
})();
$root.data_source_s3 = (() => {
  const u = {};
  return u.S3Source = function() {
    function r(a) {
      if (a)
        for (let e = Object.keys(a), n = 0; n < e.length; ++n)
          a[e[n]] != null && (this[e[n]] = a[e[n]]);
    }
    return r.prototype.bucket = "", r.prototype.region = "", r.prototype.objectKey = "", r.create = function(e) {
      return new r(e);
    }, r.encode = function(e, n) {
      return n || (n = $Writer.create()), e.bucket != null && Object.hasOwnProperty.call(e, "bucket") && n.uint32(
        /* id 1, wireType 2 =*/
        10
      ).string(e.bucket), e.region != null && Object.hasOwnProperty.call(e, "region") && n.uint32(
        /* id 2, wireType 2 =*/
        18
      ).string(e.region), e.objectKey != null && Object.hasOwnProperty.call(e, "objectKey") && n.uint32(
        /* id 3, wireType 2 =*/
        26
      ).string(e.objectKey), n;
    }, r.encodeDelimited = function(e, n) {
      return this.encode(e, n).ldelim();
    }, r.decode = function(e, n) {
      e instanceof $Reader || (e = $Reader.create(e));
      let o = n === void 0 ? e.len : e.pos + n, c = new $root.data_source_s3.S3Source();
      for (; e.pos < o; ) {
        let l = e.uint32();
        switch (l >>> 3) {
          case 1: {
            c.bucket = e.string();
            break;
          }
          case 2: {
            c.region = e.string();
            break;
          }
          case 3: {
            c.objectKey = e.string();
            break;
          }
          default:
            e.skipType(l & 7);
            break;
        }
      }
      return c;
    }, r.decodeDelimited = function(e) {
      return e instanceof $Reader || (e = new $Reader(e)), this.decode(e, e.uint32());
    }, r.verify = function(e) {
      return typeof e != "object" || e === null ? "object expected" : e.bucket != null && e.hasOwnProperty("bucket") && !$util.isString(e.bucket) ? "bucket: string expected" : e.region != null && e.hasOwnProperty("region") && !$util.isString(e.region) ? "region: string expected" : e.objectKey != null && e.hasOwnProperty("objectKey") && !$util.isString(e.objectKey) ? "objectKey: string expected" : null;
    }, r.fromObject = function(e) {
      if (e instanceof $root.data_source_s3.S3Source)
        return e;
      let n = new $root.data_source_s3.S3Source();
      return e.bucket != null && (n.bucket = String(e.bucket)), e.region != null && (n.region = String(e.region)), e.objectKey != null && (n.objectKey = String(e.objectKey)), n;
    }, r.toObject = function(e, n) {
      n || (n = {});
      let o = {};
      return n.defaults && (o.bucket = "", o.region = "", o.objectKey = ""), e.bucket != null && e.hasOwnProperty("bucket") && (o.bucket = e.bucket), e.region != null && e.hasOwnProperty("region") && (o.region = e.region), e.objectKey != null && e.hasOwnProperty("objectKey") && (o.objectKey = e.objectKey), o;
    }, r.prototype.toJSON = function() {
      return this.constructor.toObject(this, minimal.util.toJSONOptions);
    }, r.getTypeUrl = function(e) {
      return e === void 0 && (e = "type.googleapis.com"), e + "/data_source_s3.S3Source";
    }, r;
  }(), u.S3Provider = function() {
    const r = {}, a = Object.create(r);
    return a[r[0] = "AWS"] = 0, a[r[1] = "GCS"] = 1, a;
  }(), u.DataSourceS3WorkerConfiguration = function() {
    function r(a) {
      if (a)
        for (let e = Object.keys(a), n = 0; n < e.length; ++n)
          a[e[n]] != null && (this[e[n]] = a[e[n]]);
    }
    return r.prototype.source = null, r.prototype.credentialsDependency = "", r.prototype.s3Provider = 0, r.create = function(e) {
      return new r(e);
    }, r.encode = function(e, n) {
      return n || (n = $Writer.create()), e.source != null && Object.hasOwnProperty.call(e, "source") && $root.data_source_s3.S3Source.encode(e.source, n.uint32(
        /* id 1, wireType 2 =*/
        10
      ).fork()).ldelim(), e.credentialsDependency != null && Object.hasOwnProperty.call(e, "credentialsDependency") && n.uint32(
        /* id 2, wireType 2 =*/
        18
      ).string(e.credentialsDependency), e.s3Provider != null && Object.hasOwnProperty.call(e, "s3Provider") && n.uint32(
        /* id 3, wireType 0 =*/
        24
      ).int32(e.s3Provider), n;
    }, r.encodeDelimited = function(e, n) {
      return this.encode(e, n).ldelim();
    }, r.decode = function(e, n) {
      e instanceof $Reader || (e = $Reader.create(e));
      let o = n === void 0 ? e.len : e.pos + n, c = new $root.data_source_s3.DataSourceS3WorkerConfiguration();
      for (; e.pos < o; ) {
        let l = e.uint32();
        switch (l >>> 3) {
          case 1: {
            c.source = $root.data_source_s3.S3Source.decode(e, e.uint32());
            break;
          }
          case 2: {
            c.credentialsDependency = e.string();
            break;
          }
          case 3: {
            c.s3Provider = e.int32();
            break;
          }
          default:
            e.skipType(l & 7);
            break;
        }
      }
      return c;
    }, r.decodeDelimited = function(e) {
      return e instanceof $Reader || (e = new $Reader(e)), this.decode(e, e.uint32());
    }, r.verify = function(e) {
      if (typeof e != "object" || e === null)
        return "object expected";
      if (e.source != null && e.hasOwnProperty("source")) {
        let n = $root.data_source_s3.S3Source.verify(e.source);
        if (n)
          return "source." + n;
      }
      if (e.credentialsDependency != null && e.hasOwnProperty("credentialsDependency") && !$util.isString(e.credentialsDependency))
        return "credentialsDependency: string expected";
      if (e.s3Provider != null && e.hasOwnProperty("s3Provider"))
        switch (e.s3Provider) {
          default:
            return "s3Provider: enum value expected";
          case 0:
          case 1:
            break;
        }
      return null;
    }, r.fromObject = function(e) {
      if (e instanceof $root.data_source_s3.DataSourceS3WorkerConfiguration)
        return e;
      let n = new $root.data_source_s3.DataSourceS3WorkerConfiguration();
      if (e.source != null) {
        if (typeof e.source != "object")
          throw TypeError(".data_source_s3.DataSourceS3WorkerConfiguration.source: object expected");
        n.source = $root.data_source_s3.S3Source.fromObject(e.source);
      }
      switch (e.credentialsDependency != null && (n.credentialsDependency = String(e.credentialsDependency)), e.s3Provider) {
        default:
          if (typeof e.s3Provider == "number") {
            n.s3Provider = e.s3Provider;
            break;
          }
          break;
        case "AWS":
        case 0:
          n.s3Provider = 0;
          break;
        case "GCS":
        case 1:
          n.s3Provider = 1;
          break;
      }
      return n;
    }, r.toObject = function(e, n) {
      n || (n = {});
      let o = {};
      return n.defaults && (o.source = null, o.credentialsDependency = "", o.s3Provider = n.enums === String ? "AWS" : 0), e.source != null && e.hasOwnProperty("source") && (o.source = $root.data_source_s3.S3Source.toObject(e.source, n)), e.credentialsDependency != null && e.hasOwnProperty("credentialsDependency") && (o.credentialsDependency = e.credentialsDependency), e.s3Provider != null && e.hasOwnProperty("s3Provider") && (o.s3Provider = n.enums === String ? $root.data_source_s3.S3Provider[e.s3Provider] === void 0 ? e.s3Provider : $root.data_source_s3.S3Provider[e.s3Provider] : e.s3Provider), o;
    }, r.prototype.toJSON = function() {
      return this.constructor.toObject(this, minimal.util.toJSONOptions);
    }, r.getTypeUrl = function(e) {
      return e === void 0 && (e = "type.googleapis.com"), e + "/data_source_s3.DataSourceS3WorkerConfiguration";
    }, r;
  }(), u;
})();
$root.data_source_snowflake = (() => {
  const u = {};
  return u.SnowflakeSource = function() {
    function r(a) {
      if (a)
        for (let e = Object.keys(a), n = 0; n < e.length; ++n)
          a[e[n]] != null && (this[e[n]] = a[e[n]]);
    }
    return r.prototype.warehouseName = "", r.prototype.databaseName = "", r.prototype.schemaName = "", r.prototype.tableName = "", r.prototype.stageName = "", r.create = function(e) {
      return new r(e);
    }, r.encode = function(e, n) {
      return n || (n = $Writer.create()), e.warehouseName != null && Object.hasOwnProperty.call(e, "warehouseName") && n.uint32(
        /* id 1, wireType 2 =*/
        10
      ).string(e.warehouseName), e.databaseName != null && Object.hasOwnProperty.call(e, "databaseName") && n.uint32(
        /* id 2, wireType 2 =*/
        18
      ).string(e.databaseName), e.schemaName != null && Object.hasOwnProperty.call(e, "schemaName") && n.uint32(
        /* id 3, wireType 2 =*/
        26
      ).string(e.schemaName), e.tableName != null && Object.hasOwnProperty.call(e, "tableName") && n.uint32(
        /* id 4, wireType 2 =*/
        34
      ).string(e.tableName), e.stageName != null && Object.hasOwnProperty.call(e, "stageName") && n.uint32(
        /* id 5, wireType 2 =*/
        42
      ).string(e.stageName), n;
    }, r.encodeDelimited = function(e, n) {
      return this.encode(e, n).ldelim();
    }, r.decode = function(e, n) {
      e instanceof $Reader || (e = $Reader.create(e));
      let o = n === void 0 ? e.len : e.pos + n, c = new $root.data_source_snowflake.SnowflakeSource();
      for (; e.pos < o; ) {
        let l = e.uint32();
        switch (l >>> 3) {
          case 1: {
            c.warehouseName = e.string();
            break;
          }
          case 2: {
            c.databaseName = e.string();
            break;
          }
          case 3: {
            c.schemaName = e.string();
            break;
          }
          case 4: {
            c.tableName = e.string();
            break;
          }
          case 5: {
            c.stageName = e.string();
            break;
          }
          default:
            e.skipType(l & 7);
            break;
        }
      }
      return c;
    }, r.decodeDelimited = function(e) {
      return e instanceof $Reader || (e = new $Reader(e)), this.decode(e, e.uint32());
    }, r.verify = function(e) {
      return typeof e != "object" || e === null ? "object expected" : e.warehouseName != null && e.hasOwnProperty("warehouseName") && !$util.isString(e.warehouseName) ? "warehouseName: string expected" : e.databaseName != null && e.hasOwnProperty("databaseName") && !$util.isString(e.databaseName) ? "databaseName: string expected" : e.schemaName != null && e.hasOwnProperty("schemaName") && !$util.isString(e.schemaName) ? "schemaName: string expected" : e.tableName != null && e.hasOwnProperty("tableName") && !$util.isString(e.tableName) ? "tableName: string expected" : e.stageName != null && e.hasOwnProperty("stageName") && !$util.isString(e.stageName) ? "stageName: string expected" : null;
    }, r.fromObject = function(e) {
      if (e instanceof $root.data_source_snowflake.SnowflakeSource)
        return e;
      let n = new $root.data_source_snowflake.SnowflakeSource();
      return e.warehouseName != null && (n.warehouseName = String(e.warehouseName)), e.databaseName != null && (n.databaseName = String(e.databaseName)), e.schemaName != null && (n.schemaName = String(e.schemaName)), e.tableName != null && (n.tableName = String(e.tableName)), e.stageName != null && (n.stageName = String(e.stageName)), n;
    }, r.toObject = function(e, n) {
      n || (n = {});
      let o = {};
      return n.defaults && (o.warehouseName = "", o.databaseName = "", o.schemaName = "", o.tableName = "", o.stageName = ""), e.warehouseName != null && e.hasOwnProperty("warehouseName") && (o.warehouseName = e.warehouseName), e.databaseName != null && e.hasOwnProperty("databaseName") && (o.databaseName = e.databaseName), e.schemaName != null && e.hasOwnProperty("schemaName") && (o.schemaName = e.schemaName), e.tableName != null && e.hasOwnProperty("tableName") && (o.tableName = e.tableName), e.stageName != null && e.hasOwnProperty("stageName") && (o.stageName = e.stageName), o;
    }, r.prototype.toJSON = function() {
      return this.constructor.toObject(this, minimal.util.toJSONOptions);
    }, r.getTypeUrl = function(e) {
      return e === void 0 && (e = "type.googleapis.com"), e + "/data_source_snowflake.SnowflakeSource";
    }, r;
  }(), u.DataSourceSnowflakeWorkerConfiguration = function() {
    function r(a) {
      if (a)
        for (let e = Object.keys(a), n = 0; n < e.length; ++n)
          a[e[n]] != null && (this[e[n]] = a[e[n]]);
    }
    return r.prototype.source = null, r.prototype.credentialsDependency = "", r.create = function(e) {
      return new r(e);
    }, r.encode = function(e, n) {
      return n || (n = $Writer.create()), e.source != null && Object.hasOwnProperty.call(e, "source") && $root.data_source_snowflake.SnowflakeSource.encode(e.source, n.uint32(
        /* id 1, wireType 2 =*/
        10
      ).fork()).ldelim(), e.credentialsDependency != null && Object.hasOwnProperty.call(e, "credentialsDependency") && n.uint32(
        /* id 2, wireType 2 =*/
        18
      ).string(e.credentialsDependency), n;
    }, r.encodeDelimited = function(e, n) {
      return this.encode(e, n).ldelim();
    }, r.decode = function(e, n) {
      e instanceof $Reader || (e = $Reader.create(e));
      let o = n === void 0 ? e.len : e.pos + n, c = new $root.data_source_snowflake.DataSourceSnowflakeWorkerConfiguration();
      for (; e.pos < o; ) {
        let l = e.uint32();
        switch (l >>> 3) {
          case 1: {
            c.source = $root.data_source_snowflake.SnowflakeSource.decode(e, e.uint32());
            break;
          }
          case 2: {
            c.credentialsDependency = e.string();
            break;
          }
          default:
            e.skipType(l & 7);
            break;
        }
      }
      return c;
    }, r.decodeDelimited = function(e) {
      return e instanceof $Reader || (e = new $Reader(e)), this.decode(e, e.uint32());
    }, r.verify = function(e) {
      if (typeof e != "object" || e === null)
        return "object expected";
      if (e.source != null && e.hasOwnProperty("source")) {
        let n = $root.data_source_snowflake.SnowflakeSource.verify(e.source);
        if (n)
          return "source." + n;
      }
      return e.credentialsDependency != null && e.hasOwnProperty("credentialsDependency") && !$util.isString(e.credentialsDependency) ? "credentialsDependency: string expected" : null;
    }, r.fromObject = function(e) {
      if (e instanceof $root.data_source_snowflake.DataSourceSnowflakeWorkerConfiguration)
        return e;
      let n = new $root.data_source_snowflake.DataSourceSnowflakeWorkerConfiguration();
      if (e.source != null) {
        if (typeof e.source != "object")
          throw TypeError(".data_source_snowflake.DataSourceSnowflakeWorkerConfiguration.source: object expected");
        n.source = $root.data_source_snowflake.SnowflakeSource.fromObject(e.source);
      }
      return e.credentialsDependency != null && (n.credentialsDependency = String(e.credentialsDependency)), n;
    }, r.toObject = function(e, n) {
      n || (n = {});
      let o = {};
      return n.defaults && (o.source = null, o.credentialsDependency = ""), e.source != null && e.hasOwnProperty("source") && (o.source = $root.data_source_snowflake.SnowflakeSource.toObject(e.source, n)), e.credentialsDependency != null && e.hasOwnProperty("credentialsDependency") && (o.credentialsDependency = e.credentialsDependency), o;
    }, r.prototype.toJSON = function() {
      return this.constructor.toObject(this, minimal.util.toJSONOptions);
    }, r.getTypeUrl = function(e) {
      return e === void 0 && (e = "type.googleapis.com"), e + "/data_source_snowflake.DataSourceSnowflakeWorkerConfiguration";
    }, r;
  }(), u;
})();
$root.dataset_sink = (() => {
  const u = {};
  return u.RawFile = function() {
    function r(a) {
      if (a)
        for (let e = Object.keys(a), n = 0; n < e.length; ++n)
          a[e[n]] != null && (this[e[n]] = a[e[n]]);
    }
    return r.create = function(e) {
      return new r(e);
    }, r.encode = function(e, n) {
      return n || (n = $Writer.create()), n;
    }, r.encodeDelimited = function(e, n) {
      return this.encode(e, n).ldelim();
    }, r.decode = function(e, n) {
      e instanceof $Reader || (e = $Reader.create(e));
      let o = n === void 0 ? e.len : e.pos + n, c = new $root.dataset_sink.RawFile();
      for (; e.pos < o; ) {
        let l = e.uint32();
        switch (l >>> 3) {
          default:
            e.skipType(l & 7);
            break;
        }
      }
      return c;
    }, r.decodeDelimited = function(e) {
      return e instanceof $Reader || (e = new $Reader(e)), this.decode(e, e.uint32());
    }, r.verify = function(e) {
      return typeof e != "object" || e === null ? "object expected" : null;
    }, r.fromObject = function(e) {
      return e instanceof $root.dataset_sink.RawFile ? e : new $root.dataset_sink.RawFile();
    }, r.toObject = function() {
      return {};
    }, r.prototype.toJSON = function() {
      return this.constructor.toObject(this, minimal.util.toJSONOptions);
    }, r.getTypeUrl = function(e) {
      return e === void 0 && (e = "type.googleapis.com"), e + "/dataset_sink.RawFile";
    }, r;
  }(), u.AllFiles = function() {
    function r(a) {
      if (a)
        for (let e = Object.keys(a), n = 0; n < e.length; ++n)
          a[e[n]] != null && (this[e[n]] = a[e[n]]);
    }
    return r.create = function(e) {
      return new r(e);
    }, r.encode = function(e, n) {
      return n || (n = $Writer.create()), n;
    }, r.encodeDelimited = function(e, n) {
      return this.encode(e, n).ldelim();
    }, r.decode = function(e, n) {
      e instanceof $Reader || (e = $Reader.create(e));
      let o = n === void 0 ? e.len : e.pos + n, c = new $root.dataset_sink.AllFiles();
      for (; e.pos < o; ) {
        let l = e.uint32();
        switch (l >>> 3) {
          default:
            e.skipType(l & 7);
            break;
        }
      }
      return c;
    }, r.decodeDelimited = function(e) {
      return e instanceof $Reader || (e = new $Reader(e)), this.decode(e, e.uint32());
    }, r.verify = function(e) {
      return typeof e != "object" || e === null ? "object expected" : null;
    }, r.fromObject = function(e) {
      return e instanceof $root.dataset_sink.AllFiles ? e : new $root.dataset_sink.AllFiles();
    }, r.toObject = function() {
      return {};
    }, r.prototype.toJSON = function() {
      return this.constructor.toObject(this, minimal.util.toJSONOptions);
    }, r.getTypeUrl = function(e) {
      return e === void 0 && (e = "type.googleapis.com"), e + "/dataset_sink.AllFiles";
    }, r;
  }(), u.SingleFile = function() {
    function r(e) {
      if (e)
        for (let n = Object.keys(e), o = 0; o < n.length; ++o)
          e[n[o]] != null && (this[n[o]] = e[n[o]]);
    }
    r.prototype.name = "", r.prototype.renameAs = null;
    let a;
    return Object.defineProperty(r.prototype, "_renameAs", {
      get: $util.oneOfGetter(a = ["renameAs"]),
      set: $util.oneOfSetter(a)
    }), r.create = function(n) {
      return new r(n);
    }, r.encode = function(n, o) {
      return o || (o = $Writer.create()), n.name != null && Object.hasOwnProperty.call(n, "name") && o.uint32(
        /* id 1, wireType 2 =*/
        10
      ).string(n.name), n.renameAs != null && Object.hasOwnProperty.call(n, "renameAs") && o.uint32(
        /* id 2, wireType 2 =*/
        18
      ).string(n.renameAs), o;
    }, r.encodeDelimited = function(n, o) {
      return this.encode(n, o).ldelim();
    }, r.decode = function(n, o) {
      n instanceof $Reader || (n = $Reader.create(n));
      let c = o === void 0 ? n.len : n.pos + o, l = new $root.dataset_sink.SingleFile();
      for (; n.pos < c; ) {
        let d = n.uint32();
        switch (d >>> 3) {
          case 1: {
            l.name = n.string();
            break;
          }
          case 2: {
            l.renameAs = n.string();
            break;
          }
          default:
            n.skipType(d & 7);
            break;
        }
      }
      return l;
    }, r.decodeDelimited = function(n) {
      return n instanceof $Reader || (n = new $Reader(n)), this.decode(n, n.uint32());
    }, r.verify = function(n) {
      return typeof n != "object" || n === null ? "object expected" : n.name != null && n.hasOwnProperty("name") && !$util.isString(n.name) ? "name: string expected" : n.renameAs != null && n.hasOwnProperty("renameAs") && !$util.isString(n.renameAs) ? "renameAs: string expected" : null;
    }, r.fromObject = function(n) {
      if (n instanceof $root.dataset_sink.SingleFile)
        return n;
      let o = new $root.dataset_sink.SingleFile();
      return n.name != null && (o.name = String(n.name)), n.renameAs != null && (o.renameAs = String(n.renameAs)), o;
    }, r.toObject = function(n, o) {
      o || (o = {});
      let c = {};
      return o.defaults && (c.name = ""), n.name != null && n.hasOwnProperty("name") && (c.name = n.name), n.renameAs != null && n.hasOwnProperty("renameAs") && (c.renameAs = n.renameAs, o.oneofs && (c._renameAs = "renameAs")), c;
    }, r.prototype.toJSON = function() {
      return this.constructor.toObject(this, minimal.util.toJSONOptions);
    }, r.getTypeUrl = function(n) {
      return n === void 0 && (n = "type.googleapis.com"), n + "/dataset_sink.SingleFile";
    }, r;
  }(), u.FileSelection = function() {
    function r(a) {
      if (this.names = [], a)
        for (let e = Object.keys(a), n = 0; n < e.length; ++n)
          a[e[n]] != null && (this[e[n]] = a[e[n]]);
    }
    return r.prototype.names = $util.emptyArray, r.create = function(e) {
      return new r(e);
    }, r.encode = function(e, n) {
      if (n || (n = $Writer.create()), e.names != null && e.names.length)
        for (let o = 0; o < e.names.length; ++o)
          $root.dataset_sink.SingleFile.encode(e.names[o], n.uint32(
            /* id 1, wireType 2 =*/
            10
          ).fork()).ldelim();
      return n;
    }, r.encodeDelimited = function(e, n) {
      return this.encode(e, n).ldelim();
    }, r.decode = function(e, n) {
      e instanceof $Reader || (e = $Reader.create(e));
      let o = n === void 0 ? e.len : e.pos + n, c = new $root.dataset_sink.FileSelection();
      for (; e.pos < o; ) {
        let l = e.uint32();
        switch (l >>> 3) {
          case 1: {
            c.names && c.names.length || (c.names = []), c.names.push($root.dataset_sink.SingleFile.decode(e, e.uint32()));
            break;
          }
          default:
            e.skipType(l & 7);
            break;
        }
      }
      return c;
    }, r.decodeDelimited = function(e) {
      return e instanceof $Reader || (e = new $Reader(e)), this.decode(e, e.uint32());
    }, r.verify = function(e) {
      if (typeof e != "object" || e === null)
        return "object expected";
      if (e.names != null && e.hasOwnProperty("names")) {
        if (!Array.isArray(e.names))
          return "names: array expected";
        for (let n = 0; n < e.names.length; ++n) {
          let o = $root.dataset_sink.SingleFile.verify(e.names[n]);
          if (o)
            return "names." + o;
        }
      }
      return null;
    }, r.fromObject = function(e) {
      if (e instanceof $root.dataset_sink.FileSelection)
        return e;
      let n = new $root.dataset_sink.FileSelection();
      if (e.names) {
        if (!Array.isArray(e.names))
          throw TypeError(".dataset_sink.FileSelection.names: array expected");
        n.names = [];
        for (let o = 0; o < e.names.length; ++o) {
          if (typeof e.names[o] != "object")
            throw TypeError(".dataset_sink.FileSelection.names: object expected");
          n.names[o] = $root.dataset_sink.SingleFile.fromObject(e.names[o]);
        }
      }
      return n;
    }, r.toObject = function(e, n) {
      n || (n = {});
      let o = {};
      if ((n.arrays || n.defaults) && (o.names = []), e.names && e.names.length) {
        o.names = [];
        for (let c = 0; c < e.names.length; ++c)
          o.names[c] = $root.dataset_sink.SingleFile.toObject(e.names[c], n);
      }
      return o;
    }, r.prototype.toJSON = function() {
      return this.constructor.toObject(this, minimal.util.toJSONOptions);
    }, r.getTypeUrl = function(e) {
      return e === void 0 && (e = "type.googleapis.com"), e + "/dataset_sink.FileSelection";
    }, r;
  }(), u.ZipFile = function() {
    function r(e) {
      if (e)
        for (let n = Object.keys(e), o = 0; o < n.length; ++o)
          e[n[o]] != null && (this[n[o]] = e[n[o]]);
    }
    r.prototype.all = null, r.prototype.files = null;
    let a;
    return Object.defineProperty(r.prototype, "selection", {
      get: $util.oneOfGetter(a = ["all", "files"]),
      set: $util.oneOfSetter(a)
    }), r.create = function(n) {
      return new r(n);
    }, r.encode = function(n, o) {
      return o || (o = $Writer.create()), n.all != null && Object.hasOwnProperty.call(n, "all") && $root.dataset_sink.AllFiles.encode(n.all, o.uint32(
        /* id 1, wireType 2 =*/
        10
      ).fork()).ldelim(), n.files != null && Object.hasOwnProperty.call(n, "files") && $root.dataset_sink.FileSelection.encode(n.files, o.uint32(
        /* id 2, wireType 2 =*/
        18
      ).fork()).ldelim(), o;
    }, r.encodeDelimited = function(n, o) {
      return this.encode(n, o).ldelim();
    }, r.decode = function(n, o) {
      n instanceof $Reader || (n = $Reader.create(n));
      let c = o === void 0 ? n.len : n.pos + o, l = new $root.dataset_sink.ZipFile();
      for (; n.pos < c; ) {
        let d = n.uint32();
        switch (d >>> 3) {
          case 1: {
            l.all = $root.dataset_sink.AllFiles.decode(n, n.uint32());
            break;
          }
          case 2: {
            l.files = $root.dataset_sink.FileSelection.decode(n, n.uint32());
            break;
          }
          default:
            n.skipType(d & 7);
            break;
        }
      }
      return l;
    }, r.decodeDelimited = function(n) {
      return n instanceof $Reader || (n = new $Reader(n)), this.decode(n, n.uint32());
    }, r.verify = function(n) {
      if (typeof n != "object" || n === null)
        return "object expected";
      let o = {};
      if (n.all != null && n.hasOwnProperty("all")) {
        o.selection = 1;
        {
          let c = $root.dataset_sink.AllFiles.verify(n.all);
          if (c)
            return "all." + c;
        }
      }
      if (n.files != null && n.hasOwnProperty("files")) {
        if (o.selection === 1)
          return "selection: multiple values";
        o.selection = 1;
        {
          let c = $root.dataset_sink.FileSelection.verify(n.files);
          if (c)
            return "files." + c;
        }
      }
      return null;
    }, r.fromObject = function(n) {
      if (n instanceof $root.dataset_sink.ZipFile)
        return n;
      let o = new $root.dataset_sink.ZipFile();
      if (n.all != null) {
        if (typeof n.all != "object")
          throw TypeError(".dataset_sink.ZipFile.all: object expected");
        o.all = $root.dataset_sink.AllFiles.fromObject(n.all);
      }
      if (n.files != null) {
        if (typeof n.files != "object")
          throw TypeError(".dataset_sink.ZipFile.files: object expected");
        o.files = $root.dataset_sink.FileSelection.fromObject(n.files);
      }
      return o;
    }, r.toObject = function(n, o) {
      o || (o = {});
      let c = {};
      return n.all != null && n.hasOwnProperty("all") && (c.all = $root.dataset_sink.AllFiles.toObject(n.all, o), o.oneofs && (c.selection = "all")), n.files != null && n.hasOwnProperty("files") && (c.files = $root.dataset_sink.FileSelection.toObject(n.files, o), o.oneofs && (c.selection = "files")), c;
    }, r.prototype.toJSON = function() {
      return this.constructor.toObject(this, minimal.util.toJSONOptions);
    }, r.getTypeUrl = function(n) {
      return n === void 0 && (n = "type.googleapis.com"), n + "/dataset_sink.ZipFile";
    }, r;
  }(), u.SinkInput = function() {
    function r(e) {
      if (e)
        for (let n = Object.keys(e), o = 0; o < n.length; ++o)
          e[n[o]] != null && (this[n[o]] = e[n[o]]);
    }
    r.prototype.dependency = "", r.prototype.name = "", r.prototype.raw = null, r.prototype.zip = null;
    let a;
    return Object.defineProperty(r.prototype, "file", {
      get: $util.oneOfGetter(a = ["raw", "zip"]),
      set: $util.oneOfSetter(a)
    }), r.create = function(n) {
      return new r(n);
    }, r.encode = function(n, o) {
      return o || (o = $Writer.create()), n.dependency != null && Object.hasOwnProperty.call(n, "dependency") && o.uint32(
        /* id 1, wireType 2 =*/
        10
      ).string(n.dependency), n.name != null && Object.hasOwnProperty.call(n, "name") && o.uint32(
        /* id 2, wireType 2 =*/
        18
      ).string(n.name), n.raw != null && Object.hasOwnProperty.call(n, "raw") && $root.dataset_sink.RawFile.encode(n.raw, o.uint32(
        /* id 3, wireType 2 =*/
        26
      ).fork()).ldelim(), n.zip != null && Object.hasOwnProperty.call(n, "zip") && $root.dataset_sink.ZipFile.encode(n.zip, o.uint32(
        /* id 4, wireType 2 =*/
        34
      ).fork()).ldelim(), o;
    }, r.encodeDelimited = function(n, o) {
      return this.encode(n, o).ldelim();
    }, r.decode = function(n, o) {
      n instanceof $Reader || (n = $Reader.create(n));
      let c = o === void 0 ? n.len : n.pos + o, l = new $root.dataset_sink.SinkInput();
      for (; n.pos < c; ) {
        let d = n.uint32();
        switch (d >>> 3) {
          case 1: {
            l.dependency = n.string();
            break;
          }
          case 2: {
            l.name = n.string();
            break;
          }
          case 3: {
            l.raw = $root.dataset_sink.RawFile.decode(n, n.uint32());
            break;
          }
          case 4: {
            l.zip = $root.dataset_sink.ZipFile.decode(n, n.uint32());
            break;
          }
          default:
            n.skipType(d & 7);
            break;
        }
      }
      return l;
    }, r.decodeDelimited = function(n) {
      return n instanceof $Reader || (n = new $Reader(n)), this.decode(n, n.uint32());
    }, r.verify = function(n) {
      if (typeof n != "object" || n === null)
        return "object expected";
      let o = {};
      if (n.dependency != null && n.hasOwnProperty("dependency") && !$util.isString(n.dependency))
        return "dependency: string expected";
      if (n.name != null && n.hasOwnProperty("name") && !$util.isString(n.name))
        return "name: string expected";
      if (n.raw != null && n.hasOwnProperty("raw")) {
        o.file = 1;
        {
          let c = $root.dataset_sink.RawFile.verify(n.raw);
          if (c)
            return "raw." + c;
        }
      }
      if (n.zip != null && n.hasOwnProperty("zip")) {
        if (o.file === 1)
          return "file: multiple values";
        o.file = 1;
        {
          let c = $root.dataset_sink.ZipFile.verify(n.zip);
          if (c)
            return "zip." + c;
        }
      }
      return null;
    }, r.fromObject = function(n) {
      if (n instanceof $root.dataset_sink.SinkInput)
        return n;
      let o = new $root.dataset_sink.SinkInput();
      if (n.dependency != null && (o.dependency = String(n.dependency)), n.name != null && (o.name = String(n.name)), n.raw != null) {
        if (typeof n.raw != "object")
          throw TypeError(".dataset_sink.SinkInput.raw: object expected");
        o.raw = $root.dataset_sink.RawFile.fromObject(n.raw);
      }
      if (n.zip != null) {
        if (typeof n.zip != "object")
          throw TypeError(".dataset_sink.SinkInput.zip: object expected");
        o.zip = $root.dataset_sink.ZipFile.fromObject(n.zip);
      }
      return o;
    }, r.toObject = function(n, o) {
      o || (o = {});
      let c = {};
      return o.defaults && (c.dependency = "", c.name = ""), n.dependency != null && n.hasOwnProperty("dependency") && (c.dependency = n.dependency), n.name != null && n.hasOwnProperty("name") && (c.name = n.name), n.raw != null && n.hasOwnProperty("raw") && (c.raw = $root.dataset_sink.RawFile.toObject(n.raw, o), o.oneofs && (c.file = "raw")), n.zip != null && n.hasOwnProperty("zip") && (c.zip = $root.dataset_sink.ZipFile.toObject(n.zip, o), o.oneofs && (c.file = "zip")), c;
    }, r.prototype.toJSON = function() {
      return this.constructor.toObject(this, minimal.util.toJSONOptions);
    }, r.getTypeUrl = function(n) {
      return n === void 0 && (n = "type.googleapis.com"), n + "/dataset_sink.SinkInput";
    }, r;
  }(), u.DatasetSinkWorkerConfiguration = function() {
    function r(e) {
      if (this.inputs = [], e)
        for (let n = Object.keys(e), o = 0; o < n.length; ++o)
          e[n[o]] != null && (this[n[o]] = e[n[o]]);
    }
    r.prototype.inputs = $util.emptyArray, r.prototype.encryptionKeyDependency = "", r.prototype.datasetImportId = null, r.prototype.isKeyHexEncoded = !1;
    let a;
    return Object.defineProperty(r.prototype, "_datasetImportId", {
      get: $util.oneOfGetter(a = ["datasetImportId"]),
      set: $util.oneOfSetter(a)
    }), r.create = function(n) {
      return new r(n);
    }, r.encode = function(n, o) {
      if (o || (o = $Writer.create()), n.inputs != null && n.inputs.length)
        for (let c = 0; c < n.inputs.length; ++c)
          $root.dataset_sink.SinkInput.encode(n.inputs[c], o.uint32(
            /* id 1, wireType 2 =*/
            10
          ).fork()).ldelim();
      return n.encryptionKeyDependency != null && Object.hasOwnProperty.call(n, "encryptionKeyDependency") && o.uint32(
        /* id 2, wireType 2 =*/
        18
      ).string(n.encryptionKeyDependency), n.datasetImportId != null && Object.hasOwnProperty.call(n, "datasetImportId") && o.uint32(
        /* id 3, wireType 2 =*/
        26
      ).string(n.datasetImportId), n.isKeyHexEncoded != null && Object.hasOwnProperty.call(n, "isKeyHexEncoded") && o.uint32(
        /* id 4, wireType 0 =*/
        32
      ).bool(n.isKeyHexEncoded), o;
    }, r.encodeDelimited = function(n, o) {
      return this.encode(n, o).ldelim();
    }, r.decode = function(n, o) {
      n instanceof $Reader || (n = $Reader.create(n));
      let c = o === void 0 ? n.len : n.pos + o, l = new $root.dataset_sink.DatasetSinkWorkerConfiguration();
      for (; n.pos < c; ) {
        let d = n.uint32();
        switch (d >>> 3) {
          case 1: {
            l.inputs && l.inputs.length || (l.inputs = []), l.inputs.push($root.dataset_sink.SinkInput.decode(n, n.uint32()));
            break;
          }
          case 2: {
            l.encryptionKeyDependency = n.string();
            break;
          }
          case 3: {
            l.datasetImportId = n.string();
            break;
          }
          case 4: {
            l.isKeyHexEncoded = n.bool();
            break;
          }
          default:
            n.skipType(d & 7);
            break;
        }
      }
      return l;
    }, r.decodeDelimited = function(n) {
      return n instanceof $Reader || (n = new $Reader(n)), this.decode(n, n.uint32());
    }, r.verify = function(n) {
      if (typeof n != "object" || n === null)
        return "object expected";
      if (n.inputs != null && n.hasOwnProperty("inputs")) {
        if (!Array.isArray(n.inputs))
          return "inputs: array expected";
        for (let o = 0; o < n.inputs.length; ++o) {
          let c = $root.dataset_sink.SinkInput.verify(n.inputs[o]);
          if (c)
            return "inputs." + c;
        }
      }
      return n.encryptionKeyDependency != null && n.hasOwnProperty("encryptionKeyDependency") && !$util.isString(n.encryptionKeyDependency) ? "encryptionKeyDependency: string expected" : n.datasetImportId != null && n.hasOwnProperty("datasetImportId") && !$util.isString(n.datasetImportId) ? "datasetImportId: string expected" : n.isKeyHexEncoded != null && n.hasOwnProperty("isKeyHexEncoded") && typeof n.isKeyHexEncoded != "boolean" ? "isKeyHexEncoded: boolean expected" : null;
    }, r.fromObject = function(n) {
      if (n instanceof $root.dataset_sink.DatasetSinkWorkerConfiguration)
        return n;
      let o = new $root.dataset_sink.DatasetSinkWorkerConfiguration();
      if (n.inputs) {
        if (!Array.isArray(n.inputs))
          throw TypeError(".dataset_sink.DatasetSinkWorkerConfiguration.inputs: array expected");
        o.inputs = [];
        for (let c = 0; c < n.inputs.length; ++c) {
          if (typeof n.inputs[c] != "object")
            throw TypeError(".dataset_sink.DatasetSinkWorkerConfiguration.inputs: object expected");
          o.inputs[c] = $root.dataset_sink.SinkInput.fromObject(n.inputs[c]);
        }
      }
      return n.encryptionKeyDependency != null && (o.encryptionKeyDependency = String(n.encryptionKeyDependency)), n.datasetImportId != null && (o.datasetImportId = String(n.datasetImportId)), n.isKeyHexEncoded != null && (o.isKeyHexEncoded = !!n.isKeyHexEncoded), o;
    }, r.toObject = function(n, o) {
      o || (o = {});
      let c = {};
      if ((o.arrays || o.defaults) && (c.inputs = []), o.defaults && (c.encryptionKeyDependency = "", c.isKeyHexEncoded = !1), n.inputs && n.inputs.length) {
        c.inputs = [];
        for (let l = 0; l < n.inputs.length; ++l)
          c.inputs[l] = $root.dataset_sink.SinkInput.toObject(n.inputs[l], o);
      }
      return n.encryptionKeyDependency != null && n.hasOwnProperty("encryptionKeyDependency") && (c.encryptionKeyDependency = n.encryptionKeyDependency), n.datasetImportId != null && n.hasOwnProperty("datasetImportId") && (c.datasetImportId = n.datasetImportId, o.oneofs && (c._datasetImportId = "datasetImportId")), n.isKeyHexEncoded != null && n.hasOwnProperty("isKeyHexEncoded") && (c.isKeyHexEncoded = n.isKeyHexEncoded), c;
    }, r.prototype.toJSON = function() {
      return this.constructor.toObject(this, minimal.util.toJSONOptions);
    }, r.getTypeUrl = function(n) {
      return n === void 0 && (n = "type.googleapis.com"), n + "/dataset_sink.DatasetSinkWorkerConfiguration";
    }, r;
  }(), u;
})();
$root.delta_enclave_api = (() => {
  const u = {};
  return u.Request = function() {
    function r(e) {
      if (e)
        for (let n = Object.keys(e), o = 0; o < n.length; ++o)
          e[n[o]] != null && (this[n[o]] = e[n[o]]);
    }
    r.prototype.deltaRequest = null, r.prototype.extensionMessage = null, r.prototype.deltaRequestV2 = null;
    let a;
    return Object.defineProperty(r.prototype, "request", {
      get: $util.oneOfGetter(a = ["deltaRequest", "extensionMessage", "deltaRequestV2"]),
      set: $util.oneOfSetter(a)
    }), r.create = function(n) {
      return new r(n);
    }, r.encode = function(n, o) {
      return o || (o = $Writer.create()), n.deltaRequest != null && Object.hasOwnProperty.call(n, "deltaRequest") && $root.delta_enclave_api.DataNoncePubkey.encode(n.deltaRequest, o.uint32(
        /* id 1, wireType 2 =*/
        10
      ).fork()).ldelim(), n.extensionMessage != null && Object.hasOwnProperty.call(n, "extensionMessage") && $root.delta_enclave_api.ExtensionMessage.encode(n.extensionMessage, o.uint32(
        /* id 2, wireType 2 =*/
        18
      ).fork()).ldelim(), n.deltaRequestV2 != null && Object.hasOwnProperty.call(n, "deltaRequestV2") && $root.delta_enclave_api.DataNoncePubkey.encode(n.deltaRequestV2, o.uint32(
        /* id 3, wireType 2 =*/
        26
      ).fork()).ldelim(), o;
    }, r.encodeDelimited = function(n, o) {
      return this.encode(n, o).ldelim();
    }, r.decode = function(n, o) {
      n instanceof $Reader || (n = $Reader.create(n));
      let c = o === void 0 ? n.len : n.pos + o, l = new $root.delta_enclave_api.Request();
      for (; n.pos < c; ) {
        let d = n.uint32();
        switch (d >>> 3) {
          case 1: {
            l.deltaRequest = $root.delta_enclave_api.DataNoncePubkey.decode(n, n.uint32());
            break;
          }
          case 2: {
            l.extensionMessage = $root.delta_enclave_api.ExtensionMessage.decode(n, n.uint32());
            break;
          }
          case 3: {
            l.deltaRequestV2 = $root.delta_enclave_api.DataNoncePubkey.decode(n, n.uint32());
            break;
          }
          default:
            n.skipType(d & 7);
            break;
        }
      }
      return l;
    }, r.decodeDelimited = function(n) {
      return n instanceof $Reader || (n = new $Reader(n)), this.decode(n, n.uint32());
    }, r.verify = function(n) {
      if (typeof n != "object" || n === null)
        return "object expected";
      let o = {};
      if (n.deltaRequest != null && n.hasOwnProperty("deltaRequest")) {
        o.request = 1;
        {
          let c = $root.delta_enclave_api.DataNoncePubkey.verify(n.deltaRequest);
          if (c)
            return "deltaRequest." + c;
        }
      }
      if (n.extensionMessage != null && n.hasOwnProperty("extensionMessage")) {
        if (o.request === 1)
          return "request: multiple values";
        o.request = 1;
        {
          let c = $root.delta_enclave_api.ExtensionMessage.verify(n.extensionMessage);
          if (c)
            return "extensionMessage." + c;
        }
      }
      if (n.deltaRequestV2 != null && n.hasOwnProperty("deltaRequestV2")) {
        if (o.request === 1)
          return "request: multiple values";
        o.request = 1;
        {
          let c = $root.delta_enclave_api.DataNoncePubkey.verify(n.deltaRequestV2);
          if (c)
            return "deltaRequestV2." + c;
        }
      }
      return null;
    }, r.fromObject = function(n) {
      if (n instanceof $root.delta_enclave_api.Request)
        return n;
      let o = new $root.delta_enclave_api.Request();
      if (n.deltaRequest != null) {
        if (typeof n.deltaRequest != "object")
          throw TypeError(".delta_enclave_api.Request.deltaRequest: object expected");
        o.deltaRequest = $root.delta_enclave_api.DataNoncePubkey.fromObject(n.deltaRequest);
      }
      if (n.extensionMessage != null) {
        if (typeof n.extensionMessage != "object")
          throw TypeError(".delta_enclave_api.Request.extensionMessage: object expected");
        o.extensionMessage = $root.delta_enclave_api.ExtensionMessage.fromObject(n.extensionMessage);
      }
      if (n.deltaRequestV2 != null) {
        if (typeof n.deltaRequestV2 != "object")
          throw TypeError(".delta_enclave_api.Request.deltaRequestV2: object expected");
        o.deltaRequestV2 = $root.delta_enclave_api.DataNoncePubkey.fromObject(n.deltaRequestV2);
      }
      return o;
    }, r.toObject = function(n, o) {
      o || (o = {});
      let c = {};
      return n.deltaRequest != null && n.hasOwnProperty("deltaRequest") && (c.deltaRequest = $root.delta_enclave_api.DataNoncePubkey.toObject(n.deltaRequest, o), o.oneofs && (c.request = "deltaRequest")), n.extensionMessage != null && n.hasOwnProperty("extensionMessage") && (c.extensionMessage = $root.delta_enclave_api.ExtensionMessage.toObject(n.extensionMessage, o), o.oneofs && (c.request = "extensionMessage")), n.deltaRequestV2 != null && n.hasOwnProperty("deltaRequestV2") && (c.deltaRequestV2 = $root.delta_enclave_api.DataNoncePubkey.toObject(n.deltaRequestV2, o), o.oneofs && (c.request = "deltaRequestV2")), c;
    }, r.prototype.toJSON = function() {
      return this.constructor.toObject(this, minimal.util.toJSONOptions);
    }, r.getTypeUrl = function(n) {
      return n === void 0 && (n = "type.googleapis.com"), n + "/delta_enclave_api.Request";
    }, r;
  }(), u.ExtensionMessage = function() {
    function r(a) {
      if (a)
        for (let e = Object.keys(a), n = 0; n < e.length; ++n)
          a[e[n]] != null && (this[e[n]] = a[e[n]]);
    }
    return r.prototype.name = "", r.prototype.payload = $util.newBuffer([]), r.create = function(e) {
      return new r(e);
    }, r.encode = function(e, n) {
      return n || (n = $Writer.create()), e.name != null && Object.hasOwnProperty.call(e, "name") && n.uint32(
        /* id 1, wireType 2 =*/
        10
      ).string(e.name), e.payload != null && Object.hasOwnProperty.call(e, "payload") && n.uint32(
        /* id 2, wireType 2 =*/
        18
      ).bytes(e.payload), n;
    }, r.encodeDelimited = function(e, n) {
      return this.encode(e, n).ldelim();
    }, r.decode = function(e, n) {
      e instanceof $Reader || (e = $Reader.create(e));
      let o = n === void 0 ? e.len : e.pos + n, c = new $root.delta_enclave_api.ExtensionMessage();
      for (; e.pos < o; ) {
        let l = e.uint32();
        switch (l >>> 3) {
          case 1: {
            c.name = e.string();
            break;
          }
          case 2: {
            c.payload = e.bytes();
            break;
          }
          default:
            e.skipType(l & 7);
            break;
        }
      }
      return c;
    }, r.decodeDelimited = function(e) {
      return e instanceof $Reader || (e = new $Reader(e)), this.decode(e, e.uint32());
    }, r.verify = function(e) {
      return typeof e != "object" || e === null ? "object expected" : e.name != null && e.hasOwnProperty("name") && !$util.isString(e.name) ? "name: string expected" : e.payload != null && e.hasOwnProperty("payload") && !(e.payload && typeof e.payload.length == "number" || $util.isString(e.payload)) ? "payload: buffer expected" : null;
    }, r.fromObject = function(e) {
      if (e instanceof $root.delta_enclave_api.ExtensionMessage)
        return e;
      let n = new $root.delta_enclave_api.ExtensionMessage();
      return e.name != null && (n.name = String(e.name)), e.payload != null && (typeof e.payload == "string" ? $util.base64.decode(e.payload, n.payload = $util.newBuffer($util.base64.length(e.payload)), 0) : e.payload.length >= 0 && (n.payload = e.payload)), n;
    }, r.toObject = function(e, n) {
      n || (n = {});
      let o = {};
      return n.defaults && (o.name = "", n.bytes === String ? o.payload = "" : (o.payload = [], n.bytes !== Array && (o.payload = $util.newBuffer(o.payload)))), e.name != null && e.hasOwnProperty("name") && (o.name = e.name), e.payload != null && e.hasOwnProperty("payload") && (o.payload = n.bytes === String ? $util.base64.encode(e.payload, 0, e.payload.length) : n.bytes === Array ? Array.prototype.slice.call(e.payload) : e.payload), o;
    }, r.prototype.toJSON = function() {
      return this.constructor.toObject(this, minimal.util.toJSONOptions);
    }, r.getTypeUrl = function(e) {
      return e === void 0 && (e = "type.googleapis.com"), e + "/delta_enclave_api.ExtensionMessage";
    }, r;
  }(), u.Response = function() {
    function r(e) {
      if (e)
        for (let n = Object.keys(e), o = 0; o < n.length; ++o)
          e[n[o]] != null && (this[n[o]] = e[n[o]]);
    }
    r.prototype.successfulResponse = null, r.prototype.unsuccessfulResponse = null;
    let a;
    return Object.defineProperty(r.prototype, "response", {
      get: $util.oneOfGetter(a = ["successfulResponse", "unsuccessfulResponse"]),
      set: $util.oneOfSetter(a)
    }), r.create = function(n) {
      return new r(n);
    }, r.encode = function(n, o) {
      return o || (o = $Writer.create()), n.successfulResponse != null && Object.hasOwnProperty.call(n, "successfulResponse") && o.uint32(
        /* id 1, wireType 2 =*/
        10
      ).bytes(n.successfulResponse), n.unsuccessfulResponse != null && Object.hasOwnProperty.call(n, "unsuccessfulResponse") && o.uint32(
        /* id 2, wireType 2 =*/
        18
      ).string(n.unsuccessfulResponse), o;
    }, r.encodeDelimited = function(n, o) {
      return this.encode(n, o).ldelim();
    }, r.decode = function(n, o) {
      n instanceof $Reader || (n = $Reader.create(n));
      let c = o === void 0 ? n.len : n.pos + o, l = new $root.delta_enclave_api.Response();
      for (; n.pos < c; ) {
        let d = n.uint32();
        switch (d >>> 3) {
          case 1: {
            l.successfulResponse = n.bytes();
            break;
          }
          case 2: {
            l.unsuccessfulResponse = n.string();
            break;
          }
          default:
            n.skipType(d & 7);
            break;
        }
      }
      return l;
    }, r.decodeDelimited = function(n) {
      return n instanceof $Reader || (n = new $Reader(n)), this.decode(n, n.uint32());
    }, r.verify = function(n) {
      if (typeof n != "object" || n === null)
        return "object expected";
      let o = {};
      if (n.successfulResponse != null && n.hasOwnProperty("successfulResponse") && (o.response = 1, !(n.successfulResponse && typeof n.successfulResponse.length == "number" || $util.isString(n.successfulResponse))))
        return "successfulResponse: buffer expected";
      if (n.unsuccessfulResponse != null && n.hasOwnProperty("unsuccessfulResponse")) {
        if (o.response === 1)
          return "response: multiple values";
        if (o.response = 1, !$util.isString(n.unsuccessfulResponse))
          return "unsuccessfulResponse: string expected";
      }
      return null;
    }, r.fromObject = function(n) {
      if (n instanceof $root.delta_enclave_api.Response)
        return n;
      let o = new $root.delta_enclave_api.Response();
      return n.successfulResponse != null && (typeof n.successfulResponse == "string" ? $util.base64.decode(n.successfulResponse, o.successfulResponse = $util.newBuffer($util.base64.length(n.successfulResponse)), 0) : n.successfulResponse.length >= 0 && (o.successfulResponse = n.successfulResponse)), n.unsuccessfulResponse != null && (o.unsuccessfulResponse = String(n.unsuccessfulResponse)), o;
    }, r.toObject = function(n, o) {
      o || (o = {});
      let c = {};
      return n.successfulResponse != null && n.hasOwnProperty("successfulResponse") && (c.successfulResponse = o.bytes === String ? $util.base64.encode(n.successfulResponse, 0, n.successfulResponse.length) : o.bytes === Array ? Array.prototype.slice.call(n.successfulResponse) : n.successfulResponse, o.oneofs && (c.response = "successfulResponse")), n.unsuccessfulResponse != null && n.hasOwnProperty("unsuccessfulResponse") && (c.unsuccessfulResponse = n.unsuccessfulResponse, o.oneofs && (c.response = "unsuccessfulResponse")), c;
    }, r.prototype.toJSON = function() {
      return this.constructor.toObject(this, minimal.util.toJSONOptions);
    }, r.getTypeUrl = function(n) {
      return n === void 0 && (n = "type.googleapis.com"), n + "/delta_enclave_api.Response";
    }, r;
  }(), u.DataNoncePubkey = function() {
    function r(a) {
      if (a)
        for (let e = Object.keys(a), n = 0; n < e.length; ++n)
          a[e[n]] != null && (this[e[n]] = a[e[n]]);
    }
    return r.prototype.data = $util.newBuffer([]), r.prototype.nonce = $util.newBuffer([]), r.prototype.pubkey = $util.newBuffer([]), r.create = function(e) {
      return new r(e);
    }, r.encode = function(e, n) {
      return n || (n = $Writer.create()), e.data != null && Object.hasOwnProperty.call(e, "data") && n.uint32(
        /* id 1, wireType 2 =*/
        10
      ).bytes(e.data), e.nonce != null && Object.hasOwnProperty.call(e, "nonce") && n.uint32(
        /* id 2, wireType 2 =*/
        18
      ).bytes(e.nonce), e.pubkey != null && Object.hasOwnProperty.call(e, "pubkey") && n.uint32(
        /* id 3, wireType 2 =*/
        26
      ).bytes(e.pubkey), n;
    }, r.encodeDelimited = function(e, n) {
      return this.encode(e, n).ldelim();
    }, r.decode = function(e, n) {
      e instanceof $Reader || (e = $Reader.create(e));
      let o = n === void 0 ? e.len : e.pos + n, c = new $root.delta_enclave_api.DataNoncePubkey();
      for (; e.pos < o; ) {
        let l = e.uint32();
        switch (l >>> 3) {
          case 1: {
            c.data = e.bytes();
            break;
          }
          case 2: {
            c.nonce = e.bytes();
            break;
          }
          case 3: {
            c.pubkey = e.bytes();
            break;
          }
          default:
            e.skipType(l & 7);
            break;
        }
      }
      return c;
    }, r.decodeDelimited = function(e) {
      return e instanceof $Reader || (e = new $Reader(e)), this.decode(e, e.uint32());
    }, r.verify = function(e) {
      return typeof e != "object" || e === null ? "object expected" : e.data != null && e.hasOwnProperty("data") && !(e.data && typeof e.data.length == "number" || $util.isString(e.data)) ? "data: buffer expected" : e.nonce != null && e.hasOwnProperty("nonce") && !(e.nonce && typeof e.nonce.length == "number" || $util.isString(e.nonce)) ? "nonce: buffer expected" : e.pubkey != null && e.hasOwnProperty("pubkey") && !(e.pubkey && typeof e.pubkey.length == "number" || $util.isString(e.pubkey)) ? "pubkey: buffer expected" : null;
    }, r.fromObject = function(e) {
      if (e instanceof $root.delta_enclave_api.DataNoncePubkey)
        return e;
      let n = new $root.delta_enclave_api.DataNoncePubkey();
      return e.data != null && (typeof e.data == "string" ? $util.base64.decode(e.data, n.data = $util.newBuffer($util.base64.length(e.data)), 0) : e.data.length >= 0 && (n.data = e.data)), e.nonce != null && (typeof e.nonce == "string" ? $util.base64.decode(e.nonce, n.nonce = $util.newBuffer($util.base64.length(e.nonce)), 0) : e.nonce.length >= 0 && (n.nonce = e.nonce)), e.pubkey != null && (typeof e.pubkey == "string" ? $util.base64.decode(e.pubkey, n.pubkey = $util.newBuffer($util.base64.length(e.pubkey)), 0) : e.pubkey.length >= 0 && (n.pubkey = e.pubkey)), n;
    }, r.toObject = function(e, n) {
      n || (n = {});
      let o = {};
      return n.defaults && (n.bytes === String ? o.data = "" : (o.data = [], n.bytes !== Array && (o.data = $util.newBuffer(o.data))), n.bytes === String ? o.nonce = "" : (o.nonce = [], n.bytes !== Array && (o.nonce = $util.newBuffer(o.nonce))), n.bytes === String ? o.pubkey = "" : (o.pubkey = [], n.bytes !== Array && (o.pubkey = $util.newBuffer(o.pubkey)))), e.data != null && e.hasOwnProperty("data") && (o.data = n.bytes === String ? $util.base64.encode(e.data, 0, e.data.length) : n.bytes === Array ? Array.prototype.slice.call(e.data) : e.data), e.nonce != null && e.hasOwnProperty("nonce") && (o.nonce = n.bytes === String ? $util.base64.encode(e.nonce, 0, e.nonce.length) : n.bytes === Array ? Array.prototype.slice.call(e.nonce) : e.nonce), e.pubkey != null && e.hasOwnProperty("pubkey") && (o.pubkey = n.bytes === String ? $util.base64.encode(e.pubkey, 0, e.pubkey.length) : n.bytes === Array ? Array.prototype.slice.call(e.pubkey) : e.pubkey), o;
    }, r.prototype.toJSON = function() {
      return this.constructor.toObject(this, minimal.util.toJSONOptions);
    }, r.getTypeUrl = function(e) {
      return e === void 0 && (e = "type.googleapis.com"), e + "/delta_enclave_api.DataNoncePubkey";
    }, r;
  }(), u.DataNonce = function() {
    function r(a) {
      if (a)
        for (let e = Object.keys(a), n = 0; n < e.length; ++n)
          a[e[n]] != null && (this[e[n]] = a[e[n]]);
    }
    return r.prototype.data = $util.newBuffer([]), r.prototype.nonce = $util.newBuffer([]), r.create = function(e) {
      return new r(e);
    }, r.encode = function(e, n) {
      return n || (n = $Writer.create()), e.data != null && Object.hasOwnProperty.call(e, "data") && n.uint32(
        /* id 1, wireType 2 =*/
        10
      ).bytes(e.data), e.nonce != null && Object.hasOwnProperty.call(e, "nonce") && n.uint32(
        /* id 2, wireType 2 =*/
        18
      ).bytes(e.nonce), n;
    }, r.encodeDelimited = function(e, n) {
      return this.encode(e, n).ldelim();
    }, r.decode = function(e, n) {
      e instanceof $Reader || (e = $Reader.create(e));
      let o = n === void 0 ? e.len : e.pos + n, c = new $root.delta_enclave_api.DataNonce();
      for (; e.pos < o; ) {
        let l = e.uint32();
        switch (l >>> 3) {
          case 1: {
            c.data = e.bytes();
            break;
          }
          case 2: {
            c.nonce = e.bytes();
            break;
          }
          default:
            e.skipType(l & 7);
            break;
        }
      }
      return c;
    }, r.decodeDelimited = function(e) {
      return e instanceof $Reader || (e = new $Reader(e)), this.decode(e, e.uint32());
    }, r.verify = function(e) {
      return typeof e != "object" || e === null ? "object expected" : e.data != null && e.hasOwnProperty("data") && !(e.data && typeof e.data.length == "number" || $util.isString(e.data)) ? "data: buffer expected" : e.nonce != null && e.hasOwnProperty("nonce") && !(e.nonce && typeof e.nonce.length == "number" || $util.isString(e.nonce)) ? "nonce: buffer expected" : null;
    }, r.fromObject = function(e) {
      if (e instanceof $root.delta_enclave_api.DataNonce)
        return e;
      let n = new $root.delta_enclave_api.DataNonce();
      return e.data != null && (typeof e.data == "string" ? $util.base64.decode(e.data, n.data = $util.newBuffer($util.base64.length(e.data)), 0) : e.data.length >= 0 && (n.data = e.data)), e.nonce != null && (typeof e.nonce == "string" ? $util.base64.decode(e.nonce, n.nonce = $util.newBuffer($util.base64.length(e.nonce)), 0) : e.nonce.length >= 0 && (n.nonce = e.nonce)), n;
    }, r.toObject = function(e, n) {
      n || (n = {});
      let o = {};
      return n.defaults && (n.bytes === String ? o.data = "" : (o.data = [], n.bytes !== Array && (o.data = $util.newBuffer(o.data))), n.bytes === String ? o.nonce = "" : (o.nonce = [], n.bytes !== Array && (o.nonce = $util.newBuffer(o.nonce)))), e.data != null && e.hasOwnProperty("data") && (o.data = n.bytes === String ? $util.base64.encode(e.data, 0, e.data.length) : n.bytes === Array ? Array.prototype.slice.call(e.data) : e.data), e.nonce != null && e.hasOwnProperty("nonce") && (o.nonce = n.bytes === String ? $util.base64.encode(e.nonce, 0, e.nonce.length) : n.bytes === Array ? Array.prototype.slice.call(e.nonce) : e.nonce), o;
    }, r.prototype.toJSON = function() {
      return this.constructor.toObject(this, minimal.util.toJSONOptions);
    }, r.getTypeUrl = function(e) {
      return e === void 0 && (e = "type.googleapis.com"), e + "/delta_enclave_api.DataNonce";
    }, r;
  }(), u.SealedEncryptedMessage = function() {
    function r(a) {
      if (a)
        for (let e = Object.keys(a), n = 0; n < e.length; ++n)
          a[e[n]] != null && (this[e[n]] = a[e[n]]);
    }
    return r.prototype.encryptedMessage = null, r.prototype.sealingKeyParams = $util.newBuffer([]), r.create = function(e) {
      return new r(e);
    }, r.encode = function(e, n) {
      return n || (n = $Writer.create()), e.encryptedMessage != null && Object.hasOwnProperty.call(e, "encryptedMessage") && $root.delta_enclave_api.DataNonce.encode(e.encryptedMessage, n.uint32(
        /* id 1, wireType 2 =*/
        10
      ).fork()).ldelim(), e.sealingKeyParams != null && Object.hasOwnProperty.call(e, "sealingKeyParams") && n.uint32(
        /* id 2, wireType 2 =*/
        18
      ).bytes(e.sealingKeyParams), n;
    }, r.encodeDelimited = function(e, n) {
      return this.encode(e, n).ldelim();
    }, r.decode = function(e, n) {
      e instanceof $Reader || (e = $Reader.create(e));
      let o = n === void 0 ? e.len : e.pos + n, c = new $root.delta_enclave_api.SealedEncryptedMessage();
      for (; e.pos < o; ) {
        let l = e.uint32();
        switch (l >>> 3) {
          case 1: {
            c.encryptedMessage = $root.delta_enclave_api.DataNonce.decode(e, e.uint32());
            break;
          }
          case 2: {
            c.sealingKeyParams = e.bytes();
            break;
          }
          default:
            e.skipType(l & 7);
            break;
        }
      }
      return c;
    }, r.decodeDelimited = function(e) {
      return e instanceof $Reader || (e = new $Reader(e)), this.decode(e, e.uint32());
    }, r.verify = function(e) {
      if (typeof e != "object" || e === null)
        return "object expected";
      if (e.encryptedMessage != null && e.hasOwnProperty("encryptedMessage")) {
        let n = $root.delta_enclave_api.DataNonce.verify(e.encryptedMessage);
        if (n)
          return "encryptedMessage." + n;
      }
      return e.sealingKeyParams != null && e.hasOwnProperty("sealingKeyParams") && !(e.sealingKeyParams && typeof e.sealingKeyParams.length == "number" || $util.isString(e.sealingKeyParams)) ? "sealingKeyParams: buffer expected" : null;
    }, r.fromObject = function(e) {
      if (e instanceof $root.delta_enclave_api.SealedEncryptedMessage)
        return e;
      let n = new $root.delta_enclave_api.SealedEncryptedMessage();
      if (e.encryptedMessage != null) {
        if (typeof e.encryptedMessage != "object")
          throw TypeError(".delta_enclave_api.SealedEncryptedMessage.encryptedMessage: object expected");
        n.encryptedMessage = $root.delta_enclave_api.DataNonce.fromObject(e.encryptedMessage);
      }
      return e.sealingKeyParams != null && (typeof e.sealingKeyParams == "string" ? $util.base64.decode(e.sealingKeyParams, n.sealingKeyParams = $util.newBuffer($util.base64.length(e.sealingKeyParams)), 0) : e.sealingKeyParams.length >= 0 && (n.sealingKeyParams = e.sealingKeyParams)), n;
    }, r.toObject = function(e, n) {
      n || (n = {});
      let o = {};
      return n.defaults && (o.encryptedMessage = null, n.bytes === String ? o.sealingKeyParams = "" : (o.sealingKeyParams = [], n.bytes !== Array && (o.sealingKeyParams = $util.newBuffer(o.sealingKeyParams)))), e.encryptedMessage != null && e.hasOwnProperty("encryptedMessage") && (o.encryptedMessage = $root.delta_enclave_api.DataNonce.toObject(e.encryptedMessage, n)), e.sealingKeyParams != null && e.hasOwnProperty("sealingKeyParams") && (o.sealingKeyParams = n.bytes === String ? $util.base64.encode(e.sealingKeyParams, 0, e.sealingKeyParams.length) : n.bytes === Array ? Array.prototype.slice.call(e.sealingKeyParams) : e.sealingKeyParams), o;
    }, r.prototype.toJSON = function() {
      return this.constructor.toObject(this, minimal.util.toJSONOptions);
    }, r.getTypeUrl = function(e) {
      return e === void 0 && (e = "type.googleapis.com"), e + "/delta_enclave_api.SealedEncryptedMessage";
    }, r;
  }(), u.EncryptionHeader = function() {
    function r(e) {
      if (e)
        for (let n = Object.keys(e), o = 0; o < n.length; ++o)
          e[n[o]] != null && (this[n[o]] = e[n[o]]);
    }
    r.prototype.chilyKey = null;
    let a;
    return Object.defineProperty(r.prototype, "encryptionHeader", {
      get: $util.oneOfGetter(a = ["chilyKey"]),
      set: $util.oneOfSetter(a)
    }), r.create = function(n) {
      return new r(n);
    }, r.encode = function(n, o) {
      return o || (o = $Writer.create()), n.chilyKey != null && Object.hasOwnProperty.call(n, "chilyKey") && $root.delta_enclave_api.ChilyKey.encode(n.chilyKey, o.uint32(
        /* id 1, wireType 2 =*/
        10
      ).fork()).ldelim(), o;
    }, r.encodeDelimited = function(n, o) {
      return this.encode(n, o).ldelim();
    }, r.decode = function(n, o) {
      n instanceof $Reader || (n = $Reader.create(n));
      let c = o === void 0 ? n.len : n.pos + o, l = new $root.delta_enclave_api.EncryptionHeader();
      for (; n.pos < c; ) {
        let d = n.uint32();
        switch (d >>> 3) {
          case 1: {
            l.chilyKey = $root.delta_enclave_api.ChilyKey.decode(n, n.uint32());
            break;
          }
          default:
            n.skipType(d & 7);
            break;
        }
      }
      return l;
    }, r.decodeDelimited = function(n) {
      return n instanceof $Reader || (n = new $Reader(n)), this.decode(n, n.uint32());
    }, r.verify = function(n) {
      if (typeof n != "object" || n === null)
        return "object expected";
      if (n.chilyKey != null && n.hasOwnProperty("chilyKey")) {
        let o = $root.delta_enclave_api.ChilyKey.verify(n.chilyKey);
        if (o)
          return "chilyKey." + o;
      }
      return null;
    }, r.fromObject = function(n) {
      if (n instanceof $root.delta_enclave_api.EncryptionHeader)
        return n;
      let o = new $root.delta_enclave_api.EncryptionHeader();
      if (n.chilyKey != null) {
        if (typeof n.chilyKey != "object")
          throw TypeError(".delta_enclave_api.EncryptionHeader.chilyKey: object expected");
        o.chilyKey = $root.delta_enclave_api.ChilyKey.fromObject(n.chilyKey);
      }
      return o;
    }, r.toObject = function(n, o) {
      o || (o = {});
      let c = {};
      return n.chilyKey != null && n.hasOwnProperty("chilyKey") && (c.chilyKey = $root.delta_enclave_api.ChilyKey.toObject(n.chilyKey, o), o.oneofs && (c.encryptionHeader = "chilyKey")), c;
    }, r.prototype.toJSON = function() {
      return this.constructor.toObject(this, minimal.util.toJSONOptions);
    }, r.getTypeUrl = function(n) {
      return n === void 0 && (n = "type.googleapis.com"), n + "/delta_enclave_api.EncryptionHeader";
    }, r;
  }(), u.ChilyKey = function() {
    function r(a) {
      if (a)
        for (let e = Object.keys(a), n = 0; n < e.length; ++n)
          a[e[n]] != null && (this[e[n]] = a[e[n]]);
    }
    return r.prototype.encryptionNonce = $util.newBuffer([]), r.create = function(e) {
      return new r(e);
    }, r.encode = function(e, n) {
      return n || (n = $Writer.create()), e.encryptionNonce != null && Object.hasOwnProperty.call(e, "encryptionNonce") && n.uint32(
        /* id 2, wireType 2 =*/
        18
      ).bytes(e.encryptionNonce), n;
    }, r.encodeDelimited = function(e, n) {
      return this.encode(e, n).ldelim();
    }, r.decode = function(e, n) {
      e instanceof $Reader || (e = $Reader.create(e));
      let o = n === void 0 ? e.len : e.pos + n, c = new $root.delta_enclave_api.ChilyKey();
      for (; e.pos < o; ) {
        let l = e.uint32();
        switch (l >>> 3) {
          case 2: {
            c.encryptionNonce = e.bytes();
            break;
          }
          default:
            e.skipType(l & 7);
            break;
        }
      }
      return c;
    }, r.decodeDelimited = function(e) {
      return e instanceof $Reader || (e = new $Reader(e)), this.decode(e, e.uint32());
    }, r.verify = function(e) {
      return typeof e != "object" || e === null ? "object expected" : e.encryptionNonce != null && e.hasOwnProperty("encryptionNonce") && !(e.encryptionNonce && typeof e.encryptionNonce.length == "number" || $util.isString(e.encryptionNonce)) ? "encryptionNonce: buffer expected" : null;
    }, r.fromObject = function(e) {
      if (e instanceof $root.delta_enclave_api.ChilyKey)
        return e;
      let n = new $root.delta_enclave_api.ChilyKey();
      return e.encryptionNonce != null && (typeof e.encryptionNonce == "string" ? $util.base64.decode(e.encryptionNonce, n.encryptionNonce = $util.newBuffer($util.base64.length(e.encryptionNonce)), 0) : e.encryptionNonce.length >= 0 && (n.encryptionNonce = e.encryptionNonce)), n;
    }, r.toObject = function(e, n) {
      n || (n = {});
      let o = {};
      return n.defaults && (n.bytes === String ? o.encryptionNonce = "" : (o.encryptionNonce = [], n.bytes !== Array && (o.encryptionNonce = $util.newBuffer(o.encryptionNonce)))), e.encryptionNonce != null && e.hasOwnProperty("encryptionNonce") && (o.encryptionNonce = n.bytes === String ? $util.base64.encode(e.encryptionNonce, 0, e.encryptionNonce.length) : n.bytes === Array ? Array.prototype.slice.call(e.encryptionNonce) : e.encryptionNonce), o;
    }, r.prototype.toJSON = function() {
      return this.constructor.toObject(this, minimal.util.toJSONOptions);
    }, r.getTypeUrl = function(e) {
      return e === void 0 && (e = "type.googleapis.com"), e + "/delta_enclave_api.ChilyKey";
    }, r;
  }(), u.VersionHeader = function() {
    function r(a) {
      if (a)
        for (let e = Object.keys(a), n = 0; n < e.length; ++n)
          a[e[n]] != null && (this[e[n]] = a[e[n]]);
    }
    return r.prototype.version = $util.Long ? $util.Long.fromBits(0, 0, !1) : 0, r.create = function(e) {
      return new r(e);
    }, r.encode = function(e, n) {
      return n || (n = $Writer.create()), e.version != null && Object.hasOwnProperty.call(e, "version") && n.uint32(
        /* id 1, wireType 0 =*/
        8
      ).int64(e.version), n;
    }, r.encodeDelimited = function(e, n) {
      return this.encode(e, n).ldelim();
    }, r.decode = function(e, n) {
      e instanceof $Reader || (e = $Reader.create(e));
      let o = n === void 0 ? e.len : e.pos + n, c = new $root.delta_enclave_api.VersionHeader();
      for (; e.pos < o; ) {
        let l = e.uint32();
        switch (l >>> 3) {
          case 1: {
            c.version = e.int64();
            break;
          }
          default:
            e.skipType(l & 7);
            break;
        }
      }
      return c;
    }, r.decodeDelimited = function(e) {
      return e instanceof $Reader || (e = new $Reader(e)), this.decode(e, e.uint32());
    }, r.verify = function(e) {
      return typeof e != "object" || e === null ? "object expected" : e.version != null && e.hasOwnProperty("version") && !$util.isInteger(e.version) && !(e.version && $util.isInteger(e.version.low) && $util.isInteger(e.version.high)) ? "version: integer|Long expected" : null;
    }, r.fromObject = function(e) {
      if (e instanceof $root.delta_enclave_api.VersionHeader)
        return e;
      let n = new $root.delta_enclave_api.VersionHeader();
      return e.version != null && ($util.Long ? (n.version = $util.Long.fromValue(e.version)).unsigned = !1 : typeof e.version == "string" ? n.version = parseInt(e.version, 10) : typeof e.version == "number" ? n.version = e.version : typeof e.version == "object" && (n.version = new $util.LongBits(e.version.low >>> 0, e.version.high >>> 0).toNumber())), n;
    }, r.toObject = function(e, n) {
      n || (n = {});
      let o = {};
      if (n.defaults)
        if ($util.Long) {
          let c = new $util.Long(0, 0, !1);
          o.version = n.longs === String ? c.toString() : n.longs === Number ? c.toNumber() : c;
        } else
          o.version = n.longs === String ? "0" : 0;
      return e.version != null && e.hasOwnProperty("version") && (typeof e.version == "number" ? o.version = n.longs === String ? String(e.version) : e.version : o.version = n.longs === String ? $util.Long.prototype.toString.call(e.version) : n.longs === Number ? new $util.LongBits(e.version.low >>> 0, e.version.high >>> 0).toNumber() : e.version), o;
    }, r.prototype.toJSON = function() {
      return this.constructor.toObject(this, minimal.util.toJSONOptions);
    }, r.getTypeUrl = function(e) {
      return e === void 0 && (e = "type.googleapis.com"), e + "/delta_enclave_api.VersionHeader";
    }, r;
  }(), u.ChunkHeader = function() {
    function r(e) {
      if (this.untrustedChunkContentSizes = [], e)
        for (let n = Object.keys(e), o = 0; o < n.length; ++o)
          e[n[o]] != null && (this[n[o]] = e[n[o]]);
    }
    r.prototype.extraEntropy = $util.newBuffer([]), r.prototype.untrustedContentSize = null, r.prototype.untrustedChunkContentSizes = $util.emptyArray;
    let a;
    return Object.defineProperty(r.prototype, "_untrustedContentSize", {
      get: $util.oneOfGetter(a = ["untrustedContentSize"]),
      set: $util.oneOfSetter(a)
    }), r.create = function(n) {
      return new r(n);
    }, r.encode = function(n, o) {
      if (o || (o = $Writer.create()), n.extraEntropy != null && Object.hasOwnProperty.call(n, "extraEntropy") && o.uint32(
        /* id 1, wireType 2 =*/
        10
      ).bytes(n.extraEntropy), n.untrustedContentSize != null && Object.hasOwnProperty.call(n, "untrustedContentSize") && o.uint32(
        /* id 2, wireType 0 =*/
        16
      ).uint64(n.untrustedContentSize), n.untrustedChunkContentSizes != null && n.untrustedChunkContentSizes.length) {
        o.uint32(
          /* id 3, wireType 2 =*/
          26
        ).fork();
        for (let c = 0; c < n.untrustedChunkContentSizes.length; ++c)
          o.uint64(n.untrustedChunkContentSizes[c]);
        o.ldelim();
      }
      return o;
    }, r.encodeDelimited = function(n, o) {
      return this.encode(n, o).ldelim();
    }, r.decode = function(n, o) {
      n instanceof $Reader || (n = $Reader.create(n));
      let c = o === void 0 ? n.len : n.pos + o, l = new $root.delta_enclave_api.ChunkHeader();
      for (; n.pos < c; ) {
        let d = n.uint32();
        switch (d >>> 3) {
          case 1: {
            l.extraEntropy = n.bytes();
            break;
          }
          case 2: {
            l.untrustedContentSize = n.uint64();
            break;
          }
          case 3: {
            if (l.untrustedChunkContentSizes && l.untrustedChunkContentSizes.length || (l.untrustedChunkContentSizes = []), (d & 7) === 2) {
              let p = n.uint32() + n.pos;
              for (; n.pos < p; )
                l.untrustedChunkContentSizes.push(n.uint64());
            } else
              l.untrustedChunkContentSizes.push(n.uint64());
            break;
          }
          default:
            n.skipType(d & 7);
            break;
        }
      }
      return l;
    }, r.decodeDelimited = function(n) {
      return n instanceof $Reader || (n = new $Reader(n)), this.decode(n, n.uint32());
    }, r.verify = function(n) {
      if (typeof n != "object" || n === null)
        return "object expected";
      if (n.extraEntropy != null && n.hasOwnProperty("extraEntropy") && !(n.extraEntropy && typeof n.extraEntropy.length == "number" || $util.isString(n.extraEntropy)))
        return "extraEntropy: buffer expected";
      if (n.untrustedContentSize != null && n.hasOwnProperty("untrustedContentSize") && !$util.isInteger(n.untrustedContentSize) && !(n.untrustedContentSize && $util.isInteger(n.untrustedContentSize.low) && $util.isInteger(n.untrustedContentSize.high)))
        return "untrustedContentSize: integer|Long expected";
      if (n.untrustedChunkContentSizes != null && n.hasOwnProperty("untrustedChunkContentSizes")) {
        if (!Array.isArray(n.untrustedChunkContentSizes))
          return "untrustedChunkContentSizes: array expected";
        for (let o = 0; o < n.untrustedChunkContentSizes.length; ++o)
          if (!$util.isInteger(n.untrustedChunkContentSizes[o]) && !(n.untrustedChunkContentSizes[o] && $util.isInteger(n.untrustedChunkContentSizes[o].low) && $util.isInteger(n.untrustedChunkContentSizes[o].high)))
            return "untrustedChunkContentSizes: integer|Long[] expected";
      }
      return null;
    }, r.fromObject = function(n) {
      if (n instanceof $root.delta_enclave_api.ChunkHeader)
        return n;
      let o = new $root.delta_enclave_api.ChunkHeader();
      if (n.extraEntropy != null && (typeof n.extraEntropy == "string" ? $util.base64.decode(n.extraEntropy, o.extraEntropy = $util.newBuffer($util.base64.length(n.extraEntropy)), 0) : n.extraEntropy.length >= 0 && (o.extraEntropy = n.extraEntropy)), n.untrustedContentSize != null && ($util.Long ? (o.untrustedContentSize = $util.Long.fromValue(n.untrustedContentSize)).unsigned = !0 : typeof n.untrustedContentSize == "string" ? o.untrustedContentSize = parseInt(n.untrustedContentSize, 10) : typeof n.untrustedContentSize == "number" ? o.untrustedContentSize = n.untrustedContentSize : typeof n.untrustedContentSize == "object" && (o.untrustedContentSize = new $util.LongBits(n.untrustedContentSize.low >>> 0, n.untrustedContentSize.high >>> 0).toNumber(!0))), n.untrustedChunkContentSizes) {
        if (!Array.isArray(n.untrustedChunkContentSizes))
          throw TypeError(".delta_enclave_api.ChunkHeader.untrustedChunkContentSizes: array expected");
        o.untrustedChunkContentSizes = [];
        for (let c = 0; c < n.untrustedChunkContentSizes.length; ++c)
          $util.Long ? (o.untrustedChunkContentSizes[c] = $util.Long.fromValue(n.untrustedChunkContentSizes[c])).unsigned = !0 : typeof n.untrustedChunkContentSizes[c] == "string" ? o.untrustedChunkContentSizes[c] = parseInt(n.untrustedChunkContentSizes[c], 10) : typeof n.untrustedChunkContentSizes[c] == "number" ? o.untrustedChunkContentSizes[c] = n.untrustedChunkContentSizes[c] : typeof n.untrustedChunkContentSizes[c] == "object" && (o.untrustedChunkContentSizes[c] = new $util.LongBits(n.untrustedChunkContentSizes[c].low >>> 0, n.untrustedChunkContentSizes[c].high >>> 0).toNumber(!0));
      }
      return o;
    }, r.toObject = function(n, o) {
      o || (o = {});
      let c = {};
      if ((o.arrays || o.defaults) && (c.untrustedChunkContentSizes = []), o.defaults && (o.bytes === String ? c.extraEntropy = "" : (c.extraEntropy = [], o.bytes !== Array && (c.extraEntropy = $util.newBuffer(c.extraEntropy)))), n.extraEntropy != null && n.hasOwnProperty("extraEntropy") && (c.extraEntropy = o.bytes === String ? $util.base64.encode(n.extraEntropy, 0, n.extraEntropy.length) : o.bytes === Array ? Array.prototype.slice.call(n.extraEntropy) : n.extraEntropy), n.untrustedContentSize != null && n.hasOwnProperty("untrustedContentSize") && (typeof n.untrustedContentSize == "number" ? c.untrustedContentSize = o.longs === String ? String(n.untrustedContentSize) : n.untrustedContentSize : c.untrustedContentSize = o.longs === String ? $util.Long.prototype.toString.call(n.untrustedContentSize) : o.longs === Number ? new $util.LongBits(n.untrustedContentSize.low >>> 0, n.untrustedContentSize.high >>> 0).toNumber(!0) : n.untrustedContentSize, o.oneofs && (c._untrustedContentSize = "untrustedContentSize")), n.untrustedChunkContentSizes && n.untrustedChunkContentSizes.length) {
        c.untrustedChunkContentSizes = [];
        for (let l = 0; l < n.untrustedChunkContentSizes.length; ++l)
          typeof n.untrustedChunkContentSizes[l] == "number" ? c.untrustedChunkContentSizes[l] = o.longs === String ? String(n.untrustedChunkContentSizes[l]) : n.untrustedChunkContentSizes[l] : c.untrustedChunkContentSizes[l] = o.longs === String ? $util.Long.prototype.toString.call(n.untrustedChunkContentSizes[l]) : o.longs === Number ? new $util.LongBits(n.untrustedChunkContentSizes[l].low >>> 0, n.untrustedChunkContentSizes[l].high >>> 0).toNumber(!0) : n.untrustedChunkContentSizes[l];
      }
      return c;
    }, r.prototype.toJSON = function() {
      return this.constructor.toObject(this, minimal.util.toJSONOptions);
    }, r.getTypeUrl = function(n) {
      return n === void 0 && (n = "type.googleapis.com"), n + "/delta_enclave_api.ChunkHeader";
    }, r;
  }(), u;
})();
$root.gcg = (() => {
  const u = {};
  return u.GcgRequest = function() {
    function r(e) {
      if (e)
        for (let n = Object.keys(e), o = 0; o < n.length; ++o)
          e[n[o]] != null && (this[n[o]] = e[n[o]]);
    }
    r.prototype.userAuth = null, r.prototype.createDataRoomRequest = null, r.prototype.retrieveDataRoomRequest = null, r.prototype.retrieveCurrentDataRoomConfigurationRequest = null, r.prototype.retrieveDataRoomStatusRequest = null, r.prototype.updateDataRoomStatusRequest = null, r.prototype.retrieveAuditLogRequest = null, r.prototype.publishDatasetToDataRoomRequest = null, r.prototype.retrievePublishedDatasetsRequest = null, r.prototype.removePublishedDatasetRequest = null, r.prototype.executeComputeRequest = null, r.prototype.jobStatusRequest = null, r.prototype.getResultsRequest = null, r.prototype.createConfigurationCommitRequest = null, r.prototype.retrieveConfigurationCommitRequest = null, r.prototype.executeDevelopmentComputeRequest = null, r.prototype.generateMergeApprovalSignatureRequest = null, r.prototype.mergeConfigurationCommitRequest = null, r.prototype.retrieveConfigurationCommitApproversRequest = null, r.prototype.casAuxiliaryStateRequest = null, r.prototype.readAuxiliaryStateRequest = null, r.prototype.retrieveUsedAirlockQuotaRequest = null, r.prototype.getResultsSizeRequest = null, r.prototype.endorsementRequest = null;
    let a;
    return Object.defineProperty(r.prototype, "gcgRequest", {
      get: $util.oneOfGetter(a = ["createDataRoomRequest", "retrieveDataRoomRequest", "retrieveCurrentDataRoomConfigurationRequest", "retrieveDataRoomStatusRequest", "updateDataRoomStatusRequest", "retrieveAuditLogRequest", "publishDatasetToDataRoomRequest", "retrievePublishedDatasetsRequest", "removePublishedDatasetRequest", "executeComputeRequest", "jobStatusRequest", "getResultsRequest", "createConfigurationCommitRequest", "retrieveConfigurationCommitRequest", "executeDevelopmentComputeRequest", "generateMergeApprovalSignatureRequest", "mergeConfigurationCommitRequest", "retrieveConfigurationCommitApproversRequest", "casAuxiliaryStateRequest", "readAuxiliaryStateRequest", "retrieveUsedAirlockQuotaRequest", "getResultsSizeRequest", "endorsementRequest"]),
      set: $util.oneOfSetter(a)
    }), r.create = function(n) {
      return new r(n);
    }, r.encode = function(n, o) {
      return o || (o = $Writer.create()), n.userAuth != null && Object.hasOwnProperty.call(n, "userAuth") && $root.gcg.UserAuth.encode(n.userAuth, o.uint32(
        /* id 1, wireType 2 =*/
        10
      ).fork()).ldelim(), n.createDataRoomRequest != null && Object.hasOwnProperty.call(n, "createDataRoomRequest") && $root.gcg.CreateDataRoomRequest.encode(n.createDataRoomRequest, o.uint32(
        /* id 2, wireType 2 =*/
        18
      ).fork()).ldelim(), n.retrieveDataRoomRequest != null && Object.hasOwnProperty.call(n, "retrieveDataRoomRequest") && $root.gcg.RetrieveDataRoomRequest.encode(n.retrieveDataRoomRequest, o.uint32(
        /* id 3, wireType 2 =*/
        26
      ).fork()).ldelim(), n.retrieveCurrentDataRoomConfigurationRequest != null && Object.hasOwnProperty.call(n, "retrieveCurrentDataRoomConfigurationRequest") && $root.gcg.RetrieveCurrentDataRoomConfigurationRequest.encode(n.retrieveCurrentDataRoomConfigurationRequest, o.uint32(
        /* id 4, wireType 2 =*/
        34
      ).fork()).ldelim(), n.retrieveDataRoomStatusRequest != null && Object.hasOwnProperty.call(n, "retrieveDataRoomStatusRequest") && $root.gcg.RetrieveDataRoomStatusRequest.encode(n.retrieveDataRoomStatusRequest, o.uint32(
        /* id 5, wireType 2 =*/
        42
      ).fork()).ldelim(), n.updateDataRoomStatusRequest != null && Object.hasOwnProperty.call(n, "updateDataRoomStatusRequest") && $root.gcg.UpdateDataRoomStatusRequest.encode(n.updateDataRoomStatusRequest, o.uint32(
        /* id 6, wireType 2 =*/
        50
      ).fork()).ldelim(), n.retrieveAuditLogRequest != null && Object.hasOwnProperty.call(n, "retrieveAuditLogRequest") && $root.gcg.RetrieveAuditLogRequest.encode(n.retrieveAuditLogRequest, o.uint32(
        /* id 7, wireType 2 =*/
        58
      ).fork()).ldelim(), n.publishDatasetToDataRoomRequest != null && Object.hasOwnProperty.call(n, "publishDatasetToDataRoomRequest") && $root.gcg.PublishDatasetToDataRoomRequest.encode(n.publishDatasetToDataRoomRequest, o.uint32(
        /* id 8, wireType 2 =*/
        66
      ).fork()).ldelim(), n.retrievePublishedDatasetsRequest != null && Object.hasOwnProperty.call(n, "retrievePublishedDatasetsRequest") && $root.gcg.RetrievePublishedDatasetsRequest.encode(n.retrievePublishedDatasetsRequest, o.uint32(
        /* id 9, wireType 2 =*/
        74
      ).fork()).ldelim(), n.removePublishedDatasetRequest != null && Object.hasOwnProperty.call(n, "removePublishedDatasetRequest") && $root.gcg.RemovePublishedDatasetRequest.encode(n.removePublishedDatasetRequest, o.uint32(
        /* id 10, wireType 2 =*/
        82
      ).fork()).ldelim(), n.executeComputeRequest != null && Object.hasOwnProperty.call(n, "executeComputeRequest") && $root.gcg.ExecuteComputeRequest.encode(n.executeComputeRequest, o.uint32(
        /* id 11, wireType 2 =*/
        90
      ).fork()).ldelim(), n.jobStatusRequest != null && Object.hasOwnProperty.call(n, "jobStatusRequest") && $root.gcg.JobStatusRequest.encode(n.jobStatusRequest, o.uint32(
        /* id 12, wireType 2 =*/
        98
      ).fork()).ldelim(), n.getResultsRequest != null && Object.hasOwnProperty.call(n, "getResultsRequest") && $root.gcg.GetResultsRequest.encode(n.getResultsRequest, o.uint32(
        /* id 13, wireType 2 =*/
        106
      ).fork()).ldelim(), n.createConfigurationCommitRequest != null && Object.hasOwnProperty.call(n, "createConfigurationCommitRequest") && $root.gcg.CreateConfigurationCommitRequest.encode(n.createConfigurationCommitRequest, o.uint32(
        /* id 14, wireType 2 =*/
        114
      ).fork()).ldelim(), n.retrieveConfigurationCommitRequest != null && Object.hasOwnProperty.call(n, "retrieveConfigurationCommitRequest") && $root.gcg.RetrieveConfigurationCommitRequest.encode(n.retrieveConfigurationCommitRequest, o.uint32(
        /* id 15, wireType 2 =*/
        122
      ).fork()).ldelim(), n.executeDevelopmentComputeRequest != null && Object.hasOwnProperty.call(n, "executeDevelopmentComputeRequest") && $root.gcg.ExecuteDevelopmentComputeRequest.encode(n.executeDevelopmentComputeRequest, o.uint32(
        /* id 16, wireType 2 =*/
        130
      ).fork()).ldelim(), n.generateMergeApprovalSignatureRequest != null && Object.hasOwnProperty.call(n, "generateMergeApprovalSignatureRequest") && $root.gcg.GenerateMergeApprovalSignatureRequest.encode(n.generateMergeApprovalSignatureRequest, o.uint32(
        /* id 17, wireType 2 =*/
        138
      ).fork()).ldelim(), n.mergeConfigurationCommitRequest != null && Object.hasOwnProperty.call(n, "mergeConfigurationCommitRequest") && $root.gcg.MergeConfigurationCommitRequest.encode(n.mergeConfigurationCommitRequest, o.uint32(
        /* id 18, wireType 2 =*/
        146
      ).fork()).ldelim(), n.retrieveConfigurationCommitApproversRequest != null && Object.hasOwnProperty.call(n, "retrieveConfigurationCommitApproversRequest") && $root.gcg.RetrieveConfigurationCommitApproversRequest.encode(n.retrieveConfigurationCommitApproversRequest, o.uint32(
        /* id 19, wireType 2 =*/
        154
      ).fork()).ldelim(), n.casAuxiliaryStateRequest != null && Object.hasOwnProperty.call(n, "casAuxiliaryStateRequest") && $root.gcg.CasAuxiliaryStateRequest.encode(n.casAuxiliaryStateRequest, o.uint32(
        /* id 20, wireType 2 =*/
        162
      ).fork()).ldelim(), n.readAuxiliaryStateRequest != null && Object.hasOwnProperty.call(n, "readAuxiliaryStateRequest") && $root.gcg.ReadAuxiliaryStateRequest.encode(n.readAuxiliaryStateRequest, o.uint32(
        /* id 21, wireType 2 =*/
        170
      ).fork()).ldelim(), n.retrieveUsedAirlockQuotaRequest != null && Object.hasOwnProperty.call(n, "retrieveUsedAirlockQuotaRequest") && $root.gcg.RetrieveUsedAirlockQuotaRequest.encode(n.retrieveUsedAirlockQuotaRequest, o.uint32(
        /* id 22, wireType 2 =*/
        178
      ).fork()).ldelim(), n.getResultsSizeRequest != null && Object.hasOwnProperty.call(n, "getResultsSizeRequest") && $root.gcg.GetResultsSizeRequest.encode(n.getResultsSizeRequest, o.uint32(
        /* id 23, wireType 2 =*/
        186
      ).fork()).ldelim(), n.endorsementRequest != null && Object.hasOwnProperty.call(n, "endorsementRequest") && $root.identity_endorsement.EndorsementRequest.encode(n.endorsementRequest, o.uint32(
        /* id 101, wireType 2 =*/
        810
      ).fork()).ldelim(), o;
    }, r.encodeDelimited = function(n, o) {
      return this.encode(n, o).ldelim();
    }, r.decode = function(n, o) {
      n instanceof $Reader || (n = $Reader.create(n));
      let c = o === void 0 ? n.len : n.pos + o, l = new $root.gcg.GcgRequest();
      for (; n.pos < c; ) {
        let d = n.uint32();
        switch (d >>> 3) {
          case 1: {
            l.userAuth = $root.gcg.UserAuth.decode(n, n.uint32());
            break;
          }
          case 2: {
            l.createDataRoomRequest = $root.gcg.CreateDataRoomRequest.decode(n, n.uint32());
            break;
          }
          case 3: {
            l.retrieveDataRoomRequest = $root.gcg.RetrieveDataRoomRequest.decode(n, n.uint32());
            break;
          }
          case 4: {
            l.retrieveCurrentDataRoomConfigurationRequest = $root.gcg.RetrieveCurrentDataRoomConfigurationRequest.decode(n, n.uint32());
            break;
          }
          case 5: {
            l.retrieveDataRoomStatusRequest = $root.gcg.RetrieveDataRoomStatusRequest.decode(n, n.uint32());
            break;
          }
          case 6: {
            l.updateDataRoomStatusRequest = $root.gcg.UpdateDataRoomStatusRequest.decode(n, n.uint32());
            break;
          }
          case 7: {
            l.retrieveAuditLogRequest = $root.gcg.RetrieveAuditLogRequest.decode(n, n.uint32());
            break;
          }
          case 8: {
            l.publishDatasetToDataRoomRequest = $root.gcg.PublishDatasetToDataRoomRequest.decode(n, n.uint32());
            break;
          }
          case 9: {
            l.retrievePublishedDatasetsRequest = $root.gcg.RetrievePublishedDatasetsRequest.decode(n, n.uint32());
            break;
          }
          case 10: {
            l.removePublishedDatasetRequest = $root.gcg.RemovePublishedDatasetRequest.decode(n, n.uint32());
            break;
          }
          case 11: {
            l.executeComputeRequest = $root.gcg.ExecuteComputeRequest.decode(n, n.uint32());
            break;
          }
          case 12: {
            l.jobStatusRequest = $root.gcg.JobStatusRequest.decode(n, n.uint32());
            break;
          }
          case 13: {
            l.getResultsRequest = $root.gcg.GetResultsRequest.decode(n, n.uint32());
            break;
          }
          case 14: {
            l.createConfigurationCommitRequest = $root.gcg.CreateConfigurationCommitRequest.decode(n, n.uint32());
            break;
          }
          case 15: {
            l.retrieveConfigurationCommitRequest = $root.gcg.RetrieveConfigurationCommitRequest.decode(n, n.uint32());
            break;
          }
          case 16: {
            l.executeDevelopmentComputeRequest = $root.gcg.ExecuteDevelopmentComputeRequest.decode(n, n.uint32());
            break;
          }
          case 17: {
            l.generateMergeApprovalSignatureRequest = $root.gcg.GenerateMergeApprovalSignatureRequest.decode(n, n.uint32());
            break;
          }
          case 18: {
            l.mergeConfigurationCommitRequest = $root.gcg.MergeConfigurationCommitRequest.decode(n, n.uint32());
            break;
          }
          case 19: {
            l.retrieveConfigurationCommitApproversRequest = $root.gcg.RetrieveConfigurationCommitApproversRequest.decode(n, n.uint32());
            break;
          }
          case 20: {
            l.casAuxiliaryStateRequest = $root.gcg.CasAuxiliaryStateRequest.decode(n, n.uint32());
            break;
          }
          case 21: {
            l.readAuxiliaryStateRequest = $root.gcg.ReadAuxiliaryStateRequest.decode(n, n.uint32());
            break;
          }
          case 22: {
            l.retrieveUsedAirlockQuotaRequest = $root.gcg.RetrieveUsedAirlockQuotaRequest.decode(n, n.uint32());
            break;
          }
          case 23: {
            l.getResultsSizeRequest = $root.gcg.GetResultsSizeRequest.decode(n, n.uint32());
            break;
          }
          case 101: {
            l.endorsementRequest = $root.identity_endorsement.EndorsementRequest.decode(n, n.uint32());
            break;
          }
          default:
            n.skipType(d & 7);
            break;
        }
      }
      return l;
    }, r.decodeDelimited = function(n) {
      return n instanceof $Reader || (n = new $Reader(n)), this.decode(n, n.uint32());
    }, r.verify = function(n) {
      if (typeof n != "object" || n === null)
        return "object expected";
      let o = {};
      if (n.userAuth != null && n.hasOwnProperty("userAuth")) {
        let c = $root.gcg.UserAuth.verify(n.userAuth);
        if (c)
          return "userAuth." + c;
      }
      if (n.createDataRoomRequest != null && n.hasOwnProperty("createDataRoomRequest")) {
        o.gcgRequest = 1;
        {
          let c = $root.gcg.CreateDataRoomRequest.verify(n.createDataRoomRequest);
          if (c)
            return "createDataRoomRequest." + c;
        }
      }
      if (n.retrieveDataRoomRequest != null && n.hasOwnProperty("retrieveDataRoomRequest")) {
        if (o.gcgRequest === 1)
          return "gcgRequest: multiple values";
        o.gcgRequest = 1;
        {
          let c = $root.gcg.RetrieveDataRoomRequest.verify(n.retrieveDataRoomRequest);
          if (c)
            return "retrieveDataRoomRequest." + c;
        }
      }
      if (n.retrieveCurrentDataRoomConfigurationRequest != null && n.hasOwnProperty("retrieveCurrentDataRoomConfigurationRequest")) {
        if (o.gcgRequest === 1)
          return "gcgRequest: multiple values";
        o.gcgRequest = 1;
        {
          let c = $root.gcg.RetrieveCurrentDataRoomConfigurationRequest.verify(n.retrieveCurrentDataRoomConfigurationRequest);
          if (c)
            return "retrieveCurrentDataRoomConfigurationRequest." + c;
        }
      }
      if (n.retrieveDataRoomStatusRequest != null && n.hasOwnProperty("retrieveDataRoomStatusRequest")) {
        if (o.gcgRequest === 1)
          return "gcgRequest: multiple values";
        o.gcgRequest = 1;
        {
          let c = $root.gcg.RetrieveDataRoomStatusRequest.verify(n.retrieveDataRoomStatusRequest);
          if (c)
            return "retrieveDataRoomStatusRequest." + c;
        }
      }
      if (n.updateDataRoomStatusRequest != null && n.hasOwnProperty("updateDataRoomStatusRequest")) {
        if (o.gcgRequest === 1)
          return "gcgRequest: multiple values";
        o.gcgRequest = 1;
        {
          let c = $root.gcg.UpdateDataRoomStatusRequest.verify(n.updateDataRoomStatusRequest);
          if (c)
            return "updateDataRoomStatusRequest." + c;
        }
      }
      if (n.retrieveAuditLogRequest != null && n.hasOwnProperty("retrieveAuditLogRequest")) {
        if (o.gcgRequest === 1)
          return "gcgRequest: multiple values";
        o.gcgRequest = 1;
        {
          let c = $root.gcg.RetrieveAuditLogRequest.verify(n.retrieveAuditLogRequest);
          if (c)
            return "retrieveAuditLogRequest." + c;
        }
      }
      if (n.publishDatasetToDataRoomRequest != null && n.hasOwnProperty("publishDatasetToDataRoomRequest")) {
        if (o.gcgRequest === 1)
          return "gcgRequest: multiple values";
        o.gcgRequest = 1;
        {
          let c = $root.gcg.PublishDatasetToDataRoomRequest.verify(n.publishDatasetToDataRoomRequest);
          if (c)
            return "publishDatasetToDataRoomRequest." + c;
        }
      }
      if (n.retrievePublishedDatasetsRequest != null && n.hasOwnProperty("retrievePublishedDatasetsRequest")) {
        if (o.gcgRequest === 1)
          return "gcgRequest: multiple values";
        o.gcgRequest = 1;
        {
          let c = $root.gcg.RetrievePublishedDatasetsRequest.verify(n.retrievePublishedDatasetsRequest);
          if (c)
            return "retrievePublishedDatasetsRequest." + c;
        }
      }
      if (n.removePublishedDatasetRequest != null && n.hasOwnProperty("removePublishedDatasetRequest")) {
        if (o.gcgRequest === 1)
          return "gcgRequest: multiple values";
        o.gcgRequest = 1;
        {
          let c = $root.gcg.RemovePublishedDatasetRequest.verify(n.removePublishedDatasetRequest);
          if (c)
            return "removePublishedDatasetRequest." + c;
        }
      }
      if (n.executeComputeRequest != null && n.hasOwnProperty("executeComputeRequest")) {
        if (o.gcgRequest === 1)
          return "gcgRequest: multiple values";
        o.gcgRequest = 1;
        {
          let c = $root.gcg.ExecuteComputeRequest.verify(n.executeComputeRequest);
          if (c)
            return "executeComputeRequest." + c;
        }
      }
      if (n.jobStatusRequest != null && n.hasOwnProperty("jobStatusRequest")) {
        if (o.gcgRequest === 1)
          return "gcgRequest: multiple values";
        o.gcgRequest = 1;
        {
          let c = $root.gcg.JobStatusRequest.verify(n.jobStatusRequest);
          if (c)
            return "jobStatusRequest." + c;
        }
      }
      if (n.getResultsRequest != null && n.hasOwnProperty("getResultsRequest")) {
        if (o.gcgRequest === 1)
          return "gcgRequest: multiple values";
        o.gcgRequest = 1;
        {
          let c = $root.gcg.GetResultsRequest.verify(n.getResultsRequest);
          if (c)
            return "getResultsRequest." + c;
        }
      }
      if (n.createConfigurationCommitRequest != null && n.hasOwnProperty("createConfigurationCommitRequest")) {
        if (o.gcgRequest === 1)
          return "gcgRequest: multiple values";
        o.gcgRequest = 1;
        {
          let c = $root.gcg.CreateConfigurationCommitRequest.verify(n.createConfigurationCommitRequest);
          if (c)
            return "createConfigurationCommitRequest." + c;
        }
      }
      if (n.retrieveConfigurationCommitRequest != null && n.hasOwnProperty("retrieveConfigurationCommitRequest")) {
        if (o.gcgRequest === 1)
          return "gcgRequest: multiple values";
        o.gcgRequest = 1;
        {
          let c = $root.gcg.RetrieveConfigurationCommitRequest.verify(n.retrieveConfigurationCommitRequest);
          if (c)
            return "retrieveConfigurationCommitRequest." + c;
        }
      }
      if (n.executeDevelopmentComputeRequest != null && n.hasOwnProperty("executeDevelopmentComputeRequest")) {
        if (o.gcgRequest === 1)
          return "gcgRequest: multiple values";
        o.gcgRequest = 1;
        {
          let c = $root.gcg.ExecuteDevelopmentComputeRequest.verify(n.executeDevelopmentComputeRequest);
          if (c)
            return "executeDevelopmentComputeRequest." + c;
        }
      }
      if (n.generateMergeApprovalSignatureRequest != null && n.hasOwnProperty("generateMergeApprovalSignatureRequest")) {
        if (o.gcgRequest === 1)
          return "gcgRequest: multiple values";
        o.gcgRequest = 1;
        {
          let c = $root.gcg.GenerateMergeApprovalSignatureRequest.verify(n.generateMergeApprovalSignatureRequest);
          if (c)
            return "generateMergeApprovalSignatureRequest." + c;
        }
      }
      if (n.mergeConfigurationCommitRequest != null && n.hasOwnProperty("mergeConfigurationCommitRequest")) {
        if (o.gcgRequest === 1)
          return "gcgRequest: multiple values";
        o.gcgRequest = 1;
        {
          let c = $root.gcg.MergeConfigurationCommitRequest.verify(n.mergeConfigurationCommitRequest);
          if (c)
            return "mergeConfigurationCommitRequest." + c;
        }
      }
      if (n.retrieveConfigurationCommitApproversRequest != null && n.hasOwnProperty("retrieveConfigurationCommitApproversRequest")) {
        if (o.gcgRequest === 1)
          return "gcgRequest: multiple values";
        o.gcgRequest = 1;
        {
          let c = $root.gcg.RetrieveConfigurationCommitApproversRequest.verify(n.retrieveConfigurationCommitApproversRequest);
          if (c)
            return "retrieveConfigurationCommitApproversRequest." + c;
        }
      }
      if (n.casAuxiliaryStateRequest != null && n.hasOwnProperty("casAuxiliaryStateRequest")) {
        if (o.gcgRequest === 1)
          return "gcgRequest: multiple values";
        o.gcgRequest = 1;
        {
          let c = $root.gcg.CasAuxiliaryStateRequest.verify(n.casAuxiliaryStateRequest);
          if (c)
            return "casAuxiliaryStateRequest." + c;
        }
      }
      if (n.readAuxiliaryStateRequest != null && n.hasOwnProperty("readAuxiliaryStateRequest")) {
        if (o.gcgRequest === 1)
          return "gcgRequest: multiple values";
        o.gcgRequest = 1;
        {
          let c = $root.gcg.ReadAuxiliaryStateRequest.verify(n.readAuxiliaryStateRequest);
          if (c)
            return "readAuxiliaryStateRequest." + c;
        }
      }
      if (n.retrieveUsedAirlockQuotaRequest != null && n.hasOwnProperty("retrieveUsedAirlockQuotaRequest")) {
        if (o.gcgRequest === 1)
          return "gcgRequest: multiple values";
        o.gcgRequest = 1;
        {
          let c = $root.gcg.RetrieveUsedAirlockQuotaRequest.verify(n.retrieveUsedAirlockQuotaRequest);
          if (c)
            return "retrieveUsedAirlockQuotaRequest." + c;
        }
      }
      if (n.getResultsSizeRequest != null && n.hasOwnProperty("getResultsSizeRequest")) {
        if (o.gcgRequest === 1)
          return "gcgRequest: multiple values";
        o.gcgRequest = 1;
        {
          let c = $root.gcg.GetResultsSizeRequest.verify(n.getResultsSizeRequest);
          if (c)
            return "getResultsSizeRequest." + c;
        }
      }
      if (n.endorsementRequest != null && n.hasOwnProperty("endorsementRequest")) {
        if (o.gcgRequest === 1)
          return "gcgRequest: multiple values";
        o.gcgRequest = 1;
        {
          let c = $root.identity_endorsement.EndorsementRequest.verify(n.endorsementRequest);
          if (c)
            return "endorsementRequest." + c;
        }
      }
      return null;
    }, r.fromObject = function(n) {
      if (n instanceof $root.gcg.GcgRequest)
        return n;
      let o = new $root.gcg.GcgRequest();
      if (n.userAuth != null) {
        if (typeof n.userAuth != "object")
          throw TypeError(".gcg.GcgRequest.userAuth: object expected");
        o.userAuth = $root.gcg.UserAuth.fromObject(n.userAuth);
      }
      if (n.createDataRoomRequest != null) {
        if (typeof n.createDataRoomRequest != "object")
          throw TypeError(".gcg.GcgRequest.createDataRoomRequest: object expected");
        o.createDataRoomRequest = $root.gcg.CreateDataRoomRequest.fromObject(n.createDataRoomRequest);
      }
      if (n.retrieveDataRoomRequest != null) {
        if (typeof n.retrieveDataRoomRequest != "object")
          throw TypeError(".gcg.GcgRequest.retrieveDataRoomRequest: object expected");
        o.retrieveDataRoomRequest = $root.gcg.RetrieveDataRoomRequest.fromObject(n.retrieveDataRoomRequest);
      }
      if (n.retrieveCurrentDataRoomConfigurationRequest != null) {
        if (typeof n.retrieveCurrentDataRoomConfigurationRequest != "object")
          throw TypeError(".gcg.GcgRequest.retrieveCurrentDataRoomConfigurationRequest: object expected");
        o.retrieveCurrentDataRoomConfigurationRequest = $root.gcg.RetrieveCurrentDataRoomConfigurationRequest.fromObject(n.retrieveCurrentDataRoomConfigurationRequest);
      }
      if (n.retrieveDataRoomStatusRequest != null) {
        if (typeof n.retrieveDataRoomStatusRequest != "object")
          throw TypeError(".gcg.GcgRequest.retrieveDataRoomStatusRequest: object expected");
        o.retrieveDataRoomStatusRequest = $root.gcg.RetrieveDataRoomStatusRequest.fromObject(n.retrieveDataRoomStatusRequest);
      }
      if (n.updateDataRoomStatusRequest != null) {
        if (typeof n.updateDataRoomStatusRequest != "object")
          throw TypeError(".gcg.GcgRequest.updateDataRoomStatusRequest: object expected");
        o.updateDataRoomStatusRequest = $root.gcg.UpdateDataRoomStatusRequest.fromObject(n.updateDataRoomStatusRequest);
      }
      if (n.retrieveAuditLogRequest != null) {
        if (typeof n.retrieveAuditLogRequest != "object")
          throw TypeError(".gcg.GcgRequest.retrieveAuditLogRequest: object expected");
        o.retrieveAuditLogRequest = $root.gcg.RetrieveAuditLogRequest.fromObject(n.retrieveAuditLogRequest);
      }
      if (n.publishDatasetToDataRoomRequest != null) {
        if (typeof n.publishDatasetToDataRoomRequest != "object")
          throw TypeError(".gcg.GcgRequest.publishDatasetToDataRoomRequest: object expected");
        o.publishDatasetToDataRoomRequest = $root.gcg.PublishDatasetToDataRoomRequest.fromObject(n.publishDatasetToDataRoomRequest);
      }
      if (n.retrievePublishedDatasetsRequest != null) {
        if (typeof n.retrievePublishedDatasetsRequest != "object")
          throw TypeError(".gcg.GcgRequest.retrievePublishedDatasetsRequest: object expected");
        o.retrievePublishedDatasetsRequest = $root.gcg.RetrievePublishedDatasetsRequest.fromObject(n.retrievePublishedDatasetsRequest);
      }
      if (n.removePublishedDatasetRequest != null) {
        if (typeof n.removePublishedDatasetRequest != "object")
          throw TypeError(".gcg.GcgRequest.removePublishedDatasetRequest: object expected");
        o.removePublishedDatasetRequest = $root.gcg.RemovePublishedDatasetRequest.fromObject(n.removePublishedDatasetRequest);
      }
      if (n.executeComputeRequest != null) {
        if (typeof n.executeComputeRequest != "object")
          throw TypeError(".gcg.GcgRequest.executeComputeRequest: object expected");
        o.executeComputeRequest = $root.gcg.ExecuteComputeRequest.fromObject(n.executeComputeRequest);
      }
      if (n.jobStatusRequest != null) {
        if (typeof n.jobStatusRequest != "object")
          throw TypeError(".gcg.GcgRequest.jobStatusRequest: object expected");
        o.jobStatusRequest = $root.gcg.JobStatusRequest.fromObject(n.jobStatusRequest);
      }
      if (n.getResultsRequest != null) {
        if (typeof n.getResultsRequest != "object")
          throw TypeError(".gcg.GcgRequest.getResultsRequest: object expected");
        o.getResultsRequest = $root.gcg.GetResultsRequest.fromObject(n.getResultsRequest);
      }
      if (n.createConfigurationCommitRequest != null) {
        if (typeof n.createConfigurationCommitRequest != "object")
          throw TypeError(".gcg.GcgRequest.createConfigurationCommitRequest: object expected");
        o.createConfigurationCommitRequest = $root.gcg.CreateConfigurationCommitRequest.fromObject(n.createConfigurationCommitRequest);
      }
      if (n.retrieveConfigurationCommitRequest != null) {
        if (typeof n.retrieveConfigurationCommitRequest != "object")
          throw TypeError(".gcg.GcgRequest.retrieveConfigurationCommitRequest: object expected");
        o.retrieveConfigurationCommitRequest = $root.gcg.RetrieveConfigurationCommitRequest.fromObject(n.retrieveConfigurationCommitRequest);
      }
      if (n.executeDevelopmentComputeRequest != null) {
        if (typeof n.executeDevelopmentComputeRequest != "object")
          throw TypeError(".gcg.GcgRequest.executeDevelopmentComputeRequest: object expected");
        o.executeDevelopmentComputeRequest = $root.gcg.ExecuteDevelopmentComputeRequest.fromObject(n.executeDevelopmentComputeRequest);
      }
      if (n.generateMergeApprovalSignatureRequest != null) {
        if (typeof n.generateMergeApprovalSignatureRequest != "object")
          throw TypeError(".gcg.GcgRequest.generateMergeApprovalSignatureRequest: object expected");
        o.generateMergeApprovalSignatureRequest = $root.gcg.GenerateMergeApprovalSignatureRequest.fromObject(n.generateMergeApprovalSignatureRequest);
      }
      if (n.mergeConfigurationCommitRequest != null) {
        if (typeof n.mergeConfigurationCommitRequest != "object")
          throw TypeError(".gcg.GcgRequest.mergeConfigurationCommitRequest: object expected");
        o.mergeConfigurationCommitRequest = $root.gcg.MergeConfigurationCommitRequest.fromObject(n.mergeConfigurationCommitRequest);
      }
      if (n.retrieveConfigurationCommitApproversRequest != null) {
        if (typeof n.retrieveConfigurationCommitApproversRequest != "object")
          throw TypeError(".gcg.GcgRequest.retrieveConfigurationCommitApproversRequest: object expected");
        o.retrieveConfigurationCommitApproversRequest = $root.gcg.RetrieveConfigurationCommitApproversRequest.fromObject(n.retrieveConfigurationCommitApproversRequest);
      }
      if (n.casAuxiliaryStateRequest != null) {
        if (typeof n.casAuxiliaryStateRequest != "object")
          throw TypeError(".gcg.GcgRequest.casAuxiliaryStateRequest: object expected");
        o.casAuxiliaryStateRequest = $root.gcg.CasAuxiliaryStateRequest.fromObject(n.casAuxiliaryStateRequest);
      }
      if (n.readAuxiliaryStateRequest != null) {
        if (typeof n.readAuxiliaryStateRequest != "object")
          throw TypeError(".gcg.GcgRequest.readAuxiliaryStateRequest: object expected");
        o.readAuxiliaryStateRequest = $root.gcg.ReadAuxiliaryStateRequest.fromObject(n.readAuxiliaryStateRequest);
      }
      if (n.retrieveUsedAirlockQuotaRequest != null) {
        if (typeof n.retrieveUsedAirlockQuotaRequest != "object")
          throw TypeError(".gcg.GcgRequest.retrieveUsedAirlockQuotaRequest: object expected");
        o.retrieveUsedAirlockQuotaRequest = $root.gcg.RetrieveUsedAirlockQuotaRequest.fromObject(n.retrieveUsedAirlockQuotaRequest);
      }
      if (n.getResultsSizeRequest != null) {
        if (typeof n.getResultsSizeRequest != "object")
          throw TypeError(".gcg.GcgRequest.getResultsSizeRequest: object expected");
        o.getResultsSizeRequest = $root.gcg.GetResultsSizeRequest.fromObject(n.getResultsSizeRequest);
      }
      if (n.endorsementRequest != null) {
        if (typeof n.endorsementRequest != "object")
          throw TypeError(".gcg.GcgRequest.endorsementRequest: object expected");
        o.endorsementRequest = $root.identity_endorsement.EndorsementRequest.fromObject(n.endorsementRequest);
      }
      return o;
    }, r.toObject = function(n, o) {
      o || (o = {});
      let c = {};
      return o.defaults && (c.userAuth = null), n.userAuth != null && n.hasOwnProperty("userAuth") && (c.userAuth = $root.gcg.UserAuth.toObject(n.userAuth, o)), n.createDataRoomRequest != null && n.hasOwnProperty("createDataRoomRequest") && (c.createDataRoomRequest = $root.gcg.CreateDataRoomRequest.toObject(n.createDataRoomRequest, o), o.oneofs && (c.gcgRequest = "createDataRoomRequest")), n.retrieveDataRoomRequest != null && n.hasOwnProperty("retrieveDataRoomRequest") && (c.retrieveDataRoomRequest = $root.gcg.RetrieveDataRoomRequest.toObject(n.retrieveDataRoomRequest, o), o.oneofs && (c.gcgRequest = "retrieveDataRoomRequest")), n.retrieveCurrentDataRoomConfigurationRequest != null && n.hasOwnProperty("retrieveCurrentDataRoomConfigurationRequest") && (c.retrieveCurrentDataRoomConfigurationRequest = $root.gcg.RetrieveCurrentDataRoomConfigurationRequest.toObject(n.retrieveCurrentDataRoomConfigurationRequest, o), o.oneofs && (c.gcgRequest = "retrieveCurrentDataRoomConfigurationRequest")), n.retrieveDataRoomStatusRequest != null && n.hasOwnProperty("retrieveDataRoomStatusRequest") && (c.retrieveDataRoomStatusRequest = $root.gcg.RetrieveDataRoomStatusRequest.toObject(n.retrieveDataRoomStatusRequest, o), o.oneofs && (c.gcgRequest = "retrieveDataRoomStatusRequest")), n.updateDataRoomStatusRequest != null && n.hasOwnProperty("updateDataRoomStatusRequest") && (c.updateDataRoomStatusRequest = $root.gcg.UpdateDataRoomStatusRequest.toObject(n.updateDataRoomStatusRequest, o), o.oneofs && (c.gcgRequest = "updateDataRoomStatusRequest")), n.retrieveAuditLogRequest != null && n.hasOwnProperty("retrieveAuditLogRequest") && (c.retrieveAuditLogRequest = $root.gcg.RetrieveAuditLogRequest.toObject(n.retrieveAuditLogRequest, o), o.oneofs && (c.gcgRequest = "retrieveAuditLogRequest")), n.publishDatasetToDataRoomRequest != null && n.hasOwnProperty("publishDatasetToDataRoomRequest") && (c.publishDatasetToDataRoomRequest = $root.gcg.PublishDatasetToDataRoomRequest.toObject(n.publishDatasetToDataRoomRequest, o), o.oneofs && (c.gcgRequest = "publishDatasetToDataRoomRequest")), n.retrievePublishedDatasetsRequest != null && n.hasOwnProperty("retrievePublishedDatasetsRequest") && (c.retrievePublishedDatasetsRequest = $root.gcg.RetrievePublishedDatasetsRequest.toObject(n.retrievePublishedDatasetsRequest, o), o.oneofs && (c.gcgRequest = "retrievePublishedDatasetsRequest")), n.removePublishedDatasetRequest != null && n.hasOwnProperty("removePublishedDatasetRequest") && (c.removePublishedDatasetRequest = $root.gcg.RemovePublishedDatasetRequest.toObject(n.removePublishedDatasetRequest, o), o.oneofs && (c.gcgRequest = "removePublishedDatasetRequest")), n.executeComputeRequest != null && n.hasOwnProperty("executeComputeRequest") && (c.executeComputeRequest = $root.gcg.ExecuteComputeRequest.toObject(n.executeComputeRequest, o), o.oneofs && (c.gcgRequest = "executeComputeRequest")), n.jobStatusRequest != null && n.hasOwnProperty("jobStatusRequest") && (c.jobStatusRequest = $root.gcg.JobStatusRequest.toObject(n.jobStatusRequest, o), o.oneofs && (c.gcgRequest = "jobStatusRequest")), n.getResultsRequest != null && n.hasOwnProperty("getResultsRequest") && (c.getResultsRequest = $root.gcg.GetResultsRequest.toObject(n.getResultsRequest, o), o.oneofs && (c.gcgRequest = "getResultsRequest")), n.createConfigurationCommitRequest != null && n.hasOwnProperty("createConfigurationCommitRequest") && (c.createConfigurationCommitRequest = $root.gcg.CreateConfigurationCommitRequest.toObject(n.createConfigurationCommitRequest, o), o.oneofs && (c.gcgRequest = "createConfigurationCommitRequest")), n.retrieveConfigurationCommitRequest != null && n.hasOwnProperty("retrieveConfigurationCommitRequest") && (c.retrieveConfigurationCommitRequest = $root.gcg.RetrieveConfigurationCommitRequest.toObject(n.retrieveConfigurationCommitRequest, o), o.oneofs && (c.gcgRequest = "retrieveConfigurationCommitRequest")), n.executeDevelopmentComputeRequest != null && n.hasOwnProperty("executeDevelopmentComputeRequest") && (c.executeDevelopmentComputeRequest = $root.gcg.ExecuteDevelopmentComputeRequest.toObject(n.executeDevelopmentComputeRequest, o), o.oneofs && (c.gcgRequest = "executeDevelopmentComputeRequest")), n.generateMergeApprovalSignatureRequest != null && n.hasOwnProperty("generateMergeApprovalSignatureRequest") && (c.generateMergeApprovalSignatureRequest = $root.gcg.GenerateMergeApprovalSignatureRequest.toObject(n.generateMergeApprovalSignatureRequest, o), o.oneofs && (c.gcgRequest = "generateMergeApprovalSignatureRequest")), n.mergeConfigurationCommitRequest != null && n.hasOwnProperty("mergeConfigurationCommitRequest") && (c.mergeConfigurationCommitRequest = $root.gcg.MergeConfigurationCommitRequest.toObject(n.mergeConfigurationCommitRequest, o), o.oneofs && (c.gcgRequest = "mergeConfigurationCommitRequest")), n.retrieveConfigurationCommitApproversRequest != null && n.hasOwnProperty("retrieveConfigurationCommitApproversRequest") && (c.retrieveConfigurationCommitApproversRequest = $root.gcg.RetrieveConfigurationCommitApproversRequest.toObject(n.retrieveConfigurationCommitApproversRequest, o), o.oneofs && (c.gcgRequest = "retrieveConfigurationCommitApproversRequest")), n.casAuxiliaryStateRequest != null && n.hasOwnProperty("casAuxiliaryStateRequest") && (c.casAuxiliaryStateRequest = $root.gcg.CasAuxiliaryStateRequest.toObject(n.casAuxiliaryStateRequest, o), o.oneofs && (c.gcgRequest = "casAuxiliaryStateRequest")), n.readAuxiliaryStateRequest != null && n.hasOwnProperty("readAuxiliaryStateRequest") && (c.readAuxiliaryStateRequest = $root.gcg.ReadAuxiliaryStateRequest.toObject(n.readAuxiliaryStateRequest, o), o.oneofs && (c.gcgRequest = "readAuxiliaryStateRequest")), n.retrieveUsedAirlockQuotaRequest != null && n.hasOwnProperty("retrieveUsedAirlockQuotaRequest") && (c.retrieveUsedAirlockQuotaRequest = $root.gcg.RetrieveUsedAirlockQuotaRequest.toObject(n.retrieveUsedAirlockQuotaRequest, o), o.oneofs && (c.gcgRequest = "retrieveUsedAirlockQuotaRequest")), n.getResultsSizeRequest != null && n.hasOwnProperty("getResultsSizeRequest") && (c.getResultsSizeRequest = $root.gcg.GetResultsSizeRequest.toObject(n.getResultsSizeRequest, o), o.oneofs && (c.gcgRequest = "getResultsSizeRequest")), n.endorsementRequest != null && n.hasOwnProperty("endorsementRequest") && (c.endorsementRequest = $root.identity_endorsement.EndorsementRequest.toObject(n.endorsementRequest, o), o.oneofs && (c.gcgRequest = "endorsementRequest")), c;
    }, r.prototype.toJSON = function() {
      return this.constructor.toObject(this, minimal.util.toJSONOptions);
    }, r.getTypeUrl = function(n) {
      return n === void 0 && (n = "type.googleapis.com"), n + "/gcg.GcgRequest";
    }, r;
  }(), u.GcgResponse = function() {
    function r(e) {
      if (e)
        for (let n = Object.keys(e), o = 0; o < n.length; ++o)
          e[n[o]] != null && (this[n[o]] = e[n[o]]);
    }
    r.prototype.failure = null, r.prototype.createDataRoomResponse = null, r.prototype.retrieveDataRoomResponse = null, r.prototype.retrieveCurrentDataRoomConfigurationResponse = null, r.prototype.retrieveDataRoomStatusResponse = null, r.prototype.updateDataRoomStatusResponse = null, r.prototype.retrieveAuditLogResponse = null, r.prototype.publishDatasetToDataRoomResponse = null, r.prototype.retrievePublishedDatasetsResponse = null, r.prototype.removePublishedDatasetResponse = null, r.prototype.executeComputeResponse = null, r.prototype.jobStatusResponse = null, r.prototype.getResultsResponseChunk = null, r.prototype.getResultsResponseFooter = null, r.prototype.createConfigurationCommitResponse = null, r.prototype.retrieveConfigurationCommitResponse = null, r.prototype.generateMergeApprovalSignatureResponse = null, r.prototype.mergeConfigurationCommitResponse = null, r.prototype.retrieveConfigurationCommitApproversResponse = null, r.prototype.casAuxiliaryStateResponse = null, r.prototype.readAuxiliaryStateResponse = null, r.prototype.retrieveUsedAirlockQuotaResponse = null, r.prototype.getResultsSizeResponse = null, r.prototype.endorsementResponse = null;
    let a;
    return Object.defineProperty(r.prototype, "gcgResponse", {
      get: $util.oneOfGetter(a = ["failure", "createDataRoomResponse", "retrieveDataRoomResponse", "retrieveCurrentDataRoomConfigurationResponse", "retrieveDataRoomStatusResponse", "updateDataRoomStatusResponse", "retrieveAuditLogResponse", "publishDatasetToDataRoomResponse", "retrievePublishedDatasetsResponse", "removePublishedDatasetResponse", "executeComputeResponse", "jobStatusResponse", "getResultsResponseChunk", "getResultsResponseFooter", "createConfigurationCommitResponse", "retrieveConfigurationCommitResponse", "generateMergeApprovalSignatureResponse", "mergeConfigurationCommitResponse", "retrieveConfigurationCommitApproversResponse", "casAuxiliaryStateResponse", "readAuxiliaryStateResponse", "retrieveUsedAirlockQuotaResponse", "getResultsSizeResponse", "endorsementResponse"]),
      set: $util.oneOfSetter(a)
    }), r.create = function(n) {
      return new r(n);
    }, r.encode = function(n, o) {
      return o || (o = $Writer.create()), n.failure != null && Object.hasOwnProperty.call(n, "failure") && o.uint32(
        /* id 1, wireType 2 =*/
        10
      ).string(n.failure), n.createDataRoomResponse != null && Object.hasOwnProperty.call(n, "createDataRoomResponse") && $root.gcg.CreateDataRoomResponse.encode(n.createDataRoomResponse, o.uint32(
        /* id 2, wireType 2 =*/
        18
      ).fork()).ldelim(), n.retrieveDataRoomResponse != null && Object.hasOwnProperty.call(n, "retrieveDataRoomResponse") && $root.gcg.RetrieveDataRoomResponse.encode(n.retrieveDataRoomResponse, o.uint32(
        /* id 3, wireType 2 =*/
        26
      ).fork()).ldelim(), n.retrieveCurrentDataRoomConfigurationResponse != null && Object.hasOwnProperty.call(n, "retrieveCurrentDataRoomConfigurationResponse") && $root.gcg.RetrieveCurrentDataRoomConfigurationResponse.encode(n.retrieveCurrentDataRoomConfigurationResponse, o.uint32(
        /* id 4, wireType 2 =*/
        34
      ).fork()).ldelim(), n.retrieveDataRoomStatusResponse != null && Object.hasOwnProperty.call(n, "retrieveDataRoomStatusResponse") && $root.gcg.RetrieveDataRoomStatusResponse.encode(n.retrieveDataRoomStatusResponse, o.uint32(
        /* id 5, wireType 2 =*/
        42
      ).fork()).ldelim(), n.updateDataRoomStatusResponse != null && Object.hasOwnProperty.call(n, "updateDataRoomStatusResponse") && $root.gcg.UpdateDataRoomStatusResponse.encode(n.updateDataRoomStatusResponse, o.uint32(
        /* id 6, wireType 2 =*/
        50
      ).fork()).ldelim(), n.retrieveAuditLogResponse != null && Object.hasOwnProperty.call(n, "retrieveAuditLogResponse") && $root.gcg.RetrieveAuditLogResponse.encode(n.retrieveAuditLogResponse, o.uint32(
        /* id 7, wireType 2 =*/
        58
      ).fork()).ldelim(), n.publishDatasetToDataRoomResponse != null && Object.hasOwnProperty.call(n, "publishDatasetToDataRoomResponse") && $root.gcg.PublishDatasetToDataRoomResponse.encode(n.publishDatasetToDataRoomResponse, o.uint32(
        /* id 8, wireType 2 =*/
        66
      ).fork()).ldelim(), n.retrievePublishedDatasetsResponse != null && Object.hasOwnProperty.call(n, "retrievePublishedDatasetsResponse") && $root.gcg.RetrievePublishedDatasetsResponse.encode(n.retrievePublishedDatasetsResponse, o.uint32(
        /* id 9, wireType 2 =*/
        74
      ).fork()).ldelim(), n.removePublishedDatasetResponse != null && Object.hasOwnProperty.call(n, "removePublishedDatasetResponse") && $root.gcg.RemovePublishedDatasetResponse.encode(n.removePublishedDatasetResponse, o.uint32(
        /* id 10, wireType 2 =*/
        82
      ).fork()).ldelim(), n.executeComputeResponse != null && Object.hasOwnProperty.call(n, "executeComputeResponse") && $root.gcg.ExecuteComputeResponse.encode(n.executeComputeResponse, o.uint32(
        /* id 11, wireType 2 =*/
        90
      ).fork()).ldelim(), n.jobStatusResponse != null && Object.hasOwnProperty.call(n, "jobStatusResponse") && $root.gcg.JobStatusResponse.encode(n.jobStatusResponse, o.uint32(
        /* id 12, wireType 2 =*/
        98
      ).fork()).ldelim(), n.getResultsResponseChunk != null && Object.hasOwnProperty.call(n, "getResultsResponseChunk") && $root.gcg.GetResultsResponseChunk.encode(n.getResultsResponseChunk, o.uint32(
        /* id 13, wireType 2 =*/
        106
      ).fork()).ldelim(), n.getResultsResponseFooter != null && Object.hasOwnProperty.call(n, "getResultsResponseFooter") && $root.gcg.GetResultsResponseFooter.encode(n.getResultsResponseFooter, o.uint32(
        /* id 14, wireType 2 =*/
        114
      ).fork()).ldelim(), n.createConfigurationCommitResponse != null && Object.hasOwnProperty.call(n, "createConfigurationCommitResponse") && $root.gcg.CreateConfigurationCommitResponse.encode(n.createConfigurationCommitResponse, o.uint32(
        /* id 15, wireType 2 =*/
        122
      ).fork()).ldelim(), n.retrieveConfigurationCommitResponse != null && Object.hasOwnProperty.call(n, "retrieveConfigurationCommitResponse") && $root.gcg.RetrieveConfigurationCommitResponse.encode(n.retrieveConfigurationCommitResponse, o.uint32(
        /* id 16, wireType 2 =*/
        130
      ).fork()).ldelim(), n.generateMergeApprovalSignatureResponse != null && Object.hasOwnProperty.call(n, "generateMergeApprovalSignatureResponse") && $root.gcg.GenerateMergeApprovalSignatureResponse.encode(n.generateMergeApprovalSignatureResponse, o.uint32(
        /* id 17, wireType 2 =*/
        138
      ).fork()).ldelim(), n.mergeConfigurationCommitResponse != null && Object.hasOwnProperty.call(n, "mergeConfigurationCommitResponse") && $root.gcg.MergeConfigurationCommitResponse.encode(n.mergeConfigurationCommitResponse, o.uint32(
        /* id 18, wireType 2 =*/
        146
      ).fork()).ldelim(), n.retrieveConfigurationCommitApproversResponse != null && Object.hasOwnProperty.call(n, "retrieveConfigurationCommitApproversResponse") && $root.gcg.RetrieveConfigurationCommitApproversResponse.encode(n.retrieveConfigurationCommitApproversResponse, o.uint32(
        /* id 19, wireType 2 =*/
        154
      ).fork()).ldelim(), n.casAuxiliaryStateResponse != null && Object.hasOwnProperty.call(n, "casAuxiliaryStateResponse") && $root.gcg.CasAuxiliaryStateResponse.encode(n.casAuxiliaryStateResponse, o.uint32(
        /* id 20, wireType 2 =*/
        162
      ).fork()).ldelim(), n.readAuxiliaryStateResponse != null && Object.hasOwnProperty.call(n, "readAuxiliaryStateResponse") && $root.gcg.ReadAuxiliaryStateResponse.encode(n.readAuxiliaryStateResponse, o.uint32(
        /* id 21, wireType 2 =*/
        170
      ).fork()).ldelim(), n.retrieveUsedAirlockQuotaResponse != null && Object.hasOwnProperty.call(n, "retrieveUsedAirlockQuotaResponse") && $root.gcg.RetrieveUsedAirlockQuotaResponse.encode(n.retrieveUsedAirlockQuotaResponse, o.uint32(
        /* id 22, wireType 2 =*/
        178
      ).fork()).ldelim(), n.getResultsSizeResponse != null && Object.hasOwnProperty.call(n, "getResultsSizeResponse") && $root.gcg.GetResultsSizeResponse.encode(n.getResultsSizeResponse, o.uint32(
        /* id 23, wireType 2 =*/
        186
      ).fork()).ldelim(), n.endorsementResponse != null && Object.hasOwnProperty.call(n, "endorsementResponse") && $root.identity_endorsement.EndorsementResponse.encode(n.endorsementResponse, o.uint32(
        /* id 101, wireType 2 =*/
        810
      ).fork()).ldelim(), o;
    }, r.encodeDelimited = function(n, o) {
      return this.encode(n, o).ldelim();
    }, r.decode = function(n, o) {
      n instanceof $Reader || (n = $Reader.create(n));
      let c = o === void 0 ? n.len : n.pos + o, l = new $root.gcg.GcgResponse();
      for (; n.pos < c; ) {
        let d = n.uint32();
        switch (d >>> 3) {
          case 1: {
            l.failure = n.string();
            break;
          }
          case 2: {
            l.createDataRoomResponse = $root.gcg.CreateDataRoomResponse.decode(n, n.uint32());
            break;
          }
          case 3: {
            l.retrieveDataRoomResponse = $root.gcg.RetrieveDataRoomResponse.decode(n, n.uint32());
            break;
          }
          case 4: {
            l.retrieveCurrentDataRoomConfigurationResponse = $root.gcg.RetrieveCurrentDataRoomConfigurationResponse.decode(n, n.uint32());
            break;
          }
          case 5: {
            l.retrieveDataRoomStatusResponse = $root.gcg.RetrieveDataRoomStatusResponse.decode(n, n.uint32());
            break;
          }
          case 6: {
            l.updateDataRoomStatusResponse = $root.gcg.UpdateDataRoomStatusResponse.decode(n, n.uint32());
            break;
          }
          case 7: {
            l.retrieveAuditLogResponse = $root.gcg.RetrieveAuditLogResponse.decode(n, n.uint32());
            break;
          }
          case 8: {
            l.publishDatasetToDataRoomResponse = $root.gcg.PublishDatasetToDataRoomResponse.decode(n, n.uint32());
            break;
          }
          case 9: {
            l.retrievePublishedDatasetsResponse = $root.gcg.RetrievePublishedDatasetsResponse.decode(n, n.uint32());
            break;
          }
          case 10: {
            l.removePublishedDatasetResponse = $root.gcg.RemovePublishedDatasetResponse.decode(n, n.uint32());
            break;
          }
          case 11: {
            l.executeComputeResponse = $root.gcg.ExecuteComputeResponse.decode(n, n.uint32());
            break;
          }
          case 12: {
            l.jobStatusResponse = $root.gcg.JobStatusResponse.decode(n, n.uint32());
            break;
          }
          case 13: {
            l.getResultsResponseChunk = $root.gcg.GetResultsResponseChunk.decode(n, n.uint32());
            break;
          }
          case 14: {
            l.getResultsResponseFooter = $root.gcg.GetResultsResponseFooter.decode(n, n.uint32());
            break;
          }
          case 15: {
            l.createConfigurationCommitResponse = $root.gcg.CreateConfigurationCommitResponse.decode(n, n.uint32());
            break;
          }
          case 16: {
            l.retrieveConfigurationCommitResponse = $root.gcg.RetrieveConfigurationCommitResponse.decode(n, n.uint32());
            break;
          }
          case 17: {
            l.generateMergeApprovalSignatureResponse = $root.gcg.GenerateMergeApprovalSignatureResponse.decode(n, n.uint32());
            break;
          }
          case 18: {
            l.mergeConfigurationCommitResponse = $root.gcg.MergeConfigurationCommitResponse.decode(n, n.uint32());
            break;
          }
          case 19: {
            l.retrieveConfigurationCommitApproversResponse = $root.gcg.RetrieveConfigurationCommitApproversResponse.decode(n, n.uint32());
            break;
          }
          case 20: {
            l.casAuxiliaryStateResponse = $root.gcg.CasAuxiliaryStateResponse.decode(n, n.uint32());
            break;
          }
          case 21: {
            l.readAuxiliaryStateResponse = $root.gcg.ReadAuxiliaryStateResponse.decode(n, n.uint32());
            break;
          }
          case 22: {
            l.retrieveUsedAirlockQuotaResponse = $root.gcg.RetrieveUsedAirlockQuotaResponse.decode(n, n.uint32());
            break;
          }
          case 23: {
            l.getResultsSizeResponse = $root.gcg.GetResultsSizeResponse.decode(n, n.uint32());
            break;
          }
          case 101: {
            l.endorsementResponse = $root.identity_endorsement.EndorsementResponse.decode(n, n.uint32());
            break;
          }
          default:
            n.skipType(d & 7);
            break;
        }
      }
      return l;
    }, r.decodeDelimited = function(n) {
      return n instanceof $Reader || (n = new $Reader(n)), this.decode(n, n.uint32());
    }, r.verify = function(n) {
      if (typeof n != "object" || n === null)
        return "object expected";
      let o = {};
      if (n.failure != null && n.hasOwnProperty("failure") && (o.gcgResponse = 1, !$util.isString(n.failure)))
        return "failure: string expected";
      if (n.createDataRoomResponse != null && n.hasOwnProperty("createDataRoomResponse")) {
        if (o.gcgResponse === 1)
          return "gcgResponse: multiple values";
        o.gcgResponse = 1;
        {
          let c = $root.gcg.CreateDataRoomResponse.verify(n.createDataRoomResponse);
          if (c)
            return "createDataRoomResponse." + c;
        }
      }
      if (n.retrieveDataRoomResponse != null && n.hasOwnProperty("retrieveDataRoomResponse")) {
        if (o.gcgResponse === 1)
          return "gcgResponse: multiple values";
        o.gcgResponse = 1;
        {
          let c = $root.gcg.RetrieveDataRoomResponse.verify(n.retrieveDataRoomResponse);
          if (c)
            return "retrieveDataRoomResponse." + c;
        }
      }
      if (n.retrieveCurrentDataRoomConfigurationResponse != null && n.hasOwnProperty("retrieveCurrentDataRoomConfigurationResponse")) {
        if (o.gcgResponse === 1)
          return "gcgResponse: multiple values";
        o.gcgResponse = 1;
        {
          let c = $root.gcg.RetrieveCurrentDataRoomConfigurationResponse.verify(n.retrieveCurrentDataRoomConfigurationResponse);
          if (c)
            return "retrieveCurrentDataRoomConfigurationResponse." + c;
        }
      }
      if (n.retrieveDataRoomStatusResponse != null && n.hasOwnProperty("retrieveDataRoomStatusResponse")) {
        if (o.gcgResponse === 1)
          return "gcgResponse: multiple values";
        o.gcgResponse = 1;
        {
          let c = $root.gcg.RetrieveDataRoomStatusResponse.verify(n.retrieveDataRoomStatusResponse);
          if (c)
            return "retrieveDataRoomStatusResponse." + c;
        }
      }
      if (n.updateDataRoomStatusResponse != null && n.hasOwnProperty("updateDataRoomStatusResponse")) {
        if (o.gcgResponse === 1)
          return "gcgResponse: multiple values";
        o.gcgResponse = 1;
        {
          let c = $root.gcg.UpdateDataRoomStatusResponse.verify(n.updateDataRoomStatusResponse);
          if (c)
            return "updateDataRoomStatusResponse." + c;
        }
      }
      if (n.retrieveAuditLogResponse != null && n.hasOwnProperty("retrieveAuditLogResponse")) {
        if (o.gcgResponse === 1)
          return "gcgResponse: multiple values";
        o.gcgResponse = 1;
        {
          let c = $root.gcg.RetrieveAuditLogResponse.verify(n.retrieveAuditLogResponse);
          if (c)
            return "retrieveAuditLogResponse." + c;
        }
      }
      if (n.publishDatasetToDataRoomResponse != null && n.hasOwnProperty("publishDatasetToDataRoomResponse")) {
        if (o.gcgResponse === 1)
          return "gcgResponse: multiple values";
        o.gcgResponse = 1;
        {
          let c = $root.gcg.PublishDatasetToDataRoomResponse.verify(n.publishDatasetToDataRoomResponse);
          if (c)
            return "publishDatasetToDataRoomResponse." + c;
        }
      }
      if (n.retrievePublishedDatasetsResponse != null && n.hasOwnProperty("retrievePublishedDatasetsResponse")) {
        if (o.gcgResponse === 1)
          return "gcgResponse: multiple values";
        o.gcgResponse = 1;
        {
          let c = $root.gcg.RetrievePublishedDatasetsResponse.verify(n.retrievePublishedDatasetsResponse);
          if (c)
            return "retrievePublishedDatasetsResponse." + c;
        }
      }
      if (n.removePublishedDatasetResponse != null && n.hasOwnProperty("removePublishedDatasetResponse")) {
        if (o.gcgResponse === 1)
          return "gcgResponse: multiple values";
        o.gcgResponse = 1;
        {
          let c = $root.gcg.RemovePublishedDatasetResponse.verify(n.removePublishedDatasetResponse);
          if (c)
            return "removePublishedDatasetResponse." + c;
        }
      }
      if (n.executeComputeResponse != null && n.hasOwnProperty("executeComputeResponse")) {
        if (o.gcgResponse === 1)
          return "gcgResponse: multiple values";
        o.gcgResponse = 1;
        {
          let c = $root.gcg.ExecuteComputeResponse.verify(n.executeComputeResponse);
          if (c)
            return "executeComputeResponse." + c;
        }
      }
      if (n.jobStatusResponse != null && n.hasOwnProperty("jobStatusResponse")) {
        if (o.gcgResponse === 1)
          return "gcgResponse: multiple values";
        o.gcgResponse = 1;
        {
          let c = $root.gcg.JobStatusResponse.verify(n.jobStatusResponse);
          if (c)
            return "jobStatusResponse." + c;
        }
      }
      if (n.getResultsResponseChunk != null && n.hasOwnProperty("getResultsResponseChunk")) {
        if (o.gcgResponse === 1)
          return "gcgResponse: multiple values";
        o.gcgResponse = 1;
        {
          let c = $root.gcg.GetResultsResponseChunk.verify(n.getResultsResponseChunk);
          if (c)
            return "getResultsResponseChunk." + c;
        }
      }
      if (n.getResultsResponseFooter != null && n.hasOwnProperty("getResultsResponseFooter")) {
        if (o.gcgResponse === 1)
          return "gcgResponse: multiple values";
        o.gcgResponse = 1;
        {
          let c = $root.gcg.GetResultsResponseFooter.verify(n.getResultsResponseFooter);
          if (c)
            return "getResultsResponseFooter." + c;
        }
      }
      if (n.createConfigurationCommitResponse != null && n.hasOwnProperty("createConfigurationCommitResponse")) {
        if (o.gcgResponse === 1)
          return "gcgResponse: multiple values";
        o.gcgResponse = 1;
        {
          let c = $root.gcg.CreateConfigurationCommitResponse.verify(n.createConfigurationCommitResponse);
          if (c)
            return "createConfigurationCommitResponse." + c;
        }
      }
      if (n.retrieveConfigurationCommitResponse != null && n.hasOwnProperty("retrieveConfigurationCommitResponse")) {
        if (o.gcgResponse === 1)
          return "gcgResponse: multiple values";
        o.gcgResponse = 1;
        {
          let c = $root.gcg.RetrieveConfigurationCommitResponse.verify(n.retrieveConfigurationCommitResponse);
          if (c)
            return "retrieveConfigurationCommitResponse." + c;
        }
      }
      if (n.generateMergeApprovalSignatureResponse != null && n.hasOwnProperty("generateMergeApprovalSignatureResponse")) {
        if (o.gcgResponse === 1)
          return "gcgResponse: multiple values";
        o.gcgResponse = 1;
        {
          let c = $root.gcg.GenerateMergeApprovalSignatureResponse.verify(n.generateMergeApprovalSignatureResponse);
          if (c)
            return "generateMergeApprovalSignatureResponse." + c;
        }
      }
      if (n.mergeConfigurationCommitResponse != null && n.hasOwnProperty("mergeConfigurationCommitResponse")) {
        if (o.gcgResponse === 1)
          return "gcgResponse: multiple values";
        o.gcgResponse = 1;
        {
          let c = $root.gcg.MergeConfigurationCommitResponse.verify(n.mergeConfigurationCommitResponse);
          if (c)
            return "mergeConfigurationCommitResponse." + c;
        }
      }
      if (n.retrieveConfigurationCommitApproversResponse != null && n.hasOwnProperty("retrieveConfigurationCommitApproversResponse")) {
        if (o.gcgResponse === 1)
          return "gcgResponse: multiple values";
        o.gcgResponse = 1;
        {
          let c = $root.gcg.RetrieveConfigurationCommitApproversResponse.verify(n.retrieveConfigurationCommitApproversResponse);
          if (c)
            return "retrieveConfigurationCommitApproversResponse." + c;
        }
      }
      if (n.casAuxiliaryStateResponse != null && n.hasOwnProperty("casAuxiliaryStateResponse")) {
        if (o.gcgResponse === 1)
          return "gcgResponse: multiple values";
        o.gcgResponse = 1;
        {
          let c = $root.gcg.CasAuxiliaryStateResponse.verify(n.casAuxiliaryStateResponse);
          if (c)
            return "casAuxiliaryStateResponse." + c;
        }
      }
      if (n.readAuxiliaryStateResponse != null && n.hasOwnProperty("readAuxiliaryStateResponse")) {
        if (o.gcgResponse === 1)
          return "gcgResponse: multiple values";
        o.gcgResponse = 1;
        {
          let c = $root.gcg.ReadAuxiliaryStateResponse.verify(n.readAuxiliaryStateResponse);
          if (c)
            return "readAuxiliaryStateResponse." + c;
        }
      }
      if (n.retrieveUsedAirlockQuotaResponse != null && n.hasOwnProperty("retrieveUsedAirlockQuotaResponse")) {
        if (o.gcgResponse === 1)
          return "gcgResponse: multiple values";
        o.gcgResponse = 1;
        {
          let c = $root.gcg.RetrieveUsedAirlockQuotaResponse.verify(n.retrieveUsedAirlockQuotaResponse);
          if (c)
            return "retrieveUsedAirlockQuotaResponse." + c;
        }
      }
      if (n.getResultsSizeResponse != null && n.hasOwnProperty("getResultsSizeResponse")) {
        if (o.gcgResponse === 1)
          return "gcgResponse: multiple values";
        o.gcgResponse = 1;
        {
          let c = $root.gcg.GetResultsSizeResponse.verify(n.getResultsSizeResponse);
          if (c)
            return "getResultsSizeResponse." + c;
        }
      }
      if (n.endorsementResponse != null && n.hasOwnProperty("endorsementResponse")) {
        if (o.gcgResponse === 1)
          return "gcgResponse: multiple values";
        o.gcgResponse = 1;
        {
          let c = $root.identity_endorsement.EndorsementResponse.verify(n.endorsementResponse);
          if (c)
            return "endorsementResponse." + c;
        }
      }
      return null;
    }, r.fromObject = function(n) {
      if (n instanceof $root.gcg.GcgResponse)
        return n;
      let o = new $root.gcg.GcgResponse();
      if (n.failure != null && (o.failure = String(n.failure)), n.createDataRoomResponse != null) {
        if (typeof n.createDataRoomResponse != "object")
          throw TypeError(".gcg.GcgResponse.createDataRoomResponse: object expected");
        o.createDataRoomResponse = $root.gcg.CreateDataRoomResponse.fromObject(n.createDataRoomResponse);
      }
      if (n.retrieveDataRoomResponse != null) {
        if (typeof n.retrieveDataRoomResponse != "object")
          throw TypeError(".gcg.GcgResponse.retrieveDataRoomResponse: object expected");
        o.retrieveDataRoomResponse = $root.gcg.RetrieveDataRoomResponse.fromObject(n.retrieveDataRoomResponse);
      }
      if (n.retrieveCurrentDataRoomConfigurationResponse != null) {
        if (typeof n.retrieveCurrentDataRoomConfigurationResponse != "object")
          throw TypeError(".gcg.GcgResponse.retrieveCurrentDataRoomConfigurationResponse: object expected");
        o.retrieveCurrentDataRoomConfigurationResponse = $root.gcg.RetrieveCurrentDataRoomConfigurationResponse.fromObject(n.retrieveCurrentDataRoomConfigurationResponse);
      }
      if (n.retrieveDataRoomStatusResponse != null) {
        if (typeof n.retrieveDataRoomStatusResponse != "object")
          throw TypeError(".gcg.GcgResponse.retrieveDataRoomStatusResponse: object expected");
        o.retrieveDataRoomStatusResponse = $root.gcg.RetrieveDataRoomStatusResponse.fromObject(n.retrieveDataRoomStatusResponse);
      }
      if (n.updateDataRoomStatusResponse != null) {
        if (typeof n.updateDataRoomStatusResponse != "object")
          throw TypeError(".gcg.GcgResponse.updateDataRoomStatusResponse: object expected");
        o.updateDataRoomStatusResponse = $root.gcg.UpdateDataRoomStatusResponse.fromObject(n.updateDataRoomStatusResponse);
      }
      if (n.retrieveAuditLogResponse != null) {
        if (typeof n.retrieveAuditLogResponse != "object")
          throw TypeError(".gcg.GcgResponse.retrieveAuditLogResponse: object expected");
        o.retrieveAuditLogResponse = $root.gcg.RetrieveAuditLogResponse.fromObject(n.retrieveAuditLogResponse);
      }
      if (n.publishDatasetToDataRoomResponse != null) {
        if (typeof n.publishDatasetToDataRoomResponse != "object")
          throw TypeError(".gcg.GcgResponse.publishDatasetToDataRoomResponse: object expected");
        o.publishDatasetToDataRoomResponse = $root.gcg.PublishDatasetToDataRoomResponse.fromObject(n.publishDatasetToDataRoomResponse);
      }
      if (n.retrievePublishedDatasetsResponse != null) {
        if (typeof n.retrievePublishedDatasetsResponse != "object")
          throw TypeError(".gcg.GcgResponse.retrievePublishedDatasetsResponse: object expected");
        o.retrievePublishedDatasetsResponse = $root.gcg.RetrievePublishedDatasetsResponse.fromObject(n.retrievePublishedDatasetsResponse);
      }
      if (n.removePublishedDatasetResponse != null) {
        if (typeof n.removePublishedDatasetResponse != "object")
          throw TypeError(".gcg.GcgResponse.removePublishedDatasetResponse: object expected");
        o.removePublishedDatasetResponse = $root.gcg.RemovePublishedDatasetResponse.fromObject(n.removePublishedDatasetResponse);
      }
      if (n.executeComputeResponse != null) {
        if (typeof n.executeComputeResponse != "object")
          throw TypeError(".gcg.GcgResponse.executeComputeResponse: object expected");
        o.executeComputeResponse = $root.gcg.ExecuteComputeResponse.fromObject(n.executeComputeResponse);
      }
      if (n.jobStatusResponse != null) {
        if (typeof n.jobStatusResponse != "object")
          throw TypeError(".gcg.GcgResponse.jobStatusResponse: object expected");
        o.jobStatusResponse = $root.gcg.JobStatusResponse.fromObject(n.jobStatusResponse);
      }
      if (n.getResultsResponseChunk != null) {
        if (typeof n.getResultsResponseChunk != "object")
          throw TypeError(".gcg.GcgResponse.getResultsResponseChunk: object expected");
        o.getResultsResponseChunk = $root.gcg.GetResultsResponseChunk.fromObject(n.getResultsResponseChunk);
      }
      if (n.getResultsResponseFooter != null) {
        if (typeof n.getResultsResponseFooter != "object")
          throw TypeError(".gcg.GcgResponse.getResultsResponseFooter: object expected");
        o.getResultsResponseFooter = $root.gcg.GetResultsResponseFooter.fromObject(n.getResultsResponseFooter);
      }
      if (n.createConfigurationCommitResponse != null) {
        if (typeof n.createConfigurationCommitResponse != "object")
          throw TypeError(".gcg.GcgResponse.createConfigurationCommitResponse: object expected");
        o.createConfigurationCommitResponse = $root.gcg.CreateConfigurationCommitResponse.fromObject(n.createConfigurationCommitResponse);
      }
      if (n.retrieveConfigurationCommitResponse != null) {
        if (typeof n.retrieveConfigurationCommitResponse != "object")
          throw TypeError(".gcg.GcgResponse.retrieveConfigurationCommitResponse: object expected");
        o.retrieveConfigurationCommitResponse = $root.gcg.RetrieveConfigurationCommitResponse.fromObject(n.retrieveConfigurationCommitResponse);
      }
      if (n.generateMergeApprovalSignatureResponse != null) {
        if (typeof n.generateMergeApprovalSignatureResponse != "object")
          throw TypeError(".gcg.GcgResponse.generateMergeApprovalSignatureResponse: object expected");
        o.generateMergeApprovalSignatureResponse = $root.gcg.GenerateMergeApprovalSignatureResponse.fromObject(n.generateMergeApprovalSignatureResponse);
      }
      if (n.mergeConfigurationCommitResponse != null) {
        if (typeof n.mergeConfigurationCommitResponse != "object")
          throw TypeError(".gcg.GcgResponse.mergeConfigurationCommitResponse: object expected");
        o.mergeConfigurationCommitResponse = $root.gcg.MergeConfigurationCommitResponse.fromObject(n.mergeConfigurationCommitResponse);
      }
      if (n.retrieveConfigurationCommitApproversResponse != null) {
        if (typeof n.retrieveConfigurationCommitApproversResponse != "object")
          throw TypeError(".gcg.GcgResponse.retrieveConfigurationCommitApproversResponse: object expected");
        o.retrieveConfigurationCommitApproversResponse = $root.gcg.RetrieveConfigurationCommitApproversResponse.fromObject(n.retrieveConfigurationCommitApproversResponse);
      }
      if (n.casAuxiliaryStateResponse != null) {
        if (typeof n.casAuxiliaryStateResponse != "object")
          throw TypeError(".gcg.GcgResponse.casAuxiliaryStateResponse: object expected");
        o.casAuxiliaryStateResponse = $root.gcg.CasAuxiliaryStateResponse.fromObject(n.casAuxiliaryStateResponse);
      }
      if (n.readAuxiliaryStateResponse != null) {
        if (typeof n.readAuxiliaryStateResponse != "object")
          throw TypeError(".gcg.GcgResponse.readAuxiliaryStateResponse: object expected");
        o.readAuxiliaryStateResponse = $root.gcg.ReadAuxiliaryStateResponse.fromObject(n.readAuxiliaryStateResponse);
      }
      if (n.retrieveUsedAirlockQuotaResponse != null) {
        if (typeof n.retrieveUsedAirlockQuotaResponse != "object")
          throw TypeError(".gcg.GcgResponse.retrieveUsedAirlockQuotaResponse: object expected");
        o.retrieveUsedAirlockQuotaResponse = $root.gcg.RetrieveUsedAirlockQuotaResponse.fromObject(n.retrieveUsedAirlockQuotaResponse);
      }
      if (n.getResultsSizeResponse != null) {
        if (typeof n.getResultsSizeResponse != "object")
          throw TypeError(".gcg.GcgResponse.getResultsSizeResponse: object expected");
        o.getResultsSizeResponse = $root.gcg.GetResultsSizeResponse.fromObject(n.getResultsSizeResponse);
      }
      if (n.endorsementResponse != null) {
        if (typeof n.endorsementResponse != "object")
          throw TypeError(".gcg.GcgResponse.endorsementResponse: object expected");
        o.endorsementResponse = $root.identity_endorsement.EndorsementResponse.fromObject(n.endorsementResponse);
      }
      return o;
    }, r.toObject = function(n, o) {
      o || (o = {});
      let c = {};
      return n.failure != null && n.hasOwnProperty("failure") && (c.failure = n.failure, o.oneofs && (c.gcgResponse = "failure")), n.createDataRoomResponse != null && n.hasOwnProperty("createDataRoomResponse") && (c.createDataRoomResponse = $root.gcg.CreateDataRoomResponse.toObject(n.createDataRoomResponse, o), o.oneofs && (c.gcgResponse = "createDataRoomResponse")), n.retrieveDataRoomResponse != null && n.hasOwnProperty("retrieveDataRoomResponse") && (c.retrieveDataRoomResponse = $root.gcg.RetrieveDataRoomResponse.toObject(n.retrieveDataRoomResponse, o), o.oneofs && (c.gcgResponse = "retrieveDataRoomResponse")), n.retrieveCurrentDataRoomConfigurationResponse != null && n.hasOwnProperty("retrieveCurrentDataRoomConfigurationResponse") && (c.retrieveCurrentDataRoomConfigurationResponse = $root.gcg.RetrieveCurrentDataRoomConfigurationResponse.toObject(n.retrieveCurrentDataRoomConfigurationResponse, o), o.oneofs && (c.gcgResponse = "retrieveCurrentDataRoomConfigurationResponse")), n.retrieveDataRoomStatusResponse != null && n.hasOwnProperty("retrieveDataRoomStatusResponse") && (c.retrieveDataRoomStatusResponse = $root.gcg.RetrieveDataRoomStatusResponse.toObject(n.retrieveDataRoomStatusResponse, o), o.oneofs && (c.gcgResponse = "retrieveDataRoomStatusResponse")), n.updateDataRoomStatusResponse != null && n.hasOwnProperty("updateDataRoomStatusResponse") && (c.updateDataRoomStatusResponse = $root.gcg.UpdateDataRoomStatusResponse.toObject(n.updateDataRoomStatusResponse, o), o.oneofs && (c.gcgResponse = "updateDataRoomStatusResponse")), n.retrieveAuditLogResponse != null && n.hasOwnProperty("retrieveAuditLogResponse") && (c.retrieveAuditLogResponse = $root.gcg.RetrieveAuditLogResponse.toObject(n.retrieveAuditLogResponse, o), o.oneofs && (c.gcgResponse = "retrieveAuditLogResponse")), n.publishDatasetToDataRoomResponse != null && n.hasOwnProperty("publishDatasetToDataRoomResponse") && (c.publishDatasetToDataRoomResponse = $root.gcg.PublishDatasetToDataRoomResponse.toObject(n.publishDatasetToDataRoomResponse, o), o.oneofs && (c.gcgResponse = "publishDatasetToDataRoomResponse")), n.retrievePublishedDatasetsResponse != null && n.hasOwnProperty("retrievePublishedDatasetsResponse") && (c.retrievePublishedDatasetsResponse = $root.gcg.RetrievePublishedDatasetsResponse.toObject(n.retrievePublishedDatasetsResponse, o), o.oneofs && (c.gcgResponse = "retrievePublishedDatasetsResponse")), n.removePublishedDatasetResponse != null && n.hasOwnProperty("removePublishedDatasetResponse") && (c.removePublishedDatasetResponse = $root.gcg.RemovePublishedDatasetResponse.toObject(n.removePublishedDatasetResponse, o), o.oneofs && (c.gcgResponse = "removePublishedDatasetResponse")), n.executeComputeResponse != null && n.hasOwnProperty("executeComputeResponse") && (c.executeComputeResponse = $root.gcg.ExecuteComputeResponse.toObject(n.executeComputeResponse, o), o.oneofs && (c.gcgResponse = "executeComputeResponse")), n.jobStatusResponse != null && n.hasOwnProperty("jobStatusResponse") && (c.jobStatusResponse = $root.gcg.JobStatusResponse.toObject(n.jobStatusResponse, o), o.oneofs && (c.gcgResponse = "jobStatusResponse")), n.getResultsResponseChunk != null && n.hasOwnProperty("getResultsResponseChunk") && (c.getResultsResponseChunk = $root.gcg.GetResultsResponseChunk.toObject(n.getResultsResponseChunk, o), o.oneofs && (c.gcgResponse = "getResultsResponseChunk")), n.getResultsResponseFooter != null && n.hasOwnProperty("getResultsResponseFooter") && (c.getResultsResponseFooter = $root.gcg.GetResultsResponseFooter.toObject(n.getResultsResponseFooter, o), o.oneofs && (c.gcgResponse = "getResultsResponseFooter")), n.createConfigurationCommitResponse != null && n.hasOwnProperty("createConfigurationCommitResponse") && (c.createConfigurationCommitResponse = $root.gcg.CreateConfigurationCommitResponse.toObject(n.createConfigurationCommitResponse, o), o.oneofs && (c.gcgResponse = "createConfigurationCommitResponse")), n.retrieveConfigurationCommitResponse != null && n.hasOwnProperty("retrieveConfigurationCommitResponse") && (c.retrieveConfigurationCommitResponse = $root.gcg.RetrieveConfigurationCommitResponse.toObject(n.retrieveConfigurationCommitResponse, o), o.oneofs && (c.gcgResponse = "retrieveConfigurationCommitResponse")), n.generateMergeApprovalSignatureResponse != null && n.hasOwnProperty("generateMergeApprovalSignatureResponse") && (c.generateMergeApprovalSignatureResponse = $root.gcg.GenerateMergeApprovalSignatureResponse.toObject(n.generateMergeApprovalSignatureResponse, o), o.oneofs && (c.gcgResponse = "generateMergeApprovalSignatureResponse")), n.mergeConfigurationCommitResponse != null && n.hasOwnProperty("mergeConfigurationCommitResponse") && (c.mergeConfigurationCommitResponse = $root.gcg.MergeConfigurationCommitResponse.toObject(n.mergeConfigurationCommitResponse, o), o.oneofs && (c.gcgResponse = "mergeConfigurationCommitResponse")), n.retrieveConfigurationCommitApproversResponse != null && n.hasOwnProperty("retrieveConfigurationCommitApproversResponse") && (c.retrieveConfigurationCommitApproversResponse = $root.gcg.RetrieveConfigurationCommitApproversResponse.toObject(n.retrieveConfigurationCommitApproversResponse, o), o.oneofs && (c.gcgResponse = "retrieveConfigurationCommitApproversResponse")), n.casAuxiliaryStateResponse != null && n.hasOwnProperty("casAuxiliaryStateResponse") && (c.casAuxiliaryStateResponse = $root.gcg.CasAuxiliaryStateResponse.toObject(n.casAuxiliaryStateResponse, o), o.oneofs && (c.gcgResponse = "casAuxiliaryStateResponse")), n.readAuxiliaryStateResponse != null && n.hasOwnProperty("readAuxiliaryStateResponse") && (c.readAuxiliaryStateResponse = $root.gcg.ReadAuxiliaryStateResponse.toObject(n.readAuxiliaryStateResponse, o), o.oneofs && (c.gcgResponse = "readAuxiliaryStateResponse")), n.retrieveUsedAirlockQuotaResponse != null && n.hasOwnProperty("retrieveUsedAirlockQuotaResponse") && (c.retrieveUsedAirlockQuotaResponse = $root.gcg.RetrieveUsedAirlockQuotaResponse.toObject(n.retrieveUsedAirlockQuotaResponse, o), o.oneofs && (c.gcgResponse = "retrieveUsedAirlockQuotaResponse")), n.getResultsSizeResponse != null && n.hasOwnProperty("getResultsSizeResponse") && (c.getResultsSizeResponse = $root.gcg.GetResultsSizeResponse.toObject(n.getResultsSizeResponse, o), o.oneofs && (c.gcgResponse = "getResultsSizeResponse")), n.endorsementResponse != null && n.hasOwnProperty("endorsementResponse") && (c.endorsementResponse = $root.identity_endorsement.EndorsementResponse.toObject(n.endorsementResponse, o), o.oneofs && (c.gcgResponse = "endorsementResponse")), c;
    }, r.prototype.toJSON = function() {
      return this.constructor.toObject(this, minimal.util.toJSONOptions);
    }, r.getTypeUrl = function(n) {
      return n === void 0 && (n = "type.googleapis.com"), n + "/gcg.GcgResponse";
    }, r;
  }(), u.UserAuth = function() {
    function r(a) {
      if (a)
        for (let e = Object.keys(a), n = 0; n < e.length; ++n)
          a[e[n]] != null && (this[e[n]] = a[e[n]]);
    }
    return r.prototype.pki = null, r.prototype.enclaveEndorsements = null, r.create = function(e) {
      return new r(e);
    }, r.encode = function(e, n) {
      return n || (n = $Writer.create()), e.pki != null && Object.hasOwnProperty.call(e, "pki") && $root.gcg.Pki.encode(e.pki, n.uint32(
        /* id 1, wireType 2 =*/
        10
      ).fork()).ldelim(), e.enclaveEndorsements != null && Object.hasOwnProperty.call(e, "enclaveEndorsements") && $root.identity_endorsement.EnclaveEndorsements.encode(e.enclaveEndorsements, n.uint32(
        /* id 2, wireType 2 =*/
        18
      ).fork()).ldelim(), n;
    }, r.encodeDelimited = function(e, n) {
      return this.encode(e, n).ldelim();
    }, r.decode = function(e, n) {
      e instanceof $Reader || (e = $Reader.create(e));
      let o = n === void 0 ? e.len : e.pos + n, c = new $root.gcg.UserAuth();
      for (; e.pos < o; ) {
        let l = e.uint32();
        switch (l >>> 3) {
          case 1: {
            c.pki = $root.gcg.Pki.decode(e, e.uint32());
            break;
          }
          case 2: {
            c.enclaveEndorsements = $root.identity_endorsement.EnclaveEndorsements.decode(e, e.uint32());
            break;
          }
          default:
            e.skipType(l & 7);
            break;
        }
      }
      return c;
    }, r.decodeDelimited = function(e) {
      return e instanceof $Reader || (e = new $Reader(e)), this.decode(e, e.uint32());
    }, r.verify = function(e) {
      if (typeof e != "object" || e === null)
        return "object expected";
      if (e.pki != null && e.hasOwnProperty("pki")) {
        let n = $root.gcg.Pki.verify(e.pki);
        if (n)
          return "pki." + n;
      }
      if (e.enclaveEndorsements != null && e.hasOwnProperty("enclaveEndorsements")) {
        let n = $root.identity_endorsement.EnclaveEndorsements.verify(e.enclaveEndorsements);
        if (n)
          return "enclaveEndorsements." + n;
      }
      return null;
    }, r.fromObject = function(e) {
      if (e instanceof $root.gcg.UserAuth)
        return e;
      let n = new $root.gcg.UserAuth();
      if (e.pki != null) {
        if (typeof e.pki != "object")
          throw TypeError(".gcg.UserAuth.pki: object expected");
        n.pki = $root.gcg.Pki.fromObject(e.pki);
      }
      if (e.enclaveEndorsements != null) {
        if (typeof e.enclaveEndorsements != "object")
          throw TypeError(".gcg.UserAuth.enclaveEndorsements: object expected");
        n.enclaveEndorsements = $root.identity_endorsement.EnclaveEndorsements.fromObject(e.enclaveEndorsements);
      }
      return n;
    }, r.toObject = function(e, n) {
      n || (n = {});
      let o = {};
      return n.defaults && (o.pki = null, o.enclaveEndorsements = null), e.pki != null && e.hasOwnProperty("pki") && (o.pki = $root.gcg.Pki.toObject(e.pki, n)), e.enclaveEndorsements != null && e.hasOwnProperty("enclaveEndorsements") && (o.enclaveEndorsements = $root.identity_endorsement.EnclaveEndorsements.toObject(e.enclaveEndorsements, n)), o;
    }, r.prototype.toJSON = function() {
      return this.constructor.toObject(this, minimal.util.toJSONOptions);
    }, r.getTypeUrl = function(e) {
      return e === void 0 && (e = "type.googleapis.com"), e + "/gcg.UserAuth";
    }, r;
  }(), u.Pki = function() {
    function r(a) {
      if (a)
        for (let e = Object.keys(a), n = 0; n < e.length; ++n)
          a[e[n]] != null && (this[e[n]] = a[e[n]]);
    }
    return r.prototype.certChainPem = $util.newBuffer([]), r.prototype.signature = $util.newBuffer([]), r.prototype.idMac = $util.newBuffer([]), r.create = function(e) {
      return new r(e);
    }, r.encode = function(e, n) {
      return n || (n = $Writer.create()), e.certChainPem != null && Object.hasOwnProperty.call(e, "certChainPem") && n.uint32(
        /* id 1, wireType 2 =*/
        10
      ).bytes(e.certChainPem), e.signature != null && Object.hasOwnProperty.call(e, "signature") && n.uint32(
        /* id 2, wireType 2 =*/
        18
      ).bytes(e.signature), e.idMac != null && Object.hasOwnProperty.call(e, "idMac") && n.uint32(
        /* id 3, wireType 2 =*/
        26
      ).bytes(e.idMac), n;
    }, r.encodeDelimited = function(e, n) {
      return this.encode(e, n).ldelim();
    }, r.decode = function(e, n) {
      e instanceof $Reader || (e = $Reader.create(e));
      let o = n === void 0 ? e.len : e.pos + n, c = new $root.gcg.Pki();
      for (; e.pos < o; ) {
        let l = e.uint32();
        switch (l >>> 3) {
          case 1: {
            c.certChainPem = e.bytes();
            break;
          }
          case 2: {
            c.signature = e.bytes();
            break;
          }
          case 3: {
            c.idMac = e.bytes();
            break;
          }
          default:
            e.skipType(l & 7);
            break;
        }
      }
      return c;
    }, r.decodeDelimited = function(e) {
      return e instanceof $Reader || (e = new $Reader(e)), this.decode(e, e.uint32());
    }, r.verify = function(e) {
      return typeof e != "object" || e === null ? "object expected" : e.certChainPem != null && e.hasOwnProperty("certChainPem") && !(e.certChainPem && typeof e.certChainPem.length == "number" || $util.isString(e.certChainPem)) ? "certChainPem: buffer expected" : e.signature != null && e.hasOwnProperty("signature") && !(e.signature && typeof e.signature.length == "number" || $util.isString(e.signature)) ? "signature: buffer expected" : e.idMac != null && e.hasOwnProperty("idMac") && !(e.idMac && typeof e.idMac.length == "number" || $util.isString(e.idMac)) ? "idMac: buffer expected" : null;
    }, r.fromObject = function(e) {
      if (e instanceof $root.gcg.Pki)
        return e;
      let n = new $root.gcg.Pki();
      return e.certChainPem != null && (typeof e.certChainPem == "string" ? $util.base64.decode(e.certChainPem, n.certChainPem = $util.newBuffer($util.base64.length(e.certChainPem)), 0) : e.certChainPem.length >= 0 && (n.certChainPem = e.certChainPem)), e.signature != null && (typeof e.signature == "string" ? $util.base64.decode(e.signature, n.signature = $util.newBuffer($util.base64.length(e.signature)), 0) : e.signature.length >= 0 && (n.signature = e.signature)), e.idMac != null && (typeof e.idMac == "string" ? $util.base64.decode(e.idMac, n.idMac = $util.newBuffer($util.base64.length(e.idMac)), 0) : e.idMac.length >= 0 && (n.idMac = e.idMac)), n;
    }, r.toObject = function(e, n) {
      n || (n = {});
      let o = {};
      return n.defaults && (n.bytes === String ? o.certChainPem = "" : (o.certChainPem = [], n.bytes !== Array && (o.certChainPem = $util.newBuffer(o.certChainPem))), n.bytes === String ? o.signature = "" : (o.signature = [], n.bytes !== Array && (o.signature = $util.newBuffer(o.signature))), n.bytes === String ? o.idMac = "" : (o.idMac = [], n.bytes !== Array && (o.idMac = $util.newBuffer(o.idMac)))), e.certChainPem != null && e.hasOwnProperty("certChainPem") && (o.certChainPem = n.bytes === String ? $util.base64.encode(e.certChainPem, 0, e.certChainPem.length) : n.bytes === Array ? Array.prototype.slice.call(e.certChainPem) : e.certChainPem), e.signature != null && e.hasOwnProperty("signature") && (o.signature = n.bytes === String ? $util.base64.encode(e.signature, 0, e.signature.length) : n.bytes === Array ? Array.prototype.slice.call(e.signature) : e.signature), e.idMac != null && e.hasOwnProperty("idMac") && (o.idMac = n.bytes === String ? $util.base64.encode(e.idMac, 0, e.idMac.length) : n.bytes === Array ? Array.prototype.slice.call(e.idMac) : e.idMac), o;
    }, r.prototype.toJSON = function() {
      return this.constructor.toObject(this, minimal.util.toJSONOptions);
    }, r.getTypeUrl = function(e) {
      return e === void 0 && (e = "type.googleapis.com"), e + "/gcg.Pki";
    }, r;
  }(), u.CreateDataRoomRequest = function() {
    function r(e) {
      if (e)
        for (let n = Object.keys(e), o = 0; o < n.length; ++o)
          e[n[o]] != null && (this[n[o]] = e[n[o]]);
    }
    r.prototype.dataRoom = null, r.prototype.highLevelRepresentation = null, r.prototype.dataRoomMetadata = null;
    let a;
    return Object.defineProperty(r.prototype, "_highLevelRepresentation", {
      get: $util.oneOfGetter(a = ["highLevelRepresentation"]),
      set: $util.oneOfSetter(a)
    }), Object.defineProperty(r.prototype, "_dataRoomMetadata", {
      get: $util.oneOfGetter(a = ["dataRoomMetadata"]),
      set: $util.oneOfSetter(a)
    }), r.create = function(n) {
      return new r(n);
    }, r.encode = function(n, o) {
      return o || (o = $Writer.create()), n.dataRoom != null && Object.hasOwnProperty.call(n, "dataRoom") && $root.data_room.DataRoom.encode(n.dataRoom, o.uint32(
        /* id 1, wireType 2 =*/
        10
      ).fork()).ldelim(), n.highLevelRepresentation != null && Object.hasOwnProperty.call(n, "highLevelRepresentation") && o.uint32(
        /* id 2, wireType 2 =*/
        18
      ).bytes(n.highLevelRepresentation), n.dataRoomMetadata != null && Object.hasOwnProperty.call(n, "dataRoomMetadata") && o.uint32(
        /* id 3, wireType 2 =*/
        26
      ).bytes(n.dataRoomMetadata), o;
    }, r.encodeDelimited = function(n, o) {
      return this.encode(n, o).ldelim();
    }, r.decode = function(n, o) {
      n instanceof $Reader || (n = $Reader.create(n));
      let c = o === void 0 ? n.len : n.pos + o, l = new $root.gcg.CreateDataRoomRequest();
      for (; n.pos < c; ) {
        let d = n.uint32();
        switch (d >>> 3) {
          case 1: {
            l.dataRoom = $root.data_room.DataRoom.decode(n, n.uint32());
            break;
          }
          case 2: {
            l.highLevelRepresentation = n.bytes();
            break;
          }
          case 3: {
            l.dataRoomMetadata = n.bytes();
            break;
          }
          default:
            n.skipType(d & 7);
            break;
        }
      }
      return l;
    }, r.decodeDelimited = function(n) {
      return n instanceof $Reader || (n = new $Reader(n)), this.decode(n, n.uint32());
    }, r.verify = function(n) {
      if (typeof n != "object" || n === null)
        return "object expected";
      if (n.dataRoom != null && n.hasOwnProperty("dataRoom")) {
        let o = $root.data_room.DataRoom.verify(n.dataRoom);
        if (o)
          return "dataRoom." + o;
      }
      return n.highLevelRepresentation != null && n.hasOwnProperty("highLevelRepresentation") && !(n.highLevelRepresentation && typeof n.highLevelRepresentation.length == "number" || $util.isString(n.highLevelRepresentation)) ? "highLevelRepresentation: buffer expected" : n.dataRoomMetadata != null && n.hasOwnProperty("dataRoomMetadata") && !(n.dataRoomMetadata && typeof n.dataRoomMetadata.length == "number" || $util.isString(n.dataRoomMetadata)) ? "dataRoomMetadata: buffer expected" : null;
    }, r.fromObject = function(n) {
      if (n instanceof $root.gcg.CreateDataRoomRequest)
        return n;
      let o = new $root.gcg.CreateDataRoomRequest();
      if (n.dataRoom != null) {
        if (typeof n.dataRoom != "object")
          throw TypeError(".gcg.CreateDataRoomRequest.dataRoom: object expected");
        o.dataRoom = $root.data_room.DataRoom.fromObject(n.dataRoom);
      }
      return n.highLevelRepresentation != null && (typeof n.highLevelRepresentation == "string" ? $util.base64.decode(n.highLevelRepresentation, o.highLevelRepresentation = $util.newBuffer($util.base64.length(n.highLevelRepresentation)), 0) : n.highLevelRepresentation.length >= 0 && (o.highLevelRepresentation = n.highLevelRepresentation)), n.dataRoomMetadata != null && (typeof n.dataRoomMetadata == "string" ? $util.base64.decode(n.dataRoomMetadata, o.dataRoomMetadata = $util.newBuffer($util.base64.length(n.dataRoomMetadata)), 0) : n.dataRoomMetadata.length >= 0 && (o.dataRoomMetadata = n.dataRoomMetadata)), o;
    }, r.toObject = function(n, o) {
      o || (o = {});
      let c = {};
      return o.defaults && (c.dataRoom = null), n.dataRoom != null && n.hasOwnProperty("dataRoom") && (c.dataRoom = $root.data_room.DataRoom.toObject(n.dataRoom, o)), n.highLevelRepresentation != null && n.hasOwnProperty("highLevelRepresentation") && (c.highLevelRepresentation = o.bytes === String ? $util.base64.encode(n.highLevelRepresentation, 0, n.highLevelRepresentation.length) : o.bytes === Array ? Array.prototype.slice.call(n.highLevelRepresentation) : n.highLevelRepresentation, o.oneofs && (c._highLevelRepresentation = "highLevelRepresentation")), n.dataRoomMetadata != null && n.hasOwnProperty("dataRoomMetadata") && (c.dataRoomMetadata = o.bytes === String ? $util.base64.encode(n.dataRoomMetadata, 0, n.dataRoomMetadata.length) : o.bytes === Array ? Array.prototype.slice.call(n.dataRoomMetadata) : n.dataRoomMetadata, o.oneofs && (c._dataRoomMetadata = "dataRoomMetadata")), c;
    }, r.prototype.toJSON = function() {
      return this.constructor.toObject(this, minimal.util.toJSONOptions);
    }, r.getTypeUrl = function(n) {
      return n === void 0 && (n = "type.googleapis.com"), n + "/gcg.CreateDataRoomRequest";
    }, r;
  }(), u.CreateDataRoomResponse = function() {
    function r(e) {
      if (e)
        for (let n = Object.keys(e), o = 0; o < n.length; ++o)
          e[n[o]] != null && (this[n[o]] = e[n[o]]);
    }
    r.prototype.dataRoomId = null, r.prototype.dataRoomValidationError = null;
    let a;
    return Object.defineProperty(r.prototype, "createDataRoomResponse", {
      get: $util.oneOfGetter(a = ["dataRoomId", "dataRoomValidationError"]),
      set: $util.oneOfSetter(a)
    }), r.create = function(n) {
      return new r(n);
    }, r.encode = function(n, o) {
      return o || (o = $Writer.create()), n.dataRoomId != null && Object.hasOwnProperty.call(n, "dataRoomId") && o.uint32(
        /* id 1, wireType 2 =*/
        10
      ).bytes(n.dataRoomId), n.dataRoomValidationError != null && Object.hasOwnProperty.call(n, "dataRoomValidationError") && $root.gcg.DataRoomValidationError.encode(n.dataRoomValidationError, o.uint32(
        /* id 2, wireType 2 =*/
        18
      ).fork()).ldelim(), o;
    }, r.encodeDelimited = function(n, o) {
      return this.encode(n, o).ldelim();
    }, r.decode = function(n, o) {
      n instanceof $Reader || (n = $Reader.create(n));
      let c = o === void 0 ? n.len : n.pos + o, l = new $root.gcg.CreateDataRoomResponse();
      for (; n.pos < c; ) {
        let d = n.uint32();
        switch (d >>> 3) {
          case 1: {
            l.dataRoomId = n.bytes();
            break;
          }
          case 2: {
            l.dataRoomValidationError = $root.gcg.DataRoomValidationError.decode(n, n.uint32());
            break;
          }
          default:
            n.skipType(d & 7);
            break;
        }
      }
      return l;
    }, r.decodeDelimited = function(n) {
      return n instanceof $Reader || (n = new $Reader(n)), this.decode(n, n.uint32());
    }, r.verify = function(n) {
      if (typeof n != "object" || n === null)
        return "object expected";
      let o = {};
      if (n.dataRoomId != null && n.hasOwnProperty("dataRoomId") && (o.createDataRoomResponse = 1, !(n.dataRoomId && typeof n.dataRoomId.length == "number" || $util.isString(n.dataRoomId))))
        return "dataRoomId: buffer expected";
      if (n.dataRoomValidationError != null && n.hasOwnProperty("dataRoomValidationError")) {
        if (o.createDataRoomResponse === 1)
          return "createDataRoomResponse: multiple values";
        o.createDataRoomResponse = 1;
        {
          let c = $root.gcg.DataRoomValidationError.verify(n.dataRoomValidationError);
          if (c)
            return "dataRoomValidationError." + c;
        }
      }
      return null;
    }, r.fromObject = function(n) {
      if (n instanceof $root.gcg.CreateDataRoomResponse)
        return n;
      let o = new $root.gcg.CreateDataRoomResponse();
      if (n.dataRoomId != null && (typeof n.dataRoomId == "string" ? $util.base64.decode(n.dataRoomId, o.dataRoomId = $util.newBuffer($util.base64.length(n.dataRoomId)), 0) : n.dataRoomId.length >= 0 && (o.dataRoomId = n.dataRoomId)), n.dataRoomValidationError != null) {
        if (typeof n.dataRoomValidationError != "object")
          throw TypeError(".gcg.CreateDataRoomResponse.dataRoomValidationError: object expected");
        o.dataRoomValidationError = $root.gcg.DataRoomValidationError.fromObject(n.dataRoomValidationError);
      }
      return o;
    }, r.toObject = function(n, o) {
      o || (o = {});
      let c = {};
      return n.dataRoomId != null && n.hasOwnProperty("dataRoomId") && (c.dataRoomId = o.bytes === String ? $util.base64.encode(n.dataRoomId, 0, n.dataRoomId.length) : o.bytes === Array ? Array.prototype.slice.call(n.dataRoomId) : n.dataRoomId, o.oneofs && (c.createDataRoomResponse = "dataRoomId")), n.dataRoomValidationError != null && n.hasOwnProperty("dataRoomValidationError") && (c.dataRoomValidationError = $root.gcg.DataRoomValidationError.toObject(n.dataRoomValidationError, o), o.oneofs && (c.createDataRoomResponse = "dataRoomValidationError")), c;
    }, r.prototype.toJSON = function() {
      return this.constructor.toObject(this, minimal.util.toJSONOptions);
    }, r.getTypeUrl = function(n) {
      return n === void 0 && (n = "type.googleapis.com"), n + "/gcg.CreateDataRoomResponse";
    }, r;
  }(), u.DataRoomValidationError = function() {
    function r(e) {
      if (e)
        for (let n = Object.keys(e), o = 0; o < n.length; ++o)
          e[n[o]] != null && (this[n[o]] = e[n[o]]);
    }
    r.prototype.message = "", r.prototype.permissionIndex = null, r.prototype.computeNodeId = null, r.prototype.userPermissionId = null, r.prototype.attestationSpecificationId = null, r.prototype.authenticationMethodId = null;
    let a;
    return Object.defineProperty(r.prototype, "_permissionIndex", {
      get: $util.oneOfGetter(a = ["permissionIndex"]),
      set: $util.oneOfSetter(a)
    }), Object.defineProperty(r.prototype, "_computeNodeId", {
      get: $util.oneOfGetter(a = ["computeNodeId"]),
      set: $util.oneOfSetter(a)
    }), Object.defineProperty(r.prototype, "_userPermissionId", {
      get: $util.oneOfGetter(a = ["userPermissionId"]),
      set: $util.oneOfSetter(a)
    }), Object.defineProperty(r.prototype, "_attestationSpecificationId", {
      get: $util.oneOfGetter(a = ["attestationSpecificationId"]),
      set: $util.oneOfSetter(a)
    }), Object.defineProperty(r.prototype, "_authenticationMethodId", {
      get: $util.oneOfGetter(a = ["authenticationMethodId"]),
      set: $util.oneOfSetter(a)
    }), r.create = function(n) {
      return new r(n);
    }, r.encode = function(n, o) {
      return o || (o = $Writer.create()), n.message != null && Object.hasOwnProperty.call(n, "message") && o.uint32(
        /* id 1, wireType 2 =*/
        10
      ).string(n.message), n.permissionIndex != null && Object.hasOwnProperty.call(n, "permissionIndex") && o.uint32(
        /* id 2, wireType 0 =*/
        16
      ).uint64(n.permissionIndex), n.computeNodeId != null && Object.hasOwnProperty.call(n, "computeNodeId") && o.uint32(
        /* id 3, wireType 2 =*/
        26
      ).string(n.computeNodeId), n.userPermissionId != null && Object.hasOwnProperty.call(n, "userPermissionId") && o.uint32(
        /* id 4, wireType 2 =*/
        34
      ).string(n.userPermissionId), n.attestationSpecificationId != null && Object.hasOwnProperty.call(n, "attestationSpecificationId") && o.uint32(
        /* id 5, wireType 2 =*/
        42
      ).string(n.attestationSpecificationId), n.authenticationMethodId != null && Object.hasOwnProperty.call(n, "authenticationMethodId") && o.uint32(
        /* id 6, wireType 2 =*/
        50
      ).string(n.authenticationMethodId), o;
    }, r.encodeDelimited = function(n, o) {
      return this.encode(n, o).ldelim();
    }, r.decode = function(n, o) {
      n instanceof $Reader || (n = $Reader.create(n));
      let c = o === void 0 ? n.len : n.pos + o, l = new $root.gcg.DataRoomValidationError();
      for (; n.pos < c; ) {
        let d = n.uint32();
        switch (d >>> 3) {
          case 1: {
            l.message = n.string();
            break;
          }
          case 2: {
            l.permissionIndex = n.uint64();
            break;
          }
          case 3: {
            l.computeNodeId = n.string();
            break;
          }
          case 4: {
            l.userPermissionId = n.string();
            break;
          }
          case 5: {
            l.attestationSpecificationId = n.string();
            break;
          }
          case 6: {
            l.authenticationMethodId = n.string();
            break;
          }
          default:
            n.skipType(d & 7);
            break;
        }
      }
      return l;
    }, r.decodeDelimited = function(n) {
      return n instanceof $Reader || (n = new $Reader(n)), this.decode(n, n.uint32());
    }, r.verify = function(n) {
      return typeof n != "object" || n === null ? "object expected" : n.message != null && n.hasOwnProperty("message") && !$util.isString(n.message) ? "message: string expected" : n.permissionIndex != null && n.hasOwnProperty("permissionIndex") && !$util.isInteger(n.permissionIndex) && !(n.permissionIndex && $util.isInteger(n.permissionIndex.low) && $util.isInteger(n.permissionIndex.high)) ? "permissionIndex: integer|Long expected" : n.computeNodeId != null && n.hasOwnProperty("computeNodeId") && !$util.isString(n.computeNodeId) ? "computeNodeId: string expected" : n.userPermissionId != null && n.hasOwnProperty("userPermissionId") && !$util.isString(n.userPermissionId) ? "userPermissionId: string expected" : n.attestationSpecificationId != null && n.hasOwnProperty("attestationSpecificationId") && !$util.isString(n.attestationSpecificationId) ? "attestationSpecificationId: string expected" : n.authenticationMethodId != null && n.hasOwnProperty("authenticationMethodId") && !$util.isString(n.authenticationMethodId) ? "authenticationMethodId: string expected" : null;
    }, r.fromObject = function(n) {
      if (n instanceof $root.gcg.DataRoomValidationError)
        return n;
      let o = new $root.gcg.DataRoomValidationError();
      return n.message != null && (o.message = String(n.message)), n.permissionIndex != null && ($util.Long ? (o.permissionIndex = $util.Long.fromValue(n.permissionIndex)).unsigned = !0 : typeof n.permissionIndex == "string" ? o.permissionIndex = parseInt(n.permissionIndex, 10) : typeof n.permissionIndex == "number" ? o.permissionIndex = n.permissionIndex : typeof n.permissionIndex == "object" && (o.permissionIndex = new $util.LongBits(n.permissionIndex.low >>> 0, n.permissionIndex.high >>> 0).toNumber(!0))), n.computeNodeId != null && (o.computeNodeId = String(n.computeNodeId)), n.userPermissionId != null && (o.userPermissionId = String(n.userPermissionId)), n.attestationSpecificationId != null && (o.attestationSpecificationId = String(n.attestationSpecificationId)), n.authenticationMethodId != null && (o.authenticationMethodId = String(n.authenticationMethodId)), o;
    }, r.toObject = function(n, o) {
      o || (o = {});
      let c = {};
      return o.defaults && (c.message = ""), n.message != null && n.hasOwnProperty("message") && (c.message = n.message), n.permissionIndex != null && n.hasOwnProperty("permissionIndex") && (typeof n.permissionIndex == "number" ? c.permissionIndex = o.longs === String ? String(n.permissionIndex) : n.permissionIndex : c.permissionIndex = o.longs === String ? $util.Long.prototype.toString.call(n.permissionIndex) : o.longs === Number ? new $util.LongBits(n.permissionIndex.low >>> 0, n.permissionIndex.high >>> 0).toNumber(!0) : n.permissionIndex, o.oneofs && (c._permissionIndex = "permissionIndex")), n.computeNodeId != null && n.hasOwnProperty("computeNodeId") && (c.computeNodeId = n.computeNodeId, o.oneofs && (c._computeNodeId = "computeNodeId")), n.userPermissionId != null && n.hasOwnProperty("userPermissionId") && (c.userPermissionId = n.userPermissionId, o.oneofs && (c._userPermissionId = "userPermissionId")), n.attestationSpecificationId != null && n.hasOwnProperty("attestationSpecificationId") && (c.attestationSpecificationId = n.attestationSpecificationId, o.oneofs && (c._attestationSpecificationId = "attestationSpecificationId")), n.authenticationMethodId != null && n.hasOwnProperty("authenticationMethodId") && (c.authenticationMethodId = n.authenticationMethodId, o.oneofs && (c._authenticationMethodId = "authenticationMethodId")), c;
    }, r.prototype.toJSON = function() {
      return this.constructor.toObject(this, minimal.util.toJSONOptions);
    }, r.getTypeUrl = function(n) {
      return n === void 0 && (n = "type.googleapis.com"), n + "/gcg.DataRoomValidationError";
    }, r;
  }(), u.PublishDatasetToDataRoomRequest = function() {
    function r(a) {
      if (a)
        for (let e = Object.keys(a), n = 0; n < e.length; ++n)
          a[e[n]] != null && (this[e[n]] = a[e[n]]);
    }
    return r.prototype.datasetHash = $util.newBuffer([]), r.prototype.dataRoomId = $util.newBuffer([]), r.prototype.leafId = "", r.prototype.encryptionKey = $util.newBuffer([]), r.prototype.scope = $util.newBuffer([]), r.create = function(e) {
      return new r(e);
    }, r.encode = function(e, n) {
      return n || (n = $Writer.create()), e.datasetHash != null && Object.hasOwnProperty.call(e, "datasetHash") && n.uint32(
        /* id 1, wireType 2 =*/
        10
      ).bytes(e.datasetHash), e.dataRoomId != null && Object.hasOwnProperty.call(e, "dataRoomId") && n.uint32(
        /* id 2, wireType 2 =*/
        18
      ).bytes(e.dataRoomId), e.leafId != null && Object.hasOwnProperty.call(e, "leafId") && n.uint32(
        /* id 3, wireType 2 =*/
        26
      ).string(e.leafId), e.encryptionKey != null && Object.hasOwnProperty.call(e, "encryptionKey") && n.uint32(
        /* id 4, wireType 2 =*/
        34
      ).bytes(e.encryptionKey), e.scope != null && Object.hasOwnProperty.call(e, "scope") && n.uint32(
        /* id 5, wireType 2 =*/
        42
      ).bytes(e.scope), n;
    }, r.encodeDelimited = function(e, n) {
      return this.encode(e, n).ldelim();
    }, r.decode = function(e, n) {
      e instanceof $Reader || (e = $Reader.create(e));
      let o = n === void 0 ? e.len : e.pos + n, c = new $root.gcg.PublishDatasetToDataRoomRequest();
      for (; e.pos < o; ) {
        let l = e.uint32();
        switch (l >>> 3) {
          case 1: {
            c.datasetHash = e.bytes();
            break;
          }
          case 2: {
            c.dataRoomId = e.bytes();
            break;
          }
          case 3: {
            c.leafId = e.string();
            break;
          }
          case 4: {
            c.encryptionKey = e.bytes();
            break;
          }
          case 5: {
            c.scope = e.bytes();
            break;
          }
          default:
            e.skipType(l & 7);
            break;
        }
      }
      return c;
    }, r.decodeDelimited = function(e) {
      return e instanceof $Reader || (e = new $Reader(e)), this.decode(e, e.uint32());
    }, r.verify = function(e) {
      return typeof e != "object" || e === null ? "object expected" : e.datasetHash != null && e.hasOwnProperty("datasetHash") && !(e.datasetHash && typeof e.datasetHash.length == "number" || $util.isString(e.datasetHash)) ? "datasetHash: buffer expected" : e.dataRoomId != null && e.hasOwnProperty("dataRoomId") && !(e.dataRoomId && typeof e.dataRoomId.length == "number" || $util.isString(e.dataRoomId)) ? "dataRoomId: buffer expected" : e.leafId != null && e.hasOwnProperty("leafId") && !$util.isString(e.leafId) ? "leafId: string expected" : e.encryptionKey != null && e.hasOwnProperty("encryptionKey") && !(e.encryptionKey && typeof e.encryptionKey.length == "number" || $util.isString(e.encryptionKey)) ? "encryptionKey: buffer expected" : e.scope != null && e.hasOwnProperty("scope") && !(e.scope && typeof e.scope.length == "number" || $util.isString(e.scope)) ? "scope: buffer expected" : null;
    }, r.fromObject = function(e) {
      if (e instanceof $root.gcg.PublishDatasetToDataRoomRequest)
        return e;
      let n = new $root.gcg.PublishDatasetToDataRoomRequest();
      return e.datasetHash != null && (typeof e.datasetHash == "string" ? $util.base64.decode(e.datasetHash, n.datasetHash = $util.newBuffer($util.base64.length(e.datasetHash)), 0) : e.datasetHash.length >= 0 && (n.datasetHash = e.datasetHash)), e.dataRoomId != null && (typeof e.dataRoomId == "string" ? $util.base64.decode(e.dataRoomId, n.dataRoomId = $util.newBuffer($util.base64.length(e.dataRoomId)), 0) : e.dataRoomId.length >= 0 && (n.dataRoomId = e.dataRoomId)), e.leafId != null && (n.leafId = String(e.leafId)), e.encryptionKey != null && (typeof e.encryptionKey == "string" ? $util.base64.decode(e.encryptionKey, n.encryptionKey = $util.newBuffer($util.base64.length(e.encryptionKey)), 0) : e.encryptionKey.length >= 0 && (n.encryptionKey = e.encryptionKey)), e.scope != null && (typeof e.scope == "string" ? $util.base64.decode(e.scope, n.scope = $util.newBuffer($util.base64.length(e.scope)), 0) : e.scope.length >= 0 && (n.scope = e.scope)), n;
    }, r.toObject = function(e, n) {
      n || (n = {});
      let o = {};
      return n.defaults && (n.bytes === String ? o.datasetHash = "" : (o.datasetHash = [], n.bytes !== Array && (o.datasetHash = $util.newBuffer(o.datasetHash))), n.bytes === String ? o.dataRoomId = "" : (o.dataRoomId = [], n.bytes !== Array && (o.dataRoomId = $util.newBuffer(o.dataRoomId))), o.leafId = "", n.bytes === String ? o.encryptionKey = "" : (o.encryptionKey = [], n.bytes !== Array && (o.encryptionKey = $util.newBuffer(o.encryptionKey))), n.bytes === String ? o.scope = "" : (o.scope = [], n.bytes !== Array && (o.scope = $util.newBuffer(o.scope)))), e.datasetHash != null && e.hasOwnProperty("datasetHash") && (o.datasetHash = n.bytes === String ? $util.base64.encode(e.datasetHash, 0, e.datasetHash.length) : n.bytes === Array ? Array.prototype.slice.call(e.datasetHash) : e.datasetHash), e.dataRoomId != null && e.hasOwnProperty("dataRoomId") && (o.dataRoomId = n.bytes === String ? $util.base64.encode(e.dataRoomId, 0, e.dataRoomId.length) : n.bytes === Array ? Array.prototype.slice.call(e.dataRoomId) : e.dataRoomId), e.leafId != null && e.hasOwnProperty("leafId") && (o.leafId = e.leafId), e.encryptionKey != null && e.hasOwnProperty("encryptionKey") && (o.encryptionKey = n.bytes === String ? $util.base64.encode(e.encryptionKey, 0, e.encryptionKey.length) : n.bytes === Array ? Array.prototype.slice.call(e.encryptionKey) : e.encryptionKey), e.scope != null && e.hasOwnProperty("scope") && (o.scope = n.bytes === String ? $util.base64.encode(e.scope, 0, e.scope.length) : n.bytes === Array ? Array.prototype.slice.call(e.scope) : e.scope), o;
    }, r.prototype.toJSON = function() {
      return this.constructor.toObject(this, minimal.util.toJSONOptions);
    }, r.getTypeUrl = function(e) {
      return e === void 0 && (e = "type.googleapis.com"), e + "/gcg.PublishDatasetToDataRoomRequest";
    }, r;
  }(), u.PublishDatasetToDataRoomResponse = function() {
    function r(a) {
      if (a)
        for (let e = Object.keys(a), n = 0; n < e.length; ++n)
          a[e[n]] != null && (this[e[n]] = a[e[n]]);
    }
    return r.create = function(e) {
      return new r(e);
    }, r.encode = function(e, n) {
      return n || (n = $Writer.create()), n;
    }, r.encodeDelimited = function(e, n) {
      return this.encode(e, n).ldelim();
    }, r.decode = function(e, n) {
      e instanceof $Reader || (e = $Reader.create(e));
      let o = n === void 0 ? e.len : e.pos + n, c = new $root.gcg.PublishDatasetToDataRoomResponse();
      for (; e.pos < o; ) {
        let l = e.uint32();
        switch (l >>> 3) {
          default:
            e.skipType(l & 7);
            break;
        }
      }
      return c;
    }, r.decodeDelimited = function(e) {
      return e instanceof $Reader || (e = new $Reader(e)), this.decode(e, e.uint32());
    }, r.verify = function(e) {
      return typeof e != "object" || e === null ? "object expected" : null;
    }, r.fromObject = function(e) {
      return e instanceof $root.gcg.PublishDatasetToDataRoomResponse ? e : new $root.gcg.PublishDatasetToDataRoomResponse();
    }, r.toObject = function() {
      return {};
    }, r.prototype.toJSON = function() {
      return this.constructor.toObject(this, minimal.util.toJSONOptions);
    }, r.getTypeUrl = function(e) {
      return e === void 0 && (e = "type.googleapis.com"), e + "/gcg.PublishDatasetToDataRoomResponse";
    }, r;
  }(), u.ExecuteComputeRequest = function() {
    function r(a) {
      if (this.computeNodeIds = [], this.parameters = {}, this.testDatasets = {}, a)
        for (let e = Object.keys(a), n = 0; n < e.length; ++n)
          a[e[n]] != null && (this[e[n]] = a[e[n]]);
    }
    return r.prototype.dataRoomId = $util.newBuffer([]), r.prototype.computeNodeIds = $util.emptyArray, r.prototype.isDryRun = !1, r.prototype.scope = $util.newBuffer([]), r.prototype.parameters = $util.emptyObject, r.prototype.testDatasets = $util.emptyObject, r.create = function(e) {
      return new r(e);
    }, r.encode = function(e, n) {
      if (n || (n = $Writer.create()), e.dataRoomId != null && Object.hasOwnProperty.call(e, "dataRoomId") && n.uint32(
        /* id 1, wireType 2 =*/
        10
      ).bytes(e.dataRoomId), e.computeNodeIds != null && e.computeNodeIds.length)
        for (let o = 0; o < e.computeNodeIds.length; ++o)
          n.uint32(
            /* id 2, wireType 2 =*/
            18
          ).string(e.computeNodeIds[o]);
      if (e.isDryRun != null && Object.hasOwnProperty.call(e, "isDryRun") && n.uint32(
        /* id 3, wireType 0 =*/
        24
      ).bool(e.isDryRun), e.scope != null && Object.hasOwnProperty.call(e, "scope") && n.uint32(
        /* id 4, wireType 2 =*/
        34
      ).bytes(e.scope), e.parameters != null && Object.hasOwnProperty.call(e, "parameters"))
        for (let o = Object.keys(e.parameters), c = 0; c < o.length; ++c)
          n.uint32(
            /* id 5, wireType 2 =*/
            42
          ).fork().uint32(
            /* id 1, wireType 2 =*/
            10
          ).string(o[c]).uint32(
            /* id 2, wireType 2 =*/
            18
          ).string(e.parameters[o[c]]).ldelim();
      if (e.testDatasets != null && Object.hasOwnProperty.call(e, "testDatasets"))
        for (let o = Object.keys(e.testDatasets), c = 0; c < o.length; ++c)
          n.uint32(
            /* id 6, wireType 2 =*/
            50
          ).fork().uint32(
            /* id 1, wireType 2 =*/
            10
          ).string(o[c]), $root.gcg.TestDataset.encode(e.testDatasets[o[c]], n.uint32(
            /* id 2, wireType 2 =*/
            18
          ).fork()).ldelim().ldelim();
      return n;
    }, r.encodeDelimited = function(e, n) {
      return this.encode(e, n).ldelim();
    }, r.decode = function(e, n) {
      e instanceof $Reader || (e = $Reader.create(e));
      let o = n === void 0 ? e.len : e.pos + n, c = new $root.gcg.ExecuteComputeRequest(), l, d;
      for (; e.pos < o; ) {
        let p = e.uint32();
        switch (p >>> 3) {
          case 1: {
            c.dataRoomId = e.bytes();
            break;
          }
          case 2: {
            c.computeNodeIds && c.computeNodeIds.length || (c.computeNodeIds = []), c.computeNodeIds.push(e.string());
            break;
          }
          case 3: {
            c.isDryRun = e.bool();
            break;
          }
          case 4: {
            c.scope = e.bytes();
            break;
          }
          case 5: {
            c.parameters === $util.emptyObject && (c.parameters = {});
            let h = e.uint32() + e.pos;
            for (l = "", d = ""; e.pos < h; ) {
              let g = e.uint32();
              switch (g >>> 3) {
                case 1:
                  l = e.string();
                  break;
                case 2:
                  d = e.string();
                  break;
                default:
                  e.skipType(g & 7);
                  break;
              }
            }
            c.parameters[l] = d;
            break;
          }
          case 6: {
            c.testDatasets === $util.emptyObject && (c.testDatasets = {});
            let h = e.uint32() + e.pos;
            for (l = "", d = null; e.pos < h; ) {
              let g = e.uint32();
              switch (g >>> 3) {
                case 1:
                  l = e.string();
                  break;
                case 2:
                  d = $root.gcg.TestDataset.decode(e, e.uint32());
                  break;
                default:
                  e.skipType(g & 7);
                  break;
              }
            }
            c.testDatasets[l] = d;
            break;
          }
          default:
            e.skipType(p & 7);
            break;
        }
      }
      return c;
    }, r.decodeDelimited = function(e) {
      return e instanceof $Reader || (e = new $Reader(e)), this.decode(e, e.uint32());
    }, r.verify = function(e) {
      if (typeof e != "object" || e === null)
        return "object expected";
      if (e.dataRoomId != null && e.hasOwnProperty("dataRoomId") && !(e.dataRoomId && typeof e.dataRoomId.length == "number" || $util.isString(e.dataRoomId)))
        return "dataRoomId: buffer expected";
      if (e.computeNodeIds != null && e.hasOwnProperty("computeNodeIds")) {
        if (!Array.isArray(e.computeNodeIds))
          return "computeNodeIds: array expected";
        for (let n = 0; n < e.computeNodeIds.length; ++n)
          if (!$util.isString(e.computeNodeIds[n]))
            return "computeNodeIds: string[] expected";
      }
      if (e.isDryRun != null && e.hasOwnProperty("isDryRun") && typeof e.isDryRun != "boolean")
        return "isDryRun: boolean expected";
      if (e.scope != null && e.hasOwnProperty("scope") && !(e.scope && typeof e.scope.length == "number" || $util.isString(e.scope)))
        return "scope: buffer expected";
      if (e.parameters != null && e.hasOwnProperty("parameters")) {
        if (!$util.isObject(e.parameters))
          return "parameters: object expected";
        let n = Object.keys(e.parameters);
        for (let o = 0; o < n.length; ++o)
          if (!$util.isString(e.parameters[n[o]]))
            return "parameters: string{k:string} expected";
      }
      if (e.testDatasets != null && e.hasOwnProperty("testDatasets")) {
        if (!$util.isObject(e.testDatasets))
          return "testDatasets: object expected";
        let n = Object.keys(e.testDatasets);
        for (let o = 0; o < n.length; ++o) {
          let c = $root.gcg.TestDataset.verify(e.testDatasets[n[o]]);
          if (c)
            return "testDatasets." + c;
        }
      }
      return null;
    }, r.fromObject = function(e) {
      if (e instanceof $root.gcg.ExecuteComputeRequest)
        return e;
      let n = new $root.gcg.ExecuteComputeRequest();
      if (e.dataRoomId != null && (typeof e.dataRoomId == "string" ? $util.base64.decode(e.dataRoomId, n.dataRoomId = $util.newBuffer($util.base64.length(e.dataRoomId)), 0) : e.dataRoomId.length >= 0 && (n.dataRoomId = e.dataRoomId)), e.computeNodeIds) {
        if (!Array.isArray(e.computeNodeIds))
          throw TypeError(".gcg.ExecuteComputeRequest.computeNodeIds: array expected");
        n.computeNodeIds = [];
        for (let o = 0; o < e.computeNodeIds.length; ++o)
          n.computeNodeIds[o] = String(e.computeNodeIds[o]);
      }
      if (e.isDryRun != null && (n.isDryRun = !!e.isDryRun), e.scope != null && (typeof e.scope == "string" ? $util.base64.decode(e.scope, n.scope = $util.newBuffer($util.base64.length(e.scope)), 0) : e.scope.length >= 0 && (n.scope = e.scope)), e.parameters) {
        if (typeof e.parameters != "object")
          throw TypeError(".gcg.ExecuteComputeRequest.parameters: object expected");
        n.parameters = {};
        for (let o = Object.keys(e.parameters), c = 0; c < o.length; ++c)
          n.parameters[o[c]] = String(e.parameters[o[c]]);
      }
      if (e.testDatasets) {
        if (typeof e.testDatasets != "object")
          throw TypeError(".gcg.ExecuteComputeRequest.testDatasets: object expected");
        n.testDatasets = {};
        for (let o = Object.keys(e.testDatasets), c = 0; c < o.length; ++c) {
          if (typeof e.testDatasets[o[c]] != "object")
            throw TypeError(".gcg.ExecuteComputeRequest.testDatasets: object expected");
          n.testDatasets[o[c]] = $root.gcg.TestDataset.fromObject(e.testDatasets[o[c]]);
        }
      }
      return n;
    }, r.toObject = function(e, n) {
      n || (n = {});
      let o = {};
      if ((n.arrays || n.defaults) && (o.computeNodeIds = []), (n.objects || n.defaults) && (o.parameters = {}, o.testDatasets = {}), n.defaults && (n.bytes === String ? o.dataRoomId = "" : (o.dataRoomId = [], n.bytes !== Array && (o.dataRoomId = $util.newBuffer(o.dataRoomId))), o.isDryRun = !1, n.bytes === String ? o.scope = "" : (o.scope = [], n.bytes !== Array && (o.scope = $util.newBuffer(o.scope)))), e.dataRoomId != null && e.hasOwnProperty("dataRoomId") && (o.dataRoomId = n.bytes === String ? $util.base64.encode(e.dataRoomId, 0, e.dataRoomId.length) : n.bytes === Array ? Array.prototype.slice.call(e.dataRoomId) : e.dataRoomId), e.computeNodeIds && e.computeNodeIds.length) {
        o.computeNodeIds = [];
        for (let l = 0; l < e.computeNodeIds.length; ++l)
          o.computeNodeIds[l] = e.computeNodeIds[l];
      }
      e.isDryRun != null && e.hasOwnProperty("isDryRun") && (o.isDryRun = e.isDryRun), e.scope != null && e.hasOwnProperty("scope") && (o.scope = n.bytes === String ? $util.base64.encode(e.scope, 0, e.scope.length) : n.bytes === Array ? Array.prototype.slice.call(e.scope) : e.scope);
      let c;
      if (e.parameters && (c = Object.keys(e.parameters)).length) {
        o.parameters = {};
        for (let l = 0; l < c.length; ++l)
          o.parameters[c[l]] = e.parameters[c[l]];
      }
      if (e.testDatasets && (c = Object.keys(e.testDatasets)).length) {
        o.testDatasets = {};
        for (let l = 0; l < c.length; ++l)
          o.testDatasets[c[l]] = $root.gcg.TestDataset.toObject(e.testDatasets[c[l]], n);
      }
      return o;
    }, r.prototype.toJSON = function() {
      return this.constructor.toObject(this, minimal.util.toJSONOptions);
    }, r.getTypeUrl = function(e) {
      return e === void 0 && (e = "type.googleapis.com"), e + "/gcg.ExecuteComputeRequest";
    }, r;
  }(), u.ExecuteDevelopmentComputeRequest = function() {
    function r(a) {
      if (this.computeNodeIds = [], this.parameters = {}, this.testDatasets = {}, a)
        for (let e = Object.keys(a), n = 0; n < e.length; ++n)
          a[e[n]] != null && (this[e[n]] = a[e[n]]);
    }
    return r.prototype.configurationCommitId = $util.newBuffer([]), r.prototype.computeNodeIds = $util.emptyArray, r.prototype.isDryRun = !1, r.prototype.scope = $util.newBuffer([]), r.prototype.parameters = $util.emptyObject, r.prototype.testDatasets = $util.emptyObject, r.create = function(e) {
      return new r(e);
    }, r.encode = function(e, n) {
      if (n || (n = $Writer.create()), e.configurationCommitId != null && Object.hasOwnProperty.call(e, "configurationCommitId") && n.uint32(
        /* id 1, wireType 2 =*/
        10
      ).bytes(e.configurationCommitId), e.computeNodeIds != null && e.computeNodeIds.length)
        for (let o = 0; o < e.computeNodeIds.length; ++o)
          n.uint32(
            /* id 2, wireType 2 =*/
            18
          ).string(e.computeNodeIds[o]);
      if (e.isDryRun != null && Object.hasOwnProperty.call(e, "isDryRun") && n.uint32(
        /* id 3, wireType 0 =*/
        24
      ).bool(e.isDryRun), e.scope != null && Object.hasOwnProperty.call(e, "scope") && n.uint32(
        /* id 4, wireType 2 =*/
        34
      ).bytes(e.scope), e.parameters != null && Object.hasOwnProperty.call(e, "parameters"))
        for (let o = Object.keys(e.parameters), c = 0; c < o.length; ++c)
          n.uint32(
            /* id 5, wireType 2 =*/
            42
          ).fork().uint32(
            /* id 1, wireType 2 =*/
            10
          ).string(o[c]).uint32(
            /* id 2, wireType 2 =*/
            18
          ).string(e.parameters[o[c]]).ldelim();
      if (e.testDatasets != null && Object.hasOwnProperty.call(e, "testDatasets"))
        for (let o = Object.keys(e.testDatasets), c = 0; c < o.length; ++c)
          n.uint32(
            /* id 6, wireType 2 =*/
            50
          ).fork().uint32(
            /* id 1, wireType 2 =*/
            10
          ).string(o[c]), $root.gcg.TestDataset.encode(e.testDatasets[o[c]], n.uint32(
            /* id 2, wireType 2 =*/
            18
          ).fork()).ldelim().ldelim();
      return n;
    }, r.encodeDelimited = function(e, n) {
      return this.encode(e, n).ldelim();
    }, r.decode = function(e, n) {
      e instanceof $Reader || (e = $Reader.create(e));
      let o = n === void 0 ? e.len : e.pos + n, c = new $root.gcg.ExecuteDevelopmentComputeRequest(), l, d;
      for (; e.pos < o; ) {
        let p = e.uint32();
        switch (p >>> 3) {
          case 1: {
            c.configurationCommitId = e.bytes();
            break;
          }
          case 2: {
            c.computeNodeIds && c.computeNodeIds.length || (c.computeNodeIds = []), c.computeNodeIds.push(e.string());
            break;
          }
          case 3: {
            c.isDryRun = e.bool();
            break;
          }
          case 4: {
            c.scope = e.bytes();
            break;
          }
          case 5: {
            c.parameters === $util.emptyObject && (c.parameters = {});
            let h = e.uint32() + e.pos;
            for (l = "", d = ""; e.pos < h; ) {
              let g = e.uint32();
              switch (g >>> 3) {
                case 1:
                  l = e.string();
                  break;
                case 2:
                  d = e.string();
                  break;
                default:
                  e.skipType(g & 7);
                  break;
              }
            }
            c.parameters[l] = d;
            break;
          }
          case 6: {
            c.testDatasets === $util.emptyObject && (c.testDatasets = {});
            let h = e.uint32() + e.pos;
            for (l = "", d = null; e.pos < h; ) {
              let g = e.uint32();
              switch (g >>> 3) {
                case 1:
                  l = e.string();
                  break;
                case 2:
                  d = $root.gcg.TestDataset.decode(e, e.uint32());
                  break;
                default:
                  e.skipType(g & 7);
                  break;
              }
            }
            c.testDatasets[l] = d;
            break;
          }
          default:
            e.skipType(p & 7);
            break;
        }
      }
      return c;
    }, r.decodeDelimited = function(e) {
      return e instanceof $Reader || (e = new $Reader(e)), this.decode(e, e.uint32());
    }, r.verify = function(e) {
      if (typeof e != "object" || e === null)
        return "object expected";
      if (e.configurationCommitId != null && e.hasOwnProperty("configurationCommitId") && !(e.configurationCommitId && typeof e.configurationCommitId.length == "number" || $util.isString(e.configurationCommitId)))
        return "configurationCommitId: buffer expected";
      if (e.computeNodeIds != null && e.hasOwnProperty("computeNodeIds")) {
        if (!Array.isArray(e.computeNodeIds))
          return "computeNodeIds: array expected";
        for (let n = 0; n < e.computeNodeIds.length; ++n)
          if (!$util.isString(e.computeNodeIds[n]))
            return "computeNodeIds: string[] expected";
      }
      if (e.isDryRun != null && e.hasOwnProperty("isDryRun") && typeof e.isDryRun != "boolean")
        return "isDryRun: boolean expected";
      if (e.scope != null && e.hasOwnProperty("scope") && !(e.scope && typeof e.scope.length == "number" || $util.isString(e.scope)))
        return "scope: buffer expected";
      if (e.parameters != null && e.hasOwnProperty("parameters")) {
        if (!$util.isObject(e.parameters))
          return "parameters: object expected";
        let n = Object.keys(e.parameters);
        for (let o = 0; o < n.length; ++o)
          if (!$util.isString(e.parameters[n[o]]))
            return "parameters: string{k:string} expected";
      }
      if (e.testDatasets != null && e.hasOwnProperty("testDatasets")) {
        if (!$util.isObject(e.testDatasets))
          return "testDatasets: object expected";
        let n = Object.keys(e.testDatasets);
        for (let o = 0; o < n.length; ++o) {
          let c = $root.gcg.TestDataset.verify(e.testDatasets[n[o]]);
          if (c)
            return "testDatasets." + c;
        }
      }
      return null;
    }, r.fromObject = function(e) {
      if (e instanceof $root.gcg.ExecuteDevelopmentComputeRequest)
        return e;
      let n = new $root.gcg.ExecuteDevelopmentComputeRequest();
      if (e.configurationCommitId != null && (typeof e.configurationCommitId == "string" ? $util.base64.decode(e.configurationCommitId, n.configurationCommitId = $util.newBuffer($util.base64.length(e.configurationCommitId)), 0) : e.configurationCommitId.length >= 0 && (n.configurationCommitId = e.configurationCommitId)), e.computeNodeIds) {
        if (!Array.isArray(e.computeNodeIds))
          throw TypeError(".gcg.ExecuteDevelopmentComputeRequest.computeNodeIds: array expected");
        n.computeNodeIds = [];
        for (let o = 0; o < e.computeNodeIds.length; ++o)
          n.computeNodeIds[o] = String(e.computeNodeIds[o]);
      }
      if (e.isDryRun != null && (n.isDryRun = !!e.isDryRun), e.scope != null && (typeof e.scope == "string" ? $util.base64.decode(e.scope, n.scope = $util.newBuffer($util.base64.length(e.scope)), 0) : e.scope.length >= 0 && (n.scope = e.scope)), e.parameters) {
        if (typeof e.parameters != "object")
          throw TypeError(".gcg.ExecuteDevelopmentComputeRequest.parameters: object expected");
        n.parameters = {};
        for (let o = Object.keys(e.parameters), c = 0; c < o.length; ++c)
          n.parameters[o[c]] = String(e.parameters[o[c]]);
      }
      if (e.testDatasets) {
        if (typeof e.testDatasets != "object")
          throw TypeError(".gcg.ExecuteDevelopmentComputeRequest.testDatasets: object expected");
        n.testDatasets = {};
        for (let o = Object.keys(e.testDatasets), c = 0; c < o.length; ++c) {
          if (typeof e.testDatasets[o[c]] != "object")
            throw TypeError(".gcg.ExecuteDevelopmentComputeRequest.testDatasets: object expected");
          n.testDatasets[o[c]] = $root.gcg.TestDataset.fromObject(e.testDatasets[o[c]]);
        }
      }
      return n;
    }, r.toObject = function(e, n) {
      n || (n = {});
      let o = {};
      if ((n.arrays || n.defaults) && (o.computeNodeIds = []), (n.objects || n.defaults) && (o.parameters = {}, o.testDatasets = {}), n.defaults && (n.bytes === String ? o.configurationCommitId = "" : (o.configurationCommitId = [], n.bytes !== Array && (o.configurationCommitId = $util.newBuffer(o.configurationCommitId))), o.isDryRun = !1, n.bytes === String ? o.scope = "" : (o.scope = [], n.bytes !== Array && (o.scope = $util.newBuffer(o.scope)))), e.configurationCommitId != null && e.hasOwnProperty("configurationCommitId") && (o.configurationCommitId = n.bytes === String ? $util.base64.encode(e.configurationCommitId, 0, e.configurationCommitId.length) : n.bytes === Array ? Array.prototype.slice.call(e.configurationCommitId) : e.configurationCommitId), e.computeNodeIds && e.computeNodeIds.length) {
        o.computeNodeIds = [];
        for (let l = 0; l < e.computeNodeIds.length; ++l)
          o.computeNodeIds[l] = e.computeNodeIds[l];
      }
      e.isDryRun != null && e.hasOwnProperty("isDryRun") && (o.isDryRun = e.isDryRun), e.scope != null && e.hasOwnProperty("scope") && (o.scope = n.bytes === String ? $util.base64.encode(e.scope, 0, e.scope.length) : n.bytes === Array ? Array.prototype.slice.call(e.scope) : e.scope);
      let c;
      if (e.parameters && (c = Object.keys(e.parameters)).length) {
        o.parameters = {};
        for (let l = 0; l < c.length; ++l)
          o.parameters[c[l]] = e.parameters[c[l]];
      }
      if (e.testDatasets && (c = Object.keys(e.testDatasets)).length) {
        o.testDatasets = {};
        for (let l = 0; l < c.length; ++l)
          o.testDatasets[c[l]] = $root.gcg.TestDataset.toObject(e.testDatasets[c[l]], n);
      }
      return o;
    }, r.prototype.toJSON = function() {
      return this.constructor.toObject(this, minimal.util.toJSONOptions);
    }, r.getTypeUrl = function(e) {
      return e === void 0 && (e = "type.googleapis.com"), e + "/gcg.ExecuteDevelopmentComputeRequest";
    }, r;
  }(), u.TestDataset = function() {
    function r(a) {
      if (a)
        for (let e = Object.keys(a), n = 0; n < e.length; ++n)
          a[e[n]] != null && (this[e[n]] = a[e[n]]);
    }
    return r.prototype.encryptionKey = $util.newBuffer([]), r.prototype.manifestHash = $util.newBuffer([]), r.create = function(e) {
      return new r(e);
    }, r.encode = function(e, n) {
      return n || (n = $Writer.create()), e.encryptionKey != null && Object.hasOwnProperty.call(e, "encryptionKey") && n.uint32(
        /* id 1, wireType 2 =*/
        10
      ).bytes(e.encryptionKey), e.manifestHash != null && Object.hasOwnProperty.call(e, "manifestHash") && n.uint32(
        /* id 2, wireType 2 =*/
        18
      ).bytes(e.manifestHash), n;
    }, r.encodeDelimited = function(e, n) {
      return this.encode(e, n).ldelim();
    }, r.decode = function(e, n) {
      e instanceof $Reader || (e = $Reader.create(e));
      let o = n === void 0 ? e.len : e.pos + n, c = new $root.gcg.TestDataset();
      for (; e.pos < o; ) {
        let l = e.uint32();
        switch (l >>> 3) {
          case 1: {
            c.encryptionKey = e.bytes();
            break;
          }
          case 2: {
            c.manifestHash = e.bytes();
            break;
          }
          default:
            e.skipType(l & 7);
            break;
        }
      }
      return c;
    }, r.decodeDelimited = function(e) {
      return e instanceof $Reader || (e = new $Reader(e)), this.decode(e, e.uint32());
    }, r.verify = function(e) {
      return typeof e != "object" || e === null ? "object expected" : e.encryptionKey != null && e.hasOwnProperty("encryptionKey") && !(e.encryptionKey && typeof e.encryptionKey.length == "number" || $util.isString(e.encryptionKey)) ? "encryptionKey: buffer expected" : e.manifestHash != null && e.hasOwnProperty("manifestHash") && !(e.manifestHash && typeof e.manifestHash.length == "number" || $util.isString(e.manifestHash)) ? "manifestHash: buffer expected" : null;
    }, r.fromObject = function(e) {
      if (e instanceof $root.gcg.TestDataset)
        return e;
      let n = new $root.gcg.TestDataset();
      return e.encryptionKey != null && (typeof e.encryptionKey == "string" ? $util.base64.decode(e.encryptionKey, n.encryptionKey = $util.newBuffer($util.base64.length(e.encryptionKey)), 0) : e.encryptionKey.length >= 0 && (n.encryptionKey = e.encryptionKey)), e.manifestHash != null && (typeof e.manifestHash == "string" ? $util.base64.decode(e.manifestHash, n.manifestHash = $util.newBuffer($util.base64.length(e.manifestHash)), 0) : e.manifestHash.length >= 0 && (n.manifestHash = e.manifestHash)), n;
    }, r.toObject = function(e, n) {
      n || (n = {});
      let o = {};
      return n.defaults && (n.bytes === String ? o.encryptionKey = "" : (o.encryptionKey = [], n.bytes !== Array && (o.encryptionKey = $util.newBuffer(o.encryptionKey))), n.bytes === String ? o.manifestHash = "" : (o.manifestHash = [], n.bytes !== Array && (o.manifestHash = $util.newBuffer(o.manifestHash)))), e.encryptionKey != null && e.hasOwnProperty("encryptionKey") && (o.encryptionKey = n.bytes === String ? $util.base64.encode(e.encryptionKey, 0, e.encryptionKey.length) : n.bytes === Array ? Array.prototype.slice.call(e.encryptionKey) : e.encryptionKey), e.manifestHash != null && e.hasOwnProperty("manifestHash") && (o.manifestHash = n.bytes === String ? $util.base64.encode(e.manifestHash, 0, e.manifestHash.length) : n.bytes === Array ? Array.prototype.slice.call(e.manifestHash) : e.manifestHash), o;
    }, r.prototype.toJSON = function() {
      return this.constructor.toObject(this, minimal.util.toJSONOptions);
    }, r.getTypeUrl = function(e) {
      return e === void 0 && (e = "type.googleapis.com"), e + "/gcg.TestDataset";
    }, r;
  }(), u.ExecuteComputeResponse = function() {
    function r(a) {
      if (a)
        for (let e = Object.keys(a), n = 0; n < e.length; ++n)
          a[e[n]] != null && (this[e[n]] = a[e[n]]);
    }
    return r.prototype.jobId = $util.newBuffer([]), r.create = function(e) {
      return new r(e);
    }, r.encode = function(e, n) {
      return n || (n = $Writer.create()), e.jobId != null && Object.hasOwnProperty.call(e, "jobId") && n.uint32(
        /* id 1, wireType 2 =*/
        10
      ).bytes(e.jobId), n;
    }, r.encodeDelimited = function(e, n) {
      return this.encode(e, n).ldelim();
    }, r.decode = function(e, n) {
      e instanceof $Reader || (e = $Reader.create(e));
      let o = n === void 0 ? e.len : e.pos + n, c = new $root.gcg.ExecuteComputeResponse();
      for (; e.pos < o; ) {
        let l = e.uint32();
        switch (l >>> 3) {
          case 1: {
            c.jobId = e.bytes();
            break;
          }
          default:
            e.skipType(l & 7);
            break;
        }
      }
      return c;
    }, r.decodeDelimited = function(e) {
      return e instanceof $Reader || (e = new $Reader(e)), this.decode(e, e.uint32());
    }, r.verify = function(e) {
      return typeof e != "object" || e === null ? "object expected" : e.jobId != null && e.hasOwnProperty("jobId") && !(e.jobId && typeof e.jobId.length == "number" || $util.isString(e.jobId)) ? "jobId: buffer expected" : null;
    }, r.fromObject = function(e) {
      if (e instanceof $root.gcg.ExecuteComputeResponse)
        return e;
      let n = new $root.gcg.ExecuteComputeResponse();
      return e.jobId != null && (typeof e.jobId == "string" ? $util.base64.decode(e.jobId, n.jobId = $util.newBuffer($util.base64.length(e.jobId)), 0) : e.jobId.length >= 0 && (n.jobId = e.jobId)), n;
    }, r.toObject = function(e, n) {
      n || (n = {});
      let o = {};
      return n.defaults && (n.bytes === String ? o.jobId = "" : (o.jobId = [], n.bytes !== Array && (o.jobId = $util.newBuffer(o.jobId)))), e.jobId != null && e.hasOwnProperty("jobId") && (o.jobId = n.bytes === String ? $util.base64.encode(e.jobId, 0, e.jobId.length) : n.bytes === Array ? Array.prototype.slice.call(e.jobId) : e.jobId), o;
    }, r.prototype.toJSON = function() {
      return this.constructor.toObject(this, minimal.util.toJSONOptions);
    }, r.getTypeUrl = function(e) {
      return e === void 0 && (e = "type.googleapis.com"), e + "/gcg.ExecuteComputeResponse";
    }, r;
  }(), u.JobStatusRequest = function() {
    function r(a) {
      if (a)
        for (let e = Object.keys(a), n = 0; n < e.length; ++n)
          a[e[n]] != null && (this[e[n]] = a[e[n]]);
    }
    return r.prototype.jobId = $util.newBuffer([]), r.create = function(e) {
      return new r(e);
    }, r.encode = function(e, n) {
      return n || (n = $Writer.create()), e.jobId != null && Object.hasOwnProperty.call(e, "jobId") && n.uint32(
        /* id 1, wireType 2 =*/
        10
      ).bytes(e.jobId), n;
    }, r.encodeDelimited = function(e, n) {
      return this.encode(e, n).ldelim();
    }, r.decode = function(e, n) {
      e instanceof $Reader || (e = $Reader.create(e));
      let o = n === void 0 ? e.len : e.pos + n, c = new $root.gcg.JobStatusRequest();
      for (; e.pos < o; ) {
        let l = e.uint32();
        switch (l >>> 3) {
          case 1: {
            c.jobId = e.bytes();
            break;
          }
          default:
            e.skipType(l & 7);
            break;
        }
      }
      return c;
    }, r.decodeDelimited = function(e) {
      return e instanceof $Reader || (e = new $Reader(e)), this.decode(e, e.uint32());
    }, r.verify = function(e) {
      return typeof e != "object" || e === null ? "object expected" : e.jobId != null && e.hasOwnProperty("jobId") && !(e.jobId && typeof e.jobId.length == "number" || $util.isString(e.jobId)) ? "jobId: buffer expected" : null;
    }, r.fromObject = function(e) {
      if (e instanceof $root.gcg.JobStatusRequest)
        return e;
      let n = new $root.gcg.JobStatusRequest();
      return e.jobId != null && (typeof e.jobId == "string" ? $util.base64.decode(e.jobId, n.jobId = $util.newBuffer($util.base64.length(e.jobId)), 0) : e.jobId.length >= 0 && (n.jobId = e.jobId)), n;
    }, r.toObject = function(e, n) {
      n || (n = {});
      let o = {};
      return n.defaults && (n.bytes === String ? o.jobId = "" : (o.jobId = [], n.bytes !== Array && (o.jobId = $util.newBuffer(o.jobId)))), e.jobId != null && e.hasOwnProperty("jobId") && (o.jobId = n.bytes === String ? $util.base64.encode(e.jobId, 0, e.jobId.length) : n.bytes === Array ? Array.prototype.slice.call(e.jobId) : e.jobId), o;
    }, r.prototype.toJSON = function() {
      return this.constructor.toObject(this, minimal.util.toJSONOptions);
    }, r.getTypeUrl = function(e) {
      return e === void 0 && (e = "type.googleapis.com"), e + "/gcg.JobStatusRequest";
    }, r;
  }(), u.JobStatusResponse = function() {
    function r(a) {
      if (this.completeComputeNodeIds = [], a)
        for (let e = Object.keys(a), n = 0; n < e.length; ++n)
          a[e[n]] != null && (this[e[n]] = a[e[n]]);
    }
    return r.prototype.completeComputeNodeIds = $util.emptyArray, r.create = function(e) {
      return new r(e);
    }, r.encode = function(e, n) {
      if (n || (n = $Writer.create()), e.completeComputeNodeIds != null && e.completeComputeNodeIds.length)
        for (let o = 0; o < e.completeComputeNodeIds.length; ++o)
          n.uint32(
            /* id 1, wireType 2 =*/
            10
          ).string(e.completeComputeNodeIds[o]);
      return n;
    }, r.encodeDelimited = function(e, n) {
      return this.encode(e, n).ldelim();
    }, r.decode = function(e, n) {
      e instanceof $Reader || (e = $Reader.create(e));
      let o = n === void 0 ? e.len : e.pos + n, c = new $root.gcg.JobStatusResponse();
      for (; e.pos < o; ) {
        let l = e.uint32();
        switch (l >>> 3) {
          case 1: {
            c.completeComputeNodeIds && c.completeComputeNodeIds.length || (c.completeComputeNodeIds = []), c.completeComputeNodeIds.push(e.string());
            break;
          }
          default:
            e.skipType(l & 7);
            break;
        }
      }
      return c;
    }, r.decodeDelimited = function(e) {
      return e instanceof $Reader || (e = new $Reader(e)), this.decode(e, e.uint32());
    }, r.verify = function(e) {
      if (typeof e != "object" || e === null)
        return "object expected";
      if (e.completeComputeNodeIds != null && e.hasOwnProperty("completeComputeNodeIds")) {
        if (!Array.isArray(e.completeComputeNodeIds))
          return "completeComputeNodeIds: array expected";
        for (let n = 0; n < e.completeComputeNodeIds.length; ++n)
          if (!$util.isString(e.completeComputeNodeIds[n]))
            return "completeComputeNodeIds: string[] expected";
      }
      return null;
    }, r.fromObject = function(e) {
      if (e instanceof $root.gcg.JobStatusResponse)
        return e;
      let n = new $root.gcg.JobStatusResponse();
      if (e.completeComputeNodeIds) {
        if (!Array.isArray(e.completeComputeNodeIds))
          throw TypeError(".gcg.JobStatusResponse.completeComputeNodeIds: array expected");
        n.completeComputeNodeIds = [];
        for (let o = 0; o < e.completeComputeNodeIds.length; ++o)
          n.completeComputeNodeIds[o] = String(e.completeComputeNodeIds[o]);
      }
      return n;
    }, r.toObject = function(e, n) {
      n || (n = {});
      let o = {};
      if ((n.arrays || n.defaults) && (o.completeComputeNodeIds = []), e.completeComputeNodeIds && e.completeComputeNodeIds.length) {
        o.completeComputeNodeIds = [];
        for (let c = 0; c < e.completeComputeNodeIds.length; ++c)
          o.completeComputeNodeIds[c] = e.completeComputeNodeIds[c];
      }
      return o;
    }, r.prototype.toJSON = function() {
      return this.constructor.toObject(this, minimal.util.toJSONOptions);
    }, r.getTypeUrl = function(e) {
      return e === void 0 && (e = "type.googleapis.com"), e + "/gcg.JobStatusResponse";
    }, r;
  }(), u.GetResultsRequest = function() {
    function r(a) {
      if (a)
        for (let e = Object.keys(a), n = 0; n < e.length; ++n)
          a[e[n]] != null && (this[e[n]] = a[e[n]]);
    }
    return r.prototype.jobId = $util.newBuffer([]), r.prototype.computeNodeId = "", r.create = function(e) {
      return new r(e);
    }, r.encode = function(e, n) {
      return n || (n = $Writer.create()), e.jobId != null && Object.hasOwnProperty.call(e, "jobId") && n.uint32(
        /* id 1, wireType 2 =*/
        10
      ).bytes(e.jobId), e.computeNodeId != null && Object.hasOwnProperty.call(e, "computeNodeId") && n.uint32(
        /* id 2, wireType 2 =*/
        18
      ).string(e.computeNodeId), n;
    }, r.encodeDelimited = function(e, n) {
      return this.encode(e, n).ldelim();
    }, r.decode = function(e, n) {
      e instanceof $Reader || (e = $Reader.create(e));
      let o = n === void 0 ? e.len : e.pos + n, c = new $root.gcg.GetResultsRequest();
      for (; e.pos < o; ) {
        let l = e.uint32();
        switch (l >>> 3) {
          case 1: {
            c.jobId = e.bytes();
            break;
          }
          case 2: {
            c.computeNodeId = e.string();
            break;
          }
          default:
            e.skipType(l & 7);
            break;
        }
      }
      return c;
    }, r.decodeDelimited = function(e) {
      return e instanceof $Reader || (e = new $Reader(e)), this.decode(e, e.uint32());
    }, r.verify = function(e) {
      return typeof e != "object" || e === null ? "object expected" : e.jobId != null && e.hasOwnProperty("jobId") && !(e.jobId && typeof e.jobId.length == "number" || $util.isString(e.jobId)) ? "jobId: buffer expected" : e.computeNodeId != null && e.hasOwnProperty("computeNodeId") && !$util.isString(e.computeNodeId) ? "computeNodeId: string expected" : null;
    }, r.fromObject = function(e) {
      if (e instanceof $root.gcg.GetResultsRequest)
        return e;
      let n = new $root.gcg.GetResultsRequest();
      return e.jobId != null && (typeof e.jobId == "string" ? $util.base64.decode(e.jobId, n.jobId = $util.newBuffer($util.base64.length(e.jobId)), 0) : e.jobId.length >= 0 && (n.jobId = e.jobId)), e.computeNodeId != null && (n.computeNodeId = String(e.computeNodeId)), n;
    }, r.toObject = function(e, n) {
      n || (n = {});
      let o = {};
      return n.defaults && (n.bytes === String ? o.jobId = "" : (o.jobId = [], n.bytes !== Array && (o.jobId = $util.newBuffer(o.jobId))), o.computeNodeId = ""), e.jobId != null && e.hasOwnProperty("jobId") && (o.jobId = n.bytes === String ? $util.base64.encode(e.jobId, 0, e.jobId.length) : n.bytes === Array ? Array.prototype.slice.call(e.jobId) : e.jobId), e.computeNodeId != null && e.hasOwnProperty("computeNodeId") && (o.computeNodeId = e.computeNodeId), o;
    }, r.prototype.toJSON = function() {
      return this.constructor.toObject(this, minimal.util.toJSONOptions);
    }, r.getTypeUrl = function(e) {
      return e === void 0 && (e = "type.googleapis.com"), e + "/gcg.GetResultsRequest";
    }, r;
  }(), u.GetResultsSizeRequest = function() {
    function r(a) {
      if (a)
        for (let e = Object.keys(a), n = 0; n < e.length; ++n)
          a[e[n]] != null && (this[e[n]] = a[e[n]]);
    }
    return r.prototype.jobId = $util.newBuffer([]), r.prototype.computeNodeId = "", r.create = function(e) {
      return new r(e);
    }, r.encode = function(e, n) {
      return n || (n = $Writer.create()), e.jobId != null && Object.hasOwnProperty.call(e, "jobId") && n.uint32(
        /* id 1, wireType 2 =*/
        10
      ).bytes(e.jobId), e.computeNodeId != null && Object.hasOwnProperty.call(e, "computeNodeId") && n.uint32(
        /* id 2, wireType 2 =*/
        18
      ).string(e.computeNodeId), n;
    }, r.encodeDelimited = function(e, n) {
      return this.encode(e, n).ldelim();
    }, r.decode = function(e, n) {
      e instanceof $Reader || (e = $Reader.create(e));
      let o = n === void 0 ? e.len : e.pos + n, c = new $root.gcg.GetResultsSizeRequest();
      for (; e.pos < o; ) {
        let l = e.uint32();
        switch (l >>> 3) {
          case 1: {
            c.jobId = e.bytes();
            break;
          }
          case 2: {
            c.computeNodeId = e.string();
            break;
          }
          default:
            e.skipType(l & 7);
            break;
        }
      }
      return c;
    }, r.decodeDelimited = function(e) {
      return e instanceof $Reader || (e = new $Reader(e)), this.decode(e, e.uint32());
    }, r.verify = function(e) {
      return typeof e != "object" || e === null ? "object expected" : e.jobId != null && e.hasOwnProperty("jobId") && !(e.jobId && typeof e.jobId.length == "number" || $util.isString(e.jobId)) ? "jobId: buffer expected" : e.computeNodeId != null && e.hasOwnProperty("computeNodeId") && !$util.isString(e.computeNodeId) ? "computeNodeId: string expected" : null;
    }, r.fromObject = function(e) {
      if (e instanceof $root.gcg.GetResultsSizeRequest)
        return e;
      let n = new $root.gcg.GetResultsSizeRequest();
      return e.jobId != null && (typeof e.jobId == "string" ? $util.base64.decode(e.jobId, n.jobId = $util.newBuffer($util.base64.length(e.jobId)), 0) : e.jobId.length >= 0 && (n.jobId = e.jobId)), e.computeNodeId != null && (n.computeNodeId = String(e.computeNodeId)), n;
    }, r.toObject = function(e, n) {
      n || (n = {});
      let o = {};
      return n.defaults && (n.bytes === String ? o.jobId = "" : (o.jobId = [], n.bytes !== Array && (o.jobId = $util.newBuffer(o.jobId))), o.computeNodeId = ""), e.jobId != null && e.hasOwnProperty("jobId") && (o.jobId = n.bytes === String ? $util.base64.encode(e.jobId, 0, e.jobId.length) : n.bytes === Array ? Array.prototype.slice.call(e.jobId) : e.jobId), e.computeNodeId != null && e.hasOwnProperty("computeNodeId") && (o.computeNodeId = e.computeNodeId), o;
    }, r.prototype.toJSON = function() {
      return this.constructor.toObject(this, minimal.util.toJSONOptions);
    }, r.getTypeUrl = function(e) {
      return e === void 0 && (e = "type.googleapis.com"), e + "/gcg.GetResultsSizeRequest";
    }, r;
  }(), u.GetResultsResponseChunk = function() {
    function r(a) {
      if (a)
        for (let e = Object.keys(a), n = 0; n < e.length; ++n)
          a[e[n]] != null && (this[e[n]] = a[e[n]]);
    }
    return r.prototype.data = $util.newBuffer([]), r.create = function(e) {
      return new r(e);
    }, r.encode = function(e, n) {
      return n || (n = $Writer.create()), e.data != null && Object.hasOwnProperty.call(e, "data") && n.uint32(
        /* id 1, wireType 2 =*/
        10
      ).bytes(e.data), n;
    }, r.encodeDelimited = function(e, n) {
      return this.encode(e, n).ldelim();
    }, r.decode = function(e, n) {
      e instanceof $Reader || (e = $Reader.create(e));
      let o = n === void 0 ? e.len : e.pos + n, c = new $root.gcg.GetResultsResponseChunk();
      for (; e.pos < o; ) {
        let l = e.uint32();
        switch (l >>> 3) {
          case 1: {
            c.data = e.bytes();
            break;
          }
          default:
            e.skipType(l & 7);
            break;
        }
      }
      return c;
    }, r.decodeDelimited = function(e) {
      return e instanceof $Reader || (e = new $Reader(e)), this.decode(e, e.uint32());
    }, r.verify = function(e) {
      return typeof e != "object" || e === null ? "object expected" : e.data != null && e.hasOwnProperty("data") && !(e.data && typeof e.data.length == "number" || $util.isString(e.data)) ? "data: buffer expected" : null;
    }, r.fromObject = function(e) {
      if (e instanceof $root.gcg.GetResultsResponseChunk)
        return e;
      let n = new $root.gcg.GetResultsResponseChunk();
      return e.data != null && (typeof e.data == "string" ? $util.base64.decode(e.data, n.data = $util.newBuffer($util.base64.length(e.data)), 0) : e.data.length >= 0 && (n.data = e.data)), n;
    }, r.toObject = function(e, n) {
      n || (n = {});
      let o = {};
      return n.defaults && (n.bytes === String ? o.data = "" : (o.data = [], n.bytes !== Array && (o.data = $util.newBuffer(o.data)))), e.data != null && e.hasOwnProperty("data") && (o.data = n.bytes === String ? $util.base64.encode(e.data, 0, e.data.length) : n.bytes === Array ? Array.prototype.slice.call(e.data) : e.data), o;
    }, r.prototype.toJSON = function() {
      return this.constructor.toObject(this, minimal.util.toJSONOptions);
    }, r.getTypeUrl = function(e) {
      return e === void 0 && (e = "type.googleapis.com"), e + "/gcg.GetResultsResponseChunk";
    }, r;
  }(), u.GetResultsResponseFooter = function() {
    function r(a) {
      if (a)
        for (let e = Object.keys(a), n = 0; n < e.length; ++n)
          a[e[n]] != null && (this[e[n]] = a[e[n]]);
    }
    return r.create = function(e) {
      return new r(e);
    }, r.encode = function(e, n) {
      return n || (n = $Writer.create()), n;
    }, r.encodeDelimited = function(e, n) {
      return this.encode(e, n).ldelim();
    }, r.decode = function(e, n) {
      e instanceof $Reader || (e = $Reader.create(e));
      let o = n === void 0 ? e.len : e.pos + n, c = new $root.gcg.GetResultsResponseFooter();
      for (; e.pos < o; ) {
        let l = e.uint32();
        switch (l >>> 3) {
          default:
            e.skipType(l & 7);
            break;
        }
      }
      return c;
    }, r.decodeDelimited = function(e) {
      return e instanceof $Reader || (e = new $Reader(e)), this.decode(e, e.uint32());
    }, r.verify = function(e) {
      return typeof e != "object" || e === null ? "object expected" : null;
    }, r.fromObject = function(e) {
      return e instanceof $root.gcg.GetResultsResponseFooter ? e : new $root.gcg.GetResultsResponseFooter();
    }, r.toObject = function() {
      return {};
    }, r.prototype.toJSON = function() {
      return this.constructor.toObject(this, minimal.util.toJSONOptions);
    }, r.getTypeUrl = function(e) {
      return e === void 0 && (e = "type.googleapis.com"), e + "/gcg.GetResultsResponseFooter";
    }, r;
  }(), u.RetrieveDataRoomRequest = function() {
    function r(a) {
      if (a)
        for (let e = Object.keys(a), n = 0; n < e.length; ++n)
          a[e[n]] != null && (this[e[n]] = a[e[n]]);
    }
    return r.prototype.dataRoomId = $util.newBuffer([]), r.create = function(e) {
      return new r(e);
    }, r.encode = function(e, n) {
      return n || (n = $Writer.create()), e.dataRoomId != null && Object.hasOwnProperty.call(e, "dataRoomId") && n.uint32(
        /* id 1, wireType 2 =*/
        10
      ).bytes(e.dataRoomId), n;
    }, r.encodeDelimited = function(e, n) {
      return this.encode(e, n).ldelim();
    }, r.decode = function(e, n) {
      e instanceof $Reader || (e = $Reader.create(e));
      let o = n === void 0 ? e.len : e.pos + n, c = new $root.gcg.RetrieveDataRoomRequest();
      for (; e.pos < o; ) {
        let l = e.uint32();
        switch (l >>> 3) {
          case 1: {
            c.dataRoomId = e.bytes();
            break;
          }
          default:
            e.skipType(l & 7);
            break;
        }
      }
      return c;
    }, r.decodeDelimited = function(e) {
      return e instanceof $Reader || (e = new $Reader(e)), this.decode(e, e.uint32());
    }, r.verify = function(e) {
      return typeof e != "object" || e === null ? "object expected" : e.dataRoomId != null && e.hasOwnProperty("dataRoomId") && !(e.dataRoomId && typeof e.dataRoomId.length == "number" || $util.isString(e.dataRoomId)) ? "dataRoomId: buffer expected" : null;
    }, r.fromObject = function(e) {
      if (e instanceof $root.gcg.RetrieveDataRoomRequest)
        return e;
      let n = new $root.gcg.RetrieveDataRoomRequest();
      return e.dataRoomId != null && (typeof e.dataRoomId == "string" ? $util.base64.decode(e.dataRoomId, n.dataRoomId = $util.newBuffer($util.base64.length(e.dataRoomId)), 0) : e.dataRoomId.length >= 0 && (n.dataRoomId = e.dataRoomId)), n;
    }, r.toObject = function(e, n) {
      n || (n = {});
      let o = {};
      return n.defaults && (n.bytes === String ? o.dataRoomId = "" : (o.dataRoomId = [], n.bytes !== Array && (o.dataRoomId = $util.newBuffer(o.dataRoomId)))), e.dataRoomId != null && e.hasOwnProperty("dataRoomId") && (o.dataRoomId = n.bytes === String ? $util.base64.encode(e.dataRoomId, 0, e.dataRoomId.length) : n.bytes === Array ? Array.prototype.slice.call(e.dataRoomId) : e.dataRoomId), o;
    }, r.prototype.toJSON = function() {
      return this.constructor.toObject(this, minimal.util.toJSONOptions);
    }, r.getTypeUrl = function(e) {
      return e === void 0 && (e = "type.googleapis.com"), e + "/gcg.RetrieveDataRoomRequest";
    }, r;
  }(), u.RetrieveDataRoomResponse = function() {
    function r(e) {
      if (this.commits = [], e)
        for (let n = Object.keys(e), o = 0; o < n.length; ++o)
          e[n[o]] != null && (this[n[o]] = e[n[o]]);
    }
    r.prototype.dataRoom = null, r.prototype.commits = $util.emptyArray, r.prototype.highLevelRepresentation = null;
    let a;
    return Object.defineProperty(r.prototype, "_highLevelRepresentation", {
      get: $util.oneOfGetter(a = ["highLevelRepresentation"]),
      set: $util.oneOfSetter(a)
    }), r.create = function(n) {
      return new r(n);
    }, r.encode = function(n, o) {
      if (o || (o = $Writer.create()), n.dataRoom != null && Object.hasOwnProperty.call(n, "dataRoom") && $root.data_room.DataRoom.encode(n.dataRoom, o.uint32(
        /* id 1, wireType 2 =*/
        10
      ).fork()).ldelim(), n.commits != null && n.commits.length)
        for (let c = 0; c < n.commits.length; ++c)
          $root.data_room.ConfigurationCommit.encode(n.commits[c], o.uint32(
            /* id 2, wireType 2 =*/
            18
          ).fork()).ldelim();
      return n.highLevelRepresentation != null && Object.hasOwnProperty.call(n, "highLevelRepresentation") && o.uint32(
        /* id 3, wireType 2 =*/
        26
      ).bytes(n.highLevelRepresentation), o;
    }, r.encodeDelimited = function(n, o) {
      return this.encode(n, o).ldelim();
    }, r.decode = function(n, o) {
      n instanceof $Reader || (n = $Reader.create(n));
      let c = o === void 0 ? n.len : n.pos + o, l = new $root.gcg.RetrieveDataRoomResponse();
      for (; n.pos < c; ) {
        let d = n.uint32();
        switch (d >>> 3) {
          case 1: {
            l.dataRoom = $root.data_room.DataRoom.decode(n, n.uint32());
            break;
          }
          case 2: {
            l.commits && l.commits.length || (l.commits = []), l.commits.push($root.data_room.ConfigurationCommit.decode(n, n.uint32()));
            break;
          }
          case 3: {
            l.highLevelRepresentation = n.bytes();
            break;
          }
          default:
            n.skipType(d & 7);
            break;
        }
      }
      return l;
    }, r.decodeDelimited = function(n) {
      return n instanceof $Reader || (n = new $Reader(n)), this.decode(n, n.uint32());
    }, r.verify = function(n) {
      if (typeof n != "object" || n === null)
        return "object expected";
      if (n.dataRoom != null && n.hasOwnProperty("dataRoom")) {
        let o = $root.data_room.DataRoom.verify(n.dataRoom);
        if (o)
          return "dataRoom." + o;
      }
      if (n.commits != null && n.hasOwnProperty("commits")) {
        if (!Array.isArray(n.commits))
          return "commits: array expected";
        for (let o = 0; o < n.commits.length; ++o) {
          let c = $root.data_room.ConfigurationCommit.verify(n.commits[o]);
          if (c)
            return "commits." + c;
        }
      }
      return n.highLevelRepresentation != null && n.hasOwnProperty("highLevelRepresentation") && !(n.highLevelRepresentation && typeof n.highLevelRepresentation.length == "number" || $util.isString(n.highLevelRepresentation)) ? "highLevelRepresentation: buffer expected" : null;
    }, r.fromObject = function(n) {
      if (n instanceof $root.gcg.RetrieveDataRoomResponse)
        return n;
      let o = new $root.gcg.RetrieveDataRoomResponse();
      if (n.dataRoom != null) {
        if (typeof n.dataRoom != "object")
          throw TypeError(".gcg.RetrieveDataRoomResponse.dataRoom: object expected");
        o.dataRoom = $root.data_room.DataRoom.fromObject(n.dataRoom);
      }
      if (n.commits) {
        if (!Array.isArray(n.commits))
          throw TypeError(".gcg.RetrieveDataRoomResponse.commits: array expected");
        o.commits = [];
        for (let c = 0; c < n.commits.length; ++c) {
          if (typeof n.commits[c] != "object")
            throw TypeError(".gcg.RetrieveDataRoomResponse.commits: object expected");
          o.commits[c] = $root.data_room.ConfigurationCommit.fromObject(n.commits[c]);
        }
      }
      return n.highLevelRepresentation != null && (typeof n.highLevelRepresentation == "string" ? $util.base64.decode(n.highLevelRepresentation, o.highLevelRepresentation = $util.newBuffer($util.base64.length(n.highLevelRepresentation)), 0) : n.highLevelRepresentation.length >= 0 && (o.highLevelRepresentation = n.highLevelRepresentation)), o;
    }, r.toObject = function(n, o) {
      o || (o = {});
      let c = {};
      if ((o.arrays || o.defaults) && (c.commits = []), o.defaults && (c.dataRoom = null), n.dataRoom != null && n.hasOwnProperty("dataRoom") && (c.dataRoom = $root.data_room.DataRoom.toObject(n.dataRoom, o)), n.commits && n.commits.length) {
        c.commits = [];
        for (let l = 0; l < n.commits.length; ++l)
          c.commits[l] = $root.data_room.ConfigurationCommit.toObject(n.commits[l], o);
      }
      return n.highLevelRepresentation != null && n.hasOwnProperty("highLevelRepresentation") && (c.highLevelRepresentation = o.bytes === String ? $util.base64.encode(n.highLevelRepresentation, 0, n.highLevelRepresentation.length) : o.bytes === Array ? Array.prototype.slice.call(n.highLevelRepresentation) : n.highLevelRepresentation, o.oneofs && (c._highLevelRepresentation = "highLevelRepresentation")), c;
    }, r.prototype.toJSON = function() {
      return this.constructor.toObject(this, minimal.util.toJSONOptions);
    }, r.getTypeUrl = function(n) {
      return n === void 0 && (n = "type.googleapis.com"), n + "/gcg.RetrieveDataRoomResponse";
    }, r;
  }(), u.RetrieveAuditLogRequest = function() {
    function r(a) {
      if (a)
        for (let e = Object.keys(a), n = 0; n < e.length; ++n)
          a[e[n]] != null && (this[e[n]] = a[e[n]]);
    }
    return r.prototype.dataRoomId = $util.newBuffer([]), r.create = function(e) {
      return new r(e);
    }, r.encode = function(e, n) {
      return n || (n = $Writer.create()), e.dataRoomId != null && Object.hasOwnProperty.call(e, "dataRoomId") && n.uint32(
        /* id 1, wireType 2 =*/
        10
      ).bytes(e.dataRoomId), n;
    }, r.encodeDelimited = function(e, n) {
      return this.encode(e, n).ldelim();
    }, r.decode = function(e, n) {
      e instanceof $Reader || (e = $Reader.create(e));
      let o = n === void 0 ? e.len : e.pos + n, c = new $root.gcg.RetrieveAuditLogRequest();
      for (; e.pos < o; ) {
        let l = e.uint32();
        switch (l >>> 3) {
          case 1: {
            c.dataRoomId = e.bytes();
            break;
          }
          default:
            e.skipType(l & 7);
            break;
        }
      }
      return c;
    }, r.decodeDelimited = function(e) {
      return e instanceof $Reader || (e = new $Reader(e)), this.decode(e, e.uint32());
    }, r.verify = function(e) {
      return typeof e != "object" || e === null ? "object expected" : e.dataRoomId != null && e.hasOwnProperty("dataRoomId") && !(e.dataRoomId && typeof e.dataRoomId.length == "number" || $util.isString(e.dataRoomId)) ? "dataRoomId: buffer expected" : null;
    }, r.fromObject = function(e) {
      if (e instanceof $root.gcg.RetrieveAuditLogRequest)
        return e;
      let n = new $root.gcg.RetrieveAuditLogRequest();
      return e.dataRoomId != null && (typeof e.dataRoomId == "string" ? $util.base64.decode(e.dataRoomId, n.dataRoomId = $util.newBuffer($util.base64.length(e.dataRoomId)), 0) : e.dataRoomId.length >= 0 && (n.dataRoomId = e.dataRoomId)), n;
    }, r.toObject = function(e, n) {
      n || (n = {});
      let o = {};
      return n.defaults && (n.bytes === String ? o.dataRoomId = "" : (o.dataRoomId = [], n.bytes !== Array && (o.dataRoomId = $util.newBuffer(o.dataRoomId)))), e.dataRoomId != null && e.hasOwnProperty("dataRoomId") && (o.dataRoomId = n.bytes === String ? $util.base64.encode(e.dataRoomId, 0, e.dataRoomId.length) : n.bytes === Array ? Array.prototype.slice.call(e.dataRoomId) : e.dataRoomId), o;
    }, r.prototype.toJSON = function() {
      return this.constructor.toObject(this, minimal.util.toJSONOptions);
    }, r.getTypeUrl = function(e) {
      return e === void 0 && (e = "type.googleapis.com"), e + "/gcg.RetrieveAuditLogRequest";
    }, r;
  }(), u.RetrieveAuditLogResponse = function() {
    function r(a) {
      if (a)
        for (let e = Object.keys(a), n = 0; n < e.length; ++n)
          a[e[n]] != null && (this[e[n]] = a[e[n]]);
    }
    return r.prototype.log = $util.newBuffer([]), r.create = function(e) {
      return new r(e);
    }, r.encode = function(e, n) {
      return n || (n = $Writer.create()), e.log != null && Object.hasOwnProperty.call(e, "log") && n.uint32(
        /* id 1, wireType 2 =*/
        10
      ).bytes(e.log), n;
    }, r.encodeDelimited = function(e, n) {
      return this.encode(e, n).ldelim();
    }, r.decode = function(e, n) {
      e instanceof $Reader || (e = $Reader.create(e));
      let o = n === void 0 ? e.len : e.pos + n, c = new $root.gcg.RetrieveAuditLogResponse();
      for (; e.pos < o; ) {
        let l = e.uint32();
        switch (l >>> 3) {
          case 1: {
            c.log = e.bytes();
            break;
          }
          default:
            e.skipType(l & 7);
            break;
        }
      }
      return c;
    }, r.decodeDelimited = function(e) {
      return e instanceof $Reader || (e = new $Reader(e)), this.decode(e, e.uint32());
    }, r.verify = function(e) {
      return typeof e != "object" || e === null ? "object expected" : e.log != null && e.hasOwnProperty("log") && !(e.log && typeof e.log.length == "number" || $util.isString(e.log)) ? "log: buffer expected" : null;
    }, r.fromObject = function(e) {
      if (e instanceof $root.gcg.RetrieveAuditLogResponse)
        return e;
      let n = new $root.gcg.RetrieveAuditLogResponse();
      return e.log != null && (typeof e.log == "string" ? $util.base64.decode(e.log, n.log = $util.newBuffer($util.base64.length(e.log)), 0) : e.log.length >= 0 && (n.log = e.log)), n;
    }, r.toObject = function(e, n) {
      n || (n = {});
      let o = {};
      return n.defaults && (n.bytes === String ? o.log = "" : (o.log = [], n.bytes !== Array && (o.log = $util.newBuffer(o.log)))), e.log != null && e.hasOwnProperty("log") && (o.log = n.bytes === String ? $util.base64.encode(e.log, 0, e.log.length) : n.bytes === Array ? Array.prototype.slice.call(e.log) : e.log), o;
    }, r.prototype.toJSON = function() {
      return this.constructor.toObject(this, minimal.util.toJSONOptions);
    }, r.getTypeUrl = function(e) {
      return e === void 0 && (e = "type.googleapis.com"), e + "/gcg.RetrieveAuditLogResponse";
    }, r;
  }(), u.DataRoomStatus = function() {
    const r = {}, a = Object.create(r);
    return a[r[0] = "Active"] = 0, a[r[1] = "Stopped"] = 1, a;
  }(), u.RetrieveDataRoomStatusRequest = function() {
    function r(a) {
      if (a)
        for (let e = Object.keys(a), n = 0; n < e.length; ++n)
          a[e[n]] != null && (this[e[n]] = a[e[n]]);
    }
    return r.prototype.dataRoomId = $util.newBuffer([]), r.create = function(e) {
      return new r(e);
    }, r.encode = function(e, n) {
      return n || (n = $Writer.create()), e.dataRoomId != null && Object.hasOwnProperty.call(e, "dataRoomId") && n.uint32(
        /* id 1, wireType 2 =*/
        10
      ).bytes(e.dataRoomId), n;
    }, r.encodeDelimited = function(e, n) {
      return this.encode(e, n).ldelim();
    }, r.decode = function(e, n) {
      e instanceof $Reader || (e = $Reader.create(e));
      let o = n === void 0 ? e.len : e.pos + n, c = new $root.gcg.RetrieveDataRoomStatusRequest();
      for (; e.pos < o; ) {
        let l = e.uint32();
        switch (l >>> 3) {
          case 1: {
            c.dataRoomId = e.bytes();
            break;
          }
          default:
            e.skipType(l & 7);
            break;
        }
      }
      return c;
    }, r.decodeDelimited = function(e) {
      return e instanceof $Reader || (e = new $Reader(e)), this.decode(e, e.uint32());
    }, r.verify = function(e) {
      return typeof e != "object" || e === null ? "object expected" : e.dataRoomId != null && e.hasOwnProperty("dataRoomId") && !(e.dataRoomId && typeof e.dataRoomId.length == "number" || $util.isString(e.dataRoomId)) ? "dataRoomId: buffer expected" : null;
    }, r.fromObject = function(e) {
      if (e instanceof $root.gcg.RetrieveDataRoomStatusRequest)
        return e;
      let n = new $root.gcg.RetrieveDataRoomStatusRequest();
      return e.dataRoomId != null && (typeof e.dataRoomId == "string" ? $util.base64.decode(e.dataRoomId, n.dataRoomId = $util.newBuffer($util.base64.length(e.dataRoomId)), 0) : e.dataRoomId.length >= 0 && (n.dataRoomId = e.dataRoomId)), n;
    }, r.toObject = function(e, n) {
      n || (n = {});
      let o = {};
      return n.defaults && (n.bytes === String ? o.dataRoomId = "" : (o.dataRoomId = [], n.bytes !== Array && (o.dataRoomId = $util.newBuffer(o.dataRoomId)))), e.dataRoomId != null && e.hasOwnProperty("dataRoomId") && (o.dataRoomId = n.bytes === String ? $util.base64.encode(e.dataRoomId, 0, e.dataRoomId.length) : n.bytes === Array ? Array.prototype.slice.call(e.dataRoomId) : e.dataRoomId), o;
    }, r.prototype.toJSON = function() {
      return this.constructor.toObject(this, minimal.util.toJSONOptions);
    }, r.getTypeUrl = function(e) {
      return e === void 0 && (e = "type.googleapis.com"), e + "/gcg.RetrieveDataRoomStatusRequest";
    }, r;
  }(), u.RetrieveDataRoomStatusResponse = function() {
    function r(a) {
      if (a)
        for (let e = Object.keys(a), n = 0; n < e.length; ++n)
          a[e[n]] != null && (this[e[n]] = a[e[n]]);
    }
    return r.prototype.status = 0, r.create = function(e) {
      return new r(e);
    }, r.encode = function(e, n) {
      return n || (n = $Writer.create()), e.status != null && Object.hasOwnProperty.call(e, "status") && n.uint32(
        /* id 1, wireType 0 =*/
        8
      ).int32(e.status), n;
    }, r.encodeDelimited = function(e, n) {
      return this.encode(e, n).ldelim();
    }, r.decode = function(e, n) {
      e instanceof $Reader || (e = $Reader.create(e));
      let o = n === void 0 ? e.len : e.pos + n, c = new $root.gcg.RetrieveDataRoomStatusResponse();
      for (; e.pos < o; ) {
        let l = e.uint32();
        switch (l >>> 3) {
          case 1: {
            c.status = e.int32();
            break;
          }
          default:
            e.skipType(l & 7);
            break;
        }
      }
      return c;
    }, r.decodeDelimited = function(e) {
      return e instanceof $Reader || (e = new $Reader(e)), this.decode(e, e.uint32());
    }, r.verify = function(e) {
      if (typeof e != "object" || e === null)
        return "object expected";
      if (e.status != null && e.hasOwnProperty("status"))
        switch (e.status) {
          default:
            return "status: enum value expected";
          case 0:
          case 1:
            break;
        }
      return null;
    }, r.fromObject = function(e) {
      if (e instanceof $root.gcg.RetrieveDataRoomStatusResponse)
        return e;
      let n = new $root.gcg.RetrieveDataRoomStatusResponse();
      switch (e.status) {
        default:
          if (typeof e.status == "number") {
            n.status = e.status;
            break;
          }
          break;
        case "Active":
        case 0:
          n.status = 0;
          break;
        case "Stopped":
        case 1:
          n.status = 1;
          break;
      }
      return n;
    }, r.toObject = function(e, n) {
      n || (n = {});
      let o = {};
      return n.defaults && (o.status = n.enums === String ? "Active" : 0), e.status != null && e.hasOwnProperty("status") && (o.status = n.enums === String ? $root.gcg.DataRoomStatus[e.status] === void 0 ? e.status : $root.gcg.DataRoomStatus[e.status] : e.status), o;
    }, r.prototype.toJSON = function() {
      return this.constructor.toObject(this, minimal.util.toJSONOptions);
    }, r.getTypeUrl = function(e) {
      return e === void 0 && (e = "type.googleapis.com"), e + "/gcg.RetrieveDataRoomStatusResponse";
    }, r;
  }(), u.UpdateDataRoomStatusRequest = function() {
    function r(a) {
      if (a)
        for (let e = Object.keys(a), n = 0; n < e.length; ++n)
          a[e[n]] != null && (this[e[n]] = a[e[n]]);
    }
    return r.prototype.dataRoomId = $util.newBuffer([]), r.prototype.status = 0, r.create = function(e) {
      return new r(e);
    }, r.encode = function(e, n) {
      return n || (n = $Writer.create()), e.dataRoomId != null && Object.hasOwnProperty.call(e, "dataRoomId") && n.uint32(
        /* id 1, wireType 2 =*/
        10
      ).bytes(e.dataRoomId), e.status != null && Object.hasOwnProperty.call(e, "status") && n.uint32(
        /* id 2, wireType 0 =*/
        16
      ).int32(e.status), n;
    }, r.encodeDelimited = function(e, n) {
      return this.encode(e, n).ldelim();
    }, r.decode = function(e, n) {
      e instanceof $Reader || (e = $Reader.create(e));
      let o = n === void 0 ? e.len : e.pos + n, c = new $root.gcg.UpdateDataRoomStatusRequest();
      for (; e.pos < o; ) {
        let l = e.uint32();
        switch (l >>> 3) {
          case 1: {
            c.dataRoomId = e.bytes();
            break;
          }
          case 2: {
            c.status = e.int32();
            break;
          }
          default:
            e.skipType(l & 7);
            break;
        }
      }
      return c;
    }, r.decodeDelimited = function(e) {
      return e instanceof $Reader || (e = new $Reader(e)), this.decode(e, e.uint32());
    }, r.verify = function(e) {
      if (typeof e != "object" || e === null)
        return "object expected";
      if (e.dataRoomId != null && e.hasOwnProperty("dataRoomId") && !(e.dataRoomId && typeof e.dataRoomId.length == "number" || $util.isString(e.dataRoomId)))
        return "dataRoomId: buffer expected";
      if (e.status != null && e.hasOwnProperty("status"))
        switch (e.status) {
          default:
            return "status: enum value expected";
          case 0:
          case 1:
            break;
        }
      return null;
    }, r.fromObject = function(e) {
      if (e instanceof $root.gcg.UpdateDataRoomStatusRequest)
        return e;
      let n = new $root.gcg.UpdateDataRoomStatusRequest();
      switch (e.dataRoomId != null && (typeof e.dataRoomId == "string" ? $util.base64.decode(e.dataRoomId, n.dataRoomId = $util.newBuffer($util.base64.length(e.dataRoomId)), 0) : e.dataRoomId.length >= 0 && (n.dataRoomId = e.dataRoomId)), e.status) {
        default:
          if (typeof e.status == "number") {
            n.status = e.status;
            break;
          }
          break;
        case "Active":
        case 0:
          n.status = 0;
          break;
        case "Stopped":
        case 1:
          n.status = 1;
          break;
      }
      return n;
    }, r.toObject = function(e, n) {
      n || (n = {});
      let o = {};
      return n.defaults && (n.bytes === String ? o.dataRoomId = "" : (o.dataRoomId = [], n.bytes !== Array && (o.dataRoomId = $util.newBuffer(o.dataRoomId))), o.status = n.enums === String ? "Active" : 0), e.dataRoomId != null && e.hasOwnProperty("dataRoomId") && (o.dataRoomId = n.bytes === String ? $util.base64.encode(e.dataRoomId, 0, e.dataRoomId.length) : n.bytes === Array ? Array.prototype.slice.call(e.dataRoomId) : e.dataRoomId), e.status != null && e.hasOwnProperty("status") && (o.status = n.enums === String ? $root.gcg.DataRoomStatus[e.status] === void 0 ? e.status : $root.gcg.DataRoomStatus[e.status] : e.status), o;
    }, r.prototype.toJSON = function() {
      return this.constructor.toObject(this, minimal.util.toJSONOptions);
    }, r.getTypeUrl = function(e) {
      return e === void 0 && (e = "type.googleapis.com"), e + "/gcg.UpdateDataRoomStatusRequest";
    }, r;
  }(), u.UpdateDataRoomStatusResponse = function() {
    function r(a) {
      if (a)
        for (let e = Object.keys(a), n = 0; n < e.length; ++n)
          a[e[n]] != null && (this[e[n]] = a[e[n]]);
    }
    return r.create = function(e) {
      return new r(e);
    }, r.encode = function(e, n) {
      return n || (n = $Writer.create()), n;
    }, r.encodeDelimited = function(e, n) {
      return this.encode(e, n).ldelim();
    }, r.decode = function(e, n) {
      e instanceof $Reader || (e = $Reader.create(e));
      let o = n === void 0 ? e.len : e.pos + n, c = new $root.gcg.UpdateDataRoomStatusResponse();
      for (; e.pos < o; ) {
        let l = e.uint32();
        switch (l >>> 3) {
          default:
            e.skipType(l & 7);
            break;
        }
      }
      return c;
    }, r.decodeDelimited = function(e) {
      return e instanceof $Reader || (e = new $Reader(e)), this.decode(e, e.uint32());
    }, r.verify = function(e) {
      return typeof e != "object" || e === null ? "object expected" : null;
    }, r.fromObject = function(e) {
      return e instanceof $root.gcg.UpdateDataRoomStatusResponse ? e : new $root.gcg.UpdateDataRoomStatusResponse();
    }, r.toObject = function() {
      return {};
    }, r.prototype.toJSON = function() {
      return this.constructor.toObject(this, minimal.util.toJSONOptions);
    }, r.getTypeUrl = function(e) {
      return e === void 0 && (e = "type.googleapis.com"), e + "/gcg.UpdateDataRoomStatusResponse";
    }, r;
  }(), u.RetrievePublishedDatasetsRequest = function() {
    function r(a) {
      if (a)
        for (let e = Object.keys(a), n = 0; n < e.length; ++n)
          a[e[n]] != null && (this[e[n]] = a[e[n]]);
    }
    return r.prototype.dataRoomId = $util.newBuffer([]), r.create = function(e) {
      return new r(e);
    }, r.encode = function(e, n) {
      return n || (n = $Writer.create()), e.dataRoomId != null && Object.hasOwnProperty.call(e, "dataRoomId") && n.uint32(
        /* id 1, wireType 2 =*/
        10
      ).bytes(e.dataRoomId), n;
    }, r.encodeDelimited = function(e, n) {
      return this.encode(e, n).ldelim();
    }, r.decode = function(e, n) {
      e instanceof $Reader || (e = $Reader.create(e));
      let o = n === void 0 ? e.len : e.pos + n, c = new $root.gcg.RetrievePublishedDatasetsRequest();
      for (; e.pos < o; ) {
        let l = e.uint32();
        switch (l >>> 3) {
          case 1: {
            c.dataRoomId = e.bytes();
            break;
          }
          default:
            e.skipType(l & 7);
            break;
        }
      }
      return c;
    }, r.decodeDelimited = function(e) {
      return e instanceof $Reader || (e = new $Reader(e)), this.decode(e, e.uint32());
    }, r.verify = function(e) {
      return typeof e != "object" || e === null ? "object expected" : e.dataRoomId != null && e.hasOwnProperty("dataRoomId") && !(e.dataRoomId && typeof e.dataRoomId.length == "number" || $util.isString(e.dataRoomId)) ? "dataRoomId: buffer expected" : null;
    }, r.fromObject = function(e) {
      if (e instanceof $root.gcg.RetrievePublishedDatasetsRequest)
        return e;
      let n = new $root.gcg.RetrievePublishedDatasetsRequest();
      return e.dataRoomId != null && (typeof e.dataRoomId == "string" ? $util.base64.decode(e.dataRoomId, n.dataRoomId = $util.newBuffer($util.base64.length(e.dataRoomId)), 0) : e.dataRoomId.length >= 0 && (n.dataRoomId = e.dataRoomId)), n;
    }, r.toObject = function(e, n) {
      n || (n = {});
      let o = {};
      return n.defaults && (n.bytes === String ? o.dataRoomId = "" : (o.dataRoomId = [], n.bytes !== Array && (o.dataRoomId = $util.newBuffer(o.dataRoomId)))), e.dataRoomId != null && e.hasOwnProperty("dataRoomId") && (o.dataRoomId = n.bytes === String ? $util.base64.encode(e.dataRoomId, 0, e.dataRoomId.length) : n.bytes === Array ? Array.prototype.slice.call(e.dataRoomId) : e.dataRoomId), o;
    }, r.prototype.toJSON = function() {
      return this.constructor.toObject(this, minimal.util.toJSONOptions);
    }, r.getTypeUrl = function(e) {
      return e === void 0 && (e = "type.googleapis.com"), e + "/gcg.RetrievePublishedDatasetsRequest";
    }, r;
  }(), u.PublishedDataset = function() {
    function r(a) {
      if (a)
        for (let e = Object.keys(a), n = 0; n < e.length; ++n)
          a[e[n]] != null && (this[e[n]] = a[e[n]]);
    }
    return r.prototype.leafId = "", r.prototype.user = "", r.prototype.timestamp = $util.Long ? $util.Long.fromBits(0, 0, !0) : 0, r.prototype.datasetHash = $util.newBuffer([]), r.create = function(e) {
      return new r(e);
    }, r.encode = function(e, n) {
      return n || (n = $Writer.create()), e.leafId != null && Object.hasOwnProperty.call(e, "leafId") && n.uint32(
        /* id 1, wireType 2 =*/
        10
      ).string(e.leafId), e.user != null && Object.hasOwnProperty.call(e, "user") && n.uint32(
        /* id 2, wireType 2 =*/
        18
      ).string(e.user), e.timestamp != null && Object.hasOwnProperty.call(e, "timestamp") && n.uint32(
        /* id 3, wireType 0 =*/
        24
      ).uint64(e.timestamp), e.datasetHash != null && Object.hasOwnProperty.call(e, "datasetHash") && n.uint32(
        /* id 4, wireType 2 =*/
        34
      ).bytes(e.datasetHash), n;
    }, r.encodeDelimited = function(e, n) {
      return this.encode(e, n).ldelim();
    }, r.decode = function(e, n) {
      e instanceof $Reader || (e = $Reader.create(e));
      let o = n === void 0 ? e.len : e.pos + n, c = new $root.gcg.PublishedDataset();
      for (; e.pos < o; ) {
        let l = e.uint32();
        switch (l >>> 3) {
          case 1: {
            c.leafId = e.string();
            break;
          }
          case 2: {
            c.user = e.string();
            break;
          }
          case 3: {
            c.timestamp = e.uint64();
            break;
          }
          case 4: {
            c.datasetHash = e.bytes();
            break;
          }
          default:
            e.skipType(l & 7);
            break;
        }
      }
      return c;
    }, r.decodeDelimited = function(e) {
      return e instanceof $Reader || (e = new $Reader(e)), this.decode(e, e.uint32());
    }, r.verify = function(e) {
      return typeof e != "object" || e === null ? "object expected" : e.leafId != null && e.hasOwnProperty("leafId") && !$util.isString(e.leafId) ? "leafId: string expected" : e.user != null && e.hasOwnProperty("user") && !$util.isString(e.user) ? "user: string expected" : e.timestamp != null && e.hasOwnProperty("timestamp") && !$util.isInteger(e.timestamp) && !(e.timestamp && $util.isInteger(e.timestamp.low) && $util.isInteger(e.timestamp.high)) ? "timestamp: integer|Long expected" : e.datasetHash != null && e.hasOwnProperty("datasetHash") && !(e.datasetHash && typeof e.datasetHash.length == "number" || $util.isString(e.datasetHash)) ? "datasetHash: buffer expected" : null;
    }, r.fromObject = function(e) {
      if (e instanceof $root.gcg.PublishedDataset)
        return e;
      let n = new $root.gcg.PublishedDataset();
      return e.leafId != null && (n.leafId = String(e.leafId)), e.user != null && (n.user = String(e.user)), e.timestamp != null && ($util.Long ? (n.timestamp = $util.Long.fromValue(e.timestamp)).unsigned = !0 : typeof e.timestamp == "string" ? n.timestamp = parseInt(e.timestamp, 10) : typeof e.timestamp == "number" ? n.timestamp = e.timestamp : typeof e.timestamp == "object" && (n.timestamp = new $util.LongBits(e.timestamp.low >>> 0, e.timestamp.high >>> 0).toNumber(!0))), e.datasetHash != null && (typeof e.datasetHash == "string" ? $util.base64.decode(e.datasetHash, n.datasetHash = $util.newBuffer($util.base64.length(e.datasetHash)), 0) : e.datasetHash.length >= 0 && (n.datasetHash = e.datasetHash)), n;
    }, r.toObject = function(e, n) {
      n || (n = {});
      let o = {};
      if (n.defaults) {
        if (o.leafId = "", o.user = "", $util.Long) {
          let c = new $util.Long(0, 0, !0);
          o.timestamp = n.longs === String ? c.toString() : n.longs === Number ? c.toNumber() : c;
        } else
          o.timestamp = n.longs === String ? "0" : 0;
        n.bytes === String ? o.datasetHash = "" : (o.datasetHash = [], n.bytes !== Array && (o.datasetHash = $util.newBuffer(o.datasetHash)));
      }
      return e.leafId != null && e.hasOwnProperty("leafId") && (o.leafId = e.leafId), e.user != null && e.hasOwnProperty("user") && (o.user = e.user), e.timestamp != null && e.hasOwnProperty("timestamp") && (typeof e.timestamp == "number" ? o.timestamp = n.longs === String ? String(e.timestamp) : e.timestamp : o.timestamp = n.longs === String ? $util.Long.prototype.toString.call(e.timestamp) : n.longs === Number ? new $util.LongBits(e.timestamp.low >>> 0, e.timestamp.high >>> 0).toNumber(!0) : e.timestamp), e.datasetHash != null && e.hasOwnProperty("datasetHash") && (o.datasetHash = n.bytes === String ? $util.base64.encode(e.datasetHash, 0, e.datasetHash.length) : n.bytes === Array ? Array.prototype.slice.call(e.datasetHash) : e.datasetHash), o;
    }, r.prototype.toJSON = function() {
      return this.constructor.toObject(this, minimal.util.toJSONOptions);
    }, r.getTypeUrl = function(e) {
      return e === void 0 && (e = "type.googleapis.com"), e + "/gcg.PublishedDataset";
    }, r;
  }(), u.RetrievePublishedDatasetsResponse = function() {
    function r(a) {
      if (this.publishedDatasets = [], a)
        for (let e = Object.keys(a), n = 0; n < e.length; ++n)
          a[e[n]] != null && (this[e[n]] = a[e[n]]);
    }
    return r.prototype.publishedDatasets = $util.emptyArray, r.create = function(e) {
      return new r(e);
    }, r.encode = function(e, n) {
      if (n || (n = $Writer.create()), e.publishedDatasets != null && e.publishedDatasets.length)
        for (let o = 0; o < e.publishedDatasets.length; ++o)
          $root.gcg.PublishedDataset.encode(e.publishedDatasets[o], n.uint32(
            /* id 1, wireType 2 =*/
            10
          ).fork()).ldelim();
      return n;
    }, r.encodeDelimited = function(e, n) {
      return this.encode(e, n).ldelim();
    }, r.decode = function(e, n) {
      e instanceof $Reader || (e = $Reader.create(e));
      let o = n === void 0 ? e.len : e.pos + n, c = new $root.gcg.RetrievePublishedDatasetsResponse();
      for (; e.pos < o; ) {
        let l = e.uint32();
        switch (l >>> 3) {
          case 1: {
            c.publishedDatasets && c.publishedDatasets.length || (c.publishedDatasets = []), c.publishedDatasets.push($root.gcg.PublishedDataset.decode(e, e.uint32()));
            break;
          }
          default:
            e.skipType(l & 7);
            break;
        }
      }
      return c;
    }, r.decodeDelimited = function(e) {
      return e instanceof $Reader || (e = new $Reader(e)), this.decode(e, e.uint32());
    }, r.verify = function(e) {
      if (typeof e != "object" || e === null)
        return "object expected";
      if (e.publishedDatasets != null && e.hasOwnProperty("publishedDatasets")) {
        if (!Array.isArray(e.publishedDatasets))
          return "publishedDatasets: array expected";
        for (let n = 0; n < e.publishedDatasets.length; ++n) {
          let o = $root.gcg.PublishedDataset.verify(e.publishedDatasets[n]);
          if (o)
            return "publishedDatasets." + o;
        }
      }
      return null;
    }, r.fromObject = function(e) {
      if (e instanceof $root.gcg.RetrievePublishedDatasetsResponse)
        return e;
      let n = new $root.gcg.RetrievePublishedDatasetsResponse();
      if (e.publishedDatasets) {
        if (!Array.isArray(e.publishedDatasets))
          throw TypeError(".gcg.RetrievePublishedDatasetsResponse.publishedDatasets: array expected");
        n.publishedDatasets = [];
        for (let o = 0; o < e.publishedDatasets.length; ++o) {
          if (typeof e.publishedDatasets[o] != "object")
            throw TypeError(".gcg.RetrievePublishedDatasetsResponse.publishedDatasets: object expected");
          n.publishedDatasets[o] = $root.gcg.PublishedDataset.fromObject(e.publishedDatasets[o]);
        }
      }
      return n;
    }, r.toObject = function(e, n) {
      n || (n = {});
      let o = {};
      if ((n.arrays || n.defaults) && (o.publishedDatasets = []), e.publishedDatasets && e.publishedDatasets.length) {
        o.publishedDatasets = [];
        for (let c = 0; c < e.publishedDatasets.length; ++c)
          o.publishedDatasets[c] = $root.gcg.PublishedDataset.toObject(e.publishedDatasets[c], n);
      }
      return o;
    }, r.prototype.toJSON = function() {
      return this.constructor.toObject(this, minimal.util.toJSONOptions);
    }, r.getTypeUrl = function(e) {
      return e === void 0 && (e = "type.googleapis.com"), e + "/gcg.RetrievePublishedDatasetsResponse";
    }, r;
  }(), u.RemovePublishedDatasetRequest = function() {
    function r(a) {
      if (a)
        for (let e = Object.keys(a), n = 0; n < e.length; ++n)
          a[e[n]] != null && (this[e[n]] = a[e[n]]);
    }
    return r.prototype.dataRoomId = $util.newBuffer([]), r.prototype.leafId = "", r.create = function(e) {
      return new r(e);
    }, r.encode = function(e, n) {
      return n || (n = $Writer.create()), e.dataRoomId != null && Object.hasOwnProperty.call(e, "dataRoomId") && n.uint32(
        /* id 1, wireType 2 =*/
        10
      ).bytes(e.dataRoomId), e.leafId != null && Object.hasOwnProperty.call(e, "leafId") && n.uint32(
        /* id 2, wireType 2 =*/
        18
      ).string(e.leafId), n;
    }, r.encodeDelimited = function(e, n) {
      return this.encode(e, n).ldelim();
    }, r.decode = function(e, n) {
      e instanceof $Reader || (e = $Reader.create(e));
      let o = n === void 0 ? e.len : e.pos + n, c = new $root.gcg.RemovePublishedDatasetRequest();
      for (; e.pos < o; ) {
        let l = e.uint32();
        switch (l >>> 3) {
          case 1: {
            c.dataRoomId = e.bytes();
            break;
          }
          case 2: {
            c.leafId = e.string();
            break;
          }
          default:
            e.skipType(l & 7);
            break;
        }
      }
      return c;
    }, r.decodeDelimited = function(e) {
      return e instanceof $Reader || (e = new $Reader(e)), this.decode(e, e.uint32());
    }, r.verify = function(e) {
      return typeof e != "object" || e === null ? "object expected" : e.dataRoomId != null && e.hasOwnProperty("dataRoomId") && !(e.dataRoomId && typeof e.dataRoomId.length == "number" || $util.isString(e.dataRoomId)) ? "dataRoomId: buffer expected" : e.leafId != null && e.hasOwnProperty("leafId") && !$util.isString(e.leafId) ? "leafId: string expected" : null;
    }, r.fromObject = function(e) {
      if (e instanceof $root.gcg.RemovePublishedDatasetRequest)
        return e;
      let n = new $root.gcg.RemovePublishedDatasetRequest();
      return e.dataRoomId != null && (typeof e.dataRoomId == "string" ? $util.base64.decode(e.dataRoomId, n.dataRoomId = $util.newBuffer($util.base64.length(e.dataRoomId)), 0) : e.dataRoomId.length >= 0 && (n.dataRoomId = e.dataRoomId)), e.leafId != null && (n.leafId = String(e.leafId)), n;
    }, r.toObject = function(e, n) {
      n || (n = {});
      let o = {};
      return n.defaults && (n.bytes === String ? o.dataRoomId = "" : (o.dataRoomId = [], n.bytes !== Array && (o.dataRoomId = $util.newBuffer(o.dataRoomId))), o.leafId = ""), e.dataRoomId != null && e.hasOwnProperty("dataRoomId") && (o.dataRoomId = n.bytes === String ? $util.base64.encode(e.dataRoomId, 0, e.dataRoomId.length) : n.bytes === Array ? Array.prototype.slice.call(e.dataRoomId) : e.dataRoomId), e.leafId != null && e.hasOwnProperty("leafId") && (o.leafId = e.leafId), o;
    }, r.prototype.toJSON = function() {
      return this.constructor.toObject(this, minimal.util.toJSONOptions);
    }, r.getTypeUrl = function(e) {
      return e === void 0 && (e = "type.googleapis.com"), e + "/gcg.RemovePublishedDatasetRequest";
    }, r;
  }(), u.RemovePublishedDatasetResponse = function() {
    function r(a) {
      if (a)
        for (let e = Object.keys(a), n = 0; n < e.length; ++n)
          a[e[n]] != null && (this[e[n]] = a[e[n]]);
    }
    return r.create = function(e) {
      return new r(e);
    }, r.encode = function(e, n) {
      return n || (n = $Writer.create()), n;
    }, r.encodeDelimited = function(e, n) {
      return this.encode(e, n).ldelim();
    }, r.decode = function(e, n) {
      e instanceof $Reader || (e = $Reader.create(e));
      let o = n === void 0 ? e.len : e.pos + n, c = new $root.gcg.RemovePublishedDatasetResponse();
      for (; e.pos < o; ) {
        let l = e.uint32();
        switch (l >>> 3) {
          default:
            e.skipType(l & 7);
            break;
        }
      }
      return c;
    }, r.decodeDelimited = function(e) {
      return e instanceof $Reader || (e = new $Reader(e)), this.decode(e, e.uint32());
    }, r.verify = function(e) {
      return typeof e != "object" || e === null ? "object expected" : null;
    }, r.fromObject = function(e) {
      return e instanceof $root.gcg.RemovePublishedDatasetResponse ? e : new $root.gcg.RemovePublishedDatasetResponse();
    }, r.toObject = function() {
      return {};
    }, r.prototype.toJSON = function() {
      return this.constructor.toObject(this, minimal.util.toJSONOptions);
    }, r.getTypeUrl = function(e) {
      return e === void 0 && (e = "type.googleapis.com"), e + "/gcg.RemovePublishedDatasetResponse";
    }, r;
  }(), u.CreateConfigurationCommitRequest = function() {
    function r(e) {
      if (e)
        for (let n = Object.keys(e), o = 0; o < n.length; ++o)
          e[n[o]] != null && (this[n[o]] = e[n[o]]);
    }
    r.prototype.commit = null, r.prototype.highLevelRepresentation = null;
    let a;
    return Object.defineProperty(r.prototype, "_highLevelRepresentation", {
      get: $util.oneOfGetter(a = ["highLevelRepresentation"]),
      set: $util.oneOfSetter(a)
    }), r.create = function(n) {
      return new r(n);
    }, r.encode = function(n, o) {
      return o || (o = $Writer.create()), n.commit != null && Object.hasOwnProperty.call(n, "commit") && $root.data_room.ConfigurationCommit.encode(n.commit, o.uint32(
        /* id 1, wireType 2 =*/
        10
      ).fork()).ldelim(), n.highLevelRepresentation != null && Object.hasOwnProperty.call(n, "highLevelRepresentation") && o.uint32(
        /* id 2, wireType 2 =*/
        18
      ).bytes(n.highLevelRepresentation), o;
    }, r.encodeDelimited = function(n, o) {
      return this.encode(n, o).ldelim();
    }, r.decode = function(n, o) {
      n instanceof $Reader || (n = $Reader.create(n));
      let c = o === void 0 ? n.len : n.pos + o, l = new $root.gcg.CreateConfigurationCommitRequest();
      for (; n.pos < c; ) {
        let d = n.uint32();
        switch (d >>> 3) {
          case 1: {
            l.commit = $root.data_room.ConfigurationCommit.decode(n, n.uint32());
            break;
          }
          case 2: {
            l.highLevelRepresentation = n.bytes();
            break;
          }
          default:
            n.skipType(d & 7);
            break;
        }
      }
      return l;
    }, r.decodeDelimited = function(n) {
      return n instanceof $Reader || (n = new $Reader(n)), this.decode(n, n.uint32());
    }, r.verify = function(n) {
      if (typeof n != "object" || n === null)
        return "object expected";
      if (n.commit != null && n.hasOwnProperty("commit")) {
        let o = $root.data_room.ConfigurationCommit.verify(n.commit);
        if (o)
          return "commit." + o;
      }
      return n.highLevelRepresentation != null && n.hasOwnProperty("highLevelRepresentation") && !(n.highLevelRepresentation && typeof n.highLevelRepresentation.length == "number" || $util.isString(n.highLevelRepresentation)) ? "highLevelRepresentation: buffer expected" : null;
    }, r.fromObject = function(n) {
      if (n instanceof $root.gcg.CreateConfigurationCommitRequest)
        return n;
      let o = new $root.gcg.CreateConfigurationCommitRequest();
      if (n.commit != null) {
        if (typeof n.commit != "object")
          throw TypeError(".gcg.CreateConfigurationCommitRequest.commit: object expected");
        o.commit = $root.data_room.ConfigurationCommit.fromObject(n.commit);
      }
      return n.highLevelRepresentation != null && (typeof n.highLevelRepresentation == "string" ? $util.base64.decode(n.highLevelRepresentation, o.highLevelRepresentation = $util.newBuffer($util.base64.length(n.highLevelRepresentation)), 0) : n.highLevelRepresentation.length >= 0 && (o.highLevelRepresentation = n.highLevelRepresentation)), o;
    }, r.toObject = function(n, o) {
      o || (o = {});
      let c = {};
      return o.defaults && (c.commit = null), n.commit != null && n.hasOwnProperty("commit") && (c.commit = $root.data_room.ConfigurationCommit.toObject(n.commit, o)), n.highLevelRepresentation != null && n.hasOwnProperty("highLevelRepresentation") && (c.highLevelRepresentation = o.bytes === String ? $util.base64.encode(n.highLevelRepresentation, 0, n.highLevelRepresentation.length) : o.bytes === Array ? Array.prototype.slice.call(n.highLevelRepresentation) : n.highLevelRepresentation, o.oneofs && (c._highLevelRepresentation = "highLevelRepresentation")), c;
    }, r.prototype.toJSON = function() {
      return this.constructor.toObject(this, minimal.util.toJSONOptions);
    }, r.getTypeUrl = function(n) {
      return n === void 0 && (n = "type.googleapis.com"), n + "/gcg.CreateConfigurationCommitRequest";
    }, r;
  }(), u.CreateConfigurationCommitResponse = function() {
    function r(a) {
      if (a)
        for (let e = Object.keys(a), n = 0; n < e.length; ++n)
          a[e[n]] != null && (this[e[n]] = a[e[n]]);
    }
    return r.prototype.commitId = $util.newBuffer([]), r.create = function(e) {
      return new r(e);
    }, r.encode = function(e, n) {
      return n || (n = $Writer.create()), e.commitId != null && Object.hasOwnProperty.call(e, "commitId") && n.uint32(
        /* id 1, wireType 2 =*/
        10
      ).bytes(e.commitId), n;
    }, r.encodeDelimited = function(e, n) {
      return this.encode(e, n).ldelim();
    }, r.decode = function(e, n) {
      e instanceof $Reader || (e = $Reader.create(e));
      let o = n === void 0 ? e.len : e.pos + n, c = new $root.gcg.CreateConfigurationCommitResponse();
      for (; e.pos < o; ) {
        let l = e.uint32();
        switch (l >>> 3) {
          case 1: {
            c.commitId = e.bytes();
            break;
          }
          default:
            e.skipType(l & 7);
            break;
        }
      }
      return c;
    }, r.decodeDelimited = function(e) {
      return e instanceof $Reader || (e = new $Reader(e)), this.decode(e, e.uint32());
    }, r.verify = function(e) {
      return typeof e != "object" || e === null ? "object expected" : e.commitId != null && e.hasOwnProperty("commitId") && !(e.commitId && typeof e.commitId.length == "number" || $util.isString(e.commitId)) ? "commitId: buffer expected" : null;
    }, r.fromObject = function(e) {
      if (e instanceof $root.gcg.CreateConfigurationCommitResponse)
        return e;
      let n = new $root.gcg.CreateConfigurationCommitResponse();
      return e.commitId != null && (typeof e.commitId == "string" ? $util.base64.decode(e.commitId, n.commitId = $util.newBuffer($util.base64.length(e.commitId)), 0) : e.commitId.length >= 0 && (n.commitId = e.commitId)), n;
    }, r.toObject = function(e, n) {
      n || (n = {});
      let o = {};
      return n.defaults && (n.bytes === String ? o.commitId = "" : (o.commitId = [], n.bytes !== Array && (o.commitId = $util.newBuffer(o.commitId)))), e.commitId != null && e.hasOwnProperty("commitId") && (o.commitId = n.bytes === String ? $util.base64.encode(e.commitId, 0, e.commitId.length) : n.bytes === Array ? Array.prototype.slice.call(e.commitId) : e.commitId), o;
    }, r.prototype.toJSON = function() {
      return this.constructor.toObject(this, minimal.util.toJSONOptions);
    }, r.getTypeUrl = function(e) {
      return e === void 0 && (e = "type.googleapis.com"), e + "/gcg.CreateConfigurationCommitResponse";
    }, r;
  }(), u.GenerateMergeApprovalSignatureRequest = function() {
    function r(a) {
      if (a)
        for (let e = Object.keys(a), n = 0; n < e.length; ++n)
          a[e[n]] != null && (this[e[n]] = a[e[n]]);
    }
    return r.prototype.commitId = $util.newBuffer([]), r.create = function(e) {
      return new r(e);
    }, r.encode = function(e, n) {
      return n || (n = $Writer.create()), e.commitId != null && Object.hasOwnProperty.call(e, "commitId") && n.uint32(
        /* id 1, wireType 2 =*/
        10
      ).bytes(e.commitId), n;
    }, r.encodeDelimited = function(e, n) {
      return this.encode(e, n).ldelim();
    }, r.decode = function(e, n) {
      e instanceof $Reader || (e = $Reader.create(e));
      let o = n === void 0 ? e.len : e.pos + n, c = new $root.gcg.GenerateMergeApprovalSignatureRequest();
      for (; e.pos < o; ) {
        let l = e.uint32();
        switch (l >>> 3) {
          case 1: {
            c.commitId = e.bytes();
            break;
          }
          default:
            e.skipType(l & 7);
            break;
        }
      }
      return c;
    }, r.decodeDelimited = function(e) {
      return e instanceof $Reader || (e = new $Reader(e)), this.decode(e, e.uint32());
    }, r.verify = function(e) {
      return typeof e != "object" || e === null ? "object expected" : e.commitId != null && e.hasOwnProperty("commitId") && !(e.commitId && typeof e.commitId.length == "number" || $util.isString(e.commitId)) ? "commitId: buffer expected" : null;
    }, r.fromObject = function(e) {
      if (e instanceof $root.gcg.GenerateMergeApprovalSignatureRequest)
        return e;
      let n = new $root.gcg.GenerateMergeApprovalSignatureRequest();
      return e.commitId != null && (typeof e.commitId == "string" ? $util.base64.decode(e.commitId, n.commitId = $util.newBuffer($util.base64.length(e.commitId)), 0) : e.commitId.length >= 0 && (n.commitId = e.commitId)), n;
    }, r.toObject = function(e, n) {
      n || (n = {});
      let o = {};
      return n.defaults && (n.bytes === String ? o.commitId = "" : (o.commitId = [], n.bytes !== Array && (o.commitId = $util.newBuffer(o.commitId)))), e.commitId != null && e.hasOwnProperty("commitId") && (o.commitId = n.bytes === String ? $util.base64.encode(e.commitId, 0, e.commitId.length) : n.bytes === Array ? Array.prototype.slice.call(e.commitId) : e.commitId), o;
    }, r.prototype.toJSON = function() {
      return this.constructor.toObject(this, minimal.util.toJSONOptions);
    }, r.getTypeUrl = function(e) {
      return e === void 0 && (e = "type.googleapis.com"), e + "/gcg.GenerateMergeApprovalSignatureRequest";
    }, r;
  }(), u.GenerateMergeApprovalSignatureResponse = function() {
    function r(a) {
      if (a)
        for (let e = Object.keys(a), n = 0; n < e.length; ++n)
          a[e[n]] != null && (this[e[n]] = a[e[n]]);
    }
    return r.prototype.signature = $util.newBuffer([]), r.create = function(e) {
      return new r(e);
    }, r.encode = function(e, n) {
      return n || (n = $Writer.create()), e.signature != null && Object.hasOwnProperty.call(e, "signature") && n.uint32(
        /* id 1, wireType 2 =*/
        10
      ).bytes(e.signature), n;
    }, r.encodeDelimited = function(e, n) {
      return this.encode(e, n).ldelim();
    }, r.decode = function(e, n) {
      e instanceof $Reader || (e = $Reader.create(e));
      let o = n === void 0 ? e.len : e.pos + n, c = new $root.gcg.GenerateMergeApprovalSignatureResponse();
      for (; e.pos < o; ) {
        let l = e.uint32();
        switch (l >>> 3) {
          case 1: {
            c.signature = e.bytes();
            break;
          }
          default:
            e.skipType(l & 7);
            break;
        }
      }
      return c;
    }, r.decodeDelimited = function(e) {
      return e instanceof $Reader || (e = new $Reader(e)), this.decode(e, e.uint32());
    }, r.verify = function(e) {
      return typeof e != "object" || e === null ? "object expected" : e.signature != null && e.hasOwnProperty("signature") && !(e.signature && typeof e.signature.length == "number" || $util.isString(e.signature)) ? "signature: buffer expected" : null;
    }, r.fromObject = function(e) {
      if (e instanceof $root.gcg.GenerateMergeApprovalSignatureResponse)
        return e;
      let n = new $root.gcg.GenerateMergeApprovalSignatureResponse();
      return e.signature != null && (typeof e.signature == "string" ? $util.base64.decode(e.signature, n.signature = $util.newBuffer($util.base64.length(e.signature)), 0) : e.signature.length >= 0 && (n.signature = e.signature)), n;
    }, r.toObject = function(e, n) {
      n || (n = {});
      let o = {};
      return n.defaults && (n.bytes === String ? o.signature = "" : (o.signature = [], n.bytes !== Array && (o.signature = $util.newBuffer(o.signature)))), e.signature != null && e.hasOwnProperty("signature") && (o.signature = n.bytes === String ? $util.base64.encode(e.signature, 0, e.signature.length) : n.bytes === Array ? Array.prototype.slice.call(e.signature) : e.signature), o;
    }, r.prototype.toJSON = function() {
      return this.constructor.toObject(this, minimal.util.toJSONOptions);
    }, r.getTypeUrl = function(e) {
      return e === void 0 && (e = "type.googleapis.com"), e + "/gcg.GenerateMergeApprovalSignatureResponse";
    }, r;
  }(), u.MergeConfigurationCommitRequest = function() {
    function r(e) {
      if (this.approvalSignatures = {}, e)
        for (let n = Object.keys(e), o = 0; o < n.length; ++o)
          e[n[o]] != null && (this[n[o]] = e[n[o]]);
    }
    r.prototype.commitId = $util.newBuffer([]), r.prototype.approvalSignatures = $util.emptyObject, r.prototype.newDataRoomHighLevelRepresentation = null;
    let a;
    return Object.defineProperty(r.prototype, "_newDataRoomHighLevelRepresentation", {
      get: $util.oneOfGetter(a = ["newDataRoomHighLevelRepresentation"]),
      set: $util.oneOfSetter(a)
    }), r.create = function(n) {
      return new r(n);
    }, r.encode = function(n, o) {
      if (o || (o = $Writer.create()), n.commitId != null && Object.hasOwnProperty.call(n, "commitId") && o.uint32(
        /* id 1, wireType 2 =*/
        10
      ).bytes(n.commitId), n.approvalSignatures != null && Object.hasOwnProperty.call(n, "approvalSignatures"))
        for (let c = Object.keys(n.approvalSignatures), l = 0; l < c.length; ++l)
          o.uint32(
            /* id 2, wireType 2 =*/
            18
          ).fork().uint32(
            /* id 1, wireType 2 =*/
            10
          ).string(c[l]).uint32(
            /* id 2, wireType 2 =*/
            18
          ).bytes(n.approvalSignatures[c[l]]).ldelim();
      return n.newDataRoomHighLevelRepresentation != null && Object.hasOwnProperty.call(n, "newDataRoomHighLevelRepresentation") && o.uint32(
        /* id 3, wireType 2 =*/
        26
      ).bytes(n.newDataRoomHighLevelRepresentation), o;
    }, r.encodeDelimited = function(n, o) {
      return this.encode(n, o).ldelim();
    }, r.decode = function(n, o) {
      n instanceof $Reader || (n = $Reader.create(n));
      let c = o === void 0 ? n.len : n.pos + o, l = new $root.gcg.MergeConfigurationCommitRequest(), d, p;
      for (; n.pos < c; ) {
        let h = n.uint32();
        switch (h >>> 3) {
          case 1: {
            l.commitId = n.bytes();
            break;
          }
          case 2: {
            l.approvalSignatures === $util.emptyObject && (l.approvalSignatures = {});
            let g = n.uint32() + n.pos;
            for (d = "", p = []; n.pos < g; ) {
              let y = n.uint32();
              switch (y >>> 3) {
                case 1:
                  d = n.string();
                  break;
                case 2:
                  p = n.bytes();
                  break;
                default:
                  n.skipType(y & 7);
                  break;
              }
            }
            l.approvalSignatures[d] = p;
            break;
          }
          case 3: {
            l.newDataRoomHighLevelRepresentation = n.bytes();
            break;
          }
          default:
            n.skipType(h & 7);
            break;
        }
      }
      return l;
    }, r.decodeDelimited = function(n) {
      return n instanceof $Reader || (n = new $Reader(n)), this.decode(n, n.uint32());
    }, r.verify = function(n) {
      if (typeof n != "object" || n === null)
        return "object expected";
      if (n.commitId != null && n.hasOwnProperty("commitId") && !(n.commitId && typeof n.commitId.length == "number" || $util.isString(n.commitId)))
        return "commitId: buffer expected";
      if (n.approvalSignatures != null && n.hasOwnProperty("approvalSignatures")) {
        if (!$util.isObject(n.approvalSignatures))
          return "approvalSignatures: object expected";
        let o = Object.keys(n.approvalSignatures);
        for (let c = 0; c < o.length; ++c)
          if (!(n.approvalSignatures[o[c]] && typeof n.approvalSignatures[o[c]].length == "number" || $util.isString(n.approvalSignatures[o[c]])))
            return "approvalSignatures: buffer{k:string} expected";
      }
      return n.newDataRoomHighLevelRepresentation != null && n.hasOwnProperty("newDataRoomHighLevelRepresentation") && !(n.newDataRoomHighLevelRepresentation && typeof n.newDataRoomHighLevelRepresentation.length == "number" || $util.isString(n.newDataRoomHighLevelRepresentation)) ? "newDataRoomHighLevelRepresentation: buffer expected" : null;
    }, r.fromObject = function(n) {
      if (n instanceof $root.gcg.MergeConfigurationCommitRequest)
        return n;
      let o = new $root.gcg.MergeConfigurationCommitRequest();
      if (n.commitId != null && (typeof n.commitId == "string" ? $util.base64.decode(n.commitId, o.commitId = $util.newBuffer($util.base64.length(n.commitId)), 0) : n.commitId.length >= 0 && (o.commitId = n.commitId)), n.approvalSignatures) {
        if (typeof n.approvalSignatures != "object")
          throw TypeError(".gcg.MergeConfigurationCommitRequest.approvalSignatures: object expected");
        o.approvalSignatures = {};
        for (let c = Object.keys(n.approvalSignatures), l = 0; l < c.length; ++l)
          typeof n.approvalSignatures[c[l]] == "string" ? $util.base64.decode(n.approvalSignatures[c[l]], o.approvalSignatures[c[l]] = $util.newBuffer($util.base64.length(n.approvalSignatures[c[l]])), 0) : n.approvalSignatures[c[l]].length >= 0 && (o.approvalSignatures[c[l]] = n.approvalSignatures[c[l]]);
      }
      return n.newDataRoomHighLevelRepresentation != null && (typeof n.newDataRoomHighLevelRepresentation == "string" ? $util.base64.decode(n.newDataRoomHighLevelRepresentation, o.newDataRoomHighLevelRepresentation = $util.newBuffer($util.base64.length(n.newDataRoomHighLevelRepresentation)), 0) : n.newDataRoomHighLevelRepresentation.length >= 0 && (o.newDataRoomHighLevelRepresentation = n.newDataRoomHighLevelRepresentation)), o;
    }, r.toObject = function(n, o) {
      o || (o = {});
      let c = {};
      (o.objects || o.defaults) && (c.approvalSignatures = {}), o.defaults && (o.bytes === String ? c.commitId = "" : (c.commitId = [], o.bytes !== Array && (c.commitId = $util.newBuffer(c.commitId)))), n.commitId != null && n.hasOwnProperty("commitId") && (c.commitId = o.bytes === String ? $util.base64.encode(n.commitId, 0, n.commitId.length) : o.bytes === Array ? Array.prototype.slice.call(n.commitId) : n.commitId);
      let l;
      if (n.approvalSignatures && (l = Object.keys(n.approvalSignatures)).length) {
        c.approvalSignatures = {};
        for (let d = 0; d < l.length; ++d)
          c.approvalSignatures[l[d]] = o.bytes === String ? $util.base64.encode(n.approvalSignatures[l[d]], 0, n.approvalSignatures[l[d]].length) : o.bytes === Array ? Array.prototype.slice.call(n.approvalSignatures[l[d]]) : n.approvalSignatures[l[d]];
      }
      return n.newDataRoomHighLevelRepresentation != null && n.hasOwnProperty("newDataRoomHighLevelRepresentation") && (c.newDataRoomHighLevelRepresentation = o.bytes === String ? $util.base64.encode(n.newDataRoomHighLevelRepresentation, 0, n.newDataRoomHighLevelRepresentation.length) : o.bytes === Array ? Array.prototype.slice.call(n.newDataRoomHighLevelRepresentation) : n.newDataRoomHighLevelRepresentation, o.oneofs && (c._newDataRoomHighLevelRepresentation = "newDataRoomHighLevelRepresentation")), c;
    }, r.prototype.toJSON = function() {
      return this.constructor.toObject(this, minimal.util.toJSONOptions);
    }, r.getTypeUrl = function(n) {
      return n === void 0 && (n = "type.googleapis.com"), n + "/gcg.MergeConfigurationCommitRequest";
    }, r;
  }(), u.RetrieveCurrentDataRoomConfigurationRequest = function() {
    function r(a) {
      if (a)
        for (let e = Object.keys(a), n = 0; n < e.length; ++n)
          a[e[n]] != null && (this[e[n]] = a[e[n]]);
    }
    return r.prototype.dataRoomId = $util.newBuffer([]), r.create = function(e) {
      return new r(e);
    }, r.encode = function(e, n) {
      return n || (n = $Writer.create()), e.dataRoomId != null && Object.hasOwnProperty.call(e, "dataRoomId") && n.uint32(
        /* id 1, wireType 2 =*/
        10
      ).bytes(e.dataRoomId), n;
    }, r.encodeDelimited = function(e, n) {
      return this.encode(e, n).ldelim();
    }, r.decode = function(e, n) {
      e instanceof $Reader || (e = $Reader.create(e));
      let o = n === void 0 ? e.len : e.pos + n, c = new $root.gcg.RetrieveCurrentDataRoomConfigurationRequest();
      for (; e.pos < o; ) {
        let l = e.uint32();
        switch (l >>> 3) {
          case 1: {
            c.dataRoomId = e.bytes();
            break;
          }
          default:
            e.skipType(l & 7);
            break;
        }
      }
      return c;
    }, r.decodeDelimited = function(e) {
      return e instanceof $Reader || (e = new $Reader(e)), this.decode(e, e.uint32());
    }, r.verify = function(e) {
      return typeof e != "object" || e === null ? "object expected" : e.dataRoomId != null && e.hasOwnProperty("dataRoomId") && !(e.dataRoomId && typeof e.dataRoomId.length == "number" || $util.isString(e.dataRoomId)) ? "dataRoomId: buffer expected" : null;
    }, r.fromObject = function(e) {
      if (e instanceof $root.gcg.RetrieveCurrentDataRoomConfigurationRequest)
        return e;
      let n = new $root.gcg.RetrieveCurrentDataRoomConfigurationRequest();
      return e.dataRoomId != null && (typeof e.dataRoomId == "string" ? $util.base64.decode(e.dataRoomId, n.dataRoomId = $util.newBuffer($util.base64.length(e.dataRoomId)), 0) : e.dataRoomId.length >= 0 && (n.dataRoomId = e.dataRoomId)), n;
    }, r.toObject = function(e, n) {
      n || (n = {});
      let o = {};
      return n.defaults && (n.bytes === String ? o.dataRoomId = "" : (o.dataRoomId = [], n.bytes !== Array && (o.dataRoomId = $util.newBuffer(o.dataRoomId)))), e.dataRoomId != null && e.hasOwnProperty("dataRoomId") && (o.dataRoomId = n.bytes === String ? $util.base64.encode(e.dataRoomId, 0, e.dataRoomId.length) : n.bytes === Array ? Array.prototype.slice.call(e.dataRoomId) : e.dataRoomId), o;
    }, r.prototype.toJSON = function() {
      return this.constructor.toObject(this, minimal.util.toJSONOptions);
    }, r.getTypeUrl = function(e) {
      return e === void 0 && (e = "type.googleapis.com"), e + "/gcg.RetrieveCurrentDataRoomConfigurationRequest";
    }, r;
  }(), u.RetrieveCurrentDataRoomConfigurationResponse = function() {
    function r(a) {
      if (a)
        for (let e = Object.keys(a), n = 0; n < e.length; ++n)
          a[e[n]] != null && (this[e[n]] = a[e[n]]);
    }
    return r.prototype.configuration = null, r.prototype.pin = $util.newBuffer([]), r.create = function(e) {
      return new r(e);
    }, r.encode = function(e, n) {
      return n || (n = $Writer.create()), e.configuration != null && Object.hasOwnProperty.call(e, "configuration") && $root.data_room.DataRoomConfiguration.encode(e.configuration, n.uint32(
        /* id 1, wireType 2 =*/
        10
      ).fork()).ldelim(), e.pin != null && Object.hasOwnProperty.call(e, "pin") && n.uint32(
        /* id 2, wireType 2 =*/
        18
      ).bytes(e.pin), n;
    }, r.encodeDelimited = function(e, n) {
      return this.encode(e, n).ldelim();
    }, r.decode = function(e, n) {
      e instanceof $Reader || (e = $Reader.create(e));
      let o = n === void 0 ? e.len : e.pos + n, c = new $root.gcg.RetrieveCurrentDataRoomConfigurationResponse();
      for (; e.pos < o; ) {
        let l = e.uint32();
        switch (l >>> 3) {
          case 1: {
            c.configuration = $root.data_room.DataRoomConfiguration.decode(e, e.uint32());
            break;
          }
          case 2: {
            c.pin = e.bytes();
            break;
          }
          default:
            e.skipType(l & 7);
            break;
        }
      }
      return c;
    }, r.decodeDelimited = function(e) {
      return e instanceof $Reader || (e = new $Reader(e)), this.decode(e, e.uint32());
    }, r.verify = function(e) {
      if (typeof e != "object" || e === null)
        return "object expected";
      if (e.configuration != null && e.hasOwnProperty("configuration")) {
        let n = $root.data_room.DataRoomConfiguration.verify(e.configuration);
        if (n)
          return "configuration." + n;
      }
      return e.pin != null && e.hasOwnProperty("pin") && !(e.pin && typeof e.pin.length == "number" || $util.isString(e.pin)) ? "pin: buffer expected" : null;
    }, r.fromObject = function(e) {
      if (e instanceof $root.gcg.RetrieveCurrentDataRoomConfigurationResponse)
        return e;
      let n = new $root.gcg.RetrieveCurrentDataRoomConfigurationResponse();
      if (e.configuration != null) {
        if (typeof e.configuration != "object")
          throw TypeError(".gcg.RetrieveCurrentDataRoomConfigurationResponse.configuration: object expected");
        n.configuration = $root.data_room.DataRoomConfiguration.fromObject(e.configuration);
      }
      return e.pin != null && (typeof e.pin == "string" ? $util.base64.decode(e.pin, n.pin = $util.newBuffer($util.base64.length(e.pin)), 0) : e.pin.length >= 0 && (n.pin = e.pin)), n;
    }, r.toObject = function(e, n) {
      n || (n = {});
      let o = {};
      return n.defaults && (o.configuration = null, n.bytes === String ? o.pin = "" : (o.pin = [], n.bytes !== Array && (o.pin = $util.newBuffer(o.pin)))), e.configuration != null && e.hasOwnProperty("configuration") && (o.configuration = $root.data_room.DataRoomConfiguration.toObject(e.configuration, n)), e.pin != null && e.hasOwnProperty("pin") && (o.pin = n.bytes === String ? $util.base64.encode(e.pin, 0, e.pin.length) : n.bytes === Array ? Array.prototype.slice.call(e.pin) : e.pin), o;
    }, r.prototype.toJSON = function() {
      return this.constructor.toObject(this, minimal.util.toJSONOptions);
    }, r.getTypeUrl = function(e) {
      return e === void 0 && (e = "type.googleapis.com"), e + "/gcg.RetrieveCurrentDataRoomConfigurationResponse";
    }, r;
  }(), u.RetrieveConfigurationCommitApproversRequest = function() {
    function r(a) {
      if (a)
        for (let e = Object.keys(a), n = 0; n < e.length; ++n)
          a[e[n]] != null && (this[e[n]] = a[e[n]]);
    }
    return r.prototype.commitId = $util.newBuffer([]), r.create = function(e) {
      return new r(e);
    }, r.encode = function(e, n) {
      return n || (n = $Writer.create()), e.commitId != null && Object.hasOwnProperty.call(e, "commitId") && n.uint32(
        /* id 1, wireType 2 =*/
        10
      ).bytes(e.commitId), n;
    }, r.encodeDelimited = function(e, n) {
      return this.encode(e, n).ldelim();
    }, r.decode = function(e, n) {
      e instanceof $Reader || (e = $Reader.create(e));
      let o = n === void 0 ? e.len : e.pos + n, c = new $root.gcg.RetrieveConfigurationCommitApproversRequest();
      for (; e.pos < o; ) {
        let l = e.uint32();
        switch (l >>> 3) {
          case 1: {
            c.commitId = e.bytes();
            break;
          }
          default:
            e.skipType(l & 7);
            break;
        }
      }
      return c;
    }, r.decodeDelimited = function(e) {
      return e instanceof $Reader || (e = new $Reader(e)), this.decode(e, e.uint32());
    }, r.verify = function(e) {
      return typeof e != "object" || e === null ? "object expected" : e.commitId != null && e.hasOwnProperty("commitId") && !(e.commitId && typeof e.commitId.length == "number" || $util.isString(e.commitId)) ? "commitId: buffer expected" : null;
    }, r.fromObject = function(e) {
      if (e instanceof $root.gcg.RetrieveConfigurationCommitApproversRequest)
        return e;
      let n = new $root.gcg.RetrieveConfigurationCommitApproversRequest();
      return e.commitId != null && (typeof e.commitId == "string" ? $util.base64.decode(e.commitId, n.commitId = $util.newBuffer($util.base64.length(e.commitId)), 0) : e.commitId.length >= 0 && (n.commitId = e.commitId)), n;
    }, r.toObject = function(e, n) {
      n || (n = {});
      let o = {};
      return n.defaults && (n.bytes === String ? o.commitId = "" : (o.commitId = [], n.bytes !== Array && (o.commitId = $util.newBuffer(o.commitId)))), e.commitId != null && e.hasOwnProperty("commitId") && (o.commitId = n.bytes === String ? $util.base64.encode(e.commitId, 0, e.commitId.length) : n.bytes === Array ? Array.prototype.slice.call(e.commitId) : e.commitId), o;
    }, r.prototype.toJSON = function() {
      return this.constructor.toObject(this, minimal.util.toJSONOptions);
    }, r.getTypeUrl = function(e) {
      return e === void 0 && (e = "type.googleapis.com"), e + "/gcg.RetrieveConfigurationCommitApproversRequest";
    }, r;
  }(), u.RetrieveConfigurationCommitApproversResponse = function() {
    function r(a) {
      if (this.approvers = [], a)
        for (let e = Object.keys(a), n = 0; n < e.length; ++n)
          a[e[n]] != null && (this[e[n]] = a[e[n]]);
    }
    return r.prototype.approvers = $util.emptyArray, r.create = function(e) {
      return new r(e);
    }, r.encode = function(e, n) {
      if (n || (n = $Writer.create()), e.approvers != null && e.approvers.length)
        for (let o = 0; o < e.approvers.length; ++o)
          n.uint32(
            /* id 1, wireType 2 =*/
            10
          ).string(e.approvers[o]);
      return n;
    }, r.encodeDelimited = function(e, n) {
      return this.encode(e, n).ldelim();
    }, r.decode = function(e, n) {
      e instanceof $Reader || (e = $Reader.create(e));
      let o = n === void 0 ? e.len : e.pos + n, c = new $root.gcg.RetrieveConfigurationCommitApproversResponse();
      for (; e.pos < o; ) {
        let l = e.uint32();
        switch (l >>> 3) {
          case 1: {
            c.approvers && c.approvers.length || (c.approvers = []), c.approvers.push(e.string());
            break;
          }
          default:
            e.skipType(l & 7);
            break;
        }
      }
      return c;
    }, r.decodeDelimited = function(e) {
      return e instanceof $Reader || (e = new $Reader(e)), this.decode(e, e.uint32());
    }, r.verify = function(e) {
      if (typeof e != "object" || e === null)
        return "object expected";
      if (e.approvers != null && e.hasOwnProperty("approvers")) {
        if (!Array.isArray(e.approvers))
          return "approvers: array expected";
        for (let n = 0; n < e.approvers.length; ++n)
          if (!$util.isString(e.approvers[n]))
            return "approvers: string[] expected";
      }
      return null;
    }, r.fromObject = function(e) {
      if (e instanceof $root.gcg.RetrieveConfigurationCommitApproversResponse)
        return e;
      let n = new $root.gcg.RetrieveConfigurationCommitApproversResponse();
      if (e.approvers) {
        if (!Array.isArray(e.approvers))
          throw TypeError(".gcg.RetrieveConfigurationCommitApproversResponse.approvers: array expected");
        n.approvers = [];
        for (let o = 0; o < e.approvers.length; ++o)
          n.approvers[o] = String(e.approvers[o]);
      }
      return n;
    }, r.toObject = function(e, n) {
      n || (n = {});
      let o = {};
      if ((n.arrays || n.defaults) && (o.approvers = []), e.approvers && e.approvers.length) {
        o.approvers = [];
        for (let c = 0; c < e.approvers.length; ++c)
          o.approvers[c] = e.approvers[c];
      }
      return o;
    }, r.prototype.toJSON = function() {
      return this.constructor.toObject(this, minimal.util.toJSONOptions);
    }, r.getTypeUrl = function(e) {
      return e === void 0 && (e = "type.googleapis.com"), e + "/gcg.RetrieveConfigurationCommitApproversResponse";
    }, r;
  }(), u.RetrieveConfigurationCommitRequest = function() {
    function r(a) {
      if (a)
        for (let e = Object.keys(a), n = 0; n < e.length; ++n)
          a[e[n]] != null && (this[e[n]] = a[e[n]]);
    }
    return r.prototype.commitId = $util.newBuffer([]), r.create = function(e) {
      return new r(e);
    }, r.encode = function(e, n) {
      return n || (n = $Writer.create()), e.commitId != null && Object.hasOwnProperty.call(e, "commitId") && n.uint32(
        /* id 1, wireType 2 =*/
        10
      ).bytes(e.commitId), n;
    }, r.encodeDelimited = function(e, n) {
      return this.encode(e, n).ldelim();
    }, r.decode = function(e, n) {
      e instanceof $Reader || (e = $Reader.create(e));
      let o = n === void 0 ? e.len : e.pos + n, c = new $root.gcg.RetrieveConfigurationCommitRequest();
      for (; e.pos < o; ) {
        let l = e.uint32();
        switch (l >>> 3) {
          case 1: {
            c.commitId = e.bytes();
            break;
          }
          default:
            e.skipType(l & 7);
            break;
        }
      }
      return c;
    }, r.decodeDelimited = function(e) {
      return e instanceof $Reader || (e = new $Reader(e)), this.decode(e, e.uint32());
    }, r.verify = function(e) {
      return typeof e != "object" || e === null ? "object expected" : e.commitId != null && e.hasOwnProperty("commitId") && !(e.commitId && typeof e.commitId.length == "number" || $util.isString(e.commitId)) ? "commitId: buffer expected" : null;
    }, r.fromObject = function(e) {
      if (e instanceof $root.gcg.RetrieveConfigurationCommitRequest)
        return e;
      let n = new $root.gcg.RetrieveConfigurationCommitRequest();
      return e.commitId != null && (typeof e.commitId == "string" ? $util.base64.decode(e.commitId, n.commitId = $util.newBuffer($util.base64.length(e.commitId)), 0) : e.commitId.length >= 0 && (n.commitId = e.commitId)), n;
    }, r.toObject = function(e, n) {
      n || (n = {});
      let o = {};
      return n.defaults && (n.bytes === String ? o.commitId = "" : (o.commitId = [], n.bytes !== Array && (o.commitId = $util.newBuffer(o.commitId)))), e.commitId != null && e.hasOwnProperty("commitId") && (o.commitId = n.bytes === String ? $util.base64.encode(e.commitId, 0, e.commitId.length) : n.bytes === Array ? Array.prototype.slice.call(e.commitId) : e.commitId), o;
    }, r.prototype.toJSON = function() {
      return this.constructor.toObject(this, minimal.util.toJSONOptions);
    }, r.getTypeUrl = function(e) {
      return e === void 0 && (e = "type.googleapis.com"), e + "/gcg.RetrieveConfigurationCommitRequest";
    }, r;
  }(), u.RetrieveConfigurationCommitResponse = function() {
    function r(e) {
      if (e)
        for (let n = Object.keys(e), o = 0; o < n.length; ++o)
          e[n[o]] != null && (this[n[o]] = e[n[o]]);
    }
    r.prototype.commit = null, r.prototype.highLevelRepresentation = null;
    let a;
    return Object.defineProperty(r.prototype, "_highLevelRepresentation", {
      get: $util.oneOfGetter(a = ["highLevelRepresentation"]),
      set: $util.oneOfSetter(a)
    }), r.create = function(n) {
      return new r(n);
    }, r.encode = function(n, o) {
      return o || (o = $Writer.create()), n.commit != null && Object.hasOwnProperty.call(n, "commit") && $root.data_room.ConfigurationCommit.encode(n.commit, o.uint32(
        /* id 1, wireType 2 =*/
        10
      ).fork()).ldelim(), n.highLevelRepresentation != null && Object.hasOwnProperty.call(n, "highLevelRepresentation") && o.uint32(
        /* id 2, wireType 2 =*/
        18
      ).bytes(n.highLevelRepresentation), o;
    }, r.encodeDelimited = function(n, o) {
      return this.encode(n, o).ldelim();
    }, r.decode = function(n, o) {
      n instanceof $Reader || (n = $Reader.create(n));
      let c = o === void 0 ? n.len : n.pos + o, l = new $root.gcg.RetrieveConfigurationCommitResponse();
      for (; n.pos < c; ) {
        let d = n.uint32();
        switch (d >>> 3) {
          case 1: {
            l.commit = $root.data_room.ConfigurationCommit.decode(n, n.uint32());
            break;
          }
          case 2: {
            l.highLevelRepresentation = n.bytes();
            break;
          }
          default:
            n.skipType(d & 7);
            break;
        }
      }
      return l;
    }, r.decodeDelimited = function(n) {
      return n instanceof $Reader || (n = new $Reader(n)), this.decode(n, n.uint32());
    }, r.verify = function(n) {
      if (typeof n != "object" || n === null)
        return "object expected";
      if (n.commit != null && n.hasOwnProperty("commit")) {
        let o = $root.data_room.ConfigurationCommit.verify(n.commit);
        if (o)
          return "commit." + o;
      }
      return n.highLevelRepresentation != null && n.hasOwnProperty("highLevelRepresentation") && !(n.highLevelRepresentation && typeof n.highLevelRepresentation.length == "number" || $util.isString(n.highLevelRepresentation)) ? "highLevelRepresentation: buffer expected" : null;
    }, r.fromObject = function(n) {
      if (n instanceof $root.gcg.RetrieveConfigurationCommitResponse)
        return n;
      let o = new $root.gcg.RetrieveConfigurationCommitResponse();
      if (n.commit != null) {
        if (typeof n.commit != "object")
          throw TypeError(".gcg.RetrieveConfigurationCommitResponse.commit: object expected");
        o.commit = $root.data_room.ConfigurationCommit.fromObject(n.commit);
      }
      return n.highLevelRepresentation != null && (typeof n.highLevelRepresentation == "string" ? $util.base64.decode(n.highLevelRepresentation, o.highLevelRepresentation = $util.newBuffer($util.base64.length(n.highLevelRepresentation)), 0) : n.highLevelRepresentation.length >= 0 && (o.highLevelRepresentation = n.highLevelRepresentation)), o;
    }, r.toObject = function(n, o) {
      o || (o = {});
      let c = {};
      return o.defaults && (c.commit = null), n.commit != null && n.hasOwnProperty("commit") && (c.commit = $root.data_room.ConfigurationCommit.toObject(n.commit, o)), n.highLevelRepresentation != null && n.hasOwnProperty("highLevelRepresentation") && (c.highLevelRepresentation = o.bytes === String ? $util.base64.encode(n.highLevelRepresentation, 0, n.highLevelRepresentation.length) : o.bytes === Array ? Array.prototype.slice.call(n.highLevelRepresentation) : n.highLevelRepresentation, o.oneofs && (c._highLevelRepresentation = "highLevelRepresentation")), c;
    }, r.prototype.toJSON = function() {
      return this.constructor.toObject(this, minimal.util.toJSONOptions);
    }, r.getTypeUrl = function(n) {
      return n === void 0 && (n = "type.googleapis.com"), n + "/gcg.RetrieveConfigurationCommitResponse";
    }, r;
  }(), u.CasAuxiliaryStateRequest = function() {
    function r(e) {
      if (e)
        for (let n = Object.keys(e), o = 0; o < n.length; ++o)
          e[n[o]] != null && (this[n[o]] = e[n[o]]);
    }
    r.prototype.dataRoomId = $util.newBuffer([]), r.prototype.index = $util.Long ? $util.Long.fromBits(0, 0, !0) : 0, r.prototype.value = null;
    let a;
    return Object.defineProperty(r.prototype, "_value", {
      get: $util.oneOfGetter(a = ["value"]),
      set: $util.oneOfSetter(a)
    }), r.create = function(n) {
      return new r(n);
    }, r.encode = function(n, o) {
      return o || (o = $Writer.create()), n.dataRoomId != null && Object.hasOwnProperty.call(n, "dataRoomId") && o.uint32(
        /* id 1, wireType 2 =*/
        10
      ).bytes(n.dataRoomId), n.index != null && Object.hasOwnProperty.call(n, "index") && o.uint32(
        /* id 2, wireType 0 =*/
        16
      ).uint64(n.index), n.value != null && Object.hasOwnProperty.call(n, "value") && o.uint32(
        /* id 3, wireType 2 =*/
        26
      ).bytes(n.value), o;
    }, r.encodeDelimited = function(n, o) {
      return this.encode(n, o).ldelim();
    }, r.decode = function(n, o) {
      n instanceof $Reader || (n = $Reader.create(n));
      let c = o === void 0 ? n.len : n.pos + o, l = new $root.gcg.CasAuxiliaryStateRequest();
      for (; n.pos < c; ) {
        let d = n.uint32();
        switch (d >>> 3) {
          case 1: {
            l.dataRoomId = n.bytes();
            break;
          }
          case 2: {
            l.index = n.uint64();
            break;
          }
          case 3: {
            l.value = n.bytes();
            break;
          }
          default:
            n.skipType(d & 7);
            break;
        }
      }
      return l;
    }, r.decodeDelimited = function(n) {
      return n instanceof $Reader || (n = new $Reader(n)), this.decode(n, n.uint32());
    }, r.verify = function(n) {
      return typeof n != "object" || n === null ? "object expected" : n.dataRoomId != null && n.hasOwnProperty("dataRoomId") && !(n.dataRoomId && typeof n.dataRoomId.length == "number" || $util.isString(n.dataRoomId)) ? "dataRoomId: buffer expected" : n.index != null && n.hasOwnProperty("index") && !$util.isInteger(n.index) && !(n.index && $util.isInteger(n.index.low) && $util.isInteger(n.index.high)) ? "index: integer|Long expected" : n.value != null && n.hasOwnProperty("value") && !(n.value && typeof n.value.length == "number" || $util.isString(n.value)) ? "value: buffer expected" : null;
    }, r.fromObject = function(n) {
      if (n instanceof $root.gcg.CasAuxiliaryStateRequest)
        return n;
      let o = new $root.gcg.CasAuxiliaryStateRequest();
      return n.dataRoomId != null && (typeof n.dataRoomId == "string" ? $util.base64.decode(n.dataRoomId, o.dataRoomId = $util.newBuffer($util.base64.length(n.dataRoomId)), 0) : n.dataRoomId.length >= 0 && (o.dataRoomId = n.dataRoomId)), n.index != null && ($util.Long ? (o.index = $util.Long.fromValue(n.index)).unsigned = !0 : typeof n.index == "string" ? o.index = parseInt(n.index, 10) : typeof n.index == "number" ? o.index = n.index : typeof n.index == "object" && (o.index = new $util.LongBits(n.index.low >>> 0, n.index.high >>> 0).toNumber(!0))), n.value != null && (typeof n.value == "string" ? $util.base64.decode(n.value, o.value = $util.newBuffer($util.base64.length(n.value)), 0) : n.value.length >= 0 && (o.value = n.value)), o;
    }, r.toObject = function(n, o) {
      o || (o = {});
      let c = {};
      if (o.defaults)
        if (o.bytes === String ? c.dataRoomId = "" : (c.dataRoomId = [], o.bytes !== Array && (c.dataRoomId = $util.newBuffer(c.dataRoomId))), $util.Long) {
          let l = new $util.Long(0, 0, !0);
          c.index = o.longs === String ? l.toString() : o.longs === Number ? l.toNumber() : l;
        } else
          c.index = o.longs === String ? "0" : 0;
      return n.dataRoomId != null && n.hasOwnProperty("dataRoomId") && (c.dataRoomId = o.bytes === String ? $util.base64.encode(n.dataRoomId, 0, n.dataRoomId.length) : o.bytes === Array ? Array.prototype.slice.call(n.dataRoomId) : n.dataRoomId), n.index != null && n.hasOwnProperty("index") && (typeof n.index == "number" ? c.index = o.longs === String ? String(n.index) : n.index : c.index = o.longs === String ? $util.Long.prototype.toString.call(n.index) : o.longs === Number ? new $util.LongBits(n.index.low >>> 0, n.index.high >>> 0).toNumber(!0) : n.index), n.value != null && n.hasOwnProperty("value") && (c.value = o.bytes === String ? $util.base64.encode(n.value, 0, n.value.length) : o.bytes === Array ? Array.prototype.slice.call(n.value) : n.value, o.oneofs && (c._value = "value")), c;
    }, r.prototype.toJSON = function() {
      return this.constructor.toObject(this, minimal.util.toJSONOptions);
    }, r.getTypeUrl = function(n) {
      return n === void 0 && (n = "type.googleapis.com"), n + "/gcg.CasAuxiliaryStateRequest";
    }, r;
  }(), u.CasAuxiliaryStateResponse = function() {
    function r(e) {
      if (e)
        for (let n = Object.keys(e), o = 0; o < n.length; ++o)
          e[n[o]] != null && (this[n[o]] = e[n[o]]);
    }
    r.prototype.success = !1, r.prototype.index = $util.Long ? $util.Long.fromBits(0, 0, !0) : 0, r.prototype.value = null;
    let a;
    return Object.defineProperty(r.prototype, "_value", {
      get: $util.oneOfGetter(a = ["value"]),
      set: $util.oneOfSetter(a)
    }), r.create = function(n) {
      return new r(n);
    }, r.encode = function(n, o) {
      return o || (o = $Writer.create()), n.success != null && Object.hasOwnProperty.call(n, "success") && o.uint32(
        /* id 1, wireType 0 =*/
        8
      ).bool(n.success), n.index != null && Object.hasOwnProperty.call(n, "index") && o.uint32(
        /* id 2, wireType 0 =*/
        16
      ).uint64(n.index), n.value != null && Object.hasOwnProperty.call(n, "value") && o.uint32(
        /* id 3, wireType 2 =*/
        26
      ).bytes(n.value), o;
    }, r.encodeDelimited = function(n, o) {
      return this.encode(n, o).ldelim();
    }, r.decode = function(n, o) {
      n instanceof $Reader || (n = $Reader.create(n));
      let c = o === void 0 ? n.len : n.pos + o, l = new $root.gcg.CasAuxiliaryStateResponse();
      for (; n.pos < c; ) {
        let d = n.uint32();
        switch (d >>> 3) {
          case 1: {
            l.success = n.bool();
            break;
          }
          case 2: {
            l.index = n.uint64();
            break;
          }
          case 3: {
            l.value = n.bytes();
            break;
          }
          default:
            n.skipType(d & 7);
            break;
        }
      }
      return l;
    }, r.decodeDelimited = function(n) {
      return n instanceof $Reader || (n = new $Reader(n)), this.decode(n, n.uint32());
    }, r.verify = function(n) {
      return typeof n != "object" || n === null ? "object expected" : n.success != null && n.hasOwnProperty("success") && typeof n.success != "boolean" ? "success: boolean expected" : n.index != null && n.hasOwnProperty("index") && !$util.isInteger(n.index) && !(n.index && $util.isInteger(n.index.low) && $util.isInteger(n.index.high)) ? "index: integer|Long expected" : n.value != null && n.hasOwnProperty("value") && !(n.value && typeof n.value.length == "number" || $util.isString(n.value)) ? "value: buffer expected" : null;
    }, r.fromObject = function(n) {
      if (n instanceof $root.gcg.CasAuxiliaryStateResponse)
        return n;
      let o = new $root.gcg.CasAuxiliaryStateResponse();
      return n.success != null && (o.success = !!n.success), n.index != null && ($util.Long ? (o.index = $util.Long.fromValue(n.index)).unsigned = !0 : typeof n.index == "string" ? o.index = parseInt(n.index, 10) : typeof n.index == "number" ? o.index = n.index : typeof n.index == "object" && (o.index = new $util.LongBits(n.index.low >>> 0, n.index.high >>> 0).toNumber(!0))), n.value != null && (typeof n.value == "string" ? $util.base64.decode(n.value, o.value = $util.newBuffer($util.base64.length(n.value)), 0) : n.value.length >= 0 && (o.value = n.value)), o;
    }, r.toObject = function(n, o) {
      o || (o = {});
      let c = {};
      if (o.defaults)
        if (c.success = !1, $util.Long) {
          let l = new $util.Long(0, 0, !0);
          c.index = o.longs === String ? l.toString() : o.longs === Number ? l.toNumber() : l;
        } else
          c.index = o.longs === String ? "0" : 0;
      return n.success != null && n.hasOwnProperty("success") && (c.success = n.success), n.index != null && n.hasOwnProperty("index") && (typeof n.index == "number" ? c.index = o.longs === String ? String(n.index) : n.index : c.index = o.longs === String ? $util.Long.prototype.toString.call(n.index) : o.longs === Number ? new $util.LongBits(n.index.low >>> 0, n.index.high >>> 0).toNumber(!0) : n.index), n.value != null && n.hasOwnProperty("value") && (c.value = o.bytes === String ? $util.base64.encode(n.value, 0, n.value.length) : o.bytes === Array ? Array.prototype.slice.call(n.value) : n.value, o.oneofs && (c._value = "value")), c;
    }, r.prototype.toJSON = function() {
      return this.constructor.toObject(this, minimal.util.toJSONOptions);
    }, r.getTypeUrl = function(n) {
      return n === void 0 && (n = "type.googleapis.com"), n + "/gcg.CasAuxiliaryStateResponse";
    }, r;
  }(), u.ReadAuxiliaryStateRequest = function() {
    function r(a) {
      if (a)
        for (let e = Object.keys(a), n = 0; n < e.length; ++n)
          a[e[n]] != null && (this[e[n]] = a[e[n]]);
    }
    return r.prototype.dataRoomId = $util.newBuffer([]), r.create = function(e) {
      return new r(e);
    }, r.encode = function(e, n) {
      return n || (n = $Writer.create()), e.dataRoomId != null && Object.hasOwnProperty.call(e, "dataRoomId") && n.uint32(
        /* id 1, wireType 2 =*/
        10
      ).bytes(e.dataRoomId), n;
    }, r.encodeDelimited = function(e, n) {
      return this.encode(e, n).ldelim();
    }, r.decode = function(e, n) {
      e instanceof $Reader || (e = $Reader.create(e));
      let o = n === void 0 ? e.len : e.pos + n, c = new $root.gcg.ReadAuxiliaryStateRequest();
      for (; e.pos < o; ) {
        let l = e.uint32();
        switch (l >>> 3) {
          case 1: {
            c.dataRoomId = e.bytes();
            break;
          }
          default:
            e.skipType(l & 7);
            break;
        }
      }
      return c;
    }, r.decodeDelimited = function(e) {
      return e instanceof $Reader || (e = new $Reader(e)), this.decode(e, e.uint32());
    }, r.verify = function(e) {
      return typeof e != "object" || e === null ? "object expected" : e.dataRoomId != null && e.hasOwnProperty("dataRoomId") && !(e.dataRoomId && typeof e.dataRoomId.length == "number" || $util.isString(e.dataRoomId)) ? "dataRoomId: buffer expected" : null;
    }, r.fromObject = function(e) {
      if (e instanceof $root.gcg.ReadAuxiliaryStateRequest)
        return e;
      let n = new $root.gcg.ReadAuxiliaryStateRequest();
      return e.dataRoomId != null && (typeof e.dataRoomId == "string" ? $util.base64.decode(e.dataRoomId, n.dataRoomId = $util.newBuffer($util.base64.length(e.dataRoomId)), 0) : e.dataRoomId.length >= 0 && (n.dataRoomId = e.dataRoomId)), n;
    }, r.toObject = function(e, n) {
      n || (n = {});
      let o = {};
      return n.defaults && (n.bytes === String ? o.dataRoomId = "" : (o.dataRoomId = [], n.bytes !== Array && (o.dataRoomId = $util.newBuffer(o.dataRoomId)))), e.dataRoomId != null && e.hasOwnProperty("dataRoomId") && (o.dataRoomId = n.bytes === String ? $util.base64.encode(e.dataRoomId, 0, e.dataRoomId.length) : n.bytes === Array ? Array.prototype.slice.call(e.dataRoomId) : e.dataRoomId), o;
    }, r.prototype.toJSON = function() {
      return this.constructor.toObject(this, minimal.util.toJSONOptions);
    }, r.getTypeUrl = function(e) {
      return e === void 0 && (e = "type.googleapis.com"), e + "/gcg.ReadAuxiliaryStateRequest";
    }, r;
  }(), u.ReadAuxiliaryStateResponse = function() {
    function r(a) {
      if (this.values = [], a)
        for (let e = Object.keys(a), n = 0; n < e.length; ++n)
          a[e[n]] != null && (this[e[n]] = a[e[n]]);
    }
    return r.prototype.values = $util.emptyArray, r.create = function(e) {
      return new r(e);
    }, r.encode = function(e, n) {
      if (n || (n = $Writer.create()), e.values != null && e.values.length)
        for (let o = 0; o < e.values.length; ++o)
          $root.gcg.AuxiliaryStateValue.encode(e.values[o], n.uint32(
            /* id 2, wireType 2 =*/
            18
          ).fork()).ldelim();
      return n;
    }, r.encodeDelimited = function(e, n) {
      return this.encode(e, n).ldelim();
    }, r.decode = function(e, n) {
      e instanceof $Reader || (e = $Reader.create(e));
      let o = n === void 0 ? e.len : e.pos + n, c = new $root.gcg.ReadAuxiliaryStateResponse();
      for (; e.pos < o; ) {
        let l = e.uint32();
        switch (l >>> 3) {
          case 2: {
            c.values && c.values.length || (c.values = []), c.values.push($root.gcg.AuxiliaryStateValue.decode(e, e.uint32()));
            break;
          }
          default:
            e.skipType(l & 7);
            break;
        }
      }
      return c;
    }, r.decodeDelimited = function(e) {
      return e instanceof $Reader || (e = new $Reader(e)), this.decode(e, e.uint32());
    }, r.verify = function(e) {
      if (typeof e != "object" || e === null)
        return "object expected";
      if (e.values != null && e.hasOwnProperty("values")) {
        if (!Array.isArray(e.values))
          return "values: array expected";
        for (let n = 0; n < e.values.length; ++n) {
          let o = $root.gcg.AuxiliaryStateValue.verify(e.values[n]);
          if (o)
            return "values." + o;
        }
      }
      return null;
    }, r.fromObject = function(e) {
      if (e instanceof $root.gcg.ReadAuxiliaryStateResponse)
        return e;
      let n = new $root.gcg.ReadAuxiliaryStateResponse();
      if (e.values) {
        if (!Array.isArray(e.values))
          throw TypeError(".gcg.ReadAuxiliaryStateResponse.values: array expected");
        n.values = [];
        for (let o = 0; o < e.values.length; ++o) {
          if (typeof e.values[o] != "object")
            throw TypeError(".gcg.ReadAuxiliaryStateResponse.values: object expected");
          n.values[o] = $root.gcg.AuxiliaryStateValue.fromObject(e.values[o]);
        }
      }
      return n;
    }, r.toObject = function(e, n) {
      n || (n = {});
      let o = {};
      if ((n.arrays || n.defaults) && (o.values = []), e.values && e.values.length) {
        o.values = [];
        for (let c = 0; c < e.values.length; ++c)
          o.values[c] = $root.gcg.AuxiliaryStateValue.toObject(e.values[c], n);
      }
      return o;
    }, r.prototype.toJSON = function() {
      return this.constructor.toObject(this, minimal.util.toJSONOptions);
    }, r.getTypeUrl = function(e) {
      return e === void 0 && (e = "type.googleapis.com"), e + "/gcg.ReadAuxiliaryStateResponse";
    }, r;
  }(), u.AuxiliaryStateValue = function() {
    function r(a) {
      if (a)
        for (let e = Object.keys(a), n = 0; n < e.length; ++n)
          a[e[n]] != null && (this[e[n]] = a[e[n]]);
    }
    return r.prototype.user = "", r.prototype.index = $util.Long ? $util.Long.fromBits(0, 0, !0) : 0, r.prototype.value = $util.newBuffer([]), r.create = function(e) {
      return new r(e);
    }, r.encode = function(e, n) {
      return n || (n = $Writer.create()), e.user != null && Object.hasOwnProperty.call(e, "user") && n.uint32(
        /* id 1, wireType 2 =*/
        10
      ).string(e.user), e.index != null && Object.hasOwnProperty.call(e, "index") && n.uint32(
        /* id 2, wireType 0 =*/
        16
      ).uint64(e.index), e.value != null && Object.hasOwnProperty.call(e, "value") && n.uint32(
        /* id 3, wireType 2 =*/
        26
      ).bytes(e.value), n;
    }, r.encodeDelimited = function(e, n) {
      return this.encode(e, n).ldelim();
    }, r.decode = function(e, n) {
      e instanceof $Reader || (e = $Reader.create(e));
      let o = n === void 0 ? e.len : e.pos + n, c = new $root.gcg.AuxiliaryStateValue();
      for (; e.pos < o; ) {
        let l = e.uint32();
        switch (l >>> 3) {
          case 1: {
            c.user = e.string();
            break;
          }
          case 2: {
            c.index = e.uint64();
            break;
          }
          case 3: {
            c.value = e.bytes();
            break;
          }
          default:
            e.skipType(l & 7);
            break;
        }
      }
      return c;
    }, r.decodeDelimited = function(e) {
      return e instanceof $Reader || (e = new $Reader(e)), this.decode(e, e.uint32());
    }, r.verify = function(e) {
      return typeof e != "object" || e === null ? "object expected" : e.user != null && e.hasOwnProperty("user") && !$util.isString(e.user) ? "user: string expected" : e.index != null && e.hasOwnProperty("index") && !$util.isInteger(e.index) && !(e.index && $util.isInteger(e.index.low) && $util.isInteger(e.index.high)) ? "index: integer|Long expected" : e.value != null && e.hasOwnProperty("value") && !(e.value && typeof e.value.length == "number" || $util.isString(e.value)) ? "value: buffer expected" : null;
    }, r.fromObject = function(e) {
      if (e instanceof $root.gcg.AuxiliaryStateValue)
        return e;
      let n = new $root.gcg.AuxiliaryStateValue();
      return e.user != null && (n.user = String(e.user)), e.index != null && ($util.Long ? (n.index = $util.Long.fromValue(e.index)).unsigned = !0 : typeof e.index == "string" ? n.index = parseInt(e.index, 10) : typeof e.index == "number" ? n.index = e.index : typeof e.index == "object" && (n.index = new $util.LongBits(e.index.low >>> 0, e.index.high >>> 0).toNumber(!0))), e.value != null && (typeof e.value == "string" ? $util.base64.decode(e.value, n.value = $util.newBuffer($util.base64.length(e.value)), 0) : e.value.length >= 0 && (n.value = e.value)), n;
    }, r.toObject = function(e, n) {
      n || (n = {});
      let o = {};
      if (n.defaults) {
        if (o.user = "", $util.Long) {
          let c = new $util.Long(0, 0, !0);
          o.index = n.longs === String ? c.toString() : n.longs === Number ? c.toNumber() : c;
        } else
          o.index = n.longs === String ? "0" : 0;
        n.bytes === String ? o.value = "" : (o.value = [], n.bytes !== Array && (o.value = $util.newBuffer(o.value)));
      }
      return e.user != null && e.hasOwnProperty("user") && (o.user = e.user), e.index != null && e.hasOwnProperty("index") && (typeof e.index == "number" ? o.index = n.longs === String ? String(e.index) : e.index : o.index = n.longs === String ? $util.Long.prototype.toString.call(e.index) : n.longs === Number ? new $util.LongBits(e.index.low >>> 0, e.index.high >>> 0).toNumber(!0) : e.index), e.value != null && e.hasOwnProperty("value") && (o.value = n.bytes === String ? $util.base64.encode(e.value, 0, e.value.length) : n.bytes === Array ? Array.prototype.slice.call(e.value) : e.value), o;
    }, r.prototype.toJSON = function() {
      return this.constructor.toObject(this, minimal.util.toJSONOptions);
    }, r.getTypeUrl = function(e) {
      return e === void 0 && (e = "type.googleapis.com"), e + "/gcg.AuxiliaryStateValue";
    }, r;
  }(), u.MergeConfigurationCommitResponse = function() {
    function r(a) {
      if (a)
        for (let e = Object.keys(a), n = 0; n < e.length; ++n)
          a[e[n]] != null && (this[e[n]] = a[e[n]]);
    }
    return r.create = function(e) {
      return new r(e);
    }, r.encode = function(e, n) {
      return n || (n = $Writer.create()), n;
    }, r.encodeDelimited = function(e, n) {
      return this.encode(e, n).ldelim();
    }, r.decode = function(e, n) {
      e instanceof $Reader || (e = $Reader.create(e));
      let o = n === void 0 ? e.len : e.pos + n, c = new $root.gcg.MergeConfigurationCommitResponse();
      for (; e.pos < o; ) {
        let l = e.uint32();
        switch (l >>> 3) {
          default:
            e.skipType(l & 7);
            break;
        }
      }
      return c;
    }, r.decodeDelimited = function(e) {
      return e instanceof $Reader || (e = new $Reader(e)), this.decode(e, e.uint32());
    }, r.verify = function(e) {
      return typeof e != "object" || e === null ? "object expected" : null;
    }, r.fromObject = function(e) {
      return e instanceof $root.gcg.MergeConfigurationCommitResponse ? e : new $root.gcg.MergeConfigurationCommitResponse();
    }, r.toObject = function() {
      return {};
    }, r.prototype.toJSON = function() {
      return this.constructor.toObject(this, minimal.util.toJSONOptions);
    }, r.getTypeUrl = function(e) {
      return e === void 0 && (e = "type.googleapis.com"), e + "/gcg.MergeConfigurationCommitResponse";
    }, r;
  }(), u.DriverTaskConfig = function() {
    function r(e) {
      if (e)
        for (let n = Object.keys(e), o = 0; o < n.length; ++o)
          e[n[o]] != null && (this[n[o]] = e[n[o]]);
    }
    r.prototype.noop = null, r.prototype.staticContent = null;
    let a;
    return Object.defineProperty(r.prototype, "driverTaskConfig", {
      get: $util.oneOfGetter(a = ["noop", "staticContent"]),
      set: $util.oneOfSetter(a)
    }), r.create = function(n) {
      return new r(n);
    }, r.encode = function(n, o) {
      return o || (o = $Writer.create()), n.noop != null && Object.hasOwnProperty.call(n, "noop") && $root.gcg.NoopConfig.encode(n.noop, o.uint32(
        /* id 1, wireType 2 =*/
        10
      ).fork()).ldelim(), n.staticContent != null && Object.hasOwnProperty.call(n, "staticContent") && $root.gcg.StaticContentConfig.encode(n.staticContent, o.uint32(
        /* id 2, wireType 2 =*/
        18
      ).fork()).ldelim(), o;
    }, r.encodeDelimited = function(n, o) {
      return this.encode(n, o).ldelim();
    }, r.decode = function(n, o) {
      n instanceof $Reader || (n = $Reader.create(n));
      let c = o === void 0 ? n.len : n.pos + o, l = new $root.gcg.DriverTaskConfig();
      for (; n.pos < c; ) {
        let d = n.uint32();
        switch (d >>> 3) {
          case 1: {
            l.noop = $root.gcg.NoopConfig.decode(n, n.uint32());
            break;
          }
          case 2: {
            l.staticContent = $root.gcg.StaticContentConfig.decode(n, n.uint32());
            break;
          }
          default:
            n.skipType(d & 7);
            break;
        }
      }
      return l;
    }, r.decodeDelimited = function(n) {
      return n instanceof $Reader || (n = new $Reader(n)), this.decode(n, n.uint32());
    }, r.verify = function(n) {
      if (typeof n != "object" || n === null)
        return "object expected";
      let o = {};
      if (n.noop != null && n.hasOwnProperty("noop")) {
        o.driverTaskConfig = 1;
        {
          let c = $root.gcg.NoopConfig.verify(n.noop);
          if (c)
            return "noop." + c;
        }
      }
      if (n.staticContent != null && n.hasOwnProperty("staticContent")) {
        if (o.driverTaskConfig === 1)
          return "driverTaskConfig: multiple values";
        o.driverTaskConfig = 1;
        {
          let c = $root.gcg.StaticContentConfig.verify(n.staticContent);
          if (c)
            return "staticContent." + c;
        }
      }
      return null;
    }, r.fromObject = function(n) {
      if (n instanceof $root.gcg.DriverTaskConfig)
        return n;
      let o = new $root.gcg.DriverTaskConfig();
      if (n.noop != null) {
        if (typeof n.noop != "object")
          throw TypeError(".gcg.DriverTaskConfig.noop: object expected");
        o.noop = $root.gcg.NoopConfig.fromObject(n.noop);
      }
      if (n.staticContent != null) {
        if (typeof n.staticContent != "object")
          throw TypeError(".gcg.DriverTaskConfig.staticContent: object expected");
        o.staticContent = $root.gcg.StaticContentConfig.fromObject(n.staticContent);
      }
      return o;
    }, r.toObject = function(n, o) {
      o || (o = {});
      let c = {};
      return n.noop != null && n.hasOwnProperty("noop") && (c.noop = $root.gcg.NoopConfig.toObject(n.noop, o), o.oneofs && (c.driverTaskConfig = "noop")), n.staticContent != null && n.hasOwnProperty("staticContent") && (c.staticContent = $root.gcg.StaticContentConfig.toObject(n.staticContent, o), o.oneofs && (c.driverTaskConfig = "staticContent")), c;
    }, r.prototype.toJSON = function() {
      return this.constructor.toObject(this, minimal.util.toJSONOptions);
    }, r.getTypeUrl = function(n) {
      return n === void 0 && (n = "type.googleapis.com"), n + "/gcg.DriverTaskConfig";
    }, r;
  }(), u.NoopConfig = function() {
    function r(a) {
      if (a)
        for (let e = Object.keys(a), n = 0; n < e.length; ++n)
          a[e[n]] != null && (this[e[n]] = a[e[n]]);
    }
    return r.create = function(e) {
      return new r(e);
    }, r.encode = function(e, n) {
      return n || (n = $Writer.create()), n;
    }, r.encodeDelimited = function(e, n) {
      return this.encode(e, n).ldelim();
    }, r.decode = function(e, n) {
      e instanceof $Reader || (e = $Reader.create(e));
      let o = n === void 0 ? e.len : e.pos + n, c = new $root.gcg.NoopConfig();
      for (; e.pos < o; ) {
        let l = e.uint32();
        switch (l >>> 3) {
          default:
            e.skipType(l & 7);
            break;
        }
      }
      return c;
    }, r.decodeDelimited = function(e) {
      return e instanceof $Reader || (e = new $Reader(e)), this.decode(e, e.uint32());
    }, r.verify = function(e) {
      return typeof e != "object" || e === null ? "object expected" : null;
    }, r.fromObject = function(e) {
      return e instanceof $root.gcg.NoopConfig ? e : new $root.gcg.NoopConfig();
    }, r.toObject = function() {
      return {};
    }, r.prototype.toJSON = function() {
      return this.constructor.toObject(this, minimal.util.toJSONOptions);
    }, r.getTypeUrl = function(e) {
      return e === void 0 && (e = "type.googleapis.com"), e + "/gcg.NoopConfig";
    }, r;
  }(), u.StaticContentConfig = function() {
    function r(a) {
      if (a)
        for (let e = Object.keys(a), n = 0; n < e.length; ++n)
          a[e[n]] != null && (this[e[n]] = a[e[n]]);
    }
    return r.prototype.content = $util.newBuffer([]), r.create = function(e) {
      return new r(e);
    }, r.encode = function(e, n) {
      return n || (n = $Writer.create()), e.content != null && Object.hasOwnProperty.call(e, "content") && n.uint32(
        /* id 1, wireType 2 =*/
        10
      ).bytes(e.content), n;
    }, r.encodeDelimited = function(e, n) {
      return this.encode(e, n).ldelim();
    }, r.decode = function(e, n) {
      e instanceof $Reader || (e = $Reader.create(e));
      let o = n === void 0 ? e.len : e.pos + n, c = new $root.gcg.StaticContentConfig();
      for (; e.pos < o; ) {
        let l = e.uint32();
        switch (l >>> 3) {
          case 1: {
            c.content = e.bytes();
            break;
          }
          default:
            e.skipType(l & 7);
            break;
        }
      }
      return c;
    }, r.decodeDelimited = function(e) {
      return e instanceof $Reader || (e = new $Reader(e)), this.decode(e, e.uint32());
    }, r.verify = function(e) {
      return typeof e != "object" || e === null ? "object expected" : e.content != null && e.hasOwnProperty("content") && !(e.content && typeof e.content.length == "number" || $util.isString(e.content)) ? "content: buffer expected" : null;
    }, r.fromObject = function(e) {
      if (e instanceof $root.gcg.StaticContentConfig)
        return e;
      let n = new $root.gcg.StaticContentConfig();
      return e.content != null && (typeof e.content == "string" ? $util.base64.decode(e.content, n.content = $util.newBuffer($util.base64.length(e.content)), 0) : e.content.length >= 0 && (n.content = e.content)), n;
    }, r.toObject = function(e, n) {
      n || (n = {});
      let o = {};
      return n.defaults && (n.bytes === String ? o.content = "" : (o.content = [], n.bytes !== Array && (o.content = $util.newBuffer(o.content)))), e.content != null && e.hasOwnProperty("content") && (o.content = n.bytes === String ? $util.base64.encode(e.content, 0, e.content.length) : n.bytes === Array ? Array.prototype.slice.call(e.content) : e.content), o;
    }, r.prototype.toJSON = function() {
      return this.constructor.toObject(this, minimal.util.toJSONOptions);
    }, r.getTypeUrl = function(e) {
      return e === void 0 && (e = "type.googleapis.com"), e + "/gcg.StaticContentConfig";
    }, r;
  }(), u.RetrieveUsedAirlockQuotaRequest = function() {
    function r(a) {
      if (a)
        for (let e = Object.keys(a), n = 0; n < e.length; ++n)
          a[e[n]] != null && (this[e[n]] = a[e[n]]);
    }
    return r.prototype.dataRoomId = $util.newBuffer([]), r.create = function(e) {
      return new r(e);
    }, r.encode = function(e, n) {
      return n || (n = $Writer.create()), e.dataRoomId != null && Object.hasOwnProperty.call(e, "dataRoomId") && n.uint32(
        /* id 1, wireType 2 =*/
        10
      ).bytes(e.dataRoomId), n;
    }, r.encodeDelimited = function(e, n) {
      return this.encode(e, n).ldelim();
    }, r.decode = function(e, n) {
      e instanceof $Reader || (e = $Reader.create(e));
      let o = n === void 0 ? e.len : e.pos + n, c = new $root.gcg.RetrieveUsedAirlockQuotaRequest();
      for (; e.pos < o; ) {
        let l = e.uint32();
        switch (l >>> 3) {
          case 1: {
            c.dataRoomId = e.bytes();
            break;
          }
          default:
            e.skipType(l & 7);
            break;
        }
      }
      return c;
    }, r.decodeDelimited = function(e) {
      return e instanceof $Reader || (e = new $Reader(e)), this.decode(e, e.uint32());
    }, r.verify = function(e) {
      return typeof e != "object" || e === null ? "object expected" : e.dataRoomId != null && e.hasOwnProperty("dataRoomId") && !(e.dataRoomId && typeof e.dataRoomId.length == "number" || $util.isString(e.dataRoomId)) ? "dataRoomId: buffer expected" : null;
    }, r.fromObject = function(e) {
      if (e instanceof $root.gcg.RetrieveUsedAirlockQuotaRequest)
        return e;
      let n = new $root.gcg.RetrieveUsedAirlockQuotaRequest();
      return e.dataRoomId != null && (typeof e.dataRoomId == "string" ? $util.base64.decode(e.dataRoomId, n.dataRoomId = $util.newBuffer($util.base64.length(e.dataRoomId)), 0) : e.dataRoomId.length >= 0 && (n.dataRoomId = e.dataRoomId)), n;
    }, r.toObject = function(e, n) {
      n || (n = {});
      let o = {};
      return n.defaults && (n.bytes === String ? o.dataRoomId = "" : (o.dataRoomId = [], n.bytes !== Array && (o.dataRoomId = $util.newBuffer(o.dataRoomId)))), e.dataRoomId != null && e.hasOwnProperty("dataRoomId") && (o.dataRoomId = n.bytes === String ? $util.base64.encode(e.dataRoomId, 0, e.dataRoomId.length) : n.bytes === Array ? Array.prototype.slice.call(e.dataRoomId) : e.dataRoomId), o;
    }, r.prototype.toJSON = function() {
      return this.constructor.toObject(this, minimal.util.toJSONOptions);
    }, r.getTypeUrl = function(e) {
      return e === void 0 && (e = "type.googleapis.com"), e + "/gcg.RetrieveUsedAirlockQuotaRequest";
    }, r;
  }(), u.RetrieveUsedAirlockQuotaResponse = function() {
    function r(a) {
      if (this.airlockQuotas = [], a)
        for (let e = Object.keys(a), n = 0; n < e.length; ++n)
          a[e[n]] != null && (this[e[n]] = a[e[n]]);
    }
    return r.prototype.airlockQuotas = $util.emptyArray, r.create = function(e) {
      return new r(e);
    }, r.encode = function(e, n) {
      if (n || (n = $Writer.create()), e.airlockQuotas != null && e.airlockQuotas.length)
        for (let o = 0; o < e.airlockQuotas.length; ++o)
          $root.gcg.AirlockQuotaInfo.encode(e.airlockQuotas[o], n.uint32(
            /* id 1, wireType 2 =*/
            10
          ).fork()).ldelim();
      return n;
    }, r.encodeDelimited = function(e, n) {
      return this.encode(e, n).ldelim();
    }, r.decode = function(e, n) {
      e instanceof $Reader || (e = $Reader.create(e));
      let o = n === void 0 ? e.len : e.pos + n, c = new $root.gcg.RetrieveUsedAirlockQuotaResponse();
      for (; e.pos < o; ) {
        let l = e.uint32();
        switch (l >>> 3) {
          case 1: {
            c.airlockQuotas && c.airlockQuotas.length || (c.airlockQuotas = []), c.airlockQuotas.push($root.gcg.AirlockQuotaInfo.decode(e, e.uint32()));
            break;
          }
          default:
            e.skipType(l & 7);
            break;
        }
      }
      return c;
    }, r.decodeDelimited = function(e) {
      return e instanceof $Reader || (e = new $Reader(e)), this.decode(e, e.uint32());
    }, r.verify = function(e) {
      if (typeof e != "object" || e === null)
        return "object expected";
      if (e.airlockQuotas != null && e.hasOwnProperty("airlockQuotas")) {
        if (!Array.isArray(e.airlockQuotas))
          return "airlockQuotas: array expected";
        for (let n = 0; n < e.airlockQuotas.length; ++n) {
          let o = $root.gcg.AirlockQuotaInfo.verify(e.airlockQuotas[n]);
          if (o)
            return "airlockQuotas." + o;
        }
      }
      return null;
    }, r.fromObject = function(e) {
      if (e instanceof $root.gcg.RetrieveUsedAirlockQuotaResponse)
        return e;
      let n = new $root.gcg.RetrieveUsedAirlockQuotaResponse();
      if (e.airlockQuotas) {
        if (!Array.isArray(e.airlockQuotas))
          throw TypeError(".gcg.RetrieveUsedAirlockQuotaResponse.airlockQuotas: array expected");
        n.airlockQuotas = [];
        for (let o = 0; o < e.airlockQuotas.length; ++o) {
          if (typeof e.airlockQuotas[o] != "object")
            throw TypeError(".gcg.RetrieveUsedAirlockQuotaResponse.airlockQuotas: object expected");
          n.airlockQuotas[o] = $root.gcg.AirlockQuotaInfo.fromObject(e.airlockQuotas[o]);
        }
      }
      return n;
    }, r.toObject = function(e, n) {
      n || (n = {});
      let o = {};
      if ((n.arrays || n.defaults) && (o.airlockQuotas = []), e.airlockQuotas && e.airlockQuotas.length) {
        o.airlockQuotas = [];
        for (let c = 0; c < e.airlockQuotas.length; ++c)
          o.airlockQuotas[c] = $root.gcg.AirlockQuotaInfo.toObject(e.airlockQuotas[c], n);
      }
      return o;
    }, r.prototype.toJSON = function() {
      return this.constructor.toObject(this, minimal.util.toJSONOptions);
    }, r.getTypeUrl = function(e) {
      return e === void 0 && (e = "type.googleapis.com"), e + "/gcg.RetrieveUsedAirlockQuotaResponse";
    }, r;
  }(), u.AirlockQuotaInfo = function() {
    function r(a) {
      if (a)
        for (let e = Object.keys(a), n = 0; n < e.length; ++n)
          a[e[n]] != null && (this[e[n]] = a[e[n]]);
    }
    return r.prototype.airlockNodeId = "", r.prototype.quotaBytes = $util.Long ? $util.Long.fromBits(0, 0, !0) : 0, r.prototype.usedQuotaBytes = $util.Long ? $util.Long.fromBits(0, 0, !0) : 0, r.create = function(e) {
      return new r(e);
    }, r.encode = function(e, n) {
      return n || (n = $Writer.create()), e.airlockNodeId != null && Object.hasOwnProperty.call(e, "airlockNodeId") && n.uint32(
        /* id 1, wireType 2 =*/
        10
      ).string(e.airlockNodeId), e.quotaBytes != null && Object.hasOwnProperty.call(e, "quotaBytes") && n.uint32(
        /* id 2, wireType 0 =*/
        16
      ).uint64(e.quotaBytes), e.usedQuotaBytes != null && Object.hasOwnProperty.call(e, "usedQuotaBytes") && n.uint32(
        /* id 3, wireType 0 =*/
        24
      ).uint64(e.usedQuotaBytes), n;
    }, r.encodeDelimited = function(e, n) {
      return this.encode(e, n).ldelim();
    }, r.decode = function(e, n) {
      e instanceof $Reader || (e = $Reader.create(e));
      let o = n === void 0 ? e.len : e.pos + n, c = new $root.gcg.AirlockQuotaInfo();
      for (; e.pos < o; ) {
        let l = e.uint32();
        switch (l >>> 3) {
          case 1: {
            c.airlockNodeId = e.string();
            break;
          }
          case 2: {
            c.quotaBytes = e.uint64();
            break;
          }
          case 3: {
            c.usedQuotaBytes = e.uint64();
            break;
          }
          default:
            e.skipType(l & 7);
            break;
        }
      }
      return c;
    }, r.decodeDelimited = function(e) {
      return e instanceof $Reader || (e = new $Reader(e)), this.decode(e, e.uint32());
    }, r.verify = function(e) {
      return typeof e != "object" || e === null ? "object expected" : e.airlockNodeId != null && e.hasOwnProperty("airlockNodeId") && !$util.isString(e.airlockNodeId) ? "airlockNodeId: string expected" : e.quotaBytes != null && e.hasOwnProperty("quotaBytes") && !$util.isInteger(e.quotaBytes) && !(e.quotaBytes && $util.isInteger(e.quotaBytes.low) && $util.isInteger(e.quotaBytes.high)) ? "quotaBytes: integer|Long expected" : e.usedQuotaBytes != null && e.hasOwnProperty("usedQuotaBytes") && !$util.isInteger(e.usedQuotaBytes) && !(e.usedQuotaBytes && $util.isInteger(e.usedQuotaBytes.low) && $util.isInteger(e.usedQuotaBytes.high)) ? "usedQuotaBytes: integer|Long expected" : null;
    }, r.fromObject = function(e) {
      if (e instanceof $root.gcg.AirlockQuotaInfo)
        return e;
      let n = new $root.gcg.AirlockQuotaInfo();
      return e.airlockNodeId != null && (n.airlockNodeId = String(e.airlockNodeId)), e.quotaBytes != null && ($util.Long ? (n.quotaBytes = $util.Long.fromValue(e.quotaBytes)).unsigned = !0 : typeof e.quotaBytes == "string" ? n.quotaBytes = parseInt(e.quotaBytes, 10) : typeof e.quotaBytes == "number" ? n.quotaBytes = e.quotaBytes : typeof e.quotaBytes == "object" && (n.quotaBytes = new $util.LongBits(e.quotaBytes.low >>> 0, e.quotaBytes.high >>> 0).toNumber(!0))), e.usedQuotaBytes != null && ($util.Long ? (n.usedQuotaBytes = $util.Long.fromValue(e.usedQuotaBytes)).unsigned = !0 : typeof e.usedQuotaBytes == "string" ? n.usedQuotaBytes = parseInt(e.usedQuotaBytes, 10) : typeof e.usedQuotaBytes == "number" ? n.usedQuotaBytes = e.usedQuotaBytes : typeof e.usedQuotaBytes == "object" && (n.usedQuotaBytes = new $util.LongBits(e.usedQuotaBytes.low >>> 0, e.usedQuotaBytes.high >>> 0).toNumber(!0))), n;
    }, r.toObject = function(e, n) {
      n || (n = {});
      let o = {};
      if (n.defaults) {
        if (o.airlockNodeId = "", $util.Long) {
          let c = new $util.Long(0, 0, !0);
          o.quotaBytes = n.longs === String ? c.toString() : n.longs === Number ? c.toNumber() : c;
        } else
          o.quotaBytes = n.longs === String ? "0" : 0;
        if ($util.Long) {
          let c = new $util.Long(0, 0, !0);
          o.usedQuotaBytes = n.longs === String ? c.toString() : n.longs === Number ? c.toNumber() : c;
        } else
          o.usedQuotaBytes = n.longs === String ? "0" : 0;
      }
      return e.airlockNodeId != null && e.hasOwnProperty("airlockNodeId") && (o.airlockNodeId = e.airlockNodeId), e.quotaBytes != null && e.hasOwnProperty("quotaBytes") && (typeof e.quotaBytes == "number" ? o.quotaBytes = n.longs === String ? String(e.quotaBytes) : e.quotaBytes : o.quotaBytes = n.longs === String ? $util.Long.prototype.toString.call(e.quotaBytes) : n.longs === Number ? new $util.LongBits(e.quotaBytes.low >>> 0, e.quotaBytes.high >>> 0).toNumber(!0) : e.quotaBytes), e.usedQuotaBytes != null && e.hasOwnProperty("usedQuotaBytes") && (typeof e.usedQuotaBytes == "number" ? o.usedQuotaBytes = n.longs === String ? String(e.usedQuotaBytes) : e.usedQuotaBytes : o.usedQuotaBytes = n.longs === String ? $util.Long.prototype.toString.call(e.usedQuotaBytes) : n.longs === Number ? new $util.LongBits(e.usedQuotaBytes.low >>> 0, e.usedQuotaBytes.high >>> 0).toNumber(!0) : e.usedQuotaBytes), o;
    }, r.prototype.toJSON = function() {
      return this.constructor.toObject(this, minimal.util.toJSONOptions);
    }, r.getTypeUrl = function(e) {
      return e === void 0 && (e = "type.googleapis.com"), e + "/gcg.AirlockQuotaInfo";
    }, r;
  }(), u.GetResultsSizeResponse = function() {
    function r(a) {
      if (a)
        for (let e = Object.keys(a), n = 0; n < e.length; ++n)
          a[e[n]] != null && (this[e[n]] = a[e[n]]);
    }
    return r.prototype.sizeBytes = $util.Long ? $util.Long.fromBits(0, 0, !0) : 0, r.create = function(e) {
      return new r(e);
    }, r.encode = function(e, n) {
      return n || (n = $Writer.create()), e.sizeBytes != null && Object.hasOwnProperty.call(e, "sizeBytes") && n.uint32(
        /* id 1, wireType 0 =*/
        8
      ).uint64(e.sizeBytes), n;
    }, r.encodeDelimited = function(e, n) {
      return this.encode(e, n).ldelim();
    }, r.decode = function(e, n) {
      e instanceof $Reader || (e = $Reader.create(e));
      let o = n === void 0 ? e.len : e.pos + n, c = new $root.gcg.GetResultsSizeResponse();
      for (; e.pos < o; ) {
        let l = e.uint32();
        switch (l >>> 3) {
          case 1: {
            c.sizeBytes = e.uint64();
            break;
          }
          default:
            e.skipType(l & 7);
            break;
        }
      }
      return c;
    }, r.decodeDelimited = function(e) {
      return e instanceof $Reader || (e = new $Reader(e)), this.decode(e, e.uint32());
    }, r.verify = function(e) {
      return typeof e != "object" || e === null ? "object expected" : e.sizeBytes != null && e.hasOwnProperty("sizeBytes") && !$util.isInteger(e.sizeBytes) && !(e.sizeBytes && $util.isInteger(e.sizeBytes.low) && $util.isInteger(e.sizeBytes.high)) ? "sizeBytes: integer|Long expected" : null;
    }, r.fromObject = function(e) {
      if (e instanceof $root.gcg.GetResultsSizeResponse)
        return e;
      let n = new $root.gcg.GetResultsSizeResponse();
      return e.sizeBytes != null && ($util.Long ? (n.sizeBytes = $util.Long.fromValue(e.sizeBytes)).unsigned = !0 : typeof e.sizeBytes == "string" ? n.sizeBytes = parseInt(e.sizeBytes, 10) : typeof e.sizeBytes == "number" ? n.sizeBytes = e.sizeBytes : typeof e.sizeBytes == "object" && (n.sizeBytes = new $util.LongBits(e.sizeBytes.low >>> 0, e.sizeBytes.high >>> 0).toNumber(!0))), n;
    }, r.toObject = function(e, n) {
      n || (n = {});
      let o = {};
      if (n.defaults)
        if ($util.Long) {
          let c = new $util.Long(0, 0, !0);
          o.sizeBytes = n.longs === String ? c.toString() : n.longs === Number ? c.toNumber() : c;
        } else
          o.sizeBytes = n.longs === String ? "0" : 0;
      return e.sizeBytes != null && e.hasOwnProperty("sizeBytes") && (typeof e.sizeBytes == "number" ? o.sizeBytes = n.longs === String ? String(e.sizeBytes) : e.sizeBytes : o.sizeBytes = n.longs === String ? $util.Long.prototype.toString.call(e.sizeBytes) : n.longs === Number ? new $util.LongBits(e.sizeBytes.low >>> 0, e.sizeBytes.high >>> 0).toNumber(!0) : e.sizeBytes), o;
    }, r.prototype.toJSON = function() {
      return this.constructor.toObject(this, minimal.util.toJSONOptions);
    }, r.getTypeUrl = function(e) {
      return e === void 0 && (e = "type.googleapis.com"), e + "/gcg.GetResultsSizeResponse";
    }, r;
  }(), u.GcgRequestV2 = function() {
    function r(e) {
      if (e)
        for (let n = Object.keys(e), o = 0; o < n.length; ++o)
          e[n[o]] != null && (this[n[o]] = e[n[o]]);
    }
    r.prototype.unauthenticated = null, r.prototype.authenticated = null;
    let a;
    return Object.defineProperty(r.prototype, "request", {
      get: $util.oneOfGetter(a = ["unauthenticated", "authenticated"]),
      set: $util.oneOfSetter(a)
    }), r.create = function(n) {
      return new r(n);
    }, r.encode = function(n, o) {
      return o || (o = $Writer.create()), n.unauthenticated != null && Object.hasOwnProperty.call(n, "unauthenticated") && $root.gcg.UnauthenticatedRequest.encode(n.unauthenticated, o.uint32(
        /* id 1, wireType 2 =*/
        10
      ).fork()).ldelim(), n.authenticated != null && Object.hasOwnProperty.call(n, "authenticated") && $root.gcg.AuthenticatedRequest.encode(n.authenticated, o.uint32(
        /* id 2, wireType 2 =*/
        18
      ).fork()).ldelim(), o;
    }, r.encodeDelimited = function(n, o) {
      return this.encode(n, o).ldelim();
    }, r.decode = function(n, o) {
      n instanceof $Reader || (n = $Reader.create(n));
      let c = o === void 0 ? n.len : n.pos + o, l = new $root.gcg.GcgRequestV2();
      for (; n.pos < c; ) {
        let d = n.uint32();
        switch (d >>> 3) {
          case 1: {
            l.unauthenticated = $root.gcg.UnauthenticatedRequest.decode(n, n.uint32());
            break;
          }
          case 2: {
            l.authenticated = $root.gcg.AuthenticatedRequest.decode(n, n.uint32());
            break;
          }
          default:
            n.skipType(d & 7);
            break;
        }
      }
      return l;
    }, r.decodeDelimited = function(n) {
      return n instanceof $Reader || (n = new $Reader(n)), this.decode(n, n.uint32());
    }, r.verify = function(n) {
      if (typeof n != "object" || n === null)
        return "object expected";
      let o = {};
      if (n.unauthenticated != null && n.hasOwnProperty("unauthenticated")) {
        o.request = 1;
        {
          let c = $root.gcg.UnauthenticatedRequest.verify(n.unauthenticated);
          if (c)
            return "unauthenticated." + c;
        }
      }
      if (n.authenticated != null && n.hasOwnProperty("authenticated")) {
        if (o.request === 1)
          return "request: multiple values";
        o.request = 1;
        {
          let c = $root.gcg.AuthenticatedRequest.verify(n.authenticated);
          if (c)
            return "authenticated." + c;
        }
      }
      return null;
    }, r.fromObject = function(n) {
      if (n instanceof $root.gcg.GcgRequestV2)
        return n;
      let o = new $root.gcg.GcgRequestV2();
      if (n.unauthenticated != null) {
        if (typeof n.unauthenticated != "object")
          throw TypeError(".gcg.GcgRequestV2.unauthenticated: object expected");
        o.unauthenticated = $root.gcg.UnauthenticatedRequest.fromObject(n.unauthenticated);
      }
      if (n.authenticated != null) {
        if (typeof n.authenticated != "object")
          throw TypeError(".gcg.GcgRequestV2.authenticated: object expected");
        o.authenticated = $root.gcg.AuthenticatedRequest.fromObject(n.authenticated);
      }
      return o;
    }, r.toObject = function(n, o) {
      o || (o = {});
      let c = {};
      return n.unauthenticated != null && n.hasOwnProperty("unauthenticated") && (c.unauthenticated = $root.gcg.UnauthenticatedRequest.toObject(n.unauthenticated, o), o.oneofs && (c.request = "unauthenticated")), n.authenticated != null && n.hasOwnProperty("authenticated") && (c.authenticated = $root.gcg.AuthenticatedRequest.toObject(n.authenticated, o), o.oneofs && (c.request = "authenticated")), c;
    }, r.prototype.toJSON = function() {
      return this.constructor.toObject(this, minimal.util.toJSONOptions);
    }, r.getTypeUrl = function(n) {
      return n === void 0 && (n = "type.googleapis.com"), n + "/gcg.GcgRequestV2";
    }, r;
  }(), u.AuthenticatedRequest = function() {
    function r(e) {
      if (e)
        for (let n = Object.keys(e), o = 0; o < n.length; ++o)
          e[n[o]] != null && (this[n[o]] = e[n[o]]);
    }
    r.prototype.accessToken = null, r.prototype.apiToken = null, r.prototype.createPolicy = null, r.prototype.secretStore = null, r.prototype.getVerificationKey = null, r.prototype.dcrAction = null, r.prototype.createApiToken = null, r.prototype.getApiTokens = null, r.prototype.deleteApiToken = null, r.prototype.retrieveResultEncryptionKey = null, r.prototype.exportResultAsDataset = null;
    let a;
    return Object.defineProperty(r.prototype, "token", {
      get: $util.oneOfGetter(a = ["accessToken", "apiToken"]),
      set: $util.oneOfSetter(a)
    }), Object.defineProperty(r.prototype, "request", {
      get: $util.oneOfGetter(a = ["createPolicy", "secretStore", "getVerificationKey", "dcrAction", "createApiToken", "getApiTokens", "deleteApiToken", "retrieveResultEncryptionKey", "exportResultAsDataset"]),
      set: $util.oneOfSetter(a)
    }), r.create = function(n) {
      return new r(n);
    }, r.encode = function(n, o) {
      return o || (o = $Writer.create()), n.accessToken != null && Object.hasOwnProperty.call(n, "accessToken") && o.uint32(
        /* id 1, wireType 2 =*/
        10
      ).string(n.accessToken), n.apiToken != null && Object.hasOwnProperty.call(n, "apiToken") && o.uint32(
        /* id 2, wireType 2 =*/
        18
      ).string(n.apiToken), n.createPolicy != null && Object.hasOwnProperty.call(n, "createPolicy") && $root.gcg.CreatePolicyRequest.encode(n.createPolicy, o.uint32(
        /* id 3, wireType 2 =*/
        26
      ).fork()).ldelim(), n.secretStore != null && Object.hasOwnProperty.call(n, "secretStore") && $root.secret_store_api.SecretStoreRequest.encode(n.secretStore, o.uint32(
        /* id 4, wireType 2 =*/
        34
      ).fork()).ldelim(), n.getVerificationKey != null && Object.hasOwnProperty.call(n, "getVerificationKey") && $root.gcg.GetVerificationKeyRequest.encode(n.getVerificationKey, o.uint32(
        /* id 6, wireType 2 =*/
        50
      ).fork()).ldelim(), n.dcrAction != null && Object.hasOwnProperty.call(n, "dcrAction") && $root.gcg.DcrActionRequest.encode(n.dcrAction, o.uint32(
        /* id 7, wireType 2 =*/
        58
      ).fork()).ldelim(), n.createApiToken != null && Object.hasOwnProperty.call(n, "createApiToken") && $root.gcg.CreateApiTokenRequest.encode(n.createApiToken, o.uint32(
        /* id 8, wireType 2 =*/
        66
      ).fork()).ldelim(), n.getApiTokens != null && Object.hasOwnProperty.call(n, "getApiTokens") && $root.gcg.GetApiTokensRequest.encode(n.getApiTokens, o.uint32(
        /* id 9, wireType 2 =*/
        74
      ).fork()).ldelim(), n.deleteApiToken != null && Object.hasOwnProperty.call(n, "deleteApiToken") && $root.gcg.DeleteApiTokenRequest.encode(n.deleteApiToken, o.uint32(
        /* id 10, wireType 2 =*/
        82
      ).fork()).ldelim(), n.retrieveResultEncryptionKey != null && Object.hasOwnProperty.call(n, "retrieveResultEncryptionKey") && $root.gcg.RetrieveResultEncryptionKeyRequest.encode(n.retrieveResultEncryptionKey, o.uint32(
        /* id 11, wireType 2 =*/
        90
      ).fork()).ldelim(), n.exportResultAsDataset != null && Object.hasOwnProperty.call(n, "exportResultAsDataset") && $root.gcg.ExportResultAsDatasetRequest.encode(n.exportResultAsDataset, o.uint32(
        /* id 12, wireType 2 =*/
        98
      ).fork()).ldelim(), o;
    }, r.encodeDelimited = function(n, o) {
      return this.encode(n, o).ldelim();
    }, r.decode = function(n, o) {
      n instanceof $Reader || (n = $Reader.create(n));
      let c = o === void 0 ? n.len : n.pos + o, l = new $root.gcg.AuthenticatedRequest();
      for (; n.pos < c; ) {
        let d = n.uint32();
        switch (d >>> 3) {
          case 1: {
            l.accessToken = n.string();
            break;
          }
          case 2: {
            l.apiToken = n.string();
            break;
          }
          case 3: {
            l.createPolicy = $root.gcg.CreatePolicyRequest.decode(n, n.uint32());
            break;
          }
          case 4: {
            l.secretStore = $root.secret_store_api.SecretStoreRequest.decode(n, n.uint32());
            break;
          }
          case 6: {
            l.getVerificationKey = $root.gcg.GetVerificationKeyRequest.decode(n, n.uint32());
            break;
          }
          case 7: {
            l.dcrAction = $root.gcg.DcrActionRequest.decode(n, n.uint32());
            break;
          }
          case 8: {
            l.createApiToken = $root.gcg.CreateApiTokenRequest.decode(n, n.uint32());
            break;
          }
          case 9: {
            l.getApiTokens = $root.gcg.GetApiTokensRequest.decode(n, n.uint32());
            break;
          }
          case 10: {
            l.deleteApiToken = $root.gcg.DeleteApiTokenRequest.decode(n, n.uint32());
            break;
          }
          case 11: {
            l.retrieveResultEncryptionKey = $root.gcg.RetrieveResultEncryptionKeyRequest.decode(n, n.uint32());
            break;
          }
          case 12: {
            l.exportResultAsDataset = $root.gcg.ExportResultAsDatasetRequest.decode(n, n.uint32());
            break;
          }
          default:
            n.skipType(d & 7);
            break;
        }
      }
      return l;
    }, r.decodeDelimited = function(n) {
      return n instanceof $Reader || (n = new $Reader(n)), this.decode(n, n.uint32());
    }, r.verify = function(n) {
      if (typeof n != "object" || n === null)
        return "object expected";
      let o = {};
      if (n.accessToken != null && n.hasOwnProperty("accessToken") && (o.token = 1, !$util.isString(n.accessToken)))
        return "accessToken: string expected";
      if (n.apiToken != null && n.hasOwnProperty("apiToken")) {
        if (o.token === 1)
          return "token: multiple values";
        if (o.token = 1, !$util.isString(n.apiToken))
          return "apiToken: string expected";
      }
      if (n.createPolicy != null && n.hasOwnProperty("createPolicy")) {
        o.request = 1;
        {
          let c = $root.gcg.CreatePolicyRequest.verify(n.createPolicy);
          if (c)
            return "createPolicy." + c;
        }
      }
      if (n.secretStore != null && n.hasOwnProperty("secretStore")) {
        if (o.request === 1)
          return "request: multiple values";
        o.request = 1;
        {
          let c = $root.secret_store_api.SecretStoreRequest.verify(n.secretStore);
          if (c)
            return "secretStore." + c;
        }
      }
      if (n.getVerificationKey != null && n.hasOwnProperty("getVerificationKey")) {
        if (o.request === 1)
          return "request: multiple values";
        o.request = 1;
        {
          let c = $root.gcg.GetVerificationKeyRequest.verify(n.getVerificationKey);
          if (c)
            return "getVerificationKey." + c;
        }
      }
      if (n.dcrAction != null && n.hasOwnProperty("dcrAction")) {
        if (o.request === 1)
          return "request: multiple values";
        o.request = 1;
        {
          let c = $root.gcg.DcrActionRequest.verify(n.dcrAction);
          if (c)
            return "dcrAction." + c;
        }
      }
      if (n.createApiToken != null && n.hasOwnProperty("createApiToken")) {
        if (o.request === 1)
          return "request: multiple values";
        o.request = 1;
        {
          let c = $root.gcg.CreateApiTokenRequest.verify(n.createApiToken);
          if (c)
            return "createApiToken." + c;
        }
      }
      if (n.getApiTokens != null && n.hasOwnProperty("getApiTokens")) {
        if (o.request === 1)
          return "request: multiple values";
        o.request = 1;
        {
          let c = $root.gcg.GetApiTokensRequest.verify(n.getApiTokens);
          if (c)
            return "getApiTokens." + c;
        }
      }
      if (n.deleteApiToken != null && n.hasOwnProperty("deleteApiToken")) {
        if (o.request === 1)
          return "request: multiple values";
        o.request = 1;
        {
          let c = $root.gcg.DeleteApiTokenRequest.verify(n.deleteApiToken);
          if (c)
            return "deleteApiToken." + c;
        }
      }
      if (n.retrieveResultEncryptionKey != null && n.hasOwnProperty("retrieveResultEncryptionKey")) {
        if (o.request === 1)
          return "request: multiple values";
        o.request = 1;
        {
          let c = $root.gcg.RetrieveResultEncryptionKeyRequest.verify(n.retrieveResultEncryptionKey);
          if (c)
            return "retrieveResultEncryptionKey." + c;
        }
      }
      if (n.exportResultAsDataset != null && n.hasOwnProperty("exportResultAsDataset")) {
        if (o.request === 1)
          return "request: multiple values";
        o.request = 1;
        {
          let c = $root.gcg.ExportResultAsDatasetRequest.verify(n.exportResultAsDataset);
          if (c)
            return "exportResultAsDataset." + c;
        }
      }
      return null;
    }, r.fromObject = function(n) {
      if (n instanceof $root.gcg.AuthenticatedRequest)
        return n;
      let o = new $root.gcg.AuthenticatedRequest();
      if (n.accessToken != null && (o.accessToken = String(n.accessToken)), n.apiToken != null && (o.apiToken = String(n.apiToken)), n.createPolicy != null) {
        if (typeof n.createPolicy != "object")
          throw TypeError(".gcg.AuthenticatedRequest.createPolicy: object expected");
        o.createPolicy = $root.gcg.CreatePolicyRequest.fromObject(n.createPolicy);
      }
      if (n.secretStore != null) {
        if (typeof n.secretStore != "object")
          throw TypeError(".gcg.AuthenticatedRequest.secretStore: object expected");
        o.secretStore = $root.secret_store_api.SecretStoreRequest.fromObject(n.secretStore);
      }
      if (n.getVerificationKey != null) {
        if (typeof n.getVerificationKey != "object")
          throw TypeError(".gcg.AuthenticatedRequest.getVerificationKey: object expected");
        o.getVerificationKey = $root.gcg.GetVerificationKeyRequest.fromObject(n.getVerificationKey);
      }
      if (n.dcrAction != null) {
        if (typeof n.dcrAction != "object")
          throw TypeError(".gcg.AuthenticatedRequest.dcrAction: object expected");
        o.dcrAction = $root.gcg.DcrActionRequest.fromObject(n.dcrAction);
      }
      if (n.createApiToken != null) {
        if (typeof n.createApiToken != "object")
          throw TypeError(".gcg.AuthenticatedRequest.createApiToken: object expected");
        o.createApiToken = $root.gcg.CreateApiTokenRequest.fromObject(n.createApiToken);
      }
      if (n.getApiTokens != null) {
        if (typeof n.getApiTokens != "object")
          throw TypeError(".gcg.AuthenticatedRequest.getApiTokens: object expected");
        o.getApiTokens = $root.gcg.GetApiTokensRequest.fromObject(n.getApiTokens);
      }
      if (n.deleteApiToken != null) {
        if (typeof n.deleteApiToken != "object")
          throw TypeError(".gcg.AuthenticatedRequest.deleteApiToken: object expected");
        o.deleteApiToken = $root.gcg.DeleteApiTokenRequest.fromObject(n.deleteApiToken);
      }
      if (n.retrieveResultEncryptionKey != null) {
        if (typeof n.retrieveResultEncryptionKey != "object")
          throw TypeError(".gcg.AuthenticatedRequest.retrieveResultEncryptionKey: object expected");
        o.retrieveResultEncryptionKey = $root.gcg.RetrieveResultEncryptionKeyRequest.fromObject(n.retrieveResultEncryptionKey);
      }
      if (n.exportResultAsDataset != null) {
        if (typeof n.exportResultAsDataset != "object")
          throw TypeError(".gcg.AuthenticatedRequest.exportResultAsDataset: object expected");
        o.exportResultAsDataset = $root.gcg.ExportResultAsDatasetRequest.fromObject(n.exportResultAsDataset);
      }
      return o;
    }, r.toObject = function(n, o) {
      o || (o = {});
      let c = {};
      return n.accessToken != null && n.hasOwnProperty("accessToken") && (c.accessToken = n.accessToken, o.oneofs && (c.token = "accessToken")), n.apiToken != null && n.hasOwnProperty("apiToken") && (c.apiToken = n.apiToken, o.oneofs && (c.token = "apiToken")), n.createPolicy != null && n.hasOwnProperty("createPolicy") && (c.createPolicy = $root.gcg.CreatePolicyRequest.toObject(n.createPolicy, o), o.oneofs && (c.request = "createPolicy")), n.secretStore != null && n.hasOwnProperty("secretStore") && (c.secretStore = $root.secret_store_api.SecretStoreRequest.toObject(n.secretStore, o), o.oneofs && (c.request = "secretStore")), n.getVerificationKey != null && n.hasOwnProperty("getVerificationKey") && (c.getVerificationKey = $root.gcg.GetVerificationKeyRequest.toObject(n.getVerificationKey, o), o.oneofs && (c.request = "getVerificationKey")), n.dcrAction != null && n.hasOwnProperty("dcrAction") && (c.dcrAction = $root.gcg.DcrActionRequest.toObject(n.dcrAction, o), o.oneofs && (c.request = "dcrAction")), n.createApiToken != null && n.hasOwnProperty("createApiToken") && (c.createApiToken = $root.gcg.CreateApiTokenRequest.toObject(n.createApiToken, o), o.oneofs && (c.request = "createApiToken")), n.getApiTokens != null && n.hasOwnProperty("getApiTokens") && (c.getApiTokens = $root.gcg.GetApiTokensRequest.toObject(n.getApiTokens, o), o.oneofs && (c.request = "getApiTokens")), n.deleteApiToken != null && n.hasOwnProperty("deleteApiToken") && (c.deleteApiToken = $root.gcg.DeleteApiTokenRequest.toObject(n.deleteApiToken, o), o.oneofs && (c.request = "deleteApiToken")), n.retrieveResultEncryptionKey != null && n.hasOwnProperty("retrieveResultEncryptionKey") && (c.retrieveResultEncryptionKey = $root.gcg.RetrieveResultEncryptionKeyRequest.toObject(n.retrieveResultEncryptionKey, o), o.oneofs && (c.request = "retrieveResultEncryptionKey")), n.exportResultAsDataset != null && n.hasOwnProperty("exportResultAsDataset") && (c.exportResultAsDataset = $root.gcg.ExportResultAsDatasetRequest.toObject(n.exportResultAsDataset, o), o.oneofs && (c.request = "exportResultAsDataset")), c;
    }, r.prototype.toJSON = function() {
      return this.constructor.toObject(this, minimal.util.toJSONOptions);
    }, r.getTypeUrl = function(n) {
      return n === void 0 && (n = "type.googleapis.com"), n + "/gcg.AuthenticatedRequest";
    }, r;
  }(), u.AuthenticatedResponse = function() {
    function r(e) {
      if (e)
        for (let n = Object.keys(e), o = 0; o < n.length; ++o)
          e[n[o]] != null && (this[n[o]] = e[n[o]]);
    }
    r.prototype.createPolicy = null, r.prototype.secretStore = null, r.prototype.getVerificationKey = null, r.prototype.dcrAction = null, r.prototype.createApiToken = null, r.prototype.getApiTokens = null, r.prototype.deleteApiToken = null, r.prototype.retrieveResultEncryptionKey = null, r.prototype.exportResultAsDataset = null;
    let a;
    return Object.defineProperty(r.prototype, "response", {
      get: $util.oneOfGetter(a = ["createPolicy", "secretStore", "getVerificationKey", "dcrAction", "createApiToken", "getApiTokens", "deleteApiToken", "retrieveResultEncryptionKey", "exportResultAsDataset"]),
      set: $util.oneOfSetter(a)
    }), r.create = function(n) {
      return new r(n);
    }, r.encode = function(n, o) {
      return o || (o = $Writer.create()), n.createPolicy != null && Object.hasOwnProperty.call(n, "createPolicy") && $root.gcg.CreatePolicyResponse.encode(n.createPolicy, o.uint32(
        /* id 3, wireType 2 =*/
        26
      ).fork()).ldelim(), n.secretStore != null && Object.hasOwnProperty.call(n, "secretStore") && $root.secret_store_api.SecretStoreResponse.encode(n.secretStore, o.uint32(
        /* id 4, wireType 2 =*/
        34
      ).fork()).ldelim(), n.getVerificationKey != null && Object.hasOwnProperty.call(n, "getVerificationKey") && $root.gcg.GetVerificationKeyResponse.encode(n.getVerificationKey, o.uint32(
        /* id 6, wireType 2 =*/
        50
      ).fork()).ldelim(), n.dcrAction != null && Object.hasOwnProperty.call(n, "dcrAction") && $root.gcg.DcrActionResponse.encode(n.dcrAction, o.uint32(
        /* id 7, wireType 2 =*/
        58
      ).fork()).ldelim(), n.createApiToken != null && Object.hasOwnProperty.call(n, "createApiToken") && $root.gcg.CreateApiTokenResponse.encode(n.createApiToken, o.uint32(
        /* id 8, wireType 2 =*/
        66
      ).fork()).ldelim(), n.getApiTokens != null && Object.hasOwnProperty.call(n, "getApiTokens") && $root.gcg.GetApiTokensResponse.encode(n.getApiTokens, o.uint32(
        /* id 9, wireType 2 =*/
        74
      ).fork()).ldelim(), n.deleteApiToken != null && Object.hasOwnProperty.call(n, "deleteApiToken") && $root.gcg.DeleteApiTokenResponse.encode(n.deleteApiToken, o.uint32(
        /* id 10, wireType 2 =*/
        82
      ).fork()).ldelim(), n.retrieveResultEncryptionKey != null && Object.hasOwnProperty.call(n, "retrieveResultEncryptionKey") && $root.gcg.RetrieveResultEncryptionKeyResponse.encode(n.retrieveResultEncryptionKey, o.uint32(
        /* id 11, wireType 2 =*/
        90
      ).fork()).ldelim(), n.exportResultAsDataset != null && Object.hasOwnProperty.call(n, "exportResultAsDataset") && $root.gcg.ExportResultAsDatasetResponse.encode(n.exportResultAsDataset, o.uint32(
        /* id 12, wireType 2 =*/
        98
      ).fork()).ldelim(), o;
    }, r.encodeDelimited = function(n, o) {
      return this.encode(n, o).ldelim();
    }, r.decode = function(n, o) {
      n instanceof $Reader || (n = $Reader.create(n));
      let c = o === void 0 ? n.len : n.pos + o, l = new $root.gcg.AuthenticatedResponse();
      for (; n.pos < c; ) {
        let d = n.uint32();
        switch (d >>> 3) {
          case 3: {
            l.createPolicy = $root.gcg.CreatePolicyResponse.decode(n, n.uint32());
            break;
          }
          case 4: {
            l.secretStore = $root.secret_store_api.SecretStoreResponse.decode(n, n.uint32());
            break;
          }
          case 6: {
            l.getVerificationKey = $root.gcg.GetVerificationKeyResponse.decode(n, n.uint32());
            break;
          }
          case 7: {
            l.dcrAction = $root.gcg.DcrActionResponse.decode(n, n.uint32());
            break;
          }
          case 8: {
            l.createApiToken = $root.gcg.CreateApiTokenResponse.decode(n, n.uint32());
            break;
          }
          case 9: {
            l.getApiTokens = $root.gcg.GetApiTokensResponse.decode(n, n.uint32());
            break;
          }
          case 10: {
            l.deleteApiToken = $root.gcg.DeleteApiTokenResponse.decode(n, n.uint32());
            break;
          }
          case 11: {
            l.retrieveResultEncryptionKey = $root.gcg.RetrieveResultEncryptionKeyResponse.decode(n, n.uint32());
            break;
          }
          case 12: {
            l.exportResultAsDataset = $root.gcg.ExportResultAsDatasetResponse.decode(n, n.uint32());
            break;
          }
          default:
            n.skipType(d & 7);
            break;
        }
      }
      return l;
    }, r.decodeDelimited = function(n) {
      return n instanceof $Reader || (n = new $Reader(n)), this.decode(n, n.uint32());
    }, r.verify = function(n) {
      if (typeof n != "object" || n === null)
        return "object expected";
      let o = {};
      if (n.createPolicy != null && n.hasOwnProperty("createPolicy")) {
        o.response = 1;
        {
          let c = $root.gcg.CreatePolicyResponse.verify(n.createPolicy);
          if (c)
            return "createPolicy." + c;
        }
      }
      if (n.secretStore != null && n.hasOwnProperty("secretStore")) {
        if (o.response === 1)
          return "response: multiple values";
        o.response = 1;
        {
          let c = $root.secret_store_api.SecretStoreResponse.verify(n.secretStore);
          if (c)
            return "secretStore." + c;
        }
      }
      if (n.getVerificationKey != null && n.hasOwnProperty("getVerificationKey")) {
        if (o.response === 1)
          return "response: multiple values";
        o.response = 1;
        {
          let c = $root.gcg.GetVerificationKeyResponse.verify(n.getVerificationKey);
          if (c)
            return "getVerificationKey." + c;
        }
      }
      if (n.dcrAction != null && n.hasOwnProperty("dcrAction")) {
        if (o.response === 1)
          return "response: multiple values";
        o.response = 1;
        {
          let c = $root.gcg.DcrActionResponse.verify(n.dcrAction);
          if (c)
            return "dcrAction." + c;
        }
      }
      if (n.createApiToken != null && n.hasOwnProperty("createApiToken")) {
        if (o.response === 1)
          return "response: multiple values";
        o.response = 1;
        {
          let c = $root.gcg.CreateApiTokenResponse.verify(n.createApiToken);
          if (c)
            return "createApiToken." + c;
        }
      }
      if (n.getApiTokens != null && n.hasOwnProperty("getApiTokens")) {
        if (o.response === 1)
          return "response: multiple values";
        o.response = 1;
        {
          let c = $root.gcg.GetApiTokensResponse.verify(n.getApiTokens);
          if (c)
            return "getApiTokens." + c;
        }
      }
      if (n.deleteApiToken != null && n.hasOwnProperty("deleteApiToken")) {
        if (o.response === 1)
          return "response: multiple values";
        o.response = 1;
        {
          let c = $root.gcg.DeleteApiTokenResponse.verify(n.deleteApiToken);
          if (c)
            return "deleteApiToken." + c;
        }
      }
      if (n.retrieveResultEncryptionKey != null && n.hasOwnProperty("retrieveResultEncryptionKey")) {
        if (o.response === 1)
          return "response: multiple values";
        o.response = 1;
        {
          let c = $root.gcg.RetrieveResultEncryptionKeyResponse.verify(n.retrieveResultEncryptionKey);
          if (c)
            return "retrieveResultEncryptionKey." + c;
        }
      }
      if (n.exportResultAsDataset != null && n.hasOwnProperty("exportResultAsDataset")) {
        if (o.response === 1)
          return "response: multiple values";
        o.response = 1;
        {
          let c = $root.gcg.ExportResultAsDatasetResponse.verify(n.exportResultAsDataset);
          if (c)
            return "exportResultAsDataset." + c;
        }
      }
      return null;
    }, r.fromObject = function(n) {
      if (n instanceof $root.gcg.AuthenticatedResponse)
        return n;
      let o = new $root.gcg.AuthenticatedResponse();
      if (n.createPolicy != null) {
        if (typeof n.createPolicy != "object")
          throw TypeError(".gcg.AuthenticatedResponse.createPolicy: object expected");
        o.createPolicy = $root.gcg.CreatePolicyResponse.fromObject(n.createPolicy);
      }
      if (n.secretStore != null) {
        if (typeof n.secretStore != "object")
          throw TypeError(".gcg.AuthenticatedResponse.secretStore: object expected");
        o.secretStore = $root.secret_store_api.SecretStoreResponse.fromObject(n.secretStore);
      }
      if (n.getVerificationKey != null) {
        if (typeof n.getVerificationKey != "object")
          throw TypeError(".gcg.AuthenticatedResponse.getVerificationKey: object expected");
        o.getVerificationKey = $root.gcg.GetVerificationKeyResponse.fromObject(n.getVerificationKey);
      }
      if (n.dcrAction != null) {
        if (typeof n.dcrAction != "object")
          throw TypeError(".gcg.AuthenticatedResponse.dcrAction: object expected");
        o.dcrAction = $root.gcg.DcrActionResponse.fromObject(n.dcrAction);
      }
      if (n.createApiToken != null) {
        if (typeof n.createApiToken != "object")
          throw TypeError(".gcg.AuthenticatedResponse.createApiToken: object expected");
        o.createApiToken = $root.gcg.CreateApiTokenResponse.fromObject(n.createApiToken);
      }
      if (n.getApiTokens != null) {
        if (typeof n.getApiTokens != "object")
          throw TypeError(".gcg.AuthenticatedResponse.getApiTokens: object expected");
        o.getApiTokens = $root.gcg.GetApiTokensResponse.fromObject(n.getApiTokens);
      }
      if (n.deleteApiToken != null) {
        if (typeof n.deleteApiToken != "object")
          throw TypeError(".gcg.AuthenticatedResponse.deleteApiToken: object expected");
        o.deleteApiToken = $root.gcg.DeleteApiTokenResponse.fromObject(n.deleteApiToken);
      }
      if (n.retrieveResultEncryptionKey != null) {
        if (typeof n.retrieveResultEncryptionKey != "object")
          throw TypeError(".gcg.AuthenticatedResponse.retrieveResultEncryptionKey: object expected");
        o.retrieveResultEncryptionKey = $root.gcg.RetrieveResultEncryptionKeyResponse.fromObject(n.retrieveResultEncryptionKey);
      }
      if (n.exportResultAsDataset != null) {
        if (typeof n.exportResultAsDataset != "object")
          throw TypeError(".gcg.AuthenticatedResponse.exportResultAsDataset: object expected");
        o.exportResultAsDataset = $root.gcg.ExportResultAsDatasetResponse.fromObject(n.exportResultAsDataset);
      }
      return o;
    }, r.toObject = function(n, o) {
      o || (o = {});
      let c = {};
      return n.createPolicy != null && n.hasOwnProperty("createPolicy") && (c.createPolicy = $root.gcg.CreatePolicyResponse.toObject(n.createPolicy, o), o.oneofs && (c.response = "createPolicy")), n.secretStore != null && n.hasOwnProperty("secretStore") && (c.secretStore = $root.secret_store_api.SecretStoreResponse.toObject(n.secretStore, o), o.oneofs && (c.response = "secretStore")), n.getVerificationKey != null && n.hasOwnProperty("getVerificationKey") && (c.getVerificationKey = $root.gcg.GetVerificationKeyResponse.toObject(n.getVerificationKey, o), o.oneofs && (c.response = "getVerificationKey")), n.dcrAction != null && n.hasOwnProperty("dcrAction") && (c.dcrAction = $root.gcg.DcrActionResponse.toObject(n.dcrAction, o), o.oneofs && (c.response = "dcrAction")), n.createApiToken != null && n.hasOwnProperty("createApiToken") && (c.createApiToken = $root.gcg.CreateApiTokenResponse.toObject(n.createApiToken, o), o.oneofs && (c.response = "createApiToken")), n.getApiTokens != null && n.hasOwnProperty("getApiTokens") && (c.getApiTokens = $root.gcg.GetApiTokensResponse.toObject(n.getApiTokens, o), o.oneofs && (c.response = "getApiTokens")), n.deleteApiToken != null && n.hasOwnProperty("deleteApiToken") && (c.deleteApiToken = $root.gcg.DeleteApiTokenResponse.toObject(n.deleteApiToken, o), o.oneofs && (c.response = "deleteApiToken")), n.retrieveResultEncryptionKey != null && n.hasOwnProperty("retrieveResultEncryptionKey") && (c.retrieveResultEncryptionKey = $root.gcg.RetrieveResultEncryptionKeyResponse.toObject(n.retrieveResultEncryptionKey, o), o.oneofs && (c.response = "retrieveResultEncryptionKey")), n.exportResultAsDataset != null && n.hasOwnProperty("exportResultAsDataset") && (c.exportResultAsDataset = $root.gcg.ExportResultAsDatasetResponse.toObject(n.exportResultAsDataset, o), o.oneofs && (c.response = "exportResultAsDataset")), c;
    }, r.prototype.toJSON = function() {
      return this.constructor.toObject(this, minimal.util.toJSONOptions);
    }, r.getTypeUrl = function(n) {
      return n === void 0 && (n = "type.googleapis.com"), n + "/gcg.AuthenticatedResponse";
    }, r;
  }(), u.UnauthenticatedRequest = function() {
    function r(e) {
      if (e)
        for (let n = Object.keys(e), o = 0; o < n.length; ++o)
          e[n[o]] != null && (this[n[o]] = e[n[o]]);
    }
    r.prototype.authentication = null;
    let a;
    return Object.defineProperty(r.prototype, "request", {
      get: $util.oneOfGetter(a = ["authentication"]),
      set: $util.oneOfSetter(a)
    }), r.create = function(n) {
      return new r(n);
    }, r.encode = function(n, o) {
      return o || (o = $Writer.create()), n.authentication != null && Object.hasOwnProperty.call(n, "authentication") && $root.gcg.AuthenticationRequest.encode(n.authentication, o.uint32(
        /* id 1, wireType 2 =*/
        10
      ).fork()).ldelim(), o;
    }, r.encodeDelimited = function(n, o) {
      return this.encode(n, o).ldelim();
    }, r.decode = function(n, o) {
      n instanceof $Reader || (n = $Reader.create(n));
      let c = o === void 0 ? n.len : n.pos + o, l = new $root.gcg.UnauthenticatedRequest();
      for (; n.pos < c; ) {
        let d = n.uint32();
        switch (d >>> 3) {
          case 1: {
            l.authentication = $root.gcg.AuthenticationRequest.decode(n, n.uint32());
            break;
          }
          default:
            n.skipType(d & 7);
            break;
        }
      }
      return l;
    }, r.decodeDelimited = function(n) {
      return n instanceof $Reader || (n = new $Reader(n)), this.decode(n, n.uint32());
    }, r.verify = function(n) {
      if (typeof n != "object" || n === null)
        return "object expected";
      if (n.authentication != null && n.hasOwnProperty("authentication")) {
        let o = $root.gcg.AuthenticationRequest.verify(n.authentication);
        if (o)
          return "authentication." + o;
      }
      return null;
    }, r.fromObject = function(n) {
      if (n instanceof $root.gcg.UnauthenticatedRequest)
        return n;
      let o = new $root.gcg.UnauthenticatedRequest();
      if (n.authentication != null) {
        if (typeof n.authentication != "object")
          throw TypeError(".gcg.UnauthenticatedRequest.authentication: object expected");
        o.authentication = $root.gcg.AuthenticationRequest.fromObject(n.authentication);
      }
      return o;
    }, r.toObject = function(n, o) {
      o || (o = {});
      let c = {};
      return n.authentication != null && n.hasOwnProperty("authentication") && (c.authentication = $root.gcg.AuthenticationRequest.toObject(n.authentication, o), o.oneofs && (c.request = "authentication")), c;
    }, r.prototype.toJSON = function() {
      return this.constructor.toObject(this, minimal.util.toJSONOptions);
    }, r.getTypeUrl = function(n) {
      return n === void 0 && (n = "type.googleapis.com"), n + "/gcg.UnauthenticatedRequest";
    }, r;
  }(), u.GcgResponseV2 = function() {
    function r(e) {
      if (e)
        for (let n = Object.keys(e), o = 0; o < n.length; ++o)
          e[n[o]] != null && (this[n[o]] = e[n[o]]);
    }
    r.prototype.success = null, r.prototype.failure = null;
    let a;
    return Object.defineProperty(r.prototype, "response", {
      get: $util.oneOfGetter(a = ["success", "failure"]),
      set: $util.oneOfSetter(a)
    }), r.create = function(n) {
      return new r(n);
    }, r.encode = function(n, o) {
      return o || (o = $Writer.create()), n.success != null && Object.hasOwnProperty.call(n, "success") && $root.gcg.GcgSuccessfulResponseV2.encode(n.success, o.uint32(
        /* id 1, wireType 2 =*/
        10
      ).fork()).ldelim(), n.failure != null && Object.hasOwnProperty.call(n, "failure") && o.uint32(
        /* id 2, wireType 2 =*/
        18
      ).string(n.failure), o;
    }, r.encodeDelimited = function(n, o) {
      return this.encode(n, o).ldelim();
    }, r.decode = function(n, o) {
      n instanceof $Reader || (n = $Reader.create(n));
      let c = o === void 0 ? n.len : n.pos + o, l = new $root.gcg.GcgResponseV2();
      for (; n.pos < c; ) {
        let d = n.uint32();
        switch (d >>> 3) {
          case 1: {
            l.success = $root.gcg.GcgSuccessfulResponseV2.decode(n, n.uint32());
            break;
          }
          case 2: {
            l.failure = n.string();
            break;
          }
          default:
            n.skipType(d & 7);
            break;
        }
      }
      return l;
    }, r.decodeDelimited = function(n) {
      return n instanceof $Reader || (n = new $Reader(n)), this.decode(n, n.uint32());
    }, r.verify = function(n) {
      if (typeof n != "object" || n === null)
        return "object expected";
      let o = {};
      if (n.success != null && n.hasOwnProperty("success")) {
        o.response = 1;
        {
          let c = $root.gcg.GcgSuccessfulResponseV2.verify(n.success);
          if (c)
            return "success." + c;
        }
      }
      if (n.failure != null && n.hasOwnProperty("failure")) {
        if (o.response === 1)
          return "response: multiple values";
        if (o.response = 1, !$util.isString(n.failure))
          return "failure: string expected";
      }
      return null;
    }, r.fromObject = function(n) {
      if (n instanceof $root.gcg.GcgResponseV2)
        return n;
      let o = new $root.gcg.GcgResponseV2();
      if (n.success != null) {
        if (typeof n.success != "object")
          throw TypeError(".gcg.GcgResponseV2.success: object expected");
        o.success = $root.gcg.GcgSuccessfulResponseV2.fromObject(n.success);
      }
      return n.failure != null && (o.failure = String(n.failure)), o;
    }, r.toObject = function(n, o) {
      o || (o = {});
      let c = {};
      return n.success != null && n.hasOwnProperty("success") && (c.success = $root.gcg.GcgSuccessfulResponseV2.toObject(n.success, o), o.oneofs && (c.response = "success")), n.failure != null && n.hasOwnProperty("failure") && (c.failure = n.failure, o.oneofs && (c.response = "failure")), c;
    }, r.prototype.toJSON = function() {
      return this.constructor.toObject(this, minimal.util.toJSONOptions);
    }, r.getTypeUrl = function(n) {
      return n === void 0 && (n = "type.googleapis.com"), n + "/gcg.GcgResponseV2";
    }, r;
  }(), u.AuthenticationRequest = function() {
    function r(e) {
      if (e)
        for (let n = Object.keys(e), o = 0; o < n.length; ++o)
          e[n[o]] != null && (this[n[o]] = e[n[o]]);
    }
    r.prototype.emailStart = null, r.prototype.emailFinish = null;
    let a;
    return Object.defineProperty(r.prototype, "request", {
      get: $util.oneOfGetter(a = ["emailStart", "emailFinish"]),
      set: $util.oneOfSetter(a)
    }), r.create = function(n) {
      return new r(n);
    }, r.encode = function(n, o) {
      return o || (o = $Writer.create()), n.emailStart != null && Object.hasOwnProperty.call(n, "emailStart") && $root.gcg.EmailStartAuthenticationRequest.encode(n.emailStart, o.uint32(
        /* id 2, wireType 2 =*/
        18
      ).fork()).ldelim(), n.emailFinish != null && Object.hasOwnProperty.call(n, "emailFinish") && $root.gcg.EmailFinishAuthenticationRequest.encode(n.emailFinish, o.uint32(
        /* id 3, wireType 2 =*/
        26
      ).fork()).ldelim(), o;
    }, r.encodeDelimited = function(n, o) {
      return this.encode(n, o).ldelim();
    }, r.decode = function(n, o) {
      n instanceof $Reader || (n = $Reader.create(n));
      let c = o === void 0 ? n.len : n.pos + o, l = new $root.gcg.AuthenticationRequest();
      for (; n.pos < c; ) {
        let d = n.uint32();
        switch (d >>> 3) {
          case 2: {
            l.emailStart = $root.gcg.EmailStartAuthenticationRequest.decode(n, n.uint32());
            break;
          }
          case 3: {
            l.emailFinish = $root.gcg.EmailFinishAuthenticationRequest.decode(n, n.uint32());
            break;
          }
          default:
            n.skipType(d & 7);
            break;
        }
      }
      return l;
    }, r.decodeDelimited = function(n) {
      return n instanceof $Reader || (n = new $Reader(n)), this.decode(n, n.uint32());
    }, r.verify = function(n) {
      if (typeof n != "object" || n === null)
        return "object expected";
      let o = {};
      if (n.emailStart != null && n.hasOwnProperty("emailStart")) {
        o.request = 1;
        {
          let c = $root.gcg.EmailStartAuthenticationRequest.verify(n.emailStart);
          if (c)
            return "emailStart." + c;
        }
      }
      if (n.emailFinish != null && n.hasOwnProperty("emailFinish")) {
        if (o.request === 1)
          return "request: multiple values";
        o.request = 1;
        {
          let c = $root.gcg.EmailFinishAuthenticationRequest.verify(n.emailFinish);
          if (c)
            return "emailFinish." + c;
        }
      }
      return null;
    }, r.fromObject = function(n) {
      if (n instanceof $root.gcg.AuthenticationRequest)
        return n;
      let o = new $root.gcg.AuthenticationRequest();
      if (n.emailStart != null) {
        if (typeof n.emailStart != "object")
          throw TypeError(".gcg.AuthenticationRequest.emailStart: object expected");
        o.emailStart = $root.gcg.EmailStartAuthenticationRequest.fromObject(n.emailStart);
      }
      if (n.emailFinish != null) {
        if (typeof n.emailFinish != "object")
          throw TypeError(".gcg.AuthenticationRequest.emailFinish: object expected");
        o.emailFinish = $root.gcg.EmailFinishAuthenticationRequest.fromObject(n.emailFinish);
      }
      return o;
    }, r.toObject = function(n, o) {
      o || (o = {});
      let c = {};
      return n.emailStart != null && n.hasOwnProperty("emailStart") && (c.emailStart = $root.gcg.EmailStartAuthenticationRequest.toObject(n.emailStart, o), o.oneofs && (c.request = "emailStart")), n.emailFinish != null && n.hasOwnProperty("emailFinish") && (c.emailFinish = $root.gcg.EmailFinishAuthenticationRequest.toObject(n.emailFinish, o), o.oneofs && (c.request = "emailFinish")), c;
    }, r.prototype.toJSON = function() {
      return this.constructor.toObject(this, minimal.util.toJSONOptions);
    }, r.getTypeUrl = function(n) {
      return n === void 0 && (n = "type.googleapis.com"), n + "/gcg.AuthenticationRequest";
    }, r;
  }(), u.AuthenticationResponse = function() {
    function r(e) {
      if (e)
        for (let n = Object.keys(e), o = 0; o < n.length; ++o)
          e[n[o]] != null && (this[n[o]] = e[n[o]]);
    }
    r.prototype.emailStart = null, r.prototype.emailFinish = null;
    let a;
    return Object.defineProperty(r.prototype, "response", {
      get: $util.oneOfGetter(a = ["emailStart", "emailFinish"]),
      set: $util.oneOfSetter(a)
    }), r.create = function(n) {
      return new r(n);
    }, r.encode = function(n, o) {
      return o || (o = $Writer.create()), n.emailStart != null && Object.hasOwnProperty.call(n, "emailStart") && $root.gcg.EmailStartAuthenticationResponse.encode(n.emailStart, o.uint32(
        /* id 2, wireType 2 =*/
        18
      ).fork()).ldelim(), n.emailFinish != null && Object.hasOwnProperty.call(n, "emailFinish") && $root.gcg.EmailFinishAuthenticationResponse.encode(n.emailFinish, o.uint32(
        /* id 3, wireType 2 =*/
        26
      ).fork()).ldelim(), o;
    }, r.encodeDelimited = function(n, o) {
      return this.encode(n, o).ldelim();
    }, r.decode = function(n, o) {
      n instanceof $Reader || (n = $Reader.create(n));
      let c = o === void 0 ? n.len : n.pos + o, l = new $root.gcg.AuthenticationResponse();
      for (; n.pos < c; ) {
        let d = n.uint32();
        switch (d >>> 3) {
          case 2: {
            l.emailStart = $root.gcg.EmailStartAuthenticationResponse.decode(n, n.uint32());
            break;
          }
          case 3: {
            l.emailFinish = $root.gcg.EmailFinishAuthenticationResponse.decode(n, n.uint32());
            break;
          }
          default:
            n.skipType(d & 7);
            break;
        }
      }
      return l;
    }, r.decodeDelimited = function(n) {
      return n instanceof $Reader || (n = new $Reader(n)), this.decode(n, n.uint32());
    }, r.verify = function(n) {
      if (typeof n != "object" || n === null)
        return "object expected";
      let o = {};
      if (n.emailStart != null && n.hasOwnProperty("emailStart")) {
        o.response = 1;
        {
          let c = $root.gcg.EmailStartAuthenticationResponse.verify(n.emailStart);
          if (c)
            return "emailStart." + c;
        }
      }
      if (n.emailFinish != null && n.hasOwnProperty("emailFinish")) {
        if (o.response === 1)
          return "response: multiple values";
        o.response = 1;
        {
          let c = $root.gcg.EmailFinishAuthenticationResponse.verify(n.emailFinish);
          if (c)
            return "emailFinish." + c;
        }
      }
      return null;
    }, r.fromObject = function(n) {
      if (n instanceof $root.gcg.AuthenticationResponse)
        return n;
      let o = new $root.gcg.AuthenticationResponse();
      if (n.emailStart != null) {
        if (typeof n.emailStart != "object")
          throw TypeError(".gcg.AuthenticationResponse.emailStart: object expected");
        o.emailStart = $root.gcg.EmailStartAuthenticationResponse.fromObject(n.emailStart);
      }
      if (n.emailFinish != null) {
        if (typeof n.emailFinish != "object")
          throw TypeError(".gcg.AuthenticationResponse.emailFinish: object expected");
        o.emailFinish = $root.gcg.EmailFinishAuthenticationResponse.fromObject(n.emailFinish);
      }
      return o;
    }, r.toObject = function(n, o) {
      o || (o = {});
      let c = {};
      return n.emailStart != null && n.hasOwnProperty("emailStart") && (c.emailStart = $root.gcg.EmailStartAuthenticationResponse.toObject(n.emailStart, o), o.oneofs && (c.response = "emailStart")), n.emailFinish != null && n.hasOwnProperty("emailFinish") && (c.emailFinish = $root.gcg.EmailFinishAuthenticationResponse.toObject(n.emailFinish, o), o.oneofs && (c.response = "emailFinish")), c;
    }, r.prototype.toJSON = function() {
      return this.constructor.toObject(this, minimal.util.toJSONOptions);
    }, r.getTypeUrl = function(n) {
      return n === void 0 && (n = "type.googleapis.com"), n + "/gcg.AuthenticationResponse";
    }, r;
  }(), u.EmailStartAuthenticationRequest = function() {
    function r(a) {
      if (a)
        for (let e = Object.keys(a), n = 0; n < e.length; ++n)
          a[e[n]] != null && (this[e[n]] = a[e[n]]);
    }
    return r.prototype.email = "", r.create = function(e) {
      return new r(e);
    }, r.encode = function(e, n) {
      return n || (n = $Writer.create()), e.email != null && Object.hasOwnProperty.call(e, "email") && n.uint32(
        /* id 1, wireType 2 =*/
        10
      ).string(e.email), n;
    }, r.encodeDelimited = function(e, n) {
      return this.encode(e, n).ldelim();
    }, r.decode = function(e, n) {
      e instanceof $Reader || (e = $Reader.create(e));
      let o = n === void 0 ? e.len : e.pos + n, c = new $root.gcg.EmailStartAuthenticationRequest();
      for (; e.pos < o; ) {
        let l = e.uint32();
        switch (l >>> 3) {
          case 1: {
            c.email = e.string();
            break;
          }
          default:
            e.skipType(l & 7);
            break;
        }
      }
      return c;
    }, r.decodeDelimited = function(e) {
      return e instanceof $Reader || (e = new $Reader(e)), this.decode(e, e.uint32());
    }, r.verify = function(e) {
      return typeof e != "object" || e === null ? "object expected" : e.email != null && e.hasOwnProperty("email") && !$util.isString(e.email) ? "email: string expected" : null;
    }, r.fromObject = function(e) {
      if (e instanceof $root.gcg.EmailStartAuthenticationRequest)
        return e;
      let n = new $root.gcg.EmailStartAuthenticationRequest();
      return e.email != null && (n.email = String(e.email)), n;
    }, r.toObject = function(e, n) {
      n || (n = {});
      let o = {};
      return n.defaults && (o.email = ""), e.email != null && e.hasOwnProperty("email") && (o.email = e.email), o;
    }, r.prototype.toJSON = function() {
      return this.constructor.toObject(this, minimal.util.toJSONOptions);
    }, r.getTypeUrl = function(e) {
      return e === void 0 && (e = "type.googleapis.com"), e + "/gcg.EmailStartAuthenticationRequest";
    }, r;
  }(), u.EmailStartAuthenticationResponse = function() {
    function r(a) {
      if (a)
        for (let e = Object.keys(a), n = 0; n < e.length; ++n)
          a[e[n]] != null && (this[e[n]] = a[e[n]]);
    }
    return r.prototype.correlationId = "", r.create = function(e) {
      return new r(e);
    }, r.encode = function(e, n) {
      return n || (n = $Writer.create()), e.correlationId != null && Object.hasOwnProperty.call(e, "correlationId") && n.uint32(
        /* id 1, wireType 2 =*/
        10
      ).string(e.correlationId), n;
    }, r.encodeDelimited = function(e, n) {
      return this.encode(e, n).ldelim();
    }, r.decode = function(e, n) {
      e instanceof $Reader || (e = $Reader.create(e));
      let o = n === void 0 ? e.len : e.pos + n, c = new $root.gcg.EmailStartAuthenticationResponse();
      for (; e.pos < o; ) {
        let l = e.uint32();
        switch (l >>> 3) {
          case 1: {
            c.correlationId = e.string();
            break;
          }
          default:
            e.skipType(l & 7);
            break;
        }
      }
      return c;
    }, r.decodeDelimited = function(e) {
      return e instanceof $Reader || (e = new $Reader(e)), this.decode(e, e.uint32());
    }, r.verify = function(e) {
      return typeof e != "object" || e === null ? "object expected" : e.correlationId != null && e.hasOwnProperty("correlationId") && !$util.isString(e.correlationId) ? "correlationId: string expected" : null;
    }, r.fromObject = function(e) {
      if (e instanceof $root.gcg.EmailStartAuthenticationResponse)
        return e;
      let n = new $root.gcg.EmailStartAuthenticationResponse();
      return e.correlationId != null && (n.correlationId = String(e.correlationId)), n;
    }, r.toObject = function(e, n) {
      n || (n = {});
      let o = {};
      return n.defaults && (o.correlationId = ""), e.correlationId != null && e.hasOwnProperty("correlationId") && (o.correlationId = e.correlationId), o;
    }, r.prototype.toJSON = function() {
      return this.constructor.toObject(this, minimal.util.toJSONOptions);
    }, r.getTypeUrl = function(e) {
      return e === void 0 && (e = "type.googleapis.com"), e + "/gcg.EmailStartAuthenticationResponse";
    }, r;
  }(), u.EmailFinishAuthenticationRequest = function() {
    function r(a) {
      if (a)
        for (let e = Object.keys(a), n = 0; n < e.length; ++n)
          a[e[n]] != null && (this[e[n]] = a[e[n]]);
    }
    return r.prototype.email = "", r.prototype.code = "", r.create = function(e) {
      return new r(e);
    }, r.encode = function(e, n) {
      return n || (n = $Writer.create()), e.email != null && Object.hasOwnProperty.call(e, "email") && n.uint32(
        /* id 1, wireType 2 =*/
        10
      ).string(e.email), e.code != null && Object.hasOwnProperty.call(e, "code") && n.uint32(
        /* id 2, wireType 2 =*/
        18
      ).string(e.code), n;
    }, r.encodeDelimited = function(e, n) {
      return this.encode(e, n).ldelim();
    }, r.decode = function(e, n) {
      e instanceof $Reader || (e = $Reader.create(e));
      let o = n === void 0 ? e.len : e.pos + n, c = new $root.gcg.EmailFinishAuthenticationRequest();
      for (; e.pos < o; ) {
        let l = e.uint32();
        switch (l >>> 3) {
          case 1: {
            c.email = e.string();
            break;
          }
          case 2: {
            c.code = e.string();
            break;
          }
          default:
            e.skipType(l & 7);
            break;
        }
      }
      return c;
    }, r.decodeDelimited = function(e) {
      return e instanceof $Reader || (e = new $Reader(e)), this.decode(e, e.uint32());
    }, r.verify = function(e) {
      return typeof e != "object" || e === null ? "object expected" : e.email != null && e.hasOwnProperty("email") && !$util.isString(e.email) ? "email: string expected" : e.code != null && e.hasOwnProperty("code") && !$util.isString(e.code) ? "code: string expected" : null;
    }, r.fromObject = function(e) {
      if (e instanceof $root.gcg.EmailFinishAuthenticationRequest)
        return e;
      let n = new $root.gcg.EmailFinishAuthenticationRequest();
      return e.email != null && (n.email = String(e.email)), e.code != null && (n.code = String(e.code)), n;
    }, r.toObject = function(e, n) {
      n || (n = {});
      let o = {};
      return n.defaults && (o.email = "", o.code = ""), e.email != null && e.hasOwnProperty("email") && (o.email = e.email), e.code != null && e.hasOwnProperty("code") && (o.code = e.code), o;
    }, r.prototype.toJSON = function() {
      return this.constructor.toObject(this, minimal.util.toJSONOptions);
    }, r.getTypeUrl = function(e) {
      return e === void 0 && (e = "type.googleapis.com"), e + "/gcg.EmailFinishAuthenticationRequest";
    }, r;
  }(), u.EmailFinishAuthenticationResponse = function() {
    function r(e) {
      if (e)
        for (let n = Object.keys(e), o = 0; o < n.length; ++o)
          e[n[o]] != null && (this[n[o]] = e[n[o]]);
    }
    r.prototype.incorrectCode = null, r.prototype.notFound = null, r.prototype.success = null;
    let a;
    return Object.defineProperty(r.prototype, "response", {
      get: $util.oneOfGetter(a = ["incorrectCode", "notFound", "success"]),
      set: $util.oneOfSetter(a)
    }), r.create = function(n) {
      return new r(n);
    }, r.encode = function(n, o) {
      return o || (o = $Writer.create()), n.incorrectCode != null && Object.hasOwnProperty.call(n, "incorrectCode") && $root.gcg.EmailFinishAuthenticationResponseIncorrectCode.encode(n.incorrectCode, o.uint32(
        /* id 1, wireType 2 =*/
        10
      ).fork()).ldelim(), n.notFound != null && Object.hasOwnProperty.call(n, "notFound") && $root.gcg.EmailFinishAuthenticationResponseNotFound.encode(n.notFound, o.uint32(
        /* id 2, wireType 2 =*/
        18
      ).fork()).ldelim(), n.success != null && Object.hasOwnProperty.call(n, "success") && $root.gcg.EmailFinishAuthenticationResponseSuccess.encode(n.success, o.uint32(
        /* id 3, wireType 2 =*/
        26
      ).fork()).ldelim(), o;
    }, r.encodeDelimited = function(n, o) {
      return this.encode(n, o).ldelim();
    }, r.decode = function(n, o) {
      n instanceof $Reader || (n = $Reader.create(n));
      let c = o === void 0 ? n.len : n.pos + o, l = new $root.gcg.EmailFinishAuthenticationResponse();
      for (; n.pos < c; ) {
        let d = n.uint32();
        switch (d >>> 3) {
          case 1: {
            l.incorrectCode = $root.gcg.EmailFinishAuthenticationResponseIncorrectCode.decode(n, n.uint32());
            break;
          }
          case 2: {
            l.notFound = $root.gcg.EmailFinishAuthenticationResponseNotFound.decode(n, n.uint32());
            break;
          }
          case 3: {
            l.success = $root.gcg.EmailFinishAuthenticationResponseSuccess.decode(n, n.uint32());
            break;
          }
          default:
            n.skipType(d & 7);
            break;
        }
      }
      return l;
    }, r.decodeDelimited = function(n) {
      return n instanceof $Reader || (n = new $Reader(n)), this.decode(n, n.uint32());
    }, r.verify = function(n) {
      if (typeof n != "object" || n === null)
        return "object expected";
      let o = {};
      if (n.incorrectCode != null && n.hasOwnProperty("incorrectCode")) {
        o.response = 1;
        {
          let c = $root.gcg.EmailFinishAuthenticationResponseIncorrectCode.verify(n.incorrectCode);
          if (c)
            return "incorrectCode." + c;
        }
      }
      if (n.notFound != null && n.hasOwnProperty("notFound")) {
        if (o.response === 1)
          return "response: multiple values";
        o.response = 1;
        {
          let c = $root.gcg.EmailFinishAuthenticationResponseNotFound.verify(n.notFound);
          if (c)
            return "notFound." + c;
        }
      }
      if (n.success != null && n.hasOwnProperty("success")) {
        if (o.response === 1)
          return "response: multiple values";
        o.response = 1;
        {
          let c = $root.gcg.EmailFinishAuthenticationResponseSuccess.verify(n.success);
          if (c)
            return "success." + c;
        }
      }
      return null;
    }, r.fromObject = function(n) {
      if (n instanceof $root.gcg.EmailFinishAuthenticationResponse)
        return n;
      let o = new $root.gcg.EmailFinishAuthenticationResponse();
      if (n.incorrectCode != null) {
        if (typeof n.incorrectCode != "object")
          throw TypeError(".gcg.EmailFinishAuthenticationResponse.incorrectCode: object expected");
        o.incorrectCode = $root.gcg.EmailFinishAuthenticationResponseIncorrectCode.fromObject(n.incorrectCode);
      }
      if (n.notFound != null) {
        if (typeof n.notFound != "object")
          throw TypeError(".gcg.EmailFinishAuthenticationResponse.notFound: object expected");
        o.notFound = $root.gcg.EmailFinishAuthenticationResponseNotFound.fromObject(n.notFound);
      }
      if (n.success != null) {
        if (typeof n.success != "object")
          throw TypeError(".gcg.EmailFinishAuthenticationResponse.success: object expected");
        o.success = $root.gcg.EmailFinishAuthenticationResponseSuccess.fromObject(n.success);
      }
      return o;
    }, r.toObject = function(n, o) {
      o || (o = {});
      let c = {};
      return n.incorrectCode != null && n.hasOwnProperty("incorrectCode") && (c.incorrectCode = $root.gcg.EmailFinishAuthenticationResponseIncorrectCode.toObject(n.incorrectCode, o), o.oneofs && (c.response = "incorrectCode")), n.notFound != null && n.hasOwnProperty("notFound") && (c.notFound = $root.gcg.EmailFinishAuthenticationResponseNotFound.toObject(n.notFound, o), o.oneofs && (c.response = "notFound")), n.success != null && n.hasOwnProperty("success") && (c.success = $root.gcg.EmailFinishAuthenticationResponseSuccess.toObject(n.success, o), o.oneofs && (c.response = "success")), c;
    }, r.prototype.toJSON = function() {
      return this.constructor.toObject(this, minimal.util.toJSONOptions);
    }, r.getTypeUrl = function(n) {
      return n === void 0 && (n = "type.googleapis.com"), n + "/gcg.EmailFinishAuthenticationResponse";
    }, r;
  }(), u.EmailFinishAuthenticationResponseIncorrectCode = function() {
    function r(a) {
      if (a)
        for (let e = Object.keys(a), n = 0; n < e.length; ++n)
          a[e[n]] != null && (this[e[n]] = a[e[n]]);
    }
    return r.create = function(e) {
      return new r(e);
    }, r.encode = function(e, n) {
      return n || (n = $Writer.create()), n;
    }, r.encodeDelimited = function(e, n) {
      return this.encode(e, n).ldelim();
    }, r.decode = function(e, n) {
      e instanceof $Reader || (e = $Reader.create(e));
      let o = n === void 0 ? e.len : e.pos + n, c = new $root.gcg.EmailFinishAuthenticationResponseIncorrectCode();
      for (; e.pos < o; ) {
        let l = e.uint32();
        switch (l >>> 3) {
          default:
            e.skipType(l & 7);
            break;
        }
      }
      return c;
    }, r.decodeDelimited = function(e) {
      return e instanceof $Reader || (e = new $Reader(e)), this.decode(e, e.uint32());
    }, r.verify = function(e) {
      return typeof e != "object" || e === null ? "object expected" : null;
    }, r.fromObject = function(e) {
      return e instanceof $root.gcg.EmailFinishAuthenticationResponseIncorrectCode ? e : new $root.gcg.EmailFinishAuthenticationResponseIncorrectCode();
    }, r.toObject = function() {
      return {};
    }, r.prototype.toJSON = function() {
      return this.constructor.toObject(this, minimal.util.toJSONOptions);
    }, r.getTypeUrl = function(e) {
      return e === void 0 && (e = "type.googleapis.com"), e + "/gcg.EmailFinishAuthenticationResponseIncorrectCode";
    }, r;
  }(), u.EmailFinishAuthenticationResponseNotFound = function() {
    function r(a) {
      if (a)
        for (let e = Object.keys(a), n = 0; n < e.length; ++n)
          a[e[n]] != null && (this[e[n]] = a[e[n]]);
    }
    return r.create = function(e) {
      return new r(e);
    }, r.encode = function(e, n) {
      return n || (n = $Writer.create()), n;
    }, r.encodeDelimited = function(e, n) {
      return this.encode(e, n).ldelim();
    }, r.decode = function(e, n) {
      e instanceof $Reader || (e = $Reader.create(e));
      let o = n === void 0 ? e.len : e.pos + n, c = new $root.gcg.EmailFinishAuthenticationResponseNotFound();
      for (; e.pos < o; ) {
        let l = e.uint32();
        switch (l >>> 3) {
          default:
            e.skipType(l & 7);
            break;
        }
      }
      return c;
    }, r.decodeDelimited = function(e) {
      return e instanceof $Reader || (e = new $Reader(e)), this.decode(e, e.uint32());
    }, r.verify = function(e) {
      return typeof e != "object" || e === null ? "object expected" : null;
    }, r.fromObject = function(e) {
      return e instanceof $root.gcg.EmailFinishAuthenticationResponseNotFound ? e : new $root.gcg.EmailFinishAuthenticationResponseNotFound();
    }, r.toObject = function() {
      return {};
    }, r.prototype.toJSON = function() {
      return this.constructor.toObject(this, minimal.util.toJSONOptions);
    }, r.getTypeUrl = function(e) {
      return e === void 0 && (e = "type.googleapis.com"), e + "/gcg.EmailFinishAuthenticationResponseNotFound";
    }, r;
  }(), u.EmailFinishAuthenticationResponseSuccess = function() {
    function r(a) {
      if (a)
        for (let e = Object.keys(a), n = 0; n < e.length; ++n)
          a[e[n]] != null && (this[e[n]] = a[e[n]]);
    }
    return r.prototype.token = "", r.create = function(e) {
      return new r(e);
    }, r.encode = function(e, n) {
      return n || (n = $Writer.create()), e.token != null && Object.hasOwnProperty.call(e, "token") && n.uint32(
        /* id 1, wireType 2 =*/
        10
      ).string(e.token), n;
    }, r.encodeDelimited = function(e, n) {
      return this.encode(e, n).ldelim();
    }, r.decode = function(e, n) {
      e instanceof $Reader || (e = $Reader.create(e));
      let o = n === void 0 ? e.len : e.pos + n, c = new $root.gcg.EmailFinishAuthenticationResponseSuccess();
      for (; e.pos < o; ) {
        let l = e.uint32();
        switch (l >>> 3) {
          case 1: {
            c.token = e.string();
            break;
          }
          default:
            e.skipType(l & 7);
            break;
        }
      }
      return c;
    }, r.decodeDelimited = function(e) {
      return e instanceof $Reader || (e = new $Reader(e)), this.decode(e, e.uint32());
    }, r.verify = function(e) {
      return typeof e != "object" || e === null ? "object expected" : e.token != null && e.hasOwnProperty("token") && !$util.isString(e.token) ? "token: string expected" : null;
    }, r.fromObject = function(e) {
      if (e instanceof $root.gcg.EmailFinishAuthenticationResponseSuccess)
        return e;
      let n = new $root.gcg.EmailFinishAuthenticationResponseSuccess();
      return e.token != null && (n.token = String(e.token)), n;
    }, r.toObject = function(e, n) {
      n || (n = {});
      let o = {};
      return n.defaults && (o.token = ""), e.token != null && e.hasOwnProperty("token") && (o.token = e.token), o;
    }, r.prototype.toJSON = function() {
      return this.constructor.toObject(this, minimal.util.toJSONOptions);
    }, r.getTypeUrl = function(e) {
      return e === void 0 && (e = "type.googleapis.com"), e + "/gcg.EmailFinishAuthenticationResponseSuccess";
    }, r;
  }(), u.GcgSuccessfulResponseV2 = function() {
    function r(e) {
      if (e)
        for (let n = Object.keys(e), o = 0; o < n.length; ++o)
          e[n[o]] != null && (this[n[o]] = e[n[o]]);
    }
    r.prototype.unauthenticated = null, r.prototype.authenticated = null;
    let a;
    return Object.defineProperty(r.prototype, "response", {
      get: $util.oneOfGetter(a = ["unauthenticated", "authenticated"]),
      set: $util.oneOfSetter(a)
    }), r.create = function(n) {
      return new r(n);
    }, r.encode = function(n, o) {
      return o || (o = $Writer.create()), n.unauthenticated != null && Object.hasOwnProperty.call(n, "unauthenticated") && $root.gcg.UnauthenticatedResponse.encode(n.unauthenticated, o.uint32(
        /* id 1, wireType 2 =*/
        10
      ).fork()).ldelim(), n.authenticated != null && Object.hasOwnProperty.call(n, "authenticated") && $root.gcg.AuthenticatedResponse.encode(n.authenticated, o.uint32(
        /* id 2, wireType 2 =*/
        18
      ).fork()).ldelim(), o;
    }, r.encodeDelimited = function(n, o) {
      return this.encode(n, o).ldelim();
    }, r.decode = function(n, o) {
      n instanceof $Reader || (n = $Reader.create(n));
      let c = o === void 0 ? n.len : n.pos + o, l = new $root.gcg.GcgSuccessfulResponseV2();
      for (; n.pos < c; ) {
        let d = n.uint32();
        switch (d >>> 3) {
          case 1: {
            l.unauthenticated = $root.gcg.UnauthenticatedResponse.decode(n, n.uint32());
            break;
          }
          case 2: {
            l.authenticated = $root.gcg.AuthenticatedResponse.decode(n, n.uint32());
            break;
          }
          default:
            n.skipType(d & 7);
            break;
        }
      }
      return l;
    }, r.decodeDelimited = function(n) {
      return n instanceof $Reader || (n = new $Reader(n)), this.decode(n, n.uint32());
    }, r.verify = function(n) {
      if (typeof n != "object" || n === null)
        return "object expected";
      let o = {};
      if (n.unauthenticated != null && n.hasOwnProperty("unauthenticated")) {
        o.response = 1;
        {
          let c = $root.gcg.UnauthenticatedResponse.verify(n.unauthenticated);
          if (c)
            return "unauthenticated." + c;
        }
      }
      if (n.authenticated != null && n.hasOwnProperty("authenticated")) {
        if (o.response === 1)
          return "response: multiple values";
        o.response = 1;
        {
          let c = $root.gcg.AuthenticatedResponse.verify(n.authenticated);
          if (c)
            return "authenticated." + c;
        }
      }
      return null;
    }, r.fromObject = function(n) {
      if (n instanceof $root.gcg.GcgSuccessfulResponseV2)
        return n;
      let o = new $root.gcg.GcgSuccessfulResponseV2();
      if (n.unauthenticated != null) {
        if (typeof n.unauthenticated != "object")
          throw TypeError(".gcg.GcgSuccessfulResponseV2.unauthenticated: object expected");
        o.unauthenticated = $root.gcg.UnauthenticatedResponse.fromObject(n.unauthenticated);
      }
      if (n.authenticated != null) {
        if (typeof n.authenticated != "object")
          throw TypeError(".gcg.GcgSuccessfulResponseV2.authenticated: object expected");
        o.authenticated = $root.gcg.AuthenticatedResponse.fromObject(n.authenticated);
      }
      return o;
    }, r.toObject = function(n, o) {
      o || (o = {});
      let c = {};
      return n.unauthenticated != null && n.hasOwnProperty("unauthenticated") && (c.unauthenticated = $root.gcg.UnauthenticatedResponse.toObject(n.unauthenticated, o), o.oneofs && (c.response = "unauthenticated")), n.authenticated != null && n.hasOwnProperty("authenticated") && (c.authenticated = $root.gcg.AuthenticatedResponse.toObject(n.authenticated, o), o.oneofs && (c.response = "authenticated")), c;
    }, r.prototype.toJSON = function() {
      return this.constructor.toObject(this, minimal.util.toJSONOptions);
    }, r.getTypeUrl = function(n) {
      return n === void 0 && (n = "type.googleapis.com"), n + "/gcg.GcgSuccessfulResponseV2";
    }, r;
  }(), u.UnauthenticatedResponse = function() {
    function r(e) {
      if (e)
        for (let n = Object.keys(e), o = 0; o < n.length; ++o)
          e[n[o]] != null && (this[n[o]] = e[n[o]]);
    }
    r.prototype.authentication = null;
    let a;
    return Object.defineProperty(r.prototype, "response", {
      get: $util.oneOfGetter(a = ["authentication"]),
      set: $util.oneOfSetter(a)
    }), r.create = function(n) {
      return new r(n);
    }, r.encode = function(n, o) {
      return o || (o = $Writer.create()), n.authentication != null && Object.hasOwnProperty.call(n, "authentication") && $root.gcg.AuthenticationResponse.encode(n.authentication, o.uint32(
        /* id 1, wireType 2 =*/
        10
      ).fork()).ldelim(), o;
    }, r.encodeDelimited = function(n, o) {
      return this.encode(n, o).ldelim();
    }, r.decode = function(n, o) {
      n instanceof $Reader || (n = $Reader.create(n));
      let c = o === void 0 ? n.len : n.pos + o, l = new $root.gcg.UnauthenticatedResponse();
      for (; n.pos < c; ) {
        let d = n.uint32();
        switch (d >>> 3) {
          case 1: {
            l.authentication = $root.gcg.AuthenticationResponse.decode(n, n.uint32());
            break;
          }
          default:
            n.skipType(d & 7);
            break;
        }
      }
      return l;
    }, r.decodeDelimited = function(n) {
      return n instanceof $Reader || (n = new $Reader(n)), this.decode(n, n.uint32());
    }, r.verify = function(n) {
      if (typeof n != "object" || n === null)
        return "object expected";
      if (n.authentication != null && n.hasOwnProperty("authentication")) {
        let o = $root.gcg.AuthenticationResponse.verify(n.authentication);
        if (o)
          return "authentication." + o;
      }
      return null;
    }, r.fromObject = function(n) {
      if (n instanceof $root.gcg.UnauthenticatedResponse)
        return n;
      let o = new $root.gcg.UnauthenticatedResponse();
      if (n.authentication != null) {
        if (typeof n.authentication != "object")
          throw TypeError(".gcg.UnauthenticatedResponse.authentication: object expected");
        o.authentication = $root.gcg.AuthenticationResponse.fromObject(n.authentication);
      }
      return o;
    }, r.toObject = function(n, o) {
      o || (o = {});
      let c = {};
      return n.authentication != null && n.hasOwnProperty("authentication") && (c.authentication = $root.gcg.AuthenticationResponse.toObject(n.authentication, o), o.oneofs && (c.response = "authentication")), c;
    }, r.prototype.toJSON = function() {
      return this.constructor.toObject(this, minimal.util.toJSONOptions);
    }, r.getTypeUrl = function(n) {
      return n === void 0 && (n = "type.googleapis.com"), n + "/gcg.UnauthenticatedResponse";
    }, r;
  }(), u.GetVerificationKeyRequest = function() {
    function r(a) {
      if (a)
        for (let e = Object.keys(a), n = 0; n < e.length; ++n)
          a[e[n]] != null && (this[e[n]] = a[e[n]]);
    }
    return r.create = function(e) {
      return new r(e);
    }, r.encode = function(e, n) {
      return n || (n = $Writer.create()), n;
    }, r.encodeDelimited = function(e, n) {
      return this.encode(e, n).ldelim();
    }, r.decode = function(e, n) {
      e instanceof $Reader || (e = $Reader.create(e));
      let o = n === void 0 ? e.len : e.pos + n, c = new $root.gcg.GetVerificationKeyRequest();
      for (; e.pos < o; ) {
        let l = e.uint32();
        switch (l >>> 3) {
          default:
            e.skipType(l & 7);
            break;
        }
      }
      return c;
    }, r.decodeDelimited = function(e) {
      return e instanceof $Reader || (e = new $Reader(e)), this.decode(e, e.uint32());
    }, r.verify = function(e) {
      return typeof e != "object" || e === null ? "object expected" : null;
    }, r.fromObject = function(e) {
      return e instanceof $root.gcg.GetVerificationKeyRequest ? e : new $root.gcg.GetVerificationKeyRequest();
    }, r.toObject = function() {
      return {};
    }, r.prototype.toJSON = function() {
      return this.constructor.toObject(this, minimal.util.toJSONOptions);
    }, r.getTypeUrl = function(e) {
      return e === void 0 && (e = "type.googleapis.com"), e + "/gcg.GetVerificationKeyRequest";
    }, r;
  }(), u.GetVerificationKeyResponse = function() {
    function r(a) {
      if (a)
        for (let e = Object.keys(a), n = 0; n < e.length; ++n)
          a[e[n]] != null && (this[e[n]] = a[e[n]]);
    }
    return r.prototype.verificationKey = $util.newBuffer([]), r.create = function(e) {
      return new r(e);
    }, r.encode = function(e, n) {
      return n || (n = $Writer.create()), e.verificationKey != null && Object.hasOwnProperty.call(e, "verificationKey") && n.uint32(
        /* id 1, wireType 2 =*/
        10
      ).bytes(e.verificationKey), n;
    }, r.encodeDelimited = function(e, n) {
      return this.encode(e, n).ldelim();
    }, r.decode = function(e, n) {
      e instanceof $Reader || (e = $Reader.create(e));
      let o = n === void 0 ? e.len : e.pos + n, c = new $root.gcg.GetVerificationKeyResponse();
      for (; e.pos < o; ) {
        let l = e.uint32();
        switch (l >>> 3) {
          case 1: {
            c.verificationKey = e.bytes();
            break;
          }
          default:
            e.skipType(l & 7);
            break;
        }
      }
      return c;
    }, r.decodeDelimited = function(e) {
      return e instanceof $Reader || (e = new $Reader(e)), this.decode(e, e.uint32());
    }, r.verify = function(e) {
      return typeof e != "object" || e === null ? "object expected" : e.verificationKey != null && e.hasOwnProperty("verificationKey") && !(e.verificationKey && typeof e.verificationKey.length == "number" || $util.isString(e.verificationKey)) ? "verificationKey: buffer expected" : null;
    }, r.fromObject = function(e) {
      if (e instanceof $root.gcg.GetVerificationKeyResponse)
        return e;
      let n = new $root.gcg.GetVerificationKeyResponse();
      return e.verificationKey != null && (typeof e.verificationKey == "string" ? $util.base64.decode(e.verificationKey, n.verificationKey = $util.newBuffer($util.base64.length(e.verificationKey)), 0) : e.verificationKey.length >= 0 && (n.verificationKey = e.verificationKey)), n;
    }, r.toObject = function(e, n) {
      n || (n = {});
      let o = {};
      return n.defaults && (n.bytes === String ? o.verificationKey = "" : (o.verificationKey = [], n.bytes !== Array && (o.verificationKey = $util.newBuffer(o.verificationKey)))), e.verificationKey != null && e.hasOwnProperty("verificationKey") && (o.verificationKey = n.bytes === String ? $util.base64.encode(e.verificationKey, 0, e.verificationKey.length) : n.bytes === Array ? Array.prototype.slice.call(e.verificationKey) : e.verificationKey), o;
    }, r.prototype.toJSON = function() {
      return this.constructor.toObject(this, minimal.util.toJSONOptions);
    }, r.getTypeUrl = function(e) {
      return e === void 0 && (e = "type.googleapis.com"), e + "/gcg.GetVerificationKeyResponse";
    }, r;
  }(), u.CreatePolicyRequest = function() {
    function r(e) {
      if (e)
        for (let n = Object.keys(e), o = 0; o < n.length; ++o)
          e[n[o]] != null && (this[n[o]] = e[n[o]]);
    }
    r.prototype.policy = null, r.prototype.scope = null;
    let a;
    return Object.defineProperty(r.prototype, "_scope", {
      get: $util.oneOfGetter(a = ["scope"]),
      set: $util.oneOfSetter(a)
    }), r.create = function(n) {
      return new r(n);
    }, r.encode = function(n, o) {
      return o || (o = $Writer.create()), n.policy != null && Object.hasOwnProperty.call(n, "policy") && $root.release_policy_api.ReleasePolicy.encode(n.policy, o.uint32(
        /* id 1, wireType 2 =*/
        10
      ).fork()).ldelim(), n.scope != null && Object.hasOwnProperty.call(n, "scope") && o.uint32(
        /* id 2, wireType 2 =*/
        18
      ).bytes(n.scope), o;
    }, r.encodeDelimited = function(n, o) {
      return this.encode(n, o).ldelim();
    }, r.decode = function(n, o) {
      n instanceof $Reader || (n = $Reader.create(n));
      let c = o === void 0 ? n.len : n.pos + o, l = new $root.gcg.CreatePolicyRequest();
      for (; n.pos < c; ) {
        let d = n.uint32();
        switch (d >>> 3) {
          case 1: {
            l.policy = $root.release_policy_api.ReleasePolicy.decode(n, n.uint32());
            break;
          }
          case 2: {
            l.scope = n.bytes();
            break;
          }
          default:
            n.skipType(d & 7);
            break;
        }
      }
      return l;
    }, r.decodeDelimited = function(n) {
      return n instanceof $Reader || (n = new $Reader(n)), this.decode(n, n.uint32());
    }, r.verify = function(n) {
      if (typeof n != "object" || n === null)
        return "object expected";
      if (n.policy != null && n.hasOwnProperty("policy")) {
        let o = $root.release_policy_api.ReleasePolicy.verify(n.policy);
        if (o)
          return "policy." + o;
      }
      return n.scope != null && n.hasOwnProperty("scope") && !(n.scope && typeof n.scope.length == "number" || $util.isString(n.scope)) ? "scope: buffer expected" : null;
    }, r.fromObject = function(n) {
      if (n instanceof $root.gcg.CreatePolicyRequest)
        return n;
      let o = new $root.gcg.CreatePolicyRequest();
      if (n.policy != null) {
        if (typeof n.policy != "object")
          throw TypeError(".gcg.CreatePolicyRequest.policy: object expected");
        o.policy = $root.release_policy_api.ReleasePolicy.fromObject(n.policy);
      }
      return n.scope != null && (typeof n.scope == "string" ? $util.base64.decode(n.scope, o.scope = $util.newBuffer($util.base64.length(n.scope)), 0) : n.scope.length >= 0 && (o.scope = n.scope)), o;
    }, r.toObject = function(n, o) {
      o || (o = {});
      let c = {};
      return o.defaults && (c.policy = null), n.policy != null && n.hasOwnProperty("policy") && (c.policy = $root.release_policy_api.ReleasePolicy.toObject(n.policy, o)), n.scope != null && n.hasOwnProperty("scope") && (c.scope = o.bytes === String ? $util.base64.encode(n.scope, 0, n.scope.length) : o.bytes === Array ? Array.prototype.slice.call(n.scope) : n.scope, o.oneofs && (c._scope = "scope")), c;
    }, r.prototype.toJSON = function() {
      return this.constructor.toObject(this, minimal.util.toJSONOptions);
    }, r.getTypeUrl = function(n) {
      return n === void 0 && (n = "type.googleapis.com"), n + "/gcg.CreatePolicyRequest";
    }, r;
  }(), u.CreatePolicyResponse = function() {
    function r(a) {
      if (a)
        for (let e = Object.keys(a), n = 0; n < e.length; ++n)
          a[e[n]] != null && (this[e[n]] = a[e[n]]);
    }
    return r.prototype.policyId = "", r.create = function(e) {
      return new r(e);
    }, r.encode = function(e, n) {
      return n || (n = $Writer.create()), e.policyId != null && Object.hasOwnProperty.call(e, "policyId") && n.uint32(
        /* id 1, wireType 2 =*/
        10
      ).string(e.policyId), n;
    }, r.encodeDelimited = function(e, n) {
      return this.encode(e, n).ldelim();
    }, r.decode = function(e, n) {
      e instanceof $Reader || (e = $Reader.create(e));
      let o = n === void 0 ? e.len : e.pos + n, c = new $root.gcg.CreatePolicyResponse();
      for (; e.pos < o; ) {
        let l = e.uint32();
        switch (l >>> 3) {
          case 1: {
            c.policyId = e.string();
            break;
          }
          default:
            e.skipType(l & 7);
            break;
        }
      }
      return c;
    }, r.decodeDelimited = function(e) {
      return e instanceof $Reader || (e = new $Reader(e)), this.decode(e, e.uint32());
    }, r.verify = function(e) {
      return typeof e != "object" || e === null ? "object expected" : e.policyId != null && e.hasOwnProperty("policyId") && !$util.isString(e.policyId) ? "policyId: string expected" : null;
    }, r.fromObject = function(e) {
      if (e instanceof $root.gcg.CreatePolicyResponse)
        return e;
      let n = new $root.gcg.CreatePolicyResponse();
      return e.policyId != null && (n.policyId = String(e.policyId)), n;
    }, r.toObject = function(e, n) {
      n || (n = {});
      let o = {};
      return n.defaults && (o.policyId = ""), e.policyId != null && e.hasOwnProperty("policyId") && (o.policyId = e.policyId), o;
    }, r.prototype.toJSON = function() {
      return this.constructor.toObject(this, minimal.util.toJSONOptions);
    }, r.getTypeUrl = function(e) {
      return e === void 0 && (e = "type.googleapis.com"), e + "/gcg.CreatePolicyResponse";
    }, r;
  }(), u.DcrActionRequest = function() {
    function r(a) {
      if (a)
        for (let e = Object.keys(a), n = 0; n < e.length; ++n)
          a[e[n]] != null && (this[e[n]] = a[e[n]]);
    }
    return r.prototype.dataRoomId = "", r.prototype.action = $util.newBuffer([]), r.create = function(e) {
      return new r(e);
    }, r.encode = function(e, n) {
      return n || (n = $Writer.create()), e.dataRoomId != null && Object.hasOwnProperty.call(e, "dataRoomId") && n.uint32(
        /* id 1, wireType 2 =*/
        10
      ).string(e.dataRoomId), e.action != null && Object.hasOwnProperty.call(e, "action") && n.uint32(
        /* id 2, wireType 2 =*/
        18
      ).bytes(e.action), n;
    }, r.encodeDelimited = function(e, n) {
      return this.encode(e, n).ldelim();
    }, r.decode = function(e, n) {
      e instanceof $Reader || (e = $Reader.create(e));
      let o = n === void 0 ? e.len : e.pos + n, c = new $root.gcg.DcrActionRequest();
      for (; e.pos < o; ) {
        let l = e.uint32();
        switch (l >>> 3) {
          case 1: {
            c.dataRoomId = e.string();
            break;
          }
          case 2: {
            c.action = e.bytes();
            break;
          }
          default:
            e.skipType(l & 7);
            break;
        }
      }
      return c;
    }, r.decodeDelimited = function(e) {
      return e instanceof $Reader || (e = new $Reader(e)), this.decode(e, e.uint32());
    }, r.verify = function(e) {
      return typeof e != "object" || e === null ? "object expected" : e.dataRoomId != null && e.hasOwnProperty("dataRoomId") && !$util.isString(e.dataRoomId) ? "dataRoomId: string expected" : e.action != null && e.hasOwnProperty("action") && !(e.action && typeof e.action.length == "number" || $util.isString(e.action)) ? "action: buffer expected" : null;
    }, r.fromObject = function(e) {
      if (e instanceof $root.gcg.DcrActionRequest)
        return e;
      let n = new $root.gcg.DcrActionRequest();
      return e.dataRoomId != null && (n.dataRoomId = String(e.dataRoomId)), e.action != null && (typeof e.action == "string" ? $util.base64.decode(e.action, n.action = $util.newBuffer($util.base64.length(e.action)), 0) : e.action.length >= 0 && (n.action = e.action)), n;
    }, r.toObject = function(e, n) {
      n || (n = {});
      let o = {};
      return n.defaults && (o.dataRoomId = "", n.bytes === String ? o.action = "" : (o.action = [], n.bytes !== Array && (o.action = $util.newBuffer(o.action)))), e.dataRoomId != null && e.hasOwnProperty("dataRoomId") && (o.dataRoomId = e.dataRoomId), e.action != null && e.hasOwnProperty("action") && (o.action = n.bytes === String ? $util.base64.encode(e.action, 0, e.action.length) : n.bytes === Array ? Array.prototype.slice.call(e.action) : e.action), o;
    }, r.prototype.toJSON = function() {
      return this.constructor.toObject(this, minimal.util.toJSONOptions);
    }, r.getTypeUrl = function(e) {
      return e === void 0 && (e = "type.googleapis.com"), e + "/gcg.DcrActionRequest";
    }, r;
  }(), u.DcrActionResponse = function() {
    function r(a) {
      if (a)
        for (let e = Object.keys(a), n = 0; n < e.length; ++n)
          a[e[n]] != null && (this[e[n]] = a[e[n]]);
    }
    return r.prototype.response = $util.newBuffer([]), r.create = function(e) {
      return new r(e);
    }, r.encode = function(e, n) {
      return n || (n = $Writer.create()), e.response != null && Object.hasOwnProperty.call(e, "response") && n.uint32(
        /* id 1, wireType 2 =*/
        10
      ).bytes(e.response), n;
    }, r.encodeDelimited = function(e, n) {
      return this.encode(e, n).ldelim();
    }, r.decode = function(e, n) {
      e instanceof $Reader || (e = $Reader.create(e));
      let o = n === void 0 ? e.len : e.pos + n, c = new $root.gcg.DcrActionResponse();
      for (; e.pos < o; ) {
        let l = e.uint32();
        switch (l >>> 3) {
          case 1: {
            c.response = e.bytes();
            break;
          }
          default:
            e.skipType(l & 7);
            break;
        }
      }
      return c;
    }, r.decodeDelimited = function(e) {
      return e instanceof $Reader || (e = new $Reader(e)), this.decode(e, e.uint32());
    }, r.verify = function(e) {
      return typeof e != "object" || e === null ? "object expected" : e.response != null && e.hasOwnProperty("response") && !(e.response && typeof e.response.length == "number" || $util.isString(e.response)) ? "response: buffer expected" : null;
    }, r.fromObject = function(e) {
      if (e instanceof $root.gcg.DcrActionResponse)
        return e;
      let n = new $root.gcg.DcrActionResponse();
      return e.response != null && (typeof e.response == "string" ? $util.base64.decode(e.response, n.response = $util.newBuffer($util.base64.length(e.response)), 0) : e.response.length >= 0 && (n.response = e.response)), n;
    }, r.toObject = function(e, n) {
      n || (n = {});
      let o = {};
      return n.defaults && (n.bytes === String ? o.response = "" : (o.response = [], n.bytes !== Array && (o.response = $util.newBuffer(o.response)))), e.response != null && e.hasOwnProperty("response") && (o.response = n.bytes === String ? $util.base64.encode(e.response, 0, e.response.length) : n.bytes === Array ? Array.prototype.slice.call(e.response) : e.response), o;
    }, r.prototype.toJSON = function() {
      return this.constructor.toObject(this, minimal.util.toJSONOptions);
    }, r.getTypeUrl = function(e) {
      return e === void 0 && (e = "type.googleapis.com"), e + "/gcg.DcrActionResponse";
    }, r;
  }(), u.CreateApiTokenRequest = function() {
    function r(a) {
      if (a)
        for (let e = Object.keys(a), n = 0; n < e.length; ++n)
          a[e[n]] != null && (this[e[n]] = a[e[n]]);
    }
    return r.prototype.name = "", r.create = function(e) {
      return new r(e);
    }, r.encode = function(e, n) {
      return n || (n = $Writer.create()), e.name != null && Object.hasOwnProperty.call(e, "name") && n.uint32(
        /* id 1, wireType 2 =*/
        10
      ).string(e.name), n;
    }, r.encodeDelimited = function(e, n) {
      return this.encode(e, n).ldelim();
    }, r.decode = function(e, n) {
      e instanceof $Reader || (e = $Reader.create(e));
      let o = n === void 0 ? e.len : e.pos + n, c = new $root.gcg.CreateApiTokenRequest();
      for (; e.pos < o; ) {
        let l = e.uint32();
        switch (l >>> 3) {
          case 1: {
            c.name = e.string();
            break;
          }
          default:
            e.skipType(l & 7);
            break;
        }
      }
      return c;
    }, r.decodeDelimited = function(e) {
      return e instanceof $Reader || (e = new $Reader(e)), this.decode(e, e.uint32());
    }, r.verify = function(e) {
      return typeof e != "object" || e === null ? "object expected" : e.name != null && e.hasOwnProperty("name") && !$util.isString(e.name) ? "name: string expected" : null;
    }, r.fromObject = function(e) {
      if (e instanceof $root.gcg.CreateApiTokenRequest)
        return e;
      let n = new $root.gcg.CreateApiTokenRequest();
      return e.name != null && (n.name = String(e.name)), n;
    }, r.toObject = function(e, n) {
      n || (n = {});
      let o = {};
      return n.defaults && (o.name = ""), e.name != null && e.hasOwnProperty("name") && (o.name = e.name), o;
    }, r.prototype.toJSON = function() {
      return this.constructor.toObject(this, minimal.util.toJSONOptions);
    }, r.getTypeUrl = function(e) {
      return e === void 0 && (e = "type.googleapis.com"), e + "/gcg.CreateApiTokenRequest";
    }, r;
  }(), u.CreateApiTokenResponse = function() {
    function r(a) {
      if (a)
        for (let e = Object.keys(a), n = 0; n < e.length; ++n)
          a[e[n]] != null && (this[e[n]] = a[e[n]]);
    }
    return r.prototype.token = "", r.create = function(e) {
      return new r(e);
    }, r.encode = function(e, n) {
      return n || (n = $Writer.create()), e.token != null && Object.hasOwnProperty.call(e, "token") && n.uint32(
        /* id 1, wireType 2 =*/
        10
      ).string(e.token), n;
    }, r.encodeDelimited = function(e, n) {
      return this.encode(e, n).ldelim();
    }, r.decode = function(e, n) {
      e instanceof $Reader || (e = $Reader.create(e));
      let o = n === void 0 ? e.len : e.pos + n, c = new $root.gcg.CreateApiTokenResponse();
      for (; e.pos < o; ) {
        let l = e.uint32();
        switch (l >>> 3) {
          case 1: {
            c.token = e.string();
            break;
          }
          default:
            e.skipType(l & 7);
            break;
        }
      }
      return c;
    }, r.decodeDelimited = function(e) {
      return e instanceof $Reader || (e = new $Reader(e)), this.decode(e, e.uint32());
    }, r.verify = function(e) {
      return typeof e != "object" || e === null ? "object expected" : e.token != null && e.hasOwnProperty("token") && !$util.isString(e.token) ? "token: string expected" : null;
    }, r.fromObject = function(e) {
      if (e instanceof $root.gcg.CreateApiTokenResponse)
        return e;
      let n = new $root.gcg.CreateApiTokenResponse();
      return e.token != null && (n.token = String(e.token)), n;
    }, r.toObject = function(e, n) {
      n || (n = {});
      let o = {};
      return n.defaults && (o.token = ""), e.token != null && e.hasOwnProperty("token") && (o.token = e.token), o;
    }, r.prototype.toJSON = function() {
      return this.constructor.toObject(this, minimal.util.toJSONOptions);
    }, r.getTypeUrl = function(e) {
      return e === void 0 && (e = "type.googleapis.com"), e + "/gcg.CreateApiTokenResponse";
    }, r;
  }(), u.GetApiTokensRequest = function() {
    function r(a) {
      if (a)
        for (let e = Object.keys(a), n = 0; n < e.length; ++n)
          a[e[n]] != null && (this[e[n]] = a[e[n]]);
    }
    return r.create = function(e) {
      return new r(e);
    }, r.encode = function(e, n) {
      return n || (n = $Writer.create()), n;
    }, r.encodeDelimited = function(e, n) {
      return this.encode(e, n).ldelim();
    }, r.decode = function(e, n) {
      e instanceof $Reader || (e = $Reader.create(e));
      let o = n === void 0 ? e.len : e.pos + n, c = new $root.gcg.GetApiTokensRequest();
      for (; e.pos < o; ) {
        let l = e.uint32();
        switch (l >>> 3) {
          default:
            e.skipType(l & 7);
            break;
        }
      }
      return c;
    }, r.decodeDelimited = function(e) {
      return e instanceof $Reader || (e = new $Reader(e)), this.decode(e, e.uint32());
    }, r.verify = function(e) {
      return typeof e != "object" || e === null ? "object expected" : null;
    }, r.fromObject = function(e) {
      return e instanceof $root.gcg.GetApiTokensRequest ? e : new $root.gcg.GetApiTokensRequest();
    }, r.toObject = function() {
      return {};
    }, r.prototype.toJSON = function() {
      return this.constructor.toObject(this, minimal.util.toJSONOptions);
    }, r.getTypeUrl = function(e) {
      return e === void 0 && (e = "type.googleapis.com"), e + "/gcg.GetApiTokensRequest";
    }, r;
  }(), u.GetApiTokensResponse = function() {
    function r(a) {
      if (this.tokens = [], a)
        for (let e = Object.keys(a), n = 0; n < e.length; ++n)
          a[e[n]] != null && (this[e[n]] = a[e[n]]);
    }
    return r.prototype.tokens = $util.emptyArray, r.create = function(e) {
      return new r(e);
    }, r.encode = function(e, n) {
      if (n || (n = $Writer.create()), e.tokens != null && e.tokens.length)
        for (let o = 0; o < e.tokens.length; ++o)
          $root.gcg.GetApiTokenResult.encode(e.tokens[o], n.uint32(
            /* id 1, wireType 2 =*/
            10
          ).fork()).ldelim();
      return n;
    }, r.encodeDelimited = function(e, n) {
      return this.encode(e, n).ldelim();
    }, r.decode = function(e, n) {
      e instanceof $Reader || (e = $Reader.create(e));
      let o = n === void 0 ? e.len : e.pos + n, c = new $root.gcg.GetApiTokensResponse();
      for (; e.pos < o; ) {
        let l = e.uint32();
        switch (l >>> 3) {
          case 1: {
            c.tokens && c.tokens.length || (c.tokens = []), c.tokens.push($root.gcg.GetApiTokenResult.decode(e, e.uint32()));
            break;
          }
          default:
            e.skipType(l & 7);
            break;
        }
      }
      return c;
    }, r.decodeDelimited = function(e) {
      return e instanceof $Reader || (e = new $Reader(e)), this.decode(e, e.uint32());
    }, r.verify = function(e) {
      if (typeof e != "object" || e === null)
        return "object expected";
      if (e.tokens != null && e.hasOwnProperty("tokens")) {
        if (!Array.isArray(e.tokens))
          return "tokens: array expected";
        for (let n = 0; n < e.tokens.length; ++n) {
          let o = $root.gcg.GetApiTokenResult.verify(e.tokens[n]);
          if (o)
            return "tokens." + o;
        }
      }
      return null;
    }, r.fromObject = function(e) {
      if (e instanceof $root.gcg.GetApiTokensResponse)
        return e;
      let n = new $root.gcg.GetApiTokensResponse();
      if (e.tokens) {
        if (!Array.isArray(e.tokens))
          throw TypeError(".gcg.GetApiTokensResponse.tokens: array expected");
        n.tokens = [];
        for (let o = 0; o < e.tokens.length; ++o) {
          if (typeof e.tokens[o] != "object")
            throw TypeError(".gcg.GetApiTokensResponse.tokens: object expected");
          n.tokens[o] = $root.gcg.GetApiTokenResult.fromObject(e.tokens[o]);
        }
      }
      return n;
    }, r.toObject = function(e, n) {
      n || (n = {});
      let o = {};
      if ((n.arrays || n.defaults) && (o.tokens = []), e.tokens && e.tokens.length) {
        o.tokens = [];
        for (let c = 0; c < e.tokens.length; ++c)
          o.tokens[c] = $root.gcg.GetApiTokenResult.toObject(e.tokens[c], n);
      }
      return o;
    }, r.prototype.toJSON = function() {
      return this.constructor.toObject(this, minimal.util.toJSONOptions);
    }, r.getTypeUrl = function(e) {
      return e === void 0 && (e = "type.googleapis.com"), e + "/gcg.GetApiTokensResponse";
    }, r;
  }(), u.GetApiTokenResult = function() {
    function r(a) {
      if (a)
        for (let e = Object.keys(a), n = 0; n < e.length; ++n)
          a[e[n]] != null && (this[e[n]] = a[e[n]]);
    }
    return r.prototype.name = "", r.prototype.token = "", r.create = function(e) {
      return new r(e);
    }, r.encode = function(e, n) {
      return n || (n = $Writer.create()), e.name != null && Object.hasOwnProperty.call(e, "name") && n.uint32(
        /* id 1, wireType 2 =*/
        10
      ).string(e.name), e.token != null && Object.hasOwnProperty.call(e, "token") && n.uint32(
        /* id 2, wireType 2 =*/
        18
      ).string(e.token), n;
    }, r.encodeDelimited = function(e, n) {
      return this.encode(e, n).ldelim();
    }, r.decode = function(e, n) {
      e instanceof $Reader || (e = $Reader.create(e));
      let o = n === void 0 ? e.len : e.pos + n, c = new $root.gcg.GetApiTokenResult();
      for (; e.pos < o; ) {
        let l = e.uint32();
        switch (l >>> 3) {
          case 1: {
            c.name = e.string();
            break;
          }
          case 2: {
            c.token = e.string();
            break;
          }
          default:
            e.skipType(l & 7);
            break;
        }
      }
      return c;
    }, r.decodeDelimited = function(e) {
      return e instanceof $Reader || (e = new $Reader(e)), this.decode(e, e.uint32());
    }, r.verify = function(e) {
      return typeof e != "object" || e === null ? "object expected" : e.name != null && e.hasOwnProperty("name") && !$util.isString(e.name) ? "name: string expected" : e.token != null && e.hasOwnProperty("token") && !$util.isString(e.token) ? "token: string expected" : null;
    }, r.fromObject = function(e) {
      if (e instanceof $root.gcg.GetApiTokenResult)
        return e;
      let n = new $root.gcg.GetApiTokenResult();
      return e.name != null && (n.name = String(e.name)), e.token != null && (n.token = String(e.token)), n;
    }, r.toObject = function(e, n) {
      n || (n = {});
      let o = {};
      return n.defaults && (o.name = "", o.token = ""), e.name != null && e.hasOwnProperty("name") && (o.name = e.name), e.token != null && e.hasOwnProperty("token") && (o.token = e.token), o;
    }, r.prototype.toJSON = function() {
      return this.constructor.toObject(this, minimal.util.toJSONOptions);
    }, r.getTypeUrl = function(e) {
      return e === void 0 && (e = "type.googleapis.com"), e + "/gcg.GetApiTokenResult";
    }, r;
  }(), u.DeleteApiTokenRequest = function() {
    function r(a) {
      if (a)
        for (let e = Object.keys(a), n = 0; n < e.length; ++n)
          a[e[n]] != null && (this[e[n]] = a[e[n]]);
    }
    return r.prototype.token = "", r.create = function(e) {
      return new r(e);
    }, r.encode = function(e, n) {
      return n || (n = $Writer.create()), e.token != null && Object.hasOwnProperty.call(e, "token") && n.uint32(
        /* id 1, wireType 2 =*/
        10
      ).string(e.token), n;
    }, r.encodeDelimited = function(e, n) {
      return this.encode(e, n).ldelim();
    }, r.decode = function(e, n) {
      e instanceof $Reader || (e = $Reader.create(e));
      let o = n === void 0 ? e.len : e.pos + n, c = new $root.gcg.DeleteApiTokenRequest();
      for (; e.pos < o; ) {
        let l = e.uint32();
        switch (l >>> 3) {
          case 1: {
            c.token = e.string();
            break;
          }
          default:
            e.skipType(l & 7);
            break;
        }
      }
      return c;
    }, r.decodeDelimited = function(e) {
      return e instanceof $Reader || (e = new $Reader(e)), this.decode(e, e.uint32());
    }, r.verify = function(e) {
      return typeof e != "object" || e === null ? "object expected" : e.token != null && e.hasOwnProperty("token") && !$util.isString(e.token) ? "token: string expected" : null;
    }, r.fromObject = function(e) {
      if (e instanceof $root.gcg.DeleteApiTokenRequest)
        return e;
      let n = new $root.gcg.DeleteApiTokenRequest();
      return e.token != null && (n.token = String(e.token)), n;
    }, r.toObject = function(e, n) {
      n || (n = {});
      let o = {};
      return n.defaults && (o.token = ""), e.token != null && e.hasOwnProperty("token") && (o.token = e.token), o;
    }, r.prototype.toJSON = function() {
      return this.constructor.toObject(this, minimal.util.toJSONOptions);
    }, r.getTypeUrl = function(e) {
      return e === void 0 && (e = "type.googleapis.com"), e + "/gcg.DeleteApiTokenRequest";
    }, r;
  }(), u.DeleteApiTokenResponse = function() {
    function r(a) {
      if (a)
        for (let e = Object.keys(a), n = 0; n < e.length; ++n)
          a[e[n]] != null && (this[e[n]] = a[e[n]]);
    }
    return r.create = function(e) {
      return new r(e);
    }, r.encode = function(e, n) {
      return n || (n = $Writer.create()), n;
    }, r.encodeDelimited = function(e, n) {
      return this.encode(e, n).ldelim();
    }, r.decode = function(e, n) {
      e instanceof $Reader || (e = $Reader.create(e));
      let o = n === void 0 ? e.len : e.pos + n, c = new $root.gcg.DeleteApiTokenResponse();
      for (; e.pos < o; ) {
        let l = e.uint32();
        switch (l >>> 3) {
          default:
            e.skipType(l & 7);
            break;
        }
      }
      return c;
    }, r.decodeDelimited = function(e) {
      return e instanceof $Reader || (e = new $Reader(e)), this.decode(e, e.uint32());
    }, r.verify = function(e) {
      return typeof e != "object" || e === null ? "object expected" : null;
    }, r.fromObject = function(e) {
      return e instanceof $root.gcg.DeleteApiTokenResponse ? e : new $root.gcg.DeleteApiTokenResponse();
    }, r.toObject = function() {
      return {};
    }, r.prototype.toJSON = function() {
      return this.constructor.toObject(this, minimal.util.toJSONOptions);
    }, r.getTypeUrl = function(e) {
      return e === void 0 && (e = "type.googleapis.com"), e + "/gcg.DeleteApiTokenResponse";
    }, r;
  }(), u.RetrieveResultEncryptionKeyRequest = function() {
    function r(a) {
      if (a)
        for (let e = Object.keys(a), n = 0; n < e.length; ++n)
          a[e[n]] != null && (this[e[n]] = a[e[n]]);
    }
    return r.prototype.jobId = "", r.prototype.taskResultHashHex = "", r.create = function(e) {
      return new r(e);
    }, r.encode = function(e, n) {
      return n || (n = $Writer.create()), e.jobId != null && Object.hasOwnProperty.call(e, "jobId") && n.uint32(
        /* id 1, wireType 2 =*/
        10
      ).string(e.jobId), e.taskResultHashHex != null && Object.hasOwnProperty.call(e, "taskResultHashHex") && n.uint32(
        /* id 2, wireType 2 =*/
        18
      ).string(e.taskResultHashHex), n;
    }, r.encodeDelimited = function(e, n) {
      return this.encode(e, n).ldelim();
    }, r.decode = function(e, n) {
      e instanceof $Reader || (e = $Reader.create(e));
      let o = n === void 0 ? e.len : e.pos + n, c = new $root.gcg.RetrieveResultEncryptionKeyRequest();
      for (; e.pos < o; ) {
        let l = e.uint32();
        switch (l >>> 3) {
          case 1: {
            c.jobId = e.string();
            break;
          }
          case 2: {
            c.taskResultHashHex = e.string();
            break;
          }
          default:
            e.skipType(l & 7);
            break;
        }
      }
      return c;
    }, r.decodeDelimited = function(e) {
      return e instanceof $Reader || (e = new $Reader(e)), this.decode(e, e.uint32());
    }, r.verify = function(e) {
      return typeof e != "object" || e === null ? "object expected" : e.jobId != null && e.hasOwnProperty("jobId") && !$util.isString(e.jobId) ? "jobId: string expected" : e.taskResultHashHex != null && e.hasOwnProperty("taskResultHashHex") && !$util.isString(e.taskResultHashHex) ? "taskResultHashHex: string expected" : null;
    }, r.fromObject = function(e) {
      if (e instanceof $root.gcg.RetrieveResultEncryptionKeyRequest)
        return e;
      let n = new $root.gcg.RetrieveResultEncryptionKeyRequest();
      return e.jobId != null && (n.jobId = String(e.jobId)), e.taskResultHashHex != null && (n.taskResultHashHex = String(e.taskResultHashHex)), n;
    }, r.toObject = function(e, n) {
      n || (n = {});
      let o = {};
      return n.defaults && (o.jobId = "", o.taskResultHashHex = ""), e.jobId != null && e.hasOwnProperty("jobId") && (o.jobId = e.jobId), e.taskResultHashHex != null && e.hasOwnProperty("taskResultHashHex") && (o.taskResultHashHex = e.taskResultHashHex), o;
    }, r.prototype.toJSON = function() {
      return this.constructor.toObject(this, minimal.util.toJSONOptions);
    }, r.getTypeUrl = function(e) {
      return e === void 0 && (e = "type.googleapis.com"), e + "/gcg.RetrieveResultEncryptionKeyRequest";
    }, r;
  }(), u.RetrieveResultEncryptionKeyResponse = function() {
    function r(a) {
      if (a)
        for (let e = Object.keys(a), n = 0; n < e.length; ++n)
          a[e[n]] != null && (this[e[n]] = a[e[n]]);
    }
    return r.prototype.manifestHashHex = "", r.prototype.encryptionKey = $util.newBuffer([]), r.create = function(e) {
      return new r(e);
    }, r.encode = function(e, n) {
      return n || (n = $Writer.create()), e.manifestHashHex != null && Object.hasOwnProperty.call(e, "manifestHashHex") && n.uint32(
        /* id 1, wireType 2 =*/
        10
      ).string(e.manifestHashHex), e.encryptionKey != null && Object.hasOwnProperty.call(e, "encryptionKey") && n.uint32(
        /* id 2, wireType 2 =*/
        18
      ).bytes(e.encryptionKey), n;
    }, r.encodeDelimited = function(e, n) {
      return this.encode(e, n).ldelim();
    }, r.decode = function(e, n) {
      e instanceof $Reader || (e = $Reader.create(e));
      let o = n === void 0 ? e.len : e.pos + n, c = new $root.gcg.RetrieveResultEncryptionKeyResponse();
      for (; e.pos < o; ) {
        let l = e.uint32();
        switch (l >>> 3) {
          case 1: {
            c.manifestHashHex = e.string();
            break;
          }
          case 2: {
            c.encryptionKey = e.bytes();
            break;
          }
          default:
            e.skipType(l & 7);
            break;
        }
      }
      return c;
    }, r.decodeDelimited = function(e) {
      return e instanceof $Reader || (e = new $Reader(e)), this.decode(e, e.uint32());
    }, r.verify = function(e) {
      return typeof e != "object" || e === null ? "object expected" : e.manifestHashHex != null && e.hasOwnProperty("manifestHashHex") && !$util.isString(e.manifestHashHex) ? "manifestHashHex: string expected" : e.encryptionKey != null && e.hasOwnProperty("encryptionKey") && !(e.encryptionKey && typeof e.encryptionKey.length == "number" || $util.isString(e.encryptionKey)) ? "encryptionKey: buffer expected" : null;
    }, r.fromObject = function(e) {
      if (e instanceof $root.gcg.RetrieveResultEncryptionKeyResponse)
        return e;
      let n = new $root.gcg.RetrieveResultEncryptionKeyResponse();
      return e.manifestHashHex != null && (n.manifestHashHex = String(e.manifestHashHex)), e.encryptionKey != null && (typeof e.encryptionKey == "string" ? $util.base64.decode(e.encryptionKey, n.encryptionKey = $util.newBuffer($util.base64.length(e.encryptionKey)), 0) : e.encryptionKey.length >= 0 && (n.encryptionKey = e.encryptionKey)), n;
    }, r.toObject = function(e, n) {
      n || (n = {});
      let o = {};
      return n.defaults && (o.manifestHashHex = "", n.bytes === String ? o.encryptionKey = "" : (o.encryptionKey = [], n.bytes !== Array && (o.encryptionKey = $util.newBuffer(o.encryptionKey)))), e.manifestHashHex != null && e.hasOwnProperty("manifestHashHex") && (o.manifestHashHex = e.manifestHashHex), e.encryptionKey != null && e.hasOwnProperty("encryptionKey") && (o.encryptionKey = n.bytes === String ? $util.base64.encode(e.encryptionKey, 0, e.encryptionKey.length) : n.bytes === Array ? Array.prototype.slice.call(e.encryptionKey) : e.encryptionKey), o;
    }, r.prototype.toJSON = function() {
      return this.constructor.toObject(this, minimal.util.toJSONOptions);
    }, r.getTypeUrl = function(e) {
      return e === void 0 && (e = "type.googleapis.com"), e + "/gcg.RetrieveResultEncryptionKeyResponse";
    }, r;
  }(), u.ExportResultAsDatasetRequest = function() {
    function r(e) {
      if (e)
        for (let n = Object.keys(e), o = 0; o < n.length; ++o)
          e[n[o]] != null && (this[n[o]] = e[n[o]]);
    }
    r.prototype.jobId = "", r.prototype.taskResultHashHex = "", r.prototype.datasetName = "", r.prototype.raw = null, r.prototype.zip = null;
    let a;
    return Object.defineProperty(r.prototype, "exportSpecification", {
      get: $util.oneOfGetter(a = ["raw", "zip"]),
      set: $util.oneOfSetter(a)
    }), r.create = function(n) {
      return new r(n);
    }, r.encode = function(n, o) {
      return o || (o = $Writer.create()), n.jobId != null && Object.hasOwnProperty.call(n, "jobId") && o.uint32(
        /* id 1, wireType 2 =*/
        10
      ).string(n.jobId), n.taskResultHashHex != null && Object.hasOwnProperty.call(n, "taskResultHashHex") && o.uint32(
        /* id 2, wireType 2 =*/
        18
      ).string(n.taskResultHashHex), n.datasetName != null && Object.hasOwnProperty.call(n, "datasetName") && o.uint32(
        /* id 3, wireType 2 =*/
        26
      ).string(n.datasetName), n.raw != null && Object.hasOwnProperty.call(n, "raw") && $root.gcg.RawExport.encode(n.raw, o.uint32(
        /* id 4, wireType 2 =*/
        34
      ).fork()).ldelim(), n.zip != null && Object.hasOwnProperty.call(n, "zip") && $root.gcg.ZipExport.encode(n.zip, o.uint32(
        /* id 5, wireType 2 =*/
        42
      ).fork()).ldelim(), o;
    }, r.encodeDelimited = function(n, o) {
      return this.encode(n, o).ldelim();
    }, r.decode = function(n, o) {
      n instanceof $Reader || (n = $Reader.create(n));
      let c = o === void 0 ? n.len : n.pos + o, l = new $root.gcg.ExportResultAsDatasetRequest();
      for (; n.pos < c; ) {
        let d = n.uint32();
        switch (d >>> 3) {
          case 1: {
            l.jobId = n.string();
            break;
          }
          case 2: {
            l.taskResultHashHex = n.string();
            break;
          }
          case 3: {
            l.datasetName = n.string();
            break;
          }
          case 4: {
            l.raw = $root.gcg.RawExport.decode(n, n.uint32());
            break;
          }
          case 5: {
            l.zip = $root.gcg.ZipExport.decode(n, n.uint32());
            break;
          }
          default:
            n.skipType(d & 7);
            break;
        }
      }
      return l;
    }, r.decodeDelimited = function(n) {
      return n instanceof $Reader || (n = new $Reader(n)), this.decode(n, n.uint32());
    }, r.verify = function(n) {
      if (typeof n != "object" || n === null)
        return "object expected";
      let o = {};
      if (n.jobId != null && n.hasOwnProperty("jobId") && !$util.isString(n.jobId))
        return "jobId: string expected";
      if (n.taskResultHashHex != null && n.hasOwnProperty("taskResultHashHex") && !$util.isString(n.taskResultHashHex))
        return "taskResultHashHex: string expected";
      if (n.datasetName != null && n.hasOwnProperty("datasetName") && !$util.isString(n.datasetName))
        return "datasetName: string expected";
      if (n.raw != null && n.hasOwnProperty("raw")) {
        o.exportSpecification = 1;
        {
          let c = $root.gcg.RawExport.verify(n.raw);
          if (c)
            return "raw." + c;
        }
      }
      if (n.zip != null && n.hasOwnProperty("zip")) {
        if (o.exportSpecification === 1)
          return "exportSpecification: multiple values";
        o.exportSpecification = 1;
        {
          let c = $root.gcg.ZipExport.verify(n.zip);
          if (c)
            return "zip." + c;
        }
      }
      return null;
    }, r.fromObject = function(n) {
      if (n instanceof $root.gcg.ExportResultAsDatasetRequest)
        return n;
      let o = new $root.gcg.ExportResultAsDatasetRequest();
      if (n.jobId != null && (o.jobId = String(n.jobId)), n.taskResultHashHex != null && (o.taskResultHashHex = String(n.taskResultHashHex)), n.datasetName != null && (o.datasetName = String(n.datasetName)), n.raw != null) {
        if (typeof n.raw != "object")
          throw TypeError(".gcg.ExportResultAsDatasetRequest.raw: object expected");
        o.raw = $root.gcg.RawExport.fromObject(n.raw);
      }
      if (n.zip != null) {
        if (typeof n.zip != "object")
          throw TypeError(".gcg.ExportResultAsDatasetRequest.zip: object expected");
        o.zip = $root.gcg.ZipExport.fromObject(n.zip);
      }
      return o;
    }, r.toObject = function(n, o) {
      o || (o = {});
      let c = {};
      return o.defaults && (c.jobId = "", c.taskResultHashHex = "", c.datasetName = ""), n.jobId != null && n.hasOwnProperty("jobId") && (c.jobId = n.jobId), n.taskResultHashHex != null && n.hasOwnProperty("taskResultHashHex") && (c.taskResultHashHex = n.taskResultHashHex), n.datasetName != null && n.hasOwnProperty("datasetName") && (c.datasetName = n.datasetName), n.raw != null && n.hasOwnProperty("raw") && (c.raw = $root.gcg.RawExport.toObject(n.raw, o), o.oneofs && (c.exportSpecification = "raw")), n.zip != null && n.hasOwnProperty("zip") && (c.zip = $root.gcg.ZipExport.toObject(n.zip, o), o.oneofs && (c.exportSpecification = "zip")), c;
    }, r.prototype.toJSON = function() {
      return this.constructor.toObject(this, minimal.util.toJSONOptions);
    }, r.getTypeUrl = function(n) {
      return n === void 0 && (n = "type.googleapis.com"), n + "/gcg.ExportResultAsDatasetRequest";
    }, r;
  }(), u.RawExport = function() {
    function r(a) {
      if (a)
        for (let e = Object.keys(a), n = 0; n < e.length; ++n)
          a[e[n]] != null && (this[e[n]] = a[e[n]]);
    }
    return r.create = function(e) {
      return new r(e);
    }, r.encode = function(e, n) {
      return n || (n = $Writer.create()), n;
    }, r.encodeDelimited = function(e, n) {
      return this.encode(e, n).ldelim();
    }, r.decode = function(e, n) {
      e instanceof $Reader || (e = $Reader.create(e));
      let o = n === void 0 ? e.len : e.pos + n, c = new $root.gcg.RawExport();
      for (; e.pos < o; ) {
        let l = e.uint32();
        switch (l >>> 3) {
          default:
            e.skipType(l & 7);
            break;
        }
      }
      return c;
    }, r.decodeDelimited = function(e) {
      return e instanceof $Reader || (e = new $Reader(e)), this.decode(e, e.uint32());
    }, r.verify = function(e) {
      return typeof e != "object" || e === null ? "object expected" : null;
    }, r.fromObject = function(e) {
      return e instanceof $root.gcg.RawExport ? e : new $root.gcg.RawExport();
    }, r.toObject = function() {
      return {};
    }, r.prototype.toJSON = function() {
      return this.constructor.toObject(this, minimal.util.toJSONOptions);
    }, r.getTypeUrl = function(e) {
      return e === void 0 && (e = "type.googleapis.com"), e + "/gcg.RawExport";
    }, r;
  }(), u.ZipExport = function() {
    function r(a) {
      if (a)
        for (let e = Object.keys(a), n = 0; n < e.length; ++n)
          a[e[n]] != null && (this[e[n]] = a[e[n]]);
    }
    return r.prototype.path = "", r.create = function(e) {
      return new r(e);
    }, r.encode = function(e, n) {
      return n || (n = $Writer.create()), e.path != null && Object.hasOwnProperty.call(e, "path") && n.uint32(
        /* id 1, wireType 2 =*/
        10
      ).string(e.path), n;
    }, r.encodeDelimited = function(e, n) {
      return this.encode(e, n).ldelim();
    }, r.decode = function(e, n) {
      e instanceof $Reader || (e = $Reader.create(e));
      let o = n === void 0 ? e.len : e.pos + n, c = new $root.gcg.ZipExport();
      for (; e.pos < o; ) {
        let l = e.uint32();
        switch (l >>> 3) {
          case 1: {
            c.path = e.string();
            break;
          }
          default:
            e.skipType(l & 7);
            break;
        }
      }
      return c;
    }, r.decodeDelimited = function(e) {
      return e instanceof $Reader || (e = new $Reader(e)), this.decode(e, e.uint32());
    }, r.verify = function(e) {
      return typeof e != "object" || e === null ? "object expected" : e.path != null && e.hasOwnProperty("path") && !$util.isString(e.path) ? "path: string expected" : null;
    }, r.fromObject = function(e) {
      if (e instanceof $root.gcg.ZipExport)
        return e;
      let n = new $root.gcg.ZipExport();
      return e.path != null && (n.path = String(e.path)), n;
    }, r.toObject = function(e, n) {
      n || (n = {});
      let o = {};
      return n.defaults && (o.path = ""), e.path != null && e.hasOwnProperty("path") && (o.path = e.path), o;
    }, r.prototype.toJSON = function() {
      return this.constructor.toObject(this, minimal.util.toJSONOptions);
    }, r.getTypeUrl = function(e) {
      return e === void 0 && (e = "type.googleapis.com"), e + "/gcg.ZipExport";
    }, r;
  }(), u.ExportResultAsDatasetResponse = function() {
    function r(a) {
      if (a)
        for (let e = Object.keys(a), n = 0; n < e.length; ++n)
          a[e[n]] != null && (this[e[n]] = a[e[n]]);
    }
    return r.prototype.manifestHashHex = "", r.prototype.datasetId = "", r.prototype.secretId = "", r.create = function(e) {
      return new r(e);
    }, r.encode = function(e, n) {
      return n || (n = $Writer.create()), e.manifestHashHex != null && Object.hasOwnProperty.call(e, "manifestHashHex") && n.uint32(
        /* id 1, wireType 2 =*/
        10
      ).string(e.manifestHashHex), e.datasetId != null && Object.hasOwnProperty.call(e, "datasetId") && n.uint32(
        /* id 2, wireType 2 =*/
        18
      ).string(e.datasetId), e.secretId != null && Object.hasOwnProperty.call(e, "secretId") && n.uint32(
        /* id 3, wireType 2 =*/
        26
      ).string(e.secretId), n;
    }, r.encodeDelimited = function(e, n) {
      return this.encode(e, n).ldelim();
    }, r.decode = function(e, n) {
      e instanceof $Reader || (e = $Reader.create(e));
      let o = n === void 0 ? e.len : e.pos + n, c = new $root.gcg.ExportResultAsDatasetResponse();
      for (; e.pos < o; ) {
        let l = e.uint32();
        switch (l >>> 3) {
          case 1: {
            c.manifestHashHex = e.string();
            break;
          }
          case 2: {
            c.datasetId = e.string();
            break;
          }
          case 3: {
            c.secretId = e.string();
            break;
          }
          default:
            e.skipType(l & 7);
            break;
        }
      }
      return c;
    }, r.decodeDelimited = function(e) {
      return e instanceof $Reader || (e = new $Reader(e)), this.decode(e, e.uint32());
    }, r.verify = function(e) {
      return typeof e != "object" || e === null ? "object expected" : e.manifestHashHex != null && e.hasOwnProperty("manifestHashHex") && !$util.isString(e.manifestHashHex) ? "manifestHashHex: string expected" : e.datasetId != null && e.hasOwnProperty("datasetId") && !$util.isString(e.datasetId) ? "datasetId: string expected" : e.secretId != null && e.hasOwnProperty("secretId") && !$util.isString(e.secretId) ? "secretId: string expected" : null;
    }, r.fromObject = function(e) {
      if (e instanceof $root.gcg.ExportResultAsDatasetResponse)
        return e;
      let n = new $root.gcg.ExportResultAsDatasetResponse();
      return e.manifestHashHex != null && (n.manifestHashHex = String(e.manifestHashHex)), e.datasetId != null && (n.datasetId = String(e.datasetId)), e.secretId != null && (n.secretId = String(e.secretId)), n;
    }, r.toObject = function(e, n) {
      n || (n = {});
      let o = {};
      return n.defaults && (o.manifestHashHex = "", o.datasetId = "", o.secretId = ""), e.manifestHashHex != null && e.hasOwnProperty("manifestHashHex") && (o.manifestHashHex = e.manifestHashHex), e.datasetId != null && e.hasOwnProperty("datasetId") && (o.datasetId = e.datasetId), e.secretId != null && e.hasOwnProperty("secretId") && (o.secretId = e.secretId), o;
    }, r.prototype.toJSON = function() {
      return this.constructor.toObject(this, minimal.util.toJSONOptions);
    }, r.getTypeUrl = function(e) {
      return e === void 0 && (e = "type.googleapis.com"), e + "/gcg.ExportResultAsDatasetResponse";
    }, r;
  }(), u;
})();
$root.identity_endorsement = (() => {
  const u = {};
  return u.EndorsementRequest = function() {
    function r(e) {
      if (e)
        for (let n = Object.keys(e), o = 0; o < n.length; ++o)
          e[n[o]] != null && (this[n[o]] = e[n[o]]);
    }
    r.prototype.pkiEndorsementRequest = null, r.prototype.dcrSecretEndorsementRequest = null;
    let a;
    return Object.defineProperty(r.prototype, "endorsementRequest", {
      get: $util.oneOfGetter(a = ["pkiEndorsementRequest", "dcrSecretEndorsementRequest"]),
      set: $util.oneOfSetter(a)
    }), r.create = function(n) {
      return new r(n);
    }, r.encode = function(n, o) {
      return o || (o = $Writer.create()), n.pkiEndorsementRequest != null && Object.hasOwnProperty.call(n, "pkiEndorsementRequest") && $root.identity_endorsement.PkiEndorsementRequest.encode(n.pkiEndorsementRequest, o.uint32(
        /* id 2, wireType 2 =*/
        18
      ).fork()).ldelim(), n.dcrSecretEndorsementRequest != null && Object.hasOwnProperty.call(n, "dcrSecretEndorsementRequest") && $root.identity_endorsement.DcrSecretEndorsementRequest.encode(n.dcrSecretEndorsementRequest, o.uint32(
        /* id 3, wireType 2 =*/
        26
      ).fork()).ldelim(), o;
    }, r.encodeDelimited = function(n, o) {
      return this.encode(n, o).ldelim();
    }, r.decode = function(n, o) {
      n instanceof $Reader || (n = $Reader.create(n));
      let c = o === void 0 ? n.len : n.pos + o, l = new $root.identity_endorsement.EndorsementRequest();
      for (; n.pos < c; ) {
        let d = n.uint32();
        switch (d >>> 3) {
          case 2: {
            l.pkiEndorsementRequest = $root.identity_endorsement.PkiEndorsementRequest.decode(n, n.uint32());
            break;
          }
          case 3: {
            l.dcrSecretEndorsementRequest = $root.identity_endorsement.DcrSecretEndorsementRequest.decode(n, n.uint32());
            break;
          }
          default:
            n.skipType(d & 7);
            break;
        }
      }
      return l;
    }, r.decodeDelimited = function(n) {
      return n instanceof $Reader || (n = new $Reader(n)), this.decode(n, n.uint32());
    }, r.verify = function(n) {
      if (typeof n != "object" || n === null)
        return "object expected";
      let o = {};
      if (n.pkiEndorsementRequest != null && n.hasOwnProperty("pkiEndorsementRequest")) {
        o.endorsementRequest = 1;
        {
          let c = $root.identity_endorsement.PkiEndorsementRequest.verify(n.pkiEndorsementRequest);
          if (c)
            return "pkiEndorsementRequest." + c;
        }
      }
      if (n.dcrSecretEndorsementRequest != null && n.hasOwnProperty("dcrSecretEndorsementRequest")) {
        if (o.endorsementRequest === 1)
          return "endorsementRequest: multiple values";
        o.endorsementRequest = 1;
        {
          let c = $root.identity_endorsement.DcrSecretEndorsementRequest.verify(n.dcrSecretEndorsementRequest);
          if (c)
            return "dcrSecretEndorsementRequest." + c;
        }
      }
      return null;
    }, r.fromObject = function(n) {
      if (n instanceof $root.identity_endorsement.EndorsementRequest)
        return n;
      let o = new $root.identity_endorsement.EndorsementRequest();
      if (n.pkiEndorsementRequest != null) {
        if (typeof n.pkiEndorsementRequest != "object")
          throw TypeError(".identity_endorsement.EndorsementRequest.pkiEndorsementRequest: object expected");
        o.pkiEndorsementRequest = $root.identity_endorsement.PkiEndorsementRequest.fromObject(n.pkiEndorsementRequest);
      }
      if (n.dcrSecretEndorsementRequest != null) {
        if (typeof n.dcrSecretEndorsementRequest != "object")
          throw TypeError(".identity_endorsement.EndorsementRequest.dcrSecretEndorsementRequest: object expected");
        o.dcrSecretEndorsementRequest = $root.identity_endorsement.DcrSecretEndorsementRequest.fromObject(n.dcrSecretEndorsementRequest);
      }
      return o;
    }, r.toObject = function(n, o) {
      o || (o = {});
      let c = {};
      return n.pkiEndorsementRequest != null && n.hasOwnProperty("pkiEndorsementRequest") && (c.pkiEndorsementRequest = $root.identity_endorsement.PkiEndorsementRequest.toObject(n.pkiEndorsementRequest, o), o.oneofs && (c.endorsementRequest = "pkiEndorsementRequest")), n.dcrSecretEndorsementRequest != null && n.hasOwnProperty("dcrSecretEndorsementRequest") && (c.dcrSecretEndorsementRequest = $root.identity_endorsement.DcrSecretEndorsementRequest.toObject(n.dcrSecretEndorsementRequest, o), o.oneofs && (c.endorsementRequest = "dcrSecretEndorsementRequest")), c;
    }, r.prototype.toJSON = function() {
      return this.constructor.toObject(this, minimal.util.toJSONOptions);
    }, r.getTypeUrl = function(n) {
      return n === void 0 && (n = "type.googleapis.com"), n + "/identity_endorsement.EndorsementRequest";
    }, r;
  }(), u.EndorsementResponse = function() {
    function r(e) {
      if (e)
        for (let n = Object.keys(e), o = 0; o < n.length; ++o)
          e[n[o]] != null && (this[n[o]] = e[n[o]]);
    }
    r.prototype.pkiEndorsementResponse = null, r.prototype.dcrSecretEndorsementResponse = null;
    let a;
    return Object.defineProperty(r.prototype, "endorsementResponse", {
      get: $util.oneOfGetter(a = ["pkiEndorsementResponse", "dcrSecretEndorsementResponse"]),
      set: $util.oneOfSetter(a)
    }), r.create = function(n) {
      return new r(n);
    }, r.encode = function(n, o) {
      return o || (o = $Writer.create()), n.pkiEndorsementResponse != null && Object.hasOwnProperty.call(n, "pkiEndorsementResponse") && $root.identity_endorsement.PkiEndorsementResponse.encode(n.pkiEndorsementResponse, o.uint32(
        /* id 2, wireType 2 =*/
        18
      ).fork()).ldelim(), n.dcrSecretEndorsementResponse != null && Object.hasOwnProperty.call(n, "dcrSecretEndorsementResponse") && $root.identity_endorsement.DcrSecretEndorsementResponse.encode(n.dcrSecretEndorsementResponse, o.uint32(
        /* id 3, wireType 2 =*/
        26
      ).fork()).ldelim(), o;
    }, r.encodeDelimited = function(n, o) {
      return this.encode(n, o).ldelim();
    }, r.decode = function(n, o) {
      n instanceof $Reader || (n = $Reader.create(n));
      let c = o === void 0 ? n.len : n.pos + o, l = new $root.identity_endorsement.EndorsementResponse();
      for (; n.pos < c; ) {
        let d = n.uint32();
        switch (d >>> 3) {
          case 2: {
            l.pkiEndorsementResponse = $root.identity_endorsement.PkiEndorsementResponse.decode(n, n.uint32());
            break;
          }
          case 3: {
            l.dcrSecretEndorsementResponse = $root.identity_endorsement.DcrSecretEndorsementResponse.decode(n, n.uint32());
            break;
          }
          default:
            n.skipType(d & 7);
            break;
        }
      }
      return l;
    }, r.decodeDelimited = function(n) {
      return n instanceof $Reader || (n = new $Reader(n)), this.decode(n, n.uint32());
    }, r.verify = function(n) {
      if (typeof n != "object" || n === null)
        return "object expected";
      let o = {};
      if (n.pkiEndorsementResponse != null && n.hasOwnProperty("pkiEndorsementResponse")) {
        o.endorsementResponse = 1;
        {
          let c = $root.identity_endorsement.PkiEndorsementResponse.verify(n.pkiEndorsementResponse);
          if (c)
            return "pkiEndorsementResponse." + c;
        }
      }
      if (n.dcrSecretEndorsementResponse != null && n.hasOwnProperty("dcrSecretEndorsementResponse")) {
        if (o.endorsementResponse === 1)
          return "endorsementResponse: multiple values";
        o.endorsementResponse = 1;
        {
          let c = $root.identity_endorsement.DcrSecretEndorsementResponse.verify(n.dcrSecretEndorsementResponse);
          if (c)
            return "dcrSecretEndorsementResponse." + c;
        }
      }
      return null;
    }, r.fromObject = function(n) {
      if (n instanceof $root.identity_endorsement.EndorsementResponse)
        return n;
      let o = new $root.identity_endorsement.EndorsementResponse();
      if (n.pkiEndorsementResponse != null) {
        if (typeof n.pkiEndorsementResponse != "object")
          throw TypeError(".identity_endorsement.EndorsementResponse.pkiEndorsementResponse: object expected");
        o.pkiEndorsementResponse = $root.identity_endorsement.PkiEndorsementResponse.fromObject(n.pkiEndorsementResponse);
      }
      if (n.dcrSecretEndorsementResponse != null) {
        if (typeof n.dcrSecretEndorsementResponse != "object")
          throw TypeError(".identity_endorsement.EndorsementResponse.dcrSecretEndorsementResponse: object expected");
        o.dcrSecretEndorsementResponse = $root.identity_endorsement.DcrSecretEndorsementResponse.fromObject(n.dcrSecretEndorsementResponse);
      }
      return o;
    }, r.toObject = function(n, o) {
      o || (o = {});
      let c = {};
      return n.pkiEndorsementResponse != null && n.hasOwnProperty("pkiEndorsementResponse") && (c.pkiEndorsementResponse = $root.identity_endorsement.PkiEndorsementResponse.toObject(n.pkiEndorsementResponse, o), o.oneofs && (c.endorsementResponse = "pkiEndorsementResponse")), n.dcrSecretEndorsementResponse != null && n.hasOwnProperty("dcrSecretEndorsementResponse") && (c.dcrSecretEndorsementResponse = $root.identity_endorsement.DcrSecretEndorsementResponse.toObject(n.dcrSecretEndorsementResponse, o), o.oneofs && (c.endorsementResponse = "dcrSecretEndorsementResponse")), c;
    }, r.prototype.toJSON = function() {
      return this.constructor.toObject(this, minimal.util.toJSONOptions);
    }, r.getTypeUrl = function(n) {
      return n === void 0 && (n = "type.googleapis.com"), n + "/identity_endorsement.EndorsementResponse";
    }, r;
  }(), u.PkiEndorsementRequest = function() {
    function r(a) {
      if (a)
        for (let e = Object.keys(a), n = 0; n < e.length; ++n)
          a[e[n]] != null && (this[e[n]] = a[e[n]]);
    }
    return r.prototype.certificateChainPem = $util.newBuffer([]), r.create = function(e) {
      return new r(e);
    }, r.encode = function(e, n) {
      return n || (n = $Writer.create()), e.certificateChainPem != null && Object.hasOwnProperty.call(e, "certificateChainPem") && n.uint32(
        /* id 1, wireType 2 =*/
        10
      ).bytes(e.certificateChainPem), n;
    }, r.encodeDelimited = function(e, n) {
      return this.encode(e, n).ldelim();
    }, r.decode = function(e, n) {
      e instanceof $Reader || (e = $Reader.create(e));
      let o = n === void 0 ? e.len : e.pos + n, c = new $root.identity_endorsement.PkiEndorsementRequest();
      for (; e.pos < o; ) {
        let l = e.uint32();
        switch (l >>> 3) {
          case 1: {
            c.certificateChainPem = e.bytes();
            break;
          }
          default:
            e.skipType(l & 7);
            break;
        }
      }
      return c;
    }, r.decodeDelimited = function(e) {
      return e instanceof $Reader || (e = new $Reader(e)), this.decode(e, e.uint32());
    }, r.verify = function(e) {
      return typeof e != "object" || e === null ? "object expected" : e.certificateChainPem != null && e.hasOwnProperty("certificateChainPem") && !(e.certificateChainPem && typeof e.certificateChainPem.length == "number" || $util.isString(e.certificateChainPem)) ? "certificateChainPem: buffer expected" : null;
    }, r.fromObject = function(e) {
      if (e instanceof $root.identity_endorsement.PkiEndorsementRequest)
        return e;
      let n = new $root.identity_endorsement.PkiEndorsementRequest();
      return e.certificateChainPem != null && (typeof e.certificateChainPem == "string" ? $util.base64.decode(e.certificateChainPem, n.certificateChainPem = $util.newBuffer($util.base64.length(e.certificateChainPem)), 0) : e.certificateChainPem.length >= 0 && (n.certificateChainPem = e.certificateChainPem)), n;
    }, r.toObject = function(e, n) {
      n || (n = {});
      let o = {};
      return n.defaults && (n.bytes === String ? o.certificateChainPem = "" : (o.certificateChainPem = [], n.bytes !== Array && (o.certificateChainPem = $util.newBuffer(o.certificateChainPem)))), e.certificateChainPem != null && e.hasOwnProperty("certificateChainPem") && (o.certificateChainPem = n.bytes === String ? $util.base64.encode(e.certificateChainPem, 0, e.certificateChainPem.length) : n.bytes === Array ? Array.prototype.slice.call(e.certificateChainPem) : e.certificateChainPem), o;
    }, r.prototype.toJSON = function() {
      return this.constructor.toObject(this, minimal.util.toJSONOptions);
    }, r.getTypeUrl = function(e) {
      return e === void 0 && (e = "type.googleapis.com"), e + "/identity_endorsement.PkiEndorsementRequest";
    }, r;
  }(), u.PkiEndorsementResponse = function() {
    function r(a) {
      if (a)
        for (let e = Object.keys(a), n = 0; n < e.length; ++n)
          a[e[n]] != null && (this[e[n]] = a[e[n]]);
    }
    return r.prototype.pkiEndorsement = null, r.create = function(e) {
      return new r(e);
    }, r.encode = function(e, n) {
      return n || (n = $Writer.create()), e.pkiEndorsement != null && Object.hasOwnProperty.call(e, "pkiEndorsement") && $root.identity_endorsement.EnclaveEndorsement.encode(e.pkiEndorsement, n.uint32(
        /* id 1, wireType 2 =*/
        10
      ).fork()).ldelim(), n;
    }, r.encodeDelimited = function(e, n) {
      return this.encode(e, n).ldelim();
    }, r.decode = function(e, n) {
      e instanceof $Reader || (e = $Reader.create(e));
      let o = n === void 0 ? e.len : e.pos + n, c = new $root.identity_endorsement.PkiEndorsementResponse();
      for (; e.pos < o; ) {
        let l = e.uint32();
        switch (l >>> 3) {
          case 1: {
            c.pkiEndorsement = $root.identity_endorsement.EnclaveEndorsement.decode(e, e.uint32());
            break;
          }
          default:
            e.skipType(l & 7);
            break;
        }
      }
      return c;
    }, r.decodeDelimited = function(e) {
      return e instanceof $Reader || (e = new $Reader(e)), this.decode(e, e.uint32());
    }, r.verify = function(e) {
      if (typeof e != "object" || e === null)
        return "object expected";
      if (e.pkiEndorsement != null && e.hasOwnProperty("pkiEndorsement")) {
        let n = $root.identity_endorsement.EnclaveEndorsement.verify(e.pkiEndorsement);
        if (n)
          return "pkiEndorsement." + n;
      }
      return null;
    }, r.fromObject = function(e) {
      if (e instanceof $root.identity_endorsement.PkiEndorsementResponse)
        return e;
      let n = new $root.identity_endorsement.PkiEndorsementResponse();
      if (e.pkiEndorsement != null) {
        if (typeof e.pkiEndorsement != "object")
          throw TypeError(".identity_endorsement.PkiEndorsementResponse.pkiEndorsement: object expected");
        n.pkiEndorsement = $root.identity_endorsement.EnclaveEndorsement.fromObject(e.pkiEndorsement);
      }
      return n;
    }, r.toObject = function(e, n) {
      n || (n = {});
      let o = {};
      return n.defaults && (o.pkiEndorsement = null), e.pkiEndorsement != null && e.hasOwnProperty("pkiEndorsement") && (o.pkiEndorsement = $root.identity_endorsement.EnclaveEndorsement.toObject(e.pkiEndorsement, n)), o;
    }, r.prototype.toJSON = function() {
      return this.constructor.toObject(this, minimal.util.toJSONOptions);
    }, r.getTypeUrl = function(e) {
      return e === void 0 && (e = "type.googleapis.com"), e + "/identity_endorsement.PkiEndorsementResponse";
    }, r;
  }(), u.DcrSecretEndorsementRequest = function() {
    function r(a) {
      if (a)
        for (let e = Object.keys(a), n = 0; n < e.length; ++n)
          a[e[n]] != null && (this[e[n]] = a[e[n]]);
    }
    return r.prototype.dcrSecret = "", r.create = function(e) {
      return new r(e);
    }, r.encode = function(e, n) {
      return n || (n = $Writer.create()), e.dcrSecret != null && Object.hasOwnProperty.call(e, "dcrSecret") && n.uint32(
        /* id 1, wireType 2 =*/
        10
      ).string(e.dcrSecret), n;
    }, r.encodeDelimited = function(e, n) {
      return this.encode(e, n).ldelim();
    }, r.decode = function(e, n) {
      e instanceof $Reader || (e = $Reader.create(e));
      let o = n === void 0 ? e.len : e.pos + n, c = new $root.identity_endorsement.DcrSecretEndorsementRequest();
      for (; e.pos < o; ) {
        let l = e.uint32();
        switch (l >>> 3) {
          case 1: {
            c.dcrSecret = e.string();
            break;
          }
          default:
            e.skipType(l & 7);
            break;
        }
      }
      return c;
    }, r.decodeDelimited = function(e) {
      return e instanceof $Reader || (e = new $Reader(e)), this.decode(e, e.uint32());
    }, r.verify = function(e) {
      return typeof e != "object" || e === null ? "object expected" : e.dcrSecret != null && e.hasOwnProperty("dcrSecret") && !$util.isString(e.dcrSecret) ? "dcrSecret: string expected" : null;
    }, r.fromObject = function(e) {
      if (e instanceof $root.identity_endorsement.DcrSecretEndorsementRequest)
        return e;
      let n = new $root.identity_endorsement.DcrSecretEndorsementRequest();
      return e.dcrSecret != null && (n.dcrSecret = String(e.dcrSecret)), n;
    }, r.toObject = function(e, n) {
      n || (n = {});
      let o = {};
      return n.defaults && (o.dcrSecret = ""), e.dcrSecret != null && e.hasOwnProperty("dcrSecret") && (o.dcrSecret = e.dcrSecret), o;
    }, r.prototype.toJSON = function() {
      return this.constructor.toObject(this, minimal.util.toJSONOptions);
    }, r.getTypeUrl = function(e) {
      return e === void 0 && (e = "type.googleapis.com"), e + "/identity_endorsement.DcrSecretEndorsementRequest";
    }, r;
  }(), u.DcrSecretEndorsementResponse = function() {
    function r(a) {
      if (a)
        for (let e = Object.keys(a), n = 0; n < e.length; ++n)
          a[e[n]] != null && (this[e[n]] = a[e[n]]);
    }
    return r.prototype.dcrSecretEndorsement = null, r.prototype.dcrSecretId = $util.newBuffer([]), r.create = function(e) {
      return new r(e);
    }, r.encode = function(e, n) {
      return n || (n = $Writer.create()), e.dcrSecretEndorsement != null && Object.hasOwnProperty.call(e, "dcrSecretEndorsement") && $root.identity_endorsement.EnclaveEndorsement.encode(e.dcrSecretEndorsement, n.uint32(
        /* id 1, wireType 2 =*/
        10
      ).fork()).ldelim(), e.dcrSecretId != null && Object.hasOwnProperty.call(e, "dcrSecretId") && n.uint32(
        /* id 2, wireType 2 =*/
        18
      ).bytes(e.dcrSecretId), n;
    }, r.encodeDelimited = function(e, n) {
      return this.encode(e, n).ldelim();
    }, r.decode = function(e, n) {
      e instanceof $Reader || (e = $Reader.create(e));
      let o = n === void 0 ? e.len : e.pos + n, c = new $root.identity_endorsement.DcrSecretEndorsementResponse();
      for (; e.pos < o; ) {
        let l = e.uint32();
        switch (l >>> 3) {
          case 1: {
            c.dcrSecretEndorsement = $root.identity_endorsement.EnclaveEndorsement.decode(e, e.uint32());
            break;
          }
          case 2: {
            c.dcrSecretId = e.bytes();
            break;
          }
          default:
            e.skipType(l & 7);
            break;
        }
      }
      return c;
    }, r.decodeDelimited = function(e) {
      return e instanceof $Reader || (e = new $Reader(e)), this.decode(e, e.uint32());
    }, r.verify = function(e) {
      if (typeof e != "object" || e === null)
        return "object expected";
      if (e.dcrSecretEndorsement != null && e.hasOwnProperty("dcrSecretEndorsement")) {
        let n = $root.identity_endorsement.EnclaveEndorsement.verify(e.dcrSecretEndorsement);
        if (n)
          return "dcrSecretEndorsement." + n;
      }
      return e.dcrSecretId != null && e.hasOwnProperty("dcrSecretId") && !(e.dcrSecretId && typeof e.dcrSecretId.length == "number" || $util.isString(e.dcrSecretId)) ? "dcrSecretId: buffer expected" : null;
    }, r.fromObject = function(e) {
      if (e instanceof $root.identity_endorsement.DcrSecretEndorsementResponse)
        return e;
      let n = new $root.identity_endorsement.DcrSecretEndorsementResponse();
      if (e.dcrSecretEndorsement != null) {
        if (typeof e.dcrSecretEndorsement != "object")
          throw TypeError(".identity_endorsement.DcrSecretEndorsementResponse.dcrSecretEndorsement: object expected");
        n.dcrSecretEndorsement = $root.identity_endorsement.EnclaveEndorsement.fromObject(e.dcrSecretEndorsement);
      }
      return e.dcrSecretId != null && (typeof e.dcrSecretId == "string" ? $util.base64.decode(e.dcrSecretId, n.dcrSecretId = $util.newBuffer($util.base64.length(e.dcrSecretId)), 0) : e.dcrSecretId.length >= 0 && (n.dcrSecretId = e.dcrSecretId)), n;
    }, r.toObject = function(e, n) {
      n || (n = {});
      let o = {};
      return n.defaults && (o.dcrSecretEndorsement = null, n.bytes === String ? o.dcrSecretId = "" : (o.dcrSecretId = [], n.bytes !== Array && (o.dcrSecretId = $util.newBuffer(o.dcrSecretId)))), e.dcrSecretEndorsement != null && e.hasOwnProperty("dcrSecretEndorsement") && (o.dcrSecretEndorsement = $root.identity_endorsement.EnclaveEndorsement.toObject(e.dcrSecretEndorsement, n)), e.dcrSecretId != null && e.hasOwnProperty("dcrSecretId") && (o.dcrSecretId = n.bytes === String ? $util.base64.encode(e.dcrSecretId, 0, e.dcrSecretId.length) : n.bytes === Array ? Array.prototype.slice.call(e.dcrSecretId) : e.dcrSecretId), o;
    }, r.prototype.toJSON = function() {
      return this.constructor.toObject(this, minimal.util.toJSONOptions);
    }, r.getTypeUrl = function(e) {
      return e === void 0 && (e = "type.googleapis.com"), e + "/identity_endorsement.DcrSecretEndorsementResponse";
    }, r;
  }(), u.EnclaveEndorsements = function() {
    function r(a) {
      if (a)
        for (let e = Object.keys(a), n = 0; n < e.length; ++n)
          a[e[n]] != null && (this[e[n]] = a[e[n]]);
    }
    return r.prototype.personalPki = null, r.prototype.dqPki = null, r.prototype.dcrSecret = null, r.create = function(e) {
      return new r(e);
    }, r.encode = function(e, n) {
      return n || (n = $Writer.create()), e.personalPki != null && Object.hasOwnProperty.call(e, "personalPki") && $root.identity_endorsement.EnclaveEndorsement.encode(e.personalPki, n.uint32(
        /* id 1, wireType 2 =*/
        10
      ).fork()).ldelim(), e.dqPki != null && Object.hasOwnProperty.call(e, "dqPki") && $root.identity_endorsement.EnclaveEndorsement.encode(e.dqPki, n.uint32(
        /* id 2, wireType 2 =*/
        18
      ).fork()).ldelim(), e.dcrSecret != null && Object.hasOwnProperty.call(e, "dcrSecret") && $root.identity_endorsement.EnclaveEndorsement.encode(e.dcrSecret, n.uint32(
        /* id 3, wireType 2 =*/
        26
      ).fork()).ldelim(), n;
    }, r.encodeDelimited = function(e, n) {
      return this.encode(e, n).ldelim();
    }, r.decode = function(e, n) {
      e instanceof $Reader || (e = $Reader.create(e));
      let o = n === void 0 ? e.len : e.pos + n, c = new $root.identity_endorsement.EnclaveEndorsements();
      for (; e.pos < o; ) {
        let l = e.uint32();
        switch (l >>> 3) {
          case 1: {
            c.personalPki = $root.identity_endorsement.EnclaveEndorsement.decode(e, e.uint32());
            break;
          }
          case 2: {
            c.dqPki = $root.identity_endorsement.EnclaveEndorsement.decode(e, e.uint32());
            break;
          }
          case 3: {
            c.dcrSecret = $root.identity_endorsement.EnclaveEndorsement.decode(e, e.uint32());
            break;
          }
          default:
            e.skipType(l & 7);
            break;
        }
      }
      return c;
    }, r.decodeDelimited = function(e) {
      return e instanceof $Reader || (e = new $Reader(e)), this.decode(e, e.uint32());
    }, r.verify = function(e) {
      if (typeof e != "object" || e === null)
        return "object expected";
      if (e.personalPki != null && e.hasOwnProperty("personalPki")) {
        let n = $root.identity_endorsement.EnclaveEndorsement.verify(e.personalPki);
        if (n)
          return "personalPki." + n;
      }
      if (e.dqPki != null && e.hasOwnProperty("dqPki")) {
        let n = $root.identity_endorsement.EnclaveEndorsement.verify(e.dqPki);
        if (n)
          return "dqPki." + n;
      }
      if (e.dcrSecret != null && e.hasOwnProperty("dcrSecret")) {
        let n = $root.identity_endorsement.EnclaveEndorsement.verify(e.dcrSecret);
        if (n)
          return "dcrSecret." + n;
      }
      return null;
    }, r.fromObject = function(e) {
      if (e instanceof $root.identity_endorsement.EnclaveEndorsements)
        return e;
      let n = new $root.identity_endorsement.EnclaveEndorsements();
      if (e.personalPki != null) {
        if (typeof e.personalPki != "object")
          throw TypeError(".identity_endorsement.EnclaveEndorsements.personalPki: object expected");
        n.personalPki = $root.identity_endorsement.EnclaveEndorsement.fromObject(e.personalPki);
      }
      if (e.dqPki != null) {
        if (typeof e.dqPki != "object")
          throw TypeError(".identity_endorsement.EnclaveEndorsements.dqPki: object expected");
        n.dqPki = $root.identity_endorsement.EnclaveEndorsement.fromObject(e.dqPki);
      }
      if (e.dcrSecret != null) {
        if (typeof e.dcrSecret != "object")
          throw TypeError(".identity_endorsement.EnclaveEndorsements.dcrSecret: object expected");
        n.dcrSecret = $root.identity_endorsement.EnclaveEndorsement.fromObject(e.dcrSecret);
      }
      return n;
    }, r.toObject = function(e, n) {
      n || (n = {});
      let o = {};
      return n.defaults && (o.personalPki = null, o.dqPki = null, o.dcrSecret = null), e.personalPki != null && e.hasOwnProperty("personalPki") && (o.personalPki = $root.identity_endorsement.EnclaveEndorsement.toObject(e.personalPki, n)), e.dqPki != null && e.hasOwnProperty("dqPki") && (o.dqPki = $root.identity_endorsement.EnclaveEndorsement.toObject(e.dqPki, n)), e.dcrSecret != null && e.hasOwnProperty("dcrSecret") && (o.dcrSecret = $root.identity_endorsement.EnclaveEndorsement.toObject(e.dcrSecret, n)), o;
    }, r.prototype.toJSON = function() {
      return this.constructor.toObject(this, minimal.util.toJSONOptions);
    }, r.getTypeUrl = function(e) {
      return e === void 0 && (e = "type.googleapis.com"), e + "/identity_endorsement.EnclaveEndorsements";
    }, r;
  }(), u.EnclaveEndorsement = function() {
    function r(a) {
      if (a)
        for (let e = Object.keys(a), n = 0; n < e.length; ++n)
          a[e[n]] != null && (this[e[n]] = a[e[n]]);
    }
    return r.prototype.endorsementCertificateDer = $util.newBuffer([]), r.create = function(e) {
      return new r(e);
    }, r.encode = function(e, n) {
      return n || (n = $Writer.create()), e.endorsementCertificateDer != null && Object.hasOwnProperty.call(e, "endorsementCertificateDer") && n.uint32(
        /* id 1, wireType 2 =*/
        10
      ).bytes(e.endorsementCertificateDer), n;
    }, r.encodeDelimited = function(e, n) {
      return this.encode(e, n).ldelim();
    }, r.decode = function(e, n) {
      e instanceof $Reader || (e = $Reader.create(e));
      let o = n === void 0 ? e.len : e.pos + n, c = new $root.identity_endorsement.EnclaveEndorsement();
      for (; e.pos < o; ) {
        let l = e.uint32();
        switch (l >>> 3) {
          case 1: {
            c.endorsementCertificateDer = e.bytes();
            break;
          }
          default:
            e.skipType(l & 7);
            break;
        }
      }
      return c;
    }, r.decodeDelimited = function(e) {
      return e instanceof $Reader || (e = new $Reader(e)), this.decode(e, e.uint32());
    }, r.verify = function(e) {
      return typeof e != "object" || e === null ? "object expected" : e.endorsementCertificateDer != null && e.hasOwnProperty("endorsementCertificateDer") && !(e.endorsementCertificateDer && typeof e.endorsementCertificateDer.length == "number" || $util.isString(e.endorsementCertificateDer)) ? "endorsementCertificateDer: buffer expected" : null;
    }, r.fromObject = function(e) {
      if (e instanceof $root.identity_endorsement.EnclaveEndorsement)
        return e;
      let n = new $root.identity_endorsement.EnclaveEndorsement();
      return e.endorsementCertificateDer != null && (typeof e.endorsementCertificateDer == "string" ? $util.base64.decode(e.endorsementCertificateDer, n.endorsementCertificateDer = $util.newBuffer($util.base64.length(e.endorsementCertificateDer)), 0) : e.endorsementCertificateDer.length >= 0 && (n.endorsementCertificateDer = e.endorsementCertificateDer)), n;
    }, r.toObject = function(e, n) {
      n || (n = {});
      let o = {};
      return n.defaults && (n.bytes === String ? o.endorsementCertificateDer = "" : (o.endorsementCertificateDer = [], n.bytes !== Array && (o.endorsementCertificateDer = $util.newBuffer(o.endorsementCertificateDer)))), e.endorsementCertificateDer != null && e.hasOwnProperty("endorsementCertificateDer") && (o.endorsementCertificateDer = n.bytes === String ? $util.base64.encode(e.endorsementCertificateDer, 0, e.endorsementCertificateDer.length) : n.bytes === Array ? Array.prototype.slice.call(e.endorsementCertificateDer) : e.endorsementCertificateDer), o;
    }, r.prototype.toJSON = function() {
      return this.constructor.toObject(this, minimal.util.toJSONOptions);
    }, r.getTypeUrl = function(e) {
      return e === void 0 && (e = "type.googleapis.com"), e + "/identity_endorsement.EnclaveEndorsement";
    }, r;
  }(), u.PkiClaim = function() {
    function r(a) {
      if (a)
        for (let e = Object.keys(a), n = 0; n < e.length; ++n)
          a[e[n]] != null && (this[e[n]] = a[e[n]]);
    }
    return r.prototype.rootCertificateDer = $util.newBuffer([]), r.create = function(e) {
      return new r(e);
    }, r.encode = function(e, n) {
      return n || (n = $Writer.create()), e.rootCertificateDer != null && Object.hasOwnProperty.call(e, "rootCertificateDer") && n.uint32(
        /* id 1, wireType 2 =*/
        10
      ).bytes(e.rootCertificateDer), n;
    }, r.encodeDelimited = function(e, n) {
      return this.encode(e, n).ldelim();
    }, r.decode = function(e, n) {
      e instanceof $Reader || (e = $Reader.create(e));
      let o = n === void 0 ? e.len : e.pos + n, c = new $root.identity_endorsement.PkiClaim();
      for (; e.pos < o; ) {
        let l = e.uint32();
        switch (l >>> 3) {
          case 1: {
            c.rootCertificateDer = e.bytes();
            break;
          }
          default:
            e.skipType(l & 7);
            break;
        }
      }
      return c;
    }, r.decodeDelimited = function(e) {
      return e instanceof $Reader || (e = new $Reader(e)), this.decode(e, e.uint32());
    }, r.verify = function(e) {
      return typeof e != "object" || e === null ? "object expected" : e.rootCertificateDer != null && e.hasOwnProperty("rootCertificateDer") && !(e.rootCertificateDer && typeof e.rootCertificateDer.length == "number" || $util.isString(e.rootCertificateDer)) ? "rootCertificateDer: buffer expected" : null;
    }, r.fromObject = function(e) {
      if (e instanceof $root.identity_endorsement.PkiClaim)
        return e;
      let n = new $root.identity_endorsement.PkiClaim();
      return e.rootCertificateDer != null && (typeof e.rootCertificateDer == "string" ? $util.base64.decode(e.rootCertificateDer, n.rootCertificateDer = $util.newBuffer($util.base64.length(e.rootCertificateDer)), 0) : e.rootCertificateDer.length >= 0 && (n.rootCertificateDer = e.rootCertificateDer)), n;
    }, r.toObject = function(e, n) {
      n || (n = {});
      let o = {};
      return n.defaults && (n.bytes === String ? o.rootCertificateDer = "" : (o.rootCertificateDer = [], n.bytes !== Array && (o.rootCertificateDer = $util.newBuffer(o.rootCertificateDer)))), e.rootCertificateDer != null && e.hasOwnProperty("rootCertificateDer") && (o.rootCertificateDer = n.bytes === String ? $util.base64.encode(e.rootCertificateDer, 0, e.rootCertificateDer.length) : n.bytes === Array ? Array.prototype.slice.call(e.rootCertificateDer) : e.rootCertificateDer), o;
    }, r.prototype.toJSON = function() {
      return this.constructor.toObject(this, minimal.util.toJSONOptions);
    }, r.getTypeUrl = function(e) {
      return e === void 0 && (e = "type.googleapis.com"), e + "/identity_endorsement.PkiClaim";
    }, r;
  }(), u.DcrSecretClaim = function() {
    function r(a) {
      if (a)
        for (let e = Object.keys(a), n = 0; n < e.length; ++n)
          a[e[n]] != null && (this[e[n]] = a[e[n]]);
    }
    return r.prototype.dcrSecretId = $util.newBuffer([]), r.create = function(e) {
      return new r(e);
    }, r.encode = function(e, n) {
      return n || (n = $Writer.create()), e.dcrSecretId != null && Object.hasOwnProperty.call(e, "dcrSecretId") && n.uint32(
        /* id 1, wireType 2 =*/
        10
      ).bytes(e.dcrSecretId), n;
    }, r.encodeDelimited = function(e, n) {
      return this.encode(e, n).ldelim();
    }, r.decode = function(e, n) {
      e instanceof $Reader || (e = $Reader.create(e));
      let o = n === void 0 ? e.len : e.pos + n, c = new $root.identity_endorsement.DcrSecretClaim();
      for (; e.pos < o; ) {
        let l = e.uint32();
        switch (l >>> 3) {
          case 1: {
            c.dcrSecretId = e.bytes();
            break;
          }
          default:
            e.skipType(l & 7);
            break;
        }
      }
      return c;
    }, r.decodeDelimited = function(e) {
      return e instanceof $Reader || (e = new $Reader(e)), this.decode(e, e.uint32());
    }, r.verify = function(e) {
      return typeof e != "object" || e === null ? "object expected" : e.dcrSecretId != null && e.hasOwnProperty("dcrSecretId") && !(e.dcrSecretId && typeof e.dcrSecretId.length == "number" || $util.isString(e.dcrSecretId)) ? "dcrSecretId: buffer expected" : null;
    }, r.fromObject = function(e) {
      if (e instanceof $root.identity_endorsement.DcrSecretClaim)
        return e;
      let n = new $root.identity_endorsement.DcrSecretClaim();
      return e.dcrSecretId != null && (typeof e.dcrSecretId == "string" ? $util.base64.decode(e.dcrSecretId, n.dcrSecretId = $util.newBuffer($util.base64.length(e.dcrSecretId)), 0) : e.dcrSecretId.length >= 0 && (n.dcrSecretId = e.dcrSecretId)), n;
    }, r.toObject = function(e, n) {
      n || (n = {});
      let o = {};
      return n.defaults && (n.bytes === String ? o.dcrSecretId = "" : (o.dcrSecretId = [], n.bytes !== Array && (o.dcrSecretId = $util.newBuffer(o.dcrSecretId)))), e.dcrSecretId != null && e.hasOwnProperty("dcrSecretId") && (o.dcrSecretId = n.bytes === String ? $util.base64.encode(e.dcrSecretId, 0, e.dcrSecretId.length) : n.bytes === Array ? Array.prototype.slice.call(e.dcrSecretId) : e.dcrSecretId), o;
    }, r.prototype.toJSON = function() {
      return this.constructor.toObject(this, minimal.util.toJSONOptions);
    }, r.getTypeUrl = function(e) {
      return e === void 0 && (e = "type.googleapis.com"), e + "/identity_endorsement.DcrSecretClaim";
    }, r;
  }(), u;
})();
$root.release_policy_api = (() => {
  const u = {};
  return u.ReleasePolicy = function() {
    function r(e) {
      if (e)
        for (let n = Object.keys(e), o = 0; o < n.length; ++o)
          e[n[o]] != null && (this[n[o]] = e[n[o]]);
    }
    r.prototype.v0 = null;
    let a;
    return Object.defineProperty(r.prototype, "version", {
      get: $util.oneOfGetter(a = ["v0"]),
      set: $util.oneOfSetter(a)
    }), r.create = function(n) {
      return new r(n);
    }, r.encode = function(n, o) {
      return o || (o = $Writer.create()), n.v0 != null && Object.hasOwnProperty.call(n, "v0") && $root.release_policy_api.ReleasePolicyV0.encode(n.v0, o.uint32(
        /* id 1, wireType 2 =*/
        10
      ).fork()).ldelim(), o;
    }, r.encodeDelimited = function(n, o) {
      return this.encode(n, o).ldelim();
    }, r.decode = function(n, o) {
      n instanceof $Reader || (n = $Reader.create(n));
      let c = o === void 0 ? n.len : n.pos + o, l = new $root.release_policy_api.ReleasePolicy();
      for (; n.pos < c; ) {
        let d = n.uint32();
        switch (d >>> 3) {
          case 1: {
            l.v0 = $root.release_policy_api.ReleasePolicyV0.decode(n, n.uint32());
            break;
          }
          default:
            n.skipType(d & 7);
            break;
        }
      }
      return l;
    }, r.decodeDelimited = function(n) {
      return n instanceof $Reader || (n = new $Reader(n)), this.decode(n, n.uint32());
    }, r.verify = function(n) {
      if (typeof n != "object" || n === null)
        return "object expected";
      if (n.v0 != null && n.hasOwnProperty("v0")) {
        let o = $root.release_policy_api.ReleasePolicyV0.verify(n.v0);
        if (o)
          return "v0." + o;
      }
      return null;
    }, r.fromObject = function(n) {
      if (n instanceof $root.release_policy_api.ReleasePolicy)
        return n;
      let o = new $root.release_policy_api.ReleasePolicy();
      if (n.v0 != null) {
        if (typeof n.v0 != "object")
          throw TypeError(".release_policy_api.ReleasePolicy.v0: object expected");
        o.v0 = $root.release_policy_api.ReleasePolicyV0.fromObject(n.v0);
      }
      return o;
    }, r.toObject = function(n, o) {
      o || (o = {});
      let c = {};
      return n.v0 != null && n.hasOwnProperty("v0") && (c.v0 = $root.release_policy_api.ReleasePolicyV0.toObject(n.v0, o), o.oneofs && (c.version = "v0")), c;
    }, r.prototype.toJSON = function() {
      return this.constructor.toObject(this, minimal.util.toJSONOptions);
    }, r.getTypeUrl = function(n) {
      return n === void 0 && (n = "type.googleapis.com"), n + "/release_policy_api.ReleasePolicy";
    }, r;
  }(), u.ReleasePolicyV0 = function() {
    function r(a) {
      if (a)
        for (let e = Object.keys(a), n = 0; n < e.length; ++n)
          a[e[n]] != null && (this[e[n]] = a[e[n]]);
    }
    return r.prototype.secretSource = null, r.prototype.allowedComputeContext = null, r.create = function(e) {
      return new r(e);
    }, r.encode = function(e, n) {
      return n || (n = $Writer.create()), e.secretSource != null && Object.hasOwnProperty.call(e, "secretSource") && $root.release_policy_api.SecretSource.encode(e.secretSource, n.uint32(
        /* id 1, wireType 2 =*/
        10
      ).fork()).ldelim(), e.allowedComputeContext != null && Object.hasOwnProperty.call(e, "allowedComputeContext") && $root.release_policy_api.AllowedComputeContext.encode(e.allowedComputeContext, n.uint32(
        /* id 2, wireType 2 =*/
        18
      ).fork()).ldelim(), n;
    }, r.encodeDelimited = function(e, n) {
      return this.encode(e, n).ldelim();
    }, r.decode = function(e, n) {
      e instanceof $Reader || (e = $Reader.create(e));
      let o = n === void 0 ? e.len : e.pos + n, c = new $root.release_policy_api.ReleasePolicyV0();
      for (; e.pos < o; ) {
        let l = e.uint32();
        switch (l >>> 3) {
          case 1: {
            c.secretSource = $root.release_policy_api.SecretSource.decode(e, e.uint32());
            break;
          }
          case 2: {
            c.allowedComputeContext = $root.release_policy_api.AllowedComputeContext.decode(e, e.uint32());
            break;
          }
          default:
            e.skipType(l & 7);
            break;
        }
      }
      return c;
    }, r.decodeDelimited = function(e) {
      return e instanceof $Reader || (e = new $Reader(e)), this.decode(e, e.uint32());
    }, r.verify = function(e) {
      if (typeof e != "object" || e === null)
        return "object expected";
      if (e.secretSource != null && e.hasOwnProperty("secretSource")) {
        let n = $root.release_policy_api.SecretSource.verify(e.secretSource);
        if (n)
          return "secretSource." + n;
      }
      if (e.allowedComputeContext != null && e.hasOwnProperty("allowedComputeContext")) {
        let n = $root.release_policy_api.AllowedComputeContext.verify(e.allowedComputeContext);
        if (n)
          return "allowedComputeContext." + n;
      }
      return null;
    }, r.fromObject = function(e) {
      if (e instanceof $root.release_policy_api.ReleasePolicyV0)
        return e;
      let n = new $root.release_policy_api.ReleasePolicyV0();
      if (e.secretSource != null) {
        if (typeof e.secretSource != "object")
          throw TypeError(".release_policy_api.ReleasePolicyV0.secretSource: object expected");
        n.secretSource = $root.release_policy_api.SecretSource.fromObject(e.secretSource);
      }
      if (e.allowedComputeContext != null) {
        if (typeof e.allowedComputeContext != "object")
          throw TypeError(".release_policy_api.ReleasePolicyV0.allowedComputeContext: object expected");
        n.allowedComputeContext = $root.release_policy_api.AllowedComputeContext.fromObject(e.allowedComputeContext);
      }
      return n;
    }, r.toObject = function(e, n) {
      n || (n = {});
      let o = {};
      return n.defaults && (o.secretSource = null, o.allowedComputeContext = null), e.secretSource != null && e.hasOwnProperty("secretSource") && (o.secretSource = $root.release_policy_api.SecretSource.toObject(e.secretSource, n)), e.allowedComputeContext != null && e.hasOwnProperty("allowedComputeContext") && (o.allowedComputeContext = $root.release_policy_api.AllowedComputeContext.toObject(e.allowedComputeContext, n)), o;
    }, r.prototype.toJSON = function() {
      return this.constructor.toObject(this, minimal.util.toJSONOptions);
    }, r.getTypeUrl = function(e) {
      return e === void 0 && (e = "type.googleapis.com"), e + "/release_policy_api.ReleasePolicyV0";
    }, r;
  }(), u.AllowedComputeContext = function() {
    function r(e) {
      if (e)
        for (let n = Object.keys(e), o = 0; o < n.length; ++o)
          e[n[o]] != null && (this[n[o]] = e[n[o]]);
    }
    r.prototype.dcr = null;
    let a;
    return Object.defineProperty(r.prototype, "kind", {
      get: $util.oneOfGetter(a = ["dcr"]),
      set: $util.oneOfSetter(a)
    }), r.create = function(n) {
      return new r(n);
    }, r.encode = function(n, o) {
      return o || (o = $Writer.create()), n.dcr != null && Object.hasOwnProperty.call(n, "dcr") && $root.release_policy_api.DcrComputeContext.encode(n.dcr, o.uint32(
        /* id 1, wireType 2 =*/
        10
      ).fork()).ldelim(), o;
    }, r.encodeDelimited = function(n, o) {
      return this.encode(n, o).ldelim();
    }, r.decode = function(n, o) {
      n instanceof $Reader || (n = $Reader.create(n));
      let c = o === void 0 ? n.len : n.pos + o, l = new $root.release_policy_api.AllowedComputeContext();
      for (; n.pos < c; ) {
        let d = n.uint32();
        switch (d >>> 3) {
          case 1: {
            l.dcr = $root.release_policy_api.DcrComputeContext.decode(n, n.uint32());
            break;
          }
          default:
            n.skipType(d & 7);
            break;
        }
      }
      return l;
    }, r.decodeDelimited = function(n) {
      return n instanceof $Reader || (n = new $Reader(n)), this.decode(n, n.uint32());
    }, r.verify = function(n) {
      if (typeof n != "object" || n === null)
        return "object expected";
      if (n.dcr != null && n.hasOwnProperty("dcr")) {
        let o = $root.release_policy_api.DcrComputeContext.verify(n.dcr);
        if (o)
          return "dcr." + o;
      }
      return null;
    }, r.fromObject = function(n) {
      if (n instanceof $root.release_policy_api.AllowedComputeContext)
        return n;
      let o = new $root.release_policy_api.AllowedComputeContext();
      if (n.dcr != null) {
        if (typeof n.dcr != "object")
          throw TypeError(".release_policy_api.AllowedComputeContext.dcr: object expected");
        o.dcr = $root.release_policy_api.DcrComputeContext.fromObject(n.dcr);
      }
      return o;
    }, r.toObject = function(n, o) {
      o || (o = {});
      let c = {};
      return n.dcr != null && n.hasOwnProperty("dcr") && (c.dcr = $root.release_policy_api.DcrComputeContext.toObject(n.dcr, o), o.oneofs && (c.kind = "dcr")), c;
    }, r.prototype.toJSON = function() {
      return this.constructor.toObject(this, minimal.util.toJSONOptions);
    }, r.getTypeUrl = function(n) {
      return n === void 0 && (n = "type.googleapis.com"), n + "/release_policy_api.AllowedComputeContext";
    }, r;
  }(), u.DcrComputeContext = function() {
    function r(a) {
      if (a)
        for (let e = Object.keys(a), n = 0; n < e.length; ++n)
          a[e[n]] != null && (this[e[n]] = a[e[n]]);
    }
    return r.prototype.dataRoomId = "", r.prototype.targetLeaf = "", r.create = function(e) {
      return new r(e);
    }, r.encode = function(e, n) {
      return n || (n = $Writer.create()), e.dataRoomId != null && Object.hasOwnProperty.call(e, "dataRoomId") && n.uint32(
        /* id 1, wireType 2 =*/
        10
      ).string(e.dataRoomId), e.targetLeaf != null && Object.hasOwnProperty.call(e, "targetLeaf") && n.uint32(
        /* id 2, wireType 2 =*/
        18
      ).string(e.targetLeaf), n;
    }, r.encodeDelimited = function(e, n) {
      return this.encode(e, n).ldelim();
    }, r.decode = function(e, n) {
      e instanceof $Reader || (e = $Reader.create(e));
      let o = n === void 0 ? e.len : e.pos + n, c = new $root.release_policy_api.DcrComputeContext();
      for (; e.pos < o; ) {
        let l = e.uint32();
        switch (l >>> 3) {
          case 1: {
            c.dataRoomId = e.string();
            break;
          }
          case 2: {
            c.targetLeaf = e.string();
            break;
          }
          default:
            e.skipType(l & 7);
            break;
        }
      }
      return c;
    }, r.decodeDelimited = function(e) {
      return e instanceof $Reader || (e = new $Reader(e)), this.decode(e, e.uint32());
    }, r.verify = function(e) {
      return typeof e != "object" || e === null ? "object expected" : e.dataRoomId != null && e.hasOwnProperty("dataRoomId") && !$util.isString(e.dataRoomId) ? "dataRoomId: string expected" : e.targetLeaf != null && e.hasOwnProperty("targetLeaf") && !$util.isString(e.targetLeaf) ? "targetLeaf: string expected" : null;
    }, r.fromObject = function(e) {
      if (e instanceof $root.release_policy_api.DcrComputeContext)
        return e;
      let n = new $root.release_policy_api.DcrComputeContext();
      return e.dataRoomId != null && (n.dataRoomId = String(e.dataRoomId)), e.targetLeaf != null && (n.targetLeaf = String(e.targetLeaf)), n;
    }, r.toObject = function(e, n) {
      n || (n = {});
      let o = {};
      return n.defaults && (o.dataRoomId = "", o.targetLeaf = ""), e.dataRoomId != null && e.hasOwnProperty("dataRoomId") && (o.dataRoomId = e.dataRoomId), e.targetLeaf != null && e.hasOwnProperty("targetLeaf") && (o.targetLeaf = e.targetLeaf), o;
    }, r.prototype.toJSON = function() {
      return this.constructor.toObject(this, minimal.util.toJSONOptions);
    }, r.getTypeUrl = function(e) {
      return e === void 0 && (e = "type.googleapis.com"), e + "/release_policy_api.DcrComputeContext";
    }, r;
  }(), u.SecretSource = function() {
    function r(e) {
      if (e)
        for (let n = Object.keys(e), o = 0; o < n.length; ++o)
          e[n[o]] != null && (this[n[o]] = e[n[o]]);
    }
    r.prototype.secretStore = null;
    let a;
    return Object.defineProperty(r.prototype, "kind", {
      get: $util.oneOfGetter(a = ["secretStore"]),
      set: $util.oneOfSetter(a)
    }), r.create = function(n) {
      return new r(n);
    }, r.encode = function(n, o) {
      return o || (o = $Writer.create()), n.secretStore != null && Object.hasOwnProperty.call(n, "secretStore") && $root.release_policy_api.SecretStoreSource.encode(n.secretStore, o.uint32(
        /* id 1, wireType 2 =*/
        10
      ).fork()).ldelim(), o;
    }, r.encodeDelimited = function(n, o) {
      return this.encode(n, o).ldelim();
    }, r.decode = function(n, o) {
      n instanceof $Reader || (n = $Reader.create(n));
      let c = o === void 0 ? n.len : n.pos + o, l = new $root.release_policy_api.SecretSource();
      for (; n.pos < c; ) {
        let d = n.uint32();
        switch (d >>> 3) {
          case 1: {
            l.secretStore = $root.release_policy_api.SecretStoreSource.decode(n, n.uint32());
            break;
          }
          default:
            n.skipType(d & 7);
            break;
        }
      }
      return l;
    }, r.decodeDelimited = function(n) {
      return n instanceof $Reader || (n = new $Reader(n)), this.decode(n, n.uint32());
    }, r.verify = function(n) {
      if (typeof n != "object" || n === null)
        return "object expected";
      if (n.secretStore != null && n.hasOwnProperty("secretStore")) {
        let o = $root.release_policy_api.SecretStoreSource.verify(n.secretStore);
        if (o)
          return "secretStore." + o;
      }
      return null;
    }, r.fromObject = function(n) {
      if (n instanceof $root.release_policy_api.SecretSource)
        return n;
      let o = new $root.release_policy_api.SecretSource();
      if (n.secretStore != null) {
        if (typeof n.secretStore != "object")
          throw TypeError(".release_policy_api.SecretSource.secretStore: object expected");
        o.secretStore = $root.release_policy_api.SecretStoreSource.fromObject(n.secretStore);
      }
      return o;
    }, r.toObject = function(n, o) {
      o || (o = {});
      let c = {};
      return n.secretStore != null && n.hasOwnProperty("secretStore") && (c.secretStore = $root.release_policy_api.SecretStoreSource.toObject(n.secretStore, o), o.oneofs && (c.kind = "secretStore")), c;
    }, r.prototype.toJSON = function() {
      return this.constructor.toObject(this, minimal.util.toJSONOptions);
    }, r.getTypeUrl = function(n) {
      return n === void 0 && (n = "type.googleapis.com"), n + "/release_policy_api.SecretSource";
    }, r;
  }(), u.SecretStoreSource = function() {
    function r(a) {
      if (a)
        for (let e = Object.keys(a), n = 0; n < e.length; ++n)
          a[e[n]] != null && (this[e[n]] = a[e[n]]);
    }
    return r.prototype.secretId = "", r.create = function(e) {
      return new r(e);
    }, r.encode = function(e, n) {
      return n || (n = $Writer.create()), e.secretId != null && Object.hasOwnProperty.call(e, "secretId") && n.uint32(
        /* id 1, wireType 2 =*/
        10
      ).string(e.secretId), n;
    }, r.encodeDelimited = function(e, n) {
      return this.encode(e, n).ldelim();
    }, r.decode = function(e, n) {
      e instanceof $Reader || (e = $Reader.create(e));
      let o = n === void 0 ? e.len : e.pos + n, c = new $root.release_policy_api.SecretStoreSource();
      for (; e.pos < o; ) {
        let l = e.uint32();
        switch (l >>> 3) {
          case 1: {
            c.secretId = e.string();
            break;
          }
          default:
            e.skipType(l & 7);
            break;
        }
      }
      return c;
    }, r.decodeDelimited = function(e) {
      return e instanceof $Reader || (e = new $Reader(e)), this.decode(e, e.uint32());
    }, r.verify = function(e) {
      return typeof e != "object" || e === null ? "object expected" : e.secretId != null && e.hasOwnProperty("secretId") && !$util.isString(e.secretId) ? "secretId: string expected" : null;
    }, r.fromObject = function(e) {
      if (e instanceof $root.release_policy_api.SecretStoreSource)
        return e;
      let n = new $root.release_policy_api.SecretStoreSource();
      return e.secretId != null && (n.secretId = String(e.secretId)), n;
    }, r.toObject = function(e, n) {
      n || (n = {});
      let o = {};
      return n.defaults && (o.secretId = ""), e.secretId != null && e.hasOwnProperty("secretId") && (o.secretId = e.secretId), o;
    }, r.prototype.toJSON = function() {
      return this.constructor.toObject(this, minimal.util.toJSONOptions);
    }, r.getTypeUrl = function(e) {
      return e === void 0 && (e = "type.googleapis.com"), e + "/release_policy_api.SecretStoreSource";
    }, r;
  }(), u;
})();
$root.secret_store_api = (() => {
  const u = {};
  return u.SecretStoreEntry = function() {
    function r(a) {
      if (a)
        for (let e = Object.keys(a), n = 0; n < e.length; ++n)
          a[e[n]] != null && (this[e[n]] = a[e[n]]);
    }
    return r.prototype.content = $util.newBuffer([]), r.prototype.state = $util.newBuffer([]), r.create = function(e) {
      return new r(e);
    }, r.encode = function(e, n) {
      return n || (n = $Writer.create()), e.content != null && Object.hasOwnProperty.call(e, "content") && n.uint32(
        /* id 1, wireType 2 =*/
        10
      ).bytes(e.content), e.state != null && Object.hasOwnProperty.call(e, "state") && n.uint32(
        /* id 2, wireType 2 =*/
        18
      ).bytes(e.state), n;
    }, r.encodeDelimited = function(e, n) {
      return this.encode(e, n).ldelim();
    }, r.decode = function(e, n) {
      e instanceof $Reader || (e = $Reader.create(e));
      let o = n === void 0 ? e.len : e.pos + n, c = new $root.secret_store_api.SecretStoreEntry();
      for (; e.pos < o; ) {
        let l = e.uint32();
        switch (l >>> 3) {
          case 1: {
            c.content = e.bytes();
            break;
          }
          case 2: {
            c.state = e.bytes();
            break;
          }
          default:
            e.skipType(l & 7);
            break;
        }
      }
      return c;
    }, r.decodeDelimited = function(e) {
      return e instanceof $Reader || (e = new $Reader(e)), this.decode(e, e.uint32());
    }, r.verify = function(e) {
      return typeof e != "object" || e === null ? "object expected" : e.content != null && e.hasOwnProperty("content") && !(e.content && typeof e.content.length == "number" || $util.isString(e.content)) ? "content: buffer expected" : e.state != null && e.hasOwnProperty("state") && !(e.state && typeof e.state.length == "number" || $util.isString(e.state)) ? "state: buffer expected" : null;
    }, r.fromObject = function(e) {
      if (e instanceof $root.secret_store_api.SecretStoreEntry)
        return e;
      let n = new $root.secret_store_api.SecretStoreEntry();
      return e.content != null && (typeof e.content == "string" ? $util.base64.decode(e.content, n.content = $util.newBuffer($util.base64.length(e.content)), 0) : e.content.length >= 0 && (n.content = e.content)), e.state != null && (typeof e.state == "string" ? $util.base64.decode(e.state, n.state = $util.newBuffer($util.base64.length(e.state)), 0) : e.state.length >= 0 && (n.state = e.state)), n;
    }, r.toObject = function(e, n) {
      n || (n = {});
      let o = {};
      return n.defaults && (n.bytes === String ? o.content = "" : (o.content = [], n.bytes !== Array && (o.content = $util.newBuffer(o.content))), n.bytes === String ? o.state = "" : (o.state = [], n.bytes !== Array && (o.state = $util.newBuffer(o.state)))), e.content != null && e.hasOwnProperty("content") && (o.content = n.bytes === String ? $util.base64.encode(e.content, 0, e.content.length) : n.bytes === Array ? Array.prototype.slice.call(e.content) : e.content), e.state != null && e.hasOwnProperty("state") && (o.state = n.bytes === String ? $util.base64.encode(e.state, 0, e.state.length) : n.bytes === Array ? Array.prototype.slice.call(e.state) : e.state), o;
    }, r.prototype.toJSON = function() {
      return this.constructor.toObject(this, minimal.util.toJSONOptions);
    }, r.getTypeUrl = function(e) {
      return e === void 0 && (e = "type.googleapis.com"), e + "/secret_store_api.SecretStoreEntry";
    }, r;
  }(), u.CreateSecretRequest = function() {
    function r(a) {
      if (a)
        for (let e = Object.keys(a), n = 0; n < e.length; ++n)
          a[e[n]] != null && (this[e[n]] = a[e[n]]);
    }
    return r.prototype.secret = null, r.create = function(e) {
      return new r(e);
    }, r.encode = function(e, n) {
      return n || (n = $Writer.create()), e.secret != null && Object.hasOwnProperty.call(e, "secret") && $root.secret_store_api.SecretStoreEntry.encode(e.secret, n.uint32(
        /* id 1, wireType 2 =*/
        10
      ).fork()).ldelim(), n;
    }, r.encodeDelimited = function(e, n) {
      return this.encode(e, n).ldelim();
    }, r.decode = function(e, n) {
      e instanceof $Reader || (e = $Reader.create(e));
      let o = n === void 0 ? e.len : e.pos + n, c = new $root.secret_store_api.CreateSecretRequest();
      for (; e.pos < o; ) {
        let l = e.uint32();
        switch (l >>> 3) {
          case 1: {
            c.secret = $root.secret_store_api.SecretStoreEntry.decode(e, e.uint32());
            break;
          }
          default:
            e.skipType(l & 7);
            break;
        }
      }
      return c;
    }, r.decodeDelimited = function(e) {
      return e instanceof $Reader || (e = new $Reader(e)), this.decode(e, e.uint32());
    }, r.verify = function(e) {
      if (typeof e != "object" || e === null)
        return "object expected";
      if (e.secret != null && e.hasOwnProperty("secret")) {
        let n = $root.secret_store_api.SecretStoreEntry.verify(e.secret);
        if (n)
          return "secret." + n;
      }
      return null;
    }, r.fromObject = function(e) {
      if (e instanceof $root.secret_store_api.CreateSecretRequest)
        return e;
      let n = new $root.secret_store_api.CreateSecretRequest();
      if (e.secret != null) {
        if (typeof e.secret != "object")
          throw TypeError(".secret_store_api.CreateSecretRequest.secret: object expected");
        n.secret = $root.secret_store_api.SecretStoreEntry.fromObject(e.secret);
      }
      return n;
    }, r.toObject = function(e, n) {
      n || (n = {});
      let o = {};
      return n.defaults && (o.secret = null), e.secret != null && e.hasOwnProperty("secret") && (o.secret = $root.secret_store_api.SecretStoreEntry.toObject(e.secret, n)), o;
    }, r.prototype.toJSON = function() {
      return this.constructor.toObject(this, minimal.util.toJSONOptions);
    }, r.getTypeUrl = function(e) {
      return e === void 0 && (e = "type.googleapis.com"), e + "/secret_store_api.CreateSecretRequest";
    }, r;
  }(), u.CreateSecretResponse = function() {
    function r(a) {
      if (a)
        for (let e = Object.keys(a), n = 0; n < e.length; ++n)
          a[e[n]] != null && (this[e[n]] = a[e[n]]);
    }
    return r.prototype.id = "", r.create = function(e) {
      return new r(e);
    }, r.encode = function(e, n) {
      return n || (n = $Writer.create()), e.id != null && Object.hasOwnProperty.call(e, "id") && n.uint32(
        /* id 1, wireType 2 =*/
        10
      ).string(e.id), n;
    }, r.encodeDelimited = function(e, n) {
      return this.encode(e, n).ldelim();
    }, r.decode = function(e, n) {
      e instanceof $Reader || (e = $Reader.create(e));
      let o = n === void 0 ? e.len : e.pos + n, c = new $root.secret_store_api.CreateSecretResponse();
      for (; e.pos < o; ) {
        let l = e.uint32();
        switch (l >>> 3) {
          case 1: {
            c.id = e.string();
            break;
          }
          default:
            e.skipType(l & 7);
            break;
        }
      }
      return c;
    }, r.decodeDelimited = function(e) {
      return e instanceof $Reader || (e = new $Reader(e)), this.decode(e, e.uint32());
    }, r.verify = function(e) {
      return typeof e != "object" || e === null ? "object expected" : e.id != null && e.hasOwnProperty("id") && !$util.isString(e.id) ? "id: string expected" : null;
    }, r.fromObject = function(e) {
      if (e instanceof $root.secret_store_api.CreateSecretResponse)
        return e;
      let n = new $root.secret_store_api.CreateSecretResponse();
      return e.id != null && (n.id = String(e.id)), n;
    }, r.toObject = function(e, n) {
      n || (n = {});
      let o = {};
      return n.defaults && (o.id = ""), e.id != null && e.hasOwnProperty("id") && (o.id = e.id), o;
    }, r.prototype.toJSON = function() {
      return this.constructor.toObject(this, minimal.util.toJSONOptions);
    }, r.getTypeUrl = function(e) {
      return e === void 0 && (e = "type.googleapis.com"), e + "/secret_store_api.CreateSecretResponse";
    }, r;
  }(), u.GetSecretRequest = function() {
    function r(a) {
      if (a)
        for (let e = Object.keys(a), n = 0; n < e.length; ++n)
          a[e[n]] != null && (this[e[n]] = a[e[n]]);
    }
    return r.prototype.id = "", r.prototype.version = 0, r.create = function(e) {
      return new r(e);
    }, r.encode = function(e, n) {
      return n || (n = $Writer.create()), e.id != null && Object.hasOwnProperty.call(e, "id") && n.uint32(
        /* id 1, wireType 2 =*/
        10
      ).string(e.id), e.version != null && Object.hasOwnProperty.call(e, "version") && n.uint32(
        /* id 2, wireType 0 =*/
        16
      ).uint32(e.version), n;
    }, r.encodeDelimited = function(e, n) {
      return this.encode(e, n).ldelim();
    }, r.decode = function(e, n) {
      e instanceof $Reader || (e = $Reader.create(e));
      let o = n === void 0 ? e.len : e.pos + n, c = new $root.secret_store_api.GetSecretRequest();
      for (; e.pos < o; ) {
        let l = e.uint32();
        switch (l >>> 3) {
          case 1: {
            c.id = e.string();
            break;
          }
          case 2: {
            c.version = e.uint32();
            break;
          }
          default:
            e.skipType(l & 7);
            break;
        }
      }
      return c;
    }, r.decodeDelimited = function(e) {
      return e instanceof $Reader || (e = new $Reader(e)), this.decode(e, e.uint32());
    }, r.verify = function(e) {
      return typeof e != "object" || e === null ? "object expected" : e.id != null && e.hasOwnProperty("id") && !$util.isString(e.id) ? "id: string expected" : e.version != null && e.hasOwnProperty("version") && !$util.isInteger(e.version) ? "version: integer expected" : null;
    }, r.fromObject = function(e) {
      if (e instanceof $root.secret_store_api.GetSecretRequest)
        return e;
      let n = new $root.secret_store_api.GetSecretRequest();
      return e.id != null && (n.id = String(e.id)), e.version != null && (n.version = e.version >>> 0), n;
    }, r.toObject = function(e, n) {
      n || (n = {});
      let o = {};
      return n.defaults && (o.id = "", o.version = 0), e.id != null && e.hasOwnProperty("id") && (o.id = e.id), e.version != null && e.hasOwnProperty("version") && (o.version = e.version), o;
    }, r.prototype.toJSON = function() {
      return this.constructor.toObject(this, minimal.util.toJSONOptions);
    }, r.getTypeUrl = function(e) {
      return e === void 0 && (e = "type.googleapis.com"), e + "/secret_store_api.GetSecretRequest";
    }, r;
  }(), u.GetSecretResponse = function() {
    function r(a) {
      if (a)
        for (let e = Object.keys(a), n = 0; n < e.length; ++n)
          a[e[n]] != null && (this[e[n]] = a[e[n]]);
    }
    return r.prototype.secret = null, r.prototype.casIndex = $util.Long ? $util.Long.fromBits(0, 0, !0) : 0, r.create = function(e) {
      return new r(e);
    }, r.encode = function(e, n) {
      return n || (n = $Writer.create()), e.secret != null && Object.hasOwnProperty.call(e, "secret") && $root.secret_store_api.SecretStoreEntry.encode(e.secret, n.uint32(
        /* id 1, wireType 2 =*/
        10
      ).fork()).ldelim(), e.casIndex != null && Object.hasOwnProperty.call(e, "casIndex") && n.uint32(
        /* id 2, wireType 0 =*/
        16
      ).uint64(e.casIndex), n;
    }, r.encodeDelimited = function(e, n) {
      return this.encode(e, n).ldelim();
    }, r.decode = function(e, n) {
      e instanceof $Reader || (e = $Reader.create(e));
      let o = n === void 0 ? e.len : e.pos + n, c = new $root.secret_store_api.GetSecretResponse();
      for (; e.pos < o; ) {
        let l = e.uint32();
        switch (l >>> 3) {
          case 1: {
            c.secret = $root.secret_store_api.SecretStoreEntry.decode(e, e.uint32());
            break;
          }
          case 2: {
            c.casIndex = e.uint64();
            break;
          }
          default:
            e.skipType(l & 7);
            break;
        }
      }
      return c;
    }, r.decodeDelimited = function(e) {
      return e instanceof $Reader || (e = new $Reader(e)), this.decode(e, e.uint32());
    }, r.verify = function(e) {
      if (typeof e != "object" || e === null)
        return "object expected";
      if (e.secret != null && e.hasOwnProperty("secret")) {
        let n = $root.secret_store_api.SecretStoreEntry.verify(e.secret);
        if (n)
          return "secret." + n;
      }
      return e.casIndex != null && e.hasOwnProperty("casIndex") && !$util.isInteger(e.casIndex) && !(e.casIndex && $util.isInteger(e.casIndex.low) && $util.isInteger(e.casIndex.high)) ? "casIndex: integer|Long expected" : null;
    }, r.fromObject = function(e) {
      if (e instanceof $root.secret_store_api.GetSecretResponse)
        return e;
      let n = new $root.secret_store_api.GetSecretResponse();
      if (e.secret != null) {
        if (typeof e.secret != "object")
          throw TypeError(".secret_store_api.GetSecretResponse.secret: object expected");
        n.secret = $root.secret_store_api.SecretStoreEntry.fromObject(e.secret);
      }
      return e.casIndex != null && ($util.Long ? (n.casIndex = $util.Long.fromValue(e.casIndex)).unsigned = !0 : typeof e.casIndex == "string" ? n.casIndex = parseInt(e.casIndex, 10) : typeof e.casIndex == "number" ? n.casIndex = e.casIndex : typeof e.casIndex == "object" && (n.casIndex = new $util.LongBits(e.casIndex.low >>> 0, e.casIndex.high >>> 0).toNumber(!0))), n;
    }, r.toObject = function(e, n) {
      n || (n = {});
      let o = {};
      if (n.defaults)
        if (o.secret = null, $util.Long) {
          let c = new $util.Long(0, 0, !0);
          o.casIndex = n.longs === String ? c.toString() : n.longs === Number ? c.toNumber() : c;
        } else
          o.casIndex = n.longs === String ? "0" : 0;
      return e.secret != null && e.hasOwnProperty("secret") && (o.secret = $root.secret_store_api.SecretStoreEntry.toObject(e.secret, n)), e.casIndex != null && e.hasOwnProperty("casIndex") && (typeof e.casIndex == "number" ? o.casIndex = n.longs === String ? String(e.casIndex) : e.casIndex : o.casIndex = n.longs === String ? $util.Long.prototype.toString.call(e.casIndex) : n.longs === Number ? new $util.LongBits(e.casIndex.low >>> 0, e.casIndex.high >>> 0).toNumber(!0) : e.casIndex), o;
    }, r.prototype.toJSON = function() {
      return this.constructor.toObject(this, minimal.util.toJSONOptions);
    }, r.getTypeUrl = function(e) {
      return e === void 0 && (e = "type.googleapis.com"), e + "/secret_store_api.GetSecretResponse";
    }, r;
  }(), u.RemoveSecretRequest = function() {
    function r(a) {
      if (a)
        for (let e = Object.keys(a), n = 0; n < e.length; ++n)
          a[e[n]] != null && (this[e[n]] = a[e[n]]);
    }
    return r.prototype.id = "", r.prototype.expectedCasIndex = $util.Long ? $util.Long.fromBits(0, 0, !0) : 0, r.create = function(e) {
      return new r(e);
    }, r.encode = function(e, n) {
      return n || (n = $Writer.create()), e.id != null && Object.hasOwnProperty.call(e, "id") && n.uint32(
        /* id 1, wireType 2 =*/
        10
      ).string(e.id), e.expectedCasIndex != null && Object.hasOwnProperty.call(e, "expectedCasIndex") && n.uint32(
        /* id 2, wireType 0 =*/
        16
      ).uint64(e.expectedCasIndex), n;
    }, r.encodeDelimited = function(e, n) {
      return this.encode(e, n).ldelim();
    }, r.decode = function(e, n) {
      e instanceof $Reader || (e = $Reader.create(e));
      let o = n === void 0 ? e.len : e.pos + n, c = new $root.secret_store_api.RemoveSecretRequest();
      for (; e.pos < o; ) {
        let l = e.uint32();
        switch (l >>> 3) {
          case 1: {
            c.id = e.string();
            break;
          }
          case 2: {
            c.expectedCasIndex = e.uint64();
            break;
          }
          default:
            e.skipType(l & 7);
            break;
        }
      }
      return c;
    }, r.decodeDelimited = function(e) {
      return e instanceof $Reader || (e = new $Reader(e)), this.decode(e, e.uint32());
    }, r.verify = function(e) {
      return typeof e != "object" || e === null ? "object expected" : e.id != null && e.hasOwnProperty("id") && !$util.isString(e.id) ? "id: string expected" : e.expectedCasIndex != null && e.hasOwnProperty("expectedCasIndex") && !$util.isInteger(e.expectedCasIndex) && !(e.expectedCasIndex && $util.isInteger(e.expectedCasIndex.low) && $util.isInteger(e.expectedCasIndex.high)) ? "expectedCasIndex: integer|Long expected" : null;
    }, r.fromObject = function(e) {
      if (e instanceof $root.secret_store_api.RemoveSecretRequest)
        return e;
      let n = new $root.secret_store_api.RemoveSecretRequest();
      return e.id != null && (n.id = String(e.id)), e.expectedCasIndex != null && ($util.Long ? (n.expectedCasIndex = $util.Long.fromValue(e.expectedCasIndex)).unsigned = !0 : typeof e.expectedCasIndex == "string" ? n.expectedCasIndex = parseInt(e.expectedCasIndex, 10) : typeof e.expectedCasIndex == "number" ? n.expectedCasIndex = e.expectedCasIndex : typeof e.expectedCasIndex == "object" && (n.expectedCasIndex = new $util.LongBits(e.expectedCasIndex.low >>> 0, e.expectedCasIndex.high >>> 0).toNumber(!0))), n;
    }, r.toObject = function(e, n) {
      n || (n = {});
      let o = {};
      if (n.defaults)
        if (o.id = "", $util.Long) {
          let c = new $util.Long(0, 0, !0);
          o.expectedCasIndex = n.longs === String ? c.toString() : n.longs === Number ? c.toNumber() : c;
        } else
          o.expectedCasIndex = n.longs === String ? "0" : 0;
      return e.id != null && e.hasOwnProperty("id") && (o.id = e.id), e.expectedCasIndex != null && e.hasOwnProperty("expectedCasIndex") && (typeof e.expectedCasIndex == "number" ? o.expectedCasIndex = n.longs === String ? String(e.expectedCasIndex) : e.expectedCasIndex : o.expectedCasIndex = n.longs === String ? $util.Long.prototype.toString.call(e.expectedCasIndex) : n.longs === Number ? new $util.LongBits(e.expectedCasIndex.low >>> 0, e.expectedCasIndex.high >>> 0).toNumber(!0) : e.expectedCasIndex), o;
    }, r.prototype.toJSON = function() {
      return this.constructor.toObject(this, minimal.util.toJSONOptions);
    }, r.getTypeUrl = function(e) {
      return e === void 0 && (e = "type.googleapis.com"), e + "/secret_store_api.RemoveSecretRequest";
    }, r;
  }(), u.RemoveSecretResponse = function() {
    function r(a) {
      if (a)
        for (let e = Object.keys(a), n = 0; n < e.length; ++n)
          a[e[n]] != null && (this[e[n]] = a[e[n]]);
    }
    return r.prototype.removed = !1, r.create = function(e) {
      return new r(e);
    }, r.encode = function(e, n) {
      return n || (n = $Writer.create()), e.removed != null && Object.hasOwnProperty.call(e, "removed") && n.uint32(
        /* id 1, wireType 0 =*/
        8
      ).bool(e.removed), n;
    }, r.encodeDelimited = function(e, n) {
      return this.encode(e, n).ldelim();
    }, r.decode = function(e, n) {
      e instanceof $Reader || (e = $Reader.create(e));
      let o = n === void 0 ? e.len : e.pos + n, c = new $root.secret_store_api.RemoveSecretResponse();
      for (; e.pos < o; ) {
        let l = e.uint32();
        switch (l >>> 3) {
          case 1: {
            c.removed = e.bool();
            break;
          }
          default:
            e.skipType(l & 7);
            break;
        }
      }
      return c;
    }, r.decodeDelimited = function(e) {
      return e instanceof $Reader || (e = new $Reader(e)), this.decode(e, e.uint32());
    }, r.verify = function(e) {
      return typeof e != "object" || e === null ? "object expected" : e.removed != null && e.hasOwnProperty("removed") && typeof e.removed != "boolean" ? "removed: boolean expected" : null;
    }, r.fromObject = function(e) {
      if (e instanceof $root.secret_store_api.RemoveSecretResponse)
        return e;
      let n = new $root.secret_store_api.RemoveSecretResponse();
      return e.removed != null && (n.removed = !!e.removed), n;
    }, r.toObject = function(e, n) {
      n || (n = {});
      let o = {};
      return n.defaults && (o.removed = !1), e.removed != null && e.hasOwnProperty("removed") && (o.removed = e.removed), o;
    }, r.prototype.toJSON = function() {
      return this.constructor.toObject(this, minimal.util.toJSONOptions);
    }, r.getTypeUrl = function(e) {
      return e === void 0 && (e = "type.googleapis.com"), e + "/secret_store_api.RemoveSecretResponse";
    }, r;
  }(), u.UpdateSecretAclRequest = function() {
    function r(a) {
      if (a)
        for (let e = Object.keys(a), n = 0; n < e.length; ++n)
          a[e[n]] != null && (this[e[n]] = a[e[n]]);
    }
    return r.prototype.id = "", r.prototype.newAcl = $util.newBuffer([]), r.prototype.version = 0, r.prototype.expectedCasIndex = $util.Long ? $util.Long.fromBits(0, 0, !0) : 0, r.create = function(e) {
      return new r(e);
    }, r.encode = function(e, n) {
      return n || (n = $Writer.create()), e.id != null && Object.hasOwnProperty.call(e, "id") && n.uint32(
        /* id 1, wireType 2 =*/
        10
      ).string(e.id), e.newAcl != null && Object.hasOwnProperty.call(e, "newAcl") && n.uint32(
        /* id 2, wireType 2 =*/
        18
      ).bytes(e.newAcl), e.version != null && Object.hasOwnProperty.call(e, "version") && n.uint32(
        /* id 3, wireType 0 =*/
        24
      ).uint32(e.version), e.expectedCasIndex != null && Object.hasOwnProperty.call(e, "expectedCasIndex") && n.uint32(
        /* id 4, wireType 0 =*/
        32
      ).uint64(e.expectedCasIndex), n;
    }, r.encodeDelimited = function(e, n) {
      return this.encode(e, n).ldelim();
    }, r.decode = function(e, n) {
      e instanceof $Reader || (e = $Reader.create(e));
      let o = n === void 0 ? e.len : e.pos + n, c = new $root.secret_store_api.UpdateSecretAclRequest();
      for (; e.pos < o; ) {
        let l = e.uint32();
        switch (l >>> 3) {
          case 1: {
            c.id = e.string();
            break;
          }
          case 2: {
            c.newAcl = e.bytes();
            break;
          }
          case 3: {
            c.version = e.uint32();
            break;
          }
          case 4: {
            c.expectedCasIndex = e.uint64();
            break;
          }
          default:
            e.skipType(l & 7);
            break;
        }
      }
      return c;
    }, r.decodeDelimited = function(e) {
      return e instanceof $Reader || (e = new $Reader(e)), this.decode(e, e.uint32());
    }, r.verify = function(e) {
      return typeof e != "object" || e === null ? "object expected" : e.id != null && e.hasOwnProperty("id") && !$util.isString(e.id) ? "id: string expected" : e.newAcl != null && e.hasOwnProperty("newAcl") && !(e.newAcl && typeof e.newAcl.length == "number" || $util.isString(e.newAcl)) ? "newAcl: buffer expected" : e.version != null && e.hasOwnProperty("version") && !$util.isInteger(e.version) ? "version: integer expected" : e.expectedCasIndex != null && e.hasOwnProperty("expectedCasIndex") && !$util.isInteger(e.expectedCasIndex) && !(e.expectedCasIndex && $util.isInteger(e.expectedCasIndex.low) && $util.isInteger(e.expectedCasIndex.high)) ? "expectedCasIndex: integer|Long expected" : null;
    }, r.fromObject = function(e) {
      if (e instanceof $root.secret_store_api.UpdateSecretAclRequest)
        return e;
      let n = new $root.secret_store_api.UpdateSecretAclRequest();
      return e.id != null && (n.id = String(e.id)), e.newAcl != null && (typeof e.newAcl == "string" ? $util.base64.decode(e.newAcl, n.newAcl = $util.newBuffer($util.base64.length(e.newAcl)), 0) : e.newAcl.length >= 0 && (n.newAcl = e.newAcl)), e.version != null && (n.version = e.version >>> 0), e.expectedCasIndex != null && ($util.Long ? (n.expectedCasIndex = $util.Long.fromValue(e.expectedCasIndex)).unsigned = !0 : typeof e.expectedCasIndex == "string" ? n.expectedCasIndex = parseInt(e.expectedCasIndex, 10) : typeof e.expectedCasIndex == "number" ? n.expectedCasIndex = e.expectedCasIndex : typeof e.expectedCasIndex == "object" && (n.expectedCasIndex = new $util.LongBits(e.expectedCasIndex.low >>> 0, e.expectedCasIndex.high >>> 0).toNumber(!0))), n;
    }, r.toObject = function(e, n) {
      n || (n = {});
      let o = {};
      if (n.defaults)
        if (o.id = "", n.bytes === String ? o.newAcl = "" : (o.newAcl = [], n.bytes !== Array && (o.newAcl = $util.newBuffer(o.newAcl))), o.version = 0, $util.Long) {
          let c = new $util.Long(0, 0, !0);
          o.expectedCasIndex = n.longs === String ? c.toString() : n.longs === Number ? c.toNumber() : c;
        } else
          o.expectedCasIndex = n.longs === String ? "0" : 0;
      return e.id != null && e.hasOwnProperty("id") && (o.id = e.id), e.newAcl != null && e.hasOwnProperty("newAcl") && (o.newAcl = n.bytes === String ? $util.base64.encode(e.newAcl, 0, e.newAcl.length) : n.bytes === Array ? Array.prototype.slice.call(e.newAcl) : e.newAcl), e.version != null && e.hasOwnProperty("version") && (o.version = e.version), e.expectedCasIndex != null && e.hasOwnProperty("expectedCasIndex") && (typeof e.expectedCasIndex == "number" ? o.expectedCasIndex = n.longs === String ? String(e.expectedCasIndex) : e.expectedCasIndex : o.expectedCasIndex = n.longs === String ? $util.Long.prototype.toString.call(e.expectedCasIndex) : n.longs === Number ? new $util.LongBits(e.expectedCasIndex.low >>> 0, e.expectedCasIndex.high >>> 0).toNumber(!0) : e.expectedCasIndex), o;
    }, r.prototype.toJSON = function() {
      return this.constructor.toObject(this, minimal.util.toJSONOptions);
    }, r.getTypeUrl = function(e) {
      return e === void 0 && (e = "type.googleapis.com"), e + "/secret_store_api.UpdateSecretAclRequest";
    }, r;
  }(), u.UpdateSecretAclResponse = function() {
    function r(a) {
      if (a)
        for (let e = Object.keys(a), n = 0; n < e.length; ++n)
          a[e[n]] != null && (this[e[n]] = a[e[n]]);
    }
    return r.prototype.updated = !1, r.create = function(e) {
      return new r(e);
    }, r.encode = function(e, n) {
      return n || (n = $Writer.create()), e.updated != null && Object.hasOwnProperty.call(e, "updated") && n.uint32(
        /* id 1, wireType 0 =*/
        8
      ).bool(e.updated), n;
    }, r.encodeDelimited = function(e, n) {
      return this.encode(e, n).ldelim();
    }, r.decode = function(e, n) {
      e instanceof $Reader || (e = $Reader.create(e));
      let o = n === void 0 ? e.len : e.pos + n, c = new $root.secret_store_api.UpdateSecretAclResponse();
      for (; e.pos < o; ) {
        let l = e.uint32();
        switch (l >>> 3) {
          case 1: {
            c.updated = e.bool();
            break;
          }
          default:
            e.skipType(l & 7);
            break;
        }
      }
      return c;
    }, r.decodeDelimited = function(e) {
      return e instanceof $Reader || (e = new $Reader(e)), this.decode(e, e.uint32());
    }, r.verify = function(e) {
      return typeof e != "object" || e === null ? "object expected" : e.updated != null && e.hasOwnProperty("updated") && typeof e.updated != "boolean" ? "updated: boolean expected" : null;
    }, r.fromObject = function(e) {
      if (e instanceof $root.secret_store_api.UpdateSecretAclResponse)
        return e;
      let n = new $root.secret_store_api.UpdateSecretAclResponse();
      return e.updated != null && (n.updated = !!e.updated), n;
    }, r.toObject = function(e, n) {
      n || (n = {});
      let o = {};
      return n.defaults && (o.updated = !1), e.updated != null && e.hasOwnProperty("updated") && (o.updated = e.updated), o;
    }, r.prototype.toJSON = function() {
      return this.constructor.toObject(this, minimal.util.toJSONOptions);
    }, r.getTypeUrl = function(e) {
      return e === void 0 && (e = "type.googleapis.com"), e + "/secret_store_api.UpdateSecretAclResponse";
    }, r;
  }(), u.SecretStoreRequest = function() {
    function r(e) {
      if (e)
        for (let n = Object.keys(e), o = 0; o < n.length; ++o)
          e[n[o]] != null && (this[n[o]] = e[n[o]]);
    }
    r.prototype.createSecret = null, r.prototype.getSecret = null, r.prototype.removeSecret = null, r.prototype.updateSecretAcl = null;
    let a;
    return Object.defineProperty(r.prototype, "request", {
      get: $util.oneOfGetter(a = ["createSecret", "getSecret", "removeSecret", "updateSecretAcl"]),
      set: $util.oneOfSetter(a)
    }), r.create = function(n) {
      return new r(n);
    }, r.encode = function(n, o) {
      return o || (o = $Writer.create()), n.createSecret != null && Object.hasOwnProperty.call(n, "createSecret") && $root.secret_store_api.CreateSecretRequest.encode(n.createSecret, o.uint32(
        /* id 1, wireType 2 =*/
        10
      ).fork()).ldelim(), n.getSecret != null && Object.hasOwnProperty.call(n, "getSecret") && $root.secret_store_api.GetSecretRequest.encode(n.getSecret, o.uint32(
        /* id 2, wireType 2 =*/
        18
      ).fork()).ldelim(), n.removeSecret != null && Object.hasOwnProperty.call(n, "removeSecret") && $root.secret_store_api.RemoveSecretRequest.encode(n.removeSecret, o.uint32(
        /* id 3, wireType 2 =*/
        26
      ).fork()).ldelim(), n.updateSecretAcl != null && Object.hasOwnProperty.call(n, "updateSecretAcl") && $root.secret_store_api.UpdateSecretAclRequest.encode(n.updateSecretAcl, o.uint32(
        /* id 4, wireType 2 =*/
        34
      ).fork()).ldelim(), o;
    }, r.encodeDelimited = function(n, o) {
      return this.encode(n, o).ldelim();
    }, r.decode = function(n, o) {
      n instanceof $Reader || (n = $Reader.create(n));
      let c = o === void 0 ? n.len : n.pos + o, l = new $root.secret_store_api.SecretStoreRequest();
      for (; n.pos < c; ) {
        let d = n.uint32();
        switch (d >>> 3) {
          case 1: {
            l.createSecret = $root.secret_store_api.CreateSecretRequest.decode(n, n.uint32());
            break;
          }
          case 2: {
            l.getSecret = $root.secret_store_api.GetSecretRequest.decode(n, n.uint32());
            break;
          }
          case 3: {
            l.removeSecret = $root.secret_store_api.RemoveSecretRequest.decode(n, n.uint32());
            break;
          }
          case 4: {
            l.updateSecretAcl = $root.secret_store_api.UpdateSecretAclRequest.decode(n, n.uint32());
            break;
          }
          default:
            n.skipType(d & 7);
            break;
        }
      }
      return l;
    }, r.decodeDelimited = function(n) {
      return n instanceof $Reader || (n = new $Reader(n)), this.decode(n, n.uint32());
    }, r.verify = function(n) {
      if (typeof n != "object" || n === null)
        return "object expected";
      let o = {};
      if (n.createSecret != null && n.hasOwnProperty("createSecret")) {
        o.request = 1;
        {
          let c = $root.secret_store_api.CreateSecretRequest.verify(n.createSecret);
          if (c)
            return "createSecret." + c;
        }
      }
      if (n.getSecret != null && n.hasOwnProperty("getSecret")) {
        if (o.request === 1)
          return "request: multiple values";
        o.request = 1;
        {
          let c = $root.secret_store_api.GetSecretRequest.verify(n.getSecret);
          if (c)
            return "getSecret." + c;
        }
      }
      if (n.removeSecret != null && n.hasOwnProperty("removeSecret")) {
        if (o.request === 1)
          return "request: multiple values";
        o.request = 1;
        {
          let c = $root.secret_store_api.RemoveSecretRequest.verify(n.removeSecret);
          if (c)
            return "removeSecret." + c;
        }
      }
      if (n.updateSecretAcl != null && n.hasOwnProperty("updateSecretAcl")) {
        if (o.request === 1)
          return "request: multiple values";
        o.request = 1;
        {
          let c = $root.secret_store_api.UpdateSecretAclRequest.verify(n.updateSecretAcl);
          if (c)
            return "updateSecretAcl." + c;
        }
      }
      return null;
    }, r.fromObject = function(n) {
      if (n instanceof $root.secret_store_api.SecretStoreRequest)
        return n;
      let o = new $root.secret_store_api.SecretStoreRequest();
      if (n.createSecret != null) {
        if (typeof n.createSecret != "object")
          throw TypeError(".secret_store_api.SecretStoreRequest.createSecret: object expected");
        o.createSecret = $root.secret_store_api.CreateSecretRequest.fromObject(n.createSecret);
      }
      if (n.getSecret != null) {
        if (typeof n.getSecret != "object")
          throw TypeError(".secret_store_api.SecretStoreRequest.getSecret: object expected");
        o.getSecret = $root.secret_store_api.GetSecretRequest.fromObject(n.getSecret);
      }
      if (n.removeSecret != null) {
        if (typeof n.removeSecret != "object")
          throw TypeError(".secret_store_api.SecretStoreRequest.removeSecret: object expected");
        o.removeSecret = $root.secret_store_api.RemoveSecretRequest.fromObject(n.removeSecret);
      }
      if (n.updateSecretAcl != null) {
        if (typeof n.updateSecretAcl != "object")
          throw TypeError(".secret_store_api.SecretStoreRequest.updateSecretAcl: object expected");
        o.updateSecretAcl = $root.secret_store_api.UpdateSecretAclRequest.fromObject(n.updateSecretAcl);
      }
      return o;
    }, r.toObject = function(n, o) {
      o || (o = {});
      let c = {};
      return n.createSecret != null && n.hasOwnProperty("createSecret") && (c.createSecret = $root.secret_store_api.CreateSecretRequest.toObject(n.createSecret, o), o.oneofs && (c.request = "createSecret")), n.getSecret != null && n.hasOwnProperty("getSecret") && (c.getSecret = $root.secret_store_api.GetSecretRequest.toObject(n.getSecret, o), o.oneofs && (c.request = "getSecret")), n.removeSecret != null && n.hasOwnProperty("removeSecret") && (c.removeSecret = $root.secret_store_api.RemoveSecretRequest.toObject(n.removeSecret, o), o.oneofs && (c.request = "removeSecret")), n.updateSecretAcl != null && n.hasOwnProperty("updateSecretAcl") && (c.updateSecretAcl = $root.secret_store_api.UpdateSecretAclRequest.toObject(n.updateSecretAcl, o), o.oneofs && (c.request = "updateSecretAcl")), c;
    }, r.prototype.toJSON = function() {
      return this.constructor.toObject(this, minimal.util.toJSONOptions);
    }, r.getTypeUrl = function(n) {
      return n === void 0 && (n = "type.googleapis.com"), n + "/secret_store_api.SecretStoreRequest";
    }, r;
  }(), u.SecretStoreResponse = function() {
    function r(e) {
      if (e)
        for (let n = Object.keys(e), o = 0; o < n.length; ++o)
          e[n[o]] != null && (this[n[o]] = e[n[o]]);
    }
    r.prototype.createSecret = null, r.prototype.getSecret = null, r.prototype.removeSecret = null, r.prototype.updateSecretAcl = null;
    let a;
    return Object.defineProperty(r.prototype, "response", {
      get: $util.oneOfGetter(a = ["createSecret", "getSecret", "removeSecret", "updateSecretAcl"]),
      set: $util.oneOfSetter(a)
    }), r.create = function(n) {
      return new r(n);
    }, r.encode = function(n, o) {
      return o || (o = $Writer.create()), n.createSecret != null && Object.hasOwnProperty.call(n, "createSecret") && $root.secret_store_api.CreateSecretResponse.encode(n.createSecret, o.uint32(
        /* id 1, wireType 2 =*/
        10
      ).fork()).ldelim(), n.getSecret != null && Object.hasOwnProperty.call(n, "getSecret") && $root.secret_store_api.GetSecretResponse.encode(n.getSecret, o.uint32(
        /* id 2, wireType 2 =*/
        18
      ).fork()).ldelim(), n.removeSecret != null && Object.hasOwnProperty.call(n, "removeSecret") && $root.secret_store_api.RemoveSecretResponse.encode(n.removeSecret, o.uint32(
        /* id 3, wireType 2 =*/
        26
      ).fork()).ldelim(), n.updateSecretAcl != null && Object.hasOwnProperty.call(n, "updateSecretAcl") && $root.secret_store_api.UpdateSecretAclResponse.encode(n.updateSecretAcl, o.uint32(
        /* id 4, wireType 2 =*/
        34
      ).fork()).ldelim(), o;
    }, r.encodeDelimited = function(n, o) {
      return this.encode(n, o).ldelim();
    }, r.decode = function(n, o) {
      n instanceof $Reader || (n = $Reader.create(n));
      let c = o === void 0 ? n.len : n.pos + o, l = new $root.secret_store_api.SecretStoreResponse();
      for (; n.pos < c; ) {
        let d = n.uint32();
        switch (d >>> 3) {
          case 1: {
            l.createSecret = $root.secret_store_api.CreateSecretResponse.decode(n, n.uint32());
            break;
          }
          case 2: {
            l.getSecret = $root.secret_store_api.GetSecretResponse.decode(n, n.uint32());
            break;
          }
          case 3: {
            l.removeSecret = $root.secret_store_api.RemoveSecretResponse.decode(n, n.uint32());
            break;
          }
          case 4: {
            l.updateSecretAcl = $root.secret_store_api.UpdateSecretAclResponse.decode(n, n.uint32());
            break;
          }
          default:
            n.skipType(d & 7);
            break;
        }
      }
      return l;
    }, r.decodeDelimited = function(n) {
      return n instanceof $Reader || (n = new $Reader(n)), this.decode(n, n.uint32());
    }, r.verify = function(n) {
      if (typeof n != "object" || n === null)
        return "object expected";
      let o = {};
      if (n.createSecret != null && n.hasOwnProperty("createSecret")) {
        o.response = 1;
        {
          let c = $root.secret_store_api.CreateSecretResponse.verify(n.createSecret);
          if (c)
            return "createSecret." + c;
        }
      }
      if (n.getSecret != null && n.hasOwnProperty("getSecret")) {
        if (o.response === 1)
          return "response: multiple values";
        o.response = 1;
        {
          let c = $root.secret_store_api.GetSecretResponse.verify(n.getSecret);
          if (c)
            return "getSecret." + c;
        }
      }
      if (n.removeSecret != null && n.hasOwnProperty("removeSecret")) {
        if (o.response === 1)
          return "response: multiple values";
        o.response = 1;
        {
          let c = $root.secret_store_api.RemoveSecretResponse.verify(n.removeSecret);
          if (c)
            return "removeSecret." + c;
        }
      }
      if (n.updateSecretAcl != null && n.hasOwnProperty("updateSecretAcl")) {
        if (o.response === 1)
          return "response: multiple values";
        o.response = 1;
        {
          let c = $root.secret_store_api.UpdateSecretAclResponse.verify(n.updateSecretAcl);
          if (c)
            return "updateSecretAcl." + c;
        }
      }
      return null;
    }, r.fromObject = function(n) {
      if (n instanceof $root.secret_store_api.SecretStoreResponse)
        return n;
      let o = new $root.secret_store_api.SecretStoreResponse();
      if (n.createSecret != null) {
        if (typeof n.createSecret != "object")
          throw TypeError(".secret_store_api.SecretStoreResponse.createSecret: object expected");
        o.createSecret = $root.secret_store_api.CreateSecretResponse.fromObject(n.createSecret);
      }
      if (n.getSecret != null) {
        if (typeof n.getSecret != "object")
          throw TypeError(".secret_store_api.SecretStoreResponse.getSecret: object expected");
        o.getSecret = $root.secret_store_api.GetSecretResponse.fromObject(n.getSecret);
      }
      if (n.removeSecret != null) {
        if (typeof n.removeSecret != "object")
          throw TypeError(".secret_store_api.SecretStoreResponse.removeSecret: object expected");
        o.removeSecret = $root.secret_store_api.RemoveSecretResponse.fromObject(n.removeSecret);
      }
      if (n.updateSecretAcl != null) {
        if (typeof n.updateSecretAcl != "object")
          throw TypeError(".secret_store_api.SecretStoreResponse.updateSecretAcl: object expected");
        o.updateSecretAcl = $root.secret_store_api.UpdateSecretAclResponse.fromObject(n.updateSecretAcl);
      }
      return o;
    }, r.toObject = function(n, o) {
      o || (o = {});
      let c = {};
      return n.createSecret != null && n.hasOwnProperty("createSecret") && (c.createSecret = $root.secret_store_api.CreateSecretResponse.toObject(n.createSecret, o), o.oneofs && (c.response = "createSecret")), n.getSecret != null && n.hasOwnProperty("getSecret") && (c.getSecret = $root.secret_store_api.GetSecretResponse.toObject(n.getSecret, o), o.oneofs && (c.response = "getSecret")), n.removeSecret != null && n.hasOwnProperty("removeSecret") && (c.removeSecret = $root.secret_store_api.RemoveSecretResponse.toObject(n.removeSecret, o), o.oneofs && (c.response = "removeSecret")), n.updateSecretAcl != null && n.hasOwnProperty("updateSecretAcl") && (c.updateSecretAcl = $root.secret_store_api.UpdateSecretAclResponse.toObject(n.updateSecretAcl, o), o.oneofs && (c.response = "updateSecretAcl")), c;
    }, r.prototype.toJSON = function() {
      return this.constructor.toObject(this, minimal.util.toJSONOptions);
    }, r.getTypeUrl = function(n) {
      return n === void 0 && (n = "type.googleapis.com"), n + "/secret_store_api.SecretStoreResponse";
    }, r;
  }(), u;
})();
$root.google_ad_manager = (() => {
  const u = {};
  return u.SingleFile = function() {
    function r(a) {
      if (a)
        for (let e = Object.keys(a), n = 0; n < e.length; ++n)
          a[e[n]] != null && (this[e[n]] = a[e[n]]);
    }
    return r.prototype.name = "", r.create = function(e) {
      return new r(e);
    }, r.encode = function(e, n) {
      return n || (n = $Writer.create()), e.name != null && Object.hasOwnProperty.call(e, "name") && n.uint32(
        /* id 1, wireType 2 =*/
        10
      ).string(e.name), n;
    }, r.encodeDelimited = function(e, n) {
      return this.encode(e, n).ldelim();
    }, r.decode = function(e, n) {
      e instanceof $Reader || (e = $Reader.create(e));
      let o = n === void 0 ? e.len : e.pos + n, c = new $root.google_ad_manager.SingleFile();
      for (; e.pos < o; ) {
        let l = e.uint32();
        switch (l >>> 3) {
          case 1: {
            c.name = e.string();
            break;
          }
          default:
            e.skipType(l & 7);
            break;
        }
      }
      return c;
    }, r.decodeDelimited = function(e) {
      return e instanceof $Reader || (e = new $Reader(e)), this.decode(e, e.uint32());
    }, r.verify = function(e) {
      return typeof e != "object" || e === null ? "object expected" : e.name != null && e.hasOwnProperty("name") && !$util.isString(e.name) ? "name: string expected" : null;
    }, r.fromObject = function(e) {
      if (e instanceof $root.google_ad_manager.SingleFile)
        return e;
      let n = new $root.google_ad_manager.SingleFile();
      return e.name != null && (n.name = String(e.name)), n;
    }, r.toObject = function(e, n) {
      n || (n = {});
      let o = {};
      return n.defaults && (o.name = ""), e.name != null && e.hasOwnProperty("name") && (o.name = e.name), o;
    }, r.prototype.toJSON = function() {
      return this.constructor.toObject(this, minimal.util.toJSONOptions);
    }, r.getTypeUrl = function(e) {
      return e === void 0 && (e = "type.googleapis.com"), e + "/google_ad_manager.SingleFile";
    }, r;
  }(), u.RawFile = function() {
    function r(a) {
      if (a)
        for (let e = Object.keys(a), n = 0; n < e.length; ++n)
          a[e[n]] != null && (this[e[n]] = a[e[n]]);
    }
    return r.create = function(e) {
      return new r(e);
    }, r.encode = function(e, n) {
      return n || (n = $Writer.create()), n;
    }, r.encodeDelimited = function(e, n) {
      return this.encode(e, n).ldelim();
    }, r.decode = function(e, n) {
      e instanceof $Reader || (e = $Reader.create(e));
      let o = n === void 0 ? e.len : e.pos + n, c = new $root.google_ad_manager.RawFile();
      for (; e.pos < o; ) {
        let l = e.uint32();
        switch (l >>> 3) {
          default:
            e.skipType(l & 7);
            break;
        }
      }
      return c;
    }, r.decodeDelimited = function(e) {
      return e instanceof $Reader || (e = new $Reader(e)), this.decode(e, e.uint32());
    }, r.verify = function(e) {
      return typeof e != "object" || e === null ? "object expected" : null;
    }, r.fromObject = function(e) {
      return e instanceof $root.google_ad_manager.RawFile ? e : new $root.google_ad_manager.RawFile();
    }, r.toObject = function() {
      return {};
    }, r.prototype.toJSON = function() {
      return this.constructor.toObject(this, minimal.util.toJSONOptions);
    }, r.getTypeUrl = function(e) {
      return e === void 0 && (e = "type.googleapis.com"), e + "/google_ad_manager.RawFile";
    }, r;
  }(), u.ZipFile = function() {
    function r(e) {
      if (e)
        for (let n = Object.keys(e), o = 0; o < n.length; ++o)
          e[n[o]] != null && (this[n[o]] = e[n[o]]);
    }
    r.prototype.singleFile = null;
    let a;
    return Object.defineProperty(r.prototype, "selection", {
      get: $util.oneOfGetter(a = ["singleFile"]),
      set: $util.oneOfSetter(a)
    }), r.create = function(n) {
      return new r(n);
    }, r.encode = function(n, o) {
      return o || (o = $Writer.create()), n.singleFile != null && Object.hasOwnProperty.call(n, "singleFile") && $root.google_ad_manager.SingleFile.encode(n.singleFile, o.uint32(
        /* id 1, wireType 2 =*/
        10
      ).fork()).ldelim(), o;
    }, r.encodeDelimited = function(n, o) {
      return this.encode(n, o).ldelim();
    }, r.decode = function(n, o) {
      n instanceof $Reader || (n = $Reader.create(n));
      let c = o === void 0 ? n.len : n.pos + o, l = new $root.google_ad_manager.ZipFile();
      for (; n.pos < c; ) {
        let d = n.uint32();
        switch (d >>> 3) {
          case 1: {
            l.singleFile = $root.google_ad_manager.SingleFile.decode(n, n.uint32());
            break;
          }
          default:
            n.skipType(d & 7);
            break;
        }
      }
      return l;
    }, r.decodeDelimited = function(n) {
      return n instanceof $Reader || (n = new $Reader(n)), this.decode(n, n.uint32());
    }, r.verify = function(n) {
      if (typeof n != "object" || n === null)
        return "object expected";
      if (n.singleFile != null && n.hasOwnProperty("singleFile")) {
        let o = $root.google_ad_manager.SingleFile.verify(n.singleFile);
        if (o)
          return "singleFile." + o;
      }
      return null;
    }, r.fromObject = function(n) {
      if (n instanceof $root.google_ad_manager.ZipFile)
        return n;
      let o = new $root.google_ad_manager.ZipFile();
      if (n.singleFile != null) {
        if (typeof n.singleFile != "object")
          throw TypeError(".google_ad_manager.ZipFile.singleFile: object expected");
        o.singleFile = $root.google_ad_manager.SingleFile.fromObject(n.singleFile);
      }
      return o;
    }, r.toObject = function(n, o) {
      o || (o = {});
      let c = {};
      return n.singleFile != null && n.hasOwnProperty("singleFile") && (c.singleFile = $root.google_ad_manager.SingleFile.toObject(n.singleFile, o), o.oneofs && (c.selection = "singleFile")), c;
    }, r.prototype.toJSON = function() {
      return this.constructor.toObject(this, minimal.util.toJSONOptions);
    }, r.getTypeUrl = function(n) {
      return n === void 0 && (n = "type.googleapis.com"), n + "/google_ad_manager.ZipFile";
    }, r;
  }(), u.SinkInput = function() {
    function r(e) {
      if (e)
        for (let n = Object.keys(e), o = 0; o < n.length; ++o)
          e[n[o]] != null && (this[n[o]] = e[n[o]]);
    }
    r.prototype.dependency = "", r.prototype.name = "", r.prototype.raw = null, r.prototype.zip = null;
    let a;
    return Object.defineProperty(r.prototype, "file", {
      get: $util.oneOfGetter(a = ["raw", "zip"]),
      set: $util.oneOfSetter(a)
    }), r.create = function(n) {
      return new r(n);
    }, r.encode = function(n, o) {
      return o || (o = $Writer.create()), n.dependency != null && Object.hasOwnProperty.call(n, "dependency") && o.uint32(
        /* id 1, wireType 2 =*/
        10
      ).string(n.dependency), n.name != null && Object.hasOwnProperty.call(n, "name") && o.uint32(
        /* id 2, wireType 2 =*/
        18
      ).string(n.name), n.raw != null && Object.hasOwnProperty.call(n, "raw") && $root.google_ad_manager.RawFile.encode(n.raw, o.uint32(
        /* id 3, wireType 2 =*/
        26
      ).fork()).ldelim(), n.zip != null && Object.hasOwnProperty.call(n, "zip") && $root.google_ad_manager.ZipFile.encode(n.zip, o.uint32(
        /* id 4, wireType 2 =*/
        34
      ).fork()).ldelim(), o;
    }, r.encodeDelimited = function(n, o) {
      return this.encode(n, o).ldelim();
    }, r.decode = function(n, o) {
      n instanceof $Reader || (n = $Reader.create(n));
      let c = o === void 0 ? n.len : n.pos + o, l = new $root.google_ad_manager.SinkInput();
      for (; n.pos < c; ) {
        let d = n.uint32();
        switch (d >>> 3) {
          case 1: {
            l.dependency = n.string();
            break;
          }
          case 2: {
            l.name = n.string();
            break;
          }
          case 3: {
            l.raw = $root.google_ad_manager.RawFile.decode(n, n.uint32());
            break;
          }
          case 4: {
            l.zip = $root.google_ad_manager.ZipFile.decode(n, n.uint32());
            break;
          }
          default:
            n.skipType(d & 7);
            break;
        }
      }
      return l;
    }, r.decodeDelimited = function(n) {
      return n instanceof $Reader || (n = new $Reader(n)), this.decode(n, n.uint32());
    }, r.verify = function(n) {
      if (typeof n != "object" || n === null)
        return "object expected";
      let o = {};
      if (n.dependency != null && n.hasOwnProperty("dependency") && !$util.isString(n.dependency))
        return "dependency: string expected";
      if (n.name != null && n.hasOwnProperty("name") && !$util.isString(n.name))
        return "name: string expected";
      if (n.raw != null && n.hasOwnProperty("raw")) {
        o.file = 1;
        {
          let c = $root.google_ad_manager.RawFile.verify(n.raw);
          if (c)
            return "raw." + c;
        }
      }
      if (n.zip != null && n.hasOwnProperty("zip")) {
        if (o.file === 1)
          return "file: multiple values";
        o.file = 1;
        {
          let c = $root.google_ad_manager.ZipFile.verify(n.zip);
          if (c)
            return "zip." + c;
        }
      }
      return null;
    }, r.fromObject = function(n) {
      if (n instanceof $root.google_ad_manager.SinkInput)
        return n;
      let o = new $root.google_ad_manager.SinkInput();
      if (n.dependency != null && (o.dependency = String(n.dependency)), n.name != null && (o.name = String(n.name)), n.raw != null) {
        if (typeof n.raw != "object")
          throw TypeError(".google_ad_manager.SinkInput.raw: object expected");
        o.raw = $root.google_ad_manager.RawFile.fromObject(n.raw);
      }
      if (n.zip != null) {
        if (typeof n.zip != "object")
          throw TypeError(".google_ad_manager.SinkInput.zip: object expected");
        o.zip = $root.google_ad_manager.ZipFile.fromObject(n.zip);
      }
      return o;
    }, r.toObject = function(n, o) {
      o || (o = {});
      let c = {};
      return o.defaults && (c.dependency = "", c.name = ""), n.dependency != null && n.hasOwnProperty("dependency") && (c.dependency = n.dependency), n.name != null && n.hasOwnProperty("name") && (c.name = n.name), n.raw != null && n.hasOwnProperty("raw") && (c.raw = $root.google_ad_manager.RawFile.toObject(n.raw, o), o.oneofs && (c.file = "raw")), n.zip != null && n.hasOwnProperty("zip") && (c.zip = $root.google_ad_manager.ZipFile.toObject(n.zip, o), o.oneofs && (c.file = "zip")), c;
    }, r.prototype.toJSON = function() {
      return this.constructor.toObject(this, minimal.util.toJSONOptions);
    }, r.getTypeUrl = function(n) {
      return n === void 0 && (n = "type.googleapis.com"), n + "/google_ad_manager.SinkInput";
    }, r;
  }(), u.GoogleAdManagerWorkerConfiguration = function() {
    function r(a) {
      if (a)
        for (let e = Object.keys(a), n = 0; n < e.length; ++n)
          a[e[n]] != null && (this[e[n]] = a[e[n]]);
    }
    return r.prototype.input = null, r.prototype.credentialsDependency = "", r.prototype.identifierKind = "", r.prototype.listId = "", r.prototype.inputHasHeaders = !1, r.prototype.bucket = "", r.prototype.objectName = "", r.create = function(e) {
      return new r(e);
    }, r.encode = function(e, n) {
      return n || (n = $Writer.create()), e.input != null && Object.hasOwnProperty.call(e, "input") && $root.google_ad_manager.SinkInput.encode(e.input, n.uint32(
        /* id 1, wireType 2 =*/
        10
      ).fork()).ldelim(), e.credentialsDependency != null && Object.hasOwnProperty.call(e, "credentialsDependency") && n.uint32(
        /* id 2, wireType 2 =*/
        18
      ).string(e.credentialsDependency), e.identifierKind != null && Object.hasOwnProperty.call(e, "identifierKind") && n.uint32(
        /* id 3, wireType 2 =*/
        26
      ).string(e.identifierKind), e.listId != null && Object.hasOwnProperty.call(e, "listId") && n.uint32(
        /* id 4, wireType 2 =*/
        34
      ).string(e.listId), e.inputHasHeaders != null && Object.hasOwnProperty.call(e, "inputHasHeaders") && n.uint32(
        /* id 5, wireType 0 =*/
        40
      ).bool(e.inputHasHeaders), e.bucket != null && Object.hasOwnProperty.call(e, "bucket") && n.uint32(
        /* id 6, wireType 2 =*/
        50
      ).string(e.bucket), e.objectName != null && Object.hasOwnProperty.call(e, "objectName") && n.uint32(
        /* id 7, wireType 2 =*/
        58
      ).string(e.objectName), n;
    }, r.encodeDelimited = function(e, n) {
      return this.encode(e, n).ldelim();
    }, r.decode = function(e, n) {
      e instanceof $Reader || (e = $Reader.create(e));
      let o = n === void 0 ? e.len : e.pos + n, c = new $root.google_ad_manager.GoogleAdManagerWorkerConfiguration();
      for (; e.pos < o; ) {
        let l = e.uint32();
        switch (l >>> 3) {
          case 1: {
            c.input = $root.google_ad_manager.SinkInput.decode(e, e.uint32());
            break;
          }
          case 2: {
            c.credentialsDependency = e.string();
            break;
          }
          case 3: {
            c.identifierKind = e.string();
            break;
          }
          case 4: {
            c.listId = e.string();
            break;
          }
          case 5: {
            c.inputHasHeaders = e.bool();
            break;
          }
          case 6: {
            c.bucket = e.string();
            break;
          }
          case 7: {
            c.objectName = e.string();
            break;
          }
          default:
            e.skipType(l & 7);
            break;
        }
      }
      return c;
    }, r.decodeDelimited = function(e) {
      return e instanceof $Reader || (e = new $Reader(e)), this.decode(e, e.uint32());
    }, r.verify = function(e) {
      if (typeof e != "object" || e === null)
        return "object expected";
      if (e.input != null && e.hasOwnProperty("input")) {
        let n = $root.google_ad_manager.SinkInput.verify(e.input);
        if (n)
          return "input." + n;
      }
      return e.credentialsDependency != null && e.hasOwnProperty("credentialsDependency") && !$util.isString(e.credentialsDependency) ? "credentialsDependency: string expected" : e.identifierKind != null && e.hasOwnProperty("identifierKind") && !$util.isString(e.identifierKind) ? "identifierKind: string expected" : e.listId != null && e.hasOwnProperty("listId") && !$util.isString(e.listId) ? "listId: string expected" : e.inputHasHeaders != null && e.hasOwnProperty("inputHasHeaders") && typeof e.inputHasHeaders != "boolean" ? "inputHasHeaders: boolean expected" : e.bucket != null && e.hasOwnProperty("bucket") && !$util.isString(e.bucket) ? "bucket: string expected" : e.objectName != null && e.hasOwnProperty("objectName") && !$util.isString(e.objectName) ? "objectName: string expected" : null;
    }, r.fromObject = function(e) {
      if (e instanceof $root.google_ad_manager.GoogleAdManagerWorkerConfiguration)
        return e;
      let n = new $root.google_ad_manager.GoogleAdManagerWorkerConfiguration();
      if (e.input != null) {
        if (typeof e.input != "object")
          throw TypeError(".google_ad_manager.GoogleAdManagerWorkerConfiguration.input: object expected");
        n.input = $root.google_ad_manager.SinkInput.fromObject(e.input);
      }
      return e.credentialsDependency != null && (n.credentialsDependency = String(e.credentialsDependency)), e.identifierKind != null && (n.identifierKind = String(e.identifierKind)), e.listId != null && (n.listId = String(e.listId)), e.inputHasHeaders != null && (n.inputHasHeaders = !!e.inputHasHeaders), e.bucket != null && (n.bucket = String(e.bucket)), e.objectName != null && (n.objectName = String(e.objectName)), n;
    }, r.toObject = function(e, n) {
      n || (n = {});
      let o = {};
      return n.defaults && (o.input = null, o.credentialsDependency = "", o.identifierKind = "", o.listId = "", o.inputHasHeaders = !1, o.bucket = "", o.objectName = ""), e.input != null && e.hasOwnProperty("input") && (o.input = $root.google_ad_manager.SinkInput.toObject(e.input, n)), e.credentialsDependency != null && e.hasOwnProperty("credentialsDependency") && (o.credentialsDependency = e.credentialsDependency), e.identifierKind != null && e.hasOwnProperty("identifierKind") && (o.identifierKind = e.identifierKind), e.listId != null && e.hasOwnProperty("listId") && (o.listId = e.listId), e.inputHasHeaders != null && e.hasOwnProperty("inputHasHeaders") && (o.inputHasHeaders = e.inputHasHeaders), e.bucket != null && e.hasOwnProperty("bucket") && (o.bucket = e.bucket), e.objectName != null && e.hasOwnProperty("objectName") && (o.objectName = e.objectName), o;
    }, r.prototype.toJSON = function() {
      return this.constructor.toObject(this, minimal.util.toJSONOptions);
    }, r.getTypeUrl = function(e) {
      return e === void 0 && (e = "type.googleapis.com"), e + "/google_ad_manager.GoogleAdManagerWorkerConfiguration";
    }, r;
  }(), u;
})();
$root.google_dv_360_sink = (() => {
  const u = {};
  return u.SingleFile = function() {
    function r(a) {
      if (a)
        for (let e = Object.keys(a), n = 0; n < e.length; ++n)
          a[e[n]] != null && (this[e[n]] = a[e[n]]);
    }
    return r.prototype.name = "", r.create = function(e) {
      return new r(e);
    }, r.encode = function(e, n) {
      return n || (n = $Writer.create()), e.name != null && Object.hasOwnProperty.call(e, "name") && n.uint32(
        /* id 1, wireType 2 =*/
        10
      ).string(e.name), n;
    }, r.encodeDelimited = function(e, n) {
      return this.encode(e, n).ldelim();
    }, r.decode = function(e, n) {
      e instanceof $Reader || (e = $Reader.create(e));
      let o = n === void 0 ? e.len : e.pos + n, c = new $root.google_dv_360_sink.SingleFile();
      for (; e.pos < o; ) {
        let l = e.uint32();
        switch (l >>> 3) {
          case 1: {
            c.name = e.string();
            break;
          }
          default:
            e.skipType(l & 7);
            break;
        }
      }
      return c;
    }, r.decodeDelimited = function(e) {
      return e instanceof $Reader || (e = new $Reader(e)), this.decode(e, e.uint32());
    }, r.verify = function(e) {
      return typeof e != "object" || e === null ? "object expected" : e.name != null && e.hasOwnProperty("name") && !$util.isString(e.name) ? "name: string expected" : null;
    }, r.fromObject = function(e) {
      if (e instanceof $root.google_dv_360_sink.SingleFile)
        return e;
      let n = new $root.google_dv_360_sink.SingleFile();
      return e.name != null && (n.name = String(e.name)), n;
    }, r.toObject = function(e, n) {
      n || (n = {});
      let o = {};
      return n.defaults && (o.name = ""), e.name != null && e.hasOwnProperty("name") && (o.name = e.name), o;
    }, r.prototype.toJSON = function() {
      return this.constructor.toObject(this, minimal.util.toJSONOptions);
    }, r.getTypeUrl = function(e) {
      return e === void 0 && (e = "type.googleapis.com"), e + "/google_dv_360_sink.SingleFile";
    }, r;
  }(), u.RawFile = function() {
    function r(a) {
      if (a)
        for (let e = Object.keys(a), n = 0; n < e.length; ++n)
          a[e[n]] != null && (this[e[n]] = a[e[n]]);
    }
    return r.create = function(e) {
      return new r(e);
    }, r.encode = function(e, n) {
      return n || (n = $Writer.create()), n;
    }, r.encodeDelimited = function(e, n) {
      return this.encode(e, n).ldelim();
    }, r.decode = function(e, n) {
      e instanceof $Reader || (e = $Reader.create(e));
      let o = n === void 0 ? e.len : e.pos + n, c = new $root.google_dv_360_sink.RawFile();
      for (; e.pos < o; ) {
        let l = e.uint32();
        switch (l >>> 3) {
          default:
            e.skipType(l & 7);
            break;
        }
      }
      return c;
    }, r.decodeDelimited = function(e) {
      return e instanceof $Reader || (e = new $Reader(e)), this.decode(e, e.uint32());
    }, r.verify = function(e) {
      return typeof e != "object" || e === null ? "object expected" : null;
    }, r.fromObject = function(e) {
      return e instanceof $root.google_dv_360_sink.RawFile ? e : new $root.google_dv_360_sink.RawFile();
    }, r.toObject = function() {
      return {};
    }, r.prototype.toJSON = function() {
      return this.constructor.toObject(this, minimal.util.toJSONOptions);
    }, r.getTypeUrl = function(e) {
      return e === void 0 && (e = "type.googleapis.com"), e + "/google_dv_360_sink.RawFile";
    }, r;
  }(), u.ZipFile = function() {
    function r(e) {
      if (e)
        for (let n = Object.keys(e), o = 0; o < n.length; ++o)
          e[n[o]] != null && (this[n[o]] = e[n[o]]);
    }
    r.prototype.singleFile = null;
    let a;
    return Object.defineProperty(r.prototype, "selection", {
      get: $util.oneOfGetter(a = ["singleFile"]),
      set: $util.oneOfSetter(a)
    }), r.create = function(n) {
      return new r(n);
    }, r.encode = function(n, o) {
      return o || (o = $Writer.create()), n.singleFile != null && Object.hasOwnProperty.call(n, "singleFile") && $root.google_dv_360_sink.SingleFile.encode(n.singleFile, o.uint32(
        /* id 1, wireType 2 =*/
        10
      ).fork()).ldelim(), o;
    }, r.encodeDelimited = function(n, o) {
      return this.encode(n, o).ldelim();
    }, r.decode = function(n, o) {
      n instanceof $Reader || (n = $Reader.create(n));
      let c = o === void 0 ? n.len : n.pos + o, l = new $root.google_dv_360_sink.ZipFile();
      for (; n.pos < c; ) {
        let d = n.uint32();
        switch (d >>> 3) {
          case 1: {
            l.singleFile = $root.google_dv_360_sink.SingleFile.decode(n, n.uint32());
            break;
          }
          default:
            n.skipType(d & 7);
            break;
        }
      }
      return l;
    }, r.decodeDelimited = function(n) {
      return n instanceof $Reader || (n = new $Reader(n)), this.decode(n, n.uint32());
    }, r.verify = function(n) {
      if (typeof n != "object" || n === null)
        return "object expected";
      if (n.singleFile != null && n.hasOwnProperty("singleFile")) {
        let o = $root.google_dv_360_sink.SingleFile.verify(n.singleFile);
        if (o)
          return "singleFile." + o;
      }
      return null;
    }, r.fromObject = function(n) {
      if (n instanceof $root.google_dv_360_sink.ZipFile)
        return n;
      let o = new $root.google_dv_360_sink.ZipFile();
      if (n.singleFile != null) {
        if (typeof n.singleFile != "object")
          throw TypeError(".google_dv_360_sink.ZipFile.singleFile: object expected");
        o.singleFile = $root.google_dv_360_sink.SingleFile.fromObject(n.singleFile);
      }
      return o;
    }, r.toObject = function(n, o) {
      o || (o = {});
      let c = {};
      return n.singleFile != null && n.hasOwnProperty("singleFile") && (c.singleFile = $root.google_dv_360_sink.SingleFile.toObject(n.singleFile, o), o.oneofs && (c.selection = "singleFile")), c;
    }, r.prototype.toJSON = function() {
      return this.constructor.toObject(this, minimal.util.toJSONOptions);
    }, r.getTypeUrl = function(n) {
      return n === void 0 && (n = "type.googleapis.com"), n + "/google_dv_360_sink.ZipFile";
    }, r;
  }(), u.SinkInput = function() {
    function r(e) {
      if (e)
        for (let n = Object.keys(e), o = 0; o < n.length; ++o)
          e[n[o]] != null && (this[n[o]] = e[n[o]]);
    }
    r.prototype.dependency = "", r.prototype.name = "", r.prototype.raw = null, r.prototype.zip = null;
    let a;
    return Object.defineProperty(r.prototype, "file", {
      get: $util.oneOfGetter(a = ["raw", "zip"]),
      set: $util.oneOfSetter(a)
    }), r.create = function(n) {
      return new r(n);
    }, r.encode = function(n, o) {
      return o || (o = $Writer.create()), n.dependency != null && Object.hasOwnProperty.call(n, "dependency") && o.uint32(
        /* id 1, wireType 2 =*/
        10
      ).string(n.dependency), n.name != null && Object.hasOwnProperty.call(n, "name") && o.uint32(
        /* id 2, wireType 2 =*/
        18
      ).string(n.name), n.raw != null && Object.hasOwnProperty.call(n, "raw") && $root.google_dv_360_sink.RawFile.encode(n.raw, o.uint32(
        /* id 3, wireType 2 =*/
        26
      ).fork()).ldelim(), n.zip != null && Object.hasOwnProperty.call(n, "zip") && $root.google_dv_360_sink.ZipFile.encode(n.zip, o.uint32(
        /* id 4, wireType 2 =*/
        34
      ).fork()).ldelim(), o;
    }, r.encodeDelimited = function(n, o) {
      return this.encode(n, o).ldelim();
    }, r.decode = function(n, o) {
      n instanceof $Reader || (n = $Reader.create(n));
      let c = o === void 0 ? n.len : n.pos + o, l = new $root.google_dv_360_sink.SinkInput();
      for (; n.pos < c; ) {
        let d = n.uint32();
        switch (d >>> 3) {
          case 1: {
            l.dependency = n.string();
            break;
          }
          case 2: {
            l.name = n.string();
            break;
          }
          case 3: {
            l.raw = $root.google_dv_360_sink.RawFile.decode(n, n.uint32());
            break;
          }
          case 4: {
            l.zip = $root.google_dv_360_sink.ZipFile.decode(n, n.uint32());
            break;
          }
          default:
            n.skipType(d & 7);
            break;
        }
      }
      return l;
    }, r.decodeDelimited = function(n) {
      return n instanceof $Reader || (n = new $Reader(n)), this.decode(n, n.uint32());
    }, r.verify = function(n) {
      if (typeof n != "object" || n === null)
        return "object expected";
      let o = {};
      if (n.dependency != null && n.hasOwnProperty("dependency") && !$util.isString(n.dependency))
        return "dependency: string expected";
      if (n.name != null && n.hasOwnProperty("name") && !$util.isString(n.name))
        return "name: string expected";
      if (n.raw != null && n.hasOwnProperty("raw")) {
        o.file = 1;
        {
          let c = $root.google_dv_360_sink.RawFile.verify(n.raw);
          if (c)
            return "raw." + c;
        }
      }
      if (n.zip != null && n.hasOwnProperty("zip")) {
        if (o.file === 1)
          return "file: multiple values";
        o.file = 1;
        {
          let c = $root.google_dv_360_sink.ZipFile.verify(n.zip);
          if (c)
            return "zip." + c;
        }
      }
      return null;
    }, r.fromObject = function(n) {
      if (n instanceof $root.google_dv_360_sink.SinkInput)
        return n;
      let o = new $root.google_dv_360_sink.SinkInput();
      if (n.dependency != null && (o.dependency = String(n.dependency)), n.name != null && (o.name = String(n.name)), n.raw != null) {
        if (typeof n.raw != "object")
          throw TypeError(".google_dv_360_sink.SinkInput.raw: object expected");
        o.raw = $root.google_dv_360_sink.RawFile.fromObject(n.raw);
      }
      if (n.zip != null) {
        if (typeof n.zip != "object")
          throw TypeError(".google_dv_360_sink.SinkInput.zip: object expected");
        o.zip = $root.google_dv_360_sink.ZipFile.fromObject(n.zip);
      }
      return o;
    }, r.toObject = function(n, o) {
      o || (o = {});
      let c = {};
      return o.defaults && (c.dependency = "", c.name = ""), n.dependency != null && n.hasOwnProperty("dependency") && (c.dependency = n.dependency), n.name != null && n.hasOwnProperty("name") && (c.name = n.name), n.raw != null && n.hasOwnProperty("raw") && (c.raw = $root.google_dv_360_sink.RawFile.toObject(n.raw, o), o.oneofs && (c.file = "raw")), n.zip != null && n.hasOwnProperty("zip") && (c.zip = $root.google_dv_360_sink.ZipFile.toObject(n.zip, o), o.oneofs && (c.file = "zip")), c;
    }, r.prototype.toJSON = function() {
      return this.constructor.toObject(this, minimal.util.toJSONOptions);
    }, r.getTypeUrl = function(n) {
      return n === void 0 && (n = "type.googleapis.com"), n + "/google_dv_360_sink.SinkInput";
    }, r;
  }(), u.GoogleDv360SinkWorkerConfiguration = function() {
    function r(a) {
      if (a)
        for (let e = Object.keys(a), n = 0; n < e.length; ++n)
          a[e[n]] != null && (this[e[n]] = a[e[n]]);
    }
    return r.prototype.input = null, r.prototype.credentialsDependency = "", r.prototype.advertiserId = "", r.prototype.displayName = "", r.prototype.description = "", r.prototype.membershipDurationDays = "", r.prototype.userConsentGiven = !1, r.create = function(e) {
      return new r(e);
    }, r.encode = function(e, n) {
      return n || (n = $Writer.create()), e.input != null && Object.hasOwnProperty.call(e, "input") && $root.google_dv_360_sink.SinkInput.encode(e.input, n.uint32(
        /* id 1, wireType 2 =*/
        10
      ).fork()).ldelim(), e.credentialsDependency != null && Object.hasOwnProperty.call(e, "credentialsDependency") && n.uint32(
        /* id 2, wireType 2 =*/
        18
      ).string(e.credentialsDependency), e.advertiserId != null && Object.hasOwnProperty.call(e, "advertiserId") && n.uint32(
        /* id 3, wireType 2 =*/
        26
      ).string(e.advertiserId), e.displayName != null && Object.hasOwnProperty.call(e, "displayName") && n.uint32(
        /* id 4, wireType 2 =*/
        34
      ).string(e.displayName), e.description != null && Object.hasOwnProperty.call(e, "description") && n.uint32(
        /* id 5, wireType 2 =*/
        42
      ).string(e.description), e.membershipDurationDays != null && Object.hasOwnProperty.call(e, "membershipDurationDays") && n.uint32(
        /* id 6, wireType 2 =*/
        50
      ).string(e.membershipDurationDays), e.userConsentGiven != null && Object.hasOwnProperty.call(e, "userConsentGiven") && n.uint32(
        /* id 7, wireType 0 =*/
        56
      ).bool(e.userConsentGiven), n;
    }, r.encodeDelimited = function(e, n) {
      return this.encode(e, n).ldelim();
    }, r.decode = function(e, n) {
      e instanceof $Reader || (e = $Reader.create(e));
      let o = n === void 0 ? e.len : e.pos + n, c = new $root.google_dv_360_sink.GoogleDv360SinkWorkerConfiguration();
      for (; e.pos < o; ) {
        let l = e.uint32();
        switch (l >>> 3) {
          case 1: {
            c.input = $root.google_dv_360_sink.SinkInput.decode(e, e.uint32());
            break;
          }
          case 2: {
            c.credentialsDependency = e.string();
            break;
          }
          case 3: {
            c.advertiserId = e.string();
            break;
          }
          case 4: {
            c.displayName = e.string();
            break;
          }
          case 5: {
            c.description = e.string();
            break;
          }
          case 6: {
            c.membershipDurationDays = e.string();
            break;
          }
          case 7: {
            c.userConsentGiven = e.bool();
            break;
          }
          default:
            e.skipType(l & 7);
            break;
        }
      }
      return c;
    }, r.decodeDelimited = function(e) {
      return e instanceof $Reader || (e = new $Reader(e)), this.decode(e, e.uint32());
    }, r.verify = function(e) {
      if (typeof e != "object" || e === null)
        return "object expected";
      if (e.input != null && e.hasOwnProperty("input")) {
        let n = $root.google_dv_360_sink.SinkInput.verify(e.input);
        if (n)
          return "input." + n;
      }
      return e.credentialsDependency != null && e.hasOwnProperty("credentialsDependency") && !$util.isString(e.credentialsDependency) ? "credentialsDependency: string expected" : e.advertiserId != null && e.hasOwnProperty("advertiserId") && !$util.isString(e.advertiserId) ? "advertiserId: string expected" : e.displayName != null && e.hasOwnProperty("displayName") && !$util.isString(e.displayName) ? "displayName: string expected" : e.description != null && e.hasOwnProperty("description") && !$util.isString(e.description) ? "description: string expected" : e.membershipDurationDays != null && e.hasOwnProperty("membershipDurationDays") && !$util.isString(e.membershipDurationDays) ? "membershipDurationDays: string expected" : e.userConsentGiven != null && e.hasOwnProperty("userConsentGiven") && typeof e.userConsentGiven != "boolean" ? "userConsentGiven: boolean expected" : null;
    }, r.fromObject = function(e) {
      if (e instanceof $root.google_dv_360_sink.GoogleDv360SinkWorkerConfiguration)
        return e;
      let n = new $root.google_dv_360_sink.GoogleDv360SinkWorkerConfiguration();
      if (e.input != null) {
        if (typeof e.input != "object")
          throw TypeError(".google_dv_360_sink.GoogleDv360SinkWorkerConfiguration.input: object expected");
        n.input = $root.google_dv_360_sink.SinkInput.fromObject(e.input);
      }
      return e.credentialsDependency != null && (n.credentialsDependency = String(e.credentialsDependency)), e.advertiserId != null && (n.advertiserId = String(e.advertiserId)), e.displayName != null && (n.displayName = String(e.displayName)), e.description != null && (n.description = String(e.description)), e.membershipDurationDays != null && (n.membershipDurationDays = String(e.membershipDurationDays)), e.userConsentGiven != null && (n.userConsentGiven = !!e.userConsentGiven), n;
    }, r.toObject = function(e, n) {
      n || (n = {});
      let o = {};
      return n.defaults && (o.input = null, o.credentialsDependency = "", o.advertiserId = "", o.displayName = "", o.description = "", o.membershipDurationDays = "", o.userConsentGiven = !1), e.input != null && e.hasOwnProperty("input") && (o.input = $root.google_dv_360_sink.SinkInput.toObject(e.input, n)), e.credentialsDependency != null && e.hasOwnProperty("credentialsDependency") && (o.credentialsDependency = e.credentialsDependency), e.advertiserId != null && e.hasOwnProperty("advertiserId") && (o.advertiserId = e.advertiserId), e.displayName != null && e.hasOwnProperty("displayName") && (o.displayName = e.displayName), e.description != null && e.hasOwnProperty("description") && (o.description = e.description), e.membershipDurationDays != null && e.hasOwnProperty("membershipDurationDays") && (o.membershipDurationDays = e.membershipDurationDays), e.userConsentGiven != null && e.hasOwnProperty("userConsentGiven") && (o.userConsentGiven = e.userConsentGiven), o;
    }, r.prototype.toJSON = function() {
      return this.constructor.toObject(this, minimal.util.toJSONOptions);
    }, r.getTypeUrl = function(e) {
      return e === void 0 && (e = "type.googleapis.com"), e + "/google_dv_360_sink.GoogleDv360SinkWorkerConfiguration";
    }, r;
  }(), u;
})();
$root.meta_sink = (() => {
  const u = {};
  return u.SingleFile = function() {
    function r(a) {
      if (a)
        for (let e = Object.keys(a), n = 0; n < e.length; ++n)
          a[e[n]] != null && (this[e[n]] = a[e[n]]);
    }
    return r.prototype.name = "", r.create = function(e) {
      return new r(e);
    }, r.encode = function(e, n) {
      return n || (n = $Writer.create()), e.name != null && Object.hasOwnProperty.call(e, "name") && n.uint32(
        /* id 1, wireType 2 =*/
        10
      ).string(e.name), n;
    }, r.encodeDelimited = function(e, n) {
      return this.encode(e, n).ldelim();
    }, r.decode = function(e, n) {
      e instanceof $Reader || (e = $Reader.create(e));
      let o = n === void 0 ? e.len : e.pos + n, c = new $root.meta_sink.SingleFile();
      for (; e.pos < o; ) {
        let l = e.uint32();
        switch (l >>> 3) {
          case 1: {
            c.name = e.string();
            break;
          }
          default:
            e.skipType(l & 7);
            break;
        }
      }
      return c;
    }, r.decodeDelimited = function(e) {
      return e instanceof $Reader || (e = new $Reader(e)), this.decode(e, e.uint32());
    }, r.verify = function(e) {
      return typeof e != "object" || e === null ? "object expected" : e.name != null && e.hasOwnProperty("name") && !$util.isString(e.name) ? "name: string expected" : null;
    }, r.fromObject = function(e) {
      if (e instanceof $root.meta_sink.SingleFile)
        return e;
      let n = new $root.meta_sink.SingleFile();
      return e.name != null && (n.name = String(e.name)), n;
    }, r.toObject = function(e, n) {
      n || (n = {});
      let o = {};
      return n.defaults && (o.name = ""), e.name != null && e.hasOwnProperty("name") && (o.name = e.name), o;
    }, r.prototype.toJSON = function() {
      return this.constructor.toObject(this, minimal.util.toJSONOptions);
    }, r.getTypeUrl = function(e) {
      return e === void 0 && (e = "type.googleapis.com"), e + "/meta_sink.SingleFile";
    }, r;
  }(), u.RawFile = function() {
    function r(a) {
      if (a)
        for (let e = Object.keys(a), n = 0; n < e.length; ++n)
          a[e[n]] != null && (this[e[n]] = a[e[n]]);
    }
    return r.create = function(e) {
      return new r(e);
    }, r.encode = function(e, n) {
      return n || (n = $Writer.create()), n;
    }, r.encodeDelimited = function(e, n) {
      return this.encode(e, n).ldelim();
    }, r.decode = function(e, n) {
      e instanceof $Reader || (e = $Reader.create(e));
      let o = n === void 0 ? e.len : e.pos + n, c = new $root.meta_sink.RawFile();
      for (; e.pos < o; ) {
        let l = e.uint32();
        switch (l >>> 3) {
          default:
            e.skipType(l & 7);
            break;
        }
      }
      return c;
    }, r.decodeDelimited = function(e) {
      return e instanceof $Reader || (e = new $Reader(e)), this.decode(e, e.uint32());
    }, r.verify = function(e) {
      return typeof e != "object" || e === null ? "object expected" : null;
    }, r.fromObject = function(e) {
      return e instanceof $root.meta_sink.RawFile ? e : new $root.meta_sink.RawFile();
    }, r.toObject = function() {
      return {};
    }, r.prototype.toJSON = function() {
      return this.constructor.toObject(this, minimal.util.toJSONOptions);
    }, r.getTypeUrl = function(e) {
      return e === void 0 && (e = "type.googleapis.com"), e + "/meta_sink.RawFile";
    }, r;
  }(), u.ZipFile = function() {
    function r(e) {
      if (e)
        for (let n = Object.keys(e), o = 0; o < n.length; ++o)
          e[n[o]] != null && (this[n[o]] = e[n[o]]);
    }
    r.prototype.singleFile = null;
    let a;
    return Object.defineProperty(r.prototype, "selection", {
      get: $util.oneOfGetter(a = ["singleFile"]),
      set: $util.oneOfSetter(a)
    }), r.create = function(n) {
      return new r(n);
    }, r.encode = function(n, o) {
      return o || (o = $Writer.create()), n.singleFile != null && Object.hasOwnProperty.call(n, "singleFile") && $root.meta_sink.SingleFile.encode(n.singleFile, o.uint32(
        /* id 1, wireType 2 =*/
        10
      ).fork()).ldelim(), o;
    }, r.encodeDelimited = function(n, o) {
      return this.encode(n, o).ldelim();
    }, r.decode = function(n, o) {
      n instanceof $Reader || (n = $Reader.create(n));
      let c = o === void 0 ? n.len : n.pos + o, l = new $root.meta_sink.ZipFile();
      for (; n.pos < c; ) {
        let d = n.uint32();
        switch (d >>> 3) {
          case 1: {
            l.singleFile = $root.meta_sink.SingleFile.decode(n, n.uint32());
            break;
          }
          default:
            n.skipType(d & 7);
            break;
        }
      }
      return l;
    }, r.decodeDelimited = function(n) {
      return n instanceof $Reader || (n = new $Reader(n)), this.decode(n, n.uint32());
    }, r.verify = function(n) {
      if (typeof n != "object" || n === null)
        return "object expected";
      if (n.singleFile != null && n.hasOwnProperty("singleFile")) {
        let o = $root.meta_sink.SingleFile.verify(n.singleFile);
        if (o)
          return "singleFile." + o;
      }
      return null;
    }, r.fromObject = function(n) {
      if (n instanceof $root.meta_sink.ZipFile)
        return n;
      let o = new $root.meta_sink.ZipFile();
      if (n.singleFile != null) {
        if (typeof n.singleFile != "object")
          throw TypeError(".meta_sink.ZipFile.singleFile: object expected");
        o.singleFile = $root.meta_sink.SingleFile.fromObject(n.singleFile);
      }
      return o;
    }, r.toObject = function(n, o) {
      o || (o = {});
      let c = {};
      return n.singleFile != null && n.hasOwnProperty("singleFile") && (c.singleFile = $root.meta_sink.SingleFile.toObject(n.singleFile, o), o.oneofs && (c.selection = "singleFile")), c;
    }, r.prototype.toJSON = function() {
      return this.constructor.toObject(this, minimal.util.toJSONOptions);
    }, r.getTypeUrl = function(n) {
      return n === void 0 && (n = "type.googleapis.com"), n + "/meta_sink.ZipFile";
    }, r;
  }(), u.SinkInput = function() {
    function r(e) {
      if (e)
        for (let n = Object.keys(e), o = 0; o < n.length; ++o)
          e[n[o]] != null && (this[n[o]] = e[n[o]]);
    }
    r.prototype.dependency = "", r.prototype.name = "", r.prototype.raw = null, r.prototype.zip = null;
    let a;
    return Object.defineProperty(r.prototype, "file", {
      get: $util.oneOfGetter(a = ["raw", "zip"]),
      set: $util.oneOfSetter(a)
    }), r.create = function(n) {
      return new r(n);
    }, r.encode = function(n, o) {
      return o || (o = $Writer.create()), n.dependency != null && Object.hasOwnProperty.call(n, "dependency") && o.uint32(
        /* id 1, wireType 2 =*/
        10
      ).string(n.dependency), n.name != null && Object.hasOwnProperty.call(n, "name") && o.uint32(
        /* id 2, wireType 2 =*/
        18
      ).string(n.name), n.raw != null && Object.hasOwnProperty.call(n, "raw") && $root.meta_sink.RawFile.encode(n.raw, o.uint32(
        /* id 3, wireType 2 =*/
        26
      ).fork()).ldelim(), n.zip != null && Object.hasOwnProperty.call(n, "zip") && $root.meta_sink.ZipFile.encode(n.zip, o.uint32(
        /* id 4, wireType 2 =*/
        34
      ).fork()).ldelim(), o;
    }, r.encodeDelimited = function(n, o) {
      return this.encode(n, o).ldelim();
    }, r.decode = function(n, o) {
      n instanceof $Reader || (n = $Reader.create(n));
      let c = o === void 0 ? n.len : n.pos + o, l = new $root.meta_sink.SinkInput();
      for (; n.pos < c; ) {
        let d = n.uint32();
        switch (d >>> 3) {
          case 1: {
            l.dependency = n.string();
            break;
          }
          case 2: {
            l.name = n.string();
            break;
          }
          case 3: {
            l.raw = $root.meta_sink.RawFile.decode(n, n.uint32());
            break;
          }
          case 4: {
            l.zip = $root.meta_sink.ZipFile.decode(n, n.uint32());
            break;
          }
          default:
            n.skipType(d & 7);
            break;
        }
      }
      return l;
    }, r.decodeDelimited = function(n) {
      return n instanceof $Reader || (n = new $Reader(n)), this.decode(n, n.uint32());
    }, r.verify = function(n) {
      if (typeof n != "object" || n === null)
        return "object expected";
      let o = {};
      if (n.dependency != null && n.hasOwnProperty("dependency") && !$util.isString(n.dependency))
        return "dependency: string expected";
      if (n.name != null && n.hasOwnProperty("name") && !$util.isString(n.name))
        return "name: string expected";
      if (n.raw != null && n.hasOwnProperty("raw")) {
        o.file = 1;
        {
          let c = $root.meta_sink.RawFile.verify(n.raw);
          if (c)
            return "raw." + c;
        }
      }
      if (n.zip != null && n.hasOwnProperty("zip")) {
        if (o.file === 1)
          return "file: multiple values";
        o.file = 1;
        {
          let c = $root.meta_sink.ZipFile.verify(n.zip);
          if (c)
            return "zip." + c;
        }
      }
      return null;
    }, r.fromObject = function(n) {
      if (n instanceof $root.meta_sink.SinkInput)
        return n;
      let o = new $root.meta_sink.SinkInput();
      if (n.dependency != null && (o.dependency = String(n.dependency)), n.name != null && (o.name = String(n.name)), n.raw != null) {
        if (typeof n.raw != "object")
          throw TypeError(".meta_sink.SinkInput.raw: object expected");
        o.raw = $root.meta_sink.RawFile.fromObject(n.raw);
      }
      if (n.zip != null) {
        if (typeof n.zip != "object")
          throw TypeError(".meta_sink.SinkInput.zip: object expected");
        o.zip = $root.meta_sink.ZipFile.fromObject(n.zip);
      }
      return o;
    }, r.toObject = function(n, o) {
      o || (o = {});
      let c = {};
      return o.defaults && (c.dependency = "", c.name = ""), n.dependency != null && n.hasOwnProperty("dependency") && (c.dependency = n.dependency), n.name != null && n.hasOwnProperty("name") && (c.name = n.name), n.raw != null && n.hasOwnProperty("raw") && (c.raw = $root.meta_sink.RawFile.toObject(n.raw, o), o.oneofs && (c.file = "raw")), n.zip != null && n.hasOwnProperty("zip") && (c.zip = $root.meta_sink.ZipFile.toObject(n.zip, o), o.oneofs && (c.file = "zip")), c;
    }, r.prototype.toJSON = function() {
      return this.constructor.toObject(this, minimal.util.toJSONOptions);
    }, r.getTypeUrl = function(n) {
      return n === void 0 && (n = "type.googleapis.com"), n + "/meta_sink.SinkInput";
    }, r;
  }(), u.MetaSinkWorkerConfiguration = function() {
    function r(e) {
      if (e)
        for (let n = Object.keys(e), o = 0; o < n.length; ++o)
          e[n[o]] != null && (this[n[o]] = e[n[o]]);
    }
    r.prototype.input = null, r.prototype.accessTokenDependency = "", r.prototype.adAccountId = "", r.prototype.audienceName = "", r.prototype.apiVersion = null;
    let a;
    return Object.defineProperty(r.prototype, "_apiVersion", {
      get: $util.oneOfGetter(a = ["apiVersion"]),
      set: $util.oneOfSetter(a)
    }), r.create = function(n) {
      return new r(n);
    }, r.encode = function(n, o) {
      return o || (o = $Writer.create()), n.input != null && Object.hasOwnProperty.call(n, "input") && $root.meta_sink.SinkInput.encode(n.input, o.uint32(
        /* id 1, wireType 2 =*/
        10
      ).fork()).ldelim(), n.accessTokenDependency != null && Object.hasOwnProperty.call(n, "accessTokenDependency") && o.uint32(
        /* id 2, wireType 2 =*/
        18
      ).string(n.accessTokenDependency), n.adAccountId != null && Object.hasOwnProperty.call(n, "adAccountId") && o.uint32(
        /* id 3, wireType 2 =*/
        26
      ).string(n.adAccountId), n.audienceName != null && Object.hasOwnProperty.call(n, "audienceName") && o.uint32(
        /* id 4, wireType 2 =*/
        34
      ).string(n.audienceName), n.apiVersion != null && Object.hasOwnProperty.call(n, "apiVersion") && o.uint32(
        /* id 5, wireType 2 =*/
        42
      ).string(n.apiVersion), o;
    }, r.encodeDelimited = function(n, o) {
      return this.encode(n, o).ldelim();
    }, r.decode = function(n, o) {
      n instanceof $Reader || (n = $Reader.create(n));
      let c = o === void 0 ? n.len : n.pos + o, l = new $root.meta_sink.MetaSinkWorkerConfiguration();
      for (; n.pos < c; ) {
        let d = n.uint32();
        switch (d >>> 3) {
          case 1: {
            l.input = $root.meta_sink.SinkInput.decode(n, n.uint32());
            break;
          }
          case 2: {
            l.accessTokenDependency = n.string();
            break;
          }
          case 3: {
            l.adAccountId = n.string();
            break;
          }
          case 4: {
            l.audienceName = n.string();
            break;
          }
          case 5: {
            l.apiVersion = n.string();
            break;
          }
          default:
            n.skipType(d & 7);
            break;
        }
      }
      return l;
    }, r.decodeDelimited = function(n) {
      return n instanceof $Reader || (n = new $Reader(n)), this.decode(n, n.uint32());
    }, r.verify = function(n) {
      if (typeof n != "object" || n === null)
        return "object expected";
      if (n.input != null && n.hasOwnProperty("input")) {
        let o = $root.meta_sink.SinkInput.verify(n.input);
        if (o)
          return "input." + o;
      }
      return n.accessTokenDependency != null && n.hasOwnProperty("accessTokenDependency") && !$util.isString(n.accessTokenDependency) ? "accessTokenDependency: string expected" : n.adAccountId != null && n.hasOwnProperty("adAccountId") && !$util.isString(n.adAccountId) ? "adAccountId: string expected" : n.audienceName != null && n.hasOwnProperty("audienceName") && !$util.isString(n.audienceName) ? "audienceName: string expected" : n.apiVersion != null && n.hasOwnProperty("apiVersion") && !$util.isString(n.apiVersion) ? "apiVersion: string expected" : null;
    }, r.fromObject = function(n) {
      if (n instanceof $root.meta_sink.MetaSinkWorkerConfiguration)
        return n;
      let o = new $root.meta_sink.MetaSinkWorkerConfiguration();
      if (n.input != null) {
        if (typeof n.input != "object")
          throw TypeError(".meta_sink.MetaSinkWorkerConfiguration.input: object expected");
        o.input = $root.meta_sink.SinkInput.fromObject(n.input);
      }
      return n.accessTokenDependency != null && (o.accessTokenDependency = String(n.accessTokenDependency)), n.adAccountId != null && (o.adAccountId = String(n.adAccountId)), n.audienceName != null && (o.audienceName = String(n.audienceName)), n.apiVersion != null && (o.apiVersion = String(n.apiVersion)), o;
    }, r.toObject = function(n, o) {
      o || (o = {});
      let c = {};
      return o.defaults && (c.input = null, c.accessTokenDependency = "", c.adAccountId = "", c.audienceName = ""), n.input != null && n.hasOwnProperty("input") && (c.input = $root.meta_sink.SinkInput.toObject(n.input, o)), n.accessTokenDependency != null && n.hasOwnProperty("accessTokenDependency") && (c.accessTokenDependency = n.accessTokenDependency), n.adAccountId != null && n.hasOwnProperty("adAccountId") && (c.adAccountId = n.adAccountId), n.audienceName != null && n.hasOwnProperty("audienceName") && (c.audienceName = n.audienceName), n.apiVersion != null && n.hasOwnProperty("apiVersion") && (c.apiVersion = n.apiVersion, o.oneofs && (c._apiVersion = "apiVersion")), c;
    }, r.prototype.toJSON = function() {
      return this.constructor.toObject(this, minimal.util.toJSONOptions);
    }, r.getTypeUrl = function(n) {
      return n === void 0 && (n = "type.googleapis.com"), n + "/meta_sink.MetaSinkWorkerConfiguration";
    }, r;
  }(), u;
})();
$root.metering = (() => {
  const u = {};
  return u.EnclaveInfo = function() {
    function r(e) {
      if (e)
        for (let n = Object.keys(e), o = 0; o < n.length; ++o)
          e[n[o]] != null && (this[n[o]] = e[n[o]]);
    }
    r.prototype.attestationSpecHashHex = "", r.prototype.taskQueueName = null;
    let a;
    return Object.defineProperty(r.prototype, "_taskQueueName", {
      get: $util.oneOfGetter(a = ["taskQueueName"]),
      set: $util.oneOfSetter(a)
    }), r.create = function(n) {
      return new r(n);
    }, r.encode = function(n, o) {
      return o || (o = $Writer.create()), n.attestationSpecHashHex != null && Object.hasOwnProperty.call(n, "attestationSpecHashHex") && o.uint32(
        /* id 1, wireType 2 =*/
        10
      ).string(n.attestationSpecHashHex), n.taskQueueName != null && Object.hasOwnProperty.call(n, "taskQueueName") && o.uint32(
        /* id 2, wireType 2 =*/
        18
      ).string(n.taskQueueName), o;
    }, r.encodeDelimited = function(n, o) {
      return this.encode(n, o).ldelim();
    }, r.decode = function(n, o) {
      n instanceof $Reader || (n = $Reader.create(n));
      let c = o === void 0 ? n.len : n.pos + o, l = new $root.metering.EnclaveInfo();
      for (; n.pos < c; ) {
        let d = n.uint32();
        switch (d >>> 3) {
          case 1: {
            l.attestationSpecHashHex = n.string();
            break;
          }
          case 2: {
            l.taskQueueName = n.string();
            break;
          }
          default:
            n.skipType(d & 7);
            break;
        }
      }
      return l;
    }, r.decodeDelimited = function(n) {
      return n instanceof $Reader || (n = new $Reader(n)), this.decode(n, n.uint32());
    }, r.verify = function(n) {
      return typeof n != "object" || n === null ? "object expected" : n.attestationSpecHashHex != null && n.hasOwnProperty("attestationSpecHashHex") && !$util.isString(n.attestationSpecHashHex) ? "attestationSpecHashHex: string expected" : n.taskQueueName != null && n.hasOwnProperty("taskQueueName") && !$util.isString(n.taskQueueName) ? "taskQueueName: string expected" : null;
    }, r.fromObject = function(n) {
      if (n instanceof $root.metering.EnclaveInfo)
        return n;
      let o = new $root.metering.EnclaveInfo();
      return n.attestationSpecHashHex != null && (o.attestationSpecHashHex = String(n.attestationSpecHashHex)), n.taskQueueName != null && (o.taskQueueName = String(n.taskQueueName)), o;
    }, r.toObject = function(n, o) {
      o || (o = {});
      let c = {};
      return o.defaults && (c.attestationSpecHashHex = ""), n.attestationSpecHashHex != null && n.hasOwnProperty("attestationSpecHashHex") && (c.attestationSpecHashHex = n.attestationSpecHashHex), n.taskQueueName != null && n.hasOwnProperty("taskQueueName") && (c.taskQueueName = n.taskQueueName, o.oneofs && (c._taskQueueName = "taskQueueName")), c;
    }, r.prototype.toJSON = function() {
      return this.constructor.toObject(this, minimal.util.toJSONOptions);
    }, r.getTypeUrl = function(n) {
      return n === void 0 && (n = "type.googleapis.com"), n + "/metering.EnclaveInfo";
    }, r;
  }(), u.MeteringRequest = function() {
    function r(e) {
      if (e)
        for (let n = Object.keys(e), o = 0; o < n.length; ++o)
          e[n[o]] != null && (this[n[o]] = e[n[o]]);
    }
    r.prototype.createDcr = null, r.prototype.createDcrCommit = null, r.prototype.stopDcr = null, r.prototype.publishDataset = null, r.prototype.unpublishDataset = null, r.prototype.workerMetadata = null, r.prototype.submitWorkerExecutionTime = null, r.prototype.dcrInteraction = null, r.prototype.createDataset = null, r.prototype.getOrCreateDatasetScope = null, r.prototype.mergeDcrCommit = null, r.prototype.getDataConnectorCredentials = null, r.prototype.integrityStore = null, r.prototype.getAzureCommunicationCredentials = null, r.prototype.getOrCreateDcrDataScope = null, r.prototype.recordDcrInteraction = null;
    let a;
    return Object.defineProperty(r.prototype, "request", {
      get: $util.oneOfGetter(a = ["createDcr", "createDcrCommit", "stopDcr", "publishDataset", "unpublishDataset", "workerMetadata", "submitWorkerExecutionTime", "dcrInteraction", "createDataset", "getOrCreateDatasetScope", "mergeDcrCommit", "getDataConnectorCredentials", "integrityStore", "getAzureCommunicationCredentials", "getOrCreateDcrDataScope", "recordDcrInteraction"]),
      set: $util.oneOfSetter(a)
    }), r.create = function(n) {
      return new r(n);
    }, r.encode = function(n, o) {
      return o || (o = $Writer.create()), n.createDcr != null && Object.hasOwnProperty.call(n, "createDcr") && $root.metering.CreateDcrRequest.encode(n.createDcr, o.uint32(
        /* id 1, wireType 2 =*/
        10
      ).fork()).ldelim(), n.createDcrCommit != null && Object.hasOwnProperty.call(n, "createDcrCommit") && $root.metering.CreateDcrCommitRequest.encode(n.createDcrCommit, o.uint32(
        /* id 2, wireType 2 =*/
        18
      ).fork()).ldelim(), n.stopDcr != null && Object.hasOwnProperty.call(n, "stopDcr") && $root.metering.StopDcrRequest.encode(n.stopDcr, o.uint32(
        /* id 3, wireType 2 =*/
        26
      ).fork()).ldelim(), n.publishDataset != null && Object.hasOwnProperty.call(n, "publishDataset") && $root.metering.PublishDatasetRequest.encode(n.publishDataset, o.uint32(
        /* id 4, wireType 2 =*/
        34
      ).fork()).ldelim(), n.unpublishDataset != null && Object.hasOwnProperty.call(n, "unpublishDataset") && $root.metering.UnpublishDatasetRequest.encode(n.unpublishDataset, o.uint32(
        /* id 5, wireType 2 =*/
        42
      ).fork()).ldelim(), n.workerMetadata != null && Object.hasOwnProperty.call(n, "workerMetadata") && $root.metering.WorkerMetadataRequest.encode(n.workerMetadata, o.uint32(
        /* id 6, wireType 2 =*/
        50
      ).fork()).ldelim(), n.submitWorkerExecutionTime != null && Object.hasOwnProperty.call(n, "submitWorkerExecutionTime") && $root.metering.SubmitWorkerExecutionTimeRequest.encode(n.submitWorkerExecutionTime, o.uint32(
        /* id 7, wireType 2 =*/
        58
      ).fork()).ldelim(), n.dcrInteraction != null && Object.hasOwnProperty.call(n, "dcrInteraction") && $root.metering.DcrInteractionRequest.encode(n.dcrInteraction, o.uint32(
        /* id 8, wireType 2 =*/
        66
      ).fork()).ldelim(), n.createDataset != null && Object.hasOwnProperty.call(n, "createDataset") && $root.metering.CreateDatasetRequest.encode(n.createDataset, o.uint32(
        /* id 9, wireType 2 =*/
        74
      ).fork()).ldelim(), n.getOrCreateDatasetScope != null && Object.hasOwnProperty.call(n, "getOrCreateDatasetScope") && $root.metering.GetOrCreateDatasetScopeRequest.encode(n.getOrCreateDatasetScope, o.uint32(
        /* id 10, wireType 2 =*/
        82
      ).fork()).ldelim(), n.mergeDcrCommit != null && Object.hasOwnProperty.call(n, "mergeDcrCommit") && $root.metering.MergeDcrCommitRequest.encode(n.mergeDcrCommit, o.uint32(
        /* id 11, wireType 2 =*/
        90
      ).fork()).ldelim(), n.getDataConnectorCredentials != null && Object.hasOwnProperty.call(n, "getDataConnectorCredentials") && $root.metering.GetDataConnectorCredentialsRequest.encode(n.getDataConnectorCredentials, o.uint32(
        /* id 12, wireType 2 =*/
        98
      ).fork()).ldelim(), n.integrityStore != null && Object.hasOwnProperty.call(n, "integrityStore") && $root.integrity_store_api.IntegrityStoreRequest.encode(n.integrityStore, o.uint32(
        /* id 13, wireType 2 =*/
        106
      ).fork()).ldelim(), n.getAzureCommunicationCredentials != null && Object.hasOwnProperty.call(n, "getAzureCommunicationCredentials") && $root.metering.GetAzureCommunicationCredentialsRequest.encode(n.getAzureCommunicationCredentials, o.uint32(
        /* id 14, wireType 2 =*/
        114
      ).fork()).ldelim(), n.getOrCreateDcrDataScope != null && Object.hasOwnProperty.call(n, "getOrCreateDcrDataScope") && $root.metering.GetOrCreateDcrDataScopeRequest.encode(n.getOrCreateDcrDataScope, o.uint32(
        /* id 15, wireType 2 =*/
        122
      ).fork()).ldelim(), n.recordDcrInteraction != null && Object.hasOwnProperty.call(n, "recordDcrInteraction") && $root.metering.RecordDcrInteractionRequest.encode(n.recordDcrInteraction, o.uint32(
        /* id 16, wireType 2 =*/
        130
      ).fork()).ldelim(), o;
    }, r.encodeDelimited = function(n, o) {
      return this.encode(n, o).ldelim();
    }, r.decode = function(n, o) {
      n instanceof $Reader || (n = $Reader.create(n));
      let c = o === void 0 ? n.len : n.pos + o, l = new $root.metering.MeteringRequest();
      for (; n.pos < c; ) {
        let d = n.uint32();
        switch (d >>> 3) {
          case 1: {
            l.createDcr = $root.metering.CreateDcrRequest.decode(n, n.uint32());
            break;
          }
          case 2: {
            l.createDcrCommit = $root.metering.CreateDcrCommitRequest.decode(n, n.uint32());
            break;
          }
          case 3: {
            l.stopDcr = $root.metering.StopDcrRequest.decode(n, n.uint32());
            break;
          }
          case 4: {
            l.publishDataset = $root.metering.PublishDatasetRequest.decode(n, n.uint32());
            break;
          }
          case 5: {
            l.unpublishDataset = $root.metering.UnpublishDatasetRequest.decode(n, n.uint32());
            break;
          }
          case 6: {
            l.workerMetadata = $root.metering.WorkerMetadataRequest.decode(n, n.uint32());
            break;
          }
          case 7: {
            l.submitWorkerExecutionTime = $root.metering.SubmitWorkerExecutionTimeRequest.decode(n, n.uint32());
            break;
          }
          case 8: {
            l.dcrInteraction = $root.metering.DcrInteractionRequest.decode(n, n.uint32());
            break;
          }
          case 9: {
            l.createDataset = $root.metering.CreateDatasetRequest.decode(n, n.uint32());
            break;
          }
          case 10: {
            l.getOrCreateDatasetScope = $root.metering.GetOrCreateDatasetScopeRequest.decode(n, n.uint32());
            break;
          }
          case 11: {
            l.mergeDcrCommit = $root.metering.MergeDcrCommitRequest.decode(n, n.uint32());
            break;
          }
          case 12: {
            l.getDataConnectorCredentials = $root.metering.GetDataConnectorCredentialsRequest.decode(n, n.uint32());
            break;
          }
          case 13: {
            l.integrityStore = $root.integrity_store_api.IntegrityStoreRequest.decode(n, n.uint32());
            break;
          }
          case 14: {
            l.getAzureCommunicationCredentials = $root.metering.GetAzureCommunicationCredentialsRequest.decode(n, n.uint32());
            break;
          }
          case 15: {
            l.getOrCreateDcrDataScope = $root.metering.GetOrCreateDcrDataScopeRequest.decode(n, n.uint32());
            break;
          }
          case 16: {
            l.recordDcrInteraction = $root.metering.RecordDcrInteractionRequest.decode(n, n.uint32());
            break;
          }
          default:
            n.skipType(d & 7);
            break;
        }
      }
      return l;
    }, r.decodeDelimited = function(n) {
      return n instanceof $Reader || (n = new $Reader(n)), this.decode(n, n.uint32());
    }, r.verify = function(n) {
      if (typeof n != "object" || n === null)
        return "object expected";
      let o = {};
      if (n.createDcr != null && n.hasOwnProperty("createDcr")) {
        o.request = 1;
        {
          let c = $root.metering.CreateDcrRequest.verify(n.createDcr);
          if (c)
            return "createDcr." + c;
        }
      }
      if (n.createDcrCommit != null && n.hasOwnProperty("createDcrCommit")) {
        if (o.request === 1)
          return "request: multiple values";
        o.request = 1;
        {
          let c = $root.metering.CreateDcrCommitRequest.verify(n.createDcrCommit);
          if (c)
            return "createDcrCommit." + c;
        }
      }
      if (n.stopDcr != null && n.hasOwnProperty("stopDcr")) {
        if (o.request === 1)
          return "request: multiple values";
        o.request = 1;
        {
          let c = $root.metering.StopDcrRequest.verify(n.stopDcr);
          if (c)
            return "stopDcr." + c;
        }
      }
      if (n.publishDataset != null && n.hasOwnProperty("publishDataset")) {
        if (o.request === 1)
          return "request: multiple values";
        o.request = 1;
        {
          let c = $root.metering.PublishDatasetRequest.verify(n.publishDataset);
          if (c)
            return "publishDataset." + c;
        }
      }
      if (n.unpublishDataset != null && n.hasOwnProperty("unpublishDataset")) {
        if (o.request === 1)
          return "request: multiple values";
        o.request = 1;
        {
          let c = $root.metering.UnpublishDatasetRequest.verify(n.unpublishDataset);
          if (c)
            return "unpublishDataset." + c;
        }
      }
      if (n.workerMetadata != null && n.hasOwnProperty("workerMetadata")) {
        if (o.request === 1)
          return "request: multiple values";
        o.request = 1;
        {
          let c = $root.metering.WorkerMetadataRequest.verify(n.workerMetadata);
          if (c)
            return "workerMetadata." + c;
        }
      }
      if (n.submitWorkerExecutionTime != null && n.hasOwnProperty("submitWorkerExecutionTime")) {
        if (o.request === 1)
          return "request: multiple values";
        o.request = 1;
        {
          let c = $root.metering.SubmitWorkerExecutionTimeRequest.verify(n.submitWorkerExecutionTime);
          if (c)
            return "submitWorkerExecutionTime." + c;
        }
      }
      if (n.dcrInteraction != null && n.hasOwnProperty("dcrInteraction")) {
        if (o.request === 1)
          return "request: multiple values";
        o.request = 1;
        {
          let c = $root.metering.DcrInteractionRequest.verify(n.dcrInteraction);
          if (c)
            return "dcrInteraction." + c;
        }
      }
      if (n.createDataset != null && n.hasOwnProperty("createDataset")) {
        if (o.request === 1)
          return "request: multiple values";
        o.request = 1;
        {
          let c = $root.metering.CreateDatasetRequest.verify(n.createDataset);
          if (c)
            return "createDataset." + c;
        }
      }
      if (n.getOrCreateDatasetScope != null && n.hasOwnProperty("getOrCreateDatasetScope")) {
        if (o.request === 1)
          return "request: multiple values";
        o.request = 1;
        {
          let c = $root.metering.GetOrCreateDatasetScopeRequest.verify(n.getOrCreateDatasetScope);
          if (c)
            return "getOrCreateDatasetScope." + c;
        }
      }
      if (n.mergeDcrCommit != null && n.hasOwnProperty("mergeDcrCommit")) {
        if (o.request === 1)
          return "request: multiple values";
        o.request = 1;
        {
          let c = $root.metering.MergeDcrCommitRequest.verify(n.mergeDcrCommit);
          if (c)
            return "mergeDcrCommit." + c;
        }
      }
      if (n.getDataConnectorCredentials != null && n.hasOwnProperty("getDataConnectorCredentials")) {
        if (o.request === 1)
          return "request: multiple values";
        o.request = 1;
        {
          let c = $root.metering.GetDataConnectorCredentialsRequest.verify(n.getDataConnectorCredentials);
          if (c)
            return "getDataConnectorCredentials." + c;
        }
      }
      if (n.integrityStore != null && n.hasOwnProperty("integrityStore")) {
        if (o.request === 1)
          return "request: multiple values";
        o.request = 1;
        {
          let c = $root.integrity_store_api.IntegrityStoreRequest.verify(n.integrityStore);
          if (c)
            return "integrityStore." + c;
        }
      }
      if (n.getAzureCommunicationCredentials != null && n.hasOwnProperty("getAzureCommunicationCredentials")) {
        if (o.request === 1)
          return "request: multiple values";
        o.request = 1;
        {
          let c = $root.metering.GetAzureCommunicationCredentialsRequest.verify(n.getAzureCommunicationCredentials);
          if (c)
            return "getAzureCommunicationCredentials." + c;
        }
      }
      if (n.getOrCreateDcrDataScope != null && n.hasOwnProperty("getOrCreateDcrDataScope")) {
        if (o.request === 1)
          return "request: multiple values";
        o.request = 1;
        {
          let c = $root.metering.GetOrCreateDcrDataScopeRequest.verify(n.getOrCreateDcrDataScope);
          if (c)
            return "getOrCreateDcrDataScope." + c;
        }
      }
      if (n.recordDcrInteraction != null && n.hasOwnProperty("recordDcrInteraction")) {
        if (o.request === 1)
          return "request: multiple values";
        o.request = 1;
        {
          let c = $root.metering.RecordDcrInteractionRequest.verify(n.recordDcrInteraction);
          if (c)
            return "recordDcrInteraction." + c;
        }
      }
      return null;
    }, r.fromObject = function(n) {
      if (n instanceof $root.metering.MeteringRequest)
        return n;
      let o = new $root.metering.MeteringRequest();
      if (n.createDcr != null) {
        if (typeof n.createDcr != "object")
          throw TypeError(".metering.MeteringRequest.createDcr: object expected");
        o.createDcr = $root.metering.CreateDcrRequest.fromObject(n.createDcr);
      }
      if (n.createDcrCommit != null) {
        if (typeof n.createDcrCommit != "object")
          throw TypeError(".metering.MeteringRequest.createDcrCommit: object expected");
        o.createDcrCommit = $root.metering.CreateDcrCommitRequest.fromObject(n.createDcrCommit);
      }
      if (n.stopDcr != null) {
        if (typeof n.stopDcr != "object")
          throw TypeError(".metering.MeteringRequest.stopDcr: object expected");
        o.stopDcr = $root.metering.StopDcrRequest.fromObject(n.stopDcr);
      }
      if (n.publishDataset != null) {
        if (typeof n.publishDataset != "object")
          throw TypeError(".metering.MeteringRequest.publishDataset: object expected");
        o.publishDataset = $root.metering.PublishDatasetRequest.fromObject(n.publishDataset);
      }
      if (n.unpublishDataset != null) {
        if (typeof n.unpublishDataset != "object")
          throw TypeError(".metering.MeteringRequest.unpublishDataset: object expected");
        o.unpublishDataset = $root.metering.UnpublishDatasetRequest.fromObject(n.unpublishDataset);
      }
      if (n.workerMetadata != null) {
        if (typeof n.workerMetadata != "object")
          throw TypeError(".metering.MeteringRequest.workerMetadata: object expected");
        o.workerMetadata = $root.metering.WorkerMetadataRequest.fromObject(n.workerMetadata);
      }
      if (n.submitWorkerExecutionTime != null) {
        if (typeof n.submitWorkerExecutionTime != "object")
          throw TypeError(".metering.MeteringRequest.submitWorkerExecutionTime: object expected");
        o.submitWorkerExecutionTime = $root.metering.SubmitWorkerExecutionTimeRequest.fromObject(n.submitWorkerExecutionTime);
      }
      if (n.dcrInteraction != null) {
        if (typeof n.dcrInteraction != "object")
          throw TypeError(".metering.MeteringRequest.dcrInteraction: object expected");
        o.dcrInteraction = $root.metering.DcrInteractionRequest.fromObject(n.dcrInteraction);
      }
      if (n.createDataset != null) {
        if (typeof n.createDataset != "object")
          throw TypeError(".metering.MeteringRequest.createDataset: object expected");
        o.createDataset = $root.metering.CreateDatasetRequest.fromObject(n.createDataset);
      }
      if (n.getOrCreateDatasetScope != null) {
        if (typeof n.getOrCreateDatasetScope != "object")
          throw TypeError(".metering.MeteringRequest.getOrCreateDatasetScope: object expected");
        o.getOrCreateDatasetScope = $root.metering.GetOrCreateDatasetScopeRequest.fromObject(n.getOrCreateDatasetScope);
      }
      if (n.mergeDcrCommit != null) {
        if (typeof n.mergeDcrCommit != "object")
          throw TypeError(".metering.MeteringRequest.mergeDcrCommit: object expected");
        o.mergeDcrCommit = $root.metering.MergeDcrCommitRequest.fromObject(n.mergeDcrCommit);
      }
      if (n.getDataConnectorCredentials != null) {
        if (typeof n.getDataConnectorCredentials != "object")
          throw TypeError(".metering.MeteringRequest.getDataConnectorCredentials: object expected");
        o.getDataConnectorCredentials = $root.metering.GetDataConnectorCredentialsRequest.fromObject(n.getDataConnectorCredentials);
      }
      if (n.integrityStore != null) {
        if (typeof n.integrityStore != "object")
          throw TypeError(".metering.MeteringRequest.integrityStore: object expected");
        o.integrityStore = $root.integrity_store_api.IntegrityStoreRequest.fromObject(n.integrityStore);
      }
      if (n.getAzureCommunicationCredentials != null) {
        if (typeof n.getAzureCommunicationCredentials != "object")
          throw TypeError(".metering.MeteringRequest.getAzureCommunicationCredentials: object expected");
        o.getAzureCommunicationCredentials = $root.metering.GetAzureCommunicationCredentialsRequest.fromObject(n.getAzureCommunicationCredentials);
      }
      if (n.getOrCreateDcrDataScope != null) {
        if (typeof n.getOrCreateDcrDataScope != "object")
          throw TypeError(".metering.MeteringRequest.getOrCreateDcrDataScope: object expected");
        o.getOrCreateDcrDataScope = $root.metering.GetOrCreateDcrDataScopeRequest.fromObject(n.getOrCreateDcrDataScope);
      }
      if (n.recordDcrInteraction != null) {
        if (typeof n.recordDcrInteraction != "object")
          throw TypeError(".metering.MeteringRequest.recordDcrInteraction: object expected");
        o.recordDcrInteraction = $root.metering.RecordDcrInteractionRequest.fromObject(n.recordDcrInteraction);
      }
      return o;
    }, r.toObject = function(n, o) {
      o || (o = {});
      let c = {};
      return n.createDcr != null && n.hasOwnProperty("createDcr") && (c.createDcr = $root.metering.CreateDcrRequest.toObject(n.createDcr, o), o.oneofs && (c.request = "createDcr")), n.createDcrCommit != null && n.hasOwnProperty("createDcrCommit") && (c.createDcrCommit = $root.metering.CreateDcrCommitRequest.toObject(n.createDcrCommit, o), o.oneofs && (c.request = "createDcrCommit")), n.stopDcr != null && n.hasOwnProperty("stopDcr") && (c.stopDcr = $root.metering.StopDcrRequest.toObject(n.stopDcr, o), o.oneofs && (c.request = "stopDcr")), n.publishDataset != null && n.hasOwnProperty("publishDataset") && (c.publishDataset = $root.metering.PublishDatasetRequest.toObject(n.publishDataset, o), o.oneofs && (c.request = "publishDataset")), n.unpublishDataset != null && n.hasOwnProperty("unpublishDataset") && (c.unpublishDataset = $root.metering.UnpublishDatasetRequest.toObject(n.unpublishDataset, o), o.oneofs && (c.request = "unpublishDataset")), n.workerMetadata != null && n.hasOwnProperty("workerMetadata") && (c.workerMetadata = $root.metering.WorkerMetadataRequest.toObject(n.workerMetadata, o), o.oneofs && (c.request = "workerMetadata")), n.submitWorkerExecutionTime != null && n.hasOwnProperty("submitWorkerExecutionTime") && (c.submitWorkerExecutionTime = $root.metering.SubmitWorkerExecutionTimeRequest.toObject(n.submitWorkerExecutionTime, o), o.oneofs && (c.request = "submitWorkerExecutionTime")), n.dcrInteraction != null && n.hasOwnProperty("dcrInteraction") && (c.dcrInteraction = $root.metering.DcrInteractionRequest.toObject(n.dcrInteraction, o), o.oneofs && (c.request = "dcrInteraction")), n.createDataset != null && n.hasOwnProperty("createDataset") && (c.createDataset = $root.metering.CreateDatasetRequest.toObject(n.createDataset, o), o.oneofs && (c.request = "createDataset")), n.getOrCreateDatasetScope != null && n.hasOwnProperty("getOrCreateDatasetScope") && (c.getOrCreateDatasetScope = $root.metering.GetOrCreateDatasetScopeRequest.toObject(n.getOrCreateDatasetScope, o), o.oneofs && (c.request = "getOrCreateDatasetScope")), n.mergeDcrCommit != null && n.hasOwnProperty("mergeDcrCommit") && (c.mergeDcrCommit = $root.metering.MergeDcrCommitRequest.toObject(n.mergeDcrCommit, o), o.oneofs && (c.request = "mergeDcrCommit")), n.getDataConnectorCredentials != null && n.hasOwnProperty("getDataConnectorCredentials") && (c.getDataConnectorCredentials = $root.metering.GetDataConnectorCredentialsRequest.toObject(n.getDataConnectorCredentials, o), o.oneofs && (c.request = "getDataConnectorCredentials")), n.integrityStore != null && n.hasOwnProperty("integrityStore") && (c.integrityStore = $root.integrity_store_api.IntegrityStoreRequest.toObject(n.integrityStore, o), o.oneofs && (c.request = "integrityStore")), n.getAzureCommunicationCredentials != null && n.hasOwnProperty("getAzureCommunicationCredentials") && (c.getAzureCommunicationCredentials = $root.metering.GetAzureCommunicationCredentialsRequest.toObject(n.getAzureCommunicationCredentials, o), o.oneofs && (c.request = "getAzureCommunicationCredentials")), n.getOrCreateDcrDataScope != null && n.hasOwnProperty("getOrCreateDcrDataScope") && (c.getOrCreateDcrDataScope = $root.metering.GetOrCreateDcrDataScopeRequest.toObject(n.getOrCreateDcrDataScope, o), o.oneofs && (c.request = "getOrCreateDcrDataScope")), n.recordDcrInteraction != null && n.hasOwnProperty("recordDcrInteraction") && (c.recordDcrInteraction = $root.metering.RecordDcrInteractionRequest.toObject(n.recordDcrInteraction, o), o.oneofs && (c.request = "recordDcrInteraction")), c;
    }, r.prototype.toJSON = function() {
      return this.constructor.toObject(this, minimal.util.toJSONOptions);
    }, r.getTypeUrl = function(n) {
      return n === void 0 && (n = "type.googleapis.com"), n + "/metering.MeteringRequest";
    }, r;
  }(), u.MeteringSuccessResponse = function() {
    function r(e) {
      if (e)
        for (let n = Object.keys(e), o = 0; o < n.length; ++o)
          e[n[o]] != null && (this[n[o]] = e[n[o]]);
    }
    r.prototype.createDcr = null, r.prototype.createDcrCommit = null, r.prototype.stopDcr = null, r.prototype.publishDataset = null, r.prototype.unpublishDataset = null, r.prototype.workerMetadata = null, r.prototype.submitWorkerExecutionTime = null, r.prototype.dcrInteraction = null, r.prototype.createDataset = null, r.prototype.getOrCreateDatasetScope = null, r.prototype.mergeDcrCommit = null, r.prototype.dataConnectorCredentials = null, r.prototype.integrityStore = null, r.prototype.getAzureCommunicationCredentials = null, r.prototype.getOrCreateDcrDataScope = null, r.prototype.recordDcrInteraction = null;
    let a;
    return Object.defineProperty(r.prototype, "response", {
      get: $util.oneOfGetter(a = ["createDcr", "createDcrCommit", "stopDcr", "publishDataset", "unpublishDataset", "workerMetadata", "submitWorkerExecutionTime", "dcrInteraction", "createDataset", "getOrCreateDatasetScope", "mergeDcrCommit", "dataConnectorCredentials", "integrityStore", "getAzureCommunicationCredentials", "getOrCreateDcrDataScope", "recordDcrInteraction"]),
      set: $util.oneOfSetter(a)
    }), r.create = function(n) {
      return new r(n);
    }, r.encode = function(n, o) {
      return o || (o = $Writer.create()), n.createDcr != null && Object.hasOwnProperty.call(n, "createDcr") && $root.metering.CreateDcrResponse.encode(n.createDcr, o.uint32(
        /* id 1, wireType 2 =*/
        10
      ).fork()).ldelim(), n.createDcrCommit != null && Object.hasOwnProperty.call(n, "createDcrCommit") && $root.metering.CreateDcrCommitResponse.encode(n.createDcrCommit, o.uint32(
        /* id 2, wireType 2 =*/
        18
      ).fork()).ldelim(), n.stopDcr != null && Object.hasOwnProperty.call(n, "stopDcr") && $root.metering.StopDcrResponse.encode(n.stopDcr, o.uint32(
        /* id 3, wireType 2 =*/
        26
      ).fork()).ldelim(), n.publishDataset != null && Object.hasOwnProperty.call(n, "publishDataset") && $root.metering.PublishDatasetResponse.encode(n.publishDataset, o.uint32(
        /* id 4, wireType 2 =*/
        34
      ).fork()).ldelim(), n.unpublishDataset != null && Object.hasOwnProperty.call(n, "unpublishDataset") && $root.metering.UnpublishDatasetResponse.encode(n.unpublishDataset, o.uint32(
        /* id 5, wireType 2 =*/
        42
      ).fork()).ldelim(), n.workerMetadata != null && Object.hasOwnProperty.call(n, "workerMetadata") && $root.metering.WorkerMetadataResponse.encode(n.workerMetadata, o.uint32(
        /* id 6, wireType 2 =*/
        50
      ).fork()).ldelim(), n.submitWorkerExecutionTime != null && Object.hasOwnProperty.call(n, "submitWorkerExecutionTime") && $root.metering.SubmitWorkerExecutionTimeResponse.encode(n.submitWorkerExecutionTime, o.uint32(
        /* id 7, wireType 2 =*/
        58
      ).fork()).ldelim(), n.dcrInteraction != null && Object.hasOwnProperty.call(n, "dcrInteraction") && $root.metering.DcrInteractionResponse.encode(n.dcrInteraction, o.uint32(
        /* id 8, wireType 2 =*/
        66
      ).fork()).ldelim(), n.createDataset != null && Object.hasOwnProperty.call(n, "createDataset") && $root.metering.CreateDatasetResponse.encode(n.createDataset, o.uint32(
        /* id 9, wireType 2 =*/
        74
      ).fork()).ldelim(), n.getOrCreateDatasetScope != null && Object.hasOwnProperty.call(n, "getOrCreateDatasetScope") && $root.metering.GetOrCreateDatasetScopeResponse.encode(n.getOrCreateDatasetScope, o.uint32(
        /* id 10, wireType 2 =*/
        82
      ).fork()).ldelim(), n.mergeDcrCommit != null && Object.hasOwnProperty.call(n, "mergeDcrCommit") && $root.metering.MergeDcrCommitResponse.encode(n.mergeDcrCommit, o.uint32(
        /* id 11, wireType 2 =*/
        90
      ).fork()).ldelim(), n.dataConnectorCredentials != null && Object.hasOwnProperty.call(n, "dataConnectorCredentials") && $root.metering.GetDataConnectorCredentialsResponse.encode(n.dataConnectorCredentials, o.uint32(
        /* id 12, wireType 2 =*/
        98
      ).fork()).ldelim(), n.integrityStore != null && Object.hasOwnProperty.call(n, "integrityStore") && $root.integrity_store_api.IntegrityStoreResponse.encode(n.integrityStore, o.uint32(
        /* id 13, wireType 2 =*/
        106
      ).fork()).ldelim(), n.getAzureCommunicationCredentials != null && Object.hasOwnProperty.call(n, "getAzureCommunicationCredentials") && $root.metering.GetAzureCommunicationCredentialsResponse.encode(n.getAzureCommunicationCredentials, o.uint32(
        /* id 14, wireType 2 =*/
        114
      ).fork()).ldelim(), n.getOrCreateDcrDataScope != null && Object.hasOwnProperty.call(n, "getOrCreateDcrDataScope") && $root.metering.GetOrCreateDcrDataScopeResponse.encode(n.getOrCreateDcrDataScope, o.uint32(
        /* id 15, wireType 2 =*/
        122
      ).fork()).ldelim(), n.recordDcrInteraction != null && Object.hasOwnProperty.call(n, "recordDcrInteraction") && $root.metering.RecordDcrInteractionResponse.encode(n.recordDcrInteraction, o.uint32(
        /* id 16, wireType 2 =*/
        130
      ).fork()).ldelim(), o;
    }, r.encodeDelimited = function(n, o) {
      return this.encode(n, o).ldelim();
    }, r.decode = function(n, o) {
      n instanceof $Reader || (n = $Reader.create(n));
      let c = o === void 0 ? n.len : n.pos + o, l = new $root.metering.MeteringSuccessResponse();
      for (; n.pos < c; ) {
        let d = n.uint32();
        switch (d >>> 3) {
          case 1: {
            l.createDcr = $root.metering.CreateDcrResponse.decode(n, n.uint32());
            break;
          }
          case 2: {
            l.createDcrCommit = $root.metering.CreateDcrCommitResponse.decode(n, n.uint32());
            break;
          }
          case 3: {
            l.stopDcr = $root.metering.StopDcrResponse.decode(n, n.uint32());
            break;
          }
          case 4: {
            l.publishDataset = $root.metering.PublishDatasetResponse.decode(n, n.uint32());
            break;
          }
          case 5: {
            l.unpublishDataset = $root.metering.UnpublishDatasetResponse.decode(n, n.uint32());
            break;
          }
          case 6: {
            l.workerMetadata = $root.metering.WorkerMetadataResponse.decode(n, n.uint32());
            break;
          }
          case 7: {
            l.submitWorkerExecutionTime = $root.metering.SubmitWorkerExecutionTimeResponse.decode(n, n.uint32());
            break;
          }
          case 8: {
            l.dcrInteraction = $root.metering.DcrInteractionResponse.decode(n, n.uint32());
            break;
          }
          case 9: {
            l.createDataset = $root.metering.CreateDatasetResponse.decode(n, n.uint32());
            break;
          }
          case 10: {
            l.getOrCreateDatasetScope = $root.metering.GetOrCreateDatasetScopeResponse.decode(n, n.uint32());
            break;
          }
          case 11: {
            l.mergeDcrCommit = $root.metering.MergeDcrCommitResponse.decode(n, n.uint32());
            break;
          }
          case 12: {
            l.dataConnectorCredentials = $root.metering.GetDataConnectorCredentialsResponse.decode(n, n.uint32());
            break;
          }
          case 13: {
            l.integrityStore = $root.integrity_store_api.IntegrityStoreResponse.decode(n, n.uint32());
            break;
          }
          case 14: {
            l.getAzureCommunicationCredentials = $root.metering.GetAzureCommunicationCredentialsResponse.decode(n, n.uint32());
            break;
          }
          case 15: {
            l.getOrCreateDcrDataScope = $root.metering.GetOrCreateDcrDataScopeResponse.decode(n, n.uint32());
            break;
          }
          case 16: {
            l.recordDcrInteraction = $root.metering.RecordDcrInteractionResponse.decode(n, n.uint32());
            break;
          }
          default:
            n.skipType(d & 7);
            break;
        }
      }
      return l;
    }, r.decodeDelimited = function(n) {
      return n instanceof $Reader || (n = new $Reader(n)), this.decode(n, n.uint32());
    }, r.verify = function(n) {
      if (typeof n != "object" || n === null)
        return "object expected";
      let o = {};
      if (n.createDcr != null && n.hasOwnProperty("createDcr")) {
        o.response = 1;
        {
          let c = $root.metering.CreateDcrResponse.verify(n.createDcr);
          if (c)
            return "createDcr." + c;
        }
      }
      if (n.createDcrCommit != null && n.hasOwnProperty("createDcrCommit")) {
        if (o.response === 1)
          return "response: multiple values";
        o.response = 1;
        {
          let c = $root.metering.CreateDcrCommitResponse.verify(n.createDcrCommit);
          if (c)
            return "createDcrCommit." + c;
        }
      }
      if (n.stopDcr != null && n.hasOwnProperty("stopDcr")) {
        if (o.response === 1)
          return "response: multiple values";
        o.response = 1;
        {
          let c = $root.metering.StopDcrResponse.verify(n.stopDcr);
          if (c)
            return "stopDcr." + c;
        }
      }
      if (n.publishDataset != null && n.hasOwnProperty("publishDataset")) {
        if (o.response === 1)
          return "response: multiple values";
        o.response = 1;
        {
          let c = $root.metering.PublishDatasetResponse.verify(n.publishDataset);
          if (c)
            return "publishDataset." + c;
        }
      }
      if (n.unpublishDataset != null && n.hasOwnProperty("unpublishDataset")) {
        if (o.response === 1)
          return "response: multiple values";
        o.response = 1;
        {
          let c = $root.metering.UnpublishDatasetResponse.verify(n.unpublishDataset);
          if (c)
            return "unpublishDataset." + c;
        }
      }
      if (n.workerMetadata != null && n.hasOwnProperty("workerMetadata")) {
        if (o.response === 1)
          return "response: multiple values";
        o.response = 1;
        {
          let c = $root.metering.WorkerMetadataResponse.verify(n.workerMetadata);
          if (c)
            return "workerMetadata." + c;
        }
      }
      if (n.submitWorkerExecutionTime != null && n.hasOwnProperty("submitWorkerExecutionTime")) {
        if (o.response === 1)
          return "response: multiple values";
        o.response = 1;
        {
          let c = $root.metering.SubmitWorkerExecutionTimeResponse.verify(n.submitWorkerExecutionTime);
          if (c)
            return "submitWorkerExecutionTime." + c;
        }
      }
      if (n.dcrInteraction != null && n.hasOwnProperty("dcrInteraction")) {
        if (o.response === 1)
          return "response: multiple values";
        o.response = 1;
        {
          let c = $root.metering.DcrInteractionResponse.verify(n.dcrInteraction);
          if (c)
            return "dcrInteraction." + c;
        }
      }
      if (n.createDataset != null && n.hasOwnProperty("createDataset")) {
        if (o.response === 1)
          return "response: multiple values";
        o.response = 1;
        {
          let c = $root.metering.CreateDatasetResponse.verify(n.createDataset);
          if (c)
            return "createDataset." + c;
        }
      }
      if (n.getOrCreateDatasetScope != null && n.hasOwnProperty("getOrCreateDatasetScope")) {
        if (o.response === 1)
          return "response: multiple values";
        o.response = 1;
        {
          let c = $root.metering.GetOrCreateDatasetScopeResponse.verify(n.getOrCreateDatasetScope);
          if (c)
            return "getOrCreateDatasetScope." + c;
        }
      }
      if (n.mergeDcrCommit != null && n.hasOwnProperty("mergeDcrCommit")) {
        if (o.response === 1)
          return "response: multiple values";
        o.response = 1;
        {
          let c = $root.metering.MergeDcrCommitResponse.verify(n.mergeDcrCommit);
          if (c)
            return "mergeDcrCommit." + c;
        }
      }
      if (n.dataConnectorCredentials != null && n.hasOwnProperty("dataConnectorCredentials")) {
        if (o.response === 1)
          return "response: multiple values";
        o.response = 1;
        {
          let c = $root.metering.GetDataConnectorCredentialsResponse.verify(n.dataConnectorCredentials);
          if (c)
            return "dataConnectorCredentials." + c;
        }
      }
      if (n.integrityStore != null && n.hasOwnProperty("integrityStore")) {
        if (o.response === 1)
          return "response: multiple values";
        o.response = 1;
        {
          let c = $root.integrity_store_api.IntegrityStoreResponse.verify(n.integrityStore);
          if (c)
            return "integrityStore." + c;
        }
      }
      if (n.getAzureCommunicationCredentials != null && n.hasOwnProperty("getAzureCommunicationCredentials")) {
        if (o.response === 1)
          return "response: multiple values";
        o.response = 1;
        {
          let c = $root.metering.GetAzureCommunicationCredentialsResponse.verify(n.getAzureCommunicationCredentials);
          if (c)
            return "getAzureCommunicationCredentials." + c;
        }
      }
      if (n.getOrCreateDcrDataScope != null && n.hasOwnProperty("getOrCreateDcrDataScope")) {
        if (o.response === 1)
          return "response: multiple values";
        o.response = 1;
        {
          let c = $root.metering.GetOrCreateDcrDataScopeResponse.verify(n.getOrCreateDcrDataScope);
          if (c)
            return "getOrCreateDcrDataScope." + c;
        }
      }
      if (n.recordDcrInteraction != null && n.hasOwnProperty("recordDcrInteraction")) {
        if (o.response === 1)
          return "response: multiple values";
        o.response = 1;
        {
          let c = $root.metering.RecordDcrInteractionResponse.verify(n.recordDcrInteraction);
          if (c)
            return "recordDcrInteraction." + c;
        }
      }
      return null;
    }, r.fromObject = function(n) {
      if (n instanceof $root.metering.MeteringSuccessResponse)
        return n;
      let o = new $root.metering.MeteringSuccessResponse();
      if (n.createDcr != null) {
        if (typeof n.createDcr != "object")
          throw TypeError(".metering.MeteringSuccessResponse.createDcr: object expected");
        o.createDcr = $root.metering.CreateDcrResponse.fromObject(n.createDcr);
      }
      if (n.createDcrCommit != null) {
        if (typeof n.createDcrCommit != "object")
          throw TypeError(".metering.MeteringSuccessResponse.createDcrCommit: object expected");
        o.createDcrCommit = $root.metering.CreateDcrCommitResponse.fromObject(n.createDcrCommit);
      }
      if (n.stopDcr != null) {
        if (typeof n.stopDcr != "object")
          throw TypeError(".metering.MeteringSuccessResponse.stopDcr: object expected");
        o.stopDcr = $root.metering.StopDcrResponse.fromObject(n.stopDcr);
      }
      if (n.publishDataset != null) {
        if (typeof n.publishDataset != "object")
          throw TypeError(".metering.MeteringSuccessResponse.publishDataset: object expected");
        o.publishDataset = $root.metering.PublishDatasetResponse.fromObject(n.publishDataset);
      }
      if (n.unpublishDataset != null) {
        if (typeof n.unpublishDataset != "object")
          throw TypeError(".metering.MeteringSuccessResponse.unpublishDataset: object expected");
        o.unpublishDataset = $root.metering.UnpublishDatasetResponse.fromObject(n.unpublishDataset);
      }
      if (n.workerMetadata != null) {
        if (typeof n.workerMetadata != "object")
          throw TypeError(".metering.MeteringSuccessResponse.workerMetadata: object expected");
        o.workerMetadata = $root.metering.WorkerMetadataResponse.fromObject(n.workerMetadata);
      }
      if (n.submitWorkerExecutionTime != null) {
        if (typeof n.submitWorkerExecutionTime != "object")
          throw TypeError(".metering.MeteringSuccessResponse.submitWorkerExecutionTime: object expected");
        o.submitWorkerExecutionTime = $root.metering.SubmitWorkerExecutionTimeResponse.fromObject(n.submitWorkerExecutionTime);
      }
      if (n.dcrInteraction != null) {
        if (typeof n.dcrInteraction != "object")
          throw TypeError(".metering.MeteringSuccessResponse.dcrInteraction: object expected");
        o.dcrInteraction = $root.metering.DcrInteractionResponse.fromObject(n.dcrInteraction);
      }
      if (n.createDataset != null) {
        if (typeof n.createDataset != "object")
          throw TypeError(".metering.MeteringSuccessResponse.createDataset: object expected");
        o.createDataset = $root.metering.CreateDatasetResponse.fromObject(n.createDataset);
      }
      if (n.getOrCreateDatasetScope != null) {
        if (typeof n.getOrCreateDatasetScope != "object")
          throw TypeError(".metering.MeteringSuccessResponse.getOrCreateDatasetScope: object expected");
        o.getOrCreateDatasetScope = $root.metering.GetOrCreateDatasetScopeResponse.fromObject(n.getOrCreateDatasetScope);
      }
      if (n.mergeDcrCommit != null) {
        if (typeof n.mergeDcrCommit != "object")
          throw TypeError(".metering.MeteringSuccessResponse.mergeDcrCommit: object expected");
        o.mergeDcrCommit = $root.metering.MergeDcrCommitResponse.fromObject(n.mergeDcrCommit);
      }
      if (n.dataConnectorCredentials != null) {
        if (typeof n.dataConnectorCredentials != "object")
          throw TypeError(".metering.MeteringSuccessResponse.dataConnectorCredentials: object expected");
        o.dataConnectorCredentials = $root.metering.GetDataConnectorCredentialsResponse.fromObject(n.dataConnectorCredentials);
      }
      if (n.integrityStore != null) {
        if (typeof n.integrityStore != "object")
          throw TypeError(".metering.MeteringSuccessResponse.integrityStore: object expected");
        o.integrityStore = $root.integrity_store_api.IntegrityStoreResponse.fromObject(n.integrityStore);
      }
      if (n.getAzureCommunicationCredentials != null) {
        if (typeof n.getAzureCommunicationCredentials != "object")
          throw TypeError(".metering.MeteringSuccessResponse.getAzureCommunicationCredentials: object expected");
        o.getAzureCommunicationCredentials = $root.metering.GetAzureCommunicationCredentialsResponse.fromObject(n.getAzureCommunicationCredentials);
      }
      if (n.getOrCreateDcrDataScope != null) {
        if (typeof n.getOrCreateDcrDataScope != "object")
          throw TypeError(".metering.MeteringSuccessResponse.getOrCreateDcrDataScope: object expected");
        o.getOrCreateDcrDataScope = $root.metering.GetOrCreateDcrDataScopeResponse.fromObject(n.getOrCreateDcrDataScope);
      }
      if (n.recordDcrInteraction != null) {
        if (typeof n.recordDcrInteraction != "object")
          throw TypeError(".metering.MeteringSuccessResponse.recordDcrInteraction: object expected");
        o.recordDcrInteraction = $root.metering.RecordDcrInteractionResponse.fromObject(n.recordDcrInteraction);
      }
      return o;
    }, r.toObject = function(n, o) {
      o || (o = {});
      let c = {};
      return n.createDcr != null && n.hasOwnProperty("createDcr") && (c.createDcr = $root.metering.CreateDcrResponse.toObject(n.createDcr, o), o.oneofs && (c.response = "createDcr")), n.createDcrCommit != null && n.hasOwnProperty("createDcrCommit") && (c.createDcrCommit = $root.metering.CreateDcrCommitResponse.toObject(n.createDcrCommit, o), o.oneofs && (c.response = "createDcrCommit")), n.stopDcr != null && n.hasOwnProperty("stopDcr") && (c.stopDcr = $root.metering.StopDcrResponse.toObject(n.stopDcr, o), o.oneofs && (c.response = "stopDcr")), n.publishDataset != null && n.hasOwnProperty("publishDataset") && (c.publishDataset = $root.metering.PublishDatasetResponse.toObject(n.publishDataset, o), o.oneofs && (c.response = "publishDataset")), n.unpublishDataset != null && n.hasOwnProperty("unpublishDataset") && (c.unpublishDataset = $root.metering.UnpublishDatasetResponse.toObject(n.unpublishDataset, o), o.oneofs && (c.response = "unpublishDataset")), n.workerMetadata != null && n.hasOwnProperty("workerMetadata") && (c.workerMetadata = $root.metering.WorkerMetadataResponse.toObject(n.workerMetadata, o), o.oneofs && (c.response = "workerMetadata")), n.submitWorkerExecutionTime != null && n.hasOwnProperty("submitWorkerExecutionTime") && (c.submitWorkerExecutionTime = $root.metering.SubmitWorkerExecutionTimeResponse.toObject(n.submitWorkerExecutionTime, o), o.oneofs && (c.response = "submitWorkerExecutionTime")), n.dcrInteraction != null && n.hasOwnProperty("dcrInteraction") && (c.dcrInteraction = $root.metering.DcrInteractionResponse.toObject(n.dcrInteraction, o), o.oneofs && (c.response = "dcrInteraction")), n.createDataset != null && n.hasOwnProperty("createDataset") && (c.createDataset = $root.metering.CreateDatasetResponse.toObject(n.createDataset, o), o.oneofs && (c.response = "createDataset")), n.getOrCreateDatasetScope != null && n.hasOwnProperty("getOrCreateDatasetScope") && (c.getOrCreateDatasetScope = $root.metering.GetOrCreateDatasetScopeResponse.toObject(n.getOrCreateDatasetScope, o), o.oneofs && (c.response = "getOrCreateDatasetScope")), n.mergeDcrCommit != null && n.hasOwnProperty("mergeDcrCommit") && (c.mergeDcrCommit = $root.metering.MergeDcrCommitResponse.toObject(n.mergeDcrCommit, o), o.oneofs && (c.response = "mergeDcrCommit")), n.dataConnectorCredentials != null && n.hasOwnProperty("dataConnectorCredentials") && (c.dataConnectorCredentials = $root.metering.GetDataConnectorCredentialsResponse.toObject(n.dataConnectorCredentials, o), o.oneofs && (c.response = "dataConnectorCredentials")), n.integrityStore != null && n.hasOwnProperty("integrityStore") && (c.integrityStore = $root.integrity_store_api.IntegrityStoreResponse.toObject(n.integrityStore, o), o.oneofs && (c.response = "integrityStore")), n.getAzureCommunicationCredentials != null && n.hasOwnProperty("getAzureCommunicationCredentials") && (c.getAzureCommunicationCredentials = $root.metering.GetAzureCommunicationCredentialsResponse.toObject(n.getAzureCommunicationCredentials, o), o.oneofs && (c.response = "getAzureCommunicationCredentials")), n.getOrCreateDcrDataScope != null && n.hasOwnProperty("getOrCreateDcrDataScope") && (c.getOrCreateDcrDataScope = $root.metering.GetOrCreateDcrDataScopeResponse.toObject(n.getOrCreateDcrDataScope, o), o.oneofs && (c.response = "getOrCreateDcrDataScope")), n.recordDcrInteraction != null && n.hasOwnProperty("recordDcrInteraction") && (c.recordDcrInteraction = $root.metering.RecordDcrInteractionResponse.toObject(n.recordDcrInteraction, o), o.oneofs && (c.response = "recordDcrInteraction")), c;
    }, r.prototype.toJSON = function() {
      return this.constructor.toObject(this, minimal.util.toJSONOptions);
    }, r.getTypeUrl = function(n) {
      return n === void 0 && (n = "type.googleapis.com"), n + "/metering.MeteringSuccessResponse";
    }, r;
  }(), u.MeteringResponse = function() {
    function r(e) {
      if (e)
        for (let n = Object.keys(e), o = 0; o < n.length; ++o)
          e[n[o]] != null && (this[n[o]] = e[n[o]]);
    }
    r.prototype.success = null, r.prototype.failure = null;
    let a;
    return Object.defineProperty(r.prototype, "response", {
      get: $util.oneOfGetter(a = ["success", "failure"]),
      set: $util.oneOfSetter(a)
    }), r.create = function(n) {
      return new r(n);
    }, r.encode = function(n, o) {
      return o || (o = $Writer.create()), n.success != null && Object.hasOwnProperty.call(n, "success") && $root.metering.MeteringSuccessResponse.encode(n.success, o.uint32(
        /* id 1, wireType 2 =*/
        10
      ).fork()).ldelim(), n.failure != null && Object.hasOwnProperty.call(n, "failure") && o.uint32(
        /* id 2, wireType 2 =*/
        18
      ).string(n.failure), o;
    }, r.encodeDelimited = function(n, o) {
      return this.encode(n, o).ldelim();
    }, r.decode = function(n, o) {
      n instanceof $Reader || (n = $Reader.create(n));
      let c = o === void 0 ? n.len : n.pos + o, l = new $root.metering.MeteringResponse();
      for (; n.pos < c; ) {
        let d = n.uint32();
        switch (d >>> 3) {
          case 1: {
            l.success = $root.metering.MeteringSuccessResponse.decode(n, n.uint32());
            break;
          }
          case 2: {
            l.failure = n.string();
            break;
          }
          default:
            n.skipType(d & 7);
            break;
        }
      }
      return l;
    }, r.decodeDelimited = function(n) {
      return n instanceof $Reader || (n = new $Reader(n)), this.decode(n, n.uint32());
    }, r.verify = function(n) {
      if (typeof n != "object" || n === null)
        return "object expected";
      let o = {};
      if (n.success != null && n.hasOwnProperty("success")) {
        o.response = 1;
        {
          let c = $root.metering.MeteringSuccessResponse.verify(n.success);
          if (c)
            return "success." + c;
        }
      }
      if (n.failure != null && n.hasOwnProperty("failure")) {
        if (o.response === 1)
          return "response: multiple values";
        if (o.response = 1, !$util.isString(n.failure))
          return "failure: string expected";
      }
      return null;
    }, r.fromObject = function(n) {
      if (n instanceof $root.metering.MeteringResponse)
        return n;
      let o = new $root.metering.MeteringResponse();
      if (n.success != null) {
        if (typeof n.success != "object")
          throw TypeError(".metering.MeteringResponse.success: object expected");
        o.success = $root.metering.MeteringSuccessResponse.fromObject(n.success);
      }
      return n.failure != null && (o.failure = String(n.failure)), o;
    }, r.toObject = function(n, o) {
      o || (o = {});
      let c = {};
      return n.success != null && n.hasOwnProperty("success") && (c.success = $root.metering.MeteringSuccessResponse.toObject(n.success, o), o.oneofs && (c.response = "success")), n.failure != null && n.hasOwnProperty("failure") && (c.failure = n.failure, o.oneofs && (c.response = "failure")), c;
    }, r.prototype.toJSON = function() {
      return this.constructor.toObject(this, minimal.util.toJSONOptions);
    }, r.getTypeUrl = function(n) {
      return n === void 0 && (n = "type.googleapis.com"), n + "/metering.MeteringResponse";
    }, r;
  }(), u.CreateDcrPurpose = function() {
    const r = {}, a = Object.create(r);
    return a[r[0] = "STANDARD"] = 0, a[r[1] = "VALIDATION"] = 1, a[r[2] = "DATA_IMPORT"] = 2, a[r[3] = "DATA_EXPORT"] = 3, a[r[4] = "DATA_LAB"] = 4, a;
  }(), u.CreateDcrKind = function() {
    const r = {}, a = Object.create(r);
    return a[r[0] = "EXPERT"] = 0, a[r[1] = "DATASCIENCE"] = 1, a[r[2] = "MEDIA"] = 2, a[r[3] = "LOOKALIKE_MEDIA"] = 3, a[r[4] = "MEDIA_INSIGHTS"] = 4, a[r[5] = "AB_MEDIA"] = 5, a[r[6] = "MEDIA_V3"] = 6, a;
  }(), u.DcrMetadata = function() {
    function r(a) {
      if (a)
        for (let e = Object.keys(a), n = 0; n < e.length; ++n)
          a[e[n]] != null && (this[e[n]] = a[e[n]]);
    }
    return r.prototype.purpose = 0, r.prototype.showOrganizationLogo = !1, r.prototype.requirePassword = !1, r.prototype.kind = 0, r.create = function(e) {
      return new r(e);
    }, r.encode = function(e, n) {
      return n || (n = $Writer.create()), e.purpose != null && Object.hasOwnProperty.call(e, "purpose") && n.uint32(
        /* id 1, wireType 0 =*/
        8
      ).int32(e.purpose), e.showOrganizationLogo != null && Object.hasOwnProperty.call(e, "showOrganizationLogo") && n.uint32(
        /* id 2, wireType 0 =*/
        16
      ).bool(e.showOrganizationLogo), e.requirePassword != null && Object.hasOwnProperty.call(e, "requirePassword") && n.uint32(
        /* id 3, wireType 0 =*/
        24
      ).bool(e.requirePassword), e.kind != null && Object.hasOwnProperty.call(e, "kind") && n.uint32(
        /* id 4, wireType 0 =*/
        32
      ).int32(e.kind), n;
    }, r.encodeDelimited = function(e, n) {
      return this.encode(e, n).ldelim();
    }, r.decode = function(e, n) {
      e instanceof $Reader || (e = $Reader.create(e));
      let o = n === void 0 ? e.len : e.pos + n, c = new $root.metering.DcrMetadata();
      for (; e.pos < o; ) {
        let l = e.uint32();
        switch (l >>> 3) {
          case 1: {
            c.purpose = e.int32();
            break;
          }
          case 2: {
            c.showOrganizationLogo = e.bool();
            break;
          }
          case 3: {
            c.requirePassword = e.bool();
            break;
          }
          case 4: {
            c.kind = e.int32();
            break;
          }
          default:
            e.skipType(l & 7);
            break;
        }
      }
      return c;
    }, r.decodeDelimited = function(e) {
      return e instanceof $Reader || (e = new $Reader(e)), this.decode(e, e.uint32());
    }, r.verify = function(e) {
      if (typeof e != "object" || e === null)
        return "object expected";
      if (e.purpose != null && e.hasOwnProperty("purpose"))
        switch (e.purpose) {
          default:
            return "purpose: enum value expected";
          case 0:
          case 1:
          case 2:
          case 3:
          case 4:
            break;
        }
      if (e.showOrganizationLogo != null && e.hasOwnProperty("showOrganizationLogo") && typeof e.showOrganizationLogo != "boolean")
        return "showOrganizationLogo: boolean expected";
      if (e.requirePassword != null && e.hasOwnProperty("requirePassword") && typeof e.requirePassword != "boolean")
        return "requirePassword: boolean expected";
      if (e.kind != null && e.hasOwnProperty("kind"))
        switch (e.kind) {
          default:
            return "kind: enum value expected";
          case 0:
          case 1:
          case 2:
          case 3:
          case 4:
          case 5:
          case 6:
            break;
        }
      return null;
    }, r.fromObject = function(e) {
      if (e instanceof $root.metering.DcrMetadata)
        return e;
      let n = new $root.metering.DcrMetadata();
      switch (e.purpose) {
        default:
          if (typeof e.purpose == "number") {
            n.purpose = e.purpose;
            break;
          }
          break;
        case "STANDARD":
        case 0:
          n.purpose = 0;
          break;
        case "VALIDATION":
        case 1:
          n.purpose = 1;
          break;
        case "DATA_IMPORT":
        case 2:
          n.purpose = 2;
          break;
        case "DATA_EXPORT":
        case 3:
          n.purpose = 3;
          break;
        case "DATA_LAB":
        case 4:
          n.purpose = 4;
          break;
      }
      switch (e.showOrganizationLogo != null && (n.showOrganizationLogo = !!e.showOrganizationLogo), e.requirePassword != null && (n.requirePassword = !!e.requirePassword), e.kind) {
        default:
          if (typeof e.kind == "number") {
            n.kind = e.kind;
            break;
          }
          break;
        case "EXPERT":
        case 0:
          n.kind = 0;
          break;
        case "DATASCIENCE":
        case 1:
          n.kind = 1;
          break;
        case "MEDIA":
        case 2:
          n.kind = 2;
          break;
        case "LOOKALIKE_MEDIA":
        case 3:
          n.kind = 3;
          break;
        case "MEDIA_INSIGHTS":
        case 4:
          n.kind = 4;
          break;
        case "AB_MEDIA":
        case 5:
          n.kind = 5;
          break;
        case "MEDIA_V3":
        case 6:
          n.kind = 6;
          break;
      }
      return n;
    }, r.toObject = function(e, n) {
      n || (n = {});
      let o = {};
      return n.defaults && (o.purpose = n.enums === String ? "STANDARD" : 0, o.showOrganizationLogo = !1, o.requirePassword = !1, o.kind = n.enums === String ? "EXPERT" : 0), e.purpose != null && e.hasOwnProperty("purpose") && (o.purpose = n.enums === String ? $root.metering.CreateDcrPurpose[e.purpose] === void 0 ? e.purpose : $root.metering.CreateDcrPurpose[e.purpose] : e.purpose), e.showOrganizationLogo != null && e.hasOwnProperty("showOrganizationLogo") && (o.showOrganizationLogo = e.showOrganizationLogo), e.requirePassword != null && e.hasOwnProperty("requirePassword") && (o.requirePassword = e.requirePassword), e.kind != null && e.hasOwnProperty("kind") && (o.kind = n.enums === String ? $root.metering.CreateDcrKind[e.kind] === void 0 ? e.kind : $root.metering.CreateDcrKind[e.kind] : e.kind), o;
    }, r.prototype.toJSON = function() {
      return this.constructor.toObject(this, minimal.util.toJSONOptions);
    }, r.getTypeUrl = function(e) {
      return e === void 0 && (e = "type.googleapis.com"), e + "/metering.DcrMetadata";
    }, r;
  }(), u.CreateDcrRequest = function() {
    function r(e) {
      if (this.participantEmails = [], this.enclaveInfo = [], e)
        for (let n = Object.keys(e), o = 0; o < n.length; ++o)
          e[n[o]] != null && (this[n[o]] = e[n[o]]);
    }
    r.prototype.idHex = "", r.prototype.name = "", r.prototype.driverAttestationHash = "", r.prototype.participantEmails = $util.emptyArray, r.prototype.metadata = null, r.prototype.enclaveInfo = $util.emptyArray;
    let a;
    return Object.defineProperty(r.prototype, "_metadata", {
      get: $util.oneOfGetter(a = ["metadata"]),
      set: $util.oneOfSetter(a)
    }), r.create = function(n) {
      return new r(n);
    }, r.encode = function(n, o) {
      if (o || (o = $Writer.create()), n.idHex != null && Object.hasOwnProperty.call(n, "idHex") && o.uint32(
        /* id 1, wireType 2 =*/
        10
      ).string(n.idHex), n.name != null && Object.hasOwnProperty.call(n, "name") && o.uint32(
        /* id 2, wireType 2 =*/
        18
      ).string(n.name), n.driverAttestationHash != null && Object.hasOwnProperty.call(n, "driverAttestationHash") && o.uint32(
        /* id 3, wireType 2 =*/
        26
      ).string(n.driverAttestationHash), n.participantEmails != null && n.participantEmails.length)
        for (let c = 0; c < n.participantEmails.length; ++c)
          o.uint32(
            /* id 4, wireType 2 =*/
            34
          ).string(n.participantEmails[c]);
      if (n.metadata != null && Object.hasOwnProperty.call(n, "metadata") && o.uint32(
        /* id 5, wireType 2 =*/
        42
      ).bytes(n.metadata), n.enclaveInfo != null && n.enclaveInfo.length)
        for (let c = 0; c < n.enclaveInfo.length; ++c)
          $root.metering.EnclaveInfo.encode(n.enclaveInfo[c], o.uint32(
            /* id 6, wireType 2 =*/
            50
          ).fork()).ldelim();
      return o;
    }, r.encodeDelimited = function(n, o) {
      return this.encode(n, o).ldelim();
    }, r.decode = function(n, o) {
      n instanceof $Reader || (n = $Reader.create(n));
      let c = o === void 0 ? n.len : n.pos + o, l = new $root.metering.CreateDcrRequest();
      for (; n.pos < c; ) {
        let d = n.uint32();
        switch (d >>> 3) {
          case 1: {
            l.idHex = n.string();
            break;
          }
          case 2: {
            l.name = n.string();
            break;
          }
          case 3: {
            l.driverAttestationHash = n.string();
            break;
          }
          case 4: {
            l.participantEmails && l.participantEmails.length || (l.participantEmails = []), l.participantEmails.push(n.string());
            break;
          }
          case 5: {
            l.metadata = n.bytes();
            break;
          }
          case 6: {
            l.enclaveInfo && l.enclaveInfo.length || (l.enclaveInfo = []), l.enclaveInfo.push($root.metering.EnclaveInfo.decode(n, n.uint32()));
            break;
          }
          default:
            n.skipType(d & 7);
            break;
        }
      }
      return l;
    }, r.decodeDelimited = function(n) {
      return n instanceof $Reader || (n = new $Reader(n)), this.decode(n, n.uint32());
    }, r.verify = function(n) {
      if (typeof n != "object" || n === null)
        return "object expected";
      if (n.idHex != null && n.hasOwnProperty("idHex") && !$util.isString(n.idHex))
        return "idHex: string expected";
      if (n.name != null && n.hasOwnProperty("name") && !$util.isString(n.name))
        return "name: string expected";
      if (n.driverAttestationHash != null && n.hasOwnProperty("driverAttestationHash") && !$util.isString(n.driverAttestationHash))
        return "driverAttestationHash: string expected";
      if (n.participantEmails != null && n.hasOwnProperty("participantEmails")) {
        if (!Array.isArray(n.participantEmails))
          return "participantEmails: array expected";
        for (let o = 0; o < n.participantEmails.length; ++o)
          if (!$util.isString(n.participantEmails[o]))
            return "participantEmails: string[] expected";
      }
      if (n.metadata != null && n.hasOwnProperty("metadata") && !(n.metadata && typeof n.metadata.length == "number" || $util.isString(n.metadata)))
        return "metadata: buffer expected";
      if (n.enclaveInfo != null && n.hasOwnProperty("enclaveInfo")) {
        if (!Array.isArray(n.enclaveInfo))
          return "enclaveInfo: array expected";
        for (let o = 0; o < n.enclaveInfo.length; ++o) {
          let c = $root.metering.EnclaveInfo.verify(n.enclaveInfo[o]);
          if (c)
            return "enclaveInfo." + c;
        }
      }
      return null;
    }, r.fromObject = function(n) {
      if (n instanceof $root.metering.CreateDcrRequest)
        return n;
      let o = new $root.metering.CreateDcrRequest();
      if (n.idHex != null && (o.idHex = String(n.idHex)), n.name != null && (o.name = String(n.name)), n.driverAttestationHash != null && (o.driverAttestationHash = String(n.driverAttestationHash)), n.participantEmails) {
        if (!Array.isArray(n.participantEmails))
          throw TypeError(".metering.CreateDcrRequest.participantEmails: array expected");
        o.participantEmails = [];
        for (let c = 0; c < n.participantEmails.length; ++c)
          o.participantEmails[c] = String(n.participantEmails[c]);
      }
      if (n.metadata != null && (typeof n.metadata == "string" ? $util.base64.decode(n.metadata, o.metadata = $util.newBuffer($util.base64.length(n.metadata)), 0) : n.metadata.length >= 0 && (o.metadata = n.metadata)), n.enclaveInfo) {
        if (!Array.isArray(n.enclaveInfo))
          throw TypeError(".metering.CreateDcrRequest.enclaveInfo: array expected");
        o.enclaveInfo = [];
        for (let c = 0; c < n.enclaveInfo.length; ++c) {
          if (typeof n.enclaveInfo[c] != "object")
            throw TypeError(".metering.CreateDcrRequest.enclaveInfo: object expected");
          o.enclaveInfo[c] = $root.metering.EnclaveInfo.fromObject(n.enclaveInfo[c]);
        }
      }
      return o;
    }, r.toObject = function(n, o) {
      o || (o = {});
      let c = {};
      if ((o.arrays || o.defaults) && (c.participantEmails = [], c.enclaveInfo = []), o.defaults && (c.idHex = "", c.name = "", c.driverAttestationHash = ""), n.idHex != null && n.hasOwnProperty("idHex") && (c.idHex = n.idHex), n.name != null && n.hasOwnProperty("name") && (c.name = n.name), n.driverAttestationHash != null && n.hasOwnProperty("driverAttestationHash") && (c.driverAttestationHash = n.driverAttestationHash), n.participantEmails && n.participantEmails.length) {
        c.participantEmails = [];
        for (let l = 0; l < n.participantEmails.length; ++l)
          c.participantEmails[l] = n.participantEmails[l];
      }
      if (n.metadata != null && n.hasOwnProperty("metadata") && (c.metadata = o.bytes === String ? $util.base64.encode(n.metadata, 0, n.metadata.length) : o.bytes === Array ? Array.prototype.slice.call(n.metadata) : n.metadata, o.oneofs && (c._metadata = "metadata")), n.enclaveInfo && n.enclaveInfo.length) {
        c.enclaveInfo = [];
        for (let l = 0; l < n.enclaveInfo.length; ++l)
          c.enclaveInfo[l] = $root.metering.EnclaveInfo.toObject(n.enclaveInfo[l], o);
      }
      return c;
    }, r.prototype.toJSON = function() {
      return this.constructor.toObject(this, minimal.util.toJSONOptions);
    }, r.getTypeUrl = function(n) {
      return n === void 0 && (n = "type.googleapis.com"), n + "/metering.CreateDcrRequest";
    }, r;
  }(), u.ExecuteComputationNodeInteraction = function() {
    function r(e) {
      if (e)
        for (let n = Object.keys(e), o = 0; o < n.length; ++o)
          e[n[o]] != null && (this[n[o]] = e[n[o]]);
    }
    r.prototype.nodeId = "", r.prototype.rateLimiting = null;
    let a;
    return Object.defineProperty(r.prototype, "_rateLimiting", {
      get: $util.oneOfGetter(a = ["rateLimiting"]),
      set: $util.oneOfSetter(a)
    }), r.create = function(n) {
      return new r(n);
    }, r.encode = function(n, o) {
      return o || (o = $Writer.create()), n.nodeId != null && Object.hasOwnProperty.call(n, "nodeId") && o.uint32(
        /* id 1, wireType 2 =*/
        10
      ).string(n.nodeId), n.rateLimiting != null && Object.hasOwnProperty.call(n, "rateLimiting") && $root.data_room.RateLimitingConfig.encode(n.rateLimiting, o.uint32(
        /* id 2, wireType 2 =*/
        18
      ).fork()).ldelim(), o;
    }, r.encodeDelimited = function(n, o) {
      return this.encode(n, o).ldelim();
    }, r.decode = function(n, o) {
      n instanceof $Reader || (n = $Reader.create(n));
      let c = o === void 0 ? n.len : n.pos + o, l = new $root.metering.ExecuteComputationNodeInteraction();
      for (; n.pos < c; ) {
        let d = n.uint32();
        switch (d >>> 3) {
          case 1: {
            l.nodeId = n.string();
            break;
          }
          case 2: {
            l.rateLimiting = $root.data_room.RateLimitingConfig.decode(n, n.uint32());
            break;
          }
          default:
            n.skipType(d & 7);
            break;
        }
      }
      return l;
    }, r.decodeDelimited = function(n) {
      return n instanceof $Reader || (n = new $Reader(n)), this.decode(n, n.uint32());
    }, r.verify = function(n) {
      if (typeof n != "object" || n === null)
        return "object expected";
      if (n.nodeId != null && n.hasOwnProperty("nodeId") && !$util.isString(n.nodeId))
        return "nodeId: string expected";
      if (n.rateLimiting != null && n.hasOwnProperty("rateLimiting")) {
        let o = $root.data_room.RateLimitingConfig.verify(n.rateLimiting);
        if (o)
          return "rateLimiting." + o;
      }
      return null;
    }, r.fromObject = function(n) {
      if (n instanceof $root.metering.ExecuteComputationNodeInteraction)
        return n;
      let o = new $root.metering.ExecuteComputationNodeInteraction();
      if (n.nodeId != null && (o.nodeId = String(n.nodeId)), n.rateLimiting != null) {
        if (typeof n.rateLimiting != "object")
          throw TypeError(".metering.ExecuteComputationNodeInteraction.rateLimiting: object expected");
        o.rateLimiting = $root.data_room.RateLimitingConfig.fromObject(n.rateLimiting);
      }
      return o;
    }, r.toObject = function(n, o) {
      o || (o = {});
      let c = {};
      return o.defaults && (c.nodeId = ""), n.nodeId != null && n.hasOwnProperty("nodeId") && (c.nodeId = n.nodeId), n.rateLimiting != null && n.hasOwnProperty("rateLimiting") && (c.rateLimiting = $root.data_room.RateLimitingConfig.toObject(n.rateLimiting, o), o.oneofs && (c._rateLimiting = "rateLimiting")), c;
    }, r.prototype.toJSON = function() {
      return this.constructor.toObject(this, minimal.util.toJSONOptions);
    }, r.getTypeUrl = function(n) {
      return n === void 0 && (n = "type.googleapis.com"), n + "/metering.ExecuteComputationNodeInteraction";
    }, r;
  }(), u.ExecuteComputationInteraction = function() {
    function r(a) {
      if (this.nodes = [], a)
        for (let e = Object.keys(a), n = 0; n < e.length; ++n)
          a[e[n]] != null && (this[e[n]] = a[e[n]]);
    }
    return r.prototype.nodes = $util.emptyArray, r.create = function(e) {
      return new r(e);
    }, r.encode = function(e, n) {
      if (n || (n = $Writer.create()), e.nodes != null && e.nodes.length)
        for (let o = 0; o < e.nodes.length; ++o)
          $root.metering.ExecuteComputationNodeInteraction.encode(e.nodes[o], n.uint32(
            /* id 1, wireType 2 =*/
            10
          ).fork()).ldelim();
      return n;
    }, r.encodeDelimited = function(e, n) {
      return this.encode(e, n).ldelim();
    }, r.decode = function(e, n) {
      e instanceof $Reader || (e = $Reader.create(e));
      let o = n === void 0 ? e.len : e.pos + n, c = new $root.metering.ExecuteComputationInteraction();
      for (; e.pos < o; ) {
        let l = e.uint32();
        switch (l >>> 3) {
          case 1: {
            c.nodes && c.nodes.length || (c.nodes = []), c.nodes.push($root.metering.ExecuteComputationNodeInteraction.decode(e, e.uint32()));
            break;
          }
          default:
            e.skipType(l & 7);
            break;
        }
      }
      return c;
    }, r.decodeDelimited = function(e) {
      return e instanceof $Reader || (e = new $Reader(e)), this.decode(e, e.uint32());
    }, r.verify = function(e) {
      if (typeof e != "object" || e === null)
        return "object expected";
      if (e.nodes != null && e.hasOwnProperty("nodes")) {
        if (!Array.isArray(e.nodes))
          return "nodes: array expected";
        for (let n = 0; n < e.nodes.length; ++n) {
          let o = $root.metering.ExecuteComputationNodeInteraction.verify(e.nodes[n]);
          if (o)
            return "nodes." + o;
        }
      }
      return null;
    }, r.fromObject = function(e) {
      if (e instanceof $root.metering.ExecuteComputationInteraction)
        return e;
      let n = new $root.metering.ExecuteComputationInteraction();
      if (e.nodes) {
        if (!Array.isArray(e.nodes))
          throw TypeError(".metering.ExecuteComputationInteraction.nodes: array expected");
        n.nodes = [];
        for (let o = 0; o < e.nodes.length; ++o) {
          if (typeof e.nodes[o] != "object")
            throw TypeError(".metering.ExecuteComputationInteraction.nodes: object expected");
          n.nodes[o] = $root.metering.ExecuteComputationNodeInteraction.fromObject(e.nodes[o]);
        }
      }
      return n;
    }, r.toObject = function(e, n) {
      n || (n = {});
      let o = {};
      if ((n.arrays || n.defaults) && (o.nodes = []), e.nodes && e.nodes.length) {
        o.nodes = [];
        for (let c = 0; c < e.nodes.length; ++c)
          o.nodes[c] = $root.metering.ExecuteComputationNodeInteraction.toObject(e.nodes[c], n);
      }
      return o;
    }, r.prototype.toJSON = function() {
      return this.constructor.toObject(this, minimal.util.toJSONOptions);
    }, r.getTypeUrl = function(e) {
      return e === void 0 && (e = "type.googleapis.com"), e + "/metering.ExecuteComputationInteraction";
    }, r;
  }(), u.PublishDatasetInteraction = function() {
    function r(e) {
      if (e)
        for (let n = Object.keys(e), o = 0; o < n.length; ++o)
          e[n[o]] != null && (this[n[o]] = e[n[o]]);
    }
    r.prototype.nodeId = "", r.prototype.rateLimiting = null;
    let a;
    return Object.defineProperty(r.prototype, "_rateLimiting", {
      get: $util.oneOfGetter(a = ["rateLimiting"]),
      set: $util.oneOfSetter(a)
    }), r.create = function(n) {
      return new r(n);
    }, r.encode = function(n, o) {
      return o || (o = $Writer.create()), n.nodeId != null && Object.hasOwnProperty.call(n, "nodeId") && o.uint32(
        /* id 1, wireType 2 =*/
        10
      ).string(n.nodeId), n.rateLimiting != null && Object.hasOwnProperty.call(n, "rateLimiting") && $root.data_room.RateLimitingConfig.encode(n.rateLimiting, o.uint32(
        /* id 2, wireType 2 =*/
        18
      ).fork()).ldelim(), o;
    }, r.encodeDelimited = function(n, o) {
      return this.encode(n, o).ldelim();
    }, r.decode = function(n, o) {
      n instanceof $Reader || (n = $Reader.create(n));
      let c = o === void 0 ? n.len : n.pos + o, l = new $root.metering.PublishDatasetInteraction();
      for (; n.pos < c; ) {
        let d = n.uint32();
        switch (d >>> 3) {
          case 1: {
            l.nodeId = n.string();
            break;
          }
          case 2: {
            l.rateLimiting = $root.data_room.RateLimitingConfig.decode(n, n.uint32());
            break;
          }
          default:
            n.skipType(d & 7);
            break;
        }
      }
      return l;
    }, r.decodeDelimited = function(n) {
      return n instanceof $Reader || (n = new $Reader(n)), this.decode(n, n.uint32());
    }, r.verify = function(n) {
      if (typeof n != "object" || n === null)
        return "object expected";
      if (n.nodeId != null && n.hasOwnProperty("nodeId") && !$util.isString(n.nodeId))
        return "nodeId: string expected";
      if (n.rateLimiting != null && n.hasOwnProperty("rateLimiting")) {
        let o = $root.data_room.RateLimitingConfig.verify(n.rateLimiting);
        if (o)
          return "rateLimiting." + o;
      }
      return null;
    }, r.fromObject = function(n) {
      if (n instanceof $root.metering.PublishDatasetInteraction)
        return n;
      let o = new $root.metering.PublishDatasetInteraction();
      if (n.nodeId != null && (o.nodeId = String(n.nodeId)), n.rateLimiting != null) {
        if (typeof n.rateLimiting != "object")
          throw TypeError(".metering.PublishDatasetInteraction.rateLimiting: object expected");
        o.rateLimiting = $root.data_room.RateLimitingConfig.fromObject(n.rateLimiting);
      }
      return o;
    }, r.toObject = function(n, o) {
      o || (o = {});
      let c = {};
      return o.defaults && (c.nodeId = ""), n.nodeId != null && n.hasOwnProperty("nodeId") && (c.nodeId = n.nodeId), n.rateLimiting != null && n.hasOwnProperty("rateLimiting") && (c.rateLimiting = $root.data_room.RateLimitingConfig.toObject(n.rateLimiting, o), o.oneofs && (c._rateLimiting = "rateLimiting")), c;
    }, r.prototype.toJSON = function() {
      return this.constructor.toObject(this, minimal.util.toJSONOptions);
    }, r.getTypeUrl = function(n) {
      return n === void 0 && (n = "type.googleapis.com"), n + "/metering.PublishDatasetInteraction";
    }, r;
  }(), u.DcrInteractionKind = function() {
    function r(e) {
      if (e)
        for (let n = Object.keys(e), o = 0; o < n.length; ++o)
          e[n[o]] != null && (this[n[o]] = e[n[o]]);
    }
    r.prototype.executeComputation = null, r.prototype.publishDataset = null;
    let a;
    return Object.defineProperty(r.prototype, "kind", {
      get: $util.oneOfGetter(a = ["executeComputation", "publishDataset"]),
      set: $util.oneOfSetter(a)
    }), r.create = function(n) {
      return new r(n);
    }, r.encode = function(n, o) {
      return o || (o = $Writer.create()), n.executeComputation != null && Object.hasOwnProperty.call(n, "executeComputation") && $root.metering.ExecuteComputationInteraction.encode(n.executeComputation, o.uint32(
        /* id 1, wireType 2 =*/
        10
      ).fork()).ldelim(), n.publishDataset != null && Object.hasOwnProperty.call(n, "publishDataset") && $root.metering.PublishDatasetInteraction.encode(n.publishDataset, o.uint32(
        /* id 2, wireType 2 =*/
        18
      ).fork()).ldelim(), o;
    }, r.encodeDelimited = function(n, o) {
      return this.encode(n, o).ldelim();
    }, r.decode = function(n, o) {
      n instanceof $Reader || (n = $Reader.create(n));
      let c = o === void 0 ? n.len : n.pos + o, l = new $root.metering.DcrInteractionKind();
      for (; n.pos < c; ) {
        let d = n.uint32();
        switch (d >>> 3) {
          case 1: {
            l.executeComputation = $root.metering.ExecuteComputationInteraction.decode(n, n.uint32());
            break;
          }
          case 2: {
            l.publishDataset = $root.metering.PublishDatasetInteraction.decode(n, n.uint32());
            break;
          }
          default:
            n.skipType(d & 7);
            break;
        }
      }
      return l;
    }, r.decodeDelimited = function(n) {
      return n instanceof $Reader || (n = new $Reader(n)), this.decode(n, n.uint32());
    }, r.verify = function(n) {
      if (typeof n != "object" || n === null)
        return "object expected";
      let o = {};
      if (n.executeComputation != null && n.hasOwnProperty("executeComputation")) {
        o.kind = 1;
        {
          let c = $root.metering.ExecuteComputationInteraction.verify(n.executeComputation);
          if (c)
            return "executeComputation." + c;
        }
      }
      if (n.publishDataset != null && n.hasOwnProperty("publishDataset")) {
        if (o.kind === 1)
          return "kind: multiple values";
        o.kind = 1;
        {
          let c = $root.metering.PublishDatasetInteraction.verify(n.publishDataset);
          if (c)
            return "publishDataset." + c;
        }
      }
      return null;
    }, r.fromObject = function(n) {
      if (n instanceof $root.metering.DcrInteractionKind)
        return n;
      let o = new $root.metering.DcrInteractionKind();
      if (n.executeComputation != null) {
        if (typeof n.executeComputation != "object")
          throw TypeError(".metering.DcrInteractionKind.executeComputation: object expected");
        o.executeComputation = $root.metering.ExecuteComputationInteraction.fromObject(n.executeComputation);
      }
      if (n.publishDataset != null) {
        if (typeof n.publishDataset != "object")
          throw TypeError(".metering.DcrInteractionKind.publishDataset: object expected");
        o.publishDataset = $root.metering.PublishDatasetInteraction.fromObject(n.publishDataset);
      }
      return o;
    }, r.toObject = function(n, o) {
      o || (o = {});
      let c = {};
      return n.executeComputation != null && n.hasOwnProperty("executeComputation") && (c.executeComputation = $root.metering.ExecuteComputationInteraction.toObject(n.executeComputation, o), o.oneofs && (c.kind = "executeComputation")), n.publishDataset != null && n.hasOwnProperty("publishDataset") && (c.publishDataset = $root.metering.PublishDatasetInteraction.toObject(n.publishDataset, o), o.oneofs && (c.kind = "publishDataset")), c;
    }, r.prototype.toJSON = function() {
      return this.constructor.toObject(this, minimal.util.toJSONOptions);
    }, r.getTypeUrl = function(n) {
      return n === void 0 && (n = "type.googleapis.com"), n + "/metering.DcrInteractionKind";
    }, r;
  }(), u.DcrInteractionRequest = function() {
    function r(a) {
      if (a)
        for (let e = Object.keys(a), n = 0; n < e.length; ++n)
          a[e[n]] != null && (this[e[n]] = a[e[n]]);
    }
    return r.prototype.dataRoomHash = "", r.prototype.driverAttestationHash = "", r.prototype.scopeId = "", r.prototype.interaction = null, r.create = function(e) {
      return new r(e);
    }, r.encode = function(e, n) {
      return n || (n = $Writer.create()), e.dataRoomHash != null && Object.hasOwnProperty.call(e, "dataRoomHash") && n.uint32(
        /* id 1, wireType 2 =*/
        10
      ).string(e.dataRoomHash), e.driverAttestationHash != null && Object.hasOwnProperty.call(e, "driverAttestationHash") && n.uint32(
        /* id 2, wireType 2 =*/
        18
      ).string(e.driverAttestationHash), e.scopeId != null && Object.hasOwnProperty.call(e, "scopeId") && n.uint32(
        /* id 3, wireType 2 =*/
        26
      ).string(e.scopeId), e.interaction != null && Object.hasOwnProperty.call(e, "interaction") && $root.metering.DcrInteractionKind.encode(e.interaction, n.uint32(
        /* id 4, wireType 2 =*/
        34
      ).fork()).ldelim(), n;
    }, r.encodeDelimited = function(e, n) {
      return this.encode(e, n).ldelim();
    }, r.decode = function(e, n) {
      e instanceof $Reader || (e = $Reader.create(e));
      let o = n === void 0 ? e.len : e.pos + n, c = new $root.metering.DcrInteractionRequest();
      for (; e.pos < o; ) {
        let l = e.uint32();
        switch (l >>> 3) {
          case 1: {
            c.dataRoomHash = e.string();
            break;
          }
          case 2: {
            c.driverAttestationHash = e.string();
            break;
          }
          case 3: {
            c.scopeId = e.string();
            break;
          }
          case 4: {
            c.interaction = $root.metering.DcrInteractionKind.decode(e, e.uint32());
            break;
          }
          default:
            e.skipType(l & 7);
            break;
        }
      }
      return c;
    }, r.decodeDelimited = function(e) {
      return e instanceof $Reader || (e = new $Reader(e)), this.decode(e, e.uint32());
    }, r.verify = function(e) {
      if (typeof e != "object" || e === null)
        return "object expected";
      if (e.dataRoomHash != null && e.hasOwnProperty("dataRoomHash") && !$util.isString(e.dataRoomHash))
        return "dataRoomHash: string expected";
      if (e.driverAttestationHash != null && e.hasOwnProperty("driverAttestationHash") && !$util.isString(e.driverAttestationHash))
        return "driverAttestationHash: string expected";
      if (e.scopeId != null && e.hasOwnProperty("scopeId") && !$util.isString(e.scopeId))
        return "scopeId: string expected";
      if (e.interaction != null && e.hasOwnProperty("interaction")) {
        let n = $root.metering.DcrInteractionKind.verify(e.interaction);
        if (n)
          return "interaction." + n;
      }
      return null;
    }, r.fromObject = function(e) {
      if (e instanceof $root.metering.DcrInteractionRequest)
        return e;
      let n = new $root.metering.DcrInteractionRequest();
      if (e.dataRoomHash != null && (n.dataRoomHash = String(e.dataRoomHash)), e.driverAttestationHash != null && (n.driverAttestationHash = String(e.driverAttestationHash)), e.scopeId != null && (n.scopeId = String(e.scopeId)), e.interaction != null) {
        if (typeof e.interaction != "object")
          throw TypeError(".metering.DcrInteractionRequest.interaction: object expected");
        n.interaction = $root.metering.DcrInteractionKind.fromObject(e.interaction);
      }
      return n;
    }, r.toObject = function(e, n) {
      n || (n = {});
      let o = {};
      return n.defaults && (o.dataRoomHash = "", o.driverAttestationHash = "", o.scopeId = "", o.interaction = null), e.dataRoomHash != null && e.hasOwnProperty("dataRoomHash") && (o.dataRoomHash = e.dataRoomHash), e.driverAttestationHash != null && e.hasOwnProperty("driverAttestationHash") && (o.driverAttestationHash = e.driverAttestationHash), e.scopeId != null && e.hasOwnProperty("scopeId") && (o.scopeId = e.scopeId), e.interaction != null && e.hasOwnProperty("interaction") && (o.interaction = $root.metering.DcrInteractionKind.toObject(e.interaction, n)), o;
    }, r.prototype.toJSON = function() {
      return this.constructor.toObject(this, minimal.util.toJSONOptions);
    }, r.getTypeUrl = function(e) {
      return e === void 0 && (e = "type.googleapis.com"), e + "/metering.DcrInteractionRequest";
    }, r;
  }(), u.PublishDatasetRequest = function() {
    function r(a) {
      if (a)
        for (let e = Object.keys(a), n = 0; n < e.length; ++n)
          a[e[n]] != null && (this[e[n]] = a[e[n]]);
    }
    return r.prototype.computeNodeId = "", r.prototype.manifestHash = "", r.prototype.dataRoomHash = "", r.prototype.driverAttestationHash = "", r.create = function(e) {
      return new r(e);
    }, r.encode = function(e, n) {
      return n || (n = $Writer.create()), e.computeNodeId != null && Object.hasOwnProperty.call(e, "computeNodeId") && n.uint32(
        /* id 1, wireType 2 =*/
        10
      ).string(e.computeNodeId), e.manifestHash != null && Object.hasOwnProperty.call(e, "manifestHash") && n.uint32(
        /* id 2, wireType 2 =*/
        18
      ).string(e.manifestHash), e.dataRoomHash != null && Object.hasOwnProperty.call(e, "dataRoomHash") && n.uint32(
        /* id 3, wireType 2 =*/
        26
      ).string(e.dataRoomHash), e.driverAttestationHash != null && Object.hasOwnProperty.call(e, "driverAttestationHash") && n.uint32(
        /* id 4, wireType 2 =*/
        34
      ).string(e.driverAttestationHash), n;
    }, r.encodeDelimited = function(e, n) {
      return this.encode(e, n).ldelim();
    }, r.decode = function(e, n) {
      e instanceof $Reader || (e = $Reader.create(e));
      let o = n === void 0 ? e.len : e.pos + n, c = new $root.metering.PublishDatasetRequest();
      for (; e.pos < o; ) {
        let l = e.uint32();
        switch (l >>> 3) {
          case 1: {
            c.computeNodeId = e.string();
            break;
          }
          case 2: {
            c.manifestHash = e.string();
            break;
          }
          case 3: {
            c.dataRoomHash = e.string();
            break;
          }
          case 4: {
            c.driverAttestationHash = e.string();
            break;
          }
          default:
            e.skipType(l & 7);
            break;
        }
      }
      return c;
    }, r.decodeDelimited = function(e) {
      return e instanceof $Reader || (e = new $Reader(e)), this.decode(e, e.uint32());
    }, r.verify = function(e) {
      return typeof e != "object" || e === null ? "object expected" : e.computeNodeId != null && e.hasOwnProperty("computeNodeId") && !$util.isString(e.computeNodeId) ? "computeNodeId: string expected" : e.manifestHash != null && e.hasOwnProperty("manifestHash") && !$util.isString(e.manifestHash) ? "manifestHash: string expected" : e.dataRoomHash != null && e.hasOwnProperty("dataRoomHash") && !$util.isString(e.dataRoomHash) ? "dataRoomHash: string expected" : e.driverAttestationHash != null && e.hasOwnProperty("driverAttestationHash") && !$util.isString(e.driverAttestationHash) ? "driverAttestationHash: string expected" : null;
    }, r.fromObject = function(e) {
      if (e instanceof $root.metering.PublishDatasetRequest)
        return e;
      let n = new $root.metering.PublishDatasetRequest();
      return e.computeNodeId != null && (n.computeNodeId = String(e.computeNodeId)), e.manifestHash != null && (n.manifestHash = String(e.manifestHash)), e.dataRoomHash != null && (n.dataRoomHash = String(e.dataRoomHash)), e.driverAttestationHash != null && (n.driverAttestationHash = String(e.driverAttestationHash)), n;
    }, r.toObject = function(e, n) {
      n || (n = {});
      let o = {};
      return n.defaults && (o.computeNodeId = "", o.manifestHash = "", o.dataRoomHash = "", o.driverAttestationHash = ""), e.computeNodeId != null && e.hasOwnProperty("computeNodeId") && (o.computeNodeId = e.computeNodeId), e.manifestHash != null && e.hasOwnProperty("manifestHash") && (o.manifestHash = e.manifestHash), e.dataRoomHash != null && e.hasOwnProperty("dataRoomHash") && (o.dataRoomHash = e.dataRoomHash), e.driverAttestationHash != null && e.hasOwnProperty("driverAttestationHash") && (o.driverAttestationHash = e.driverAttestationHash), o;
    }, r.prototype.toJSON = function() {
      return this.constructor.toObject(this, minimal.util.toJSONOptions);
    }, r.getTypeUrl = function(e) {
      return e === void 0 && (e = "type.googleapis.com"), e + "/metering.PublishDatasetRequest";
    }, r;
  }(), u.CreateDatasetRequest = function() {
    function r(e) {
      if (e)
        for (let n = Object.keys(e), o = 0; o < n.length; ++o)
          e[n[o]] != null && (this[n[o]] = e[n[o]]);
    }
    r.prototype.manifestHash = "", r.prototype.manifest = null, r.prototype.scopeId = "", r.prototype.name = "", r.prototype.description = null, r.prototype.sizeBytes = null, r.prototype.statistics = null, r.prototype.datasetImportId = null;
    let a;
    return Object.defineProperty(r.prototype, "_manifest", {
      get: $util.oneOfGetter(a = ["manifest"]),
      set: $util.oneOfSetter(a)
    }), Object.defineProperty(r.prototype, "_description", {
      get: $util.oneOfGetter(a = ["description"]),
      set: $util.oneOfSetter(a)
    }), Object.defineProperty(r.prototype, "_sizeBytes", {
      get: $util.oneOfGetter(a = ["sizeBytes"]),
      set: $util.oneOfSetter(a)
    }), Object.defineProperty(r.prototype, "_statistics", {
      get: $util.oneOfGetter(a = ["statistics"]),
      set: $util.oneOfSetter(a)
    }), Object.defineProperty(r.prototype, "_datasetImportId", {
      get: $util.oneOfGetter(a = ["datasetImportId"]),
      set: $util.oneOfSetter(a)
    }), r.create = function(n) {
      return new r(n);
    }, r.encode = function(n, o) {
      return o || (o = $Writer.create()), n.manifestHash != null && Object.hasOwnProperty.call(n, "manifestHash") && o.uint32(
        /* id 1, wireType 2 =*/
        10
      ).string(n.manifestHash), n.manifest != null && Object.hasOwnProperty.call(n, "manifest") && o.uint32(
        /* id 2, wireType 2 =*/
        18
      ).string(n.manifest), n.scopeId != null && Object.hasOwnProperty.call(n, "scopeId") && o.uint32(
        /* id 3, wireType 2 =*/
        26
      ).string(n.scopeId), n.name != null && Object.hasOwnProperty.call(n, "name") && o.uint32(
        /* id 4, wireType 2 =*/
        34
      ).string(n.name), n.description != null && Object.hasOwnProperty.call(n, "description") && o.uint32(
        /* id 5, wireType 2 =*/
        42
      ).string(n.description), n.sizeBytes != null && Object.hasOwnProperty.call(n, "sizeBytes") && o.uint32(
        /* id 6, wireType 0 =*/
        48
      ).uint64(n.sizeBytes), n.statistics != null && Object.hasOwnProperty.call(n, "statistics") && o.uint32(
        /* id 7, wireType 2 =*/
        58
      ).string(n.statistics), n.datasetImportId != null && Object.hasOwnProperty.call(n, "datasetImportId") && o.uint32(
        /* id 8, wireType 2 =*/
        66
      ).string(n.datasetImportId), o;
    }, r.encodeDelimited = function(n, o) {
      return this.encode(n, o).ldelim();
    }, r.decode = function(n, o) {
      n instanceof $Reader || (n = $Reader.create(n));
      let c = o === void 0 ? n.len : n.pos + o, l = new $root.metering.CreateDatasetRequest();
      for (; n.pos < c; ) {
        let d = n.uint32();
        switch (d >>> 3) {
          case 1: {
            l.manifestHash = n.string();
            break;
          }
          case 2: {
            l.manifest = n.string();
            break;
          }
          case 3: {
            l.scopeId = n.string();
            break;
          }
          case 4: {
            l.name = n.string();
            break;
          }
          case 5: {
            l.description = n.string();
            break;
          }
          case 6: {
            l.sizeBytes = n.uint64();
            break;
          }
          case 7: {
            l.statistics = n.string();
            break;
          }
          case 8: {
            l.datasetImportId = n.string();
            break;
          }
          default:
            n.skipType(d & 7);
            break;
        }
      }
      return l;
    }, r.decodeDelimited = function(n) {
      return n instanceof $Reader || (n = new $Reader(n)), this.decode(n, n.uint32());
    }, r.verify = function(n) {
      return typeof n != "object" || n === null ? "object expected" : n.manifestHash != null && n.hasOwnProperty("manifestHash") && !$util.isString(n.manifestHash) ? "manifestHash: string expected" : n.manifest != null && n.hasOwnProperty("manifest") && !$util.isString(n.manifest) ? "manifest: string expected" : n.scopeId != null && n.hasOwnProperty("scopeId") && !$util.isString(n.scopeId) ? "scopeId: string expected" : n.name != null && n.hasOwnProperty("name") && !$util.isString(n.name) ? "name: string expected" : n.description != null && n.hasOwnProperty("description") && !$util.isString(n.description) ? "description: string expected" : n.sizeBytes != null && n.hasOwnProperty("sizeBytes") && !$util.isInteger(n.sizeBytes) && !(n.sizeBytes && $util.isInteger(n.sizeBytes.low) && $util.isInteger(n.sizeBytes.high)) ? "sizeBytes: integer|Long expected" : n.statistics != null && n.hasOwnProperty("statistics") && !$util.isString(n.statistics) ? "statistics: string expected" : n.datasetImportId != null && n.hasOwnProperty("datasetImportId") && !$util.isString(n.datasetImportId) ? "datasetImportId: string expected" : null;
    }, r.fromObject = function(n) {
      if (n instanceof $root.metering.CreateDatasetRequest)
        return n;
      let o = new $root.metering.CreateDatasetRequest();
      return n.manifestHash != null && (o.manifestHash = String(n.manifestHash)), n.manifest != null && (o.manifest = String(n.manifest)), n.scopeId != null && (o.scopeId = String(n.scopeId)), n.name != null && (o.name = String(n.name)), n.description != null && (o.description = String(n.description)), n.sizeBytes != null && ($util.Long ? (o.sizeBytes = $util.Long.fromValue(n.sizeBytes)).unsigned = !0 : typeof n.sizeBytes == "string" ? o.sizeBytes = parseInt(n.sizeBytes, 10) : typeof n.sizeBytes == "number" ? o.sizeBytes = n.sizeBytes : typeof n.sizeBytes == "object" && (o.sizeBytes = new $util.LongBits(n.sizeBytes.low >>> 0, n.sizeBytes.high >>> 0).toNumber(!0))), n.statistics != null && (o.statistics = String(n.statistics)), n.datasetImportId != null && (o.datasetImportId = String(n.datasetImportId)), o;
    }, r.toObject = function(n, o) {
      o || (o = {});
      let c = {};
      return o.defaults && (c.manifestHash = "", c.scopeId = "", c.name = ""), n.manifestHash != null && n.hasOwnProperty("manifestHash") && (c.manifestHash = n.manifestHash), n.manifest != null && n.hasOwnProperty("manifest") && (c.manifest = n.manifest, o.oneofs && (c._manifest = "manifest")), n.scopeId != null && n.hasOwnProperty("scopeId") && (c.scopeId = n.scopeId), n.name != null && n.hasOwnProperty("name") && (c.name = n.name), n.description != null && n.hasOwnProperty("description") && (c.description = n.description, o.oneofs && (c._description = "description")), n.sizeBytes != null && n.hasOwnProperty("sizeBytes") && (typeof n.sizeBytes == "number" ? c.sizeBytes = o.longs === String ? String(n.sizeBytes) : n.sizeBytes : c.sizeBytes = o.longs === String ? $util.Long.prototype.toString.call(n.sizeBytes) : o.longs === Number ? new $util.LongBits(n.sizeBytes.low >>> 0, n.sizeBytes.high >>> 0).toNumber(!0) : n.sizeBytes, o.oneofs && (c._sizeBytes = "sizeBytes")), n.statistics != null && n.hasOwnProperty("statistics") && (c.statistics = n.statistics, o.oneofs && (c._statistics = "statistics")), n.datasetImportId != null && n.hasOwnProperty("datasetImportId") && (c.datasetImportId = n.datasetImportId, o.oneofs && (c._datasetImportId = "datasetImportId")), c;
    }, r.prototype.toJSON = function() {
      return this.constructor.toObject(this, minimal.util.toJSONOptions);
    }, r.getTypeUrl = function(n) {
      return n === void 0 && (n = "type.googleapis.com"), n + "/metering.CreateDatasetRequest";
    }, r;
  }(), u.GetOrCreateDatasetScopeRequest = function() {
    function r(e) {
      if (e)
        for (let n = Object.keys(e), o = 0; o < n.length; ++o)
          e[n[o]] != null && (this[n[o]] = e[n[o]]);
    }
    r.prototype.manifestHash = null;
    let a;
    return Object.defineProperty(r.prototype, "_manifestHash", {
      get: $util.oneOfGetter(a = ["manifestHash"]),
      set: $util.oneOfSetter(a)
    }), r.create = function(n) {
      return new r(n);
    }, r.encode = function(n, o) {
      return o || (o = $Writer.create()), n.manifestHash != null && Object.hasOwnProperty.call(n, "manifestHash") && o.uint32(
        /* id 1, wireType 2 =*/
        10
      ).string(n.manifestHash), o;
    }, r.encodeDelimited = function(n, o) {
      return this.encode(n, o).ldelim();
    }, r.decode = function(n, o) {
      n instanceof $Reader || (n = $Reader.create(n));
      let c = o === void 0 ? n.len : n.pos + o, l = new $root.metering.GetOrCreateDatasetScopeRequest();
      for (; n.pos < c; ) {
        let d = n.uint32();
        switch (d >>> 3) {
          case 1: {
            l.manifestHash = n.string();
            break;
          }
          default:
            n.skipType(d & 7);
            break;
        }
      }
      return l;
    }, r.decodeDelimited = function(n) {
      return n instanceof $Reader || (n = new $Reader(n)), this.decode(n, n.uint32());
    }, r.verify = function(n) {
      return typeof n != "object" || n === null ? "object expected" : n.manifestHash != null && n.hasOwnProperty("manifestHash") && !$util.isString(n.manifestHash) ? "manifestHash: string expected" : null;
    }, r.fromObject = function(n) {
      if (n instanceof $root.metering.GetOrCreateDatasetScopeRequest)
        return n;
      let o = new $root.metering.GetOrCreateDatasetScopeRequest();
      return n.manifestHash != null && (o.manifestHash = String(n.manifestHash)), o;
    }, r.toObject = function(n, o) {
      o || (o = {});
      let c = {};
      return n.manifestHash != null && n.hasOwnProperty("manifestHash") && (c.manifestHash = n.manifestHash, o.oneofs && (c._manifestHash = "manifestHash")), c;
    }, r.prototype.toJSON = function() {
      return this.constructor.toObject(this, minimal.util.toJSONOptions);
    }, r.getTypeUrl = function(n) {
      return n === void 0 && (n = "type.googleapis.com"), n + "/metering.GetOrCreateDatasetScopeRequest";
    }, r;
  }(), u.GetOrCreateDcrDataScopeRequest = function() {
    function r(a) {
      if (a)
        for (let e = Object.keys(a), n = 0; n < e.length; ++n)
          a[e[n]] != null && (this[e[n]] = a[e[n]]);
    }
    return r.prototype.dcrIdHex = "", r.create = function(e) {
      return new r(e);
    }, r.encode = function(e, n) {
      return n || (n = $Writer.create()), e.dcrIdHex != null && Object.hasOwnProperty.call(e, "dcrIdHex") && n.uint32(
        /* id 1, wireType 2 =*/
        10
      ).string(e.dcrIdHex), n;
    }, r.encodeDelimited = function(e, n) {
      return this.encode(e, n).ldelim();
    }, r.decode = function(e, n) {
      e instanceof $Reader || (e = $Reader.create(e));
      let o = n === void 0 ? e.len : e.pos + n, c = new $root.metering.GetOrCreateDcrDataScopeRequest();
      for (; e.pos < o; ) {
        let l = e.uint32();
        switch (l >>> 3) {
          case 1: {
            c.dcrIdHex = e.string();
            break;
          }
          default:
            e.skipType(l & 7);
            break;
        }
      }
      return c;
    }, r.decodeDelimited = function(e) {
      return e instanceof $Reader || (e = new $Reader(e)), this.decode(e, e.uint32());
    }, r.verify = function(e) {
      return typeof e != "object" || e === null ? "object expected" : e.dcrIdHex != null && e.hasOwnProperty("dcrIdHex") && !$util.isString(e.dcrIdHex) ? "dcrIdHex: string expected" : null;
    }, r.fromObject = function(e) {
      if (e instanceof $root.metering.GetOrCreateDcrDataScopeRequest)
        return e;
      let n = new $root.metering.GetOrCreateDcrDataScopeRequest();
      return e.dcrIdHex != null && (n.dcrIdHex = String(e.dcrIdHex)), n;
    }, r.toObject = function(e, n) {
      n || (n = {});
      let o = {};
      return n.defaults && (o.dcrIdHex = ""), e.dcrIdHex != null && e.hasOwnProperty("dcrIdHex") && (o.dcrIdHex = e.dcrIdHex), o;
    }, r.prototype.toJSON = function() {
      return this.constructor.toObject(this, minimal.util.toJSONOptions);
    }, r.getTypeUrl = function(e) {
      return e === void 0 && (e = "type.googleapis.com"), e + "/metering.GetOrCreateDcrDataScopeRequest";
    }, r;
  }(), u.UnpublishDatasetRequest = function() {
    function r(a) {
      if (a)
        for (let e = Object.keys(a), n = 0; n < e.length; ++n)
          a[e[n]] != null && (this[e[n]] = a[e[n]]);
    }
    return r.prototype.computeNodeId = "", r.prototype.dataRoomHash = "", r.prototype.driverAttestationHash = "", r.create = function(e) {
      return new r(e);
    }, r.encode = function(e, n) {
      return n || (n = $Writer.create()), e.computeNodeId != null && Object.hasOwnProperty.call(e, "computeNodeId") && n.uint32(
        /* id 1, wireType 2 =*/
        10
      ).string(e.computeNodeId), e.dataRoomHash != null && Object.hasOwnProperty.call(e, "dataRoomHash") && n.uint32(
        /* id 2, wireType 2 =*/
        18
      ).string(e.dataRoomHash), e.driverAttestationHash != null && Object.hasOwnProperty.call(e, "driverAttestationHash") && n.uint32(
        /* id 3, wireType 2 =*/
        26
      ).string(e.driverAttestationHash), n;
    }, r.encodeDelimited = function(e, n) {
      return this.encode(e, n).ldelim();
    }, r.decode = function(e, n) {
      e instanceof $Reader || (e = $Reader.create(e));
      let o = n === void 0 ? e.len : e.pos + n, c = new $root.metering.UnpublishDatasetRequest();
      for (; e.pos < o; ) {
        let l = e.uint32();
        switch (l >>> 3) {
          case 1: {
            c.computeNodeId = e.string();
            break;
          }
          case 2: {
            c.dataRoomHash = e.string();
            break;
          }
          case 3: {
            c.driverAttestationHash = e.string();
            break;
          }
          default:
            e.skipType(l & 7);
            break;
        }
      }
      return c;
    }, r.decodeDelimited = function(e) {
      return e instanceof $Reader || (e = new $Reader(e)), this.decode(e, e.uint32());
    }, r.verify = function(e) {
      return typeof e != "object" || e === null ? "object expected" : e.computeNodeId != null && e.hasOwnProperty("computeNodeId") && !$util.isString(e.computeNodeId) ? "computeNodeId: string expected" : e.dataRoomHash != null && e.hasOwnProperty("dataRoomHash") && !$util.isString(e.dataRoomHash) ? "dataRoomHash: string expected" : e.driverAttestationHash != null && e.hasOwnProperty("driverAttestationHash") && !$util.isString(e.driverAttestationHash) ? "driverAttestationHash: string expected" : null;
    }, r.fromObject = function(e) {
      if (e instanceof $root.metering.UnpublishDatasetRequest)
        return e;
      let n = new $root.metering.UnpublishDatasetRequest();
      return e.computeNodeId != null && (n.computeNodeId = String(e.computeNodeId)), e.dataRoomHash != null && (n.dataRoomHash = String(e.dataRoomHash)), e.driverAttestationHash != null && (n.driverAttestationHash = String(e.driverAttestationHash)), n;
    }, r.toObject = function(e, n) {
      n || (n = {});
      let o = {};
      return n.defaults && (o.computeNodeId = "", o.dataRoomHash = "", o.driverAttestationHash = ""), e.computeNodeId != null && e.hasOwnProperty("computeNodeId") && (o.computeNodeId = e.computeNodeId), e.dataRoomHash != null && e.hasOwnProperty("dataRoomHash") && (o.dataRoomHash = e.dataRoomHash), e.driverAttestationHash != null && e.hasOwnProperty("driverAttestationHash") && (o.driverAttestationHash = e.driverAttestationHash), o;
    }, r.prototype.toJSON = function() {
      return this.constructor.toObject(this, minimal.util.toJSONOptions);
    }, r.getTypeUrl = function(e) {
      return e === void 0 && (e = "type.googleapis.com"), e + "/metering.UnpublishDatasetRequest";
    }, r;
  }(), u.StopDcrRequest = function() {
    function r(a) {
      if (a)
        for (let e = Object.keys(a), n = 0; n < e.length; ++n)
          a[e[n]] != null && (this[e[n]] = a[e[n]]);
    }
    return r.prototype.dataRoomHash = "", r.prototype.driverAttestationHash = "", r.create = function(e) {
      return new r(e);
    }, r.encode = function(e, n) {
      return n || (n = $Writer.create()), e.dataRoomHash != null && Object.hasOwnProperty.call(e, "dataRoomHash") && n.uint32(
        /* id 1, wireType 2 =*/
        10
      ).string(e.dataRoomHash), e.driverAttestationHash != null && Object.hasOwnProperty.call(e, "driverAttestationHash") && n.uint32(
        /* id 2, wireType 2 =*/
        18
      ).string(e.driverAttestationHash), n;
    }, r.encodeDelimited = function(e, n) {
      return this.encode(e, n).ldelim();
    }, r.decode = function(e, n) {
      e instanceof $Reader || (e = $Reader.create(e));
      let o = n === void 0 ? e.len : e.pos + n, c = new $root.metering.StopDcrRequest();
      for (; e.pos < o; ) {
        let l = e.uint32();
        switch (l >>> 3) {
          case 1: {
            c.dataRoomHash = e.string();
            break;
          }
          case 2: {
            c.driverAttestationHash = e.string();
            break;
          }
          default:
            e.skipType(l & 7);
            break;
        }
      }
      return c;
    }, r.decodeDelimited = function(e) {
      return e instanceof $Reader || (e = new $Reader(e)), this.decode(e, e.uint32());
    }, r.verify = function(e) {
      return typeof e != "object" || e === null ? "object expected" : e.dataRoomHash != null && e.hasOwnProperty("dataRoomHash") && !$util.isString(e.dataRoomHash) ? "dataRoomHash: string expected" : e.driverAttestationHash != null && e.hasOwnProperty("driverAttestationHash") && !$util.isString(e.driverAttestationHash) ? "driverAttestationHash: string expected" : null;
    }, r.fromObject = function(e) {
      if (e instanceof $root.metering.StopDcrRequest)
        return e;
      let n = new $root.metering.StopDcrRequest();
      return e.dataRoomHash != null && (n.dataRoomHash = String(e.dataRoomHash)), e.driverAttestationHash != null && (n.driverAttestationHash = String(e.driverAttestationHash)), n;
    }, r.toObject = function(e, n) {
      n || (n = {});
      let o = {};
      return n.defaults && (o.dataRoomHash = "", o.driverAttestationHash = ""), e.dataRoomHash != null && e.hasOwnProperty("dataRoomHash") && (o.dataRoomHash = e.dataRoomHash), e.driverAttestationHash != null && e.hasOwnProperty("driverAttestationHash") && (o.driverAttestationHash = e.driverAttestationHash), o;
    }, r.prototype.toJSON = function() {
      return this.constructor.toObject(this, minimal.util.toJSONOptions);
    }, r.getTypeUrl = function(e) {
      return e === void 0 && (e = "type.googleapis.com"), e + "/metering.StopDcrRequest";
    }, r;
  }(), u.CreateDcrCommitRequest = function() {
    function r(a) {
      if (this.enclaveInfo = [], a)
        for (let e = Object.keys(a), n = 0; n < e.length; ++n)
          a[e[n]] != null && (this[e[n]] = a[e[n]]);
    }
    return r.prototype.id = "", r.prototype.dcrIdHex = "", r.prototype.driverAttestationHash = "", r.prototype.enclaveInfo = $util.emptyArray, r.create = function(e) {
      return new r(e);
    }, r.encode = function(e, n) {
      if (n || (n = $Writer.create()), e.id != null && Object.hasOwnProperty.call(e, "id") && n.uint32(
        /* id 1, wireType 2 =*/
        10
      ).string(e.id), e.dcrIdHex != null && Object.hasOwnProperty.call(e, "dcrIdHex") && n.uint32(
        /* id 2, wireType 2 =*/
        18
      ).string(e.dcrIdHex), e.driverAttestationHash != null && Object.hasOwnProperty.call(e, "driverAttestationHash") && n.uint32(
        /* id 3, wireType 2 =*/
        26
      ).string(e.driverAttestationHash), e.enclaveInfo != null && e.enclaveInfo.length)
        for (let o = 0; o < e.enclaveInfo.length; ++o)
          $root.metering.EnclaveInfo.encode(e.enclaveInfo[o], n.uint32(
            /* id 6, wireType 2 =*/
            50
          ).fork()).ldelim();
      return n;
    }, r.encodeDelimited = function(e, n) {
      return this.encode(e, n).ldelim();
    }, r.decode = function(e, n) {
      e instanceof $Reader || (e = $Reader.create(e));
      let o = n === void 0 ? e.len : e.pos + n, c = new $root.metering.CreateDcrCommitRequest();
      for (; e.pos < o; ) {
        let l = e.uint32();
        switch (l >>> 3) {
          case 1: {
            c.id = e.string();
            break;
          }
          case 2: {
            c.dcrIdHex = e.string();
            break;
          }
          case 3: {
            c.driverAttestationHash = e.string();
            break;
          }
          case 6: {
            c.enclaveInfo && c.enclaveInfo.length || (c.enclaveInfo = []), c.enclaveInfo.push($root.metering.EnclaveInfo.decode(e, e.uint32()));
            break;
          }
          default:
            e.skipType(l & 7);
            break;
        }
      }
      return c;
    }, r.decodeDelimited = function(e) {
      return e instanceof $Reader || (e = new $Reader(e)), this.decode(e, e.uint32());
    }, r.verify = function(e) {
      if (typeof e != "object" || e === null)
        return "object expected";
      if (e.id != null && e.hasOwnProperty("id") && !$util.isString(e.id))
        return "id: string expected";
      if (e.dcrIdHex != null && e.hasOwnProperty("dcrIdHex") && !$util.isString(e.dcrIdHex))
        return "dcrIdHex: string expected";
      if (e.driverAttestationHash != null && e.hasOwnProperty("driverAttestationHash") && !$util.isString(e.driverAttestationHash))
        return "driverAttestationHash: string expected";
      if (e.enclaveInfo != null && e.hasOwnProperty("enclaveInfo")) {
        if (!Array.isArray(e.enclaveInfo))
          return "enclaveInfo: array expected";
        for (let n = 0; n < e.enclaveInfo.length; ++n) {
          let o = $root.metering.EnclaveInfo.verify(e.enclaveInfo[n]);
          if (o)
            return "enclaveInfo." + o;
        }
      }
      return null;
    }, r.fromObject = function(e) {
      if (e instanceof $root.metering.CreateDcrCommitRequest)
        return e;
      let n = new $root.metering.CreateDcrCommitRequest();
      if (e.id != null && (n.id = String(e.id)), e.dcrIdHex != null && (n.dcrIdHex = String(e.dcrIdHex)), e.driverAttestationHash != null && (n.driverAttestationHash = String(e.driverAttestationHash)), e.enclaveInfo) {
        if (!Array.isArray(e.enclaveInfo))
          throw TypeError(".metering.CreateDcrCommitRequest.enclaveInfo: array expected");
        n.enclaveInfo = [];
        for (let o = 0; o < e.enclaveInfo.length; ++o) {
          if (typeof e.enclaveInfo[o] != "object")
            throw TypeError(".metering.CreateDcrCommitRequest.enclaveInfo: object expected");
          n.enclaveInfo[o] = $root.metering.EnclaveInfo.fromObject(e.enclaveInfo[o]);
        }
      }
      return n;
    }, r.toObject = function(e, n) {
      n || (n = {});
      let o = {};
      if ((n.arrays || n.defaults) && (o.enclaveInfo = []), n.defaults && (o.id = "", o.dcrIdHex = "", o.driverAttestationHash = ""), e.id != null && e.hasOwnProperty("id") && (o.id = e.id), e.dcrIdHex != null && e.hasOwnProperty("dcrIdHex") && (o.dcrIdHex = e.dcrIdHex), e.driverAttestationHash != null && e.hasOwnProperty("driverAttestationHash") && (o.driverAttestationHash = e.driverAttestationHash), e.enclaveInfo && e.enclaveInfo.length) {
        o.enclaveInfo = [];
        for (let c = 0; c < e.enclaveInfo.length; ++c)
          o.enclaveInfo[c] = $root.metering.EnclaveInfo.toObject(e.enclaveInfo[c], n);
      }
      return o;
    }, r.prototype.toJSON = function() {
      return this.constructor.toObject(this, minimal.util.toJSONOptions);
    }, r.getTypeUrl = function(e) {
      return e === void 0 && (e = "type.googleapis.com"), e + "/metering.CreateDcrCommitRequest";
    }, r;
  }(), u.MergeDcrCommitRequest = function() {
    function r(a) {
      if (this.enclaveInfo = [], a)
        for (let e = Object.keys(a), n = 0; n < e.length; ++n)
          a[e[n]] != null && (this[e[n]] = a[e[n]]);
    }
    return r.prototype.id = "", r.prototype.dcrIdHex = "", r.prototype.driverAttestationHash = "", r.prototype.enclaveInfo = $util.emptyArray, r.create = function(e) {
      return new r(e);
    }, r.encode = function(e, n) {
      if (n || (n = $Writer.create()), e.id != null && Object.hasOwnProperty.call(e, "id") && n.uint32(
        /* id 1, wireType 2 =*/
        10
      ).string(e.id), e.dcrIdHex != null && Object.hasOwnProperty.call(e, "dcrIdHex") && n.uint32(
        /* id 2, wireType 2 =*/
        18
      ).string(e.dcrIdHex), e.driverAttestationHash != null && Object.hasOwnProperty.call(e, "driverAttestationHash") && n.uint32(
        /* id 3, wireType 2 =*/
        26
      ).string(e.driverAttestationHash), e.enclaveInfo != null && e.enclaveInfo.length)
        for (let o = 0; o < e.enclaveInfo.length; ++o)
          $root.metering.EnclaveInfo.encode(e.enclaveInfo[o], n.uint32(
            /* id 6, wireType 2 =*/
            50
          ).fork()).ldelim();
      return n;
    }, r.encodeDelimited = function(e, n) {
      return this.encode(e, n).ldelim();
    }, r.decode = function(e, n) {
      e instanceof $Reader || (e = $Reader.create(e));
      let o = n === void 0 ? e.len : e.pos + n, c = new $root.metering.MergeDcrCommitRequest();
      for (; e.pos < o; ) {
        let l = e.uint32();
        switch (l >>> 3) {
          case 1: {
            c.id = e.string();
            break;
          }
          case 2: {
            c.dcrIdHex = e.string();
            break;
          }
          case 3: {
            c.driverAttestationHash = e.string();
            break;
          }
          case 6: {
            c.enclaveInfo && c.enclaveInfo.length || (c.enclaveInfo = []), c.enclaveInfo.push($root.metering.EnclaveInfo.decode(e, e.uint32()));
            break;
          }
          default:
            e.skipType(l & 7);
            break;
        }
      }
      return c;
    }, r.decodeDelimited = function(e) {
      return e instanceof $Reader || (e = new $Reader(e)), this.decode(e, e.uint32());
    }, r.verify = function(e) {
      if (typeof e != "object" || e === null)
        return "object expected";
      if (e.id != null && e.hasOwnProperty("id") && !$util.isString(e.id))
        return "id: string expected";
      if (e.dcrIdHex != null && e.hasOwnProperty("dcrIdHex") && !$util.isString(e.dcrIdHex))
        return "dcrIdHex: string expected";
      if (e.driverAttestationHash != null && e.hasOwnProperty("driverAttestationHash") && !$util.isString(e.driverAttestationHash))
        return "driverAttestationHash: string expected";
      if (e.enclaveInfo != null && e.hasOwnProperty("enclaveInfo")) {
        if (!Array.isArray(e.enclaveInfo))
          return "enclaveInfo: array expected";
        for (let n = 0; n < e.enclaveInfo.length; ++n) {
          let o = $root.metering.EnclaveInfo.verify(e.enclaveInfo[n]);
          if (o)
            return "enclaveInfo." + o;
        }
      }
      return null;
    }, r.fromObject = function(e) {
      if (e instanceof $root.metering.MergeDcrCommitRequest)
        return e;
      let n = new $root.metering.MergeDcrCommitRequest();
      if (e.id != null && (n.id = String(e.id)), e.dcrIdHex != null && (n.dcrIdHex = String(e.dcrIdHex)), e.driverAttestationHash != null && (n.driverAttestationHash = String(e.driverAttestationHash)), e.enclaveInfo) {
        if (!Array.isArray(e.enclaveInfo))
          throw TypeError(".metering.MergeDcrCommitRequest.enclaveInfo: array expected");
        n.enclaveInfo = [];
        for (let o = 0; o < e.enclaveInfo.length; ++o) {
          if (typeof e.enclaveInfo[o] != "object")
            throw TypeError(".metering.MergeDcrCommitRequest.enclaveInfo: object expected");
          n.enclaveInfo[o] = $root.metering.EnclaveInfo.fromObject(e.enclaveInfo[o]);
        }
      }
      return n;
    }, r.toObject = function(e, n) {
      n || (n = {});
      let o = {};
      if ((n.arrays || n.defaults) && (o.enclaveInfo = []), n.defaults && (o.id = "", o.dcrIdHex = "", o.driverAttestationHash = ""), e.id != null && e.hasOwnProperty("id") && (o.id = e.id), e.dcrIdHex != null && e.hasOwnProperty("dcrIdHex") && (o.dcrIdHex = e.dcrIdHex), e.driverAttestationHash != null && e.hasOwnProperty("driverAttestationHash") && (o.driverAttestationHash = e.driverAttestationHash), e.enclaveInfo && e.enclaveInfo.length) {
        o.enclaveInfo = [];
        for (let c = 0; c < e.enclaveInfo.length; ++c)
          o.enclaveInfo[c] = $root.metering.EnclaveInfo.toObject(e.enclaveInfo[c], n);
      }
      return o;
    }, r.prototype.toJSON = function() {
      return this.constructor.toObject(this, minimal.util.toJSONOptions);
    }, r.getTypeUrl = function(e) {
      return e === void 0 && (e = "type.googleapis.com"), e + "/metering.MergeDcrCommitRequest";
    }, r;
  }(), u.CreateDcrResponse = function() {
    function r(a) {
      if (a)
        for (let e = Object.keys(a), n = 0; n < e.length; ++n)
          a[e[n]] != null && (this[e[n]] = a[e[n]]);
    }
    return r.create = function(e) {
      return new r(e);
    }, r.encode = function(e, n) {
      return n || (n = $Writer.create()), n;
    }, r.encodeDelimited = function(e, n) {
      return this.encode(e, n).ldelim();
    }, r.decode = function(e, n) {
      e instanceof $Reader || (e = $Reader.create(e));
      let o = n === void 0 ? e.len : e.pos + n, c = new $root.metering.CreateDcrResponse();
      for (; e.pos < o; ) {
        let l = e.uint32();
        switch (l >>> 3) {
          default:
            e.skipType(l & 7);
            break;
        }
      }
      return c;
    }, r.decodeDelimited = function(e) {
      return e instanceof $Reader || (e = new $Reader(e)), this.decode(e, e.uint32());
    }, r.verify = function(e) {
      return typeof e != "object" || e === null ? "object expected" : null;
    }, r.fromObject = function(e) {
      return e instanceof $root.metering.CreateDcrResponse ? e : new $root.metering.CreateDcrResponse();
    }, r.toObject = function() {
      return {};
    }, r.prototype.toJSON = function() {
      return this.constructor.toObject(this, minimal.util.toJSONOptions);
    }, r.getTypeUrl = function(e) {
      return e === void 0 && (e = "type.googleapis.com"), e + "/metering.CreateDcrResponse";
    }, r;
  }(), u.GetOrCreateDatasetScopeResponse = function() {
    function r(a) {
      if (a)
        for (let e = Object.keys(a), n = 0; n < e.length; ++n)
          a[e[n]] != null && (this[e[n]] = a[e[n]]);
    }
    return r.prototype.id = "", r.create = function(e) {
      return new r(e);
    }, r.encode = function(e, n) {
      return n || (n = $Writer.create()), e.id != null && Object.hasOwnProperty.call(e, "id") && n.uint32(
        /* id 1, wireType 2 =*/
        10
      ).string(e.id), n;
    }, r.encodeDelimited = function(e, n) {
      return this.encode(e, n).ldelim();
    }, r.decode = function(e, n) {
      e instanceof $Reader || (e = $Reader.create(e));
      let o = n === void 0 ? e.len : e.pos + n, c = new $root.metering.GetOrCreateDatasetScopeResponse();
      for (; e.pos < o; ) {
        let l = e.uint32();
        switch (l >>> 3) {
          case 1: {
            c.id = e.string();
            break;
          }
          default:
            e.skipType(l & 7);
            break;
        }
      }
      return c;
    }, r.decodeDelimited = function(e) {
      return e instanceof $Reader || (e = new $Reader(e)), this.decode(e, e.uint32());
    }, r.verify = function(e) {
      return typeof e != "object" || e === null ? "object expected" : e.id != null && e.hasOwnProperty("id") && !$util.isString(e.id) ? "id: string expected" : null;
    }, r.fromObject = function(e) {
      if (e instanceof $root.metering.GetOrCreateDatasetScopeResponse)
        return e;
      let n = new $root.metering.GetOrCreateDatasetScopeResponse();
      return e.id != null && (n.id = String(e.id)), n;
    }, r.toObject = function(e, n) {
      n || (n = {});
      let o = {};
      return n.defaults && (o.id = ""), e.id != null && e.hasOwnProperty("id") && (o.id = e.id), o;
    }, r.prototype.toJSON = function() {
      return this.constructor.toObject(this, minimal.util.toJSONOptions);
    }, r.getTypeUrl = function(e) {
      return e === void 0 && (e = "type.googleapis.com"), e + "/metering.GetOrCreateDatasetScopeResponse";
    }, r;
  }(), u.GetOrCreateDcrDataScopeResponse = function() {
    function r(a) {
      if (a)
        for (let e = Object.keys(a), n = 0; n < e.length; ++n)
          a[e[n]] != null && (this[e[n]] = a[e[n]]);
    }
    return r.prototype.id = "", r.create = function(e) {
      return new r(e);
    }, r.encode = function(e, n) {
      return n || (n = $Writer.create()), e.id != null && Object.hasOwnProperty.call(e, "id") && n.uint32(
        /* id 1, wireType 2 =*/
        10
      ).string(e.id), n;
    }, r.encodeDelimited = function(e, n) {
      return this.encode(e, n).ldelim();
    }, r.decode = function(e, n) {
      e instanceof $Reader || (e = $Reader.create(e));
      let o = n === void 0 ? e.len : e.pos + n, c = new $root.metering.GetOrCreateDcrDataScopeResponse();
      for (; e.pos < o; ) {
        let l = e.uint32();
        switch (l >>> 3) {
          case 1: {
            c.id = e.string();
            break;
          }
          default:
            e.skipType(l & 7);
            break;
        }
      }
      return c;
    }, r.decodeDelimited = function(e) {
      return e instanceof $Reader || (e = new $Reader(e)), this.decode(e, e.uint32());
    }, r.verify = function(e) {
      return typeof e != "object" || e === null ? "object expected" : e.id != null && e.hasOwnProperty("id") && !$util.isString(e.id) ? "id: string expected" : null;
    }, r.fromObject = function(e) {
      if (e instanceof $root.metering.GetOrCreateDcrDataScopeResponse)
        return e;
      let n = new $root.metering.GetOrCreateDcrDataScopeResponse();
      return e.id != null && (n.id = String(e.id)), n;
    }, r.toObject = function(e, n) {
      n || (n = {});
      let o = {};
      return n.defaults && (o.id = ""), e.id != null && e.hasOwnProperty("id") && (o.id = e.id), o;
    }, r.prototype.toJSON = function() {
      return this.constructor.toObject(this, minimal.util.toJSONOptions);
    }, r.getTypeUrl = function(e) {
      return e === void 0 && (e = "type.googleapis.com"), e + "/metering.GetOrCreateDcrDataScopeResponse";
    }, r;
  }(), u.DcrInteractionResponse = function() {
    function r(a) {
      if (a)
        for (let e = Object.keys(a), n = 0; n < e.length; ++n)
          a[e[n]] != null && (this[e[n]] = a[e[n]]);
    }
    return r.create = function(e) {
      return new r(e);
    }, r.encode = function(e, n) {
      return n || (n = $Writer.create()), n;
    }, r.encodeDelimited = function(e, n) {
      return this.encode(e, n).ldelim();
    }, r.decode = function(e, n) {
      e instanceof $Reader || (e = $Reader.create(e));
      let o = n === void 0 ? e.len : e.pos + n, c = new $root.metering.DcrInteractionResponse();
      for (; e.pos < o; ) {
        let l = e.uint32();
        switch (l >>> 3) {
          default:
            e.skipType(l & 7);
            break;
        }
      }
      return c;
    }, r.decodeDelimited = function(e) {
      return e instanceof $Reader || (e = new $Reader(e)), this.decode(e, e.uint32());
    }, r.verify = function(e) {
      return typeof e != "object" || e === null ? "object expected" : null;
    }, r.fromObject = function(e) {
      return e instanceof $root.metering.DcrInteractionResponse ? e : new $root.metering.DcrInteractionResponse();
    }, r.toObject = function() {
      return {};
    }, r.prototype.toJSON = function() {
      return this.constructor.toObject(this, minimal.util.toJSONOptions);
    }, r.getTypeUrl = function(e) {
      return e === void 0 && (e = "type.googleapis.com"), e + "/metering.DcrInteractionResponse";
    }, r;
  }(), u.CreateDcrCommitResponse = function() {
    function r(a) {
      if (a)
        for (let e = Object.keys(a), n = 0; n < e.length; ++n)
          a[e[n]] != null && (this[e[n]] = a[e[n]]);
    }
    return r.create = function(e) {
      return new r(e);
    }, r.encode = function(e, n) {
      return n || (n = $Writer.create()), n;
    }, r.encodeDelimited = function(e, n) {
      return this.encode(e, n).ldelim();
    }, r.decode = function(e, n) {
      e instanceof $Reader || (e = $Reader.create(e));
      let o = n === void 0 ? e.len : e.pos + n, c = new $root.metering.CreateDcrCommitResponse();
      for (; e.pos < o; ) {
        let l = e.uint32();
        switch (l >>> 3) {
          default:
            e.skipType(l & 7);
            break;
        }
      }
      return c;
    }, r.decodeDelimited = function(e) {
      return e instanceof $Reader || (e = new $Reader(e)), this.decode(e, e.uint32());
    }, r.verify = function(e) {
      return typeof e != "object" || e === null ? "object expected" : null;
    }, r.fromObject = function(e) {
      return e instanceof $root.metering.CreateDcrCommitResponse ? e : new $root.metering.CreateDcrCommitResponse();
    }, r.toObject = function() {
      return {};
    }, r.prototype.toJSON = function() {
      return this.constructor.toObject(this, minimal.util.toJSONOptions);
    }, r.getTypeUrl = function(e) {
      return e === void 0 && (e = "type.googleapis.com"), e + "/metering.CreateDcrCommitResponse";
    }, r;
  }(), u.MergeDcrCommitResponse = function() {
    function r(a) {
      if (a)
        for (let e = Object.keys(a), n = 0; n < e.length; ++n)
          a[e[n]] != null && (this[e[n]] = a[e[n]]);
    }
    return r.create = function(e) {
      return new r(e);
    }, r.encode = function(e, n) {
      return n || (n = $Writer.create()), n;
    }, r.encodeDelimited = function(e, n) {
      return this.encode(e, n).ldelim();
    }, r.decode = function(e, n) {
      e instanceof $Reader || (e = $Reader.create(e));
      let o = n === void 0 ? e.len : e.pos + n, c = new $root.metering.MergeDcrCommitResponse();
      for (; e.pos < o; ) {
        let l = e.uint32();
        switch (l >>> 3) {
          default:
            e.skipType(l & 7);
            break;
        }
      }
      return c;
    }, r.decodeDelimited = function(e) {
      return e instanceof $Reader || (e = new $Reader(e)), this.decode(e, e.uint32());
    }, r.verify = function(e) {
      return typeof e != "object" || e === null ? "object expected" : null;
    }, r.fromObject = function(e) {
      return e instanceof $root.metering.MergeDcrCommitResponse ? e : new $root.metering.MergeDcrCommitResponse();
    }, r.toObject = function() {
      return {};
    }, r.prototype.toJSON = function() {
      return this.constructor.toObject(this, minimal.util.toJSONOptions);
    }, r.getTypeUrl = function(e) {
      return e === void 0 && (e = "type.googleapis.com"), e + "/metering.MergeDcrCommitResponse";
    }, r;
  }(), u.StopDcrResponse = function() {
    function r(a) {
      if (a)
        for (let e = Object.keys(a), n = 0; n < e.length; ++n)
          a[e[n]] != null && (this[e[n]] = a[e[n]]);
    }
    return r.create = function(e) {
      return new r(e);
    }, r.encode = function(e, n) {
      return n || (n = $Writer.create()), n;
    }, r.encodeDelimited = function(e, n) {
      return this.encode(e, n).ldelim();
    }, r.decode = function(e, n) {
      e instanceof $Reader || (e = $Reader.create(e));
      let o = n === void 0 ? e.len : e.pos + n, c = new $root.metering.StopDcrResponse();
      for (; e.pos < o; ) {
        let l = e.uint32();
        switch (l >>> 3) {
          default:
            e.skipType(l & 7);
            break;
        }
      }
      return c;
    }, r.decodeDelimited = function(e) {
      return e instanceof $Reader || (e = new $Reader(e)), this.decode(e, e.uint32());
    }, r.verify = function(e) {
      return typeof e != "object" || e === null ? "object expected" : null;
    }, r.fromObject = function(e) {
      return e instanceof $root.metering.StopDcrResponse ? e : new $root.metering.StopDcrResponse();
    }, r.toObject = function() {
      return {};
    }, r.prototype.toJSON = function() {
      return this.constructor.toObject(this, minimal.util.toJSONOptions);
    }, r.getTypeUrl = function(e) {
      return e === void 0 && (e = "type.googleapis.com"), e + "/metering.StopDcrResponse";
    }, r;
  }(), u.PublishDatasetResponse = function() {
    function r(a) {
      if (a)
        for (let e = Object.keys(a), n = 0; n < e.length; ++n)
          a[e[n]] != null && (this[e[n]] = a[e[n]]);
    }
    return r.create = function(e) {
      return new r(e);
    }, r.encode = function(e, n) {
      return n || (n = $Writer.create()), n;
    }, r.encodeDelimited = function(e, n) {
      return this.encode(e, n).ldelim();
    }, r.decode = function(e, n) {
      e instanceof $Reader || (e = $Reader.create(e));
      let o = n === void 0 ? e.len : e.pos + n, c = new $root.metering.PublishDatasetResponse();
      for (; e.pos < o; ) {
        let l = e.uint32();
        switch (l >>> 3) {
          default:
            e.skipType(l & 7);
            break;
        }
      }
      return c;
    }, r.decodeDelimited = function(e) {
      return e instanceof $Reader || (e = new $Reader(e)), this.decode(e, e.uint32());
    }, r.verify = function(e) {
      return typeof e != "object" || e === null ? "object expected" : null;
    }, r.fromObject = function(e) {
      return e instanceof $root.metering.PublishDatasetResponse ? e : new $root.metering.PublishDatasetResponse();
    }, r.toObject = function() {
      return {};
    }, r.prototype.toJSON = function() {
      return this.constructor.toObject(this, minimal.util.toJSONOptions);
    }, r.getTypeUrl = function(e) {
      return e === void 0 && (e = "type.googleapis.com"), e + "/metering.PublishDatasetResponse";
    }, r;
  }(), u.CreateDatasetResponse = function() {
    function r(a) {
      if (a)
        for (let e = Object.keys(a), n = 0; n < e.length; ++n)
          a[e[n]] != null && (this[e[n]] = a[e[n]]);
    }
    return r.prototype.id = "", r.create = function(e) {
      return new r(e);
    }, r.encode = function(e, n) {
      return n || (n = $Writer.create()), e.id != null && Object.hasOwnProperty.call(e, "id") && n.uint32(
        /* id 1, wireType 2 =*/
        10
      ).string(e.id), n;
    }, r.encodeDelimited = function(e, n) {
      return this.encode(e, n).ldelim();
    }, r.decode = function(e, n) {
      e instanceof $Reader || (e = $Reader.create(e));
      let o = n === void 0 ? e.len : e.pos + n, c = new $root.metering.CreateDatasetResponse();
      for (; e.pos < o; ) {
        let l = e.uint32();
        switch (l >>> 3) {
          case 1: {
            c.id = e.string();
            break;
          }
          default:
            e.skipType(l & 7);
            break;
        }
      }
      return c;
    }, r.decodeDelimited = function(e) {
      return e instanceof $Reader || (e = new $Reader(e)), this.decode(e, e.uint32());
    }, r.verify = function(e) {
      return typeof e != "object" || e === null ? "object expected" : e.id != null && e.hasOwnProperty("id") && !$util.isString(e.id) ? "id: string expected" : null;
    }, r.fromObject = function(e) {
      if (e instanceof $root.metering.CreateDatasetResponse)
        return e;
      let n = new $root.metering.CreateDatasetResponse();
      return e.id != null && (n.id = String(e.id)), n;
    }, r.toObject = function(e, n) {
      n || (n = {});
      let o = {};
      return n.defaults && (o.id = ""), e.id != null && e.hasOwnProperty("id") && (o.id = e.id), o;
    }, r.prototype.toJSON = function() {
      return this.constructor.toObject(this, minimal.util.toJSONOptions);
    }, r.getTypeUrl = function(e) {
      return e === void 0 && (e = "type.googleapis.com"), e + "/metering.CreateDatasetResponse";
    }, r;
  }(), u.UnpublishDatasetResponse = function() {
    function r(a) {
      if (a)
        for (let e = Object.keys(a), n = 0; n < e.length; ++n)
          a[e[n]] != null && (this[e[n]] = a[e[n]]);
    }
    return r.create = function(e) {
      return new r(e);
    }, r.encode = function(e, n) {
      return n || (n = $Writer.create()), n;
    }, r.encodeDelimited = function(e, n) {
      return this.encode(e, n).ldelim();
    }, r.decode = function(e, n) {
      e instanceof $Reader || (e = $Reader.create(e));
      let o = n === void 0 ? e.len : e.pos + n, c = new $root.metering.UnpublishDatasetResponse();
      for (; e.pos < o; ) {
        let l = e.uint32();
        switch (l >>> 3) {
          default:
            e.skipType(l & 7);
            break;
        }
      }
      return c;
    }, r.decodeDelimited = function(e) {
      return e instanceof $Reader || (e = new $Reader(e)), this.decode(e, e.uint32());
    }, r.verify = function(e) {
      return typeof e != "object" || e === null ? "object expected" : null;
    }, r.fromObject = function(e) {
      return e instanceof $root.metering.UnpublishDatasetResponse ? e : new $root.metering.UnpublishDatasetResponse();
    }, r.toObject = function() {
      return {};
    }, r.prototype.toJSON = function() {
      return this.constructor.toObject(this, minimal.util.toJSONOptions);
    }, r.getTypeUrl = function(e) {
      return e === void 0 && (e = "type.googleapis.com"), e + "/metering.UnpublishDatasetResponse";
    }, r;
  }(), u.WorkerMetadataRequest = function() {
    function r(a) {
      if (a)
        for (let e = Object.keys(a), n = 0; n < e.length; ++n)
          a[e[n]] != null && (this[e[n]] = a[e[n]]);
    }
    return r.prototype.attestationSpec = null, r.prototype.scopeId = "", r.create = function(e) {
      return new r(e);
    }, r.encode = function(e, n) {
      return n || (n = $Writer.create()), e.attestationSpec != null && Object.hasOwnProperty.call(e, "attestationSpec") && $root.attestation.AttestationSpecification.encode(e.attestationSpec, n.uint32(
        /* id 1, wireType 2 =*/
        10
      ).fork()).ldelim(), e.scopeId != null && Object.hasOwnProperty.call(e, "scopeId") && n.uint32(
        /* id 2, wireType 2 =*/
        18
      ).string(e.scopeId), n;
    }, r.encodeDelimited = function(e, n) {
      return this.encode(e, n).ldelim();
    }, r.decode = function(e, n) {
      e instanceof $Reader || (e = $Reader.create(e));
      let o = n === void 0 ? e.len : e.pos + n, c = new $root.metering.WorkerMetadataRequest();
      for (; e.pos < o; ) {
        let l = e.uint32();
        switch (l >>> 3) {
          case 1: {
            c.attestationSpec = $root.attestation.AttestationSpecification.decode(e, e.uint32());
            break;
          }
          case 2: {
            c.scopeId = e.string();
            break;
          }
          default:
            e.skipType(l & 7);
            break;
        }
      }
      return c;
    }, r.decodeDelimited = function(e) {
      return e instanceof $Reader || (e = new $Reader(e)), this.decode(e, e.uint32());
    }, r.verify = function(e) {
      if (typeof e != "object" || e === null)
        return "object expected";
      if (e.attestationSpec != null && e.hasOwnProperty("attestationSpec")) {
        let n = $root.attestation.AttestationSpecification.verify(e.attestationSpec);
        if (n)
          return "attestationSpec." + n;
      }
      return e.scopeId != null && e.hasOwnProperty("scopeId") && !$util.isString(e.scopeId) ? "scopeId: string expected" : null;
    }, r.fromObject = function(e) {
      if (e instanceof $root.metering.WorkerMetadataRequest)
        return e;
      let n = new $root.metering.WorkerMetadataRequest();
      if (e.attestationSpec != null) {
        if (typeof e.attestationSpec != "object")
          throw TypeError(".metering.WorkerMetadataRequest.attestationSpec: object expected");
        n.attestationSpec = $root.attestation.AttestationSpecification.fromObject(e.attestationSpec);
      }
      return e.scopeId != null && (n.scopeId = String(e.scopeId)), n;
    }, r.toObject = function(e, n) {
      n || (n = {});
      let o = {};
      return n.defaults && (o.attestationSpec = null, o.scopeId = ""), e.attestationSpec != null && e.hasOwnProperty("attestationSpec") && (o.attestationSpec = $root.attestation.AttestationSpecification.toObject(e.attestationSpec, n)), e.scopeId != null && e.hasOwnProperty("scopeId") && (o.scopeId = e.scopeId), o;
    }, r.prototype.toJSON = function() {
      return this.constructor.toObject(this, minimal.util.toJSONOptions);
    }, r.getTypeUrl = function(e) {
      return e === void 0 && (e = "type.googleapis.com"), e + "/metering.WorkerMetadataRequest";
    }, r;
  }(), u.WorkerMetadataResponse = function() {
    function r(a) {
      if (a)
        for (let e = Object.keys(a), n = 0; n < e.length; ++n)
          a[e[n]] != null && (this[e[n]] = a[e[n]]);
    }
    return r.prototype.maxExecutionSeconds = $util.Long ? $util.Long.fromBits(0, 0, !0) : 0, r.create = function(e) {
      return new r(e);
    }, r.encode = function(e, n) {
      return n || (n = $Writer.create()), e.maxExecutionSeconds != null && Object.hasOwnProperty.call(e, "maxExecutionSeconds") && n.uint32(
        /* id 1, wireType 0 =*/
        8
      ).uint64(e.maxExecutionSeconds), n;
    }, r.encodeDelimited = function(e, n) {
      return this.encode(e, n).ldelim();
    }, r.decode = function(e, n) {
      e instanceof $Reader || (e = $Reader.create(e));
      let o = n === void 0 ? e.len : e.pos + n, c = new $root.metering.WorkerMetadataResponse();
      for (; e.pos < o; ) {
        let l = e.uint32();
        switch (l >>> 3) {
          case 1: {
            c.maxExecutionSeconds = e.uint64();
            break;
          }
          default:
            e.skipType(l & 7);
            break;
        }
      }
      return c;
    }, r.decodeDelimited = function(e) {
      return e instanceof $Reader || (e = new $Reader(e)), this.decode(e, e.uint32());
    }, r.verify = function(e) {
      return typeof e != "object" || e === null ? "object expected" : e.maxExecutionSeconds != null && e.hasOwnProperty("maxExecutionSeconds") && !$util.isInteger(e.maxExecutionSeconds) && !(e.maxExecutionSeconds && $util.isInteger(e.maxExecutionSeconds.low) && $util.isInteger(e.maxExecutionSeconds.high)) ? "maxExecutionSeconds: integer|Long expected" : null;
    }, r.fromObject = function(e) {
      if (e instanceof $root.metering.WorkerMetadataResponse)
        return e;
      let n = new $root.metering.WorkerMetadataResponse();
      return e.maxExecutionSeconds != null && ($util.Long ? (n.maxExecutionSeconds = $util.Long.fromValue(e.maxExecutionSeconds)).unsigned = !0 : typeof e.maxExecutionSeconds == "string" ? n.maxExecutionSeconds = parseInt(e.maxExecutionSeconds, 10) : typeof e.maxExecutionSeconds == "number" ? n.maxExecutionSeconds = e.maxExecutionSeconds : typeof e.maxExecutionSeconds == "object" && (n.maxExecutionSeconds = new $util.LongBits(e.maxExecutionSeconds.low >>> 0, e.maxExecutionSeconds.high >>> 0).toNumber(!0))), n;
    }, r.toObject = function(e, n) {
      n || (n = {});
      let o = {};
      if (n.defaults)
        if ($util.Long) {
          let c = new $util.Long(0, 0, !0);
          o.maxExecutionSeconds = n.longs === String ? c.toString() : n.longs === Number ? c.toNumber() : c;
        } else
          o.maxExecutionSeconds = n.longs === String ? "0" : 0;
      return e.maxExecutionSeconds != null && e.hasOwnProperty("maxExecutionSeconds") && (typeof e.maxExecutionSeconds == "number" ? o.maxExecutionSeconds = n.longs === String ? String(e.maxExecutionSeconds) : e.maxExecutionSeconds : o.maxExecutionSeconds = n.longs === String ? $util.Long.prototype.toString.call(e.maxExecutionSeconds) : n.longs === Number ? new $util.LongBits(e.maxExecutionSeconds.low >>> 0, e.maxExecutionSeconds.high >>> 0).toNumber(!0) : e.maxExecutionSeconds), o;
    }, r.prototype.toJSON = function() {
      return this.constructor.toObject(this, minimal.util.toJSONOptions);
    }, r.getTypeUrl = function(e) {
      return e === void 0 && (e = "type.googleapis.com"), e + "/metering.WorkerMetadataResponse";
    }, r;
  }(), u.SubmitWorkerExecutionTimeRequest = function() {
    function r(a) {
      if (a)
        for (let e = Object.keys(a), n = 0; n < e.length; ++n)
          a[e[n]] != null && (this[e[n]] = a[e[n]]);
    }
    return r.prototype.executionTimeSeconds = 0, r.prototype.attestationSpec = null, r.prototype.scopeId = "", r.create = function(e) {
      return new r(e);
    }, r.encode = function(e, n) {
      return n || (n = $Writer.create()), e.executionTimeSeconds != null && Object.hasOwnProperty.call(e, "executionTimeSeconds") && n.uint32(
        /* id 1, wireType 0 =*/
        8
      ).uint32(e.executionTimeSeconds), e.attestationSpec != null && Object.hasOwnProperty.call(e, "attestationSpec") && $root.attestation.AttestationSpecification.encode(e.attestationSpec, n.uint32(
        /* id 2, wireType 2 =*/
        18
      ).fork()).ldelim(), e.scopeId != null && Object.hasOwnProperty.call(e, "scopeId") && n.uint32(
        /* id 3, wireType 2 =*/
        26
      ).string(e.scopeId), n;
    }, r.encodeDelimited = function(e, n) {
      return this.encode(e, n).ldelim();
    }, r.decode = function(e, n) {
      e instanceof $Reader || (e = $Reader.create(e));
      let o = n === void 0 ? e.len : e.pos + n, c = new $root.metering.SubmitWorkerExecutionTimeRequest();
      for (; e.pos < o; ) {
        let l = e.uint32();
        switch (l >>> 3) {
          case 1: {
            c.executionTimeSeconds = e.uint32();
            break;
          }
          case 2: {
            c.attestationSpec = $root.attestation.AttestationSpecification.decode(e, e.uint32());
            break;
          }
          case 3: {
            c.scopeId = e.string();
            break;
          }
          default:
            e.skipType(l & 7);
            break;
        }
      }
      return c;
    }, r.decodeDelimited = function(e) {
      return e instanceof $Reader || (e = new $Reader(e)), this.decode(e, e.uint32());
    }, r.verify = function(e) {
      if (typeof e != "object" || e === null)
        return "object expected";
      if (e.executionTimeSeconds != null && e.hasOwnProperty("executionTimeSeconds") && !$util.isInteger(e.executionTimeSeconds))
        return "executionTimeSeconds: integer expected";
      if (e.attestationSpec != null && e.hasOwnProperty("attestationSpec")) {
        let n = $root.attestation.AttestationSpecification.verify(e.attestationSpec);
        if (n)
          return "attestationSpec." + n;
      }
      return e.scopeId != null && e.hasOwnProperty("scopeId") && !$util.isString(e.scopeId) ? "scopeId: string expected" : null;
    }, r.fromObject = function(e) {
      if (e instanceof $root.metering.SubmitWorkerExecutionTimeRequest)
        return e;
      let n = new $root.metering.SubmitWorkerExecutionTimeRequest();
      if (e.executionTimeSeconds != null && (n.executionTimeSeconds = e.executionTimeSeconds >>> 0), e.attestationSpec != null) {
        if (typeof e.attestationSpec != "object")
          throw TypeError(".metering.SubmitWorkerExecutionTimeRequest.attestationSpec: object expected");
        n.attestationSpec = $root.attestation.AttestationSpecification.fromObject(e.attestationSpec);
      }
      return e.scopeId != null && (n.scopeId = String(e.scopeId)), n;
    }, r.toObject = function(e, n) {
      n || (n = {});
      let o = {};
      return n.defaults && (o.executionTimeSeconds = 0, o.attestationSpec = null, o.scopeId = ""), e.executionTimeSeconds != null && e.hasOwnProperty("executionTimeSeconds") && (o.executionTimeSeconds = e.executionTimeSeconds), e.attestationSpec != null && e.hasOwnProperty("attestationSpec") && (o.attestationSpec = $root.attestation.AttestationSpecification.toObject(e.attestationSpec, n)), e.scopeId != null && e.hasOwnProperty("scopeId") && (o.scopeId = e.scopeId), o;
    }, r.prototype.toJSON = function() {
      return this.constructor.toObject(this, minimal.util.toJSONOptions);
    }, r.getTypeUrl = function(e) {
      return e === void 0 && (e = "type.googleapis.com"), e + "/metering.SubmitWorkerExecutionTimeRequest";
    }, r;
  }(), u.SubmitWorkerExecutionTimeResponse = function() {
    function r(a) {
      if (a)
        for (let e = Object.keys(a), n = 0; n < e.length; ++n)
          a[e[n]] != null && (this[e[n]] = a[e[n]]);
    }
    return r.create = function(e) {
      return new r(e);
    }, r.encode = function(e, n) {
      return n || (n = $Writer.create()), n;
    }, r.encodeDelimited = function(e, n) {
      return this.encode(e, n).ldelim();
    }, r.decode = function(e, n) {
      e instanceof $Reader || (e = $Reader.create(e));
      let o = n === void 0 ? e.len : e.pos + n, c = new $root.metering.SubmitWorkerExecutionTimeResponse();
      for (; e.pos < o; ) {
        let l = e.uint32();
        switch (l >>> 3) {
          default:
            e.skipType(l & 7);
            break;
        }
      }
      return c;
    }, r.decodeDelimited = function(e) {
      return e instanceof $Reader || (e = new $Reader(e)), this.decode(e, e.uint32());
    }, r.verify = function(e) {
      return typeof e != "object" || e === null ? "object expected" : null;
    }, r.fromObject = function(e) {
      return e instanceof $root.metering.SubmitWorkerExecutionTimeResponse ? e : new $root.metering.SubmitWorkerExecutionTimeResponse();
    }, r.toObject = function() {
      return {};
    }, r.prototype.toJSON = function() {
      return this.constructor.toObject(this, minimal.util.toJSONOptions);
    }, r.getTypeUrl = function(e) {
      return e === void 0 && (e = "type.googleapis.com"), e + "/metering.SubmitWorkerExecutionTimeResponse";
    }, r;
  }(), u.SplickyCredentials = function() {
    function r(a) {
      if (a)
        for (let e = Object.keys(a), n = 0; n < e.length; ++n)
          a[e[n]] != null && (this[e[n]] = a[e[n]]);
    }
    return r.create = function(e) {
      return new r(e);
    }, r.encode = function(e, n) {
      return n || (n = $Writer.create()), n;
    }, r.encodeDelimited = function(e, n) {
      return this.encode(e, n).ldelim();
    }, r.decode = function(e, n) {
      e instanceof $Reader || (e = $Reader.create(e));
      let o = n === void 0 ? e.len : e.pos + n, c = new $root.metering.SplickyCredentials();
      for (; e.pos < o; ) {
        let l = e.uint32();
        switch (l >>> 3) {
          default:
            e.skipType(l & 7);
            break;
        }
      }
      return c;
    }, r.decodeDelimited = function(e) {
      return e instanceof $Reader || (e = new $Reader(e)), this.decode(e, e.uint32());
    }, r.verify = function(e) {
      return typeof e != "object" || e === null ? "object expected" : null;
    }, r.fromObject = function(e) {
      return e instanceof $root.metering.SplickyCredentials ? e : new $root.metering.SplickyCredentials();
    }, r.toObject = function() {
      return {};
    }, r.prototype.toJSON = function() {
      return this.constructor.toObject(this, minimal.util.toJSONOptions);
    }, r.getTypeUrl = function(e) {
      return e === void 0 && (e = "type.googleapis.com"), e + "/metering.SplickyCredentials";
    }, r;
  }(), u.MicrosoftDspMember = function() {
    function r(a) {
      if (a)
        for (let e = Object.keys(a), n = 0; n < e.length; ++n)
          a[e[n]] != null && (this[e[n]] = a[e[n]]);
    }
    return r.prototype.member = "", r.create = function(e) {
      return new r(e);
    }, r.encode = function(e, n) {
      return n || (n = $Writer.create()), e.member != null && Object.hasOwnProperty.call(e, "member") && n.uint32(
        /* id 1, wireType 2 =*/
        10
      ).string(e.member), n;
    }, r.encodeDelimited = function(e, n) {
      return this.encode(e, n).ldelim();
    }, r.decode = function(e, n) {
      e instanceof $Reader || (e = $Reader.create(e));
      let o = n === void 0 ? e.len : e.pos + n, c = new $root.metering.MicrosoftDspMember();
      for (; e.pos < o; ) {
        let l = e.uint32();
        switch (l >>> 3) {
          case 1: {
            c.member = e.string();
            break;
          }
          default:
            e.skipType(l & 7);
            break;
        }
      }
      return c;
    }, r.decodeDelimited = function(e) {
      return e instanceof $Reader || (e = new $Reader(e)), this.decode(e, e.uint32());
    }, r.verify = function(e) {
      return typeof e != "object" || e === null ? "object expected" : e.member != null && e.hasOwnProperty("member") && !$util.isString(e.member) ? "member: string expected" : null;
    }, r.fromObject = function(e) {
      if (e instanceof $root.metering.MicrosoftDspMember)
        return e;
      let n = new $root.metering.MicrosoftDspMember();
      return e.member != null && (n.member = String(e.member)), n;
    }, r.toObject = function(e, n) {
      n || (n = {});
      let o = {};
      return n.defaults && (o.member = ""), e.member != null && e.hasOwnProperty("member") && (o.member = e.member), o;
    }, r.prototype.toJSON = function() {
      return this.constructor.toObject(this, minimal.util.toJSONOptions);
    }, r.getTypeUrl = function(e) {
      return e === void 0 && (e = "type.googleapis.com"), e + "/metering.MicrosoftDspMember";
    }, r;
  }(), u.CredentialsKind = function() {
    function r(e) {
      if (e)
        for (let n = Object.keys(e), o = 0; o < n.length; ++o)
          e[n[o]] != null && (this[n[o]] = e[n[o]]);
    }
    r.prototype.splicky = null, r.prototype.microsoftDspMember = null;
    let a;
    return Object.defineProperty(r.prototype, "credentials", {
      get: $util.oneOfGetter(a = ["splicky", "microsoftDspMember"]),
      set: $util.oneOfSetter(a)
    }), r.create = function(n) {
      return new r(n);
    }, r.encode = function(n, o) {
      return o || (o = $Writer.create()), n.splicky != null && Object.hasOwnProperty.call(n, "splicky") && $root.metering.SplickyCredentials.encode(n.splicky, o.uint32(
        /* id 1, wireType 2 =*/
        10
      ).fork()).ldelim(), n.microsoftDspMember != null && Object.hasOwnProperty.call(n, "microsoftDspMember") && $root.metering.MicrosoftDspMember.encode(n.microsoftDspMember, o.uint32(
        /* id 2, wireType 2 =*/
        18
      ).fork()).ldelim(), o;
    }, r.encodeDelimited = function(n, o) {
      return this.encode(n, o).ldelim();
    }, r.decode = function(n, o) {
      n instanceof $Reader || (n = $Reader.create(n));
      let c = o === void 0 ? n.len : n.pos + o, l = new $root.metering.CredentialsKind();
      for (; n.pos < c; ) {
        let d = n.uint32();
        switch (d >>> 3) {
          case 1: {
            l.splicky = $root.metering.SplickyCredentials.decode(n, n.uint32());
            break;
          }
          case 2: {
            l.microsoftDspMember = $root.metering.MicrosoftDspMember.decode(n, n.uint32());
            break;
          }
          default:
            n.skipType(d & 7);
            break;
        }
      }
      return l;
    }, r.decodeDelimited = function(n) {
      return n instanceof $Reader || (n = new $Reader(n)), this.decode(n, n.uint32());
    }, r.verify = function(n) {
      if (typeof n != "object" || n === null)
        return "object expected";
      let o = {};
      if (n.splicky != null && n.hasOwnProperty("splicky")) {
        o.credentials = 1;
        {
          let c = $root.metering.SplickyCredentials.verify(n.splicky);
          if (c)
            return "splicky." + c;
        }
      }
      if (n.microsoftDspMember != null && n.hasOwnProperty("microsoftDspMember")) {
        if (o.credentials === 1)
          return "credentials: multiple values";
        o.credentials = 1;
        {
          let c = $root.metering.MicrosoftDspMember.verify(n.microsoftDspMember);
          if (c)
            return "microsoftDspMember." + c;
        }
      }
      return null;
    }, r.fromObject = function(n) {
      if (n instanceof $root.metering.CredentialsKind)
        return n;
      let o = new $root.metering.CredentialsKind();
      if (n.splicky != null) {
        if (typeof n.splicky != "object")
          throw TypeError(".metering.CredentialsKind.splicky: object expected");
        o.splicky = $root.metering.SplickyCredentials.fromObject(n.splicky);
      }
      if (n.microsoftDspMember != null) {
        if (typeof n.microsoftDspMember != "object")
          throw TypeError(".metering.CredentialsKind.microsoftDspMember: object expected");
        o.microsoftDspMember = $root.metering.MicrosoftDspMember.fromObject(n.microsoftDspMember);
      }
      return o;
    }, r.toObject = function(n, o) {
      o || (o = {});
      let c = {};
      return n.splicky != null && n.hasOwnProperty("splicky") && (c.splicky = $root.metering.SplickyCredentials.toObject(n.splicky, o), o.oneofs && (c.credentials = "splicky")), n.microsoftDspMember != null && n.hasOwnProperty("microsoftDspMember") && (c.microsoftDspMember = $root.metering.MicrosoftDspMember.toObject(n.microsoftDspMember, o), o.oneofs && (c.credentials = "microsoftDspMember")), c;
    }, r.prototype.toJSON = function() {
      return this.constructor.toObject(this, minimal.util.toJSONOptions);
    }, r.getTypeUrl = function(n) {
      return n === void 0 && (n = "type.googleapis.com"), n + "/metering.CredentialsKind";
    }, r;
  }(), u.GetDataConnectorCredentialsRequest = function() {
    function r(a) {
      if (a)
        for (let e = Object.keys(a), n = 0; n < e.length; ++n)
          a[e[n]] != null && (this[e[n]] = a[e[n]]);
    }
    return r.prototype.kind = null, r.create = function(e) {
      return new r(e);
    }, r.encode = function(e, n) {
      return n || (n = $Writer.create()), e.kind != null && Object.hasOwnProperty.call(e, "kind") && $root.metering.CredentialsKind.encode(e.kind, n.uint32(
        /* id 1, wireType 2 =*/
        10
      ).fork()).ldelim(), n;
    }, r.encodeDelimited = function(e, n) {
      return this.encode(e, n).ldelim();
    }, r.decode = function(e, n) {
      e instanceof $Reader || (e = $Reader.create(e));
      let o = n === void 0 ? e.len : e.pos + n, c = new $root.metering.GetDataConnectorCredentialsRequest();
      for (; e.pos < o; ) {
        let l = e.uint32();
        switch (l >>> 3) {
          case 1: {
            c.kind = $root.metering.CredentialsKind.decode(e, e.uint32());
            break;
          }
          default:
            e.skipType(l & 7);
            break;
        }
      }
      return c;
    }, r.decodeDelimited = function(e) {
      return e instanceof $Reader || (e = new $Reader(e)), this.decode(e, e.uint32());
    }, r.verify = function(e) {
      if (typeof e != "object" || e === null)
        return "object expected";
      if (e.kind != null && e.hasOwnProperty("kind")) {
        let n = $root.metering.CredentialsKind.verify(e.kind);
        if (n)
          return "kind." + n;
      }
      return null;
    }, r.fromObject = function(e) {
      if (e instanceof $root.metering.GetDataConnectorCredentialsRequest)
        return e;
      let n = new $root.metering.GetDataConnectorCredentialsRequest();
      if (e.kind != null) {
        if (typeof e.kind != "object")
          throw TypeError(".metering.GetDataConnectorCredentialsRequest.kind: object expected");
        n.kind = $root.metering.CredentialsKind.fromObject(e.kind);
      }
      return n;
    }, r.toObject = function(e, n) {
      n || (n = {});
      let o = {};
      return n.defaults && (o.kind = null), e.kind != null && e.hasOwnProperty("kind") && (o.kind = $root.metering.CredentialsKind.toObject(e.kind, n)), o;
    }, r.prototype.toJSON = function() {
      return this.constructor.toObject(this, minimal.util.toJSONOptions);
    }, r.getTypeUrl = function(e) {
      return e === void 0 && (e = "type.googleapis.com"), e + "/metering.GetDataConnectorCredentialsRequest";
    }, r;
  }(), u.GetDataConnectorCredentialsResponse = function() {
    function r(a) {
      if (a)
        for (let e = Object.keys(a), n = 0; n < e.length; ++n)
          a[e[n]] != null && (this[e[n]] = a[e[n]]);
    }
    return r.prototype.credentials = "", r.create = function(e) {
      return new r(e);
    }, r.encode = function(e, n) {
      return n || (n = $Writer.create()), e.credentials != null && Object.hasOwnProperty.call(e, "credentials") && n.uint32(
        /* id 1, wireType 2 =*/
        10
      ).string(e.credentials), n;
    }, r.encodeDelimited = function(e, n) {
      return this.encode(e, n).ldelim();
    }, r.decode = function(e, n) {
      e instanceof $Reader || (e = $Reader.create(e));
      let o = n === void 0 ? e.len : e.pos + n, c = new $root.metering.GetDataConnectorCredentialsResponse();
      for (; e.pos < o; ) {
        let l = e.uint32();
        switch (l >>> 3) {
          case 1: {
            c.credentials = e.string();
            break;
          }
          default:
            e.skipType(l & 7);
            break;
        }
      }
      return c;
    }, r.decodeDelimited = function(e) {
      return e instanceof $Reader || (e = new $Reader(e)), this.decode(e, e.uint32());
    }, r.verify = function(e) {
      return typeof e != "object" || e === null ? "object expected" : e.credentials != null && e.hasOwnProperty("credentials") && !$util.isString(e.credentials) ? "credentials: string expected" : null;
    }, r.fromObject = function(e) {
      if (e instanceof $root.metering.GetDataConnectorCredentialsResponse)
        return e;
      let n = new $root.metering.GetDataConnectorCredentialsResponse();
      return e.credentials != null && (n.credentials = String(e.credentials)), n;
    }, r.toObject = function(e, n) {
      n || (n = {});
      let o = {};
      return n.defaults && (o.credentials = ""), e.credentials != null && e.hasOwnProperty("credentials") && (o.credentials = e.credentials), o;
    }, r.prototype.toJSON = function() {
      return this.constructor.toObject(this, minimal.util.toJSONOptions);
    }, r.getTypeUrl = function(e) {
      return e === void 0 && (e = "type.googleapis.com"), e + "/metering.GetDataConnectorCredentialsResponse";
    }, r;
  }(), u.GetAzureCommunicationCredentialsRequest = function() {
    function r(a) {
      if (a)
        for (let e = Object.keys(a), n = 0; n < e.length; ++n)
          a[e[n]] != null && (this[e[n]] = a[e[n]]);
    }
    return r.create = function(e) {
      return new r(e);
    }, r.encode = function(e, n) {
      return n || (n = $Writer.create()), n;
    }, r.encodeDelimited = function(e, n) {
      return this.encode(e, n).ldelim();
    }, r.decode = function(e, n) {
      e instanceof $Reader || (e = $Reader.create(e));
      let o = n === void 0 ? e.len : e.pos + n, c = new $root.metering.GetAzureCommunicationCredentialsRequest();
      for (; e.pos < o; ) {
        let l = e.uint32();
        switch (l >>> 3) {
          default:
            e.skipType(l & 7);
            break;
        }
      }
      return c;
    }, r.decodeDelimited = function(e) {
      return e instanceof $Reader || (e = new $Reader(e)), this.decode(e, e.uint32());
    }, r.verify = function(e) {
      return typeof e != "object" || e === null ? "object expected" : null;
    }, r.fromObject = function(e) {
      return e instanceof $root.metering.GetAzureCommunicationCredentialsRequest ? e : new $root.metering.GetAzureCommunicationCredentialsRequest();
    }, r.toObject = function() {
      return {};
    }, r.prototype.toJSON = function() {
      return this.constructor.toObject(this, minimal.util.toJSONOptions);
    }, r.getTypeUrl = function(e) {
      return e === void 0 && (e = "type.googleapis.com"), e + "/metering.GetAzureCommunicationCredentialsRequest";
    }, r;
  }(), u.GetAzureCommunicationCredentialsResponse = function() {
    function r(a) {
      if (a)
        for (let e = Object.keys(a), n = 0; n < e.length; ++n)
          a[e[n]] != null && (this[e[n]] = a[e[n]]);
    }
    return r.prototype.endpoint = "", r.prototype.accessKey = "", r.prototype.senderEmail = "", r.create = function(e) {
      return new r(e);
    }, r.encode = function(e, n) {
      return n || (n = $Writer.create()), e.endpoint != null && Object.hasOwnProperty.call(e, "endpoint") && n.uint32(
        /* id 1, wireType 2 =*/
        10
      ).string(e.endpoint), e.accessKey != null && Object.hasOwnProperty.call(e, "accessKey") && n.uint32(
        /* id 2, wireType 2 =*/
        18
      ).string(e.accessKey), e.senderEmail != null && Object.hasOwnProperty.call(e, "senderEmail") && n.uint32(
        /* id 3, wireType 2 =*/
        26
      ).string(e.senderEmail), n;
    }, r.encodeDelimited = function(e, n) {
      return this.encode(e, n).ldelim();
    }, r.decode = function(e, n) {
      e instanceof $Reader || (e = $Reader.create(e));
      let o = n === void 0 ? e.len : e.pos + n, c = new $root.metering.GetAzureCommunicationCredentialsResponse();
      for (; e.pos < o; ) {
        let l = e.uint32();
        switch (l >>> 3) {
          case 1: {
            c.endpoint = e.string();
            break;
          }
          case 2: {
            c.accessKey = e.string();
            break;
          }
          case 3: {
            c.senderEmail = e.string();
            break;
          }
          default:
            e.skipType(l & 7);
            break;
        }
      }
      return c;
    }, r.decodeDelimited = function(e) {
      return e instanceof $Reader || (e = new $Reader(e)), this.decode(e, e.uint32());
    }, r.verify = function(e) {
      return typeof e != "object" || e === null ? "object expected" : e.endpoint != null && e.hasOwnProperty("endpoint") && !$util.isString(e.endpoint) ? "endpoint: string expected" : e.accessKey != null && e.hasOwnProperty("accessKey") && !$util.isString(e.accessKey) ? "accessKey: string expected" : e.senderEmail != null && e.hasOwnProperty("senderEmail") && !$util.isString(e.senderEmail) ? "senderEmail: string expected" : null;
    }, r.fromObject = function(e) {
      if (e instanceof $root.metering.GetAzureCommunicationCredentialsResponse)
        return e;
      let n = new $root.metering.GetAzureCommunicationCredentialsResponse();
      return e.endpoint != null && (n.endpoint = String(e.endpoint)), e.accessKey != null && (n.accessKey = String(e.accessKey)), e.senderEmail != null && (n.senderEmail = String(e.senderEmail)), n;
    }, r.toObject = function(e, n) {
      n || (n = {});
      let o = {};
      return n.defaults && (o.endpoint = "", o.accessKey = "", o.senderEmail = ""), e.endpoint != null && e.hasOwnProperty("endpoint") && (o.endpoint = e.endpoint), e.accessKey != null && e.hasOwnProperty("accessKey") && (o.accessKey = e.accessKey), e.senderEmail != null && e.hasOwnProperty("senderEmail") && (o.senderEmail = e.senderEmail), o;
    }, r.prototype.toJSON = function() {
      return this.constructor.toObject(this, minimal.util.toJSONOptions);
    }, r.getTypeUrl = function(e) {
      return e === void 0 && (e = "type.googleapis.com"), e + "/metering.GetAzureCommunicationCredentialsResponse";
    }, r;
  }(), u.RecordDcrInteractionRequest = function() {
    function r(a) {
      if (a)
        for (let e = Object.keys(a), n = 0; n < e.length; ++n)
          a[e[n]] != null && (this[e[n]] = a[e[n]]);
    }
    return r.prototype.dataRoomId = "", r.prototype.interaction = null, r.create = function(e) {
      return new r(e);
    }, r.encode = function(e, n) {
      return n || (n = $Writer.create()), e.dataRoomId != null && Object.hasOwnProperty.call(e, "dataRoomId") && n.uint32(
        /* id 1, wireType 2 =*/
        10
      ).string(e.dataRoomId), e.interaction != null && Object.hasOwnProperty.call(e, "interaction") && $root.metering.DcrInteractionKind.encode(e.interaction, n.uint32(
        /* id 2, wireType 2 =*/
        18
      ).fork()).ldelim(), n;
    }, r.encodeDelimited = function(e, n) {
      return this.encode(e, n).ldelim();
    }, r.decode = function(e, n) {
      e instanceof $Reader || (e = $Reader.create(e));
      let o = n === void 0 ? e.len : e.pos + n, c = new $root.metering.RecordDcrInteractionRequest();
      for (; e.pos < o; ) {
        let l = e.uint32();
        switch (l >>> 3) {
          case 1: {
            c.dataRoomId = e.string();
            break;
          }
          case 2: {
            c.interaction = $root.metering.DcrInteractionKind.decode(e, e.uint32());
            break;
          }
          default:
            e.skipType(l & 7);
            break;
        }
      }
      return c;
    }, r.decodeDelimited = function(e) {
      return e instanceof $Reader || (e = new $Reader(e)), this.decode(e, e.uint32());
    }, r.verify = function(e) {
      if (typeof e != "object" || e === null)
        return "object expected";
      if (e.dataRoomId != null && e.hasOwnProperty("dataRoomId") && !$util.isString(e.dataRoomId))
        return "dataRoomId: string expected";
      if (e.interaction != null && e.hasOwnProperty("interaction")) {
        let n = $root.metering.DcrInteractionKind.verify(e.interaction);
        if (n)
          return "interaction." + n;
      }
      return null;
    }, r.fromObject = function(e) {
      if (e instanceof $root.metering.RecordDcrInteractionRequest)
        return e;
      let n = new $root.metering.RecordDcrInteractionRequest();
      if (e.dataRoomId != null && (n.dataRoomId = String(e.dataRoomId)), e.interaction != null) {
        if (typeof e.interaction != "object")
          throw TypeError(".metering.RecordDcrInteractionRequest.interaction: object expected");
        n.interaction = $root.metering.DcrInteractionKind.fromObject(e.interaction);
      }
      return n;
    }, r.toObject = function(e, n) {
      n || (n = {});
      let o = {};
      return n.defaults && (o.dataRoomId = "", o.interaction = null), e.dataRoomId != null && e.hasOwnProperty("dataRoomId") && (o.dataRoomId = e.dataRoomId), e.interaction != null && e.hasOwnProperty("interaction") && (o.interaction = $root.metering.DcrInteractionKind.toObject(e.interaction, n)), o;
    }, r.prototype.toJSON = function() {
      return this.constructor.toObject(this, minimal.util.toJSONOptions);
    }, r.getTypeUrl = function(e) {
      return e === void 0 && (e = "type.googleapis.com"), e + "/metering.RecordDcrInteractionRequest";
    }, r;
  }(), u.RecordDcrInteractionResponse = function() {
    function r(a) {
      if (a)
        for (let e = Object.keys(a), n = 0; n < e.length; ++n)
          a[e[n]] != null && (this[e[n]] = a[e[n]]);
    }
    return r.create = function(e) {
      return new r(e);
    }, r.encode = function(e, n) {
      return n || (n = $Writer.create()), n;
    }, r.encodeDelimited = function(e, n) {
      return this.encode(e, n).ldelim();
    }, r.decode = function(e, n) {
      e instanceof $Reader || (e = $Reader.create(e));
      let o = n === void 0 ? e.len : e.pos + n, c = new $root.metering.RecordDcrInteractionResponse();
      for (; e.pos < o; ) {
        let l = e.uint32();
        switch (l >>> 3) {
          default:
            e.skipType(l & 7);
            break;
        }
      }
      return c;
    }, r.decodeDelimited = function(e) {
      return e instanceof $Reader || (e = new $Reader(e)), this.decode(e, e.uint32());
    }, r.verify = function(e) {
      return typeof e != "object" || e === null ? "object expected" : null;
    }, r.fromObject = function(e) {
      return e instanceof $root.metering.RecordDcrInteractionResponse ? e : new $root.metering.RecordDcrInteractionResponse();
    }, r.toObject = function() {
      return {};
    }, r.prototype.toJSON = function() {
      return this.constructor.toObject(this, minimal.util.toJSONOptions);
    }, r.getTypeUrl = function(e) {
      return e === void 0 && (e = "type.googleapis.com"), e + "/metering.RecordDcrInteractionResponse";
    }, r;
  }(), u;
})();
$root.integrity_store_api = (() => {
  const u = {};
  return u.IntegrityStoreRequest = function() {
    function r(e) {
      if (e)
        for (let n = Object.keys(e), o = 0; o < n.length; ++o)
          e[n[o]] != null && (this[n[o]] = e[n[o]]);
    }
    r.prototype.cas = null;
    let a;
    return Object.defineProperty(r.prototype, "request", {
      get: $util.oneOfGetter(a = ["cas"]),
      set: $util.oneOfSetter(a)
    }), r.create = function(n) {
      return new r(n);
    }, r.encode = function(n, o) {
      return o || (o = $Writer.create()), n.cas != null && Object.hasOwnProperty.call(n, "cas") && $root.integrity_store_api.BatchCompareAndSwapRequest.encode(n.cas, o.uint32(
        /* id 1, wireType 2 =*/
        10
      ).fork()).ldelim(), o;
    }, r.encodeDelimited = function(n, o) {
      return this.encode(n, o).ldelim();
    }, r.decode = function(n, o) {
      n instanceof $Reader || (n = $Reader.create(n));
      let c = o === void 0 ? n.len : n.pos + o, l = new $root.integrity_store_api.IntegrityStoreRequest();
      for (; n.pos < c; ) {
        let d = n.uint32();
        switch (d >>> 3) {
          case 1: {
            l.cas = $root.integrity_store_api.BatchCompareAndSwapRequest.decode(n, n.uint32());
            break;
          }
          default:
            n.skipType(d & 7);
            break;
        }
      }
      return l;
    }, r.decodeDelimited = function(n) {
      return n instanceof $Reader || (n = new $Reader(n)), this.decode(n, n.uint32());
    }, r.verify = function(n) {
      if (typeof n != "object" || n === null)
        return "object expected";
      if (n.cas != null && n.hasOwnProperty("cas")) {
        let o = $root.integrity_store_api.BatchCompareAndSwapRequest.verify(n.cas);
        if (o)
          return "cas." + o;
      }
      return null;
    }, r.fromObject = function(n) {
      if (n instanceof $root.integrity_store_api.IntegrityStoreRequest)
        return n;
      let o = new $root.integrity_store_api.IntegrityStoreRequest();
      if (n.cas != null) {
        if (typeof n.cas != "object")
          throw TypeError(".integrity_store_api.IntegrityStoreRequest.cas: object expected");
        o.cas = $root.integrity_store_api.BatchCompareAndSwapRequest.fromObject(n.cas);
      }
      return o;
    }, r.toObject = function(n, o) {
      o || (o = {});
      let c = {};
      return n.cas != null && n.hasOwnProperty("cas") && (c.cas = $root.integrity_store_api.BatchCompareAndSwapRequest.toObject(n.cas, o), o.oneofs && (c.request = "cas")), c;
    }, r.prototype.toJSON = function() {
      return this.constructor.toObject(this, minimal.util.toJSONOptions);
    }, r.getTypeUrl = function(n) {
      return n === void 0 && (n = "type.googleapis.com"), n + "/integrity_store_api.IntegrityStoreRequest";
    }, r;
  }(), u.IntegrityStoreResponse = function() {
    function r(e) {
      if (e)
        for (let n = Object.keys(e), o = 0; o < n.length; ++o)
          e[n[o]] != null && (this[n[o]] = e[n[o]]);
    }
    r.prototype.cas = null;
    let a;
    return Object.defineProperty(r.prototype, "response", {
      get: $util.oneOfGetter(a = ["cas"]),
      set: $util.oneOfSetter(a)
    }), r.create = function(n) {
      return new r(n);
    }, r.encode = function(n, o) {
      return o || (o = $Writer.create()), n.cas != null && Object.hasOwnProperty.call(n, "cas") && $root.integrity_store_api.BatchCompareAndSwapResponse.encode(n.cas, o.uint32(
        /* id 1, wireType 2 =*/
        10
      ).fork()).ldelim(), o;
    }, r.encodeDelimited = function(n, o) {
      return this.encode(n, o).ldelim();
    }, r.decode = function(n, o) {
      n instanceof $Reader || (n = $Reader.create(n));
      let c = o === void 0 ? n.len : n.pos + o, l = new $root.integrity_store_api.IntegrityStoreResponse();
      for (; n.pos < c; ) {
        let d = n.uint32();
        switch (d >>> 3) {
          case 1: {
            l.cas = $root.integrity_store_api.BatchCompareAndSwapResponse.decode(n, n.uint32());
            break;
          }
          default:
            n.skipType(d & 7);
            break;
        }
      }
      return l;
    }, r.decodeDelimited = function(n) {
      return n instanceof $Reader || (n = new $Reader(n)), this.decode(n, n.uint32());
    }, r.verify = function(n) {
      if (typeof n != "object" || n === null)
        return "object expected";
      if (n.cas != null && n.hasOwnProperty("cas")) {
        let o = $root.integrity_store_api.BatchCompareAndSwapResponse.verify(n.cas);
        if (o)
          return "cas." + o;
      }
      return null;
    }, r.fromObject = function(n) {
      if (n instanceof $root.integrity_store_api.IntegrityStoreResponse)
        return n;
      let o = new $root.integrity_store_api.IntegrityStoreResponse();
      if (n.cas != null) {
        if (typeof n.cas != "object")
          throw TypeError(".integrity_store_api.IntegrityStoreResponse.cas: object expected");
        o.cas = $root.integrity_store_api.BatchCompareAndSwapResponse.fromObject(n.cas);
      }
      return o;
    }, r.toObject = function(n, o) {
      o || (o = {});
      let c = {};
      return n.cas != null && n.hasOwnProperty("cas") && (c.cas = $root.integrity_store_api.BatchCompareAndSwapResponse.toObject(n.cas, o), o.oneofs && (c.response = "cas")), c;
    }, r.prototype.toJSON = function() {
      return this.constructor.toObject(this, minimal.util.toJSONOptions);
    }, r.getTypeUrl = function(n) {
      return n === void 0 && (n = "type.googleapis.com"), n + "/integrity_store_api.IntegrityStoreResponse";
    }, r;
  }(), u.BatchCompareAndSwapRequest = function() {
    function r(a) {
      if (this.requests = [], a)
        for (let e = Object.keys(a), n = 0; n < e.length; ++n)
          a[e[n]] != null && (this[e[n]] = a[e[n]]);
    }
    return r.prototype.requests = $util.emptyArray, r.create = function(e) {
      return new r(e);
    }, r.encode = function(e, n) {
      if (n || (n = $Writer.create()), e.requests != null && e.requests.length)
        for (let o = 0; o < e.requests.length; ++o)
          $root.integrity_store_api.CompareAndSwapRequest.encode(e.requests[o], n.uint32(
            /* id 1, wireType 2 =*/
            10
          ).fork()).ldelim();
      return n;
    }, r.encodeDelimited = function(e, n) {
      return this.encode(e, n).ldelim();
    }, r.decode = function(e, n) {
      e instanceof $Reader || (e = $Reader.create(e));
      let o = n === void 0 ? e.len : e.pos + n, c = new $root.integrity_store_api.BatchCompareAndSwapRequest();
      for (; e.pos < o; ) {
        let l = e.uint32();
        switch (l >>> 3) {
          case 1: {
            c.requests && c.requests.length || (c.requests = []), c.requests.push($root.integrity_store_api.CompareAndSwapRequest.decode(e, e.uint32()));
            break;
          }
          default:
            e.skipType(l & 7);
            break;
        }
      }
      return c;
    }, r.decodeDelimited = function(e) {
      return e instanceof $Reader || (e = new $Reader(e)), this.decode(e, e.uint32());
    }, r.verify = function(e) {
      if (typeof e != "object" || e === null)
        return "object expected";
      if (e.requests != null && e.hasOwnProperty("requests")) {
        if (!Array.isArray(e.requests))
          return "requests: array expected";
        for (let n = 0; n < e.requests.length; ++n) {
          let o = $root.integrity_store_api.CompareAndSwapRequest.verify(e.requests[n]);
          if (o)
            return "requests." + o;
        }
      }
      return null;
    }, r.fromObject = function(e) {
      if (e instanceof $root.integrity_store_api.BatchCompareAndSwapRequest)
        return e;
      let n = new $root.integrity_store_api.BatchCompareAndSwapRequest();
      if (e.requests) {
        if (!Array.isArray(e.requests))
          throw TypeError(".integrity_store_api.BatchCompareAndSwapRequest.requests: array expected");
        n.requests = [];
        for (let o = 0; o < e.requests.length; ++o) {
          if (typeof e.requests[o] != "object")
            throw TypeError(".integrity_store_api.BatchCompareAndSwapRequest.requests: object expected");
          n.requests[o] = $root.integrity_store_api.CompareAndSwapRequest.fromObject(e.requests[o]);
        }
      }
      return n;
    }, r.toObject = function(e, n) {
      n || (n = {});
      let o = {};
      if ((n.arrays || n.defaults) && (o.requests = []), e.requests && e.requests.length) {
        o.requests = [];
        for (let c = 0; c < e.requests.length; ++c)
          o.requests[c] = $root.integrity_store_api.CompareAndSwapRequest.toObject(e.requests[c], n);
      }
      return o;
    }, r.prototype.toJSON = function() {
      return this.constructor.toObject(this, minimal.util.toJSONOptions);
    }, r.getTypeUrl = function(e) {
      return e === void 0 && (e = "type.googleapis.com"), e + "/integrity_store_api.BatchCompareAndSwapRequest";
    }, r;
  }(), u.BatchCompareAndSwapResponse = function() {
    function r(a) {
      if (this.responses = [], a)
        for (let e = Object.keys(a), n = 0; n < e.length; ++n)
          a[e[n]] != null && (this[e[n]] = a[e[n]]);
    }
    return r.prototype.responses = $util.emptyArray, r.create = function(e) {
      return new r(e);
    }, r.encode = function(e, n) {
      if (n || (n = $Writer.create()), e.responses != null && e.responses.length)
        for (let o = 0; o < e.responses.length; ++o)
          $root.integrity_store_api.CompareAndSwapResponse.encode(e.responses[o], n.uint32(
            /* id 1, wireType 2 =*/
            10
          ).fork()).ldelim();
      return n;
    }, r.encodeDelimited = function(e, n) {
      return this.encode(e, n).ldelim();
    }, r.decode = function(e, n) {
      e instanceof $Reader || (e = $Reader.create(e));
      let o = n === void 0 ? e.len : e.pos + n, c = new $root.integrity_store_api.BatchCompareAndSwapResponse();
      for (; e.pos < o; ) {
        let l = e.uint32();
        switch (l >>> 3) {
          case 1: {
            c.responses && c.responses.length || (c.responses = []), c.responses.push($root.integrity_store_api.CompareAndSwapResponse.decode(e, e.uint32()));
            break;
          }
          default:
            e.skipType(l & 7);
            break;
        }
      }
      return c;
    }, r.decodeDelimited = function(e) {
      return e instanceof $Reader || (e = new $Reader(e)), this.decode(e, e.uint32());
    }, r.verify = function(e) {
      if (typeof e != "object" || e === null)
        return "object expected";
      if (e.responses != null && e.hasOwnProperty("responses")) {
        if (!Array.isArray(e.responses))
          return "responses: array expected";
        for (let n = 0; n < e.responses.length; ++n) {
          let o = $root.integrity_store_api.CompareAndSwapResponse.verify(e.responses[n]);
          if (o)
            return "responses." + o;
        }
      }
      return null;
    }, r.fromObject = function(e) {
      if (e instanceof $root.integrity_store_api.BatchCompareAndSwapResponse)
        return e;
      let n = new $root.integrity_store_api.BatchCompareAndSwapResponse();
      if (e.responses) {
        if (!Array.isArray(e.responses))
          throw TypeError(".integrity_store_api.BatchCompareAndSwapResponse.responses: array expected");
        n.responses = [];
        for (let o = 0; o < e.responses.length; ++o) {
          if (typeof e.responses[o] != "object")
            throw TypeError(".integrity_store_api.BatchCompareAndSwapResponse.responses: object expected");
          n.responses[o] = $root.integrity_store_api.CompareAndSwapResponse.fromObject(e.responses[o]);
        }
      }
      return n;
    }, r.toObject = function(e, n) {
      n || (n = {});
      let o = {};
      if ((n.arrays || n.defaults) && (o.responses = []), e.responses && e.responses.length) {
        o.responses = [];
        for (let c = 0; c < e.responses.length; ++c)
          o.responses[c] = $root.integrity_store_api.CompareAndSwapResponse.toObject(e.responses[c], n);
      }
      return o;
    }, r.prototype.toJSON = function() {
      return this.constructor.toObject(this, minimal.util.toJSONOptions);
    }, r.getTypeUrl = function(e) {
      return e === void 0 && (e = "type.googleapis.com"), e + "/integrity_store_api.BatchCompareAndSwapResponse";
    }, r;
  }(), u.CompareAndSwapRequest = function() {
    function r(e) {
      if (e)
        for (let n = Object.keys(e), o = 0; o < n.length; ++o)
          e[n[o]] != null && (this[n[o]] = e[n[o]]);
    }
    r.prototype.id = "", r.prototype.contentType = "", r.prototype.expectedCasIndex = null, r.prototype.newValue = null;
    let a;
    return Object.defineProperty(r.prototype, "_expectedCasIndex", {
      get: $util.oneOfGetter(a = ["expectedCasIndex"]),
      set: $util.oneOfSetter(a)
    }), Object.defineProperty(r.prototype, "_newValue", {
      get: $util.oneOfGetter(a = ["newValue"]),
      set: $util.oneOfSetter(a)
    }), r.create = function(n) {
      return new r(n);
    }, r.encode = function(n, o) {
      return o || (o = $Writer.create()), n.id != null && Object.hasOwnProperty.call(n, "id") && o.uint32(
        /* id 1, wireType 2 =*/
        10
      ).string(n.id), n.contentType != null && Object.hasOwnProperty.call(n, "contentType") && o.uint32(
        /* id 2, wireType 2 =*/
        18
      ).string(n.contentType), n.expectedCasIndex != null && Object.hasOwnProperty.call(n, "expectedCasIndex") && o.uint32(
        /* id 3, wireType 0 =*/
        24
      ).uint64(n.expectedCasIndex), n.newValue != null && Object.hasOwnProperty.call(n, "newValue") && $root.integrity_store_api.IntegrityStoreValue.encode(n.newValue, o.uint32(
        /* id 4, wireType 2 =*/
        34
      ).fork()).ldelim(), o;
    }, r.encodeDelimited = function(n, o) {
      return this.encode(n, o).ldelim();
    }, r.decode = function(n, o) {
      n instanceof $Reader || (n = $Reader.create(n));
      let c = o === void 0 ? n.len : n.pos + o, l = new $root.integrity_store_api.CompareAndSwapRequest();
      for (; n.pos < c; ) {
        let d = n.uint32();
        switch (d >>> 3) {
          case 1: {
            l.id = n.string();
            break;
          }
          case 2: {
            l.contentType = n.string();
            break;
          }
          case 3: {
            l.expectedCasIndex = n.uint64();
            break;
          }
          case 4: {
            l.newValue = $root.integrity_store_api.IntegrityStoreValue.decode(n, n.uint32());
            break;
          }
          default:
            n.skipType(d & 7);
            break;
        }
      }
      return l;
    }, r.decodeDelimited = function(n) {
      return n instanceof $Reader || (n = new $Reader(n)), this.decode(n, n.uint32());
    }, r.verify = function(n) {
      if (typeof n != "object" || n === null)
        return "object expected";
      if (n.id != null && n.hasOwnProperty("id") && !$util.isString(n.id))
        return "id: string expected";
      if (n.contentType != null && n.hasOwnProperty("contentType") && !$util.isString(n.contentType))
        return "contentType: string expected";
      if (n.expectedCasIndex != null && n.hasOwnProperty("expectedCasIndex") && !$util.isInteger(n.expectedCasIndex) && !(n.expectedCasIndex && $util.isInteger(n.expectedCasIndex.low) && $util.isInteger(n.expectedCasIndex.high)))
        return "expectedCasIndex: integer|Long expected";
      if (n.newValue != null && n.hasOwnProperty("newValue")) {
        let o = $root.integrity_store_api.IntegrityStoreValue.verify(n.newValue);
        if (o)
          return "newValue." + o;
      }
      return null;
    }, r.fromObject = function(n) {
      if (n instanceof $root.integrity_store_api.CompareAndSwapRequest)
        return n;
      let o = new $root.integrity_store_api.CompareAndSwapRequest();
      if (n.id != null && (o.id = String(n.id)), n.contentType != null && (o.contentType = String(n.contentType)), n.expectedCasIndex != null && ($util.Long ? (o.expectedCasIndex = $util.Long.fromValue(n.expectedCasIndex)).unsigned = !0 : typeof n.expectedCasIndex == "string" ? o.expectedCasIndex = parseInt(n.expectedCasIndex, 10) : typeof n.expectedCasIndex == "number" ? o.expectedCasIndex = n.expectedCasIndex : typeof n.expectedCasIndex == "object" && (o.expectedCasIndex = new $util.LongBits(n.expectedCasIndex.low >>> 0, n.expectedCasIndex.high >>> 0).toNumber(!0))), n.newValue != null) {
        if (typeof n.newValue != "object")
          throw TypeError(".integrity_store_api.CompareAndSwapRequest.newValue: object expected");
        o.newValue = $root.integrity_store_api.IntegrityStoreValue.fromObject(n.newValue);
      }
      return o;
    }, r.toObject = function(n, o) {
      o || (o = {});
      let c = {};
      return o.defaults && (c.id = "", c.contentType = ""), n.id != null && n.hasOwnProperty("id") && (c.id = n.id), n.contentType != null && n.hasOwnProperty("contentType") && (c.contentType = n.contentType), n.expectedCasIndex != null && n.hasOwnProperty("expectedCasIndex") && (typeof n.expectedCasIndex == "number" ? c.expectedCasIndex = o.longs === String ? String(n.expectedCasIndex) : n.expectedCasIndex : c.expectedCasIndex = o.longs === String ? $util.Long.prototype.toString.call(n.expectedCasIndex) : o.longs === Number ? new $util.LongBits(n.expectedCasIndex.low >>> 0, n.expectedCasIndex.high >>> 0).toNumber(!0) : n.expectedCasIndex, o.oneofs && (c._expectedCasIndex = "expectedCasIndex")), n.newValue != null && n.hasOwnProperty("newValue") && (c.newValue = $root.integrity_store_api.IntegrityStoreValue.toObject(n.newValue, o), o.oneofs && (c._newValue = "newValue")), c;
    }, r.prototype.toJSON = function() {
      return this.constructor.toObject(this, minimal.util.toJSONOptions);
    }, r.getTypeUrl = function(n) {
      return n === void 0 && (n = "type.googleapis.com"), n + "/integrity_store_api.CompareAndSwapRequest";
    }, r;
  }(), u.CompareAndSwapResponse = function() {
    function r(e) {
      if (e)
        for (let n = Object.keys(e), o = 0; o < n.length; ++o)
          e[n[o]] != null && (this[n[o]] = e[n[o]]);
    }
    r.prototype.swapped = !1, r.prototype.previousCasIndex = null, r.prototype.previousValue = null;
    let a;
    return Object.defineProperty(r.prototype, "_previousCasIndex", {
      get: $util.oneOfGetter(a = ["previousCasIndex"]),
      set: $util.oneOfSetter(a)
    }), Object.defineProperty(r.prototype, "_previousValue", {
      get: $util.oneOfGetter(a = ["previousValue"]),
      set: $util.oneOfSetter(a)
    }), r.create = function(n) {
      return new r(n);
    }, r.encode = function(n, o) {
      return o || (o = $Writer.create()), n.swapped != null && Object.hasOwnProperty.call(n, "swapped") && o.uint32(
        /* id 1, wireType 0 =*/
        8
      ).bool(n.swapped), n.previousCasIndex != null && Object.hasOwnProperty.call(n, "previousCasIndex") && o.uint32(
        /* id 2, wireType 0 =*/
        16
      ).uint64(n.previousCasIndex), n.previousValue != null && Object.hasOwnProperty.call(n, "previousValue") && $root.integrity_store_api.IntegrityStoreValue.encode(n.previousValue, o.uint32(
        /* id 3, wireType 2 =*/
        26
      ).fork()).ldelim(), o;
    }, r.encodeDelimited = function(n, o) {
      return this.encode(n, o).ldelim();
    }, r.decode = function(n, o) {
      n instanceof $Reader || (n = $Reader.create(n));
      let c = o === void 0 ? n.len : n.pos + o, l = new $root.integrity_store_api.CompareAndSwapResponse();
      for (; n.pos < c; ) {
        let d = n.uint32();
        switch (d >>> 3) {
          case 1: {
            l.swapped = n.bool();
            break;
          }
          case 2: {
            l.previousCasIndex = n.uint64();
            break;
          }
          case 3: {
            l.previousValue = $root.integrity_store_api.IntegrityStoreValue.decode(n, n.uint32());
            break;
          }
          default:
            n.skipType(d & 7);
            break;
        }
      }
      return l;
    }, r.decodeDelimited = function(n) {
      return n instanceof $Reader || (n = new $Reader(n)), this.decode(n, n.uint32());
    }, r.verify = function(n) {
      if (typeof n != "object" || n === null)
        return "object expected";
      if (n.swapped != null && n.hasOwnProperty("swapped") && typeof n.swapped != "boolean")
        return "swapped: boolean expected";
      if (n.previousCasIndex != null && n.hasOwnProperty("previousCasIndex") && !$util.isInteger(n.previousCasIndex) && !(n.previousCasIndex && $util.isInteger(n.previousCasIndex.low) && $util.isInteger(n.previousCasIndex.high)))
        return "previousCasIndex: integer|Long expected";
      if (n.previousValue != null && n.hasOwnProperty("previousValue")) {
        let o = $root.integrity_store_api.IntegrityStoreValue.verify(n.previousValue);
        if (o)
          return "previousValue." + o;
      }
      return null;
    }, r.fromObject = function(n) {
      if (n instanceof $root.integrity_store_api.CompareAndSwapResponse)
        return n;
      let o = new $root.integrity_store_api.CompareAndSwapResponse();
      if (n.swapped != null && (o.swapped = !!n.swapped), n.previousCasIndex != null && ($util.Long ? (o.previousCasIndex = $util.Long.fromValue(n.previousCasIndex)).unsigned = !0 : typeof n.previousCasIndex == "string" ? o.previousCasIndex = parseInt(n.previousCasIndex, 10) : typeof n.previousCasIndex == "number" ? o.previousCasIndex = n.previousCasIndex : typeof n.previousCasIndex == "object" && (o.previousCasIndex = new $util.LongBits(n.previousCasIndex.low >>> 0, n.previousCasIndex.high >>> 0).toNumber(!0))), n.previousValue != null) {
        if (typeof n.previousValue != "object")
          throw TypeError(".integrity_store_api.CompareAndSwapResponse.previousValue: object expected");
        o.previousValue = $root.integrity_store_api.IntegrityStoreValue.fromObject(n.previousValue);
      }
      return o;
    }, r.toObject = function(n, o) {
      o || (o = {});
      let c = {};
      return o.defaults && (c.swapped = !1), n.swapped != null && n.hasOwnProperty("swapped") && (c.swapped = n.swapped), n.previousCasIndex != null && n.hasOwnProperty("previousCasIndex") && (typeof n.previousCasIndex == "number" ? c.previousCasIndex = o.longs === String ? String(n.previousCasIndex) : n.previousCasIndex : c.previousCasIndex = o.longs === String ? $util.Long.prototype.toString.call(n.previousCasIndex) : o.longs === Number ? new $util.LongBits(n.previousCasIndex.low >>> 0, n.previousCasIndex.high >>> 0).toNumber(!0) : n.previousCasIndex, o.oneofs && (c._previousCasIndex = "previousCasIndex")), n.previousValue != null && n.hasOwnProperty("previousValue") && (c.previousValue = $root.integrity_store_api.IntegrityStoreValue.toObject(n.previousValue, o), o.oneofs && (c._previousValue = "previousValue")), c;
    }, r.prototype.toJSON = function() {
      return this.constructor.toObject(this, minimal.util.toJSONOptions);
    }, r.getTypeUrl = function(n) {
      return n === void 0 && (n = "type.googleapis.com"), n + "/integrity_store_api.CompareAndSwapResponse";
    }, r;
  }(), u.IntegrityStoreValue = function() {
    function r(e) {
      if (e)
        for (let n = Object.keys(e), o = 0; o < n.length; ++o)
          e[n[o]] != null && (this[n[o]] = e[n[o]]);
    }
    r.prototype.version = 0, r.prototype.plaintextContent = null, r.prototype.plaintextSignature = null, r.prototype.encryptedContent = null;
    let a;
    return Object.defineProperty(r.prototype, "_plaintextContent", {
      get: $util.oneOfGetter(a = ["plaintextContent"]),
      set: $util.oneOfSetter(a)
    }), Object.defineProperty(r.prototype, "_plaintextSignature", {
      get: $util.oneOfGetter(a = ["plaintextSignature"]),
      set: $util.oneOfSetter(a)
    }), Object.defineProperty(r.prototype, "_encryptedContent", {
      get: $util.oneOfGetter(a = ["encryptedContent"]),
      set: $util.oneOfSetter(a)
    }), r.create = function(n) {
      return new r(n);
    }, r.encode = function(n, o) {
      return o || (o = $Writer.create()), n.version != null && Object.hasOwnProperty.call(n, "version") && o.uint32(
        /* id 1, wireType 0 =*/
        8
      ).uint32(n.version), n.plaintextContent != null && Object.hasOwnProperty.call(n, "plaintextContent") && o.uint32(
        /* id 2, wireType 2 =*/
        18
      ).string(n.plaintextContent), n.plaintextSignature != null && Object.hasOwnProperty.call(n, "plaintextSignature") && o.uint32(
        /* id 3, wireType 2 =*/
        26
      ).bytes(n.plaintextSignature), n.encryptedContent != null && Object.hasOwnProperty.call(n, "encryptedContent") && o.uint32(
        /* id 4, wireType 2 =*/
        34
      ).bytes(n.encryptedContent), o;
    }, r.encodeDelimited = function(n, o) {
      return this.encode(n, o).ldelim();
    }, r.decode = function(n, o) {
      n instanceof $Reader || (n = $Reader.create(n));
      let c = o === void 0 ? n.len : n.pos + o, l = new $root.integrity_store_api.IntegrityStoreValue();
      for (; n.pos < c; ) {
        let d = n.uint32();
        switch (d >>> 3) {
          case 1: {
            l.version = n.uint32();
            break;
          }
          case 2: {
            l.plaintextContent = n.string();
            break;
          }
          case 3: {
            l.plaintextSignature = n.bytes();
            break;
          }
          case 4: {
            l.encryptedContent = n.bytes();
            break;
          }
          default:
            n.skipType(d & 7);
            break;
        }
      }
      return l;
    }, r.decodeDelimited = function(n) {
      return n instanceof $Reader || (n = new $Reader(n)), this.decode(n, n.uint32());
    }, r.verify = function(n) {
      return typeof n != "object" || n === null ? "object expected" : n.version != null && n.hasOwnProperty("version") && !$util.isInteger(n.version) ? "version: integer expected" : n.plaintextContent != null && n.hasOwnProperty("plaintextContent") && !$util.isString(n.plaintextContent) ? "plaintextContent: string expected" : n.plaintextSignature != null && n.hasOwnProperty("plaintextSignature") && !(n.plaintextSignature && typeof n.plaintextSignature.length == "number" || $util.isString(n.plaintextSignature)) ? "plaintextSignature: buffer expected" : n.encryptedContent != null && n.hasOwnProperty("encryptedContent") && !(n.encryptedContent && typeof n.encryptedContent.length == "number" || $util.isString(n.encryptedContent)) ? "encryptedContent: buffer expected" : null;
    }, r.fromObject = function(n) {
      if (n instanceof $root.integrity_store_api.IntegrityStoreValue)
        return n;
      let o = new $root.integrity_store_api.IntegrityStoreValue();
      return n.version != null && (o.version = n.version >>> 0), n.plaintextContent != null && (o.plaintextContent = String(n.plaintextContent)), n.plaintextSignature != null && (typeof n.plaintextSignature == "string" ? $util.base64.decode(n.plaintextSignature, o.plaintextSignature = $util.newBuffer($util.base64.length(n.plaintextSignature)), 0) : n.plaintextSignature.length >= 0 && (o.plaintextSignature = n.plaintextSignature)), n.encryptedContent != null && (typeof n.encryptedContent == "string" ? $util.base64.decode(n.encryptedContent, o.encryptedContent = $util.newBuffer($util.base64.length(n.encryptedContent)), 0) : n.encryptedContent.length >= 0 && (o.encryptedContent = n.encryptedContent)), o;
    }, r.toObject = function(n, o) {
      o || (o = {});
      let c = {};
      return o.defaults && (c.version = 0), n.version != null && n.hasOwnProperty("version") && (c.version = n.version), n.plaintextContent != null && n.hasOwnProperty("plaintextContent") && (c.plaintextContent = n.plaintextContent, o.oneofs && (c._plaintextContent = "plaintextContent")), n.plaintextSignature != null && n.hasOwnProperty("plaintextSignature") && (c.plaintextSignature = o.bytes === String ? $util.base64.encode(n.plaintextSignature, 0, n.plaintextSignature.length) : o.bytes === Array ? Array.prototype.slice.call(n.plaintextSignature) : n.plaintextSignature, o.oneofs && (c._plaintextSignature = "plaintextSignature")), n.encryptedContent != null && n.hasOwnProperty("encryptedContent") && (c.encryptedContent = o.bytes === String ? $util.base64.encode(n.encryptedContent, 0, n.encryptedContent.length) : o.bytes === Array ? Array.prototype.slice.call(n.encryptedContent) : n.encryptedContent, o.oneofs && (c._encryptedContent = "encryptedContent")), c;
    }, r.prototype.toJSON = function() {
      return this.constructor.toObject(this, minimal.util.toJSONOptions);
    }, r.getTypeUrl = function(n) {
      return n === void 0 && (n = "type.googleapis.com"), n + "/integrity_store_api.IntegrityStoreValue";
    }, r;
  }(), u;
})();
$root.permutive = (() => {
  const u = {};
  return u.ImportRole = function() {
    function r(a) {
      if (a)
        for (let e = Object.keys(a), n = 0; n < e.length; ++n)
          a[e[n]] != null && (this[e[n]] = a[e[n]]);
    }
    return r.create = function(e) {
      return new r(e);
    }, r.encode = function(e, n) {
      return n || (n = $Writer.create()), n;
    }, r.encodeDelimited = function(e, n) {
      return this.encode(e, n).ldelim();
    }, r.decode = function(e, n) {
      e instanceof $Reader || (e = $Reader.create(e));
      let o = n === void 0 ? e.len : e.pos + n, c = new $root.permutive.ImportRole();
      for (; e.pos < o; ) {
        let l = e.uint32();
        switch (l >>> 3) {
          default:
            e.skipType(l & 7);
            break;
        }
      }
      return c;
    }, r.decodeDelimited = function(e) {
      return e instanceof $Reader || (e = new $Reader(e)), this.decode(e, e.uint32());
    }, r.verify = function(e) {
      return typeof e != "object" || e === null ? "object expected" : null;
    }, r.fromObject = function(e) {
      return e instanceof $root.permutive.ImportRole ? e : new $root.permutive.ImportRole();
    }, r.toObject = function() {
      return {};
    }, r.prototype.toJSON = function() {
      return this.constructor.toObject(this, minimal.util.toJSONOptions);
    }, r.getTypeUrl = function(e) {
      return e === void 0 && (e = "type.googleapis.com"), e + "/permutive.ImportRole";
    }, r;
  }(), u.ExportRole = function() {
    function r(a) {
      if (a)
        for (let e = Object.keys(a), n = 0; n < e.length; ++n)
          a[e[n]] != null && (this[e[n]] = a[e[n]]);
    }
    return r.prototype.input = null, r.create = function(e) {
      return new r(e);
    }, r.encode = function(e, n) {
      return n || (n = $Writer.create()), e.input != null && Object.hasOwnProperty.call(e, "input") && $root.permutive.SinkInput.encode(e.input, n.uint32(
        /* id 1, wireType 2 =*/
        10
      ).fork()).ldelim(), n;
    }, r.encodeDelimited = function(e, n) {
      return this.encode(e, n).ldelim();
    }, r.decode = function(e, n) {
      e instanceof $Reader || (e = $Reader.create(e));
      let o = n === void 0 ? e.len : e.pos + n, c = new $root.permutive.ExportRole();
      for (; e.pos < o; ) {
        let l = e.uint32();
        switch (l >>> 3) {
          case 1: {
            c.input = $root.permutive.SinkInput.decode(e, e.uint32());
            break;
          }
          default:
            e.skipType(l & 7);
            break;
        }
      }
      return c;
    }, r.decodeDelimited = function(e) {
      return e instanceof $Reader || (e = new $Reader(e)), this.decode(e, e.uint32());
    }, r.verify = function(e) {
      if (typeof e != "object" || e === null)
        return "object expected";
      if (e.input != null && e.hasOwnProperty("input")) {
        let n = $root.permutive.SinkInput.verify(e.input);
        if (n)
          return "input." + n;
      }
      return null;
    }, r.fromObject = function(e) {
      if (e instanceof $root.permutive.ExportRole)
        return e;
      let n = new $root.permutive.ExportRole();
      if (e.input != null) {
        if (typeof e.input != "object")
          throw TypeError(".permutive.ExportRole.input: object expected");
        n.input = $root.permutive.SinkInput.fromObject(e.input);
      }
      return n;
    }, r.toObject = function(e, n) {
      n || (n = {});
      let o = {};
      return n.defaults && (o.input = null), e.input != null && e.hasOwnProperty("input") && (o.input = $root.permutive.SinkInput.toObject(e.input, n)), o;
    }, r.prototype.toJSON = function() {
      return this.constructor.toObject(this, minimal.util.toJSONOptions);
    }, r.getTypeUrl = function(e) {
      return e === void 0 && (e = "type.googleapis.com"), e + "/permutive.ExportRole";
    }, r;
  }(), u.SingleFile = function() {
    function r(a) {
      if (a)
        for (let e = Object.keys(a), n = 0; n < e.length; ++n)
          a[e[n]] != null && (this[e[n]] = a[e[n]]);
    }
    return r.prototype.name = "", r.create = function(e) {
      return new r(e);
    }, r.encode = function(e, n) {
      return n || (n = $Writer.create()), e.name != null && Object.hasOwnProperty.call(e, "name") && n.uint32(
        /* id 1, wireType 2 =*/
        10
      ).string(e.name), n;
    }, r.encodeDelimited = function(e, n) {
      return this.encode(e, n).ldelim();
    }, r.decode = function(e, n) {
      e instanceof $Reader || (e = $Reader.create(e));
      let o = n === void 0 ? e.len : e.pos + n, c = new $root.permutive.SingleFile();
      for (; e.pos < o; ) {
        let l = e.uint32();
        switch (l >>> 3) {
          case 1: {
            c.name = e.string();
            break;
          }
          default:
            e.skipType(l & 7);
            break;
        }
      }
      return c;
    }, r.decodeDelimited = function(e) {
      return e instanceof $Reader || (e = new $Reader(e)), this.decode(e, e.uint32());
    }, r.verify = function(e) {
      return typeof e != "object" || e === null ? "object expected" : e.name != null && e.hasOwnProperty("name") && !$util.isString(e.name) ? "name: string expected" : null;
    }, r.fromObject = function(e) {
      if (e instanceof $root.permutive.SingleFile)
        return e;
      let n = new $root.permutive.SingleFile();
      return e.name != null && (n.name = String(e.name)), n;
    }, r.toObject = function(e, n) {
      n || (n = {});
      let o = {};
      return n.defaults && (o.name = ""), e.name != null && e.hasOwnProperty("name") && (o.name = e.name), o;
    }, r.prototype.toJSON = function() {
      return this.constructor.toObject(this, minimal.util.toJSONOptions);
    }, r.getTypeUrl = function(e) {
      return e === void 0 && (e = "type.googleapis.com"), e + "/permutive.SingleFile";
    }, r;
  }(), u.RawFile = function() {
    function r(a) {
      if (a)
        for (let e = Object.keys(a), n = 0; n < e.length; ++n)
          a[e[n]] != null && (this[e[n]] = a[e[n]]);
    }
    return r.create = function(e) {
      return new r(e);
    }, r.encode = function(e, n) {
      return n || (n = $Writer.create()), n;
    }, r.encodeDelimited = function(e, n) {
      return this.encode(e, n).ldelim();
    }, r.decode = function(e, n) {
      e instanceof $Reader || (e = $Reader.create(e));
      let o = n === void 0 ? e.len : e.pos + n, c = new $root.permutive.RawFile();
      for (; e.pos < o; ) {
        let l = e.uint32();
        switch (l >>> 3) {
          default:
            e.skipType(l & 7);
            break;
        }
      }
      return c;
    }, r.decodeDelimited = function(e) {
      return e instanceof $Reader || (e = new $Reader(e)), this.decode(e, e.uint32());
    }, r.verify = function(e) {
      return typeof e != "object" || e === null ? "object expected" : null;
    }, r.fromObject = function(e) {
      return e instanceof $root.permutive.RawFile ? e : new $root.permutive.RawFile();
    }, r.toObject = function() {
      return {};
    }, r.prototype.toJSON = function() {
      return this.constructor.toObject(this, minimal.util.toJSONOptions);
    }, r.getTypeUrl = function(e) {
      return e === void 0 && (e = "type.googleapis.com"), e + "/permutive.RawFile";
    }, r;
  }(), u.ZipFile = function() {
    function r(e) {
      if (e)
        for (let n = Object.keys(e), o = 0; o < n.length; ++o)
          e[n[o]] != null && (this[n[o]] = e[n[o]]);
    }
    r.prototype.singleFile = null;
    let a;
    return Object.defineProperty(r.prototype, "selection", {
      get: $util.oneOfGetter(a = ["singleFile"]),
      set: $util.oneOfSetter(a)
    }), r.create = function(n) {
      return new r(n);
    }, r.encode = function(n, o) {
      return o || (o = $Writer.create()), n.singleFile != null && Object.hasOwnProperty.call(n, "singleFile") && $root.permutive.SingleFile.encode(n.singleFile, o.uint32(
        /* id 1, wireType 2 =*/
        10
      ).fork()).ldelim(), o;
    }, r.encodeDelimited = function(n, o) {
      return this.encode(n, o).ldelim();
    }, r.decode = function(n, o) {
      n instanceof $Reader || (n = $Reader.create(n));
      let c = o === void 0 ? n.len : n.pos + o, l = new $root.permutive.ZipFile();
      for (; n.pos < c; ) {
        let d = n.uint32();
        switch (d >>> 3) {
          case 1: {
            l.singleFile = $root.permutive.SingleFile.decode(n, n.uint32());
            break;
          }
          default:
            n.skipType(d & 7);
            break;
        }
      }
      return l;
    }, r.decodeDelimited = function(n) {
      return n instanceof $Reader || (n = new $Reader(n)), this.decode(n, n.uint32());
    }, r.verify = function(n) {
      if (typeof n != "object" || n === null)
        return "object expected";
      if (n.singleFile != null && n.hasOwnProperty("singleFile")) {
        let o = $root.permutive.SingleFile.verify(n.singleFile);
        if (o)
          return "singleFile." + o;
      }
      return null;
    }, r.fromObject = function(n) {
      if (n instanceof $root.permutive.ZipFile)
        return n;
      let o = new $root.permutive.ZipFile();
      if (n.singleFile != null) {
        if (typeof n.singleFile != "object")
          throw TypeError(".permutive.ZipFile.singleFile: object expected");
        o.singleFile = $root.permutive.SingleFile.fromObject(n.singleFile);
      }
      return o;
    }, r.toObject = function(n, o) {
      o || (o = {});
      let c = {};
      return n.singleFile != null && n.hasOwnProperty("singleFile") && (c.singleFile = $root.permutive.SingleFile.toObject(n.singleFile, o), o.oneofs && (c.selection = "singleFile")), c;
    }, r.prototype.toJSON = function() {
      return this.constructor.toObject(this, minimal.util.toJSONOptions);
    }, r.getTypeUrl = function(n) {
      return n === void 0 && (n = "type.googleapis.com"), n + "/permutive.ZipFile";
    }, r;
  }(), u.SinkInput = function() {
    function r(e) {
      if (e)
        for (let n = Object.keys(e), o = 0; o < n.length; ++o)
          e[n[o]] != null && (this[n[o]] = e[n[o]]);
    }
    r.prototype.dependency = "", r.prototype.name = "", r.prototype.raw = null, r.prototype.zip = null;
    let a;
    return Object.defineProperty(r.prototype, "file", {
      get: $util.oneOfGetter(a = ["raw", "zip"]),
      set: $util.oneOfSetter(a)
    }), r.create = function(n) {
      return new r(n);
    }, r.encode = function(n, o) {
      return o || (o = $Writer.create()), n.dependency != null && Object.hasOwnProperty.call(n, "dependency") && o.uint32(
        /* id 1, wireType 2 =*/
        10
      ).string(n.dependency), n.name != null && Object.hasOwnProperty.call(n, "name") && o.uint32(
        /* id 2, wireType 2 =*/
        18
      ).string(n.name), n.raw != null && Object.hasOwnProperty.call(n, "raw") && $root.permutive.RawFile.encode(n.raw, o.uint32(
        /* id 3, wireType 2 =*/
        26
      ).fork()).ldelim(), n.zip != null && Object.hasOwnProperty.call(n, "zip") && $root.permutive.ZipFile.encode(n.zip, o.uint32(
        /* id 4, wireType 2 =*/
        34
      ).fork()).ldelim(), o;
    }, r.encodeDelimited = function(n, o) {
      return this.encode(n, o).ldelim();
    }, r.decode = function(n, o) {
      n instanceof $Reader || (n = $Reader.create(n));
      let c = o === void 0 ? n.len : n.pos + o, l = new $root.permutive.SinkInput();
      for (; n.pos < c; ) {
        let d = n.uint32();
        switch (d >>> 3) {
          case 1: {
            l.dependency = n.string();
            break;
          }
          case 2: {
            l.name = n.string();
            break;
          }
          case 3: {
            l.raw = $root.permutive.RawFile.decode(n, n.uint32());
            break;
          }
          case 4: {
            l.zip = $root.permutive.ZipFile.decode(n, n.uint32());
            break;
          }
          default:
            n.skipType(d & 7);
            break;
        }
      }
      return l;
    }, r.decodeDelimited = function(n) {
      return n instanceof $Reader || (n = new $Reader(n)), this.decode(n, n.uint32());
    }, r.verify = function(n) {
      if (typeof n != "object" || n === null)
        return "object expected";
      let o = {};
      if (n.dependency != null && n.hasOwnProperty("dependency") && !$util.isString(n.dependency))
        return "dependency: string expected";
      if (n.name != null && n.hasOwnProperty("name") && !$util.isString(n.name))
        return "name: string expected";
      if (n.raw != null && n.hasOwnProperty("raw")) {
        o.file = 1;
        {
          let c = $root.permutive.RawFile.verify(n.raw);
          if (c)
            return "raw." + c;
        }
      }
      if (n.zip != null && n.hasOwnProperty("zip")) {
        if (o.file === 1)
          return "file: multiple values";
        o.file = 1;
        {
          let c = $root.permutive.ZipFile.verify(n.zip);
          if (c)
            return "zip." + c;
        }
      }
      return null;
    }, r.fromObject = function(n) {
      if (n instanceof $root.permutive.SinkInput)
        return n;
      let o = new $root.permutive.SinkInput();
      if (n.dependency != null && (o.dependency = String(n.dependency)), n.name != null && (o.name = String(n.name)), n.raw != null) {
        if (typeof n.raw != "object")
          throw TypeError(".permutive.SinkInput.raw: object expected");
        o.raw = $root.permutive.RawFile.fromObject(n.raw);
      }
      if (n.zip != null) {
        if (typeof n.zip != "object")
          throw TypeError(".permutive.SinkInput.zip: object expected");
        o.zip = $root.permutive.ZipFile.fromObject(n.zip);
      }
      return o;
    }, r.toObject = function(n, o) {
      o || (o = {});
      let c = {};
      return o.defaults && (c.dependency = "", c.name = ""), n.dependency != null && n.hasOwnProperty("dependency") && (c.dependency = n.dependency), n.name != null && n.hasOwnProperty("name") && (c.name = n.name), n.raw != null && n.hasOwnProperty("raw") && (c.raw = $root.permutive.RawFile.toObject(n.raw, o), o.oneofs && (c.file = "raw")), n.zip != null && n.hasOwnProperty("zip") && (c.zip = $root.permutive.ZipFile.toObject(n.zip, o), o.oneofs && (c.file = "zip")), c;
    }, r.prototype.toJSON = function() {
      return this.constructor.toObject(this, minimal.util.toJSONOptions);
    }, r.getTypeUrl = function(n) {
      return n === void 0 && (n = "type.googleapis.com"), n + "/permutive.SinkInput";
    }, r;
  }(), u.PermutiveWorkerConfiguration = function() {
    function r(e) {
      if (e)
        for (let n = Object.keys(e), o = 0; o < n.length; ++o)
          e[n[o]] != null && (this[n[o]] = e[n[o]]);
    }
    r.prototype.credentialsDependency = "", r.prototype.importRole = null, r.prototype.exportRole = null, r.prototype.importId = "", r.prototype.segmentName = "", r.prototype.segmentCode = "", r.prototype.inputHasHeaders = !1;
    let a;
    return Object.defineProperty(r.prototype, "role", {
      get: $util.oneOfGetter(a = ["importRole", "exportRole"]),
      set: $util.oneOfSetter(a)
    }), r.create = function(n) {
      return new r(n);
    }, r.encode = function(n, o) {
      return o || (o = $Writer.create()), n.credentialsDependency != null && Object.hasOwnProperty.call(n, "credentialsDependency") && o.uint32(
        /* id 1, wireType 2 =*/
        10
      ).string(n.credentialsDependency), n.importRole != null && Object.hasOwnProperty.call(n, "importRole") && $root.permutive.ImportRole.encode(n.importRole, o.uint32(
        /* id 2, wireType 2 =*/
        18
      ).fork()).ldelim(), n.exportRole != null && Object.hasOwnProperty.call(n, "exportRole") && $root.permutive.ExportRole.encode(n.exportRole, o.uint32(
        /* id 3, wireType 2 =*/
        26
      ).fork()).ldelim(), n.importId != null && Object.hasOwnProperty.call(n, "importId") && o.uint32(
        /* id 4, wireType 2 =*/
        34
      ).string(n.importId), n.segmentName != null && Object.hasOwnProperty.call(n, "segmentName") && o.uint32(
        /* id 5, wireType 2 =*/
        42
      ).string(n.segmentName), n.segmentCode != null && Object.hasOwnProperty.call(n, "segmentCode") && o.uint32(
        /* id 6, wireType 2 =*/
        50
      ).string(n.segmentCode), n.inputHasHeaders != null && Object.hasOwnProperty.call(n, "inputHasHeaders") && o.uint32(
        /* id 7, wireType 0 =*/
        56
      ).bool(n.inputHasHeaders), o;
    }, r.encodeDelimited = function(n, o) {
      return this.encode(n, o).ldelim();
    }, r.decode = function(n, o) {
      n instanceof $Reader || (n = $Reader.create(n));
      let c = o === void 0 ? n.len : n.pos + o, l = new $root.permutive.PermutiveWorkerConfiguration();
      for (; n.pos < c; ) {
        let d = n.uint32();
        switch (d >>> 3) {
          case 1: {
            l.credentialsDependency = n.string();
            break;
          }
          case 2: {
            l.importRole = $root.permutive.ImportRole.decode(n, n.uint32());
            break;
          }
          case 3: {
            l.exportRole = $root.permutive.ExportRole.decode(n, n.uint32());
            break;
          }
          case 4: {
            l.importId = n.string();
            break;
          }
          case 5: {
            l.segmentName = n.string();
            break;
          }
          case 6: {
            l.segmentCode = n.string();
            break;
          }
          case 7: {
            l.inputHasHeaders = n.bool();
            break;
          }
          default:
            n.skipType(d & 7);
            break;
        }
      }
      return l;
    }, r.decodeDelimited = function(n) {
      return n instanceof $Reader || (n = new $Reader(n)), this.decode(n, n.uint32());
    }, r.verify = function(n) {
      if (typeof n != "object" || n === null)
        return "object expected";
      let o = {};
      if (n.credentialsDependency != null && n.hasOwnProperty("credentialsDependency") && !$util.isString(n.credentialsDependency))
        return "credentialsDependency: string expected";
      if (n.importRole != null && n.hasOwnProperty("importRole")) {
        o.role = 1;
        {
          let c = $root.permutive.ImportRole.verify(n.importRole);
          if (c)
            return "importRole." + c;
        }
      }
      if (n.exportRole != null && n.hasOwnProperty("exportRole")) {
        if (o.role === 1)
          return "role: multiple values";
        o.role = 1;
        {
          let c = $root.permutive.ExportRole.verify(n.exportRole);
          if (c)
            return "exportRole." + c;
        }
      }
      return n.importId != null && n.hasOwnProperty("importId") && !$util.isString(n.importId) ? "importId: string expected" : n.segmentName != null && n.hasOwnProperty("segmentName") && !$util.isString(n.segmentName) ? "segmentName: string expected" : n.segmentCode != null && n.hasOwnProperty("segmentCode") && !$util.isString(n.segmentCode) ? "segmentCode: string expected" : n.inputHasHeaders != null && n.hasOwnProperty("inputHasHeaders") && typeof n.inputHasHeaders != "boolean" ? "inputHasHeaders: boolean expected" : null;
    }, r.fromObject = function(n) {
      if (n instanceof $root.permutive.PermutiveWorkerConfiguration)
        return n;
      let o = new $root.permutive.PermutiveWorkerConfiguration();
      if (n.credentialsDependency != null && (o.credentialsDependency = String(n.credentialsDependency)), n.importRole != null) {
        if (typeof n.importRole != "object")
          throw TypeError(".permutive.PermutiveWorkerConfiguration.importRole: object expected");
        o.importRole = $root.permutive.ImportRole.fromObject(n.importRole);
      }
      if (n.exportRole != null) {
        if (typeof n.exportRole != "object")
          throw TypeError(".permutive.PermutiveWorkerConfiguration.exportRole: object expected");
        o.exportRole = $root.permutive.ExportRole.fromObject(n.exportRole);
      }
      return n.importId != null && (o.importId = String(n.importId)), n.segmentName != null && (o.segmentName = String(n.segmentName)), n.segmentCode != null && (o.segmentCode = String(n.segmentCode)), n.inputHasHeaders != null && (o.inputHasHeaders = !!n.inputHasHeaders), o;
    }, r.toObject = function(n, o) {
      o || (o = {});
      let c = {};
      return o.defaults && (c.credentialsDependency = "", c.importId = "", c.segmentName = "", c.segmentCode = "", c.inputHasHeaders = !1), n.credentialsDependency != null && n.hasOwnProperty("credentialsDependency") && (c.credentialsDependency = n.credentialsDependency), n.importRole != null && n.hasOwnProperty("importRole") && (c.importRole = $root.permutive.ImportRole.toObject(n.importRole, o), o.oneofs && (c.role = "importRole")), n.exportRole != null && n.hasOwnProperty("exportRole") && (c.exportRole = $root.permutive.ExportRole.toObject(n.exportRole, o), o.oneofs && (c.role = "exportRole")), n.importId != null && n.hasOwnProperty("importId") && (c.importId = n.importId), n.segmentName != null && n.hasOwnProperty("segmentName") && (c.segmentName = n.segmentName), n.segmentCode != null && n.hasOwnProperty("segmentCode") && (c.segmentCode = n.segmentCode), n.inputHasHeaders != null && n.hasOwnProperty("inputHasHeaders") && (c.inputHasHeaders = n.inputHasHeaders), c;
    }, r.prototype.toJSON = function() {
      return this.constructor.toObject(this, minimal.util.toJSONOptions);
    }, r.getTypeUrl = function(n) {
      return n === void 0 && (n = "type.googleapis.com"), n + "/permutive.PermutiveWorkerConfiguration";
    }, r;
  }(), u;
})();
$root.salesforce = (() => {
  const u = {};
  return u.Core = function() {
    function r(a) {
      if (a)
        for (let e = Object.keys(a), n = 0; n < e.length; ++n)
          a[e[n]] != null && (this[e[n]] = a[e[n]]);
    }
    return r.create = function(e) {
      return new r(e);
    }, r.encode = function(e, n) {
      return n || (n = $Writer.create()), n;
    }, r.encodeDelimited = function(e, n) {
      return this.encode(e, n).ldelim();
    }, r.decode = function(e, n) {
      e instanceof $Reader || (e = $Reader.create(e));
      let o = n === void 0 ? e.len : e.pos + n, c = new $root.salesforce.Core();
      for (; e.pos < o; ) {
        let l = e.uint32();
        switch (l >>> 3) {
          default:
            e.skipType(l & 7);
            break;
        }
      }
      return c;
    }, r.decodeDelimited = function(e) {
      return e instanceof $Reader || (e = new $Reader(e)), this.decode(e, e.uint32());
    }, r.verify = function(e) {
      return typeof e != "object" || e === null ? "object expected" : null;
    }, r.fromObject = function(e) {
      return e instanceof $root.salesforce.Core ? e : new $root.salesforce.Core();
    }, r.toObject = function() {
      return {};
    }, r.prototype.toJSON = function() {
      return this.constructor.toObject(this, minimal.util.toJSONOptions);
    }, r.getTypeUrl = function(e) {
      return e === void 0 && (e = "type.googleapis.com"), e + "/salesforce.Core";
    }, r;
  }(), u.MarketingCloud = function() {
    function r(a) {
      if (a)
        for (let e = Object.keys(a), n = 0; n < e.length; ++n)
          a[e[n]] != null && (this[e[n]] = a[e[n]]);
    }
    return r.create = function(e) {
      return new r(e);
    }, r.encode = function(e, n) {
      return n || (n = $Writer.create()), n;
    }, r.encodeDelimited = function(e, n) {
      return this.encode(e, n).ldelim();
    }, r.decode = function(e, n) {
      e instanceof $Reader || (e = $Reader.create(e));
      let o = n === void 0 ? e.len : e.pos + n, c = new $root.salesforce.MarketingCloud();
      for (; e.pos < o; ) {
        let l = e.uint32();
        switch (l >>> 3) {
          default:
            e.skipType(l & 7);
            break;
        }
      }
      return c;
    }, r.decodeDelimited = function(e) {
      return e instanceof $Reader || (e = new $Reader(e)), this.decode(e, e.uint32());
    }, r.verify = function(e) {
      return typeof e != "object" || e === null ? "object expected" : null;
    }, r.fromObject = function(e) {
      return e instanceof $root.salesforce.MarketingCloud ? e : new $root.salesforce.MarketingCloud();
    }, r.toObject = function() {
      return {};
    }, r.prototype.toJSON = function() {
      return this.constructor.toObject(this, minimal.util.toJSONOptions);
    }, r.getTypeUrl = function(e) {
      return e === void 0 && (e = "type.googleapis.com"), e + "/salesforce.MarketingCloud";
    }, r;
  }(), u.ImportRole = function() {
    function r(e) {
      if (e)
        for (let n = Object.keys(e), o = 0; o < n.length; ++o)
          e[n[o]] != null && (this[n[o]] = e[n[o]]);
    }
    r.prototype.core = null, r.prototype.marketingCloud = null;
    let a;
    return Object.defineProperty(r.prototype, "productType", {
      get: $util.oneOfGetter(a = ["core", "marketingCloud"]),
      set: $util.oneOfSetter(a)
    }), r.create = function(n) {
      return new r(n);
    }, r.encode = function(n, o) {
      return o || (o = $Writer.create()), n.core != null && Object.hasOwnProperty.call(n, "core") && $root.salesforce.Core.encode(n.core, o.uint32(
        /* id 1, wireType 2 =*/
        10
      ).fork()).ldelim(), n.marketingCloud != null && Object.hasOwnProperty.call(n, "marketingCloud") && $root.salesforce.MarketingCloud.encode(n.marketingCloud, o.uint32(
        /* id 2, wireType 2 =*/
        18
      ).fork()).ldelim(), o;
    }, r.encodeDelimited = function(n, o) {
      return this.encode(n, o).ldelim();
    }, r.decode = function(n, o) {
      n instanceof $Reader || (n = $Reader.create(n));
      let c = o === void 0 ? n.len : n.pos + o, l = new $root.salesforce.ImportRole();
      for (; n.pos < c; ) {
        let d = n.uint32();
        switch (d >>> 3) {
          case 1: {
            l.core = $root.salesforce.Core.decode(n, n.uint32());
            break;
          }
          case 2: {
            l.marketingCloud = $root.salesforce.MarketingCloud.decode(n, n.uint32());
            break;
          }
          default:
            n.skipType(d & 7);
            break;
        }
      }
      return l;
    }, r.decodeDelimited = function(n) {
      return n instanceof $Reader || (n = new $Reader(n)), this.decode(n, n.uint32());
    }, r.verify = function(n) {
      if (typeof n != "object" || n === null)
        return "object expected";
      let o = {};
      if (n.core != null && n.hasOwnProperty("core")) {
        o.productType = 1;
        {
          let c = $root.salesforce.Core.verify(n.core);
          if (c)
            return "core." + c;
        }
      }
      if (n.marketingCloud != null && n.hasOwnProperty("marketingCloud")) {
        if (o.productType === 1)
          return "productType: multiple values";
        o.productType = 1;
        {
          let c = $root.salesforce.MarketingCloud.verify(n.marketingCloud);
          if (c)
            return "marketingCloud." + c;
        }
      }
      return null;
    }, r.fromObject = function(n) {
      if (n instanceof $root.salesforce.ImportRole)
        return n;
      let o = new $root.salesforce.ImportRole();
      if (n.core != null) {
        if (typeof n.core != "object")
          throw TypeError(".salesforce.ImportRole.core: object expected");
        o.core = $root.salesforce.Core.fromObject(n.core);
      }
      if (n.marketingCloud != null) {
        if (typeof n.marketingCloud != "object")
          throw TypeError(".salesforce.ImportRole.marketingCloud: object expected");
        o.marketingCloud = $root.salesforce.MarketingCloud.fromObject(n.marketingCloud);
      }
      return o;
    }, r.toObject = function(n, o) {
      o || (o = {});
      let c = {};
      return n.core != null && n.hasOwnProperty("core") && (c.core = $root.salesforce.Core.toObject(n.core, o), o.oneofs && (c.productType = "core")), n.marketingCloud != null && n.hasOwnProperty("marketingCloud") && (c.marketingCloud = $root.salesforce.MarketingCloud.toObject(n.marketingCloud, o), o.oneofs && (c.productType = "marketingCloud")), c;
    }, r.prototype.toJSON = function() {
      return this.constructor.toObject(this, minimal.util.toJSONOptions);
    }, r.getTypeUrl = function(n) {
      return n === void 0 && (n = "type.googleapis.com"), n + "/salesforce.ImportRole";
    }, r;
  }(), u.ExportRole = function() {
    function r(a) {
      if (a)
        for (let e = Object.keys(a), n = 0; n < e.length; ++n)
          a[e[n]] != null && (this[e[n]] = a[e[n]]);
    }
    return r.prototype.input = null, r.create = function(e) {
      return new r(e);
    }, r.encode = function(e, n) {
      return n || (n = $Writer.create()), e.input != null && Object.hasOwnProperty.call(e, "input") && $root.salesforce.SinkInput.encode(e.input, n.uint32(
        /* id 1, wireType 2 =*/
        10
      ).fork()).ldelim(), n;
    }, r.encodeDelimited = function(e, n) {
      return this.encode(e, n).ldelim();
    }, r.decode = function(e, n) {
      e instanceof $Reader || (e = $Reader.create(e));
      let o = n === void 0 ? e.len : e.pos + n, c = new $root.salesforce.ExportRole();
      for (; e.pos < o; ) {
        let l = e.uint32();
        switch (l >>> 3) {
          case 1: {
            c.input = $root.salesforce.SinkInput.decode(e, e.uint32());
            break;
          }
          default:
            e.skipType(l & 7);
            break;
        }
      }
      return c;
    }, r.decodeDelimited = function(e) {
      return e instanceof $Reader || (e = new $Reader(e)), this.decode(e, e.uint32());
    }, r.verify = function(e) {
      if (typeof e != "object" || e === null)
        return "object expected";
      if (e.input != null && e.hasOwnProperty("input")) {
        let n = $root.salesforce.SinkInput.verify(e.input);
        if (n)
          return "input." + n;
      }
      return null;
    }, r.fromObject = function(e) {
      if (e instanceof $root.salesforce.ExportRole)
        return e;
      let n = new $root.salesforce.ExportRole();
      if (e.input != null) {
        if (typeof e.input != "object")
          throw TypeError(".salesforce.ExportRole.input: object expected");
        n.input = $root.salesforce.SinkInput.fromObject(e.input);
      }
      return n;
    }, r.toObject = function(e, n) {
      n || (n = {});
      let o = {};
      return n.defaults && (o.input = null), e.input != null && e.hasOwnProperty("input") && (o.input = $root.salesforce.SinkInput.toObject(e.input, n)), o;
    }, r.prototype.toJSON = function() {
      return this.constructor.toObject(this, minimal.util.toJSONOptions);
    }, r.getTypeUrl = function(e) {
      return e === void 0 && (e = "type.googleapis.com"), e + "/salesforce.ExportRole";
    }, r;
  }(), u.SingleFile = function() {
    function r(a) {
      if (a)
        for (let e = Object.keys(a), n = 0; n < e.length; ++n)
          a[e[n]] != null && (this[e[n]] = a[e[n]]);
    }
    return r.prototype.name = "", r.create = function(e) {
      return new r(e);
    }, r.encode = function(e, n) {
      return n || (n = $Writer.create()), e.name != null && Object.hasOwnProperty.call(e, "name") && n.uint32(
        /* id 1, wireType 2 =*/
        10
      ).string(e.name), n;
    }, r.encodeDelimited = function(e, n) {
      return this.encode(e, n).ldelim();
    }, r.decode = function(e, n) {
      e instanceof $Reader || (e = $Reader.create(e));
      let o = n === void 0 ? e.len : e.pos + n, c = new $root.salesforce.SingleFile();
      for (; e.pos < o; ) {
        let l = e.uint32();
        switch (l >>> 3) {
          case 1: {
            c.name = e.string();
            break;
          }
          default:
            e.skipType(l & 7);
            break;
        }
      }
      return c;
    }, r.decodeDelimited = function(e) {
      return e instanceof $Reader || (e = new $Reader(e)), this.decode(e, e.uint32());
    }, r.verify = function(e) {
      return typeof e != "object" || e === null ? "object expected" : e.name != null && e.hasOwnProperty("name") && !$util.isString(e.name) ? "name: string expected" : null;
    }, r.fromObject = function(e) {
      if (e instanceof $root.salesforce.SingleFile)
        return e;
      let n = new $root.salesforce.SingleFile();
      return e.name != null && (n.name = String(e.name)), n;
    }, r.toObject = function(e, n) {
      n || (n = {});
      let o = {};
      return n.defaults && (o.name = ""), e.name != null && e.hasOwnProperty("name") && (o.name = e.name), o;
    }, r.prototype.toJSON = function() {
      return this.constructor.toObject(this, minimal.util.toJSONOptions);
    }, r.getTypeUrl = function(e) {
      return e === void 0 && (e = "type.googleapis.com"), e + "/salesforce.SingleFile";
    }, r;
  }(), u.RawFile = function() {
    function r(a) {
      if (a)
        for (let e = Object.keys(a), n = 0; n < e.length; ++n)
          a[e[n]] != null && (this[e[n]] = a[e[n]]);
    }
    return r.create = function(e) {
      return new r(e);
    }, r.encode = function(e, n) {
      return n || (n = $Writer.create()), n;
    }, r.encodeDelimited = function(e, n) {
      return this.encode(e, n).ldelim();
    }, r.decode = function(e, n) {
      e instanceof $Reader || (e = $Reader.create(e));
      let o = n === void 0 ? e.len : e.pos + n, c = new $root.salesforce.RawFile();
      for (; e.pos < o; ) {
        let l = e.uint32();
        switch (l >>> 3) {
          default:
            e.skipType(l & 7);
            break;
        }
      }
      return c;
    }, r.decodeDelimited = function(e) {
      return e instanceof $Reader || (e = new $Reader(e)), this.decode(e, e.uint32());
    }, r.verify = function(e) {
      return typeof e != "object" || e === null ? "object expected" : null;
    }, r.fromObject = function(e) {
      return e instanceof $root.salesforce.RawFile ? e : new $root.salesforce.RawFile();
    }, r.toObject = function() {
      return {};
    }, r.prototype.toJSON = function() {
      return this.constructor.toObject(this, minimal.util.toJSONOptions);
    }, r.getTypeUrl = function(e) {
      return e === void 0 && (e = "type.googleapis.com"), e + "/salesforce.RawFile";
    }, r;
  }(), u.ZipFile = function() {
    function r(e) {
      if (e)
        for (let n = Object.keys(e), o = 0; o < n.length; ++o)
          e[n[o]] != null && (this[n[o]] = e[n[o]]);
    }
    r.prototype.singleFile = null;
    let a;
    return Object.defineProperty(r.prototype, "selection", {
      get: $util.oneOfGetter(a = ["singleFile"]),
      set: $util.oneOfSetter(a)
    }), r.create = function(n) {
      return new r(n);
    }, r.encode = function(n, o) {
      return o || (o = $Writer.create()), n.singleFile != null && Object.hasOwnProperty.call(n, "singleFile") && $root.salesforce.SingleFile.encode(n.singleFile, o.uint32(
        /* id 1, wireType 2 =*/
        10
      ).fork()).ldelim(), o;
    }, r.encodeDelimited = function(n, o) {
      return this.encode(n, o).ldelim();
    }, r.decode = function(n, o) {
      n instanceof $Reader || (n = $Reader.create(n));
      let c = o === void 0 ? n.len : n.pos + o, l = new $root.salesforce.ZipFile();
      for (; n.pos < c; ) {
        let d = n.uint32();
        switch (d >>> 3) {
          case 1: {
            l.singleFile = $root.salesforce.SingleFile.decode(n, n.uint32());
            break;
          }
          default:
            n.skipType(d & 7);
            break;
        }
      }
      return l;
    }, r.decodeDelimited = function(n) {
      return n instanceof $Reader || (n = new $Reader(n)), this.decode(n, n.uint32());
    }, r.verify = function(n) {
      if (typeof n != "object" || n === null)
        return "object expected";
      if (n.singleFile != null && n.hasOwnProperty("singleFile")) {
        let o = $root.salesforce.SingleFile.verify(n.singleFile);
        if (o)
          return "singleFile." + o;
      }
      return null;
    }, r.fromObject = function(n) {
      if (n instanceof $root.salesforce.ZipFile)
        return n;
      let o = new $root.salesforce.ZipFile();
      if (n.singleFile != null) {
        if (typeof n.singleFile != "object")
          throw TypeError(".salesforce.ZipFile.singleFile: object expected");
        o.singleFile = $root.salesforce.SingleFile.fromObject(n.singleFile);
      }
      return o;
    }, r.toObject = function(n, o) {
      o || (o = {});
      let c = {};
      return n.singleFile != null && n.hasOwnProperty("singleFile") && (c.singleFile = $root.salesforce.SingleFile.toObject(n.singleFile, o), o.oneofs && (c.selection = "singleFile")), c;
    }, r.prototype.toJSON = function() {
      return this.constructor.toObject(this, minimal.util.toJSONOptions);
    }, r.getTypeUrl = function(n) {
      return n === void 0 && (n = "type.googleapis.com"), n + "/salesforce.ZipFile";
    }, r;
  }(), u.SinkInput = function() {
    function r(e) {
      if (e)
        for (let n = Object.keys(e), o = 0; o < n.length; ++o)
          e[n[o]] != null && (this[n[o]] = e[n[o]]);
    }
    r.prototype.dependency = "", r.prototype.name = "", r.prototype.raw = null, r.prototype.zip = null;
    let a;
    return Object.defineProperty(r.prototype, "file", {
      get: $util.oneOfGetter(a = ["raw", "zip"]),
      set: $util.oneOfSetter(a)
    }), r.create = function(n) {
      return new r(n);
    }, r.encode = function(n, o) {
      return o || (o = $Writer.create()), n.dependency != null && Object.hasOwnProperty.call(n, "dependency") && o.uint32(
        /* id 1, wireType 2 =*/
        10
      ).string(n.dependency), n.name != null && Object.hasOwnProperty.call(n, "name") && o.uint32(
        /* id 2, wireType 2 =*/
        18
      ).string(n.name), n.raw != null && Object.hasOwnProperty.call(n, "raw") && $root.salesforce.RawFile.encode(n.raw, o.uint32(
        /* id 3, wireType 2 =*/
        26
      ).fork()).ldelim(), n.zip != null && Object.hasOwnProperty.call(n, "zip") && $root.salesforce.ZipFile.encode(n.zip, o.uint32(
        /* id 4, wireType 2 =*/
        34
      ).fork()).ldelim(), o;
    }, r.encodeDelimited = function(n, o) {
      return this.encode(n, o).ldelim();
    }, r.decode = function(n, o) {
      n instanceof $Reader || (n = $Reader.create(n));
      let c = o === void 0 ? n.len : n.pos + o, l = new $root.salesforce.SinkInput();
      for (; n.pos < c; ) {
        let d = n.uint32();
        switch (d >>> 3) {
          case 1: {
            l.dependency = n.string();
            break;
          }
          case 2: {
            l.name = n.string();
            break;
          }
          case 3: {
            l.raw = $root.salesforce.RawFile.decode(n, n.uint32());
            break;
          }
          case 4: {
            l.zip = $root.salesforce.ZipFile.decode(n, n.uint32());
            break;
          }
          default:
            n.skipType(d & 7);
            break;
        }
      }
      return l;
    }, r.decodeDelimited = function(n) {
      return n instanceof $Reader || (n = new $Reader(n)), this.decode(n, n.uint32());
    }, r.verify = function(n) {
      if (typeof n != "object" || n === null)
        return "object expected";
      let o = {};
      if (n.dependency != null && n.hasOwnProperty("dependency") && !$util.isString(n.dependency))
        return "dependency: string expected";
      if (n.name != null && n.hasOwnProperty("name") && !$util.isString(n.name))
        return "name: string expected";
      if (n.raw != null && n.hasOwnProperty("raw")) {
        o.file = 1;
        {
          let c = $root.salesforce.RawFile.verify(n.raw);
          if (c)
            return "raw." + c;
        }
      }
      if (n.zip != null && n.hasOwnProperty("zip")) {
        if (o.file === 1)
          return "file: multiple values";
        o.file = 1;
        {
          let c = $root.salesforce.ZipFile.verify(n.zip);
          if (c)
            return "zip." + c;
        }
      }
      return null;
    }, r.fromObject = function(n) {
      if (n instanceof $root.salesforce.SinkInput)
        return n;
      let o = new $root.salesforce.SinkInput();
      if (n.dependency != null && (o.dependency = String(n.dependency)), n.name != null && (o.name = String(n.name)), n.raw != null) {
        if (typeof n.raw != "object")
          throw TypeError(".salesforce.SinkInput.raw: object expected");
        o.raw = $root.salesforce.RawFile.fromObject(n.raw);
      }
      if (n.zip != null) {
        if (typeof n.zip != "object")
          throw TypeError(".salesforce.SinkInput.zip: object expected");
        o.zip = $root.salesforce.ZipFile.fromObject(n.zip);
      }
      return o;
    }, r.toObject = function(n, o) {
      o || (o = {});
      let c = {};
      return o.defaults && (c.dependency = "", c.name = ""), n.dependency != null && n.hasOwnProperty("dependency") && (c.dependency = n.dependency), n.name != null && n.hasOwnProperty("name") && (c.name = n.name), n.raw != null && n.hasOwnProperty("raw") && (c.raw = $root.salesforce.RawFile.toObject(n.raw, o), o.oneofs && (c.file = "raw")), n.zip != null && n.hasOwnProperty("zip") && (c.zip = $root.salesforce.ZipFile.toObject(n.zip, o), o.oneofs && (c.file = "zip")), c;
    }, r.prototype.toJSON = function() {
      return this.constructor.toObject(this, minimal.util.toJSONOptions);
    }, r.getTypeUrl = function(n) {
      return n === void 0 && (n = "type.googleapis.com"), n + "/salesforce.SinkInput";
    }, r;
  }(), u.SalesforceWorkerConfiguration = function() {
    function r(e) {
      if (e)
        for (let n = Object.keys(e), o = 0; o < n.length; ++o)
          e[n[o]] != null && (this[n[o]] = e[n[o]]);
    }
    r.prototype.credentialsDependency = "", r.prototype.importRole = null, r.prototype.exportRole = null, r.prototype.domainUrl = "", r.prototype.apiName = "";
    let a;
    return Object.defineProperty(r.prototype, "role", {
      get: $util.oneOfGetter(a = ["importRole", "exportRole"]),
      set: $util.oneOfSetter(a)
    }), r.create = function(n) {
      return new r(n);
    }, r.encode = function(n, o) {
      return o || (o = $Writer.create()), n.credentialsDependency != null && Object.hasOwnProperty.call(n, "credentialsDependency") && o.uint32(
        /* id 1, wireType 2 =*/
        10
      ).string(n.credentialsDependency), n.importRole != null && Object.hasOwnProperty.call(n, "importRole") && $root.salesforce.ImportRole.encode(n.importRole, o.uint32(
        /* id 2, wireType 2 =*/
        18
      ).fork()).ldelim(), n.exportRole != null && Object.hasOwnProperty.call(n, "exportRole") && $root.salesforce.ExportRole.encode(n.exportRole, o.uint32(
        /* id 3, wireType 2 =*/
        26
      ).fork()).ldelim(), n.domainUrl != null && Object.hasOwnProperty.call(n, "domainUrl") && o.uint32(
        /* id 4, wireType 2 =*/
        34
      ).string(n.domainUrl), n.apiName != null && Object.hasOwnProperty.call(n, "apiName") && o.uint32(
        /* id 5, wireType 2 =*/
        42
      ).string(n.apiName), o;
    }, r.encodeDelimited = function(n, o) {
      return this.encode(n, o).ldelim();
    }, r.decode = function(n, o) {
      n instanceof $Reader || (n = $Reader.create(n));
      let c = o === void 0 ? n.len : n.pos + o, l = new $root.salesforce.SalesforceWorkerConfiguration();
      for (; n.pos < c; ) {
        let d = n.uint32();
        switch (d >>> 3) {
          case 1: {
            l.credentialsDependency = n.string();
            break;
          }
          case 2: {
            l.importRole = $root.salesforce.ImportRole.decode(n, n.uint32());
            break;
          }
          case 3: {
            l.exportRole = $root.salesforce.ExportRole.decode(n, n.uint32());
            break;
          }
          case 4: {
            l.domainUrl = n.string();
            break;
          }
          case 5: {
            l.apiName = n.string();
            break;
          }
          default:
            n.skipType(d & 7);
            break;
        }
      }
      return l;
    }, r.decodeDelimited = function(n) {
      return n instanceof $Reader || (n = new $Reader(n)), this.decode(n, n.uint32());
    }, r.verify = function(n) {
      if (typeof n != "object" || n === null)
        return "object expected";
      let o = {};
      if (n.credentialsDependency != null && n.hasOwnProperty("credentialsDependency") && !$util.isString(n.credentialsDependency))
        return "credentialsDependency: string expected";
      if (n.importRole != null && n.hasOwnProperty("importRole")) {
        o.role = 1;
        {
          let c = $root.salesforce.ImportRole.verify(n.importRole);
          if (c)
            return "importRole." + c;
        }
      }
      if (n.exportRole != null && n.hasOwnProperty("exportRole")) {
        if (o.role === 1)
          return "role: multiple values";
        o.role = 1;
        {
          let c = $root.salesforce.ExportRole.verify(n.exportRole);
          if (c)
            return "exportRole." + c;
        }
      }
      return n.domainUrl != null && n.hasOwnProperty("domainUrl") && !$util.isString(n.domainUrl) ? "domainUrl: string expected" : n.apiName != null && n.hasOwnProperty("apiName") && !$util.isString(n.apiName) ? "apiName: string expected" : null;
    }, r.fromObject = function(n) {
      if (n instanceof $root.salesforce.SalesforceWorkerConfiguration)
        return n;
      let o = new $root.salesforce.SalesforceWorkerConfiguration();
      if (n.credentialsDependency != null && (o.credentialsDependency = String(n.credentialsDependency)), n.importRole != null) {
        if (typeof n.importRole != "object")
          throw TypeError(".salesforce.SalesforceWorkerConfiguration.importRole: object expected");
        o.importRole = $root.salesforce.ImportRole.fromObject(n.importRole);
      }
      if (n.exportRole != null) {
        if (typeof n.exportRole != "object")
          throw TypeError(".salesforce.SalesforceWorkerConfiguration.exportRole: object expected");
        o.exportRole = $root.salesforce.ExportRole.fromObject(n.exportRole);
      }
      return n.domainUrl != null && (o.domainUrl = String(n.domainUrl)), n.apiName != null && (o.apiName = String(n.apiName)), o;
    }, r.toObject = function(n, o) {
      o || (o = {});
      let c = {};
      return o.defaults && (c.credentialsDependency = "", c.domainUrl = "", c.apiName = ""), n.credentialsDependency != null && n.hasOwnProperty("credentialsDependency") && (c.credentialsDependency = n.credentialsDependency), n.importRole != null && n.hasOwnProperty("importRole") && (c.importRole = $root.salesforce.ImportRole.toObject(n.importRole, o), o.oneofs && (c.role = "importRole")), n.exportRole != null && n.hasOwnProperty("exportRole") && (c.exportRole = $root.salesforce.ExportRole.toObject(n.exportRole, o), o.oneofs && (c.role = "exportRole")), n.domainUrl != null && n.hasOwnProperty("domainUrl") && (c.domainUrl = n.domainUrl), n.apiName != null && n.hasOwnProperty("apiName") && (c.apiName = n.apiName), c;
    }, r.prototype.toJSON = function() {
      return this.constructor.toObject(this, minimal.util.toJSONOptions);
    }, r.getTypeUrl = function(n) {
      return n === void 0 && (n = "type.googleapis.com"), n + "/salesforce.SalesforceWorkerConfiguration";
    }, r;
  }(), u;
})();
$root.synth_data = (() => {
  const u = {};
  return u.SyntheticDataConf = function() {
    function r(a) {
      if (this.columns = [], a)
        for (let e = Object.keys(a), n = 0; n < e.length; ++n)
          a[e[n]] != null && (this[e[n]] = a[e[n]]);
    }
    return r.prototype.columns = $util.emptyArray, r.prototype.outputOriginalDataStats = !1, r.prototype.epsilon = 0, r.create = function(e) {
      return new r(e);
    }, r.encode = function(e, n) {
      if (n || (n = $Writer.create()), e.columns != null && e.columns.length)
        for (let o = 0; o < e.columns.length; ++o)
          $root.synth_data.Column.encode(e.columns[o], n.uint32(
            /* id 1, wireType 2 =*/
            10
          ).fork()).ldelim();
      return e.outputOriginalDataStats != null && Object.hasOwnProperty.call(e, "outputOriginalDataStats") && n.uint32(
        /* id 2, wireType 0 =*/
        16
      ).bool(e.outputOriginalDataStats), e.epsilon != null && Object.hasOwnProperty.call(e, "epsilon") && n.uint32(
        /* id 3, wireType 5 =*/
        29
      ).float(e.epsilon), n;
    }, r.encodeDelimited = function(e, n) {
      return this.encode(e, n).ldelim();
    }, r.decode = function(e, n) {
      e instanceof $Reader || (e = $Reader.create(e));
      let o = n === void 0 ? e.len : e.pos + n, c = new $root.synth_data.SyntheticDataConf();
      for (; e.pos < o; ) {
        let l = e.uint32();
        switch (l >>> 3) {
          case 1: {
            c.columns && c.columns.length || (c.columns = []), c.columns.push($root.synth_data.Column.decode(e, e.uint32()));
            break;
          }
          case 2: {
            c.outputOriginalDataStats = e.bool();
            break;
          }
          case 3: {
            c.epsilon = e.float();
            break;
          }
          default:
            e.skipType(l & 7);
            break;
        }
      }
      return c;
    }, r.decodeDelimited = function(e) {
      return e instanceof $Reader || (e = new $Reader(e)), this.decode(e, e.uint32());
    }, r.verify = function(e) {
      if (typeof e != "object" || e === null)
        return "object expected";
      if (e.columns != null && e.hasOwnProperty("columns")) {
        if (!Array.isArray(e.columns))
          return "columns: array expected";
        for (let n = 0; n < e.columns.length; ++n) {
          let o = $root.synth_data.Column.verify(e.columns[n]);
          if (o)
            return "columns." + o;
        }
      }
      return e.outputOriginalDataStats != null && e.hasOwnProperty("outputOriginalDataStats") && typeof e.outputOriginalDataStats != "boolean" ? "outputOriginalDataStats: boolean expected" : e.epsilon != null && e.hasOwnProperty("epsilon") && typeof e.epsilon != "number" ? "epsilon: number expected" : null;
    }, r.fromObject = function(e) {
      if (e instanceof $root.synth_data.SyntheticDataConf)
        return e;
      let n = new $root.synth_data.SyntheticDataConf();
      if (e.columns) {
        if (!Array.isArray(e.columns))
          throw TypeError(".synth_data.SyntheticDataConf.columns: array expected");
        n.columns = [];
        for (let o = 0; o < e.columns.length; ++o) {
          if (typeof e.columns[o] != "object")
            throw TypeError(".synth_data.SyntheticDataConf.columns: object expected");
          n.columns[o] = $root.synth_data.Column.fromObject(e.columns[o]);
        }
      }
      return e.outputOriginalDataStats != null && (n.outputOriginalDataStats = !!e.outputOriginalDataStats), e.epsilon != null && (n.epsilon = Number(e.epsilon)), n;
    }, r.toObject = function(e, n) {
      n || (n = {});
      let o = {};
      if ((n.arrays || n.defaults) && (o.columns = []), n.defaults && (o.outputOriginalDataStats = !1, o.epsilon = 0), e.columns && e.columns.length) {
        o.columns = [];
        for (let c = 0; c < e.columns.length; ++c)
          o.columns[c] = $root.synth_data.Column.toObject(e.columns[c], n);
      }
      return e.outputOriginalDataStats != null && e.hasOwnProperty("outputOriginalDataStats") && (o.outputOriginalDataStats = e.outputOriginalDataStats), e.epsilon != null && e.hasOwnProperty("epsilon") && (o.epsilon = n.json && !isFinite(e.epsilon) ? String(e.epsilon) : e.epsilon), o;
    }, r.prototype.toJSON = function() {
      return this.constructor.toObject(this, minimal.util.toJSONOptions);
    }, r.getTypeUrl = function(e) {
      return e === void 0 && (e = "type.googleapis.com"), e + "/synth_data.SyntheticDataConf";
    }, r;
  }(), u.Mask = function() {
    function r(a) {
      if (a)
        for (let e = Object.keys(a), n = 0; n < e.length; ++n)
          a[e[n]] != null && (this[e[n]] = a[e[n]]);
    }
    return r.prototype.format = 0, r.create = function(e) {
      return new r(e);
    }, r.encode = function(e, n) {
      return n || (n = $Writer.create()), e.format != null && Object.hasOwnProperty.call(e, "format") && n.uint32(
        /* id 1, wireType 0 =*/
        8
      ).int32(e.format), n;
    }, r.encodeDelimited = function(e, n) {
      return this.encode(e, n).ldelim();
    }, r.decode = function(e, n) {
      e instanceof $Reader || (e = $Reader.create(e));
      let o = n === void 0 ? e.len : e.pos + n, c = new $root.synth_data.Mask();
      for (; e.pos < o; ) {
        let l = e.uint32();
        switch (l >>> 3) {
          case 1: {
            c.format = e.int32();
            break;
          }
          default:
            e.skipType(l & 7);
            break;
        }
      }
      return c;
    }, r.decodeDelimited = function(e) {
      return e instanceof $Reader || (e = new $Reader(e)), this.decode(e, e.uint32());
    }, r.verify = function(e) {
      if (typeof e != "object" || e === null)
        return "object expected";
      if (e.format != null && e.hasOwnProperty("format"))
        switch (e.format) {
          default:
            return "format: enum value expected";
          case 0:
          case 1:
          case 2:
          case 3:
          case 4:
          case 5:
          case 6:
          case 7:
          case 8:
          case 9:
          case 10:
            break;
        }
      return null;
    }, r.fromObject = function(e) {
      if (e instanceof $root.synth_data.Mask)
        return e;
      let n = new $root.synth_data.Mask();
      switch (e.format) {
        default:
          if (typeof e.format == "number") {
            n.format = e.format;
            break;
          }
          break;
        case "GENERIC_STRING":
        case 0:
          n.format = 0;
          break;
        case "GENERIC_NUMBER":
        case 1:
          n.format = 1;
          break;
        case "NAME":
        case 2:
          n.format = 2;
          break;
        case "ADDRESS":
        case 3:
          n.format = 3;
          break;
        case "POSTCODE":
        case 4:
          n.format = 4;
          break;
        case "PHONE_NUMBER":
        case 5:
          n.format = 5;
          break;
        case "SOCIAL_SECURITY_NUMBER":
        case 6:
          n.format = 6;
          break;
        case "EMAIL":
        case 7:
          n.format = 7;
          break;
        case "DATE":
        case 8:
          n.format = 8;
          break;
        case "TIMESTAMP":
        case 9:
          n.format = 9;
          break;
        case "IBAN":
        case 10:
          n.format = 10;
          break;
      }
      return n;
    }, r.toObject = function(e, n) {
      n || (n = {});
      let o = {};
      return n.defaults && (o.format = n.enums === String ? "GENERIC_STRING" : 0), e.format != null && e.hasOwnProperty("format") && (o.format = n.enums === String ? $root.synth_data.Mask.MaskFormat[e.format] === void 0 ? e.format : $root.synth_data.Mask.MaskFormat[e.format] : e.format), o;
    }, r.prototype.toJSON = function() {
      return this.constructor.toObject(this, minimal.util.toJSONOptions);
    }, r.getTypeUrl = function(e) {
      return e === void 0 && (e = "type.googleapis.com"), e + "/synth_data.Mask";
    }, r.MaskFormat = function() {
      const a = {}, e = Object.create(a);
      return e[a[0] = "GENERIC_STRING"] = 0, e[a[1] = "GENERIC_NUMBER"] = 1, e[a[2] = "NAME"] = 2, e[a[3] = "ADDRESS"] = 3, e[a[4] = "POSTCODE"] = 4, e[a[5] = "PHONE_NUMBER"] = 5, e[a[6] = "SOCIAL_SECURITY_NUMBER"] = 6, e[a[7] = "EMAIL"] = 7, e[a[8] = "DATE"] = 8, e[a[9] = "TIMESTAMP"] = 9, e[a[10] = "IBAN"] = 10, e;
    }(), r;
  }(), u.Column = function() {
    function r(a) {
      if (a)
        for (let e = Object.keys(a), n = 0; n < e.length; ++n)
          a[e[n]] != null && (this[e[n]] = a[e[n]]);
    }
    return r.prototype.index = 0, r.prototype.type = null, r.prototype.mask = null, r.create = function(e) {
      return new r(e);
    }, r.encode = function(e, n) {
      return n || (n = $Writer.create()), e.index != null && Object.hasOwnProperty.call(e, "index") && n.uint32(
        /* id 1, wireType 0 =*/
        8
      ).int32(e.index), e.type != null && Object.hasOwnProperty.call(e, "type") && $root.compute_sql.ColumnType.encode(e.type, n.uint32(
        /* id 2, wireType 2 =*/
        18
      ).fork()).ldelim(), e.mask != null && Object.hasOwnProperty.call(e, "mask") && $root.synth_data.Mask.encode(e.mask, n.uint32(
        /* id 3, wireType 2 =*/
        26
      ).fork()).ldelim(), n;
    }, r.encodeDelimited = function(e, n) {
      return this.encode(e, n).ldelim();
    }, r.decode = function(e, n) {
      e instanceof $Reader || (e = $Reader.create(e));
      let o = n === void 0 ? e.len : e.pos + n, c = new $root.synth_data.Column();
      for (; e.pos < o; ) {
        let l = e.uint32();
        switch (l >>> 3) {
          case 1: {
            c.index = e.int32();
            break;
          }
          case 2: {
            c.type = $root.compute_sql.ColumnType.decode(e, e.uint32());
            break;
          }
          case 3: {
            c.mask = $root.synth_data.Mask.decode(e, e.uint32());
            break;
          }
          default:
            e.skipType(l & 7);
            break;
        }
      }
      return c;
    }, r.decodeDelimited = function(e) {
      return e instanceof $Reader || (e = new $Reader(e)), this.decode(e, e.uint32());
    }, r.verify = function(e) {
      if (typeof e != "object" || e === null)
        return "object expected";
      if (e.index != null && e.hasOwnProperty("index") && !$util.isInteger(e.index))
        return "index: integer expected";
      if (e.type != null && e.hasOwnProperty("type")) {
        let n = $root.compute_sql.ColumnType.verify(e.type);
        if (n)
          return "type." + n;
      }
      if (e.mask != null && e.hasOwnProperty("mask")) {
        let n = $root.synth_data.Mask.verify(e.mask);
        if (n)
          return "mask." + n;
      }
      return null;
    }, r.fromObject = function(e) {
      if (e instanceof $root.synth_data.Column)
        return e;
      let n = new $root.synth_data.Column();
      if (e.index != null && (n.index = e.index | 0), e.type != null) {
        if (typeof e.type != "object")
          throw TypeError(".synth_data.Column.type: object expected");
        n.type = $root.compute_sql.ColumnType.fromObject(e.type);
      }
      if (e.mask != null) {
        if (typeof e.mask != "object")
          throw TypeError(".synth_data.Column.mask: object expected");
        n.mask = $root.synth_data.Mask.fromObject(e.mask);
      }
      return n;
    }, r.toObject = function(e, n) {
      n || (n = {});
      let o = {};
      return n.defaults && (o.index = 0, o.type = null, o.mask = null), e.index != null && e.hasOwnProperty("index") && (o.index = e.index), e.type != null && e.hasOwnProperty("type") && (o.type = $root.compute_sql.ColumnType.toObject(e.type, n)), e.mask != null && e.hasOwnProperty("mask") && (o.mask = $root.synth_data.Mask.toObject(e.mask, n)), o;
    }, r.prototype.toJSON = function() {
      return this.constructor.toObject(this, minimal.util.toJSONOptions);
    }, r.getTypeUrl = function(e) {
      return e === void 0 && (e = "type.googleapis.com"), e + "/synth_data.Column";
    }, r;
  }(), u;
})();
$root.adform_dsp = (() => {
  const u = {};
  return u.SingleFile = function() {
    function r(a) {
      if (a)
        for (let e = Object.keys(a), n = 0; n < e.length; ++n)
          a[e[n]] != null && (this[e[n]] = a[e[n]]);
    }
    return r.prototype.name = "", r.create = function(e) {
      return new r(e);
    }, r.encode = function(e, n) {
      return n || (n = $Writer.create()), e.name != null && Object.hasOwnProperty.call(e, "name") && n.uint32(
        /* id 1, wireType 2 =*/
        10
      ).string(e.name), n;
    }, r.encodeDelimited = function(e, n) {
      return this.encode(e, n).ldelim();
    }, r.decode = function(e, n) {
      e instanceof $Reader || (e = $Reader.create(e));
      let o = n === void 0 ? e.len : e.pos + n, c = new $root.adform_dsp.SingleFile();
      for (; e.pos < o; ) {
        let l = e.uint32();
        switch (l >>> 3) {
          case 1: {
            c.name = e.string();
            break;
          }
          default:
            e.skipType(l & 7);
            break;
        }
      }
      return c;
    }, r.decodeDelimited = function(e) {
      return e instanceof $Reader || (e = new $Reader(e)), this.decode(e, e.uint32());
    }, r.verify = function(e) {
      return typeof e != "object" || e === null ? "object expected" : e.name != null && e.hasOwnProperty("name") && !$util.isString(e.name) ? "name: string expected" : null;
    }, r.fromObject = function(e) {
      if (e instanceof $root.adform_dsp.SingleFile)
        return e;
      let n = new $root.adform_dsp.SingleFile();
      return e.name != null && (n.name = String(e.name)), n;
    }, r.toObject = function(e, n) {
      n || (n = {});
      let o = {};
      return n.defaults && (o.name = ""), e.name != null && e.hasOwnProperty("name") && (o.name = e.name), o;
    }, r.prototype.toJSON = function() {
      return this.constructor.toObject(this, minimal.util.toJSONOptions);
    }, r.getTypeUrl = function(e) {
      return e === void 0 && (e = "type.googleapis.com"), e + "/adform_dsp.SingleFile";
    }, r;
  }(), u.RawFile = function() {
    function r(a) {
      if (a)
        for (let e = Object.keys(a), n = 0; n < e.length; ++n)
          a[e[n]] != null && (this[e[n]] = a[e[n]]);
    }
    return r.create = function(e) {
      return new r(e);
    }, r.encode = function(e, n) {
      return n || (n = $Writer.create()), n;
    }, r.encodeDelimited = function(e, n) {
      return this.encode(e, n).ldelim();
    }, r.decode = function(e, n) {
      e instanceof $Reader || (e = $Reader.create(e));
      let o = n === void 0 ? e.len : e.pos + n, c = new $root.adform_dsp.RawFile();
      for (; e.pos < o; ) {
        let l = e.uint32();
        switch (l >>> 3) {
          default:
            e.skipType(l & 7);
            break;
        }
      }
      return c;
    }, r.decodeDelimited = function(e) {
      return e instanceof $Reader || (e = new $Reader(e)), this.decode(e, e.uint32());
    }, r.verify = function(e) {
      return typeof e != "object" || e === null ? "object expected" : null;
    }, r.fromObject = function(e) {
      return e instanceof $root.adform_dsp.RawFile ? e : new $root.adform_dsp.RawFile();
    }, r.toObject = function() {
      return {};
    }, r.prototype.toJSON = function() {
      return this.constructor.toObject(this, minimal.util.toJSONOptions);
    }, r.getTypeUrl = function(e) {
      return e === void 0 && (e = "type.googleapis.com"), e + "/adform_dsp.RawFile";
    }, r;
  }(), u.ZipFile = function() {
    function r(e) {
      if (e)
        for (let n = Object.keys(e), o = 0; o < n.length; ++o)
          e[n[o]] != null && (this[n[o]] = e[n[o]]);
    }
    r.prototype.singleFile = null;
    let a;
    return Object.defineProperty(r.prototype, "selection", {
      get: $util.oneOfGetter(a = ["singleFile"]),
      set: $util.oneOfSetter(a)
    }), r.create = function(n) {
      return new r(n);
    }, r.encode = function(n, o) {
      return o || (o = $Writer.create()), n.singleFile != null && Object.hasOwnProperty.call(n, "singleFile") && $root.adform_dsp.SingleFile.encode(n.singleFile, o.uint32(
        /* id 1, wireType 2 =*/
        10
      ).fork()).ldelim(), o;
    }, r.encodeDelimited = function(n, o) {
      return this.encode(n, o).ldelim();
    }, r.decode = function(n, o) {
      n instanceof $Reader || (n = $Reader.create(n));
      let c = o === void 0 ? n.len : n.pos + o, l = new $root.adform_dsp.ZipFile();
      for (; n.pos < c; ) {
        let d = n.uint32();
        switch (d >>> 3) {
          case 1: {
            l.singleFile = $root.adform_dsp.SingleFile.decode(n, n.uint32());
            break;
          }
          default:
            n.skipType(d & 7);
            break;
        }
      }
      return l;
    }, r.decodeDelimited = function(n) {
      return n instanceof $Reader || (n = new $Reader(n)), this.decode(n, n.uint32());
    }, r.verify = function(n) {
      if (typeof n != "object" || n === null)
        return "object expected";
      if (n.singleFile != null && n.hasOwnProperty("singleFile")) {
        let o = $root.adform_dsp.SingleFile.verify(n.singleFile);
        if (o)
          return "singleFile." + o;
      }
      return null;
    }, r.fromObject = function(n) {
      if (n instanceof $root.adform_dsp.ZipFile)
        return n;
      let o = new $root.adform_dsp.ZipFile();
      if (n.singleFile != null) {
        if (typeof n.singleFile != "object")
          throw TypeError(".adform_dsp.ZipFile.singleFile: object expected");
        o.singleFile = $root.adform_dsp.SingleFile.fromObject(n.singleFile);
      }
      return o;
    }, r.toObject = function(n, o) {
      o || (o = {});
      let c = {};
      return n.singleFile != null && n.hasOwnProperty("singleFile") && (c.singleFile = $root.adform_dsp.SingleFile.toObject(n.singleFile, o), o.oneofs && (c.selection = "singleFile")), c;
    }, r.prototype.toJSON = function() {
      return this.constructor.toObject(this, minimal.util.toJSONOptions);
    }, r.getTypeUrl = function(n) {
      return n === void 0 && (n = "type.googleapis.com"), n + "/adform_dsp.ZipFile";
    }, r;
  }(), u.SinkInput = function() {
    function r(e) {
      if (e)
        for (let n = Object.keys(e), o = 0; o < n.length; ++o)
          e[n[o]] != null && (this[n[o]] = e[n[o]]);
    }
    r.prototype.dependency = "", r.prototype.name = "", r.prototype.raw = null, r.prototype.zip = null;
    let a;
    return Object.defineProperty(r.prototype, "file", {
      get: $util.oneOfGetter(a = ["raw", "zip"]),
      set: $util.oneOfSetter(a)
    }), r.create = function(n) {
      return new r(n);
    }, r.encode = function(n, o) {
      return o || (o = $Writer.create()), n.dependency != null && Object.hasOwnProperty.call(n, "dependency") && o.uint32(
        /* id 1, wireType 2 =*/
        10
      ).string(n.dependency), n.name != null && Object.hasOwnProperty.call(n, "name") && o.uint32(
        /* id 2, wireType 2 =*/
        18
      ).string(n.name), n.raw != null && Object.hasOwnProperty.call(n, "raw") && $root.adform_dsp.RawFile.encode(n.raw, o.uint32(
        /* id 3, wireType 2 =*/
        26
      ).fork()).ldelim(), n.zip != null && Object.hasOwnProperty.call(n, "zip") && $root.adform_dsp.ZipFile.encode(n.zip, o.uint32(
        /* id 4, wireType 2 =*/
        34
      ).fork()).ldelim(), o;
    }, r.encodeDelimited = function(n, o) {
      return this.encode(n, o).ldelim();
    }, r.decode = function(n, o) {
      n instanceof $Reader || (n = $Reader.create(n));
      let c = o === void 0 ? n.len : n.pos + o, l = new $root.adform_dsp.SinkInput();
      for (; n.pos < c; ) {
        let d = n.uint32();
        switch (d >>> 3) {
          case 1: {
            l.dependency = n.string();
            break;
          }
          case 2: {
            l.name = n.string();
            break;
          }
          case 3: {
            l.raw = $root.adform_dsp.RawFile.decode(n, n.uint32());
            break;
          }
          case 4: {
            l.zip = $root.adform_dsp.ZipFile.decode(n, n.uint32());
            break;
          }
          default:
            n.skipType(d & 7);
            break;
        }
      }
      return l;
    }, r.decodeDelimited = function(n) {
      return n instanceof $Reader || (n = new $Reader(n)), this.decode(n, n.uint32());
    }, r.verify = function(n) {
      if (typeof n != "object" || n === null)
        return "object expected";
      let o = {};
      if (n.dependency != null && n.hasOwnProperty("dependency") && !$util.isString(n.dependency))
        return "dependency: string expected";
      if (n.name != null && n.hasOwnProperty("name") && !$util.isString(n.name))
        return "name: string expected";
      if (n.raw != null && n.hasOwnProperty("raw")) {
        o.file = 1;
        {
          let c = $root.adform_dsp.RawFile.verify(n.raw);
          if (c)
            return "raw." + c;
        }
      }
      if (n.zip != null && n.hasOwnProperty("zip")) {
        if (o.file === 1)
          return "file: multiple values";
        o.file = 1;
        {
          let c = $root.adform_dsp.ZipFile.verify(n.zip);
          if (c)
            return "zip." + c;
        }
      }
      return null;
    }, r.fromObject = function(n) {
      if (n instanceof $root.adform_dsp.SinkInput)
        return n;
      let o = new $root.adform_dsp.SinkInput();
      if (n.dependency != null && (o.dependency = String(n.dependency)), n.name != null && (o.name = String(n.name)), n.raw != null) {
        if (typeof n.raw != "object")
          throw TypeError(".adform_dsp.SinkInput.raw: object expected");
        o.raw = $root.adform_dsp.RawFile.fromObject(n.raw);
      }
      if (n.zip != null) {
        if (typeof n.zip != "object")
          throw TypeError(".adform_dsp.SinkInput.zip: object expected");
        o.zip = $root.adform_dsp.ZipFile.fromObject(n.zip);
      }
      return o;
    }, r.toObject = function(n, o) {
      o || (o = {});
      let c = {};
      return o.defaults && (c.dependency = "", c.name = ""), n.dependency != null && n.hasOwnProperty("dependency") && (c.dependency = n.dependency), n.name != null && n.hasOwnProperty("name") && (c.name = n.name), n.raw != null && n.hasOwnProperty("raw") && (c.raw = $root.adform_dsp.RawFile.toObject(n.raw, o), o.oneofs && (c.file = "raw")), n.zip != null && n.hasOwnProperty("zip") && (c.zip = $root.adform_dsp.ZipFile.toObject(n.zip, o), o.oneofs && (c.file = "zip")), c;
    }, r.prototype.toJSON = function() {
      return this.constructor.toObject(this, minimal.util.toJSONOptions);
    }, r.getTypeUrl = function(n) {
      return n === void 0 && (n = "type.googleapis.com"), n + "/adform_dsp.SinkInput";
    }, r;
  }(), u.AdformDspWorkerConfiguration = function() {
    function r(a) {
      if (this.segmentOwners = [], a)
        for (let e = Object.keys(a), n = 0; n < e.length; ++n)
          a[e[n]] != null && (this[e[n]] = a[e[n]]);
    }
    return r.prototype.input = null, r.prototype.segmentOwners = $util.emptyArray, r.create = function(e) {
      return new r(e);
    }, r.encode = function(e, n) {
      if (n || (n = $Writer.create()), e.input != null && Object.hasOwnProperty.call(e, "input") && $root.adform_dsp.SinkInput.encode(e.input, n.uint32(
        /* id 1, wireType 2 =*/
        10
      ).fork()).ldelim(), e.segmentOwners != null && e.segmentOwners.length)
        for (let o = 0; o < e.segmentOwners.length; ++o)
          n.uint32(
            /* id 2, wireType 2 =*/
            18
          ).string(e.segmentOwners[o]);
      return n;
    }, r.encodeDelimited = function(e, n) {
      return this.encode(e, n).ldelim();
    }, r.decode = function(e, n) {
      e instanceof $Reader || (e = $Reader.create(e));
      let o = n === void 0 ? e.len : e.pos + n, c = new $root.adform_dsp.AdformDspWorkerConfiguration();
      for (; e.pos < o; ) {
        let l = e.uint32();
        switch (l >>> 3) {
          case 1: {
            c.input = $root.adform_dsp.SinkInput.decode(e, e.uint32());
            break;
          }
          case 2: {
            c.segmentOwners && c.segmentOwners.length || (c.segmentOwners = []), c.segmentOwners.push(e.string());
            break;
          }
          default:
            e.skipType(l & 7);
            break;
        }
      }
      return c;
    }, r.decodeDelimited = function(e) {
      return e instanceof $Reader || (e = new $Reader(e)), this.decode(e, e.uint32());
    }, r.verify = function(e) {
      if (typeof e != "object" || e === null)
        return "object expected";
      if (e.input != null && e.hasOwnProperty("input")) {
        let n = $root.adform_dsp.SinkInput.verify(e.input);
        if (n)
          return "input." + n;
      }
      if (e.segmentOwners != null && e.hasOwnProperty("segmentOwners")) {
        if (!Array.isArray(e.segmentOwners))
          return "segmentOwners: array expected";
        for (let n = 0; n < e.segmentOwners.length; ++n)
          if (!$util.isString(e.segmentOwners[n]))
            return "segmentOwners: string[] expected";
      }
      return null;
    }, r.fromObject = function(e) {
      if (e instanceof $root.adform_dsp.AdformDspWorkerConfiguration)
        return e;
      let n = new $root.adform_dsp.AdformDspWorkerConfiguration();
      if (e.input != null) {
        if (typeof e.input != "object")
          throw TypeError(".adform_dsp.AdformDspWorkerConfiguration.input: object expected");
        n.input = $root.adform_dsp.SinkInput.fromObject(e.input);
      }
      if (e.segmentOwners) {
        if (!Array.isArray(e.segmentOwners))
          throw TypeError(".adform_dsp.AdformDspWorkerConfiguration.segmentOwners: array expected");
        n.segmentOwners = [];
        for (let o = 0; o < e.segmentOwners.length; ++o)
          n.segmentOwners[o] = String(e.segmentOwners[o]);
      }
      return n;
    }, r.toObject = function(e, n) {
      n || (n = {});
      let o = {};
      if ((n.arrays || n.defaults) && (o.segmentOwners = []), n.defaults && (o.input = null), e.input != null && e.hasOwnProperty("input") && (o.input = $root.adform_dsp.SinkInput.toObject(e.input, n)), e.segmentOwners && e.segmentOwners.length) {
        o.segmentOwners = [];
        for (let c = 0; c < e.segmentOwners.length; ++c)
          o.segmentOwners[c] = e.segmentOwners[c];
      }
      return o;
    }, r.prototype.toJSON = function() {
      return this.constructor.toObject(this, minimal.util.toJSONOptions);
    }, r.getTypeUrl = function(e) {
      return e === void 0 && (e = "type.googleapis.com"), e + "/adform_dsp.AdformDspWorkerConfiguration";
    }, r;
  }(), u;
})();
$root.microsoft_dsp = (() => {
  const u = {};
  return u.SingleFile = function() {
    function r(a) {
      if (a)
        for (let e = Object.keys(a), n = 0; n < e.length; ++n)
          a[e[n]] != null && (this[e[n]] = a[e[n]]);
    }
    return r.prototype.name = "", r.create = function(e) {
      return new r(e);
    }, r.encode = function(e, n) {
      return n || (n = $Writer.create()), e.name != null && Object.hasOwnProperty.call(e, "name") && n.uint32(
        /* id 1, wireType 2 =*/
        10
      ).string(e.name), n;
    }, r.encodeDelimited = function(e, n) {
      return this.encode(e, n).ldelim();
    }, r.decode = function(e, n) {
      e instanceof $Reader || (e = $Reader.create(e));
      let o = n === void 0 ? e.len : e.pos + n, c = new $root.microsoft_dsp.SingleFile();
      for (; e.pos < o; ) {
        let l = e.uint32();
        switch (l >>> 3) {
          case 1: {
            c.name = e.string();
            break;
          }
          default:
            e.skipType(l & 7);
            break;
        }
      }
      return c;
    }, r.decodeDelimited = function(e) {
      return e instanceof $Reader || (e = new $Reader(e)), this.decode(e, e.uint32());
    }, r.verify = function(e) {
      return typeof e != "object" || e === null ? "object expected" : e.name != null && e.hasOwnProperty("name") && !$util.isString(e.name) ? "name: string expected" : null;
    }, r.fromObject = function(e) {
      if (e instanceof $root.microsoft_dsp.SingleFile)
        return e;
      let n = new $root.microsoft_dsp.SingleFile();
      return e.name != null && (n.name = String(e.name)), n;
    }, r.toObject = function(e, n) {
      n || (n = {});
      let o = {};
      return n.defaults && (o.name = ""), e.name != null && e.hasOwnProperty("name") && (o.name = e.name), o;
    }, r.prototype.toJSON = function() {
      return this.constructor.toObject(this, minimal.util.toJSONOptions);
    }, r.getTypeUrl = function(e) {
      return e === void 0 && (e = "type.googleapis.com"), e + "/microsoft_dsp.SingleFile";
    }, r;
  }(), u.RawFile = function() {
    function r(a) {
      if (a)
        for (let e = Object.keys(a), n = 0; n < e.length; ++n)
          a[e[n]] != null && (this[e[n]] = a[e[n]]);
    }
    return r.create = function(e) {
      return new r(e);
    }, r.encode = function(e, n) {
      return n || (n = $Writer.create()), n;
    }, r.encodeDelimited = function(e, n) {
      return this.encode(e, n).ldelim();
    }, r.decode = function(e, n) {
      e instanceof $Reader || (e = $Reader.create(e));
      let o = n === void 0 ? e.len : e.pos + n, c = new $root.microsoft_dsp.RawFile();
      for (; e.pos < o; ) {
        let l = e.uint32();
        switch (l >>> 3) {
          default:
            e.skipType(l & 7);
            break;
        }
      }
      return c;
    }, r.decodeDelimited = function(e) {
      return e instanceof $Reader || (e = new $Reader(e)), this.decode(e, e.uint32());
    }, r.verify = function(e) {
      return typeof e != "object" || e === null ? "object expected" : null;
    }, r.fromObject = function(e) {
      return e instanceof $root.microsoft_dsp.RawFile ? e : new $root.microsoft_dsp.RawFile();
    }, r.toObject = function() {
      return {};
    }, r.prototype.toJSON = function() {
      return this.constructor.toObject(this, minimal.util.toJSONOptions);
    }, r.getTypeUrl = function(e) {
      return e === void 0 && (e = "type.googleapis.com"), e + "/microsoft_dsp.RawFile";
    }, r;
  }(), u.ZipFile = function() {
    function r(e) {
      if (e)
        for (let n = Object.keys(e), o = 0; o < n.length; ++o)
          e[n[o]] != null && (this[n[o]] = e[n[o]]);
    }
    r.prototype.singleFile = null;
    let a;
    return Object.defineProperty(r.prototype, "selection", {
      get: $util.oneOfGetter(a = ["singleFile"]),
      set: $util.oneOfSetter(a)
    }), r.create = function(n) {
      return new r(n);
    }, r.encode = function(n, o) {
      return o || (o = $Writer.create()), n.singleFile != null && Object.hasOwnProperty.call(n, "singleFile") && $root.microsoft_dsp.SingleFile.encode(n.singleFile, o.uint32(
        /* id 1, wireType 2 =*/
        10
      ).fork()).ldelim(), o;
    }, r.encodeDelimited = function(n, o) {
      return this.encode(n, o).ldelim();
    }, r.decode = function(n, o) {
      n instanceof $Reader || (n = $Reader.create(n));
      let c = o === void 0 ? n.len : n.pos + o, l = new $root.microsoft_dsp.ZipFile();
      for (; n.pos < c; ) {
        let d = n.uint32();
        switch (d >>> 3) {
          case 1: {
            l.singleFile = $root.microsoft_dsp.SingleFile.decode(n, n.uint32());
            break;
          }
          default:
            n.skipType(d & 7);
            break;
        }
      }
      return l;
    }, r.decodeDelimited = function(n) {
      return n instanceof $Reader || (n = new $Reader(n)), this.decode(n, n.uint32());
    }, r.verify = function(n) {
      if (typeof n != "object" || n === null)
        return "object expected";
      if (n.singleFile != null && n.hasOwnProperty("singleFile")) {
        let o = $root.microsoft_dsp.SingleFile.verify(n.singleFile);
        if (o)
          return "singleFile." + o;
      }
      return null;
    }, r.fromObject = function(n) {
      if (n instanceof $root.microsoft_dsp.ZipFile)
        return n;
      let o = new $root.microsoft_dsp.ZipFile();
      if (n.singleFile != null) {
        if (typeof n.singleFile != "object")
          throw TypeError(".microsoft_dsp.ZipFile.singleFile: object expected");
        o.singleFile = $root.microsoft_dsp.SingleFile.fromObject(n.singleFile);
      }
      return o;
    }, r.toObject = function(n, o) {
      o || (o = {});
      let c = {};
      return n.singleFile != null && n.hasOwnProperty("singleFile") && (c.singleFile = $root.microsoft_dsp.SingleFile.toObject(n.singleFile, o), o.oneofs && (c.selection = "singleFile")), c;
    }, r.prototype.toJSON = function() {
      return this.constructor.toObject(this, minimal.util.toJSONOptions);
    }, r.getTypeUrl = function(n) {
      return n === void 0 && (n = "type.googleapis.com"), n + "/microsoft_dsp.ZipFile";
    }, r;
  }(), u.SinkInput = function() {
    function r(e) {
      if (e)
        for (let n = Object.keys(e), o = 0; o < n.length; ++o)
          e[n[o]] != null && (this[n[o]] = e[n[o]]);
    }
    r.prototype.dependency = "", r.prototype.name = "", r.prototype.raw = null, r.prototype.zip = null;
    let a;
    return Object.defineProperty(r.prototype, "file", {
      get: $util.oneOfGetter(a = ["raw", "zip"]),
      set: $util.oneOfSetter(a)
    }), r.create = function(n) {
      return new r(n);
    }, r.encode = function(n, o) {
      return o || (o = $Writer.create()), n.dependency != null && Object.hasOwnProperty.call(n, "dependency") && o.uint32(
        /* id 1, wireType 2 =*/
        10
      ).string(n.dependency), n.name != null && Object.hasOwnProperty.call(n, "name") && o.uint32(
        /* id 2, wireType 2 =*/
        18
      ).string(n.name), n.raw != null && Object.hasOwnProperty.call(n, "raw") && $root.microsoft_dsp.RawFile.encode(n.raw, o.uint32(
        /* id 3, wireType 2 =*/
        26
      ).fork()).ldelim(), n.zip != null && Object.hasOwnProperty.call(n, "zip") && $root.microsoft_dsp.ZipFile.encode(n.zip, o.uint32(
        /* id 4, wireType 2 =*/
        34
      ).fork()).ldelim(), o;
    }, r.encodeDelimited = function(n, o) {
      return this.encode(n, o).ldelim();
    }, r.decode = function(n, o) {
      n instanceof $Reader || (n = $Reader.create(n));
      let c = o === void 0 ? n.len : n.pos + o, l = new $root.microsoft_dsp.SinkInput();
      for (; n.pos < c; ) {
        let d = n.uint32();
        switch (d >>> 3) {
          case 1: {
            l.dependency = n.string();
            break;
          }
          case 2: {
            l.name = n.string();
            break;
          }
          case 3: {
            l.raw = $root.microsoft_dsp.RawFile.decode(n, n.uint32());
            break;
          }
          case 4: {
            l.zip = $root.microsoft_dsp.ZipFile.decode(n, n.uint32());
            break;
          }
          default:
            n.skipType(d & 7);
            break;
        }
      }
      return l;
    }, r.decodeDelimited = function(n) {
      return n instanceof $Reader || (n = new $Reader(n)), this.decode(n, n.uint32());
    }, r.verify = function(n) {
      if (typeof n != "object" || n === null)
        return "object expected";
      let o = {};
      if (n.dependency != null && n.hasOwnProperty("dependency") && !$util.isString(n.dependency))
        return "dependency: string expected";
      if (n.name != null && n.hasOwnProperty("name") && !$util.isString(n.name))
        return "name: string expected";
      if (n.raw != null && n.hasOwnProperty("raw")) {
        o.file = 1;
        {
          let c = $root.microsoft_dsp.RawFile.verify(n.raw);
          if (c)
            return "raw." + c;
        }
      }
      if (n.zip != null && n.hasOwnProperty("zip")) {
        if (o.file === 1)
          return "file: multiple values";
        o.file = 1;
        {
          let c = $root.microsoft_dsp.ZipFile.verify(n.zip);
          if (c)
            return "zip." + c;
        }
      }
      return null;
    }, r.fromObject = function(n) {
      if (n instanceof $root.microsoft_dsp.SinkInput)
        return n;
      let o = new $root.microsoft_dsp.SinkInput();
      if (n.dependency != null && (o.dependency = String(n.dependency)), n.name != null && (o.name = String(n.name)), n.raw != null) {
        if (typeof n.raw != "object")
          throw TypeError(".microsoft_dsp.SinkInput.raw: object expected");
        o.raw = $root.microsoft_dsp.RawFile.fromObject(n.raw);
      }
      if (n.zip != null) {
        if (typeof n.zip != "object")
          throw TypeError(".microsoft_dsp.SinkInput.zip: object expected");
        o.zip = $root.microsoft_dsp.ZipFile.fromObject(n.zip);
      }
      return o;
    }, r.toObject = function(n, o) {
      o || (o = {});
      let c = {};
      return o.defaults && (c.dependency = "", c.name = ""), n.dependency != null && n.hasOwnProperty("dependency") && (c.dependency = n.dependency), n.name != null && n.hasOwnProperty("name") && (c.name = n.name), n.raw != null && n.hasOwnProperty("raw") && (c.raw = $root.microsoft_dsp.RawFile.toObject(n.raw, o), o.oneofs && (c.file = "raw")), n.zip != null && n.hasOwnProperty("zip") && (c.zip = $root.microsoft_dsp.ZipFile.toObject(n.zip, o), o.oneofs && (c.file = "zip")), c;
    }, r.prototype.toJSON = function() {
      return this.constructor.toObject(this, minimal.util.toJSONOptions);
    }, r.getTypeUrl = function(n) {
      return n === void 0 && (n = "type.googleapis.com"), n + "/microsoft_dsp.SinkInput";
    }, r;
  }(), u.MemberInfo = function() {
    function r(a) {
      if (a)
        for (let e = Object.keys(a), n = 0; n < e.length; ++n)
          a[e[n]] != null && (this[e[n]] = a[e[n]]);
    }
    return r.prototype.id = 0, r.prototype.name = "", r.create = function(e) {
      return new r(e);
    }, r.encode = function(e, n) {
      return n || (n = $Writer.create()), e.id != null && Object.hasOwnProperty.call(e, "id") && n.uint32(
        /* id 1, wireType 0 =*/
        8
      ).int32(e.id), e.name != null && Object.hasOwnProperty.call(e, "name") && n.uint32(
        /* id 2, wireType 2 =*/
        18
      ).string(e.name), n;
    }, r.encodeDelimited = function(e, n) {
      return this.encode(e, n).ldelim();
    }, r.decode = function(e, n) {
      e instanceof $Reader || (e = $Reader.create(e));
      let o = n === void 0 ? e.len : e.pos + n, c = new $root.microsoft_dsp.MemberInfo();
      for (; e.pos < o; ) {
        let l = e.uint32();
        switch (l >>> 3) {
          case 1: {
            c.id = e.int32();
            break;
          }
          case 2: {
            c.name = e.string();
            break;
          }
          default:
            e.skipType(l & 7);
            break;
        }
      }
      return c;
    }, r.decodeDelimited = function(e) {
      return e instanceof $Reader || (e = new $Reader(e)), this.decode(e, e.uint32());
    }, r.verify = function(e) {
      return typeof e != "object" || e === null ? "object expected" : e.id != null && e.hasOwnProperty("id") && !$util.isInteger(e.id) ? "id: integer expected" : e.name != null && e.hasOwnProperty("name") && !$util.isString(e.name) ? "name: string expected" : null;
    }, r.fromObject = function(e) {
      if (e instanceof $root.microsoft_dsp.MemberInfo)
        return e;
      let n = new $root.microsoft_dsp.MemberInfo();
      return e.id != null && (n.id = e.id | 0), e.name != null && (n.name = String(e.name)), n;
    }, r.toObject = function(e, n) {
      n || (n = {});
      let o = {};
      return n.defaults && (o.id = 0, o.name = ""), e.id != null && e.hasOwnProperty("id") && (o.id = e.id), e.name != null && e.hasOwnProperty("name") && (o.name = e.name), o;
    }, r.prototype.toJSON = function() {
      return this.constructor.toObject(this, minimal.util.toJSONOptions);
    }, r.getTypeUrl = function(e) {
      return e === void 0 && (e = "type.googleapis.com"), e + "/microsoft_dsp.MemberInfo";
    }, r;
  }(), u.SegmentInfo = function() {
    function r(a) {
      if (a)
        for (let e = Object.keys(a), n = 0; n < e.length; ++n)
          a[e[n]] != null && (this[e[n]] = a[e[n]]);
    }
    return r.prototype.shortName = "", r.prototype.code = "", r.create = function(e) {
      return new r(e);
    }, r.encode = function(e, n) {
      return n || (n = $Writer.create()), e.shortName != null && Object.hasOwnProperty.call(e, "shortName") && n.uint32(
        /* id 1, wireType 2 =*/
        10
      ).string(e.shortName), e.code != null && Object.hasOwnProperty.call(e, "code") && n.uint32(
        /* id 2, wireType 2 =*/
        18
      ).string(e.code), n;
    }, r.encodeDelimited = function(e, n) {
      return this.encode(e, n).ldelim();
    }, r.decode = function(e, n) {
      e instanceof $Reader || (e = $Reader.create(e));
      let o = n === void 0 ? e.len : e.pos + n, c = new $root.microsoft_dsp.SegmentInfo();
      for (; e.pos < o; ) {
        let l = e.uint32();
        switch (l >>> 3) {
          case 1: {
            c.shortName = e.string();
            break;
          }
          case 2: {
            c.code = e.string();
            break;
          }
          default:
            e.skipType(l & 7);
            break;
        }
      }
      return c;
    }, r.decodeDelimited = function(e) {
      return e instanceof $Reader || (e = new $Reader(e)), this.decode(e, e.uint32());
    }, r.verify = function(e) {
      return typeof e != "object" || e === null ? "object expected" : e.shortName != null && e.hasOwnProperty("shortName") && !$util.isString(e.shortName) ? "shortName: string expected" : e.code != null && e.hasOwnProperty("code") && !$util.isString(e.code) ? "code: string expected" : null;
    }, r.fromObject = function(e) {
      if (e instanceof $root.microsoft_dsp.SegmentInfo)
        return e;
      let n = new $root.microsoft_dsp.SegmentInfo();
      return e.shortName != null && (n.shortName = String(e.shortName)), e.code != null && (n.code = String(e.code)), n;
    }, r.toObject = function(e, n) {
      n || (n = {});
      let o = {};
      return n.defaults && (o.shortName = "", o.code = ""), e.shortName != null && e.hasOwnProperty("shortName") && (o.shortName = e.shortName), e.code != null && e.hasOwnProperty("code") && (o.code = e.code), o;
    }, r.prototype.toJSON = function() {
      return this.constructor.toObject(this, minimal.util.toJSONOptions);
    }, r.getTypeUrl = function(e) {
      return e === void 0 && (e = "type.googleapis.com"), e + "/microsoft_dsp.SegmentInfo";
    }, r;
  }(), u.MicrosoftDspWorkerConfiguration = function() {
    function r(a) {
      if (a)
        for (let e = Object.keys(a), n = 0; n < e.length; ++n)
          a[e[n]] != null && (this[e[n]] = a[e[n]]);
    }
    return r.prototype.input = null, r.prototype.memberInfo = null, r.prototype.segmentInfo = null, r.create = function(e) {
      return new r(e);
    }, r.encode = function(e, n) {
      return n || (n = $Writer.create()), e.input != null && Object.hasOwnProperty.call(e, "input") && $root.microsoft_dsp.SinkInput.encode(e.input, n.uint32(
        /* id 1, wireType 2 =*/
        10
      ).fork()).ldelim(), e.memberInfo != null && Object.hasOwnProperty.call(e, "memberInfo") && $root.microsoft_dsp.MemberInfo.encode(e.memberInfo, n.uint32(
        /* id 2, wireType 2 =*/
        18
      ).fork()).ldelim(), e.segmentInfo != null && Object.hasOwnProperty.call(e, "segmentInfo") && $root.microsoft_dsp.SegmentInfo.encode(e.segmentInfo, n.uint32(
        /* id 3, wireType 2 =*/
        26
      ).fork()).ldelim(), n;
    }, r.encodeDelimited = function(e, n) {
      return this.encode(e, n).ldelim();
    }, r.decode = function(e, n) {
      e instanceof $Reader || (e = $Reader.create(e));
      let o = n === void 0 ? e.len : e.pos + n, c = new $root.microsoft_dsp.MicrosoftDspWorkerConfiguration();
      for (; e.pos < o; ) {
        let l = e.uint32();
        switch (l >>> 3) {
          case 1: {
            c.input = $root.microsoft_dsp.SinkInput.decode(e, e.uint32());
            break;
          }
          case 2: {
            c.memberInfo = $root.microsoft_dsp.MemberInfo.decode(e, e.uint32());
            break;
          }
          case 3: {
            c.segmentInfo = $root.microsoft_dsp.SegmentInfo.decode(e, e.uint32());
            break;
          }
          default:
            e.skipType(l & 7);
            break;
        }
      }
      return c;
    }, r.decodeDelimited = function(e) {
      return e instanceof $Reader || (e = new $Reader(e)), this.decode(e, e.uint32());
    }, r.verify = function(e) {
      if (typeof e != "object" || e === null)
        return "object expected";
      if (e.input != null && e.hasOwnProperty("input")) {
        let n = $root.microsoft_dsp.SinkInput.verify(e.input);
        if (n)
          return "input." + n;
      }
      if (e.memberInfo != null && e.hasOwnProperty("memberInfo")) {
        let n = $root.microsoft_dsp.MemberInfo.verify(e.memberInfo);
        if (n)
          return "memberInfo." + n;
      }
      if (e.segmentInfo != null && e.hasOwnProperty("segmentInfo")) {
        let n = $root.microsoft_dsp.SegmentInfo.verify(e.segmentInfo);
        if (n)
          return "segmentInfo." + n;
      }
      return null;
    }, r.fromObject = function(e) {
      if (e instanceof $root.microsoft_dsp.MicrosoftDspWorkerConfiguration)
        return e;
      let n = new $root.microsoft_dsp.MicrosoftDspWorkerConfiguration();
      if (e.input != null) {
        if (typeof e.input != "object")
          throw TypeError(".microsoft_dsp.MicrosoftDspWorkerConfiguration.input: object expected");
        n.input = $root.microsoft_dsp.SinkInput.fromObject(e.input);
      }
      if (e.memberInfo != null) {
        if (typeof e.memberInfo != "object")
          throw TypeError(".microsoft_dsp.MicrosoftDspWorkerConfiguration.memberInfo: object expected");
        n.memberInfo = $root.microsoft_dsp.MemberInfo.fromObject(e.memberInfo);
      }
      if (e.segmentInfo != null) {
        if (typeof e.segmentInfo != "object")
          throw TypeError(".microsoft_dsp.MicrosoftDspWorkerConfiguration.segmentInfo: object expected");
        n.segmentInfo = $root.microsoft_dsp.SegmentInfo.fromObject(e.segmentInfo);
      }
      return n;
    }, r.toObject = function(e, n) {
      n || (n = {});
      let o = {};
      return n.defaults && (o.input = null, o.memberInfo = null, o.segmentInfo = null), e.input != null && e.hasOwnProperty("input") && (o.input = $root.microsoft_dsp.SinkInput.toObject(e.input, n)), e.memberInfo != null && e.hasOwnProperty("memberInfo") && (o.memberInfo = $root.microsoft_dsp.MemberInfo.toObject(e.memberInfo, n)), e.segmentInfo != null && e.hasOwnProperty("segmentInfo") && (o.segmentInfo = $root.microsoft_dsp.SegmentInfo.toObject(e.segmentInfo, n)), o;
    }, r.prototype.toJSON = function() {
      return this.constructor.toObject(this, minimal.util.toJSONOptions);
    }, r.getTypeUrl = function(e) {
      return e === void 0 && (e = "type.googleapis.com"), e + "/microsoft_dsp.MicrosoftDspWorkerConfiguration";
    }, r;
  }(), u;
})();
/*! *****************************************************************************
Copyright (C) Microsoft. All rights reserved.
Licensed under the Apache License, Version 2.0 (the "License"); you may not use
this file except in compliance with the License. You may obtain a copy of the
License at http://www.apache.org/licenses/LICENSE-2.0

THIS CODE IS PROVIDED ON AN *AS IS* BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
KIND, EITHER EXPRESS OR IMPLIED, INCLUDING WITHOUT LIMITATION ANY IMPLIED
WARRANTIES OR CONDITIONS OF TITLE, FITNESS FOR A PARTICULAR PURPOSE,
MERCHANTABLITY OR NON-INFRINGEMENT.

See the Apache Version 2.0 License for specific language governing permissions
and limitations under the License.
***************************************************************************** */
var Reflect$1;
(function(u) {
  (function(r) {
    var a = typeof commonjsGlobal == "object" ? commonjsGlobal : typeof self == "object" ? self : typeof this == "object" ? this : Function("return this;")(), e = n(u);
    typeof a.Reflect > "u" ? a.Reflect = u : e = n(a.Reflect, e), r(e);
    function n(o, c) {
      return function(l, d) {
        typeof o[l] != "function" && Object.defineProperty(o, l, { configurable: !0, writable: !0, value: d }), c && c(l, d);
      };
    }
  })(function(r) {
    var a = Object.prototype.hasOwnProperty, e = typeof Symbol == "function", n = e && typeof Symbol.toPrimitive < "u" ? Symbol.toPrimitive : "@@toPrimitive", o = e && typeof Symbol.iterator < "u" ? Symbol.iterator : "@@iterator", c = typeof Object.create == "function", l = { __proto__: [] } instanceof Array, d = !c && !l, p = {
      // create an object in dictionary mode (a.k.a. "slow" mode in v8)
      create: c ? function() {
        return Ie(/* @__PURE__ */ Object.create(null));
      } : l ? function() {
        return Ie({ __proto__: null });
      } : function() {
        return Ie({});
      },
      has: d ? function(q, V) {
        return a.call(q, V);
      } : function(q, V) {
        return V in q;
      },
      get: d ? function(q, V) {
        return a.call(q, V) ? q[V] : void 0;
      } : function(q, V) {
        return q[V];
      }
    }, h = Object.getPrototypeOf(Function), g = typeof process == "object" && process.env && process.env.REFLECT_METADATA_USE_MAP_POLYFILL === "true", y = !g && typeof Map == "function" && typeof Map.prototype.entries == "function" ? Map : Ce(), v = !g && typeof Set == "function" && typeof Set.prototype.entries == "function" ? Set : Ae(), m = !g && typeof WeakMap == "function" ? WeakMap : ke(), b = new m();
    function R(q, V, H, G) {
      if (W(H)) {
        if (!se(q))
          throw new TypeError();
        if (!ue(V))
          throw new TypeError();
        return k(q, V);
      } else {
        if (!se(q))
          throw new TypeError();
        if (!ee(V))
          throw new TypeError();
        if (!ee(G) && !W(G) && !ae(G))
          throw new TypeError();
        return ae(G) && (G = void 0), H = ne(H), B(q, V, H, G);
      }
    }
    r("decorate", R);
    function $(q, V) {
      function H(G, re) {
        if (!ee(G))
          throw new TypeError();
        if (!W(re) && !Re(re))
          throw new TypeError();
        K(q, V, G, re);
      }
      return H;
    }
    r("metadata", $);
    function x(q, V, H, G) {
      if (!ee(H))
        throw new TypeError();
      return W(G) || (G = ne(G)), K(q, V, H, G);
    }
    r("defineMetadata", x);
    function E(q, V, H) {
      if (!ee(V))
        throw new TypeError();
      return W(H) || (H = ne(H)), J(q, V, H);
    }
    r("hasMetadata", E);
    function T(q, V, H) {
      if (!ee(V))
        throw new TypeError();
      return W(H) || (H = ne(H)), N(q, V, H);
    }
    r("hasOwnMetadata", T);
    function P(q, V, H) {
      if (!ee(V))
        throw new TypeError();
      return W(H) || (H = ne(H)), F(q, V, H);
    }
    r("getMetadata", P);
    function O(q, V, H) {
      if (!ee(V))
        throw new TypeError();
      return W(H) || (H = ne(H)), U(q, V, H);
    }
    r("getOwnMetadata", O);
    function w(q, V) {
      if (!ee(q))
        throw new TypeError();
      return W(V) || (V = ne(V)), ve(q, V);
    }
    r("getMetadataKeys", w);
    function _(q, V) {
      if (!ee(q))
        throw new TypeError();
      return W(V) || (V = ne(V)), he(q, V);
    }
    r("getOwnMetadataKeys", _);
    function C(q, V, H) {
      if (!ee(V))
        throw new TypeError();
      W(H) || (H = ne(H));
      var G = j(
        V,
        H,
        /*Create*/
        !1
      );
      if (W(G) || !G.delete(q))
        return !1;
      if (G.size > 0)
        return !0;
      var re = b.get(V);
      return re.delete(H), re.size > 0 || b.delete(V), !0;
    }
    r("deleteMetadata", C);
    function k(q, V) {
      for (var H = q.length - 1; H >= 0; --H) {
        var G = q[H], re = G(V);
        if (!W(re) && !ae(re)) {
          if (!ue(re))
            throw new TypeError();
          V = re;
        }
      }
      return V;
    }
    function B(q, V, H, G) {
      for (var re = q.length - 1; re >= 0; --re) {
        var $e = q[re], ce = $e(V, H, G);
        if (!W(ce) && !ae(ce)) {
          if (!ee(ce))
            throw new TypeError();
          G = ce;
        }
      }
      return G;
    }
    function j(q, V, H) {
      var G = b.get(q);
      if (W(G)) {
        if (!H)
          return;
        G = new y(), b.set(q, G);
      }
      var re = G.get(V);
      if (W(re)) {
        if (!H)
          return;
        re = new y(), G.set(V, re);
      }
      return re;
    }
    function J(q, V, H) {
      var G = N(q, V, H);
      if (G)
        return !0;
      var re = _e(V);
      return ae(re) ? !1 : J(q, re, H);
    }
    function N(q, V, H) {
      var G = j(
        V,
        H,
        /*Create*/
        !1
      );
      return W(G) ? !1 : Q(G.has(q));
    }
    function F(q, V, H) {
      var G = N(q, V, H);
      if (G)
        return U(q, V, H);
      var re = _e(V);
      if (!ae(re))
        return F(q, re, H);
    }
    function U(q, V, H) {
      var G = j(
        V,
        H,
        /*Create*/
        !1
      );
      if (!W(G))
        return G.get(q);
    }
    function K(q, V, H, G) {
      var re = j(
        H,
        G,
        /*Create*/
        !0
      );
      re.set(q, V);
    }
    function ve(q, V) {
      var H = he(q, V), G = _e(q);
      if (G === null)
        return H;
      var re = ve(G, V);
      if (re.length <= 0)
        return H;
      if (H.length <= 0)
        return re;
      for (var $e = new v(), ce = [], le = 0, ie = H; le < ie.length; le++) {
        var ye = ie[le], ge = $e.has(ye);
        ge || ($e.add(ye), ce.push(ye));
      }
      for (var xe = 0, Ee = re; xe < Ee.length; xe++) {
        var ye = Ee[xe], ge = $e.has(ye);
        ge || ($e.add(ye), ce.push(ye));
      }
      return ce;
    }
    function he(q, V) {
      var H = [], G = j(
        q,
        V,
        /*Create*/
        !1
      );
      if (W(G))
        return H;
      for (var re = G.keys(), $e = me(re), ce = 0; ; ) {
        var le = De($e);
        if (!le)
          return H.length = ce, H;
        var ie = Oe(le);
        try {
          H[ce] = ie;
        } catch (ye) {
          try {
            we($e);
          } finally {
            throw ye;
          }
        }
        ce++;
      }
    }
    function te(q) {
      if (q === null)
        return 1;
      switch (typeof q) {
        case "undefined":
          return 0;
        case "boolean":
          return 2;
        case "string":
          return 3;
        case "symbol":
          return 4;
        case "number":
          return 5;
        case "object":
          return q === null ? 1 : 6;
        default:
          return 6;
      }
    }
    function W(q) {
      return q === void 0;
    }
    function ae(q) {
      return q === null;
    }
    function fe(q) {
      return typeof q == "symbol";
    }
    function ee(q) {
      return typeof q == "object" ? q !== null : typeof q == "function";
    }
    function Se(q, V) {
      switch (te(q)) {
        case 0:
          return q;
        case 1:
          return q;
        case 2:
          return q;
        case 3:
          return q;
        case 4:
          return q;
        case 5:
          return q;
      }
      var H = "string", G = be(q, n);
      if (G !== void 0) {
        var re = G.call(q, H);
        if (ee(re))
          throw new TypeError();
        return re;
      }
      return pe(q);
    }
    function pe(q, V) {
      var H, G, re;
      {
        var $e = q.toString;
        if (de($e)) {
          var G = $e.call(q);
          if (!ee(G))
            return G;
        }
        var H = q.valueOf;
        if (de(H)) {
          var G = H.call(q);
          if (!ee(G))
            return G;
        }
      }
      throw new TypeError();
    }
    function Q(q) {
      return !!q;
    }
    function oe(q) {
      return "" + q;
    }
    function ne(q) {
      var V = Se(q);
      return fe(V) ? V : oe(V);
    }
    function se(q) {
      return Array.isArray ? Array.isArray(q) : q instanceof Object ? q instanceof Array : Object.prototype.toString.call(q) === "[object Array]";
    }
    function de(q) {
      return typeof q == "function";
    }
    function ue(q) {
      return typeof q == "function";
    }
    function Re(q) {
      switch (te(q)) {
        case 3:
          return !0;
        case 4:
          return !0;
        default:
          return !1;
      }
    }
    function be(q, V) {
      var H = q[V];
      if (H != null) {
        if (!de(H))
          throw new TypeError();
        return H;
      }
    }
    function me(q) {
      var V = be(q, o);
      if (!de(V))
        throw new TypeError();
      var H = V.call(q);
      if (!ee(H))
        throw new TypeError();
      return H;
    }
    function Oe(q) {
      return q.value;
    }
    function De(q) {
      var V = q.next();
      return V.done ? !1 : V;
    }
    function we(q) {
      var V = q.return;
      V && V.call(q);
    }
    function _e(q) {
      var V = Object.getPrototypeOf(q);
      if (typeof q != "function" || q === h || V !== h)
        return V;
      var H = q.prototype, G = H && Object.getPrototypeOf(H);
      if (G == null || G === Object.prototype)
        return V;
      var re = G.constructor;
      return typeof re != "function" || re === q ? V : re;
    }
    function Ce() {
      var q = {}, V = [], H = (
        /** @class */
        function() {
          function ce(le, ie, ye) {
            this._index = 0, this._keys = le, this._values = ie, this._selector = ye;
          }
          return ce.prototype["@@iterator"] = function() {
            return this;
          }, ce.prototype[o] = function() {
            return this;
          }, ce.prototype.next = function() {
            var le = this._index;
            if (le >= 0 && le < this._keys.length) {
              var ie = this._selector(this._keys[le], this._values[le]);
              return le + 1 >= this._keys.length ? (this._index = -1, this._keys = V, this._values = V) : this._index++, { value: ie, done: !1 };
            }
            return { value: void 0, done: !0 };
          }, ce.prototype.throw = function(le) {
            throw this._index >= 0 && (this._index = -1, this._keys = V, this._values = V), le;
          }, ce.prototype.return = function(le) {
            return this._index >= 0 && (this._index = -1, this._keys = V, this._values = V), { value: le, done: !0 };
          }, ce;
        }()
      );
      return (
        /** @class */
        function() {
          function ce() {
            this._keys = [], this._values = [], this._cacheKey = q, this._cacheIndex = -2;
          }
          return Object.defineProperty(ce.prototype, "size", {
            get: function() {
              return this._keys.length;
            },
            enumerable: !0,
            configurable: !0
          }), ce.prototype.has = function(le) {
            return this._find(
              le,
              /*insert*/
              !1
            ) >= 0;
          }, ce.prototype.get = function(le) {
            var ie = this._find(
              le,
              /*insert*/
              !1
            );
            return ie >= 0 ? this._values[ie] : void 0;
          }, ce.prototype.set = function(le, ie) {
            var ye = this._find(
              le,
              /*insert*/
              !0
            );
            return this._values[ye] = ie, this;
          }, ce.prototype.delete = function(le) {
            var ie = this._find(
              le,
              /*insert*/
              !1
            );
            if (ie >= 0) {
              for (var ye = this._keys.length, ge = ie + 1; ge < ye; ge++)
                this._keys[ge - 1] = this._keys[ge], this._values[ge - 1] = this._values[ge];
              return this._keys.length--, this._values.length--, le === this._cacheKey && (this._cacheKey = q, this._cacheIndex = -2), !0;
            }
            return !1;
          }, ce.prototype.clear = function() {
            this._keys.length = 0, this._values.length = 0, this._cacheKey = q, this._cacheIndex = -2;
          }, ce.prototype.keys = function() {
            return new H(this._keys, this._values, G);
          }, ce.prototype.values = function() {
            return new H(this._keys, this._values, re);
          }, ce.prototype.entries = function() {
            return new H(this._keys, this._values, $e);
          }, ce.prototype["@@iterator"] = function() {
            return this.entries();
          }, ce.prototype[o] = function() {
            return this.entries();
          }, ce.prototype._find = function(le, ie) {
            return this._cacheKey !== le && (this._cacheIndex = this._keys.indexOf(this._cacheKey = le)), this._cacheIndex < 0 && ie && (this._cacheIndex = this._keys.length, this._keys.push(le), this._values.push(void 0)), this._cacheIndex;
          }, ce;
        }()
      );
      function G(ce, le) {
        return ce;
      }
      function re(ce, le) {
        return le;
      }
      function $e(ce, le) {
        return [ce, le];
      }
    }
    function Ae() {
      return (
        /** @class */
        function() {
          function q() {
            this._map = new y();
          }
          return Object.defineProperty(q.prototype, "size", {
            get: function() {
              return this._map.size;
            },
            enumerable: !0,
            configurable: !0
          }), q.prototype.has = function(V) {
            return this._map.has(V);
          }, q.prototype.add = function(V) {
            return this._map.set(V, V), this;
          }, q.prototype.delete = function(V) {
            return this._map.delete(V);
          }, q.prototype.clear = function() {
            this._map.clear();
          }, q.prototype.keys = function() {
            return this._map.keys();
          }, q.prototype.values = function() {
            return this._map.values();
          }, q.prototype.entries = function() {
            return this._map.entries();
          }, q.prototype["@@iterator"] = function() {
            return this.keys();
          }, q.prototype[o] = function() {
            return this.keys();
          }, q;
        }()
      );
    }
    function ke() {
      var q = 16, V = p.create(), H = G();
      return (
        /** @class */
        function() {
          function ie() {
            this._key = G();
          }
          return ie.prototype.has = function(ye) {
            var ge = re(
              ye,
              /*create*/
              !1
            );
            return ge !== void 0 ? p.has(ge, this._key) : !1;
          }, ie.prototype.get = function(ye) {
            var ge = re(
              ye,
              /*create*/
              !1
            );
            return ge !== void 0 ? p.get(ge, this._key) : void 0;
          }, ie.prototype.set = function(ye, ge) {
            var xe = re(
              ye,
              /*create*/
              !0
            );
            return xe[this._key] = ge, this;
          }, ie.prototype.delete = function(ye) {
            var ge = re(
              ye,
              /*create*/
              !1
            );
            return ge !== void 0 ? delete ge[this._key] : !1;
          }, ie.prototype.clear = function() {
            this._key = G();
          }, ie;
        }()
      );
      function G() {
        var ie;
        do
          ie = "@@WeakMap@@" + le();
        while (p.has(V, ie));
        return V[ie] = !0, ie;
      }
      function re(ie, ye) {
        if (!a.call(ie, H)) {
          if (!ye)
            return;
          Object.defineProperty(ie, H, { value: p.create() });
        }
        return ie[H];
      }
      function $e(ie, ye) {
        for (var ge = 0; ge < ye; ++ge)
          ie[ge] = Math.random() * 255 | 0;
        return ie;
      }
      function ce(ie) {
        return typeof Uint8Array == "function" ? typeof crypto < "u" ? crypto.getRandomValues(new Uint8Array(ie)) : typeof msCrypto < "u" ? msCrypto.getRandomValues(new Uint8Array(ie)) : $e(new Uint8Array(ie), ie) : $e(new Array(ie), ie);
      }
      function le() {
        var ie = ce(q);
        ie[6] = ie[6] & 79 | 64, ie[8] = ie[8] & 191 | 128;
        for (var ye = "", ge = 0; ge < q; ++ge) {
          var xe = ie[ge];
          (ge === 4 || ge === 6 || ge === 8) && (ye += "-"), xe < 16 && (ye += "0"), ye += xe.toString(16).toLowerCase();
        }
        return ye;
      }
    }
    function Ie(q) {
      return q.__ = void 0, delete q.__, q;
    }
  });
})(Reflect$1 || (Reflect$1 = {}));
/*!
 * MIT License
 * 
 * Copyright (c) 2017-2024 Peculiar Ventures, LLC
 * 
 * Permission is hereby granted, free of charge, to any person obtaining a copy
 * of this software and associated documentation files (the "Software"), to deal
 * in the Software without restriction, including without limitation the rights
 * to use, copy, modify, merge, publish, distribute, sublicense, and/or sell
 * copies of the Software, and to permit persons to whom the Software is
 * furnished to do so, subject to the following conditions:
 * 
 * The above copyright notice and this permission notice shall be included in all
 * copies or substantial portions of the Software.
 * 
 * THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS OR
 * IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF MERCHANTABILITY,
 * FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN NO EVENT SHALL THE
 * AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM, DAMAGES OR OTHER
 * LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR OTHERWISE, ARISING FROM,
 * OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE USE OR OTHER DEALINGS IN THE
 * SOFTWARE.
 * 
 */
const ARRAY_BUFFER_NAME = "[object ArrayBuffer]";
class BufferSourceConverter {
  static isArrayBuffer(r) {
    return Object.prototype.toString.call(r) === ARRAY_BUFFER_NAME;
  }
  static toArrayBuffer(r) {
    return this.isArrayBuffer(r) ? r : r.byteLength === r.buffer.byteLength || r.byteOffset === 0 && r.byteLength === r.buffer.byteLength ? r.buffer : this.toUint8Array(r.buffer).slice(r.byteOffset, r.byteOffset + r.byteLength).buffer;
  }
  static toUint8Array(r) {
    return this.toView(r, Uint8Array);
  }
  static toView(r, a) {
    if (r.constructor === a)
      return r;
    if (this.isArrayBuffer(r))
      return new a(r);
    if (this.isArrayBufferView(r))
      return new a(r.buffer, r.byteOffset, r.byteLength);
    throw new TypeError("The provided value is not of type '(ArrayBuffer or ArrayBufferView)'");
  }
  static isBufferSource(r) {
    return this.isArrayBufferView(r) || this.isArrayBuffer(r);
  }
  static isArrayBufferView(r) {
    return ArrayBuffer.isView(r) || r && this.isArrayBuffer(r.buffer);
  }
  static isEqual(r, a) {
    const e = BufferSourceConverter.toUint8Array(r), n = BufferSourceConverter.toUint8Array(a);
    if (e.length !== n.byteLength)
      return !1;
    for (let o = 0; o < e.length; o++)
      if (e[o] !== n[o])
        return !1;
    return !0;
  }
  static concat(...r) {
    let a;
    Array.isArray(r[0]) && !(r[1] instanceof Function) || Array.isArray(r[0]) && r[1] instanceof Function ? a = r[0] : r[r.length - 1] instanceof Function ? a = r.slice(0, r.length - 1) : a = r;
    let e = 0;
    for (const c of a)
      e += c.byteLength;
    const n = new Uint8Array(e);
    let o = 0;
    for (const c of a) {
      const l = this.toUint8Array(c);
      n.set(l, o), o += l.length;
    }
    return r[r.length - 1] instanceof Function ? this.toView(n, r[r.length - 1]) : n.buffer;
  }
}
const STRING_TYPE = "string", HEX_REGEX = /^[0-9a-f\s]+$/i, BASE64_REGEX = /^(?:[A-Za-z0-9+/]{4})*(?:[A-Za-z0-9+/]{2}==|[A-Za-z0-9+/]{3}=)?$/, BASE64URL_REGEX = /^[a-zA-Z0-9-_]+$/;
class Utf8Converter {
  static fromString(r) {
    const a = unescape(encodeURIComponent(r)), e = new Uint8Array(a.length);
    for (let n = 0; n < a.length; n++)
      e[n] = a.charCodeAt(n);
    return e.buffer;
  }
  static toString(r) {
    const a = BufferSourceConverter.toUint8Array(r);
    let e = "";
    for (let o = 0; o < a.length; o++)
      e += String.fromCharCode(a[o]);
    return decodeURIComponent(escape(e));
  }
}
class Utf16Converter {
  static toString(r, a = !1) {
    const e = BufferSourceConverter.toArrayBuffer(r), n = new DataView(e);
    let o = "";
    for (let c = 0; c < e.byteLength; c += 2) {
      const l = n.getUint16(c, a);
      o += String.fromCharCode(l);
    }
    return o;
  }
  static fromString(r, a = !1) {
    const e = new ArrayBuffer(r.length * 2), n = new DataView(e);
    for (let o = 0; o < r.length; o++)
      n.setUint16(o * 2, r.charCodeAt(o), a);
    return e;
  }
}
class Convert {
  static isHex(r) {
    return typeof r === STRING_TYPE && HEX_REGEX.test(r);
  }
  static isBase64(r) {
    return typeof r === STRING_TYPE && BASE64_REGEX.test(r);
  }
  static isBase64Url(r) {
    return typeof r === STRING_TYPE && BASE64URL_REGEX.test(r);
  }
  static ToString(r, a = "utf8") {
    const e = BufferSourceConverter.toUint8Array(r);
    switch (a.toLowerCase()) {
      case "utf8":
        return this.ToUtf8String(e);
      case "binary":
        return this.ToBinary(e);
      case "hex":
        return this.ToHex(e);
      case "base64":
        return this.ToBase64(e);
      case "base64url":
        return this.ToBase64Url(e);
      case "utf16le":
        return Utf16Converter.toString(e, !0);
      case "utf16":
      case "utf16be":
        return Utf16Converter.toString(e);
      default:
        throw new Error(`Unknown type of encoding '${a}'`);
    }
  }
  static FromString(r, a = "utf8") {
    if (!r)
      return new ArrayBuffer(0);
    switch (a.toLowerCase()) {
      case "utf8":
        return this.FromUtf8String(r);
      case "binary":
        return this.FromBinary(r);
      case "hex":
        return this.FromHex(r);
      case "base64":
        return this.FromBase64(r);
      case "base64url":
        return this.FromBase64Url(r);
      case "utf16le":
        return Utf16Converter.fromString(r, !0);
      case "utf16":
      case "utf16be":
        return Utf16Converter.fromString(r);
      default:
        throw new Error(`Unknown type of encoding '${a}'`);
    }
  }
  static ToBase64(r) {
    const a = BufferSourceConverter.toUint8Array(r);
    if (typeof btoa < "u") {
      const e = this.ToString(a, "binary");
      return btoa(e);
    } else
      return Buffer.from(a).toString("base64");
  }
  static FromBase64(r) {
    const a = this.formatString(r);
    if (!a)
      return new ArrayBuffer(0);
    if (!Convert.isBase64(a))
      throw new TypeError("Argument 'base64Text' is not Base64 encoded");
    return typeof atob < "u" ? this.FromBinary(atob(a)) : new Uint8Array(Buffer.from(a, "base64")).buffer;
  }
  static FromBase64Url(r) {
    const a = this.formatString(r);
    if (!a)
      return new ArrayBuffer(0);
    if (!Convert.isBase64Url(a))
      throw new TypeError("Argument 'base64url' is not Base64Url encoded");
    return this.FromBase64(this.Base64Padding(a.replace(/\-/g, "+").replace(/\_/g, "/")));
  }
  static ToBase64Url(r) {
    return this.ToBase64(r).replace(/\+/g, "-").replace(/\//g, "_").replace(/\=/g, "");
  }
  static FromUtf8String(r, a = Convert.DEFAULT_UTF8_ENCODING) {
    switch (a) {
      case "ascii":
        return this.FromBinary(r);
      case "utf8":
        return Utf8Converter.fromString(r);
      case "utf16":
      case "utf16be":
        return Utf16Converter.fromString(r);
      case "utf16le":
      case "usc2":
        return Utf16Converter.fromString(r, !0);
      default:
        throw new Error(`Unknown type of encoding '${a}'`);
    }
  }
  static ToUtf8String(r, a = Convert.DEFAULT_UTF8_ENCODING) {
    switch (a) {
      case "ascii":
        return this.ToBinary(r);
      case "utf8":
        return Utf8Converter.toString(r);
      case "utf16":
      case "utf16be":
        return Utf16Converter.toString(r);
      case "utf16le":
      case "usc2":
        return Utf16Converter.toString(r, !0);
      default:
        throw new Error(`Unknown type of encoding '${a}'`);
    }
  }
  static FromBinary(r) {
    const a = r.length, e = new Uint8Array(a);
    for (let n = 0; n < a; n++)
      e[n] = r.charCodeAt(n);
    return e.buffer;
  }
  static ToBinary(r) {
    const a = BufferSourceConverter.toUint8Array(r);
    let e = "";
    for (let n = 0; n < a.length; n++)
      e += String.fromCharCode(a[n]);
    return e;
  }
  static ToHex(r) {
    const a = BufferSourceConverter.toUint8Array(r);
    let e = "";
    const n = a.length;
    for (let o = 0; o < n; o++) {
      const c = a[o];
      c < 16 && (e += "0"), e += c.toString(16);
    }
    return e;
  }
  static FromHex(r) {
    let a = this.formatString(r);
    if (!a)
      return new ArrayBuffer(0);
    if (!Convert.isHex(a))
      throw new TypeError("Argument 'hexString' is not HEX encoded");
    a.length % 2 && (a = `0${a}`);
    const e = new Uint8Array(a.length / 2);
    for (let n = 0; n < a.length; n = n + 2) {
      const o = a.slice(n, n + 2);
      e[n / 2] = parseInt(o, 16);
    }
    return e.buffer;
  }
  static ToUtf16String(r, a = !1) {
    return Utf16Converter.toString(r, a);
  }
  static FromUtf16String(r, a = !1) {
    return Utf16Converter.fromString(r, a);
  }
  static Base64Padding(r) {
    const a = 4 - r.length % 4;
    if (a < 4)
      for (let e = 0; e < a; e++)
        r += "=";
    return r;
  }
  static formatString(r) {
    return r?.replace(/[\n\r\t ]/g, "") || "";
  }
}
Convert.DEFAULT_UTF8_ENCODING = "utf8";
function combine(...u) {
  const r = u.map((n) => n.byteLength).reduce((n, o) => n + o), a = new Uint8Array(r);
  let e = 0;
  return u.map((n) => new Uint8Array(n)).forEach((n) => {
    for (const o of n)
      a[e++] = o;
  }), a.buffer;
}
function isEqual(u, r) {
  if (!(u && r) || u.byteLength !== r.byteLength)
    return !1;
  const a = new Uint8Array(u), e = new Uint8Array(r);
  for (let n = 0; n < u.byteLength; n++)
    if (a[n] !== e[n])
      return !1;
  return !0;
}
/*!
 Copyright (c) Peculiar Ventures, LLC
*/
function utilFromBase(u, r) {
  let a = 0;
  if (u.length === 1)
    return u[0];
  for (let e = u.length - 1; e >= 0; e--)
    a += u[u.length - 1 - e] * Math.pow(2, r * e);
  return a;
}
function utilToBase(u, r, a = -1) {
  const e = a;
  let n = u, o = 0, c = Math.pow(2, r);
  for (let l = 1; l < 8; l++) {
    if (u < c) {
      let d;
      if (e < 0)
        d = new ArrayBuffer(l), o = l;
      else {
        if (e < l)
          return new ArrayBuffer(0);
        d = new ArrayBuffer(e), o = e;
      }
      const p = new Uint8Array(d);
      for (let h = l - 1; h >= 0; h--) {
        const g = Math.pow(2, h * r);
        p[o - h - 1] = Math.floor(n / g), n -= p[o - h - 1] * g;
      }
      return d;
    }
    c *= Math.pow(2, r);
  }
  return new ArrayBuffer(0);
}
function utilConcatView(...u) {
  let r = 0, a = 0;
  for (const o of u)
    r += o.length;
  const e = new ArrayBuffer(r), n = new Uint8Array(e);
  for (const o of u)
    n.set(o, a), a += o.length;
  return n;
}
function utilDecodeTC() {
  const u = new Uint8Array(this.valueHex);
  if (this.valueHex.byteLength >= 2) {
    const l = u[0] === 255 && u[1] & 128, d = u[0] === 0 && (u[1] & 128) === 0;
    (l || d) && this.warnings.push("Needlessly long format");
  }
  const r = new ArrayBuffer(this.valueHex.byteLength), a = new Uint8Array(r);
  for (let l = 0; l < this.valueHex.byteLength; l++)
    a[l] = 0;
  a[0] = u[0] & 128;
  const e = utilFromBase(a, 8), n = new ArrayBuffer(this.valueHex.byteLength), o = new Uint8Array(n);
  for (let l = 0; l < this.valueHex.byteLength; l++)
    o[l] = u[l];
  return o[0] &= 127, utilFromBase(o, 8) - e;
}
function utilEncodeTC(u) {
  const r = u < 0 ? u * -1 : u;
  let a = 128;
  for (let e = 1; e < 8; e++) {
    if (r <= a) {
      if (u < 0) {
        const c = a - r, l = utilToBase(c, 8, e), d = new Uint8Array(l);
        return d[0] |= 128, l;
      }
      let n = utilToBase(r, 8, e), o = new Uint8Array(n);
      if (o[0] & 128) {
        const c = n.slice(0), l = new Uint8Array(c);
        n = new ArrayBuffer(n.byteLength + 1), o = new Uint8Array(n);
        for (let d = 0; d < c.byteLength; d++)
          o[d + 1] = l[d];
        o[0] = 0;
      }
      return n;
    }
    a *= Math.pow(2, 8);
  }
  return new ArrayBuffer(0);
}
function isEqualBuffer(u, r) {
  if (u.byteLength !== r.byteLength)
    return !1;
  const a = new Uint8Array(u), e = new Uint8Array(r);
  for (let n = 0; n < a.length; n++)
    if (a[n] !== e[n])
      return !1;
  return !0;
}
function padNumber(u, r) {
  const a = u.toString(10);
  if (r < a.length)
    return "";
  const e = r - a.length, n = new Array(e);
  for (let c = 0; c < e; c++)
    n[c] = "0";
  return n.join("").concat(a);
}
/*!
 * Copyright (c) 2014, GMO GlobalSign
 * Copyright (c) 2015-2022, Peculiar Ventures
 * All rights reserved.
 * 
 * Author 2014-2019, Yury Strozhevsky
 * 
 * Redistribution and use in source and binary forms, with or without modification,
 * are permitted provided that the following conditions are met:
 * 
 * * Redistributions of source code must retain the above copyright notice, this
 *   list of conditions and the following disclaimer.
 * 
 * * Redistributions in binary form must reproduce the above copyright notice, this
 *   list of conditions and the following disclaimer in the documentation and/or
 *   other materials provided with the distribution.
 * 
 * * Neither the name of the copyright holder nor the names of its
 *   contributors may be used to endorse or promote products derived from
 *   this software without specific prior written permission.
 * 
 * THIS SOFTWARE IS PROVIDED BY THE COPYRIGHT HOLDERS AND CONTRIBUTORS "AS IS" AND
 * ANY EXPRESS OR IMPLIED WARRANTIES, INCLUDING, BUT NOT LIMITED TO, THE IMPLIED
 * WARRANTIES OF MERCHANTABILITY AND FITNESS FOR A PARTICULAR PURPOSE ARE
 * DISCLAIMED. IN NO EVENT SHALL THE COPYRIGHT HOLDER OR CONTRIBUTORS BE LIABLE FOR
 * ANY DIRECT, INDIRECT, INCIDENTAL, SPECIAL, EXEMPLARY, OR CONSEQUENTIAL DAMAGES
 * (INCLUDING, BUT NOT LIMITED TO, PROCUREMENT OF SUBSTITUTE GOODS OR SERVICES;
 * LOSS OF USE, DATA, OR PROFITS; OR BUSINESS INTERRUPTION) HOWEVER CAUSED AND ON
 * ANY THEORY OF LIABILITY, WHETHER IN CONTRACT, STRICT LIABILITY, OR TORT
 * (INCLUDING NEGLIGENCE OR OTHERWISE) ARISING IN ANY WAY OUT OF THE USE OF THIS
 * SOFTWARE, EVEN IF ADVISED OF THE POSSIBILITY OF SUCH DAMAGE.
 * 
 */
function assertBigInt() {
  if (typeof BigInt > "u")
    throw new Error("BigInt is not defined. Your environment doesn't implement BigInt.");
}
function concat(u) {
  let r = 0, a = 0;
  for (let n = 0; n < u.length; n++) {
    const o = u[n];
    r += o.byteLength;
  }
  const e = new Uint8Array(r);
  for (let n = 0; n < u.length; n++) {
    const o = u[n];
    e.set(new Uint8Array(o), a), a += o.byteLength;
  }
  return e.buffer;
}
function checkBufferParams(u, r, a, e) {
  return r instanceof Uint8Array ? r.byteLength ? a < 0 ? (u.error = "Wrong parameter: inputOffset less than zero", !1) : e < 0 ? (u.error = "Wrong parameter: inputLength less than zero", !1) : r.byteLength - a - e < 0 ? (u.error = "End of input reached before message was fully decoded (inconsistent offset and length values)", !1) : !0 : (u.error = "Wrong parameter: inputBuffer has zero length", !1) : (u.error = "Wrong parameter: inputBuffer must be 'Uint8Array'", !1);
}
class ViewWriter {
  constructor() {
    this.items = [];
  }
  write(r) {
    this.items.push(r);
  }
  final() {
    return concat(this.items);
  }
}
const powers2 = [new Uint8Array([1])], digitsString = "0123456789", NAME$1 = "name", VALUE_HEX_VIEW = "valueHexView", IS_HEX_ONLY = "isHexOnly", ID_BLOCK = "idBlock", TAG_CLASS = "tagClass", TAG_NUMBER = "tagNumber", IS_CONSTRUCTED = "isConstructed", FROM_BER = "fromBER", TO_BER = "toBER", LOCAL = "local", EMPTY_STRING = "", EMPTY_BUFFER = new ArrayBuffer(0), EMPTY_VIEW = new Uint8Array(0), END_OF_CONTENT_NAME = "EndOfContent", OCTET_STRING_NAME = "OCTET STRING", BIT_STRING_NAME = "BIT STRING";
function HexBlock(u) {
  var r;
  return r = class extends u {
    get valueHex() {
      return this.valueHexView.slice().buffer;
    }
    set valueHex(e) {
      this.valueHexView = new Uint8Array(e);
    }
    constructor(...e) {
      var n;
      super(...e);
      const o = e[0] || {};
      this.isHexOnly = (n = o.isHexOnly) !== null && n !== void 0 ? n : !1, this.valueHexView = o.valueHex ? BufferSourceConverter.toUint8Array(o.valueHex) : EMPTY_VIEW;
    }
    fromBER(e, n, o) {
      const c = e instanceof ArrayBuffer ? new Uint8Array(e) : e;
      if (!checkBufferParams(this, c, n, o))
        return -1;
      const l = n + o;
      return this.valueHexView = c.subarray(n, l), this.valueHexView.length ? (this.blockLength = o, l) : (this.warnings.push("Zero buffer length"), n);
    }
    toBER(e = !1) {
      return this.isHexOnly ? e ? new ArrayBuffer(this.valueHexView.byteLength) : this.valueHexView.byteLength === this.valueHexView.buffer.byteLength ? this.valueHexView.buffer : this.valueHexView.slice().buffer : (this.error = "Flag 'isHexOnly' is not set, abort", EMPTY_BUFFER);
    }
    toJSON() {
      return {
        ...super.toJSON(),
        isHexOnly: this.isHexOnly,
        valueHex: Convert.ToHex(this.valueHexView)
      };
    }
  }, r.NAME = "hexBlock", r;
}
class LocalBaseBlock {
  static blockName() {
    return this.NAME;
  }
  get valueBeforeDecode() {
    return this.valueBeforeDecodeView.slice().buffer;
  }
  set valueBeforeDecode(r) {
    this.valueBeforeDecodeView = new Uint8Array(r);
  }
  constructor({ blockLength: r = 0, error: a = EMPTY_STRING, warnings: e = [], valueBeforeDecode: n = EMPTY_VIEW } = {}) {
    this.blockLength = r, this.error = a, this.warnings = e, this.valueBeforeDecodeView = BufferSourceConverter.toUint8Array(n);
  }
  toJSON() {
    return {
      blockName: this.constructor.NAME,
      blockLength: this.blockLength,
      error: this.error,
      warnings: this.warnings,
      valueBeforeDecode: Convert.ToHex(this.valueBeforeDecodeView)
    };
  }
}
LocalBaseBlock.NAME = "baseBlock";
class ValueBlock extends LocalBaseBlock {
  fromBER(r, a, e) {
    throw TypeError("User need to make a specific function in a class which extends 'ValueBlock'");
  }
  toBER(r, a) {
    throw TypeError("User need to make a specific function in a class which extends 'ValueBlock'");
  }
}
ValueBlock.NAME = "valueBlock";
class LocalIdentificationBlock extends HexBlock(LocalBaseBlock) {
  constructor({ idBlock: r = {} } = {}) {
    var a, e, n, o;
    super(), r ? (this.isHexOnly = (a = r.isHexOnly) !== null && a !== void 0 ? a : !1, this.valueHexView = r.valueHex ? BufferSourceConverter.toUint8Array(r.valueHex) : EMPTY_VIEW, this.tagClass = (e = r.tagClass) !== null && e !== void 0 ? e : -1, this.tagNumber = (n = r.tagNumber) !== null && n !== void 0 ? n : -1, this.isConstructed = (o = r.isConstructed) !== null && o !== void 0 ? o : !1) : (this.tagClass = -1, this.tagNumber = -1, this.isConstructed = !1);
  }
  toBER(r = !1) {
    let a = 0;
    switch (this.tagClass) {
      case 1:
        a |= 0;
        break;
      case 2:
        a |= 64;
        break;
      case 3:
        a |= 128;
        break;
      case 4:
        a |= 192;
        break;
      default:
        return this.error = "Unknown tag class", EMPTY_BUFFER;
    }
    if (this.isConstructed && (a |= 32), this.tagNumber < 31 && !this.isHexOnly) {
      const n = new Uint8Array(1);
      if (!r) {
        let o = this.tagNumber;
        o &= 31, a |= o, n[0] = a;
      }
      return n.buffer;
    }
    if (!this.isHexOnly) {
      const n = utilToBase(this.tagNumber, 7), o = new Uint8Array(n), c = n.byteLength, l = new Uint8Array(c + 1);
      if (l[0] = a | 31, !r) {
        for (let d = 0; d < c - 1; d++)
          l[d + 1] = o[d] | 128;
        l[c] = o[c - 1];
      }
      return l.buffer;
    }
    const e = new Uint8Array(this.valueHexView.byteLength + 1);
    if (e[0] = a | 31, !r) {
      const n = this.valueHexView;
      for (let o = 0; o < n.length - 1; o++)
        e[o + 1] = n[o] | 128;
      e[this.valueHexView.byteLength] = n[n.length - 1];
    }
    return e.buffer;
  }
  fromBER(r, a, e) {
    const n = BufferSourceConverter.toUint8Array(r);
    if (!checkBufferParams(this, n, a, e))
      return -1;
    const o = n.subarray(a, a + e);
    if (o.length === 0)
      return this.error = "Zero buffer length", -1;
    switch (o[0] & 192) {
      case 0:
        this.tagClass = 1;
        break;
      case 64:
        this.tagClass = 2;
        break;
      case 128:
        this.tagClass = 3;
        break;
      case 192:
        this.tagClass = 4;
        break;
      default:
        return this.error = "Unknown tag class", -1;
    }
    this.isConstructed = (o[0] & 32) === 32, this.isHexOnly = !1;
    const l = o[0] & 31;
    if (l !== 31)
      this.tagNumber = l, this.blockLength = 1;
    else {
      let d = 1, p = this.valueHexView = new Uint8Array(255), h = 255;
      for (; o[d] & 128; ) {
        if (p[d - 1] = o[d] & 127, d++, d >= o.length)
          return this.error = "End of input reached before message was fully decoded", -1;
        if (d === h) {
          h += 255;
          const y = new Uint8Array(h);
          for (let v = 0; v < p.length; v++)
            y[v] = p[v];
          p = this.valueHexView = new Uint8Array(h);
        }
      }
      this.blockLength = d + 1, p[d - 1] = o[d] & 127;
      const g = new Uint8Array(d);
      for (let y = 0; y < d; y++)
        g[y] = p[y];
      p = this.valueHexView = new Uint8Array(d), p.set(g), this.blockLength <= 9 ? this.tagNumber = utilFromBase(p, 7) : (this.isHexOnly = !0, this.warnings.push("Tag too long, represented as hex-coded"));
    }
    if (this.tagClass === 1 && this.isConstructed)
      switch (this.tagNumber) {
        case 1:
        case 2:
        case 5:
        case 6:
        case 9:
        case 13:
        case 14:
        case 23:
        case 24:
        case 31:
        case 32:
        case 33:
        case 34:
          return this.error = "Constructed encoding used for primitive type", -1;
      }
    return a + this.blockLength;
  }
  toJSON() {
    return {
      ...super.toJSON(),
      tagClass: this.tagClass,
      tagNumber: this.tagNumber,
      isConstructed: this.isConstructed
    };
  }
}
LocalIdentificationBlock.NAME = "identificationBlock";
class LocalLengthBlock extends LocalBaseBlock {
  constructor({ lenBlock: r = {} } = {}) {
    var a, e, n;
    super(), this.isIndefiniteForm = (a = r.isIndefiniteForm) !== null && a !== void 0 ? a : !1, this.longFormUsed = (e = r.longFormUsed) !== null && e !== void 0 ? e : !1, this.length = (n = r.length) !== null && n !== void 0 ? n : 0;
  }
  fromBER(r, a, e) {
    const n = BufferSourceConverter.toUint8Array(r);
    if (!checkBufferParams(this, n, a, e))
      return -1;
    const o = n.subarray(a, a + e);
    if (o.length === 0)
      return this.error = "Zero buffer length", -1;
    if (o[0] === 255)
      return this.error = "Length block 0xFF is reserved by standard", -1;
    if (this.isIndefiniteForm = o[0] === 128, this.isIndefiniteForm)
      return this.blockLength = 1, a + this.blockLength;
    if (this.longFormUsed = !!(o[0] & 128), this.longFormUsed === !1)
      return this.length = o[0], this.blockLength = 1, a + this.blockLength;
    const c = o[0] & 127;
    if (c > 8)
      return this.error = "Too big integer", -1;
    if (c + 1 > o.length)
      return this.error = "End of input reached before message was fully decoded", -1;
    const l = a + 1, d = n.subarray(l, l + c);
    return d[c - 1] === 0 && this.warnings.push("Needlessly long encoded length"), this.length = utilFromBase(d, 8), this.longFormUsed && this.length <= 127 && this.warnings.push("Unnecessary usage of long length form"), this.blockLength = c + 1, a + this.blockLength;
  }
  toBER(r = !1) {
    let a, e;
    if (this.length > 127 && (this.longFormUsed = !0), this.isIndefiniteForm)
      return a = new ArrayBuffer(1), r === !1 && (e = new Uint8Array(a), e[0] = 128), a;
    if (this.longFormUsed) {
      const n = utilToBase(this.length, 8);
      if (n.byteLength > 127)
        return this.error = "Too big length", EMPTY_BUFFER;
      if (a = new ArrayBuffer(n.byteLength + 1), r)
        return a;
      const o = new Uint8Array(n);
      e = new Uint8Array(a), e[0] = n.byteLength | 128;
      for (let c = 0; c < n.byteLength; c++)
        e[c + 1] = o[c];
      return a;
    }
    return a = new ArrayBuffer(1), r === !1 && (e = new Uint8Array(a), e[0] = this.length), a;
  }
  toJSON() {
    return {
      ...super.toJSON(),
      isIndefiniteForm: this.isIndefiniteForm,
      longFormUsed: this.longFormUsed,
      length: this.length
    };
  }
}
LocalLengthBlock.NAME = "lengthBlock";
const typeStore = {};
class BaseBlock extends LocalBaseBlock {
  constructor({ name: r = EMPTY_STRING, optional: a = !1, primitiveSchema: e, ...n } = {}, o) {
    super(n), this.name = r, this.optional = a, e && (this.primitiveSchema = e), this.idBlock = new LocalIdentificationBlock(n), this.lenBlock = new LocalLengthBlock(n), this.valueBlock = o ? new o(n) : new ValueBlock(n);
  }
  fromBER(r, a, e) {
    const n = this.valueBlock.fromBER(r, a, this.lenBlock.isIndefiniteForm ? e : this.lenBlock.length);
    return n === -1 ? (this.error = this.valueBlock.error, n) : (this.idBlock.error.length || (this.blockLength += this.idBlock.blockLength), this.lenBlock.error.length || (this.blockLength += this.lenBlock.blockLength), this.valueBlock.error.length || (this.blockLength += this.valueBlock.blockLength), n);
  }
  toBER(r, a) {
    const e = a || new ViewWriter();
    a || prepareIndefiniteForm(this);
    const n = this.idBlock.toBER(r);
    if (e.write(n), this.lenBlock.isIndefiniteForm)
      e.write(new Uint8Array([128]).buffer), this.valueBlock.toBER(r, e), e.write(new ArrayBuffer(2));
    else {
      const o = this.valueBlock.toBER(r);
      this.lenBlock.length = o.byteLength;
      const c = this.lenBlock.toBER(r);
      e.write(c), e.write(o);
    }
    return a ? EMPTY_BUFFER : e.final();
  }
  toJSON() {
    const r = {
      ...super.toJSON(),
      idBlock: this.idBlock.toJSON(),
      lenBlock: this.lenBlock.toJSON(),
      valueBlock: this.valueBlock.toJSON(),
      name: this.name,
      optional: this.optional
    };
    return this.primitiveSchema && (r.primitiveSchema = this.primitiveSchema.toJSON()), r;
  }
  toString(r = "ascii") {
    return r === "ascii" ? this.onAsciiEncoding() : Convert.ToHex(this.toBER());
  }
  onAsciiEncoding() {
    const r = this.constructor.NAME, a = Convert.ToHex(this.valueBlock.valueBeforeDecodeView);
    return `${r} : ${a}`;
  }
  isEqual(r) {
    if (this === r)
      return !0;
    if (!(r instanceof this.constructor))
      return !1;
    const a = this.toBER(), e = r.toBER();
    return isEqualBuffer(a, e);
  }
}
BaseBlock.NAME = "BaseBlock";
function prepareIndefiniteForm(u) {
  var r;
  if (u instanceof typeStore.Constructed)
    for (const a of u.valueBlock.value)
      prepareIndefiniteForm(a) && (u.lenBlock.isIndefiniteForm = !0);
  return !!(!((r = u.lenBlock) === null || r === void 0) && r.isIndefiniteForm);
}
class BaseStringBlock extends BaseBlock {
  getValue() {
    return this.valueBlock.value;
  }
  setValue(r) {
    this.valueBlock.value = r;
  }
  constructor({ value: r = EMPTY_STRING, ...a } = {}, e) {
    super(a, e), r && this.fromString(r);
  }
  fromBER(r, a, e) {
    const n = this.valueBlock.fromBER(r, a, this.lenBlock.isIndefiniteForm ? e : this.lenBlock.length);
    return n === -1 ? (this.error = this.valueBlock.error, n) : (this.fromBuffer(this.valueBlock.valueHexView), this.idBlock.error.length || (this.blockLength += this.idBlock.blockLength), this.lenBlock.error.length || (this.blockLength += this.lenBlock.blockLength), this.valueBlock.error.length || (this.blockLength += this.valueBlock.blockLength), n);
  }
  onAsciiEncoding() {
    return `${this.constructor.NAME} : '${this.valueBlock.value}'`;
  }
}
BaseStringBlock.NAME = "BaseStringBlock";
class LocalPrimitiveValueBlock extends HexBlock(ValueBlock) {
  constructor({ isHexOnly: r = !0, ...a } = {}) {
    super(a), this.isHexOnly = r;
  }
}
LocalPrimitiveValueBlock.NAME = "PrimitiveValueBlock";
var _a$w;
class Primitive extends BaseBlock {
  constructor(r = {}) {
    super(r, LocalPrimitiveValueBlock), this.idBlock.isConstructed = !1;
  }
}
_a$w = Primitive;
typeStore.Primitive = _a$w;
Primitive.NAME = "PRIMITIVE";
function localChangeType(u, r) {
  if (u instanceof r)
    return u;
  const a = new r();
  return a.idBlock = u.idBlock, a.lenBlock = u.lenBlock, a.warnings = u.warnings, a.valueBeforeDecodeView = u.valueBeforeDecodeView, a;
}
function localFromBER(u, r = 0, a = u.length) {
  const e = r;
  let n = new BaseBlock({}, ValueBlock);
  const o = new LocalBaseBlock();
  if (!checkBufferParams(o, u, r, a))
    return n.error = o.error, {
      offset: -1,
      result: n
    };
  if (!u.subarray(r, r + a).length)
    return n.error = "Zero buffer length", {
      offset: -1,
      result: n
    };
  let l = n.idBlock.fromBER(u, r, a);
  if (n.idBlock.warnings.length && n.warnings.concat(n.idBlock.warnings), l === -1)
    return n.error = n.idBlock.error, {
      offset: -1,
      result: n
    };
  if (r = l, a -= n.idBlock.blockLength, l = n.lenBlock.fromBER(u, r, a), n.lenBlock.warnings.length && n.warnings.concat(n.lenBlock.warnings), l === -1)
    return n.error = n.lenBlock.error, {
      offset: -1,
      result: n
    };
  if (r = l, a -= n.lenBlock.blockLength, !n.idBlock.isConstructed && n.lenBlock.isIndefiniteForm)
    return n.error = "Indefinite length form used for primitive encoding form", {
      offset: -1,
      result: n
    };
  let d = BaseBlock;
  switch (n.idBlock.tagClass) {
    case 1:
      if (n.idBlock.tagNumber >= 37 && n.idBlock.isHexOnly === !1)
        return n.error = "UNIVERSAL 37 and upper tags are reserved by ASN.1 standard", {
          offset: -1,
          result: n
        };
      switch (n.idBlock.tagNumber) {
        case 0:
          if (n.idBlock.isConstructed && n.lenBlock.length > 0)
            return n.error = "Type [UNIVERSAL 0] is reserved", {
              offset: -1,
              result: n
            };
          d = typeStore.EndOfContent;
          break;
        case 1:
          d = typeStore.Boolean;
          break;
        case 2:
          d = typeStore.Integer;
          break;
        case 3:
          d = typeStore.BitString;
          break;
        case 4:
          d = typeStore.OctetString;
          break;
        case 5:
          d = typeStore.Null;
          break;
        case 6:
          d = typeStore.ObjectIdentifier;
          break;
        case 10:
          d = typeStore.Enumerated;
          break;
        case 12:
          d = typeStore.Utf8String;
          break;
        case 13:
          d = typeStore.RelativeObjectIdentifier;
          break;
        case 14:
          d = typeStore.TIME;
          break;
        case 15:
          return n.error = "[UNIVERSAL 15] is reserved by ASN.1 standard", {
            offset: -1,
            result: n
          };
        case 16:
          d = typeStore.Sequence;
          break;
        case 17:
          d = typeStore.Set;
          break;
        case 18:
          d = typeStore.NumericString;
          break;
        case 19:
          d = typeStore.PrintableString;
          break;
        case 20:
          d = typeStore.TeletexString;
          break;
        case 21:
          d = typeStore.VideotexString;
          break;
        case 22:
          d = typeStore.IA5String;
          break;
        case 23:
          d = typeStore.UTCTime;
          break;
        case 24:
          d = typeStore.GeneralizedTime;
          break;
        case 25:
          d = typeStore.GraphicString;
          break;
        case 26:
          d = typeStore.VisibleString;
          break;
        case 27:
          d = typeStore.GeneralString;
          break;
        case 28:
          d = typeStore.UniversalString;
          break;
        case 29:
          d = typeStore.CharacterString;
          break;
        case 30:
          d = typeStore.BmpString;
          break;
        case 31:
          d = typeStore.DATE;
          break;
        case 32:
          d = typeStore.TimeOfDay;
          break;
        case 33:
          d = typeStore.DateTime;
          break;
        case 34:
          d = typeStore.Duration;
          break;
        default: {
          const p = n.idBlock.isConstructed ? new typeStore.Constructed() : new typeStore.Primitive();
          p.idBlock = n.idBlock, p.lenBlock = n.lenBlock, p.warnings = n.warnings, n = p;
        }
      }
      break;
    case 2:
    case 3:
    case 4:
    default:
      d = n.idBlock.isConstructed ? typeStore.Constructed : typeStore.Primitive;
  }
  return n = localChangeType(n, d), l = n.fromBER(u, r, n.lenBlock.isIndefiniteForm ? a : n.lenBlock.length), n.valueBeforeDecodeView = u.subarray(e, e + n.blockLength), {
    offset: l,
    result: n
  };
}
function fromBER(u) {
  if (!u.byteLength) {
    const r = new BaseBlock({}, ValueBlock);
    return r.error = "Input buffer has zero length", {
      offset: -1,
      result: r
    };
  }
  return localFromBER(BufferSourceConverter.toUint8Array(u).slice(), 0, u.byteLength);
}
function checkLen(u, r) {
  return u ? 1 : r;
}
class LocalConstructedValueBlock extends ValueBlock {
  constructor({ value: r = [], isIndefiniteForm: a = !1, ...e } = {}) {
    super(e), this.value = r, this.isIndefiniteForm = a;
  }
  fromBER(r, a, e) {
    const n = BufferSourceConverter.toUint8Array(r);
    if (!checkBufferParams(this, n, a, e))
      return -1;
    if (this.valueBeforeDecodeView = n.subarray(a, a + e), this.valueBeforeDecodeView.length === 0)
      return this.warnings.push("Zero buffer length"), a;
    let o = a;
    for (; checkLen(this.isIndefiniteForm, e) > 0; ) {
      const c = localFromBER(n, o, e);
      if (c.offset === -1)
        return this.error = c.result.error, this.warnings.concat(c.result.warnings), -1;
      if (o = c.offset, this.blockLength += c.result.blockLength, e -= c.result.blockLength, this.value.push(c.result), this.isIndefiniteForm && c.result.constructor.NAME === END_OF_CONTENT_NAME)
        break;
    }
    return this.isIndefiniteForm && (this.value[this.value.length - 1].constructor.NAME === END_OF_CONTENT_NAME ? this.value.pop() : this.warnings.push("No EndOfContent block encoded")), o;
  }
  toBER(r, a) {
    const e = a || new ViewWriter();
    for (let n = 0; n < this.value.length; n++)
      this.value[n].toBER(r, e);
    return a ? EMPTY_BUFFER : e.final();
  }
  toJSON() {
    const r = {
      ...super.toJSON(),
      isIndefiniteForm: this.isIndefiniteForm,
      value: []
    };
    for (const a of this.value)
      r.value.push(a.toJSON());
    return r;
  }
}
LocalConstructedValueBlock.NAME = "ConstructedValueBlock";
var _a$v;
class Constructed extends BaseBlock {
  constructor(r = {}) {
    super(r, LocalConstructedValueBlock), this.idBlock.isConstructed = !0;
  }
  fromBER(r, a, e) {
    this.valueBlock.isIndefiniteForm = this.lenBlock.isIndefiniteForm;
    const n = this.valueBlock.fromBER(r, a, this.lenBlock.isIndefiniteForm ? e : this.lenBlock.length);
    return n === -1 ? (this.error = this.valueBlock.error, n) : (this.idBlock.error.length || (this.blockLength += this.idBlock.blockLength), this.lenBlock.error.length || (this.blockLength += this.lenBlock.blockLength), this.valueBlock.error.length || (this.blockLength += this.valueBlock.blockLength), n);
  }
  onAsciiEncoding() {
    const r = [];
    for (const e of this.valueBlock.value)
      r.push(e.toString("ascii").split(`
`).map((n) => `  ${n}`).join(`
`));
    const a = this.idBlock.tagClass === 3 ? `[${this.idBlock.tagNumber}]` : this.constructor.NAME;
    return r.length ? `${a} :
${r.join(`
`)}` : `${a} :`;
  }
}
_a$v = Constructed;
typeStore.Constructed = _a$v;
Constructed.NAME = "CONSTRUCTED";
class LocalEndOfContentValueBlock extends ValueBlock {
  fromBER(r, a, e) {
    return a;
  }
  toBER(r) {
    return EMPTY_BUFFER;
  }
}
LocalEndOfContentValueBlock.override = "EndOfContentValueBlock";
var _a$u;
class EndOfContent extends BaseBlock {
  constructor(r = {}) {
    super(r, LocalEndOfContentValueBlock), this.idBlock.tagClass = 1, this.idBlock.tagNumber = 0;
  }
}
_a$u = EndOfContent;
typeStore.EndOfContent = _a$u;
EndOfContent.NAME = END_OF_CONTENT_NAME;
var _a$t;
class Null extends BaseBlock {
  constructor(r = {}) {
    super(r, ValueBlock), this.idBlock.tagClass = 1, this.idBlock.tagNumber = 5;
  }
  fromBER(r, a, e) {
    return this.lenBlock.length > 0 && this.warnings.push("Non-zero length of value block for Null type"), this.idBlock.error.length || (this.blockLength += this.idBlock.blockLength), this.lenBlock.error.length || (this.blockLength += this.lenBlock.blockLength), this.blockLength += e, a + e > r.byteLength ? (this.error = "End of input reached before message was fully decoded (inconsistent offset and length values)", -1) : a + e;
  }
  toBER(r, a) {
    const e = new ArrayBuffer(2);
    if (!r) {
      const n = new Uint8Array(e);
      n[0] = 5, n[1] = 0;
    }
    return a && a.write(e), e;
  }
  onAsciiEncoding() {
    return `${this.constructor.NAME}`;
  }
}
_a$t = Null;
typeStore.Null = _a$t;
Null.NAME = "NULL";
class LocalBooleanValueBlock extends HexBlock(ValueBlock) {
  get value() {
    for (const r of this.valueHexView)
      if (r > 0)
        return !0;
    return !1;
  }
  set value(r) {
    this.valueHexView[0] = r ? 255 : 0;
  }
  constructor({ value: r, ...a } = {}) {
    super(a), a.valueHex ? this.valueHexView = BufferSourceConverter.toUint8Array(a.valueHex) : this.valueHexView = new Uint8Array(1), r && (this.value = r);
  }
  fromBER(r, a, e) {
    const n = BufferSourceConverter.toUint8Array(r);
    return checkBufferParams(this, n, a, e) ? (this.valueHexView = n.subarray(a, a + e), e > 1 && this.warnings.push("Boolean value encoded in more then 1 octet"), this.isHexOnly = !0, utilDecodeTC.call(this), this.blockLength = e, a + e) : -1;
  }
  toBER() {
    return this.valueHexView.slice();
  }
  toJSON() {
    return {
      ...super.toJSON(),
      value: this.value
    };
  }
}
LocalBooleanValueBlock.NAME = "BooleanValueBlock";
var _a$s;
let Boolean$1 = class extends BaseBlock {
  getValue() {
    return this.valueBlock.value;
  }
  setValue(r) {
    this.valueBlock.value = r;
  }
  constructor(r = {}) {
    super(r, LocalBooleanValueBlock), this.idBlock.tagClass = 1, this.idBlock.tagNumber = 1;
  }
  onAsciiEncoding() {
    return `${this.constructor.NAME} : ${this.getValue}`;
  }
};
_a$s = Boolean$1;
typeStore.Boolean = _a$s;
Boolean$1.NAME = "BOOLEAN";
class LocalOctetStringValueBlock extends HexBlock(LocalConstructedValueBlock) {
  constructor({ isConstructed: r = !1, ...a } = {}) {
    super(a), this.isConstructed = r;
  }
  fromBER(r, a, e) {
    let n = 0;
    if (this.isConstructed) {
      if (this.isHexOnly = !1, n = LocalConstructedValueBlock.prototype.fromBER.call(this, r, a, e), n === -1)
        return n;
      for (let o = 0; o < this.value.length; o++) {
        const c = this.value[o].constructor.NAME;
        if (c === END_OF_CONTENT_NAME) {
          if (this.isIndefiniteForm)
            break;
          return this.error = "EndOfContent is unexpected, OCTET STRING may consists of OCTET STRINGs only", -1;
        }
        if (c !== OCTET_STRING_NAME)
          return this.error = "OCTET STRING may consists of OCTET STRINGs only", -1;
      }
    } else
      this.isHexOnly = !0, n = super.fromBER(r, a, e), this.blockLength = e;
    return n;
  }
  toBER(r, a) {
    return this.isConstructed ? LocalConstructedValueBlock.prototype.toBER.call(this, r, a) : r ? new ArrayBuffer(this.valueHexView.byteLength) : this.valueHexView.slice().buffer;
  }
  toJSON() {
    return {
      ...super.toJSON(),
      isConstructed: this.isConstructed
    };
  }
}
LocalOctetStringValueBlock.NAME = "OctetStringValueBlock";
var _a$r;
let OctetString$1 = class extends BaseBlock {
  constructor({ idBlock: r = {}, lenBlock: a = {}, ...e } = {}) {
    var n, o;
    (n = e.isConstructed) !== null && n !== void 0 || (e.isConstructed = !!(!((o = e.value) === null || o === void 0) && o.length)), super({
      idBlock: {
        isConstructed: e.isConstructed,
        ...r
      },
      lenBlock: {
        ...a,
        isIndefiniteForm: !!e.isIndefiniteForm
      },
      ...e
    }, LocalOctetStringValueBlock), this.idBlock.tagClass = 1, this.idBlock.tagNumber = 4;
  }
  fromBER(r, a, e) {
    if (this.valueBlock.isConstructed = this.idBlock.isConstructed, this.valueBlock.isIndefiniteForm = this.lenBlock.isIndefiniteForm, e === 0)
      return this.idBlock.error.length === 0 && (this.blockLength += this.idBlock.blockLength), this.lenBlock.error.length === 0 && (this.blockLength += this.lenBlock.blockLength), a;
    if (!this.valueBlock.isConstructed) {
      const o = (r instanceof ArrayBuffer ? new Uint8Array(r) : r).subarray(a, a + e);
      try {
        if (o.byteLength) {
          const c = localFromBER(o, 0, o.byteLength);
          c.offset !== -1 && c.offset === e && (this.valueBlock.value = [c.result]);
        }
      } catch {
      }
    }
    return super.fromBER(r, a, e);
  }
  onAsciiEncoding() {
    if (this.valueBlock.isConstructed || this.valueBlock.value && this.valueBlock.value.length)
      return Constructed.prototype.onAsciiEncoding.call(this);
    const r = this.constructor.NAME, a = Convert.ToHex(this.valueBlock.valueHexView);
    return `${r} : ${a}`;
  }
  getValue() {
    if (!this.idBlock.isConstructed)
      return this.valueBlock.valueHexView.slice().buffer;
    const r = [];
    for (const a of this.valueBlock.value)
      a instanceof _a$r && r.push(a.valueBlock.valueHexView);
    return BufferSourceConverter.concat(r);
  }
};
_a$r = OctetString$1;
typeStore.OctetString = _a$r;
OctetString$1.NAME = OCTET_STRING_NAME;
class LocalBitStringValueBlock extends HexBlock(LocalConstructedValueBlock) {
  constructor({ unusedBits: r = 0, isConstructed: a = !1, ...e } = {}) {
    super(e), this.unusedBits = r, this.isConstructed = a, this.blockLength = this.valueHexView.byteLength;
  }
  fromBER(r, a, e) {
    if (!e)
      return a;
    let n = -1;
    if (this.isConstructed) {
      if (n = LocalConstructedValueBlock.prototype.fromBER.call(this, r, a, e), n === -1)
        return n;
      for (const l of this.value) {
        const d = l.constructor.NAME;
        if (d === END_OF_CONTENT_NAME) {
          if (this.isIndefiniteForm)
            break;
          return this.error = "EndOfContent is unexpected, BIT STRING may consists of BIT STRINGs only", -1;
        }
        if (d !== BIT_STRING_NAME)
          return this.error = "BIT STRING may consists of BIT STRINGs only", -1;
        const p = l.valueBlock;
        if (this.unusedBits > 0 && p.unusedBits > 0)
          return this.error = 'Using of "unused bits" inside constructive BIT STRING allowed for least one only', -1;
        this.unusedBits = p.unusedBits;
      }
      return n;
    }
    const o = BufferSourceConverter.toUint8Array(r);
    if (!checkBufferParams(this, o, a, e))
      return -1;
    const c = o.subarray(a, a + e);
    if (this.unusedBits = c[0], this.unusedBits > 7)
      return this.error = "Unused bits for BitString must be in range 0-7", -1;
    if (!this.unusedBits) {
      const l = c.subarray(1);
      try {
        if (l.byteLength) {
          const d = localFromBER(l, 0, l.byteLength);
          d.offset !== -1 && d.offset === e - 1 && (this.value = [d.result]);
        }
      } catch {
      }
    }
    return this.valueHexView = c.subarray(1), this.blockLength = c.length, a + e;
  }
  toBER(r, a) {
    if (this.isConstructed)
      return LocalConstructedValueBlock.prototype.toBER.call(this, r, a);
    if (r)
      return new ArrayBuffer(this.valueHexView.byteLength + 1);
    if (!this.valueHexView.byteLength)
      return EMPTY_BUFFER;
    const e = new Uint8Array(this.valueHexView.length + 1);
    return e[0] = this.unusedBits, e.set(this.valueHexView, 1), e.buffer;
  }
  toJSON() {
    return {
      ...super.toJSON(),
      unusedBits: this.unusedBits,
      isConstructed: this.isConstructed
    };
  }
}
LocalBitStringValueBlock.NAME = "BitStringValueBlock";
var _a$q;
let BitString$1 = class extends BaseBlock {
  constructor({ idBlock: r = {}, lenBlock: a = {}, ...e } = {}) {
    var n, o;
    (n = e.isConstructed) !== null && n !== void 0 || (e.isConstructed = !!(!((o = e.value) === null || o === void 0) && o.length)), super({
      idBlock: {
        isConstructed: e.isConstructed,
        ...r
      },
      lenBlock: {
        ...a,
        isIndefiniteForm: !!e.isIndefiniteForm
      },
      ...e
    }, LocalBitStringValueBlock), this.idBlock.tagClass = 1, this.idBlock.tagNumber = 3;
  }
  fromBER(r, a, e) {
    return this.valueBlock.isConstructed = this.idBlock.isConstructed, this.valueBlock.isIndefiniteForm = this.lenBlock.isIndefiniteForm, super.fromBER(r, a, e);
  }
  onAsciiEncoding() {
    if (this.valueBlock.isConstructed || this.valueBlock.value && this.valueBlock.value.length)
      return Constructed.prototype.onAsciiEncoding.call(this);
    {
      const r = [], a = this.valueBlock.valueHexView;
      for (const c of a)
        r.push(c.toString(2).padStart(8, "0"));
      const e = r.join(""), n = this.constructor.NAME, o = e.substring(0, e.length - this.valueBlock.unusedBits);
      return `${n} : ${o}`;
    }
  }
};
_a$q = BitString$1;
typeStore.BitString = _a$q;
BitString$1.NAME = BIT_STRING_NAME;
var _a$p;
function viewAdd(u, r) {
  const a = new Uint8Array([0]), e = new Uint8Array(u), n = new Uint8Array(r);
  let o = e.slice(0);
  const c = o.length - 1, l = n.slice(0), d = l.length - 1;
  let p = 0;
  const h = d < c ? c : d;
  let g = 0;
  for (let y = h; y >= 0; y--, g++) {
    switch (!0) {
      case g < l.length:
        p = o[c - g] + l[d - g] + a[0];
        break;
      default:
        p = o[c - g] + a[0];
    }
    switch (a[0] = p / 10, !0) {
      case g >= o.length:
        o = utilConcatView(new Uint8Array([p % 10]), o);
        break;
      default:
        o[c - g] = p % 10;
    }
  }
  return a[0] > 0 && (o = utilConcatView(a, o)), o;
}
function power2(u) {
  if (u >= powers2.length)
    for (let r = powers2.length; r <= u; r++) {
      const a = new Uint8Array([0]);
      let e = powers2[r - 1].slice(0);
      for (let n = e.length - 1; n >= 0; n--) {
        const o = new Uint8Array([(e[n] << 1) + a[0]]);
        a[0] = o[0] / 10, e[n] = o[0] % 10;
      }
      a[0] > 0 && (e = utilConcatView(a, e)), powers2.push(e);
    }
  return powers2[u];
}
function viewSub(u, r) {
  let a = 0;
  const e = new Uint8Array(u), n = new Uint8Array(r), o = e.slice(0), c = o.length - 1, l = n.slice(0), d = l.length - 1;
  let p, h = 0;
  for (let g = d; g >= 0; g--, h++)
    switch (p = o[c - h] - l[d - h] - a, !0) {
      case p < 0:
        a = 1, o[c - h] = p + 10;
        break;
      default:
        a = 0, o[c - h] = p;
    }
  if (a > 0)
    for (let g = c - d + 1; g >= 0; g--, h++)
      if (p = o[c - h] - a, p < 0)
        a = 1, o[c - h] = p + 10;
      else {
        a = 0, o[c - h] = p;
        break;
      }
  return o.slice();
}
class LocalIntegerValueBlock extends HexBlock(ValueBlock) {
  setValueHex() {
    this.valueHexView.length >= 4 ? (this.warnings.push("Too big Integer for decoding, hex only"), this.isHexOnly = !0, this._valueDec = 0) : (this.isHexOnly = !1, this.valueHexView.length > 0 && (this._valueDec = utilDecodeTC.call(this)));
  }
  constructor({ value: r, ...a } = {}) {
    super(a), this._valueDec = 0, a.valueHex && this.setValueHex(), r !== void 0 && (this.valueDec = r);
  }
  set valueDec(r) {
    this._valueDec = r, this.isHexOnly = !1, this.valueHexView = new Uint8Array(utilEncodeTC(r));
  }
  get valueDec() {
    return this._valueDec;
  }
  fromDER(r, a, e, n = 0) {
    const o = this.fromBER(r, a, e);
    if (o === -1)
      return o;
    const c = this.valueHexView;
    return c[0] === 0 && c[1] & 128 ? this.valueHexView = c.subarray(1) : n !== 0 && c.length < n && (n - c.length > 1 && (n = c.length + 1), this.valueHexView = c.subarray(n - c.length)), o;
  }
  toDER(r = !1) {
    const a = this.valueHexView;
    switch (!0) {
      case (a[0] & 128) !== 0:
        {
          const e = new Uint8Array(this.valueHexView.length + 1);
          e[0] = 0, e.set(a, 1), this.valueHexView = e;
        }
        break;
      case (a[0] === 0 && (a[1] & 128) === 0):
        this.valueHexView = this.valueHexView.subarray(1);
        break;
    }
    return this.toBER(r);
  }
  fromBER(r, a, e) {
    const n = super.fromBER(r, a, e);
    return n === -1 || this.setValueHex(), n;
  }
  toBER(r) {
    return r ? new ArrayBuffer(this.valueHexView.length) : this.valueHexView.slice().buffer;
  }
  toJSON() {
    return {
      ...super.toJSON(),
      valueDec: this.valueDec
    };
  }
  toString() {
    const r = this.valueHexView.length * 8 - 1;
    let a = new Uint8Array(this.valueHexView.length * 8 / 3), e = 0, n;
    const o = this.valueHexView;
    let c = "", l = !1;
    for (let d = o.byteLength - 1; d >= 0; d--) {
      n = o[d];
      for (let p = 0; p < 8; p++) {
        if ((n & 1) === 1)
          switch (e) {
            case r:
              a = viewSub(power2(e), a), c = "-";
              break;
            default:
              a = viewAdd(a, power2(e));
          }
        e++, n >>= 1;
      }
    }
    for (let d = 0; d < a.length; d++)
      a[d] && (l = !0), l && (c += digitsString.charAt(a[d]));
    return l === !1 && (c += digitsString.charAt(0)), c;
  }
}
_a$p = LocalIntegerValueBlock;
LocalIntegerValueBlock.NAME = "IntegerValueBlock";
Object.defineProperty(_a$p.prototype, "valueHex", {
  set: function(u) {
    this.valueHexView = new Uint8Array(u), this.setValueHex();
  },
  get: function() {
    return this.valueHexView.slice().buffer;
  }
});
var _a$o;
class Integer extends BaseBlock {
  constructor(r = {}) {
    super(r, LocalIntegerValueBlock), this.idBlock.tagClass = 1, this.idBlock.tagNumber = 2;
  }
  toBigInt() {
    return assertBigInt(), BigInt(this.valueBlock.toString());
  }
  static fromBigInt(r) {
    assertBigInt();
    const a = BigInt(r), e = new ViewWriter(), n = a.toString(16).replace(/^-/, ""), o = new Uint8Array(Convert.FromHex(n));
    if (a < 0) {
      const l = new Uint8Array(o.length + (o[0] & 128 ? 1 : 0));
      l[0] |= 128;
      const p = BigInt(`0x${Convert.ToHex(l)}`) + a, h = BufferSourceConverter.toUint8Array(Convert.FromHex(p.toString(16)));
      h[0] |= 128, e.write(h);
    } else
      o[0] & 128 && e.write(new Uint8Array([0])), e.write(o);
    return new _a$o({ valueHex: e.final() });
  }
  convertToDER() {
    const r = new _a$o({ valueHex: this.valueBlock.valueHexView });
    return r.valueBlock.toDER(), r;
  }
  convertFromDER() {
    return new _a$o({
      valueHex: this.valueBlock.valueHexView[0] === 0 ? this.valueBlock.valueHexView.subarray(1) : this.valueBlock.valueHexView
    });
  }
  onAsciiEncoding() {
    return `${this.constructor.NAME} : ${this.valueBlock.toString()}`;
  }
}
_a$o = Integer;
typeStore.Integer = _a$o;
Integer.NAME = "INTEGER";
var _a$n;
class Enumerated extends Integer {
  constructor(r = {}) {
    super(r), this.idBlock.tagClass = 1, this.idBlock.tagNumber = 10;
  }
}
_a$n = Enumerated;
typeStore.Enumerated = _a$n;
Enumerated.NAME = "ENUMERATED";
class LocalSidValueBlock extends HexBlock(ValueBlock) {
  constructor({ valueDec: r = -1, isFirstSid: a = !1, ...e } = {}) {
    super(e), this.valueDec = r, this.isFirstSid = a;
  }
  fromBER(r, a, e) {
    if (!e)
      return a;
    const n = BufferSourceConverter.toUint8Array(r);
    if (!checkBufferParams(this, n, a, e))
      return -1;
    const o = n.subarray(a, a + e);
    this.valueHexView = new Uint8Array(e);
    for (let l = 0; l < e && (this.valueHexView[l] = o[l] & 127, this.blockLength++, !!(o[l] & 128)); l++)
      ;
    const c = new Uint8Array(this.blockLength);
    for (let l = 0; l < this.blockLength; l++)
      c[l] = this.valueHexView[l];
    return this.valueHexView = c, o[this.blockLength - 1] & 128 ? (this.error = "End of input reached before message was fully decoded", -1) : (this.valueHexView[0] === 0 && this.warnings.push("Needlessly long format of SID encoding"), this.blockLength <= 8 ? this.valueDec = utilFromBase(this.valueHexView, 7) : (this.isHexOnly = !0, this.warnings.push("Too big SID for decoding, hex only")), a + this.blockLength);
  }
  set valueBigInt(r) {
    assertBigInt();
    let a = BigInt(r).toString(2);
    for (; a.length % 7; )
      a = "0" + a;
    const e = new Uint8Array(a.length / 7);
    for (let n = 0; n < e.length; n++)
      e[n] = parseInt(a.slice(n * 7, n * 7 + 7), 2) + (n + 1 < e.length ? 128 : 0);
    this.fromBER(e.buffer, 0, e.length);
  }
  toBER(r) {
    if (this.isHexOnly) {
      if (r)
        return new ArrayBuffer(this.valueHexView.byteLength);
      const n = this.valueHexView, o = new Uint8Array(this.blockLength);
      for (let c = 0; c < this.blockLength - 1; c++)
        o[c] = n[c] | 128;
      return o[this.blockLength - 1] = n[this.blockLength - 1], o.buffer;
    }
    const a = utilToBase(this.valueDec, 7);
    if (a.byteLength === 0)
      return this.error = "Error during encoding SID value", EMPTY_BUFFER;
    const e = new Uint8Array(a.byteLength);
    if (!r) {
      const n = new Uint8Array(a), o = a.byteLength - 1;
      for (let c = 0; c < o; c++)
        e[c] = n[c] | 128;
      e[o] = n[o];
    }
    return e;
  }
  toString() {
    let r = "";
    if (this.isHexOnly)
      r = Convert.ToHex(this.valueHexView);
    else if (this.isFirstSid) {
      let a = this.valueDec;
      this.valueDec <= 39 ? r = "0." : this.valueDec <= 79 ? (r = "1.", a -= 40) : (r = "2.", a -= 80), r += a.toString();
    } else
      r = this.valueDec.toString();
    return r;
  }
  toJSON() {
    return {
      ...super.toJSON(),
      valueDec: this.valueDec,
      isFirstSid: this.isFirstSid
    };
  }
}
LocalSidValueBlock.NAME = "sidBlock";
class LocalObjectIdentifierValueBlock extends ValueBlock {
  constructor({ value: r = EMPTY_STRING, ...a } = {}) {
    super(a), this.value = [], r && this.fromString(r);
  }
  fromBER(r, a, e) {
    let n = a;
    for (; e > 0; ) {
      const o = new LocalSidValueBlock();
      if (n = o.fromBER(r, n, e), n === -1)
        return this.blockLength = 0, this.error = o.error, n;
      this.value.length === 0 && (o.isFirstSid = !0), this.blockLength += o.blockLength, e -= o.blockLength, this.value.push(o);
    }
    return n;
  }
  toBER(r) {
    const a = [];
    for (let e = 0; e < this.value.length; e++) {
      const n = this.value[e].toBER(r);
      if (n.byteLength === 0)
        return this.error = this.value[e].error, EMPTY_BUFFER;
      a.push(n);
    }
    return concat(a);
  }
  fromString(r) {
    this.value = [];
    let a = 0, e = 0, n = "", o = !1;
    do
      if (e = r.indexOf(".", a), e === -1 ? n = r.substring(a) : n = r.substring(a, e), a = e + 1, o) {
        const c = this.value[0];
        let l = 0;
        switch (c.valueDec) {
          case 0:
            break;
          case 1:
            l = 40;
            break;
          case 2:
            l = 80;
            break;
          default:
            this.value = [];
            return;
        }
        const d = parseInt(n, 10);
        if (isNaN(d))
          return;
        c.valueDec = d + l, o = !1;
      } else {
        const c = new LocalSidValueBlock();
        if (n > Number.MAX_SAFE_INTEGER) {
          assertBigInt();
          const l = BigInt(n);
          c.valueBigInt = l;
        } else if (c.valueDec = parseInt(n, 10), isNaN(c.valueDec))
          return;
        this.value.length || (c.isFirstSid = !0, o = !0), this.value.push(c);
      }
    while (e !== -1);
  }
  toString() {
    let r = "", a = !1;
    for (let e = 0; e < this.value.length; e++) {
      a = this.value[e].isHexOnly;
      let n = this.value[e].toString();
      e !== 0 && (r = `${r}.`), a ? (n = `{${n}}`, this.value[e].isFirstSid ? r = `2.{${n} - 80}` : r += n) : r += n;
    }
    return r;
  }
  toJSON() {
    const r = {
      ...super.toJSON(),
      value: this.toString(),
      sidArray: []
    };
    for (let a = 0; a < this.value.length; a++)
      r.sidArray.push(this.value[a].toJSON());
    return r;
  }
}
LocalObjectIdentifierValueBlock.NAME = "ObjectIdentifierValueBlock";
var _a$m;
class ObjectIdentifier extends BaseBlock {
  getValue() {
    return this.valueBlock.toString();
  }
  setValue(r) {
    this.valueBlock.fromString(r);
  }
  constructor(r = {}) {
    super(r, LocalObjectIdentifierValueBlock), this.idBlock.tagClass = 1, this.idBlock.tagNumber = 6;
  }
  onAsciiEncoding() {
    return `${this.constructor.NAME} : ${this.valueBlock.toString() || "empty"}`;
  }
  toJSON() {
    return {
      ...super.toJSON(),
      value: this.getValue()
    };
  }
}
_a$m = ObjectIdentifier;
typeStore.ObjectIdentifier = _a$m;
ObjectIdentifier.NAME = "OBJECT IDENTIFIER";
class LocalRelativeSidValueBlock extends HexBlock(LocalBaseBlock) {
  constructor({ valueDec: r = 0, ...a } = {}) {
    super(a), this.valueDec = r;
  }
  fromBER(r, a, e) {
    if (e === 0)
      return a;
    const n = BufferSourceConverter.toUint8Array(r);
    if (!checkBufferParams(this, n, a, e))
      return -1;
    const o = n.subarray(a, a + e);
    this.valueHexView = new Uint8Array(e);
    for (let l = 0; l < e && (this.valueHexView[l] = o[l] & 127, this.blockLength++, !!(o[l] & 128)); l++)
      ;
    const c = new Uint8Array(this.blockLength);
    for (let l = 0; l < this.blockLength; l++)
      c[l] = this.valueHexView[l];
    return this.valueHexView = c, o[this.blockLength - 1] & 128 ? (this.error = "End of input reached before message was fully decoded", -1) : (this.valueHexView[0] === 0 && this.warnings.push("Needlessly long format of SID encoding"), this.blockLength <= 8 ? this.valueDec = utilFromBase(this.valueHexView, 7) : (this.isHexOnly = !0, this.warnings.push("Too big SID for decoding, hex only")), a + this.blockLength);
  }
  toBER(r) {
    if (this.isHexOnly) {
      if (r)
        return new ArrayBuffer(this.valueHexView.byteLength);
      const n = this.valueHexView, o = new Uint8Array(this.blockLength);
      for (let c = 0; c < this.blockLength - 1; c++)
        o[c] = n[c] | 128;
      return o[this.blockLength - 1] = n[this.blockLength - 1], o.buffer;
    }
    const a = utilToBase(this.valueDec, 7);
    if (a.byteLength === 0)
      return this.error = "Error during encoding SID value", EMPTY_BUFFER;
    const e = new Uint8Array(a.byteLength);
    if (!r) {
      const n = new Uint8Array(a), o = a.byteLength - 1;
      for (let c = 0; c < o; c++)
        e[c] = n[c] | 128;
      e[o] = n[o];
    }
    return e.buffer;
  }
  toString() {
    let r = "";
    return this.isHexOnly ? r = Convert.ToHex(this.valueHexView) : r = this.valueDec.toString(), r;
  }
  toJSON() {
    return {
      ...super.toJSON(),
      valueDec: this.valueDec
    };
  }
}
LocalRelativeSidValueBlock.NAME = "relativeSidBlock";
class LocalRelativeObjectIdentifierValueBlock extends ValueBlock {
  constructor({ value: r = EMPTY_STRING, ...a } = {}) {
    super(a), this.value = [], r && this.fromString(r);
  }
  fromBER(r, a, e) {
    let n = a;
    for (; e > 0; ) {
      const o = new LocalRelativeSidValueBlock();
      if (n = o.fromBER(r, n, e), n === -1)
        return this.blockLength = 0, this.error = o.error, n;
      this.blockLength += o.blockLength, e -= o.blockLength, this.value.push(o);
    }
    return n;
  }
  toBER(r, a) {
    const e = [];
    for (let n = 0; n < this.value.length; n++) {
      const o = this.value[n].toBER(r);
      if (o.byteLength === 0)
        return this.error = this.value[n].error, EMPTY_BUFFER;
      e.push(o);
    }
    return concat(e);
  }
  fromString(r) {
    this.value = [];
    let a = 0, e = 0, n = "";
    do {
      e = r.indexOf(".", a), e === -1 ? n = r.substring(a) : n = r.substring(a, e), a = e + 1;
      const o = new LocalRelativeSidValueBlock();
      if (o.valueDec = parseInt(n, 10), isNaN(o.valueDec))
        return !0;
      this.value.push(o);
    } while (e !== -1);
    return !0;
  }
  toString() {
    let r = "", a = !1;
    for (let e = 0; e < this.value.length; e++) {
      a = this.value[e].isHexOnly;
      let n = this.value[e].toString();
      e !== 0 && (r = `${r}.`), a && (n = `{${n}}`), r += n;
    }
    return r;
  }
  toJSON() {
    const r = {
      ...super.toJSON(),
      value: this.toString(),
      sidArray: []
    };
    for (let a = 0; a < this.value.length; a++)
      r.sidArray.push(this.value[a].toJSON());
    return r;
  }
}
LocalRelativeObjectIdentifierValueBlock.NAME = "RelativeObjectIdentifierValueBlock";
var _a$l;
class RelativeObjectIdentifier extends BaseBlock {
  getValue() {
    return this.valueBlock.toString();
  }
  setValue(r) {
    this.valueBlock.fromString(r);
  }
  constructor(r = {}) {
    super(r, LocalRelativeObjectIdentifierValueBlock), this.idBlock.tagClass = 1, this.idBlock.tagNumber = 13;
  }
  onAsciiEncoding() {
    return `${this.constructor.NAME} : ${this.valueBlock.toString() || "empty"}`;
  }
  toJSON() {
    return {
      ...super.toJSON(),
      value: this.getValue()
    };
  }
}
_a$l = RelativeObjectIdentifier;
typeStore.RelativeObjectIdentifier = _a$l;
RelativeObjectIdentifier.NAME = "RelativeObjectIdentifier";
var _a$k;
class Sequence extends Constructed {
  constructor(r = {}) {
    super(r), this.idBlock.tagClass = 1, this.idBlock.tagNumber = 16;
  }
}
_a$k = Sequence;
typeStore.Sequence = _a$k;
Sequence.NAME = "SEQUENCE";
var _a$j;
let Set$1 = class extends Constructed {
  constructor(r = {}) {
    super(r), this.idBlock.tagClass = 1, this.idBlock.tagNumber = 17;
  }
};
_a$j = Set$1;
typeStore.Set = _a$j;
Set$1.NAME = "SET";
class LocalStringValueBlock extends HexBlock(ValueBlock) {
  constructor({ ...r } = {}) {
    super(r), this.isHexOnly = !0, this.value = EMPTY_STRING;
  }
  toJSON() {
    return {
      ...super.toJSON(),
      value: this.value
    };
  }
}
LocalStringValueBlock.NAME = "StringValueBlock";
class LocalSimpleStringValueBlock extends LocalStringValueBlock {
}
LocalSimpleStringValueBlock.NAME = "SimpleStringValueBlock";
class LocalSimpleStringBlock extends BaseStringBlock {
  constructor({ ...r } = {}) {
    super(r, LocalSimpleStringValueBlock);
  }
  fromBuffer(r) {
    this.valueBlock.value = String.fromCharCode.apply(null, BufferSourceConverter.toUint8Array(r));
  }
  fromString(r) {
    const a = r.length, e = this.valueBlock.valueHexView = new Uint8Array(a);
    for (let n = 0; n < a; n++)
      e[n] = r.charCodeAt(n);
    this.valueBlock.value = r;
  }
}
LocalSimpleStringBlock.NAME = "SIMPLE STRING";
class LocalUtf8StringValueBlock extends LocalSimpleStringBlock {
  fromBuffer(r) {
    this.valueBlock.valueHexView = BufferSourceConverter.toUint8Array(r);
    try {
      this.valueBlock.value = Convert.ToUtf8String(r);
    } catch (a) {
      this.warnings.push(`Error during "decodeURIComponent": ${a}, using raw string`), this.valueBlock.value = Convert.ToBinary(r);
    }
  }
  fromString(r) {
    this.valueBlock.valueHexView = new Uint8Array(Convert.FromUtf8String(r)), this.valueBlock.value = r;
  }
}
LocalUtf8StringValueBlock.NAME = "Utf8StringValueBlock";
var _a$i;
class Utf8String extends LocalUtf8StringValueBlock {
  constructor(r = {}) {
    super(r), this.idBlock.tagClass = 1, this.idBlock.tagNumber = 12;
  }
}
_a$i = Utf8String;
typeStore.Utf8String = _a$i;
Utf8String.NAME = "UTF8String";
class LocalBmpStringValueBlock extends LocalSimpleStringBlock {
  fromBuffer(r) {
    this.valueBlock.value = Convert.ToUtf16String(r), this.valueBlock.valueHexView = BufferSourceConverter.toUint8Array(r);
  }
  fromString(r) {
    this.valueBlock.value = r, this.valueBlock.valueHexView = new Uint8Array(Convert.FromUtf16String(r));
  }
}
LocalBmpStringValueBlock.NAME = "BmpStringValueBlock";
var _a$h;
class BmpString extends LocalBmpStringValueBlock {
  constructor({ ...r } = {}) {
    super(r), this.idBlock.tagClass = 1, this.idBlock.tagNumber = 30;
  }
}
_a$h = BmpString;
typeStore.BmpString = _a$h;
BmpString.NAME = "BMPString";
class LocalUniversalStringValueBlock extends LocalSimpleStringBlock {
  fromBuffer(r) {
    const a = ArrayBuffer.isView(r) ? r.slice().buffer : r.slice(0), e = new Uint8Array(a);
    for (let n = 0; n < e.length; n += 4)
      e[n] = e[n + 3], e[n + 1] = e[n + 2], e[n + 2] = 0, e[n + 3] = 0;
    this.valueBlock.value = String.fromCharCode.apply(null, new Uint32Array(a));
  }
  fromString(r) {
    const a = r.length, e = this.valueBlock.valueHexView = new Uint8Array(a * 4);
    for (let n = 0; n < a; n++) {
      const o = utilToBase(r.charCodeAt(n), 8), c = new Uint8Array(o);
      if (c.length > 4)
        continue;
      const l = 4 - c.length;
      for (let d = c.length - 1; d >= 0; d--)
        e[n * 4 + d + l] = c[d];
    }
    this.valueBlock.value = r;
  }
}
LocalUniversalStringValueBlock.NAME = "UniversalStringValueBlock";
var _a$g;
class UniversalString extends LocalUniversalStringValueBlock {
  constructor({ ...r } = {}) {
    super(r), this.idBlock.tagClass = 1, this.idBlock.tagNumber = 28;
  }
}
_a$g = UniversalString;
typeStore.UniversalString = _a$g;
UniversalString.NAME = "UniversalString";
var _a$f;
class NumericString extends LocalSimpleStringBlock {
  constructor(r = {}) {
    super(r), this.idBlock.tagClass = 1, this.idBlock.tagNumber = 18;
  }
}
_a$f = NumericString;
typeStore.NumericString = _a$f;
NumericString.NAME = "NumericString";
var _a$e;
class PrintableString extends LocalSimpleStringBlock {
  constructor(r = {}) {
    super(r), this.idBlock.tagClass = 1, this.idBlock.tagNumber = 19;
  }
}
_a$e = PrintableString;
typeStore.PrintableString = _a$e;
PrintableString.NAME = "PrintableString";
var _a$d;
class TeletexString extends LocalSimpleStringBlock {
  constructor(r = {}) {
    super(r), this.idBlock.tagClass = 1, this.idBlock.tagNumber = 20;
  }
}
_a$d = TeletexString;
typeStore.TeletexString = _a$d;
TeletexString.NAME = "TeletexString";
var _a$c;
class VideotexString extends LocalSimpleStringBlock {
  constructor(r = {}) {
    super(r), this.idBlock.tagClass = 1, this.idBlock.tagNumber = 21;
  }
}
_a$c = VideotexString;
typeStore.VideotexString = _a$c;
VideotexString.NAME = "VideotexString";
var _a$b;
class IA5String extends LocalSimpleStringBlock {
  constructor(r = {}) {
    super(r), this.idBlock.tagClass = 1, this.idBlock.tagNumber = 22;
  }
}
_a$b = IA5String;
typeStore.IA5String = _a$b;
IA5String.NAME = "IA5String";
var _a$a;
class GraphicString extends LocalSimpleStringBlock {
  constructor(r = {}) {
    super(r), this.idBlock.tagClass = 1, this.idBlock.tagNumber = 25;
  }
}
_a$a = GraphicString;
typeStore.GraphicString = _a$a;
GraphicString.NAME = "GraphicString";
var _a$9;
class VisibleString extends LocalSimpleStringBlock {
  constructor(r = {}) {
    super(r), this.idBlock.tagClass = 1, this.idBlock.tagNumber = 26;
  }
}
_a$9 = VisibleString;
typeStore.VisibleString = _a$9;
VisibleString.NAME = "VisibleString";
var _a$8;
class GeneralString extends LocalSimpleStringBlock {
  constructor(r = {}) {
    super(r), this.idBlock.tagClass = 1, this.idBlock.tagNumber = 27;
  }
}
_a$8 = GeneralString;
typeStore.GeneralString = _a$8;
GeneralString.NAME = "GeneralString";
var _a$7;
class CharacterString extends LocalSimpleStringBlock {
  constructor(r = {}) {
    super(r), this.idBlock.tagClass = 1, this.idBlock.tagNumber = 29;
  }
}
_a$7 = CharacterString;
typeStore.CharacterString = _a$7;
CharacterString.NAME = "CharacterString";
var _a$6;
class UTCTime extends VisibleString {
  constructor({ value: r, valueDate: a, ...e } = {}) {
    if (super(e), this.year = 0, this.month = 0, this.day = 0, this.hour = 0, this.minute = 0, this.second = 0, r) {
      this.fromString(r), this.valueBlock.valueHexView = new Uint8Array(r.length);
      for (let n = 0; n < r.length; n++)
        this.valueBlock.valueHexView[n] = r.charCodeAt(n);
    }
    a && (this.fromDate(a), this.valueBlock.valueHexView = new Uint8Array(this.toBuffer())), this.idBlock.tagClass = 1, this.idBlock.tagNumber = 23;
  }
  fromBuffer(r) {
    this.fromString(String.fromCharCode.apply(null, BufferSourceConverter.toUint8Array(r)));
  }
  toBuffer() {
    const r = this.toString(), a = new ArrayBuffer(r.length), e = new Uint8Array(a);
    for (let n = 0; n < r.length; n++)
      e[n] = r.charCodeAt(n);
    return a;
  }
  fromDate(r) {
    this.year = r.getUTCFullYear(), this.month = r.getUTCMonth() + 1, this.day = r.getUTCDate(), this.hour = r.getUTCHours(), this.minute = r.getUTCMinutes(), this.second = r.getUTCSeconds();
  }
  toDate() {
    return new Date(Date.UTC(this.year, this.month - 1, this.day, this.hour, this.minute, this.second));
  }
  fromString(r) {
    const e = /(\d{2})(\d{2})(\d{2})(\d{2})(\d{2})(\d{2})Z/ig.exec(r);
    if (e === null) {
      this.error = "Wrong input string for conversion";
      return;
    }
    const n = parseInt(e[1], 10);
    n >= 50 ? this.year = 1900 + n : this.year = 2e3 + n, this.month = parseInt(e[2], 10), this.day = parseInt(e[3], 10), this.hour = parseInt(e[4], 10), this.minute = parseInt(e[5], 10), this.second = parseInt(e[6], 10);
  }
  toString(r = "iso") {
    if (r === "iso") {
      const a = new Array(7);
      return a[0] = padNumber(this.year < 2e3 ? this.year - 1900 : this.year - 2e3, 2), a[1] = padNumber(this.month, 2), a[2] = padNumber(this.day, 2), a[3] = padNumber(this.hour, 2), a[4] = padNumber(this.minute, 2), a[5] = padNumber(this.second, 2), a[6] = "Z", a.join("");
    }
    return super.toString(r);
  }
  onAsciiEncoding() {
    return `${this.constructor.NAME} : ${this.toDate().toISOString()}`;
  }
  toJSON() {
    return {
      ...super.toJSON(),
      year: this.year,
      month: this.month,
      day: this.day,
      hour: this.hour,
      minute: this.minute,
      second: this.second
    };
  }
}
_a$6 = UTCTime;
typeStore.UTCTime = _a$6;
UTCTime.NAME = "UTCTime";
var _a$5;
class GeneralizedTime extends UTCTime {
  constructor(r = {}) {
    var a;
    super(r), (a = this.millisecond) !== null && a !== void 0 || (this.millisecond = 0), this.idBlock.tagClass = 1, this.idBlock.tagNumber = 24;
  }
  fromDate(r) {
    super.fromDate(r), this.millisecond = r.getUTCMilliseconds();
  }
  toDate() {
    const r = Date.UTC(this.year, this.month - 1, this.day, this.hour, this.minute, this.second, this.millisecond);
    return new Date(r);
  }
  fromString(r) {
    let a = !1, e = "", n = "", o = 0, c, l = 0, d = 0;
    if (r[r.length - 1] === "Z")
      e = r.substring(0, r.length - 1), a = !0;
    else {
      const g = new Number(r[r.length - 1]);
      if (isNaN(g.valueOf()))
        throw new Error("Wrong input string for conversion");
      e = r;
    }
    if (a) {
      if (e.indexOf("+") !== -1)
        throw new Error("Wrong input string for conversion");
      if (e.indexOf("-") !== -1)
        throw new Error("Wrong input string for conversion");
    } else {
      let g = 1, y = e.indexOf("+"), v = "";
      if (y === -1 && (y = e.indexOf("-"), g = -1), y !== -1) {
        if (v = e.substring(y + 1), e = e.substring(0, y), v.length !== 2 && v.length !== 4)
          throw new Error("Wrong input string for conversion");
        let m = parseInt(v.substring(0, 2), 10);
        if (isNaN(m.valueOf()))
          throw new Error("Wrong input string for conversion");
        if (l = g * m, v.length === 4) {
          if (m = parseInt(v.substring(2, 4), 10), isNaN(m.valueOf()))
            throw new Error("Wrong input string for conversion");
          d = g * m;
        }
      }
    }
    let p = e.indexOf(".");
    if (p === -1 && (p = e.indexOf(",")), p !== -1) {
      const g = new Number(`0${e.substring(p)}`);
      if (isNaN(g.valueOf()))
        throw new Error("Wrong input string for conversion");
      o = g.valueOf(), n = e.substring(0, p);
    } else
      n = e;
    switch (!0) {
      case n.length === 8:
        if (c = /(\d{4})(\d{2})(\d{2})/ig, p !== -1)
          throw new Error("Wrong input string for conversion");
        break;
      case n.length === 10:
        if (c = /(\d{4})(\d{2})(\d{2})(\d{2})/ig, p !== -1) {
          let g = 60 * o;
          this.minute = Math.floor(g), g = 60 * (g - this.minute), this.second = Math.floor(g), g = 1e3 * (g - this.second), this.millisecond = Math.floor(g);
        }
        break;
      case n.length === 12:
        if (c = /(\d{4})(\d{2})(\d{2})(\d{2})(\d{2})/ig, p !== -1) {
          let g = 60 * o;
          this.second = Math.floor(g), g = 1e3 * (g - this.second), this.millisecond = Math.floor(g);
        }
        break;
      case n.length === 14:
        if (c = /(\d{4})(\d{2})(\d{2})(\d{2})(\d{2})(\d{2})/ig, p !== -1) {
          const g = 1e3 * o;
          this.millisecond = Math.floor(g);
        }
        break;
      default:
        throw new Error("Wrong input string for conversion");
    }
    const h = c.exec(n);
    if (h === null)
      throw new Error("Wrong input string for conversion");
    for (let g = 1; g < h.length; g++)
      switch (g) {
        case 1:
          this.year = parseInt(h[g], 10);
          break;
        case 2:
          this.month = parseInt(h[g], 10);
          break;
        case 3:
          this.day = parseInt(h[g], 10);
          break;
        case 4:
          this.hour = parseInt(h[g], 10) + l;
          break;
        case 5:
          this.minute = parseInt(h[g], 10) + d;
          break;
        case 6:
          this.second = parseInt(h[g], 10);
          break;
        default:
          throw new Error("Wrong input string for conversion");
      }
    if (a === !1) {
      const g = new Date(this.year, this.month, this.day, this.hour, this.minute, this.second, this.millisecond);
      this.year = g.getUTCFullYear(), this.month = g.getUTCMonth(), this.day = g.getUTCDay(), this.hour = g.getUTCHours(), this.minute = g.getUTCMinutes(), this.second = g.getUTCSeconds(), this.millisecond = g.getUTCMilliseconds();
    }
  }
  toString(r = "iso") {
    if (r === "iso") {
      const a = [];
      return a.push(padNumber(this.year, 4)), a.push(padNumber(this.month, 2)), a.push(padNumber(this.day, 2)), a.push(padNumber(this.hour, 2)), a.push(padNumber(this.minute, 2)), a.push(padNumber(this.second, 2)), this.millisecond !== 0 && (a.push("."), a.push(padNumber(this.millisecond, 3))), a.push("Z"), a.join("");
    }
    return super.toString(r);
  }
  toJSON() {
    return {
      ...super.toJSON(),
      millisecond: this.millisecond
    };
  }
}
_a$5 = GeneralizedTime;
typeStore.GeneralizedTime = _a$5;
GeneralizedTime.NAME = "GeneralizedTime";
var _a$4;
class DATE extends Utf8String {
  constructor(r = {}) {
    super(r), this.idBlock.tagClass = 1, this.idBlock.tagNumber = 31;
  }
}
_a$4 = DATE;
typeStore.DATE = _a$4;
DATE.NAME = "DATE";
var _a$3;
class TimeOfDay extends Utf8String {
  constructor(r = {}) {
    super(r), this.idBlock.tagClass = 1, this.idBlock.tagNumber = 32;
  }
}
_a$3 = TimeOfDay;
typeStore.TimeOfDay = _a$3;
TimeOfDay.NAME = "TimeOfDay";
var _a$2;
class DateTime extends Utf8String {
  constructor(r = {}) {
    super(r), this.idBlock.tagClass = 1, this.idBlock.tagNumber = 33;
  }
}
_a$2 = DateTime;
typeStore.DateTime = _a$2;
DateTime.NAME = "DateTime";
var _a$1;
class Duration extends Utf8String {
  constructor(r = {}) {
    super(r), this.idBlock.tagClass = 1, this.idBlock.tagNumber = 34;
  }
}
_a$1 = Duration;
typeStore.Duration = _a$1;
Duration.NAME = "Duration";
var _a$x;
class TIME extends Utf8String {
  constructor(r = {}) {
    super(r), this.idBlock.tagClass = 1, this.idBlock.tagNumber = 14;
  }
}
_a$x = TIME;
typeStore.TIME = _a$x;
TIME.NAME = "TIME";
class Any {
  constructor({ name: r = EMPTY_STRING, optional: a = !1 } = {}) {
    this.name = r, this.optional = a;
  }
}
class Choice extends Any {
  constructor({ value: r = [], ...a } = {}) {
    super(a), this.value = r;
  }
}
class Repeated extends Any {
  constructor({ value: r = new Any(), local: a = !1, ...e } = {}) {
    super(e), this.value = r, this.local = a;
  }
}
class RawData {
  get data() {
    return this.dataView.slice().buffer;
  }
  set data(r) {
    this.dataView = BufferSourceConverter.toUint8Array(r);
  }
  constructor({ data: r = EMPTY_VIEW } = {}) {
    this.dataView = BufferSourceConverter.toUint8Array(r);
  }
  fromBER(r, a, e) {
    const n = a + e;
    return this.dataView = BufferSourceConverter.toUint8Array(r).subarray(a, n), n;
  }
  toBER(r) {
    return this.dataView.slice().buffer;
  }
}
function compareSchema(u, r, a) {
  if (a instanceof Choice) {
    for (const o of a.value)
      if (compareSchema(u, r, o).verified)
        return {
          verified: !0,
          result: u
        };
    {
      const o = {
        verified: !1,
        result: { error: "Wrong values for Choice type" }
      };
      return a.hasOwnProperty(NAME$1) && (o.name = a.name), o;
    }
  }
  if (a instanceof Any)
    return a.hasOwnProperty(NAME$1) && (u[a.name] = r), {
      verified: !0,
      result: u
    };
  if (!(u instanceof Object))
    return {
      verified: !1,
      result: { error: "Wrong root object" }
    };
  if (!(r instanceof Object))
    return {
      verified: !1,
      result: { error: "Wrong ASN.1 data" }
    };
  if (!(a instanceof Object))
    return {
      verified: !1,
      result: { error: "Wrong ASN.1 schema" }
    };
  if (!(ID_BLOCK in a))
    return {
      verified: !1,
      result: { error: "Wrong ASN.1 schema" }
    };
  if (!(FROM_BER in a.idBlock))
    return {
      verified: !1,
      result: { error: "Wrong ASN.1 schema" }
    };
  if (!(TO_BER in a.idBlock))
    return {
      verified: !1,
      result: { error: "Wrong ASN.1 schema" }
    };
  const e = a.idBlock.toBER(!1);
  if (e.byteLength === 0)
    return {
      verified: !1,
      result: { error: "Error encoding idBlock for ASN.1 schema" }
    };
  if (a.idBlock.fromBER(e, 0, e.byteLength) === -1)
    return {
      verified: !1,
      result: { error: "Error decoding idBlock for ASN.1 schema" }
    };
  if (a.idBlock.hasOwnProperty(TAG_CLASS) === !1)
    return {
      verified: !1,
      result: { error: "Wrong ASN.1 schema" }
    };
  if (a.idBlock.tagClass !== r.idBlock.tagClass)
    return {
      verified: !1,
      result: u
    };
  if (a.idBlock.hasOwnProperty(TAG_NUMBER) === !1)
    return {
      verified: !1,
      result: { error: "Wrong ASN.1 schema" }
    };
  if (a.idBlock.tagNumber !== r.idBlock.tagNumber)
    return {
      verified: !1,
      result: u
    };
  if (a.idBlock.hasOwnProperty(IS_CONSTRUCTED) === !1)
    return {
      verified: !1,
      result: { error: "Wrong ASN.1 schema" }
    };
  if (a.idBlock.isConstructed !== r.idBlock.isConstructed)
    return {
      verified: !1,
      result: u
    };
  if (!(IS_HEX_ONLY in a.idBlock))
    return {
      verified: !1,
      result: { error: "Wrong ASN.1 schema" }
    };
  if (a.idBlock.isHexOnly !== r.idBlock.isHexOnly)
    return {
      verified: !1,
      result: u
    };
  if (a.idBlock.isHexOnly) {
    if (!(VALUE_HEX_VIEW in a.idBlock))
      return {
        verified: !1,
        result: { error: "Wrong ASN.1 schema" }
      };
    const o = a.idBlock.valueHexView, c = r.idBlock.valueHexView;
    if (o.length !== c.length)
      return {
        verified: !1,
        result: u
      };
    for (let l = 0; l < o.length; l++)
      if (o[l] !== c[1])
        return {
          verified: !1,
          result: u
        };
  }
  if (a.name && (a.name = a.name.replace(/^\s+|\s+$/g, EMPTY_STRING), a.name && (u[a.name] = r)), a instanceof typeStore.Constructed) {
    let o = 0, c = {
      verified: !1,
      result: { error: "Unknown error" }
    }, l = a.valueBlock.value.length;
    if (l > 0 && a.valueBlock.value[0] instanceof Repeated && (l = r.valueBlock.value.length), l === 0)
      return {
        verified: !0,
        result: u
      };
    if (r.valueBlock.value.length === 0 && a.valueBlock.value.length !== 0) {
      let d = !0;
      for (let p = 0; p < a.valueBlock.value.length; p++)
        d = d && (a.valueBlock.value[p].optional || !1);
      return d ? {
        verified: !0,
        result: u
      } : (a.name && (a.name = a.name.replace(/^\s+|\s+$/g, EMPTY_STRING), a.name && delete u[a.name]), u.error = "Inconsistent object length", {
        verified: !1,
        result: u
      });
    }
    for (let d = 0; d < l; d++)
      if (d - o >= r.valueBlock.value.length) {
        if (a.valueBlock.value[d].optional === !1) {
          const p = {
            verified: !1,
            result: u
          };
          return u.error = "Inconsistent length between ASN.1 data and schema", a.name && (a.name = a.name.replace(/^\s+|\s+$/g, EMPTY_STRING), a.name && (delete u[a.name], p.name = a.name)), p;
        }
      } else if (a.valueBlock.value[0] instanceof Repeated) {
        if (c = compareSchema(u, r.valueBlock.value[d], a.valueBlock.value[0].value), c.verified === !1)
          if (a.valueBlock.value[0].optional)
            o++;
          else
            return a.name && (a.name = a.name.replace(/^\s+|\s+$/g, EMPTY_STRING), a.name && delete u[a.name]), c;
        if (NAME$1 in a.valueBlock.value[0] && a.valueBlock.value[0].name.length > 0) {
          let p = {};
          LOCAL in a.valueBlock.value[0] && a.valueBlock.value[0].local ? p = r : p = u, typeof p[a.valueBlock.value[0].name] > "u" && (p[a.valueBlock.value[0].name] = []), p[a.valueBlock.value[0].name].push(r.valueBlock.value[d]);
        }
      } else if (c = compareSchema(u, r.valueBlock.value[d - o], a.valueBlock.value[d]), c.verified === !1)
        if (a.valueBlock.value[d].optional)
          o++;
        else
          return a.name && (a.name = a.name.replace(/^\s+|\s+$/g, EMPTY_STRING), a.name && delete u[a.name]), c;
    if (c.verified === !1) {
      const d = {
        verified: !1,
        result: u
      };
      return a.name && (a.name = a.name.replace(/^\s+|\s+$/g, EMPTY_STRING), a.name && (delete u[a.name], d.name = a.name)), d;
    }
    return {
      verified: !0,
      result: u
    };
  }
  if (a.primitiveSchema && VALUE_HEX_VIEW in r.valueBlock) {
    const o = localFromBER(r.valueBlock.valueHexView);
    if (o.offset === -1) {
      const c = {
        verified: !1,
        result: o.result
      };
      return a.name && (a.name = a.name.replace(/^\s+|\s+$/g, EMPTY_STRING), a.name && (delete u[a.name], c.name = a.name)), c;
    }
    return compareSchema(u, o.result, a.primitiveSchema);
  }
  return {
    verified: !0,
    result: u
  };
}
function verifySchema(u, r) {
  if (!(r instanceof Object))
    return {
      verified: !1,
      result: { error: "Wrong ASN.1 schema type" }
    };
  const a = localFromBER(BufferSourceConverter.toUint8Array(u));
  return a.offset === -1 ? {
    verified: !1,
    result: a.result
  } : compareSchema(a.result, a.result, r);
}
const asn1js = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  Any,
  BaseBlock,
  BaseStringBlock,
  BitString: BitString$1,
  BmpString,
  Boolean: Boolean$1,
  CharacterString,
  Choice,
  Constructed,
  DATE,
  DateTime,
  Duration,
  EndOfContent,
  Enumerated,
  GeneralString,
  GeneralizedTime,
  GraphicString,
  HexBlock,
  IA5String,
  Integer,
  Null,
  NumericString,
  ObjectIdentifier,
  OctetString: OctetString$1,
  Primitive,
  PrintableString,
  RawData,
  RelativeObjectIdentifier,
  Repeated,
  Sequence,
  Set: Set$1,
  TIME,
  TeletexString,
  TimeOfDay,
  UTCTime,
  UniversalString,
  Utf8String,
  ValueBlock,
  VideotexString,
  ViewWriter,
  VisibleString,
  compareSchema,
  fromBER,
  verifySchema
}, Symbol.toStringTag, { value: "Module" }));
var AsnTypeTypes;
(function(u) {
  u[u.Sequence = 0] = "Sequence", u[u.Set = 1] = "Set", u[u.Choice = 2] = "Choice";
})(AsnTypeTypes || (AsnTypeTypes = {}));
var AsnPropTypes;
(function(u) {
  u[u.Any = 1] = "Any", u[u.Boolean = 2] = "Boolean", u[u.OctetString = 3] = "OctetString", u[u.BitString = 4] = "BitString", u[u.Integer = 5] = "Integer", u[u.Enumerated = 6] = "Enumerated", u[u.ObjectIdentifier = 7] = "ObjectIdentifier", u[u.Utf8String = 8] = "Utf8String", u[u.BmpString = 9] = "BmpString", u[u.UniversalString = 10] = "UniversalString", u[u.NumericString = 11] = "NumericString", u[u.PrintableString = 12] = "PrintableString", u[u.TeletexString = 13] = "TeletexString", u[u.VideotexString = 14] = "VideotexString", u[u.IA5String = 15] = "IA5String", u[u.GraphicString = 16] = "GraphicString", u[u.VisibleString = 17] = "VisibleString", u[u.GeneralString = 18] = "GeneralString", u[u.CharacterString = 19] = "CharacterString", u[u.UTCTime = 20] = "UTCTime", u[u.GeneralizedTime = 21] = "GeneralizedTime", u[u.DATE = 22] = "DATE", u[u.TimeOfDay = 23] = "TimeOfDay", u[u.DateTime = 24] = "DateTime", u[u.Duration = 25] = "Duration", u[u.TIME = 26] = "TIME", u[u.Null = 27] = "Null";
})(AsnPropTypes || (AsnPropTypes = {}));
class BitString {
  constructor(r, a = 0) {
    if (this.unusedBits = 0, this.value = new ArrayBuffer(0), r)
      if (typeof r == "number")
        this.fromNumber(r);
      else if (BufferSourceConverter.isBufferSource(r))
        this.unusedBits = a, this.value = BufferSourceConverter.toArrayBuffer(r);
      else
        throw TypeError("Unsupported type of 'params' argument for BitString");
  }
  fromASN(r) {
    if (!(r instanceof BitString$1))
      throw new TypeError("Argument 'asn' is not instance of ASN.1 BitString");
    return this.unusedBits = r.valueBlock.unusedBits, this.value = r.valueBlock.valueHex, this;
  }
  toASN() {
    return new BitString$1({ unusedBits: this.unusedBits, valueHex: this.value });
  }
  toSchema(r) {
    return new BitString$1({ name: r });
  }
  toNumber() {
    let r = "";
    const a = new Uint8Array(this.value);
    for (const e of a)
      r += e.toString(2).padStart(8, "0");
    return r = r.split("").reverse().join(""), this.unusedBits && (r = r.slice(this.unusedBits).padStart(this.unusedBits, "0")), parseInt(r, 2);
  }
  fromNumber(r) {
    let a = r.toString(2);
    const e = a.length + 7 >> 3;
    this.unusedBits = (e << 3) - a.length;
    const n = new Uint8Array(e);
    a = a.padStart(e << 3, "0").split("").reverse().join("");
    let o = 0;
    for (; o < e; )
      n[o] = parseInt(a.slice(o << 3, (o << 3) + 8), 2), o++;
    this.value = n.buffer;
  }
}
class OctetString {
  get byteLength() {
    return this.buffer.byteLength;
  }
  get byteOffset() {
    return 0;
  }
  constructor(r) {
    typeof r == "number" ? this.buffer = new ArrayBuffer(r) : BufferSourceConverter.isBufferSource(r) ? this.buffer = BufferSourceConverter.toArrayBuffer(r) : Array.isArray(r) ? this.buffer = new Uint8Array(r) : this.buffer = new ArrayBuffer(0);
  }
  fromASN(r) {
    if (!(r instanceof OctetString$1))
      throw new TypeError("Argument 'asn' is not instance of ASN.1 OctetString");
    return this.buffer = r.valueBlock.valueHex, this;
  }
  toASN() {
    return new OctetString$1({ valueHex: this.buffer });
  }
  toSchema(r) {
    return new OctetString$1({ name: r });
  }
}
const AsnAnyConverter = {
  fromASN: (u) => u instanceof Null ? null : u.valueBeforeDecodeView,
  toASN: (u) => {
    if (u === null)
      return new Null();
    const r = fromBER(u);
    if (r.result.error)
      throw new Error(r.result.error);
    return r.result;
  }
}, AsnIntegerConverter = {
  fromASN: (u) => u.valueBlock.valueHexView.byteLength >= 4 ? u.valueBlock.toString() : u.valueBlock.valueDec,
  toASN: (u) => new Integer({ value: +u })
}, AsnEnumeratedConverter = {
  fromASN: (u) => u.valueBlock.valueDec,
  toASN: (u) => new Enumerated({ value: u })
}, AsnIntegerArrayBufferConverter = {
  fromASN: (u) => u.valueBlock.valueHexView,
  toASN: (u) => new Integer({ valueHex: u })
}, AsnBitStringConverter = {
  fromASN: (u) => u.valueBlock.valueHexView,
  toASN: (u) => new BitString$1({ valueHex: u })
}, AsnObjectIdentifierConverter = {
  fromASN: (u) => u.valueBlock.toString(),
  toASN: (u) => new ObjectIdentifier({ value: u })
}, AsnBooleanConverter = {
  fromASN: (u) => u.valueBlock.value,
  toASN: (u) => new Boolean$1({ value: u })
}, AsnOctetStringConverter = {
  fromASN: (u) => u.valueBlock.valueHexView,
  toASN: (u) => new OctetString$1({ valueHex: u })
}, AsnConstructedOctetStringConverter = {
  fromASN: (u) => new OctetString(u.getValue()),
  toASN: (u) => u.toASN()
};
function createStringConverter(u) {
  return {
    fromASN: (r) => r.valueBlock.value,
    toASN: (r) => new u({ value: r })
  };
}
const AsnUtf8StringConverter = createStringConverter(Utf8String), AsnBmpStringConverter = createStringConverter(BmpString), AsnUniversalStringConverter = createStringConverter(UniversalString), AsnNumericStringConverter = createStringConverter(NumericString), AsnPrintableStringConverter = createStringConverter(PrintableString), AsnTeletexStringConverter = createStringConverter(TeletexString), AsnVideotexStringConverter = createStringConverter(VideotexString), AsnIA5StringConverter = createStringConverter(IA5String), AsnGraphicStringConverter = createStringConverter(GraphicString), AsnVisibleStringConverter = createStringConverter(VisibleString), AsnGeneralStringConverter = createStringConverter(GeneralString), AsnCharacterStringConverter = createStringConverter(CharacterString), AsnUTCTimeConverter = {
  fromASN: (u) => u.toDate(),
  toASN: (u) => new UTCTime({ valueDate: u })
}, AsnGeneralizedTimeConverter = {
  fromASN: (u) => u.toDate(),
  toASN: (u) => new GeneralizedTime({ valueDate: u })
}, AsnNullConverter = {
  fromASN: () => null,
  toASN: () => new Null()
};
function defaultConverter(u) {
  switch (u) {
    case AsnPropTypes.Any:
      return AsnAnyConverter;
    case AsnPropTypes.BitString:
      return AsnBitStringConverter;
    case AsnPropTypes.BmpString:
      return AsnBmpStringConverter;
    case AsnPropTypes.Boolean:
      return AsnBooleanConverter;
    case AsnPropTypes.CharacterString:
      return AsnCharacterStringConverter;
    case AsnPropTypes.Enumerated:
      return AsnEnumeratedConverter;
    case AsnPropTypes.GeneralString:
      return AsnGeneralStringConverter;
    case AsnPropTypes.GeneralizedTime:
      return AsnGeneralizedTimeConverter;
    case AsnPropTypes.GraphicString:
      return AsnGraphicStringConverter;
    case AsnPropTypes.IA5String:
      return AsnIA5StringConverter;
    case AsnPropTypes.Integer:
      return AsnIntegerConverter;
    case AsnPropTypes.Null:
      return AsnNullConverter;
    case AsnPropTypes.NumericString:
      return AsnNumericStringConverter;
    case AsnPropTypes.ObjectIdentifier:
      return AsnObjectIdentifierConverter;
    case AsnPropTypes.OctetString:
      return AsnOctetStringConverter;
    case AsnPropTypes.PrintableString:
      return AsnPrintableStringConverter;
    case AsnPropTypes.TeletexString:
      return AsnTeletexStringConverter;
    case AsnPropTypes.UTCTime:
      return AsnUTCTimeConverter;
    case AsnPropTypes.UniversalString:
      return AsnUniversalStringConverter;
    case AsnPropTypes.Utf8String:
      return AsnUtf8StringConverter;
    case AsnPropTypes.VideotexString:
      return AsnVideotexStringConverter;
    case AsnPropTypes.VisibleString:
      return AsnVisibleStringConverter;
    default:
      return null;
  }
}
function isConvertible(u) {
  return typeof u == "function" && u.prototype ? u.prototype.toASN && u.prototype.fromASN ? !0 : isConvertible(u.prototype) : !!(u && typeof u == "object" && "toASN" in u && "fromASN" in u);
}
function isTypeOfArray(u) {
  var r;
  if (u) {
    const a = Object.getPrototypeOf(u);
    return ((r = a?.prototype) === null || r === void 0 ? void 0 : r.constructor) === Array ? !0 : isTypeOfArray(a);
  }
  return !1;
}
function isArrayEqual(u, r) {
  if (!(u && r) || u.byteLength !== r.byteLength)
    return !1;
  const a = new Uint8Array(u), e = new Uint8Array(r);
  for (let n = 0; n < u.byteLength; n++)
    if (a[n] !== e[n])
      return !1;
  return !0;
}
class AsnSchemaStorage {
  constructor() {
    this.items = /* @__PURE__ */ new WeakMap();
  }
  has(r) {
    return this.items.has(r);
  }
  get(r, a = !1) {
    const e = this.items.get(r);
    if (!e)
      throw new Error(`Cannot get schema for '${r.prototype.constructor.name}' target`);
    if (a && !e.schema)
      throw new Error(`Schema '${r.prototype.constructor.name}' doesn't contain ASN.1 schema. Call 'AsnSchemaStorage.cache'.`);
    return e;
  }
  cache(r) {
    const a = this.get(r);
    a.schema || (a.schema = this.create(r, !0));
  }
  createDefault(r) {
    const a = {
      type: AsnTypeTypes.Sequence,
      items: {}
    }, e = this.findParentSchema(r);
    return e && (Object.assign(a, e), a.items = Object.assign({}, a.items, e.items)), a;
  }
  create(r, a) {
    const e = this.items.get(r) || this.createDefault(r), n = [];
    for (const o in e.items) {
      const c = e.items[o], l = a ? o : "";
      let d;
      if (typeof c.type == "number") {
        const h = AsnPropTypes[c.type], g = asn1js[h];
        if (!g)
          throw new Error(`Cannot get ASN1 class by name '${h}'`);
        d = new g({ name: l });
      } else
        isConvertible(c.type) ? d = new c.type().toSchema(l) : c.optional ? this.get(c.type).type === AsnTypeTypes.Choice ? d = new Any({ name: l }) : (d = this.create(c.type, !1), d.name = l) : d = new Any({ name: l });
      const p = !!c.optional || c.defaultValue !== void 0;
      if (c.repeated) {
        d.name = "";
        const h = c.repeated === "set" ? Set$1 : Sequence;
        d = new h({
          name: "",
          value: [
            new Repeated({
              name: l,
              value: d
            })
          ]
        });
      }
      if (c.context !== null && c.context !== void 0)
        if (c.implicit)
          if (typeof c.type == "number" || isConvertible(c.type)) {
            const h = c.repeated ? Constructed : Primitive;
            n.push(new h({
              name: l,
              optional: p,
              idBlock: {
                tagClass: 3,
                tagNumber: c.context
              }
            }));
          } else {
            this.cache(c.type);
            const h = !!c.repeated;
            let g = h ? d : this.get(c.type, !0).schema;
            g = "valueBlock" in g ? g.valueBlock.value : g.value, n.push(new Constructed({
              name: h ? "" : l,
              optional: p,
              idBlock: {
                tagClass: 3,
                tagNumber: c.context
              },
              value: g
            }));
          }
        else
          n.push(new Constructed({
            optional: p,
            idBlock: {
              tagClass: 3,
              tagNumber: c.context
            },
            value: [d]
          }));
      else
        d.optional = p, n.push(d);
    }
    switch (e.type) {
      case AsnTypeTypes.Sequence:
        return new Sequence({ value: n, name: "" });
      case AsnTypeTypes.Set:
        return new Set$1({ value: n, name: "" });
      case AsnTypeTypes.Choice:
        return new Choice({ value: n, name: "" });
      default:
        throw new Error("Unsupported ASN1 type in use");
    }
  }
  set(r, a) {
    return this.items.set(r, a), this;
  }
  findParentSchema(r) {
    const a = Object.getPrototypeOf(r);
    return a ? this.items.get(a) || this.findParentSchema(a) : null;
  }
}
const schemaStorage = new AsnSchemaStorage(), AsnType = (u) => (r) => {
  let a;
  schemaStorage.has(r) ? a = schemaStorage.get(r) : (a = schemaStorage.createDefault(r), schemaStorage.set(r, a)), Object.assign(a, u);
}, AsnProp = (u) => (r, a) => {
  let e;
  schemaStorage.has(r.constructor) ? e = schemaStorage.get(r.constructor) : (e = schemaStorage.createDefault(r.constructor), schemaStorage.set(r.constructor, e));
  const n = Object.assign({}, u);
  if (typeof n.type == "number" && !n.converter) {
    const o = defaultConverter(u.type);
    if (!o)
      throw new Error(`Cannot get default converter for property '${a}' of ${r.constructor.name}`);
    n.converter = o;
  }
  e.items[a] = n;
};
class AsnSchemaValidationError extends Error {
  constructor() {
    super(...arguments), this.schemas = [];
  }
}
class AsnParser {
  static parse(r, a) {
    const e = fromBER(r);
    if (e.result.error)
      throw new Error(e.result.error);
    return this.fromASN(e.result, a);
  }
  static fromASN(r, a) {
    var e;
    try {
      if (isConvertible(a))
        return new a().fromASN(r);
      const n = schemaStorage.get(a);
      schemaStorage.cache(a);
      let o = n.schema;
      if (r.constructor === Constructed && n.type !== AsnTypeTypes.Choice) {
        o = new Constructed({
          idBlock: {
            tagClass: 3,
            tagNumber: r.idBlock.tagNumber
          },
          value: n.schema.valueBlock.value
        });
        for (const d in n.items)
          delete r[d];
      }
      const c = compareSchema({}, r, o);
      if (!c.verified)
        throw new AsnSchemaValidationError(`Data does not match to ${a.name} ASN1 schema. ${c.result.error}`);
      const l = new a();
      if (isTypeOfArray(a)) {
        if (!("value" in r.valueBlock && Array.isArray(r.valueBlock.value)))
          throw new Error("Cannot get items from the ASN.1 parsed value. ASN.1 object is not constructed.");
        const d = n.itemType;
        if (typeof d == "number") {
          const p = defaultConverter(d);
          if (!p)
            throw new Error(`Cannot get default converter for array item of ${a.name} ASN1 schema`);
          return a.from(r.valueBlock.value, (h) => p.fromASN(h));
        } else
          return a.from(r.valueBlock.value, (p) => this.fromASN(p, d));
      }
      for (const d in n.items) {
        const p = c.result[d];
        if (!p)
          continue;
        const h = n.items[d], g = h.type;
        if (typeof g == "number" || isConvertible(g)) {
          const y = (e = h.converter) !== null && e !== void 0 ? e : isConvertible(g) ? new g() : null;
          if (!y)
            throw new Error("Converter is empty");
          if (h.repeated)
            if (h.implicit) {
              const v = h.repeated === "sequence" ? Sequence : Set$1, m = new v();
              m.valueBlock = p.valueBlock;
              const b = fromBER(m.toBER(!1));
              if (b.offset === -1)
                throw new Error(`Cannot parse the child item. ${b.result.error}`);
              if (!("value" in b.result.valueBlock && Array.isArray(b.result.valueBlock.value)))
                throw new Error("Cannot get items from the ASN.1 parsed value. ASN.1 object is not constructed.");
              const R = b.result.valueBlock.value;
              l[d] = Array.from(R, ($) => y.fromASN($));
            } else
              l[d] = Array.from(p, (v) => y.fromASN(v));
          else {
            let v = p;
            if (h.implicit) {
              let m;
              if (isConvertible(g))
                m = new g().toSchema("");
              else {
                const b = AsnPropTypes[g], R = asn1js[b];
                if (!R)
                  throw new Error(`Cannot get '${b}' class from asn1js module`);
                m = new R();
              }
              m.valueBlock = v.valueBlock, v = fromBER(m.toBER(!1)).result;
            }
            l[d] = y.fromASN(v);
          }
        } else if (h.repeated) {
          if (!Array.isArray(p))
            throw new Error("Cannot get list of items from the ASN.1 parsed value. ASN.1 value should be iterable.");
          l[d] = Array.from(p, (y) => this.fromASN(y, g));
        } else
          l[d] = this.fromASN(p, g);
      }
      return l;
    } catch (n) {
      throw n instanceof AsnSchemaValidationError && n.schemas.push(a.name), n;
    }
  }
}
class AsnSerializer {
  static serialize(r) {
    return r instanceof BaseBlock ? r.toBER(!1) : this.toASN(r).toBER(!1);
  }
  static toASN(r) {
    if (r && typeof r == "object" && isConvertible(r))
      return r.toASN();
    if (!(r && typeof r == "object"))
      throw new TypeError("Parameter 1 should be type of Object.");
    const a = r.constructor, e = schemaStorage.get(a);
    schemaStorage.cache(a);
    let n = [];
    if (e.itemType) {
      if (!Array.isArray(r))
        throw new TypeError("Parameter 1 should be type of Array.");
      if (typeof e.itemType == "number") {
        const c = defaultConverter(e.itemType);
        if (!c)
          throw new Error(`Cannot get default converter for array item of ${a.name} ASN1 schema`);
        n = r.map((l) => c.toASN(l));
      } else
        n = r.map((c) => this.toAsnItem({ type: e.itemType }, "[]", a, c));
    } else
      for (const c in e.items) {
        const l = e.items[c], d = r[c];
        if (d === void 0 || l.defaultValue === d || typeof l.defaultValue == "object" && typeof d == "object" && isArrayEqual(this.serialize(l.defaultValue), this.serialize(d)))
          continue;
        const p = AsnSerializer.toAsnItem(l, c, a, d);
        if (typeof l.context == "number")
          if (l.implicit)
            if (!l.repeated && (typeof l.type == "number" || isConvertible(l.type))) {
              const h = {};
              h.valueHex = p instanceof Null ? p.valueBeforeDecodeView : p.valueBlock.toBER(), n.push(new Primitive({
                optional: l.optional,
                idBlock: {
                  tagClass: 3,
                  tagNumber: l.context
                },
                ...h
              }));
            } else
              n.push(new Constructed({
                optional: l.optional,
                idBlock: {
                  tagClass: 3,
                  tagNumber: l.context
                },
                value: p.valueBlock.value
              }));
          else
            n.push(new Constructed({
              optional: l.optional,
              idBlock: {
                tagClass: 3,
                tagNumber: l.context
              },
              value: [p]
            }));
        else
          l.repeated ? n = n.concat(p) : n.push(p);
      }
    let o;
    switch (e.type) {
      case AsnTypeTypes.Sequence:
        o = new Sequence({ value: n });
        break;
      case AsnTypeTypes.Set:
        o = new Set$1({ value: n });
        break;
      case AsnTypeTypes.Choice:
        if (!n[0])
          throw new Error(`Schema '${a.name}' has wrong data. Choice cannot be empty.`);
        o = n[0];
        break;
    }
    return o;
  }
  static toAsnItem(r, a, e, n) {
    let o;
    if (typeof r.type == "number") {
      const c = r.converter;
      if (!c)
        throw new Error(`Property '${a}' doesn't have converter for type ${AsnPropTypes[r.type]} in schema '${e.name}'`);
      if (r.repeated) {
        if (!Array.isArray(n))
          throw new TypeError("Parameter 'objProp' should be type of Array.");
        const l = Array.from(n, (p) => c.toASN(p)), d = r.repeated === "sequence" ? Sequence : Set$1;
        o = new d({
          value: l
        });
      } else
        o = c.toASN(n);
    } else if (r.repeated) {
      if (!Array.isArray(n))
        throw new TypeError("Parameter 'objProp' should be type of Array.");
      const c = Array.from(n, (d) => this.toASN(d)), l = r.repeated === "sequence" ? Sequence : Set$1;
      o = new l({
        value: c
      });
    } else
      o = this.toASN(n);
    return o;
  }
}
class AsnArray extends Array {
  constructor(r = []) {
    if (typeof r == "number")
      super(r);
    else {
      super();
      for (const a of r)
        this.push(a);
    }
  }
}
class AsnConvert {
  static serialize(r) {
    return AsnSerializer.serialize(r);
  }
  static parse(r, a) {
    return AsnParser.parse(r, a);
  }
  static toString(r) {
    const a = BufferSourceConverter.isBufferSource(r) ? BufferSourceConverter.toArrayBuffer(r) : AsnConvert.serialize(r), e = fromBER(a);
    if (e.offset === -1)
      throw new Error(`Cannot decode ASN.1 data. ${e.result.error}`);
    return e.result.toString();
  }
}
function __decorate(u, r, a, e) {
  var n = arguments.length, o = n < 3 ? r : e === null ? e = Object.getOwnPropertyDescriptor(r, a) : e, c;
  if (typeof Reflect == "object" && typeof Reflect.decorate == "function")
    o = Reflect.decorate(u, r, a, e);
  else
    for (var l = u.length - 1; l >= 0; l--)
      (c = u[l]) && (o = (n < 3 ? c(o) : n > 3 ? c(r, a, o) : c(r, a)) || o);
  return n > 3 && o && Object.defineProperty(r, a, o), o;
}
typeof SuppressedError == "function" && SuppressedError;
class IpConverter {
  static isIPv4(r) {
    return /^(\d{1,3}\.){3}\d{1,3}$/.test(r);
  }
  static parseIPv4(r) {
    const a = r.split(".");
    if (a.length !== 4)
      throw new Error("Invalid IPv4 address");
    return a.map((e) => {
      const n = parseInt(e, 10);
      if (isNaN(n) || n < 0 || n > 255)
        throw new Error("Invalid IPv4 address part");
      return n;
    });
  }
  static parseIPv6(r) {
    const e = this.expandIPv6(r).split(":");
    if (e.length !== 8)
      throw new Error("Invalid IPv6 address");
    return e.reduce((n, o) => {
      const c = parseInt(o, 16);
      if (isNaN(c) || c < 0 || c > 65535)
        throw new Error("Invalid IPv6 address part");
      return n.push(c >> 8 & 255), n.push(c & 255), n;
    }, []);
  }
  static expandIPv6(r) {
    if (!r.includes("::"))
      return r;
    const a = r.split("::");
    if (a.length > 2)
      throw new Error("Invalid IPv6 address");
    const e = a[0] ? a[0].split(":") : [], n = a[1] ? a[1].split(":") : [], o = 8 - (e.length + n.length);
    if (o < 0)
      throw new Error("Invalid IPv6 address");
    return [...e, ...Array(o).fill("0"), ...n].join(":");
  }
  static formatIPv6(r) {
    const a = [];
    for (let e = 0; e < 16; e += 2)
      a.push((r[e] << 8 | r[e + 1]).toString(16));
    return this.compressIPv6(a.join(":"));
  }
  static compressIPv6(r) {
    const a = r.split(":");
    let e = -1, n = 0, o = -1, c = 0;
    for (let l = 0; l < a.length; l++)
      a[l] === "0" ? (o === -1 && (o = l), c++) : (c > n && (e = o, n = c), o = -1, c = 0);
    if (c > n && (e = o, n = c), n > 1) {
      const l = a.slice(0, e).join(":"), d = a.slice(e + n).join(":");
      return `${l}::${d}`;
    }
    return r;
  }
  static parseCIDR(r) {
    const [a, e] = r.split("/"), n = parseInt(e, 10);
    if (this.isIPv4(a)) {
      if (n < 0 || n > 32)
        throw new Error("Invalid IPv4 prefix length");
      return [this.parseIPv4(a), n];
    } else {
      if (n < 0 || n > 128)
        throw new Error("Invalid IPv6 prefix length");
      return [this.parseIPv6(a), n];
    }
  }
  static decodeIP(r) {
    if (r.length === 64 && parseInt(r, 16) === 0)
      return "::/0";
    if (r.length !== 16)
      return r;
    const a = parseInt(r.slice(8), 16).toString(2).split("").reduce((n, o) => n + +o, 0);
    let e = r.slice(0, 8).replace(/(.{2})/g, (n) => `${parseInt(n, 16)}.`);
    return e = e.slice(0, -1), `${e}/${a}`;
  }
  static toString(r) {
    const a = new Uint8Array(r);
    if (a.length === 4)
      return Array.from(a).join(".");
    if (a.length === 16)
      return this.formatIPv6(a);
    if (a.length === 8 || a.length === 32) {
      const e = a.length / 2, n = a.slice(0, e), o = a.slice(e);
      if (a.every((d) => d === 0))
        return a.length === 8 ? "0.0.0.0/0" : "::/0";
      const l = o.reduce((d, p) => d + (p.toString(2).match(/1/g) || []).length, 0);
      return a.length === 8 ? `${Array.from(n).join(".")}/${l}` : `${this.formatIPv6(n)}/${l}`;
    }
    return this.decodeIP(Convert.ToHex(r));
  }
  static fromString(r) {
    if (r.includes("/")) {
      const [e, n] = this.parseCIDR(r), o = new Uint8Array(e.length);
      let c = n;
      for (let d = 0; d < o.length; d++)
        c >= 8 ? (o[d] = 255, c -= 8) : c > 0 && (o[d] = 255 << 8 - c, c = 0);
      const l = new Uint8Array(e.length * 2);
      return l.set(e, 0), l.set(o, e.length), l.buffer;
    }
    const a = this.isIPv4(r) ? this.parseIPv4(r) : this.parseIPv6(r);
    return new Uint8Array(a).buffer;
  }
}
var RelativeDistinguishedName_1, RDNSequence_1, Name_1;
let DirectoryString = class {
  constructor(r = {}) {
    Object.assign(this, r);
  }
  toString() {
    return this.bmpString || this.printableString || this.teletexString || this.universalString || this.utf8String || "";
  }
};
__decorate([
  AsnProp({ type: AsnPropTypes.TeletexString })
], DirectoryString.prototype, "teletexString", void 0);
__decorate([
  AsnProp({ type: AsnPropTypes.PrintableString })
], DirectoryString.prototype, "printableString", void 0);
__decorate([
  AsnProp({ type: AsnPropTypes.UniversalString })
], DirectoryString.prototype, "universalString", void 0);
__decorate([
  AsnProp({ type: AsnPropTypes.Utf8String })
], DirectoryString.prototype, "utf8String", void 0);
__decorate([
  AsnProp({ type: AsnPropTypes.BmpString })
], DirectoryString.prototype, "bmpString", void 0);
DirectoryString = __decorate([
  AsnType({ type: AsnTypeTypes.Choice })
], DirectoryString);
let AttributeValue = class extends DirectoryString {
  constructor(r = {}) {
    super(r), Object.assign(this, r);
  }
  toString() {
    return this.ia5String || (this.anyValue ? Convert.ToHex(this.anyValue) : super.toString());
  }
};
__decorate([
  AsnProp({ type: AsnPropTypes.IA5String })
], AttributeValue.prototype, "ia5String", void 0);
__decorate([
  AsnProp({ type: AsnPropTypes.Any })
], AttributeValue.prototype, "anyValue", void 0);
AttributeValue = __decorate([
  AsnType({ type: AsnTypeTypes.Choice })
], AttributeValue);
class AttributeTypeAndValue {
  constructor(r = {}) {
    this.type = "", this.value = new AttributeValue(), Object.assign(this, r);
  }
}
__decorate([
  AsnProp({ type: AsnPropTypes.ObjectIdentifier })
], AttributeTypeAndValue.prototype, "type", void 0);
__decorate([
  AsnProp({ type: AttributeValue })
], AttributeTypeAndValue.prototype, "value", void 0);
let RelativeDistinguishedName = RelativeDistinguishedName_1 = class extends AsnArray {
  constructor(r) {
    super(r), Object.setPrototypeOf(this, RelativeDistinguishedName_1.prototype);
  }
};
RelativeDistinguishedName = RelativeDistinguishedName_1 = __decorate([
  AsnType({ type: AsnTypeTypes.Set, itemType: AttributeTypeAndValue })
], RelativeDistinguishedName);
let RDNSequence = RDNSequence_1 = class extends AsnArray {
  constructor(r) {
    super(r), Object.setPrototypeOf(this, RDNSequence_1.prototype);
  }
};
RDNSequence = RDNSequence_1 = __decorate([
  AsnType({ type: AsnTypeTypes.Sequence, itemType: RelativeDistinguishedName })
], RDNSequence);
let Name$1 = Name_1 = class extends RDNSequence {
  constructor(r) {
    super(r), Object.setPrototypeOf(this, Name_1.prototype);
  }
};
Name$1 = Name_1 = __decorate([
  AsnType({ type: AsnTypeTypes.Sequence })
], Name$1);
const AsnIpConverter = {
  fromASN: (u) => IpConverter.toString(AsnOctetStringConverter.fromASN(u)),
  toASN: (u) => AsnOctetStringConverter.toASN(IpConverter.fromString(u))
};
class OtherName {
  constructor(r = {}) {
    this.typeId = "", this.value = new ArrayBuffer(0), Object.assign(this, r);
  }
}
__decorate([
  AsnProp({ type: AsnPropTypes.ObjectIdentifier })
], OtherName.prototype, "typeId", void 0);
__decorate([
  AsnProp({ type: AsnPropTypes.Any, context: 0 })
], OtherName.prototype, "value", void 0);
class EDIPartyName {
  constructor(r = {}) {
    this.partyName = new DirectoryString(), Object.assign(this, r);
  }
}
__decorate([
  AsnProp({ type: DirectoryString, optional: !0, context: 0, implicit: !0 })
], EDIPartyName.prototype, "nameAssigner", void 0);
__decorate([
  AsnProp({ type: DirectoryString, context: 1, implicit: !0 })
], EDIPartyName.prototype, "partyName", void 0);
let GeneralName$1 = class {
  constructor(r = {}) {
    Object.assign(this, r);
  }
};
__decorate([
  AsnProp({ type: OtherName, context: 0, implicit: !0 })
], GeneralName$1.prototype, "otherName", void 0);
__decorate([
  AsnProp({ type: AsnPropTypes.IA5String, context: 1, implicit: !0 })
], GeneralName$1.prototype, "rfc822Name", void 0);
__decorate([
  AsnProp({ type: AsnPropTypes.IA5String, context: 2, implicit: !0 })
], GeneralName$1.prototype, "dNSName", void 0);
__decorate([
  AsnProp({ type: AsnPropTypes.Any, context: 3, implicit: !0 })
], GeneralName$1.prototype, "x400Address", void 0);
__decorate([
  AsnProp({ type: Name$1, context: 4, implicit: !1 })
], GeneralName$1.prototype, "directoryName", void 0);
__decorate([
  AsnProp({ type: EDIPartyName, context: 5 })
], GeneralName$1.prototype, "ediPartyName", void 0);
__decorate([
  AsnProp({ type: AsnPropTypes.IA5String, context: 6, implicit: !0 })
], GeneralName$1.prototype, "uniformResourceIdentifier", void 0);
__decorate([
  AsnProp({
    type: AsnPropTypes.OctetString,
    context: 7,
    implicit: !0,
    converter: AsnIpConverter
  })
], GeneralName$1.prototype, "iPAddress", void 0);
__decorate([
  AsnProp({ type: AsnPropTypes.ObjectIdentifier, context: 8, implicit: !0 })
], GeneralName$1.prototype, "registeredID", void 0);
GeneralName$1 = __decorate([
  AsnType({ type: AsnTypeTypes.Choice })
], GeneralName$1);
const id_pkix = "1.3.6.1.5.5.7", id_kp = `${id_pkix}.3`, id_ce = "2.5.29";
var AuthorityInfoAccessSyntax_1;
class AccessDescription {
  constructor(r = {}) {
    this.accessMethod = "", this.accessLocation = new GeneralName$1(), Object.assign(this, r);
  }
}
__decorate([
  AsnProp({ type: AsnPropTypes.ObjectIdentifier })
], AccessDescription.prototype, "accessMethod", void 0);
__decorate([
  AsnProp({ type: GeneralName$1 })
], AccessDescription.prototype, "accessLocation", void 0);
let AuthorityInfoAccessSyntax = AuthorityInfoAccessSyntax_1 = class extends AsnArray {
  constructor(r) {
    super(r), Object.setPrototypeOf(this, AuthorityInfoAccessSyntax_1.prototype);
  }
};
AuthorityInfoAccessSyntax = AuthorityInfoAccessSyntax_1 = __decorate([
  AsnType({ type: AsnTypeTypes.Sequence, itemType: AccessDescription })
], AuthorityInfoAccessSyntax);
const id_ce_authorityKeyIdentifier = `${id_ce}.35`;
class KeyIdentifier extends OctetString {
}
class AuthorityKeyIdentifier {
  constructor(r = {}) {
    r && Object.assign(this, r);
  }
}
__decorate([
  AsnProp({ type: KeyIdentifier, context: 0, optional: !0, implicit: !0 })
], AuthorityKeyIdentifier.prototype, "keyIdentifier", void 0);
__decorate([
  AsnProp({ type: GeneralName$1, context: 1, optional: !0, implicit: !0, repeated: "sequence" })
], AuthorityKeyIdentifier.prototype, "authorityCertIssuer", void 0);
__decorate([
  AsnProp({
    type: AsnPropTypes.Integer,
    context: 2,
    optional: !0,
    implicit: !0,
    converter: AsnIntegerArrayBufferConverter
  })
], AuthorityKeyIdentifier.prototype, "authorityCertSerialNumber", void 0);
const id_ce_basicConstraints = `${id_ce}.19`;
class BasicConstraints {
  constructor(r = {}) {
    this.cA = !1, Object.assign(this, r);
  }
}
__decorate([
  AsnProp({ type: AsnPropTypes.Boolean, defaultValue: !1 })
], BasicConstraints.prototype, "cA", void 0);
__decorate([
  AsnProp({ type: AsnPropTypes.Integer, optional: !0 })
], BasicConstraints.prototype, "pathLenConstraint", void 0);
var GeneralNames_1;
let GeneralNames$1 = GeneralNames_1 = class extends AsnArray {
  constructor(r) {
    super(r), Object.setPrototypeOf(this, GeneralNames_1.prototype);
  }
};
GeneralNames$1 = GeneralNames_1 = __decorate([
  AsnType({ type: AsnTypeTypes.Sequence, itemType: GeneralName$1 })
], GeneralNames$1);
var CertificateIssuer_1;
let CertificateIssuer = CertificateIssuer_1 = class extends GeneralNames$1 {
  constructor(r) {
    super(r), Object.setPrototypeOf(this, CertificateIssuer_1.prototype);
  }
};
CertificateIssuer = CertificateIssuer_1 = __decorate([
  AsnType({ type: AsnTypeTypes.Sequence })
], CertificateIssuer);
var CertificatePolicies_1;
const id_ce_certificatePolicies = `${id_ce}.32`;
let DisplayText = class {
  constructor(r = {}) {
    Object.assign(this, r);
  }
  toString() {
    return this.ia5String || this.visibleString || this.bmpString || this.utf8String || "";
  }
};
__decorate([
  AsnProp({ type: AsnPropTypes.IA5String })
], DisplayText.prototype, "ia5String", void 0);
__decorate([
  AsnProp({ type: AsnPropTypes.VisibleString })
], DisplayText.prototype, "visibleString", void 0);
__decorate([
  AsnProp({ type: AsnPropTypes.BmpString })
], DisplayText.prototype, "bmpString", void 0);
__decorate([
  AsnProp({ type: AsnPropTypes.Utf8String })
], DisplayText.prototype, "utf8String", void 0);
DisplayText = __decorate([
  AsnType({ type: AsnTypeTypes.Choice })
], DisplayText);
class NoticeReference {
  constructor(r = {}) {
    this.organization = new DisplayText(), this.noticeNumbers = [], Object.assign(this, r);
  }
}
__decorate([
  AsnProp({ type: DisplayText })
], NoticeReference.prototype, "organization", void 0);
__decorate([
  AsnProp({ type: AsnPropTypes.Integer, repeated: "sequence" })
], NoticeReference.prototype, "noticeNumbers", void 0);
class UserNotice {
  constructor(r = {}) {
    Object.assign(this, r);
  }
}
__decorate([
  AsnProp({ type: NoticeReference, optional: !0 })
], UserNotice.prototype, "noticeRef", void 0);
__decorate([
  AsnProp({ type: DisplayText, optional: !0 })
], UserNotice.prototype, "explicitText", void 0);
let Qualifier = class {
  constructor(r = {}) {
    Object.assign(this, r);
  }
};
__decorate([
  AsnProp({ type: AsnPropTypes.IA5String })
], Qualifier.prototype, "cPSuri", void 0);
__decorate([
  AsnProp({ type: UserNotice })
], Qualifier.prototype, "userNotice", void 0);
Qualifier = __decorate([
  AsnType({ type: AsnTypeTypes.Choice })
], Qualifier);
class PolicyQualifierInfo {
  constructor(r = {}) {
    this.policyQualifierId = "", this.qualifier = new ArrayBuffer(0), Object.assign(this, r);
  }
}
__decorate([
  AsnProp({ type: AsnPropTypes.ObjectIdentifier })
], PolicyQualifierInfo.prototype, "policyQualifierId", void 0);
__decorate([
  AsnProp({ type: AsnPropTypes.Any })
], PolicyQualifierInfo.prototype, "qualifier", void 0);
class PolicyInformation {
  constructor(r = {}) {
    this.policyIdentifier = "", Object.assign(this, r);
  }
}
__decorate([
  AsnProp({ type: AsnPropTypes.ObjectIdentifier })
], PolicyInformation.prototype, "policyIdentifier", void 0);
__decorate([
  AsnProp({ type: PolicyQualifierInfo, repeated: "sequence", optional: !0 })
], PolicyInformation.prototype, "policyQualifiers", void 0);
let CertificatePolicies = CertificatePolicies_1 = class extends AsnArray {
  constructor(r) {
    super(r), Object.setPrototypeOf(this, CertificatePolicies_1.prototype);
  }
};
CertificatePolicies = CertificatePolicies_1 = __decorate([
  AsnType({ type: AsnTypeTypes.Sequence, itemType: PolicyInformation })
], CertificatePolicies);
let CRLNumber = class {
  constructor(r = 0) {
    this.value = r;
  }
};
__decorate([
  AsnProp({ type: AsnPropTypes.Integer })
], CRLNumber.prototype, "value", void 0);
CRLNumber = __decorate([
  AsnType({ type: AsnTypeTypes.Choice })
], CRLNumber);
let BaseCRLNumber = class extends CRLNumber {
};
BaseCRLNumber = __decorate([
  AsnType({ type: AsnTypeTypes.Choice })
], BaseCRLNumber);
var CRLDistributionPoints_1, ReasonFlags;
(function(u) {
  u[u.unused = 1] = "unused", u[u.keyCompromise = 2] = "keyCompromise", u[u.cACompromise = 4] = "cACompromise", u[u.affiliationChanged = 8] = "affiliationChanged", u[u.superseded = 16] = "superseded", u[u.cessationOfOperation = 32] = "cessationOfOperation", u[u.certificateHold = 64] = "certificateHold", u[u.privilegeWithdrawn = 128] = "privilegeWithdrawn", u[u.aACompromise = 256] = "aACompromise";
})(ReasonFlags || (ReasonFlags = {}));
class Reason extends BitString {
  toJSON() {
    const r = [], a = this.toNumber();
    return a & ReasonFlags.aACompromise && r.push("aACompromise"), a & ReasonFlags.affiliationChanged && r.push("affiliationChanged"), a & ReasonFlags.cACompromise && r.push("cACompromise"), a & ReasonFlags.certificateHold && r.push("certificateHold"), a & ReasonFlags.cessationOfOperation && r.push("cessationOfOperation"), a & ReasonFlags.keyCompromise && r.push("keyCompromise"), a & ReasonFlags.privilegeWithdrawn && r.push("privilegeWithdrawn"), a & ReasonFlags.superseded && r.push("superseded"), a & ReasonFlags.unused && r.push("unused"), r;
  }
  toString() {
    return `[${this.toJSON().join(", ")}]`;
  }
}
let DistributionPointName = class {
  constructor(r = {}) {
    Object.assign(this, r);
  }
};
__decorate([
  AsnProp({ type: GeneralName$1, context: 0, repeated: "sequence", implicit: !0 })
], DistributionPointName.prototype, "fullName", void 0);
__decorate([
  AsnProp({ type: RelativeDistinguishedName, context: 1, implicit: !0 })
], DistributionPointName.prototype, "nameRelativeToCRLIssuer", void 0);
DistributionPointName = __decorate([
  AsnType({ type: AsnTypeTypes.Choice })
], DistributionPointName);
class DistributionPoint {
  constructor(r = {}) {
    Object.assign(this, r);
  }
}
__decorate([
  AsnProp({ type: DistributionPointName, context: 0, optional: !0 })
], DistributionPoint.prototype, "distributionPoint", void 0);
__decorate([
  AsnProp({ type: Reason, context: 1, optional: !0, implicit: !0 })
], DistributionPoint.prototype, "reasons", void 0);
__decorate([
  AsnProp({ type: GeneralName$1, context: 2, optional: !0, repeated: "sequence", implicit: !0 })
], DistributionPoint.prototype, "cRLIssuer", void 0);
let CRLDistributionPoints = CRLDistributionPoints_1 = class extends AsnArray {
  constructor(r) {
    super(r), Object.setPrototypeOf(this, CRLDistributionPoints_1.prototype);
  }
};
CRLDistributionPoints = CRLDistributionPoints_1 = __decorate([
  AsnType({ type: AsnTypeTypes.Sequence, itemType: DistributionPoint })
], CRLDistributionPoints);
var FreshestCRL_1;
let FreshestCRL = FreshestCRL_1 = class extends CRLDistributionPoints {
  constructor(r) {
    super(r), Object.setPrototypeOf(this, FreshestCRL_1.prototype);
  }
};
FreshestCRL = FreshestCRL_1 = __decorate([
  AsnType({ type: AsnTypeTypes.Sequence, itemType: DistributionPoint })
], FreshestCRL);
class IssuingDistributionPoint {
  constructor(r = {}) {
    this.onlyContainsUserCerts = IssuingDistributionPoint.ONLY, this.onlyContainsCACerts = IssuingDistributionPoint.ONLY, this.indirectCRL = IssuingDistributionPoint.ONLY, this.onlyContainsAttributeCerts = IssuingDistributionPoint.ONLY, Object.assign(this, r);
  }
}
IssuingDistributionPoint.ONLY = !1;
__decorate([
  AsnProp({ type: DistributionPointName, context: 0, optional: !0 })
], IssuingDistributionPoint.prototype, "distributionPoint", void 0);
__decorate([
  AsnProp({
    type: AsnPropTypes.Boolean,
    context: 1,
    defaultValue: IssuingDistributionPoint.ONLY,
    implicit: !0
  })
], IssuingDistributionPoint.prototype, "onlyContainsUserCerts", void 0);
__decorate([
  AsnProp({
    type: AsnPropTypes.Boolean,
    context: 2,
    defaultValue: IssuingDistributionPoint.ONLY,
    implicit: !0
  })
], IssuingDistributionPoint.prototype, "onlyContainsCACerts", void 0);
__decorate([
  AsnProp({ type: Reason, context: 3, optional: !0, implicit: !0 })
], IssuingDistributionPoint.prototype, "onlySomeReasons", void 0);
__decorate([
  AsnProp({
    type: AsnPropTypes.Boolean,
    context: 4,
    defaultValue: IssuingDistributionPoint.ONLY,
    implicit: !0
  })
], IssuingDistributionPoint.prototype, "indirectCRL", void 0);
__decorate([
  AsnProp({
    type: AsnPropTypes.Boolean,
    context: 5,
    defaultValue: IssuingDistributionPoint.ONLY,
    implicit: !0
  })
], IssuingDistributionPoint.prototype, "onlyContainsAttributeCerts", void 0);
var CRLReasons;
(function(u) {
  u[u.unspecified = 0] = "unspecified", u[u.keyCompromise = 1] = "keyCompromise", u[u.cACompromise = 2] = "cACompromise", u[u.affiliationChanged = 3] = "affiliationChanged", u[u.superseded = 4] = "superseded", u[u.cessationOfOperation = 5] = "cessationOfOperation", u[u.certificateHold = 6] = "certificateHold", u[u.removeFromCRL = 8] = "removeFromCRL", u[u.privilegeWithdrawn = 9] = "privilegeWithdrawn", u[u.aACompromise = 10] = "aACompromise";
})(CRLReasons || (CRLReasons = {}));
let CRLReason = class {
  constructor(r = CRLReasons.unspecified) {
    this.reason = CRLReasons.unspecified, this.reason = r;
  }
  toJSON() {
    return CRLReasons[this.reason];
  }
  toString() {
    return this.toJSON();
  }
};
__decorate([
  AsnProp({ type: AsnPropTypes.Enumerated })
], CRLReason.prototype, "reason", void 0);
CRLReason = __decorate([
  AsnType({ type: AsnTypeTypes.Choice })
], CRLReason);
var ExtendedKeyUsage_1;
const id_ce_extKeyUsage = `${id_ce}.37`;
let ExtendedKeyUsage$1 = ExtendedKeyUsage_1 = class extends AsnArray {
  constructor(r) {
    super(r), Object.setPrototypeOf(this, ExtendedKeyUsage_1.prototype);
  }
};
ExtendedKeyUsage$1 = ExtendedKeyUsage_1 = __decorate([
  AsnType({ type: AsnTypeTypes.Sequence, itemType: AsnPropTypes.ObjectIdentifier })
], ExtendedKeyUsage$1);
const id_kp_serverAuth = `${id_kp}.1`, id_kp_clientAuth = `${id_kp}.2`, id_kp_codeSigning = `${id_kp}.3`, id_kp_emailProtection = `${id_kp}.4`, id_kp_timeStamping = `${id_kp}.8`, id_kp_OCSPSigning = `${id_kp}.9`;
let InhibitAnyPolicy = class {
  constructor(r = new ArrayBuffer(0)) {
    this.value = r;
  }
};
__decorate([
  AsnProp({ type: AsnPropTypes.Integer, converter: AsnIntegerArrayBufferConverter })
], InhibitAnyPolicy.prototype, "value", void 0);
InhibitAnyPolicy = __decorate([
  AsnType({ type: AsnTypeTypes.Choice })
], InhibitAnyPolicy);
let InvalidityDate = class {
  constructor(r) {
    this.value = /* @__PURE__ */ new Date(), r && (this.value = r);
  }
};
__decorate([
  AsnProp({ type: AsnPropTypes.GeneralizedTime })
], InvalidityDate.prototype, "value", void 0);
InvalidityDate = __decorate([
  AsnType({ type: AsnTypeTypes.Choice })
], InvalidityDate);
var IssueAlternativeName_1;
let IssueAlternativeName = IssueAlternativeName_1 = class extends GeneralNames$1 {
  constructor(r) {
    super(r), Object.setPrototypeOf(this, IssueAlternativeName_1.prototype);
  }
};
IssueAlternativeName = IssueAlternativeName_1 = __decorate([
  AsnType({ type: AsnTypeTypes.Sequence })
], IssueAlternativeName);
const id_ce_keyUsage = `${id_ce}.15`;
var KeyUsageFlags$1;
(function(u) {
  u[u.digitalSignature = 1] = "digitalSignature", u[u.nonRepudiation = 2] = "nonRepudiation", u[u.keyEncipherment = 4] = "keyEncipherment", u[u.dataEncipherment = 8] = "dataEncipherment", u[u.keyAgreement = 16] = "keyAgreement", u[u.keyCertSign = 32] = "keyCertSign", u[u.cRLSign = 64] = "cRLSign", u[u.encipherOnly = 128] = "encipherOnly", u[u.decipherOnly = 256] = "decipherOnly";
})(KeyUsageFlags$1 || (KeyUsageFlags$1 = {}));
class KeyUsage extends BitString {
  toJSON() {
    const r = this.toNumber(), a = [];
    return r & KeyUsageFlags$1.cRLSign && a.push("crlSign"), r & KeyUsageFlags$1.dataEncipherment && a.push("dataEncipherment"), r & KeyUsageFlags$1.decipherOnly && a.push("decipherOnly"), r & KeyUsageFlags$1.digitalSignature && a.push("digitalSignature"), r & KeyUsageFlags$1.encipherOnly && a.push("encipherOnly"), r & KeyUsageFlags$1.keyAgreement && a.push("keyAgreement"), r & KeyUsageFlags$1.keyCertSign && a.push("keyCertSign"), r & KeyUsageFlags$1.keyEncipherment && a.push("keyEncipherment"), r & KeyUsageFlags$1.nonRepudiation && a.push("nonRepudiation"), a;
  }
  toString() {
    return `[${this.toJSON().join(", ")}]`;
  }
}
var GeneralSubtrees_1;
class GeneralSubtree {
  constructor(r = {}) {
    this.base = new GeneralName$1(), this.minimum = 0, Object.assign(this, r);
  }
}
__decorate([
  AsnProp({ type: GeneralName$1 })
], GeneralSubtree.prototype, "base", void 0);
__decorate([
  AsnProp({ type: AsnPropTypes.Integer, context: 0, defaultValue: 0, implicit: !0 })
], GeneralSubtree.prototype, "minimum", void 0);
__decorate([
  AsnProp({ type: AsnPropTypes.Integer, context: 1, optional: !0, implicit: !0 })
], GeneralSubtree.prototype, "maximum", void 0);
let GeneralSubtrees = GeneralSubtrees_1 = class extends AsnArray {
  constructor(r) {
    super(r), Object.setPrototypeOf(this, GeneralSubtrees_1.prototype);
  }
};
GeneralSubtrees = GeneralSubtrees_1 = __decorate([
  AsnType({ type: AsnTypeTypes.Sequence, itemType: GeneralSubtree })
], GeneralSubtrees);
class NameConstraints {
  constructor(r = {}) {
    Object.assign(this, r);
  }
}
__decorate([
  AsnProp({ type: GeneralSubtrees, context: 0, optional: !0, implicit: !0 })
], NameConstraints.prototype, "permittedSubtrees", void 0);
__decorate([
  AsnProp({ type: GeneralSubtrees, context: 1, optional: !0, implicit: !0 })
], NameConstraints.prototype, "excludedSubtrees", void 0);
class PolicyConstraints {
  constructor(r = {}) {
    Object.assign(this, r);
  }
}
__decorate([
  AsnProp({
    type: AsnPropTypes.Integer,
    context: 0,
    implicit: !0,
    optional: !0,
    converter: AsnIntegerArrayBufferConverter
  })
], PolicyConstraints.prototype, "requireExplicitPolicy", void 0);
__decorate([
  AsnProp({
    type: AsnPropTypes.Integer,
    context: 1,
    implicit: !0,
    optional: !0,
    converter: AsnIntegerArrayBufferConverter
  })
], PolicyConstraints.prototype, "inhibitPolicyMapping", void 0);
var PolicyMappings_1;
class PolicyMapping {
  constructor(r = {}) {
    this.issuerDomainPolicy = "", this.subjectDomainPolicy = "", Object.assign(this, r);
  }
}
__decorate([
  AsnProp({ type: AsnPropTypes.ObjectIdentifier })
], PolicyMapping.prototype, "issuerDomainPolicy", void 0);
__decorate([
  AsnProp({ type: AsnPropTypes.ObjectIdentifier })
], PolicyMapping.prototype, "subjectDomainPolicy", void 0);
let PolicyMappings = PolicyMappings_1 = class extends AsnArray {
  constructor(r) {
    super(r), Object.setPrototypeOf(this, PolicyMappings_1.prototype);
  }
};
PolicyMappings = PolicyMappings_1 = __decorate([
  AsnType({ type: AsnTypeTypes.Sequence, itemType: PolicyMapping })
], PolicyMappings);
var SubjectAlternativeName_1;
const id_ce_subjectAltName = `${id_ce}.17`;
let SubjectAlternativeName = SubjectAlternativeName_1 = class extends GeneralNames$1 {
  constructor(r) {
    super(r), Object.setPrototypeOf(this, SubjectAlternativeName_1.prototype);
  }
};
SubjectAlternativeName = SubjectAlternativeName_1 = __decorate([
  AsnType({ type: AsnTypeTypes.Sequence })
], SubjectAlternativeName);
let Attribute$2 = class {
  constructor(r = {}) {
    this.type = "", this.values = [], Object.assign(this, r);
  }
};
__decorate([
  AsnProp({ type: AsnPropTypes.ObjectIdentifier })
], Attribute$2.prototype, "type", void 0);
__decorate([
  AsnProp({ type: AsnPropTypes.Any, repeated: "set" })
], Attribute$2.prototype, "values", void 0);
var SubjectDirectoryAttributes_1;
let SubjectDirectoryAttributes = SubjectDirectoryAttributes_1 = class extends AsnArray {
  constructor(r) {
    super(r), Object.setPrototypeOf(this, SubjectDirectoryAttributes_1.prototype);
  }
};
SubjectDirectoryAttributes = SubjectDirectoryAttributes_1 = __decorate([
  AsnType({ type: AsnTypeTypes.Sequence, itemType: Attribute$2 })
], SubjectDirectoryAttributes);
const id_ce_subjectKeyIdentifier = `${id_ce}.14`;
class SubjectKeyIdentifier extends KeyIdentifier {
}
class PrivateKeyUsagePeriod {
  constructor(r = {}) {
    Object.assign(this, r);
  }
}
__decorate([
  AsnProp({ type: AsnPropTypes.GeneralizedTime, context: 0, implicit: !0, optional: !0 })
], PrivateKeyUsagePeriod.prototype, "notBefore", void 0);
__decorate([
  AsnProp({ type: AsnPropTypes.GeneralizedTime, context: 1, implicit: !0, optional: !0 })
], PrivateKeyUsagePeriod.prototype, "notAfter", void 0);
var EntrustInfoFlags;
(function(u) {
  u[u.keyUpdateAllowed = 1] = "keyUpdateAllowed", u[u.newExtensions = 2] = "newExtensions", u[u.pKIXCertificate = 4] = "pKIXCertificate";
})(EntrustInfoFlags || (EntrustInfoFlags = {}));
class EntrustInfo extends BitString {
  toJSON() {
    const r = [], a = this.toNumber();
    return a & EntrustInfoFlags.pKIXCertificate && r.push("pKIXCertificate"), a & EntrustInfoFlags.newExtensions && r.push("newExtensions"), a & EntrustInfoFlags.keyUpdateAllowed && r.push("keyUpdateAllowed"), r;
  }
  toString() {
    return `[${this.toJSON().join(", ")}]`;
  }
}
class EntrustVersionInfo {
  constructor(r = {}) {
    this.entrustVers = "", this.entrustInfoFlags = new EntrustInfo(), Object.assign(this, r);
  }
}
__decorate([
  AsnProp({ type: AsnPropTypes.GeneralString })
], EntrustVersionInfo.prototype, "entrustVers", void 0);
__decorate([
  AsnProp({ type: EntrustInfo })
], EntrustVersionInfo.prototype, "entrustInfoFlags", void 0);
var SubjectInfoAccessSyntax_1;
let SubjectInfoAccessSyntax = SubjectInfoAccessSyntax_1 = class extends AsnArray {
  constructor(r) {
    super(r), Object.setPrototypeOf(this, SubjectInfoAccessSyntax_1.prototype);
  }
};
SubjectInfoAccessSyntax = SubjectInfoAccessSyntax_1 = __decorate([
  AsnType({ type: AsnTypeTypes.Sequence, itemType: AccessDescription })
], SubjectInfoAccessSyntax);
class AlgorithmIdentifier {
  constructor(r = {}) {
    this.algorithm = "", Object.assign(this, r);
  }
  isEqual(r) {
    return r instanceof AlgorithmIdentifier && r.algorithm == this.algorithm && (r.parameters && this.parameters && isEqual(r.parameters, this.parameters) || r.parameters === this.parameters);
  }
}
__decorate([
  AsnProp({
    type: AsnPropTypes.ObjectIdentifier
  })
], AlgorithmIdentifier.prototype, "algorithm", void 0);
__decorate([
  AsnProp({
    type: AsnPropTypes.Any,
    optional: !0
  })
], AlgorithmIdentifier.prototype, "parameters", void 0);
class SubjectPublicKeyInfo {
  constructor(r = {}) {
    this.algorithm = new AlgorithmIdentifier(), this.subjectPublicKey = new ArrayBuffer(0), Object.assign(this, r);
  }
}
__decorate([
  AsnProp({ type: AlgorithmIdentifier })
], SubjectPublicKeyInfo.prototype, "algorithm", void 0);
__decorate([
  AsnProp({ type: AsnPropTypes.BitString })
], SubjectPublicKeyInfo.prototype, "subjectPublicKey", void 0);
let Time = class {
  constructor(r) {
    if (r)
      if (typeof r == "string" || typeof r == "number" || r instanceof Date) {
        const a = new Date(r);
        a.getUTCFullYear() > 2049 ? this.generalTime = a : this.utcTime = a;
      } else
        Object.assign(this, r);
  }
  getTime() {
    const r = this.utcTime || this.generalTime;
    if (!r)
      throw new Error("Cannot get time from CHOICE object");
    return r;
  }
};
__decorate([
  AsnProp({
    type: AsnPropTypes.UTCTime
  })
], Time.prototype, "utcTime", void 0);
__decorate([
  AsnProp({
    type: AsnPropTypes.GeneralizedTime
  })
], Time.prototype, "generalTime", void 0);
Time = __decorate([
  AsnType({ type: AsnTypeTypes.Choice })
], Time);
class Validity {
  constructor(r) {
    this.notBefore = new Time(/* @__PURE__ */ new Date()), this.notAfter = new Time(/* @__PURE__ */ new Date()), r && (this.notBefore = new Time(r.notBefore), this.notAfter = new Time(r.notAfter));
  }
}
__decorate([
  AsnProp({ type: Time })
], Validity.prototype, "notBefore", void 0);
__decorate([
  AsnProp({ type: Time })
], Validity.prototype, "notAfter", void 0);
var Extensions_1;
let Extension$1 = class Pe {
  constructor(r = {}) {
    this.extnID = "", this.critical = Pe.CRITICAL, this.extnValue = new OctetString(), Object.assign(this, r);
  }
};
Extension$1.CRITICAL = !1;
__decorate([
  AsnProp({ type: AsnPropTypes.ObjectIdentifier })
], Extension$1.prototype, "extnID", void 0);
__decorate([
  AsnProp({
    type: AsnPropTypes.Boolean,
    defaultValue: Extension$1.CRITICAL
  })
], Extension$1.prototype, "critical", void 0);
__decorate([
  AsnProp({ type: OctetString })
], Extension$1.prototype, "extnValue", void 0);
let Extensions = Extensions_1 = class extends AsnArray {
  constructor(r) {
    super(r), Object.setPrototypeOf(this, Extensions_1.prototype);
  }
};
Extensions = Extensions_1 = __decorate([
  AsnType({ type: AsnTypeTypes.Sequence, itemType: Extension$1 })
], Extensions);
var Version$1;
(function(u) {
  u[u.v1 = 0] = "v1", u[u.v2 = 1] = "v2", u[u.v3 = 2] = "v3";
})(Version$1 || (Version$1 = {}));
class TBSCertificate {
  constructor(r = {}) {
    this.version = Version$1.v1, this.serialNumber = new ArrayBuffer(0), this.signature = new AlgorithmIdentifier(), this.issuer = new Name$1(), this.validity = new Validity(), this.subject = new Name$1(), this.subjectPublicKeyInfo = new SubjectPublicKeyInfo(), Object.assign(this, r);
  }
}
__decorate([
  AsnProp({
    type: AsnPropTypes.Integer,
    context: 0,
    defaultValue: Version$1.v1
  })
], TBSCertificate.prototype, "version", void 0);
__decorate([
  AsnProp({
    type: AsnPropTypes.Integer,
    converter: AsnIntegerArrayBufferConverter
  })
], TBSCertificate.prototype, "serialNumber", void 0);
__decorate([
  AsnProp({ type: AlgorithmIdentifier })
], TBSCertificate.prototype, "signature", void 0);
__decorate([
  AsnProp({ type: Name$1 })
], TBSCertificate.prototype, "issuer", void 0);
__decorate([
  AsnProp({ type: Validity })
], TBSCertificate.prototype, "validity", void 0);
__decorate([
  AsnProp({ type: Name$1 })
], TBSCertificate.prototype, "subject", void 0);
__decorate([
  AsnProp({ type: SubjectPublicKeyInfo })
], TBSCertificate.prototype, "subjectPublicKeyInfo", void 0);
__decorate([
  AsnProp({
    type: AsnPropTypes.BitString,
    context: 1,
    implicit: !0,
    optional: !0
  })
], TBSCertificate.prototype, "issuerUniqueID", void 0);
__decorate([
  AsnProp({ type: AsnPropTypes.BitString, context: 2, implicit: !0, optional: !0 })
], TBSCertificate.prototype, "subjectUniqueID", void 0);
__decorate([
  AsnProp({ type: Extensions, context: 3, optional: !0 })
], TBSCertificate.prototype, "extensions", void 0);
class Certificate {
  constructor(r = {}) {
    this.tbsCertificate = new TBSCertificate(), this.signatureAlgorithm = new AlgorithmIdentifier(), this.signatureValue = new ArrayBuffer(0), Object.assign(this, r);
  }
}
__decorate([
  AsnProp({ type: TBSCertificate })
], Certificate.prototype, "tbsCertificate", void 0);
__decorate([
  AsnProp({ type: AlgorithmIdentifier })
], Certificate.prototype, "signatureAlgorithm", void 0);
__decorate([
  AsnProp({ type: AsnPropTypes.BitString })
], Certificate.prototype, "signatureValue", void 0);
class RevokedCertificate {
  constructor(r = {}) {
    this.userCertificate = new ArrayBuffer(0), this.revocationDate = new Time(), Object.assign(this, r);
  }
}
__decorate([
  AsnProp({ type: AsnPropTypes.Integer, converter: AsnIntegerArrayBufferConverter })
], RevokedCertificate.prototype, "userCertificate", void 0);
__decorate([
  AsnProp({ type: Time })
], RevokedCertificate.prototype, "revocationDate", void 0);
__decorate([
  AsnProp({ type: Extension$1, optional: !0, repeated: "sequence" })
], RevokedCertificate.prototype, "crlEntryExtensions", void 0);
class TBSCertList {
  constructor(r = {}) {
    this.signature = new AlgorithmIdentifier(), this.issuer = new Name$1(), this.thisUpdate = new Time(), Object.assign(this, r);
  }
}
__decorate([
  AsnProp({ type: AsnPropTypes.Integer, optional: !0 })
], TBSCertList.prototype, "version", void 0);
__decorate([
  AsnProp({ type: AlgorithmIdentifier })
], TBSCertList.prototype, "signature", void 0);
__decorate([
  AsnProp({ type: Name$1 })
], TBSCertList.prototype, "issuer", void 0);
__decorate([
  AsnProp({ type: Time })
], TBSCertList.prototype, "thisUpdate", void 0);
__decorate([
  AsnProp({ type: Time, optional: !0 })
], TBSCertList.prototype, "nextUpdate", void 0);
__decorate([
  AsnProp({ type: RevokedCertificate, repeated: "sequence", optional: !0 })
], TBSCertList.prototype, "revokedCertificates", void 0);
__decorate([
  AsnProp({ type: Extension$1, optional: !0, context: 0, repeated: "sequence" })
], TBSCertList.prototype, "crlExtensions", void 0);
class CertificateList {
  constructor(r = {}) {
    this.tbsCertList = new TBSCertList(), this.signatureAlgorithm = new AlgorithmIdentifier(), this.signature = new ArrayBuffer(0), Object.assign(this, r);
  }
}
__decorate([
  AsnProp({ type: TBSCertList })
], CertificateList.prototype, "tbsCertList", void 0);
__decorate([
  AsnProp({ type: AlgorithmIdentifier })
], CertificateList.prototype, "signatureAlgorithm", void 0);
__decorate([
  AsnProp({ type: AsnPropTypes.BitString })
], CertificateList.prototype, "signature", void 0);
class IssuerAndSerialNumber {
  constructor(r = {}) {
    this.issuer = new Name$1(), this.serialNumber = new ArrayBuffer(0), Object.assign(this, r);
  }
}
__decorate([
  AsnProp({ type: Name$1 })
], IssuerAndSerialNumber.prototype, "issuer", void 0);
__decorate([
  AsnProp({ type: AsnPropTypes.Integer, converter: AsnIntegerArrayBufferConverter })
], IssuerAndSerialNumber.prototype, "serialNumber", void 0);
let SignerIdentifier = class {
  constructor(r = {}) {
    Object.assign(this, r);
  }
};
__decorate([
  AsnProp({ type: SubjectKeyIdentifier, context: 0, implicit: !0 })
], SignerIdentifier.prototype, "subjectKeyIdentifier", void 0);
__decorate([
  AsnProp({ type: IssuerAndSerialNumber })
], SignerIdentifier.prototype, "issuerAndSerialNumber", void 0);
SignerIdentifier = __decorate([
  AsnType({ type: AsnTypeTypes.Choice })
], SignerIdentifier);
var CMSVersion;
(function(u) {
  u[u.v0 = 0] = "v0", u[u.v1 = 1] = "v1", u[u.v2 = 2] = "v2", u[u.v3 = 3] = "v3", u[u.v4 = 4] = "v4", u[u.v5 = 5] = "v5";
})(CMSVersion || (CMSVersion = {}));
let DigestAlgorithmIdentifier = class extends AlgorithmIdentifier {
};
DigestAlgorithmIdentifier = __decorate([
  AsnType({ type: AsnTypeTypes.Sequence })
], DigestAlgorithmIdentifier);
let SignatureAlgorithmIdentifier = class extends AlgorithmIdentifier {
};
SignatureAlgorithmIdentifier = __decorate([
  AsnType({ type: AsnTypeTypes.Sequence })
], SignatureAlgorithmIdentifier);
let KeyEncryptionAlgorithmIdentifier = class extends AlgorithmIdentifier {
};
KeyEncryptionAlgorithmIdentifier = __decorate([
  AsnType({ type: AsnTypeTypes.Sequence })
], KeyEncryptionAlgorithmIdentifier);
let ContentEncryptionAlgorithmIdentifier = class extends AlgorithmIdentifier {
};
ContentEncryptionAlgorithmIdentifier = __decorate([
  AsnType({ type: AsnTypeTypes.Sequence })
], ContentEncryptionAlgorithmIdentifier);
let MessageAuthenticationCodeAlgorithm = class extends AlgorithmIdentifier {
};
MessageAuthenticationCodeAlgorithm = __decorate([
  AsnType({ type: AsnTypeTypes.Sequence })
], MessageAuthenticationCodeAlgorithm);
let KeyDerivationAlgorithmIdentifier = class extends AlgorithmIdentifier {
};
KeyDerivationAlgorithmIdentifier = __decorate([
  AsnType({ type: AsnTypeTypes.Sequence })
], KeyDerivationAlgorithmIdentifier);
let Attribute$1 = class {
  constructor(r = {}) {
    this.attrType = "", this.attrValues = [], Object.assign(this, r);
  }
};
__decorate([
  AsnProp({ type: AsnPropTypes.ObjectIdentifier })
], Attribute$1.prototype, "attrType", void 0);
__decorate([
  AsnProp({ type: AsnPropTypes.Any, repeated: "set" })
], Attribute$1.prototype, "attrValues", void 0);
var SignerInfos_1;
class SignerInfo {
  constructor(r = {}) {
    this.version = CMSVersion.v0, this.sid = new SignerIdentifier(), this.digestAlgorithm = new DigestAlgorithmIdentifier(), this.signatureAlgorithm = new SignatureAlgorithmIdentifier(), this.signature = new OctetString(), Object.assign(this, r);
  }
}
__decorate([
  AsnProp({ type: AsnPropTypes.Integer })
], SignerInfo.prototype, "version", void 0);
__decorate([
  AsnProp({ type: SignerIdentifier })
], SignerInfo.prototype, "sid", void 0);
__decorate([
  AsnProp({ type: DigestAlgorithmIdentifier })
], SignerInfo.prototype, "digestAlgorithm", void 0);
__decorate([
  AsnProp({ type: Attribute$1, repeated: "set", context: 0, implicit: !0, optional: !0 })
], SignerInfo.prototype, "signedAttrs", void 0);
__decorate([
  AsnProp({ type: SignatureAlgorithmIdentifier })
], SignerInfo.prototype, "signatureAlgorithm", void 0);
__decorate([
  AsnProp({ type: OctetString })
], SignerInfo.prototype, "signature", void 0);
__decorate([
  AsnProp({ type: Attribute$1, repeated: "set", context: 1, implicit: !0, optional: !0 })
], SignerInfo.prototype, "unsignedAttrs", void 0);
let SignerInfos = SignerInfos_1 = class extends AsnArray {
  constructor(r) {
    super(r), Object.setPrototypeOf(this, SignerInfos_1.prototype);
  }
};
SignerInfos = SignerInfos_1 = __decorate([
  AsnType({ type: AsnTypeTypes.Set, itemType: SignerInfo })
], SignerInfos);
let SigningTime$1 = class extends Time {
};
SigningTime$1 = __decorate([
  AsnType({ type: AsnTypeTypes.Choice })
], SigningTime$1);
let CounterSignature$1 = class extends SignerInfo {
};
CounterSignature$1 = __decorate([
  AsnType({ type: AsnTypeTypes.Sequence })
], CounterSignature$1);
class ACClearAttrs {
  constructor(r = {}) {
    this.acIssuer = new GeneralName$1(), this.acSerial = 0, this.attrs = [], Object.assign(this, r);
  }
}
__decorate([
  AsnProp({ type: GeneralName$1 })
], ACClearAttrs.prototype, "acIssuer", void 0);
__decorate([
  AsnProp({ type: AsnPropTypes.Integer })
], ACClearAttrs.prototype, "acSerial", void 0);
__decorate([
  AsnProp({ type: Attribute$2, repeated: "sequence" })
], ACClearAttrs.prototype, "attrs", void 0);
var AttrSpec_1;
let AttrSpec = AttrSpec_1 = class extends AsnArray {
  constructor(r) {
    super(r), Object.setPrototypeOf(this, AttrSpec_1.prototype);
  }
};
AttrSpec = AttrSpec_1 = __decorate([
  AsnType({ type: AsnTypeTypes.Sequence, itemType: AsnPropTypes.ObjectIdentifier })
], AttrSpec);
class AAControls {
  constructor(r = {}) {
    this.permitUnSpecified = !0, Object.assign(this, r);
  }
}
__decorate([
  AsnProp({ type: AsnPropTypes.Integer, optional: !0 })
], AAControls.prototype, "pathLenConstraint", void 0);
__decorate([
  AsnProp({ type: AttrSpec, implicit: !0, context: 0, optional: !0 })
], AAControls.prototype, "permittedAttrs", void 0);
__decorate([
  AsnProp({ type: AttrSpec, implicit: !0, context: 1, optional: !0 })
], AAControls.prototype, "excludedAttrs", void 0);
__decorate([
  AsnProp({ type: AsnPropTypes.Boolean, defaultValue: !0 })
], AAControls.prototype, "permitUnSpecified", void 0);
class IssuerSerial {
  constructor(r = {}) {
    this.issuer = new GeneralNames$1(), this.serial = new ArrayBuffer(0), this.issuerUID = new ArrayBuffer(0), Object.assign(this, r);
  }
}
__decorate([
  AsnProp({ type: GeneralNames$1 })
], IssuerSerial.prototype, "issuer", void 0);
__decorate([
  AsnProp({ type: AsnPropTypes.Integer, converter: AsnIntegerArrayBufferConverter })
], IssuerSerial.prototype, "serial", void 0);
__decorate([
  AsnProp({ type: AsnPropTypes.BitString, optional: !0 })
], IssuerSerial.prototype, "issuerUID", void 0);
var DigestedObjectType;
(function(u) {
  u[u.publicKey = 0] = "publicKey", u[u.publicKeyCert = 1] = "publicKeyCert", u[u.otherObjectTypes = 2] = "otherObjectTypes";
})(DigestedObjectType || (DigestedObjectType = {}));
class ObjectDigestInfo {
  constructor(r = {}) {
    this.digestedObjectType = DigestedObjectType.publicKey, this.digestAlgorithm = new AlgorithmIdentifier(), this.objectDigest = new ArrayBuffer(0), Object.assign(this, r);
  }
}
__decorate([
  AsnProp({ type: AsnPropTypes.Enumerated })
], ObjectDigestInfo.prototype, "digestedObjectType", void 0);
__decorate([
  AsnProp({ type: AsnPropTypes.ObjectIdentifier, optional: !0 })
], ObjectDigestInfo.prototype, "otherObjectTypeID", void 0);
__decorate([
  AsnProp({ type: AlgorithmIdentifier })
], ObjectDigestInfo.prototype, "digestAlgorithm", void 0);
__decorate([
  AsnProp({ type: AsnPropTypes.BitString })
], ObjectDigestInfo.prototype, "objectDigest", void 0);
class V2Form {
  constructor(r = {}) {
    Object.assign(this, r);
  }
}
__decorate([
  AsnProp({ type: GeneralNames$1, optional: !0 })
], V2Form.prototype, "issuerName", void 0);
__decorate([
  AsnProp({ type: IssuerSerial, context: 0, implicit: !0, optional: !0 })
], V2Form.prototype, "baseCertificateID", void 0);
__decorate([
  AsnProp({ type: ObjectDigestInfo, context: 1, implicit: !0, optional: !0 })
], V2Form.prototype, "objectDigestInfo", void 0);
let AttCertIssuer = class {
  constructor(r = {}) {
    Object.assign(this, r);
  }
};
__decorate([
  AsnProp({ type: GeneralName$1, repeated: "sequence" })
], AttCertIssuer.prototype, "v1Form", void 0);
__decorate([
  AsnProp({ type: V2Form, context: 0, implicit: !0 })
], AttCertIssuer.prototype, "v2Form", void 0);
AttCertIssuer = __decorate([
  AsnType({ type: AsnTypeTypes.Choice })
], AttCertIssuer);
class AttCertValidityPeriod {
  constructor(r = {}) {
    this.notBeforeTime = /* @__PURE__ */ new Date(), this.notAfterTime = /* @__PURE__ */ new Date(), Object.assign(this, r);
  }
}
__decorate([
  AsnProp({ type: AsnPropTypes.GeneralizedTime })
], AttCertValidityPeriod.prototype, "notBeforeTime", void 0);
__decorate([
  AsnProp({ type: AsnPropTypes.GeneralizedTime })
], AttCertValidityPeriod.prototype, "notAfterTime", void 0);
class Holder {
  constructor(r = {}) {
    Object.assign(this, r);
  }
}
__decorate([
  AsnProp({ type: IssuerSerial, implicit: !0, context: 0, optional: !0 })
], Holder.prototype, "baseCertificateID", void 0);
__decorate([
  AsnProp({ type: GeneralNames$1, implicit: !0, context: 1, optional: !0 })
], Holder.prototype, "entityName", void 0);
__decorate([
  AsnProp({ type: ObjectDigestInfo, implicit: !0, context: 2, optional: !0 })
], Holder.prototype, "objectDigestInfo", void 0);
var AttCertVersion;
(function(u) {
  u[u.v2 = 1] = "v2";
})(AttCertVersion || (AttCertVersion = {}));
class AttributeCertificateInfo {
  constructor(r = {}) {
    this.version = AttCertVersion.v2, this.holder = new Holder(), this.issuer = new AttCertIssuer(), this.signature = new AlgorithmIdentifier(), this.serialNumber = new ArrayBuffer(0), this.attrCertValidityPeriod = new AttCertValidityPeriod(), this.attributes = [], Object.assign(this, r);
  }
}
__decorate([
  AsnProp({ type: AsnPropTypes.Integer })
], AttributeCertificateInfo.prototype, "version", void 0);
__decorate([
  AsnProp({ type: Holder })
], AttributeCertificateInfo.prototype, "holder", void 0);
__decorate([
  AsnProp({ type: AttCertIssuer })
], AttributeCertificateInfo.prototype, "issuer", void 0);
__decorate([
  AsnProp({ type: AlgorithmIdentifier })
], AttributeCertificateInfo.prototype, "signature", void 0);
__decorate([
  AsnProp({ type: AsnPropTypes.Integer, converter: AsnIntegerArrayBufferConverter })
], AttributeCertificateInfo.prototype, "serialNumber", void 0);
__decorate([
  AsnProp({ type: AttCertValidityPeriod })
], AttributeCertificateInfo.prototype, "attrCertValidityPeriod", void 0);
__decorate([
  AsnProp({ type: Attribute$2, repeated: "sequence" })
], AttributeCertificateInfo.prototype, "attributes", void 0);
__decorate([
  AsnProp({ type: AsnPropTypes.BitString, optional: !0 })
], AttributeCertificateInfo.prototype, "issuerUniqueID", void 0);
__decorate([
  AsnProp({ type: Extensions, optional: !0 })
], AttributeCertificateInfo.prototype, "extensions", void 0);
class AttributeCertificate {
  constructor(r = {}) {
    this.acinfo = new AttributeCertificateInfo(), this.signatureAlgorithm = new AlgorithmIdentifier(), this.signatureValue = new ArrayBuffer(0), Object.assign(this, r);
  }
}
__decorate([
  AsnProp({ type: AttributeCertificateInfo })
], AttributeCertificate.prototype, "acinfo", void 0);
__decorate([
  AsnProp({ type: AlgorithmIdentifier })
], AttributeCertificate.prototype, "signatureAlgorithm", void 0);
__decorate([
  AsnProp({ type: AsnPropTypes.BitString })
], AttributeCertificate.prototype, "signatureValue", void 0);
var ClassListFlags;
(function(u) {
  u[u.unmarked = 1] = "unmarked", u[u.unclassified = 2] = "unclassified", u[u.restricted = 4] = "restricted", u[u.confidential = 8] = "confidential", u[u.secret = 16] = "secret", u[u.topSecret = 32] = "topSecret";
})(ClassListFlags || (ClassListFlags = {}));
class ClassList extends BitString {
}
class SecurityCategory {
  constructor(r = {}) {
    this.type = "", this.value = new ArrayBuffer(0), Object.assign(this, r);
  }
}
__decorate([
  AsnProp({ type: AsnPropTypes.ObjectIdentifier, implicit: !0, context: 0 })
], SecurityCategory.prototype, "type", void 0);
__decorate([
  AsnProp({ type: AsnPropTypes.Any, implicit: !0, context: 1 })
], SecurityCategory.prototype, "value", void 0);
class Clearance {
  constructor(r = {}) {
    this.policyId = "", this.classList = new ClassList(ClassListFlags.unclassified), Object.assign(this, r);
  }
}
__decorate([
  AsnProp({ type: AsnPropTypes.ObjectIdentifier })
], Clearance.prototype, "policyId", void 0);
__decorate([
  AsnProp({ type: ClassList, defaultValue: new ClassList(ClassListFlags.unclassified) })
], Clearance.prototype, "classList", void 0);
__decorate([
  AsnProp({ type: SecurityCategory, repeated: "set" })
], Clearance.prototype, "securityCategories", void 0);
class IetfAttrSyntaxValueChoices {
  constructor(r = {}) {
    Object.assign(this, r);
  }
}
__decorate([
  AsnProp({ type: OctetString })
], IetfAttrSyntaxValueChoices.prototype, "cotets", void 0);
__decorate([
  AsnProp({ type: AsnPropTypes.ObjectIdentifier })
], IetfAttrSyntaxValueChoices.prototype, "oid", void 0);
__decorate([
  AsnProp({ type: AsnPropTypes.Utf8String })
], IetfAttrSyntaxValueChoices.prototype, "string", void 0);
class IetfAttrSyntax {
  constructor(r = {}) {
    this.values = [], Object.assign(this, r);
  }
}
__decorate([
  AsnProp({ type: GeneralNames$1, implicit: !0, context: 0, optional: !0 })
], IetfAttrSyntax.prototype, "policyAuthority", void 0);
__decorate([
  AsnProp({ type: IetfAttrSyntaxValueChoices, repeated: "sequence" })
], IetfAttrSyntax.prototype, "values", void 0);
var Targets_1;
class TargetCert {
  constructor(r = {}) {
    this.targetCertificate = new IssuerSerial(), Object.assign(this, r);
  }
}
__decorate([
  AsnProp({ type: IssuerSerial })
], TargetCert.prototype, "targetCertificate", void 0);
__decorate([
  AsnProp({ type: GeneralName$1, optional: !0 })
], TargetCert.prototype, "targetName", void 0);
__decorate([
  AsnProp({ type: ObjectDigestInfo, optional: !0 })
], TargetCert.prototype, "certDigestInfo", void 0);
let Target = class {
  constructor(r = {}) {
    Object.assign(this, r);
  }
};
__decorate([
  AsnProp({ type: GeneralName$1, context: 0, implicit: !0 })
], Target.prototype, "targetName", void 0);
__decorate([
  AsnProp({ type: GeneralName$1, context: 1, implicit: !0 })
], Target.prototype, "targetGroup", void 0);
__decorate([
  AsnProp({ type: TargetCert, context: 2, implicit: !0 })
], Target.prototype, "targetCert", void 0);
Target = __decorate([
  AsnType({ type: AsnTypeTypes.Choice })
], Target);
let Targets = Targets_1 = class extends AsnArray {
  constructor(r) {
    super(r), Object.setPrototypeOf(this, Targets_1.prototype);
  }
};
Targets = Targets_1 = __decorate([
  AsnType({ type: AsnTypeTypes.Sequence, itemType: Target })
], Targets);
var ProxyInfo_1;
let ProxyInfo = ProxyInfo_1 = class extends AsnArray {
  constructor(r) {
    super(r), Object.setPrototypeOf(this, ProxyInfo_1.prototype);
  }
};
ProxyInfo = ProxyInfo_1 = __decorate([
  AsnType({ type: AsnTypeTypes.Sequence, itemType: Targets })
], ProxyInfo);
class RoleSyntax {
  constructor(r = {}) {
    Object.assign(this, r);
  }
}
__decorate([
  AsnProp({ type: GeneralNames$1, implicit: !0, context: 0, optional: !0 })
], RoleSyntax.prototype, "roleAuthority", void 0);
__decorate([
  AsnProp({ type: GeneralName$1, implicit: !0, context: 1 })
], RoleSyntax.prototype, "roleName", void 0);
class SvceAuthInfo {
  constructor(r = {}) {
    this.service = new GeneralName$1(), this.ident = new GeneralName$1(), Object.assign(this, r);
  }
}
__decorate([
  AsnProp({ type: GeneralName$1 })
], SvceAuthInfo.prototype, "service", void 0);
__decorate([
  AsnProp({ type: GeneralName$1 })
], SvceAuthInfo.prototype, "ident", void 0);
__decorate([
  AsnProp({ type: OctetString, optional: !0 })
], SvceAuthInfo.prototype, "authInfo", void 0);
var CertificateSet_1;
class OtherCertificateFormat {
  constructor(r = {}) {
    this.otherCertFormat = "", this.otherCert = new ArrayBuffer(0), Object.assign(this, r);
  }
}
__decorate([
  AsnProp({ type: AsnPropTypes.ObjectIdentifier })
], OtherCertificateFormat.prototype, "otherCertFormat", void 0);
__decorate([
  AsnProp({ type: AsnPropTypes.Any })
], OtherCertificateFormat.prototype, "otherCert", void 0);
let CertificateChoices = class {
  constructor(r = {}) {
    Object.assign(this, r);
  }
};
__decorate([
  AsnProp({ type: Certificate })
], CertificateChoices.prototype, "certificate", void 0);
__decorate([
  AsnProp({ type: AttributeCertificate, context: 2, implicit: !0 })
], CertificateChoices.prototype, "v2AttrCert", void 0);
__decorate([
  AsnProp({ type: OtherCertificateFormat, context: 3, implicit: !0 })
], CertificateChoices.prototype, "other", void 0);
CertificateChoices = __decorate([
  AsnType({ type: AsnTypeTypes.Choice })
], CertificateChoices);
let CertificateSet = CertificateSet_1 = class extends AsnArray {
  constructor(r) {
    super(r), Object.setPrototypeOf(this, CertificateSet_1.prototype);
  }
};
CertificateSet = CertificateSet_1 = __decorate([
  AsnType({ type: AsnTypeTypes.Set, itemType: CertificateChoices })
], CertificateSet);
class ContentInfo {
  constructor(r = {}) {
    this.contentType = "", this.content = new ArrayBuffer(0), Object.assign(this, r);
  }
}
__decorate([
  AsnProp({ type: AsnPropTypes.ObjectIdentifier })
], ContentInfo.prototype, "contentType", void 0);
__decorate([
  AsnProp({ type: AsnPropTypes.Any, context: 0 })
], ContentInfo.prototype, "content", void 0);
let EncapsulatedContent = class {
  constructor(r = {}) {
    Object.assign(this, r);
  }
};
__decorate([
  AsnProp({ type: OctetString })
], EncapsulatedContent.prototype, "single", void 0);
__decorate([
  AsnProp({ type: AsnPropTypes.Any })
], EncapsulatedContent.prototype, "any", void 0);
EncapsulatedContent = __decorate([
  AsnType({ type: AsnTypeTypes.Choice })
], EncapsulatedContent);
class EncapsulatedContentInfo {
  constructor(r = {}) {
    this.eContentType = "", Object.assign(this, r);
  }
}
__decorate([
  AsnProp({ type: AsnPropTypes.ObjectIdentifier })
], EncapsulatedContentInfo.prototype, "eContentType", void 0);
__decorate([
  AsnProp({ type: EncapsulatedContent, context: 0, optional: !0 })
], EncapsulatedContentInfo.prototype, "eContent", void 0);
let EncryptedContent = class {
  constructor(r = {}) {
    Object.assign(this, r);
  }
};
__decorate([
  AsnProp({ type: OctetString, context: 0, implicit: !0, optional: !0 })
], EncryptedContent.prototype, "value", void 0);
__decorate([
  AsnProp({
    type: OctetString,
    converter: AsnConstructedOctetStringConverter,
    context: 0,
    implicit: !0,
    optional: !0,
    repeated: "sequence"
  })
], EncryptedContent.prototype, "constructedValue", void 0);
EncryptedContent = __decorate([
  AsnType({ type: AsnTypeTypes.Choice })
], EncryptedContent);
class EncryptedContentInfo {
  constructor(r = {}) {
    this.contentType = "", this.contentEncryptionAlgorithm = new ContentEncryptionAlgorithmIdentifier(), Object.assign(this, r);
  }
}
__decorate([
  AsnProp({ type: AsnPropTypes.ObjectIdentifier })
], EncryptedContentInfo.prototype, "contentType", void 0);
__decorate([
  AsnProp({ type: ContentEncryptionAlgorithmIdentifier })
], EncryptedContentInfo.prototype, "contentEncryptionAlgorithm", void 0);
__decorate([
  AsnProp({ type: EncryptedContent, optional: !0 })
], EncryptedContentInfo.prototype, "encryptedContent", void 0);
class OtherKeyAttribute {
  constructor(r = {}) {
    this.keyAttrId = "", Object.assign(this, r);
  }
}
__decorate([
  AsnProp({ type: AsnPropTypes.ObjectIdentifier })
], OtherKeyAttribute.prototype, "keyAttrId", void 0);
__decorate([
  AsnProp({ type: AsnPropTypes.Any, optional: !0 })
], OtherKeyAttribute.prototype, "keyAttr", void 0);
var RecipientEncryptedKeys_1;
class RecipientKeyIdentifier {
  constructor(r = {}) {
    this.subjectKeyIdentifier = new SubjectKeyIdentifier(), Object.assign(this, r);
  }
}
__decorate([
  AsnProp({ type: SubjectKeyIdentifier })
], RecipientKeyIdentifier.prototype, "subjectKeyIdentifier", void 0);
__decorate([
  AsnProp({ type: AsnPropTypes.GeneralizedTime, optional: !0 })
], RecipientKeyIdentifier.prototype, "date", void 0);
__decorate([
  AsnProp({ type: OtherKeyAttribute, optional: !0 })
], RecipientKeyIdentifier.prototype, "other", void 0);
let KeyAgreeRecipientIdentifier = class {
  constructor(r = {}) {
    Object.assign(this, r);
  }
};
__decorate([
  AsnProp({ type: RecipientKeyIdentifier, context: 0, implicit: !0, optional: !0 })
], KeyAgreeRecipientIdentifier.prototype, "rKeyId", void 0);
__decorate([
  AsnProp({ type: IssuerAndSerialNumber, optional: !0 })
], KeyAgreeRecipientIdentifier.prototype, "issuerAndSerialNumber", void 0);
KeyAgreeRecipientIdentifier = __decorate([
  AsnType({ type: AsnTypeTypes.Choice })
], KeyAgreeRecipientIdentifier);
class RecipientEncryptedKey {
  constructor(r = {}) {
    this.rid = new KeyAgreeRecipientIdentifier(), this.encryptedKey = new OctetString(), Object.assign(this, r);
  }
}
__decorate([
  AsnProp({ type: KeyAgreeRecipientIdentifier })
], RecipientEncryptedKey.prototype, "rid", void 0);
__decorate([
  AsnProp({ type: OctetString })
], RecipientEncryptedKey.prototype, "encryptedKey", void 0);
let RecipientEncryptedKeys = RecipientEncryptedKeys_1 = class extends AsnArray {
  constructor(r) {
    super(r), Object.setPrototypeOf(this, RecipientEncryptedKeys_1.prototype);
  }
};
RecipientEncryptedKeys = RecipientEncryptedKeys_1 = __decorate([
  AsnType({ type: AsnTypeTypes.Sequence, itemType: RecipientEncryptedKey })
], RecipientEncryptedKeys);
class OriginatorPublicKey {
  constructor(r = {}) {
    this.algorithm = new AlgorithmIdentifier(), this.publicKey = new ArrayBuffer(0), Object.assign(this, r);
  }
}
__decorate([
  AsnProp({ type: AlgorithmIdentifier })
], OriginatorPublicKey.prototype, "algorithm", void 0);
__decorate([
  AsnProp({ type: AsnPropTypes.BitString })
], OriginatorPublicKey.prototype, "publicKey", void 0);
let OriginatorIdentifierOrKey = class {
  constructor(r = {}) {
    Object.assign(this, r);
  }
};
__decorate([
  AsnProp({ type: SubjectKeyIdentifier, context: 0, implicit: !0, optional: !0 })
], OriginatorIdentifierOrKey.prototype, "subjectKeyIdentifier", void 0);
__decorate([
  AsnProp({ type: OriginatorPublicKey, context: 1, implicit: !0, optional: !0 })
], OriginatorIdentifierOrKey.prototype, "originatorKey", void 0);
__decorate([
  AsnProp({ type: IssuerAndSerialNumber, optional: !0 })
], OriginatorIdentifierOrKey.prototype, "issuerAndSerialNumber", void 0);
OriginatorIdentifierOrKey = __decorate([
  AsnType({ type: AsnTypeTypes.Choice })
], OriginatorIdentifierOrKey);
class KeyAgreeRecipientInfo {
  constructor(r = {}) {
    this.version = CMSVersion.v3, this.originator = new OriginatorIdentifierOrKey(), this.keyEncryptionAlgorithm = new KeyEncryptionAlgorithmIdentifier(), this.recipientEncryptedKeys = new RecipientEncryptedKeys(), Object.assign(this, r);
  }
}
__decorate([
  AsnProp({ type: AsnPropTypes.Integer })
], KeyAgreeRecipientInfo.prototype, "version", void 0);
__decorate([
  AsnProp({ type: OriginatorIdentifierOrKey, context: 0 })
], KeyAgreeRecipientInfo.prototype, "originator", void 0);
__decorate([
  AsnProp({ type: OctetString, context: 1, optional: !0 })
], KeyAgreeRecipientInfo.prototype, "ukm", void 0);
__decorate([
  AsnProp({ type: KeyEncryptionAlgorithmIdentifier })
], KeyAgreeRecipientInfo.prototype, "keyEncryptionAlgorithm", void 0);
__decorate([
  AsnProp({ type: RecipientEncryptedKeys })
], KeyAgreeRecipientInfo.prototype, "recipientEncryptedKeys", void 0);
let RecipientIdentifier = class {
  constructor(r = {}) {
    Object.assign(this, r);
  }
};
__decorate([
  AsnProp({ type: SubjectKeyIdentifier, context: 0, implicit: !0 })
], RecipientIdentifier.prototype, "subjectKeyIdentifier", void 0);
__decorate([
  AsnProp({ type: IssuerAndSerialNumber })
], RecipientIdentifier.prototype, "issuerAndSerialNumber", void 0);
RecipientIdentifier = __decorate([
  AsnType({ type: AsnTypeTypes.Choice })
], RecipientIdentifier);
class KeyTransRecipientInfo {
  constructor(r = {}) {
    this.version = CMSVersion.v0, this.rid = new RecipientIdentifier(), this.keyEncryptionAlgorithm = new KeyEncryptionAlgorithmIdentifier(), this.encryptedKey = new OctetString(), Object.assign(this, r);
  }
}
__decorate([
  AsnProp({ type: AsnPropTypes.Integer })
], KeyTransRecipientInfo.prototype, "version", void 0);
__decorate([
  AsnProp({ type: RecipientIdentifier })
], KeyTransRecipientInfo.prototype, "rid", void 0);
__decorate([
  AsnProp({ type: KeyEncryptionAlgorithmIdentifier })
], KeyTransRecipientInfo.prototype, "keyEncryptionAlgorithm", void 0);
__decorate([
  AsnProp({ type: OctetString })
], KeyTransRecipientInfo.prototype, "encryptedKey", void 0);
class KEKIdentifier {
  constructor(r = {}) {
    this.keyIdentifier = new OctetString(), Object.assign(this, r);
  }
}
__decorate([
  AsnProp({ type: OctetString })
], KEKIdentifier.prototype, "keyIdentifier", void 0);
__decorate([
  AsnProp({ type: AsnPropTypes.GeneralizedTime, optional: !0 })
], KEKIdentifier.prototype, "date", void 0);
__decorate([
  AsnProp({ type: OtherKeyAttribute, optional: !0 })
], KEKIdentifier.prototype, "other", void 0);
class KEKRecipientInfo {
  constructor(r = {}) {
    this.version = CMSVersion.v4, this.kekid = new KEKIdentifier(), this.keyEncryptionAlgorithm = new KeyEncryptionAlgorithmIdentifier(), this.encryptedKey = new OctetString(), Object.assign(this, r);
  }
}
__decorate([
  AsnProp({ type: AsnPropTypes.Integer })
], KEKRecipientInfo.prototype, "version", void 0);
__decorate([
  AsnProp({ type: KEKIdentifier })
], KEKRecipientInfo.prototype, "kekid", void 0);
__decorate([
  AsnProp({ type: KeyEncryptionAlgorithmIdentifier })
], KEKRecipientInfo.prototype, "keyEncryptionAlgorithm", void 0);
__decorate([
  AsnProp({ type: OctetString })
], KEKRecipientInfo.prototype, "encryptedKey", void 0);
class PasswordRecipientInfo {
  constructor(r = {}) {
    this.version = CMSVersion.v0, this.keyEncryptionAlgorithm = new KeyEncryptionAlgorithmIdentifier(), this.encryptedKey = new OctetString(), Object.assign(this, r);
  }
}
__decorate([
  AsnProp({ type: AsnPropTypes.Integer })
], PasswordRecipientInfo.prototype, "version", void 0);
__decorate([
  AsnProp({ type: KeyDerivationAlgorithmIdentifier, context: 0, optional: !0 })
], PasswordRecipientInfo.prototype, "keyDerivationAlgorithm", void 0);
__decorate([
  AsnProp({ type: KeyEncryptionAlgorithmIdentifier })
], PasswordRecipientInfo.prototype, "keyEncryptionAlgorithm", void 0);
__decorate([
  AsnProp({ type: OctetString })
], PasswordRecipientInfo.prototype, "encryptedKey", void 0);
class OtherRecipientInfo {
  constructor(r = {}) {
    this.oriType = "", this.oriValue = new ArrayBuffer(0), Object.assign(this, r);
  }
}
__decorate([
  AsnProp({ type: AsnPropTypes.ObjectIdentifier })
], OtherRecipientInfo.prototype, "oriType", void 0);
__decorate([
  AsnProp({ type: AsnPropTypes.Any })
], OtherRecipientInfo.prototype, "oriValue", void 0);
let RecipientInfo = class {
  constructor(r = {}) {
    Object.assign(this, r);
  }
};
__decorate([
  AsnProp({ type: KeyTransRecipientInfo, optional: !0 })
], RecipientInfo.prototype, "ktri", void 0);
__decorate([
  AsnProp({ type: KeyAgreeRecipientInfo, context: 1, implicit: !0, optional: !0 })
], RecipientInfo.prototype, "kari", void 0);
__decorate([
  AsnProp({ type: KEKRecipientInfo, context: 2, implicit: !0, optional: !0 })
], RecipientInfo.prototype, "kekri", void 0);
__decorate([
  AsnProp({ type: PasswordRecipientInfo, context: 3, implicit: !0, optional: !0 })
], RecipientInfo.prototype, "pwri", void 0);
__decorate([
  AsnProp({ type: OtherRecipientInfo, context: 4, implicit: !0, optional: !0 })
], RecipientInfo.prototype, "ori", void 0);
RecipientInfo = __decorate([
  AsnType({ type: AsnTypeTypes.Choice })
], RecipientInfo);
var RecipientInfos_1;
let RecipientInfos = RecipientInfos_1 = class extends AsnArray {
  constructor(r) {
    super(r), Object.setPrototypeOf(this, RecipientInfos_1.prototype);
  }
};
RecipientInfos = RecipientInfos_1 = __decorate([
  AsnType({ type: AsnTypeTypes.Set, itemType: RecipientInfo })
], RecipientInfos);
var RevocationInfoChoices_1;
class OtherRevocationInfoFormat {
  constructor(r = {}) {
    this.otherRevInfoFormat = "", this.otherRevInfo = new ArrayBuffer(0), Object.assign(this, r);
  }
}
__decorate([
  AsnProp({ type: AsnPropTypes.ObjectIdentifier })
], OtherRevocationInfoFormat.prototype, "otherRevInfoFormat", void 0);
__decorate([
  AsnProp({ type: AsnPropTypes.Any })
], OtherRevocationInfoFormat.prototype, "otherRevInfo", void 0);
let RevocationInfoChoice = class {
  constructor(r = {}) {
    this.other = new OtherRevocationInfoFormat(), Object.assign(this, r);
  }
};
__decorate([
  AsnProp({ type: OtherRevocationInfoFormat, context: 1, implicit: !0 })
], RevocationInfoChoice.prototype, "other", void 0);
RevocationInfoChoice = __decorate([
  AsnType({ type: AsnTypeTypes.Choice })
], RevocationInfoChoice);
let RevocationInfoChoices = RevocationInfoChoices_1 = class extends AsnArray {
  constructor(r) {
    super(r), Object.setPrototypeOf(this, RevocationInfoChoices_1.prototype);
  }
};
RevocationInfoChoices = RevocationInfoChoices_1 = __decorate([
  AsnType({ type: AsnTypeTypes.Set, itemType: RevocationInfoChoice })
], RevocationInfoChoices);
class OriginatorInfo {
  constructor(r = {}) {
    Object.assign(this, r);
  }
}
__decorate([
  AsnProp({ type: CertificateSet, context: 0, implicit: !0, optional: !0 })
], OriginatorInfo.prototype, "certs", void 0);
__decorate([
  AsnProp({ type: RevocationInfoChoices, context: 1, implicit: !0, optional: !0 })
], OriginatorInfo.prototype, "crls", void 0);
var UnprotectedAttributes_1;
let UnprotectedAttributes = UnprotectedAttributes_1 = class extends AsnArray {
  constructor(r) {
    super(r), Object.setPrototypeOf(this, UnprotectedAttributes_1.prototype);
  }
};
UnprotectedAttributes = UnprotectedAttributes_1 = __decorate([
  AsnType({ type: AsnTypeTypes.Set, itemType: Attribute$1 })
], UnprotectedAttributes);
class EnvelopedData {
  constructor(r = {}) {
    this.version = CMSVersion.v0, this.recipientInfos = new RecipientInfos(), this.encryptedContentInfo = new EncryptedContentInfo(), Object.assign(this, r);
  }
}
__decorate([
  AsnProp({ type: AsnPropTypes.Integer })
], EnvelopedData.prototype, "version", void 0);
__decorate([
  AsnProp({ type: OriginatorInfo, context: 0, implicit: !0, optional: !0 })
], EnvelopedData.prototype, "originatorInfo", void 0);
__decorate([
  AsnProp({ type: RecipientInfos })
], EnvelopedData.prototype, "recipientInfos", void 0);
__decorate([
  AsnProp({ type: EncryptedContentInfo })
], EnvelopedData.prototype, "encryptedContentInfo", void 0);
__decorate([
  AsnProp({ type: UnprotectedAttributes, context: 1, implicit: !0, optional: !0 })
], EnvelopedData.prototype, "unprotectedAttrs", void 0);
const id_data = "1.2.840.113549.1.7.1", id_signedData = "1.2.840.113549.1.7.2";
var DigestAlgorithmIdentifiers_1;
let DigestAlgorithmIdentifiers = DigestAlgorithmIdentifiers_1 = class extends AsnArray {
  constructor(r) {
    super(r), Object.setPrototypeOf(this, DigestAlgorithmIdentifiers_1.prototype);
  }
};
DigestAlgorithmIdentifiers = DigestAlgorithmIdentifiers_1 = __decorate([
  AsnType({ type: AsnTypeTypes.Set, itemType: DigestAlgorithmIdentifier })
], DigestAlgorithmIdentifiers);
class SignedData {
  constructor(r = {}) {
    this.version = CMSVersion.v0, this.digestAlgorithms = new DigestAlgorithmIdentifiers(), this.encapContentInfo = new EncapsulatedContentInfo(), this.signerInfos = new SignerInfos(), Object.assign(this, r);
  }
}
__decorate([
  AsnProp({ type: AsnPropTypes.Integer })
], SignedData.prototype, "version", void 0);
__decorate([
  AsnProp({ type: DigestAlgorithmIdentifiers })
], SignedData.prototype, "digestAlgorithms", void 0);
__decorate([
  AsnProp({ type: EncapsulatedContentInfo })
], SignedData.prototype, "encapContentInfo", void 0);
__decorate([
  AsnProp({ type: CertificateSet, context: 0, implicit: !0, optional: !0 })
], SignedData.prototype, "certificates", void 0);
__decorate([
  AsnProp({ type: RevocationInfoChoices, context: 1, implicit: !0, optional: !0 })
], SignedData.prototype, "crls", void 0);
__decorate([
  AsnProp({ type: SignerInfos })
], SignedData.prototype, "signerInfos", void 0);
const id_ecPublicKey = "1.2.840.10045.2.1", id_ecdsaWithSHA1 = "1.2.840.10045.4.1", id_ecdsaWithSHA224 = "1.2.840.10045.4.3.1", id_ecdsaWithSHA256 = "1.2.840.10045.4.3.2", id_ecdsaWithSHA384 = "1.2.840.10045.4.3.3", id_ecdsaWithSHA512 = "1.2.840.10045.4.3.4", id_secp256r1 = "1.2.840.10045.3.1.7", id_secp384r1 = "1.3.132.0.34", id_secp521r1 = "1.3.132.0.35";
function create$1(u) {
  return new AlgorithmIdentifier({ algorithm: u });
}
const ecdsaWithSHA1 = create$1(id_ecdsaWithSHA1);
create$1(id_ecdsaWithSHA224);
const ecdsaWithSHA256 = create$1(id_ecdsaWithSHA256), ecdsaWithSHA384 = create$1(id_ecdsaWithSHA384), ecdsaWithSHA512 = create$1(id_ecdsaWithSHA512);
let FieldID = class {
  constructor(r = {}) {
    Object.assign(this, r);
  }
};
__decorate([
  AsnProp({ type: AsnPropTypes.ObjectIdentifier })
], FieldID.prototype, "fieldType", void 0);
__decorate([
  AsnProp({ type: AsnPropTypes.Any })
], FieldID.prototype, "parameters", void 0);
FieldID = __decorate([
  AsnType({ type: AsnTypeTypes.Sequence })
], FieldID);
class ECPoint extends OctetString {
}
let Curve = class {
  constructor(r = {}) {
    Object.assign(this, r);
  }
};
__decorate([
  AsnProp({ type: AsnPropTypes.OctetString })
], Curve.prototype, "a", void 0);
__decorate([
  AsnProp({ type: AsnPropTypes.OctetString })
], Curve.prototype, "b", void 0);
__decorate([
  AsnProp({ type: AsnPropTypes.BitString, optional: !0 })
], Curve.prototype, "seed", void 0);
Curve = __decorate([
  AsnType({ type: AsnTypeTypes.Sequence })
], Curve);
var ECPVer;
(function(u) {
  u[u.ecpVer1 = 1] = "ecpVer1";
})(ECPVer || (ECPVer = {}));
let SpecifiedECDomain = class {
  constructor(r = {}) {
    this.version = ECPVer.ecpVer1, Object.assign(this, r);
  }
};
__decorate([
  AsnProp({ type: AsnPropTypes.Integer })
], SpecifiedECDomain.prototype, "version", void 0);
__decorate([
  AsnProp({ type: FieldID })
], SpecifiedECDomain.prototype, "fieldID", void 0);
__decorate([
  AsnProp({ type: Curve })
], SpecifiedECDomain.prototype, "curve", void 0);
__decorate([
  AsnProp({ type: ECPoint })
], SpecifiedECDomain.prototype, "base", void 0);
__decorate([
  AsnProp({ type: AsnPropTypes.Integer, converter: AsnIntegerArrayBufferConverter })
], SpecifiedECDomain.prototype, "order", void 0);
__decorate([
  AsnProp({ type: AsnPropTypes.Integer, optional: !0 })
], SpecifiedECDomain.prototype, "cofactor", void 0);
SpecifiedECDomain = __decorate([
  AsnType({ type: AsnTypeTypes.Sequence })
], SpecifiedECDomain);
let ECParameters = class {
  constructor(r = {}) {
    Object.assign(this, r);
  }
};
__decorate([
  AsnProp({ type: AsnPropTypes.ObjectIdentifier })
], ECParameters.prototype, "namedCurve", void 0);
__decorate([
  AsnProp({ type: AsnPropTypes.Null })
], ECParameters.prototype, "implicitCurve", void 0);
__decorate([
  AsnProp({ type: SpecifiedECDomain })
], ECParameters.prototype, "specifiedCurve", void 0);
ECParameters = __decorate([
  AsnType({ type: AsnTypeTypes.Choice })
], ECParameters);
class ECPrivateKey {
  constructor(r = {}) {
    this.version = 1, this.privateKey = new OctetString(), Object.assign(this, r);
  }
}
__decorate([
  AsnProp({ type: AsnPropTypes.Integer })
], ECPrivateKey.prototype, "version", void 0);
__decorate([
  AsnProp({ type: OctetString })
], ECPrivateKey.prototype, "privateKey", void 0);
__decorate([
  AsnProp({ type: ECParameters, context: 0, optional: !0 })
], ECPrivateKey.prototype, "parameters", void 0);
__decorate([
  AsnProp({ type: AsnPropTypes.BitString, context: 1, optional: !0 })
], ECPrivateKey.prototype, "publicKey", void 0);
class ECDSASigValue {
  constructor(r = {}) {
    this.r = new ArrayBuffer(0), this.s = new ArrayBuffer(0), Object.assign(this, r);
  }
}
__decorate([
  AsnProp({ type: AsnPropTypes.Integer, converter: AsnIntegerArrayBufferConverter })
], ECDSASigValue.prototype, "r", void 0);
__decorate([
  AsnProp({ type: AsnPropTypes.Integer, converter: AsnIntegerArrayBufferConverter })
], ECDSASigValue.prototype, "s", void 0);
const id_pkcs_1 = "1.2.840.113549.1.1", id_rsaEncryption = `${id_pkcs_1}.1`, id_RSAES_OAEP = `${id_pkcs_1}.7`, id_pSpecified = `${id_pkcs_1}.9`, id_RSASSA_PSS = `${id_pkcs_1}.10`, id_md2WithRSAEncryption = `${id_pkcs_1}.2`, id_md5WithRSAEncryption = `${id_pkcs_1}.4`, id_sha1WithRSAEncryption = `${id_pkcs_1}.5`, id_sha224WithRSAEncryption = `${id_pkcs_1}.14`, id_sha256WithRSAEncryption = `${id_pkcs_1}.11`, id_sha384WithRSAEncryption = `${id_pkcs_1}.12`, id_sha512WithRSAEncryption = `${id_pkcs_1}.13`, id_sha512_224WithRSAEncryption = `${id_pkcs_1}.15`, id_sha512_256WithRSAEncryption = `${id_pkcs_1}.16`, id_sha1 = "1.3.14.3.2.26", id_sha224 = "2.16.840.1.101.3.4.2.4", id_sha256 = "2.16.840.1.101.3.4.2.1", id_sha384 = "2.16.840.1.101.3.4.2.2", id_sha512 = "2.16.840.1.101.3.4.2.3", id_sha512_224 = "2.16.840.1.101.3.4.2.5", id_sha512_256 = "2.16.840.1.101.3.4.2.6", id_md2 = "1.2.840.113549.2.2", id_md5 = "1.2.840.113549.2.5", id_mgf1 = `${id_pkcs_1}.8`;
function create(u) {
  return new AlgorithmIdentifier({ algorithm: u, parameters: null });
}
create(id_md2);
create(id_md5);
const sha1$1 = create(id_sha1);
create(id_sha224);
create(id_sha256);
create(id_sha384);
create(id_sha512);
create(id_sha512_224);
create(id_sha512_256);
const mgf1SHA1 = new AlgorithmIdentifier({
  algorithm: id_mgf1,
  parameters: AsnConvert.serialize(sha1$1)
}), pSpecifiedEmpty = new AlgorithmIdentifier({
  algorithm: id_pSpecified,
  parameters: AsnConvert.serialize(AsnOctetStringConverter.toASN(new Uint8Array([
    218,
    57,
    163,
    238,
    94,
    107,
    75,
    13,
    50,
    85,
    191,
    239,
    149,
    96,
    24,
    144,
    175,
    216,
    7,
    9
  ]).buffer))
});
create(id_rsaEncryption);
create(id_md2WithRSAEncryption);
create(id_md5WithRSAEncryption);
create(id_sha1WithRSAEncryption);
create(id_sha512_224WithRSAEncryption);
create(id_sha512_256WithRSAEncryption);
create(id_sha384WithRSAEncryption);
create(id_sha512WithRSAEncryption);
create(id_sha512_224WithRSAEncryption);
create(id_sha512_256WithRSAEncryption);
class RsaEsOaepParams {
  constructor(r = {}) {
    this.hashAlgorithm = new AlgorithmIdentifier(sha1$1), this.maskGenAlgorithm = new AlgorithmIdentifier({
      algorithm: id_mgf1,
      parameters: AsnConvert.serialize(sha1$1)
    }), this.pSourceAlgorithm = new AlgorithmIdentifier(pSpecifiedEmpty), Object.assign(this, r);
  }
}
__decorate([
  AsnProp({ type: AlgorithmIdentifier, context: 0, defaultValue: sha1$1 })
], RsaEsOaepParams.prototype, "hashAlgorithm", void 0);
__decorate([
  AsnProp({ type: AlgorithmIdentifier, context: 1, defaultValue: mgf1SHA1 })
], RsaEsOaepParams.prototype, "maskGenAlgorithm", void 0);
__decorate([
  AsnProp({ type: AlgorithmIdentifier, context: 2, defaultValue: pSpecifiedEmpty })
], RsaEsOaepParams.prototype, "pSourceAlgorithm", void 0);
new AlgorithmIdentifier({
  algorithm: id_RSAES_OAEP,
  parameters: AsnConvert.serialize(new RsaEsOaepParams())
});
class RsaSaPssParams {
  constructor(r = {}) {
    this.hashAlgorithm = new AlgorithmIdentifier(sha1$1), this.maskGenAlgorithm = new AlgorithmIdentifier({
      algorithm: id_mgf1,
      parameters: AsnConvert.serialize(sha1$1)
    }), this.saltLength = 20, this.trailerField = 1, Object.assign(this, r);
  }
}
__decorate([
  AsnProp({ type: AlgorithmIdentifier, context: 0, defaultValue: sha1$1 })
], RsaSaPssParams.prototype, "hashAlgorithm", void 0);
__decorate([
  AsnProp({ type: AlgorithmIdentifier, context: 1, defaultValue: mgf1SHA1 })
], RsaSaPssParams.prototype, "maskGenAlgorithm", void 0);
__decorate([
  AsnProp({ type: AsnPropTypes.Integer, context: 2, defaultValue: 20 })
], RsaSaPssParams.prototype, "saltLength", void 0);
__decorate([
  AsnProp({ type: AsnPropTypes.Integer, context: 3, defaultValue: 1 })
], RsaSaPssParams.prototype, "trailerField", void 0);
new AlgorithmIdentifier({
  algorithm: id_RSASSA_PSS,
  parameters: AsnConvert.serialize(new RsaSaPssParams())
});
class DigestInfo {
  constructor(r = {}) {
    this.digestAlgorithm = new AlgorithmIdentifier(), this.digest = new OctetString(), Object.assign(this, r);
  }
}
__decorate([
  AsnProp({ type: AlgorithmIdentifier })
], DigestInfo.prototype, "digestAlgorithm", void 0);
__decorate([
  AsnProp({ type: OctetString })
], DigestInfo.prototype, "digest", void 0);
var OtherPrimeInfos_1;
class OtherPrimeInfo {
  constructor(r = {}) {
    this.prime = new ArrayBuffer(0), this.exponent = new ArrayBuffer(0), this.coefficient = new ArrayBuffer(0), Object.assign(this, r);
  }
}
__decorate([
  AsnProp({ type: AsnPropTypes.Integer, converter: AsnIntegerArrayBufferConverter })
], OtherPrimeInfo.prototype, "prime", void 0);
__decorate([
  AsnProp({ type: AsnPropTypes.Integer, converter: AsnIntegerArrayBufferConverter })
], OtherPrimeInfo.prototype, "exponent", void 0);
__decorate([
  AsnProp({ type: AsnPropTypes.Integer, converter: AsnIntegerArrayBufferConverter })
], OtherPrimeInfo.prototype, "coefficient", void 0);
let OtherPrimeInfos = OtherPrimeInfos_1 = class extends AsnArray {
  constructor(r) {
    super(r), Object.setPrototypeOf(this, OtherPrimeInfos_1.prototype);
  }
};
OtherPrimeInfos = OtherPrimeInfos_1 = __decorate([
  AsnType({ type: AsnTypeTypes.Sequence, itemType: OtherPrimeInfo })
], OtherPrimeInfos);
class RSAPrivateKey {
  constructor(r = {}) {
    this.version = 0, this.modulus = new ArrayBuffer(0), this.publicExponent = new ArrayBuffer(0), this.privateExponent = new ArrayBuffer(0), this.prime1 = new ArrayBuffer(0), this.prime2 = new ArrayBuffer(0), this.exponent1 = new ArrayBuffer(0), this.exponent2 = new ArrayBuffer(0), this.coefficient = new ArrayBuffer(0), Object.assign(this, r);
  }
}
__decorate([
  AsnProp({ type: AsnPropTypes.Integer })
], RSAPrivateKey.prototype, "version", void 0);
__decorate([
  AsnProp({ type: AsnPropTypes.Integer, converter: AsnIntegerArrayBufferConverter })
], RSAPrivateKey.prototype, "modulus", void 0);
__decorate([
  AsnProp({ type: AsnPropTypes.Integer, converter: AsnIntegerArrayBufferConverter })
], RSAPrivateKey.prototype, "publicExponent", void 0);
__decorate([
  AsnProp({ type: AsnPropTypes.Integer, converter: AsnIntegerArrayBufferConverter })
], RSAPrivateKey.prototype, "privateExponent", void 0);
__decorate([
  AsnProp({ type: AsnPropTypes.Integer, converter: AsnIntegerArrayBufferConverter })
], RSAPrivateKey.prototype, "prime1", void 0);
__decorate([
  AsnProp({ type: AsnPropTypes.Integer, converter: AsnIntegerArrayBufferConverter })
], RSAPrivateKey.prototype, "prime2", void 0);
__decorate([
  AsnProp({ type: AsnPropTypes.Integer, converter: AsnIntegerArrayBufferConverter })
], RSAPrivateKey.prototype, "exponent1", void 0);
__decorate([
  AsnProp({ type: AsnPropTypes.Integer, converter: AsnIntegerArrayBufferConverter })
], RSAPrivateKey.prototype, "exponent2", void 0);
__decorate([
  AsnProp({ type: AsnPropTypes.Integer, converter: AsnIntegerArrayBufferConverter })
], RSAPrivateKey.prototype, "coefficient", void 0);
__decorate([
  AsnProp({ type: OtherPrimeInfos, optional: !0 })
], RSAPrivateKey.prototype, "otherPrimeInfos", void 0);
class RSAPublicKey {
  constructor(r = {}) {
    this.modulus = new ArrayBuffer(0), this.publicExponent = new ArrayBuffer(0), Object.assign(this, r);
  }
}
__decorate([
  AsnProp({ type: AsnPropTypes.Integer, converter: AsnIntegerArrayBufferConverter })
], RSAPublicKey.prototype, "modulus", void 0);
__decorate([
  AsnProp({ type: AsnPropTypes.Integer, converter: AsnIntegerArrayBufferConverter })
], RSAPublicKey.prototype, "publicExponent", void 0);
var Lifecycle;
(function(u) {
  u[u.Transient = 0] = "Transient", u[u.Singleton = 1] = "Singleton", u[u.ResolutionScoped = 2] = "ResolutionScoped", u[u.ContainerScoped = 3] = "ContainerScoped";
})(Lifecycle || (Lifecycle = {}));
const Lifecycle$1 = Lifecycle;
/*! *****************************************************************************
Copyright (c) Microsoft Corporation.

Permission to use, copy, modify, and/or distribute this software for any
purpose with or without fee is hereby granted.

THE SOFTWARE IS PROVIDED "AS IS" AND THE AUTHOR DISCLAIMS ALL WARRANTIES WITH
REGARD TO THIS SOFTWARE INCLUDING ALL IMPLIED WARRANTIES OF MERCHANTABILITY
AND FITNESS. IN NO EVENT SHALL THE AUTHOR BE LIABLE FOR ANY SPECIAL, DIRECT,
INDIRECT, OR CONSEQUENTIAL DAMAGES OR ANY DAMAGES WHATSOEVER RESULTING FROM
LOSS OF USE, DATA OR PROFITS, WHETHER IN AN ACTION OF CONTRACT, NEGLIGENCE OR
OTHER TORTIOUS ACTION, ARISING OUT OF OR IN CONNECTION WITH THE USE OR
PERFORMANCE OF THIS SOFTWARE.
***************************************************************************** */
var extendStatics = function(u, r) {
  return extendStatics = Object.setPrototypeOf || { __proto__: [] } instanceof Array && function(a, e) {
    a.__proto__ = e;
  } || function(a, e) {
    for (var n in e)
      e.hasOwnProperty(n) && (a[n] = e[n]);
  }, extendStatics(u, r);
};
function __extends(u, r) {
  extendStatics(u, r);
  function a() {
    this.constructor = u;
  }
  u.prototype = r === null ? Object.create(r) : (a.prototype = r.prototype, new a());
}
function __awaiter(u, r, a, e) {
  function n(o) {
    return o instanceof a ? o : new a(function(c) {
      c(o);
    });
  }
  return new (a || (a = Promise))(function(o, c) {
    function l(h) {
      try {
        p(e.next(h));
      } catch (g) {
        c(g);
      }
    }
    function d(h) {
      try {
        p(e.throw(h));
      } catch (g) {
        c(g);
      }
    }
    function p(h) {
      h.done ? o(h.value) : n(h.value).then(l, d);
    }
    p((e = e.apply(u, [])).next());
  });
}
function __generator(u, r) {
  var a = { label: 0, sent: function() {
    if (o[0] & 1)
      throw o[1];
    return o[1];
  }, trys: [], ops: [] }, e, n, o, c;
  return c = { next: l(0), throw: l(1), return: l(2) }, typeof Symbol == "function" && (c[Symbol.iterator] = function() {
    return this;
  }), c;
  function l(p) {
    return function(h) {
      return d([p, h]);
    };
  }
  function d(p) {
    if (e)
      throw new TypeError("Generator is already executing.");
    for (; a; )
      try {
        if (e = 1, n && (o = p[0] & 2 ? n.return : p[0] ? n.throw || ((o = n.return) && o.call(n), 0) : n.next) && !(o = o.call(n, p[1])).done)
          return o;
        switch (n = 0, o && (p = [p[0] & 2, o.value]), p[0]) {
          case 0:
          case 1:
            o = p;
            break;
          case 4:
            return a.label++, { value: p[1], done: !1 };
          case 5:
            a.label++, n = p[1], p = [0];
            continue;
          case 7:
            p = a.ops.pop(), a.trys.pop();
            continue;
          default:
            if (o = a.trys, !(o = o.length > 0 && o[o.length - 1]) && (p[0] === 6 || p[0] === 2)) {
              a = 0;
              continue;
            }
            if (p[0] === 3 && (!o || p[1] > o[0] && p[1] < o[3])) {
              a.label = p[1];
              break;
            }
            if (p[0] === 6 && a.label < o[1]) {
              a.label = o[1], o = p;
              break;
            }
            if (o && a.label < o[2]) {
              a.label = o[2], a.ops.push(p);
              break;
            }
            o[2] && a.ops.pop(), a.trys.pop();
            continue;
        }
        p = r.call(u, a);
      } catch (h) {
        p = [6, h], n = 0;
      } finally {
        e = o = 0;
      }
    if (p[0] & 5)
      throw p[1];
    return { value: p[0] ? p[1] : void 0, done: !0 };
  }
}
function __values(u) {
  var r = typeof Symbol == "function" && Symbol.iterator, a = r && u[r], e = 0;
  if (a)
    return a.call(u);
  if (u && typeof u.length == "number")
    return {
      next: function() {
        return u && e >= u.length && (u = void 0), { value: u && u[e++], done: !u };
      }
    };
  throw new TypeError(r ? "Object is not iterable." : "Symbol.iterator is not defined.");
}
function __read(u, r) {
  var a = typeof Symbol == "function" && u[Symbol.iterator];
  if (!a)
    return u;
  var e = a.call(u), n, o = [], c;
  try {
    for (; (r === void 0 || r-- > 0) && !(n = e.next()).done; )
      o.push(n.value);
  } catch (l) {
    c = { error: l };
  } finally {
    try {
      n && !n.done && (a = e.return) && a.call(e);
    } finally {
      if (c)
        throw c.error;
    }
  }
  return o;
}
function __spread() {
  for (var u = [], r = 0; r < arguments.length; r++)
    u = u.concat(__read(arguments[r]));
  return u;
}
var INJECTION_TOKEN_METADATA_KEY = "injectionTokens";
function getParamInfo(u) {
  var r = Reflect.getMetadata("design:paramtypes", u) || [], a = Reflect.getOwnMetadata(INJECTION_TOKEN_METADATA_KEY, u) || {};
  return Object.keys(a).forEach(function(e) {
    r[+e] = a[e];
  }), r;
}
function isClassProvider(u) {
  return !!u.useClass;
}
function isFactoryProvider(u) {
  return !!u.useFactory;
}
var DelayedConstructor = function() {
  function u(r) {
    this.wrap = r, this.reflectMethods = [
      "get",
      "getPrototypeOf",
      "setPrototypeOf",
      "getOwnPropertyDescriptor",
      "defineProperty",
      "has",
      "set",
      "deleteProperty",
      "apply",
      "construct",
      "ownKeys"
    ];
  }
  return u.prototype.createProxy = function(r) {
    var a = this, e = {}, n = !1, o, c = function() {
      return n || (o = r(a.wrap()), n = !0), o;
    };
    return new Proxy(e, this.createHandler(c));
  }, u.prototype.createHandler = function(r) {
    var a = {}, e = function(n) {
      a[n] = function() {
        for (var o = [], c = 0; c < arguments.length; c++)
          o[c] = arguments[c];
        o[0] = r();
        var l = Reflect[n];
        return l.apply(void 0, __spread(o));
      };
    };
    return this.reflectMethods.forEach(e), a;
  }, u;
}();
function isNormalToken(u) {
  return typeof u == "string" || typeof u == "symbol";
}
function isTokenDescriptor(u) {
  return typeof u == "object" && "token" in u && "multiple" in u;
}
function isTransformDescriptor(u) {
  return typeof u == "object" && "token" in u && "transform" in u;
}
function isConstructorToken(u) {
  return typeof u == "function" || u instanceof DelayedConstructor;
}
function isTokenProvider(u) {
  return !!u.useToken;
}
function isValueProvider(u) {
  return u.useValue != null;
}
function isProvider(u) {
  return isClassProvider(u) || isValueProvider(u) || isTokenProvider(u) || isFactoryProvider(u);
}
var RegistryBase = function() {
  function u() {
    this._registryMap = /* @__PURE__ */ new Map();
  }
  return u.prototype.entries = function() {
    return this._registryMap.entries();
  }, u.prototype.getAll = function(r) {
    return this.ensure(r), this._registryMap.get(r);
  }, u.prototype.get = function(r) {
    this.ensure(r);
    var a = this._registryMap.get(r);
    return a[a.length - 1] || null;
  }, u.prototype.set = function(r, a) {
    this.ensure(r), this._registryMap.get(r).push(a);
  }, u.prototype.setAll = function(r, a) {
    this._registryMap.set(r, a);
  }, u.prototype.has = function(r) {
    return this.ensure(r), this._registryMap.get(r).length > 0;
  }, u.prototype.clear = function() {
    this._registryMap.clear();
  }, u.prototype.ensure = function(r) {
    this._registryMap.has(r) || this._registryMap.set(r, []);
  }, u;
}(), Registry = function(u) {
  __extends(r, u);
  function r() {
    return u !== null && u.apply(this, arguments) || this;
  }
  return r;
}(RegistryBase), ResolutionContext = /* @__PURE__ */ function() {
  function u() {
    this.scopedResolutions = /* @__PURE__ */ new Map();
  }
  return u;
}();
function formatDependency(u, r) {
  if (u === null)
    return "at position #" + r;
  var a = u.split(",")[r].trim();
  return '"' + a + '" at position #' + r;
}
function composeErrorMessage(u, r, a) {
  return a === void 0 && (a = "    "), __spread([u], r.message.split(`
`).map(function(e) {
    return a + e;
  })).join(`
`);
}
function formatErrorCtor(u, r, a) {
  var e = __read(u.toString().match(/constructor\(([\w, ]+)\)/) || [], 2), n = e[1], o = n === void 0 ? null : n, c = formatDependency(o, r);
  return composeErrorMessage("Cannot inject the dependency " + c + ' of "' + u.name + '" constructor. Reason:', a);
}
function isDisposable(u) {
  if (typeof u.dispose != "function")
    return !1;
  var r = u.dispose;
  return !(r.length > 0);
}
var PreResolutionInterceptors = function(u) {
  __extends(r, u);
  function r() {
    return u !== null && u.apply(this, arguments) || this;
  }
  return r;
}(RegistryBase), PostResolutionInterceptors = function(u) {
  __extends(r, u);
  function r() {
    return u !== null && u.apply(this, arguments) || this;
  }
  return r;
}(RegistryBase), Interceptors = /* @__PURE__ */ function() {
  function u() {
    this.preResolution = new PreResolutionInterceptors(), this.postResolution = new PostResolutionInterceptors();
  }
  return u;
}(), typeInfo = /* @__PURE__ */ new Map(), InternalDependencyContainer = function() {
  function u(r) {
    this.parent = r, this._registry = new Registry(), this.interceptors = new Interceptors(), this.disposed = !1, this.disposables = /* @__PURE__ */ new Set();
  }
  return u.prototype.register = function(r, a, e) {
    e === void 0 && (e = { lifecycle: Lifecycle$1.Transient }), this.ensureNotDisposed();
    var n;
    if (isProvider(a) ? n = a : n = { useClass: a }, isTokenProvider(n))
      for (var o = [r], c = n; c != null; ) {
        var l = c.useToken;
        if (o.includes(l))
          throw new Error("Token registration cycle detected! " + __spread(o, [l]).join(" -> "));
        o.push(l);
        var d = this._registry.get(l);
        d && isTokenProvider(d.provider) ? c = d.provider : c = null;
      }
    if ((e.lifecycle === Lifecycle$1.Singleton || e.lifecycle == Lifecycle$1.ContainerScoped || e.lifecycle == Lifecycle$1.ResolutionScoped) && (isValueProvider(n) || isFactoryProvider(n)))
      throw new Error('Cannot use lifecycle "' + Lifecycle$1[e.lifecycle] + '" with ValueProviders or FactoryProviders');
    return this._registry.set(r, { provider: n, options: e }), this;
  }, u.prototype.registerType = function(r, a) {
    return this.ensureNotDisposed(), isNormalToken(a) ? this.register(r, {
      useToken: a
    }) : this.register(r, {
      useClass: a
    });
  }, u.prototype.registerInstance = function(r, a) {
    return this.ensureNotDisposed(), this.register(r, {
      useValue: a
    });
  }, u.prototype.registerSingleton = function(r, a) {
    if (this.ensureNotDisposed(), isNormalToken(r)) {
      if (isNormalToken(a))
        return this.register(r, {
          useToken: a
        }, { lifecycle: Lifecycle$1.Singleton });
      if (a)
        return this.register(r, {
          useClass: a
        }, { lifecycle: Lifecycle$1.Singleton });
      throw new Error('Cannot register a type name as a singleton without a "to" token');
    }
    var e = r;
    return a && !isNormalToken(a) && (e = a), this.register(r, {
      useClass: e
    }, { lifecycle: Lifecycle$1.Singleton });
  }, u.prototype.resolve = function(r, a) {
    a === void 0 && (a = new ResolutionContext()), this.ensureNotDisposed();
    var e = this.getRegistration(r);
    if (!e && isNormalToken(r))
      throw new Error('Attempted to resolve unregistered dependency token: "' + r.toString() + '"');
    if (this.executePreResolutionInterceptor(r, "Single"), e) {
      var n = this.resolveRegistration(e, a);
      return this.executePostResolutionInterceptor(r, n, "Single"), n;
    }
    if (isConstructorToken(r)) {
      var n = this.construct(r, a);
      return this.executePostResolutionInterceptor(r, n, "Single"), n;
    }
    throw new Error("Attempted to construct an undefined constructor. Could mean a circular dependency problem. Try using `delay` function.");
  }, u.prototype.executePreResolutionInterceptor = function(r, a) {
    var e, n;
    if (this.interceptors.preResolution.has(r)) {
      var o = [];
      try {
        for (var c = __values(this.interceptors.preResolution.getAll(r)), l = c.next(); !l.done; l = c.next()) {
          var d = l.value;
          d.options.frequency != "Once" && o.push(d), d.callback(r, a);
        }
      } catch (p) {
        e = { error: p };
      } finally {
        try {
          l && !l.done && (n = c.return) && n.call(c);
        } finally {
          if (e)
            throw e.error;
        }
      }
      this.interceptors.preResolution.setAll(r, o);
    }
  }, u.prototype.executePostResolutionInterceptor = function(r, a, e) {
    var n, o;
    if (this.interceptors.postResolution.has(r)) {
      var c = [];
      try {
        for (var l = __values(this.interceptors.postResolution.getAll(r)), d = l.next(); !d.done; d = l.next()) {
          var p = d.value;
          p.options.frequency != "Once" && c.push(p), p.callback(r, a, e);
        }
      } catch (h) {
        n = { error: h };
      } finally {
        try {
          d && !d.done && (o = l.return) && o.call(l);
        } finally {
          if (n)
            throw n.error;
        }
      }
      this.interceptors.postResolution.setAll(r, c);
    }
  }, u.prototype.resolveRegistration = function(r, a) {
    if (this.ensureNotDisposed(), r.options.lifecycle === Lifecycle$1.ResolutionScoped && a.scopedResolutions.has(r))
      return a.scopedResolutions.get(r);
    var e = r.options.lifecycle === Lifecycle$1.Singleton, n = r.options.lifecycle === Lifecycle$1.ContainerScoped, o = e || n, c;
    return isValueProvider(r.provider) ? c = r.provider.useValue : isTokenProvider(r.provider) ? c = o ? r.instance || (r.instance = this.resolve(r.provider.useToken, a)) : this.resolve(r.provider.useToken, a) : isClassProvider(r.provider) ? c = o ? r.instance || (r.instance = this.construct(r.provider.useClass, a)) : this.construct(r.provider.useClass, a) : isFactoryProvider(r.provider) ? c = r.provider.useFactory(this) : c = this.construct(r.provider, a), r.options.lifecycle === Lifecycle$1.ResolutionScoped && a.scopedResolutions.set(r, c), c;
  }, u.prototype.resolveAll = function(r, a) {
    var e = this;
    a === void 0 && (a = new ResolutionContext()), this.ensureNotDisposed();
    var n = this.getAllRegistrations(r);
    if (!n && isNormalToken(r))
      throw new Error('Attempted to resolve unregistered dependency token: "' + r.toString() + '"');
    if (this.executePreResolutionInterceptor(r, "All"), n) {
      var o = n.map(function(l) {
        return e.resolveRegistration(l, a);
      });
      return this.executePostResolutionInterceptor(r, o, "All"), o;
    }
    var c = [this.construct(r, a)];
    return this.executePostResolutionInterceptor(r, c, "All"), c;
  }, u.prototype.isRegistered = function(r, a) {
    return a === void 0 && (a = !1), this.ensureNotDisposed(), this._registry.has(r) || a && (this.parent || !1) && this.parent.isRegistered(r, !0);
  }, u.prototype.reset = function() {
    this.ensureNotDisposed(), this._registry.clear(), this.interceptors.preResolution.clear(), this.interceptors.postResolution.clear();
  }, u.prototype.clearInstances = function() {
    var r, a;
    this.ensureNotDisposed();
    try {
      for (var e = __values(this._registry.entries()), n = e.next(); !n.done; n = e.next()) {
        var o = __read(n.value, 2), c = o[0], l = o[1];
        this._registry.setAll(c, l.filter(function(d) {
          return !isValueProvider(d.provider);
        }).map(function(d) {
          return d.instance = void 0, d;
        }));
      }
    } catch (d) {
      r = { error: d };
    } finally {
      try {
        n && !n.done && (a = e.return) && a.call(e);
      } finally {
        if (r)
          throw r.error;
      }
    }
  }, u.prototype.createChildContainer = function() {
    var r, a;
    this.ensureNotDisposed();
    var e = new u(this);
    try {
      for (var n = __values(this._registry.entries()), o = n.next(); !o.done; o = n.next()) {
        var c = __read(o.value, 2), l = c[0], d = c[1];
        d.some(function(p) {
          var h = p.options;
          return h.lifecycle === Lifecycle$1.ContainerScoped;
        }) && e._registry.setAll(l, d.map(function(p) {
          return p.options.lifecycle === Lifecycle$1.ContainerScoped ? {
            provider: p.provider,
            options: p.options
          } : p;
        }));
      }
    } catch (p) {
      r = { error: p };
    } finally {
      try {
        o && !o.done && (a = n.return) && a.call(n);
      } finally {
        if (r)
          throw r.error;
      }
    }
    return e;
  }, u.prototype.beforeResolution = function(r, a, e) {
    e === void 0 && (e = { frequency: "Always" }), this.interceptors.preResolution.set(r, {
      callback: a,
      options: e
    });
  }, u.prototype.afterResolution = function(r, a, e) {
    e === void 0 && (e = { frequency: "Always" }), this.interceptors.postResolution.set(r, {
      callback: a,
      options: e
    });
  }, u.prototype.dispose = function() {
    return __awaiter(this, void 0, void 0, function() {
      var r;
      return __generator(this, function(a) {
        switch (a.label) {
          case 0:
            return this.disposed = !0, r = [], this.disposables.forEach(function(e) {
              var n = e.dispose();
              n && r.push(n);
            }), [4, Promise.all(r)];
          case 1:
            return a.sent(), [2];
        }
      });
    });
  }, u.prototype.getRegistration = function(r) {
    return this.isRegistered(r) ? this._registry.get(r) : this.parent ? this.parent.getRegistration(r) : null;
  }, u.prototype.getAllRegistrations = function(r) {
    return this.isRegistered(r) ? this._registry.getAll(r) : this.parent ? this.parent.getAllRegistrations(r) : null;
  }, u.prototype.construct = function(r, a) {
    var e = this;
    if (r instanceof DelayedConstructor)
      return r.createProxy(function(o) {
        return e.resolve(o, a);
      });
    var n = function() {
      var o = typeInfo.get(r);
      if (!o || o.length === 0) {
        if (r.length === 0)
          return new r();
        throw new Error('TypeInfo not known for "' + r.name + '"');
      }
      var c = o.map(e.resolveParams(a, r));
      return new (r.bind.apply(r, __spread([void 0], c)))();
    }();
    return isDisposable(n) && this.disposables.add(n), n;
  }, u.prototype.resolveParams = function(r, a) {
    var e = this;
    return function(n, o) {
      var c, l, d;
      try {
        return isTokenDescriptor(n) ? isTransformDescriptor(n) ? n.multiple ? (c = e.resolve(n.transform)).transform.apply(c, __spread([e.resolveAll(n.token)], n.transformArgs)) : (l = e.resolve(n.transform)).transform.apply(l, __spread([e.resolve(n.token, r)], n.transformArgs)) : n.multiple ? e.resolveAll(n.token) : e.resolve(n.token, r) : isTransformDescriptor(n) ? (d = e.resolve(n.transform, r)).transform.apply(d, __spread([e.resolve(n.token, r)], n.transformArgs)) : e.resolve(n, r);
      } catch (p) {
        throw new Error(formatErrorCtor(a, o, p));
      }
    };
  }, u.prototype.ensureNotDisposed = function() {
    if (this.disposed)
      throw new Error("This container has been disposed, you cannot interact with a disposed container");
  }, u;
}(), instance = new InternalDependencyContainer();
function injectable() {
  return function(u) {
    typeInfo.set(u, getParamInfo(u));
  };
}
if (typeof Reflect > "u" || !Reflect.getMetadata)
  throw new Error(`tsyringe requires a reflect polyfill. Please add 'import "reflect-metadata"' to the top of your entry point.`);
var PKCS12AttrSet_1;
class PKCS12Attribute {
  constructor(r = {}) {
    this.attrId = "", this.attrValues = [], Object.assign(r);
  }
}
__decorate([
  AsnProp({ type: AsnPropTypes.ObjectIdentifier })
], PKCS12Attribute.prototype, "attrId", void 0);
__decorate([
  AsnProp({ type: AsnPropTypes.Any, repeated: "set" })
], PKCS12Attribute.prototype, "attrValues", void 0);
let PKCS12AttrSet = PKCS12AttrSet_1 = class extends AsnArray {
  constructor(r) {
    super(r), Object.setPrototypeOf(this, PKCS12AttrSet_1.prototype);
  }
};
PKCS12AttrSet = PKCS12AttrSet_1 = __decorate([
  AsnType({ type: AsnTypeTypes.Sequence, itemType: PKCS12Attribute })
], PKCS12AttrSet);
var AuthenticatedSafe_1;
let AuthenticatedSafe = AuthenticatedSafe_1 = class extends AsnArray {
  constructor(r) {
    super(r), Object.setPrototypeOf(this, AuthenticatedSafe_1.prototype);
  }
};
AuthenticatedSafe = AuthenticatedSafe_1 = __decorate([
  AsnType({ type: AsnTypeTypes.Sequence, itemType: ContentInfo })
], AuthenticatedSafe);
class CertBag {
  constructor(r = {}) {
    this.certId = "", this.certValue = new ArrayBuffer(0), Object.assign(this, r);
  }
}
__decorate([
  AsnProp({ type: AsnPropTypes.ObjectIdentifier })
], CertBag.prototype, "certId", void 0);
__decorate([
  AsnProp({ type: AsnPropTypes.Any, context: 0 })
], CertBag.prototype, "certValue", void 0);
class CRLBag {
  constructor(r = {}) {
    this.crlId = "", this.crltValue = new ArrayBuffer(0), Object.assign(this, r);
  }
}
__decorate([
  AsnProp({ type: AsnPropTypes.ObjectIdentifier })
], CRLBag.prototype, "crlId", void 0);
__decorate([
  AsnProp({ type: AsnPropTypes.Any, context: 0 })
], CRLBag.prototype, "crltValue", void 0);
class EncryptedData extends OctetString {
}
let EncryptedPrivateKeyInfo$1 = class {
  constructor(r = {}) {
    this.encryptionAlgorithm = new AlgorithmIdentifier(), this.encryptedData = new EncryptedData(), Object.assign(this, r);
  }
};
__decorate([
  AsnProp({ type: AlgorithmIdentifier })
], EncryptedPrivateKeyInfo$1.prototype, "encryptionAlgorithm", void 0);
__decorate([
  AsnProp({ type: EncryptedData })
], EncryptedPrivateKeyInfo$1.prototype, "encryptedData", void 0);
var Attributes_1$1, Version;
(function(u) {
  u[u.v1 = 0] = "v1";
})(Version || (Version = {}));
class PrivateKey extends OctetString {
}
let Attributes$1 = Attributes_1$1 = class extends AsnArray {
  constructor(r) {
    super(r), Object.setPrototypeOf(this, Attributes_1$1.prototype);
  }
};
Attributes$1 = Attributes_1$1 = __decorate([
  AsnType({ type: AsnTypeTypes.Sequence, itemType: Attribute$2 })
], Attributes$1);
class PrivateKeyInfo {
  constructor(r = {}) {
    this.version = Version.v1, this.privateKeyAlgorithm = new AlgorithmIdentifier(), this.privateKey = new PrivateKey(), Object.assign(this, r);
  }
}
__decorate([
  AsnProp({ type: AsnPropTypes.Integer })
], PrivateKeyInfo.prototype, "version", void 0);
__decorate([
  AsnProp({ type: AlgorithmIdentifier })
], PrivateKeyInfo.prototype, "privateKeyAlgorithm", void 0);
__decorate([
  AsnProp({ type: PrivateKey })
], PrivateKeyInfo.prototype, "privateKey", void 0);
__decorate([
  AsnProp({ type: Attributes$1, implicit: !0, context: 0, optional: !0 })
], PrivateKeyInfo.prototype, "attributes", void 0);
let KeyBag = class extends PrivateKeyInfo {
};
KeyBag = __decorate([
  AsnType({ type: AsnTypeTypes.Sequence })
], KeyBag);
let PKCS8ShroudedKeyBag = class extends EncryptedPrivateKeyInfo$1 {
};
PKCS8ShroudedKeyBag = __decorate([
  AsnType({ type: AsnTypeTypes.Sequence })
], PKCS8ShroudedKeyBag);
class SecretBag {
  constructor(r = {}) {
    this.secretTypeId = "", this.secretValue = new ArrayBuffer(0), Object.assign(this, r);
  }
}
__decorate([
  AsnProp({ type: AsnPropTypes.ObjectIdentifier })
], SecretBag.prototype, "secretTypeId", void 0);
__decorate([
  AsnProp({ type: AsnPropTypes.Any, context: 0 })
], SecretBag.prototype, "secretValue", void 0);
class MacData {
  constructor(r = {}) {
    this.mac = new DigestInfo(), this.macSalt = new OctetString(), this.iterations = 1, Object.assign(this, r);
  }
}
__decorate([
  AsnProp({ type: DigestInfo })
], MacData.prototype, "mac", void 0);
__decorate([
  AsnProp({ type: OctetString })
], MacData.prototype, "macSalt", void 0);
__decorate([
  AsnProp({ type: AsnPropTypes.Integer, defaultValue: 1 })
], MacData.prototype, "iterations", void 0);
class PFX {
  constructor(r = {}) {
    this.version = 3, this.authSafe = new ContentInfo(), this.macData = new MacData(), Object.assign(this, r);
  }
}
__decorate([
  AsnProp({ type: AsnPropTypes.Integer })
], PFX.prototype, "version", void 0);
__decorate([
  AsnProp({ type: ContentInfo })
], PFX.prototype, "authSafe", void 0);
__decorate([
  AsnProp({ type: MacData, optional: !0 })
], PFX.prototype, "macData", void 0);
var SafeContents_1;
class SafeBag {
  constructor(r = {}) {
    this.bagId = "", this.bagValue = new ArrayBuffer(0), Object.assign(this, r);
  }
}
__decorate([
  AsnProp({ type: AsnPropTypes.ObjectIdentifier })
], SafeBag.prototype, "bagId", void 0);
__decorate([
  AsnProp({ type: AsnPropTypes.Any, context: 0 })
], SafeBag.prototype, "bagValue", void 0);
__decorate([
  AsnProp({ type: PKCS12Attribute, repeated: "set", optional: !0 })
], SafeBag.prototype, "bagAttributes", void 0);
let SafeContents = SafeContents_1 = class extends AsnArray {
  constructor(r) {
    super(r), Object.setPrototypeOf(this, SafeContents_1.prototype);
  }
};
SafeContents = SafeContents_1 = __decorate([
  AsnType({ type: AsnTypeTypes.Sequence, itemType: SafeBag })
], SafeContents);
var ExtensionRequest_1, ExtendedCertificateAttributes_1, SMIMECapabilities_1;
const id_pkcs9 = "1.2.840.113549.1.9", id_pkcs9_at_challengePassword = `${id_pkcs9}.7`, id_pkcs9_at_extensionRequest = `${id_pkcs9}.14`;
let PKCS9String = class extends DirectoryString {
  constructor(r = {}) {
    super(r);
  }
  toString() {
    return this.ia5String || super.toString();
  }
};
__decorate([
  AsnProp({ type: AsnPropTypes.IA5String })
], PKCS9String.prototype, "ia5String", void 0);
PKCS9String = __decorate([
  AsnType({ type: AsnTypeTypes.Choice })
], PKCS9String);
let Pkcs7PDU = class extends ContentInfo {
};
Pkcs7PDU = __decorate([
  AsnType({ type: AsnTypeTypes.Sequence })
], Pkcs7PDU);
let UserPKCS12 = class extends PFX {
};
UserPKCS12 = __decorate([
  AsnType({ type: AsnTypeTypes.Sequence })
], UserPKCS12);
let EncryptedPrivateKeyInfo = class extends EncryptedPrivateKeyInfo$1 {
};
EncryptedPrivateKeyInfo = __decorate([
  AsnType({ type: AsnTypeTypes.Sequence })
], EncryptedPrivateKeyInfo);
let EmailAddress = class {
  constructor(r = "") {
    this.value = r;
  }
  toString() {
    return this.value;
  }
};
__decorate([
  AsnProp({ type: AsnPropTypes.IA5String })
], EmailAddress.prototype, "value", void 0);
EmailAddress = __decorate([
  AsnType({ type: AsnTypeTypes.Choice })
], EmailAddress);
let UnstructuredName = class extends PKCS9String {
};
UnstructuredName = __decorate([
  AsnType({ type: AsnTypeTypes.Choice })
], UnstructuredName);
let UnstructuredAddress = class extends DirectoryString {
};
UnstructuredAddress = __decorate([
  AsnType({ type: AsnTypeTypes.Choice })
], UnstructuredAddress);
let DateOfBirth = class {
  constructor(r = /* @__PURE__ */ new Date()) {
    this.value = r;
  }
};
__decorate([
  AsnProp({ type: AsnPropTypes.GeneralizedTime })
], DateOfBirth.prototype, "value", void 0);
DateOfBirth = __decorate([
  AsnType({ type: AsnTypeTypes.Choice })
], DateOfBirth);
let PlaceOfBirth = class extends DirectoryString {
};
PlaceOfBirth = __decorate([
  AsnType({ type: AsnTypeTypes.Choice })
], PlaceOfBirth);
let Gender = class {
  constructor(r = "M") {
    this.value = r;
  }
  toString() {
    return this.value;
  }
};
__decorate([
  AsnProp({ type: AsnPropTypes.PrintableString })
], Gender.prototype, "value", void 0);
Gender = __decorate([
  AsnType({ type: AsnTypeTypes.Choice })
], Gender);
let CountryOfCitizenship = class {
  constructor(r = "") {
    this.value = r;
  }
  toString() {
    return this.value;
  }
};
__decorate([
  AsnProp({ type: AsnPropTypes.PrintableString })
], CountryOfCitizenship.prototype, "value", void 0);
CountryOfCitizenship = __decorate([
  AsnType({ type: AsnTypeTypes.Choice })
], CountryOfCitizenship);
let CountryOfResidence = class extends CountryOfCitizenship {
};
CountryOfResidence = __decorate([
  AsnType({ type: AsnTypeTypes.Choice })
], CountryOfResidence);
let Pseudonym = class extends DirectoryString {
};
Pseudonym = __decorate([
  AsnType({ type: AsnTypeTypes.Choice })
], Pseudonym);
let ContentType = class {
  constructor(r = "") {
    this.value = r;
  }
  toString() {
    return this.value;
  }
};
__decorate([
  AsnProp({ type: AsnPropTypes.ObjectIdentifier })
], ContentType.prototype, "value", void 0);
ContentType = __decorate([
  AsnType({ type: AsnTypeTypes.Choice })
], ContentType);
let SigningTime = class extends Time {
};
SigningTime = __decorate([
  AsnType({ type: AsnTypeTypes.Choice })
], SigningTime);
let SequenceNumber = class {
  constructor(r = 0) {
    this.value = r;
  }
  toString() {
    return this.value.toString();
  }
};
__decorate([
  AsnProp({ type: AsnPropTypes.Integer })
], SequenceNumber.prototype, "value", void 0);
SequenceNumber = __decorate([
  AsnType({ type: AsnTypeTypes.Choice })
], SequenceNumber);
let CounterSignature = class extends SignerInfo {
};
CounterSignature = __decorate([
  AsnType({ type: AsnTypeTypes.Sequence })
], CounterSignature);
let ChallengePassword = class extends DirectoryString {
};
ChallengePassword = __decorate([
  AsnType({ type: AsnTypeTypes.Choice })
], ChallengePassword);
let ExtensionRequest = ExtensionRequest_1 = class extends Extensions {
  constructor(r) {
    super(r), Object.setPrototypeOf(this, ExtensionRequest_1.prototype);
  }
};
ExtensionRequest = ExtensionRequest_1 = __decorate([
  AsnType({ type: AsnTypeTypes.Sequence })
], ExtensionRequest);
let ExtendedCertificateAttributes = ExtendedCertificateAttributes_1 = class extends AsnArray {
  constructor(r) {
    super(r), Object.setPrototypeOf(this, ExtendedCertificateAttributes_1.prototype);
  }
};
ExtendedCertificateAttributes = ExtendedCertificateAttributes_1 = __decorate([
  AsnType({ type: AsnTypeTypes.Set, itemType: Attribute$1 })
], ExtendedCertificateAttributes);
let FriendlyName = class {
  constructor(r = "") {
    this.value = r;
  }
  toString() {
    return this.value;
  }
};
__decorate([
  AsnProp({ type: AsnPropTypes.BmpString })
], FriendlyName.prototype, "value", void 0);
FriendlyName = __decorate([
  AsnType({ type: AsnTypeTypes.Choice })
], FriendlyName);
let SMIMECapability = class extends AlgorithmIdentifier {
};
SMIMECapability = __decorate([
  AsnType({ type: AsnTypeTypes.Sequence })
], SMIMECapability);
let SMIMECapabilities = SMIMECapabilities_1 = class extends AsnArray {
  constructor(r) {
    super(r), Object.setPrototypeOf(this, SMIMECapabilities_1.prototype);
  }
};
SMIMECapabilities = SMIMECapabilities_1 = __decorate([
  AsnType({ type: AsnTypeTypes.Sequence, itemType: SMIMECapability })
], SMIMECapabilities);
var Attributes_1;
let Attributes = Attributes_1 = class extends AsnArray {
  constructor(r) {
    super(r), Object.setPrototypeOf(this, Attributes_1.prototype);
  }
};
Attributes = Attributes_1 = __decorate([
  AsnType({ type: AsnTypeTypes.Sequence, itemType: Attribute$2 })
], Attributes);
class CertificationRequestInfo {
  constructor(r = {}) {
    this.version = 0, this.subject = new Name$1(), this.subjectPKInfo = new SubjectPublicKeyInfo(), this.attributes = new Attributes(), Object.assign(this, r);
  }
}
__decorate([
  AsnProp({ type: AsnPropTypes.Integer })
], CertificationRequestInfo.prototype, "version", void 0);
__decorate([
  AsnProp({ type: Name$1 })
], CertificationRequestInfo.prototype, "subject", void 0);
__decorate([
  AsnProp({ type: SubjectPublicKeyInfo })
], CertificationRequestInfo.prototype, "subjectPKInfo", void 0);
__decorate([
  AsnProp({ type: Attributes, implicit: !0, context: 0 })
], CertificationRequestInfo.prototype, "attributes", void 0);
class CertificationRequest {
  constructor(r = {}) {
    this.certificationRequestInfo = new CertificationRequestInfo(), this.signatureAlgorithm = new AlgorithmIdentifier(), this.signature = new ArrayBuffer(0), Object.assign(this, r);
  }
}
__decorate([
  AsnProp({ type: CertificationRequestInfo })
], CertificationRequest.prototype, "certificationRequestInfo", void 0);
__decorate([
  AsnProp({ type: AlgorithmIdentifier })
], CertificationRequest.prototype, "signatureAlgorithm", void 0);
__decorate([
  AsnProp({ type: AsnPropTypes.BitString })
], CertificationRequest.prototype, "signature", void 0);
/*!
 * MIT License
 * 
 * Copyright (c) Peculiar Ventures. All rights reserved.
 * 
 * Permission is hereby granted, free of charge, to any person obtaining a copy
 * of this software and associated documentation files (the "Software"), to deal
 * in the Software without restriction, including without limitation the rights
 * to use, copy, modify, merge, publish, distribute, sublicense, and/or sell
 * copies of the Software, and to permit persons to whom the Software is
 * furnished to do so, subject to the following conditions:
 * 
 * The above copyright notice and this permission notice shall be included in all
 * copies or substantial portions of the Software.
 * 
 * THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS OR
 * IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF MERCHANTABILITY,
 * FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN NO EVENT SHALL THE
 * AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM, DAMAGES OR OTHER
 * LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR OTHERWISE, ARISING FROM,
 * OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE USE OR OTHER DEALINGS IN THE
 * SOFTWARE.
 * 
 */
const diAlgorithm = "crypto.algorithm";
class AlgorithmProvider {
  getAlgorithms() {
    return instance.resolveAll(diAlgorithm);
  }
  toAsnAlgorithm(r) {
    ({ ...r });
    for (const a of this.getAlgorithms()) {
      const e = a.toAsnAlgorithm(r);
      if (e)
        return e;
    }
    if (/[0-9.]+/.test(r.name)) {
      const a = new AlgorithmIdentifier({
        algorithm: r.name
      });
      if ("parameters" in r) {
        const e = r;
        a.parameters = e.parameters;
      }
      return a;
    }
    throw new Error("Cannot convert WebCrypto algorithm to ASN.1 algorithm");
  }
  toWebAlgorithm(r) {
    for (const e of this.getAlgorithms()) {
      const n = e.toWebAlgorithm(r);
      if (n)
        return n;
    }
    return {
      name: r.algorithm,
      parameters: r.parameters
    };
  }
}
const diAlgorithmProvider = "crypto.algorithmProvider";
instance.registerSingleton(diAlgorithmProvider, AlgorithmProvider);
var EcAlgorithm_1;
const idVersionOne = "1.3.36.3.3.2.8.1.1", idBrainpoolP160r1 = `${idVersionOne}.1`, idBrainpoolP160t1 = `${idVersionOne}.2`, idBrainpoolP192r1 = `${idVersionOne}.3`, idBrainpoolP192t1 = `${idVersionOne}.4`, idBrainpoolP224r1 = `${idVersionOne}.5`, idBrainpoolP224t1 = `${idVersionOne}.6`, idBrainpoolP256r1 = `${idVersionOne}.7`, idBrainpoolP256t1 = `${idVersionOne}.8`, idBrainpoolP320r1 = `${idVersionOne}.9`, idBrainpoolP320t1 = `${idVersionOne}.10`, idBrainpoolP384r1 = `${idVersionOne}.11`, idBrainpoolP384t1 = `${idVersionOne}.12`, idBrainpoolP512r1 = `${idVersionOne}.13`, idBrainpoolP512t1 = `${idVersionOne}.14`, brainpoolP160r1 = "brainpoolP160r1", brainpoolP160t1 = "brainpoolP160t1", brainpoolP192r1 = "brainpoolP192r1", brainpoolP192t1 = "brainpoolP192t1", brainpoolP224r1 = "brainpoolP224r1", brainpoolP224t1 = "brainpoolP224t1", brainpoolP256r1 = "brainpoolP256r1", brainpoolP256t1 = "brainpoolP256t1", brainpoolP320r1 = "brainpoolP320r1", brainpoolP320t1 = "brainpoolP320t1", brainpoolP384r1 = "brainpoolP384r1", brainpoolP384t1 = "brainpoolP384t1", brainpoolP512r1 = "brainpoolP512r1", brainpoolP512t1 = "brainpoolP512t1", ECDSA = "ECDSA";
let EcAlgorithm = EcAlgorithm_1 = class {
  toAsnAlgorithm(r) {
    switch (r.name.toLowerCase()) {
      case ECDSA.toLowerCase():
        if ("hash" in r)
          switch ((typeof r.hash == "string" ? r.hash : r.hash.name).toLowerCase()) {
            case "sha-1":
              return ecdsaWithSHA1;
            case "sha-256":
              return ecdsaWithSHA256;
            case "sha-384":
              return ecdsaWithSHA384;
            case "sha-512":
              return ecdsaWithSHA512;
          }
        else if ("namedCurve" in r) {
          let a = "";
          switch (r.namedCurve) {
            case "P-256":
              a = id_secp256r1;
              break;
            case "K-256":
              a = EcAlgorithm_1.SECP256K1;
              break;
            case "P-384":
              a = id_secp384r1;
              break;
            case "P-521":
              a = id_secp521r1;
              break;
            case brainpoolP160r1:
              a = idBrainpoolP160r1;
              break;
            case brainpoolP160t1:
              a = idBrainpoolP160t1;
              break;
            case brainpoolP192r1:
              a = idBrainpoolP192r1;
              break;
            case brainpoolP192t1:
              a = idBrainpoolP192t1;
              break;
            case brainpoolP224r1:
              a = idBrainpoolP224r1;
              break;
            case brainpoolP224t1:
              a = idBrainpoolP224t1;
              break;
            case brainpoolP256r1:
              a = idBrainpoolP256r1;
              break;
            case brainpoolP256t1:
              a = idBrainpoolP256t1;
              break;
            case brainpoolP320r1:
              a = idBrainpoolP320r1;
              break;
            case brainpoolP320t1:
              a = idBrainpoolP320t1;
              break;
            case brainpoolP384r1:
              a = idBrainpoolP384r1;
              break;
            case brainpoolP384t1:
              a = idBrainpoolP384t1;
              break;
            case brainpoolP512r1:
              a = idBrainpoolP512r1;
              break;
            case brainpoolP512t1:
              a = idBrainpoolP512t1;
              break;
          }
          if (a)
            return new AlgorithmIdentifier({
              algorithm: id_ecPublicKey,
              parameters: AsnConvert.serialize(new ECParameters({ namedCurve: a }))
            });
        }
    }
    return null;
  }
  toWebAlgorithm(r) {
    switch (r.algorithm) {
      case id_ecdsaWithSHA1:
        return { name: ECDSA, hash: { name: "SHA-1" } };
      case id_ecdsaWithSHA256:
        return { name: ECDSA, hash: { name: "SHA-256" } };
      case id_ecdsaWithSHA384:
        return { name: ECDSA, hash: { name: "SHA-384" } };
      case id_ecdsaWithSHA512:
        return { name: ECDSA, hash: { name: "SHA-512" } };
      case id_ecPublicKey: {
        if (!r.parameters)
          throw new TypeError("Cannot get required parameters from EC algorithm");
        switch (AsnConvert.parse(r.parameters, ECParameters).namedCurve) {
          case id_secp256r1:
            return { name: ECDSA, namedCurve: "P-256" };
          case EcAlgorithm_1.SECP256K1:
            return { name: ECDSA, namedCurve: "K-256" };
          case id_secp384r1:
            return { name: ECDSA, namedCurve: "P-384" };
          case id_secp521r1:
            return { name: ECDSA, namedCurve: "P-521" };
          case idBrainpoolP160r1:
            return { name: ECDSA, namedCurve: brainpoolP160r1 };
          case idBrainpoolP160t1:
            return { name: ECDSA, namedCurve: brainpoolP160t1 };
          case idBrainpoolP192r1:
            return { name: ECDSA, namedCurve: brainpoolP192r1 };
          case idBrainpoolP192t1:
            return { name: ECDSA, namedCurve: brainpoolP192t1 };
          case idBrainpoolP224r1:
            return { name: ECDSA, namedCurve: brainpoolP224r1 };
          case idBrainpoolP224t1:
            return { name: ECDSA, namedCurve: brainpoolP224t1 };
          case idBrainpoolP256r1:
            return { name: ECDSA, namedCurve: brainpoolP256r1 };
          case idBrainpoolP256t1:
            return { name: ECDSA, namedCurve: brainpoolP256t1 };
          case idBrainpoolP320r1:
            return { name: ECDSA, namedCurve: brainpoolP320r1 };
          case idBrainpoolP320t1:
            return { name: ECDSA, namedCurve: brainpoolP320t1 };
          case idBrainpoolP384r1:
            return { name: ECDSA, namedCurve: brainpoolP384r1 };
          case idBrainpoolP384t1:
            return { name: ECDSA, namedCurve: brainpoolP384t1 };
          case idBrainpoolP512r1:
            return { name: ECDSA, namedCurve: brainpoolP512r1 };
          case idBrainpoolP512t1:
            return { name: ECDSA, namedCurve: brainpoolP512t1 };
        }
      }
    }
    return null;
  }
};
EcAlgorithm.SECP256K1 = "1.3.132.0.10";
EcAlgorithm = EcAlgorithm_1 = __decorate([
  injectable()
], EcAlgorithm);
instance.registerSingleton(diAlgorithm, EcAlgorithm);
const NAME = Symbol("name"), VALUE = Symbol("value");
class TextObject {
  constructor(r, a = {}, e = "") {
    this[NAME] = r, this[VALUE] = e;
    for (const n in a)
      this[n] = a[n];
  }
}
TextObject.NAME = NAME;
TextObject.VALUE = VALUE;
class DefaultAlgorithmSerializer {
  static toTextObject(r) {
    const a = new TextObject("Algorithm Identifier", {}, OidSerializer.toString(r.algorithm));
    if (r.parameters)
      switch (r.algorithm) {
        case id_ecPublicKey: {
          const e = new EcAlgorithm().toWebAlgorithm(r);
          e && "namedCurve" in e ? a["Named Curve"] = e.namedCurve : a.Parameters = r.parameters;
          break;
        }
        default:
          a.Parameters = r.parameters;
      }
    return a;
  }
}
class OidSerializer {
  static toString(r) {
    const a = this.items[r];
    return a || r;
  }
}
OidSerializer.items = {
  [id_sha1]: "sha1",
  [id_sha224]: "sha224",
  [id_sha256]: "sha256",
  [id_sha384]: "sha384",
  [id_sha512]: "sha512",
  [id_rsaEncryption]: "rsaEncryption",
  [id_sha1WithRSAEncryption]: "sha1WithRSAEncryption",
  [id_sha224WithRSAEncryption]: "sha224WithRSAEncryption",
  [id_sha256WithRSAEncryption]: "sha256WithRSAEncryption",
  [id_sha384WithRSAEncryption]: "sha384WithRSAEncryption",
  [id_sha512WithRSAEncryption]: "sha512WithRSAEncryption",
  [id_ecPublicKey]: "ecPublicKey",
  [id_ecdsaWithSHA1]: "ecdsaWithSHA1",
  [id_ecdsaWithSHA224]: "ecdsaWithSHA224",
  [id_ecdsaWithSHA256]: "ecdsaWithSHA256",
  [id_ecdsaWithSHA384]: "ecdsaWithSHA384",
  [id_ecdsaWithSHA512]: "ecdsaWithSHA512",
  [id_kp_serverAuth]: "TLS WWW server authentication",
  [id_kp_clientAuth]: "TLS WWW client authentication",
  [id_kp_codeSigning]: "Code Signing",
  [id_kp_emailProtection]: "E-mail Protection",
  [id_kp_timeStamping]: "Time Stamping",
  [id_kp_OCSPSigning]: "OCSP Signing",
  [id_signedData]: "Signed Data"
};
class TextConverter {
  static serialize(r) {
    return this.serializeObj(r).join(`
`);
  }
  static pad(r = 0) {
    return "".padStart(2 * r, " ");
  }
  static serializeObj(r, a = 0) {
    const e = [];
    let n = this.pad(a++), o = "";
    const c = r[TextObject.VALUE];
    c && (o = ` ${c}`), e.push(`${n}${r[TextObject.NAME]}:${o}`), n = this.pad(a);
    for (const l in r) {
      if (typeof l == "symbol")
        continue;
      const d = r[l], p = l ? `${l}: ` : "";
      if (typeof d == "string" || typeof d == "number" || typeof d == "boolean")
        e.push(`${n}${p}${d}`);
      else if (d instanceof Date)
        e.push(`${n}${p}${d.toUTCString()}`);
      else if (Array.isArray(d))
        for (const h of d)
          h[TextObject.NAME] = l, e.push(...this.serializeObj(h, a));
      else if (d instanceof TextObject)
        d[TextObject.NAME] = l, e.push(...this.serializeObj(d, a));
      else if (BufferSourceConverter.isBufferSource(d))
        l ? (e.push(`${n}${p}`), e.push(...this.serializeBufferSource(d, a + 1))) : e.push(...this.serializeBufferSource(d, a));
      else if ("toTextObject" in d) {
        const h = d.toTextObject();
        h[TextObject.NAME] = l, e.push(...this.serializeObj(h, a));
      } else
        throw new TypeError("Cannot serialize data in text format. Unsupported type.");
    }
    return e;
  }
  static serializeBufferSource(r, a = 0) {
    const e = this.pad(a), n = BufferSourceConverter.toUint8Array(r), o = [];
    for (let c = 0; c < n.length; ) {
      const l = [];
      for (let d = 0; d < 16 && c < n.length; d++) {
        d === 8 && l.push("");
        const p = n[c++].toString(16).padStart(2, "0");
        l.push(p);
      }
      o.push(`${e}${l.join(" ")}`);
    }
    return o;
  }
  static serializeAlgorithm(r) {
    return this.algorithmSerializer.toTextObject(r);
  }
}
TextConverter.oidSerializer = OidSerializer;
TextConverter.algorithmSerializer = DefaultAlgorithmSerializer;
class AsnData {
  constructor(...r) {
    if (r.length === 1) {
      const a = r[0];
      this.rawData = AsnConvert.serialize(a), this.onInit(a);
    } else {
      const a = AsnConvert.parse(r[0], r[1]);
      this.rawData = BufferSourceConverter.toArrayBuffer(r[0]), this.onInit(a);
    }
  }
  equal(r) {
    return r instanceof AsnData ? isEqual(r.rawData, this.rawData) : !1;
  }
  toString(r = "text") {
    switch (r) {
      case "asn":
        return AsnConvert.toString(this.rawData);
      case "text":
        return TextConverter.serialize(this.toTextObject());
      case "hex":
        return Convert.ToHex(this.rawData);
      case "base64":
        return Convert.ToBase64(this.rawData);
      case "base64url":
        return Convert.ToBase64Url(this.rawData);
      default:
        throw TypeError("Argument 'format' is unsupported value");
    }
  }
  getTextName() {
    return this.constructor.NAME;
  }
  toTextObject() {
    const r = this.toTextObjectEmpty();
    return r[""] = this.rawData, r;
  }
  toTextObjectEmpty(r) {
    return new TextObject(this.getTextName(), {}, r);
  }
}
AsnData.NAME = "ASN";
class Extension extends AsnData {
  constructor(...r) {
    let a;
    BufferSourceConverter.isBufferSource(r[0]) ? a = BufferSourceConverter.toArrayBuffer(r[0]) : a = AsnConvert.serialize(new Extension$1({
      extnID: r[0],
      critical: r[1],
      extnValue: new OctetString(BufferSourceConverter.toArrayBuffer(r[2]))
    })), super(a, Extension$1);
  }
  onInit(r) {
    this.type = r.extnID, this.critical = r.critical, this.value = r.extnValue.buffer;
  }
  toTextObject() {
    const r = this.toTextObjectWithoutValue();
    return r[""] = this.value, r;
  }
  toTextObjectWithoutValue() {
    const r = this.toTextObjectEmpty(this.critical ? "critical" : void 0);
    return r[TextObject.NAME] === Extension.NAME && (r[TextObject.NAME] = OidSerializer.toString(this.type)), r;
  }
}
var _a;
class CryptoProvider {
  constructor() {
    this.items = /* @__PURE__ */ new Map(), this[_a] = "CryptoProvider", typeof self < "u" && typeof crypto < "u" && this.set(CryptoProvider.DEFAULT, crypto);
  }
  static isCryptoKeyPair(r) {
    return r && r.privateKey && r.publicKey;
  }
  static isCryptoKey(r) {
    return r && r.usages && r.type && r.algorithm && r.extractable !== void 0;
  }
  clear() {
    this.items.clear();
  }
  delete(r) {
    return this.items.delete(r);
  }
  forEach(r, a) {
    return this.items.forEach(r, a);
  }
  has(r) {
    return this.items.has(r);
  }
  get size() {
    return this.items.size;
  }
  entries() {
    return this.items.entries();
  }
  keys() {
    return this.items.keys();
  }
  values() {
    return this.items.values();
  }
  [Symbol.iterator]() {
    return this.items[Symbol.iterator]();
  }
  get(r = CryptoProvider.DEFAULT) {
    const a = this.items.get(r.toLowerCase());
    if (!a)
      throw new Error(`Cannot get Crypto by name '${r}'`);
    return a;
  }
  set(r, a) {
    if (typeof r == "string") {
      if (!a)
        throw new TypeError("Argument 'value' is required");
      this.items.set(r.toLowerCase(), a);
    } else
      this.items.set(CryptoProvider.DEFAULT, r);
    return this;
  }
}
_a = Symbol.toStringTag;
CryptoProvider.DEFAULT = "default";
const cryptoProvider = new CryptoProvider(), OID_REGEX = /^[0-2](?:\.[1-9][0-9]*)+$/;
function isOID(u) {
  return new RegExp(OID_REGEX).test(u);
}
class NameIdentifier {
  constructor(r = {}) {
    this.items = {};
    for (const a in r)
      this.register(a, r[a]);
  }
  get(r) {
    return this.items[r] || null;
  }
  findId(r) {
    return isOID(r) ? r : this.get(r);
  }
  register(r, a) {
    this.items[r] = a, this.items[a] = r;
  }
}
const names = new NameIdentifier();
names.register("CN", "2.5.4.3");
names.register("L", "2.5.4.7");
names.register("ST", "2.5.4.8");
names.register("O", "2.5.4.10");
names.register("OU", "2.5.4.11");
names.register("C", "2.5.4.6");
names.register("DC", "0.9.2342.19200300.100.1.25");
names.register("E", "1.2.840.113549.1.9.1");
names.register("G", "2.5.4.42");
names.register("I", "2.5.4.43");
names.register("SN", "2.5.4.4");
names.register("T", "2.5.4.12");
function replaceUnknownCharacter(u, r) {
  return `\\${Convert.ToHex(Convert.FromUtf8String(r)).toUpperCase()}`;
}
function escape$1(u) {
  return u.replace(/([,+"\\<>;])/g, "\\$1").replace(/^([ #])/, "\\$1").replace(/([ ]$)/, "\\$1").replace(/([\r\n\t])/, replaceUnknownCharacter);
}
class Name {
  constructor(r, a = {}) {
    this.extraNames = new NameIdentifier(), this.asn = new Name$1();
    for (const e in a)
      if (Object.prototype.hasOwnProperty.call(a, e)) {
        const n = a[e];
        this.extraNames.register(e, n);
      }
    typeof r == "string" ? this.asn = this.fromString(r) : r instanceof Name$1 ? this.asn = r : BufferSourceConverter.isBufferSource(r) ? this.asn = AsnConvert.parse(r, Name$1) : this.asn = this.fromJSON(r);
  }
  static isASCII(r) {
    for (let a = 0; a < r.length; a++)
      if (r.charCodeAt(a) > 255)
        return !1;
    return !0;
  }
  getField(r) {
    const a = this.extraNames.findId(r) || names.findId(r), e = [];
    for (const n of this.asn)
      for (const o of n)
        o.type === a && e.push(o.value.toString());
    return e;
  }
  getName(r) {
    return this.extraNames.get(r) || names.get(r);
  }
  toString() {
    return this.asn.map((r) => r.map((a) => {
      const e = this.getName(a.type) || a.type, n = a.value.anyValue ? `#${Convert.ToHex(a.value.anyValue)}` : escape$1(a.value.toString());
      return `${e}=${n}`;
    }).join("+")).join(", ");
  }
  toJSON() {
    var r;
    const a = [];
    for (const e of this.asn) {
      const n = {};
      for (const o of e) {
        const c = this.getName(o.type) || o.type;
        (r = n[c]) !== null && r !== void 0 || (n[c] = []), n[c].push(o.value.anyValue ? `#${Convert.ToHex(o.value.anyValue)}` : o.value.toString());
      }
      a.push(n);
    }
    return a;
  }
  fromString(r) {
    const a = new Name$1(), e = /(\d\.[\d.]*\d|[A-Za-z]+)=((?:"")|(?:".*?[^\\]")|(?:[^,+].*?(?:[^\\][,+]))|(?:))([,+])?/g;
    let n = null, o = ",";
    for (; n = e.exec(`${r},`); ) {
      let [, c, l] = n;
      const d = l[l.length - 1];
      (d === "," || d === "+") && (l = l.slice(0, l.length - 1), n[3] = d);
      const p = n[3];
      if (/[\d.]+/.test(c) || (c = this.getName(c) || ""), !c)
        throw new Error(`Cannot get OID for name type '${c}'`);
      const h = new AttributeTypeAndValue({ type: c });
      if (l.charAt(0) === "#")
        h.value.anyValue = Convert.FromHex(l.slice(1));
      else {
        const g = /"(.*?[^\\])?"/.exec(l);
        g && (l = g[1]), l = l.replace(/\\0a/ig, `
`).replace(/\\0d/ig, "\r").replace(/\\0g/ig, "	").replace(/\\(.)/g, "$1"), c === this.getName("E") || c === this.getName("DC") ? h.value.ia5String = l : Name.isASCII(l) ? h.value.printableString = l : h.value.utf8String = l;
      }
      o === "+" ? a[a.length - 1].push(h) : a.push(new RelativeDistinguishedName([h])), o = p;
    }
    return a;
  }
  fromJSON(r) {
    const a = new Name$1();
    for (const e of r) {
      const n = new RelativeDistinguishedName();
      for (const o in e) {
        let c = o;
        if (/[\d.]+/.test(o) || (c = this.getName(o) || ""), !c)
          throw new Error(`Cannot get OID for name type '${o}'`);
        const l = e[o];
        for (const d of l) {
          const p = new AttributeTypeAndValue({ type: c });
          if (typeof d == "object")
            for (const h in d)
              switch (h) {
                case "ia5String":
                  p.value.ia5String = d[h];
                  break;
                case "utf8String":
                  p.value.utf8String = d[h];
                  break;
                case "universalString":
                  p.value.universalString = d[h];
                  break;
                case "bmpString":
                  p.value.bmpString = d[h];
                  break;
                case "printableString":
                  p.value.printableString = d[h];
                  break;
              }
          else
            d[0] === "#" ? p.value.anyValue = Convert.FromHex(d.slice(1)) : c === this.getName("E") || c === this.getName("DC") ? p.value.ia5String = d : p.value.printableString = d;
          n.push(p);
        }
      }
      a.push(n);
    }
    return a;
  }
  toArrayBuffer() {
    return AsnConvert.serialize(this.asn);
  }
  async getThumbprint(...r) {
    var a;
    let e, n = "SHA-1";
    return r.length >= 1 && !(!((a = r[0]) === null || a === void 0) && a.subtle) ? (n = r[0] || n, e = r[1] || cryptoProvider.get()) : e = r[0] || cryptoProvider.get(), await e.subtle.digest(n, this.toArrayBuffer());
  }
}
const ERR_GN_CONSTRUCTOR = "Cannot initialize GeneralName from ASN.1 data.", ERR_GN_STRING_FORMAT = `${ERR_GN_CONSTRUCTOR} Unsupported string format in use.`, ERR_GUID = `${ERR_GN_CONSTRUCTOR} Value doesn't match to GUID regular expression.`, GUID_REGEX = /^([0-9a-f]{8})-?([0-9a-f]{4})-?([0-9a-f]{4})-?([0-9a-f]{4})-?([0-9a-f]{12})$/i, id_GUID = "1.3.6.1.4.1.311.25.1", id_UPN = "1.3.6.1.4.1.311.20.2.3", DNS = "dns", DN = "dn", EMAIL = "email", IP = "ip", URL$1 = "url", GUID = "guid", UPN = "upn", REGISTERED_ID = "id";
class GeneralName extends AsnData {
  constructor(...r) {
    let a;
    if (r.length === 2)
      switch (r[0]) {
        case DN: {
          const e = new Name(r[1]).toArrayBuffer(), n = AsnConvert.parse(e, Name$1);
          a = new GeneralName$1({ directoryName: n });
          break;
        }
        case DNS:
          a = new GeneralName$1({ dNSName: r[1] });
          break;
        case EMAIL:
          a = new GeneralName$1({ rfc822Name: r[1] });
          break;
        case GUID: {
          const e = new RegExp(GUID_REGEX, "i").exec(r[1]);
          if (!e)
            throw new Error("Cannot parse GUID value. Value doesn't match to regular expression");
          const n = e.slice(1).map((o, c) => c < 3 ? Convert.ToHex(new Uint8Array(Convert.FromHex(o)).reverse()) : o).join("");
          a = new GeneralName$1({
            otherName: new OtherName({
              typeId: id_GUID,
              value: AsnConvert.serialize(new OctetString(Convert.FromHex(n)))
            })
          });
          break;
        }
        case IP:
          a = new GeneralName$1({ iPAddress: r[1] });
          break;
        case REGISTERED_ID:
          a = new GeneralName$1({ registeredID: r[1] });
          break;
        case UPN: {
          a = new GeneralName$1({
            otherName: new OtherName({
              typeId: id_UPN,
              value: AsnConvert.serialize(AsnUtf8StringConverter.toASN(r[1]))
            })
          });
          break;
        }
        case URL$1:
          a = new GeneralName$1({ uniformResourceIdentifier: r[1] });
          break;
        default:
          throw new Error("Cannot create GeneralName. Unsupported type of the name");
      }
    else
      BufferSourceConverter.isBufferSource(r[0]) ? a = AsnConvert.parse(r[0], GeneralName$1) : a = r[0];
    super(a);
  }
  onInit(r) {
    if (r.dNSName != null)
      this.type = DNS, this.value = r.dNSName;
    else if (r.rfc822Name != null)
      this.type = EMAIL, this.value = r.rfc822Name;
    else if (r.iPAddress != null)
      this.type = IP, this.value = r.iPAddress;
    else if (r.uniformResourceIdentifier != null)
      this.type = URL$1, this.value = r.uniformResourceIdentifier;
    else if (r.registeredID != null)
      this.type = REGISTERED_ID, this.value = r.registeredID;
    else if (r.directoryName != null)
      this.type = DN, this.value = new Name(r.directoryName).toString();
    else if (r.otherName != null)
      if (r.otherName.typeId === id_GUID) {
        this.type = GUID;
        const a = AsnConvert.parse(r.otherName.value, OctetString), e = new RegExp(GUID_REGEX, "i").exec(Convert.ToHex(a));
        if (!e)
          throw new Error(ERR_GUID);
        this.value = e.slice(1).map((n, o) => o < 3 ? Convert.ToHex(new Uint8Array(Convert.FromHex(n)).reverse()) : n).join("-");
      } else if (r.otherName.typeId === id_UPN)
        this.type = UPN, this.value = AsnConvert.parse(r.otherName.value, DirectoryString).toString();
      else
        throw new Error(ERR_GN_STRING_FORMAT);
    else
      throw new Error(ERR_GN_STRING_FORMAT);
  }
  toJSON() {
    return {
      type: this.type,
      value: this.value
    };
  }
  toTextObject() {
    let r;
    switch (this.type) {
      case DN:
      case DNS:
      case GUID:
      case IP:
      case REGISTERED_ID:
      case UPN:
      case URL$1:
        r = this.type.toUpperCase();
        break;
      case EMAIL:
        r = "Email";
        break;
      default:
        throw new Error("Unsupported GeneralName type");
    }
    let a = this.value;
    return this.type === REGISTERED_ID && (a = OidSerializer.toString(a)), new TextObject(r, void 0, a);
  }
}
class GeneralNames extends AsnData {
  constructor(r) {
    let a;
    if (r instanceof GeneralNames$1)
      a = r;
    else if (Array.isArray(r)) {
      const e = [];
      for (const n of r)
        if (n instanceof GeneralName$1)
          e.push(n);
        else {
          const o = AsnConvert.parse(new GeneralName(n.type, n.value).rawData, GeneralName$1);
          e.push(o);
        }
      a = new GeneralNames$1(e);
    } else if (BufferSourceConverter.isBufferSource(r))
      a = AsnConvert.parse(r, GeneralNames$1);
    else
      throw new Error("Cannot initialize GeneralNames. Incorrect incoming arguments");
    super(a);
  }
  onInit(r) {
    const a = [];
    for (const e of r) {
      let n = null;
      try {
        n = new GeneralName(e);
      } catch {
        continue;
      }
      a.push(n);
    }
    this.items = a;
  }
  toJSON() {
    return this.items.map((r) => r.toJSON());
  }
  toTextObject() {
    const r = super.toTextObjectEmpty();
    for (const a of this.items) {
      const e = a.toTextObject();
      let n = r[e[TextObject.NAME]];
      Array.isArray(n) || (n = [], r[e[TextObject.NAME]] = n), n.push(e);
    }
    return r;
  }
}
GeneralNames.NAME = "GeneralNames";
const rPaddingTag = "-{5}", rEolChars = "\\n", rNameTag = `[^${rEolChars}]+`, rBeginTag = `${rPaddingTag}BEGIN (${rNameTag}(?=${rPaddingTag}))${rPaddingTag}`, rEndTag = `${rPaddingTag}END \\1${rPaddingTag}`, rEolGroup = "\\n", rHeaderKey = `[^:${rEolChars}]+`, rHeaderValue = `(?:[^${rEolChars}]+${rEolGroup}(?: +[^${rEolChars}]+${rEolGroup})*)`, rBase64Chars = "[a-zA-Z0-9=+/]+", rBase64 = `(?:${rBase64Chars}${rEolGroup})+`, rPem = `${rBeginTag}${rEolGroup}(?:((?:${rHeaderKey}: ${rHeaderValue})+))?${rEolGroup}?(${rBase64})${rEndTag}`;
class PemConverter {
  static isPem(r) {
    return typeof r == "string" && new RegExp(rPem, "g").test(r);
  }
  static decodeWithHeaders(r) {
    r = r.replace(/\r/g, "");
    const a = new RegExp(rPem, "g"), e = [];
    let n = null;
    for (; n = a.exec(r); ) {
      const o = n[3].replace(new RegExp(`[${rEolChars}]+`, "g"), ""), c = {
        type: n[1],
        headers: [],
        rawData: Convert.FromBase64(o)
      }, l = n[2];
      if (l) {
        const d = l.split(new RegExp(rEolGroup, "g"));
        let p = null;
        for (const h of d) {
          const [g, y] = h.split(/:(.*)/);
          if (y === void 0) {
            if (!p)
              throw new Error("Cannot parse PEM string. Incorrect header value");
            p.value += g.trim();
          } else
            p && c.headers.push(p), p = { key: g, value: y.trim() };
        }
        p && c.headers.push(p);
      }
      e.push(c);
    }
    return e;
  }
  static decode(r) {
    return this.decodeWithHeaders(r).map((e) => e.rawData);
  }
  static decodeFirst(r) {
    const a = this.decode(r);
    if (!a.length)
      throw new RangeError("PEM string doesn't contain any objects");
    return a[0];
  }
  static encode(r, a) {
    if (Array.isArray(r)) {
      const e = new Array();
      return a ? r.forEach((n) => {
        if (!BufferSourceConverter.isBufferSource(n))
          throw new TypeError("Cannot encode array of BufferSource in PEM format. Not all items of the array are BufferSource");
        e.push(this.encodeStruct({
          type: a,
          rawData: BufferSourceConverter.toArrayBuffer(n)
        }));
      }) : r.forEach((n) => {
        if (!("type" in n))
          throw new TypeError("Cannot encode array of PemStruct in PEM format. Not all items of the array are PemStrut");
        e.push(this.encodeStruct(n));
      }), e.join(`
`);
    } else {
      if (!a)
        throw new Error("Required argument 'tag' is missed");
      return this.encodeStruct({
        type: a,
        rawData: BufferSourceConverter.toArrayBuffer(r)
      });
    }
  }
  static encodeStruct(r) {
    var a;
    const e = r.type.toLocaleUpperCase(), n = [];
    if (n.push(`-----BEGIN ${e}-----`), !((a = r.headers) === null || a === void 0) && a.length) {
      for (const p of r.headers)
        n.push(`${p.key}: ${p.value}`);
      n.push("");
    }
    const o = Convert.ToBase64(r.rawData);
    let c, l = 0;
    const d = Array();
    for (; l < o.length && (o.length - l < 64 ? c = o.substring(l) : (c = o.substring(l, l + 64), l += 64), c.length !== 0); )
      if (d.push(c), c.length < 64)
        break;
    return n.push(...d), n.push(`-----END ${e}-----`), n.join(`
`);
  }
}
PemConverter.CertificateTag = "CERTIFICATE";
PemConverter.CrlTag = "CRL";
PemConverter.CertificateRequestTag = "CERTIFICATE REQUEST";
PemConverter.PublicKeyTag = "PUBLIC KEY";
PemConverter.PrivateKeyTag = "PRIVATE KEY";
class PemData extends AsnData {
  static isAsnEncoded(r) {
    return BufferSourceConverter.isBufferSource(r) || typeof r == "string";
  }
  static toArrayBuffer(r) {
    if (typeof r == "string") {
      if (PemConverter.isPem(r))
        return PemConverter.decode(r)[0];
      if (Convert.isHex(r))
        return Convert.FromHex(r);
      if (Convert.isBase64(r))
        return Convert.FromBase64(r);
      if (Convert.isBase64Url(r))
        return Convert.FromBase64Url(r);
      throw new TypeError("Unsupported format of 'raw' argument. Must be one of DER, PEM, HEX, Base64, or Base4Url");
    } else {
      const a = Convert.ToBinary(r);
      return PemConverter.isPem(a) ? PemConverter.decode(a)[0] : Convert.isHex(a) ? Convert.FromHex(a) : Convert.isBase64(a) ? Convert.FromBase64(a) : Convert.isBase64Url(a) ? Convert.FromBase64Url(a) : BufferSourceConverter.toArrayBuffer(r);
    }
  }
  constructor(...r) {
    PemData.isAsnEncoded(r[0]) ? super(PemData.toArrayBuffer(r[0]), r[1]) : super(r[0]);
  }
  toString(r = "pem") {
    switch (r) {
      case "pem":
        return PemConverter.encode(this.rawData, this.tag);
      default:
        return super.toString(r);
    }
  }
}
class PublicKey extends PemData {
  constructor(r) {
    PemData.isAsnEncoded(r) ? super(r, SubjectPublicKeyInfo) : super(r), this.tag = PemConverter.PublicKeyTag;
  }
  async export(...r) {
    let a, e = ["verify"], n = { hash: "SHA-256", ...this.algorithm };
    return r.length > 1 ? (n = r[0] || n, e = r[1] || e, a = r[2] || cryptoProvider.get()) : a = r[0] || cryptoProvider.get(), a.subtle.importKey("spki", this.rawData, n, !0, e);
  }
  onInit(r) {
    const a = instance.resolve(diAlgorithmProvider), e = this.algorithm = a.toWebAlgorithm(r.algorithm);
    switch (r.algorithm.algorithm) {
      case id_rsaEncryption: {
        const n = AsnConvert.parse(r.subjectPublicKey, RSAPublicKey), o = BufferSourceConverter.toUint8Array(n.modulus);
        e.publicExponent = BufferSourceConverter.toUint8Array(n.publicExponent), e.modulusLength = (o[0] ? o : o.slice(1)).byteLength << 3;
        break;
      }
    }
  }
  async getThumbprint(...r) {
    var a;
    let e, n = "SHA-1";
    return r.length >= 1 && !(!((a = r[0]) === null || a === void 0) && a.subtle) ? (n = r[0] || n, e = r[1] || cryptoProvider.get()) : e = r[0] || cryptoProvider.get(), await e.subtle.digest(n, this.rawData);
  }
  async getKeyIdentifier(r) {
    r || (r = cryptoProvider.get());
    const a = AsnConvert.parse(this.rawData, SubjectPublicKeyInfo);
    return await r.subtle.digest("SHA-1", a.subjectPublicKey);
  }
  toTextObject() {
    const r = this.toTextObjectEmpty(), a = AsnConvert.parse(this.rawData, SubjectPublicKeyInfo);
    switch (r.Algorithm = TextConverter.serializeAlgorithm(a.algorithm), a.algorithm.algorithm) {
      case id_ecPublicKey:
        r["EC Point"] = a.subjectPublicKey;
        break;
      case id_rsaEncryption:
      default:
        r["Raw Data"] = a.subjectPublicKey;
    }
    return r;
  }
}
class ExtensionFactory {
  static register(r, a) {
    this.items.set(r, a);
  }
  static create(r) {
    const a = new Extension(r), e = this.items.get(a.type);
    return e ? new e(r) : a;
  }
}
ExtensionFactory.items = /* @__PURE__ */ new Map();
const diAsnSignatureFormatter = "crypto.signatureFormatter";
class AsnDefaultSignatureFormatter {
  toAsnSignature(r, a) {
    return BufferSourceConverter.toArrayBuffer(a);
  }
  toWebSignature(r, a) {
    return BufferSourceConverter.toArrayBuffer(a);
  }
}
class X509Certificate extends PemData {
  constructor(r) {
    PemData.isAsnEncoded(r) ? super(r, Certificate) : super(r), this.tag = PemConverter.CertificateTag;
  }
  onInit(r) {
    const a = r.tbsCertificate;
    this.tbs = AsnConvert.serialize(a), this.serialNumber = Convert.ToHex(a.serialNumber), this.subjectName = new Name(a.subject), this.subject = new Name(a.subject).toString(), this.issuerName = new Name(a.issuer), this.issuer = this.issuerName.toString();
    const e = instance.resolve(diAlgorithmProvider);
    this.signatureAlgorithm = e.toWebAlgorithm(r.signatureAlgorithm), this.signature = r.signatureValue;
    const n = a.validity.notBefore.utcTime || a.validity.notBefore.generalTime;
    if (!n)
      throw new Error("Cannot get 'notBefore' value");
    this.notBefore = n;
    const o = a.validity.notAfter.utcTime || a.validity.notAfter.generalTime;
    if (!o)
      throw new Error("Cannot get 'notAfter' value");
    this.notAfter = o, this.extensions = [], a.extensions && (this.extensions = a.extensions.map((c) => ExtensionFactory.create(AsnConvert.serialize(c)))), this.publicKey = new PublicKey(a.subjectPublicKeyInfo);
  }
  getExtension(r) {
    for (const a of this.extensions)
      if (typeof r == "string") {
        if (a.type === r)
          return a;
      } else if (a instanceof r)
        return a;
    return null;
  }
  getExtensions(r) {
    return this.extensions.filter((a) => typeof r == "string" ? a.type === r : a instanceof r);
  }
  async verify(r = {}, a = cryptoProvider.get()) {
    let e, n;
    const o = r.publicKey;
    try {
      if (!o)
        e = { ...this.publicKey.algorithm, ...this.signatureAlgorithm }, n = await this.publicKey.export(e, ["verify"], a);
      else if ("publicKey" in o)
        e = { ...o.publicKey.algorithm, ...this.signatureAlgorithm }, n = await o.publicKey.export(e, ["verify"]);
      else if (o instanceof PublicKey)
        e = { ...o.algorithm, ...this.signatureAlgorithm }, n = await o.export(e, ["verify"]);
      else if (BufferSourceConverter.isBufferSource(o)) {
        const p = new PublicKey(o);
        e = { ...p.algorithm, ...this.signatureAlgorithm }, n = await p.export(e, ["verify"]);
      } else
        e = { ...o.algorithm, ...this.signatureAlgorithm }, n = o;
    } catch {
      return !1;
    }
    const c = instance.resolveAll(diAsnSignatureFormatter).reverse();
    let l = null;
    for (const p of c)
      if (l = p.toWebSignature(e, this.signature), l)
        break;
    if (!l)
      throw Error("Cannot convert ASN.1 signature value to WebCrypto format");
    const d = await a.subtle.verify(this.signatureAlgorithm, n, l, this.tbs);
    if (r.signatureOnly)
      return d;
    {
      const h = (r.date || /* @__PURE__ */ new Date()).getTime();
      return d && this.notBefore.getTime() < h && h < this.notAfter.getTime();
    }
  }
  async getThumbprint(...r) {
    let a, e = "SHA-1";
    return r[0] && (r[0].subtle ? a = r[0] : (e = r[0] || e, a = r[1])), a ?? (a = cryptoProvider.get()), await a.subtle.digest(e, this.rawData);
  }
  async isSelfSigned(r = cryptoProvider.get()) {
    return this.subject === this.issuer && await this.verify({ signatureOnly: !0 }, r);
  }
  toTextObject() {
    const r = this.toTextObjectEmpty(), a = AsnConvert.parse(this.rawData, Certificate), e = a.tbsCertificate, n = new TextObject("", {
      Version: `${Version$1[e.version]} (${e.version})`,
      "Serial Number": e.serialNumber,
      "Signature Algorithm": TextConverter.serializeAlgorithm(e.signature),
      Issuer: this.issuer,
      Validity: new TextObject("", {
        "Not Before": e.validity.notBefore.getTime(),
        "Not After": e.validity.notAfter.getTime()
      }),
      Subject: this.subject,
      "Subject Public Key Info": this.publicKey
    });
    if (e.issuerUniqueID && (n["Issuer Unique ID"] = e.issuerUniqueID), e.subjectUniqueID && (n["Subject Unique ID"] = e.subjectUniqueID), this.extensions.length) {
      const o = new TextObject("");
      for (const c of this.extensions) {
        const l = c.toTextObject();
        o[l[TextObject.NAME]] = l;
      }
      n.Extensions = o;
    }
    return r.Data = n, r.Signature = new TextObject("", {
      Algorithm: TextConverter.serializeAlgorithm(a.signatureAlgorithm),
      "": a.signatureValue
    }), r;
  }
}
X509Certificate.NAME = "Certificate";
class AuthorityKeyIdentifierExtension extends Extension {
  constructor(...r) {
    if (BufferSourceConverter.isBufferSource(r[0]))
      super(r[0]);
    else if (typeof r[0] == "string") {
      const a = new AuthorityKeyIdentifier({ keyIdentifier: new KeyIdentifier(Convert.FromHex(r[0])) });
      super(id_ce_authorityKeyIdentifier, r[1], AsnConvert.serialize(a));
    } else {
      const a = r[0], e = a.name instanceof GeneralNames ? AsnConvert.parse(a.name.rawData, GeneralNames$1) : a.name, n = new AuthorityKeyIdentifier({
        authorityCertIssuer: e,
        authorityCertSerialNumber: Convert.FromHex(a.serialNumber)
      });
      super(id_ce_authorityKeyIdentifier, r[1], AsnConvert.serialize(n));
    }
  }
  static async create(r, a = !1, e = cryptoProvider.get()) {
    if (r instanceof X509Certificate || CryptoProvider.isCryptoKey(r)) {
      const n = r instanceof X509Certificate ? await r.publicKey.export(e) : r, o = await e.subtle.exportKey("spki", n), l = await new PublicKey(o).getKeyIdentifier(e);
      return new AuthorityKeyIdentifierExtension(Convert.ToHex(l), a);
    } else
      return new AuthorityKeyIdentifierExtension(r, a);
  }
  onInit(r) {
    super.onInit(r);
    const a = AsnConvert.parse(r.extnValue, AuthorityKeyIdentifier);
    a.keyIdentifier && (this.keyId = Convert.ToHex(a.keyIdentifier)), a.authorityCertIssuer && a.authorityCertSerialNumber && (this.certId = {
      name: a.authorityCertIssuer,
      serialNumber: Convert.ToHex(a.authorityCertSerialNumber)
    });
  }
  toTextObject() {
    const r = this.toTextObjectWithoutValue(), a = AsnConvert.parse(this.value, AuthorityKeyIdentifier);
    return a.authorityCertIssuer && (r["Authority Issuer"] = new GeneralNames(a.authorityCertIssuer).toTextObject()), a.authorityCertSerialNumber && (r["Authority Serial Number"] = a.authorityCertSerialNumber), a.keyIdentifier && (r[""] = a.keyIdentifier), r;
  }
}
AuthorityKeyIdentifierExtension.NAME = "Authority Key Identifier";
class BasicConstraintsExtension extends Extension {
  constructor(...r) {
    if (BufferSourceConverter.isBufferSource(r[0])) {
      super(r[0]);
      const a = AsnConvert.parse(this.value, BasicConstraints);
      this.ca = a.cA, this.pathLength = a.pathLenConstraint;
    } else {
      const a = new BasicConstraints({
        cA: r[0],
        pathLenConstraint: r[1]
      });
      super(id_ce_basicConstraints, r[2], AsnConvert.serialize(a)), this.ca = r[0], this.pathLength = r[1];
    }
  }
  toTextObject() {
    const r = this.toTextObjectWithoutValue();
    return this.ca && (r.CA = this.ca), this.pathLength !== void 0 && (r["Path Length"] = this.pathLength), r;
  }
}
BasicConstraintsExtension.NAME = "Basic Constraints";
var ExtendedKeyUsage;
(function(u) {
  u.serverAuth = "1.3.6.1.5.5.7.3.1", u.clientAuth = "1.3.6.1.5.5.7.3.2", u.codeSigning = "1.3.6.1.5.5.7.3.3", u.emailProtection = "1.3.6.1.5.5.7.3.4", u.timeStamping = "1.3.6.1.5.5.7.3.8", u.ocspSigning = "1.3.6.1.5.5.7.3.9";
})(ExtendedKeyUsage || (ExtendedKeyUsage = {}));
class ExtendedKeyUsageExtension extends Extension {
  constructor(...r) {
    if (BufferSourceConverter.isBufferSource(r[0])) {
      super(r[0]);
      const a = AsnConvert.parse(this.value, ExtendedKeyUsage$1);
      this.usages = a.map((e) => e);
    } else {
      const a = new ExtendedKeyUsage$1(r[0]);
      super(id_ce_extKeyUsage, r[1], AsnConvert.serialize(a)), this.usages = r[0];
    }
  }
  toTextObject() {
    const r = this.toTextObjectWithoutValue();
    return r[""] = this.usages.map((a) => OidSerializer.toString(a)).join(", "), r;
  }
}
ExtendedKeyUsageExtension.NAME = "Extended Key Usages";
var KeyUsageFlags;
(function(u) {
  u[u.digitalSignature = 1] = "digitalSignature", u[u.nonRepudiation = 2] = "nonRepudiation", u[u.keyEncipherment = 4] = "keyEncipherment", u[u.dataEncipherment = 8] = "dataEncipherment", u[u.keyAgreement = 16] = "keyAgreement", u[u.keyCertSign = 32] = "keyCertSign", u[u.cRLSign = 64] = "cRLSign", u[u.encipherOnly = 128] = "encipherOnly", u[u.decipherOnly = 256] = "decipherOnly";
})(KeyUsageFlags || (KeyUsageFlags = {}));
class KeyUsagesExtension extends Extension {
  constructor(...r) {
    if (BufferSourceConverter.isBufferSource(r[0])) {
      super(r[0]);
      const a = AsnConvert.parse(this.value, KeyUsage);
      this.usages = a.toNumber();
    } else {
      const a = new KeyUsage(r[0]);
      super(id_ce_keyUsage, r[1], AsnConvert.serialize(a)), this.usages = r[0];
    }
  }
  toTextObject() {
    const r = this.toTextObjectWithoutValue(), a = AsnConvert.parse(this.value, KeyUsage);
    return r[""] = a.toJSON().join(", "), r;
  }
}
KeyUsagesExtension.NAME = "Key Usages";
class SubjectKeyIdentifierExtension extends Extension {
  constructor(...r) {
    if (BufferSourceConverter.isBufferSource(r[0])) {
      super(r[0]);
      const a = AsnConvert.parse(this.value, SubjectKeyIdentifier);
      this.keyId = Convert.ToHex(a);
    } else {
      const a = typeof r[0] == "string" ? Convert.FromHex(r[0]) : r[0], e = new SubjectKeyIdentifier(a);
      super(id_ce_subjectKeyIdentifier, r[1], AsnConvert.serialize(e)), this.keyId = Convert.ToHex(a);
    }
  }
  static async create(r, a = !1, e = cryptoProvider.get()) {
    let n;
    r instanceof PublicKey ? n = r.rawData : "publicKey" in r ? n = r.publicKey.rawData : BufferSourceConverter.isBufferSource(r) ? n = r : n = await e.subtle.exportKey("spki", r);
    const c = await new PublicKey(n).getKeyIdentifier(e);
    return new SubjectKeyIdentifierExtension(Convert.ToHex(c), a);
  }
  toTextObject() {
    const r = this.toTextObjectWithoutValue(), a = AsnConvert.parse(this.value, SubjectKeyIdentifier);
    return r[""] = a, r;
  }
}
SubjectKeyIdentifierExtension.NAME = "Subject Key Identifier";
class SubjectAlternativeNameExtension extends Extension {
  constructor(...r) {
    BufferSourceConverter.isBufferSource(r[0]) ? super(r[0]) : super(id_ce_subjectAltName, r[1], new GeneralNames(r[0] || []).rawData);
  }
  onInit(r) {
    super.onInit(r);
    const a = AsnConvert.parse(r.extnValue, SubjectAlternativeName);
    this.names = new GeneralNames(a);
  }
  toTextObject() {
    const r = this.toTextObjectWithoutValue(), a = this.names.toTextObject();
    for (const e in a)
      r[e] = a[e];
    return r;
  }
}
SubjectAlternativeNameExtension.NAME = "Subject Alternative Name";
class CertificatePolicyExtension extends Extension {
  constructor(...r) {
    var a;
    if (BufferSourceConverter.isBufferSource(r[0])) {
      super(r[0]);
      const e = AsnConvert.parse(this.value, CertificatePolicies);
      this.policies = e.map((n) => n.policyIdentifier);
    } else {
      const e = r[0], n = (a = r[1]) !== null && a !== void 0 ? a : !1, o = new CertificatePolicies(e.map((c) => new PolicyInformation({
        policyIdentifier: c
      })));
      super(id_ce_certificatePolicies, n, AsnConvert.serialize(o)), this.policies = e;
    }
  }
  toTextObject() {
    const r = this.toTextObjectWithoutValue();
    return r.Policy = this.policies.map((a) => new TextObject("", {}, OidSerializer.toString(a))), r;
  }
}
CertificatePolicyExtension.NAME = "Certificate Policies";
ExtensionFactory.register(id_ce_certificatePolicies, CertificatePolicyExtension);
class Attribute extends AsnData {
  constructor(...r) {
    let a;
    if (BufferSourceConverter.isBufferSource(r[0]))
      a = BufferSourceConverter.toArrayBuffer(r[0]);
    else {
      const e = r[0], n = Array.isArray(r[1]) ? r[1].map((o) => BufferSourceConverter.toArrayBuffer(o)) : [];
      a = AsnConvert.serialize(new Attribute$2({ type: e, values: n }));
    }
    super(a, Attribute$2);
  }
  onInit(r) {
    this.type = r.type, this.values = r.values;
  }
  toTextObject() {
    const r = this.toTextObjectWithoutValue();
    return r.Value = this.values.map((a) => new TextObject("", { "": a })), r;
  }
  toTextObjectWithoutValue() {
    const r = this.toTextObjectEmpty();
    return r[TextObject.NAME] === Attribute.NAME && (r[TextObject.NAME] = OidSerializer.toString(this.type)), r;
  }
}
Attribute.NAME = "Attribute";
class ChallengePasswordAttribute extends Attribute {
  constructor(...r) {
    var a;
    if (BufferSourceConverter.isBufferSource(r[0]))
      super(r[0]);
    else {
      const e = new ChallengePassword({
        printableString: r[0]
      });
      super(id_pkcs9_at_challengePassword, [AsnConvert.serialize(e)]);
    }
    (a = this.password) !== null && a !== void 0 || (this.password = "");
  }
  onInit(r) {
    if (super.onInit(r), this.values[0]) {
      const a = AsnConvert.parse(this.values[0], ChallengePassword);
      this.password = a.toString();
    }
  }
  toTextObject() {
    const r = this.toTextObjectWithoutValue();
    return r[TextObject.VALUE] = this.password, r;
  }
}
ChallengePasswordAttribute.NAME = "Challenge Password";
class ExtensionsAttribute extends Attribute {
  constructor(...r) {
    var a;
    if (BufferSourceConverter.isBufferSource(r[0]))
      super(r[0]);
    else {
      const e = r[0], n = new Extensions();
      for (const o of e)
        n.push(AsnConvert.parse(o.rawData, Extension$1));
      super(id_pkcs9_at_extensionRequest, [AsnConvert.serialize(n)]);
    }
    (a = this.items) !== null && a !== void 0 || (this.items = []);
  }
  onInit(r) {
    if (super.onInit(r), this.values[0]) {
      const a = AsnConvert.parse(this.values[0], Extensions);
      this.items = a.map((e) => ExtensionFactory.create(AsnConvert.serialize(e)));
    }
  }
  toTextObject() {
    const r = this.toTextObjectWithoutValue(), a = this.items.map((e) => e.toTextObject());
    for (const e of a)
      r[e[TextObject.NAME]] = e;
    return r;
  }
}
ExtensionsAttribute.NAME = "Extensions";
class AttributeFactory {
  static register(r, a) {
    this.items.set(r, a);
  }
  static create(r) {
    const a = new Attribute(r), e = this.items.get(a.type);
    return e ? new e(r) : a;
  }
}
AttributeFactory.items = /* @__PURE__ */ new Map();
let RsaAlgorithm = class {
  toAsnAlgorithm(r) {
    switch (r.name.toLowerCase()) {
      case "rsassa-pkcs1-v1_5":
        if (r.hash)
          switch (r.hash.name.toLowerCase()) {
            case "sha-1":
              return new AlgorithmIdentifier({ algorithm: id_sha1WithRSAEncryption, parameters: null });
            case "sha-256":
              return new AlgorithmIdentifier({ algorithm: id_sha256WithRSAEncryption, parameters: null });
            case "sha-384":
              return new AlgorithmIdentifier({ algorithm: id_sha384WithRSAEncryption, parameters: null });
            case "sha-512":
              return new AlgorithmIdentifier({ algorithm: id_sha512WithRSAEncryption, parameters: null });
          }
        else
          return new AlgorithmIdentifier({ algorithm: id_rsaEncryption, parameters: null });
    }
    return null;
  }
  toWebAlgorithm(r) {
    switch (r.algorithm) {
      case id_rsaEncryption:
        return { name: "RSASSA-PKCS1-v1_5" };
      case id_sha1WithRSAEncryption:
        return { name: "RSASSA-PKCS1-v1_5", hash: { name: "SHA-1" } };
      case id_sha256WithRSAEncryption:
        return { name: "RSASSA-PKCS1-v1_5", hash: { name: "SHA-256" } };
      case id_sha384WithRSAEncryption:
        return { name: "RSASSA-PKCS1-v1_5", hash: { name: "SHA-384" } };
      case id_sha512WithRSAEncryption:
        return { name: "RSASSA-PKCS1-v1_5", hash: { name: "SHA-512" } };
    }
    return null;
  }
};
RsaAlgorithm = __decorate([
  injectable()
], RsaAlgorithm);
instance.registerSingleton(diAlgorithm, RsaAlgorithm);
class AsnEcSignatureFormatter {
  addPadding(r, a) {
    const e = BufferSourceConverter.toUint8Array(a), n = new Uint8Array(r);
    return n.set(e, r - e.length), n;
  }
  removePadding(r, a = !1) {
    let e = BufferSourceConverter.toUint8Array(r);
    for (let n = 0; n < e.length; n++)
      if (e[n]) {
        e = e.slice(n);
        break;
      }
    if (a && e[0] > 127) {
      const n = new Uint8Array(e.length + 1);
      return n.set(e, 1), n.buffer;
    }
    return e.buffer;
  }
  toAsnSignature(r, a) {
    if (r.name === "ECDSA") {
      const e = r.namedCurve, n = AsnEcSignatureFormatter.namedCurveSize.get(e) || AsnEcSignatureFormatter.defaultNamedCurveSize, o = new ECDSASigValue(), c = BufferSourceConverter.toUint8Array(a);
      return o.r = this.removePadding(c.slice(0, n), !0), o.s = this.removePadding(c.slice(n, n + n), !0), AsnConvert.serialize(o);
    }
    return null;
  }
  toWebSignature(r, a) {
    if (r.name === "ECDSA") {
      const e = AsnConvert.parse(a, ECDSASigValue), n = r.namedCurve, o = AsnEcSignatureFormatter.namedCurveSize.get(n) || AsnEcSignatureFormatter.defaultNamedCurveSize, c = this.addPadding(o, this.removePadding(e.r)), l = this.addPadding(o, this.removePadding(e.s));
      return combine(c, l);
    }
    return null;
  }
}
AsnEcSignatureFormatter.namedCurveSize = /* @__PURE__ */ new Map();
AsnEcSignatureFormatter.defaultNamedCurveSize = 32;
const idX25519 = "1.3.101.110", idX448 = "1.3.101.111", idEd25519 = "1.3.101.112", idEd448 = "1.3.101.113";
let EdAlgorithm = class {
  toAsnAlgorithm(r) {
    let a = null;
    switch (r.name.toLowerCase()) {
      case "eddsa":
        switch (r.namedCurve.toLowerCase()) {
          case "ed25519":
            a = idEd25519;
            break;
          case "ed448":
            a = idEd448;
            break;
        }
        break;
      case "ecdh-es":
        switch (r.namedCurve.toLowerCase()) {
          case "x25519":
            a = idX25519;
            break;
          case "x448":
            a = idX448;
            break;
        }
    }
    return a ? new AlgorithmIdentifier({
      algorithm: a
    }) : null;
  }
  toWebAlgorithm(r) {
    switch (r.algorithm) {
      case idEd25519:
        return { name: "EdDSA", namedCurve: "Ed25519" };
      case idEd448:
        return { name: "EdDSA", namedCurve: "Ed448" };
      case idX25519:
        return { name: "ECDH-ES", namedCurve: "X25519" };
      case idX448:
        return { name: "ECDH-ES", namedCurve: "X448" };
    }
    return null;
  }
};
EdAlgorithm = __decorate([
  injectable()
], EdAlgorithm);
instance.registerSingleton(diAlgorithm, EdAlgorithm);
class Pkcs10CertificateRequest extends PemData {
  constructor(r) {
    PemData.isAsnEncoded(r) ? super(r, CertificationRequest) : super(r), this.tag = PemConverter.CertificateRequestTag;
  }
  onInit(r) {
    this.tbs = AsnConvert.serialize(r.certificationRequestInfo), this.publicKey = new PublicKey(r.certificationRequestInfo.subjectPKInfo);
    const a = instance.resolve(diAlgorithmProvider);
    this.signatureAlgorithm = a.toWebAlgorithm(r.signatureAlgorithm), this.signature = r.signature, this.attributes = r.certificationRequestInfo.attributes.map((n) => AttributeFactory.create(AsnConvert.serialize(n)));
    const e = this.getAttribute(id_pkcs9_at_extensionRequest);
    this.extensions = [], e instanceof ExtensionsAttribute && (this.extensions = e.items), this.subjectName = new Name(r.certificationRequestInfo.subject), this.subject = this.subjectName.toString();
  }
  getAttribute(r) {
    for (const a of this.attributes)
      if (a.type === r)
        return a;
    return null;
  }
  getAttributes(r) {
    return this.attributes.filter((a) => a.type === r);
  }
  getExtension(r) {
    for (const a of this.extensions)
      if (a.type === r)
        return a;
    return null;
  }
  getExtensions(r) {
    return this.extensions.filter((a) => a.type === r);
  }
  async verify(r = cryptoProvider.get()) {
    const a = { ...this.publicKey.algorithm, ...this.signatureAlgorithm }, e = await this.publicKey.export(a, ["verify"], r), n = instance.resolveAll(diAsnSignatureFormatter).reverse();
    let o = null;
    for (const l of n)
      if (o = l.toWebSignature(a, this.signature), o)
        break;
    if (!o)
      throw Error("Cannot convert WebCrypto signature value to ASN.1 format");
    return await r.subtle.verify(this.signatureAlgorithm, e, o, this.tbs);
  }
  toTextObject() {
    const r = this.toTextObjectEmpty(), a = AsnConvert.parse(this.rawData, CertificationRequest), e = a.certificationRequestInfo, n = new TextObject("", {
      Version: `${Version$1[e.version]} (${e.version})`,
      Subject: this.subject,
      "Subject Public Key Info": this.publicKey
    });
    if (this.attributes.length) {
      const o = new TextObject("");
      for (const c of this.attributes) {
        const l = c.toTextObject();
        o[l[TextObject.NAME]] = l;
      }
      n.Attributes = o;
    }
    return r.Data = n, r.Signature = new TextObject("", {
      Algorithm: TextConverter.serializeAlgorithm(a.signatureAlgorithm),
      "": a.signature
    }), r;
  }
}
Pkcs10CertificateRequest.NAME = "PKCS#10 Certificate Request";
class X509Certificates extends Array {
  constructor(r) {
    if (super(), PemData.isAsnEncoded(r))
      this.import(r);
    else if (r instanceof X509Certificate)
      this.push(r);
    else if (Array.isArray(r))
      for (const a of r)
        this.push(a);
  }
  export(r) {
    const a = new SignedData();
    a.version = 1, a.encapContentInfo.eContentType = id_data, a.encapContentInfo.eContent = new EncapsulatedContent({
      single: new OctetString()
    }), a.certificates = new CertificateSet(this.map((o) => new CertificateChoices({
      certificate: AsnConvert.parse(o.rawData, Certificate)
    })));
    const e = new ContentInfo({
      contentType: id_signedData,
      content: AsnConvert.serialize(a)
    }), n = AsnConvert.serialize(e);
    return r === "raw" ? n : this.toString(r);
  }
  import(r) {
    const a = PemData.toArrayBuffer(r), e = AsnConvert.parse(a, ContentInfo);
    if (e.contentType !== id_signedData)
      throw new TypeError("Cannot parse CMS package. Incoming data is not a SignedData object.");
    const n = AsnConvert.parse(e.content, SignedData);
    this.clear();
    for (const o of n.certificates || [])
      o.certificate && this.push(new X509Certificate(o.certificate));
  }
  clear() {
    for (; this.pop(); )
      ;
  }
  toString(r = "pem") {
    const a = this.export("raw");
    switch (r) {
      case "pem":
        return PemConverter.encode(a, "CMS");
      case "pem-chain":
        return this.map((e) => e.toString("pem")).join(`
`);
      case "asn":
        return AsnConvert.toString(a);
      case "hex":
        return Convert.ToHex(a);
      case "base64":
        return Convert.ToBase64(a);
      case "base64url":
        return Convert.ToBase64Url(a);
      case "text":
        return TextConverter.serialize(this.toTextObject());
      default:
        throw TypeError("Argument 'format' is unsupported value");
    }
  }
  toTextObject() {
    const r = AsnConvert.parse(this.export("raw"), ContentInfo), a = AsnConvert.parse(r.content, SignedData);
    return new TextObject("X509Certificates", {
      "Content Type": OidSerializer.toString(r.contentType),
      Content: new TextObject("", {
        Version: `${CMSVersion[a.version]} (${a.version})`,
        Certificates: new TextObject("", { Certificate: this.map((n) => n.toTextObject()) })
      })
    });
  }
}
class X509ChainBuilder {
  constructor(r = {}) {
    this.certificates = [], r.certificates && (this.certificates = r.certificates);
  }
  async build(r, a = cryptoProvider.get()) {
    const e = new X509Certificates(r);
    let n = r;
    for (; n = await this.findIssuer(n, a); ) {
      const o = await n.getThumbprint(a);
      for (const c of e) {
        const l = await c.getThumbprint(a);
        if (isEqual(o, l))
          throw new Error("Cannot build a certificate chain. Circular dependency.");
      }
      e.push(n);
    }
    return e;
  }
  async findIssuer(r, a = cryptoProvider.get()) {
    if (!await r.isSelfSigned(a)) {
      const e = r.getExtension(id_ce_authorityKeyIdentifier);
      for (const n of this.certificates)
        if (n.subject === r.issuer) {
          if (e) {
            if (e.keyId) {
              const o = n.getExtension(id_ce_subjectKeyIdentifier);
              if (o && o.keyId !== e.keyId)
                continue;
            } else if (e.certId) {
              const o = n.getExtension(id_ce_subjectAltName);
              if (o && !(e.certId.serialNumber === n.serialNumber && isEqual(AsnConvert.serialize(e.certId.name), AsnConvert.serialize(o))))
                continue;
            }
          }
          if (await r.verify({
            publicKey: await n.publicKey.export(a),
            signatureOnly: !0
          }, a))
            return n;
        }
    }
    return null;
  }
}
var X509CrlReason;
(function(u) {
  u[u.unspecified = 0] = "unspecified", u[u.keyCompromise = 1] = "keyCompromise", u[u.cACompromise = 2] = "cACompromise", u[u.affiliationChanged = 3] = "affiliationChanged", u[u.superseded = 4] = "superseded", u[u.cessationOfOperation = 5] = "cessationOfOperation", u[u.certificateHold = 6] = "certificateHold", u[u.removeFromCRL = 8] = "removeFromCRL", u[u.privilegeWithdrawn = 9] = "privilegeWithdrawn", u[u.aACompromise = 10] = "aACompromise";
})(X509CrlReason || (X509CrlReason = {}));
ExtensionFactory.register(id_ce_basicConstraints, BasicConstraintsExtension);
ExtensionFactory.register(id_ce_extKeyUsage, ExtendedKeyUsageExtension);
ExtensionFactory.register(id_ce_keyUsage, KeyUsagesExtension);
ExtensionFactory.register(id_ce_subjectKeyIdentifier, SubjectKeyIdentifierExtension);
ExtensionFactory.register(id_ce_authorityKeyIdentifier, AuthorityKeyIdentifierExtension);
ExtensionFactory.register(id_ce_subjectAltName, SubjectAlternativeNameExtension);
AttributeFactory.register(id_pkcs9_at_challengePassword, ChallengePasswordAttribute);
AttributeFactory.register(id_pkcs9_at_extensionRequest, ExtensionsAttribute);
instance.registerSingleton(diAsnSignatureFormatter, AsnDefaultSignatureFormatter);
instance.registerSingleton(diAsnSignatureFormatter, AsnEcSignatureFormatter);
AsnEcSignatureFormatter.namedCurveSize.set("P-256", 32);
AsnEcSignatureFormatter.namedCurveSize.set("K-256", 32);
AsnEcSignatureFormatter.namedCurveSize.set("P-384", 48);
AsnEcSignatureFormatter.namedCurveSize.set("P-521", 66);
var navigator$1 = {};
navigator$1.userAgent = !1;
var window$1 = {};
/*! CryptoJS v3.1.2 core-fix.js
 * code.google.com/p/crypto-js
 * (c) 2009-2013 by Jeff Mott. All rights reserved.
 * code.google.com/p/crypto-js/wiki/License
 * THIS IS FIX of 'core.js' to fix Hmac issue.
 * https://code.google.com/p/crypto-js/issues/detail?id=84
 * https://crypto-js.googlecode.com/svn-history/r667/branches/3.x/src/core.js
 */
var CryptoJS = CryptoJS || function(u, r) {
  var a = {}, e = a.lib = {}, n = e.Base = /* @__PURE__ */ function() {
    function y() {
    }
    return { extend: function(v) {
      y.prototype = this;
      var m = new y();
      return v && m.mixIn(v), m.hasOwnProperty("init") || (m.init = function() {
        m.$super.init.apply(this, arguments);
      }), m.init.prototype = m, m.$super = this, m;
    }, create: function() {
      var v = this.extend();
      return v.init.apply(v, arguments), v;
    }, init: function() {
    }, mixIn: function(v) {
      for (var m in v)
        v.hasOwnProperty(m) && (this[m] = v[m]);
      v.hasOwnProperty("toString") && (this.toString = v.toString);
    }, clone: function() {
      return this.init.prototype.extend(this);
    } };
  }(), o = e.WordArray = n.extend({ init: function(y, v) {
    y = this.words = y || [], v != r ? this.sigBytes = v : this.sigBytes = y.length * 4;
  }, toString: function(y) {
    return (y || l).stringify(this);
  }, concat: function(y) {
    var v = this.words, m = y.words, b = this.sigBytes, R = y.sigBytes;
    if (this.clamp(), b % 4)
      for (var $ = 0; $ < R; $++) {
        var x = m[$ >>> 2] >>> 24 - $ % 4 * 8 & 255;
        v[b + $ >>> 2] |= x << 24 - (b + $) % 4 * 8;
      }
    else
      for (var $ = 0; $ < R; $ += 4)
        v[b + $ >>> 2] = m[$ >>> 2];
    return this.sigBytes += R, this;
  }, clamp: function() {
    var y = this.words, v = this.sigBytes;
    y[v >>> 2] &= 4294967295 << 32 - v % 4 * 8, y.length = u.ceil(v / 4);
  }, clone: function() {
    var y = n.clone.call(this);
    return y.words = this.words.slice(0), y;
  }, random: function(y) {
    for (var v = [], m = 0; m < y; m += 4)
      v.push(u.random() * 4294967296 | 0);
    return new o.init(v, y);
  } }), c = a.enc = {}, l = c.Hex = { stringify: function(y) {
    for (var v = y.words, m = y.sigBytes, b = [], R = 0; R < m; R++) {
      var $ = v[R >>> 2] >>> 24 - R % 4 * 8 & 255;
      b.push(($ >>> 4).toString(16)), b.push(($ & 15).toString(16));
    }
    return b.join("");
  }, parse: function(y) {
    for (var v = y.length, m = [], b = 0; b < v; b += 2)
      m[b >>> 3] |= parseInt(y.substr(b, 2), 16) << 24 - b % 8 * 4;
    return new o.init(m, v / 2);
  } }, d = c.Latin1 = { stringify: function(y) {
    for (var v = y.words, m = y.sigBytes, b = [], R = 0; R < m; R++) {
      var $ = v[R >>> 2] >>> 24 - R % 4 * 8 & 255;
      b.push(String.fromCharCode($));
    }
    return b.join("");
  }, parse: function(y) {
    for (var v = y.length, m = [], b = 0; b < v; b++)
      m[b >>> 2] |= (y.charCodeAt(b) & 255) << 24 - b % 4 * 8;
    return new o.init(m, v);
  } }, p = c.Utf8 = { stringify: function(y) {
    try {
      return decodeURIComponent(escape(d.stringify(y)));
    } catch {
      throw new Error("Malformed UTF-8 data");
    }
  }, parse: function(y) {
    return d.parse(unescape(encodeURIComponent(y)));
  } }, h = e.BufferedBlockAlgorithm = n.extend({ reset: function() {
    this._data = new o.init(), this._nDataBytes = 0;
  }, _append: function(y) {
    typeof y == "string" && (y = p.parse(y)), this._data.concat(y), this._nDataBytes += y.sigBytes;
  }, _process: function(y) {
    var v = this._data, m = v.words, b = v.sigBytes, R = this.blockSize, $ = R * 4, x = b / $;
    y ? x = u.ceil(x) : x = u.max((x | 0) - this._minBufferSize, 0);
    var E = x * R, T = u.min(E * 4, b);
    if (E) {
      for (var P = 0; P < E; P += R)
        this._doProcessBlock(m, P);
      var O = m.splice(0, E);
      v.sigBytes -= T;
    }
    return new o.init(O, T);
  }, clone: function() {
    var y = n.clone.call(this);
    return y._data = this._data.clone(), y;
  }, _minBufferSize: 0 });
  e.Hasher = h.extend({ cfg: n.extend(), init: function(y) {
    this.cfg = this.cfg.extend(y), this.reset();
  }, reset: function() {
    h.reset.call(this), this._doReset();
  }, update: function(y) {
    return this._append(y), this._process(), this;
  }, finalize: function(y) {
    y && this._append(y);
    var v = this._doFinalize();
    return v;
  }, blockSize: 512 / 32, _createHelper: function(y) {
    return function(v, m) {
      return new y.init(m).finalize(v);
    };
  }, _createHmacHelper: function(y) {
    return function(v, m) {
      return new g.HMAC.init(y, m).finalize(v);
    };
  } });
  var g = a.algo = {};
  return a;
}(Math);
(function(u) {
  var n = CryptoJS, r = n.lib, a = r.Base, e = r.WordArray, n = n.x64 = {};
  n.Word = a.extend({ init: function(o, c) {
    this.high = o, this.low = c;
  } }), n.WordArray = a.extend({ init: function(o, c) {
    o = this.words = o || [], this.sigBytes = c != u ? c : 8 * o.length;
  }, toX32: function() {
    for (var o = this.words, c = o.length, l = [], d = 0; d < c; d++) {
      var p = o[d];
      l.push(p.high), l.push(p.low);
    }
    return e.create(l, this.sigBytes);
  }, clone: function() {
    for (var o = a.clone.call(this), c = o.words = this.words.slice(0), l = c.length, d = 0; d < l; d++)
      c[d] = c[d].clone();
    return o;
  } });
})();
CryptoJS.lib.Cipher || function(u) {
  var v = CryptoJS, r = v.lib, a = r.Base, e = r.WordArray, n = r.BufferedBlockAlgorithm, o = v.enc.Base64, c = v.algo.EvpKDF, l = r.Cipher = n.extend({ cfg: a.extend(), createEncryptor: function(b, R) {
    return this.create(this._ENC_XFORM_MODE, b, R);
  }, createDecryptor: function(b, R) {
    return this.create(this._DEC_XFORM_MODE, b, R);
  }, init: function(b, R, $) {
    this.cfg = this.cfg.extend($), this._xformMode = b, this._key = R, this.reset();
  }, reset: function() {
    n.reset.call(this), this._doReset();
  }, process: function(b) {
    return this._append(b), this._process();
  }, finalize: function(b) {
    return b && this._append(b), this._doFinalize();
  }, keySize: 4, ivSize: 4, _ENC_XFORM_MODE: 1, _DEC_XFORM_MODE: 2, _createHelper: function(b) {
    return { encrypt: function(R, $, x) {
      return (typeof $ == "string" ? m : y).encrypt(b, R, $, x);
    }, decrypt: function(R, $, x) {
      return (typeof $ == "string" ? m : y).decrypt(b, R, $, x);
    } };
  } });
  r.StreamCipher = l.extend({ _doFinalize: function() {
    return this._process(!0);
  }, blockSize: 1 });
  var g = v.mode = {}, d = function(b, R, $) {
    var x = this._iv;
    x ? this._iv = u : x = this._prevBlock;
    for (var E = 0; E < $; E++)
      b[R + E] ^= x[E];
  }, p = (r.BlockCipherMode = a.extend({ createEncryptor: function(b, R) {
    return this.Encryptor.create(b, R);
  }, createDecryptor: function(b, R) {
    return this.Decryptor.create(b, R);
  }, init: function(b, R) {
    this._cipher = b, this._iv = R;
  } })).extend();
  p.Encryptor = p.extend({ processBlock: function(b, R) {
    var $ = this._cipher, x = $.blockSize;
    d.call(this, b, R, x), $.encryptBlock(b, R), this._prevBlock = b.slice(R, R + x);
  } }), p.Decryptor = p.extend({ processBlock: function(b, R) {
    var $ = this._cipher, x = $.blockSize, E = b.slice(R, R + x);
    $.decryptBlock(
      b,
      R
    ), d.call(this, b, R, x), this._prevBlock = E;
  } }), g = g.CBC = p, p = (v.pad = {}).Pkcs7 = { pad: function(b, R) {
    for (var $ = 4 * R, $ = $ - b.sigBytes % $, x = $ << 24 | $ << 16 | $ << 8 | $, E = [], T = 0; T < $; T += 4)
      E.push(x);
    $ = e.create(E, $), b.concat($);
  }, unpad: function(b) {
    b.sigBytes -= b.words[b.sigBytes - 1 >>> 2] & 255;
  } }, r.BlockCipher = l.extend({ cfg: l.cfg.extend({ mode: g, padding: p }), reset: function() {
    l.reset.call(this);
    var R = this.cfg, b = R.iv, R = R.mode;
    if (this._xformMode == this._ENC_XFORM_MODE)
      var $ = R.createEncryptor;
    else
      $ = R.createDecryptor, this._minBufferSize = 1;
    this._mode = $.call(R, this, b && b.words);
  }, _doProcessBlock: function(b, R) {
    this._mode.processBlock(b, R);
  }, _doFinalize: function() {
    var b = this.cfg.padding;
    if (this._xformMode == this._ENC_XFORM_MODE) {
      b.pad(this._data, this.blockSize);
      var R = this._process(!0);
    } else
      R = this._process(!0), b.unpad(R);
    return R;
  }, blockSize: 4 });
  var h = r.CipherParams = a.extend({ init: function(b) {
    this.mixIn(b);
  }, toString: function(b) {
    return (b || this.formatter).stringify(this);
  } }), g = (v.format = {}).OpenSSL = { stringify: function(b) {
    var R = b.ciphertext;
    return b = b.salt, (b ? e.create([1398893684, 1701076831]).concat(b).concat(R) : R).toString(o);
  }, parse: function(b) {
    b = o.parse(b);
    var R = b.words;
    if (R[0] == 1398893684 && R[1] == 1701076831) {
      var $ = e.create(R.slice(2, 4));
      R.splice(0, 4), b.sigBytes -= 16;
    }
    return h.create({ ciphertext: b, salt: $ });
  } }, y = r.SerializableCipher = a.extend({ cfg: a.extend({ format: g }), encrypt: function(b, R, $, x) {
    x = this.cfg.extend(x);
    var E = b.createEncryptor($, x);
    return R = E.finalize(R), E = E.cfg, h.create({
      ciphertext: R,
      key: $,
      iv: E.iv,
      algorithm: b,
      mode: E.mode,
      padding: E.padding,
      blockSize: b.blockSize,
      formatter: x.format
    });
  }, decrypt: function(b, R, $, x) {
    return x = this.cfg.extend(x), R = this._parse(R, x.format), b.createDecryptor($, x).finalize(R.ciphertext);
  }, _parse: function(b, R) {
    return typeof b == "string" ? R.parse(b, this) : b;
  } }), v = (v.kdf = {}).OpenSSL = { execute: function(b, R, $, x) {
    return x || (x = e.random(8)), b = c.create({ keySize: R + $ }).compute(b, x), $ = e.create(b.words.slice(R), 4 * $), b.sigBytes = 4 * R, h.create({ key: b, iv: $, salt: x });
  } }, m = r.PasswordBasedCipher = y.extend({ cfg: y.cfg.extend({ kdf: v }), encrypt: function(b, R, $, x) {
    return x = this.cfg.extend(x), $ = x.kdf.execute($, b.keySize, b.ivSize), x.iv = $.iv, b = y.encrypt.call(this, b, R, $.key, x), b.mixIn($), b;
  }, decrypt: function(b, R, $, x) {
    return x = this.cfg.extend(x), R = this._parse(R, x.format), $ = x.kdf.execute($, b.keySize, b.ivSize, R.salt), x.iv = $.iv, y.decrypt.call(this, b, R, $.key, x);
  } });
}();
(function() {
  for (var u = CryptoJS, r = u.lib.BlockCipher, O = u.algo, a = [], e = [], n = [], o = [], c = [], l = [], d = [], p = [], h = [], g = [], y = [], v = 0; 256 > v; v++)
    y[v] = 128 > v ? v << 1 : v << 1 ^ 283;
  for (var m = 0, b = 0, v = 0; 256 > v; v++) {
    var R = b ^ b << 1 ^ b << 2 ^ b << 3 ^ b << 4, R = R >>> 8 ^ R & 255 ^ 99;
    a[m] = R, e[R] = m;
    var $ = y[m], x = y[$], E = y[x], T = 257 * y[R] ^ 16843008 * R;
    n[m] = T << 24 | T >>> 8, o[m] = T << 16 | T >>> 16, c[m] = T << 8 | T >>> 24, l[m] = T, T = 16843009 * E ^ 65537 * x ^ 257 * $ ^ 16843008 * m, d[R] = T << 24 | T >>> 8, p[R] = T << 16 | T >>> 16, h[R] = T << 8 | T >>> 24, g[R] = T, m ? (m = $ ^ y[y[y[E ^ $]]], b ^= y[y[b]]) : m = b = 1;
  }
  var P = [
    0,
    1,
    2,
    4,
    8,
    16,
    32,
    64,
    128,
    27,
    54
  ], O = O.AES = r.extend({ _doReset: function() {
    for (var C = this._key, w = C.words, _ = C.sigBytes / 4, C = 4 * ((this._nRounds = _ + 6) + 1), k = this._keySchedule = [], B = 0; B < C; B++)
      if (B < _)
        k[B] = w[B];
      else {
        var j = k[B - 1];
        B % _ ? 6 < _ && B % _ == 4 && (j = a[j >>> 24] << 24 | a[j >>> 16 & 255] << 16 | a[j >>> 8 & 255] << 8 | a[j & 255]) : (j = j << 8 | j >>> 24, j = a[j >>> 24] << 24 | a[j >>> 16 & 255] << 16 | a[j >>> 8 & 255] << 8 | a[j & 255], j ^= P[B / _ | 0] << 24), k[B] = k[B - _] ^ j;
      }
    for (w = this._invKeySchedule = [], _ = 0; _ < C; _++)
      B = C - _, j = _ % 4 ? k[B] : k[B - 4], w[_] = 4 > _ || 4 >= B ? j : d[a[j >>> 24]] ^ p[a[j >>> 16 & 255]] ^ h[a[j >>> 8 & 255]] ^ g[a[j & 255]];
  }, encryptBlock: function(w, _) {
    this._doCryptBlock(w, _, this._keySchedule, n, o, c, l, a);
  }, decryptBlock: function(w, _) {
    var C = w[_ + 1];
    w[_ + 1] = w[_ + 3], w[_ + 3] = C, this._doCryptBlock(w, _, this._invKeySchedule, d, p, h, g, e), C = w[_ + 1], w[_ + 1] = w[_ + 3], w[_ + 3] = C;
  }, _doCryptBlock: function(w, _, C, k, B, j, J, N) {
    for (var F = this._nRounds, ae = w[_] ^ C[0], fe = w[_ + 1] ^ C[1], ee = w[_ + 2] ^ C[2], W = w[_ + 3] ^ C[3], U = 4, K = 1; K < F; K++)
      var ve = k[ae >>> 24] ^ B[fe >>> 16 & 255] ^ j[ee >>> 8 & 255] ^ J[W & 255] ^ C[U++], he = k[fe >>> 24] ^ B[ee >>> 16 & 255] ^ j[W >>> 8 & 255] ^ J[ae & 255] ^ C[U++], te = k[ee >>> 24] ^ B[W >>> 16 & 255] ^ j[ae >>> 8 & 255] ^ J[fe & 255] ^ C[U++], W = k[W >>> 24] ^ B[ae >>> 16 & 255] ^ j[fe >>> 8 & 255] ^ J[ee & 255] ^ C[U++], ae = ve, fe = he, ee = te;
    ve = (N[ae >>> 24] << 24 | N[fe >>> 16 & 255] << 16 | N[ee >>> 8 & 255] << 8 | N[W & 255]) ^ C[U++], he = (N[fe >>> 24] << 24 | N[ee >>> 16 & 255] << 16 | N[W >>> 8 & 255] << 8 | N[ae & 255]) ^ C[U++], te = (N[ee >>> 24] << 24 | N[W >>> 16 & 255] << 16 | N[ae >>> 8 & 255] << 8 | N[fe & 255]) ^ C[U++], W = (N[W >>> 24] << 24 | N[ae >>> 16 & 255] << 16 | N[fe >>> 8 & 255] << 8 | N[ee & 255]) ^ C[U++], w[_] = ve, w[_ + 1] = he, w[_ + 2] = te, w[_ + 3] = W;
  }, keySize: 8 });
  u.AES = r._createHelper(O);
})();
(function() {
  function u(y, v) {
    var m = (this._lBlock >>> y ^ this._rBlock) & v;
    this._rBlock ^= m, this._lBlock ^= m << y;
  }
  function r(y, v) {
    var m = (this._rBlock >>> y ^ this._lBlock) & v;
    this._lBlock ^= m, this._rBlock ^= m << y;
  }
  var a = CryptoJS, n = a.lib, e = n.WordArray, n = n.BlockCipher, o = a.algo, c = [57, 49, 41, 33, 25, 17, 9, 1, 58, 50, 42, 34, 26, 18, 10, 2, 59, 51, 43, 35, 27, 19, 11, 3, 60, 52, 44, 36, 63, 55, 47, 39, 31, 23, 15, 7, 62, 54, 46, 38, 30, 22, 14, 6, 61, 53, 45, 37, 29, 21, 13, 5, 28, 20, 12, 4], l = [
    14,
    17,
    11,
    24,
    1,
    5,
    3,
    28,
    15,
    6,
    21,
    10,
    23,
    19,
    12,
    4,
    26,
    8,
    16,
    7,
    27,
    20,
    13,
    2,
    41,
    52,
    31,
    37,
    47,
    55,
    30,
    40,
    51,
    45,
    33,
    48,
    44,
    49,
    39,
    56,
    34,
    53,
    46,
    42,
    50,
    36,
    29,
    32
  ], d = [1, 2, 4, 6, 8, 10, 12, 14, 15, 17, 19, 21, 23, 25, 27, 28], p = [{
    0: 8421888,
    268435456: 32768,
    536870912: 8421378,
    805306368: 2,
    1073741824: 512,
    1342177280: 8421890,
    1610612736: 8389122,
    1879048192: 8388608,
    2147483648: 514,
    2415919104: 8389120,
    2684354560: 33280,
    2952790016: 8421376,
    3221225472: 32770,
    3489660928: 8388610,
    3758096384: 0,
    4026531840: 33282,
    134217728: 0,
    402653184: 8421890,
    671088640: 33282,
    939524096: 32768,
    1207959552: 8421888,
    1476395008: 512,
    1744830464: 8421378,
    2013265920: 2,
    2281701376: 8389120,
    2550136832: 33280,
    2818572288: 8421376,
    3087007744: 8389122,
    3355443200: 8388610,
    3623878656: 32770,
    3892314112: 514,
    4160749568: 8388608,
    1: 32768,
    268435457: 2,
    536870913: 8421888,
    805306369: 8388608,
    1073741825: 8421378,
    1342177281: 33280,
    1610612737: 512,
    1879048193: 8389122,
    2147483649: 8421890,
    2415919105: 8421376,
    2684354561: 8388610,
    2952790017: 33282,
    3221225473: 514,
    3489660929: 8389120,
    3758096385: 32770,
    4026531841: 0,
    134217729: 8421890,
    402653185: 8421376,
    671088641: 8388608,
    939524097: 512,
    1207959553: 32768,
    1476395009: 8388610,
    1744830465: 2,
    2013265921: 33282,
    2281701377: 32770,
    2550136833: 8389122,
    2818572289: 514,
    3087007745: 8421888,
    3355443201: 8389120,
    3623878657: 0,
    3892314113: 33280,
    4160749569: 8421378
  }, {
    0: 1074282512,
    16777216: 16384,
    33554432: 524288,
    50331648: 1074266128,
    67108864: 1073741840,
    83886080: 1074282496,
    100663296: 1073758208,
    117440512: 16,
    134217728: 540672,
    150994944: 1073758224,
    167772160: 1073741824,
    184549376: 540688,
    201326592: 524304,
    218103808: 0,
    234881024: 16400,
    251658240: 1074266112,
    8388608: 1073758208,
    25165824: 540688,
    41943040: 16,
    58720256: 1073758224,
    75497472: 1074282512,
    92274688: 1073741824,
    109051904: 524288,
    125829120: 1074266128,
    142606336: 524304,
    159383552: 0,
    176160768: 16384,
    192937984: 1074266112,
    209715200: 1073741840,
    226492416: 540672,
    243269632: 1074282496,
    260046848: 16400,
    268435456: 0,
    285212672: 1074266128,
    301989888: 1073758224,
    318767104: 1074282496,
    335544320: 1074266112,
    352321536: 16,
    369098752: 540688,
    385875968: 16384,
    402653184: 16400,
    419430400: 524288,
    436207616: 524304,
    452984832: 1073741840,
    469762048: 540672,
    486539264: 1073758208,
    503316480: 1073741824,
    520093696: 1074282512,
    276824064: 540688,
    293601280: 524288,
    310378496: 1074266112,
    327155712: 16384,
    343932928: 1073758208,
    360710144: 1074282512,
    377487360: 16,
    394264576: 1073741824,
    411041792: 1074282496,
    427819008: 1073741840,
    444596224: 1073758224,
    461373440: 524304,
    478150656: 0,
    494927872: 16400,
    511705088: 1074266128,
    528482304: 540672
  }, {
    0: 260,
    1048576: 0,
    2097152: 67109120,
    3145728: 65796,
    4194304: 65540,
    5242880: 67108868,
    6291456: 67174660,
    7340032: 67174400,
    8388608: 67108864,
    9437184: 67174656,
    10485760: 65792,
    11534336: 67174404,
    12582912: 67109124,
    13631488: 65536,
    14680064: 4,
    15728640: 256,
    524288: 67174656,
    1572864: 67174404,
    2621440: 0,
    3670016: 67109120,
    4718592: 67108868,
    5767168: 65536,
    6815744: 65540,
    7864320: 260,
    8912896: 4,
    9961472: 256,
    11010048: 67174400,
    12058624: 65796,
    13107200: 65792,
    14155776: 67109124,
    15204352: 67174660,
    16252928: 67108864,
    16777216: 67174656,
    17825792: 65540,
    18874368: 65536,
    19922944: 67109120,
    20971520: 256,
    22020096: 67174660,
    23068672: 67108868,
    24117248: 0,
    25165824: 67109124,
    26214400: 67108864,
    27262976: 4,
    28311552: 65792,
    29360128: 67174400,
    30408704: 260,
    31457280: 65796,
    32505856: 67174404,
    17301504: 67108864,
    18350080: 260,
    19398656: 67174656,
    20447232: 0,
    21495808: 65540,
    22544384: 67109120,
    23592960: 256,
    24641536: 67174404,
    25690112: 65536,
    26738688: 67174660,
    27787264: 65796,
    28835840: 67108868,
    29884416: 67109124,
    30932992: 67174400,
    31981568: 4,
    33030144: 65792
  }, {
    0: 2151682048,
    65536: 2147487808,
    131072: 4198464,
    196608: 2151677952,
    262144: 0,
    327680: 4198400,
    393216: 2147483712,
    458752: 4194368,
    524288: 2147483648,
    589824: 4194304,
    655360: 64,
    720896: 2147487744,
    786432: 2151678016,
    851968: 4160,
    917504: 4096,
    983040: 2151682112,
    32768: 2147487808,
    98304: 64,
    163840: 2151678016,
    229376: 2147487744,
    294912: 4198400,
    360448: 2151682112,
    425984: 0,
    491520: 2151677952,
    557056: 4096,
    622592: 2151682048,
    688128: 4194304,
    753664: 4160,
    819200: 2147483648,
    884736: 4194368,
    950272: 4198464,
    1015808: 2147483712,
    1048576: 4194368,
    1114112: 4198400,
    1179648: 2147483712,
    1245184: 0,
    1310720: 4160,
    1376256: 2151678016,
    1441792: 2151682048,
    1507328: 2147487808,
    1572864: 2151682112,
    1638400: 2147483648,
    1703936: 2151677952,
    1769472: 4198464,
    1835008: 2147487744,
    1900544: 4194304,
    1966080: 64,
    2031616: 4096,
    1081344: 2151677952,
    1146880: 2151682112,
    1212416: 0,
    1277952: 4198400,
    1343488: 4194368,
    1409024: 2147483648,
    1474560: 2147487808,
    1540096: 64,
    1605632: 2147483712,
    1671168: 4096,
    1736704: 2147487744,
    1802240: 2151678016,
    1867776: 4160,
    1933312: 2151682048,
    1998848: 4194304,
    2064384: 4198464
  }, {
    0: 128,
    4096: 17039360,
    8192: 262144,
    12288: 536870912,
    16384: 537133184,
    20480: 16777344,
    24576: 553648256,
    28672: 262272,
    32768: 16777216,
    36864: 537133056,
    40960: 536871040,
    45056: 553910400,
    49152: 553910272,
    53248: 0,
    57344: 17039488,
    61440: 553648128,
    2048: 17039488,
    6144: 553648256,
    10240: 128,
    14336: 17039360,
    18432: 262144,
    22528: 537133184,
    26624: 553910272,
    30720: 536870912,
    34816: 537133056,
    38912: 0,
    43008: 553910400,
    47104: 16777344,
    51200: 536871040,
    55296: 553648128,
    59392: 16777216,
    63488: 262272,
    65536: 262144,
    69632: 128,
    73728: 536870912,
    77824: 553648256,
    81920: 16777344,
    86016: 553910272,
    90112: 537133184,
    94208: 16777216,
    98304: 553910400,
    102400: 553648128,
    106496: 17039360,
    110592: 537133056,
    114688: 262272,
    118784: 536871040,
    122880: 0,
    126976: 17039488,
    67584: 553648256,
    71680: 16777216,
    75776: 17039360,
    79872: 537133184,
    83968: 536870912,
    88064: 17039488,
    92160: 128,
    96256: 553910272,
    100352: 262272,
    104448: 553910400,
    108544: 0,
    112640: 553648128,
    116736: 16777344,
    120832: 262144,
    124928: 537133056,
    129024: 536871040
  }, {
    0: 268435464,
    256: 8192,
    512: 270532608,
    768: 270540808,
    1024: 268443648,
    1280: 2097152,
    1536: 2097160,
    1792: 268435456,
    2048: 0,
    2304: 268443656,
    2560: 2105344,
    2816: 8,
    3072: 270532616,
    3328: 2105352,
    3584: 8200,
    3840: 270540800,
    128: 270532608,
    384: 270540808,
    640: 8,
    896: 2097152,
    1152: 2105352,
    1408: 268435464,
    1664: 268443648,
    1920: 8200,
    2176: 2097160,
    2432: 8192,
    2688: 268443656,
    2944: 270532616,
    3200: 0,
    3456: 270540800,
    3712: 2105344,
    3968: 268435456,
    4096: 268443648,
    4352: 270532616,
    4608: 270540808,
    4864: 8200,
    5120: 2097152,
    5376: 268435456,
    5632: 268435464,
    5888: 2105344,
    6144: 2105352,
    6400: 0,
    6656: 8,
    6912: 270532608,
    7168: 8192,
    7424: 268443656,
    7680: 270540800,
    7936: 2097160,
    4224: 8,
    4480: 2105344,
    4736: 2097152,
    4992: 268435464,
    5248: 268443648,
    5504: 8200,
    5760: 270540808,
    6016: 270532608,
    6272: 270540800,
    6528: 270532616,
    6784: 8192,
    7040: 2105352,
    7296: 2097160,
    7552: 0,
    7808: 268435456,
    8064: 268443656
  }, {
    0: 1048576,
    16: 33555457,
    32: 1024,
    48: 1049601,
    64: 34604033,
    80: 0,
    96: 1,
    112: 34603009,
    128: 33555456,
    144: 1048577,
    160: 33554433,
    176: 34604032,
    192: 34603008,
    208: 1025,
    224: 1049600,
    240: 33554432,
    8: 34603009,
    24: 0,
    40: 33555457,
    56: 34604032,
    72: 1048576,
    88: 33554433,
    104: 33554432,
    120: 1025,
    136: 1049601,
    152: 33555456,
    168: 34603008,
    184: 1048577,
    200: 1024,
    216: 34604033,
    232: 1,
    248: 1049600,
    256: 33554432,
    272: 1048576,
    288: 33555457,
    304: 34603009,
    320: 1048577,
    336: 33555456,
    352: 34604032,
    368: 1049601,
    384: 1025,
    400: 34604033,
    416: 1049600,
    432: 1,
    448: 0,
    464: 34603008,
    480: 33554433,
    496: 1024,
    264: 1049600,
    280: 33555457,
    296: 34603009,
    312: 1,
    328: 33554432,
    344: 1048576,
    360: 1025,
    376: 34604032,
    392: 33554433,
    408: 34603008,
    424: 0,
    440: 34604033,
    456: 1049601,
    472: 1024,
    488: 33555456,
    504: 1048577
  }, {
    0: 134219808,
    1: 131072,
    2: 134217728,
    3: 32,
    4: 131104,
    5: 134350880,
    6: 134350848,
    7: 2048,
    8: 134348800,
    9: 134219776,
    10: 133120,
    11: 134348832,
    12: 2080,
    13: 0,
    14: 134217760,
    15: 133152,
    2147483648: 2048,
    2147483649: 134350880,
    2147483650: 134219808,
    2147483651: 134217728,
    2147483652: 134348800,
    2147483653: 133120,
    2147483654: 133152,
    2147483655: 32,
    2147483656: 134217760,
    2147483657: 2080,
    2147483658: 131104,
    2147483659: 134350848,
    2147483660: 0,
    2147483661: 134348832,
    2147483662: 134219776,
    2147483663: 131072,
    16: 133152,
    17: 134350848,
    18: 32,
    19: 2048,
    20: 134219776,
    21: 134217760,
    22: 134348832,
    23: 131072,
    24: 0,
    25: 131104,
    26: 134348800,
    27: 134219808,
    28: 134350880,
    29: 133120,
    30: 2080,
    31: 134217728,
    2147483664: 131072,
    2147483665: 2048,
    2147483666: 134348832,
    2147483667: 133152,
    2147483668: 32,
    2147483669: 134348800,
    2147483670: 134217728,
    2147483671: 134219808,
    2147483672: 134350880,
    2147483673: 134217760,
    2147483674: 134219776,
    2147483675: 0,
    2147483676: 133120,
    2147483677: 2080,
    2147483678: 131104,
    2147483679: 134350848
  }], h = [4160749569, 528482304, 33030144, 2064384, 129024, 8064, 504, 2147483679], g = o.DES = n.extend({ _doReset: function() {
    for (var y = this._key.words, v = [], m = 0; 56 > m; m++) {
      var b = c[m] - 1;
      v[m] = y[b >>> 5] >>> 31 - b % 32 & 1;
    }
    for (y = this._subKeys = [], b = 0; 16 > b; b++) {
      for (var R = y[b] = [], $ = d[b], m = 0; 24 > m; m++)
        R[m / 6 | 0] |= v[(l[m] - 1 + $) % 28] << 31 - m % 6, R[4 + (m / 6 | 0)] |= v[28 + (l[m + 24] - 1 + $) % 28] << 31 - m % 6;
      for (R[0] = R[0] << 1 | R[0] >>> 31, m = 1; 7 > m; m++)
        R[m] >>>= 4 * (m - 1) + 3;
      R[7] = R[7] << 5 | R[7] >>> 27;
    }
    for (v = this._invSubKeys = [], m = 0; 16 > m; m++)
      v[m] = y[15 - m];
  }, encryptBlock: function(y, v) {
    this._doCryptBlock(y, v, this._subKeys);
  }, decryptBlock: function(y, v) {
    this._doCryptBlock(y, v, this._invSubKeys);
  }, _doCryptBlock: function(y, v, m) {
    this._lBlock = y[v], this._rBlock = y[v + 1], u.call(this, 4, 252645135), u.call(this, 16, 65535), r.call(this, 2, 858993459), r.call(this, 8, 16711935), u.call(this, 1, 1431655765);
    for (var b = 0; 16 > b; b++) {
      for (var R = m[b], $ = this._lBlock, x = this._rBlock, E = 0, T = 0; 8 > T; T++)
        E |= p[T][((x ^ R[T]) & h[T]) >>> 0];
      this._lBlock = x, this._rBlock = $ ^ E;
    }
    m = this._lBlock, this._lBlock = this._rBlock, this._rBlock = m, u.call(this, 1, 1431655765), r.call(this, 8, 16711935), r.call(this, 2, 858993459), u.call(this, 16, 65535), u.call(this, 4, 252645135), y[v] = this._lBlock, y[v + 1] = this._rBlock;
  }, keySize: 2, ivSize: 2, blockSize: 2 });
  a.DES = n._createHelper(g), o = o.TripleDES = n.extend({ _doReset: function() {
    var y = this._key.words;
    this._des1 = g.createEncryptor(e.create(y.slice(0, 2))), this._des2 = g.createEncryptor(e.create(y.slice(2, 4))), this._des3 = g.createEncryptor(e.create(y.slice(4, 6)));
  }, encryptBlock: function(y, v) {
    this._des1.encryptBlock(y, v), this._des2.decryptBlock(y, v), this._des3.encryptBlock(y, v);
  }, decryptBlock: function(y, v) {
    this._des3.decryptBlock(y, v), this._des2.encryptBlock(y, v), this._des1.decryptBlock(y, v);
  }, keySize: 6, ivSize: 2, blockSize: 2 }), a.TripleDES = n._createHelper(o);
})();
(function() {
  var u = CryptoJS, r = u.lib.WordArray;
  u.enc.Base64 = { stringify: function(a) {
    var e = a.words, n = a.sigBytes, o = this._map;
    a.clamp(), a = [];
    for (var c = 0; c < n; c += 3)
      for (var l = (e[c >>> 2] >>> 24 - 8 * (c % 4) & 255) << 16 | (e[c + 1 >>> 2] >>> 24 - 8 * ((c + 1) % 4) & 255) << 8 | e[c + 2 >>> 2] >>> 24 - 8 * ((c + 2) % 4) & 255, d = 0; 4 > d && c + 0.75 * d < n; d++)
        a.push(o.charAt(l >>> 6 * (3 - d) & 63));
    if (e = o.charAt(64))
      for (; a.length % 4; )
        a.push(e);
    return a.join("");
  }, parse: function(a) {
    var e = a.length, n = this._map, o = n.charAt(64);
    o && (o = a.indexOf(o), o != -1 && (e = o));
    for (var o = [], c = 0, l = 0; l < e; l++)
      if (l % 4) {
        var d = n.indexOf(a.charAt(l - 1)) << 2 * (l % 4), p = n.indexOf(a.charAt(l)) >>> 6 - 2 * (l % 4);
        o[c >>> 2] |= (d | p) << 24 - 8 * (c % 4), c++;
      }
    return r.create(o, c);
  }, _map: "ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789+/=" };
})();
(function(u) {
  function r(g, y, v, m, b, R, $) {
    return g = g + (y & v | ~y & m) + b + $, (g << R | g >>> 32 - R) + y;
  }
  function a(g, y, v, m, b, R, $) {
    return g = g + (y & m | v & ~m) + b + $, (g << R | g >>> 32 - R) + y;
  }
  function e(g, y, v, m, b, R, $) {
    return g = g + (y ^ v ^ m) + b + $, (g << R | g >>> 32 - R) + y;
  }
  function n(g, y, v, m, b, R, $) {
    return g = g + (v ^ (y | ~m)) + b + $, (g << R | g >>> 32 - R) + y;
  }
  for (var o = CryptoJS, d = o.lib, c = d.WordArray, l = d.Hasher, d = o.algo, p = [], h = 0; 64 > h; h++)
    p[h] = 4294967296 * u.abs(u.sin(h + 1)) | 0;
  d = d.MD5 = l.extend({
    _doReset: function() {
      this._hash = new c.init([1732584193, 4023233417, 2562383102, 271733878]);
    },
    _doProcessBlock: function(g, y) {
      for (var v = 0; 16 > v; v++) {
        var m = y + v, b = g[m];
        g[m] = (b << 8 | b >>> 24) & 16711935 | (b << 24 | b >>> 8) & 4278255360;
      }
      var v = this._hash.words, m = g[y + 0], b = g[y + 1], R = g[y + 2], $ = g[y + 3], x = g[y + 4], E = g[y + 5], T = g[y + 6], P = g[y + 7], O = g[y + 8], w = g[y + 9], _ = g[y + 10], C = g[y + 11], k = g[y + 12], B = g[y + 13], j = g[y + 14], J = g[y + 15], N = v[0], K = v[1], U = v[2], F = v[3], N = r(N, K, U, F, m, 7, p[0]), F = r(F, N, K, U, b, 12, p[1]), U = r(U, F, N, K, R, 17, p[2]), K = r(K, U, F, N, $, 22, p[3]), N = r(N, K, U, F, x, 7, p[4]), F = r(F, N, K, U, E, 12, p[5]), U = r(U, F, N, K, T, 17, p[6]), K = r(K, U, F, N, P, 22, p[7]), N = r(N, K, U, F, O, 7, p[8]), F = r(F, N, K, U, w, 12, p[9]), U = r(U, F, N, K, _, 17, p[10]), K = r(K, U, F, N, C, 22, p[11]), N = r(N, K, U, F, k, 7, p[12]), F = r(F, N, K, U, B, 12, p[13]), U = r(U, F, N, K, j, 17, p[14]), K = r(K, U, F, N, J, 22, p[15]), N = a(N, K, U, F, b, 5, p[16]), F = a(F, N, K, U, T, 9, p[17]), U = a(U, F, N, K, C, 14, p[18]), K = a(K, U, F, N, m, 20, p[19]), N = a(N, K, U, F, E, 5, p[20]), F = a(F, N, K, U, _, 9, p[21]), U = a(U, F, N, K, J, 14, p[22]), K = a(K, U, F, N, x, 20, p[23]), N = a(N, K, U, F, w, 5, p[24]), F = a(F, N, K, U, j, 9, p[25]), U = a(U, F, N, K, $, 14, p[26]), K = a(K, U, F, N, O, 20, p[27]), N = a(N, K, U, F, B, 5, p[28]), F = a(
        F,
        N,
        K,
        U,
        R,
        9,
        p[29]
      ), U = a(U, F, N, K, P, 14, p[30]), K = a(K, U, F, N, k, 20, p[31]), N = e(N, K, U, F, E, 4, p[32]), F = e(F, N, K, U, O, 11, p[33]), U = e(U, F, N, K, C, 16, p[34]), K = e(K, U, F, N, j, 23, p[35]), N = e(N, K, U, F, b, 4, p[36]), F = e(F, N, K, U, x, 11, p[37]), U = e(U, F, N, K, P, 16, p[38]), K = e(K, U, F, N, _, 23, p[39]), N = e(N, K, U, F, B, 4, p[40]), F = e(F, N, K, U, m, 11, p[41]), U = e(U, F, N, K, $, 16, p[42]), K = e(K, U, F, N, T, 23, p[43]), N = e(N, K, U, F, w, 4, p[44]), F = e(F, N, K, U, k, 11, p[45]), U = e(U, F, N, K, J, 16, p[46]), K = e(K, U, F, N, R, 23, p[47]), N = n(N, K, U, F, m, 6, p[48]), F = n(F, N, K, U, P, 10, p[49]), U = n(
        U,
        F,
        N,
        K,
        j,
        15,
        p[50]
      ), K = n(K, U, F, N, E, 21, p[51]), N = n(N, K, U, F, k, 6, p[52]), F = n(F, N, K, U, $, 10, p[53]), U = n(U, F, N, K, _, 15, p[54]), K = n(K, U, F, N, b, 21, p[55]), N = n(N, K, U, F, O, 6, p[56]), F = n(F, N, K, U, J, 10, p[57]), U = n(U, F, N, K, T, 15, p[58]), K = n(K, U, F, N, B, 21, p[59]), N = n(N, K, U, F, x, 6, p[60]), F = n(F, N, K, U, C, 10, p[61]), U = n(U, F, N, K, R, 15, p[62]), K = n(K, U, F, N, w, 21, p[63]);
      v[0] = v[0] + N | 0, v[1] = v[1] + K | 0, v[2] = v[2] + U | 0, v[3] = v[3] + F | 0;
    },
    _doFinalize: function() {
      var g = this._data, y = g.words, v = 8 * this._nDataBytes, m = 8 * g.sigBytes;
      y[m >>> 5] |= 128 << 24 - m % 32;
      var b = u.floor(v / 4294967296);
      for (y[(m + 64 >>> 9 << 4) + 15] = (b << 8 | b >>> 24) & 16711935 | (b << 24 | b >>> 8) & 4278255360, y[(m + 64 >>> 9 << 4) + 14] = (v << 8 | v >>> 24) & 16711935 | (v << 24 | v >>> 8) & 4278255360, g.sigBytes = 4 * (y.length + 1), this._process(), g = this._hash, y = g.words, v = 0; 4 > v; v++)
        m = y[v], y[v] = (m << 8 | m >>> 24) & 16711935 | (m << 24 | m >>> 8) & 4278255360;
      return g;
    },
    clone: function() {
      var g = l.clone.call(this);
      return g._hash = this._hash.clone(), g;
    }
  }), o.MD5 = l._createHelper(d), o.HmacMD5 = l._createHmacHelper(d);
})(Math);
(function() {
  var u = CryptoJS, n = u.lib, r = n.WordArray, a = n.Hasher, e = [], n = u.algo.SHA1 = a.extend({ _doReset: function() {
    this._hash = new r.init([1732584193, 4023233417, 2562383102, 271733878, 3285377520]);
  }, _doProcessBlock: function(o, c) {
    for (var l = this._hash.words, d = l[0], p = l[1], h = l[2], g = l[3], y = l[4], v = 0; 80 > v; v++) {
      if (16 > v)
        e[v] = o[c + v] | 0;
      else {
        var m = e[v - 3] ^ e[v - 8] ^ e[v - 14] ^ e[v - 16];
        e[v] = m << 1 | m >>> 31;
      }
      m = (d << 5 | d >>> 27) + y + e[v], m = 20 > v ? m + ((p & h | ~p & g) + 1518500249) : 40 > v ? m + ((p ^ h ^ g) + 1859775393) : 60 > v ? m + ((p & h | p & g | h & g) - 1894007588) : m + ((p ^ h ^ g) - 899497514), y = g, g = h, h = p << 30 | p >>> 2, p = d, d = m;
    }
    l[0] = l[0] + d | 0, l[1] = l[1] + p | 0, l[2] = l[2] + h | 0, l[3] = l[3] + g | 0, l[4] = l[4] + y | 0;
  }, _doFinalize: function() {
    var o = this._data, c = o.words, l = 8 * this._nDataBytes, d = 8 * o.sigBytes;
    return c[d >>> 5] |= 128 << 24 - d % 32, c[(d + 64 >>> 9 << 4) + 14] = Math.floor(l / 4294967296), c[(d + 64 >>> 9 << 4) + 15] = l, o.sigBytes = 4 * c.length, this._process(), this._hash;
  }, clone: function() {
    var o = a.clone.call(this);
    return o._hash = this._hash.clone(), o;
  } });
  u.SHA1 = a._createHelper(n), u.HmacSHA1 = a._createHmacHelper(n);
})();
(function(u) {
  for (var r = CryptoJS, v = r.lib, a = v.WordArray, e = v.Hasher, v = r.algo, n = [], o = [], c = function(b) {
    return 4294967296 * (b - (b | 0)) | 0;
  }, l = 2, d = 0; 64 > d; ) {
    var p;
    e: {
      p = l;
      for (var h = u.sqrt(p), g = 2; g <= h; g++)
        if (!(p % g)) {
          p = !1;
          break e;
        }
      p = !0;
    }
    p && (8 > d && (n[d] = c(u.pow(l, 0.5))), o[d] = c(u.pow(l, 1 / 3)), d++), l++;
  }
  var y = [], v = v.SHA256 = e.extend({ _doReset: function() {
    this._hash = new a.init(n.slice(0));
  }, _doProcessBlock: function(m, b) {
    for (var R = this._hash.words, $ = R[0], x = R[1], E = R[2], T = R[3], P = R[4], O = R[5], w = R[6], _ = R[7], C = 0; 64 > C; C++) {
      if (16 > C)
        y[C] = m[b + C] | 0;
      else {
        var k = y[C - 15], B = y[C - 2];
        y[C] = ((k << 25 | k >>> 7) ^ (k << 14 | k >>> 18) ^ k >>> 3) + y[C - 7] + ((B << 15 | B >>> 17) ^ (B << 13 | B >>> 19) ^ B >>> 10) + y[C - 16];
      }
      k = _ + ((P << 26 | P >>> 6) ^ (P << 21 | P >>> 11) ^ (P << 7 | P >>> 25)) + (P & O ^ ~P & w) + o[C] + y[C], B = (($ << 30 | $ >>> 2) ^ ($ << 19 | $ >>> 13) ^ ($ << 10 | $ >>> 22)) + ($ & x ^ $ & E ^ x & E), _ = w, w = O, O = P, P = T + k | 0, T = E, E = x, x = $, $ = k + B | 0;
    }
    R[0] = R[0] + $ | 0, R[1] = R[1] + x | 0, R[2] = R[2] + E | 0, R[3] = R[3] + T | 0, R[4] = R[4] + P | 0, R[5] = R[5] + O | 0, R[6] = R[6] + w | 0, R[7] = R[7] + _ | 0;
  }, _doFinalize: function() {
    var m = this._data, b = m.words, R = 8 * this._nDataBytes, $ = 8 * m.sigBytes;
    return b[$ >>> 5] |= 128 << 24 - $ % 32, b[($ + 64 >>> 9 << 4) + 14] = u.floor(R / 4294967296), b[($ + 64 >>> 9 << 4) + 15] = R, m.sigBytes = 4 * b.length, this._process(), this._hash;
  }, clone: function() {
    var m = e.clone.call(this);
    return m._hash = this._hash.clone(), m;
  } });
  r.SHA256 = e._createHelper(v), r.HmacSHA256 = e._createHmacHelper(v);
})(Math);
(function() {
  var u = CryptoJS, r = u.lib.WordArray, e = u.algo, a = e.SHA256, e = e.SHA224 = a.extend({ _doReset: function() {
    this._hash = new r.init([3238371032, 914150663, 812702999, 4144912697, 4290775857, 1750603025, 1694076839, 3204075428]);
  }, _doFinalize: function() {
    var n = a._doFinalize.call(this);
    return n.sigBytes -= 4, n;
  } });
  u.SHA224 = a._createHelper(e), u.HmacSHA224 = a._createHmacHelper(e);
})();
(function() {
  function u() {
    return e.create.apply(e, arguments);
  }
  for (var r = CryptoJS, a = r.lib.Hasher, o = r.x64, e = o.Word, n = o.WordArray, o = r.algo, c = [
    u(1116352408, 3609767458),
    u(1899447441, 602891725),
    u(3049323471, 3964484399),
    u(3921009573, 2173295548),
    u(961987163, 4081628472),
    u(1508970993, 3053834265),
    u(2453635748, 2937671579),
    u(2870763221, 3664609560),
    u(3624381080, 2734883394),
    u(310598401, 1164996542),
    u(607225278, 1323610764),
    u(1426881987, 3590304994),
    u(1925078388, 4068182383),
    u(2162078206, 991336113),
    u(2614888103, 633803317),
    u(3248222580, 3479774868),
    u(3835390401, 2666613458),
    u(4022224774, 944711139),
    u(264347078, 2341262773),
    u(604807628, 2007800933),
    u(770255983, 1495990901),
    u(1249150122, 1856431235),
    u(1555081692, 3175218132),
    u(1996064986, 2198950837),
    u(2554220882, 3999719339),
    u(2821834349, 766784016),
    u(2952996808, 2566594879),
    u(3210313671, 3203337956),
    u(3336571891, 1034457026),
    u(3584528711, 2466948901),
    u(113926993, 3758326383),
    u(338241895, 168717936),
    u(666307205, 1188179964),
    u(773529912, 1546045734),
    u(1294757372, 1522805485),
    u(
      1396182291,
      2643833823
    ),
    u(1695183700, 2343527390),
    u(1986661051, 1014477480),
    u(2177026350, 1206759142),
    u(2456956037, 344077627),
    u(2730485921, 1290863460),
    u(2820302411, 3158454273),
    u(3259730800, 3505952657),
    u(3345764771, 106217008),
    u(3516065817, 3606008344),
    u(3600352804, 1432725776),
    u(4094571909, 1467031594),
    u(275423344, 851169720),
    u(430227734, 3100823752),
    u(506948616, 1363258195),
    u(659060556, 3750685593),
    u(883997877, 3785050280),
    u(958139571, 3318307427),
    u(1322822218, 3812723403),
    u(1537002063, 2003034995),
    u(1747873779, 3602036899),
    u(1955562222, 1575990012),
    u(2024104815, 1125592928),
    u(2227730452, 2716904306),
    u(2361852424, 442776044),
    u(2428436474, 593698344),
    u(2756734187, 3733110249),
    u(3204031479, 2999351573),
    u(3329325298, 3815920427),
    u(3391569614, 3928383900),
    u(3515267271, 566280711),
    u(3940187606, 3454069534),
    u(4118630271, 4000239992),
    u(116418474, 1914138554),
    u(174292421, 2731055270),
    u(289380356, 3203993006),
    u(460393269, 320620315),
    u(685471733, 587496836),
    u(852142971, 1086792851),
    u(1017036298, 365543100),
    u(1126000580, 2618297676),
    u(
      1288033470,
      3409855158
    ),
    u(1501505948, 4234509866),
    u(1607167915, 987167468),
    u(1816402316, 1246189591)
  ], l = [], d = 0; 80 > d; d++)
    l[d] = u();
  o = o.SHA512 = a.extend({ _doReset: function() {
    this._hash = new n.init([new e.init(1779033703, 4089235720), new e.init(3144134277, 2227873595), new e.init(1013904242, 4271175723), new e.init(2773480762, 1595750129), new e.init(1359893119, 2917565137), new e.init(2600822924, 725511199), new e.init(528734635, 4215389547), new e.init(1541459225, 327033209)]);
  }, _doProcessBlock: function(p, h) {
    for (var x = this._hash.words, g = x[0], y = x[1], v = x[2], m = x[3], b = x[4], R = x[5], $ = x[6], x = x[7], E = g.high, T = g.low, P = y.high, O = y.low, w = v.high, _ = v.low, C = m.high, k = m.low, B = b.high, j = b.low, J = R.high, N = R.low, F = $.high, U = $.low, K = x.high, ve = x.low, he = E, te = T, W = P, ae = O, fe = w, ee = _, Se = C, pe = k, Q = B, oe = j, ne = J, se = N, de = F, ue = U, Re = K, be = ve, me = 0; 80 > me; me++) {
      var G = l[me];
      if (16 > me)
        var Oe = G.high = p[h + 2 * me] | 0, H = G.low = p[h + 2 * me + 1] | 0;
      else {
        var Oe = l[me - 15], H = Oe.high, Ce = Oe.low, Oe = (H >>> 1 | Ce << 31) ^ (H >>> 8 | Ce << 24) ^ H >>> 7, Ce = (Ce >>> 1 | H << 31) ^ (Ce >>> 8 | H << 24) ^ (Ce >>> 7 | H << 25), Ae = l[me - 2], H = Ae.high, q = Ae.low, Ae = (H >>> 19 | q << 13) ^ (H << 3 | q >>> 29) ^ H >>> 6, q = (q >>> 19 | H << 13) ^ (q << 3 | H >>> 29) ^ (q >>> 6 | H << 26), H = l[me - 7], De = H.high, we = l[me - 16], V = we.high, we = we.low, H = Ce + H.low, Oe = Oe + De + (H >>> 0 < Ce >>> 0 ? 1 : 0), H = H + q, Oe = Oe + Ae + (H >>> 0 < q >>> 0 ? 1 : 0), H = H + we, Oe = Oe + V + (H >>> 0 < we >>> 0 ? 1 : 0);
        G.high = Oe, G.low = H;
      }
      var De = Q & ne ^ ~Q & de, we = oe & se ^ ~oe & ue, G = he & W ^ he & fe ^ W & fe, _e = te & ae ^ te & ee ^ ae & ee, Ce = (he >>> 28 | te << 4) ^ (he << 30 | te >>> 2) ^ (he << 25 | te >>> 7), Ae = (te >>> 28 | he << 4) ^ (te << 30 | he >>> 2) ^ (te << 25 | he >>> 7), q = c[me], ke = q.high, Ie = q.low, q = be + ((oe >>> 14 | Q << 18) ^ (oe >>> 18 | Q << 14) ^ (oe << 23 | Q >>> 9)), V = Re + ((Q >>> 14 | oe << 18) ^ (Q >>> 18 | oe << 14) ^ (Q << 23 | oe >>> 9)) + (q >>> 0 < be >>> 0 ? 1 : 0), q = q + we, V = V + De + (q >>> 0 < we >>> 0 ? 1 : 0), q = q + Ie, V = V + ke + (q >>> 0 < Ie >>> 0 ? 1 : 0), q = q + H, V = V + Oe + (q >>> 0 < H >>> 0 ? 1 : 0), H = Ae + _e, G = Ce + G + (H >>> 0 < Ae >>> 0 ? 1 : 0), Re = de, be = ue, de = ne, ue = se, ne = Q, se = oe, oe = pe + q | 0, Q = Se + V + (oe >>> 0 < pe >>> 0 ? 1 : 0) | 0, Se = fe, pe = ee, fe = W, ee = ae, W = he, ae = te, te = q + H | 0, he = V + G + (te >>> 0 < q >>> 0 ? 1 : 0) | 0;
    }
    T = g.low = T + te, g.high = E + he + (T >>> 0 < te >>> 0 ? 1 : 0), O = y.low = O + ae, y.high = P + W + (O >>> 0 < ae >>> 0 ? 1 : 0), _ = v.low = _ + ee, v.high = w + fe + (_ >>> 0 < ee >>> 0 ? 1 : 0), k = m.low = k + pe, m.high = C + Se + (k >>> 0 < pe >>> 0 ? 1 : 0), j = b.low = j + oe, b.high = B + Q + (j >>> 0 < oe >>> 0 ? 1 : 0), N = R.low = N + se, R.high = J + ne + (N >>> 0 < se >>> 0 ? 1 : 0), U = $.low = U + ue, $.high = F + de + (U >>> 0 < ue >>> 0 ? 1 : 0), ve = x.low = ve + be, x.high = K + Re + (ve >>> 0 < be >>> 0 ? 1 : 0);
  }, _doFinalize: function() {
    var p = this._data, h = p.words, g = 8 * this._nDataBytes, y = 8 * p.sigBytes;
    return h[y >>> 5] |= 128 << 24 - y % 32, h[(y + 128 >>> 10 << 5) + 30] = Math.floor(g / 4294967296), h[(y + 128 >>> 10 << 5) + 31] = g, p.sigBytes = 4 * h.length, this._process(), this._hash.toX32();
  }, clone: function() {
    var p = a.clone.call(this);
    return p._hash = this._hash.clone(), p;
  }, blockSize: 32 }), r.SHA512 = a._createHelper(o), r.HmacSHA512 = a._createHmacHelper(o);
})();
(function() {
  var u = CryptoJS, n = u.x64, r = n.Word, a = n.WordArray, n = u.algo, e = n.SHA512, n = n.SHA384 = e.extend({ _doReset: function() {
    this._hash = new a.init([new r.init(3418070365, 3238371032), new r.init(1654270250, 914150663), new r.init(2438529370, 812702999), new r.init(355462360, 4144912697), new r.init(1731405415, 4290775857), new r.init(2394180231, 1750603025), new r.init(3675008525, 1694076839), new r.init(1203062813, 3204075428)]);
  }, _doFinalize: function() {
    var o = e._doFinalize.call(this);
    return o.sigBytes -= 16, o;
  } });
  u.SHA384 = e._createHelper(n), u.HmacSHA384 = e._createHmacHelper(n);
})();
(function() {
  var u = CryptoJS, p = u.lib, r = p.WordArray, a = p.Hasher, p = u.algo, e = r.create([0, 1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11, 12, 13, 14, 15, 7, 4, 13, 1, 10, 6, 15, 3, 12, 0, 9, 5, 2, 14, 11, 8, 3, 10, 14, 4, 9, 15, 8, 1, 2, 7, 0, 6, 13, 11, 5, 12, 1, 9, 11, 10, 0, 8, 12, 4, 13, 3, 7, 15, 14, 5, 6, 2, 4, 0, 5, 9, 7, 12, 2, 10, 14, 1, 3, 8, 11, 6, 15, 13]), n = r.create([5, 14, 7, 0, 9, 2, 11, 4, 13, 6, 15, 8, 1, 10, 3, 12, 6, 11, 3, 7, 0, 13, 5, 10, 14, 15, 8, 12, 4, 9, 1, 2, 15, 5, 1, 3, 7, 14, 6, 9, 11, 8, 12, 2, 10, 0, 4, 13, 8, 6, 4, 1, 3, 11, 15, 0, 5, 12, 2, 13, 9, 7, 10, 14, 12, 15, 10, 4, 1, 5, 8, 7, 6, 2, 13, 14, 0, 3, 9, 11]), o = r.create([
    11,
    14,
    15,
    12,
    5,
    8,
    7,
    9,
    11,
    13,
    14,
    15,
    6,
    7,
    9,
    8,
    7,
    6,
    8,
    13,
    11,
    9,
    7,
    15,
    7,
    12,
    15,
    9,
    11,
    7,
    13,
    12,
    11,
    13,
    6,
    7,
    14,
    9,
    13,
    15,
    14,
    8,
    13,
    6,
    5,
    12,
    7,
    5,
    11,
    12,
    14,
    15,
    14,
    15,
    9,
    8,
    9,
    14,
    5,
    6,
    8,
    6,
    5,
    12,
    9,
    15,
    5,
    11,
    6,
    8,
    13,
    12,
    5,
    12,
    13,
    14,
    11,
    8,
    5,
    6
  ]), c = r.create([8, 9, 9, 11, 13, 15, 15, 5, 7, 7, 8, 11, 14, 14, 12, 6, 9, 13, 15, 7, 12, 8, 9, 11, 7, 7, 12, 7, 6, 15, 13, 11, 9, 7, 15, 11, 8, 6, 6, 14, 12, 13, 5, 14, 13, 13, 7, 5, 15, 5, 8, 11, 14, 14, 6, 14, 6, 9, 12, 9, 12, 5, 15, 8, 8, 5, 12, 9, 12, 5, 14, 6, 8, 13, 6, 5, 15, 13, 11, 11]), l = r.create([0, 1518500249, 1859775393, 2400959708, 2840853838]), d = r.create([
    1352829926,
    1548603684,
    1836072691,
    2053994217,
    0
  ]), p = p.RIPEMD160 = a.extend({ _doReset: function() {
    this._hash = r.create([1732584193, 4023233417, 2562383102, 271733878, 3285377520]);
  }, _doProcessBlock: function(h, g) {
    for (var y = 0; 16 > y; y++) {
      var v = g + y, m = h[v];
      h[v] = (m << 8 | m >>> 24) & 16711935 | (m << 24 | m >>> 8) & 4278255360;
    }
    var v = this._hash.words, m = l.words, b = d.words, R = e.words, $ = n.words, x = o.words, E = c.words, T, P, O, w, _, C, k, B, j, J;
    C = T = v[0], k = P = v[1], B = O = v[2], j = w = v[3], J = _ = v[4];
    for (var N, y = 0; 80 > y; y += 1)
      N = T + h[g + R[y]] | 0, N = 16 > y ? N + ((P ^ O ^ w) + m[0]) : 32 > y ? N + ((P & O | ~P & w) + m[1]) : 48 > y ? N + (((P | ~O) ^ w) + m[2]) : 64 > y ? N + ((P & w | O & ~w) + m[3]) : N + ((P ^ (O | ~w)) + m[4]), N |= 0, N = N << x[y] | N >>> 32 - x[y], N = N + _ | 0, T = _, _ = w, w = O << 10 | O >>> 22, O = P, P = N, N = C + h[g + $[y]] | 0, N = 16 > y ? N + ((k ^ (B | ~j)) + b[0]) : 32 > y ? N + ((k & j | B & ~j) + b[1]) : 48 > y ? N + (((k | ~B) ^ j) + b[2]) : 64 > y ? N + ((k & B | ~k & j) + b[3]) : N + ((k ^ B ^ j) + b[4]), N |= 0, N = N << E[y] | N >>> 32 - E[y], N = N + J | 0, C = J, J = j, j = B << 10 | B >>> 22, B = k, k = N;
    N = v[1] + O + j | 0, v[1] = v[2] + w + J | 0, v[2] = v[3] + _ + C | 0, v[3] = v[4] + T + k | 0, v[4] = v[0] + P + B | 0, v[0] = N;
  }, _doFinalize: function() {
    var h = this._data, g = h.words, y = 8 * this._nDataBytes, v = 8 * h.sigBytes;
    for (g[v >>> 5] |= 128 << 24 - v % 32, g[(v + 64 >>> 9 << 4) + 14] = (y << 8 | y >>> 24) & 16711935 | (y << 24 | y >>> 8) & 4278255360, h.sigBytes = 4 * (g.length + 1), this._process(), h = this._hash, g = h.words, y = 0; 5 > y; y++)
      v = g[y], g[y] = (v << 8 | v >>> 24) & 16711935 | (v << 24 | v >>> 8) & 4278255360;
    return h;
  }, clone: function() {
    var h = a.clone.call(this);
    return h._hash = this._hash.clone(), h;
  } });
  u.RIPEMD160 = a._createHelper(p), u.HmacRIPEMD160 = a._createHmacHelper(p);
})();
(function() {
  var u = CryptoJS, r = u.enc.Utf8;
  u.algo.HMAC = u.lib.Base.extend({ init: function(a, e) {
    a = this._hasher = new a.init(), typeof e == "string" && (e = r.parse(e));
    var n = a.blockSize, o = 4 * n;
    e.sigBytes > o && (e = a.finalize(e)), e.clamp();
    for (var c = this._oKey = e.clone(), l = this._iKey = e.clone(), d = c.words, p = l.words, h = 0; h < n; h++)
      d[h] ^= 1549556828, p[h] ^= 909522486;
    c.sigBytes = l.sigBytes = o, this.reset();
  }, reset: function() {
    var a = this._hasher;
    a.reset(), a.update(this._iKey);
  }, update: function(a) {
    return this._hasher.update(a), this;
  }, finalize: function(a) {
    var e = this._hasher;
    return a = e.finalize(a), e.reset(), e.finalize(this._oKey.clone().concat(a));
  } });
})();
(function() {
  var u = CryptoJS, e = u.lib, r = e.Base, a = e.WordArray, e = u.algo, n = e.HMAC, o = e.PBKDF2 = r.extend({ cfg: r.extend({ keySize: 4, hasher: e.SHA1, iterations: 1 }), init: function(c) {
    this.cfg = this.cfg.extend(c);
  }, compute: function(c, l) {
    for (var m = this.cfg, d = n.create(m.hasher, c), p = a.create(), h = a.create([1]), g = p.words, y = h.words, v = m.keySize, m = m.iterations; g.length < v; ) {
      var b = d.update(l).finalize(h);
      d.reset();
      for (var R = b.words, $ = R.length, x = b, E = 1; E < m; E++) {
        x = d.finalize(x), d.reset();
        for (var T = x.words, P = 0; P < $; P++)
          R[P] ^= T[P];
      }
      p.concat(b), y[0]++;
    }
    return p.sigBytes = 4 * v, p;
  } });
  u.PBKDF2 = function(c, l, d) {
    return o.create(d).compute(c, l);
  };
})();
/*! (c) Tom Wu | http://www-cs-students.stanford.edu/~tjw/jsbn/
 */
var b64map = "ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789+/", b64pad = "=";
function hex2b64(u) {
  var r, a, e = "";
  for (r = 0; r + 3 <= u.length; r += 3)
    a = parseInt(u.substring(r, r + 3), 16), e += b64map.charAt(a >> 6) + b64map.charAt(a & 63);
  for (r + 1 == u.length ? (a = parseInt(u.substring(r, r + 1), 16), e += b64map.charAt(a << 2)) : r + 2 == u.length && (a = parseInt(u.substring(r, r + 2), 16), e += b64map.charAt(a >> 2) + b64map.charAt((a & 3) << 4)); (e.length & 3) > 0; )
    e += b64pad;
  return e;
}
function b64tohex(u) {
  var r = "", a, e = 0, n, o;
  for (a = 0; a < u.length && u.charAt(a) != b64pad; ++a)
    o = b64map.indexOf(u.charAt(a)), !(o < 0) && (e == 0 ? (r += int2char$1(o >> 2), n = o & 3, e = 1) : e == 1 ? (r += int2char$1(n << 2 | o >> 4), n = o & 15, e = 2) : e == 2 ? (r += int2char$1(n), r += int2char$1(o >> 2), n = o & 3, e = 3) : (r += int2char$1(n << 2 | o >> 4), r += int2char$1(o & 15), e = 0));
  return e == 1 && (r += int2char$1(n << 2)), r;
}
/*! (c) Tom Wu | http://www-cs-students.stanford.edu/~tjw/jsbn/
*/
var dbits$1;
function BigInteger$5(u, r, a) {
  u != null && (typeof u == "number" ? this.fromNumber(u, r, a) : r == null && typeof u != "string" ? this.fromString(u, 256) : this.fromString(u, r));
}
function nbi$1() {
  return new BigInteger$5(null);
}
function am1$1(u, r, a, e, n, o) {
  for (; --o >= 0; ) {
    var c = r * this[u++] + a[e] + n;
    n = Math.floor(c / 67108864), a[e++] = c & 67108863;
  }
  return n;
}
function am2$1(u, r, a, e, n, o) {
  for (var c = r & 32767, l = r >> 15; --o >= 0; ) {
    var d = this[u] & 32767, p = this[u++] >> 15, h = l * d + p * c;
    d = c * d + ((h & 32767) << 15) + a[e] + (n & 1073741823), n = (d >>> 30) + (h >>> 15) + l * p + (n >>> 30), a[e++] = d & 1073741823;
  }
  return n;
}
function am3$1(u, r, a, e, n, o) {
  for (var c = r & 16383, l = r >> 14; --o >= 0; ) {
    var d = this[u] & 16383, p = this[u++] >> 14, h = l * d + p * c;
    d = c * d + ((h & 16383) << 14) + a[e] + n, n = (d >> 28) + (h >> 14) + l * p, a[e++] = d & 268435455;
  }
  return n;
}
navigator$1.appName == "Microsoft Internet Explorer" ? (BigInteger$5.prototype.am = am2$1, dbits$1 = 30) : navigator$1.appName != "Netscape" ? (BigInteger$5.prototype.am = am1$1, dbits$1 = 26) : (BigInteger$5.prototype.am = am3$1, dbits$1 = 28);
BigInteger$5.prototype.DB = dbits$1;
BigInteger$5.prototype.DM = (1 << dbits$1) - 1;
BigInteger$5.prototype.DV = 1 << dbits$1;
var BI_FP$1 = 52;
BigInteger$5.prototype.FV = Math.pow(2, BI_FP$1);
BigInteger$5.prototype.F1 = BI_FP$1 - dbits$1;
BigInteger$5.prototype.F2 = 2 * dbits$1 - BI_FP$1;
var BI_RM$1 = "0123456789abcdefghijklmnopqrstuvwxyz", BI_RC$1 = new Array(), rr$1, vv$1;
rr$1 = 48;
for (vv$1 = 0; vv$1 <= 9; ++vv$1)
  BI_RC$1[rr$1++] = vv$1;
rr$1 = 97;
for (vv$1 = 10; vv$1 < 36; ++vv$1)
  BI_RC$1[rr$1++] = vv$1;
rr$1 = 65;
for (vv$1 = 10; vv$1 < 36; ++vv$1)
  BI_RC$1[rr$1++] = vv$1;
function int2char$1(u) {
  return BI_RM$1.charAt(u);
}
function intAt$1(u, r) {
  var a = BI_RC$1[u.charCodeAt(r)];
  return a ?? -1;
}
function bnpCopyTo$1(u) {
  for (var r = this.t - 1; r >= 0; --r)
    u[r] = this[r];
  u.t = this.t, u.s = this.s;
}
function bnpFromInt$1(u) {
  this.t = 1, this.s = u < 0 ? -1 : 0, u > 0 ? this[0] = u : u < -1 ? this[0] = u + this.DV : this.t = 0;
}
function nbv$1(u) {
  var r = nbi$1();
  return r.fromInt(u), r;
}
function bnpFromString$1(u, r) {
  var a;
  if (r == 16)
    a = 4;
  else if (r == 8)
    a = 3;
  else if (r == 256)
    a = 8;
  else if (r == 2)
    a = 1;
  else if (r == 32)
    a = 5;
  else if (r == 4)
    a = 2;
  else {
    this.fromRadix(u, r);
    return;
  }
  this.t = 0, this.s = 0;
  for (var e = u.length, n = !1, o = 0; --e >= 0; ) {
    var c = a == 8 ? u[e] & 255 : intAt$1(u, e);
    if (c < 0) {
      u.charAt(e) == "-" && (n = !0);
      continue;
    }
    n = !1, o == 0 ? this[this.t++] = c : o + a > this.DB ? (this[this.t - 1] |= (c & (1 << this.DB - o) - 1) << o, this[this.t++] = c >> this.DB - o) : this[this.t - 1] |= c << o, o += a, o >= this.DB && (o -= this.DB);
  }
  a == 8 && u[0] & 128 && (this.s = -1, o > 0 && (this[this.t - 1] |= (1 << this.DB - o) - 1 << o)), this.clamp(), n && BigInteger$5.ZERO.subTo(this, this);
}
function bnpClamp$1() {
  for (var u = this.s & this.DM; this.t > 0 && this[this.t - 1] == u; )
    --this.t;
}
function bnToString$1(u) {
  if (this.s < 0)
    return "-" + this.negate().toString(u);
  var r;
  if (u == 16)
    r = 4;
  else if (u == 8)
    r = 3;
  else if (u == 2)
    r = 1;
  else if (u == 32)
    r = 5;
  else if (u == 4)
    r = 2;
  else
    return this.toRadix(u);
  var a = (1 << r) - 1, e, n = !1, o = "", c = this.t, l = this.DB - c * this.DB % r;
  if (c-- > 0)
    for (l < this.DB && (e = this[c] >> l) > 0 && (n = !0, o = int2char$1(e)); c >= 0; )
      l < r ? (e = (this[c] & (1 << l) - 1) << r - l, e |= this[--c] >> (l += this.DB - r)) : (e = this[c] >> (l -= r) & a, l <= 0 && (l += this.DB, --c)), e > 0 && (n = !0), n && (o += int2char$1(e));
  return n ? o : "0";
}
function bnNegate$1() {
  var u = nbi$1();
  return BigInteger$5.ZERO.subTo(this, u), u;
}
function bnAbs$1() {
  return this.s < 0 ? this.negate() : this;
}
function bnCompareTo$1(u) {
  var r = this.s - u.s;
  if (r != 0)
    return r;
  var a = this.t;
  if (r = a - u.t, r != 0)
    return this.s < 0 ? -r : r;
  for (; --a >= 0; )
    if ((r = this[a] - u[a]) != 0)
      return r;
  return 0;
}
function nbits$1(u) {
  var r = 1, a;
  return (a = u >>> 16) != 0 && (u = a, r += 16), (a = u >> 8) != 0 && (u = a, r += 8), (a = u >> 4) != 0 && (u = a, r += 4), (a = u >> 2) != 0 && (u = a, r += 2), (a = u >> 1) != 0 && (u = a, r += 1), r;
}
function bnBitLength$1() {
  return this.t <= 0 ? 0 : this.DB * (this.t - 1) + nbits$1(this[this.t - 1] ^ this.s & this.DM);
}
function bnpDLShiftTo$1(u, r) {
  var a;
  for (a = this.t - 1; a >= 0; --a)
    r[a + u] = this[a];
  for (a = u - 1; a >= 0; --a)
    r[a] = 0;
  r.t = this.t + u, r.s = this.s;
}
function bnpDRShiftTo$1(u, r) {
  for (var a = u; a < this.t; ++a)
    r[a - u] = this[a];
  r.t = Math.max(this.t - u, 0), r.s = this.s;
}
function bnpLShiftTo$1(u, r) {
  var a = u % this.DB, e = this.DB - a, n = (1 << e) - 1, o = Math.floor(u / this.DB), c = this.s << a & this.DM, l;
  for (l = this.t - 1; l >= 0; --l)
    r[l + o + 1] = this[l] >> e | c, c = (this[l] & n) << a;
  for (l = o - 1; l >= 0; --l)
    r[l] = 0;
  r[o] = c, r.t = this.t + o + 1, r.s = this.s, r.clamp();
}
function bnpRShiftTo$1(u, r) {
  r.s = this.s;
  var a = Math.floor(u / this.DB);
  if (a >= this.t) {
    r.t = 0;
    return;
  }
  var e = u % this.DB, n = this.DB - e, o = (1 << e) - 1;
  r[0] = this[a] >> e;
  for (var c = a + 1; c < this.t; ++c)
    r[c - a - 1] |= (this[c] & o) << n, r[c - a] = this[c] >> e;
  e > 0 && (r[this.t - a - 1] |= (this.s & o) << n), r.t = this.t - a, r.clamp();
}
function bnpSubTo$1(u, r) {
  for (var a = 0, e = 0, n = Math.min(u.t, this.t); a < n; )
    e += this[a] - u[a], r[a++] = e & this.DM, e >>= this.DB;
  if (u.t < this.t) {
    for (e -= u.s; a < this.t; )
      e += this[a], r[a++] = e & this.DM, e >>= this.DB;
    e += this.s;
  } else {
    for (e += this.s; a < u.t; )
      e -= u[a], r[a++] = e & this.DM, e >>= this.DB;
    e -= u.s;
  }
  r.s = e < 0 ? -1 : 0, e < -1 ? r[a++] = this.DV + e : e > 0 && (r[a++] = e), r.t = a, r.clamp();
}
function bnpMultiplyTo$1(u, r) {
  var a = this.abs(), e = u.abs(), n = a.t;
  for (r.t = n + e.t; --n >= 0; )
    r[n] = 0;
  for (n = 0; n < e.t; ++n)
    r[n + a.t] = a.am(0, e[n], r, n, 0, a.t);
  r.s = 0, r.clamp(), this.s != u.s && BigInteger$5.ZERO.subTo(r, r);
}
function bnpSquareTo$1(u) {
  for (var r = this.abs(), a = u.t = 2 * r.t; --a >= 0; )
    u[a] = 0;
  for (a = 0; a < r.t - 1; ++a) {
    var e = r.am(a, r[a], u, 2 * a, 0, 1);
    (u[a + r.t] += r.am(a + 1, 2 * r[a], u, 2 * a + 1, e, r.t - a - 1)) >= r.DV && (u[a + r.t] -= r.DV, u[a + r.t + 1] = 1);
  }
  u.t > 0 && (u[u.t - 1] += r.am(a, r[a], u, 2 * a, 0, 1)), u.s = 0, u.clamp();
}
function bnpDivRemTo$1(u, r, a) {
  var e = u.abs();
  if (!(e.t <= 0)) {
    var n = this.abs();
    if (n.t < e.t) {
      r?.fromInt(0), a != null && this.copyTo(a);
      return;
    }
    a == null && (a = nbi$1());
    var o = nbi$1(), c = this.s, l = u.s, d = this.DB - nbits$1(e[e.t - 1]);
    d > 0 ? (e.lShiftTo(d, o), n.lShiftTo(d, a)) : (e.copyTo(o), n.copyTo(a));
    var p = o.t, h = o[p - 1];
    if (h != 0) {
      var g = h * (1 << this.F1) + (p > 1 ? o[p - 2] >> this.F2 : 0), y = this.FV / g, v = (1 << this.F1) / g, m = 1 << this.F2, b = a.t, R = b - p, $ = r ?? nbi$1();
      for (o.dlShiftTo(R, $), a.compareTo($) >= 0 && (a[a.t++] = 1, a.subTo($, a)), BigInteger$5.ONE.dlShiftTo(p, $), $.subTo(o, o); o.t < p; )
        o[o.t++] = 0;
      for (; --R >= 0; ) {
        var x = a[--b] == h ? this.DM : Math.floor(a[b] * y + (a[b - 1] + m) * v);
        if ((a[b] += o.am(0, x, a, R, 0, p)) < x)
          for (o.dlShiftTo(R, $), a.subTo($, a); a[b] < --x; )
            a.subTo($, a);
      }
      r != null && (a.drShiftTo(p, r), c != l && BigInteger$5.ZERO.subTo(r, r)), a.t = p, a.clamp(), d > 0 && a.rShiftTo(d, a), c < 0 && BigInteger$5.ZERO.subTo(a, a);
    }
  }
}
function bnMod$1(u) {
  var r = nbi$1();
  return this.abs().divRemTo(u, null, r), this.s < 0 && r.compareTo(BigInteger$5.ZERO) > 0 && u.subTo(r, r), r;
}
function Classic$1(u) {
  this.m = u;
}
function cConvert$1(u) {
  return u.s < 0 || u.compareTo(this.m) >= 0 ? u.mod(this.m) : u;
}
function cRevert$1(u) {
  return u;
}
function cReduce$1(u) {
  u.divRemTo(this.m, null, u);
}
function cMulTo$1(u, r, a) {
  u.multiplyTo(r, a), this.reduce(a);
}
function cSqrTo$1(u, r) {
  u.squareTo(r), this.reduce(r);
}
Classic$1.prototype.convert = cConvert$1;
Classic$1.prototype.revert = cRevert$1;
Classic$1.prototype.reduce = cReduce$1;
Classic$1.prototype.mulTo = cMulTo$1;
Classic$1.prototype.sqrTo = cSqrTo$1;
function bnpInvDigit$1() {
  if (this.t < 1)
    return 0;
  var u = this[0];
  if (!(u & 1))
    return 0;
  var r = u & 3;
  return r = r * (2 - (u & 15) * r) & 15, r = r * (2 - (u & 255) * r) & 255, r = r * (2 - ((u & 65535) * r & 65535)) & 65535, r = r * (2 - u * r % this.DV) % this.DV, r > 0 ? this.DV - r : -r;
}
function Montgomery$1(u) {
  this.m = u, this.mp = u.invDigit(), this.mpl = this.mp & 32767, this.mph = this.mp >> 15, this.um = (1 << u.DB - 15) - 1, this.mt2 = 2 * u.t;
}
function montConvert$1(u) {
  var r = nbi$1();
  return u.abs().dlShiftTo(this.m.t, r), r.divRemTo(this.m, null, r), u.s < 0 && r.compareTo(BigInteger$5.ZERO) > 0 && this.m.subTo(r, r), r;
}
function montRevert$1(u) {
  var r = nbi$1();
  return u.copyTo(r), this.reduce(r), r;
}
function montReduce$1(u) {
  for (; u.t <= this.mt2; )
    u[u.t++] = 0;
  for (var r = 0; r < this.m.t; ++r) {
    var a = u[r] & 32767, e = a * this.mpl + ((a * this.mph + (u[r] >> 15) * this.mpl & this.um) << 15) & u.DM;
    for (a = r + this.m.t, u[a] += this.m.am(0, e, u, r, 0, this.m.t); u[a] >= u.DV; )
      u[a] -= u.DV, u[++a]++;
  }
  u.clamp(), u.drShiftTo(this.m.t, u), u.compareTo(this.m) >= 0 && u.subTo(this.m, u);
}
function montSqrTo$1(u, r) {
  u.squareTo(r), this.reduce(r);
}
function montMulTo$1(u, r, a) {
  u.multiplyTo(r, a), this.reduce(a);
}
Montgomery$1.prototype.convert = montConvert$1;
Montgomery$1.prototype.revert = montRevert$1;
Montgomery$1.prototype.reduce = montReduce$1;
Montgomery$1.prototype.mulTo = montMulTo$1;
Montgomery$1.prototype.sqrTo = montSqrTo$1;
function bnpIsEven$1() {
  return (this.t > 0 ? this[0] & 1 : this.s) == 0;
}
function bnpExp$1(u, r) {
  if (u > 4294967295 || u < 1)
    return BigInteger$5.ONE;
  var a = nbi$1(), e = nbi$1(), n = r.convert(this), o = nbits$1(u) - 1;
  for (n.copyTo(a); --o >= 0; )
    if (r.sqrTo(a, e), (u & 1 << o) > 0)
      r.mulTo(e, n, a);
    else {
      var c = a;
      a = e, e = c;
    }
  return r.revert(a);
}
function bnModPowInt$1(u, r) {
  var a;
  return u < 256 || r.isEven() ? a = new Classic$1(r) : a = new Montgomery$1(r), this.exp(u, a);
}
BigInteger$5.prototype.copyTo = bnpCopyTo$1;
BigInteger$5.prototype.fromInt = bnpFromInt$1;
BigInteger$5.prototype.fromString = bnpFromString$1;
BigInteger$5.prototype.clamp = bnpClamp$1;
BigInteger$5.prototype.dlShiftTo = bnpDLShiftTo$1;
BigInteger$5.prototype.drShiftTo = bnpDRShiftTo$1;
BigInteger$5.prototype.lShiftTo = bnpLShiftTo$1;
BigInteger$5.prototype.rShiftTo = bnpRShiftTo$1;
BigInteger$5.prototype.subTo = bnpSubTo$1;
BigInteger$5.prototype.multiplyTo = bnpMultiplyTo$1;
BigInteger$5.prototype.squareTo = bnpSquareTo$1;
BigInteger$5.prototype.divRemTo = bnpDivRemTo$1;
BigInteger$5.prototype.invDigit = bnpInvDigit$1;
BigInteger$5.prototype.isEven = bnpIsEven$1;
BigInteger$5.prototype.exp = bnpExp$1;
BigInteger$5.prototype.toString = bnToString$1;
BigInteger$5.prototype.negate = bnNegate$1;
BigInteger$5.prototype.abs = bnAbs$1;
BigInteger$5.prototype.compareTo = bnCompareTo$1;
BigInteger$5.prototype.bitLength = bnBitLength$1;
BigInteger$5.prototype.mod = bnMod$1;
BigInteger$5.prototype.modPowInt = bnModPowInt$1;
BigInteger$5.ZERO = nbv$1(0);
BigInteger$5.ONE = nbv$1(1);
/*! (c) Tom Wu | http://www-cs-students.stanford.edu/~tjw/jsbn/
 */
function bnClone$1() {
  var u = nbi$1();
  return this.copyTo(u), u;
}
function bnIntValue$1() {
  if (this.s < 0) {
    if (this.t == 1)
      return this[0] - this.DV;
    if (this.t == 0)
      return -1;
  } else {
    if (this.t == 1)
      return this[0];
    if (this.t == 0)
      return 0;
  }
  return (this[1] & (1 << 32 - this.DB) - 1) << this.DB | this[0];
}
function bnByteValue$1() {
  return this.t == 0 ? this.s : this[0] << 24 >> 24;
}
function bnShortValue$1() {
  return this.t == 0 ? this.s : this[0] << 16 >> 16;
}
function bnpChunkSize$1(u) {
  return Math.floor(Math.LN2 * this.DB / Math.log(u));
}
function bnSigNum$1() {
  return this.s < 0 ? -1 : this.t <= 0 || this.t == 1 && this[0] <= 0 ? 0 : 1;
}
function bnpToRadix$1(u) {
  if (u == null && (u = 10), this.signum() == 0 || u < 2 || u > 36)
    return "0";
  var r = this.chunkSize(u), a = Math.pow(u, r), e = nbv$1(a), n = nbi$1(), o = nbi$1(), c = "";
  for (this.divRemTo(e, n, o); n.signum() > 0; )
    c = (a + o.intValue()).toString(u).substr(1) + c, n.divRemTo(e, n, o);
  return o.intValue().toString(u) + c;
}
function bnpFromRadix$1(u, r) {
  this.fromInt(0), r == null && (r = 10);
  for (var a = this.chunkSize(r), e = Math.pow(r, a), n = !1, o = 0, c = 0, l = 0; l < u.length; ++l) {
    var d = intAt$1(u, l);
    if (d < 0) {
      u.charAt(l) == "-" && this.signum() == 0 && (n = !0);
      continue;
    }
    c = r * c + d, ++o >= a && (this.dMultiply(e), this.dAddOffset(c, 0), o = 0, c = 0);
  }
  o > 0 && (this.dMultiply(Math.pow(r, o)), this.dAddOffset(c, 0)), n && BigInteger$5.ZERO.subTo(this, this);
}
function bnpFromNumber$1(u, r, a) {
  if (typeof r == "number")
    if (u < 2)
      this.fromInt(1);
    else
      for (this.fromNumber(u, a), this.testBit(u - 1) || this.bitwiseTo(BigInteger$5.ONE.shiftLeft(u - 1), op_or$1, this), this.isEven() && this.dAddOffset(1, 0); !this.isProbablePrime(r); )
        this.dAddOffset(2, 0), this.bitLength() > u && this.subTo(BigInteger$5.ONE.shiftLeft(u - 1), this);
  else {
    var e = new Array(), n = u & 7;
    e.length = (u >> 3) + 1, r.nextBytes(e), n > 0 ? e[0] &= (1 << n) - 1 : e[0] = 0, this.fromString(e, 256);
  }
}
function bnToByteArray$1() {
  var u = this.t, r = new Array();
  r[0] = this.s;
  var a = this.DB - u * this.DB % 8, e, n = 0;
  if (u-- > 0)
    for (a < this.DB && (e = this[u] >> a) != (this.s & this.DM) >> a && (r[n++] = e | this.s << this.DB - a); u >= 0; )
      a < 8 ? (e = (this[u] & (1 << a) - 1) << 8 - a, e |= this[--u] >> (a += this.DB - 8)) : (e = this[u] >> (a -= 8) & 255, a <= 0 && (a += this.DB, --u)), e & 128 && (e |= -256), n == 0 && (this.s & 128) != (e & 128) && ++n, (n > 0 || e != this.s) && (r[n++] = e);
  return r;
}
function bnEquals$1(u) {
  return this.compareTo(u) == 0;
}
function bnMin$1(u) {
  return this.compareTo(u) < 0 ? this : u;
}
function bnMax$1(u) {
  return this.compareTo(u) > 0 ? this : u;
}
function bnpBitwiseTo$1(u, r, a) {
  var e, n, o = Math.min(u.t, this.t);
  for (e = 0; e < o; ++e)
    a[e] = r(this[e], u[e]);
  if (u.t < this.t) {
    for (n = u.s & this.DM, e = o; e < this.t; ++e)
      a[e] = r(this[e], n);
    a.t = this.t;
  } else {
    for (n = this.s & this.DM, e = o; e < u.t; ++e)
      a[e] = r(n, u[e]);
    a.t = u.t;
  }
  a.s = r(this.s, u.s), a.clamp();
}
function op_and$1(u, r) {
  return u & r;
}
function bnAnd$1(u) {
  var r = nbi$1();
  return this.bitwiseTo(u, op_and$1, r), r;
}
function op_or$1(u, r) {
  return u | r;
}
function bnOr$1(u) {
  var r = nbi$1();
  return this.bitwiseTo(u, op_or$1, r), r;
}
function op_xor$1(u, r) {
  return u ^ r;
}
function bnXor$1(u) {
  var r = nbi$1();
  return this.bitwiseTo(u, op_xor$1, r), r;
}
function op_andnot$1(u, r) {
  return u & ~r;
}
function bnAndNot$1(u) {
  var r = nbi$1();
  return this.bitwiseTo(u, op_andnot$1, r), r;
}
function bnNot$1() {
  for (var u = nbi$1(), r = 0; r < this.t; ++r)
    u[r] = this.DM & ~this[r];
  return u.t = this.t, u.s = ~this.s, u;
}
function bnShiftLeft$1(u) {
  var r = nbi$1();
  return u < 0 ? this.rShiftTo(-u, r) : this.lShiftTo(u, r), r;
}
function bnShiftRight$1(u) {
  var r = nbi$1();
  return u < 0 ? this.lShiftTo(-u, r) : this.rShiftTo(u, r), r;
}
function lbit$1(u) {
  if (u == 0)
    return -1;
  var r = 0;
  return u & 65535 || (u >>= 16, r += 16), u & 255 || (u >>= 8, r += 8), u & 15 || (u >>= 4, r += 4), u & 3 || (u >>= 2, r += 2), u & 1 || ++r, r;
}
function bnGetLowestSetBit$1() {
  for (var u = 0; u < this.t; ++u)
    if (this[u] != 0)
      return u * this.DB + lbit$1(this[u]);
  return this.s < 0 ? this.t * this.DB : -1;
}
function cbit$1(u) {
  for (var r = 0; u != 0; )
    u &= u - 1, ++r;
  return r;
}
function bnBitCount$1() {
  for (var u = 0, r = this.s & this.DM, a = 0; a < this.t; ++a)
    u += cbit$1(this[a] ^ r);
  return u;
}
function bnTestBit$1(u) {
  var r = Math.floor(u / this.DB);
  return r >= this.t ? this.s != 0 : (this[r] & 1 << u % this.DB) != 0;
}
function bnpChangeBit$1(u, r) {
  var a = BigInteger$5.ONE.shiftLeft(u);
  return this.bitwiseTo(a, r, a), a;
}
function bnSetBit$1(u) {
  return this.changeBit(u, op_or$1);
}
function bnClearBit$1(u) {
  return this.changeBit(u, op_andnot$1);
}
function bnFlipBit$1(u) {
  return this.changeBit(u, op_xor$1);
}
function bnpAddTo$1(u, r) {
  for (var a = 0, e = 0, n = Math.min(u.t, this.t); a < n; )
    e += this[a] + u[a], r[a++] = e & this.DM, e >>= this.DB;
  if (u.t < this.t) {
    for (e += u.s; a < this.t; )
      e += this[a], r[a++] = e & this.DM, e >>= this.DB;
    e += this.s;
  } else {
    for (e += this.s; a < u.t; )
      e += u[a], r[a++] = e & this.DM, e >>= this.DB;
    e += u.s;
  }
  r.s = e < 0 ? -1 : 0, e > 0 ? r[a++] = e : e < -1 && (r[a++] = this.DV + e), r.t = a, r.clamp();
}
function bnAdd$1(u) {
  var r = nbi$1();
  return this.addTo(u, r), r;
}
function bnSubtract$1(u) {
  var r = nbi$1();
  return this.subTo(u, r), r;
}
function bnMultiply$1(u) {
  var r = nbi$1();
  return this.multiplyTo(u, r), r;
}
function bnSquare() {
  var u = nbi$1();
  return this.squareTo(u), u;
}
function bnDivide$1(u) {
  var r = nbi$1();
  return this.divRemTo(u, r, null), r;
}
function bnRemainder$1(u) {
  var r = nbi$1();
  return this.divRemTo(u, null, r), r;
}
function bnDivideAndRemainder$1(u) {
  var r = nbi$1(), a = nbi$1();
  return this.divRemTo(u, r, a), new Array(r, a);
}
function bnpDMultiply$1(u) {
  this[this.t] = this.am(0, u - 1, this, 0, 0, this.t), ++this.t, this.clamp();
}
function bnpDAddOffset$1(u, r) {
  if (u != 0) {
    for (; this.t <= r; )
      this[this.t++] = 0;
    for (this[r] += u; this[r] >= this.DV; )
      this[r] -= this.DV, ++r >= this.t && (this[this.t++] = 0), ++this[r];
  }
}
function NullExp$1() {
}
function nNop$1(u) {
  return u;
}
function nMulTo$1(u, r, a) {
  u.multiplyTo(r, a);
}
function nSqrTo$1(u, r) {
  u.squareTo(r);
}
NullExp$1.prototype.convert = nNop$1;
NullExp$1.prototype.revert = nNop$1;
NullExp$1.prototype.mulTo = nMulTo$1;
NullExp$1.prototype.sqrTo = nSqrTo$1;
function bnPow$1(u) {
  return this.exp(u, new NullExp$1());
}
function bnpMultiplyLowerTo$1(u, r, a) {
  var e = Math.min(this.t + u.t, r);
  for (a.s = 0, a.t = e; e > 0; )
    a[--e] = 0;
  var n;
  for (n = a.t - this.t; e < n; ++e)
    a[e + this.t] = this.am(0, u[e], a, e, 0, this.t);
  for (n = Math.min(u.t, r); e < n; ++e)
    this.am(0, u[e], a, e, 0, r - e);
  a.clamp();
}
function bnpMultiplyUpperTo$1(u, r, a) {
  --r;
  var e = a.t = this.t + u.t - r;
  for (a.s = 0; --e >= 0; )
    a[e] = 0;
  for (e = Math.max(r - this.t, 0); e < u.t; ++e)
    a[this.t + e - r] = this.am(r - e, u[e], a, 0, 0, this.t + e - r);
  a.clamp(), a.drShiftTo(1, a);
}
function Barrett$1(u) {
  this.r2 = nbi$1(), this.q3 = nbi$1(), BigInteger$5.ONE.dlShiftTo(2 * u.t, this.r2), this.mu = this.r2.divide(u), this.m = u;
}
function barrettConvert$1(u) {
  if (u.s < 0 || u.t > 2 * this.m.t)
    return u.mod(this.m);
  if (u.compareTo(this.m) < 0)
    return u;
  var r = nbi$1();
  return u.copyTo(r), this.reduce(r), r;
}
function barrettRevert$1(u) {
  return u;
}
function barrettReduce$1(u) {
  for (u.drShiftTo(this.m.t - 1, this.r2), u.t > this.m.t + 1 && (u.t = this.m.t + 1, u.clamp()), this.mu.multiplyUpperTo(this.r2, this.m.t + 1, this.q3), this.m.multiplyLowerTo(this.q3, this.m.t + 1, this.r2); u.compareTo(this.r2) < 0; )
    u.dAddOffset(1, this.m.t + 1);
  for (u.subTo(this.r2, u); u.compareTo(this.m) >= 0; )
    u.subTo(this.m, u);
}
function barrettSqrTo$1(u, r) {
  u.squareTo(r), this.reduce(r);
}
function barrettMulTo$1(u, r, a) {
  u.multiplyTo(r, a), this.reduce(a);
}
Barrett$1.prototype.convert = barrettConvert$1;
Barrett$1.prototype.revert = barrettRevert$1;
Barrett$1.prototype.reduce = barrettReduce$1;
Barrett$1.prototype.mulTo = barrettMulTo$1;
Barrett$1.prototype.sqrTo = barrettSqrTo$1;
function bnModPow$1(u, r) {
  var a = u.bitLength(), e, n = nbv$1(1), o;
  if (a <= 0)
    return n;
  a < 18 ? e = 1 : a < 48 ? e = 3 : a < 144 ? e = 4 : a < 768 ? e = 5 : e = 6, a < 8 ? o = new Classic$1(r) : r.isEven() ? o = new Barrett$1(r) : o = new Montgomery$1(r);
  var c = new Array(), l = 3, d = e - 1, p = (1 << e) - 1;
  if (c[1] = o.convert(this), e > 1) {
    var h = nbi$1();
    for (o.sqrTo(c[1], h); l <= p; )
      c[l] = nbi$1(), o.mulTo(h, c[l - 2], c[l]), l += 2;
  }
  var g = u.t - 1, y, v = !0, m = nbi$1(), b;
  for (a = nbits$1(u[g]) - 1; g >= 0; ) {
    for (a >= d ? y = u[g] >> a - d & p : (y = (u[g] & (1 << a + 1) - 1) << d - a, g > 0 && (y |= u[g - 1] >> this.DB + a - d)), l = e; !(y & 1); )
      y >>= 1, --l;
    if ((a -= l) < 0 && (a += this.DB, --g), v)
      c[y].copyTo(n), v = !1;
    else {
      for (; l > 1; )
        o.sqrTo(n, m), o.sqrTo(m, n), l -= 2;
      l > 0 ? o.sqrTo(n, m) : (b = n, n = m, m = b), o.mulTo(m, c[y], n);
    }
    for (; g >= 0 && !(u[g] & 1 << a); )
      o.sqrTo(n, m), b = n, n = m, m = b, --a < 0 && (a = this.DB - 1, --g);
  }
  return o.revert(n);
}
function bnGCD$1(u) {
  var r = this.s < 0 ? this.negate() : this.clone(), a = u.s < 0 ? u.negate() : u.clone();
  if (r.compareTo(a) < 0) {
    var e = r;
    r = a, a = e;
  }
  var n = r.getLowestSetBit(), o = a.getLowestSetBit();
  if (o < 0)
    return r;
  for (n < o && (o = n), o > 0 && (r.rShiftTo(o, r), a.rShiftTo(o, a)); r.signum() > 0; )
    (n = r.getLowestSetBit()) > 0 && r.rShiftTo(n, r), (n = a.getLowestSetBit()) > 0 && a.rShiftTo(n, a), r.compareTo(a) >= 0 ? (r.subTo(a, r), r.rShiftTo(1, r)) : (a.subTo(r, a), a.rShiftTo(1, a));
  return o > 0 && a.lShiftTo(o, a), a;
}
function bnpModInt$1(u) {
  if (u <= 0)
    return 0;
  var r = this.DV % u, a = this.s < 0 ? u - 1 : 0;
  if (this.t > 0)
    if (r == 0)
      a = this[0] % u;
    else
      for (var e = this.t - 1; e >= 0; --e)
        a = (r * a + this[e]) % u;
  return a;
}
function bnModInverse$1(u) {
  var r = u.isEven();
  if (this.isEven() && r || u.signum() == 0)
    return BigInteger$5.ZERO;
  for (var a = u.clone(), e = this.clone(), n = nbv$1(1), o = nbv$1(0), c = nbv$1(0), l = nbv$1(1); a.signum() != 0; ) {
    for (; a.isEven(); )
      a.rShiftTo(1, a), r ? ((!n.isEven() || !o.isEven()) && (n.addTo(this, n), o.subTo(u, o)), n.rShiftTo(1, n)) : o.isEven() || o.subTo(u, o), o.rShiftTo(1, o);
    for (; e.isEven(); )
      e.rShiftTo(1, e), r ? ((!c.isEven() || !l.isEven()) && (c.addTo(this, c), l.subTo(u, l)), c.rShiftTo(1, c)) : l.isEven() || l.subTo(u, l), l.rShiftTo(1, l);
    a.compareTo(e) >= 0 ? (a.subTo(e, a), r && n.subTo(c, n), o.subTo(l, o)) : (e.subTo(a, e), r && c.subTo(n, c), l.subTo(o, l));
  }
  if (e.compareTo(BigInteger$5.ONE) != 0)
    return BigInteger$5.ZERO;
  if (l.compareTo(u) >= 0)
    return l.subtract(u);
  if (l.signum() < 0)
    l.addTo(u, l);
  else
    return l;
  return l.signum() < 0 ? l.add(u) : l;
}
var lowprimes$1 = [2, 3, 5, 7, 11, 13, 17, 19, 23, 29, 31, 37, 41, 43, 47, 53, 59, 61, 67, 71, 73, 79, 83, 89, 97, 101, 103, 107, 109, 113, 127, 131, 137, 139, 149, 151, 157, 163, 167, 173, 179, 181, 191, 193, 197, 199, 211, 223, 227, 229, 233, 239, 241, 251, 257, 263, 269, 271, 277, 281, 283, 293, 307, 311, 313, 317, 331, 337, 347, 349, 353, 359, 367, 373, 379, 383, 389, 397, 401, 409, 419, 421, 431, 433, 439, 443, 449, 457, 461, 463, 467, 479, 487, 491, 499, 503, 509, 521, 523, 541, 547, 557, 563, 569, 571, 577, 587, 593, 599, 601, 607, 613, 617, 619, 631, 641, 643, 647, 653, 659, 661, 673, 677, 683, 691, 701, 709, 719, 727, 733, 739, 743, 751, 757, 761, 769, 773, 787, 797, 809, 811, 821, 823, 827, 829, 839, 853, 857, 859, 863, 877, 881, 883, 887, 907, 911, 919, 929, 937, 941, 947, 953, 967, 971, 977, 983, 991, 997], lplim$1 = (1 << 26) / lowprimes$1[lowprimes$1.length - 1];
function bnIsProbablePrime$1(u) {
  var r, a = this.abs();
  if (a.t == 1 && a[0] <= lowprimes$1[lowprimes$1.length - 1]) {
    for (r = 0; r < lowprimes$1.length; ++r)
      if (a[0] == lowprimes$1[r])
        return !0;
    return !1;
  }
  if (a.isEven())
    return !1;
  for (r = 1; r < lowprimes$1.length; ) {
    for (var e = lowprimes$1[r], n = r + 1; n < lowprimes$1.length && e < lplim$1; )
      e *= lowprimes$1[n++];
    for (e = a.modInt(e); r < n; )
      if (e % lowprimes$1[r++] == 0)
        return !1;
  }
  return a.millerRabin(u);
}
function bnpMillerRabin$1(u) {
  var r = this.subtract(BigInteger$5.ONE), a = r.getLowestSetBit();
  if (a <= 0)
    return !1;
  var e = r.shiftRight(a);
  u = u + 1 >> 1, u > lowprimes$1.length && (u = lowprimes$1.length);
  for (var n = nbi$1(), o = 0; o < u; ++o) {
    n.fromInt(lowprimes$1[Math.floor(Math.random() * lowprimes$1.length)]);
    var c = n.modPow(e, this);
    if (c.compareTo(BigInteger$5.ONE) != 0 && c.compareTo(r) != 0) {
      for (var l = 1; l++ < a && c.compareTo(r) != 0; )
        if (c = c.modPowInt(2, this), c.compareTo(BigInteger$5.ONE) == 0)
          return !1;
      if (c.compareTo(r) != 0)
        return !1;
    }
  }
  return !0;
}
BigInteger$5.prototype.chunkSize = bnpChunkSize$1;
BigInteger$5.prototype.toRadix = bnpToRadix$1;
BigInteger$5.prototype.fromRadix = bnpFromRadix$1;
BigInteger$5.prototype.fromNumber = bnpFromNumber$1;
BigInteger$5.prototype.bitwiseTo = bnpBitwiseTo$1;
BigInteger$5.prototype.changeBit = bnpChangeBit$1;
BigInteger$5.prototype.addTo = bnpAddTo$1;
BigInteger$5.prototype.dMultiply = bnpDMultiply$1;
BigInteger$5.prototype.dAddOffset = bnpDAddOffset$1;
BigInteger$5.prototype.multiplyLowerTo = bnpMultiplyLowerTo$1;
BigInteger$5.prototype.multiplyUpperTo = bnpMultiplyUpperTo$1;
BigInteger$5.prototype.modInt = bnpModInt$1;
BigInteger$5.prototype.millerRabin = bnpMillerRabin$1;
BigInteger$5.prototype.clone = bnClone$1;
BigInteger$5.prototype.intValue = bnIntValue$1;
BigInteger$5.prototype.byteValue = bnByteValue$1;
BigInteger$5.prototype.shortValue = bnShortValue$1;
BigInteger$5.prototype.signum = bnSigNum$1;
BigInteger$5.prototype.toByteArray = bnToByteArray$1;
BigInteger$5.prototype.equals = bnEquals$1;
BigInteger$5.prototype.min = bnMin$1;
BigInteger$5.prototype.max = bnMax$1;
BigInteger$5.prototype.and = bnAnd$1;
BigInteger$5.prototype.or = bnOr$1;
BigInteger$5.prototype.xor = bnXor$1;
BigInteger$5.prototype.andNot = bnAndNot$1;
BigInteger$5.prototype.not = bnNot$1;
BigInteger$5.prototype.shiftLeft = bnShiftLeft$1;
BigInteger$5.prototype.shiftRight = bnShiftRight$1;
BigInteger$5.prototype.getLowestSetBit = bnGetLowestSetBit$1;
BigInteger$5.prototype.bitCount = bnBitCount$1;
BigInteger$5.prototype.testBit = bnTestBit$1;
BigInteger$5.prototype.setBit = bnSetBit$1;
BigInteger$5.prototype.clearBit = bnClearBit$1;
BigInteger$5.prototype.flipBit = bnFlipBit$1;
BigInteger$5.prototype.add = bnAdd$1;
BigInteger$5.prototype.subtract = bnSubtract$1;
BigInteger$5.prototype.multiply = bnMultiply$1;
BigInteger$5.prototype.divide = bnDivide$1;
BigInteger$5.prototype.remainder = bnRemainder$1;
BigInteger$5.prototype.divideAndRemainder = bnDivideAndRemainder$1;
BigInteger$5.prototype.modPow = bnModPow$1;
BigInteger$5.prototype.modInverse = bnModInverse$1;
BigInteger$5.prototype.pow = bnPow$1;
BigInteger$5.prototype.gcd = bnGCD$1;
BigInteger$5.prototype.isProbablePrime = bnIsProbablePrime$1;
BigInteger$5.prototype.square = bnSquare;
/*! (c) Tom Wu | http://www-cs-students.stanford.edu/~tjw/jsbn/
 */
function Arcfour() {
  this.i = 0, this.j = 0, this.S = new Array();
}
function ARC4init(u) {
  var r, a, e;
  for (r = 0; r < 256; ++r)
    this.S[r] = r;
  for (a = 0, r = 0; r < 256; ++r)
    a = a + this.S[r] + u[r % u.length] & 255, e = this.S[r], this.S[r] = this.S[a], this.S[a] = e;
  this.i = 0, this.j = 0;
}
function ARC4next() {
  var u;
  return this.i = this.i + 1 & 255, this.j = this.j + this.S[this.i] & 255, u = this.S[this.i], this.S[this.i] = this.S[this.j], this.S[this.j] = u, this.S[u + this.S[this.i] & 255];
}
Arcfour.prototype.init = ARC4init;
Arcfour.prototype.next = ARC4next;
function prng_newstate() {
  return new Arcfour();
}
var rng_psize = 256;
/*! (c) Tom Wu | http://www-cs-students.stanford.edu/~tjw/jsbn/
 */
var rng_state, rng_pool, rng_pptr;
function rng_seed_int(u) {
  rng_pool[rng_pptr++] ^= u & 255, rng_pool[rng_pptr++] ^= u >> 8 & 255, rng_pool[rng_pptr++] ^= u >> 16 & 255, rng_pool[rng_pptr++] ^= u >> 24 & 255, rng_pptr >= rng_psize && (rng_pptr -= rng_psize);
}
function rng_seed_time() {
  rng_seed_int((/* @__PURE__ */ new Date()).getTime());
}
if (rng_pool == null) {
  rng_pool = new Array(), rng_pptr = 0;
  var t;
  if (window$1 !== void 0 && (window$1.crypto !== void 0 || window$1.msCrypto !== void 0)) {
    var crypto$2 = window$1.crypto || window$1.msCrypto;
    if (crypto$2.getRandomValues) {
      var ua = new Uint8Array(32);
      for (crypto$2.getRandomValues(ua), t = 0; t < 32; ++t)
        rng_pool[rng_pptr++] = ua[t];
    } else if (navigator$1.appName == "Netscape" && navigator$1.appVersion < "5") {
      var z = window$1.crypto.random(32);
      for (t = 0; t < z.length; ++t)
        rng_pool[rng_pptr++] = z.charCodeAt(t) & 255;
    }
  }
  for (; rng_pptr < rng_psize; )
    t = Math.floor(65536 * Math.random()), rng_pool[rng_pptr++] = t >>> 8, rng_pool[rng_pptr++] = t & 255;
  rng_pptr = 0, rng_seed_time();
}
function rng_get_byte() {
  if (rng_state == null) {
    for (rng_seed_time(), rng_state = prng_newstate(), rng_state.init(rng_pool), rng_pptr = 0; rng_pptr < rng_pool.length; ++rng_pptr)
      rng_pool[rng_pptr] = 0;
    rng_pptr = 0;
  }
  return rng_state.next();
}
function rng_get_bytes(u) {
  var r;
  for (r = 0; r < u.length; ++r)
    u[r] = rng_get_byte();
}
function SecureRandom() {
}
SecureRandom.prototype.nextBytes = rng_get_bytes;
/*! (c) Tom Wu | http://www-cs-students.stanford.edu/~tjw/jsbn/
 */
function parseBigInt(u, r) {
  return new BigInteger$5(u, r);
}
function RSAKey() {
  this.n = null, this.e = 0, this.d = null, this.p = null, this.q = null, this.dmp1 = null, this.dmq1 = null, this.coeff = null;
}
function RSASetPublic(u, r) {
  if (this.isPublic = !0, this.isPrivate = !1, typeof u != "string")
    this.n = u, this.e = r;
  else if (u != null && r != null && u.length > 0 && r.length > 0)
    this.n = parseBigInt(u, 16), this.e = parseInt(r, 16);
  else
    throw "Invalid RSA public key";
}
function RSADoPublic(u) {
  return u.modPowInt(this.e, this.n);
}
RSAKey.prototype.doPublic = RSADoPublic;
RSAKey.prototype.setPublic = RSASetPublic;
RSAKey.prototype.type = "RSA";
function RSASetPrivate(u, r, a) {
  if (this.isPrivate = !0, typeof u != "string")
    this.n = u, this.e = r, this.d = a;
  else if (u != null && r != null && u.length > 0 && r.length > 0)
    this.n = parseBigInt(u, 16), this.e = parseInt(r, 16), this.d = parseBigInt(a, 16);
  else
    throw "Invalid RSA private key";
}
function RSASetPrivateEx(u, r, a, e, n, o, c, l) {
  if (this.isPrivate = !0, this.isPublic = !1, u == null)
    throw "RSASetPrivateEx N == null";
  if (r == null)
    throw "RSASetPrivateEx E == null";
  if (u.length == 0)
    throw "RSASetPrivateEx N.length == 0";
  if (r.length == 0)
    throw "RSASetPrivateEx E.length == 0";
  if (u != null && r != null && u.length > 0 && r.length > 0)
    this.n = parseBigInt(u, 16), this.e = parseInt(r, 16), this.d = parseBigInt(a, 16), this.p = parseBigInt(e, 16), this.q = parseBigInt(n, 16), this.dmp1 = parseBigInt(o, 16), this.dmq1 = parseBigInt(c, 16), this.coeff = parseBigInt(l, 16);
  else
    throw "Invalid RSA private key in RSASetPrivateEx";
}
function RSAGenerate(u, r) {
  var a = new SecureRandom(), e = u >> 1;
  this.e = parseInt(r, 16);
  for (var n = new BigInteger$5(r, 16), o = u / 2 - 100, c = BigInteger$5.ONE.shiftLeft(o); ; ) {
    for (; this.p = new BigInteger$5(u - e, 1, a), !(this.p.subtract(BigInteger$5.ONE).gcd(n).compareTo(BigInteger$5.ONE) == 0 && this.p.isProbablePrime(10)); )
      ;
    for (; this.q = new BigInteger$5(e, 1, a), !(this.q.subtract(BigInteger$5.ONE).gcd(n).compareTo(BigInteger$5.ONE) == 0 && this.q.isProbablePrime(10)); )
      ;
    if (this.p.compareTo(this.q) <= 0) {
      var l = this.p;
      this.p = this.q, this.q = l;
    }
    var d = this.q.subtract(this.p).abs();
    if (!(d.bitLength() < o || d.compareTo(c) <= 0)) {
      var p = this.p.subtract(BigInteger$5.ONE), h = this.q.subtract(BigInteger$5.ONE), g = p.multiply(h);
      if (g.gcd(n).compareTo(BigInteger$5.ONE) == 0 && (this.n = this.p.multiply(this.q), this.n.bitLength() == u)) {
        this.d = n.modInverse(g), this.dmp1 = this.d.mod(p), this.dmq1 = this.d.mod(h), this.coeff = this.q.modInverse(this.p);
        break;
      }
    }
  }
  this.isPrivate = !0;
}
function RSADoPrivate(u) {
  if (this.p == null || this.q == null)
    return u.modPow(this.d, this.n);
  for (var r = u.mod(this.p).modPow(this.dmp1, this.p), a = u.mod(this.q).modPow(this.dmq1, this.q); r.compareTo(a) < 0; )
    r = r.add(this.p);
  return r.subtract(a).multiply(this.coeff).mod(this.p).multiply(this.q).add(a);
}
RSAKey.prototype.doPrivate = RSADoPrivate;
RSAKey.prototype.setPrivate = RSASetPrivate;
RSAKey.prototype.setPrivateEx = RSASetPrivateEx;
RSAKey.prototype.generate = RSAGenerate;
/*! (c) Tom Wu | http://www-cs-students.stanford.edu/~tjw/jsbn/
 */
function ECFieldElementFp(u, r) {
  this.x = r, this.q = u;
}
function feFpEquals(u) {
  return u == this ? !0 : this.q.equals(u.q) && this.x.equals(u.x);
}
function feFpToBigInteger() {
  return this.x;
}
function feFpNegate() {
  return new ECFieldElementFp(this.q, this.x.negate().mod(this.q));
}
function feFpAdd(u) {
  return new ECFieldElementFp(this.q, this.x.add(u.toBigInteger()).mod(this.q));
}
function feFpSubtract(u) {
  return new ECFieldElementFp(this.q, this.x.subtract(u.toBigInteger()).mod(this.q));
}
function feFpMultiply(u) {
  return new ECFieldElementFp(this.q, this.x.multiply(u.toBigInteger()).mod(this.q));
}
function feFpSquare() {
  return new ECFieldElementFp(this.q, this.x.square().mod(this.q));
}
function feFpDivide(u) {
  return new ECFieldElementFp(this.q, this.x.multiply(u.toBigInteger().modInverse(this.q)).mod(this.q));
}
ECFieldElementFp.prototype.equals = feFpEquals;
ECFieldElementFp.prototype.toBigInteger = feFpToBigInteger;
ECFieldElementFp.prototype.negate = feFpNegate;
ECFieldElementFp.prototype.add = feFpAdd;
ECFieldElementFp.prototype.subtract = feFpSubtract;
ECFieldElementFp.prototype.multiply = feFpMultiply;
ECFieldElementFp.prototype.square = feFpSquare;
ECFieldElementFp.prototype.divide = feFpDivide;
ECFieldElementFp.prototype.sqrt = function() {
  return new ECFieldElementFp(this.q, this.x.sqrt().mod(this.q));
};
function ECPointFp(u, r, a, e) {
  this.curve = u, this.x = r, this.y = a, e == null ? this.z = BigInteger$5.ONE : this.z = e, this.zinv = null;
}
function pointFpGetX() {
  return this.zinv == null && (this.zinv = this.z.modInverse(this.curve.q)), this.curve.fromBigInteger(this.x.toBigInteger().multiply(this.zinv).mod(this.curve.q));
}
function pointFpGetY() {
  return this.zinv == null && (this.zinv = this.z.modInverse(this.curve.q)), this.curve.fromBigInteger(this.y.toBigInteger().multiply(this.zinv).mod(this.curve.q));
}
function pointFpEquals(u) {
  if (u == this)
    return !0;
  if (this.isInfinity())
    return u.isInfinity();
  if (u.isInfinity())
    return this.isInfinity();
  var r, a;
  return r = u.y.toBigInteger().multiply(this.z).subtract(this.y.toBigInteger().multiply(u.z)).mod(this.curve.q), r.equals(BigInteger$5.ZERO) ? (a = u.x.toBigInteger().multiply(this.z).subtract(this.x.toBigInteger().multiply(u.z)).mod(this.curve.q), a.equals(BigInteger$5.ZERO)) : !1;
}
function pointFpIsInfinity() {
  return this.x == null && this.y == null ? !0 : this.z.equals(BigInteger$5.ZERO) && !this.y.toBigInteger().equals(BigInteger$5.ZERO);
}
function pointFpNegate() {
  return new ECPointFp(this.curve, this.x, this.y.negate(), this.z);
}
function pointFpAdd(u) {
  if (this.isInfinity())
    return u;
  if (u.isInfinity())
    return this;
  var r = u.y.toBigInteger().multiply(this.z).subtract(this.y.toBigInteger().multiply(u.z)).mod(this.curve.q), a = u.x.toBigInteger().multiply(this.z).subtract(this.x.toBigInteger().multiply(u.z)).mod(this.curve.q);
  if (BigInteger$5.ZERO.equals(a))
    return BigInteger$5.ZERO.equals(r) ? this.twice() : this.curve.getInfinity();
  var e = new BigInteger$5("3"), n = this.x.toBigInteger(), o = this.y.toBigInteger();
  u.x.toBigInteger(), u.y.toBigInteger();
  var c = a.square(), l = c.multiply(a), d = n.multiply(c), p = r.square().multiply(this.z), h = p.subtract(d.shiftLeft(1)).multiply(u.z).subtract(l).multiply(a).mod(this.curve.q), g = d.multiply(e).multiply(r).subtract(o.multiply(l)).subtract(p.multiply(r)).multiply(u.z).add(r.multiply(l)).mod(this.curve.q), y = l.multiply(this.z).multiply(u.z).mod(this.curve.q);
  return new ECPointFp(this.curve, this.curve.fromBigInteger(h), this.curve.fromBigInteger(g), y);
}
function pointFpTwice() {
  if (this.isInfinity())
    return this;
  if (this.y.toBigInteger().signum() == 0)
    return this.curve.getInfinity();
  var u = new BigInteger$5("3"), r = this.x.toBigInteger(), a = this.y.toBigInteger(), e = a.multiply(this.z), n = e.multiply(a).mod(this.curve.q), o = this.curve.a.toBigInteger(), c = r.square().multiply(u);
  BigInteger$5.ZERO.equals(o) || (c = c.add(this.z.square().multiply(o))), c = c.mod(this.curve.q);
  var l = c.square().subtract(r.shiftLeft(3).multiply(n)).shiftLeft(1).multiply(e).mod(this.curve.q), d = c.multiply(u).multiply(r).subtract(n.shiftLeft(1)).shiftLeft(2).multiply(n).subtract(c.square().multiply(c)).mod(this.curve.q), p = e.square().multiply(e).shiftLeft(3).mod(this.curve.q);
  return new ECPointFp(this.curve, this.curve.fromBigInteger(l), this.curve.fromBigInteger(d), p);
}
function pointFpMultiply(u) {
  if (this.isInfinity())
    return this;
  if (u.signum() == 0)
    return this.curve.getInfinity();
  var r = u, a = r.multiply(new BigInteger$5("3")), e = this.negate(), n = this, o = this.curve.q.subtract(u), c = o.multiply(new BigInteger$5("3")), l = new ECPointFp(this.curve, this.x, this.y), d = l.negate(), p;
  for (p = a.bitLength() - 2; p > 0; --p) {
    n = n.twice();
    var h = a.testBit(p), g = r.testBit(p);
    h != g && (n = n.add(h ? this : e));
  }
  for (p = c.bitLength() - 2; p > 0; --p) {
    l = l.twice();
    var y = c.testBit(p), v = o.testBit(p);
    y != v && (l = l.add(y ? l : d));
  }
  return n;
}
function pointFpMultiplyTwo(u, r, a) {
  var e;
  u.bitLength() > a.bitLength() ? e = u.bitLength() - 1 : e = a.bitLength() - 1;
  for (var n = this.curve.getInfinity(), o = this.add(r); e >= 0; )
    n = n.twice(), u.testBit(e) ? a.testBit(e) ? n = n.add(o) : n = n.add(this) : a.testBit(e) && (n = n.add(r)), --e;
  return n;
}
ECPointFp.prototype.getX = pointFpGetX;
ECPointFp.prototype.getY = pointFpGetY;
ECPointFp.prototype.equals = pointFpEquals;
ECPointFp.prototype.isInfinity = pointFpIsInfinity;
ECPointFp.prototype.negate = pointFpNegate;
ECPointFp.prototype.add = pointFpAdd;
ECPointFp.prototype.twice = pointFpTwice;
ECPointFp.prototype.multiply = pointFpMultiply;
ECPointFp.prototype.multiplyTwo = pointFpMultiplyTwo;
function ECCurveFp(u, r, a) {
  this.q = u, this.a = this.fromBigInteger(r), this.b = this.fromBigInteger(a), this.infinity = new ECPointFp(this, null, null);
}
function curveFpGetQ() {
  return this.q;
}
function curveFpGetA() {
  return this.a;
}
function curveFpGetB() {
  return this.b;
}
function curveFpEquals(u) {
  return u == this ? !0 : this.q.equals(u.q) && this.a.equals(u.a) && this.b.equals(u.b);
}
function curveFpGetInfinity() {
  return this.infinity;
}
function curveFpFromBigInteger(u) {
  return new ECFieldElementFp(this.q, u);
}
function curveFpDecodePointHex(u) {
  switch (parseInt(u.substr(0, 2), 16)) {
    case 0:
      return this.infinity;
    case 2:
    case 3:
      var r = u.substr(0, 2);
      u.substr(2);
      var a = this.fromBigInteger(new BigInteger$5(d, 16)), e = this.getA(), n = this.getB(), o = a.square().add(e).multiply(a).add(n), c = o.sqrt();
      return r == "03" && (c = c.negate()), new ECPointFp(this, a, c);
    case 4:
    case 6:
    case 7:
      var l = (u.length - 2) / 2, d = u.substr(2, l), p = u.substr(l + 2, l);
      return new ECPointFp(this, this.fromBigInteger(new BigInteger$5(d, 16)), this.fromBigInteger(new BigInteger$5(p, 16)));
    default:
      return null;
  }
}
ECCurveFp.prototype.getQ = curveFpGetQ;
ECCurveFp.prototype.getA = curveFpGetA;
ECCurveFp.prototype.getB = curveFpGetB;
ECCurveFp.prototype.equals = curveFpEquals;
ECCurveFp.prototype.getInfinity = curveFpGetInfinity;
ECCurveFp.prototype.fromBigInteger = curveFpFromBigInteger;
ECCurveFp.prototype.decodePointHex = curveFpDecodePointHex;
/*! (c) Stefan Thomas | https://github.com/bitcoinjs/bitcoinjs-lib
 */
ECFieldElementFp.prototype.getByteLength = function() {
  return Math.floor((this.toBigInteger().bitLength() + 7) / 8);
};
ECPointFp.prototype.getEncoded = function(u) {
  var r = function(o, c) {
    var l = o.toByteArrayUnsigned();
    if (c < l.length)
      l = l.slice(l.length - c);
    else
      for (; c > l.length; )
        l.unshift(0);
    return l;
  }, a = this.getX().toBigInteger(), e = this.getY().toBigInteger(), n = r(a, 32);
  return u ? e.isEven() ? n.unshift(2) : n.unshift(3) : (n.unshift(4), n = n.concat(r(e, 32))), n;
};
ECPointFp.decodeFrom = function(u, r) {
  r[0];
  var a = r.length - 1, e = r.slice(1, 1 + a / 2), n = r.slice(1 + a / 2, 1 + a);
  e.unshift(0), n.unshift(0);
  var o = new BigInteger$5(e), c = new BigInteger$5(n);
  return new ECPointFp(u, u.fromBigInteger(o), u.fromBigInteger(c));
};
ECPointFp.decodeFromHex = function(u, r) {
  r.substr(0, 2);
  var a = r.length - 2, e = r.substr(2, a / 2), n = r.substr(2 + a / 2, a / 2), o = new BigInteger$5(e, 16), c = new BigInteger$5(n, 16);
  return new ECPointFp(u, u.fromBigInteger(o), u.fromBigInteger(c));
};
ECPointFp.prototype.add2D = function(u) {
  if (this.isInfinity())
    return u;
  if (u.isInfinity())
    return this;
  if (this.x.equals(u.x))
    return this.y.equals(u.y) ? this.twice() : this.curve.getInfinity();
  var r = u.x.subtract(this.x), a = u.y.subtract(this.y), e = a.divide(r), n = e.square().subtract(this.x).subtract(u.x), o = e.multiply(this.x.subtract(n)).subtract(this.y);
  return new ECPointFp(this.curve, n, o);
};
ECPointFp.prototype.twice2D = function() {
  if (this.isInfinity())
    return this;
  if (this.y.toBigInteger().signum() == 0)
    return this.curve.getInfinity();
  var u = this.curve.fromBigInteger(BigInteger$5.valueOf(2)), r = this.curve.fromBigInteger(BigInteger$5.valueOf(3)), a = this.x.square().multiply(r).add(this.curve.a).divide(this.y.multiply(u)), e = a.square().subtract(this.x.multiply(u)), n = a.multiply(this.x.subtract(e)).subtract(this.y);
  return new ECPointFp(this.curve, e, n);
};
ECPointFp.prototype.multiply2D = function(u) {
  if (this.isInfinity())
    return this;
  if (u.signum() == 0)
    return this.curve.getInfinity();
  var r = u, a = r.multiply(new BigInteger$5("3")), e = this.negate(), n = this, o;
  for (o = a.bitLength() - 2; o > 0; --o) {
    n = n.twice();
    var c = a.testBit(o), l = r.testBit(o);
    c != l && (n = n.add2D(c ? this : e));
  }
  return n;
};
ECPointFp.prototype.isOnCurve = function() {
  var u = this.getX().toBigInteger(), r = this.getY().toBigInteger(), a = this.curve.getA().toBigInteger(), e = this.curve.getB().toBigInteger(), n = this.curve.getQ(), o = r.multiply(r).mod(n), c = u.multiply(u).multiply(u).add(a.multiply(u)).add(e).mod(n);
  return o.equals(c);
};
ECPointFp.prototype.toString = function() {
  return "(" + this.getX().toBigInteger().toString() + "," + this.getY().toBigInteger().toString() + ")";
};
ECPointFp.prototype.validate = function() {
  var u = this.curve.getQ();
  if (this.isInfinity())
    throw new Error("Point is at infinity.");
  var r = this.getX().toBigInteger(), a = this.getY().toBigInteger();
  if (r.compareTo(BigInteger$5.ONE) < 0 || r.compareTo(u.subtract(BigInteger$5.ONE)) > 0)
    throw new Error("x coordinate out of bounds");
  if (a.compareTo(BigInteger$5.ONE) < 0 || a.compareTo(u.subtract(BigInteger$5.ONE)) > 0)
    throw new Error("y coordinate out of bounds");
  if (!this.isOnCurve())
    throw new Error("Point is not on the curve.");
  if (this.multiply(u).isInfinity())
    throw new Error("Point is not a scalar multiple of G.");
  return !0;
};
/*! Mike Samuel (c) 2009 | code.google.com/p/json-sans-eval
 */
var jsonParse = function() {
  var u = "(?:-?\\b(?:0|[1-9][0-9]*)(?:\\.[0-9]+)?(?:[eE][+-]?[0-9]+)?\\b)", r = '(?:[^\\0-\\x08\\x0a-\\x1f"\\\\]|\\\\(?:["/\\\\bfnrt]|u[0-9A-Fa-f]{4}))', a = '(?:"' + r + '*")', e = new RegExp("(?:false|true|null|[\\{\\}\\[\\]]|" + u + "|" + a + ")", "g"), n = new RegExp("\\\\(?:([^u])|u(.{4}))", "g"), o = { '"': '"', "/": "/", "\\": "\\", b: "\b", f: "\f", n: `
`, r: "\r", t: "	" };
  function c(h, g, y) {
    return g ? o[g] : String.fromCharCode(parseInt(y, 16));
  }
  var l = new String(""), d = "\\", p = Object.hasOwnProperty;
  return function(h, g) {
    var y = h.match(e), v, m = y[0], b = !1;
    m === "{" ? v = {} : m === "[" ? v = [] : (v = [], b = !0);
    for (var R, $ = [v], x = 1 - b, E = y.length; x < E; ++x) {
      m = y[x];
      var T;
      switch (m.charCodeAt(0)) {
        default:
          T = $[0], T[R || T.length] = +m, R = void 0;
          break;
        case 34:
          if (m = m.substring(1, m.length - 1), m.indexOf(d) !== -1 && (m = m.replace(n, c)), T = $[0], !R)
            if (T instanceof Array)
              R = T.length;
            else {
              R = m || l;
              break;
            }
          T[R] = m, R = void 0;
          break;
        case 91:
          T = $[0], $.unshift(T[R || T.length] = []), R = void 0;
          break;
        case 93:
          $.shift();
          break;
        case 102:
          T = $[0], T[R || T.length] = !1, R = void 0;
          break;
        case 110:
          T = $[0], T[R || T.length] = null, R = void 0;
          break;
        case 116:
          T = $[0], T[R || T.length] = !0, R = void 0;
          break;
        case 123:
          T = $[0], $.unshift(T[R || T.length] = {}), R = void 0;
          break;
        case 125:
          $.shift();
          break;
      }
    }
    if (b) {
      if ($.length !== 1)
        throw new Error();
      v = v[0];
    } else if ($.length)
      throw new Error();
    if (g) {
      var P = function(O, w) {
        var _ = O[w];
        if (_ && typeof _ == "object") {
          var C = null;
          for (var k in _)
            if (p.call(_, k) && _ !== O) {
              var B = P(_, k);
              B !== void 0 ? _[k] = B : (C || (C = []), C.push(k));
            }
          if (C)
            for (var j = C.length; --j >= 0; )
              delete _[C[j]];
        }
        return g.call(O, w, _);
      };
      v = P({ "": v }, "");
    }
    return v;
  };
}();
(typeof KJUR > "u" || !KJUR) && (KJUR = {});
(typeof KJUR.asn1 > "u" || !KJUR.asn1) && (KJUR.asn1 = {});
KJUR.asn1.ASN1Util = new function() {
  this.integerToByteHex = function(u) {
    var r = u.toString(16);
    return r.length % 2 == 1 && (r = "0" + r), r;
  }, this.bigIntToMinTwosComplementsHex = function(u) {
    return twoscompl(u);
  }, this.getPEMStringFromHex = function(u, r) {
    return hextopem(u, r);
  }, this.newObject = function(u) {
    var r = KJUR, a = r.asn1, e = a.ASN1Object, n = a.DERBoolean, o = a.DERInteger, c = a.DERBitString, l = a.DEROctetString, d = a.DERNull, p = a.DERObjectIdentifier, h = a.DEREnumerated, g = a.DERUTF8String, y = a.DERNumericString, v = a.DERPrintableString, m = a.DERTeletexString, b = a.DERIA5String, R = a.DERUTCTime, $ = a.DERGeneralizedTime, x = a.DERVisibleString, E = a.DERBMPString, T = a.DERSequence, P = a.DERSet, O = a.DERTaggedObject, w = a.ASN1Util.newObject;
    if (u instanceof a.ASN1Object)
      return u;
    var _ = Object.keys(u);
    if (_.length != 1)
      throw new Error("key of param shall be only one.");
    var C = _[0];
    if (":asn1:bool:int:bitstr:octstr:null:oid:enum:utf8str:numstr:prnstr:telstr:ia5str:utctime:gentime:visstr:bmpstr:seq:set:tag:".indexOf(":" + C + ":") == -1)
      throw new Error("undefined key: " + C);
    if (C == "bool")
      return new n(u[C]);
    if (C == "int")
      return new o(u[C]);
    if (C == "bitstr")
      return new c(u[C]);
    if (C == "octstr")
      return new l(u[C]);
    if (C == "null")
      return new d(u[C]);
    if (C == "oid")
      return new p(u[C]);
    if (C == "enum")
      return new h(u[C]);
    if (C == "utf8str")
      return new g(u[C]);
    if (C == "numstr")
      return new y(u[C]);
    if (C == "prnstr")
      return new v(u[C]);
    if (C == "telstr")
      return new m(u[C]);
    if (C == "ia5str")
      return new b(u[C]);
    if (C == "utctime")
      return new R(u[C]);
    if (C == "gentime")
      return new $(u[C]);
    if (C == "visstr")
      return new x(u[C]);
    if (C == "bmpstr")
      return new E(u[C]);
    if (C == "asn1")
      return new e(u[C]);
    if (C == "seq") {
      for (var k = u[C], B = [], j = 0; j < k.length; j++) {
        var J = w(k[j]);
        B.push(J);
      }
      return new T({ array: B });
    }
    if (C == "set") {
      for (var k = u[C], B = [], j = 0; j < k.length; j++) {
        var J = w(k[j]);
        B.push(J);
      }
      return new P({ array: B });
    }
    if (C == "tag") {
      var N = u[C];
      if (Object.prototype.toString.call(N) === "[object Array]" && N.length == 3) {
        var F = w(N[2]);
        return new O({ tag: N[0], explicit: N[1], obj: F });
      } else
        return new O(N);
    }
  }, this.jsonToASN1HEX = function(u) {
    var r = this.newObject(u);
    return r.tohex();
  };
}();
KJUR.asn1.ASN1Util.oidHexToInt = function(u) {
  for (var n = "", r = parseInt(u.substr(0, 2), 16), a = Math.floor(r / 40), e = r % 40, n = a + "." + e, o = "", c = 2; c < u.length; c += 2) {
    var l = parseInt(u.substr(c, 2), 16), d = ("00000000" + l.toString(2)).slice(-8);
    if (o = o + d.substr(1, 7), d.substr(0, 1) == "0") {
      var p = new BigInteger$5(o, 2);
      n = n + "." + p.toString(10), o = "";
    }
  }
  return n;
};
KJUR.asn1.ASN1Util.oidIntToHex = function(u) {
  var r = function(l) {
    var d = l.toString(16);
    return d.length == 1 && (d = "0" + d), d;
  }, a = function(l) {
    var d = "", p = new BigInteger$5(l, 10), h = p.toString(2), g = 7 - h.length % 7;
    g == 7 && (g = 0);
    for (var y = "", v = 0; v < g; v++)
      y += "0";
    h = y + h;
    for (var v = 0; v < h.length - 1; v += 7) {
      var m = h.substr(v, 7);
      v != h.length - 7 && (m = "1" + m), d += r(parseInt(m, 2));
    }
    return d;
  };
  if (!u.match(/^[0-9.]+$/))
    throw "malformed oid string: " + u;
  var e = "", n = u.split("."), o = parseInt(n[0]) * 40 + parseInt(n[1]);
  e += r(o), n.splice(0, 2);
  for (var c = 0; c < n.length; c++)
    e += a(n[c]);
  return e;
};
KJUR.asn1.ASN1Object = function(u) {
  var r = "";
  this.params = null, this.getLengthHexFromValue = function() {
    if (typeof this.hV > "u" || this.hV == null)
      throw new Error("this.hV is null or undefined");
    if (this.hV.length % 2 == 1)
      throw new Error("value hex must be even length: n=" + r.length + ",v=" + this.hV);
    var a = this.hV.length / 2, e = a.toString(16);
    if (e.length % 2 == 1 && (e = "0" + e), a < 128)
      return e;
    var n = e.length / 2;
    if (n > 15)
      throw new Error("ASN.1 length too long to represent by 8x: n = " + a.toString(16));
    var o = 128 + n;
    return o.toString(16) + e;
  }, this.tohex = function() {
    return (this.hTLV == null || this.isModified) && (this.hV = this.getFreshValueHex(), this.hL = this.getLengthHexFromValue(), this.hTLV = this.hT + this.hL + this.hV, this.isModified = !1), this.hTLV;
  }, this.getEncodedHex = function() {
    return this.tohex();
  }, this.getValueHex = function() {
    return this.tohex(), this.hV;
  }, this.getFreshValueHex = function() {
    return "";
  }, this.setByParam = function(a) {
    this.params = a;
  }, u != null && u.tlv != null && (this.hTLV = u.tlv, this.isModified = !1);
};
KJUR.asn1.DERAbstractString = function(u) {
  KJUR.asn1.DERAbstractString.superclass.constructor.call(this), this.getString = function() {
    return this.s;
  }, this.setString = function(r) {
    this.hTLV = null, this.isModified = !0, this.s = r, this.hV = utf8tohex(this.s).toLowerCase();
  }, this.setStringHex = function(r) {
    this.hTLV = null, this.isModified = !0, this.s = null, this.hV = r;
  }, this.getFreshValueHex = function() {
    return this.hV;
  }, typeof u < "u" && (typeof u == "string" ? this.setString(u) : typeof u.str < "u" ? this.setString(u.str) : typeof u.hex < "u" && this.setStringHex(u.hex));
};
extendClass(KJUR.asn1.DERAbstractString, KJUR.asn1.ASN1Object);
KJUR.asn1.DERAbstractTime = function(u) {
  KJUR.asn1.DERAbstractTime.superclass.constructor.call(this), this.localDateToUTC = function(r) {
    var a = r.getTime() + r.getTimezoneOffset() * 6e4, e = new Date(a);
    return e;
  }, this.formatDate = function(r, a, e) {
    var n = this.zeroPadding, o = this.localDateToUTC(r), c = String(o.getFullYear());
    a == "utc" && (c = c.substr(2, 2));
    var l = n(String(o.getMonth() + 1), 2), d = n(String(o.getDate()), 2), p = n(String(o.getHours()), 2), h = n(String(o.getMinutes()), 2), g = n(String(o.getSeconds()), 2), y = c + l + d + p + h + g;
    if (e === !0) {
      var v = o.getMilliseconds();
      if (v != 0) {
        var m = n(String(v), 3);
        m = m.replace(/[0]+$/, ""), y = y + "." + m;
      }
    }
    return y + "Z";
  }, this.zeroPadding = function(r, a) {
    return r.length >= a ? r : new Array(a - r.length + 1).join("0") + r;
  }, this.setByParam = function(r) {
    this.hV = null, this.hTLV = null, this.params = r;
  }, this.getString = function() {
  }, this.setString = function(r) {
    this.hTLV = null, this.isModified = !0, this.params == null && (this.params = {}), this.params.str = r;
  }, this.setByDate = function(r) {
    this.hTLV = null, this.isModified = !0, this.params == null && (this.params = {}), this.params.date = r;
  }, this.setByDateValue = function(r, a, e, n, o, c) {
    var l = new Date(Date.UTC(r, a - 1, e, n, o, c, 0));
    this.setByDate(l);
  }, this.getFreshValueHex = function() {
    return this.hV;
  };
};
extendClass(KJUR.asn1.DERAbstractTime, KJUR.asn1.ASN1Object);
KJUR.asn1.DERAbstractStructured = function(u) {
  KJUR.asn1.DERAbstractString.superclass.constructor.call(this), this.setByASN1ObjectArray = function(r) {
    this.hTLV = null, this.isModified = !0, this.asn1Array = r;
  }, this.appendASN1Object = function(r) {
    this.hTLV = null, this.isModified = !0, this.asn1Array.push(r);
  }, this.asn1Array = new Array(), typeof u < "u" && typeof u.array < "u" && (this.asn1Array = u.array);
};
extendClass(KJUR.asn1.DERAbstractStructured, KJUR.asn1.ASN1Object);
KJUR.asn1.DERBoolean = function(u) {
  KJUR.asn1.DERBoolean.superclass.constructor.call(this), this.hT = "01", u == !1 ? this.hTLV = "010100" : this.hTLV = "0101ff";
};
extendClass(KJUR.asn1.DERBoolean, KJUR.asn1.ASN1Object);
KJUR.asn1.DERInteger = function(u) {
  KJUR.asn1.DERInteger.superclass.constructor.call(this), this.hT = "02", this.params = null;
  var r = twoscompl;
  this.setByBigInteger = function(a) {
    this.isModified = !0, this.params = { bigint: a };
  }, this.setByInteger = function(a) {
    this.isModified = !0, this.params = a;
  }, this.setValueHex = function(a) {
    this.isModified = !0, this.params = { hex: a };
  }, this.getFreshValueHex = function() {
    var a = this.params, e = null;
    if (a == null)
      throw new Error("value not set");
    if (typeof a == "object" && a.hex != null)
      return this.hV = a.hex, this.hV;
    if (typeof a == "number")
      e = new BigInteger$5(String(a), 10);
    else if (a.int != null)
      e = new BigInteger$5(String(a.int), 10);
    else if (a.bigint != null)
      e = a.bigint;
    else
      throw new Error("wrong parameter");
    return this.hV = r(e), this.hV;
  }, u != null && (this.params = u);
};
extendClass(KJUR.asn1.DERInteger, KJUR.asn1.ASN1Object);
KJUR.asn1.DERBitString = function(u) {
  if (u !== void 0 && typeof u.obj < "u") {
    var r = KJUR.asn1.ASN1Util.newObject(u.obj);
    u.hex = "00" + r.tohex();
  }
  KJUR.asn1.DERBitString.superclass.constructor.call(this), this.hT = "03", this.setHexValueIncludingUnusedBits = function(a) {
    this.hTLV = null, this.isModified = !0, this.hV = a;
  }, this.setUnusedBitsAndHexValue = function(a, e) {
    if (a < 0 || 7 < a)
      throw "unused bits shall be from 0 to 7: u = " + a;
    var n = "0" + a;
    this.hTLV = null, this.isModified = !0, this.hV = n + e;
  }, this.setByBinaryString = function(a) {
    a = a.replace(/0+$/, "");
    var e = 8 - a.length % 8;
    e == 8 && (e = 0), a += "0000000".substr(0, e);
    for (var n = "", o = 0; o < a.length - 1; o += 8) {
      var c = a.substr(o, 8), l = parseInt(c, 2).toString(16);
      l.length == 1 && (l = "0" + l), n += l;
    }
    this.hTLV = null, this.isModified = !0, this.hV = "0" + e + n;
  }, this.setByBooleanArray = function(a) {
    for (var e = "", n = 0; n < a.length; n++)
      a[n] == !0 ? e += "1" : e += "0";
    this.setByBinaryString(e);
  }, this.newFalseArray = function(a) {
    for (var e = new Array(a), n = 0; n < a; n++)
      e[n] = !1;
    return e;
  }, this.getFreshValueHex = function() {
    return this.hV;
  }, typeof u < "u" && (typeof u == "string" && u.toLowerCase().match(/^[0-9a-f]+$/) ? this.setHexValueIncludingUnusedBits(u) : typeof u.hex < "u" ? this.setHexValueIncludingUnusedBits(u.hex) : typeof u.bin < "u" ? this.setByBinaryString(u.bin) : typeof u.array < "u" && this.setByBooleanArray(u.array));
};
extendClass(KJUR.asn1.DERBitString, KJUR.asn1.ASN1Object);
KJUR.asn1.DEROctetString = function(u) {
  if (u !== void 0 && typeof u.obj < "u") {
    var r = KJUR.asn1.ASN1Util.newObject(u.obj);
    u.hex = r.tohex();
  }
  KJUR.asn1.DEROctetString.superclass.constructor.call(this, u), this.hT = "04";
};
extendClass(KJUR.asn1.DEROctetString, KJUR.asn1.DERAbstractString);
KJUR.asn1.DERNull = function() {
  KJUR.asn1.DERNull.superclass.constructor.call(this), this.hT = "05", this.hTLV = "0500";
};
extendClass(KJUR.asn1.DERNull, KJUR.asn1.ASN1Object);
KJUR.asn1.DERObjectIdentifier = function(u) {
  KJUR.asn1.DERObjectIdentifier.superclass.constructor.call(this), this.hT = "06", this.setValueHex = function(r) {
    this.hTLV = null, this.isModified = !0, this.s = null, this.hV = r;
  }, this.setValueOidString = function(r) {
    var a = oidtohex(r);
    if (a == null)
      throw new Error("malformed oid string: " + r);
    this.hTLV = null, this.isModified = !0, this.s = null, this.hV = a;
  }, this.setValueName = function(r) {
    var a = KJUR.asn1.x509.OID.name2oid(r);
    if (a !== "")
      this.setValueOidString(a);
    else
      throw new Error("DERObjectIdentifier oidName undefined: " + r);
  }, this.setValueNameOrOid = function(r) {
    r.match(/^[0-2].[0-9.]+$/) ? this.setValueOidString(r) : this.setValueName(r);
  }, this.getFreshValueHex = function() {
    return this.hV;
  }, this.setByParam = function(r) {
    typeof r == "string" ? this.setValueNameOrOid(r) : r.oid !== void 0 ? this.setValueNameOrOid(r.oid) : r.name !== void 0 ? this.setValueNameOrOid(r.name) : r.hex !== void 0 && this.setValueHex(r.hex);
  }, u !== void 0 && this.setByParam(u);
};
extendClass(KJUR.asn1.DERObjectIdentifier, KJUR.asn1.ASN1Object);
KJUR.asn1.DEREnumerated = function(u) {
  KJUR.asn1.DEREnumerated.superclass.constructor.call(this), this.hT = "0a", this.setByBigInteger = function(r) {
    this.hTLV = null, this.isModified = !0, this.hV = twoscompl(r);
  }, this.setByInteger = function(r) {
    var a = new BigInteger$5(String(r), 10);
    this.setByBigInteger(a);
  }, this.setValueHex = function(r) {
    this.hV = r;
  }, this.getFreshValueHex = function() {
    return this.hV;
  }, typeof u < "u" && (typeof u.int < "u" ? this.setByInteger(u.int) : typeof u == "number" ? this.setByInteger(u) : typeof u.hex < "u" && this.setValueHex(u.hex));
};
extendClass(KJUR.asn1.DEREnumerated, KJUR.asn1.ASN1Object);
KJUR.asn1.DERUTF8String = function(u) {
  KJUR.asn1.DERUTF8String.superclass.constructor.call(this, u), this.hT = "0c";
};
extendClass(KJUR.asn1.DERUTF8String, KJUR.asn1.DERAbstractString);
KJUR.asn1.DERNumericString = function(u) {
  KJUR.asn1.DERNumericString.superclass.constructor.call(this, u), this.hT = "12";
};
extendClass(KJUR.asn1.DERNumericString, KJUR.asn1.DERAbstractString);
KJUR.asn1.DERPrintableString = function(u) {
  KJUR.asn1.DERPrintableString.superclass.constructor.call(this, u), this.hT = "13";
};
extendClass(KJUR.asn1.DERPrintableString, KJUR.asn1.DERAbstractString);
KJUR.asn1.DERTeletexString = function(u) {
  KJUR.asn1.DERTeletexString.superclass.constructor.call(this, u), this.hT = "14";
};
extendClass(KJUR.asn1.DERTeletexString, KJUR.asn1.DERAbstractString);
KJUR.asn1.DERIA5String = function(u) {
  KJUR.asn1.DERIA5String.superclass.constructor.call(this, u), this.hT = "16";
};
extendClass(KJUR.asn1.DERIA5String, KJUR.asn1.DERAbstractString);
KJUR.asn1.DERVisibleString = function(u) {
  KJUR.asn1.DERIA5String.superclass.constructor.call(this, u), this.hT = "1a";
};
extendClass(KJUR.asn1.DERVisibleString, KJUR.asn1.DERAbstractString);
KJUR.asn1.DERBMPString = function(u) {
  KJUR.asn1.DERBMPString.superclass.constructor.call(this, u), this.hT = "1e";
};
extendClass(KJUR.asn1.DERBMPString, KJUR.asn1.DERAbstractString);
KJUR.asn1.DERUTCTime = function(u) {
  KJUR.asn1.DERUTCTime.superclass.constructor.call(this, u), this.hT = "17", this.params = void 0, this.getFreshValueHex = function() {
    var r = this.params;
    if (this.params == null && (r = { date: /* @__PURE__ */ new Date() }), typeof r == "string")
      if (r.match(/^[0-9]{12}Z$/) || r.match(/^[0-9]{12}\.[0-9]+Z$/))
        this.hV = stohex(r);
      else
        throw new Error("malformed string for UTCTime: " + r);
    else if (r.str != null)
      this.hV = stohex(r.str);
    else if (r.date == null && r.millis == !0) {
      var a = /* @__PURE__ */ new Date();
      this.hV = stohex(this.formatDate(a, "utc", !0));
    } else if (r.date != null && r.date instanceof Date) {
      var e = r.millis === !0;
      this.hV = stohex(this.formatDate(r.date, "utc", e));
    } else
      r instanceof Date && (this.hV = stohex(this.formatDate(r, "utc")));
    if (this.hV == null)
      throw new Error("parameter not specified properly for UTCTime");
    return this.hV;
  }, u != null && this.setByParam(u);
};
extendClass(KJUR.asn1.DERUTCTime, KJUR.asn1.DERAbstractTime);
KJUR.asn1.DERGeneralizedTime = function(u) {
  KJUR.asn1.DERGeneralizedTime.superclass.constructor.call(this, u), this.hT = "18", this.params = u, this.getFreshValueHex = function() {
    var r = this.params;
    if (this.params == null && (r = { date: /* @__PURE__ */ new Date() }), typeof r == "string")
      if (r.match(/^[0-9]{14}Z$/) || r.match(/^[0-9]{14}\.[0-9]+Z$/))
        this.hV = stohex(r);
      else
        throw new Error("malformed string for GeneralizedTime: " + r);
    else if (r.str != null)
      this.hV = stohex(r.str);
    else if (r.date == null && r.millis == !0) {
      var a = /* @__PURE__ */ new Date();
      this.hV = stohex(this.formatDate(a, "gen", !0));
    } else if (r.date != null && r.date instanceof Date) {
      var e = r.millis === !0;
      this.hV = stohex(this.formatDate(r.date, "gen", e));
    } else
      r instanceof Date && (this.hV = stohex(this.formatDate(r, "gen")));
    if (this.hV == null)
      throw new Error("parameter not specified properly for GeneralizedTime");
    return this.hV;
  }, u != null && this.setByParam(u);
};
extendClass(KJUR.asn1.DERGeneralizedTime, KJUR.asn1.DERAbstractTime);
KJUR.asn1.DERSequence = function(u) {
  KJUR.asn1.DERSequence.superclass.constructor.call(this, u), this.hT = "30", this.getFreshValueHex = function() {
    for (var r = "", a = 0; a < this.asn1Array.length; a++) {
      var e = this.asn1Array[a];
      r += e.tohex();
    }
    return this.hV = r, this.hV;
  };
};
extendClass(KJUR.asn1.DERSequence, KJUR.asn1.DERAbstractStructured);
KJUR.asn1.DERSet = function(u) {
  KJUR.asn1.DERSet.superclass.constructor.call(this, u), this.hT = "31", this.sortFlag = !0, this.getFreshValueHex = function() {
    for (var r = new Array(), a = 0; a < this.asn1Array.length; a++) {
      var e = this.asn1Array[a];
      r.push(e.tohex());
    }
    return this.sortFlag == !0 && r.sort(), this.hV = r.join(""), this.hV;
  }, typeof u < "u" && typeof u.sortflag < "u" && u.sortflag == !1 && (this.sortFlag = !1);
};
extendClass(KJUR.asn1.DERSet, KJUR.asn1.DERAbstractStructured);
KJUR.asn1.DERTaggedObject = function(u) {
  KJUR.asn1.DERTaggedObject.superclass.constructor.call(this);
  var r = KJUR.asn1, a = ASN1HEX, e = a.getV;
  a.isASN1HEX;
  var n = r.ASN1Util.newObject;
  this.hT = "a0", this.hV = "", this.isExplicit = !0, this.asn1Object = null, this.params = { tag: "a0", explicit: !0 }, this.setASN1Object = function(o, c, l) {
    this.params = { tag: c, explicit: o, obj: l };
  }, this.getFreshValueHex = function() {
    var o = this.params;
    if (o.explicit == null && (o.explicit = !0), o.tage != null && (o.tag = o.tage, o.explicit = !0), o.tagi != null && (o.tag = o.tagi, o.explicit = !1), o.str != null)
      this.hV = utf8tohex(o.str);
    else if (o.hex != null)
      this.hV = o.hex;
    else if (o.obj != null) {
      var c;
      o.obj instanceof r.ASN1Object ? c = o.obj.tohex() : typeof o.obj == "object" && (c = n(o.obj).tohex()), o.explicit ? this.hV = c : this.hV = e(c, 0);
    } else
      throw new Error("str, hex nor obj not specified");
    return o.tag == null && (o.tag = "a0"), this.hT = o.tag, this.hTLV = null, this.isModified = !0, this.hV;
  }, this.setByParam = function(o) {
    this.params = o;
  }, u !== void 0 && this.setByParam(u);
};
extendClass(KJUR.asn1.DERTaggedObject, KJUR.asn1.ASN1Object);
var ASN1HEX = new function() {
}();
ASN1HEX.getLblen = function(u, r) {
  if (u.substr(r + 2, 1) != "8")
    return 1;
  var a = parseInt(u.substr(r + 3, 1));
  return a == 0 ? -1 : 0 < a && a < 10 ? a + 1 : -2;
};
ASN1HEX.getL = function(u, r) {
  var a = ASN1HEX.getLblen(u, r);
  return a < 1 ? "" : u.substr(r + 2, a * 2);
};
ASN1HEX.getVblen = function(u, r) {
  var a, e;
  return a = ASN1HEX.getL(u, r), a == "" ? -1 : (a.substr(0, 1) === "8" ? e = new BigInteger$5(a.substr(2), 16) : e = new BigInteger$5(a, 16), e.intValue());
};
ASN1HEX.getVidx = function(u, r) {
  var a = ASN1HEX.getLblen(u, r);
  return a < 0 ? a : r + (a + 1) * 2;
};
ASN1HEX.getV = function(u, r) {
  var a = ASN1HEX.getVidx(u, r), e = ASN1HEX.getVblen(u, r);
  return u.substr(a, e * 2);
};
ASN1HEX.getTLV = function(u, r) {
  return u.substr(r, 2) + ASN1HEX.getL(u, r) + ASN1HEX.getV(u, r);
};
ASN1HEX.getTLVblen = function(u, r) {
  return 2 + ASN1HEX.getLblen(u, r) * 2 + ASN1HEX.getVblen(u, r) * 2;
};
ASN1HEX.getNextSiblingIdx = function(u, r) {
  var a = ASN1HEX.getVidx(u, r), e = ASN1HEX.getVblen(u, r);
  return a + e * 2;
};
ASN1HEX.getChildIdx = function(u, r) {
  var a = ASN1HEX, e = [], n, o, c;
  n = a.getVidx(u, r), o = a.getVblen(u, r) * 2, u.substr(r, 2) == "03" && (n += 2, o -= 2), c = 0;
  for (var l = n; c <= o; ) {
    var d = a.getTLVblen(u, l);
    if (c += d, c <= o && e.push(l), l += d, c >= o)
      break;
  }
  return e;
};
ASN1HEX.getNthChildIdx = function(u, r, a) {
  var e = ASN1HEX.getChildIdx(u, r);
  return e[a];
};
ASN1HEX.getIdxbyList = function(u, r, a, e) {
  var n = ASN1HEX, o, c;
  return a.length == 0 ? e !== void 0 && u.substr(r, 2) !== e ? -1 : r : (o = a.shift(), c = n.getChildIdx(u, r), o >= c.length ? -1 : n.getIdxbyList(u, c[o], a, e));
};
ASN1HEX.getIdxbyListEx = function(u, r, a, e) {
  var n = ASN1HEX, o, c;
  if (a.length == 0)
    return e !== void 0 && u.substr(r, 2) !== e ? -1 : r;
  o = a.shift(), c = n.getChildIdx(u, r);
  for (var l = 0, d = 0; d < c.length; d++) {
    var p = u.substr(c[d], 2);
    if (typeof o == "number" && !n.isContextTag(p) && l == o || typeof o == "string" && n.isContextTag(p, o))
      return n.getIdxbyListEx(u, c[d], a, e);
    n.isContextTag(p) || l++;
  }
  return -1;
};
ASN1HEX.getTLVbyList = function(u, r, a, e) {
  var n = ASN1HEX, o = n.getIdxbyList(u, r, a, e);
  return o == -1 || o >= u.length ? null : n.getTLV(u, o);
};
ASN1HEX.getTLVbyListEx = function(u, r, a, e) {
  var n = ASN1HEX, o = n.getIdxbyListEx(u, r, a, e);
  return o == -1 ? null : n.getTLV(u, o);
};
ASN1HEX.getVbyList = function(u, r, a, e, n) {
  var o = ASN1HEX, c, l;
  return c = o.getIdxbyList(u, r, a, e), c == -1 || c >= u.length ? null : (l = o.getV(u, c), n === !0 && (l = l.substr(2)), l);
};
ASN1HEX.getVbyListEx = function(u, r, a, e, n) {
  var o = ASN1HEX, c, l;
  return c = o.getIdxbyListEx(u, r, a, e), c == -1 ? null : (l = o.getV(u, c), u.substr(c, 2) == "03" && n !== !1 && (l = l.substr(2)), l);
};
ASN1HEX.getInt = function(u, r, a) {
  a == null && (a = -1);
  try {
    var e = u.substr(r, 2);
    if (e != "02" && e != "03")
      return a;
    var n = ASN1HEX.getV(u, r);
    return e == "02" ? parseInt(n, 16) : bitstrtoint(n);
  } catch {
    return a;
  }
};
ASN1HEX.getOID = function(u, r, a) {
  a == null && (a = null);
  try {
    if (u.substr(r, 2) != "06")
      return a;
    var e = ASN1HEX.getV(u, r);
    return hextooid(e);
  } catch {
    return a;
  }
};
ASN1HEX.getOIDName = function(u, r, a) {
  a == null && (a = null);
  try {
    var e = ASN1HEX.getOID(u, r, a);
    if (e == a)
      return a;
    var n = KJUR.asn1.x509.OID.oid2name(e);
    return n == "" ? e : n;
  } catch {
    return a;
  }
};
ASN1HEX.getString = function(u, r, a) {
  a == null && (a = null);
  try {
    var e = ASN1HEX.getV(u, r);
    return hextorstr(e);
  } catch {
    return a;
  }
};
ASN1HEX.hextooidstr = function(u) {
  var r = function(g, y) {
    return g.length >= y ? g : new Array(y - g.length + 1).join("0") + g;
  }, a = [], e = u.substr(0, 2), n = parseInt(e, 16);
  a[0] = new String(Math.floor(n / 40)), a[1] = new String(n % 40);
  for (var o = u.substr(2), c = [], l = 0; l < o.length / 2; l++)
    c.push(parseInt(o.substr(l * 2, 2), 16));
  for (var d = [], p = "", l = 0; l < c.length; l++)
    c[l] & 128 ? p = p + r((c[l] & 127).toString(2), 7) : (p = p + r((c[l] & 127).toString(2), 7), d.push(new String(parseInt(p, 2))), p = "");
  var h = a.join(".");
  return d.length > 0 && (h = h + "." + d.join(".")), h;
};
ASN1HEX.dump = function(u, r, a, e) {
  var n = ASN1HEX, o = n.getV, c = n.dump, l = n.getChildIdx, d = u;
  u instanceof KJUR.asn1.ASN1Object && (d = u.tohex());
  var p = function(w, _) {
    if (w.length <= _ * 2)
      return w;
    var C = w.substr(0, _) + "..(total " + w.length / 2 + "bytes).." + w.substr(w.length - _, _);
    return C;
  };
  r === void 0 && (r = { ommit_long_octet: 32 }), a === void 0 && (a = 0), e === void 0 && (e = "");
  var h = r.ommit_long_octet, P = d.substr(a, 2);
  if (P == "01") {
    var g = o(d, a);
    return g == "00" ? e + `BOOLEAN FALSE
` : e + `BOOLEAN TRUE
`;
  }
  if (P == "02") {
    var g = o(d, a);
    return e + "INTEGER " + p(g, h) + `
`;
  }
  if (P == "03") {
    var g = o(d, a);
    if (n.isASN1HEX(g.substr(2))) {
      var y = e + `BITSTRING, encapsulates
`;
      return y = y + c(g.substr(2), r, 0, e + "  "), y;
    } else
      return e + "BITSTRING " + p(g, h) + `
`;
  }
  if (P == "04") {
    var g = o(d, a);
    if (n.isASN1HEX(g)) {
      var y = e + `OCTETSTRING, encapsulates
`;
      return y = y + c(g, r, 0, e + "  "), y;
    } else
      return e + "OCTETSTRING " + p(g, h) + `
`;
  }
  if (P == "05")
    return e + `NULL
`;
  if (P == "06") {
    var v = o(d, a), m = KJUR.asn1.ASN1Util.oidHexToInt(v), b = KJUR.asn1.x509.OID.oid2name(m), R = m.replace(/\./g, " ");
    return b != "" ? e + "ObjectIdentifier " + b + " (" + R + `)
` : e + "ObjectIdentifier (" + R + `)
`;
  }
  if (P == "0a")
    return e + "ENUMERATED " + parseInt(o(d, a)) + `
`;
  if (P == "0c")
    return e + "UTF8String '" + hextoutf8(o(d, a)) + `'
`;
  if (P == "13")
    return e + "PrintableString '" + hextoutf8(o(d, a)) + `'
`;
  if (P == "14")
    return e + "TeletexString '" + hextoutf8(o(d, a)) + `'
`;
  if (P == "16")
    return e + "IA5String '" + hextoutf8(o(d, a)) + `'
`;
  if (P == "17")
    return e + "UTCTime " + hextoutf8(o(d, a)) + `
`;
  if (P == "18")
    return e + "GeneralizedTime " + hextoutf8(o(d, a)) + `
`;
  if (P == "1a")
    return e + "VisualString '" + hextoutf8(o(d, a)) + `'
`;
  if (P == "1e")
    return e + "BMPString '" + ucs2hextoutf8(o(d, a)) + `'
`;
  if (P == "30") {
    if (d.substr(a, 4) == "3000")
      return e + `SEQUENCE {}
`;
    var y = e + `SEQUENCE
`, $ = l(d, a), x = r;
    if (($.length == 2 || $.length == 3) && d.substr($[0], 2) == "06" && d.substr($[$.length - 1], 2) == "04") {
      var b = n.oidname(o(d, $[0])), E = JSON.parse(JSON.stringify(r));
      E.x509ExtName = b, x = E;
    }
    for (var T = 0; T < $.length; T++)
      y = y + c(d, x, $[T], e + "  ");
    return y;
  }
  if (P == "31") {
    for (var y = e + `SET
`, $ = l(d, a), T = 0; T < $.length; T++)
      y = y + c(d, r, $[T], e + "  ");
    return y;
  }
  var P = parseInt(P, 16);
  if (P & 128) {
    var O = P & 31;
    if (P & 32) {
      for (var y = e + "[" + O + `]
`, $ = l(d, a), T = 0; T < $.length; T++)
        y = y + c(d, r, $[T], e + "  ");
      return y;
    } else {
      var g = o(d, a);
      if (ASN1HEX.isASN1HEX(g)) {
        var y = e + "[" + O + `]
`;
        return y = y + c(g, r, 0, e + "  "), y;
      } else
        (g.substr(0, 8) == "68747470" || r.x509ExtName === "subjectAltName" && O == 2) && (g = hextoutf8(g));
      var y = e + "[" + O + "] " + g + `
`;
      return y;
    }
  }
  return e + "UNKNOWN(" + P + ") " + o(d, a) + `
`;
};
ASN1HEX.parse = function(u) {
  var r = ASN1HEX, a = r.parse, e = r.isASN1HEX, n = r.getV, o = r.getTLV, c = r.getChildIdx, l = KJUR.asn1, d = l.ASN1Util.oidHexToInt, p = l.x509.OID.oid2name, h = hextoutf8, g = ucs2hextoutf8, y = iso88591hextoutf8, v = { "0c": "utf8str", 12: "numstr", 13: "prnstr", 14: "telstr", 16: "ia5str", 17: "utctime", 18: "gentime", "1a": "visstr", "1e": "bmpstr", 30: "seq", 31: "set" }, m = function(C) {
    for (var k = [], B = c(C, 0), j = 0; j < B.length; j++) {
      var J = B[j], N = o(C, J), F = a(N);
      k.push(F);
    }
    return k;
  }, b = u.substr(0, 2), R = {}, $ = n(u, 0);
  if (b == "01")
    return u == "0101ff" ? { bool: !0 } : { bool: !1 };
  if (b == "02")
    return { int: { hex: $ } };
  if (b == "03")
    try {
      if ($.substr(0, 2) != "00")
        throw "not encap";
      var x = $.substr(2);
      if (!e(x))
        throw "not encap";
      return { bitstr: { obj: a(x) } };
    } catch {
      var E = null;
      return $.length <= 10 && (E = bitstrtobinstr($)), E == null ? { bitstr: { hex: $ } } : { bitstr: { bin: E } };
    }
  else if (b == "04")
    try {
      if (!e($))
        throw "not encap";
      return { octstr: { obj: a($) } };
    } catch {
      return { octstr: { hex: $ } };
    }
  else {
    if (b == "05")
      return { null: "" };
    if (b == "06") {
      var T = d($), P = p(T);
      return P == "" ? { oid: T } : { oid: P };
    } else {
      if (b == "0a")
        return $.length > 4 ? { enum: { hex: $ } } : { enum: parseInt($, 16) };
      if (b == "30" || b == "31")
        return R[v[b]] = m(u), R;
      if (b == "14") {
        var O = y($);
        return R[v[b]] = { str: O }, R;
      } else if (b == "1e") {
        var O = g($);
        return R[v[b]] = { str: O }, R;
      } else if (":0c:12:13:16:17:18:1a:".indexOf(b) != -1) {
        var O = h($);
        return R[v[b]] = { str: O }, R;
      } else if (b.match(/^8[0-9]$/)) {
        var O = h($);
        return O == null | O == "" ? { tag: { tag: b, explicit: !1, hex: $ } } : O.match(/[\x00-\x1F\x7F-\x9F]/) != null || O.match(/[\u0000-\u001F\u0080–\u009F]/) != null ? { tag: { tag: b, explicit: !1, hex: $ } } : { tag: { tag: b, explicit: !1, str: O } };
      } else if (b.match(/^a[0-9]$/))
        try {
          if (!e($))
            throw new Error("not encap");
          return { tag: { tag: b, explicit: !0, obj: a($) } };
        } catch {
          return { tag: { tag: b, explicit: !0, hex: $ } };
        }
      else {
        var w = new KJUR.asn1.ASN1Object();
        w.hV = $;
        var _ = w.getLengthHexFromValue();
        return { asn1: { tlv: b + _ + $ } };
      }
    }
  }
};
ASN1HEX.isContextTag = function(u, r) {
  u = u.toLowerCase();
  var a, e;
  try {
    a = parseInt(u, 16);
  } catch {
    return -1;
  }
  if (r === void 0)
    return (a & 192) == 128;
  try {
    var n = r.match(/^\[[0-9]+\]$/);
    return n == null || (e = parseInt(r.substr(1, r.length - 1), 10), e > 31) ? !1 : (a & 192) == 128 && (a & 31) == e;
  } catch {
    return !1;
  }
};
ASN1HEX.isASN1HEX = function(u) {
  var r = ASN1HEX;
  if (u.length % 2 == 1)
    return !1;
  var a = r.getVblen(u, 0), e = u.substr(0, 2), n = r.getL(u, 0), o = u.length - e.length - n.length;
  return o == a * 2;
};
ASN1HEX.checkStrictDER = function(u, r, a, e, n) {
  var o = ASN1HEX;
  if (a === void 0) {
    if (typeof u != "string")
      throw new Error("not hex string");
    if (u = u.toLowerCase(), !KJUR.lang.String.isHex(u))
      throw new Error("not hex string");
    a = u.length, e = u.length / 2, e < 128 ? n = 1 : n = Math.ceil(e.toString(16)) + 1;
  }
  var c = o.getL(u, r);
  if (c.length > n * 2)
    throw new Error("L of TLV too long: idx=" + r);
  var l = o.getVblen(u, r);
  if (l > e)
    throw new Error("value of L too long than hex: idx=" + r);
  var d = o.getTLV(u, r), p = d.length - 2 - o.getL(u, r).length;
  if (p !== l * 2)
    throw new Error("V string length and L's value not the same:" + p + "/" + l * 2);
  if (r === 0 && u.length != d.length)
    throw new Error("total length and TLV length unmatch:" + u.length + "!=" + d.length);
  var h = u.substr(r, 2);
  if (h === "02") {
    var g = o.getVidx(u, r);
    if (u.substr(g, 2) == "00" && u.charCodeAt(g + 2) < 56)
      throw new Error("not least zeros for DER INTEGER");
  }
  if (parseInt(h, 16) & 32) {
    for (var y = o.getVblen(u, r), v = 0, m = o.getChildIdx(u, r), b = 0; b < m.length; b++) {
      var R = o.getTLV(u, m[b]);
      v += R.length, o.checkStrictDER(u, m[b], a, e, n);
    }
    if (y * 2 != v)
      throw new Error("sum of children's TLV length and L unmatch: " + y * 2 + "!=" + v);
  }
};
ASN1HEX.oidname = function(u) {
  var r = KJUR.asn1;
  KJUR.lang.String.isHex(u) && (u = r.ASN1Util.oidHexToInt(u));
  var a = r.x509.OID.oid2name(u);
  return a === "" && (a = u), a;
};
(typeof KJUR > "u" || !KJUR) && (KJUR = {});
(typeof KJUR.asn1 > "u" || !KJUR.asn1) && (KJUR.asn1 = {});
(typeof KJUR.asn1.x509 > "u" || !KJUR.asn1.x509) && (KJUR.asn1.x509 = {});
KJUR.asn1.x509.Certificate = function(u) {
  KJUR.asn1.x509.Certificate.superclass.constructor.call(this);
  var r = KJUR, a = r.asn1, e = a.DERBitString, n = a.DERSequence, o = a.x509, c = o.TBSCertificate, l = o.AlgorithmIdentifier;
  this.params = void 0, this.setByParam = function(d) {
    this.params = d;
  }, this.sign = function() {
    var d = this.params, p = d.sigalg;
    d.sigalg.name != null && (p = d.sigalg.name);
    var h = d.tbsobj.tohex(), g = new KJUR.crypto.Signature({ alg: p });
    g.init(d.cakey), g.updateHex(h), d.sighex = g.sign();
  }, this.getPEM = function() {
    return hextopem(this.tohex(), "CERTIFICATE");
  }, this.tohex = function() {
    var d = this.params;
    if ((d.tbsobj == null || d.tbsobj == null) && (d.tbsobj = new c(d)), d.sighex == null && d.cakey != null && this.sign(), d.sighex == null)
      throw new Error("sighex or cakey parameter not defined");
    var p = [];
    p.push(d.tbsobj), p.push(new l({ name: d.sigalg })), p.push(new e({ hex: "00" + d.sighex }));
    var h = new n({ array: p });
    return h.tohex();
  }, this.getEncodedHex = function() {
    return this.tohex();
  }, u != null && (this.params = u);
};
extendClass(KJUR.asn1.x509.Certificate, KJUR.asn1.ASN1Object);
KJUR.asn1.x509.TBSCertificate = function(u) {
  KJUR.asn1.x509.TBSCertificate.superclass.constructor.call(this);
  var r = KJUR, a = r.asn1, e = a.x509, n = a.DERTaggedObject, o = a.DERInteger, c = a.DERSequence, l = e.AlgorithmIdentifier, d = e.Time, p = e.X500Name, h = e.Extensions, g = e.SubjectPublicKeyInfo;
  this.params = null, this.setByParam = function(y) {
    this.params = y;
  }, this.tohex = function() {
    var y = [], v = this.params;
    if (v.version != null || v.version != 1) {
      var m = 2;
      v.version != null && (m = v.version - 1);
      var b = new n({ obj: new o({ int: m }) });
      y.push(b);
    }
    y.push(new o(v.serial)), y.push(new l({ name: v.sigalg })), y.push(new p(v.issuer)), y.push(new c({ array: [new d(v.notbefore), new d(v.notafter)] })), y.push(new p(v.subject)), y.push(new g(KEYUTIL.getKey(v.sbjpubkey))), v.ext !== void 0 && v.ext.length > 0 && y.push(new n({ tag: "a3", obj: new h(v.ext) }));
    var R = new KJUR.asn1.DERSequence({ array: y });
    return R.tohex();
  }, this.getEncodedHex = function() {
    return this.tohex();
  }, u !== void 0 && this.setByParam(u);
};
extendClass(KJUR.asn1.x509.TBSCertificate, KJUR.asn1.ASN1Object);
KJUR.asn1.x509.Extensions = function(u) {
  KJUR.asn1.x509.Extensions.superclass.constructor.call(this);
  var r = KJUR, a = r.asn1, e = a.DERSequence, n = a.x509;
  this.aParam = [], this.setByParam = function(o) {
    this.aParam = o;
  }, this.tohex = function() {
    for (var o = [], c = 0; c < this.aParam.length; c++) {
      var l = this.aParam[c], d = l.extname, p = null;
      if (l.extn != null)
        p = new n.PrivateExtension(l);
      else if (d == "subjectKeyIdentifier")
        p = new n.SubjectKeyIdentifier(l);
      else if (d == "keyUsage")
        p = new n.KeyUsage(l);
      else if (d == "subjectAltName")
        p = new n.SubjectAltName(l);
      else if (d == "issuerAltName")
        p = new n.IssuerAltName(l);
      else if (d == "basicConstraints")
        p = new n.BasicConstraints(l);
      else if (d == "nameConstraints")
        p = new n.NameConstraints(l);
      else if (d == "cRLDistributionPoints")
        p = new n.CRLDistributionPoints(l);
      else if (d == "certificatePolicies")
        p = new n.CertificatePolicies(l);
      else if (d == "policyMappings")
        p = new n.PolicyMappings(l);
      else if (d == "policyConstraints")
        p = new n.PolicyConstraints(l);
      else if (d == "inhibitAnyPolicy")
        p = new n.InhibitAnyPolicy(l);
      else if (d == "authorityKeyIdentifier")
        p = new n.AuthorityKeyIdentifier(l);
      else if (d == "extKeyUsage")
        p = new n.ExtKeyUsage(l);
      else if (d == "authorityInfoAccess")
        p = new n.AuthorityInfoAccess(l);
      else if (d == "cRLNumber")
        p = new n.CRLNumber(l);
      else if (d == "cRLReason")
        p = new n.CRLReason(l);
      else if (d == "ocspNonce")
        p = new n.OCSPNonce(l);
      else if (d == "ocspNoCheck")
        p = new n.OCSPNoCheck(l);
      else if (d == "adobeTimeStamp")
        p = new n.AdobeTimeStamp(l);
      else if (d == "subjectDirectoryAttributes")
        p = new n.SubjectDirectoryAttributes(l);
      else
        throw new Error("extension not supported:" + JSON.stringify(l));
      p != null && o.push(p);
    }
    var h = new e({ array: o });
    return h.tohex();
  }, this.getEncodedHex = function() {
    return this.tohex();
  }, u != null && this.setByParam(u);
};
extendClass(KJUR.asn1.x509.Extensions, KJUR.asn1.ASN1Object);
KJUR.asn1.x509.Extension = function(u) {
  KJUR.asn1.x509.Extension.superclass.constructor.call(this);
  var r = KJUR, a = r.asn1, e = a.DERObjectIdentifier, n = a.DEROctetString;
  a.DERBitString;
  var o = a.DERBoolean, c = a.DERSequence;
  this.tohex = function() {
    var l = new e({ oid: this.oid }), d = new n({ hex: this.getExtnValueHex() }), p = new Array();
    p.push(l), this.critical && p.push(new o()), p.push(d);
    var h = new c({ array: p });
    return h.tohex();
  }, this.getEncodedHex = function() {
    return this.tohex();
  }, this.critical = !1, u !== void 0 && u.critical !== void 0 && (this.critical = u.critical);
};
extendClass(KJUR.asn1.x509.Extension, KJUR.asn1.ASN1Object);
KJUR.asn1.x509.KeyUsage = function(u) {
  KJUR.asn1.x509.KeyUsage.superclass.constructor.call(this, u);
  var r = Error, a = { digitalSignature: 0, nonRepudiation: 1, keyEncipherment: 2, dataEncipherment: 3, keyAgreement: 4, keyCertSign: 5, cRLSign: 6, encipherOnly: 7, decipherOnly: 8 };
  this.getExtnValueHex = function() {
    var e = this.getBinValue();
    return this.asn1ExtnValue = new KJUR.asn1.DERBitString({ bin: e }), this.asn1ExtnValue.tohex();
  }, this.getBinValue = function() {
    var e = this.params;
    if (typeof e != "object" || typeof e.names != "object" && typeof e.bin != "string")
      throw new r("parameter not yet set");
    if (e.names != null)
      return namearraytobinstr(e.names, a);
    if (e.bin != null)
      return e.bin;
    throw new r("parameter not set properly");
  }, this.oid = "2.5.29.15", u !== void 0 && (this.params = u);
};
extendClass(KJUR.asn1.x509.KeyUsage, KJUR.asn1.x509.Extension);
KJUR.asn1.x509.BasicConstraints = function(u) {
  KJUR.asn1.x509.BasicConstraints.superclass.constructor.call(this, u);
  var r = KJUR.asn1, a = r.DERBoolean, e = r.DERInteger, n = r.DERSequence;
  this.getExtnValueHex = function() {
    var o = new Array();
    this.cA && o.push(new a()), this.pathLen > -1 && o.push(new e({ int: this.pathLen }));
    var c = new n({ array: o });
    return this.asn1ExtnValue = c, this.asn1ExtnValue.tohex();
  }, this.oid = "2.5.29.19", this.cA = !1, this.pathLen = -1, u !== void 0 && (u.cA !== void 0 && (this.cA = u.cA), u.pathLen !== void 0 && (this.pathLen = u.pathLen));
};
extendClass(KJUR.asn1.x509.BasicConstraints, KJUR.asn1.x509.Extension);
KJUR.asn1.x509.CRLDistributionPoints = function(u) {
  KJUR.asn1.x509.CRLDistributionPoints.superclass.constructor.call(this, u);
  var r = KJUR, a = r.asn1, e = a.x509;
  this.getExtnValueHex = function() {
    return this.asn1ExtnValue.tohex();
  }, this.setByDPArray = function(n) {
    for (var o = [], c = 0; c < n.length; c++)
      if (n[c] instanceof KJUR.asn1.ASN1Object)
        o.push(n[c]);
      else {
        var l = new e.DistributionPoint(n[c]);
        o.push(l);
      }
    this.asn1ExtnValue = new a.DERSequence({ array: o });
  }, this.setByOneURI = function(n) {
    var o = new e.DistributionPoint({ fulluri: n });
    this.setByDPArray([o]);
  }, this.oid = "2.5.29.31", u !== void 0 && (u.array !== void 0 ? this.setByDPArray(u.array) : u.uri !== void 0 && this.setByOneURI(u.uri));
};
extendClass(KJUR.asn1.x509.CRLDistributionPoints, KJUR.asn1.x509.Extension);
KJUR.asn1.x509.DistributionPoint = function(u) {
  KJUR.asn1.x509.DistributionPoint.superclass.constructor.call(this);
  var r = KJUR, a = r.asn1, e = a.x509.DistributionPointName;
  this.tohex = function() {
    var n = new a.DERSequence();
    if (this.asn1DP != null) {
      var o = new a.DERTaggedObject({ explicit: !0, tag: "a0", obj: this.asn1DP });
      n.appendASN1Object(o);
    }
    return this.hTLV = n.tohex(), this.hTLV;
  }, this.getEncodedHex = function() {
    return this.tohex();
  }, u !== void 0 && (u.dpobj !== void 0 ? this.asn1DP = u.dpobj : u.dpname !== void 0 ? this.asn1DP = new e(u.dpname) : u.fulluri !== void 0 && (this.asn1DP = new e({ full: [{ uri: u.fulluri }] })));
};
extendClass(KJUR.asn1.x509.DistributionPoint, KJUR.asn1.ASN1Object);
KJUR.asn1.x509.DistributionPointName = function(u) {
  KJUR.asn1.x509.DistributionPointName.superclass.constructor.call(this);
  var r = KJUR, a = r.asn1, e = a.DERTaggedObject;
  if (this.tohex = function() {
    if (this.type != "full")
      throw new Error("currently type shall be 'full': " + this.type);
    return this.asn1Obj = new e({ explicit: !1, tag: this.tag, obj: this.asn1V }), this.hTLV = this.asn1Obj.tohex(), this.hTLV;
  }, this.getEncodedHex = function() {
    return this.tohex();
  }, u !== void 0)
    if (a.x509.GeneralNames.prototype.isPrototypeOf(u))
      this.type = "full", this.tag = "a0", this.asn1V = u;
    else if (u.full !== void 0)
      this.type = "full", this.tag = "a0", this.asn1V = new a.x509.GeneralNames(u.full);
    else
      throw new Error("This class supports GeneralNames only as argument");
};
extendClass(KJUR.asn1.x509.DistributionPointName, KJUR.asn1.ASN1Object);
KJUR.asn1.x509.CertificatePolicies = function(u) {
  KJUR.asn1.x509.CertificatePolicies.superclass.constructor.call(this, u);
  var r = KJUR, a = r.asn1, e = a.x509, n = a.DERSequence, o = e.PolicyInformation;
  this.params = null, this.getExtnValueHex = function() {
    for (var c = [], l = 0; l < this.params.array.length; l++)
      c.push(new o(this.params.array[l]));
    var d = new n({ array: c });
    return this.asn1ExtnValue = d, this.asn1ExtnValue.tohex();
  }, this.oid = "2.5.29.32", u !== void 0 && (this.params = u);
};
extendClass(KJUR.asn1.x509.CertificatePolicies, KJUR.asn1.x509.Extension);
KJUR.asn1.x509.PolicyInformation = function(u) {
  KJUR.asn1.x509.PolicyInformation.superclass.constructor.call(this, u);
  var r = KJUR.asn1, a = r.DERSequence, e = r.DERObjectIdentifier, n = r.x509.PolicyQualifierInfo;
  this.params = null, this.tohex = function() {
    if (this.params.policyoid === void 0 && this.params.array === void 0)
      throw new Error("parameter oid and array missing");
    var o = [new e(this.params.policyoid)];
    if (this.params.array !== void 0) {
      for (var c = [], l = 0; l < this.params.array.length; l++)
        c.push(new n(this.params.array[l]));
      c.length > 0 && o.push(new a({ array: c }));
    }
    var d = new a({ array: o });
    return d.tohex();
  }, this.getEncodedHex = function() {
    return this.tohex();
  }, u !== void 0 && (this.params = u);
};
extendClass(KJUR.asn1.x509.PolicyInformation, KJUR.asn1.ASN1Object);
KJUR.asn1.x509.PolicyQualifierInfo = function(u) {
  KJUR.asn1.x509.PolicyQualifierInfo.superclass.constructor.call(this, u);
  var r = KJUR.asn1, a = r.DERSequence, e = r.DERIA5String, n = r.DERObjectIdentifier, o = r.x509.UserNotice;
  this.params = null, this.tohex = function() {
    if (this.params.cps !== void 0) {
      var c = new a({ array: [new n({ oid: "1.3.6.1.5.5.7.2.1" }), new e({ str: this.params.cps })] });
      return c.tohex();
    }
    if (this.params.unotice != null) {
      var c = new a({ array: [new n({ oid: "1.3.6.1.5.5.7.2.2" }), new o(this.params.unotice)] });
      return c.tohex();
    }
  }, this.getEncodedHex = function() {
    return this.tohex();
  }, u !== void 0 && (this.params = u);
};
extendClass(KJUR.asn1.x509.PolicyQualifierInfo, KJUR.asn1.ASN1Object);
KJUR.asn1.x509.UserNotice = function(u) {
  KJUR.asn1.x509.UserNotice.superclass.constructor.call(this, u);
  var r = KJUR.asn1.DERSequence;
  KJUR.asn1.DERInteger;
  var a = KJUR.asn1.x509.DisplayText, e = KJUR.asn1.x509.NoticeReference;
  this.params = null, this.tohex = function() {
    var n = [];
    this.params.noticeref !== void 0 && n.push(new e(this.params.noticeref)), this.params.exptext !== void 0 && n.push(new a(this.params.exptext));
    var o = new r({ array: n });
    return o.tohex();
  }, this.getEncodedHex = function() {
    return this.tohex();
  }, u !== void 0 && (this.params = u);
};
extendClass(KJUR.asn1.x509.UserNotice, KJUR.asn1.ASN1Object);
KJUR.asn1.x509.NoticeReference = function(u) {
  KJUR.asn1.x509.NoticeReference.superclass.constructor.call(this, u);
  var r = KJUR.asn1.DERSequence, a = KJUR.asn1.DERInteger, e = KJUR.asn1.x509.DisplayText;
  this.params = null, this.tohex = function() {
    var n = [];
    if (this.params.org !== void 0 && n.push(new e(this.params.org)), this.params.noticenum !== void 0) {
      for (var o = [], c = this.params.noticenum, l = 0; l < c.length; l++)
        o.push(new a(c[l]));
      n.push(new r({ array: o }));
    }
    if (n.length == 0)
      throw new Error("parameter is empty");
    var d = new r({ array: n });
    return d.tohex();
  }, this.getEncodedHex = function() {
    return this.tohex();
  }, u !== void 0 && (this.params = u);
};
extendClass(KJUR.asn1.x509.NoticeReference, KJUR.asn1.ASN1Object);
KJUR.asn1.x509.DisplayText = function(u) {
  KJUR.asn1.x509.DisplayText.superclass.constructor.call(this, u), this.hT = "0c", u !== void 0 && (u.type === "ia5" ? this.hT = "16" : u.type === "vis" ? this.hT = "1a" : u.type === "bmp" && (this.hT = "1e"));
};
extendClass(KJUR.asn1.x509.DisplayText, KJUR.asn1.DERAbstractString);
KJUR.asn1.x509.PolicyMappings = function(u) {
  KJUR.asn1.x509.PolicyMappings.superclass.constructor.call(this, u);
  var r = KJUR, a = r.asn1;
  a.x509;
  var e = a.ASN1Util.newObject;
  this.params = null, this.getExtnValueHex = function() {
    for (var n = this.params, o = [], c = 0; c < n.array.length; c++) {
      var l = n.array[c];
      o.push({ seq: [{ oid: l[0] }, { oid: l[1] }] });
    }
    return this.asn1ExtnValue = e({ seq: o }), this.asn1ExtnValue.tohex();
  }, this.oid = "2.5.29.33", u !== void 0 && (this.params = u);
};
extendClass(KJUR.asn1.x509.PolicyMappings, KJUR.asn1.x509.Extension);
KJUR.asn1.x509.PolicyConstraints = function(u) {
  KJUR.asn1.x509.PolicyConstraints.superclass.constructor.call(this, u);
  var r = KJUR, a = r.asn1;
  a.x509;
  var e = a.ASN1Util.newObject;
  this.params = null, this.getExtnValueHex = function() {
    var n = this.params, o = [];
    return n.reqexp != null && o.push({ tag: { tagi: "80", obj: { int: n.reqexp } } }), n.inhibit != null && o.push({ tag: { tagi: "81", obj: { int: n.inhibit } } }), this.asn1ExtnValue = e({ seq: o }), this.asn1ExtnValue.tohex();
  }, this.oid = "2.5.29.36", u !== void 0 && (this.params = u);
};
extendClass(KJUR.asn1.x509.PolicyConstraints, KJUR.asn1.x509.Extension);
KJUR.asn1.x509.InhibitAnyPolicy = function(u) {
  KJUR.asn1.x509.InhibitAnyPolicy.superclass.constructor.call(this, u);
  var r = KJUR, a = r.asn1;
  a.x509;
  var e = a.ASN1Util.newObject;
  this.params = null, this.getExtnValueHex = function() {
    return this.asn1ExtnValue = e({ int: this.params.skip }), this.asn1ExtnValue.tohex();
  }, this.oid = "2.5.29.54", u !== void 0 && (this.params = u);
};
extendClass(KJUR.asn1.x509.InhibitAnyPolicy, KJUR.asn1.x509.Extension);
KJUR.asn1.x509.NameConstraints = function(u) {
  KJUR.asn1.x509.NameConstraints.superclass.constructor.call(this, u);
  var r = KJUR, a = r.asn1, e = a.x509, n = a.ASN1Util.newObject, o = e.GeneralSubtree;
  this.params = null, this.getExtnValueHex = function() {
    var c = this.params, l = [];
    if (c.permit != null && c.permit.length != null) {
      for (var d = [], p = 0; p < c.permit.length; p++)
        d.push(new o(c.permit[p]));
      l.push({ tag: { tagi: "a0", obj: { seq: d } } });
    }
    if (c.exclude != null && c.exclude.length != null) {
      for (var h = [], p = 0; p < c.exclude.length; p++)
        h.push(new o(c.exclude[p]));
      l.push({ tag: { tagi: "a1", obj: { seq: h } } });
    }
    return this.asn1ExtnValue = n({ seq: l }), this.asn1ExtnValue.tohex();
  }, this.oid = "2.5.29.30", u !== void 0 && (this.params = u);
};
extendClass(KJUR.asn1.x509.NameConstraints, KJUR.asn1.x509.Extension);
KJUR.asn1.x509.GeneralSubtree = function(u) {
  KJUR.asn1.x509.GeneralSubtree.superclass.constructor.call(this);
  var r = KJUR.asn1, a = r.x509, e = a.GeneralName, n = r.ASN1Util.newObject;
  this.params = null, this.setByParam = function(o) {
    this.params = o;
  }, this.tohex = function() {
    var o = this.params, c = [new e(o)];
    o.min != null && c.push({ tag: { tagi: "80", obj: { int: o.min } } }), o.max != null && c.push({ tag: { tagi: "81", obj: { int: o.max } } });
    var l = n({ seq: c });
    return l.tohex();
  }, this.getEncodedHex = function() {
    return this.tohex();
  }, u !== void 0 && this.setByParam(u);
};
extendClass(KJUR.asn1.x509.GeneralSubtree, KJUR.asn1.ASN1Object);
KJUR.asn1.x509.ExtKeyUsage = function(u) {
  KJUR.asn1.x509.ExtKeyUsage.superclass.constructor.call(this, u);
  var r = KJUR, a = r.asn1;
  this.setPurposeArray = function(e) {
    this.asn1ExtnValue = new a.DERSequence();
    for (var n = 0; n < e.length; n++) {
      var o = new a.DERObjectIdentifier(e[n]);
      this.asn1ExtnValue.appendASN1Object(o);
    }
  }, this.getExtnValueHex = function() {
    return this.asn1ExtnValue.tohex();
  }, this.oid = "2.5.29.37", u !== void 0 && u.array !== void 0 && this.setPurposeArray(u.array);
};
extendClass(KJUR.asn1.x509.ExtKeyUsage, KJUR.asn1.x509.Extension);
KJUR.asn1.x509.AuthorityKeyIdentifier = function(u) {
  KJUR.asn1.x509.AuthorityKeyIdentifier.superclass.constructor.call(this, u);
  var r = KJUR, a = r.asn1, e = a.DERTaggedObject, n = a.x509.GeneralNames;
  r.crypto.Util.isKey, this.asn1KID = null, this.asn1CertIssuer = null, this.asn1CertSN = null, this.getExtnValueHex = function() {
    var o = new Array();
    this.asn1KID && o.push(new e({ explicit: !1, tag: "80", obj: this.asn1KID })), this.asn1CertIssuer && o.push(new e({ explicit: !1, tag: "a1", obj: new n([{ dn: this.asn1CertIssuer }]) })), this.asn1CertSN && o.push(new e({ explicit: !1, tag: "82", obj: this.asn1CertSN }));
    var c = new a.DERSequence({ array: o });
    return this.asn1ExtnValue = c, this.asn1ExtnValue.tohex();
  }, this.setKIDByParam = function(o) {
    if (o.str !== void 0 || o.hex !== void 0)
      this.asn1KID = new KJUR.asn1.DEROctetString(o);
    else if (typeof o == "object" && KJUR.crypto.Util.isKey(o) || typeof o == "string" && o.indexOf("BEGIN ") != -1) {
      var c = o;
      typeof o == "string" && (c = KEYUTIL.getKey(o));
      var l = KEYUTIL.getKeyID(c);
      this.asn1KID = new KJUR.asn1.DEROctetString({ hex: l });
    }
  }, this.setCertIssuerByParam = function(o) {
    o.str !== void 0 || o.ldapstr !== void 0 || o.hex !== void 0 || o.certsubject !== void 0 || o.certissuer !== void 0 ? this.asn1CertIssuer = new KJUR.asn1.x509.X500Name(o) : typeof o == "string" && o.indexOf("BEGIN ") != -1 && o.indexOf("CERTIFICATE") != -1 && (this.asn1CertIssuer = new KJUR.asn1.x509.X500Name({ certissuer: o }));
  }, this.setCertSNByParam = function(o) {
    if (o.str !== void 0 || o.bigint !== void 0 || o.hex !== void 0)
      this.asn1CertSN = new KJUR.asn1.DERInteger(o);
    else if (typeof o == "string" && o.indexOf("BEGIN ") != -1 && o.indexOf("CERTIFICATE")) {
      var c = new X509();
      c.readCertPEM(o);
      var l = c.getSerialNumberHex();
      this.asn1CertSN = new KJUR.asn1.DERInteger({ hex: l });
    }
  }, this.oid = "2.5.29.35", u !== void 0 && (u.kid !== void 0 && this.setKIDByParam(u.kid), u.issuer !== void 0 && this.setCertIssuerByParam(u.issuer), u.sn !== void 0 && this.setCertSNByParam(u.sn), u.issuersn !== void 0 && typeof u.issuersn == "string" && u.issuersn.indexOf("BEGIN ") != -1 && u.issuersn.indexOf("CERTIFICATE") && (this.setCertSNByParam(u.issuersn), this.setCertIssuerByParam(u.issuersn)));
};
extendClass(KJUR.asn1.x509.AuthorityKeyIdentifier, KJUR.asn1.x509.Extension);
KJUR.asn1.x509.SubjectKeyIdentifier = function(u) {
  KJUR.asn1.x509.SubjectKeyIdentifier.superclass.constructor.call(this, u);
  var r = KJUR, a = r.asn1, e = a.DEROctetString;
  this.asn1KID = null, this.getExtnValueHex = function() {
    return this.asn1ExtnValue = this.asn1KID, this.asn1ExtnValue.tohex();
  }, this.setKIDByParam = function(n) {
    if (n.str !== void 0 || n.hex !== void 0)
      this.asn1KID = new e(n);
    else if (typeof n == "object" && KJUR.crypto.Util.isKey(n) || typeof n == "string" && n.indexOf("BEGIN") != -1) {
      var o = n;
      typeof n == "string" && (o = KEYUTIL.getKey(n));
      var c = KEYUTIL.getKeyID(o);
      this.asn1KID = new KJUR.asn1.DEROctetString({ hex: c });
    }
  }, this.oid = "2.5.29.14", u !== void 0 && u.kid !== void 0 && this.setKIDByParam(u.kid);
};
extendClass(KJUR.asn1.x509.SubjectKeyIdentifier, KJUR.asn1.x509.Extension);
KJUR.asn1.x509.AuthorityInfoAccess = function(u) {
  KJUR.asn1.x509.AuthorityInfoAccess.superclass.constructor.call(this, u), this.setAccessDescriptionArray = function(r) {
    for (var a = new Array(), e = KJUR, n = e.asn1, o = n.DERSequence, c = n.DERObjectIdentifier, l = n.x509.GeneralName, d = 0; d < r.length; d++) {
      var p, h = r[d];
      if (h.ocsp !== void 0)
        p = new o({ array: [new c({ oid: "1.3.6.1.5.5.7.48.1" }), new l({ uri: h.ocsp })] });
      else if (h.caissuer !== void 0)
        p = new o({ array: [new c({ oid: "1.3.6.1.5.5.7.48.2" }), new l({ uri: h.caissuer })] });
      else
        throw new Error("unknown AccessMethod parameter: " + JSON.stringify(h));
      a.push(p);
    }
    this.asn1ExtnValue = new o({ array: a });
  }, this.getExtnValueHex = function() {
    return this.asn1ExtnValue.tohex();
  }, this.oid = "1.3.6.1.5.5.7.1.1", u !== void 0 && u.array !== void 0 && this.setAccessDescriptionArray(u.array);
};
extendClass(KJUR.asn1.x509.AuthorityInfoAccess, KJUR.asn1.x509.Extension);
KJUR.asn1.x509.SubjectAltName = function(u) {
  KJUR.asn1.x509.SubjectAltName.superclass.constructor.call(this, u), this.setNameArray = function(r) {
    this.asn1ExtnValue = new KJUR.asn1.x509.GeneralNames(r);
  }, this.getExtnValueHex = function() {
    return this.asn1ExtnValue.tohex();
  }, this.oid = "2.5.29.17", u !== void 0 && u.array !== void 0 && this.setNameArray(u.array);
};
extendClass(KJUR.asn1.x509.SubjectAltName, KJUR.asn1.x509.Extension);
KJUR.asn1.x509.IssuerAltName = function(u) {
  KJUR.asn1.x509.IssuerAltName.superclass.constructor.call(this, u), this.setNameArray = function(r) {
    this.asn1ExtnValue = new KJUR.asn1.x509.GeneralNames(r);
  }, this.getExtnValueHex = function() {
    return this.asn1ExtnValue.tohex();
  }, this.oid = "2.5.29.18", u !== void 0 && u.array !== void 0 && this.setNameArray(u.array);
};
extendClass(KJUR.asn1.x509.IssuerAltName, KJUR.asn1.x509.Extension);
KJUR.asn1.x509.SubjectDirectoryAttributes = function(u) {
  KJUR.asn1.x509.SubjectDirectoryAttributes.superclass.constructor.call(this, u);
  var r = KJUR.asn1, a = r.DERSequence, e = r.ASN1Util.newObject, n = r.x509.OID.name2oid;
  this.params = null, this.getExtnValueHex = function() {
    for (var o = [], c = 0; c < this.params.array.length; c++) {
      var l = this.params.array[c];
      if (l.attr != null && l.array != null) {
        var d = { seq: [{ oid: l.attr }, { set: l.array }] };
        o.push(e(d));
        continue;
      }
      var p = { seq: [{ oid: "1.2.3.4" }, { set: [{ utf8str: "DE" }] }] };
      if (l.attr == "dateOfBirth")
        p.seq[0].oid = n(l.attr), p.seq[1].set[0] = { gentime: l.str };
      else if (l.attr == "placeOfBirth")
        p.seq[0].oid = n(l.attr), p.seq[1].set[0] = { utf8str: l.str };
      else if (l.attr == "gender")
        p.seq[0].oid = n(l.attr), p.seq[1].set[0] = { prnstr: l.str };
      else if (l.attr == "countryOfCitizenship")
        p.seq[0].oid = n(l.attr), p.seq[1].set[0] = { prnstr: l.str };
      else if (l.attr == "countryOfResidence")
        p.seq[0].oid = n(l.attr), p.seq[1].set[0] = { prnstr: l.str };
      else
        throw new Error("unsupported attribute: " + l.attr);
      o.push(new e(p));
    }
    var h = new a({ array: o });
    return this.asn1ExtnValue = h, this.asn1ExtnValue.tohex();
  }, this.oid = "2.5.29.9", u !== void 0 && (this.params = u);
};
extendClass(KJUR.asn1.x509.SubjectDirectoryAttributes, KJUR.asn1.x509.Extension);
KJUR.asn1.x509.PrivateExtension = function(u) {
  KJUR.asn1.x509.PrivateExtension.superclass.constructor.call(this, u);
  var r = KJUR, a = r.lang.String.isHex, e = r.asn1, n = e.x509.OID.name2oid, o = e.ASN1Util.newObject;
  this.params = null, this.setByParam = function(c) {
    this.oid = n(c.extname), this.params = c;
  }, this.getExtnValueHex = function() {
    if (this.params.extname == null || this.params.extn == null)
      throw new Error("extname or extnhex not specified");
    var c = this.params.extn;
    if (typeof c == "string" && a(c))
      return c;
    if (typeof c == "object")
      try {
        return o(c).tohex();
      } catch {
      }
    throw new Error("unsupported extn value");
  }, u != null && this.setByParam(u);
};
extendClass(KJUR.asn1.x509.PrivateExtension, KJUR.asn1.x509.Extension);
KJUR.asn1.x509.CRL = function(u) {
  KJUR.asn1.x509.CRL.superclass.constructor.call(this);
  var r = KJUR, a = r.asn1, e = a.DERSequence, n = a.DERBitString, o = a.x509, c = o.AlgorithmIdentifier, l = o.TBSCertList;
  this.params = void 0, this.setByParam = function(d) {
    this.params = d;
  }, this.sign = function() {
    var d = new l(this.params).tohex(), p = new KJUR.crypto.Signature({ alg: this.params.sigalg });
    p.init(this.params.cakey), p.updateHex(d);
    var h = p.sign();
    this.params.sighex = h;
  }, this.getPEM = function() {
    return hextopem(this.tohex(), "X509 CRL");
  }, this.tohex = function() {
    var d = this.params;
    if (d.tbsobj == null && (d.tbsobj = new l(d)), d.sighex == null && d.cakey != null && this.sign(), d.sighex == null)
      throw new Error("sighex or cakey parameter not defined");
    var p = [];
    p.push(d.tbsobj), p.push(new c({ name: d.sigalg })), p.push(new n({ hex: "00" + d.sighex }));
    var h = new e({ array: p });
    return h.tohex();
  }, this.getEncodedHex = function() {
    return this.tohex();
  }, u != null && (this.params = u);
};
extendClass(KJUR.asn1.x509.CRL, KJUR.asn1.ASN1Object);
KJUR.asn1.x509.TBSCertList = function(u) {
  KJUR.asn1.x509.TBSCertList.superclass.constructor.call(this);
  var r = KJUR, a = r.asn1, e = a.DERInteger, n = a.DERSequence, o = a.DERTaggedObject;
  a.DERObjectIdentifier;
  var c = a.x509, l = c.AlgorithmIdentifier, d = c.Time, p = c.Extensions, h = c.X500Name;
  this.params = null, this.setByParam = function(g) {
    this.params = g;
  }, this.getRevCertSequence = function() {
    for (var g = [], y = this.params.revcert, v = 0; v < y.length; v++) {
      var m = [new e(y[v].sn), new d(y[v].date)];
      y[v].ext != null && m.push(new p(y[v].ext)), g.push(new n({ array: m }));
    }
    return new n({ array: g });
  }, this.tohex = function() {
    var g = [], y = this.params;
    if (y.version != null) {
      var v = y.version - 1, m = new e({ int: v });
      g.push(m);
    }
    if (g.push(new l({ name: y.sigalg })), g.push(new h(y.issuer)), g.push(new d(y.thisupdate)), y.nextupdate != null && g.push(new d(y.nextupdate)), y.revcert != null && g.push(this.getRevCertSequence()), y.ext != null) {
      var b = new p(y.ext);
      g.push(new o({ tag: "a0", explicit: !0, obj: b }));
    }
    var R = new n({ array: g });
    return R.tohex();
  }, this.getEncodedHex = function() {
    return this.tohex();
  }, u !== void 0 && this.setByParam(u);
};
extendClass(KJUR.asn1.x509.TBSCertList, KJUR.asn1.ASN1Object);
KJUR.asn1.x509.CRLEntry = function(u) {
  KJUR.asn1.x509.CRLEntry.superclass.constructor.call(this);
  var r = KJUR, a = r.asn1;
  this.setCertSerial = function(e) {
    this.sn = new a.DERInteger(e);
  }, this.setRevocationDate = function(e) {
    this.time = new a.x509.Time(e);
  }, this.tohex = function() {
    var e = new a.DERSequence({ array: [this.sn, this.time] });
    return this.TLV = e.tohex(), this.TLV;
  }, this.getEncodedHex = function() {
    return this.tohex();
  }, u !== void 0 && (u.time !== void 0 && this.setRevocationDate(u.time), u.sn !== void 0 && this.setCertSerial(u.sn));
};
extendClass(KJUR.asn1.x509.CRLEntry, KJUR.asn1.ASN1Object);
KJUR.asn1.x509.CRLNumber = function(u) {
  KJUR.asn1.x509.CRLNumber.superclass.constructor.call(this, u), this.params = void 0, this.getExtnValueHex = function() {
    return this.asn1ExtnValue = new KJUR.asn1.DERInteger(this.params.num), this.asn1ExtnValue.tohex();
  }, this.oid = "2.5.29.20", u != null && (this.params = u);
};
extendClass(KJUR.asn1.x509.CRLNumber, KJUR.asn1.x509.Extension);
KJUR.asn1.x509.CRLReason = function(u) {
  KJUR.asn1.x509.CRLReason.superclass.constructor.call(this, u), this.params = void 0, this.getExtnValueHex = function() {
    return this.asn1ExtnValue = new KJUR.asn1.DEREnumerated(this.params.code), this.asn1ExtnValue.tohex();
  }, this.oid = "2.5.29.21", u != null && (this.params = u);
};
extendClass(KJUR.asn1.x509.CRLReason, KJUR.asn1.x509.Extension);
KJUR.asn1.x509.OCSPNonce = function(u) {
  KJUR.asn1.x509.OCSPNonce.superclass.constructor.call(this, u), this.params = void 0, this.getExtnValueHex = function() {
    return this.asn1ExtnValue = new KJUR.asn1.DEROctetString(this.params), this.asn1ExtnValue.tohex();
  }, this.oid = "1.3.6.1.5.5.7.48.1.2", u != null && (this.params = u);
};
extendClass(KJUR.asn1.x509.OCSPNonce, KJUR.asn1.x509.Extension);
KJUR.asn1.x509.OCSPNoCheck = function(u) {
  KJUR.asn1.x509.OCSPNoCheck.superclass.constructor.call(this, u), this.params = void 0, this.getExtnValueHex = function() {
    return this.asn1ExtnValue = new KJUR.asn1.DERNull(), this.asn1ExtnValue.tohex();
  }, this.oid = "1.3.6.1.5.5.7.48.1.5", u != null && (this.params = u);
};
extendClass(KJUR.asn1.x509.OCSPNoCheck, KJUR.asn1.x509.Extension);
KJUR.asn1.x509.AdobeTimeStamp = function(u) {
  KJUR.asn1.x509.AdobeTimeStamp.superclass.constructor.call(this, u);
  var r = KJUR, a = r.asn1, e = a.DERInteger, n = a.DERBoolean, o = a.DERSequence, c = a.x509.GeneralName;
  this.params = null, this.getExtnValueHex = function() {
    var l = this.params, d = [new e(1)];
    return d.push(new c({ uri: l.uri })), l.reqauth != null && d.push(new n(l.reqauth)), this.asn1ExtnValue = new o({ array: d }), this.asn1ExtnValue.tohex();
  }, this.oid = "1.2.840.113583.1.1.9.1", u !== void 0 && this.setByParam(u);
};
extendClass(KJUR.asn1.x509.AdobeTimeStamp, KJUR.asn1.x509.Extension);
KJUR.asn1.x509.X500Name = function(u) {
  KJUR.asn1.x509.X500Name.superclass.constructor.call(this), this.asn1Array = [], this.paramArray = [], this.sRule = "utf8";
  var r = KJUR, a = r.asn1, e = a.x509, n = e.RDN;
  this.setByString = function(o, c) {
    c !== void 0 && (this.sRule = c);
    var l = o.split("/");
    l.shift();
    for (var d = [], p = 0; p < l.length; p++)
      if (l[p].match(/^[^=]+=.+$/))
        d.push(l[p]);
      else {
        var h = d.length - 1;
        d[h] = d[h] + "/" + l[p];
      }
    for (var p = 0; p < d.length; p++)
      this.asn1Array.push(new n({ str: d[p], rule: this.sRule }));
  }, this.setByLdapString = function(o, c) {
    c !== void 0 && (this.sRule = c);
    var l = e.X500Name.ldapToCompat(o);
    this.setByString(l, c);
  }, this.setByObject = function(o, c) {
    c !== void 0 && (this.sRule = c);
    for (var l in o)
      if (o.hasOwnProperty(l)) {
        var d = new n({ str: l + "=" + o[l], rule: this.sRule });
        this.asn1Array ? this.asn1Array.push(d) : this.asn1Array = [d];
      }
  }, this.setByParam = function(o) {
    if (o.rule !== void 0 && (this.sRule = o.rule), o.array !== void 0)
      this.paramArray = o.array;
    else if (o.str !== void 0)
      this.setByString(o.str);
    else if (o.ldapstr !== void 0)
      this.setByLdapString(o.ldapstr);
    else if (o.hex !== void 0)
      this.hTLV = o.hex;
    else if (o.certissuer !== void 0) {
      var c = new X509();
      c.readCertPEM(o.certissuer), this.hTLV = c.getIssuerHex();
    } else if (o.certsubject !== void 0) {
      var c = new X509();
      c.readCertPEM(o.certsubject), this.hTLV = c.getSubjectHex();
    } else
      typeof o == "object" && o.certsubject === void 0 && o.certissuer === void 0 && this.setByObject(o);
  }, this.tohex = function() {
    if (typeof this.hTLV == "string")
      return this.hTLV;
    if (this.asn1Array.length == 0 && this.paramArray.length > 0)
      for (var o = 0; o < this.paramArray.length; o++) {
        var c = { array: this.paramArray[o] };
        this.sRule != "utf8" && (c.rule = this.sRule);
        var l = new n(c);
        this.asn1Array.push(l);
      }
    var d = new a.DERSequence({ array: this.asn1Array });
    return this.hTLV = d.tohex(), this.hTLV;
  }, this.getEncodedHex = function() {
    return this.tohex();
  }, u !== void 0 && this.setByParam(u);
};
extendClass(KJUR.asn1.x509.X500Name, KJUR.asn1.ASN1Object);
KJUR.asn1.x509.X500Name.compatToLDAP = function(u) {
  if (u.substr(0, 1) !== "/")
    throw "malformed input";
  u = u.substr(1);
  var r = u.split("/");
  return r.reverse(), r = r.map(function(a) {
    return a.replace(/,/, "\\,");
  }), r.join(",");
};
KJUR.asn1.x509.X500Name.onelineToLDAP = function(u) {
  return KJUR.asn1.x509.X500Name.compatToLDAP(u);
};
KJUR.asn1.x509.X500Name.ldapToCompat = function(u) {
  for (var r = u.split(","), a = !1, e = [], n = 0; r.length > 0; n++) {
    var o = r.shift();
    if (a === !0) {
      var c = e.pop(), l = (c + "," + o).replace(/\\,/g, ",");
      e.push(l), a = !1;
    } else
      e.push(o);
    o.substr(-1, 1) === "\\" && (a = !0);
  }
  return e = e.map(function(d) {
    return d.replace("/", "\\/");
  }), e.reverse(), "/" + e.join("/");
};
KJUR.asn1.x509.X500Name.ldapToOneline = function(u) {
  return KJUR.asn1.x509.X500Name.ldapToCompat(u);
};
KJUR.asn1.x509.RDN = function(u) {
  KJUR.asn1.x509.RDN.superclass.constructor.call(this), this.asn1Array = [], this.paramArray = [], this.sRule = "utf8";
  var r = KJUR.asn1.x509.AttributeTypeAndValue;
  this.setByParam = function(a) {
    a.rule !== void 0 && (this.sRule = a.rule), a.str !== void 0 && this.addByMultiValuedString(a.str), a.array !== void 0 && (this.paramArray = a.array);
  }, this.addByString = function(a) {
    this.asn1Array.push(new KJUR.asn1.x509.AttributeTypeAndValue({ str: a, rule: this.sRule }));
  }, this.addByMultiValuedString = function(a) {
    for (var e = KJUR.asn1.x509.RDN.parseString(a), n = 0; n < e.length; n++)
      this.addByString(e[n]);
  }, this.tohex = function() {
    if (this.asn1Array.length == 0 && this.paramArray.length > 0)
      for (var a = 0; a < this.paramArray.length; a++) {
        var e = this.paramArray[a];
        e.rule !== void 0 && this.sRule != "utf8" && (e.rule = this.sRule);
        var n = new r(e);
        this.asn1Array.push(n);
      }
    var o = new KJUR.asn1.DERSet({ array: this.asn1Array });
    return this.TLV = o.tohex(), this.TLV;
  }, this.getEncodedHex = function() {
    return this.tohex();
  }, u !== void 0 && this.setByParam(u);
};
extendClass(KJUR.asn1.x509.RDN, KJUR.asn1.ASN1Object);
KJUR.asn1.x509.RDN.parseString = function(u) {
  for (var r = u.split(/\+/), a = !1, e = [], n = 0; r.length > 0; n++) {
    var o = r.shift();
    if (a === !0) {
      var c = e.pop(), l = (c + "+" + o).replace(/\\\+/g, "+");
      e.push(l), a = !1;
    } else
      e.push(o);
    o.substr(-1, 1) === "\\" && (a = !0);
  }
  for (var d = !1, p = [], n = 0; e.length > 0; n++) {
    var o = e.shift();
    if (d === !0) {
      var h = p.pop();
      if (o.match(/"$/)) {
        var l = (h + "+" + o).replace(/^([^=]+)="(.*)"$/, "$1=$2");
        p.push(l), d = !1;
      } else
        p.push(h + "+" + o);
    } else
      p.push(o);
    o.match(/^[^=]+="/) && (d = !0);
  }
  return p;
};
KJUR.asn1.x509.AttributeTypeAndValue = function(u) {
  KJUR.asn1.x509.AttributeTypeAndValue.superclass.constructor.call(this), this.sRule = "utf8", this.sType = null, this.sValue = null, this.dsType = null;
  var r = KJUR, a = r.asn1, e = a.DERSequence, n = a.DERUTF8String, o = a.DERPrintableString, c = a.DERTeletexString, l = a.DERIA5String, d = a.DERVisibleString, p = a.DERBMPString, h = r.lang.String.isMail, g = r.lang.String.isPrintable;
  this.setByParam = function(y) {
    if (y.rule !== void 0 && (this.sRule = y.rule), y.ds !== void 0 && (this.dsType = y.ds), y.value === void 0 && y.str !== void 0) {
      var v = y.str, m = v.match(/^([^=]+)=(.+)$/);
      if (m)
        this.sType = m[1], this.sValue = m[2];
      else
        throw new Error("malformed attrTypeAndValueStr: " + attrTypeAndValueStr);
    } else
      this.sType = y.type, this.sValue = y.value;
  }, this.setByString = function(y, v) {
    v !== void 0 && (this.sRule = v);
    var m = y.match(/^([^=]+)=(.+)$/);
    if (m)
      this.setByAttrTypeAndValueStr(m[1], m[2]);
    else
      throw new Error("malformed attrTypeAndValueStr: " + attrTypeAndValueStr);
  }, this._getDsType = function() {
    var y = this.sType, v = this.sValue, m = this.sRule;
    return m === "prn" ? y == "CN" && h(v) ? "ia5" : g(v) ? "prn" : "utf8" : m === "utf8" ? y == "CN" && h(v) ? "ia5" : y == "C" ? "prn" : "utf8" : "utf8";
  }, this.setByAttrTypeAndValueStr = function(y, v, m) {
    m !== void 0 && (this.sRule = m), this.sType = y, this.sValue = v;
  }, this.getValueObj = function(y, v) {
    if (y == "utf8")
      return new n({ str: v });
    if (y == "prn")
      return new o({ str: v });
    if (y == "tel")
      return new c({ str: v });
    if (y == "ia5")
      return new l({ str: v });
    if (y == "vis")
      return new d({ str: v });
    if (y == "bmp")
      return new p({ str: v });
    throw new Error("unsupported directory string type: type=" + y + " value=" + v);
  }, this.tohex = function() {
    this.dsType == null && (this.dsType = this._getDsType());
    var y = KJUR.asn1.x509.OID.atype2obj(this.sType), v = this.getValueObj(this.dsType, this.sValue), m = new e({ array: [y, v] });
    return this.TLV = m.tohex(), this.TLV;
  }, this.getEncodedHex = function() {
    return this.tohex();
  }, u !== void 0 && this.setByParam(u);
};
extendClass(KJUR.asn1.x509.AttributeTypeAndValue, KJUR.asn1.ASN1Object);
KJUR.asn1.x509.SubjectPublicKeyInfo = function(u) {
  KJUR.asn1.x509.SubjectPublicKeyInfo.superclass.constructor.call(this);
  var r = KJUR, a = r.asn1, e = a.DERInteger, n = a.DERBitString, o = a.DERObjectIdentifier, c = a.DERSequence, l = a.ASN1Util.newObject, d = a.x509, p = d.AlgorithmIdentifier, h = r.crypto;
  h.ECDSA, h.DSA, this.getASN1Object = function() {
    if (this.asn1AlgId == null || this.asn1SubjPKey == null)
      throw "algId and/or subjPubKey not set";
    var g = new c({ array: [this.asn1AlgId, this.asn1SubjPKey] });
    return g;
  }, this.tohex = function() {
    var g = this.getASN1Object();
    return this.hTLV = g.tohex(), this.hTLV;
  }, this.getEncodedHex = function() {
    return this.tohex();
  }, this.setPubKey = function(g) {
    try {
      if (g instanceof RSAKey) {
        var y = l({ seq: [{ int: { bigint: g.n } }, { int: { int: g.e } }] }), v = y.tohex();
        this.asn1AlgId = new p({ name: "rsaEncryption" }), this.asn1SubjPKey = new n({ hex: "00" + v });
      }
    } catch {
    }
    try {
      if (g instanceof KJUR.crypto.ECDSA) {
        var m = new o({ name: g.curveName });
        this.asn1AlgId = new p({ name: "ecPublicKey", asn1params: m }), this.asn1SubjPKey = new n({ hex: "00" + g.pubKeyHex });
      }
    } catch {
    }
    try {
      if (g instanceof KJUR.crypto.DSA) {
        var m = new l({ seq: [{ int: { bigint: g.p } }, { int: { bigint: g.q } }, { int: { bigint: g.g } }] });
        this.asn1AlgId = new p({ name: "dsa", asn1params: m });
        var b = new e({ bigint: g.y });
        this.asn1SubjPKey = new n({ hex: "00" + b.tohex() });
      }
    } catch {
    }
  }, u !== void 0 && this.setPubKey(u);
};
extendClass(KJUR.asn1.x509.SubjectPublicKeyInfo, KJUR.asn1.ASN1Object);
KJUR.asn1.x509.Time = function(u) {
  KJUR.asn1.x509.Time.superclass.constructor.call(this);
  var r = KJUR, a = r.asn1, e = a.DERUTCTime, n = a.DERGeneralizedTime;
  this.params = null, this.type = null, this.setTimeParams = function(o) {
    this.timeParams = o;
  }, this.setByParam = function(o) {
    this.params = o;
  }, this.getType = function(o) {
    return o.match(/^[0-9]{12}Z$/) ? "utc" : o.match(/^[0-9]{14}Z$/) ? "gen" : o.match(/^[0-9]{12}\.[0-9]+Z$/) ? "utc" : o.match(/^[0-9]{14}\.[0-9]+Z$/) ? "gen" : null;
  }, this.tohex = function() {
    var o = this.params, c = null;
    if (typeof o == "string" && (o = { str: o }), o != null && o.str && (o.type == null || o.type == null) && (o.type = this.getType(o.str)), o != null && o.str ? (o.type == "utc" && (c = new e(o.str)), o.type == "gen" && (c = new n(o.str))) : this.type == "gen" ? c = new n() : c = new e(), c == null)
      throw new Error("wrong setting for Time");
    return this.TLV = c.tohex(), this.TLV;
  }, this.getEncodedHex = function() {
    return this.tohex();
  }, u != null && this.setByParam(u);
};
KJUR.asn1.x509.Time_bak = function(u) {
  KJUR.asn1.x509.Time_bak.superclass.constructor.call(this);
  var r = KJUR, a = r.asn1, e = a.DERUTCTime, n = a.DERGeneralizedTime;
  this.setTimeParams = function(o) {
    this.timeParams = o;
  }, this.tohex = function() {
    var o = null;
    return this.timeParams != null ? this.type == "utc" ? o = new e(this.timeParams) : o = new n(this.timeParams) : this.type == "utc" ? o = new e() : o = new n(), this.TLV = o.tohex(), this.TLV;
  }, this.getEncodedHex = function() {
    return this.tohex();
  }, this.type = "utc", u !== void 0 && (u.type !== void 0 ? this.type = u.type : u.str !== void 0 && (u.str.match(/^[0-9]{12}Z$/) && (this.type = "utc"), u.str.match(/^[0-9]{14}Z$/) && (this.type = "gen")), this.timeParams = u);
};
extendClass(KJUR.asn1.x509.Time, KJUR.asn1.ASN1Object);
KJUR.asn1.x509.AlgorithmIdentifier = function(u) {
  KJUR.asn1.x509.AlgorithmIdentifier.superclass.constructor.call(this), this.nameAlg = null, this.asn1Alg = null, this.asn1Params = null, this.paramEmpty = !1;
  var r = KJUR, a = r.asn1, e = a.x509.AlgorithmIdentifier.PSSNAME2ASN1TLV;
  if (this.tohex = function() {
    if (this.nameAlg === null && this.asn1Alg === null)
      throw new Error("algorithm not specified");
    if (this.nameAlg !== null) {
      var o = null;
      for (var c in e)
        c === this.nameAlg && (o = e[c]);
      if (o !== null)
        return this.hTLV = o, this.hTLV;
    }
    this.nameAlg !== null && this.asn1Alg === null && (this.asn1Alg = a.x509.OID.name2obj(this.nameAlg));
    var l = [this.asn1Alg];
    this.asn1Params !== null && l.push(this.asn1Params);
    var d = new a.DERSequence({ array: l });
    return this.hTLV = d.tohex(), this.hTLV;
  }, this.getEncodedHex = function() {
    return this.tohex();
  }, u !== void 0 && (u.name !== void 0 && (this.nameAlg = u.name), u.asn1params !== void 0 && (this.asn1Params = u.asn1params), u.paramempty !== void 0 && (this.paramEmpty = u.paramempty)), this.asn1Params === null && this.paramEmpty === !1 && this.nameAlg !== null) {
    this.nameAlg.name !== void 0 && (this.nameAlg = this.nameAlg.name);
    var n = this.nameAlg.toLowerCase();
    n.substr(-7, 7) !== "withdsa" && n.substr(-9, 9) !== "withecdsa" && (this.asn1Params = new a.DERNull());
  }
};
extendClass(KJUR.asn1.x509.AlgorithmIdentifier, KJUR.asn1.ASN1Object);
KJUR.asn1.x509.AlgorithmIdentifier.PSSNAME2ASN1TLV = { SHAwithRSAandMGF1: "300d06092a864886f70d01010a3000", SHA256withRSAandMGF1: "303d06092a864886f70d01010a3030a00d300b0609608648016503040201a11a301806092a864886f70d010108300b0609608648016503040201a203020120", SHA384withRSAandMGF1: "303d06092a864886f70d01010a3030a00d300b0609608648016503040202a11a301806092a864886f70d010108300b0609608648016503040202a203020130", SHA512withRSAandMGF1: "303d06092a864886f70d01010a3030a00d300b0609608648016503040203a11a301806092a864886f70d010108300b0609608648016503040203a203020140" };
KJUR.asn1.x509.GeneralName = function(u) {
  KJUR.asn1.x509.GeneralName.superclass.constructor.call(this);
  var r = KJUR, a = r.asn1, e = a.x509, n = e.X500Name, o = e.OtherName, c = a.DERIA5String;
  a.DERPrintableString;
  var l = a.DEROctetString, d = a.DERTaggedObject, p = a.ASN1Object, h = Error;
  this.params = null, this.setByParam = function(g) {
    this.params = g;
  }, this.tohex = function() {
    var g = this.params, y, m, v, m = !1;
    if (g.other !== void 0)
      y = "a0", v = new o(g.other);
    else if (g.rfc822 !== void 0)
      y = "81", v = new c({ str: g.rfc822 });
    else if (g.dns !== void 0)
      y = "82", v = new c({ str: g.dns });
    else if (g.dn !== void 0)
      y = "a4", m = !0, typeof g.dn == "string" ? v = new n({ str: g.dn }) : g.dn instanceof KJUR.asn1.x509.X500Name ? v = g.dn : v = new n(g.dn);
    else if (g.ldapdn !== void 0)
      y = "a4", m = !0, v = new n({ ldapstr: g.ldapdn });
    else if (g.certissuer !== void 0 || g.certsubj !== void 0) {
      y = "a4", m = !0;
      var b, R, $ = null;
      if (g.certsubj !== void 0 ? (b = !1, R = g.certsubj) : (b = !0, R = g.certissuer), R.match(/^[0-9A-Fa-f]+$/), R.indexOf("-----BEGIN ") != -1 && ($ = pemtohex(R)), $ == null)
        throw new Error("certsubj/certissuer not cert");
      var x = new X509();
      x.hex = $;
      var E;
      b ? E = x.getIssuerHex() : E = x.getSubjectHex(), v = new p(), v.hTLV = E;
    } else if (g.uri !== void 0)
      y = "86", v = new c({ str: g.uri });
    else if (g.ip !== void 0) {
      y = "87";
      var T, P = g.ip;
      try {
        if (P.match(/^[0-9a-f]+$/)) {
          var O = P.length;
          if (O == 8 || O == 16 || O == 32 || O == 64)
            T = P;
          else
            throw "err";
        } else
          T = iptohex(P);
      } catch (_) {
        throw new h("malformed IP address: " + g.ip + ":" + _.message);
      }
      v = new l({ hex: T });
    } else
      throw new h("improper params");
    var w = new d({ tag: y, explicit: m, obj: v });
    return w.tohex();
  }, this.getEncodedHex = function() {
    return this.tohex();
  }, u !== void 0 && this.setByParam(u);
};
extendClass(KJUR.asn1.x509.GeneralName, KJUR.asn1.ASN1Object);
KJUR.asn1.x509.GeneralNames = function(u) {
  KJUR.asn1.x509.GeneralNames.superclass.constructor.call(this);
  var r = KJUR, a = r.asn1;
  this.setByParamArray = function(e) {
    for (var n = 0; n < e.length; n++) {
      var o = new a.x509.GeneralName(e[n]);
      this.asn1Array.push(o);
    }
  }, this.tohex = function() {
    var e = new a.DERSequence({ array: this.asn1Array });
    return e.tohex();
  }, this.getEncodedHex = function() {
    return this.tohex();
  }, this.asn1Array = new Array(), typeof u < "u" && this.setByParamArray(u);
};
extendClass(KJUR.asn1.x509.GeneralNames, KJUR.asn1.ASN1Object);
KJUR.asn1.x509.OtherName = function(u) {
  KJUR.asn1.x509.OtherName.superclass.constructor.call(this);
  var r = KJUR, a = r.asn1, e = a.DERObjectIdentifier, n = a.DERSequence, o = a.ASN1Util.newObject;
  this.params = null, this.setByParam = function(c) {
    this.params = c;
  }, this.tohex = function() {
    var c = this.params;
    if (c.oid == null || c.value == null)
      throw new Error("oid or value not specified");
    var l = new e({ oid: c.oid }), d = o({ tag: { tag: "a0", explicit: !0, obj: c.value } }), p = new n({ array: [l, d] });
    return p.tohex();
  }, this.getEncodedHex = function() {
    return this.tohex();
  }, u !== void 0 && this.setByParam(u);
};
extendClass(KJUR.asn1.x509.OtherName, KJUR.asn1.ASN1Object);
KJUR.asn1.x509.OID = new function() {
  var u = KJUR.asn1.DERObjectIdentifier;
  this.name2oidList = { "aes128-CBC": "2.16.840.1.101.3.4.1.2", "aes256-CBC": "2.16.840.1.101.3.4.1.42", sha1: "1.3.14.3.2.26", sha256: "2.16.840.1.101.3.4.2.1", sha384: "2.16.840.1.101.3.4.2.2", sha512: "2.16.840.1.101.3.4.2.3", sha224: "2.16.840.1.101.3.4.2.4", md5: "1.2.840.113549.2.5", md2: "1.3.14.7.2.2.1", ripemd160: "1.3.36.3.2.1", hmacWithSHA1: "1.2.840.113549.2.7", hmacWithSHA224: "1.2.840.113549.2.8", hmacWithSHA256: "1.2.840.113549.2.9", hmacWithSHA384: "1.2.840.113549.2.10", hmacWithSHA512: "1.2.840.113549.2.11", MD2withRSA: "1.2.840.113549.1.1.2", MD4withRSA: "1.2.840.113549.1.1.3", MD5withRSA: "1.2.840.113549.1.1.4", SHA1withRSA: "1.2.840.113549.1.1.5", "pkcs1-MGF": "1.2.840.113549.1.1.8", rsaPSS: "1.2.840.113549.1.1.10", SHA224withRSA: "1.2.840.113549.1.1.14", SHA256withRSA: "1.2.840.113549.1.1.11", SHA384withRSA: "1.2.840.113549.1.1.12", SHA512withRSA: "1.2.840.113549.1.1.13", SHA1withECDSA: "1.2.840.10045.4.1", SHA224withECDSA: "1.2.840.10045.4.3.1", SHA256withECDSA: "1.2.840.10045.4.3.2", SHA384withECDSA: "1.2.840.10045.4.3.3", SHA512withECDSA: "1.2.840.10045.4.3.4", dsa: "1.2.840.10040.4.1", SHA1withDSA: "1.2.840.10040.4.3", SHA224withDSA: "2.16.840.1.101.3.4.3.1", SHA256withDSA: "2.16.840.1.101.3.4.3.2", rsaEncryption: "1.2.840.113549.1.1.1", commonName: "2.5.4.3", countryName: "2.5.4.6", localityName: "2.5.4.7", stateOrProvinceName: "2.5.4.8", streetAddress: "2.5.4.9", organizationName: "2.5.4.10", organizationalUnitName: "2.5.4.11", domainComponent: "0.9.2342.19200300.100.1.25", userId: "0.9.2342.19200300.100.1.1", surname: "2.5.4.4", givenName: "2.5.4.42", title: "2.5.4.12", distinguishedName: "2.5.4.49", emailAddress: "1.2.840.113549.1.9.1", description: "2.5.4.13", businessCategory: "2.5.4.15", postalCode: "2.5.4.17", uniqueIdentifier: "2.5.4.45", organizationIdentifier: "2.5.4.97", jurisdictionOfIncorporationL: "1.3.6.1.4.1.311.60.2.1.1", jurisdictionOfIncorporationSP: "1.3.6.1.4.1.311.60.2.1.2", jurisdictionOfIncorporationC: "1.3.6.1.4.1.311.60.2.1.3", subjectDirectoryAttributes: "2.5.29.9", subjectKeyIdentifier: "2.5.29.14", keyUsage: "2.5.29.15", subjectAltName: "2.5.29.17", issuerAltName: "2.5.29.18", basicConstraints: "2.5.29.19", cRLNumber: "2.5.29.20", cRLReason: "2.5.29.21", nameConstraints: "2.5.29.30", cRLDistributionPoints: "2.5.29.31", certificatePolicies: "2.5.29.32", anyPolicy: "2.5.29.32.0", policyMappings: "2.5.29.33", authorityKeyIdentifier: "2.5.29.35", policyConstraints: "2.5.29.36", extKeyUsage: "2.5.29.37", inhibitAnyPolicy: "2.5.29.54", authorityInfoAccess: "1.3.6.1.5.5.7.1.1", ocsp: "1.3.6.1.5.5.7.48.1", ocspBasic: "1.3.6.1.5.5.7.48.1.1", ocspNonce: "1.3.6.1.5.5.7.48.1.2", ocspNoCheck: "1.3.6.1.5.5.7.48.1.5", caIssuers: "1.3.6.1.5.5.7.48.2", anyExtendedKeyUsage: "2.5.29.37.0", serverAuth: "1.3.6.1.5.5.7.3.1", clientAuth: "1.3.6.1.5.5.7.3.2", codeSigning: "1.3.6.1.5.5.7.3.3", emailProtection: "1.3.6.1.5.5.7.3.4", timeStamping: "1.3.6.1.5.5.7.3.8", ocspSigning: "1.3.6.1.5.5.7.3.9", smtpUTF8Mailbox: "1.3.6.1.5.5.7.8.9", dateOfBirth: "1.3.6.1.5.5.7.9.1", placeOfBirth: "1.3.6.1.5.5.7.9.2", gender: "1.3.6.1.5.5.7.9.3", countryOfCitizenship: "1.3.6.1.5.5.7.9.4", countryOfResidence: "1.3.6.1.5.5.7.9.5", ecPublicKey: "1.2.840.10045.2.1", "P-256": "1.2.840.10045.3.1.7", secp256r1: "1.2.840.10045.3.1.7", secp256k1: "1.3.132.0.10", secp384r1: "1.3.132.0.34", secp521r1: "1.3.132.0.35", pkcs5PBES2: "1.2.840.113549.1.5.13", pkcs5PBKDF2: "1.2.840.113549.1.5.12", "des-EDE3-CBC": "1.2.840.113549.3.7", data: "1.2.840.113549.1.7.1", "signed-data": "1.2.840.113549.1.7.2", "enveloped-data": "1.2.840.113549.1.7.3", "digested-data": "1.2.840.113549.1.7.5", "encrypted-data": "1.2.840.113549.1.7.6", "authenticated-data": "1.2.840.113549.1.9.16.1.2", tstinfo: "1.2.840.113549.1.9.16.1.4", signingCertificate: "1.2.840.113549.1.9.16.2.12", timeStampToken: "1.2.840.113549.1.9.16.2.14", signaturePolicyIdentifier: "1.2.840.113549.1.9.16.2.15", etsArchiveTimeStamp: "1.2.840.113549.1.9.16.2.27", signingCertificateV2: "1.2.840.113549.1.9.16.2.47", etsArchiveTimeStampV2: "1.2.840.113549.1.9.16.2.48", extensionRequest: "1.2.840.113549.1.9.14", contentType: "1.2.840.113549.1.9.3", messageDigest: "1.2.840.113549.1.9.4", signingTime: "1.2.840.113549.1.9.5", counterSignature: "1.2.840.113549.1.9.6", archiveTimeStampV3: "0.4.0.1733.2.4", pdfRevocationInfoArchival: "1.2.840.113583.1.1.8", adobeTimeStamp: "1.2.840.113583.1.1.9.1", smimeMailboxLegacy: "2.23.140.1.5.1.1", smimeMailboxMulti: "2.23.140.1.5.1.2", smimeMailboxStrict: "2.23.140.1.5.1.3", smimeOrganizationLegacy: "2.23.140.1.5.2.1", smimeOrganizationMulti: "2.23.140.1.5.2.2", smimeOrganizationStrict: "2.23.140.1.5.2.3", smimeSponsorLegacy: "2.23.140.1.5.3.1", smimeSponsorMulti: "2.23.140.1.5.3.2", smimeSponsorStrict: "2.23.140.1.5.3.3", smimeIndividualLegacy: "2.23.140.1.5.4.1", smimeIndividualMulti: "2.23.140.1.5.4.2", smimeIndividualStrict: "2.23.140.1.5.4.3" }, this.atype2oidList = { CN: "2.5.4.3", L: "2.5.4.7", ST: "2.5.4.8", O: "2.5.4.10", OU: "2.5.4.11", C: "2.5.4.6", STREET: "2.5.4.9", DC: "0.9.2342.19200300.100.1.25", UID: "0.9.2342.19200300.100.1.1", SN: "2.5.4.4", T: "2.5.4.12", GN: "2.5.4.42", DN: "2.5.4.49", E: "1.2.840.113549.1.9.1", description: "2.5.4.13", businessCategory: "2.5.4.15", postalCode: "2.5.4.17", serialNumber: "2.5.4.5", uniqueIdentifier: "2.5.4.45", organizationIdentifier: "2.5.4.97", jurisdictionOfIncorporationL: "1.3.6.1.4.1.311.60.2.1.1", jurisdictionOfIncorporationSP: "1.3.6.1.4.1.311.60.2.1.2", jurisdictionOfIncorporationC: "1.3.6.1.4.1.311.60.2.1.3" }, this.objCache = {}, this.name2obj = function(r) {
    if (typeof this.objCache[r] < "u")
      return this.objCache[r];
    if (typeof this.name2oidList[r] > "u")
      throw "Name of ObjectIdentifier not defined: " + r;
    var a = this.name2oidList[r], e = new u({ oid: a });
    return this.objCache[r] = e, e;
  }, this.atype2obj = function(r) {
    if (this.objCache[r] !== void 0)
      return this.objCache[r];
    var a;
    if (r.match(/^\d+\.\d+\.[0-9.]+$/))
      a = r;
    else if (this.atype2oidList[r] !== void 0)
      a = this.atype2oidList[r];
    else if (this.name2oidList[r] !== void 0)
      a = this.name2oidList[r];
    else
      throw new Error("AttributeType name undefined: " + r);
    var e = new u({ oid: a });
    return this.objCache[r] = e, e;
  }, this.registerOIDs = function(r) {
    if (this.checkOIDs(r))
      for (var a in r)
        this.name2oidList[a] = r[a];
  }, this.checkOIDs = function(r) {
    try {
      var a = Object.keys(r);
      return a.length == 0 ? !1 : (a.map(function(e, n, o) {
        var c = this[e];
        if (!c.match(/^[0-2]\.[0-9.]+$/))
          throw new Error("value is not OID");
      }, r), !0);
    } catch {
      return !1;
    }
  };
}();
KJUR.asn1.x509.OID.oid2name = function(u) {
  var r = KJUR.asn1.x509.OID.name2oidList;
  for (var a in r)
    if (r[a] == u)
      return a;
  return "";
};
KJUR.asn1.x509.OID.oid2atype = function(u) {
  var r = KJUR.asn1.x509.OID.atype2oidList;
  for (var a in r)
    if (r[a] == u)
      return a;
  return u;
};
KJUR.asn1.x509.OID.name2oid = function(u) {
  if (u.match(/^[0-9.]+$/))
    return u;
  var r = KJUR.asn1.x509.OID.name2oidList;
  return r[u] === void 0 ? "" : r[u];
};
KJUR.asn1.x509.X509Util = {};
KJUR.asn1.x509.X509Util.newCertPEM = function(u) {
  var r = KJUR.asn1.x509;
  r.TBSCertificate;
  var a = r.Certificate, e = new a(u);
  return e.getPEM();
};
(typeof KJUR > "u" || !KJUR) && (KJUR = {});
(typeof KJUR.asn1 > "u" || !KJUR.asn1) && (KJUR.asn1 = {});
(typeof KJUR.asn1.cms > "u" || !KJUR.asn1.cms) && (KJUR.asn1.cms = {});
KJUR.asn1.cms.Attribute = function(u) {
  var r = Error, a = KJUR, e = a.asn1, n = e.DERSequence, o = e.DERSet, c = e.DERObjectIdentifier;
  this.params = null, this.typeOid = null, this.setByParam = function(l) {
    this.params = l;
  }, this.getValueArray = function() {
    throw new r("not yet implemented abstract");
  }, this.tohex = function() {
    var l = new c({ oid: this.typeOid }), d = new o({ array: this.getValueArray() }), p = new n({ array: [l, d] });
    return p.tohex();
  }, this.getEncodedHex = function() {
    return this.tohex();
  };
};
extendClass(KJUR.asn1.cms.Attribute, KJUR.asn1.ASN1Object);
KJUR.asn1.cms.ContentType = function(u) {
  var r = KJUR, a = r.asn1;
  a.cms.ContentType.superclass.constructor.call(this), this.typeOid = "1.2.840.113549.1.9.3", this.getValueArray = function() {
    var e = new a.DERObjectIdentifier(this.params.type);
    return [e];
  }, u != null && this.setByParam(u);
};
extendClass(KJUR.asn1.cms.ContentType, KJUR.asn1.cms.Attribute);
KJUR.asn1.cms.MessageDigest = function(u) {
  var r = KJUR, a = r.asn1, e = a.DEROctetString, n = a.cms;
  n.MessageDigest.superclass.constructor.call(this), this.typeOid = "1.2.840.113549.1.9.4", this.getValueArray = function() {
    var o = new e(this.params);
    return [o];
  }, u != null && this.setByParam(u);
};
extendClass(KJUR.asn1.cms.MessageDigest, KJUR.asn1.cms.Attribute);
KJUR.asn1.cms.SigningTime = function(u) {
  var r = KJUR, a = r.asn1;
  a.cms.SigningTime.superclass.constructor.call(this), this.typeOid = "1.2.840.113549.1.9.5", this.getValueArray = function() {
    var e = new a.x509.Time(this.params);
    return [e];
  }, u != null && this.setByParam(u);
};
extendClass(KJUR.asn1.cms.SigningTime, KJUR.asn1.cms.Attribute);
KJUR.asn1.cms.SigningCertificate = function(u) {
  var r = Error, a = KJUR, e = a.asn1, n = e.DERSequence, o = e.cms, c = o.ESSCertID;
  a.crypto, o.SigningCertificate.superclass.constructor.call(this), this.typeOid = "1.2.840.113549.1.9.16.2.12", this.getValueArray = function() {
    if (this.params == null || this.params == null || this.params.array == null)
      throw new r("parameter 'array' not specified");
    for (var l = this.params.array, d = [], p = 0; p < l.length; p++) {
      var h = l[p];
      u.hasis == !1 && typeof h == "string" && (h.indexOf("-----BEGIN") != -1 || ASN1HEX.isASN1HEX(h)) && (h = { cert: h }), h.hasis != !1 && u.hasis == !1 && (h.hasis = !1), d.push(new c(h));
    }
    var g = new n({ array: d }), y = new n({ array: [g] });
    return [y];
  }, u != null && this.setByParam(u);
};
extendClass(KJUR.asn1.cms.SigningCertificate, KJUR.asn1.cms.Attribute);
KJUR.asn1.cms.ESSCertID = function(u) {
  KJUR.asn1.cms.ESSCertID.superclass.constructor.call(this);
  var r = Error, a = KJUR, e = a.asn1, n = e.DEROctetString, o = e.DERSequence, c = e.cms.IssuerSerial;
  this.params = null, this.getCertHash = function(l, d) {
    if (l.hash != null)
      return l.hash;
    if (typeof l == "string" && l.indexOf("-----BEGIN") == -1 && !ASN1HEX.isASN1HEX(l))
      return l;
    var p;
    if (typeof l == "string")
      p = l;
    else if (l.cert != null)
      p = l.cert;
    else
      throw new r("hash nor cert unspecified");
    var h;
    p.indexOf("-----BEGIN") != -1 ? h = pemtohex(p) : h = p, typeof l == "string" && (l.indexOf("-----BEGIN") != -1 ? h = pemtohex(l) : ASN1HEX.isASN1HEX(l) && (h = l));
    var g;
    if (l.alg != null)
      g = l.alg;
    else if (d != null)
      g = d;
    else
      throw new r("hash alg unspecified");
    return a.crypto.Util.hashHex(h, g);
  }, this.tohex = function() {
    var l = this.params, d = this.getCertHash(l, "sha1"), p = [];
    p.push(new n({ hex: d })), (typeof l == "string" && l.indexOf("-----BEGIN") != -1 || l.cert != null && l.hasis != !1 || l.issuer != null && l.serial != null) && p.push(new c(l));
    var h = new o({ array: p });
    return h.tohex();
  }, this.getEncodedHex = function() {
    return this.tohex();
  }, u != null && this.setByParam(u);
};
extendClass(KJUR.asn1.cms.ESSCertID, KJUR.asn1.ASN1Object);
KJUR.asn1.cms.SigningCertificateV2 = function(u) {
  var r = Error, a = KJUR, e = a.asn1, n = e.DERSequence;
  e.x509;
  var o = e.cms, c = o.ESSCertIDv2;
  a.crypto, o.SigningCertificateV2.superclass.constructor.call(this), this.typeOid = "1.2.840.113549.1.9.16.2.47", this.getValueArray = function() {
    if (this.params == null || this.params == null || this.params.array == null)
      throw new r("parameter 'array' not specified");
    for (var l = this.params.array, d = [], p = 0; p < l.length; p++) {
      var h = l[p];
      (u.alg != null || u.hasis == !1) && typeof h == "string" && (h.indexOf("-----BEGIN") != -1 || ASN1HEX.isASN1HEX(h)) && (h = { cert: h }), h.alg == null && u.alg != null && (h.alg = u.alg), h.hasis != !1 && u.hasis == !1 && (h.hasis = !1), d.push(new c(h));
    }
    var g = new n({ array: d }), y = new n({ array: [g] });
    return [y];
  }, u != null && this.setByParam(u);
};
extendClass(KJUR.asn1.cms.SigningCertificateV2, KJUR.asn1.cms.Attribute);
KJUR.asn1.cms.ESSCertIDv2 = function(u) {
  KJUR.asn1.cms.ESSCertIDv2.superclass.constructor.call(this);
  var r = KJUR, a = r.asn1, e = a.DEROctetString, n = a.DERSequence, o = a.cms.IssuerSerial, c = a.x509.AlgorithmIdentifier;
  this.params = null, this.tohex = function() {
    var l = this.params, d = this.getCertHash(l, "sha256"), p = [];
    l.alg != null && l.alg != "sha256" && p.push(new c({ name: l.alg })), p.push(new e({ hex: d })), (typeof l == "string" && l.indexOf("-----BEGIN") != -1 || l.cert != null && l.hasis != !1 || l.issuer != null && l.serial != null) && p.push(new o(l));
    var h = new n({ array: p });
    return h.tohex();
  }, this.getEncodedHex = function() {
    return this.tohex();
  }, u != null && this.setByParam(u);
};
extendClass(KJUR.asn1.cms.ESSCertIDv2, KJUR.asn1.cms.ESSCertID);
KJUR.asn1.cms.IssuerSerial = function(u) {
  var r = Error, a = KJUR, e = a.asn1, n = e.DERInteger, o = e.DERSequence, c = e.cms, l = e.x509, d = l.GeneralNames, p = X509;
  c.IssuerSerial.superclass.constructor.call(this), this.setByParam = function(h) {
    this.params = h;
  }, this.tohex = function() {
    var h = this.params, g, y;
    if (typeof h == "string" && h.indexOf("-----BEGIN") != -1 || h.cert != null) {
      var v;
      h.cert != null ? v = h.cert : v = h;
      var m = new p();
      m.readCertPEM(v), g = m.getIssuer(), y = { hex: m.getSerialNumberHex() };
    } else if (h.issuer != null && h.serial)
      g = h.issuer, y = h.serial;
    else
      throw new r("cert or issuer and serial parameter not specified");
    var b = new d([{ dn: g }]), R = new n(y), $ = new o({ array: [b, R] });
    return $.tohex();
  }, this.getEncodedHex = function() {
    return this.tohex();
  }, u != null && this.setByParam(u);
};
extendClass(KJUR.asn1.cms.IssuerSerial, KJUR.asn1.ASN1Object);
KJUR.asn1.cms.SignerIdentifier = function(u) {
  var r = KJUR, a = r.asn1;
  a.DERInteger, a.DERSequence;
  var e = a.cms, n = e.IssuerAndSerialNumber, o = e.SubjectKeyIdentifier, c = a.x509;
  c.X500Name, e.SignerIdentifier.superclass.constructor.call(this), this.params = null, this.tohex = function() {
    var l = this.params;
    if (l.type == "isssn") {
      var d = new n(l);
      return d.tohex();
    } else if (l.type == "skid") {
      var p = new o(l);
      return p.tohex();
    } else
      throw new Error("wrong property for isssn or skid");
  }, this.getEncodedHex = function() {
    return this.tohex();
  }, u != null && this.setByParam(u);
};
extendClass(KJUR.asn1.cms.SignerIdentifier, KJUR.asn1.ASN1Object);
KJUR.asn1.cms.IssuerAndSerialNumber = function(u) {
  var r = KJUR, a = r.asn1, e = a.DERInteger, n = a.DERSequence, o = a.cms, c = a.x509, l = c.X500Name, d = X509, p = Error;
  o.IssuerAndSerialNumber.superclass.constructor.call(this), this.params = null, this.tohex = function() {
    var h = this.params, g, y;
    if (typeof h == "string" && h.indexOf("-----BEGIN") != -1 || h.cert != null) {
      var v;
      h.cert != null ? v = h.cert : v = h;
      var m = new d();
      m.readCertPEM(v), g = m.getIssuer(), y = { hex: m.getSerialNumberHex() };
    } else if (h.issuer != null && h.serial)
      g = h.issuer, y = h.serial;
    else
      throw new p("cert or issuer and serial parameter not specified");
    var b = new l(g), R = new e(y), $ = new n({ array: [b, R] });
    return $.tohex();
  }, this.getEncodedHex = function() {
    return this.tohex();
  }, this.setByParam = function(h) {
    this.params = h;
  }, u != null && this.setByParam(u);
};
extendClass(KJUR.asn1.cms.IssuerAndSerialNumber, KJUR.asn1.ASN1Object);
KJUR.asn1.cms.SubjectKeyIdentifier = function(u) {
  var r = KJUR, a = r.asn1;
  a.DERInteger, a.DERSequence;
  var e = a.ASN1Util.newObject, n = a.cms;
  n.IssuerAndSerialName, n.SubjectKeyIdentifier;
  var o = a.x509;
  o.X500Name;
  var c = X509, l = Error;
  n.SubjectKeyIdentifier.superclass.constructor.call(this), this.tohex = function() {
    var d = this.params;
    if (d.cert == null && d.skid == null)
      throw new l("property cert nor skid undefined");
    var p;
    if (d.cert != null) {
      var h = new c(d.cert), g = h.getExtSubjectKeyIdentifier();
      p = g.kid.hex;
    } else
      d.skid != null && (p = d.skid);
    var y = e({ tag: { tage: "a0", obj: { octstr: { hex: p } } } });
    return y.tohex();
  }, this.getEncodedHex = function() {
    return this.tohex();
  }, u != null && this.setByParam(u);
};
extendClass(KJUR.asn1.cms.SubjectKeyIdentifier, KJUR.asn1.ASN1Object);
KJUR.asn1.cms.AttributeList = function(u) {
  var r = Error, a = KJUR, e = a.asn1, n = e.DERSet, o = e.cms;
  o.AttributeList.superclass.constructor.call(this), this.params = null, this.hTLV = null, this.setByParam = function(c) {
    this.params = c;
  }, this.tohex = function() {
    var c = this.params;
    if (this.hTLV != null)
      return this.hTLV;
    var l = !0;
    c.sortflag != null && (l = c.sortflag);
    for (var d = c.array, p = [], h = 0; h < d.length; h++) {
      var g = d[h], y = g.attr;
      if (y == "contentType")
        p.push(new o.ContentType(g));
      else if (y == "messageDigest")
        p.push(new o.MessageDigest(g));
      else if (y == "signingTime")
        p.push(new o.SigningTime(g));
      else if (y == "signingCertificate")
        p.push(new o.SigningCertificate(g));
      else if (y == "signingCertificateV2")
        p.push(new o.SigningCertificateV2(g));
      else if (y == "signaturePolicyIdentifier")
        p.push(new KJUR.asn1.cades.SignaturePolicyIdentifier(g));
      else if (y == "signatureTimeStamp" || y == "timeStampToken")
        p.push(new KJUR.asn1.cades.SignatureTimeStamp(g));
      else
        throw new r("unknown attr: " + y);
    }
    var v = new n({ array: p, sortflag: l });
    return this.hTLV = v.tohex(), this.hTLV;
  }, this.getEncodedHex = function() {
    return this.tohex();
  }, u != null && this.setByParam(u);
};
extendClass(KJUR.asn1.cms.AttributeList, KJUR.asn1.ASN1Object);
KJUR.asn1.cms.SignerInfo = function(u) {
  var r = Error, a = KJUR, e = a.asn1, n = e.DERInteger, o = e.DEROctetString, c = e.DERSequence, l = e.DERTaggedObject, d = e.cms, p = d.SignerIdentifier, h = d.AttributeList;
  d.ContentType, d.EncapsulatedContentInfo, d.MessageDigest, d.SignedData;
  var g = e.x509, y = g.AlgorithmIdentifier, v = a.crypto, m = KEYUTIL;
  d.SignerInfo.superclass.constructor.call(this), this.params = null, this.sign = function() {
    var b = this.params, R = b.sigalg, $ = new h(b.sattrs).tohex(), x = m.getKey(b.signkey), E = new v.Signature({ alg: R });
    E.init(x), E.updateHex($);
    var T = E.sign();
    b.sighex = T;
  }, this.tohex = function() {
    var b = this.params, R = [];
    if (R.push(new n({ int: b.version })), R.push(new p(b.id)), R.push(new y({ name: b.hashalg })), b.sattrs != null) {
      var $ = new h(b.sattrs);
      try {
        R.push(new l({ tag: "a0", explicit: !1, obj: $ }));
      } catch (E) {
        throw new r("si sattr error: " + E);
      }
    }
    if (b.sigalgfield != null ? R.push(new y({ name: b.sigalgfield })) : R.push(new y({ name: b.sigalg })), b.sighex == null && b.signkey != null && this.sign(), R.push(new o({ hex: b.sighex })), b.uattrs != null) {
      var $ = new h(b.uattrs);
      try {
        R.push(new l({ tag: "a1", explicit: !1, obj: $ }));
      } catch (T) {
        throw new r("si uattr error: " + T);
      }
    }
    var x = new c({ array: R });
    return x.tohex();
  }, this.getEncodedHex = function() {
    return this.tohex();
  }, u != null && this.setByParam(u);
};
extendClass(KJUR.asn1.cms.SignerInfo, KJUR.asn1.ASN1Object);
KJUR.asn1.cms.EncapsulatedContentInfo = function(u) {
  var r = KJUR, a = r.asn1, e = a.DERTaggedObject, n = a.DERSequence, o = a.DERObjectIdentifier, c = a.DEROctetString, l = a.cms;
  l.EncapsulatedContentInfo.superclass.constructor.call(this), this.params = null, this.tohex = function() {
    var d = this.params, p = [];
    if (p.push(new o(d.type)), d.content != null && (d.content.hex != null || d.content.str != null) && d.isDetached != !0) {
      var h = new c(d.content), g = new e({ tag: "a0", explicit: !0, obj: h });
      p.push(g);
    }
    var y = new n({ array: p });
    return y.tohex();
  }, this.getEncodedHex = function() {
    return this.tohex();
  }, this.setByParam = function(d) {
    this.params = d;
  }, u != null && this.setByParam(u);
};
extendClass(KJUR.asn1.cms.EncapsulatedContentInfo, KJUR.asn1.ASN1Object);
KJUR.asn1.cms.ContentInfo = function(u) {
  var r = KJUR, a = r.asn1, e = a.DERTaggedObject, n = a.DERSequence, o = a.DERObjectIdentifier, c = a.x509;
  c.OID.name2obj, KJUR.asn1.cms.ContentInfo.superclass.constructor.call(this), this.params = null, this.tohex = function() {
    var l = this.params, d = [];
    d.push(new o(l.type));
    var p = new e({ tag: "a0", explicit: !0, obj: l.obj });
    d.push(p);
    var h = new n({ array: d });
    return h.tohex();
  }, this.getEncodedHex = function() {
    return this.tohex();
  }, this.setByParam = function(l) {
    this.params = l;
  }, u != null && this.setByParam(u);
};
extendClass(KJUR.asn1.cms.ContentInfo, KJUR.asn1.ASN1Object);
KJUR.asn1.cms.SignedData = function(u) {
  var r = KJUR, a = r.asn1;
  a.ASN1Object;
  var e = a.DERInteger, n = a.DERSet, o = a.DERSequence;
  a.DERTaggedObject;
  var c = a.cms, l = c.EncapsulatedContentInfo, d = c.SignerInfo, p = c.ContentInfo, h = c.CertificateSet, g = c.RevocationInfoChoices, y = a.x509, v = y.AlgorithmIdentifier;
  KJUR.asn1.cms.SignedData.superclass.constructor.call(this), this.params = null, this.checkAndFixParam = function() {
    var m = this.params;
    this._setDigestAlgs(m), this._setContentTypeByEContent(m), this._setMessageDigestByEContent(m), this._setSignerInfoVersion(m), this._setSignedDataVersion(m);
  }, this._setDigestAlgs = function(m) {
    for (var b = {}, R = m.sinfos, $ = 0; $ < R.length; $++) {
      var x = R[$];
      b[x.hashalg] = 1;
    }
    m.hashalgs = Object.keys(b).sort();
  }, this._setContentTypeByEContent = function(m) {
    for (var b = m.econtent.type, R = m.sinfos, $ = 0; $ < R.length; $++) {
      var x = R[$], E = this._getAttrParamByName(x, "contentType");
      E.type = b;
    }
  }, this._setMessageDigestByEContent = function(m) {
    var b = m.econtent;
    m.econtent.type;
    var R = b.content.hex;
    R == null && b.type == "data" && b.content.str != null && (R = rstrtohex(b.content.str));
    for (var $ = m.sinfos, x = 0; x < $.length; x++) {
      var E = $[x], T = E.hashalg, P = this._getAttrParamByName(E, "messageDigest"), O = KJUR.crypto.Util.hashHex(R, T);
      P.hex = O;
    }
  }, this._getAttrParamByName = function(m, b) {
    for (var R = m.sattrs.array, $ = 0; $ < R.length; $++)
      if (R[$].attr == b)
        return R[$];
  }, this._setSignerInfoVersion = function(m) {
    for (var b = m.sinfos, R = 0; R < b.length; R++) {
      var $ = b[R], x = 1;
      $.id.type == "skid" && (x = 3), $.version = x;
    }
  }, this._setSignedDataVersion = function(m) {
    var b = this._getSignedDataVersion(m);
    m.version = b;
  }, this._getSignedDataVersion = function(m) {
    if (m.revinfos != null)
      for (var b = m.revinfos, R = 0; R < b.length; R++) {
        var $ = b[R];
        if ($.ocsp != null)
          return 5;
      }
    for (var x = m.sinfos, R = 0; R < x.length; R++) {
      var E = m.sinfos[R];
      if (E.version == 3)
        return 3;
    }
    return m.econtent.type != "data" ? 3 : 1;
  }, this.tohex = function() {
    var m = this.params;
    this.getEncodedHexPrepare != null && this.getEncodedHexPrepare(), m.fixed != !0 && this.checkAndFixParam();
    var b = [];
    b.push(new e({ int: m.version }));
    for (var R = [], $ = 0; $ < m.hashalgs.length; $++) {
      var x = m.hashalgs[$];
      R.push(new v({ name: x }));
    }
    b.push(new n({ array: R })), b.push(new l(m.econtent)), m.certs != null && b.push(new h(m.certs)), m.revinfos != null && b.push(new g(m.revinfos));
    for (var E = [], $ = 0; $ < m.sinfos.length; $++) {
      var T = m.sinfos[$];
      E.push(new d(T));
    }
    b.push(new n({ array: E }));
    var P = new o({ array: b });
    return P.tohex();
  }, this.getEncodedHex = function() {
    return this.tohex();
  }, this.getContentInfo = function() {
    var m = new p({ type: "signed-data", obj: this });
    return m;
  }, this.getContentInfoEncodedHex = function() {
    return this.getContentInfo().tohex();
  }, u != null && this.setByParam(u);
};
extendClass(KJUR.asn1.cms.SignedData, KJUR.asn1.ASN1Object);
KJUR.asn1.cms.CertificateSet = function(u) {
  KJUR.asn1.cms.CertificateSet.superclass.constructor.call(this);
  var r = Error, a = KJUR.asn1, e = a.DERTaggedObject, n = a.DERSet, o = a.ASN1Object;
  this.params = null, this.tohex = function() {
    var c = this.params, l = [], d;
    if (c instanceof Array)
      d = c;
    else if (c.array != null)
      d = c.array;
    else
      throw new r("cert array not specified");
    for (var p = 0; p < d.length; p++) {
      var h = d[p], g = pemtohex(h), y = new o();
      y.hTLV = g, l.push(y);
    }
    var v = { array: l };
    c.sortflag == !1 && (v.sortflag = !1);
    var m = new n(v), b = new e({ tag: "a0", explicit: !1, obj: m });
    return b.tohex();
  }, this.getEncodedHex = function() {
    return this.tohex();
  }, u != null && this.setByParam(u);
};
extendClass(KJUR.asn1.cms.CertificateSet, KJUR.asn1.ASN1Object);
KJUR.asn1.cms.RevocationInfoChoices = function(u) {
  KJUR.asn1.cms.RevocationInfoChoices.superclass.constructor.call(this), this.params = null, this.tohex = function() {
    var r = this.params;
    if (!r instanceof Array)
      throw new Error("params is not array");
    for (var a = [], e = 0; e < r.length; e++)
      a.push(new KJUR.asn1.cms.RevocationInfoChoice(r[e]));
    var n = KJUR.asn1.ASN1Util.newObject({ tag: { tagi: "a1", obj: { set: a } } });
    return n.tohex();
  }, this.getEncodedHex = function() {
    return this.tohex();
  }, u != null && this.setByParam(u);
};
extendClass(KJUR.asn1.cms.RevocationInfoChoices, KJUR.asn1.ASN1Object);
KJUR.asn1.cms.RevocationInfoChoice = function(u) {
  KJUR.asn1.cms.RevocationInfoChoice.superclass.constructor.call(this), this.params = null, this.tohex = function() {
    var r = this.params;
    if (r.crl != null && typeof r.crl == "string") {
      var a = r.crl;
      return r.crl.indexOf("-----BEGIN") != -1 && (a = pemtohex(r.crl)), a;
    } else if (r.ocsp != null) {
      var e = KJUR.asn1.ASN1Util.newObject({ tag: { tagi: "a1", obj: new KJUR.asn1.cms.OtherRevocationFormat(r) } });
      return e.tohex();
    } else
      throw new Error("property crl or ocsp undefined");
  }, this.getEncodedHex = function() {
    return this.tohex();
  }, u != null && this.setByParam(u);
};
extendClass(KJUR.asn1.cms.RevocationInfoChoice, KJUR.asn1.ASN1Object);
KJUR.asn1.cms.OtherRevocationFormat = function(u) {
  KJUR.asn1.cms.OtherRevocationFormat.superclass.constructor.call(this);
  var r = Error, a = KJUR, e = a.asn1, n = e.ASN1Util.newObject, o = a.lang.String.isHex;
  this.params = null, this.tohex = function() {
    var c = this.params;
    if (c.ocsp == null)
      throw new r("property ocsp not specified");
    if (!o(c.ocsp) || !ASN1HEX.isASN1HEX(c.ocsp))
      throw new r("ocsp value not ASN.1 hex string");
    var l = n({ seq: [{ oid: "1.3.6.1.5.5.7.16.2" }, { asn1: { tlv: c.ocsp } }] });
    return l.tohex();
  }, this.getEncodedHex = function() {
    return this.tohex();
  }, u != null && this.setByParam(u);
};
extendClass(KJUR.asn1.cms.OtherRevocationFormat, KJUR.asn1.ASN1Object);
KJUR.asn1.cms.CMSUtil = new function() {
}();
KJUR.asn1.cms.CMSUtil.newSignedData = function(u) {
  return new KJUR.asn1.cms.SignedData(u);
};
KJUR.asn1.cms.CMSUtil.verifySignedData = function(u) {
  var r = KJUR, a = r.asn1, e = a.cms;
  e.SignerInfo, e.SignedData, e.SigningTime, e.SigningCertificate, e.SigningCertificateV2;
  var n = a.cades;
  n.SignaturePolicyIdentifier;
  var o = r.lang.String.isHex, c = ASN1HEX, l = c.getVbyList, d = c.getTLVbyList, p = c.getIdxbyList, h = c.getChildIdx, g = c.getTLV, y = c.oidname, v = r.crypto.Util.hashHex;
  u.cms === void 0 && o(u.cms);
  var m = u.cms, b = function(_, C) {
    for (var k, B = 3; B < 6; B++)
      if (k = p(_, 0, [1, 0, B]), k !== void 0) {
        var j = _.substr(k, 2);
        j === "a0" && (C.certsIdx = k), j === "a1" && (C.revinfosIdx = k), j === "31" && (C.signerinfosIdx = k);
      }
  }, R = function(_, C) {
    var k = C.signerinfosIdx;
    if (k !== void 0) {
      var B = h(_, k);
      C.signerInfoIdxList = B;
      for (var j = 0; j < B.length; j++) {
        var J = B[j], N = { idx: J };
        $(_, N), C.signerInfos.push(N);
      }
    }
  }, $ = function(_, C) {
    var k = C.idx;
    C.signerid_issuer1 = d(_, k, [1, 0], "30"), C.signerid_serial1 = l(_, k, [1, 1], "02"), C.hashalg = y(l(_, k, [2, 0], "06"));
    var B = p(_, k, [3], "a0");
    C.idxSignedAttrs = B, x(_, C, B);
    var j = h(_, k), J = j.length;
    if (J < 6)
      throw "malformed SignerInfo";
    C.sigalg = y(l(_, k, [J - 2, 0], "06")), C.sigval = l(_, k, [J - 1], "04");
  }, x = function(_, C, k) {
    var B = h(_, k);
    C.signedAttrIdxList = B;
    for (var j = 0; j < B.length; j++) {
      var J = B[j], N = l(_, J, [0], "06"), F;
      N === "2a864886f70d010905" ? (F = hextoutf8(l(_, J, [1, 0])), C.saSigningTime = F) : N === "2a864886f70d010904" && (F = l(_, J, [1, 0], "04"), C.saMessageDigest = F);
    }
  }, E = function(_, C) {
    if (l(_, 0, [0], "06") !== "2a864886f70d010702")
      return C;
    C.cmsType = "signedData", C.econtent = l(_, 0, [1, 0, 2, 1, 0]), b(_, C), C.signerInfos = [], R(_, C);
  }, T = function(_, C) {
    for (var k = C.parse.signerInfos, B = k.length, j = !0, J = 0; J < B; J++) {
      var N = k[J];
      O(_, C, N), N.isValid || (j = !1);
    }
    C.isValid = j;
  }, P = function(_, C, k, B) {
    var j = C.parse.certsIdx, J;
    if (C.certs === void 0) {
      J = [], C.certkeys = [];
      for (var N = h(_, j), F = 0; F < N.length; F++) {
        var U = g(_, N[F]), K = new X509();
        K.readCertHex(U), J[F] = K, C.certkeys[F] = K.getPublicKey();
      }
      C.certs = J;
    } else
      J = C.certs;
    C.cccc = J.length, C.cccci = N.length;
    for (var F = 0; F < J.length; F++) {
      var ve = K.getIssuerHex(), he = K.getSerialNumberHex();
      k.signerid_issuer1 === ve && k.signerid_serial1 === he && (k.certkey_idx = F);
    }
  }, O = function(_, C, k, B) {
    k.verifyDetail = {};
    var j = k.verifyDetail, J = C.parse.econtent, N = k.hashalg, F = k.saMessageDigest;
    j.validMessageDigest = !1, v(J, N) === F && (j.validMessageDigest = !0), P(_, C, k), j.validSignatureValue = !1;
    var U = k.sigalg, K = "31" + g(_, k.idxSignedAttrs).substr(2);
    k.signedattrshex = K;
    var ve = C.certs[k.certkey_idx].getPublicKey(), he = new KJUR.crypto.Signature({ alg: U });
    he.init(ve), he.updateHex(K);
    var te = he.verify(k.sigval);
    j.validSignatureValue_isValid = te, te === !0 && (j.validSignatureValue = !0), k.isValid = !1, j.validMessageDigest && j.validSignatureValue && (k.isValid = !0);
  }, w = { isValid: !1, parse: {} };
  return E(m, w.parse), T(m, w), w;
};
KJUR.asn1.cms.CMSParser = function() {
  var u = Error, r = X509, a = new r(), e = ASN1HEX, n = e.getV, o = e.getTLV;
  e.getIdxbyList;
  var c = e.getTLVbyList, l = e.getTLVbyListEx, d = e.getVbyList, p = e.getVbyListEx, h = e.getChildIdx;
  this.getCMSSignedData = function(g) {
    var y = c(g, 0, [1, 0]), v = this.getSignedData(y);
    return v;
  }, this.getSignedData = function(g) {
    var y = h(g, 0), v = {}, m = n(g, y[0]), b = parseInt(m, 16);
    v.version = b;
    var R = o(g, y[1]);
    v.hashalgs = this.getHashAlgArray(R);
    var $ = o(g, y[2]);
    v.econtent = this.getEContent($);
    var x = l(g, 0, ["[0]"]);
    x != null && (v.certs = this.getCertificateSet(x)), l(g, 0, ["[1]"]);
    var E = l(g, 0, [3]);
    return v.sinfos = this.getSignerInfos(E), v;
  }, this.getHashAlgArray = function(g) {
    for (var y = h(g, 0), v = new r(), m = [], b = 0; b < y.length; b++) {
      var R = o(g, y[b]), $ = v.getAlgorithmIdentifierName(R);
      m.push($);
    }
    return m;
  }, this.getEContent = function(g) {
    var y = {}, v = d(g, 0, [0]), m = d(g, 0, [1, 0]);
    return y.type = KJUR.asn1.x509.OID.oid2name(ASN1HEX.hextooidstr(v)), y.content = { hex: m }, y;
  }, this.getSignerInfos = function(g) {
    for (var y = [], v = h(g, 0), m = 0; m < v.length; m++) {
      var b = o(g, v[m]), R = this.getSignerInfo(b);
      y.push(R);
    }
    return y;
  }, this.getSignerInfo = function(g) {
    var y = {}, v = h(g, 0), m = e.getInt(g, v[0], -1);
    m != -1 && (y.version = m);
    var b = o(g, v[1]), R = this.getIssuerAndSerialNumber(b);
    y.id = R;
    var $ = o(g, v[2]), x = a.getAlgorithmIdentifierName($);
    y.hashalg = x;
    var E = l(g, 0, ["[0]"]);
    if (E != null) {
      var T = this.getAttributeList(E);
      y.sattrs = T;
    }
    var P = l(g, 0, [3]), O = a.getAlgorithmIdentifierName(P);
    y.sigalg = O;
    var w = p(g, 0, [4]);
    y.sighex = w;
    var _ = l(g, 0, ["[1]"]);
    if (_ != null) {
      var C = this.getAttributeList(_);
      y.uattrs = C;
    }
    return y;
  }, this.getSignerIdentifier = function(g) {
    if (g.substr(0, 2) == "30")
      return this.getIssuerAndSerialNumber(g);
    throw new Error("SKID of signerIdentifier not supported");
  }, this.getIssuerAndSerialNumber = function(g) {
    var y = { type: "isssn" }, v = h(g, 0), m = o(g, v[0]);
    y.issuer = a.getX500Name(m);
    var b = n(g, v[1]);
    return y.serial = { hex: b }, y;
  }, this.getAttributeList = function(g) {
    for (var y = [], v = h(g, 0), m = 0; m < v.length; m++) {
      var b = o(g, v[m]), R = this.getAttribute(b);
      y.push(R);
    }
    return { array: y };
  }, this.getAttribute = function(g) {
    var y = {}, v = h(g, 0), m = e.getOID(g, v[0]), b = KJUR.asn1.x509.OID.oid2name(m);
    y.attr = b;
    var R = o(g, v[1]), $ = h(R, 0);
    if ($.length == 1)
      y.valhex = o(R, $[0]);
    else {
      for (var x = [], E = 0; E < $.length; E++)
        x.push(o(R, $[E]));
      y.valhex = x;
    }
    return b == "contentType" ? this.setContentType(y) : b == "messageDigest" ? this.setMessageDigest(y) : b == "signingTime" ? this.setSigningTime(y) : b == "signingCertificate" ? this.setSigningCertificate(y) : b == "signingCertificateV2" ? this.setSigningCertificateV2(y) : b == "signaturePolicyIdentifier" && this.setSignaturePolicyIdentifier(y), y;
  }, this.setContentType = function(g) {
    var y = e.getOIDName(g.valhex, 0, null);
    y != null && (g.type = y, delete g.valhex);
  }, this.setSigningTime = function(g) {
    var y = n(g.valhex, 0), v = hextoutf8(y);
    g.str = v, delete g.valhex;
  }, this.setMessageDigest = function(g) {
    var y = n(g.valhex, 0);
    g.hex = y, delete g.valhex;
  }, this.setSigningCertificate = function(g) {
    var y = h(g.valhex, 0);
    if (y.length > 0) {
      for (var v = o(g.valhex, y[0]), m = h(v, 0), b = [], R = 0; R < m.length; R++) {
        var $ = o(v, m[R]), x = this.getESSCertID($);
        b.push(x);
      }
      g.array = b;
    }
    if (y.length > 1) {
      var E = o(g.valhex, y[1]);
      g.polhex = E;
    }
    delete g.valhex;
  }, this.setSignaturePolicyIdentifier = function(g) {
    var y = h(g.valhex, 0);
    if (y.length > 0) {
      var v = e.getOID(g.valhex, y[0]);
      g.oid = v;
    }
    if (y.length > 1) {
      var m = new r(), b = h(g.valhex, y[1]), R = o(g.valhex, b[0]), $ = m.getAlgorithmIdentifierName(R);
      g.alg = $;
      var x = n(g.valhex, b[1]);
      g.hash = x;
    }
    delete g.valhex;
  }, this.setSigningCertificateV2 = function(g) {
    var y = h(g.valhex, 0);
    if (y.length > 0) {
      for (var v = o(g.valhex, y[0]), m = h(v, 0), b = [], R = 0; R < m.length; R++) {
        var $ = o(v, m[R]), x = this.getESSCertIDv2($);
        b.push(x);
      }
      g.array = b;
    }
    if (y.length > 1) {
      var E = o(g.valhex, y[1]);
      g.polhex = E;
    }
    delete g.valhex;
  }, this.getESSCertID = function(g) {
    var y = {}, v = h(g, 0);
    if (v.length > 0) {
      var m = n(g, v[0]);
      y.hash = m;
    }
    if (v.length > 1) {
      var b = o(g, v[1]), R = this.getIssuerSerial(b);
      R.serial != null && (y.serial = R.serial), R.issuer != null && (y.issuer = R.issuer);
    }
    return y;
  }, this.getESSCertIDv2 = function(g) {
    var y = {}, v = h(g, 0);
    if (v.length < 1 || 3 < v.length)
      throw new u("wrong number of elements");
    var m = 0;
    if (g.substr(v[0], 2) == "30") {
      var b = o(g, v[0]);
      y.alg = a.getAlgorithmIdentifierName(b), m++;
    } else
      y.alg = "sha256";
    var R = n(g, v[m]);
    if (y.hash = R, v.length > m + 1) {
      var $ = o(g, v[m + 1]), x = this.getIssuerSerial($);
      y.issuer = x.issuer, y.serial = x.serial;
    }
    return y;
  }, this.getIssuerSerial = function(g) {
    var y = {}, v = h(g, 0), m = o(g, v[0]), b = a.getGeneralNames(m), R = b[0].dn;
    y.issuer = R;
    var $ = n(g, v[1]);
    return y.serial = { hex: $ }, y;
  }, this.getCertificateSet = function(g) {
    for (var y = h(g, 0), v = [], m = 0; m < y.length; m++) {
      var b = o(g, y[m]);
      if (b.substr(0, 2) == "30") {
        var R = hextopem(b, "CERTIFICATE");
        v.push(R);
      }
    }
    return { array: v, sortflag: !1 };
  };
};
(typeof KJUR > "u" || !KJUR) && (KJUR = {});
(typeof KJUR.asn1 > "u" || !KJUR.asn1) && (KJUR.asn1 = {});
(typeof KJUR.asn1.tsp > "u" || !KJUR.asn1.tsp) && (KJUR.asn1.tsp = {});
KJUR.asn1.tsp.TimeStampToken = function(u) {
  var r = KJUR, a = r.asn1, e = a.tsp;
  e.TimeStampToken.superclass.constructor.call(this), this.params = null, this.getEncodedHexPrepare = function() {
    var n = new e.TSTInfo(this.params.econtent.content);
    this.params.econtent.content.hex = n.tohex();
  }, u != null && this.setByParam(u);
};
extendClass(KJUR.asn1.tsp.TimeStampToken, KJUR.asn1.cms.SignedData);
KJUR.asn1.tsp.TSTInfo = function(u) {
  var r = KJUR, a = r.asn1, e = a.DERSequence, n = a.DERInteger, o = a.DERBoolean, c = a.DERGeneralizedTime, l = a.DERObjectIdentifier, d = a.DERTaggedObject, p = a.tsp, h = p.MessageImprint, g = p.Accuracy;
  a.x509.X500Name;
  var y = a.x509.GeneralName;
  if (p.TSTInfo.superclass.constructor.call(this), this.dVersion = new n({ int: 1 }), this.dPolicy = null, this.dMessageImprint = null, this.dSerial = null, this.dGenTime = null, this.dAccuracy = null, this.dOrdering = null, this.dNonce = null, this.dTsa = null, this.tohex = function() {
    var v = [this.dVersion];
    if (this.dPolicy == null)
      throw new Error("policy shall be specified.");
    if (v.push(this.dPolicy), this.dMessageImprint == null)
      throw new Error("messageImprint shall be specified.");
    if (v.push(this.dMessageImprint), this.dSerial == null)
      throw new Error("serialNumber shall be specified.");
    if (v.push(this.dSerial), this.dGenTime == null)
      throw new Error("genTime shall be specified.");
    v.push(this.dGenTime), this.dAccuracy != null && v.push(this.dAccuracy), this.dOrdering != null && v.push(this.dOrdering), this.dNonce != null && v.push(this.dNonce), this.dTsa != null && v.push(this.dTsa);
    var m = new e({ array: v });
    return this.hTLV = m.tohex(), this.hTLV;
  }, this.getEncodedHex = function() {
    return this.tohex();
  }, u !== void 0) {
    if (typeof u.policy == "string") {
      if (!u.policy.match(/^[0-9.]+$/))
        throw "policy shall be oid like 0.1.4.134";
      this.dPolicy = new l({ oid: u.policy });
    }
    u.messageImprint !== void 0 && (this.dMessageImprint = new h(u.messageImprint)), u.serial !== void 0 && (this.dSerial = new n(u.serial)), u.genTime !== void 0 && (this.dGenTime = new c(u.genTime)), u.accuracy !== void 0 && (this.dAccuracy = new g(u.accuracy)), u.ordering !== void 0 && u.ordering == !0 && (this.dOrdering = new o()), u.nonce !== void 0 && (this.dNonce = new n(u.nonce)), u.tsa !== void 0 && (this.dTsa = new d({ tag: "a0", explicit: !0, obj: new y({ dn: u.tsa }) }));
  }
};
extendClass(KJUR.asn1.tsp.TSTInfo, KJUR.asn1.ASN1Object);
KJUR.asn1.tsp.Accuracy = function(u) {
  var r = KJUR, a = r.asn1, e = a.ASN1Util.newObject;
  a.tsp.Accuracy.superclass.constructor.call(this), this.params = null, this.tohex = function() {
    var n = this.params, o = [];
    return n.seconds != null && typeof n.seconds == "number" && o.push({ int: n.seconds }), n.millis != null && typeof n.millis == "number" && o.push({ tag: { tagi: "80", obj: { int: n.millis } } }), n.micros != null && typeof n.micros == "number" && o.push({ tag: { tagi: "81", obj: { int: n.micros } } }), e({ seq: o }).tohex();
  }, this.getEncodedHex = function() {
    return this.tohex();
  }, u != null && this.setByParam(u);
};
extendClass(KJUR.asn1.tsp.Accuracy, KJUR.asn1.ASN1Object);
KJUR.asn1.tsp.MessageImprint = function(u) {
  var r = KJUR, a = r.asn1, e = a.DERSequence, n = a.DEROctetString, o = a.x509, c = o.AlgorithmIdentifier;
  a.tsp.MessageImprint.superclass.constructor.call(this), this.params = null, this.tohex = function() {
    var l = this.params, d = new c({ name: l.alg }), p = new n({ hex: l.hash }), h = new e({ array: [d, p] });
    return h.tohex();
  }, this.getEncodedHex = function() {
    return this.tohex();
  }, u !== void 0 && this.setByParam(u);
};
extendClass(KJUR.asn1.tsp.MessageImprint, KJUR.asn1.ASN1Object);
KJUR.asn1.tsp.TimeStampReq = function(u) {
  var r = KJUR, a = r.asn1, e = a.DERSequence, n = a.DERInteger, o = a.DERBoolean;
  a.ASN1Object;
  var c = a.DERObjectIdentifier, l = a.tsp, d = l.MessageImprint;
  l.TimeStampReq.superclass.constructor.call(this), this.params = null, this.tohex = function() {
    var p = this.params, h = [];
    h.push(new n({ int: 1 })), p.messageImprint instanceof KJUR.asn1.ASN1Object ? h.push(p.messageImprint) : h.push(new d(p.messageImprint)), p.policy != null && h.push(new c(p.policy)), p.nonce != null && h.push(new n(p.nonce)), p.certreq == !0 && h.push(new o());
    var g = new e({ array: h });
    return g.tohex();
  }, this.getEncodedHex = function() {
    return this.tohex();
  }, u != null && this.setByParam(u);
};
extendClass(KJUR.asn1.tsp.TimeStampReq, KJUR.asn1.ASN1Object);
KJUR.asn1.tsp.TimeStampResp = function(u) {
  var r = KJUR, a = r.asn1, e = a.DERSequence;
  a.ASN1Object;
  var n = a.tsp, o = n.PKIStatusInfo;
  n.TimeStampResp.superclass.constructor.call(this), this.params = null, this.tohex = function() {
    var c = this.params, l = [];
    if (c.econtent != null || c.tst != null)
      if (c.statusinfo != null ? l.push(new o(c.statusinfo)) : l.push(new o("granted")), c.econtent != null)
        l.push(new n.TimeStampToken(c).getContentInfo());
      else if (c.tst instanceof a.ASN1Object)
        l.push(c.tst);
      else
        throw new Error("improper member tst value");
    else if (c.statusinfo != null)
      l.push(new o(c.statusinfo));
    else
      throw new Error("parameter for token nor statusinfo not specified");
    var d = new e({ array: l });
    return d.tohex();
  }, this.getEncodedHex = function() {
    return this.tohex();
  }, u != null && this.setByParam(u);
};
extendClass(KJUR.asn1.tsp.TimeStampResp, KJUR.asn1.ASN1Object);
KJUR.asn1.tsp.PKIStatusInfo = function(u) {
  var r = Error, a = KJUR, e = a.asn1, n = e.DERSequence, o = e.tsp, c = o.PKIStatus, l = o.PKIFreeText, d = o.PKIFailureInfo;
  o.PKIStatusInfo.superclass.constructor.call(this), this.params = null, this.tohex = function() {
    var p = this.params, h = [];
    if (typeof p == "string")
      h.push(new c(p));
    else {
      if (p.status == null)
        throw new r("property 'status' unspecified");
      h.push(new c(p.status)), p.statusstr != null && h.push(new l(p.statusstr)), p.failinfo != null && h.push(new d(p.failinfo));
    }
    var g = new n({ array: h });
    return g.tohex();
  }, this.getEncodedHex = function() {
    return this.tohex();
  }, u != null && this.setByParam(u);
};
extendClass(KJUR.asn1.tsp.PKIStatusInfo, KJUR.asn1.ASN1Object);
KJUR.asn1.tsp.PKIStatus = function(u) {
  var r = Error, a = KJUR, e = a.asn1, n = e.DERInteger, o = e.tsp;
  o.PKIStatus.superclass.constructor.call(this);
  var c = { granted: 0, grantedWithMods: 1, rejection: 2, waiting: 3, revocationWarning: 4, revocationNotification: 5 };
  this.params = null, this.tohex = function() {
    var l = this.params, d;
    if (typeof l == "string")
      try {
        d = c[l];
      } catch {
        throw new r("undefined name: " + l);
      }
    else if (typeof l == "number")
      d = l;
    else
      throw new r("unsupported params");
    return new n({ int: d }).tohex();
  }, this.getEncodedHex = function() {
    return this.tohex();
  }, u != null && this.setByParam(u);
};
extendClass(KJUR.asn1.tsp.PKIStatus, KJUR.asn1.ASN1Object);
KJUR.asn1.tsp.PKIFreeText = function(u) {
  var r = Error, a = KJUR, e = a.asn1, n = e.DERSequence, o = e.DERUTF8String, c = e.tsp;
  c.PKIFreeText.superclass.constructor.call(this), this.params = null, this.tohex = function() {
    var l = this.params;
    if (!l instanceof Array)
      throw new r("wrong params: not array");
    for (var d = [], p = 0; p < l.length; p++)
      d.push(new o({ str: l[p] }));
    var h = new n({ array: d });
    return h.tohex();
  }, this.getEncodedHex = function() {
    return this.tohex();
  }, u != null && this.setByParam(u);
};
extendClass(KJUR.asn1.tsp.PKIFreeText, KJUR.asn1.ASN1Object);
KJUR.asn1.tsp.PKIFailureInfo = function(u) {
  var r = Error, a = KJUR, e = a.asn1, n = e.DERBitString, o = e.tsp, c = o.PKIFailureInfo, l = { badAlg: 0, badRequest: 2, badDataFormat: 5, timeNotAvailable: 14, unacceptedPolicy: 15, unacceptedExtension: 16, addInfoNotAvailable: 17, systemFailure: 25 };
  c.superclass.constructor.call(this), this.params = null, this.getBinValue = function() {
    var d = this.params, p = 0;
    if (typeof d == "number" && 0 <= d && d <= 25) {
      p |= 1 << d;
      for (var h = p.toString(2), g = "", y = h.length - 1; y >= 0; y--)
        g += h[y];
      return g;
    } else {
      if (typeof d == "string" && l[d] != null)
        return namearraytobinstr([d], l);
      if (typeof d == "object" && d.length != null)
        return namearraytobinstr(d, l);
      throw new r("wrong params");
    }
  }, this.tohex = function() {
    this.params;
    var d = this.getBinValue();
    return new n({ bin: d }).tohex();
  }, this.getEncodedHex = function() {
    return this.tohex();
  }, u != null && this.setByParam(u);
};
extendClass(KJUR.asn1.tsp.PKIFailureInfo, KJUR.asn1.ASN1Object);
KJUR.asn1.tsp.AbstractTSAAdapter = function(u) {
  this.getTSTHex = function(r, a) {
    throw "not implemented yet";
  };
};
KJUR.asn1.tsp.SimpleTSAAdapter = function(u) {
  var r = KJUR, a = r.asn1, e = a.tsp, n = r.crypto.Util.hashHex;
  e.SimpleTSAAdapter.superclass.constructor.call(this), this.params = null, this.serial = 0, this.getTSTHex = function(o, c) {
    var l = n(o, c);
    this.params.econtent.content.messageImprint = { alg: c, hash: l }, this.params.econtent.content.serial = { int: this.serial++ };
    var d = Math.floor(Math.random() * 1e9);
    this.params.econtent.content.nonce = { int: d };
    var p = new e.TimeStampToken(this.params);
    return p.getContentInfoEncodedHex();
  }, u !== void 0 && (this.params = u);
};
extendClass(KJUR.asn1.tsp.SimpleTSAAdapter, KJUR.asn1.tsp.AbstractTSAAdapter);
KJUR.asn1.tsp.FixedTSAAdapter = function(u) {
  var r = KJUR, a = r.asn1, e = a.tsp, n = r.crypto.Util.hashHex;
  e.FixedTSAAdapter.superclass.constructor.call(this), this.params = null, this.getTSTHex = function(o, c) {
    var l = n(o, c);
    this.params.econtent.content.messageImprint = { alg: c, hash: l };
    var d = new e.TimeStampToken(this.params);
    return d.getContentInfoEncodedHex();
  }, u !== void 0 && (this.params = u);
};
extendClass(KJUR.asn1.tsp.FixedTSAAdapter, KJUR.asn1.tsp.AbstractTSAAdapter);
KJUR.asn1.tsp.TSPUtil = new function() {
}();
KJUR.asn1.tsp.TSPUtil.newTimeStampToken = function(u) {
  return new KJUR.asn1.tsp.TimeStampToken(u);
};
KJUR.asn1.tsp.TSPUtil.parseTimeStampReq = function(u) {
  var r = new KJUR.asn1.tsp.TSPParser();
  return r.getTimeStampReq(u);
};
KJUR.asn1.tsp.TSPUtil.parseMessageImprint = function(u) {
  var r = new KJUR.asn1.tsp.TSPParser();
  return r.getMessageImprint(u);
};
KJUR.asn1.tsp.TSPParser = function() {
  var u = X509, r = new u(), a = ASN1HEX, e = a.getV, n = a.getTLV, o = a.getIdxbyList;
  a.getTLVbyListEx;
  var c = a.getChildIdx, l = ["granted", "grantedWithMods", "rejection", "waiting", "revocationWarning", "revocationNotification"], d = { 0: "badAlg", 2: "badRequest", 5: "badDataFormat", 14: "timeNotAvailable", 15: "unacceptedPolicy", 16: "unacceptedExtension", 17: "addInfoNotAvailable", 25: "systemFailure" };
  this.getResponse = function(p) {
    var h = c(p, 0);
    if (h.length == 1)
      return this.getPKIStatusInfo(n(p, h[0]));
    if (h.length > 1) {
      var g = this.getPKIStatusInfo(n(p, h[0])), y = n(p, h[1]), v = this.getToken(y);
      return v.statusinfo = g, v;
    }
  }, this.getToken = function(p) {
    var h = new KJUR.asn1.cms.CMSParser(), g = h.getCMSSignedData(p);
    return this.setTSTInfo(g), g;
  }, this.setTSTInfo = function(p) {
    var h = p.econtent;
    if (h.type == "tstinfo") {
      var g = h.content.hex, y = this.getTSTInfo(g);
      h.content = y;
    }
  }, this.getTSTInfo = function(p) {
    var h = {}, g = c(p, 0), y = e(p, g[1]);
    h.policy = hextooid(y);
    var v = n(p, g[2]);
    h.messageImprint = this.getMessageImprint(v);
    var m = e(p, g[3]);
    h.serial = { hex: m };
    var b = e(p, g[4]);
    h.genTime = { str: hextoutf8(b) };
    var R = 0;
    if (g.length > 5 && p.substr(g[5], 2) == "30") {
      var $ = n(p, g[5]);
      h.accuracy = this.getAccuracy($), R++;
    }
    if (g.length > 5 + R && p.substr(g[5 + R], 2) == "01") {
      var x = e(p, g[5 + R]);
      x == "ff" && (h.ordering = !0), R++;
    }
    if (g.length > 5 + R && p.substr(g[5 + R], 2) == "02") {
      var E = e(p, g[5 + R]);
      h.nonce = { hex: E }, R++;
    }
    if (g.length > 5 + R && p.substr(g[5 + R], 2) == "a0") {
      var T = n(p, g[5 + R]);
      T = "30" + T.substr(2), pGeneralNames = r.getGeneralNames(T);
      var P = pGeneralNames[0].dn;
      h.tsa = P, R++;
    }
    if (g.length > 5 + R && p.substr(g[5 + R], 2) == "a1") {
      var O = n(p, g[5 + R]);
      O = "30" + O.substr(2);
      var w = r.getExtParamArray(O);
      h.ext = w, R++;
    }
    return h;
  }, this.getAccuracy = function(p) {
    for (var h = {}, g = c(p, 0), y = 0; y < g.length; y++) {
      var v = p.substr(g[y], 2), m = e(p, g[y]), b = parseInt(m, 16);
      v == "02" ? h.seconds = b : v == "80" ? h.millis = b : v == "81" && (h.micros = b);
    }
    return h;
  }, this.getMessageImprint = function(p) {
    if (p.substr(0, 2) != "30")
      throw new Error("head of messageImprint hex shall be x30");
    var h = {};
    c(p, 0);
    var g = o(p, 0, [0, 0]), y = e(p, g), v = a.hextooidstr(y), m = KJUR.asn1.x509.OID.oid2name(v);
    if (m == "")
      throw new Error("hashAlg name undefined: " + v);
    var b = m, R = o(p, 0, [1]);
    return h.alg = b, h.hash = e(p, R), h;
  }, this.getPKIStatusInfo = function(p) {
    var h = {}, g = c(p, 0), y = 0;
    try {
      var v = e(p, g[0]), m = parseInt(v, 16);
      h.status = l[m];
    } catch {
    }
    if (g.length > 1 && p.substr(g[1], 2) == "30") {
      var b = n(p, g[1]);
      h.statusstr = this.getPKIFreeText(b), y++;
    }
    if (g.length > y && p.substr(g[1 + y], 2) == "03") {
      var R = n(p, g[1 + y]);
      h.failinfo = this.getPKIFailureInfo(R);
    }
    return h;
  }, this.getPKIFreeText = function(p) {
    for (var h = [], g = c(p, 0), y = 0; y < g.length; y++)
      h.push(a.getString(p, g[y]));
    return h;
  }, this.getPKIFailureInfo = function(p) {
    var h = a.getInt(p, 0);
    return d[h] != null ? d[h] : h;
  }, this.getTimeStampReq = function(p) {
    var h = {};
    h.certreq = !1;
    var g = c(p, 0);
    if (g.length < 2)
      throw new Error("TimeStampReq must have at least 2 items");
    var y = n(p, g[1]);
    h.messageImprint = KJUR.asn1.tsp.TSPUtil.parseMessageImprint(y);
    for (var v = 2; v < g.length; v++) {
      var m = g[v], b = p.substr(m, 2);
      if (b == "06") {
        var R = e(p, m);
        h.policy = a.hextooidstr(R);
      }
      b == "02" && (h.nonce = e(p, m)), b == "01" && (h.certreq = !0);
    }
    return h;
  };
};
(typeof KJUR > "u" || !KJUR) && (KJUR = {});
(typeof KJUR.asn1 > "u" || !KJUR.asn1) && (KJUR.asn1 = {});
(typeof KJUR.asn1.cades > "u" || !KJUR.asn1.cades) && (KJUR.asn1.cades = {});
KJUR.asn1.cades.SignaturePolicyIdentifier = function(u) {
  var r = KJUR, a = r.asn1, e = a.cades, n = e.SignaturePolicyId;
  e.SignaturePolicyIdentifier.superclass.constructor.call(this), this.typeOid = "1.2.840.113549.1.9.16.2.15", this.params = null, this.getValueArray = function() {
    return [new n(this.params)];
  }, this.setByParam = function(o) {
    this.params = o;
  }, u != null && this.setByParam(u);
};
extendClass(KJUR.asn1.cades.SignaturePolicyIdentifier, KJUR.asn1.cms.Attribute);
KJUR.asn1.cades.SignaturePolicyId = function(u) {
  var r = KJUR, a = r.asn1, e = a.DERSequence, n = a.DERObjectIdentifier, o = a.x509;
  o.AlgorithmIdentifier;
  var c = a.cades, l = c.SignaturePolicyId, d = c.OtherHashAlgAndValue;
  l.superclass.constructor.call(this), this.params = null, this.tohex = function() {
    var p = this.params, h = [];
    h.push(new n(p.oid)), h.push(new d(p));
    var g = new e({ array: h });
    return g.tohex();
  }, this.getEncodedHex = function() {
    return this.tohex();
  }, this.setByParam = function(p) {
    this.params = p;
  }, u != null && this.setByParam(u);
};
extendClass(KJUR.asn1.cades.SignaturePolicyId, KJUR.asn1.ASN1Object);
KJUR.asn1.cades.OtherHashAlgAndValue = function(u) {
  var r = Error, a = KJUR, e = a.asn1, n = e.DERSequence, o = e.DEROctetString, c = e.x509, l = c.AlgorithmIdentifier, d = e.cades, p = d.OtherHashAlgAndValue;
  p.superclass.constructor.call(this), this.params = null, this.tohex = function() {
    var h = this.params;
    if (h.alg == null)
      throw new r("property 'alg' not specified");
    if (h.hash == null && h.cert == null)
      throw new r("property 'hash' nor 'cert' not specified");
    var g = null;
    if (h.hash != null)
      g = h.hash;
    else if (h.cert != null) {
      if (typeof h.cert != "string")
        throw new r("cert not string");
      var y = h.cert;
      h.cert.indexOf("-----BEGIN") != -1 && (y = pemtohex(h.cert)), g = KJUR.crypto.Util.hashHex(y, h.alg);
    }
    var v = [];
    v.push(new l({ name: h.alg })), v.push(new o({ hex: g }));
    var m = new n({ array: v });
    return m.tohex();
  }, this.getEncodedHex = function() {
    return this.tohex();
  }, u != null && this.setByParam(u);
};
extendClass(KJUR.asn1.cades.OtherHashAlgAndValue, KJUR.asn1.ASN1Object);
KJUR.asn1.cades.OtherHashValue = function(u) {
  KJUR.asn1.cades.OtherHashValue.superclass.constructor.call(this);
  var r = Error, a = KJUR;
  a.lang.String.isHex;
  var e = a.asn1, n = e.DEROctetString;
  a.crypto.Util.hashHex, this.params = null, this.tohex = function() {
    var o = this.params;
    if (o.hash == null && o.cert == null)
      throw new r("hash or cert not specified");
    var c = null;
    if (o.hash != null)
      c = o.hash;
    else if (o.cert != null) {
      if (typeof o.cert != "string")
        throw new r("cert not string");
      var l = o.cert;
      o.cert.indexOf("-----BEGIN") != -1 && (l = pemtohex(o.cert)), c = KJUR.crypto.Util.hashHex(l, "sha1");
    }
    return new n({ hex: c }).tohex();
  }, this.getEncodedHex = function() {
    return this.tohex();
  }, u != null && this.setByParam(u);
};
extendClass(KJUR.asn1.cades.OtherHashValue, KJUR.asn1.ASN1Object);
KJUR.asn1.cades.SignatureTimeStamp = function(u) {
  var r = Error, a = KJUR, e = a.lang.String.isHex, n = a.asn1, o = n.ASN1Object;
  n.x509;
  var c = n.cades;
  c.SignatureTimeStamp.superclass.constructor.call(this), this.typeOid = "1.2.840.113549.1.9.16.2.14", this.params = null, this.getValueArray = function() {
    var l = this.params;
    if (l.tst != null)
      if (e(l.tst)) {
        var d = new o();
        return d.hTLV = l.tst, [d];
      } else {
        if (l.tst instanceof o)
          return [l.tst];
        throw new r("params.tst has wrong value");
      }
    else if (l.res != null) {
      var p = l.res;
      if (p instanceof o && (p = p.tohex()), typeof p != "string" || !e(p))
        throw new r("params.res has wrong value");
      ASN1HEX.getTLVbyList(p, 0, [1]);
      var d = new o();
      return d.hTLV = l.tst, [d];
    }
  }, u != null && this.setByParam(u);
};
extendClass(KJUR.asn1.cades.SignatureTimeStamp, KJUR.asn1.cms.Attribute);
KJUR.asn1.cades.CompleteCertificateRefs = function(u) {
  var r = Error, a = KJUR, e = a.asn1, n = e.DERSequence, o = e.cades, c = o.OtherCertID, l = a.lang.String.isHex;
  o.CompleteCertificateRefs.superclass.constructor.call(this), this.typeOid = "1.2.840.113549.1.9.16.2.21", this.params = null, this.getValueArray = function() {
    for (var d = this.params, p = [], h = 0; h < d.array.length; h++) {
      var g = d.array[h];
      if (typeof g == "string")
        if (g.indexOf("-----BEGIN") != -1)
          g = { cert: g };
        else if (l(g))
          g = { hash: g };
        else
          throw new r("unsupported value: " + g);
      d.alg != null && g.alg == null && (g.alg = d.alg), d.hasis != null && g.hasis == null && (g.hasis = d.hasis);
      var y = new c(g);
      p.push(y);
    }
    var v = new n({ array: p });
    return [v];
  }, u != null && this.setByParam(u);
};
extendClass(KJUR.asn1.cades.CompleteCertificateRefs, KJUR.asn1.cms.Attribute);
KJUR.asn1.cades.OtherCertID = function(u) {
  var r = KJUR, a = r.asn1, e = a.DERSequence, n = a.cms, o = n.IssuerSerial, c = a.cades, l = c.OtherHashValue, d = c.OtherHashAlgAndValue;
  c.OtherCertID.superclass.constructor.call(this), this.params = u, this.tohex = function() {
    var p = this.params;
    typeof p == "string" && (p.indexOf("-----BEGIN") != -1 ? p = { cert: p } : _isHex(p) && (p = { hash: p }));
    var h = [], g = null;
    if (p.alg != null ? g = new d(p) : g = new l(p), h.push(g), p.cert != null && p.hasis == !0 || p.issuer != null && p.serial != null) {
      var y = new o(p);
      h.push(y);
    }
    var v = new e({ array: h });
    return v.tohex();
  }, this.getEncodedHex = function() {
    return this.tohex();
  }, u != null && this.setByParam(u);
};
extendClass(KJUR.asn1.cades.OtherCertID, KJUR.asn1.ASN1Object);
KJUR.asn1.cades.OtherHash = function(u) {
  var r = KJUR, a = r.asn1;
  a.cms;
  var e = a.cades, n = e.OtherHashAlgAndValue, o = e.OtherHashValue;
  r.crypto.Util.hashHex;
  var c = r.lang.String.isHex;
  e.OtherHash.superclass.constructor.call(this), this.params = null, this.tohex = function() {
    var l = this.params;
    typeof l == "string" && (l.indexOf("-----BEGIN") != -1 ? l = { cert: l } : c(l) && (l = { hash: l }));
    var d = null;
    return l.alg != null ? d = new n(l) : d = new o(l), d.tohex();
  }, this.getEncodedHex = function() {
    return this.tohex();
  }, u != null && this.setByParam(u);
};
extendClass(KJUR.asn1.cades.OtherHash, KJUR.asn1.ASN1Object);
KJUR.asn1.cades.CAdESUtil = new function() {
}();
KJUR.asn1.cades.CAdESUtil.parseSignedDataForAddingUnsigned = function(u) {
  var r = new KJUR.asn1.cms.CMSParser(), a = r.getCMSSignedData(u);
  return a;
};
KJUR.asn1.cades.CAdESUtil.parseSignerInfoForAddingUnsigned = function(u, r, a) {
  var e = ASN1HEX, n = e.getChildIdx, o = e.getTLV, c = e.getV, l = KJUR, d = l.asn1, p = d.ASN1Object, h = d.cms, g = h.AttributeList, y = h.SignerInfo, v = {}, m = n(u, r);
  if (m.length != 6)
    throw "not supported items for SignerInfo (!=6)";
  var b = m.shift();
  v.version = o(u, b);
  var R = m.shift();
  v.si = o(u, R);
  var $ = m.shift();
  v.digalg = o(u, $);
  var x = m.shift();
  v.sattrs = o(u, x);
  var E = m.shift();
  v.sigalg = o(u, E);
  var T = m.shift();
  v.sig = o(u, T), v.sigval = c(u, T);
  var P = null;
  return v.obj = new y(), P = new p(), P.hTLV = v.version, v.obj.dCMSVersion = P, P = new p(), P.hTLV = v.si, v.obj.dSignerIdentifier = P, P = new p(), P.hTLV = v.digalg, v.obj.dDigestAlgorithm = P, P = new p(), P.hTLV = v.sattrs, v.obj.dSignedAttrs = P, P = new p(), P.hTLV = v.sigalg, v.obj.dSigAlg = P, P = new p(), P.hTLV = v.sig, v.obj.dSig = P, v.obj.dUnsignedAttrs = new g(), v;
};
(typeof KJUR.asn1.csr > "u" || !KJUR.asn1.csr) && (KJUR.asn1.csr = {});
KJUR.asn1.csr.CertificationRequest = function(u) {
  var r = KJUR, a = r.asn1, e = a.DERBitString, n = a.DERSequence, o = a.csr;
  a.x509;
  var c = o.CertificationRequestInfo;
  o.CertificationRequest.superclass.constructor.call(this), this.setByParam = function(l) {
    this.params = l;
  }, this.sign = function() {
    var l = new c(this.params).tohex(), d = new KJUR.crypto.Signature({ alg: this.params.sigalg });
    d.init(this.params.sbjprvkey), d.updateHex(l);
    var p = d.sign();
    this.params.sighex = p;
  }, this.getPEM = function() {
    return hextopem(this.tohex(), "CERTIFICATE REQUEST");
  }, this.tohex = function() {
    var l = this.params, d = new KJUR.asn1.csr.CertificationRequestInfo(this.params), p = new KJUR.asn1.x509.AlgorithmIdentifier({ name: l.sigalg });
    if (l.sighex == null && l.sbjprvkey != null && this.sign(), l.sighex == null)
      throw new Error("sighex or sbjprvkey parameter not defined");
    var h = new e({ hex: "00" + l.sighex }), g = new n({ array: [d, p, h] });
    return g.tohex();
  }, this.getEncodedHex = function() {
    return this.tohex();
  }, u !== void 0 && this.setByParam(u);
};
extendClass(KJUR.asn1.csr.CertificationRequest, KJUR.asn1.ASN1Object);
KJUR.asn1.csr.CertificationRequestInfo = function(u) {
  var r = KJUR, a = r.asn1;
  a.DERBitString;
  var e = a.DERSequence, n = a.DERInteger, o = a.DERUTF8String, c = a.DERTaggedObject, l = a.ASN1Util.newObject, d = a.csr, p = a.x509, h = p.X500Name, g = p.Extensions, y = p.SubjectPublicKeyInfo;
  d.AttributeList, d.CertificationRequestInfo.superclass.constructor.call(this), this.params = null, this.setByParam = function(m) {
    m != null && (this.params = m);
  }, this.tohex = function() {
    var m = this.params, b = [];
    if (b.push(new n({ int: 0 })), b.push(new h(m.subject)), b.push(new y(KEYUTIL.getKey(m.sbjpubkey))), m.attrs != null) {
      var R = v(m.attrs), $ = l({ tag: { tage: "a0", obj: R } });
      b.push($);
    } else if (m.extreq != null) {
      var x = new g(m.extreq), $ = l({ tag: { tage: "a0", obj: { seq: [{ oid: "1.2.840.113549.1.9.14" }, { set: [x] }] } } });
      b.push($);
    } else
      b.push(new c({ tag: "a0", explicit: !1, obj: new o({ str: "" }) }));
    var E = new e({ array: b });
    return E.tohex();
  }, this.getEncodedHex = function() {
    return this.tohex();
  };
  function v(m) {
    for (var b = Error, R = KJUR.asn1.x509.Extensions, $ = [], x = 0; x < m.length; x++) {
      var E = m[x], T = E.attr;
      if (T == "extensionRequest") {
        var P = new R(E.ext), O = { seq: [{ oid: "1.2.840.113549.1.9.14" }, { set: [P] }] };
        $.push(O);
      } else if (T == "unstructuredName") {
        var O = { seq: [{ oid: "1.2.840.113549.1.9.2" }, { set: E.names }] };
        $.push(O);
      } else if (T == "challengePassword") {
        var O = { seq: [{ oid: "1.2.840.113549.1.9.7" }, { set: [{ utf8str: E.password }] }] };
        $.push(O);
      } else
        throw new b("unknown CSR attribute");
    }
    return { set: $ };
  }
  u != null && this.setByParam(u);
};
extendClass(KJUR.asn1.csr.CertificationRequestInfo, KJUR.asn1.ASN1Object);
KJUR.asn1.csr.AttributeList = function(u) {
};
extendClass(KJUR.asn1.csr.AttributeList, KJUR.asn1.ASN1Object);
KJUR.asn1.csr.CSRUtil = new function() {
}();
KJUR.asn1.csr.CSRUtil.newCSRPEM = function(u) {
  var r = KJUR.asn1.csr, a = new r.CertificationRequest(u), e = a.getPEM();
  return e;
};
KJUR.asn1.csr.CSRUtil.getParam = function(u, r) {
  var a = ASN1HEX, e = a.getV, n = a.getIdxbyList, o = a.getTLVbyList, c = a.getTLVbyListEx, l = a.getVbyListEx, d = function(x) {
    var E = n(x, 0, [0, 3, 0, 0], "06");
    return e(x, E) != "2a864886f70d01090e" ? null : o(x, 0, [0, 3, 0, 1, 0], "30");
  }, p = {};
  if (u.indexOf("-----BEGIN CERTIFICATE REQUEST") == -1)
    throw new Error("argument is not PEM file");
  var h = pemtohex(u, "CERTIFICATE REQUEST");
  r && (p.tbs = o(h, 0, [0]));
  try {
    var g = c(h, 0, [0, 1]);
    if (g == "3000")
      p.subject = {};
    else {
      var b = new X509();
      p.subject = b.getX500Name(g);
    }
  } catch {
  }
  var y = c(h, 0, [0, 2]), v = KEYUTIL.getKey(y, null, "pkcs8pub");
  p.sbjpubkey = KEYUTIL.getPEM(v, "PKCS8PUB");
  var m = d(h), b = new X509();
  m != null && (p.extreq = b.getExtParamArray(m));
  try {
    var R = c(h, 0, [1], "30"), b = new X509();
    p.sigalg = b.getAlgorithmIdentifierName(R);
  } catch {
  }
  try {
    var $ = l(h, 0, [2]);
    p.sighex = $;
  } catch {
  }
  return p;
};
KJUR.asn1.csr.CSRUtil.verifySignature = function(u) {
  try {
    var r = null;
    if (typeof u == "string" && u.indexOf("-----BEGIN CERTIFICATE REQUEST") != -1 ? r = KJUR.asn1.csr.CSRUtil.getParam(u, !0) : typeof u == "object" && u.sbjpubkey != null && u.sigalg != null && u.sighex != null && u.tbs != null && (r = u), r == null)
      return !1;
    var a = new KJUR.crypto.Signature({ alg: r.sigalg });
    return a.init(r.sbjpubkey), a.updateHex(r.tbs), a.verify(r.sighex);
  } catch (e) {
    return alert(e), !1;
  }
};
(typeof KJUR > "u" || !KJUR) && (KJUR = {});
(typeof KJUR.asn1 > "u" || !KJUR.asn1) && (KJUR.asn1 = {});
(typeof KJUR.asn1.ocsp > "u" || !KJUR.asn1.ocsp) && (KJUR.asn1.ocsp = {});
KJUR.asn1.ocsp.DEFAULT_HASH = "sha1";
KJUR.asn1.ocsp.OCSPResponse = function(u) {
  KJUR.asn1.ocsp.OCSPResponse.superclass.constructor.call(this), KJUR.asn1.DEREnumerated;
  var r = KJUR.asn1.ASN1Util.newObject, a = KJUR.asn1.ocsp.ResponseBytes, e = ["successful", "malformedRequest", "internalError", "tryLater", "_not_used_", "sigRequired", "unauthorized"];
  this.params = null, this._getStatusCode = function() {
    var n = this.params.resstatus;
    return typeof n == "number" ? n : typeof n != "string" ? -1 : e.indexOf(n);
  }, this.setByParam = function(n) {
    this.params = n;
  }, this.tohex = function() {
    var n = this.params, o = this._getStatusCode();
    if (o == -1)
      throw new Error("responseStatus not supported: " + n.resstatus);
    if (o != 0)
      return r({ seq: [{ enum: { int: o } }] }).tohex();
    var c = new a(n);
    return r({ seq: [{ enum: { int: 0 } }, { tag: { tag: "a0", explicit: !0, obj: c } }] }).tohex();
  }, this.getEncodedHex = function() {
    return this.tohex();
  }, u !== void 0 && this.setByParam(u);
};
extendClass(KJUR.asn1.ocsp.OCSPResponse, KJUR.asn1.ASN1Object);
KJUR.asn1.ocsp.ResponseBytes = function(u) {
  KJUR.asn1.ocsp.ResponseBytes.superclass.constructor.call(this);
  var r = KJUR.asn1, a = r.DERSequence, e = r.DERObjectIdentifier, n = r.DEROctetString, o = r.ocsp.BasicOCSPResponse;
  this.params = null, this.setByParam = function(c) {
    this.params = c;
  }, this.tohex = function() {
    var c = this.params;
    if (c.restype != "ocspBasic")
      throw new Error("not supported responseType: " + c.restype);
    var l = new o(c), d = [];
    d.push(new e({ name: "ocspBasic" })), d.push(new n({ hex: l.tohex() }));
    var p = new a({ array: d });
    return p.tohex();
  }, this.getEncodedHex = function() {
    return this.tohex();
  }, u !== void 0 && this.setByParam(u);
};
extendClass(KJUR.asn1.ocsp.ResponseBytes, KJUR.asn1.ASN1Object);
KJUR.asn1.ocsp.BasicOCSPResponse = function(u) {
  KJUR.asn1.ocsp.BasicOCSPResponse.superclass.constructor.call(this);
  var r = Error, a = KJUR.asn1, e = a.ASN1Object, n = a.DERSequence;
  a.DERGeneralizedTime;
  var o = a.DERTaggedObject, c = a.DERBitString;
  a.x509.Extensions;
  var l = a.x509.AlgorithmIdentifier, d = a.ocsp;
  d.ResponderID, _SingleResponseList = d.SingleResponseList, _ResponseData = d.ResponseData, this.params = null, this.setByParam = function(p) {
    this.params = p;
  }, this.sign = function() {
    var p = this.params, h = p.tbsresp.tohex(), g = new KJUR.crypto.Signature({ alg: p.sigalg });
    g.init(p.reskey), g.updateHex(h), p.sighex = g.sign();
  }, this.tohex = function() {
    var p = this.params;
    p.tbsresp == null && (p.tbsresp = new _ResponseData(p)), p.sighex == null && p.reskey != null && this.sign();
    var h = [];
    if (h.push(p.tbsresp), h.push(new l({ name: p.sigalg })), h.push(new c({ hex: "00" + p.sighex })), p.certs != null && p.certs.length != null) {
      for (var g = [], y = 0; y < p.certs.length; y++) {
        var v = p.certs[y], m = null;
        if (ASN1HEX.isASN1HEX(v))
          m = v;
        else if (v.match(/-----BEGIN/))
          m = pemtohex(v);
        else
          throw new r("certs[" + y + "] not hex or PEM");
        g.push(new e({ tlv: m }));
      }
      var b = new n({ array: g });
      h.push(new o({ tag: "a0", explicit: !0, obj: b }));
    }
    var R = new n({ array: h });
    return R.tohex();
  }, this.getEncodedHex = function() {
    return this.tohex();
  }, u !== void 0 && this.setByParam(u);
};
extendClass(KJUR.asn1.ocsp.BasicOCSPResponse, KJUR.asn1.ASN1Object);
KJUR.asn1.ocsp.ResponseData = function(u) {
  KJUR.asn1.ocsp.ResponseData.superclass.constructor.call(this);
  var r = KJUR.asn1, a = r.DERSequence, e = r.DERGeneralizedTime, n = r.DERTaggedObject, o = r.x509.Extensions, c = r.ocsp, l = c.ResponderID;
  _SingleResponseList = c.SingleResponseList, this.params = null, this.tohex = function() {
    var d = this.params;
    d.respid != null, d.prodat != null, d.array != null;
    var p = [];
    if (p.push(new l(d.respid)), p.push(new e(d.prodat)), p.push(new _SingleResponseList(d.array)), d.ext != null) {
      var h = new o(d.ext);
      p.push(new n({ tag: "a1", explicit: !0, obj: h }));
    }
    var g = new a({ array: p });
    return g.tohex();
  }, this.getEncodedHex = function() {
    return this.tohex();
  }, this.setByParam = function(d) {
    this.params = d;
  }, u !== void 0 && this.setByParam(u);
};
extendClass(KJUR.asn1.ocsp.ResponseData, KJUR.asn1.ASN1Object);
KJUR.asn1.ocsp.ResponderID = function(u) {
  KJUR.asn1.ocsp.ResponderID.superclass.constructor.call(this);
  var r = KJUR, a = r.asn1, e = a.ASN1Util.newObject, n = a.x509.X500Name, o = r.lang.String.isHex, c = Error;
  this.params = null, this.tohex = function() {
    var l = this.params;
    if (l.key != null) {
      var d = null;
      if (typeof l.key == "string") {
        if (o(l.key) && (d = l.key), l.key.match(/-----BEGIN CERTIFICATE/)) {
          var p = new X509(l.key), h = p.getExtSubjectKeyIdentifier();
          h != null && (d = h.kid.hex);
        }
      } else if (l.key instanceof X509) {
        var h = l.key.getExtSubjectKeyIdentifier();
        h != null && (d = h.kid.hex);
      }
      if (d == null)
        throw new c("wrong key member value");
      var g = e({ tag: { tag: "a2", explicit: !0, obj: { octstr: { hex: d } } } });
      return g.tohex();
    } else if (l.name != null) {
      var y = null;
      if (typeof l.name == "string" && l.name.match(/-----BEGIN CERTIFICATE/)) {
        var p = new X509(l.name);
        y = p.getSubject();
      } else
        l.name instanceof X509 ? y = l.name.getSubject() : typeof l.name == "object" && (l.name.array != null || l.name.str != null) && (y = l.name);
      if (y == null)
        throw new c("wrong name member value");
      var g = e({ tag: { tag: "a1", explicit: !0, obj: new n(y) } });
      return g.tohex();
    }
    throw new c("key or name not specified");
  }, this.getEncodedHex = function() {
    return this.tohex();
  }, this.setByParam = function(l) {
    this.params = l;
  }, u !== void 0 && this.setByParam(u);
};
extendClass(KJUR.asn1.ocsp.ResponderID, KJUR.asn1.ASN1Object);
KJUR.asn1.ocsp.SingleResponseList = function(u) {
  KJUR.asn1.ocsp.SingleResponseList.superclass.constructor.call(this);
  var r = KJUR.asn1, a = r.DERSequence, e = r.ocsp.SingleResponse;
  this.params = null, this.tohex = function() {
    var n = this.params;
    if (typeof n != "object" || n.length == null)
      throw new Error("params not specified properly");
    for (var o = [], c = 0; c < n.length; c++)
      o.push(new e(n[c]));
    var l = new a({ array: o });
    return l.tohex();
  }, this.getEncodedHex = function() {
    return this.tohex();
  }, this.setByParam = function(n) {
    this.params = n;
  }, u !== void 0 && this.setByParam(u);
};
extendClass(KJUR.asn1.ocsp.SingleResponseList, KJUR.asn1.ASN1Object);
KJUR.asn1.ocsp.SingleResponse = function(u) {
  var r = Error, a = KJUR, e = a.asn1, n = e.DERSequence, o = e.DERGeneralizedTime, c = e.DERTaggedObject, l = e.ocsp, d = l.CertID, p = l.CertStatus, h = e.x509, g = h.Extensions;
  l.SingleResponse.superclass.constructor.call(this), this.params = null, this.tohex = function() {
    var y = this.params, v = [];
    if (y.certid == null)
      throw new r("certid unspecified");
    if (y.status == null)
      throw new r("status unspecified");
    if (y.thisupdate == null)
      throw new r("thisupdate unspecified");
    if (v.push(new d(y.certid)), v.push(new p(y.status)), v.push(new o(y.thisupdate)), y.nextupdate != null) {
      var m = new o(y.nextupdate);
      v.push(new c({ tag: "a0", explicit: !0, obj: m }));
    }
    if (y.ext != null) {
      var b = new g(y.ext);
      v.push(new c({ tag: "a1", explicit: !0, obj: b }));
    }
    var R = new n({ array: v });
    return R.tohex();
  }, this.getEncodedHex = function() {
    return this.tohex();
  }, this.setByParam = function(y) {
    this.params = y;
  }, u !== void 0 && this.setByParam(u);
};
extendClass(KJUR.asn1.ocsp.SingleResponse, KJUR.asn1.ASN1Object);
KJUR.asn1.ocsp.CertID = function(u) {
  var r = KJUR, a = r.asn1, e = a.DEROctetString, n = a.DERInteger, o = a.DERSequence, c = a.x509, l = c.AlgorithmIdentifier, d = a.ocsp;
  d.DEFAULT_HASH;
  var p = r.crypto, h = p.Util.hashHex, g = X509, y = ASN1HEX, v = y.getVbyList;
  d.CertID.superclass.constructor.call(this), this.DEFAULT_HASH = "sha1", this.params = null, this.setByValue = function(m, b, R, $) {
    $ == null && ($ = this.DEFAULT_HASH), this.params = { alg: $, issname: m, isskey: b, sbjsn: R };
  }, this.setByCert = function(m, b, R) {
    R == null && (R = this.DEFAULT_HASH), this.params = { alg: R, issuerCert: m, subjectCert: b };
  }, this.getParamByCerts = function(m, b, R) {
    R == null && (R = this.DEFAULT_HASH);
    var $ = new g(m), x = new g(b), E = h($.getSubjectHex(), R), T = $.getPublicKeyHex(), P = h(v(T, 0, [1], "03", !0), R), O = x.getSerialNumberHex(), w = { alg: R, issname: E, isskey: P, sbjsn: O };
    return w;
  }, this.tohex = function() {
    if (typeof this.params != "object")
      throw new Error("params not set");
    var m = this.params, b, R, $, x;
    if (m.alg == null ? x = this.DEFAULT_HASH : x = m.alg, m.issuerCert != null && m.subjectCert != null) {
      var E = this.getParamByCerts(m.issuerCert, m.subjectCert, x);
      b = E.issname, R = E.isskey, $ = E.sbjsn;
    } else if (m.issname != null && m.isskey != null && m.sbjsn != null)
      b = m.issname, R = m.isskey, $ = m.sbjsn;
    else
      throw new Error("required param members not defined");
    var T = new l({ name: x }), P = new e({ hex: b }), O = new e({ hex: R }), w = new n({ hex: $ }), _ = new o({ array: [T, P, O, w] });
    return this.hTLV = _.tohex(), this.hTLV;
  }, this.getEncodedHex = function() {
    return this.tohex();
  }, u !== void 0 && this.setByParam(u);
};
extendClass(KJUR.asn1.ocsp.CertID, KJUR.asn1.ASN1Object);
KJUR.asn1.ocsp.CertStatus = function(u) {
  KJUR.asn1.ocsp.CertStatus.superclass.constructor.call(this), this.params = null, this.tohex = function() {
    var r = this.params;
    if (r.status == "good")
      return "8000";
    if (r.status == "unknown")
      return "8200";
    if (r.status == "revoked") {
      var a = [{ gentime: { str: r.time } }];
      r.reason != null && a.push({ tag: { tag: "a0", explicit: !0, obj: { enum: { int: r.reason } } } });
      var e = { tag: "a1", explicit: !1, obj: { seq: a } };
      return KJUR.asn1.ASN1Util.newObject({ tag: e }).tohex();
    }
    throw new Error("bad status");
  }, this.getEncodedHex = function() {
    return this.tohex();
  }, this.setByParam = function(r) {
    this.params = r;
  }, u !== void 0 && this.setByParam(u);
};
extendClass(KJUR.asn1.ocsp.CertStatus, KJUR.asn1.ASN1Object);
KJUR.asn1.ocsp.Request = function(u) {
  var r = KJUR, a = r.asn1, e = a.DERSequence, n = a.ocsp;
  if (n.Request.superclass.constructor.call(this), this.dReqCert = null, this.dExt = null, this.tohex = function() {
    var c = [];
    if (this.dReqCert === null)
      throw "reqCert not set";
    c.push(this.dReqCert);
    var l = new e({ array: c });
    return this.hTLV = l.tohex(), this.hTLV;
  }, this.getEncodedHex = function() {
    return this.tohex();
  }, typeof u < "u") {
    var o = new n.CertID(u);
    this.dReqCert = o;
  }
};
extendClass(KJUR.asn1.ocsp.Request, KJUR.asn1.ASN1Object);
KJUR.asn1.ocsp.TBSRequest = function(u) {
  var r = KJUR, a = r.asn1, e = a.DERSequence, n = a.ocsp;
  n.TBSRequest.superclass.constructor.call(this), this.version = 0, this.dRequestorName = null, this.dRequestList = [], this.dRequestExt = null, this.setRequestListByParam = function(o) {
    for (var c = [], l = 0; l < o.length; l++) {
      var d = new n.Request(o[0]);
      c.push(d);
    }
    this.dRequestList = c;
  }, this.tohex = function() {
    var o = [];
    if (this.version !== 0)
      throw "not supported version: " + this.version;
    if (this.dRequestorName !== null)
      throw "requestorName not supported";
    var c = new e({ array: this.dRequestList });
    if (o.push(c), this.dRequestExt !== null)
      throw "requestExtensions not supported";
    var l = new e({ array: o });
    return this.hTLV = l.tohex(), this.hTLV;
  }, this.getEncodedHex = function() {
    return this.tohex();
  }, u !== void 0 && u.reqList !== void 0 && this.setRequestListByParam(u.reqList);
};
extendClass(KJUR.asn1.ocsp.TBSRequest, KJUR.asn1.ASN1Object);
KJUR.asn1.ocsp.OCSPRequest = function(u) {
  var r = KJUR, a = r.asn1, e = a.DERSequence, n = a.ocsp;
  if (n.OCSPRequest.superclass.constructor.call(this), this.dTbsRequest = null, this.dOptionalSignature = null, this.tohex = function() {
    var c = [];
    if (this.dTbsRequest !== null)
      c.push(this.dTbsRequest);
    else
      throw "tbsRequest not set";
    if (this.dOptionalSignature !== null)
      throw "optionalSignature not supported";
    var l = new e({ array: c });
    return this.hTLV = l.tohex(), this.hTLV;
  }, this.getEncodedHex = function() {
    return this.tohex();
  }, u !== void 0 && u.reqList !== void 0) {
    var o = new n.TBSRequest(u);
    this.dTbsRequest = o;
  }
};
extendClass(KJUR.asn1.ocsp.OCSPRequest, KJUR.asn1.ASN1Object);
KJUR.asn1.ocsp.OCSPUtil = {};
KJUR.asn1.ocsp.OCSPUtil.getRequestHex = function(u, r, a) {
  var e = KJUR, n = e.asn1, o = n.ocsp;
  a === void 0 && (a = o.DEFAULT_HASH);
  var c = { alg: a, issuerCert: u, subjectCert: r }, l = new o.OCSPRequest({ reqList: [c] });
  return l.tohex();
};
KJUR.asn1.ocsp.OCSPUtil.getOCSPResponseInfo = function(u) {
  var r = ASN1HEX, a = r.getVbyList, e = r.getVbyListEx, n = r.getIdxbyList;
  r.getIdxbyListEx;
  var o = r.getV, c = {};
  try {
    var l = e(u, 0, [0], "0a");
    c.responseStatus = parseInt(l, 16);
  } catch {
  }
  if (c.responseStatus !== 0)
    return c;
  try {
    var d = n(u, 0, [1, 0, 1, 0, 0, 2, 0, 1]);
    u.substr(d, 2) === "80" ? c.certStatus = "good" : u.substr(d, 2) === "a1" ? (c.certStatus = "revoked", c.revocationTime = hextoutf8(a(u, d, [0]))) : u.substr(d, 2) === "82" && (c.certStatus = "unknown");
  } catch {
  }
  try {
    var p = n(u, 0, [1, 0, 1, 0, 0, 2, 0, 2]);
    c.thisUpdate = hextoutf8(o(u, p));
  } catch {
  }
  try {
    var h = n(u, 0, [1, 0, 1, 0, 0, 2, 0, 3]);
    u.substr(h, 2) === "a0" && (c.nextUpdate = hextoutf8(a(u, h, [0])));
  } catch {
  }
  return c;
};
KJUR.asn1.ocsp.OCSPParser = function() {
  var u = Error, r = X509, a = new r(), e = ASN1HEX, n = e.getV, o = e.getTLV, c = e.getIdxbyList, l = e.getVbyList, d = e.getTLVbyList, p = e.getVbyListEx, h = e.getTLVbyListEx, g = e.getChildIdx;
  this.getOCSPRequest = function(y) {
    var v = g(y, 0);
    if (v.length != 1 && v.length != 2)
      throw new u("wrong number elements: " + v.length);
    var m = this.getTBSRequest(o(y, v[0]));
    return m;
  }, this.getTBSRequest = function(y) {
    var v = {}, m = h(y, 0, [0], "30");
    v.array = this.getRequestList(m);
    var b = h(y, 0, ["[2]", 0], "30");
    return b != null && (v.ext = a.getExtParamArray(b)), v;
  }, this.getRequestList = function(y) {
    for (var v = [], m = g(y, 0), b = 0; b < m.length; b++) {
      var y = o(y, m[b]);
      v.push(this.getRequest(y));
    }
    return v;
  }, this.getRequest = function(y) {
    var v = g(y, 0);
    if (v.length != 1 && v.length != 2)
      throw new u("wrong number elements: " + v.length);
    var m = this.getCertID(o(y, v[0]));
    if (v.length == 2) {
      var b = c(y, 0, [1, 0]);
      m.ext = a.getExtParamArray(o(y, b));
    }
    return m;
  }, this.getCertID = function(y) {
    var v = g(y, 0);
    if (v.length != 4)
      throw new u("wrong number elements: " + v.length);
    var m = new r(), b = {};
    return b.alg = m.getAlgorithmIdentifierName(o(y, v[0])), b.issname = n(y, v[1]), b.isskey = n(y, v[2]), b.sbjsn = n(y, v[3]), b;
  }, this.getOCSPResponse = function(y) {
    var v = g(y, 0), m, b = n(y, v[0]), R = parseInt(b);
    if (v.length == 1)
      return { resstatus: R };
    var $ = d(y, 0, [1, 0]);
    return m = this.getResponseBytes($), m.resstatus = R, m;
  }, this.getResponseBytes = function(y) {
    var v = g(y, 0), m, b = d(y, 0, [1, 0]);
    m = this.getBasicOCSPResponse(b);
    var R = n(y, v[0]);
    return m.restype = KJUR.asn1.x509.OID.oid2name(hextooid(R)), m;
  }, this.getBasicOCSPResponse = function(y) {
    var v = g(y, 0), m;
    m = this.getResponseData(o(y, v[0]));
    var b = new X509();
    m.alg = b.getAlgorithmIdentifierName(o(y, v[1]));
    var R = n(y, v[2]);
    m.sighex = R.substr(2);
    var $ = p(y, 0, ["[0]"]);
    if ($ != null) {
      for (var x = g($, 0), E = [], T = 0; T < x.length; T++) {
        var P = o($, x[T]);
        E.push(P);
      }
      m.certs = E;
    }
    return m;
  }, this.getResponseData = function(y) {
    var v = g(y, 0), m = v.length, b = {}, R = 0;
    y.substr(v[0], 2) == "a0" && R++, b.respid = this.getResponderID(o(y, v[R++]));
    var $ = n(y, v[R++]);
    if (b.prodat = hextoutf8($), b.array = this.getSingleResponseList(o(y, v[R++])), y.substr(v[m - 1], 2) == "a1") {
      var x = d(y, v[m - 1], [0]), E = new X509();
      b.ext = E.getExtParamArray(x);
    }
    return b;
  }, this.getResponderID = function(y) {
    var v = {};
    if (y.substr(0, 2) == "a2") {
      var m = l(y, 0, [0]);
      v.key = m;
    }
    if (y.substr(0, 2) == "a1") {
      var b = d(y, 0, [0]), R = new X509();
      v.name = R.getX500Name(b);
    }
    return v;
  }, this.getSingleResponseList = function(y) {
    for (var v = g(y, 0), m = [], b = 0; b < v.length; b++) {
      var R = this.getSingleResponse(o(y, v[b]));
      m.push(R);
    }
    return m;
  }, this.getSingleResponse = function(y) {
    var v = g(y, 0), m = {}, b = this.getCertID(o(y, v[0]));
    m.certid = b;
    var R = this.getCertStatus(o(y, v[1]));
    if (m.status = R, y.substr(v[2], 2) == "18") {
      var $ = n(y, v[2]);
      m.thisupdate = hextoutf8($);
    }
    for (var x = 3; x < v.length; x++) {
      if (y.substr(v[x], 2) == "a0") {
        var E = l(y, v[x], [0], "18");
        m.nextupdate = hextoutf8(E);
      }
      if (y.substr(v[x], 2) == "a1") {
        var T = new X509(), P = d(y, 0, [x, 0]);
        m.ext = T.getExtParamArray(P);
      }
    }
    return m;
  }, this.getCertStatus = function(y) {
    var v = {};
    if (y == "8000")
      return { status: "good" };
    if (y == "8200")
      return { status: "unknown" };
    if (y.substr(0, 2) == "a1") {
      v.status = "revoked";
      var m = l(y, 0, [0]), b = hextoutf8(m);
      v.time = b;
    }
    return v;
  };
};
var KJUR;
(typeof KJUR > "u" || !KJUR) && (KJUR = {});
(typeof KJUR.lang > "u" || !KJUR.lang) && (KJUR.lang = {});
KJUR.lang.String = function() {
};
function stoBA(u) {
  for (var r = new Array(), a = 0; a < u.length; a++)
    r[a] = u.charCodeAt(a);
  return r;
}
function BAtohex(u) {
  for (var r = "", a = 0; a < u.length; a++) {
    var e = u[a].toString(16);
    e.length == 1 && (e = "0" + e), r = r + e;
  }
  return r;
}
function stohex(u) {
  return BAtohex(stoBA(u));
}
function b64tob64u(u) {
  return u = u.replace(/\=/g, ""), u = u.replace(/\+/g, "-"), u = u.replace(/\//g, "_"), u;
}
function b64utob64(u) {
  return u.length % 4 == 2 ? u = u + "==" : u.length % 4 == 3 && (u = u + "="), u = u.replace(/-/g, "+"), u = u.replace(/_/g, "/"), u;
}
function hextob64u(u) {
  return u.length % 2 == 1 && (u = "0" + u), b64tob64u(hex2b64(u));
}
function b64utohex(u) {
  return b64tohex(b64utob64(u));
}
var utf8tob64u, b64utoutf8;
typeof Buffer == "function" ? (utf8tob64u = function(u) {
  return b64tob64u(Buffer.from(u, "utf8").toString("base64"));
}, b64utoutf8 = function(u) {
  return Buffer.from(b64utob64(u), "base64").toString("utf8");
}) : (utf8tob64u = function(u) {
  return hextob64u(uricmptohex(encodeURIComponentAll(u)));
}, b64utoutf8 = function(u) {
  return decodeURIComponent(hextouricmp(b64utohex(u)));
});
function utf8tohex(u) {
  return uricmptohex(encodeURIComponentAll(u)).toLowerCase();
}
function hextoutf8(u) {
  try {
    return decodeURIComponent(hextouricmp(u));
  } catch {
    return null;
  }
}
function iso88591hextoutf8(u) {
  return hextoutf8(iso88591hextoutf8hex(u));
}
function iso88591hextoutf8hex(u) {
  for (var r = u.match(/.{1,2}/g), a = [], e = 0; e < r.length; e++) {
    var n = parseInt(r[e], 16);
    161 <= n && n <= 191 ? (a.push("c2"), a.push(r[e])) : 192 <= n && n <= 255 ? (a.push("c3"), a.push((n - 64).toString(16))) : a.push(r[e]);
  }
  return a.join("");
}
function hextorstr(u) {
  for (var r = "", a = 0; a < u.length - 1; a += 2)
    r += String.fromCharCode(parseInt(u.substr(a, 2), 16));
  return r;
}
function rstrtohex(u) {
  for (var r = "", a = 0; a < u.length; a++)
    r += ("0" + u.charCodeAt(a).toString(16)).slice(-2);
  return r;
}
function hextob64(u) {
  return hex2b64(u);
}
function foldnl(u, r) {
  return u = u.replace(new RegExp("(.{" + r + "})", "g"), `$1\r
`), u = u.replace(/\s+$/, ""), u;
}
function b64nltohex(u) {
  var r = u.replace(/[^0-9A-Za-z\/+=]*/g, ""), a = b64tohex(r);
  return a;
}
function hextopem(u, r) {
  return "-----BEGIN " + r + `-----\r
` + foldnl(hextob64(u), 64) + `\r
-----END ` + r + `-----\r
`;
}
function pemtohex(u, r) {
  if (u.indexOf("-----BEGIN ") == -1)
    throw new Error("can't find PEM header");
  return r !== void 0 ? (u = u.replace(new RegExp("^[^]*-----BEGIN " + r + "-----"), ""), u = u.replace(new RegExp("-----END " + r + "-----[^]*$"), "")) : (u = u.replace(/^[^]*-----BEGIN [^-]+-----/, ""), u = u.replace(/-----END [^-]+-----[^]*$/, "")), b64nltohex(u);
}
function zulutomsec(u) {
  var r, a, e, n, o, c, l, d, p, h;
  if (u = timetogen(u), h = u.match(/^(\d{4})(\d\d)(\d\d)(\d\d)(\d\d)(\d\d)(|\.\d+)Z$/), h)
    return r = parseInt(h[1]), a = parseInt(h[2]) - 1, e = parseInt(h[3]), n = parseInt(h[4]), o = parseInt(h[5]), c = parseInt(h[6]), l = 0, d = h[7], d !== "" && (p = (d.substr(1) + "00").substr(0, 3), l = parseInt(p)), Date.UTC(r, a, e, n, o, c, l);
  throw new Error("unsupported zulu format: " + u);
}
function zulutosec(u) {
  return Math.round(zulutomsec(u) / 1e3);
}
function timetogen(u) {
  return u.match(/^[0-9]{12}Z$/) || u.match(/^[0-9]{12}[.][0-9]*Z$/) ? u.match(/^[0-4]/) ? "20" + u : "19" + u : u;
}
function uricmptohex(u) {
  return u.replace(/%/g, "");
}
function hextouricmp(u) {
  return u.replace(/(..)/g, "%$1");
}
function ipv6tohex(u) {
  var r = "malformed IPv6 address";
  if (!u.match(/^[0-9A-Fa-f:]+$/))
    throw r;
  u = u.toLowerCase();
  var a = u.split(":").length - 1;
  if (a < 2)
    throw r;
  var e = ":".repeat(7 - a + 2);
  u = u.replace("::", e);
  var n = u.split(":");
  if (n.length != 8)
    throw r;
  for (var o = 0; o < 8; o++)
    n[o] = ("0000" + n[o]).slice(-4);
  return n.join("");
}
function hextoipv6(u) {
  if (!u.match(/^[0-9A-Fa-f]{32}$/))
    throw new Error("malformed IPv6 address: " + u);
  u = u.toLowerCase();
  var r = u.match(/.{1,4}/g);
  r = r.map(function(n) {
    return n.replace(/^0+/, "");
  }), r = r.map(function(n) {
    return n == "" ? "0" : n;
  }), u = ":" + r.join(":") + ":";
  var a = u.match(/:(0:){2,}/g);
  if (a == null)
    return u.slice(1, -1);
  var e = a.sort().slice(-1)[0];
  return u = u.replace(e.substr(0, e.length - 1), ":"), u.substr(0, 2) != "::" && (u = u.substr(1)), u.substr(-2, 2) != "::" && (u = u.substr(0, u.length - 1)), u;
}
function hextoip(u) {
  var r = new Error("malformed hex value");
  if (!u.match(/^([0-9A-Fa-f][0-9A-Fa-f]){1,}$/))
    throw r;
  if (u.length == 8) {
    var a;
    try {
      return a = parseInt(u.substr(0, 2), 16) + "." + parseInt(u.substr(2, 2), 16) + "." + parseInt(u.substr(4, 2), 16) + "." + parseInt(u.substr(6, 2), 16), a;
    } catch {
      throw r;
    }
  } else if (u.length == 16)
    try {
      return hextoip(u.substr(0, 8)) + "/" + ipprefixlen(u.substr(8));
    } catch {
      throw r;
    }
  else {
    if (u.length == 32)
      return hextoipv6(u);
    if (u.length == 64) {
      try {
        return hextoipv6(u.substr(0, 32)) + "/" + ipprefixlen(u.substr(32));
      } catch {
        throw r;
      }
      return;
    } else
      return u;
  }
}
function ipprefixlen(u) {
  var r = new Error("malformed mask"), a;
  try {
    a = new BigInteger$5(u, 16).toString(2);
  } catch {
    throw r;
  }
  if (!a.match(/^1*0*$/))
    throw r;
  return a.replace(/0+$/, "").length;
}
function iptohex(u) {
  var r = new Error("malformed IP address");
  if (u = u.toLowerCase(u), !u.match(/^[0-9a-f.:/]+$/))
    throw r;
  if (u.match(/^[0-9.]+$/)) {
    var a = u.split(".");
    if (a.length !== 4)
      throw r;
    var e = "";
    try {
      for (var n = 0; n < 4; n++) {
        var o = parseInt(a[n]);
        e += ("0" + o.toString(16)).slice(-2);
      }
      return e;
    } catch {
      throw r;
    }
  } else if (u.match(/^[0-9.]+\/[0-9]+$/)) {
    var c = u.split("/");
    return iptohex(c[0]) + ipnetmask(parseInt(c[1]), 32);
  } else {
    if (u.match(/^[0-9a-f:]+$/) && u.indexOf(":") !== -1)
      return ipv6tohex(u);
    if (u.match(/^[0-9a-f:]+\/[0-9]+$/) && u.indexOf(":") !== -1) {
      var c = u.split("/");
      return ipv6tohex(c[0]) + ipnetmask(parseInt(c[1]), 128);
    } else
      throw r;
  }
}
function ipnetmask(u, r) {
  if (r == 32 && u == 0)
    return "00000000";
  if (r == 128 && u == 0)
    return "00000000000000000000000000000000";
  var a = Array(u + 1).join("1") + Array(r - u + 1).join("0");
  return new BigInteger$5(a, 2).toString(16);
}
function ucs2hextoutf8(u) {
  function r(n) {
    var o = parseInt(n.substr(0, 2), 16), c = parseInt(n.substr(2), 16);
    if (o == 0 & c < 128)
      return String.fromCharCode(c);
    if (o < 8) {
      var l = 192 | (o & 7) << 3 | (c & 192) >> 6, d = 128 | c & 63;
      return hextoutf8(l.toString(16) + d.toString(16));
    }
    var l = 224 | (o & 240) >> 4, d = 128 | (o & 15) << 2 | (c & 192) >> 6, p = 128 | c & 63;
    return hextoutf8(l.toString(16) + d.toString(16) + p.toString(16));
  }
  var a = u.match(/.{4}/g), e = a.map(r);
  return e.join("");
}
function encodeURIComponentAll(u) {
  for (var r = encodeURIComponent(u), a = "", e = 0; e < r.length; e++)
    r[e] == "%" ? (a = a + r.substr(e, 3), e = e + 2) : a = a + "%" + stohex(r[e]);
  return a;
}
KJUR.lang.String.isInteger = function(u) {
  return u.match(/^[0-9]+$/) ? !0 : !!u.match(/^-[0-9]+$/);
};
KJUR.lang.String.isHex = function(u) {
  return ishex(u);
};
function ishex(u) {
  return !!(u.length % 2 == 0 && (u.match(/^[0-9a-f]+$/) || u.match(/^[0-9A-F]+$/)));
}
KJUR.lang.String.isBase64 = function(u) {
  return u = u.replace(/\s+/g, ""), !!(u.match(/^[0-9A-Za-z+\/]+={0,3}$/) && u.length % 4 == 0);
};
KJUR.lang.String.isBase64URL = function(u) {
  return u.match(/[+/=]/) ? !1 : (u = b64utob64(u), KJUR.lang.String.isBase64(u));
};
function isBase64URLDot(u) {
  return !!u.match(/^[0-9A-Za-z-_.]+$/);
}
KJUR.lang.String.isIntegerArray = function(u) {
  return u = u.replace(/\s+/g, ""), !!u.match(/^\[[0-9,]+\]$/);
};
KJUR.lang.String.isPrintable = function(u) {
  return u.match(/^[0-9A-Za-z '()+,-./:=?]*$/) !== null;
};
KJUR.lang.String.isIA5 = function(u) {
  return u.match(/^[\x20-\x21\x23-\x7f]*$/) !== null;
};
KJUR.lang.String.isMail = function(u) {
  return u.match(/^[A-Za-z0-9]{1}[A-Za-z0-9_.-]*@{1}[A-Za-z0-9_.-]{1,}\.[A-Za-z0-9]{1,}$/) !== null;
};
function hextoposhex(u) {
  return u.length % 2 == 1 ? "0" + u : u.substr(0, 1) > "7" ? "00" + u : u;
}
function oidtohex(u) {
  var r = function(l) {
    var d = l.toString(16);
    return d.length == 1 && (d = "0" + d), d;
  }, a = function(l) {
    var d = "", p = parseInt(l, 10), h = p.toString(2), g = 7 - h.length % 7;
    g == 7 && (g = 0);
    for (var y = "", v = 0; v < g; v++)
      y += "0";
    h = y + h;
    for (var v = 0; v < h.length - 1; v += 7) {
      var m = h.substr(v, 7);
      v != h.length - 7 && (m = "1" + m), d += r(parseInt(m, 2));
    }
    return d;
  };
  try {
    if (!u.match(/^[0-9.]+$/))
      return null;
    var e = "", n = u.split("."), o = parseInt(n[0], 10) * 40 + parseInt(n[1], 10);
    e += r(o), n.splice(0, 2);
    for (var c = 0; c < n.length; c++)
      e += a(n[c]);
    return e;
  } catch {
    return null;
  }
}
function hextooid(u) {
  if (!ishex(u))
    return null;
  try {
    var r = [], a = u.substr(0, 2), e = parseInt(a, 16);
    r[0] = new String(Math.floor(e / 40)), r[1] = new String(e % 40);
    for (var n = u.substr(2), o = [], c = 0; c < n.length / 2; c++)
      o.push(parseInt(n.substr(c * 2, 2), 16));
    for (var l = [], d = "", c = 0; c < o.length; c++)
      o[c] & 128 ? d = d + strpad((o[c] & 127).toString(2), 7) : (d = d + strpad((o[c] & 127).toString(2), 7), l.push(new String(parseInt(d, 2))), d = "");
    var p = r.join(".");
    return l.length > 0 && (p = p + "." + l.join(".")), p;
  } catch {
    return null;
  }
}
function inttohex(u) {
  var r = new BigInteger$5(String(u), 10);
  return twoscompl(r);
}
function twoscompl(u) {
  var r = u.toString(16);
  if (r.substr(0, 1) != "-")
    return r.length % 2 == 1 ? r = "0" + r : r.match(/^[0-7]/) || (r = "00" + r), r;
  var a = r.substr(1), e = a.length;
  e % 2 == 1 ? e += 1 : r.match(/^[0-7]/) || (e += 2);
  for (var n = "", o = 0; o < e; o++)
    n += "f";
  var c = new BigInteger$5(n, 16), l = c.xor(u).add(BigInteger$5.ONE);
  return r = l.toString(16).replace(/^-/, ""), r;
}
var strpad = function(u, r, a) {
  return a == null && (a = "0"), u.length >= r ? u : new Array(r - u.length + 1).join(a) + u;
};
function bitstrtoint(u) {
  if (u.length % 2 != 0 || (u = u.toLowerCase(), u.match(/^[0-9a-f]+$/) == null))
    return -1;
  try {
    var r = u.substr(0, 2);
    if (r == "00")
      return parseInt(u.substr(2), 16);
    var a = parseInt(r, 16);
    if (a > 7)
      return -1;
    var e = u.substr(2), n = parseInt(e, 16).toString(2);
    n == "0" && (n = "00000000"), n = n.slice(0, 0 - a);
    var o = parseInt(n, 2);
    return o == NaN ? -1 : o;
  } catch {
    return -1;
  }
}
function bitstrtobinstr(u) {
  if (typeof u != "string" || u.length % 2 != 0 || !u.match(/^[0-9a-f]+$/))
    return null;
  try {
    var r = parseInt(u.substr(0, 2), 16);
    if (r < 0 || 7 < r)
      return null;
    for (var a = u.substr(2), e = "", n = 0; n < a.length; n += 2) {
      var o = a.substr(n, 2), c = parseInt(o, 16).toString(2);
      c = ("0000000" + c).slice(-8), e += c;
    }
    return e.substr(0, e.length - r);
  } catch {
    return null;
  }
}
function namearraytobinstr(u, r) {
  for (var a = 0, e = 0; e < u.length; e++)
    a |= 1 << r[u[e]];
  for (var n = a.toString(2), o = "", e = n.length - 1; e >= 0; e--)
    o += n[e];
  return o;
}
function aryval(u, e, a) {
  if (typeof u == "object") {
    for (var e = String(e).split("."), n = 0; n < e.length && u; n++) {
      var o = e[n];
      o.match(/^[0-9]+$/) && (o = parseInt(o)), u = u[o];
    }
    return u || u === !1 ? u : a;
  }
}
function extendClass(u, r) {
  var a = function() {
  };
  a.prototype = r.prototype, u.prototype = new a(), u.prototype.constructor = u, u.superclass = r.prototype, r.prototype.constructor == Object.prototype.constructor && (r.prototype.constructor = r);
}
(typeof KJUR > "u" || !KJUR) && (KJUR = {});
(typeof KJUR.crypto > "u" || !KJUR.crypto) && (KJUR.crypto = {});
KJUR.crypto.Util = new function() {
  this.DIGESTINFOHEAD = { sha1: "3021300906052b0e03021a05000414", sha224: "302d300d06096086480165030402040500041c", sha256: "3031300d060960864801650304020105000420", sha384: "3041300d060960864801650304020205000430", sha512: "3051300d060960864801650304020305000440", md2: "3020300c06082a864886f70d020205000410", md5: "3020300c06082a864886f70d020505000410", ripemd160: "3021300906052b2403020105000414" }, this.DEFAULTPROVIDER = { md5: "cryptojs", sha1: "cryptojs", sha224: "cryptojs", sha256: "cryptojs", sha384: "cryptojs", sha512: "cryptojs", ripemd160: "cryptojs", hmacmd5: "cryptojs", hmacsha1: "cryptojs", hmacsha224: "cryptojs", hmacsha256: "cryptojs", hmacsha384: "cryptojs", hmacsha512: "cryptojs", hmacripemd160: "cryptojs", MD5withRSA: "cryptojs/jsrsa", SHA1withRSA: "cryptojs/jsrsa", SHA224withRSA: "cryptojs/jsrsa", SHA256withRSA: "cryptojs/jsrsa", SHA384withRSA: "cryptojs/jsrsa", SHA512withRSA: "cryptojs/jsrsa", RIPEMD160withRSA: "cryptojs/jsrsa", MD5withECDSA: "cryptojs/jsrsa", SHA1withECDSA: "cryptojs/jsrsa", SHA224withECDSA: "cryptojs/jsrsa", SHA256withECDSA: "cryptojs/jsrsa", SHA384withECDSA: "cryptojs/jsrsa", SHA512withECDSA: "cryptojs/jsrsa", RIPEMD160withECDSA: "cryptojs/jsrsa", SHA1withDSA: "cryptojs/jsrsa", SHA224withDSA: "cryptojs/jsrsa", SHA256withDSA: "cryptojs/jsrsa", MD5withRSAandMGF1: "cryptojs/jsrsa", SHAwithRSAandMGF1: "cryptojs/jsrsa", SHA1withRSAandMGF1: "cryptojs/jsrsa", SHA224withRSAandMGF1: "cryptojs/jsrsa", SHA256withRSAandMGF1: "cryptojs/jsrsa", SHA384withRSAandMGF1: "cryptojs/jsrsa", SHA512withRSAandMGF1: "cryptojs/jsrsa", RIPEMD160withRSAandMGF1: "cryptojs/jsrsa" }, this.CRYPTOJSMESSAGEDIGESTNAME = { md5: CryptoJS.algo.MD5, sha1: CryptoJS.algo.SHA1, sha224: CryptoJS.algo.SHA224, sha256: CryptoJS.algo.SHA256, sha384: CryptoJS.algo.SHA384, sha512: CryptoJS.algo.SHA512, ripemd160: CryptoJS.algo.RIPEMD160 }, this.getDigestInfoHex = function(u, r) {
    if (typeof this.DIGESTINFOHEAD[r] > "u")
      throw "alg not supported in Util.DIGESTINFOHEAD: " + r;
    return this.DIGESTINFOHEAD[r] + u;
  }, this.getPaddedDigestInfoHex = function(u, r, a) {
    var e = this.getDigestInfoHex(u, r), n = a / 4;
    if (e.length + 22 > n)
      throw "key is too short for SigAlg: keylen=" + a + "," + r;
    for (var o = "0001", c = "00" + e, l = "", d = n - o.length - c.length, p = 0; p < d; p += 2)
      l += "ff";
    var h = o + l + c;
    return h;
  }, this.hashString = function(u, r) {
    var a = new KJUR.crypto.MessageDigest({ alg: r });
    return a.digestString(u);
  }, this.hashHex = function(u, r) {
    var a = new KJUR.crypto.MessageDigest({ alg: r });
    return a.digestHex(u);
  }, this.sha1 = function(u) {
    return this.hashString(u, "sha1");
  }, this.sha256 = function(u) {
    return this.hashString(u, "sha256");
  }, this.sha256Hex = function(u) {
    return this.hashHex(u, "sha256");
  }, this.sha512 = function(u) {
    return this.hashString(u, "sha512");
  }, this.sha512Hex = function(u) {
    return this.hashHex(u, "sha512");
  }, this.isKey = function(u) {
    return u instanceof RSAKey || u instanceof KJUR.crypto.DSA || u instanceof KJUR.crypto.ECDSA;
  };
}();
KJUR.crypto.Util.md5 = function(u) {
  var r = new KJUR.crypto.MessageDigest({ alg: "md5", prov: "cryptojs" });
  return r.digestString(u);
};
KJUR.crypto.Util.ripemd160 = function(u) {
  var r = new KJUR.crypto.MessageDigest({ alg: "ripemd160", prov: "cryptojs" });
  return r.digestString(u);
};
KJUR.crypto.Util.SECURERANDOMGEN = new SecureRandom();
KJUR.crypto.Util.getRandomHexOfNbytes = function(u) {
  var r = new Array(u);
  return KJUR.crypto.Util.SECURERANDOMGEN.nextBytes(r), BAtohex(r);
};
KJUR.crypto.Util.getRandomBigIntegerOfNbytes = function(u) {
  return new BigInteger$5(KJUR.crypto.Util.getRandomHexOfNbytes(u), 16);
};
KJUR.crypto.Util.getRandomHexOfNbits = function(u) {
  var r = u % 8, a = (u - r) / 8, e = new Array(a + 1);
  return KJUR.crypto.Util.SECURERANDOMGEN.nextBytes(e), e[0] = (255 << r & 255 ^ 255) & e[0], BAtohex(e);
};
KJUR.crypto.Util.getRandomBigIntegerOfNbits = function(u) {
  return new BigInteger$5(KJUR.crypto.Util.getRandomHexOfNbits(u), 16);
};
KJUR.crypto.Util.getRandomBigIntegerZeroToMax = function(u) {
  for (var r = u.bitLength(); ; ) {
    var a = KJUR.crypto.Util.getRandomBigIntegerOfNbits(r);
    if (u.compareTo(a) != -1)
      return a;
  }
};
KJUR.crypto.Util.getRandomBigIntegerMinToMax = function(u, r) {
  var a = u.compareTo(r);
  if (a == 1)
    throw "biMin is greater than biMax";
  if (a == 0)
    return u;
  var e = r.subtract(u), n = KJUR.crypto.Util.getRandomBigIntegerZeroToMax(e);
  return n.add(u);
};
KJUR.crypto.MessageDigest = function(u) {
  this.setAlgAndProvider = function(r, a) {
    if (r = KJUR.crypto.MessageDigest.getCanonicalAlgName(r), r !== null && a === void 0 && (a = KJUR.crypto.Util.DEFAULTPROVIDER[r]), ":md5:sha1:sha224:sha256:sha384:sha512:ripemd160:".indexOf(r) != -1 && a == "cryptojs") {
      try {
        this.md = KJUR.crypto.Util.CRYPTOJSMESSAGEDIGESTNAME[r].create();
      } catch (e) {
        throw "setAlgAndProvider hash alg set fail alg=" + r + "/" + e;
      }
      this.updateString = function(e) {
        this.md.update(e);
      }, this.updateHex = function(e) {
        var n = CryptoJS.enc.Hex.parse(e);
        this.md.update(n);
      }, this.digest = function() {
        var e = this.md.finalize();
        return e.toString(CryptoJS.enc.Hex);
      }, this.digestString = function(e) {
        return this.updateString(e), this.digest();
      }, this.digestHex = function(e) {
        return this.updateHex(e), this.digest();
      };
    }
    if (":sha256:".indexOf(r) != -1 && a == "sjcl") {
      try {
        this.md = new sjcl.hash.sha256();
      } catch (e) {
        throw "setAlgAndProvider hash alg set fail alg=" + r + "/" + e;
      }
      this.updateString = function(e) {
        this.md.update(e);
      }, this.updateHex = function(e) {
        var n = sjcl.codec.hex.toBits(e);
        this.md.update(n);
      }, this.digest = function() {
        var e = this.md.finalize();
        return sjcl.codec.hex.fromBits(e);
      }, this.digestString = function(e) {
        return this.updateString(e), this.digest();
      }, this.digestHex = function(e) {
        return this.updateHex(e), this.digest();
      };
    }
  }, this.updateString = function(r) {
    throw "updateString(str) not supported for this alg/prov: " + this.algName + "/" + this.provName;
  }, this.updateHex = function(r) {
    throw "updateHex(hex) not supported for this alg/prov: " + this.algName + "/" + this.provName;
  }, this.digest = function() {
    throw "digest() not supported for this alg/prov: " + this.algName + "/" + this.provName;
  }, this.digestString = function(r) {
    throw "digestString(str) not supported for this alg/prov: " + this.algName + "/" + this.provName;
  }, this.digestHex = function(r) {
    throw "digestHex(hex) not supported for this alg/prov: " + this.algName + "/" + this.provName;
  }, u !== void 0 && u.alg !== void 0 && (this.algName = u.alg, u.prov === void 0 && (this.provName = KJUR.crypto.Util.DEFAULTPROVIDER[this.algName]), this.setAlgAndProvider(this.algName, this.provName));
};
KJUR.crypto.MessageDigest.getCanonicalAlgName = function(u) {
  return typeof u == "string" && (u = u.toLowerCase(), u = u.replace(/-/, "")), u;
};
KJUR.crypto.MessageDigest.getHashLength = function(u) {
  var r = KJUR.crypto.MessageDigest, a = r.getCanonicalAlgName(u);
  if (r.HASHLENGTH[a] === void 0)
    throw "not supported algorithm: " + u;
  return r.HASHLENGTH[a];
};
KJUR.crypto.MessageDigest.HASHLENGTH = { md5: 16, sha1: 20, sha224: 28, sha256: 32, sha384: 48, sha512: 64, ripemd160: 20 };
KJUR.crypto.Mac = function(u) {
  this.setAlgAndProvider = function(r, a) {
    if (r = r.toLowerCase(), r == null && (r = "hmacsha1"), r = r.toLowerCase(), r.substr(0, 4) != "hmac")
      throw "setAlgAndProvider unsupported HMAC alg: " + r;
    a === void 0 && (a = KJUR.crypto.Util.DEFAULTPROVIDER[r]), this.algProv = r + "/" + a;
    var e = r.substr(4);
    if (":md5:sha1:sha224:sha256:sha384:sha512:ripemd160:".indexOf(e) != -1 && a == "cryptojs") {
      try {
        var n = KJUR.crypto.Util.CRYPTOJSMESSAGEDIGESTNAME[e];
        this.mac = CryptoJS.algo.HMAC.create(n, this.pass);
      } catch (o) {
        throw "setAlgAndProvider hash alg set fail hashAlg=" + e + "/" + o;
      }
      this.updateString = function(o) {
        this.mac.update(o);
      }, this.updateHex = function(o) {
        var c = CryptoJS.enc.Hex.parse(o);
        this.mac.update(c);
      }, this.doFinal = function() {
        var o = this.mac.finalize();
        return o.toString(CryptoJS.enc.Hex);
      }, this.doFinalString = function(o) {
        return this.updateString(o), this.doFinal();
      }, this.doFinalHex = function(o) {
        return this.updateHex(o), this.doFinal();
      };
    }
  }, this.updateString = function(r) {
    throw "updateString(str) not supported for this alg/prov: " + this.algProv;
  }, this.updateHex = function(r) {
    throw "updateHex(hex) not supported for this alg/prov: " + this.algProv;
  }, this.doFinal = function() {
    throw "digest() not supported for this alg/prov: " + this.algProv;
  }, this.doFinalString = function(r) {
    throw "digestString(str) not supported for this alg/prov: " + this.algProv;
  }, this.doFinalHex = function(r) {
    throw "digestHex(hex) not supported for this alg/prov: " + this.algProv;
  }, this.setPassword = function(r) {
    if (typeof r == "string") {
      var a = r;
      (r.length % 2 == 1 || !r.match(/^[0-9A-Fa-f]+$/)) && (a = rstrtohex(r)), this.pass = CryptoJS.enc.Hex.parse(a);
      return;
    }
    if (typeof r != "object")
      throw "KJUR.crypto.Mac unsupported password type: " + r;
    var a = null;
    if (r.hex !== void 0) {
      if (r.hex.length % 2 != 0 || !r.hex.match(/^[0-9A-Fa-f]+$/))
        throw "Mac: wrong hex password: " + r.hex;
      a = r.hex;
    }
    if (r.utf8 !== void 0 && (a = utf8tohex(r.utf8)), r.rstr !== void 0 && (a = rstrtohex(r.rstr)), r.b64 !== void 0 && (a = b64tohex(r.b64)), r.b64u !== void 0 && (a = b64utohex(r.b64u)), a == null)
      throw "KJUR.crypto.Mac unsupported password type: " + r;
    this.pass = CryptoJS.enc.Hex.parse(a);
  }, u !== void 0 && (u.pass !== void 0 && this.setPassword(u.pass), u.alg !== void 0 && (this.algName = u.alg, u.prov === void 0 && (this.provName = KJUR.crypto.Util.DEFAULTPROVIDER[this.algName]), this.setAlgAndProvider(this.algName, this.provName)));
};
KJUR.crypto.Signature = function(u) {
  var r = null;
  if (this._setAlgNames = function() {
    var a = this.algName.match(/^(.+)with(.+)$/);
    a && (this.mdAlgName = a[1].toLowerCase(), this.pubkeyAlgName = a[2].toLowerCase(), this.pubkeyAlgName == "rsaandmgf1" && this.mdAlgName == "sha" && (this.mdAlgName = "sha1"));
  }, this._zeroPaddingOfSignature = function(a, e) {
    for (var n = "", o = e / 4 - a.length, c = 0; c < o; c++)
      n = n + "0";
    return n + a;
  }, this.setAlgAndProvider = function(a, e) {
    if (this._setAlgNames(), e != "cryptojs/jsrsa")
      throw new Error("provider not supported: " + e);
    if (":md5:sha1:sha224:sha256:sha384:sha512:ripemd160:".indexOf(this.mdAlgName) != -1) {
      try {
        this.md = new KJUR.crypto.MessageDigest({ alg: this.mdAlgName });
      } catch (n) {
        throw new Error("setAlgAndProvider hash alg set fail alg=" + this.mdAlgName + "/" + n);
      }
      this.init = function(n, o) {
        var c = null;
        try {
          o === void 0 ? c = KEYUTIL.getKey(n) : c = KEYUTIL.getKey(n, o);
        } catch (l) {
          throw "init failed:" + l;
        }
        if (c.isPrivate === !0)
          this.prvKey = c, this.state = "SIGN";
        else if (c.isPublic === !0)
          this.pubKey = c, this.state = "VERIFY";
        else
          throw "init failed.:" + c;
      }, this.updateString = function(n) {
        this.md.updateString(n);
      }, this.updateHex = function(n) {
        this.md.updateHex(n);
      }, this.sign = function() {
        if (this.sHashHex = this.md.digest(), this.prvKey === void 0 && this.ecprvhex !== void 0 && this.eccurvename !== void 0 && KJUR.crypto.ECDSA !== void 0 && (this.prvKey = new KJUR.crypto.ECDSA({ curve: this.eccurvename, prv: this.ecprvhex })), this.prvKey instanceof RSAKey && this.pubkeyAlgName === "rsaandmgf1")
          this.hSign = this.prvKey.signWithMessageHashPSS(this.sHashHex, this.mdAlgName, this.pssSaltLen);
        else if (this.prvKey instanceof RSAKey && this.pubkeyAlgName === "rsa")
          this.hSign = this.prvKey.signWithMessageHash(this.sHashHex, this.mdAlgName);
        else if (this.prvKey instanceof KJUR.crypto.ECDSA)
          this.hSign = this.prvKey.signWithMessageHash(this.sHashHex);
        else if (this.prvKey instanceof KJUR.crypto.DSA)
          this.hSign = this.prvKey.signWithMessageHash(this.sHashHex);
        else
          throw "Signature: unsupported private key alg: " + this.pubkeyAlgName;
        return this.hSign;
      }, this.signString = function(n) {
        return this.updateString(n), this.sign();
      }, this.signHex = function(n) {
        return this.updateHex(n), this.sign();
      }, this.verify = function(n) {
        if (this.sHashHex = this.md.digest(), this.pubKey === void 0 && this.ecpubhex !== void 0 && this.eccurvename !== void 0 && KJUR.crypto.ECDSA !== void 0 && (this.pubKey = new KJUR.crypto.ECDSA({ curve: this.eccurvename, pub: this.ecpubhex })), this.pubKey instanceof RSAKey && this.pubkeyAlgName === "rsaandmgf1")
          return this.pubKey.verifyWithMessageHashPSS(this.sHashHex, n, this.mdAlgName, this.pssSaltLen);
        if (this.pubKey instanceof RSAKey && this.pubkeyAlgName === "rsa")
          return this.pubKey.verifyWithMessageHash(this.sHashHex, n);
        if (KJUR.crypto.ECDSA !== void 0 && this.pubKey instanceof KJUR.crypto.ECDSA)
          return this.pubKey.verifyWithMessageHash(this.sHashHex, n);
        if (KJUR.crypto.DSA !== void 0 && this.pubKey instanceof KJUR.crypto.DSA)
          return this.pubKey.verifyWithMessageHash(this.sHashHex, n);
        throw "Signature: unsupported public key alg: " + this.pubkeyAlgName;
      };
    }
  }, this.init = function(a, e) {
    throw "init(key, pass) not supported for this alg:prov=" + this.algProvName;
  }, this.updateString = function(a) {
    throw "updateString(str) not supported for this alg:prov=" + this.algProvName;
  }, this.updateHex = function(a) {
    throw "updateHex(hex) not supported for this alg:prov=" + this.algProvName;
  }, this.sign = function() {
    throw "sign() not supported for this alg:prov=" + this.algProvName;
  }, this.signString = function(a) {
    throw "digestString(str) not supported for this alg:prov=" + this.algProvName;
  }, this.signHex = function(a) {
    throw "digestHex(hex) not supported for this alg:prov=" + this.algProvName;
  }, this.verify = function(a) {
    throw "verify(hSigVal) not supported for this alg:prov=" + this.algProvName;
  }, this.initParams = u, u !== void 0 && (u.alg !== void 0 && (this.algName = u.alg, u.prov === void 0 ? this.provName = KJUR.crypto.Util.DEFAULTPROVIDER[this.algName] : this.provName = u.prov, this.algProvName = this.algName + ":" + this.provName, this.setAlgAndProvider(this.algName, this.provName), this._setAlgNames()), u.psssaltlen !== void 0 && (this.pssSaltLen = u.psssaltlen), u.prvkeypem !== void 0)) {
    if (u.prvkeypas !== void 0)
      throw "both prvkeypem and prvkeypas parameters not supported";
    try {
      var r = KEYUTIL.getKey(u.prvkeypem);
      this.init(r);
    } catch (a) {
      throw "fatal error to load pem private key: " + a;
    }
  }
};
KJUR.crypto.Cipher = function(u) {
};
KJUR.crypto.Cipher.encrypt = function(u, r, a, e) {
  if (aryval(e, "enclag") != null && (a = e.encalg), typeof a == "string" && a.substr(-4) == "-CBC") {
    var n = r, o = u;
    aryval(e, "key") != null && (n = e.key), aryval(e, "enc") != null && (hEnc = e.enc);
    var c = CryptoJS.enc.Hex.parse(n), l = CryptoJS.enc.Hex.parse(o), d = CryptoJS.enc.Hex.parse(e.iv), p;
    if (a == "des-EDE3-CBC")
      p = CryptoJS.TripleDES.encrypt(l, c, { iv: d });
    else if (a == "aes128-CBC" || a == "aes256-CBC")
      p = CryptoJS.AES.encrypt(l, c, { iv: d });
    else
      throw new Error("unsupported algorithm: " + a);
    return p + "";
  } else
    throw new Error("Cipher.encrypt: unsupported key or algorithm");
};
KJUR.crypto.Cipher.decrypt = function(u, r, a, e) {
  if (aryval(e, "enclag") != null && (a = e.encalg), typeof a == "string" && a.substr(-4) == "-CBC") {
    var n = r, o = u;
    aryval(e, "key") != null && (n = e.key), aryval(e, "enc") != null && (o = e.enc);
    var c = CryptoJS.enc.Hex.parse(n), l = CryptoJS.enc.Hex.parse(o), d = CryptoJS.enc.Hex.parse(e.iv), p;
    if (a == "des-EDE3-CBC")
      p = CryptoJS.TripleDES.decrypt({ ciphertext: l }, c, { iv: d });
    else if (a == "aes128-CBC" || a == "aes256-CBC")
      p = CryptoJS.AES.decrypt({ ciphertext: l }, c, { iv: d });
    else
      throw new Error("unsupported algorithm: " + a);
    return CryptoJS.enc.Hex.stringify(p);
  } else
    throw new Error("Cipher.decrypt: unsupported key or algorithm");
};
KJUR.crypto.OID = new function() {
  this.oidhex2name = { "2a864886f70d010101": "rsaEncryption", "2a8648ce3d0201": "ecPublicKey", "2a8648ce380401": "dsa", "2a8648ce3d030107": "secp256r1", "2b8104001f": "secp192k1", "2b81040021": "secp224r1", "2b8104000a": "secp256k1", "2b81040022": "secp384r1", "2b81040023": "secp521r1", "2a8648ce380403": "SHA1withDSA", "608648016503040301": "SHA224withDSA", "608648016503040302": "SHA256withDSA" };
}();
(typeof KJUR > "u" || !KJUR) && (KJUR = {});
(typeof KJUR.crypto > "u" || !KJUR.crypto) && (KJUR.crypto = {});
KJUR.crypto.ECDSA = function(u) {
  var r = "secp256r1", a = Error, e = BigInteger$5, n = ECPointFp, o = KJUR.crypto.ECDSA, c = KJUR.crypto.ECParameterDB, l = o.getName, d = ASN1HEX, p = d.getVbyListEx, h = d.isASN1HEX, g = new SecureRandom();
  this.type = "EC", this.isPrivate = !1, this.isPublic = !1, this.getBigRandom = function(y) {
    return new e(y.bitLength(), g).mod(y.subtract(e.ONE)).add(e.ONE);
  }, this.setNamedCurve = function(y) {
    this.ecparams = c.getByName(y), this.prvKeyHex = null, this.pubKeyHex = null, this.curveName = y;
  }, this.setPrivateKeyHex = function(y) {
    this.isPrivate = !0, this.prvKeyHex = y;
  }, this.setPublicKeyHex = function(y) {
    this.isPublic = !0, this.pubKeyHex = y;
  }, this.getPublicKeyXYHex = function() {
    var y = this.pubKeyHex;
    if (y.substr(0, 2) !== "04")
      throw "this method supports uncompressed format(04) only";
    var v = this.ecparams.keycharlen;
    if (y.length !== 2 + v * 2)
      throw "malformed public key hex length";
    var m = {};
    return m.x = y.substr(2, v), m.y = y.substr(2 + v), m;
  }, this.getShortNISTPCurveName = function() {
    var y = this.curveName;
    return y === "secp256r1" || y === "NIST P-256" || y === "P-256" || y === "prime256v1" ? "P-256" : y === "secp384r1" || y === "NIST P-384" || y === "P-384" ? "P-384" : y === "secp521r1" || y === "NIST P-521" || y === "P-521" ? "P-521" : null;
  }, this.generateKeyPairHex = function() {
    var y = this.ecparams.n, v = this.getBigRandom(y), m = this.ecparams.keycharlen, b = ("0000000000" + v.toString(16)).slice(-m);
    this.setPrivateKeyHex(b);
    var R = this.generatePublicKeyHex();
    return { ecprvhex: b, ecpubhex: R };
  }, this.generatePublicKeyHex = function() {
    var y = new e(this.prvKeyHex, 16), v = this.ecparams.G.multiply(y), m = v.getX().toBigInteger(), b = v.getY().toBigInteger(), R = this.ecparams.keycharlen, $ = ("0000000000" + m.toString(16)).slice(-R), x = ("0000000000" + b.toString(16)).slice(-R), E = "04" + $ + x;
    return this.setPublicKeyHex(E), E;
  }, this.signWithMessageHash = function(y) {
    return this.signHex(y, this.prvKeyHex);
  }, this.signHex = function(y, v) {
    var m = new e(v, 16), b = this.ecparams.n, R = new e(y.substring(0, this.ecparams.keycharlen), 16);
    do
      var $ = this.getBigRandom(b), x = this.ecparams.G, E = x.multiply($), T = E.getX().toBigInteger().mod(b);
    while (T.compareTo(e.ZERO) <= 0);
    var P = $.modInverse(b).multiply(R.add(m.multiply(T))).mod(b);
    return o.biRSSigToASN1Sig(T, P);
  }, this.sign = function(y, v) {
    var m = v, b = this.ecparams.n, R = e.fromByteArrayUnsigned(y);
    do
      var $ = this.getBigRandom(b), x = this.ecparams.G, E = x.multiply($), T = E.getX().toBigInteger().mod(b);
    while (T.compareTo(BigInteger$5.ZERO) <= 0);
    var P = $.modInverse(b).multiply(R.add(m.multiply(T))).mod(b);
    return this.serializeSig(T, P);
  }, this.verifyWithMessageHash = function(y, v) {
    return this.verifyHex(y, v, this.pubKeyHex);
  }, this.verifyHex = function(y, v, m) {
    try {
      var b, R, $ = o.parseSigHex(v);
      b = $.r, R = $.s;
      var x = n.decodeFromHex(this.ecparams.curve, m), E = new e(y.substring(0, this.ecparams.keycharlen), 16);
      return this.verifyRaw(E, b, R, x);
    } catch {
      return !1;
    }
  }, this.verify = function(y, v, m) {
    var b, R;
    if (Bitcoin.Util.isArray(v)) {
      var $ = this.parseSig(v);
      b = $.r, R = $.s;
    } else if (typeof v == "object" && v.r && v.s)
      b = v.r, R = v.s;
    else
      throw "Invalid value for signature";
    var x;
    if (m instanceof ECPointFp)
      x = m;
    else if (Bitcoin.Util.isArray(m))
      x = n.decodeFrom(this.ecparams.curve, m);
    else
      throw "Invalid format for pubkey value, must be byte array or ECPointFp";
    var E = e.fromByteArrayUnsigned(y);
    return this.verifyRaw(E, b, R, x);
  }, this.verifyRaw = function(y, v, m, b) {
    var R = this.ecparams.n, $ = this.ecparams.G;
    if (v.compareTo(e.ONE) < 0 || v.compareTo(R) >= 0 || m.compareTo(e.ONE) < 0 || m.compareTo(R) >= 0)
      return !1;
    var x = m.modInverse(R), E = y.multiply(x).mod(R), T = v.multiply(x).mod(R), P = $.multiply(E).add(b.multiply(T)), O = P.getX().toBigInteger().mod(R);
    return O.equals(v);
  }, this.serializeSig = function(y, v) {
    var m = y.toByteArraySigned(), b = v.toByteArraySigned(), R = [];
    return R.push(2), R.push(m.length), R = R.concat(m), R.push(2), R.push(b.length), R = R.concat(b), R.unshift(R.length), R.unshift(48), R;
  }, this.parseSig = function(y) {
    var v;
    if (y[0] != 48)
      throw new Error("Signature not a valid DERSequence");
    if (v = 2, y[v] != 2)
      throw new Error("First element in signature must be a DERInteger");
    var m = y.slice(v + 2, v + 2 + y[v + 1]);
    if (v += 2 + y[v + 1], y[v] != 2)
      throw new Error("Second element in signature must be a DERInteger");
    var b = y.slice(v + 2, v + 2 + y[v + 1]);
    v += 2 + y[v + 1];
    var R = e.fromByteArrayUnsigned(m), $ = e.fromByteArrayUnsigned(b);
    return { r: R, s: $ };
  }, this.parseSigCompact = function(y) {
    if (y.length !== 65)
      throw "Signature has the wrong length";
    var v = y[0] - 27;
    if (v < 0 || v > 7)
      throw "Invalid signature type";
    var m = this.ecparams.n, b = e.fromByteArrayUnsigned(y.slice(1, 33)).mod(m), R = e.fromByteArrayUnsigned(y.slice(33, 65)).mod(m);
    return { r: b, s: R, i: v };
  }, this.readPKCS5PrvKeyHex = function(y) {
    if (h(y) === !1)
      throw new Error("not ASN.1 hex string");
    var v, m, b;
    try {
      v = p(y, 0, ["[0]", 0], "06"), m = p(y, 0, [1], "04");
      try {
        b = p(y, 0, ["[1]", 0], "03");
      } catch {
      }
    } catch {
      throw new Error("malformed PKCS#1/5 plain ECC private key");
    }
    if (this.curveName = l(v), this.curveName === void 0)
      throw "unsupported curve name";
    this.setNamedCurve(this.curveName), this.setPublicKeyHex(b), this.setPrivateKeyHex(m), this.isPublic = !1;
  }, this.readPKCS8PrvKeyHex = function(y) {
    if (h(y) === !1)
      throw new a("not ASN.1 hex string");
    var v, m, b, R;
    try {
      v = p(y, 0, [1, 0], "06"), m = p(y, 0, [1, 1], "06"), b = p(y, 0, [2, 0, 1], "04");
      try {
        R = p(y, 0, [2, 0, "[1]", 0], "03");
      } catch {
      }
    } catch {
      throw new a("malformed PKCS#8 plain ECC private key");
    }
    if (this.curveName = l(m), this.curveName === void 0)
      throw new a("unsupported curve name");
    this.setNamedCurve(this.curveName), this.setPublicKeyHex(R), this.setPrivateKeyHex(b), this.isPublic = !1;
  }, this.readPKCS8PubKeyHex = function(y) {
    if (h(y) === !1)
      throw new a("not ASN.1 hex string");
    var v, m, b;
    try {
      v = p(y, 0, [0, 0], "06"), m = p(y, 0, [0, 1], "06"), b = p(y, 0, [1], "03");
    } catch {
      throw new a("malformed PKCS#8 ECC public key");
    }
    if (this.curveName = l(m), this.curveName === null)
      throw new a("unsupported curve name");
    this.setNamedCurve(this.curveName), this.setPublicKeyHex(b);
  }, this.readCertPubKeyHex = function(y, v) {
    if (h(y) === !1)
      throw new a("not ASN.1 hex string");
    var m, b;
    try {
      m = p(y, 0, [0, 5, 0, 1], "06"), b = p(y, 0, [0, 5, 1], "03");
    } catch {
      throw new a("malformed X.509 certificate ECC public key");
    }
    if (this.curveName = l(m), this.curveName === null)
      throw new a("unsupported curve name");
    this.setNamedCurve(this.curveName), this.setPublicKeyHex(b);
  }, u !== void 0 && u.curve !== void 0 && (this.curveName = u.curve), this.curveName === void 0 && (this.curveName = r), this.setNamedCurve(this.curveName), u !== void 0 && (u.prv !== void 0 && this.setPrivateKeyHex(u.prv), u.pub !== void 0 && this.setPublicKeyHex(u.pub));
};
KJUR.crypto.ECDSA.parseSigHex = function(u) {
  var r = KJUR.crypto.ECDSA.parseSigHexInHexRS(u), a = new BigInteger$5(r.r, 16), e = new BigInteger$5(r.s, 16);
  return { r: a, s: e };
};
KJUR.crypto.ECDSA.parseSigHexInHexRS = function(u) {
  var r = ASN1HEX, a = r.getChildIdx, e = r.getV;
  if (r.checkStrictDER(u, 0), u.substr(0, 2) != "30")
    throw new Error("signature is not a ASN.1 sequence");
  var n = a(u, 0);
  if (n.length != 2)
    throw new Error("signature shall have two elements");
  var o = n[0], c = n[1];
  if (u.substr(o, 2) != "02")
    throw new Error("1st item not ASN.1 integer");
  if (u.substr(c, 2) != "02")
    throw new Error("2nd item not ASN.1 integer");
  var l = e(u, o), d = e(u, c);
  return { r: l, s: d };
};
KJUR.crypto.ECDSA.asn1SigToConcatSig = function(u) {
  var r = KJUR.crypto.ECDSA.parseSigHexInHexRS(u), a = r.r, e = r.s;
  if (a.length >= 130 && a.length <= 134) {
    if (a.length % 2 != 0)
      throw Error("unknown ECDSA sig r length error");
    if (e.length % 2 != 0)
      throw Error("unknown ECDSA sig s length error");
    a.substr(0, 2) == "00" && (a = a.substr(2)), e.substr(0, 2) == "00" && (e = e.substr(2));
    var n = Math.max(a.length, e.length);
    return a = ("000000" + a).slice(-n), e = ("000000" + e).slice(-n), a + e;
  }
  if (a.substr(0, 2) == "00" && a.length % 32 == 2 && (a = a.substr(2)), e.substr(0, 2) == "00" && e.length % 32 == 2 && (e = e.substr(2)), a.length % 32 == 30 && (a = "00" + a), e.length % 32 == 30 && (e = "00" + e), a.length % 32 != 0)
    throw Error("unknown ECDSA sig r length error");
  if (e.length % 32 != 0)
    throw Error("unknown ECDSA sig s length error");
  return a + e;
};
KJUR.crypto.ECDSA.concatSigToASN1Sig = function(u) {
  if (u.length % 4 != 0)
    throw Error("unknown ECDSA concatinated r-s sig length error");
  var r = u.substr(0, u.length / 2), a = u.substr(u.length / 2);
  return KJUR.crypto.ECDSA.hexRSSigToASN1Sig(r, a);
};
KJUR.crypto.ECDSA.hexRSSigToASN1Sig = function(u, r) {
  var a = new BigInteger$5(u, 16), e = new BigInteger$5(r, 16);
  return KJUR.crypto.ECDSA.biRSSigToASN1Sig(a, e);
};
KJUR.crypto.ECDSA.biRSSigToASN1Sig = function(u, r) {
  var a = KJUR.asn1, e = new a.DERInteger({ bigint: u }), n = new a.DERInteger({ bigint: r }), o = new a.DERSequence({ array: [e, n] });
  return o.tohex();
};
KJUR.crypto.ECDSA.getName = function(u) {
  return u === "2b8104001f" ? "secp192k1" : u === "2a8648ce3d030107" ? "secp256r1" : u === "2b8104000a" ? "secp256k1" : u === "2b81040021" ? "secp224r1" : u === "2b81040022" ? "secp384r1" : u === "2b81040023" ? "secp521r1" : "|secp256r1|NIST P-256|P-256|prime256v1|".indexOf(u) !== -1 ? "secp256r1" : "|secp256k1|".indexOf(u) !== -1 ? "secp256k1" : "|secp224r1|NIST P-224|P-224|".indexOf(u) !== -1 ? "secp224r1" : "|secp384r1|NIST P-384|P-384|".indexOf(u) !== -1 ? "secp384r1" : "|secp521r1|NIST P-521|P-521|".indexOf(u) !== -1 ? "secp521r1" : null;
};
(typeof KJUR > "u" || !KJUR) && (KJUR = {});
(typeof KJUR.crypto > "u" || !KJUR.crypto) && (KJUR.crypto = {});
KJUR.crypto.ECParameterDB = new function() {
  var u = {}, r = {};
  function a(e) {
    return new BigInteger$5(e, 16);
  }
  this.getByName = function(e) {
    var n = e;
    if (typeof r[n] < "u" && (n = r[e]), typeof u[n] < "u")
      return u[n];
    throw "unregistered EC curve name: " + n;
  }, this.regist = function(e, n, o, c, l, d, p, h, g, y, v, m) {
    u[e] = {};
    var b = a(o), R = a(c), $ = a(l), x = a(d), E = a(p), T = new ECCurveFp(b, R, $), P = T.decodePointHex("04" + h + g);
    u[e].name = e, u[e].keylen = n, u[e].keycharlen = Math.ceil(n / 8) * 2, u[e].curve = T, u[e].G = P, u[e].n = x, u[e].h = E, u[e].oid = v, u[e].info = m;
    for (var O = 0; O < y.length; O++)
      r[y[O]] = e;
  };
}();
KJUR.crypto.ECParameterDB.regist("secp128r1", 128, "FFFFFFFDFFFFFFFFFFFFFFFFFFFFFFFF", "FFFFFFFDFFFFFFFFFFFFFFFFFFFFFFFC", "E87579C11079F43DD824993C2CEE5ED3", "FFFFFFFE0000000075A30D1B9038A115", "1", "161FF7528B899B2D0C28607CA52C5B86", "CF5AC8395BAFEB13C02DA292DDED7A83", [], "", "secp128r1 : SECG curve over a 128 bit prime field");
KJUR.crypto.ECParameterDB.regist("secp160k1", 160, "FFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFEFFFFAC73", "0", "7", "0100000000000000000001B8FA16DFAB9ACA16B6B3", "1", "3B4C382CE37AA192A4019E763036F4F5DD4D7EBB", "938CF935318FDCED6BC28286531733C3F03C4FEE", [], "", "secp160k1 : SECG curve over a 160 bit prime field");
KJUR.crypto.ECParameterDB.regist("secp160r1", 160, "FFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFF7FFFFFFF", "FFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFF7FFFFFFC", "1C97BEFC54BD7A8B65ACF89F81D4D4ADC565FA45", "0100000000000000000001F4C8F927AED3CA752257", "1", "4A96B5688EF573284664698968C38BB913CBFC82", "23A628553168947D59DCC912042351377AC5FB32", [], "", "secp160r1 : SECG curve over a 160 bit prime field");
KJUR.crypto.ECParameterDB.regist("secp192k1", 192, "FFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFEFFFFEE37", "0", "3", "FFFFFFFFFFFFFFFFFFFFFFFE26F2FC170F69466A74DEFD8D", "1", "DB4FF10EC057E9AE26B07D0280B7F4341DA5D1B1EAE06C7D", "9B2F2F6D9C5628A7844163D015BE86344082AA88D95E2F9D", []);
KJUR.crypto.ECParameterDB.regist("secp192r1", 192, "FFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFEFFFFFFFFFFFFFFFF", "FFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFEFFFFFFFFFFFFFFFC", "64210519E59C80E70FA7E9AB72243049FEB8DEECC146B9B1", "FFFFFFFFFFFFFFFFFFFFFFFF99DEF836146BC9B1B4D22831", "1", "188DA80EB03090F67CBF20EB43A18800F4FF0AFD82FF1012", "07192B95FFC8DA78631011ED6B24CDD573F977A11E794811", []);
KJUR.crypto.ECParameterDB.regist("secp224r1", 224, "FFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFF000000000000000000000001", "FFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFEFFFFFFFFFFFFFFFFFFFFFFFE", "B4050A850C04B3ABF54132565044B0B7D7BFD8BA270B39432355FFB4", "FFFFFFFFFFFFFFFFFFFFFFFFFFFF16A2E0B8F03E13DD29455C5C2A3D", "1", "B70E0CBD6BB4BF7F321390B94A03C1D356C21122343280D6115C1D21", "BD376388B5F723FB4C22DFE6CD4375A05A07476444D5819985007E34", []);
KJUR.crypto.ECParameterDB.regist("secp256k1", 256, "FFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFEFFFFFC2F", "0", "7", "FFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFEBAAEDCE6AF48A03BBFD25E8CD0364141", "1", "79BE667EF9DCBBAC55A06295CE870B07029BFCDB2DCE28D959F2815B16F81798", "483ADA7726A3C4655DA4FBFC0E1108A8FD17B448A68554199C47D08FFB10D4B8", []);
KJUR.crypto.ECParameterDB.regist("secp256r1", 256, "FFFFFFFF00000001000000000000000000000000FFFFFFFFFFFFFFFFFFFFFFFF", "FFFFFFFF00000001000000000000000000000000FFFFFFFFFFFFFFFFFFFFFFFC", "5AC635D8AA3A93E7B3EBBD55769886BC651D06B0CC53B0F63BCE3C3E27D2604B", "FFFFFFFF00000000FFFFFFFFFFFFFFFFBCE6FAADA7179E84F3B9CAC2FC632551", "1", "6B17D1F2E12C4247F8BCE6E563A440F277037D812DEB33A0F4A13945D898C296", "4FE342E2FE1A7F9B8EE7EB4A7C0F9E162BCE33576B315ECECBB6406837BF51F5", ["NIST P-256", "P-256", "prime256v1"]);
KJUR.crypto.ECParameterDB.regist("secp384r1", 384, "FFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFEFFFFFFFF0000000000000000FFFFFFFF", "FFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFEFFFFFFFF0000000000000000FFFFFFFC", "B3312FA7E23EE7E4988E056BE3F82D19181D9C6EFE8141120314088F5013875AC656398D8A2ED19D2A85C8EDD3EC2AEF", "FFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFC7634D81F4372DDF581A0DB248B0A77AECEC196ACCC52973", "1", "AA87CA22BE8B05378EB1C71EF320AD746E1D3B628BA79B9859F741E082542A385502F25DBF55296C3A545E3872760AB7", "3617de4a96262c6f5d9e98bf9292dc29f8f41dbd289a147ce9da3113b5f0b8c00a60b1ce1d7e819d7a431d7c90ea0e5f", ["NIST P-384", "P-384"]);
KJUR.crypto.ECParameterDB.regist("secp521r1", 521, "1FFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFF", "1FFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFC", "051953EB9618E1C9A1F929A21A0B68540EEA2DA725B99B315F3B8B489918EF109E156193951EC7E937B1652C0BD3BB1BF073573DF883D2C34F1EF451FD46B503F00", "1FFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFA51868783BF2F966B7FCC0148F709A5D03BB5C9B8899C47AEBB6FB71E91386409", "1", "00C6858E06B70404E9CD9E3ECB662395B4429C648139053FB521F828AF606B4D3DBAA14B5E77EFE75928FE1DC127A2FFA8DE3348B3C1856A429BF97E7E31C2E5BD66", "011839296a789a3bc0045c8a5fb42c7d1bd998f54449579b446817afbd17273e662c97ee72995ef42640c550b9013fad0761353c7086a272c24088be94769fd16650", ["NIST P-521", "P-521"]);
(typeof KJUR > "u" || !KJUR) && (KJUR = {});
(typeof KJUR.crypto > "u" || !KJUR.crypto) && (KJUR.crypto = {});
KJUR.crypto.DSA = function() {
  var u = ASN1HEX;
  u.getVbyList;
  var r = u.getVbyListEx, a = u.isASN1HEX, e = BigInteger$5;
  this.p = null, this.q = null, this.g = null, this.y = null, this.x = null, this.type = "DSA", this.isPrivate = !1, this.isPublic = !1, this.setPrivate = function(n, o, c, l, d) {
    this.isPrivate = !0, this.p = n, this.q = o, this.g = c, this.y = l, this.x = d;
  }, this.setPrivateHex = function(n, o, c, l, d) {
    var p, h, g, y, v;
    p = new BigInteger$5(n, 16), h = new BigInteger$5(o, 16), g = new BigInteger$5(c, 16), typeof l == "string" && l.length > 1 ? y = new BigInteger$5(l, 16) : y = null, v = new BigInteger$5(d, 16), this.setPrivate(p, h, g, y, v);
  }, this.setPublic = function(n, o, c, l) {
    this.isPublic = !0, this.p = n, this.q = o, this.g = c, this.y = l, this.x = null;
  }, this.setPublicHex = function(n, o, c, l) {
    var d, p, h, g;
    d = new BigInteger$5(n, 16), p = new BigInteger$5(o, 16), h = new BigInteger$5(c, 16), g = new BigInteger$5(l, 16), this.setPublic(d, p, h, g);
  }, this.signWithMessageHash = function(n) {
    var o = this.p, c = this.q, l = this.g;
    this.y;
    var d = this.x, p = KJUR.crypto.Util.getRandomBigIntegerMinToMax(BigInteger$5.ONE.add(BigInteger$5.ONE), c.subtract(BigInteger$5.ONE)), h = n.substr(0, c.bitLength() / 4), g = new BigInteger$5(h, 16), y = l.modPow(p, o).mod(c), v = p.modInverse(c).multiply(g.add(d.multiply(y))).mod(c), m = KJUR.asn1.ASN1Util.jsonToASN1HEX({ seq: [{ int: { bigint: y } }, { int: { bigint: v } }] });
    return m;
  }, this.verifyWithMessageHash = function(n, o) {
    var c = this.p, l = this.q, d = this.g, p = this.y, h = this.parseASN1Signature(o), g = h[0], y = h[1], v = n.substr(0, l.bitLength() / 4), m = new BigInteger$5(v, 16);
    if (BigInteger$5.ZERO.compareTo(g) > 0 || g.compareTo(l) > 0 || BigInteger$5.ZERO.compareTo(y) >= 0 || y.compareTo(l) > 0)
      throw "invalid DSA signature";
    var b = y.modInverse(l), R = m.multiply(b).mod(l), $ = g.multiply(b).mod(l), x = d.modPow(R, c).multiply(p.modPow($, c)).mod(c).mod(l);
    return x.compareTo(g) == 0;
  }, this.parseASN1Signature = function(n) {
    try {
      var o = new e(r(n, 0, [0], "02"), 16), c = new e(r(n, 0, [1], "02"), 16);
      return [o, c];
    } catch {
      throw new Error("malformed ASN.1 DSA signature");
    }
  }, this.readPKCS5PrvKeyHex = function(n) {
    var o, c, l, d, p;
    if (a(n) === !1)
      throw new Error("not ASN.1 hex string");
    try {
      o = r(n, 0, [1], "02"), c = r(n, 0, [2], "02"), l = r(n, 0, [3], "02"), d = r(n, 0, [4], "02"), p = r(n, 0, [5], "02");
    } catch {
      throw new Error("malformed PKCS#1/5 plain DSA private key");
    }
    this.setPrivateHex(o, c, l, d, p);
  }, this.readPKCS8PrvKeyHex = function(n) {
    var o, c, l, d;
    if (a(n) === !1)
      throw new Error("not ASN.1 hex string");
    try {
      o = r(n, 0, [1, 1, 0], "02"), c = r(n, 0, [1, 1, 1], "02"), l = r(n, 0, [1, 1, 2], "02"), d = r(n, 0, [2, 0], "02");
    } catch {
      throw new Error("malformed PKCS#8 plain DSA private key");
    }
    this.setPrivateHex(o, c, l, null, d);
  }, this.readPKCS8PubKeyHex = function(n) {
    var o, c, l, d;
    if (a(n) === !1)
      throw new Error("not ASN.1 hex string");
    try {
      o = r(n, 0, [0, 1, 0], "02"), c = r(n, 0, [0, 1, 1], "02"), l = r(n, 0, [0, 1, 2], "02"), d = r(n, 0, [1, 0], "02");
    } catch {
      throw new Error("malformed PKCS#8 DSA public key");
    }
    this.setPublicHex(o, c, l, d);
  }, this.readCertPubKeyHex = function(n, o) {
    var c, l, d, p;
    if (a(n) === !1)
      throw new Error("not ASN.1 hex string");
    try {
      c = r(n, 0, [0, 5, 0, 1, 0], "02"), l = r(n, 0, [0, 5, 0, 1, 1], "02"), d = r(n, 0, [0, 5, 0, 1, 2], "02"), p = r(n, 0, [0, 5, 1, 0], "02");
    } catch {
      throw new Error("malformed X.509 certificate DSA public key");
    }
    this.setPublicHex(c, l, d, p);
  };
};
var KEYUTIL = /* @__PURE__ */ function() {
  var u = function(m, b, R) {
    return e(CryptoJS.AES, m, b, R);
  }, r = function(m, b, R) {
    return e(CryptoJS.TripleDES, m, b, R);
  }, a = function(m, b, R) {
    return e(CryptoJS.DES, m, b, R);
  }, e = function(m, b, R, $) {
    var x = CryptoJS.enc.Hex.parse(b), E = CryptoJS.enc.Hex.parse(R), T = CryptoJS.enc.Hex.parse($), P = {};
    P.key = E, P.iv = T, P.ciphertext = x;
    var O = m.decrypt(P, E, { iv: T });
    return CryptoJS.enc.Hex.stringify(O);
  }, n = function(m, b, R) {
    return l(CryptoJS.AES, m, b, R);
  }, o = function(m, b, R) {
    return l(CryptoJS.TripleDES, m, b, R);
  }, c = function(m, b, R) {
    return l(CryptoJS.DES, m, b, R);
  }, l = function(m, b, R, $) {
    var x = CryptoJS.enc.Hex.parse(b), E = CryptoJS.enc.Hex.parse(R), T = CryptoJS.enc.Hex.parse($), P = m.encrypt(x, E, { iv: T }), O = CryptoJS.enc.Hex.parse(P.toString()), w = CryptoJS.enc.Base64.stringify(O);
    return w;
  }, d = { "AES-256-CBC": { proc: u, eproc: n, keylen: 32, ivlen: 16 }, "AES-192-CBC": { proc: u, eproc: n, keylen: 24, ivlen: 16 }, "AES-128-CBC": { proc: u, eproc: n, keylen: 16, ivlen: 16 }, "DES-EDE3-CBC": { proc: r, eproc: o, keylen: 24, ivlen: 8 }, "DES-CBC": { proc: a, eproc: c, keylen: 8, ivlen: 8 } }, p = function(m) {
    var b = CryptoJS.lib.WordArray.random(m), R = CryptoJS.enc.Hex.stringify(b);
    return R;
  }, h = function(m) {
    var b = {}, R = m.match(new RegExp("DEK-Info: ([^,]+),([0-9A-Fa-f]+)", "m"));
    R && (b.cipher = R[1], b.ivsalt = R[2]);
    var $ = m.match(new RegExp("-----BEGIN ([A-Z]+) PRIVATE KEY-----"));
    $ && (b.type = $[1]);
    var x = -1, E = 0;
    m.indexOf(`\r
\r
`) != -1 && (x = m.indexOf(`\r
\r
`), E = 2), m.indexOf(`

`) != -1 && (x = m.indexOf(`

`), E = 1);
    var T = m.indexOf("-----END");
    if (x != -1 && T != -1) {
      var P = m.substring(x + E * 2, T - E);
      P = P.replace(/\s+/g, ""), b.data = P;
    }
    return b;
  }, g = function(m, b, R) {
    for (var $ = R.substring(0, 16), x = CryptoJS.enc.Hex.parse($), E = CryptoJS.enc.Utf8.parse(b), T = d[m].keylen + d[m].ivlen, P = "", O = null; ; ) {
      var w = CryptoJS.algo.MD5.create();
      if (O != null && w.update(O), w.update(E), w.update(x), O = w.finalize(), P = P + CryptoJS.enc.Hex.stringify(O), P.length >= T * 2)
        break;
    }
    var _ = {};
    return _.keyhex = P.substr(0, d[m].keylen * 2), _.ivhex = P.substr(d[m].keylen * 2, d[m].ivlen * 2), _;
  }, y = function(m, b, R, $) {
    var x = CryptoJS.enc.Base64.parse(m), E = CryptoJS.enc.Hex.stringify(x), T = d[b].proc, P = T(E, R, $);
    return P;
  }, v = function(m, b, R, $) {
    var x = d[b].eproc, E = x(m, R, $);
    return E;
  };
  return { version: "1.0.0", parsePKCS5PEM: function(m) {
    return h(m);
  }, getKeyAndUnusedIvByPasscodeAndIvsalt: function(m, b, R) {
    return g(m, b, R);
  }, decryptKeyB64: function(m, b, R, $) {
    return y(m, b, R, $);
  }, getDecryptedKeyHex: function(m, b) {
    var R = h(m), $ = R.cipher, x = R.ivsalt, E = R.data, T = g($, b, x), P = T.keyhex, O = y(E, $, P, x);
    return O;
  }, getEncryptedPKCS5PEMFromPrvKeyHex: function(m, b, R, $, x) {
    var C = "";
    if ((typeof $ > "u" || $ == null) && ($ = "AES-256-CBC"), typeof d[$] > "u")
      throw new Error("KEYUTIL unsupported algorithm: " + $);
    if (typeof x > "u" || x == null) {
      var E = d[$].ivlen, T = p(E);
      x = T.toUpperCase();
    }
    var P = g($, R, x), O = P.keyhex, w = v(b, $, O, x), _ = w.replace(/(.{64})/g, `$1\r
`), C = "-----BEGIN " + m + ` PRIVATE KEY-----\r
`;
    return C += `Proc-Type: 4,ENCRYPTED\r
`, C += "DEK-Info: " + $ + "," + x + `\r
`, C += `\r
`, C += _, C += `\r
-----END ` + m + ` PRIVATE KEY-----\r
`, C;
  }, getEncryptedPKCS8PEM: function(m, b, R) {
    var $ = this.getEncryptedPKCS8Hex(m, b, R);
    return hextopem($, "ENCRYPTED PRIVATE KEY");
  }, getEncryptedPKCS8Hex: function(m, b, R) {
    var $;
    R == null || R == null ? $ = {} : $ = JSON.parse(JSON.stringify(R)), $.plain = m, this.initPBES2Param($), this.encryptPBES2Param($, b);
    var x = this.generatePBES2ASN1Param($);
    return KJUR.asn1.ASN1Util.newObject(x).tohex();
  }, initPBES2Param: function(m) {
    if (aryval(m, "encalg") == null && (m.encalg = "aes256-CBC"), aryval(m, "iter") == null && (m.iter = 2048), aryval(m, "prf") == null && (m.prf = "hmacWithSHA256"), aryval(m, "salt") == null && (m.salt = CryptoJS.enc.Hex.stringify(CryptoJS.lib.WordArray.random(8))), aryval(m, "enciv") == null) {
      var b;
      m.encalg == "des-EDE3-CBC" && (b = 8), m.encalg == "aes128-CBC" && (b = 16), m.encalg == "aes256-CBC" && (b = 16), m.enciv = CryptoJS.enc.Hex.stringify(CryptoJS.lib.WordArray.random(b));
    }
  }, encryptPBES2Param: function(m, b) {
    var R = KEYUTIL.getDKFromPBES2Param(m, b);
    try {
      var $ = KJUR.crypto.Cipher.encrypt(m.plain, R, m.encalg, { iv: m.enciv });
    } catch {
      throw new Error("encrypt error: " + m.plain + " " + R + " " + m.encalg + " " + m.enciv);
    }
    m.enc = $;
  }, generatePBES2ASN1Param: function(m) {
    var b = { seq: [{ seq: [{ oid: "pkcs5PBES2" }, { seq: [{ seq: [{ oid: "pkcs5PBKDF2" }, { seq: [{ octstr: { hex: m.salt } }, { int: { hex: inttohex(m.iter) } }] }] }, { seq: [{ oid: m.encalg }, { octstr: { hex: m.enciv } }] }] }] }, { octstr: { hex: m.enc } }] };
    return m.prf != "hmacWithSHA1" && b.seq[0].seq[1].seq[0].seq[1].seq.push({ seq: [{ oid: m.prf }, { null: "" }] }), b;
  }, parseHexOfEncryptedPKCS8: function(m) {
    var b = ASN1HEX, R = b.getChildIdx, $ = b.getV, x = {}, E = R(m, 0);
    if (E.length != 2)
      throw new Error("malformed format: SEQUENCE(0).items != 2: " + E.length);
    x.ciphertext = $(m, E[1]);
    var T = R(m, E[0]);
    if (T.length != 2)
      throw new Error("malformed format: SEQUENCE(0.0).items != 2: " + T.length);
    if ($(m, T[0]) != "2a864886f70d01050d")
      throw new Error("this only supports pkcs5PBES2");
    var P = R(m, T[1]);
    if (T.length != 2)
      throw new Error("malformed format: SEQUENCE(0.0.1).items != 2: " + P.length);
    var O = R(m, P[1]);
    if (O.length != 2)
      throw new Error("malformed format: SEQUENCE(0.0.1.1).items != 2: " + O.length);
    if ($(m, O[0]) != "2a864886f70d0307")
      throw "this only supports TripleDES";
    x.encryptionSchemeAlg = "TripleDES", x.encryptionSchemeIV = $(m, O[1]);
    var w = R(m, P[0]);
    if (w.length != 2)
      throw new Error("malformed format: SEQUENCE(0.0.1.0).items != 2: " + w.length);
    if ($(m, w[0]) != "2a864886f70d01050c")
      throw new Error("this only supports pkcs5PBKDF2");
    var _ = R(m, w[1]);
    if (_.length < 2)
      throw new Error("malformed format: SEQUENCE(0.0.1.0.1).items < 2: " + _.length);
    x.pbkdf2Salt = $(m, _[0]);
    var C = $(m, _[1]);
    try {
      x.pbkdf2Iter = parseInt(C, 16);
    } catch {
      throw new Error("malformed format pbkdf2Iter: " + C);
    }
    return x;
  }, getPBKDF2KeyHexFromParam: function(m, b) {
    var R = CryptoJS.enc.Hex.parse(m.pbkdf2Salt), $ = m.pbkdf2Iter, x = CryptoJS.PBKDF2(b, R, { keySize: 192 / 32, iterations: $ }), E = CryptoJS.enc.Hex.stringify(x);
    return E;
  }, _getPlainPKCS8HexFromEncryptedPKCS8PEM: function(m, b) {
    var R = pemtohex(m, "ENCRYPTED PRIVATE KEY"), $ = this.parseHexOfEncryptedPKCS8(R), x = KEYUTIL.getPBKDF2KeyHexFromParam($, b), E = {};
    E.ciphertext = CryptoJS.enc.Hex.parse($.ciphertext);
    var T = CryptoJS.enc.Hex.parse(x), P = CryptoJS.enc.Hex.parse($.encryptionSchemeIV), O = CryptoJS.TripleDES.decrypt(E, T, { iv: P }), w = CryptoJS.enc.Hex.stringify(O);
    return w;
  }, parsePBES2: function(m) {
    var b = ASN1HEX.parse(m);
    if (aryval(b, "seq.0.seq.0.oid") != "pkcs5PBES2" || aryval(b, "seq.0.seq.1.seq.0.seq.0.oid") != "pkcs5PBKDF2")
      throw new Error("not pkcs5PBES2 and pkcs5PBKDF2 used");
    var R = aryval(b, "seq.0.seq.1.seq.0.seq.1.seq");
    if (R == null)
      throw new Error("PBKDF2 parameter not found");
    var $ = aryval(R, "0.octstr.hex"), x = aryval(R, "1.int.hex"), E = aryval(R, "2.seq.0.oid", "hmacWithSHA1"), T = -1;
    try {
      T = parseInt(x, 16);
    } catch {
      throw new Error("iter not proper value");
    }
    var P = aryval(b, "seq.0.seq.1.seq.1.seq.0.oid"), O = aryval(b, "seq.0.seq.1.seq.1.seq.1.octstr.hex"), w = aryval(b, "seq.1.octstr.hex");
    if (P == null || O == null || w == null)
      throw new Error("encalg, enciv or enc is undefined");
    var _ = { salt: $, iter: T, prf: E, encalg: P, enciv: O, enc: w };
    return _;
  }, getDKFromPBES2Param: function(m, b) {
    var R = { hmacWithSHA1: CryptoJS.algo.SHA1, hmacWithSHA224: CryptoJS.algo.SHA224, hmacWithSHA256: CryptoJS.algo.SHA256, hmacWithSHA384: CryptoJS.algo.SHA384, hmacWithSHA512: CryptoJS.algo.SHA512 }, $ = { "des-EDE3-CBC": 192 / 32, "aes128-CBC": 128 / 32, "aes256-CBC": 256 / 32 }, x = R[m.prf];
    if (x == null)
      throw new Error("unsupported prf");
    var E = $[m.encalg];
    if (E == null)
      throw new Error("unsupported encalg");
    var T = CryptoJS.enc.Hex.parse(m.salt), P = m.iter;
    try {
      var O = CryptoJS.PBKDF2(b, T, { keySize: E, iterations: P, hasher: x });
      return CryptoJS.enc.Hex.stringify(O);
    } catch (w) {
      throw new Error("PBKDF2 error: " + w + " " + JSON.stringify(m) + " " + b);
    }
  }, getPlainHexFromEncryptedPKCS8PEM: function(m, b) {
    if (m.indexOf("BEGIN ENCRYPTED PRIVATE KEY") == -1)
      throw new Error("not Encrypted PKCS#8 PEM string");
    var R = pemtohex(m), $;
    try {
      $ = KEYUTIL.parsePBES2(R);
    } catch (E) {
      throw new Error("malformed PBES2 format: " + E.message);
    }
    var x = KEYUTIL.getDKFromPBES2Param($, b);
    return KJUR.crypto.Cipher.decrypt($.enc, x, $.encalg, { iv: $.enciv });
  }, getKeyFromEncryptedPKCS8PEM: function(m, b) {
    var R = this.getPlainHexFromEncryptedPKCS8PEM(m, b), $ = this.getKeyFromPlainPrivatePKCS8Hex(R);
    return $;
  }, parsePlainPrivatePKCS8Hex: function(m) {
    var b = ASN1HEX, R = b.getChildIdx, $ = b.getV, x = {};
    if (x.algparam = null, m.substr(0, 2) != "30")
      throw new Error("malformed plain PKCS8 private key(code:001)");
    var E = R(m, 0);
    if (E.length < 3)
      throw new Error("malformed plain PKCS8 private key(code:002)");
    if (m.substr(E[1], 2) != "30")
      throw new Error("malformed PKCS8 private key(code:003)");
    var T = R(m, E[1]);
    if (T.length != 2)
      throw new Error("malformed PKCS8 private key(code:004)");
    if (m.substr(T[0], 2) != "06")
      throw new Error("malformed PKCS8 private key(code:005)");
    if (x.algoid = $(m, T[0]), m.substr(T[1], 2) == "06" && (x.algparam = $(m, T[1])), m.substr(E[2], 2) != "04")
      throw new Error("malformed PKCS8 private key(code:006)");
    return x.keyidx = b.getVidx(m, E[2]), x;
  }, getKeyFromPlainPrivatePKCS8PEM: function(m) {
    var b = pemtohex(m, "PRIVATE KEY"), R = this.getKeyFromPlainPrivatePKCS8Hex(b);
    return R;
  }, getKeyFromPlainPrivatePKCS8Hex: function(m) {
    var b = this.parsePlainPrivatePKCS8Hex(m), R;
    if (b.algoid == "2a864886f70d010101")
      R = new RSAKey();
    else if (b.algoid == "2a8648ce380401")
      R = new KJUR.crypto.DSA();
    else if (b.algoid == "2a8648ce3d0201")
      R = new KJUR.crypto.ECDSA();
    else
      throw new Error("unsupported private key algorithm");
    return R.readPKCS8PrvKeyHex(m), R;
  }, _getKeyFromPublicPKCS8Hex: function(m) {
    var b, R = ASN1HEX.getVbyList(m, 0, [0, 0], "06");
    if (R === "2a864886f70d010101")
      b = new RSAKey();
    else if (R === "2a8648ce380401")
      b = new KJUR.crypto.DSA();
    else if (R === "2a8648ce3d0201")
      b = new KJUR.crypto.ECDSA();
    else
      throw new Error("unsupported PKCS#8 public key hex");
    return b.readPKCS8PubKeyHex(m), b;
  }, parsePublicRawRSAKeyHex: function(m) {
    var b = ASN1HEX, R = b.getChildIdx, $ = b.getV, x = {};
    if (m.substr(0, 2) != "30")
      throw new Error("malformed RSA key(code:001)");
    var E = R(m, 0);
    if (E.length != 2)
      throw new Error("malformed RSA key(code:002)");
    if (m.substr(E[0], 2) != "02")
      throw new Error("malformed RSA key(code:003)");
    if (x.n = $(m, E[0]), m.substr(E[1], 2) != "02")
      throw new Error("malformed RSA key(code:004)");
    return x.e = $(m, E[1]), x;
  }, parsePublicPKCS8Hex: function(m) {
    var b = ASN1HEX, R = b.getChildIdx, $ = b.getV, x = {};
    x.algparam = null;
    var E = R(m, 0);
    if (E.length != 2)
      throw new Error("outer DERSequence shall have 2 elements: " + E.length);
    var T = E[0];
    if (m.substr(T, 2) != "30")
      throw new Error("malformed PKCS8 public key(code:001)");
    var P = R(m, T);
    if (P.length != 2)
      throw new Error("malformed PKCS8 public key(code:002)");
    if (m.substr(P[0], 2) != "06")
      throw new Error("malformed PKCS8 public key(code:003)");
    if (x.algoid = $(m, P[0]), m.substr(P[1], 2) == "06" ? x.algparam = $(m, P[1]) : m.substr(P[1], 2) == "30" && (x.algparam = {}, x.algparam.p = b.getVbyList(m, P[1], [0], "02"), x.algparam.q = b.getVbyList(m, P[1], [1], "02"), x.algparam.g = b.getVbyList(m, P[1], [2], "02")), m.substr(E[1], 2) != "03")
      throw new Error("malformed PKCS8 public key(code:004)");
    return x.key = $(m, E[1]).substr(2), x;
  } };
}();
KEYUTIL.getKey = function(u, r, a) {
  var e = ASN1HEX, n = e.getChildIdx;
  e.getV;
  var o = e.getVbyList, c = KJUR.crypto, l = c.ECDSA, d = c.DSA, p = RSAKey, h = pemtohex, g = KEYUTIL;
  if (typeof p < "u" && u instanceof p || typeof l < "u" && u instanceof l || typeof d < "u" && u instanceof d)
    return u;
  if (u.curve !== void 0 && u.xy !== void 0 && u.d === void 0)
    return new l({ pub: u.xy, curve: u.curve });
  if (u.curve !== void 0 && u.d !== void 0)
    return new l({ prv: u.d, curve: u.curve });
  if (u.kty === void 0 && u.n !== void 0 && u.e !== void 0 && u.d === void 0) {
    var y = new p();
    return y.setPublic(u.n, u.e), y;
  }
  if (u.kty === void 0 && u.n !== void 0 && u.e !== void 0 && u.d !== void 0 && u.p !== void 0 && u.q !== void 0 && u.dp !== void 0 && u.dq !== void 0 && u.co !== void 0 && u.qi === void 0) {
    var y = new p();
    return y.setPrivateEx(u.n, u.e, u.d, u.p, u.q, u.dp, u.dq, u.co), y;
  }
  if (u.kty === void 0 && u.n !== void 0 && u.e !== void 0 && u.d !== void 0 && u.p === void 0) {
    var y = new p();
    return y.setPrivate(u.n, u.e, u.d), y;
  }
  if (u.p !== void 0 && u.q !== void 0 && u.g !== void 0 && u.y !== void 0 && u.x === void 0) {
    var y = new d();
    return y.setPublic(u.p, u.q, u.g, u.y), y;
  }
  if (u.p !== void 0 && u.q !== void 0 && u.g !== void 0 && u.y !== void 0 && u.x !== void 0) {
    var y = new d();
    return y.setPrivate(u.p, u.q, u.g, u.y, u.x), y;
  }
  if (u.kty === "RSA" && u.n !== void 0 && u.e !== void 0 && u.d === void 0) {
    var y = new p();
    return y.setPublic(b64utohex(u.n), b64utohex(u.e)), y;
  }
  if (u.kty === "RSA" && u.n !== void 0 && u.e !== void 0 && u.d !== void 0 && u.p !== void 0 && u.q !== void 0 && u.dp !== void 0 && u.dq !== void 0 && u.qi !== void 0) {
    var y = new p();
    return y.setPrivateEx(b64utohex(u.n), b64utohex(u.e), b64utohex(u.d), b64utohex(u.p), b64utohex(u.q), b64utohex(u.dp), b64utohex(u.dq), b64utohex(u.qi)), y;
  }
  if (u.kty === "RSA" && u.n !== void 0 && u.e !== void 0 && u.d !== void 0) {
    var y = new p();
    return y.setPrivate(b64utohex(u.n), b64utohex(u.e), b64utohex(u.d)), y;
  }
  if (u.kty === "EC" && u.crv !== void 0 && u.x !== void 0 && u.y !== void 0 && u.d === void 0) {
    var v = new l({ curve: u.crv }), m = v.ecparams.keycharlen, b = ("0000000000" + b64utohex(u.x)).slice(-m), R = ("0000000000" + b64utohex(u.y)).slice(-m), $ = "04" + b + R;
    return v.setPublicKeyHex($), v;
  }
  if (u.kty === "EC" && u.crv !== void 0 && u.x !== void 0 && u.y !== void 0 && u.d !== void 0) {
    var v = new l({ curve: u.crv }), m = v.ecparams.keycharlen, b = ("0000000000" + b64utohex(u.x)).slice(-m), R = ("0000000000" + b64utohex(u.y)).slice(-m), $ = "04" + b + R, x = ("0000000000" + b64utohex(u.d)).slice(-m);
    return v.setPublicKeyHex($), v.setPrivateKeyHex(x), v;
  }
  if (a === "pkcs5prv") {
    var E = u, e = ASN1HEX, T, y;
    if (T = n(E, 0), T.length === 9)
      y = new p(), y.readPKCS5PrvKeyHex(E);
    else if (T.length === 6)
      y = new d(), y.readPKCS5PrvKeyHex(E);
    else if (T.length > 2 && E.substr(T[1], 2) === "04")
      y = new l(), y.readPKCS5PrvKeyHex(E);
    else
      throw new Error("unsupported PKCS#1/5 hexadecimal key");
    return y;
  }
  if (a === "pkcs8prv") {
    var y = g.getKeyFromPlainPrivatePKCS8Hex(u);
    return y;
  }
  if (a === "pkcs8pub")
    return g._getKeyFromPublicPKCS8Hex(u);
  if (a === "x509pub")
    return X509.getPublicKeyFromCertHex(u);
  if (u.indexOf("-END CERTIFICATE-", 0) != -1 || u.indexOf("-END X509 CERTIFICATE-", 0) != -1 || u.indexOf("-END TRUSTED CERTIFICATE-", 0) != -1)
    return X509.getPublicKeyFromCertPEM(u);
  if (u.indexOf("-END PUBLIC KEY-") != -1) {
    var P = pemtohex(u, "PUBLIC KEY");
    return g._getKeyFromPublicPKCS8Hex(P);
  }
  if (u.indexOf("-END RSA PRIVATE KEY-") != -1 && u.indexOf("4,ENCRYPTED") == -1) {
    var O = h(u, "RSA PRIVATE KEY");
    return g.getKey(O, null, "pkcs5prv");
  }
  if (u.indexOf("-END DSA PRIVATE KEY-") != -1 && u.indexOf("4,ENCRYPTED") == -1) {
    var w = h(u, "DSA PRIVATE KEY"), _ = o(w, 0, [1], "02"), C = o(w, 0, [2], "02"), k = o(w, 0, [3], "02"), B = o(w, 0, [4], "02"), j = o(w, 0, [5], "02"), y = new d();
    return y.setPrivate(new BigInteger$5(_, 16), new BigInteger$5(C, 16), new BigInteger$5(k, 16), new BigInteger$5(B, 16), new BigInteger$5(j, 16)), y;
  }
  if (u.indexOf("-END EC PRIVATE KEY-") != -1 && u.indexOf("4,ENCRYPTED") == -1) {
    var O = h(u, "EC PRIVATE KEY");
    return g.getKey(O, null, "pkcs5prv");
  }
  if (u.indexOf("-END PRIVATE KEY-") != -1)
    return g.getKeyFromPlainPrivatePKCS8PEM(u);
  if (u.indexOf("-END RSA PRIVATE KEY-") != -1 && u.indexOf("4,ENCRYPTED") != -1) {
    var J = g.getDecryptedKeyHex(u, r), N = new RSAKey();
    return N.readPKCS5PrvKeyHex(J), N;
  }
  if (u.indexOf("-END EC PRIVATE KEY-") != -1 && u.indexOf("4,ENCRYPTED") != -1) {
    var w = g.getDecryptedKeyHex(u, r), y = o(w, 0, [1], "04"), F = o(w, 0, [2, 0], "06"), U = o(w, 0, [3, 0], "03").substr(2), K = "";
    if (KJUR.crypto.OID.oidhex2name[F] !== void 0)
      K = KJUR.crypto.OID.oidhex2name[F];
    else
      throw new Error("undefined OID(hex) in KJUR.crypto.OID: " + F);
    var v = new l({ curve: K });
    return v.setPublicKeyHex(U), v.setPrivateKeyHex(y), v.isPublic = !1, v;
  }
  if (u.indexOf("-END DSA PRIVATE KEY-") != -1 && u.indexOf("4,ENCRYPTED") != -1) {
    var w = g.getDecryptedKeyHex(u, r), _ = o(w, 0, [1], "02"), C = o(w, 0, [2], "02"), k = o(w, 0, [3], "02"), B = o(w, 0, [4], "02"), j = o(w, 0, [5], "02"), y = new d();
    return y.setPrivate(new BigInteger$5(_, 16), new BigInteger$5(C, 16), new BigInteger$5(k, 16), new BigInteger$5(B, 16), new BigInteger$5(j, 16)), y;
  }
  if (u.indexOf("-END ENCRYPTED PRIVATE KEY-") != -1)
    return g.getKeyFromEncryptedPKCS8PEM(u, r);
  throw new Error("not supported argument");
};
KEYUTIL.generateKeypair = function(u, r) {
  if (u == "RSA") {
    var a = r, e = new RSAKey();
    e.generate(a, "10001"), e.isPrivate = !0, e.isPublic = !0;
    var n = new RSAKey(), o = e.n.toString(16), c = e.e.toString(16);
    n.setPublic(o, c), n.isPrivate = !1, n.isPublic = !0;
    var l = {};
    return l.prvKeyObj = e, l.pubKeyObj = n, l;
  } else if (u == "EC") {
    var d = r, p = new KJUR.crypto.ECDSA({ curve: d }), h = p.generateKeyPairHex(), e = new KJUR.crypto.ECDSA({ curve: d });
    e.setPublicKeyHex(h.ecpubhex), e.setPrivateKeyHex(h.ecprvhex), e.isPrivate = !0, e.isPublic = !1;
    var n = new KJUR.crypto.ECDSA({ curve: d });
    n.setPublicKeyHex(h.ecpubhex), n.isPrivate = !1, n.isPublic = !0;
    var l = {};
    return l.prvKeyObj = e, l.pubKeyObj = n, l;
  } else
    throw new Error("unknown algorithm: " + u);
};
KEYUTIL.getPEM = function(u, r, a, e, n, o) {
  var c = KJUR, l = c.asn1, d = l.DERObjectIdentifier, p = l.DERInteger, h = l.ASN1Util.newObject, g = l.x509, y = g.SubjectPublicKeyInfo, v = c.crypto, m = v.DSA, b = v.ECDSA, R = RSAKey;
  function $(F) {
    var U = h({ seq: [{ int: 0 }, { int: { bigint: F.n } }, { int: F.e }, { int: { bigint: F.d } }, { int: { bigint: F.p } }, { int: { bigint: F.q } }, { int: { bigint: F.dmp1 } }, { int: { bigint: F.dmq1 } }, { int: { bigint: F.coeff } }] });
    return U;
  }
  function x(F) {
    var U = h({ seq: [{ int: 1 }, { octstr: { hex: F.prvKeyHex } }, { tag: ["a0", !0, { oid: { name: F.curveName } }] }, { tag: ["a1", !0, { bitstr: { hex: "00" + F.pubKeyHex } }] }] });
    return U;
  }
  function E(F) {
    var U = h({ seq: [{ int: 0 }, { int: { bigint: F.p } }, { int: { bigint: F.q } }, { int: { bigint: F.g } }, { int: { bigint: F.y } }, { int: { bigint: F.x } }] });
    return U;
  }
  if ((R !== void 0 && u instanceof R || m !== void 0 && u instanceof m || b !== void 0 && u instanceof b) && u.isPublic == !0 && (r === void 0 || r == "PKCS8PUB")) {
    var T = new y(u), P = T.tohex();
    return hextopem(P, "PUBLIC KEY");
  }
  if (r == "PKCS1PRV" && R !== void 0 && u instanceof R && (a === void 0 || a == null) && u.isPrivate == !0) {
    var T = $(u), P = T.tohex();
    return hextopem(P, "RSA PRIVATE KEY");
  }
  if (r == "PKCS1PRV" && b !== void 0 && u instanceof b && (a === void 0 || a == null) && u.isPrivate == !0) {
    var O = new d({ name: u.curveName }), w = O.tohex(), _ = x(u), C = _.tohex(), k = "";
    return k += hextopem(w, "EC PARAMETERS"), k += hextopem(C, "EC PRIVATE KEY"), k;
  }
  if (r == "PKCS1PRV" && m !== void 0 && u instanceof m && (a === void 0 || a == null) && u.isPrivate == !0) {
    var T = E(u), P = T.tohex();
    return hextopem(P, "DSA PRIVATE KEY");
  }
  if (r == "PKCS5PRV" && R !== void 0 && u instanceof R && a !== void 0 && a != null && u.isPrivate == !0) {
    var T = $(u), P = T.tohex();
    return e === void 0 && (e = "DES-EDE3-CBC"), this.getEncryptedPKCS5PEMFromPrvKeyHex("RSA", P, a, e, o);
  }
  if (r == "PKCS5PRV" && b !== void 0 && u instanceof b && a !== void 0 && a != null && u.isPrivate == !0) {
    var T = x(u), P = T.tohex();
    return e === void 0 && (e = "DES-EDE3-CBC"), this.getEncryptedPKCS5PEMFromPrvKeyHex("EC", P, a, e, o);
  }
  if (r == "PKCS5PRV" && m !== void 0 && u instanceof m && a !== void 0 && a != null && u.isPrivate == !0) {
    var T = E(u), P = T.tohex();
    return e === void 0 && (e = "DES-EDE3-CBC"), this.getEncryptedPKCS5PEMFromPrvKeyHex("DSA", P, a, e, o);
  }
  var B = function(F, U) {
    if (typeof U == "string")
      return KEYUTIL.getEncryptedPKCS8PEM(F, U);
    if (typeof U == "object" && aryval(U, "passcode") != null) {
      var K = JSON.parse(JSON.stringify(U)), ve = K.passcode;
      return delete K.passcode, KEYUTIL.getEncryptedPKCS8PEM(F, ve, K);
    }
  };
  if (r == "PKCS8PRV" && R != null && u instanceof R && u.isPrivate == !0) {
    var j = $(u), J = j.tohex(), T = h({ seq: [{ int: 0 }, { seq: [{ oid: { name: "rsaEncryption" } }, { null: !0 }] }, { octstr: { hex: J } }] }), P = T.tohex();
    return a === void 0 || a == null ? hextopem(P, "PRIVATE KEY") : B(P, a);
  }
  if (r == "PKCS8PRV" && b !== void 0 && u instanceof b && u.isPrivate == !0) {
    var N = { seq: [{ int: 1 }, { octstr: { hex: u.prvKeyHex } }] };
    typeof u.pubKeyHex == "string" && N.seq.push({ tag: ["a1", !0, { bitstr: { hex: "00" + u.pubKeyHex } }] });
    var j = new h(N), J = j.tohex(), T = h({ seq: [{ int: 0 }, { seq: [{ oid: { name: "ecPublicKey" } }, { oid: { name: u.curveName } }] }, { octstr: { hex: J } }] }), P = T.tohex();
    return a === void 0 || a == null ? hextopem(P, "PRIVATE KEY") : B(P, a);
  }
  if (r == "PKCS8PRV" && m !== void 0 && u instanceof m && u.isPrivate == !0) {
    var j = new p({ bigint: u.x }), J = j.tohex(), T = h({ seq: [{ int: 0 }, { seq: [{ oid: { name: "dsa" } }, { seq: [{ int: { bigint: u.p } }, { int: { bigint: u.q } }, { int: { bigint: u.g } }] }] }, { octstr: { hex: J } }] }), P = T.tohex();
    return a === void 0 || a == null ? hextopem(P, "PRIVATE KEY") : B(P, a);
  }
  throw new Error("unsupported object nor format");
};
KEYUTIL.getKeyFromCSRPEM = function(u) {
  var r = pemtohex(u, "CERTIFICATE REQUEST"), a = KEYUTIL.getKeyFromCSRHex(r);
  return a;
};
KEYUTIL.getKeyFromCSRHex = function(u) {
  var r = KEYUTIL.parseCSRHex(u), a = KEYUTIL.getKey(r.p8pubkeyhex, null, "pkcs8pub");
  return a;
};
KEYUTIL.parseCSRHex = function(u) {
  var r = ASN1HEX, a = r.getChildIdx, e = r.getTLV, n = {}, o = u;
  if (o.substr(0, 2) != "30")
    throw new Error("malformed CSR(code:001)");
  var c = a(o, 0);
  if (c.length < 1)
    throw new Error("malformed CSR(code:002)");
  if (o.substr(c[0], 2) != "30")
    throw new Error("malformed CSR(code:003)");
  var l = a(o, c[0]);
  if (l.length < 3)
    throw new Error("malformed CSR(code:004)");
  return n.p8pubkeyhex = e(o, l[2]), n;
};
KEYUTIL.getKeyID = function(u) {
  var r = KEYUTIL, a = ASN1HEX;
  typeof u == "string" && u.indexOf("BEGIN ") != -1 && (u = r.getKey(u));
  var e = pemtohex(r.getPEM(u)), n = a.getIdxbyList(e, 0, [1]), o = a.getV(e, n).substring(2);
  return KJUR.crypto.Util.hashHex(o, "sha1");
};
KEYUTIL.getJWK = function(u, r, a, e, n) {
  var o, c = {}, l, d = KJUR.crypto.Util.hashHex;
  if (typeof u == "string")
    o = KEYUTIL.getKey(u), u.indexOf("CERTIFICATE") != -1 && (l = pemtohex(u));
  else if (typeof u == "object")
    u instanceof X509 ? (o = u.getPublicKey(), l = u.hex) : o = u;
  else
    throw new Error("unsupported keyinfo type");
  if (o instanceof RSAKey && o.isPrivate)
    c.kty = "RSA", c.n = hextob64u(o.n.toString(16)), c.e = hextob64u(o.e.toString(16)), c.d = hextob64u(o.d.toString(16)), c.p = hextob64u(o.p.toString(16)), c.q = hextob64u(o.q.toString(16)), c.dp = hextob64u(o.dmp1.toString(16)), c.dq = hextob64u(o.dmq1.toString(16)), c.qi = hextob64u(o.coeff.toString(16));
  else if (o instanceof RSAKey && o.isPublic)
    c.kty = "RSA", c.n = hextob64u(o.n.toString(16)), c.e = hextob64u(o.e.toString(16));
  else if (o instanceof KJUR.crypto.ECDSA && o.isPrivate) {
    var p = o.getShortNISTPCurveName();
    if (p !== "P-256" && p !== "P-384" && p !== "P-521")
      throw new Error("unsupported curve name for JWT: " + p);
    var h = o.getPublicKeyXYHex();
    c.kty = "EC", c.crv = p, c.x = hextob64u(h.x), c.y = hextob64u(h.y), c.d = hextob64u(o.prvKeyHex);
  } else if (o instanceof KJUR.crypto.ECDSA && o.isPublic) {
    var p = o.getShortNISTPCurveName();
    if (p !== "P-256" && p !== "P-384" && p !== "P-521")
      throw new Error("unsupported curve name for JWT: " + p);
    var h = o.getPublicKeyXYHex();
    c.kty = "EC", c.crv = p, c.x = hextob64u(h.x), c.y = hextob64u(h.y);
  }
  if (c.kty == null)
    throw new Error("unsupported keyinfo");
  return !o.isPrivate && r != !0 && (c.kid = KJUR.jws.JWS.getJWKthumbprint(c)), l != null && a != !0 && (c.x5c = [hex2b64(l)]), l != null && e != !0 && (c.x5t = b64tob64u(hex2b64(d(l, "sha1")))), l != null && n != !0 && (c["x5t#S256"] = b64tob64u(hex2b64(d(l, "sha256")))), c;
};
KEYUTIL.getJWKFromKey = function(u) {
  return KEYUTIL.getJWK(u, !0, !0, !0, !0);
};
RSAKey.getPosArrayOfChildrenFromHex = function(u) {
  return ASN1HEX.getChildIdx(u, 0);
};
RSAKey.getHexValueArrayOfChildrenFromHex = function(u) {
  var r = ASN1HEX, a = r.getV, y = RSAKey.getPosArrayOfChildrenFromHex(u), e = a(u, y[0]), n = a(u, y[1]), o = a(u, y[2]), c = a(u, y[3]), l = a(u, y[4]), d = a(u, y[5]), p = a(u, y[6]), h = a(u, y[7]), g = a(u, y[8]), y = new Array();
  return y.push(e, n, o, c, l, d, p, h, g), y;
};
RSAKey.prototype.readPrivateKeyFromPEMString = function(u) {
  var r = pemtohex(u), a = RSAKey.getHexValueArrayOfChildrenFromHex(r);
  this.setPrivateEx(a[1], a[2], a[3], a[4], a[5], a[6], a[7], a[8]);
};
RSAKey.prototype.readPKCS5PrvKeyHex = function(u) {
  var r = RSAKey.getHexValueArrayOfChildrenFromHex(u);
  this.setPrivateEx(r[1], r[2], r[3], r[4], r[5], r[6], r[7], r[8]);
};
RSAKey.prototype.readPKCS8PrvKeyHex = function(u) {
  var r, a, e, n, o, c, l, d, p = ASN1HEX, h = p.getVbyListEx;
  if (p.isASN1HEX(u) === !1)
    throw new Error("not ASN.1 hex string");
  try {
    r = h(u, 0, [2, 0, 1], "02"), a = h(u, 0, [2, 0, 2], "02"), e = h(u, 0, [2, 0, 3], "02"), n = h(u, 0, [2, 0, 4], "02"), o = h(u, 0, [2, 0, 5], "02"), c = h(u, 0, [2, 0, 6], "02"), l = h(u, 0, [2, 0, 7], "02"), d = h(u, 0, [2, 0, 8], "02");
  } catch {
    throw new Error("malformed PKCS#8 plain RSA private key");
  }
  this.setPrivateEx(r, a, e, n, o, c, l, d);
};
RSAKey.prototype.readPKCS5PubKeyHex = function(u) {
  var r = ASN1HEX, a = r.getV;
  if (r.isASN1HEX(u) === !1)
    throw new Error("keyHex is not ASN.1 hex string");
  var e = r.getChildIdx(u, 0);
  if (e.length !== 2 || u.substr(e[0], 2) !== "02" || u.substr(e[1], 2) !== "02")
    throw new Error("wrong hex for PKCS#5 public key");
  var n = a(u, e[0]), o = a(u, e[1]);
  this.setPublic(n, o);
};
RSAKey.prototype.readPKCS8PubKeyHex = function(u) {
  var r = ASN1HEX;
  if (r.isASN1HEX(u) === !1)
    throw new Error("not ASN.1 hex string");
  if (r.getTLVbyListEx(u, 0, [0, 0]) !== "06092a864886f70d010101")
    throw new Error("not PKCS8 RSA public key");
  var a = r.getTLVbyListEx(u, 0, [1, 0]);
  this.readPKCS5PubKeyHex(a);
};
RSAKey.prototype.readCertPubKeyHex = function(u, r) {
  var a, e;
  a = new X509(), a.readCertHex(u), e = a.getPublicKeyHex(), this.readPKCS8PubKeyHex(e);
};
function _zeroPaddingOfSignature(u, r) {
  for (var a = "", e = r / 4 - u.length, n = 0; n < e; n++)
    a = a + "0";
  return a + u;
}
RSAKey.prototype.sign = function(u, r) {
  var a = function(n) {
    return KJUR.crypto.Util.hashString(n, r);
  }, e = a(u);
  return this.signWithMessageHash(e, r);
};
RSAKey.prototype.signWithMessageHash = function(u, r) {
  var a = KJUR.crypto.Util.getPaddedDigestInfoHex(u, r, this.n.bitLength()), e = parseBigInt(a, 16), n = this.doPrivate(e), o = n.toString(16);
  return _zeroPaddingOfSignature(o, this.n.bitLength());
};
function pss_mgf1_str(u, r, a) {
  for (var e = "", n = 0; e.length < r; )
    e += hextorstr(a(rstrtohex(u + String.fromCharCode.apply(String, [(n & 4278190080) >> 24, (n & 16711680) >> 16, (n & 65280) >> 8, n & 255])))), n += 1;
  return e;
}
RSAKey.prototype.signPSS = function(u, r, a) {
  var e = function(o) {
    return KJUR.crypto.Util.hashHex(o, r);
  }, n = e(rstrtohex(u));
  return a === void 0 && (a = -1), this.signWithMessageHashPSS(n, r, a);
};
RSAKey.prototype.signWithMessageHashPSS = function(u, r, a) {
  var e = hextorstr(u), n = e.length, o = this.n.bitLength() - 1, c = Math.ceil(o / 8), l, d = function(R) {
    return KJUR.crypto.Util.hashHex(R, r);
  };
  if (a === -1 || a === void 0)
    a = n;
  else if (a === -2)
    a = c - n - 2;
  else if (a < -2)
    throw new Error("invalid salt length");
  if (c < n + a + 2)
    throw new Error("data too long");
  var p = "";
  a > 0 && (p = new Array(a), new SecureRandom().nextBytes(p), p = String.fromCharCode.apply(String, p));
  var h = hextorstr(d(rstrtohex("\0\0\0\0\0\0\0\0" + e + p))), g = [];
  for (l = 0; l < c - a - n - 2; l += 1)
    g[l] = 0;
  var y = String.fromCharCode.apply(String, g) + "" + p, v = pss_mgf1_str(h, y.length, d), m = [];
  for (l = 0; l < y.length; l += 1)
    m[l] = y.charCodeAt(l) ^ v.charCodeAt(l);
  var b = 65280 >> 8 * c - o & 255;
  for (m[0] &= ~b, l = 0; l < n; l++)
    m.push(h.charCodeAt(l));
  return m.push(188), _zeroPaddingOfSignature(this.doPrivate(new BigInteger$5(m)).toString(16), this.n.bitLength());
};
function _rsasign_getAlgNameAndHashFromHexDisgestInfo(u) {
  for (var r in KJUR.crypto.Util.DIGESTINFOHEAD) {
    var a = KJUR.crypto.Util.DIGESTINFOHEAD[r], e = a.length;
    if (u.substring(0, e) == a) {
      var n = [r, u.substring(e)];
      return n;
    }
  }
  return [];
}
RSAKey.prototype.verify = function(u, r) {
  if (r = r.toLowerCase(), r.match(/^[0-9a-f]+$/) == null)
    return !1;
  var a = parseBigInt(r, 16), e = this.n.bitLength();
  if (a.bitLength() > e)
    return !1;
  var n = this.doPublic(a), o = n.toString(16);
  if (o.length + 3 != e / 4)
    return !1;
  var c = o.replace(/^1f+00/, ""), l = _rsasign_getAlgNameAndHashFromHexDisgestInfo(c);
  if (l.length == 0)
    return !1;
  var d = l[0], p = l[1], h = function(y) {
    return KJUR.crypto.Util.hashString(y, d);
  }, g = h(u);
  return p == g;
};
RSAKey.prototype.verifyWithMessageHash = function(u, r) {
  if (r.length != Math.ceil(this.n.bitLength() / 4))
    return !1;
  var a = parseBigInt(r, 16);
  if (a.bitLength() > this.n.bitLength())
    return 0;
  var e = this.doPublic(a), n = e.toString(16).replace(/^1f+00/, ""), o = _rsasign_getAlgNameAndHashFromHexDisgestInfo(n);
  if (o.length == 0)
    return !1;
  o[0];
  var c = o[1];
  return c == u;
};
RSAKey.prototype.verifyPSS = function(u, r, a, e) {
  var n = function(c) {
    return KJUR.crypto.Util.hashHex(c, a);
  }, o = n(rstrtohex(u));
  return e === void 0 && (e = -1), this.verifyWithMessageHashPSS(o, r, a, e);
};
RSAKey.prototype.verifyWithMessageHashPSS = function(u, r, a, e) {
  if (r.length != Math.ceil(this.n.bitLength() / 4))
    return !1;
  var n = new BigInteger$5(r, 16), o = function(x) {
    return KJUR.crypto.Util.hashHex(x, a);
  }, c = hextorstr(u), l = c.length, d = this.n.bitLength() - 1, p = Math.ceil(d / 8), h;
  if (e === -1 || e === void 0)
    e = l;
  else if (e === -2)
    e = p - l - 2;
  else if (e < -2)
    throw new Error("invalid salt length");
  if (p < l + e + 2)
    throw new Error("data too long");
  var g = this.doPublic(n).toByteArray();
  for (h = 0; h < g.length; h += 1)
    g[h] &= 255;
  for (; g.length < p; )
    g.unshift(0);
  if (g[p - 1] !== 188)
    throw new Error("encoded message does not end in 0xbc");
  g = String.fromCharCode.apply(String, g);
  var y = g.substr(0, p - l - 1), v = g.substr(y.length, l), m = 65280 >> 8 * p - d & 255;
  if (y.charCodeAt(0) & m)
    throw new Error("bits beyond keysize not zero");
  var b = pss_mgf1_str(v, y.length, o), R = [];
  for (h = 0; h < y.length; h += 1)
    R[h] = y.charCodeAt(h) ^ b.charCodeAt(h);
  R[0] &= ~m;
  var $ = p - l - e - 2;
  for (h = 0; h < $; h += 1)
    if (R[h] !== 0)
      throw new Error("leftmost octets not zero");
  if (R[$] !== 1)
    throw new Error("0x01 marker not found");
  return v === hextorstr(o(rstrtohex("\0\0\0\0\0\0\0\0" + c + String.fromCharCode.apply(String, R.slice(-e)))));
};
RSAKey.SALT_LEN_HLEN = -1;
RSAKey.SALT_LEN_MAX = -2;
RSAKey.SALT_LEN_RECOVER = -2;
function X509(u) {
  var r = ASN1HEX, a = r.getChildIdx, e = r.getV;
  r.dump;
  var n = r.parse, o = r.getTLV, c = r.getVbyList, l = r.getVbyListEx, d = r.getTLVbyList, p = r.getTLVbyListEx, h = r.getIdxbyList, g = r.getIdxbyListEx, y = r.getVidx, v = r.getInt, m = r.oidname, b = r.hextooidstr, R = pemtohex, $, x = Error;
  try {
    $ = KJUR.asn1.x509.AlgorithmIdentifier.PSSNAME2ASN1TLV;
  } catch {
  }
  this.HEX2STAG = { "0c": "utf8", 13: "prn", 16: "ia5", "1a": "vis", "1e": "bmp" }, this.hex = null, this.version = 0, this.foffset = 0, this.aExtInfo = null, this.getVersion = function() {
    if (this.hex === null || this.version !== 0)
      return this.version;
    var O = d(this.hex, 0, [0, 0]);
    if (O.substr(0, 2) == "a0") {
      var w = d(O, 0, [0]), _ = v(w, 0);
      if (_ < 0 || 2 < _)
        throw new Error("malformed version field");
      return this.version = _ + 1, this.version;
    } else
      return this.version = 1, this.foffset = -1, 1;
  }, this.getSerialNumberHex = function() {
    return l(this.hex, 0, [0, 0], "02");
  }, this.getSignatureAlgorithmField = function() {
    var O = p(this.hex, 0, [0, 1]);
    return this.getAlgorithmIdentifierName(O);
  }, this.getAlgorithmIdentifierName = function(O) {
    for (var w in $)
      if (O === $[w])
        return w;
    return m(l(O, 0, [0], "06"));
  }, this.getIssuer = function(O, w) {
    return this.getX500Name(this.getIssuerHex(), O, w);
  }, this.getIssuerHex = function() {
    return d(this.hex, 0, [0, 3 + this.foffset], "30");
  }, this.getIssuerString = function() {
    var O = this.getIssuer();
    return O.str;
  }, this.getSubject = function(O, w) {
    return this.getX500Name(this.getSubjectHex(), O, w);
  }, this.getSubjectHex = function() {
    return d(this.hex, 0, [0, 5 + this.foffset], "30");
  }, this.getSubjectString = function() {
    var O = this.getSubject();
    return O.str;
  }, this.getNotBefore = function() {
    var O = c(this.hex, 0, [0, 4 + this.foffset, 0]);
    return O = O.replace(/(..)/g, "%$1"), O = decodeURIComponent(O), O;
  }, this.getNotAfter = function() {
    var O = c(this.hex, 0, [0, 4 + this.foffset, 1]);
    return O = O.replace(/(..)/g, "%$1"), O = decodeURIComponent(O), O;
  }, this.getPublicKeyHex = function() {
    return this.getSPKI();
  }, this.getSPKI = function() {
    return d(this.hex, 0, [0, 6 + this.foffset], "30");
  }, this.getSPKIValue = function() {
    var O = this.getSPKI();
    return O == null ? null : c(O, 0, [1], "03", !0);
  }, this.getPublicKeyIdx = function() {
    return h(this.hex, 0, [0, 6 + this.foffset], "30");
  }, this.getPublicKeyContentIdx = function() {
    var O = this.getPublicKeyIdx();
    return h(this.hex, O, [1, 0], "30");
  }, this.getPublicKey = function() {
    return KEYUTIL.getKey(this.getPublicKeyHex(), null, "pkcs8pub");
  }, this.getSignatureAlgorithmName = function() {
    var O = d(this.hex, 0, [1], "30");
    return this.getAlgorithmIdentifierName(O);
  }, this.getSignatureValueHex = function() {
    return c(this.hex, 0, [2], "03", !0);
  }, this.verifySignature = function(O) {
    var w = this.getSignatureAlgorithmField(), _ = this.getSignatureValueHex(), C = d(this.hex, 0, [0], "30"), k = new KJUR.crypto.Signature({ alg: w });
    return k.init(O), k.updateHex(C), k.verify(_);
  }, this.parseExt = function(O) {
    var w, _, C;
    if (O === void 0) {
      if (C = this.hex, this.version !== 3)
        return -1;
      w = h(C, 0, [0, 7, 0], "30"), _ = a(C, w);
    } else {
      C = pemtohex(O);
      var k = h(C, 0, [0, 3, 0, 0], "06");
      if (e(C, k) != "2a864886f70d01090e") {
        this.aExtInfo = new Array();
        return;
      }
      w = h(C, 0, [0, 3, 0, 1, 0], "30"), _ = a(C, w), this.hex = C;
    }
    this.aExtInfo = new Array();
    for (var B = 0; B < _.length; B++) {
      var j = {};
      j.critical = !1;
      var J = a(C, _[B]), N = 0;
      J.length === 3 && (j.critical = !0, N = 1), j.oid = r.hextooidstr(c(C, _[B], [0], "06"));
      var F = h(C, _[B], [1 + N]);
      j.vidx = y(C, F), this.aExtInfo.push(j);
    }
  }, this.getExtInfo = function(O) {
    var w = this.aExtInfo, _ = O;
    if (O.match(/^[0-9.]+$/) || (_ = KJUR.asn1.x509.OID.name2oid(O)), _ !== "") {
      for (var C = 0; C < w.length; C++)
        if (w[C].oid === _)
          return w[C];
    }
  }, this.getCriticalExtV = function(O, w, _) {
    if (w != null)
      return [w, _];
    var C = this.getExtInfo(O);
    return C == null ? [null, null] : [o(this.hex, C.vidx), C.critical];
  }, this.getExtBasicConstraints = function(O, w) {
    if (O === void 0 && w === void 0) {
      var _ = this.getExtInfo("basicConstraints");
      if (_ === void 0)
        return;
      O = o(this.hex, _.vidx), w = _.critical;
    }
    var C = { extname: "basicConstraints" };
    if (w && (C.critical = !0), O === "3000")
      return C;
    if (O === "30030101ff")
      return C.cA = !0, C;
    if (O.substr(0, 12) === "30060101ff02") {
      var k = e(O, 10), B = parseInt(k, 16);
      return C.cA = !0, C.pathLen = B, C;
    }
    throw new Error("hExtV parse error: " + O);
  }, this.getExtNameConstraints = function(O, w) {
    var _ = this.getCriticalExtV("nameConstraints", O, w);
    if (O = _[0], w = _[1], O != null) {
      var C = { extname: "nameConstraints" };
      w && (C.critical = !0);
      for (var k = a(O, 0), B = 0; B < k.length; B++) {
        for (var j = [], J = a(O, k[B]), N = 0; N < J.length; N++) {
          var F = o(O, J[N]), U = this.getGeneralSubtree(F);
          j.push(U);
        }
        var K = O.substr(k[B], 2);
        K == "a0" ? C.permit = j : K == "a1" && (C.exclude = j);
      }
      return C;
    }
  }, this.getGeneralSubtree = function(O) {
    var w = a(O, 0), _ = w.length;
    if (_ < 1 || 2 < _)
      throw new Error("wrong num elements");
    for (var C = this.getGeneralName(o(O, w[0])), k = 1; k < _; k++) {
      var B = O.substr(w[k], 2), j = e(O, w[k]), J = parseInt(j, 16);
      B == "80" && (C.min = J), B == "81" && (C.max = J);
    }
    return C;
  }, this.getExtKeyUsage = function(O, w) {
    var _ = this.getCriticalExtV("keyUsage", O, w);
    if (O = _[0], w = _[1], O != null) {
      var C = { extname: "keyUsage" };
      return w && (C.critical = !0), C.names = this.getExtKeyUsageString(O).split(","), C;
    }
  }, this.getExtKeyUsageBin = function(O) {
    if (O === void 0) {
      var w = this.getExtInfo("keyUsage");
      if (w === void 0)
        return "";
      O = o(this.hex, w.vidx);
    }
    if (O.length != 8 && O.length != 10)
      throw new Error("malformed key usage value: " + O);
    var _ = "000000000000000" + parseInt(O.substr(6), 16).toString(2);
    return O.length == 8 && (_ = _.slice(-8)), O.length == 10 && (_ = _.slice(-16)), _ = _.replace(/0+$/, ""), _ == "" && (_ = "0"), _;
  }, this.getExtKeyUsageString = function(O) {
    for (var w = this.getExtKeyUsageBin(O), _ = new Array(), C = 0; C < w.length; C++)
      w.substr(C, 1) == "1" && _.push(X509.KEYUSAGE_NAME[C]);
    return _.join(",");
  }, this.getExtSubjectKeyIdentifier = function(O, w) {
    if (O === void 0 && w === void 0) {
      var _ = this.getExtInfo("subjectKeyIdentifier");
      if (_ === void 0)
        return;
      O = o(this.hex, _.vidx), w = _.critical;
    }
    var C = { extname: "subjectKeyIdentifier" };
    w && (C.critical = !0);
    var k = e(O, 0);
    return C.kid = { hex: k }, C;
  }, this.getExtAuthorityKeyIdentifier = function(O, w) {
    if (O === void 0 && w === void 0) {
      var _ = this.getExtInfo("authorityKeyIdentifier");
      if (_ === void 0)
        return;
      O = o(this.hex, _.vidx), w = _.critical;
    }
    var C = { extname: "authorityKeyIdentifier" };
    w && (C.critical = !0);
    for (var k = a(O, 0), B = 0; B < k.length; B++) {
      var j = O.substr(k[B], 2);
      if (j === "80" && (C.kid = { hex: e(O, k[B]) }), j === "a1") {
        var J = o(O, k[B]), N = this.getGeneralNames(J);
        C.issuer = N[0].dn;
      }
      j === "82" && (C.sn = { hex: e(O, k[B]) });
    }
    return C;
  }, this.getExtExtKeyUsage = function(O, w) {
    if (O === void 0 && w === void 0) {
      var _ = this.getExtInfo("extKeyUsage");
      if (_ === void 0)
        return;
      O = o(this.hex, _.vidx), w = _.critical;
    }
    var C = { extname: "extKeyUsage", array: [] };
    w && (C.critical = !0);
    for (var k = a(O, 0), B = 0; B < k.length; B++)
      C.array.push(m(e(O, k[B])));
    return C;
  }, this.getExtExtKeyUsageName = function() {
    var O = this.getExtInfo("extKeyUsage");
    if (O === void 0)
      return O;
    var w = new Array(), _ = o(this.hex, O.vidx);
    if (_ === "")
      return w;
    for (var C = a(_, 0), k = 0; k < C.length; k++)
      w.push(m(e(_, C[k])));
    return w;
  }, this.getExtSubjectAltName = function(O, w) {
    if (O === void 0 && w === void 0) {
      var _ = this.getExtInfo("subjectAltName");
      if (_ === void 0)
        return;
      O = o(this.hex, _.vidx), w = _.critical;
    }
    var C = { extname: "subjectAltName", array: [] };
    return w && (C.critical = !0), C.array = this.getGeneralNames(O), C;
  }, this.getExtIssuerAltName = function(O, w) {
    if (O === void 0 && w === void 0) {
      var _ = this.getExtInfo("issuerAltName");
      if (_ === void 0)
        return;
      O = o(this.hex, _.vidx), w = _.critical;
    }
    var C = { extname: "issuerAltName", array: [] };
    return w && (C.critical = !0), C.array = this.getGeneralNames(O), C;
  }, this.getGeneralNames = function(O) {
    for (var w = a(O, 0), _ = [], C = 0; C < w.length; C++) {
      var k = this.getGeneralName(o(O, w[C]));
      k !== void 0 && _.push(k);
    }
    return _;
  }, this.getGeneralName = function(O) {
    var w = O.substr(0, 2), _ = e(O, 0), C = hextorstr(_);
    if (w == "81")
      return { rfc822: C };
    if (w == "82")
      return { dns: C };
    if (w == "86")
      return { uri: C };
    if (w == "87")
      return { ip: hextoip(_) };
    if (w == "a4")
      return { dn: this.getX500Name(_) };
    if (w == "a0")
      return { other: this.getOtherName(O) };
  }, this.getExtSubjectAltName2 = function() {
    var O, w, _, C = this.getExtInfo("subjectAltName");
    if (C === void 0)
      return C;
    for (var k = new Array(), B = o(this.hex, C.vidx), j = a(B, 0), J = 0; J < j.length; J++)
      _ = B.substr(j[J], 2), O = e(B, j[J]), _ === "81" && (w = hextoutf8(O), k.push(["MAIL", w])), _ === "82" && (w = hextoutf8(O), k.push(["DNS", w])), _ === "84" && (w = X509.hex2dn(O, 0), k.push(["DN", w])), _ === "86" && (w = hextoutf8(O), k.push(["URI", w])), _ === "87" && (w = hextoip(O), k.push(["IP", w]));
    return k;
  }, this.getExtCRLDistributionPoints = function(O, w) {
    if (O === void 0 && w === void 0) {
      var _ = this.getExtInfo("cRLDistributionPoints");
      if (_ === void 0)
        return;
      O = o(this.hex, _.vidx), w = _.critical;
    }
    var C = { extname: "cRLDistributionPoints", array: [] };
    w && (C.critical = !0);
    for (var k = a(O, 0), B = 0; B < k.length; B++) {
      var j = o(O, k[B]);
      C.array.push(this.getDistributionPoint(j));
    }
    return C;
  }, this.getDistributionPoint = function(O) {
    for (var w = {}, _ = a(O, 0), C = 0; C < _.length; C++) {
      var k = O.substr(_[C], 2), B = o(O, _[C]);
      k == "a0" && (w.dpname = this.getDistributionPointName(B));
    }
    return w;
  }, this.getDistributionPointName = function(O) {
    for (var w = {}, _ = a(O, 0), C = 0; C < _.length; C++) {
      var k = O.substr(_[C], 2), B = o(O, _[C]);
      k == "a0" && (w.full = this.getGeneralNames(B));
    }
    return w;
  }, this.getExtCRLDistributionPointsURI = function() {
    var O = this.getExtCRLDistributionPoints();
    if (O == null)
      return O;
    for (var w = O.array, _ = [], C = 0; C < w.length; C++)
      try {
        w[C].dpname.full[0].uri != null && _.push(w[C].dpname.full[0].uri);
      } catch {
      }
    return _;
  }, this.getExtAIAInfo = function() {
    var O = this.getExtInfo("authorityInfoAccess");
    if (O === void 0)
      return O;
    for (var w = { ocsp: [], caissuer: [] }, _ = a(this.hex, O.vidx), C = 0; C < _.length; C++) {
      var k = c(this.hex, _[C], [0], "06"), B = c(this.hex, _[C], [1], "86");
      k === "2b06010505073001" && w.ocsp.push(hextoutf8(B)), k === "2b06010505073002" && w.caissuer.push(hextoutf8(B));
    }
    return w;
  }, this.getExtAuthorityInfoAccess = function(O, w) {
    if (O === void 0 && w === void 0) {
      var _ = this.getExtInfo("authorityInfoAccess");
      if (_ === void 0)
        return;
      O = o(this.hex, _.vidx), w = _.critical;
    }
    var C = { extname: "authorityInfoAccess", array: [] };
    w && (C.critical = !0);
    for (var k = a(O, 0), B = 0; B < k.length; B++) {
      var j = l(O, k[B], [0], "06"), J = c(O, k[B], [1], "86"), N = hextoutf8(J);
      if (j == "2b06010505073001")
        C.array.push({ ocsp: N });
      else if (j == "2b06010505073002")
        C.array.push({ caissuer: N });
      else
        throw new Error("unknown method: " + j);
    }
    return C;
  }, this.getExtCertificatePolicies = function(O, w) {
    if (O === void 0 && w === void 0) {
      var _ = this.getExtInfo("certificatePolicies");
      if (_ === void 0)
        return;
      O = o(this.hex, _.vidx), w = _.critical;
    }
    var C = { extname: "certificatePolicies", array: [] };
    w && (C.critical = !0);
    for (var k = a(O, 0), B = 0; B < k.length; B++) {
      var j = o(O, k[B]), J = this.getPolicyInformation(j);
      C.array.push(J);
    }
    return C;
  }, this.getPolicyInformation = function(O) {
    var w = {}, _ = c(O, 0, [0], "06");
    w.policyoid = m(_);
    var C = g(O, 0, [1], "30");
    if (C != -1) {
      w.array = [];
      for (var k = a(O, C), B = 0; B < k.length; B++) {
        var j = o(O, k[B]), J = this.getPolicyQualifierInfo(j);
        w.array.push(J);
      }
    }
    return w;
  }, this.getOtherName = function(O) {
    var w = {}, _ = a(O, 0), C = c(O, _[0], [], "06"), k = c(O, _[1], []);
    return w.oid = m(C), w.value = n(k), w;
  }, this.getPolicyQualifierInfo = function(O) {
    var w = {}, _ = c(O, 0, [0], "06");
    if (_ === "2b06010505070201") {
      var C = l(O, 0, [1], "16");
      w.cps = hextorstr(C);
    } else if (_ === "2b06010505070202") {
      var k = d(O, 0, [1], "30");
      w.unotice = this.getUserNotice(k);
    }
    return w;
  }, this.getUserNotice = function(O) {
    var w = null;
    try {
      w = r.parse(O);
      var _ = this._asn1ToUnotice(w);
      return _;
    } catch {
      return;
    }
  }, this._asn1ToUnotice = function(O) {
    try {
      for (var w = {}, _ = aryval(O, "seq"), C = 0; C < _.length; C++) {
        var k = this._asn1ToNoticeRef(_[C]);
        k != null && (w.noticeref = k);
        var B = this.asn1ToDisplayText(_[C]);
        B != null && (w.exptext = B);
      }
      return Object.keys(w).length > 0 ? w : void 0;
    } catch {
      return;
    }
  }, this._asn1ToNoticeRef = function(O) {
    try {
      for (var w = {}, _ = aryval(O, "seq"), C = 0; C < _.length; C++) {
        var k = this._asn1ToNoticeNum(_[C]);
        k != null && (w.noticenum = k);
        var B = this.asn1ToDisplayText(_[C]);
        B != null && (w.org = B);
      }
      return Object.keys(w).length > 0 ? w : void 0;
    } catch {
      return;
    }
  }, this._asn1ToNoticeNum = function(O) {
    try {
      for (var w = aryval(O, "seq"), _ = [], C = 0; C < w.length; C++) {
        var k = w[C];
        _.push(parseInt(aryval(k, "int.hex"), 16));
      }
      return _;
    } catch {
      return;
    }
  }, this.getDisplayText = function(O) {
    var w = { "0c": "utf8", 16: "ia5", "1a": "vis", "1e": "bmp" }, _ = {};
    return _.type = w[O.substr(0, 2)], _.str = hextorstr(e(O, 0)), _;
  }, this.asn1ToDisplayText = function(O) {
    if (O.utf8str != null)
      return { type: "utf8", str: O.utf8str.str };
    if (O.ia5str != null)
      return { type: "ia5", str: O.ia5str.str };
    if (O.visstr != null)
      return { type: "vis", str: O.visstr.str };
    if (O.bmpstr != null)
      return { type: "bmp", str: O.bmpstr.str };
    if (O.prnstr != null)
      return { type: "prn", str: O.prnstr.str };
  }, this.getExtPolicyMappings = function(O, w) {
    var _ = this.getCriticalExtV("policyMappings", O, w);
    if (O = _[0], w = _[1], O != null) {
      var C = { extname: "policyMappings" };
      w && (C.critical = !0);
      try {
        for (var k = n(O), B = k.seq, j = [], J = 0; J < B.length; J++) {
          var N = B[J].seq;
          j.push([N[0].oid, N[1].oid]);
        }
        C.array = j;
      } catch {
        throw new x("malformed policyMappings");
      }
      return C;
    }
  }, this.getExtPolicyConstraints = function(O, w) {
    var _ = this.getCriticalExtV("policyConstraints", O, w);
    if (O = _[0], w = _[1], O != null) {
      var C = { extname: "policyConstraints" };
      w && (C.critical = !0);
      var k = n(O);
      try {
        for (var B = k.seq, j = 0; j < B.length; j++) {
          var J = B[j].tag;
          J.explicit == !1 && (J.tag == "80" && (C.reqexp = parseInt(J.hex, 16)), J.tag == "81" && (C.inhibit = parseInt(J.hex, 16)));
        }
      } catch {
        return new x("malformed policyConstraints value");
      }
      return C;
    }
  }, this.getExtInhibitAnyPolicy = function(O, w) {
    var _ = this.getCriticalExtV("inhibitAnyPolicy", O, w);
    if (O = _[0], w = _[1], O != null) {
      var C = { extname: "inhibitAnyPolicy" };
      w && (C.critical = !0);
      var k = v(O, 0);
      return k == -1 ? new x("wrong value") : (C.skip = k, C);
    }
  }, this.getExtCRLNumber = function(O, w) {
    var _ = { extname: "cRLNumber" };
    if (w && (_.critical = !0), O.substr(0, 2) == "02")
      return _.num = { hex: e(O, 0) }, _;
    throw new x("hExtV parse error: " + O);
  }, this.getExtCRLReason = function(O, w) {
    var _ = { extname: "cRLReason" };
    if (w && (_.critical = !0), O.substr(0, 2) == "0a")
      return _.code = parseInt(e(O, 0), 16), _;
    throw new Error("hExtV parse error: " + O);
  }, this.getExtOcspNonce = function(O, w) {
    var _ = { extname: "ocspNonce" };
    w && (_.critical = !0);
    var C = e(O, 0);
    return _.hex = C, _;
  }, this.getExtOcspNoCheck = function(O, w) {
    var _ = { extname: "ocspNoCheck" };
    return w && (_.critical = !0), _;
  }, this.getExtAdobeTimeStamp = function(O, w) {
    if (O === void 0 && w === void 0) {
      var _ = this.getExtInfo("adobeTimeStamp");
      if (_ === void 0)
        return;
      O = o(this.hex, _.vidx), w = _.critical;
    }
    var C = { extname: "adobeTimeStamp" };
    w && (C.critical = !0);
    var k = a(O, 0);
    if (k.length > 1) {
      var B = o(O, k[1]), j = this.getGeneralName(B);
      j.uri != null && (C.uri = j.uri);
    }
    if (k.length > 2) {
      var J = o(O, k[2]);
      J == "0101ff" && (C.reqauth = !0), J == "010100" && (C.reqauth = !1);
    }
    return C;
  }, this.getExtSubjectDirectoryAttributes = function(O, w) {
    if (O === void 0 && w === void 0) {
      var _ = this.getExtInfo("subjectDirectoryAttributes");
      if (_ === void 0)
        return;
      O = o(this.hex, _.vidx), w = _.critical;
    }
    var C = { extname: "subjectDirectoryAttributes" };
    w && (C.critical = !0);
    try {
      for (var k = n(O), B = [], j = 0; j < k.seq.length; j++) {
        var J = k.seq[j], N = aryval(J, "seq.0.oid"), F = aryval(J, "seq.1.set");
        if (N == null || F == null)
          throw "error";
        B.push({ attr: N, array: F });
      }
      return C.array = B, C;
    } catch {
      throw new Error("malformed subjectDirectoryAttributes extension value");
    }
  };
  var E = function(O) {
    var w = {};
    try {
      var _ = O.seq[0].oid, C = KJUR.asn1.x509.OID.name2oid(_);
      w.type = KJUR.asn1.x509.OID.oid2atype(C);
      var k = O.seq[1];
      if (k.utf8str != null)
        w.ds = "utf8", w.value = k.utf8str.str;
      else if (k.numstr != null)
        w.ds = "num", w.value = k.numstr.str;
      else if (k.telstr != null)
        w.ds = "tel", w.value = k.telstr.str;
      else if (k.prnstr != null)
        w.ds = "prn", w.value = k.prnstr.str;
      else if (k.ia5str != null)
        w.ds = "ia5", w.value = k.ia5str.str;
      else if (k.visstr != null)
        w.ds = "vis", w.value = k.visstr.str;
      else if (k.bmpstr != null)
        w.ds = "bmp", w.value = k.bmpstr.str;
      else
        throw "error";
      return w;
    } catch {
      throw new Erorr("improper ASN.1 parsed AttrTypeAndValue");
    }
  }, T = function(O) {
    try {
      return O.set.map(function(w) {
        return E(w);
      });
    } catch (w) {
      throw new Error("improper ASN.1 parsed RDN: " + w);
    }
  }, P = function(O) {
    try {
      return O.seq.map(function(w) {
        return T(w);
      });
    } catch (w) {
      throw new Error("improper ASN.1 parsed X500Name: " + w);
    }
  };
  this.getX500NameRule = function(O) {
    for (var w = null, _ = [], C = 0; C < O.length; C++)
      for (var k = O[C], B = 0; B < k.length; B++)
        _.push(k[B]);
    for (var C = 0; C < _.length; C++) {
      var j = _[C], J = j.ds, N = j.value, F = j.type;
      if (J != "prn" && J != "utf8" && J != "ia5")
        return "mixed";
      if (J == "ia5") {
        if (F != "CN")
          return "mixed";
        if (KJUR.lang.String.isMail(N))
          continue;
        return "mixed";
      }
      if (F == "C") {
        if (J == "prn")
          continue;
        return "mixed";
      }
      if (w == null)
        w = J;
      else if (w !== J)
        return "mixed";
    }
    return w ?? "prn";
  }, this.getAttrTypeAndValue = function(O) {
    var w = n(O);
    return E(w);
  }, this.getRDN = function(O) {
    var w = n(O);
    return T(w);
  }, this.getX500NameArray = function(O) {
    var w = n(O);
    return P(w);
  }, this.getX500Name = function(O, w, _) {
    var C = this.getX500NameArray(O), k = this.dnarraytostr(C), B = { str: k };
    return B.array = C, _ == !0 && (B.hex = O), w == !0 && (B.canon = this.c14nRDNArray(C)), B;
  }, this.readCertPEM = function(O) {
    this.readCertHex(R(O));
  }, this.readCertHex = function(O) {
    this.hex = O, this.getVersion();
    try {
      h(this.hex, 0, [0, 7], "a3"), this.parseExt();
    } catch {
    }
  }, this.getParam = function(O) {
    var w = {};
    return O == null && (O = {}), w.version = this.getVersion(), w.serial = { hex: this.getSerialNumberHex() }, w.sigalg = this.getSignatureAlgorithmField(), w.issuer = this.getIssuer(O.dncanon, O.dnhex), w.notbefore = this.getNotBefore(), w.notafter = this.getNotAfter(), w.subject = this.getSubject(O.dncanon, O.dnhex), w.sbjpubkey = hextopem(this.getPublicKeyHex(), "PUBLIC KEY"), this.aExtInfo != null && this.aExtInfo.length > 0 && (w.ext = this.getExtParamArray()), w.sighex = this.getSignatureValueHex(), O.tbshex == !0 && (w.tbshex = d(this.hex, 0, [0])), O.nodnarray == !0 && (delete w.issuer.array, delete w.subject.array), w;
  }, this.getExtParamArray = function(O) {
    if (O == null) {
      var w = g(this.hex, 0, [0, "[3]"]);
      w != -1 && (O = p(this.hex, 0, [0, "[3]", 0], "30"));
    }
    for (var _ = [], C = a(O, 0), k = 0; k < C.length; k++) {
      var B = o(O, C[k]), j = this.getExtParam(B);
      j != null && _.push(j);
    }
    return _;
  }, this.getExtParam = function(O) {
    var w = a(O, 0), _ = w.length;
    if (_ != 2 && _ != 3)
      throw new Error("wrong number elements in Extension: " + _ + " " + O);
    var C = b(c(O, 0, [0], "06")), k = !1;
    _ == 3 && d(O, 0, [1]) == "0101ff" && (k = !0);
    var B = d(O, 0, [_ - 1, 0]), j = void 0;
    if (C == "2.5.29.14" ? j = this.getExtSubjectKeyIdentifier(B, k) : C == "2.5.29.15" ? j = this.getExtKeyUsage(B, k) : C == "2.5.29.17" ? j = this.getExtSubjectAltName(B, k) : C == "2.5.29.18" ? j = this.getExtIssuerAltName(B, k) : C == "2.5.29.19" ? j = this.getExtBasicConstraints(B, k) : C == "2.5.29.30" ? j = this.getExtNameConstraints(B, k) : C == "2.5.29.31" ? j = this.getExtCRLDistributionPoints(B, k) : C == "2.5.29.32" ? j = this.getExtCertificatePolicies(B, k) : C == "2.5.29.33" ? j = this.getExtPolicyMappings(B, k) : C == "2.5.29.35" ? j = this.getExtAuthorityKeyIdentifier(B, k) : C == "2.5.29.36" ? j = this.getExtPolicyConstraints(B, k) : C == "2.5.29.37" ? j = this.getExtExtKeyUsage(B, k) : C == "2.5.29.54" ? j = this.getExtInhibitAnyPolicy(B, k) : C == "1.3.6.1.5.5.7.1.1" ? j = this.getExtAuthorityInfoAccess(B, k) : C == "2.5.29.20" ? j = this.getExtCRLNumber(B, k) : C == "2.5.29.21" ? j = this.getExtCRLReason(B, k) : C == "2.5.29.9" ? j = this.getExtSubjectDirectoryAttributes(B, k) : C == "1.3.6.1.5.5.7.48.1.2" ? j = this.getExtOcspNonce(B, k) : C == "1.3.6.1.5.5.7.48.1.5" ? j = this.getExtOcspNoCheck(B, k) : C == "1.2.840.113583.1.1.9.1" ? j = this.getExtAdobeTimeStamp(B, k) : X509.EXT_PARSER[C] != null && (j = X509.EXT_PARSER[C](C, k, B)), j != null)
      return j;
    var J = { extname: C, extn: B };
    try {
      J.extn = n(B);
    } catch {
    }
    return k && (J.critical = !0), J;
  }, this.findExt = function(O, w) {
    for (var _ = 0; _ < O.length; _++)
      if (O[_].extname == w)
        return O[_];
    return null;
  }, this.updateExtCDPFullURI = function(O, w) {
    var _ = this.findExt(O, "cRLDistributionPoints");
    if (_ != null && _.array != null) {
      for (var C = _.array, k = 0; k < C.length; k++)
        if (C[k].dpname != null && C[k].dpname.full != null)
          for (var B = C[k].dpname.full, j = 0; j < B.length; j++) {
            var J = B[k];
            J.uri != null && (J.uri = w);
          }
    }
  }, this.updateExtAIAOCSP = function(O, w) {
    var _ = this.findExt(O, "authorityInfoAccess");
    if (_ != null && _.array != null)
      for (var C = _.array, k = 0; k < C.length; k++)
        C[k].ocsp != null && (C[k].ocsp = w);
  }, this.updateExtAIACAIssuer = function(O, w) {
    var _ = this.findExt(O, "authorityInfoAccess");
    if (_ != null && _.array != null)
      for (var C = _.array, k = 0; k < C.length; k++)
        C[k].caissuer != null && (C[k].caissuer = w);
  }, this.dnarraytostr = function(O) {
    function w(C) {
      return C.map(function(k) {
        return _(k).replace(/\+/, "\\+");
      }).join("+");
    }
    function _(C) {
      return C.type + "=" + C.value;
    }
    return "/" + O.map(function(C) {
      return w(C).replace(/\//, "\\/");
    }).join("/");
  }, this.setCanonicalizedDN = function(O) {
    var w;
    if (O.str != null && O.array == null) {
      var _ = new KJUR.asn1.x509.X500Name({ str: O.str }), C = _.tohex();
      w = this.getX500NameArray(C);
    } else
      w = O.array;
    O.canon == null && (O.canon = this.c14nRDNArray(w));
  }, this.c14nRDNArray = function(O) {
    for (var w = [], _ = 0; _ < O.length; _++) {
      for (var C = O[_], k = [], B = 0; B < C.length; B++) {
        var j = C[B], J = j.value;
        J = J.replace(/^\s*/, ""), J = J.replace(/\s*$/, ""), J = J.replace(/\s+/g, " "), J = J.toLowerCase(), k.push(j.type.toLowerCase() + "=" + J);
      }
      w.push(k.join("+"));
    }
    return "/" + w.join("/");
  }, this.getInfo = function() {
    var O = function(pe) {
      for (var Q = "", oe = "    ", ne = `
`, se = pe.array, de = 0; de < se.length; de++) {
        var ue = se[de];
        if (ue.dn != null && (Q += oe + "dn: " + ue.dn.str + ne), ue.ip != null && (Q += oe + "ip: " + ue.ip + ne), ue.rfc822 != null && (Q += oe + "rfc822: " + ue.rfc822 + ne), ue.dns != null && (Q += oe + "dns: " + ue.dns + ne), ue.uri != null && (Q += oe + "uri: " + ue.uri + ne), ue.other != null) {
          var Re = ue.other.oid, be = JSON.stringify(ue.other.value).replace(/\"/g, "");
          Q += oe + "other: " + Re + "=" + be + ne;
        }
      }
      return Q = Q.replace(/\n$/, ""), Q;
    }, w = function(pe) {
      for (var Q = "", oe = pe.array, ne = 0; ne < oe.length; ne++) {
        var se = oe[ne];
        if (Q += "    policy oid: " + se.policyoid + `
`, se.array !== void 0)
          for (var de = 0; de < se.array.length; de++) {
            var ue = se.array[de];
            ue.cps !== void 0 && (Q += "    cps: " + ue.cps + `
`);
          }
      }
      return Q;
    }, _ = function(pe) {
      for (var Q = "", oe = pe.array, ne = 0; ne < oe.length; ne++) {
        var se = oe[ne];
        try {
          se.dpname.full[0].uri !== void 0 && (Q += "    " + se.dpname.full[0].uri + `
`);
        } catch {
        }
        try {
          se.dname.full[0].dn.hex !== void 0 && (Q += "    " + X509.hex2dn(se.dpname.full[0].dn.hex) + `
`);
        } catch {
        }
      }
      return Q;
    }, C = function(pe) {
      for (var Q = "", oe = pe.array, ne = 0; ne < oe.length; ne++) {
        var se = oe[ne];
        se.caissuer !== void 0 && (Q += "    caissuer: " + se.caissuer + `
`), se.ocsp !== void 0 && (Q += "    ocsp: " + se.ocsp + `
`);
      }
      return Q;
    }, k, B, j;
    if (k = `Basic Fields
`, k += "  serial number: " + this.getSerialNumberHex() + `
`, k += "  signature algorithm: " + this.getSignatureAlgorithmField() + `
`, k += "  issuer: " + this.getIssuerString() + `
`, k += "  notBefore: " + this.getNotBefore() + `
`, k += "  notAfter: " + this.getNotAfter() + `
`, k += "  subject: " + this.getSubjectString() + `
`, k += `  subject public key info: 
`, B = this.getPublicKey(), k += "    key algorithm: " + B.type + `
`, B.type === "RSA" && (k += "    n=" + hextoposhex(B.n.toString(16)).substr(0, 16) + `...
`, k += "    e=" + hextoposhex(B.e.toString(16)) + `
`), j = this.aExtInfo, j != null) {
      k += `X509v3 Extensions:
`;
      for (var J = 0; J < j.length; J++) {
        var N = j[J], F = KJUR.asn1.x509.OID.oid2name(N.oid);
        F === "" && (F = N.oid);
        var U = "";
        if (N.critical === !0 && (U = "CRITICAL"), k += "  " + F + " " + U + `:
`, F === "basicConstraints") {
          var K = this.getExtBasicConstraints();
          K.cA === void 0 ? k += `    {}
` : (k += "    cA=true", K.pathLen !== void 0 && (k += ", pathLen=" + K.pathLen), k += `
`);
        } else if (F == "policyMappings") {
          var ve = this.getExtPolicyMappings().array, he = ve.map(function(pe) {
            var Q = pe;
            return Q[0] + ":" + Q[1];
          }).join(", ");
          k += "    " + he + `
`;
        } else if (F == "policyConstraints") {
          var te = this.getExtPolicyConstraints();
          k += "    ", te.reqexp != null && (k += " reqexp=" + te.reqexp), te.inhibit != null && (k += " inhibit=" + te.inhibit), k += `
`;
        } else if (F == "inhibitAnyPolicy") {
          var te = this.getExtInhibitAnyPolicy();
          k += "    skip=" + te.skip + `
`;
        } else if (F == "keyUsage")
          k += "    " + this.getExtKeyUsageString() + `
`;
        else if (F == "subjectKeyIdentifier")
          k += "    " + this.getExtSubjectKeyIdentifier().kid.hex + `
`;
        else if (F == "authorityKeyIdentifier") {
          var W = this.getExtAuthorityKeyIdentifier();
          W.kid !== void 0 && (k += "    kid=" + W.kid.hex + `
`);
        } else if (F == "extKeyUsage") {
          var ae = this.getExtExtKeyUsage().array;
          k += "    " + ae.join(", ") + `
`;
        } else if (F == "subjectAltName") {
          var fe = O(this.getExtSubjectAltName());
          k += fe + `
`;
        } else if (F == "cRLDistributionPoints") {
          var ee = this.getExtCRLDistributionPoints();
          k += _(ee);
        } else if (F == "authorityInfoAccess") {
          var Se = this.getExtAuthorityInfoAccess();
          k += C(Se);
        } else
          F == "certificatePolicies" && (k += w(this.getExtCertificatePolicies()));
      }
    }
    return k += "signature algorithm: " + this.getSignatureAlgorithmName() + `
`, k += "signature: " + this.getSignatureValueHex().substr(0, 16) + `...
`, k;
  }, typeof u == "string" && (u.indexOf("-----BEGIN") != -1 ? this.readCertPEM(u) : KJUR.lang.String.isHex(u) && this.readCertHex(u));
}
X509.EXT_PARSER = {};
X509.registExtParser = function(u, r) {
  X509.EXT_PARSER[u] = r;
};
X509.hex2dn = function(u, r) {
  r === void 0 && (r = 0);
  var a = new X509();
  ASN1HEX.getTLV(u, r);
  var e = a.getX500Name(u);
  return e.str;
};
X509.hex2rdn = function(u, r) {
  if (r === void 0 && (r = 0), u.substr(r, 2) !== "31")
    throw new Error("malformed RDN");
  for (var a = new Array(), e = ASN1HEX.getChildIdx(u, r), n = 0; n < e.length; n++)
    a.push(X509.hex2attrTypeValue(u, e[n]));
  return a = a.map(function(o) {
    return o.replace("+", "\\+");
  }), a.join("+");
};
X509.hex2attrTypeValue = function(u, r) {
  var a = ASN1HEX, e = a.getV;
  if (r === void 0 && (r = 0), u.substr(r, 2) !== "30")
    throw new Error("malformed attribute type and value");
  var n = a.getChildIdx(u, r);
  n.length !== 2 || u.substr(n[0], 2);
  var o = e(u, n[0]), c = KJUR.asn1.ASN1Util.oidHexToInt(o), l = KJUR.asn1.x509.OID.oid2atype(c), d = e(u, n[1]), p = hextorstr(d);
  return l + "=" + p;
};
X509.getPublicKeyFromCertHex = function(u) {
  var r = new X509();
  return r.readCertHex(u), r.getPublicKey();
};
X509.getPublicKeyFromCertPEM = function(u) {
  var r = new X509();
  return r.readCertPEM(u), r.getPublicKey();
};
X509.getPublicKeyInfoPropOfCertPEM = function(u) {
  var r = ASN1HEX, a = r.getVbyList, e = {}, n, o;
  return e.algparam = null, n = new X509(), n.readCertPEM(u), o = n.getPublicKeyHex(), e.keyhex = a(o, 0, [1], "03").substr(2), e.algoid = a(o, 0, [0, 0], "06"), e.algoid === "2a8648ce3d0201" && (e.algparam = a(o, 0, [0, 1], "06")), e;
};
X509.KEYUSAGE_NAME = ["digitalSignature", "nonRepudiation", "keyEncipherment", "dataEncipherment", "keyAgreement", "keyCertSign", "cRLSign", "encipherOnly", "decipherOnly"];
(typeof KJUR > "u" || !KJUR) && (KJUR = {});
(typeof KJUR.jws > "u" || !KJUR.jws) && (KJUR.jws = {});
KJUR.jws.JWS = function() {
  var u = KJUR, r = u.jws.JWS, a = r.isSafeJSONString;
  this.parseJWS = function(e, n) {
    if (!(this.parsedJWS !== void 0 && (n || this.parsedJWS.sigvalH !== void 0))) {
      var o = e.match(/^([^.]+)\.([^.]+)\.([^.]+)$/);
      if (o == null)
        throw "JWS signature is not a form of 'Head.Payload.SigValue'.";
      var c = o[1], l = o[2], d = o[3], p = c + "." + l;
      if (this.parsedJWS = {}, this.parsedJWS.headB64U = c, this.parsedJWS.payloadB64U = l, this.parsedJWS.sigvalB64U = d, this.parsedJWS.si = p, !n) {
        var h = b64utohex(d), g = parseBigInt(h, 16);
        this.parsedJWS.sigvalH = h, this.parsedJWS.sigvalBI = g;
      }
      var y = b64utoutf8(c), v = b64utoutf8(l);
      if (this.parsedJWS.headS = y, this.parsedJWS.payloadS = v, !a(y, this.parsedJWS, "headP"))
        throw "malformed JSON string for JWS Head: " + y;
    }
  };
};
KJUR.jws.JWS.sign = function(u, r, a, e, n) {
  var o = KJUR, c = o.jws, l = c.JWS, d = l.readSafeJSONString, p = l.isSafeJSONString, h = o.crypto;
  h.ECDSA;
  var g = h.Mac, y = h.Signature, v = JSON, m, b, R;
  if (typeof r != "string" && typeof r != "object")
    throw "spHeader must be JSON string or object: " + r;
  if (typeof r == "object" && (b = r, m = v.stringify(b)), typeof r == "string") {
    if (m = r, !p(m))
      throw "JWS Head is not safe JSON string: " + m;
    b = d(m);
  }
  if (R = a, typeof a == "object" && (R = v.stringify(a)), (u == "" || u == null) && b.alg !== void 0 && (u = b.alg), u != "" && u != null && b.alg === void 0 && (b.alg = u, m = v.stringify(b)), u !== b.alg)
    throw "alg and sHeader.alg doesn't match: " + u + "!=" + b.alg;
  var $ = null;
  if (l.jwsalg2sigalg[u] === void 0)
    throw "unsupported alg name: " + u;
  $ = l.jwsalg2sigalg[u];
  var x = utf8tob64u(m), E = utf8tob64u(R), T = x + "." + E, P = "";
  if ($.substr(0, 4) == "Hmac") {
    if (e === void 0)
      throw "mac key shall be specified for HS* alg";
    var O = new g({ alg: $, prov: "cryptojs", pass: e });
    O.updateString(T), P = O.doFinal();
  } else if ($.indexOf("withECDSA") != -1) {
    var w = new y({ alg: $ });
    w.init(e, n), w.updateString(T);
    var _ = w.sign();
    P = KJUR.crypto.ECDSA.asn1SigToConcatSig(_);
  } else if ($ != "none") {
    var w = new y({ alg: $ });
    w.init(e, n), w.updateString(T), P = w.sign();
  }
  var C = hextob64u(P);
  return T + "." + C;
};
KJUR.jws.JWS.verify = function(u, r, a) {
  var e = KJUR, n = e.jws, o = n.JWS, c = o.readSafeJSONString, l = e.crypto, d = l.ECDSA, p = l.Mac, h = l.Signature, g;
  if (typeof RSAKey !== void 0 && (g = RSAKey), !isBase64URLDot(u))
    return !1;
  var y = u.split(".");
  if (y.length !== 3)
    return !1;
  var v = y[0], m = y[1], b = v + "." + m, R = b64utohex(y[2]), $ = c(b64utoutf8(y[0])), x = null, E = null;
  if ($.alg === void 0)
    throw "algorithm not specified in header";
  if (x = $.alg, E = x.substr(0, 2), a != null && Object.prototype.toString.call(a) === "[object Array]" && a.length > 0) {
    var T = ":" + a.join(":") + ":";
    if (T.indexOf(":" + x + ":") == -1)
      throw "algorithm '" + x + "' not accepted in the list";
  }
  if (x != "none" && r === null)
    throw "key shall be specified to verify.";
  if (typeof r == "string" && r.indexOf("-----BEGIN ") != -1 && (r = KEYUTIL.getKey(r)), (E == "RS" || E == "PS") && !(r instanceof g))
    throw "key shall be a RSAKey obj for RS* and PS* algs";
  if (E == "ES" && !(r instanceof d))
    throw "key shall be a ECDSA obj for ES* algs";
  var P = null;
  if (o.jwsalg2sigalg[$.alg] === void 0)
    throw "unsupported alg name: " + x;
  if (P = o.jwsalg2sigalg[x], P == "none")
    throw "not supported";
  if (P.substr(0, 4) == "Hmac") {
    var O = null;
    if (r === void 0)
      throw "hexadecimal key shall be specified for HMAC";
    var w = new p({ alg: P, pass: r });
    return w.updateString(b), O = w.doFinal(), R == O;
  } else if (P.indexOf("withECDSA") != -1) {
    var _ = null;
    try {
      _ = d.concatSigToASN1Sig(R);
    } catch {
      return !1;
    }
    var C = new h({ alg: P });
    return C.init(r), C.updateString(b), C.verify(_);
  } else {
    var C = new h({ alg: P });
    return C.init(r), C.updateString(b), C.verify(R);
  }
};
KJUR.jws.JWS.parse = function(u) {
  var r = u.split("."), a = {}, e, n, o;
  if (r.length != 2 && r.length != 3)
    throw "malformed sJWS: wrong number of '.' splitted elements";
  return e = r[0], n = r[1], r.length == 3 && (o = r[2]), a.headerObj = KJUR.jws.JWS.readSafeJSONString(b64utoutf8(e)), a.payloadObj = KJUR.jws.JWS.readSafeJSONString(b64utoutf8(n)), a.headerPP = JSON.stringify(a.headerObj, null, "  "), a.payloadObj == null ? a.payloadPP = b64utoutf8(n) : a.payloadPP = JSON.stringify(a.payloadObj, null, "  "), o !== void 0 && (a.sigHex = b64utohex(o)), a;
};
KJUR.jws.JWS.verifyJWT = function(u, r, a) {
  var e = KJUR, n = e.jws, o = n.JWS, c = o.readSafeJSONString, l = o.inArray, d = o.includedArray;
  if (!isBase64URLDot(u))
    return !1;
  var p = u.split(".");
  if (p.length != 3)
    return !1;
  var h = p[0], g = p[1];
  b64utohex(p[2]);
  var y = c(b64utoutf8(h)), v = c(b64utoutf8(g));
  if (y.alg === void 0)
    return !1;
  if (a.alg === void 0)
    throw "acceptField.alg shall be specified";
  if (!l(y.alg, a.alg) || v.iss !== void 0 && typeof a.iss == "object" && !l(v.iss, a.iss) || v.sub !== void 0 && typeof a.sub == "object" && !l(v.sub, a.sub))
    return !1;
  if (v.aud !== void 0 && typeof a.aud == "object") {
    if (typeof v.aud == "string") {
      if (!l(v.aud, a.aud))
        return !1;
    } else if (typeof v.aud == "object" && !d(v.aud, a.aud))
      return !1;
  }
  var m = n.IntDate.getNow();
  return a.verifyAt !== void 0 && typeof a.verifyAt == "number" && (m = a.verifyAt), (a.gracePeriod === void 0 || typeof a.gracePeriod != "number") && (a.gracePeriod = 0), !(v.exp !== void 0 && typeof v.exp == "number" && v.exp + a.gracePeriod < m || v.nbf !== void 0 && typeof v.nbf == "number" && m < v.nbf - a.gracePeriod || v.iat !== void 0 && typeof v.iat == "number" && m < v.iat - a.gracePeriod || v.jti !== void 0 && a.jti !== void 0 && v.jti !== a.jti || !o.verify(u, r, a.alg));
};
KJUR.jws.JWS.includedArray = function(u, r) {
  var a = KJUR.jws.JWS.inArray;
  if (u === null || typeof u != "object" || typeof u.length != "number")
    return !1;
  for (var e = 0; e < u.length; e++)
    if (!a(u[e], r))
      return !1;
  return !0;
};
KJUR.jws.JWS.inArray = function(u, r) {
  if (r === null || typeof r != "object" || typeof r.length != "number")
    return !1;
  for (var a = 0; a < r.length; a++)
    if (r[a] == u)
      return !0;
  return !1;
};
KJUR.jws.JWS.jwsalg2sigalg = { HS256: "HmacSHA256", HS384: "HmacSHA384", HS512: "HmacSHA512", RS256: "SHA256withRSA", RS384: "SHA384withRSA", RS512: "SHA512withRSA", ES256: "SHA256withECDSA", ES384: "SHA384withECDSA", ES512: "SHA512withECDSA", PS256: "SHA256withRSAandMGF1", PS384: "SHA384withRSAandMGF1", PS512: "SHA512withRSAandMGF1", none: "none" };
KJUR.jws.JWS.isSafeJSONString = function(u, r, a) {
  var e = null;
  try {
    return e = jsonParse(u), typeof e != "object" || e.constructor === Array ? 0 : (r && (r[a] = e), 1);
  } catch {
    return 0;
  }
};
KJUR.jws.JWS.readSafeJSONString = function(u) {
  var r = null;
  try {
    return r = jsonParse(u), typeof r != "object" || r.constructor === Array ? null : r;
  } catch {
    return null;
  }
};
KJUR.jws.JWS.getEncodedSignatureValueFromJWS = function(u) {
  var r = u.match(/^[^.]+\.[^.]+\.([^.]+)$/);
  if (r == null)
    throw "JWS signature is not a form of 'Head.Payload.SigValue'.";
  return r[1];
};
KJUR.jws.JWS.getJWKthumbprint = function(u) {
  if (u.kty !== "RSA" && u.kty !== "EC" && u.kty !== "oct")
    throw "unsupported algorithm for JWK Thumprint";
  var r = "{";
  if (u.kty === "RSA") {
    if (typeof u.n != "string" || typeof u.e != "string")
      throw "wrong n and e value for RSA key";
    r += '"e":"' + u.e + '",', r += '"kty":"' + u.kty + '",', r += '"n":"' + u.n + '"}';
  } else if (u.kty === "EC") {
    if (typeof u.crv != "string" || typeof u.x != "string" || typeof u.y != "string")
      throw "wrong crv, x and y value for EC key";
    r += '"crv":"' + u.crv + '",', r += '"kty":"' + u.kty + '",', r += '"x":"' + u.x + '",', r += '"y":"' + u.y + '"}';
  } else if (u.kty === "oct") {
    if (typeof u.k != "string")
      throw "wrong k value for oct(symmetric) key";
    r += '"kty":"' + u.kty + '",', r += '"k":"' + u.k + '"}';
  }
  var a = rstrtohex(r), e = KJUR.crypto.Util.hashHex(a, "sha256"), n = hextob64u(e);
  return n;
};
KJUR.jws.IntDate = {};
KJUR.jws.IntDate.get = function(u) {
  var r = KJUR.jws.IntDate, a = r.getNow, e = r.getZulu;
  if (u == "now")
    return a();
  if (u == "now + 1hour")
    return a() + 60 * 60;
  if (u == "now + 1day")
    return a() + 60 * 60 * 24;
  if (u == "now + 1month")
    return a() + 60 * 60 * 24 * 30;
  if (u == "now + 1year")
    return a() + 60 * 60 * 24 * 365;
  if (u.match(/Z$/))
    return e(u);
  if (u.match(/^[0-9]+$/))
    return parseInt(u);
  throw "unsupported format: " + u;
};
KJUR.jws.IntDate.getZulu = function(u) {
  return zulutosec(u);
};
KJUR.jws.IntDate.getNow = function() {
  var u = ~~(/* @__PURE__ */ new Date() / 1e3);
  return u;
};
KJUR.jws.IntDate.intDate2UTCString = function(u) {
  var r = new Date(u * 1e3);
  return r.toUTCString();
};
KJUR.jws.IntDate.intDate2Zulu = function(u) {
  var r = new Date(u * 1e3), a = ("0000" + r.getUTCFullYear()).slice(-4), e = ("00" + (r.getUTCMonth() + 1)).slice(-2), n = ("00" + r.getUTCDate()).slice(-2), o = ("00" + r.getUTCHours()).slice(-2), c = ("00" + r.getUTCMinutes()).slice(-2), l = ("00" + r.getUTCSeconds()).slice(-2);
  return a + e + n + o + c + l + "Z";
};
(typeof KJUR > "u" || !KJUR) && (KJUR = {});
(typeof KJUR.jws > "u" || !KJUR.jws) && (KJUR.jws = {});
KJUR.jws.JWSJS = function() {
  var u = KJUR, r = u.jws, a = r.JWS, e = a.readSafeJSONString;
  this.aHeader = [], this.sPayload = "", this.aSignature = [], this.init = function() {
    this.aHeader = [], this.sPayload = void 0, this.aSignature = [];
  }, this.initWithJWS = function(n) {
    this.init();
    var o = n.split(".");
    if (o.length != 3)
      throw "malformed input JWS";
    this.aHeader.push(o[0]), this.sPayload = o[1], this.aSignature.push(o[2]);
  }, this.addSignature = function(n, o, c, l) {
    if (this.sPayload === void 0 || this.sPayload === null)
      throw "there's no JSON-JS signature to add.";
    var d = this.aHeader.length;
    if (this.aHeader.length != this.aSignature.length)
      throw "aHeader.length != aSignature.length";
    try {
      var p = KJUR.jws.JWS.sign(n, o, this.sPayload, c, l), h = p.split("."), g = h[0], y = h[2];
      this.aHeader.push(h[0]), this.aSignature.push(h[2]);
    } catch (v) {
      throw this.aHeader.length > d && this.aHeader.pop(), this.aSignature.length > d && this.aSignature.pop(), "addSignature failed: " + v;
    }
  }, this.verifyAll = function(n) {
    if (this.aHeader.length !== n.length || this.aSignature.length !== n.length)
      return !1;
    for (var o = 0; o < n.length; o++) {
      var c = n[o];
      if (c.length !== 2)
        return !1;
      var l = this.verifyNth(o, c[0], c[1]);
      if (l === !1)
        return !1;
    }
    return !0;
  }, this.verifyNth = function(n, o, c) {
    if (this.aHeader.length <= n || this.aSignature.length <= n)
      return !1;
    var l = this.aHeader[n], d = this.aSignature[n], p = l + "." + this.sPayload + "." + d, h = !1;
    try {
      h = a.verify(p, o, c);
    } catch {
      return !1;
    }
    return h;
  }, this.readJWSJS = function(n) {
    if (typeof n == "string") {
      var o = e(n);
      if (o == null)
        throw "argument is not safe JSON object string";
      this.aHeader = o.headers, this.sPayload = o.payload, this.aSignature = o.signatures;
    } else
      try {
        if (n.headers.length > 0)
          this.aHeader = n.headers;
        else
          throw "malformed header";
        if (typeof n.payload == "string")
          this.sPayload = n.payload;
        else
          throw "malformed signatures";
        if (n.signatures.length > 0)
          this.aSignature = n.signatures;
        else
          throw "malformed signatures";
      } catch (c) {
        throw "malformed JWS-JS JSON object: " + c;
      }
  }, this.getJSON = function() {
    return { headers: this.aHeader, payload: this.sPayload, signatures: this.aSignature };
  }, this.isEmpty = function() {
    return this.aHeader.length == 0 ? 1 : 0;
  };
};
KJUR.crypto.ECDSA;
KJUR.crypto.DSA;
KJUR.crypto.Signature;
KJUR.crypto.MessageDigest;
KJUR.crypto.Mac;
var KJUR_1 = KJUR;
KJUR.crypto;
KJUR.asn1;
KJUR.jws;
KJUR.lang;
var forge$C = {
  // default options
  options: {
    usePureJavaScript: !1
  }
}, api = {}, baseN$1 = api, _reverseAlphabets = {};
api.encode = function(u, r, a) {
  if (typeof r != "string")
    throw new TypeError('"alphabet" must be a string.');
  if (a !== void 0 && typeof a != "number")
    throw new TypeError('"maxline" must be a number.');
  var e = "";
  if (!(u instanceof Uint8Array))
    e = _encodeWithByteBuffer(u, r);
  else {
    var n = 0, o = r.length, c = r.charAt(0), l = [0];
    for (n = 0; n < u.length; ++n) {
      for (var d = 0, p = u[n]; d < l.length; ++d)
        p += l[d] << 8, l[d] = p % o, p = p / o | 0;
      for (; p > 0; )
        l.push(p % o), p = p / o | 0;
    }
    for (n = 0; u[n] === 0 && n < u.length - 1; ++n)
      e += c;
    for (n = l.length - 1; n >= 0; --n)
      e += r[l[n]];
  }
  if (a) {
    var h = new RegExp(".{1," + a + "}", "g");
    e = e.match(h).join(`\r
`);
  }
  return e;
};
api.decode = function(u, r) {
  if (typeof u != "string")
    throw new TypeError('"input" must be a string.');
  if (typeof r != "string")
    throw new TypeError('"alphabet" must be a string.');
  var a = _reverseAlphabets[r];
  if (!a) {
    a = _reverseAlphabets[r] = [];
    for (var e = 0; e < r.length; ++e)
      a[r.charCodeAt(e)] = e;
  }
  u = u.replace(/\s/g, "");
  for (var n = r.length, o = r.charAt(0), c = [0], e = 0; e < u.length; e++) {
    var l = a[u.charCodeAt(e)];
    if (l === void 0)
      return;
    for (var d = 0, p = l; d < c.length; ++d)
      p += c[d] * n, c[d] = p & 255, p >>= 8;
    for (; p > 0; )
      c.push(p & 255), p >>= 8;
  }
  for (var h = 0; u[h] === o && h < u.length - 1; ++h)
    c.push(0);
  return typeof Buffer < "u" ? Buffer.from(c.reverse()) : new Uint8Array(c.reverse());
};
function _encodeWithByteBuffer(u, r) {
  var a = 0, e = r.length, n = r.charAt(0), o = [0];
  for (a = 0; a < u.length(); ++a) {
    for (var c = 0, l = u.at(a); c < o.length; ++c)
      l += o[c] << 8, o[c] = l % e, l = l / e | 0;
    for (; l > 0; )
      o.push(l % e), l = l / e | 0;
  }
  var d = "";
  for (a = 0; u.at(a) === 0 && a < u.length() - 1; ++a)
    d += n;
  for (a = o.length - 1; a >= 0; --a)
    d += r[o[a]];
  return d;
}
var forge$B = forge$C, baseN = baseN$1, util$1 = forge$B.util = forge$B.util || {};
(function() {
  if (typeof process < "u" && process.nextTick && !process.browser) {
    util$1.nextTick = process.nextTick, typeof setImmediate == "function" ? util$1.setImmediate = setImmediate : util$1.setImmediate = util$1.nextTick;
    return;
  }
  if (typeof setImmediate == "function") {
    util$1.setImmediate = function() {
      return setImmediate.apply(void 0, arguments);
    }, util$1.nextTick = function(c) {
      return setImmediate(c);
    };
    return;
  }
  if (util$1.setImmediate = function(c) {
    setTimeout(c, 0);
  }, typeof window < "u" && typeof window.postMessage == "function") {
    let c = function(l) {
      if (l.source === window && l.data === u) {
        l.stopPropagation();
        var d = r.slice();
        r.length = 0, d.forEach(function(p) {
          p();
        });
      }
    };
    var u = "forge.setImmediate", r = [];
    util$1.setImmediate = function(l) {
      r.push(l), r.length === 1 && window.postMessage(u, "*");
    }, window.addEventListener("message", c, !0);
  }
  if (typeof MutationObserver < "u") {
    var a = Date.now(), e = !0, n = document.createElement("div"), r = [];
    new MutationObserver(function() {
      var l = r.slice();
      r.length = 0, l.forEach(function(d) {
        d();
      });
    }).observe(n, { attributes: !0 });
    var o = util$1.setImmediate;
    util$1.setImmediate = function(l) {
      Date.now() - a > 15 ? (a = Date.now(), o(l)) : (r.push(l), r.length === 1 && n.setAttribute("a", e = !e));
    };
  }
  util$1.nextTick = util$1.setImmediate;
})();
util$1.isNodejs = typeof process < "u" && process.versions && process.versions.node;
util$1.globalScope = function() {
  return util$1.isNodejs ? commonjsGlobal : typeof self > "u" ? window : self;
}();
util$1.isArray = Array.isArray || function(u) {
  return Object.prototype.toString.call(u) === "[object Array]";
};
util$1.isArrayBuffer = function(u) {
  return typeof ArrayBuffer < "u" && u instanceof ArrayBuffer;
};
util$1.isArrayBufferView = function(u) {
  return u && util$1.isArrayBuffer(u.buffer) && u.byteLength !== void 0;
};
function _checkBitsParam(u) {
  if (!(u === 8 || u === 16 || u === 24 || u === 32))
    throw new Error("Only 8, 16, 24, or 32 bits supported: " + u);
}
util$1.ByteBuffer = ByteStringBuffer;
function ByteStringBuffer(u) {
  if (this.data = "", this.read = 0, typeof u == "string")
    this.data = u;
  else if (util$1.isArrayBuffer(u) || util$1.isArrayBufferView(u))
    if (typeof Buffer < "u" && u instanceof Buffer)
      this.data = u.toString("binary");
    else {
      var r = new Uint8Array(u);
      try {
        this.data = String.fromCharCode.apply(null, r);
      } catch {
        for (var a = 0; a < r.length; ++a)
          this.putByte(r[a]);
      }
    }
  else
    (u instanceof ByteStringBuffer || typeof u == "object" && typeof u.data == "string" && typeof u.read == "number") && (this.data = u.data, this.read = u.read);
  this._constructedStringLength = 0;
}
util$1.ByteStringBuffer = ByteStringBuffer;
var _MAX_CONSTRUCTED_STRING_LENGTH = 4096;
util$1.ByteStringBuffer.prototype._optimizeConstructedString = function(u) {
  this._constructedStringLength += u, this._constructedStringLength > _MAX_CONSTRUCTED_STRING_LENGTH && (this.data.substr(0, 1), this._constructedStringLength = 0);
};
util$1.ByteStringBuffer.prototype.length = function() {
  return this.data.length - this.read;
};
util$1.ByteStringBuffer.prototype.isEmpty = function() {
  return this.length() <= 0;
};
util$1.ByteStringBuffer.prototype.putByte = function(u) {
  return this.putBytes(String.fromCharCode(u));
};
util$1.ByteStringBuffer.prototype.fillWithByte = function(u, r) {
  u = String.fromCharCode(u);
  for (var a = this.data; r > 0; )
    r & 1 && (a += u), r >>>= 1, r > 0 && (u += u);
  return this.data = a, this._optimizeConstructedString(r), this;
};
util$1.ByteStringBuffer.prototype.putBytes = function(u) {
  return this.data += u, this._optimizeConstructedString(u.length), this;
};
util$1.ByteStringBuffer.prototype.putString = function(u) {
  return this.putBytes(util$1.encodeUtf8(u));
};
util$1.ByteStringBuffer.prototype.putInt16 = function(u) {
  return this.putBytes(
    String.fromCharCode(u >> 8 & 255) + String.fromCharCode(u & 255)
  );
};
util$1.ByteStringBuffer.prototype.putInt24 = function(u) {
  return this.putBytes(
    String.fromCharCode(u >> 16 & 255) + String.fromCharCode(u >> 8 & 255) + String.fromCharCode(u & 255)
  );
};
util$1.ByteStringBuffer.prototype.putInt32 = function(u) {
  return this.putBytes(
    String.fromCharCode(u >> 24 & 255) + String.fromCharCode(u >> 16 & 255) + String.fromCharCode(u >> 8 & 255) + String.fromCharCode(u & 255)
  );
};
util$1.ByteStringBuffer.prototype.putInt16Le = function(u) {
  return this.putBytes(
    String.fromCharCode(u & 255) + String.fromCharCode(u >> 8 & 255)
  );
};
util$1.ByteStringBuffer.prototype.putInt24Le = function(u) {
  return this.putBytes(
    String.fromCharCode(u & 255) + String.fromCharCode(u >> 8 & 255) + String.fromCharCode(u >> 16 & 255)
  );
};
util$1.ByteStringBuffer.prototype.putInt32Le = function(u) {
  return this.putBytes(
    String.fromCharCode(u & 255) + String.fromCharCode(u >> 8 & 255) + String.fromCharCode(u >> 16 & 255) + String.fromCharCode(u >> 24 & 255)
  );
};
util$1.ByteStringBuffer.prototype.putInt = function(u, r) {
  _checkBitsParam(r);
  var a = "";
  do
    r -= 8, a += String.fromCharCode(u >> r & 255);
  while (r > 0);
  return this.putBytes(a);
};
util$1.ByteStringBuffer.prototype.putSignedInt = function(u, r) {
  return u < 0 && (u += 2 << r - 1), this.putInt(u, r);
};
util$1.ByteStringBuffer.prototype.putBuffer = function(u) {
  return this.putBytes(u.getBytes());
};
util$1.ByteStringBuffer.prototype.getByte = function() {
  return this.data.charCodeAt(this.read++);
};
util$1.ByteStringBuffer.prototype.getInt16 = function() {
  var u = this.data.charCodeAt(this.read) << 8 ^ this.data.charCodeAt(this.read + 1);
  return this.read += 2, u;
};
util$1.ByteStringBuffer.prototype.getInt24 = function() {
  var u = this.data.charCodeAt(this.read) << 16 ^ this.data.charCodeAt(this.read + 1) << 8 ^ this.data.charCodeAt(this.read + 2);
  return this.read += 3, u;
};
util$1.ByteStringBuffer.prototype.getInt32 = function() {
  var u = this.data.charCodeAt(this.read) << 24 ^ this.data.charCodeAt(this.read + 1) << 16 ^ this.data.charCodeAt(this.read + 2) << 8 ^ this.data.charCodeAt(this.read + 3);
  return this.read += 4, u;
};
util$1.ByteStringBuffer.prototype.getInt16Le = function() {
  var u = this.data.charCodeAt(this.read) ^ this.data.charCodeAt(this.read + 1) << 8;
  return this.read += 2, u;
};
util$1.ByteStringBuffer.prototype.getInt24Le = function() {
  var u = this.data.charCodeAt(this.read) ^ this.data.charCodeAt(this.read + 1) << 8 ^ this.data.charCodeAt(this.read + 2) << 16;
  return this.read += 3, u;
};
util$1.ByteStringBuffer.prototype.getInt32Le = function() {
  var u = this.data.charCodeAt(this.read) ^ this.data.charCodeAt(this.read + 1) << 8 ^ this.data.charCodeAt(this.read + 2) << 16 ^ this.data.charCodeAt(this.read + 3) << 24;
  return this.read += 4, u;
};
util$1.ByteStringBuffer.prototype.getInt = function(u) {
  _checkBitsParam(u);
  var r = 0;
  do
    r = (r << 8) + this.data.charCodeAt(this.read++), u -= 8;
  while (u > 0);
  return r;
};
util$1.ByteStringBuffer.prototype.getSignedInt = function(u) {
  var r = this.getInt(u), a = 2 << u - 2;
  return r >= a && (r -= a << 1), r;
};
util$1.ByteStringBuffer.prototype.getBytes = function(u) {
  var r;
  return u ? (u = Math.min(this.length(), u), r = this.data.slice(this.read, this.read + u), this.read += u) : u === 0 ? r = "" : (r = this.read === 0 ? this.data : this.data.slice(this.read), this.clear()), r;
};
util$1.ByteStringBuffer.prototype.bytes = function(u) {
  return typeof u > "u" ? this.data.slice(this.read) : this.data.slice(this.read, this.read + u);
};
util$1.ByteStringBuffer.prototype.at = function(u) {
  return this.data.charCodeAt(this.read + u);
};
util$1.ByteStringBuffer.prototype.setAt = function(u, r) {
  return this.data = this.data.substr(0, this.read + u) + String.fromCharCode(r) + this.data.substr(this.read + u + 1), this;
};
util$1.ByteStringBuffer.prototype.last = function() {
  return this.data.charCodeAt(this.data.length - 1);
};
util$1.ByteStringBuffer.prototype.copy = function() {
  var u = util$1.createBuffer(this.data);
  return u.read = this.read, u;
};
util$1.ByteStringBuffer.prototype.compact = function() {
  return this.read > 0 && (this.data = this.data.slice(this.read), this.read = 0), this;
};
util$1.ByteStringBuffer.prototype.clear = function() {
  return this.data = "", this.read = 0, this;
};
util$1.ByteStringBuffer.prototype.truncate = function(u) {
  var r = Math.max(0, this.length() - u);
  return this.data = this.data.substr(this.read, r), this.read = 0, this;
};
util$1.ByteStringBuffer.prototype.toHex = function() {
  for (var u = "", r = this.read; r < this.data.length; ++r) {
    var a = this.data.charCodeAt(r);
    a < 16 && (u += "0"), u += a.toString(16);
  }
  return u;
};
util$1.ByteStringBuffer.prototype.toString = function() {
  return util$1.decodeUtf8(this.bytes());
};
function DataBuffer(u, r) {
  r = r || {}, this.read = r.readOffset || 0, this.growSize = r.growSize || 1024;
  var a = util$1.isArrayBuffer(u), e = util$1.isArrayBufferView(u);
  if (a || e) {
    a ? this.data = new DataView(u) : this.data = new DataView(u.buffer, u.byteOffset, u.byteLength), this.write = "writeOffset" in r ? r.writeOffset : this.data.byteLength;
    return;
  }
  this.data = new DataView(new ArrayBuffer(0)), this.write = 0, u != null && this.putBytes(u), "writeOffset" in r && (this.write = r.writeOffset);
}
util$1.DataBuffer = DataBuffer;
util$1.DataBuffer.prototype.length = function() {
  return this.write - this.read;
};
util$1.DataBuffer.prototype.isEmpty = function() {
  return this.length() <= 0;
};
util$1.DataBuffer.prototype.accommodate = function(u, r) {
  if (this.length() >= u)
    return this;
  r = Math.max(r || this.growSize, u);
  var a = new Uint8Array(
    this.data.buffer,
    this.data.byteOffset,
    this.data.byteLength
  ), e = new Uint8Array(this.length() + r);
  return e.set(a), this.data = new DataView(e.buffer), this;
};
util$1.DataBuffer.prototype.putByte = function(u) {
  return this.accommodate(1), this.data.setUint8(this.write++, u), this;
};
util$1.DataBuffer.prototype.fillWithByte = function(u, r) {
  this.accommodate(r);
  for (var a = 0; a < r; ++a)
    this.data.setUint8(u);
  return this;
};
util$1.DataBuffer.prototype.putBytes = function(u, r) {
  if (util$1.isArrayBufferView(u)) {
    var a = new Uint8Array(u.buffer, u.byteOffset, u.byteLength), e = a.byteLength - a.byteOffset;
    this.accommodate(e);
    var n = new Uint8Array(this.data.buffer, this.write);
    return n.set(a), this.write += e, this;
  }
  if (util$1.isArrayBuffer(u)) {
    var a = new Uint8Array(u);
    this.accommodate(a.byteLength);
    var n = new Uint8Array(this.data.buffer);
    return n.set(a, this.write), this.write += a.byteLength, this;
  }
  if (u instanceof util$1.DataBuffer || typeof u == "object" && typeof u.read == "number" && typeof u.write == "number" && util$1.isArrayBufferView(u.data)) {
    var a = new Uint8Array(u.data.byteLength, u.read, u.length());
    this.accommodate(a.byteLength);
    var n = new Uint8Array(u.data.byteLength, this.write);
    return n.set(a), this.write += a.byteLength, this;
  }
  if (u instanceof util$1.ByteStringBuffer && (u = u.data, r = "binary"), r = r || "binary", typeof u == "string") {
    var o;
    if (r === "hex")
      return this.accommodate(Math.ceil(u.length / 2)), o = new Uint8Array(this.data.buffer, this.write), this.write += util$1.binary.hex.decode(u, o, this.write), this;
    if (r === "base64")
      return this.accommodate(Math.ceil(u.length / 4) * 3), o = new Uint8Array(this.data.buffer, this.write), this.write += util$1.binary.base64.decode(u, o, this.write), this;
    if (r === "utf8" && (u = util$1.encodeUtf8(u), r = "binary"), r === "binary" || r === "raw")
      return this.accommodate(u.length), o = new Uint8Array(this.data.buffer, this.write), this.write += util$1.binary.raw.decode(o), this;
    if (r === "utf16")
      return this.accommodate(u.length * 2), o = new Uint16Array(this.data.buffer, this.write), this.write += util$1.text.utf16.encode(o), this;
    throw new Error("Invalid encoding: " + r);
  }
  throw Error("Invalid parameter: " + u);
};
util$1.DataBuffer.prototype.putBuffer = function(u) {
  return this.putBytes(u), u.clear(), this;
};
util$1.DataBuffer.prototype.putString = function(u) {
  return this.putBytes(u, "utf16");
};
util$1.DataBuffer.prototype.putInt16 = function(u) {
  return this.accommodate(2), this.data.setInt16(this.write, u), this.write += 2, this;
};
util$1.DataBuffer.prototype.putInt24 = function(u) {
  return this.accommodate(3), this.data.setInt16(this.write, u >> 8 & 65535), this.data.setInt8(this.write, u >> 16 & 255), this.write += 3, this;
};
util$1.DataBuffer.prototype.putInt32 = function(u) {
  return this.accommodate(4), this.data.setInt32(this.write, u), this.write += 4, this;
};
util$1.DataBuffer.prototype.putInt16Le = function(u) {
  return this.accommodate(2), this.data.setInt16(this.write, u, !0), this.write += 2, this;
};
util$1.DataBuffer.prototype.putInt24Le = function(u) {
  return this.accommodate(3), this.data.setInt8(this.write, u >> 16 & 255), this.data.setInt16(this.write, u >> 8 & 65535, !0), this.write += 3, this;
};
util$1.DataBuffer.prototype.putInt32Le = function(u) {
  return this.accommodate(4), this.data.setInt32(this.write, u, !0), this.write += 4, this;
};
util$1.DataBuffer.prototype.putInt = function(u, r) {
  _checkBitsParam(r), this.accommodate(r / 8);
  do
    r -= 8, this.data.setInt8(this.write++, u >> r & 255);
  while (r > 0);
  return this;
};
util$1.DataBuffer.prototype.putSignedInt = function(u, r) {
  return _checkBitsParam(r), this.accommodate(r / 8), u < 0 && (u += 2 << r - 1), this.putInt(u, r);
};
util$1.DataBuffer.prototype.getByte = function() {
  return this.data.getInt8(this.read++);
};
util$1.DataBuffer.prototype.getInt16 = function() {
  var u = this.data.getInt16(this.read);
  return this.read += 2, u;
};
util$1.DataBuffer.prototype.getInt24 = function() {
  var u = this.data.getInt16(this.read) << 8 ^ this.data.getInt8(this.read + 2);
  return this.read += 3, u;
};
util$1.DataBuffer.prototype.getInt32 = function() {
  var u = this.data.getInt32(this.read);
  return this.read += 4, u;
};
util$1.DataBuffer.prototype.getInt16Le = function() {
  var u = this.data.getInt16(this.read, !0);
  return this.read += 2, u;
};
util$1.DataBuffer.prototype.getInt24Le = function() {
  var u = this.data.getInt8(this.read) ^ this.data.getInt16(this.read + 1, !0) << 8;
  return this.read += 3, u;
};
util$1.DataBuffer.prototype.getInt32Le = function() {
  var u = this.data.getInt32(this.read, !0);
  return this.read += 4, u;
};
util$1.DataBuffer.prototype.getInt = function(u) {
  _checkBitsParam(u);
  var r = 0;
  do
    r = (r << 8) + this.data.getInt8(this.read++), u -= 8;
  while (u > 0);
  return r;
};
util$1.DataBuffer.prototype.getSignedInt = function(u) {
  var r = this.getInt(u), a = 2 << u - 2;
  return r >= a && (r -= a << 1), r;
};
util$1.DataBuffer.prototype.getBytes = function(u) {
  var r;
  return u ? (u = Math.min(this.length(), u), r = this.data.slice(this.read, this.read + u), this.read += u) : u === 0 ? r = "" : (r = this.read === 0 ? this.data : this.data.slice(this.read), this.clear()), r;
};
util$1.DataBuffer.prototype.bytes = function(u) {
  return typeof u > "u" ? this.data.slice(this.read) : this.data.slice(this.read, this.read + u);
};
util$1.DataBuffer.prototype.at = function(u) {
  return this.data.getUint8(this.read + u);
};
util$1.DataBuffer.prototype.setAt = function(u, r) {
  return this.data.setUint8(u, r), this;
};
util$1.DataBuffer.prototype.last = function() {
  return this.data.getUint8(this.write - 1);
};
util$1.DataBuffer.prototype.copy = function() {
  return new util$1.DataBuffer(this);
};
util$1.DataBuffer.prototype.compact = function() {
  if (this.read > 0) {
    var u = new Uint8Array(this.data.buffer, this.read), r = new Uint8Array(u.byteLength);
    r.set(u), this.data = new DataView(r), this.write -= this.read, this.read = 0;
  }
  return this;
};
util$1.DataBuffer.prototype.clear = function() {
  return this.data = new DataView(new ArrayBuffer(0)), this.read = this.write = 0, this;
};
util$1.DataBuffer.prototype.truncate = function(u) {
  return this.write = Math.max(0, this.length() - u), this.read = Math.min(this.read, this.write), this;
};
util$1.DataBuffer.prototype.toHex = function() {
  for (var u = "", r = this.read; r < this.data.byteLength; ++r) {
    var a = this.data.getUint8(r);
    a < 16 && (u += "0"), u += a.toString(16);
  }
  return u;
};
util$1.DataBuffer.prototype.toString = function(u) {
  var r = new Uint8Array(this.data, this.read, this.length());
  if (u = u || "utf8", u === "binary" || u === "raw")
    return util$1.binary.raw.encode(r);
  if (u === "hex")
    return util$1.binary.hex.encode(r);
  if (u === "base64")
    return util$1.binary.base64.encode(r);
  if (u === "utf8")
    return util$1.text.utf8.decode(r);
  if (u === "utf16")
    return util$1.text.utf16.decode(r);
  throw new Error("Invalid encoding: " + u);
};
util$1.createBuffer = function(u, r) {
  return r = r || "raw", u !== void 0 && r === "utf8" && (u = util$1.encodeUtf8(u)), new util$1.ByteBuffer(u);
};
util$1.fillString = function(u, r) {
  for (var a = ""; r > 0; )
    r & 1 && (a += u), r >>>= 1, r > 0 && (u += u);
  return a;
};
util$1.xorBytes = function(u, r, a) {
  for (var e = "", n = "", o = "", c = 0, l = 0; a > 0; --a, ++c)
    n = u.charCodeAt(c) ^ r.charCodeAt(c), l >= 10 && (e += o, o = "", l = 0), o += String.fromCharCode(n), ++l;
  return e += o, e;
};
util$1.hexToBytes = function(u) {
  var r = "", a = 0;
  for (u.length & !0 && (a = 1, r += String.fromCharCode(parseInt(u[0], 16))); a < u.length; a += 2)
    r += String.fromCharCode(parseInt(u.substr(a, 2), 16));
  return r;
};
util$1.bytesToHex = function(u) {
  return util$1.createBuffer(u).toHex();
};
util$1.int32ToBytes = function(u) {
  return String.fromCharCode(u >> 24 & 255) + String.fromCharCode(u >> 16 & 255) + String.fromCharCode(u >> 8 & 255) + String.fromCharCode(u & 255);
};
var _base64 = "ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789+/=", _base64Idx = [
  /*43 -43 = 0*/
  /*'+',  1,  2,  3,'/' */
  62,
  -1,
  -1,
  -1,
  63,
  /*'0','1','2','3','4','5','6','7','8','9' */
  52,
  53,
  54,
  55,
  56,
  57,
  58,
  59,
  60,
  61,
  /*15, 16, 17,'=', 19, 20, 21 */
  -1,
  -1,
  -1,
  64,
  -1,
  -1,
  -1,
  /*65 - 43 = 22*/
  /*'A','B','C','D','E','F','G','H','I','J','K','L','M', */
  0,
  1,
  2,
  3,
  4,
  5,
  6,
  7,
  8,
  9,
  10,
  11,
  12,
  /*'N','O','P','Q','R','S','T','U','V','W','X','Y','Z' */
  13,
  14,
  15,
  16,
  17,
  18,
  19,
  20,
  21,
  22,
  23,
  24,
  25,
  /*91 - 43 = 48 */
  /*48, 49, 50, 51, 52, 53 */
  -1,
  -1,
  -1,
  -1,
  -1,
  -1,
  /*97 - 43 = 54*/
  /*'a','b','c','d','e','f','g','h','i','j','k','l','m' */
  26,
  27,
  28,
  29,
  30,
  31,
  32,
  33,
  34,
  35,
  36,
  37,
  38,
  /*'n','o','p','q','r','s','t','u','v','w','x','y','z' */
  39,
  40,
  41,
  42,
  43,
  44,
  45,
  46,
  47,
  48,
  49,
  50,
  51
], _base58 = "123456789ABCDEFGHJKLMNPQRSTUVWXYZabcdefghijkmnopqrstuvwxyz";
util$1.encode64 = function(u, r) {
  for (var a = "", e = "", n, o, c, l = 0; l < u.length; )
    n = u.charCodeAt(l++), o = u.charCodeAt(l++), c = u.charCodeAt(l++), a += _base64.charAt(n >> 2), a += _base64.charAt((n & 3) << 4 | o >> 4), isNaN(o) ? a += "==" : (a += _base64.charAt((o & 15) << 2 | c >> 6), a += isNaN(c) ? "=" : _base64.charAt(c & 63)), r && a.length > r && (e += a.substr(0, r) + `\r
`, a = a.substr(r));
  return e += a, e;
};
util$1.decode64 = function(u) {
  u = u.replace(/[^A-Za-z0-9\+\/\=]/g, "");
  for (var r = "", a, e, n, o, c = 0; c < u.length; )
    a = _base64Idx[u.charCodeAt(c++) - 43], e = _base64Idx[u.charCodeAt(c++) - 43], n = _base64Idx[u.charCodeAt(c++) - 43], o = _base64Idx[u.charCodeAt(c++) - 43], r += String.fromCharCode(a << 2 | e >> 4), n !== 64 && (r += String.fromCharCode((e & 15) << 4 | n >> 2), o !== 64 && (r += String.fromCharCode((n & 3) << 6 | o)));
  return r;
};
util$1.encodeUtf8 = function(u) {
  return unescape(encodeURIComponent(u));
};
util$1.decodeUtf8 = function(u) {
  return decodeURIComponent(escape(u));
};
util$1.binary = {
  raw: {},
  hex: {},
  base64: {},
  base58: {},
  baseN: {
    encode: baseN.encode,
    decode: baseN.decode
  }
};
util$1.binary.raw.encode = function(u) {
  return String.fromCharCode.apply(null, u);
};
util$1.binary.raw.decode = function(u, r, a) {
  var e = r;
  e || (e = new Uint8Array(u.length)), a = a || 0;
  for (var n = a, o = 0; o < u.length; ++o)
    e[n++] = u.charCodeAt(o);
  return r ? n - a : e;
};
util$1.binary.hex.encode = util$1.bytesToHex;
util$1.binary.hex.decode = function(u, r, a) {
  var e = r;
  e || (e = new Uint8Array(Math.ceil(u.length / 2))), a = a || 0;
  var n = 0, o = a;
  for (u.length & 1 && (n = 1, e[o++] = parseInt(u[0], 16)); n < u.length; n += 2)
    e[o++] = parseInt(u.substr(n, 2), 16);
  return r ? o - a : e;
};
util$1.binary.base64.encode = function(u, r) {
  for (var a = "", e = "", n, o, c, l = 0; l < u.byteLength; )
    n = u[l++], o = u[l++], c = u[l++], a += _base64.charAt(n >> 2), a += _base64.charAt((n & 3) << 4 | o >> 4), isNaN(o) ? a += "==" : (a += _base64.charAt((o & 15) << 2 | c >> 6), a += isNaN(c) ? "=" : _base64.charAt(c & 63)), r && a.length > r && (e += a.substr(0, r) + `\r
`, a = a.substr(r));
  return e += a, e;
};
util$1.binary.base64.decode = function(u, r, a) {
  var e = r;
  e || (e = new Uint8Array(Math.ceil(u.length / 4) * 3)), u = u.replace(/[^A-Za-z0-9\+\/\=]/g, ""), a = a || 0;
  for (var n, o, c, l, d = 0, p = a; d < u.length; )
    n = _base64Idx[u.charCodeAt(d++) - 43], o = _base64Idx[u.charCodeAt(d++) - 43], c = _base64Idx[u.charCodeAt(d++) - 43], l = _base64Idx[u.charCodeAt(d++) - 43], e[p++] = n << 2 | o >> 4, c !== 64 && (e[p++] = (o & 15) << 4 | c >> 2, l !== 64 && (e[p++] = (c & 3) << 6 | l));
  return r ? p - a : e.subarray(0, p);
};
util$1.binary.base58.encode = function(u, r) {
  return util$1.binary.baseN.encode(u, _base58, r);
};
util$1.binary.base58.decode = function(u, r) {
  return util$1.binary.baseN.decode(u, _base58, r);
};
util$1.text = {
  utf8: {},
  utf16: {}
};
util$1.text.utf8.encode = function(u, r, a) {
  u = util$1.encodeUtf8(u);
  var e = r;
  e || (e = new Uint8Array(u.length)), a = a || 0;
  for (var n = a, o = 0; o < u.length; ++o)
    e[n++] = u.charCodeAt(o);
  return r ? n - a : e;
};
util$1.text.utf8.decode = function(u) {
  return util$1.decodeUtf8(String.fromCharCode.apply(null, u));
};
util$1.text.utf16.encode = function(u, r, a) {
  var e = r;
  e || (e = new Uint8Array(u.length * 2));
  var n = new Uint16Array(e.buffer);
  a = a || 0;
  for (var o = a, c = a, l = 0; l < u.length; ++l)
    n[c++] = u.charCodeAt(l), o += 2;
  return r ? o - a : e;
};
util$1.text.utf16.decode = function(u) {
  return String.fromCharCode.apply(null, new Uint16Array(u.buffer));
};
util$1.deflate = function(u, r, a) {
  if (r = util$1.decode64(u.deflate(util$1.encode64(r)).rval), a) {
    var e = 2, n = r.charCodeAt(1);
    n & 32 && (e = 6), r = r.substring(e, r.length - 4);
  }
  return r;
};
util$1.inflate = function(u, r, a) {
  var e = u.inflate(util$1.encode64(r)).rval;
  return e === null ? null : util$1.decode64(e);
};
var _setStorageObject = function(u, r, a) {
  if (!u)
    throw new Error("WebStorage not available.");
  var e;
  if (a === null ? e = u.removeItem(r) : (a = util$1.encode64(JSON.stringify(a)), e = u.setItem(r, a)), typeof e < "u" && e.rval !== !0) {
    var n = new Error(e.error.message);
    throw n.id = e.error.id, n.name = e.error.name, n;
  }
}, _getStorageObject = function(u, r) {
  if (!u)
    throw new Error("WebStorage not available.");
  var a = u.getItem(r);
  if (u.init)
    if (a.rval === null) {
      if (a.error) {
        var e = new Error(a.error.message);
        throw e.id = a.error.id, e.name = a.error.name, e;
      }
      a = null;
    } else
      a = a.rval;
  return a !== null && (a = JSON.parse(util$1.decode64(a))), a;
}, _setItem = function(u, r, a, e) {
  var n = _getStorageObject(u, r);
  n === null && (n = {}), n[a] = e, _setStorageObject(u, r, n);
}, _getItem = function(u, r, a) {
  var e = _getStorageObject(u, r);
  return e !== null && (e = a in e ? e[a] : null), e;
}, _removeItem = function(u, r, a) {
  var e = _getStorageObject(u, r);
  if (e !== null && a in e) {
    delete e[a];
    var n = !0;
    for (var o in e) {
      n = !1;
      break;
    }
    n && (e = null), _setStorageObject(u, r, e);
  }
}, _clearItems = function(u, r) {
  _setStorageObject(u, r, null);
}, _callStorageFunction = function(u, r, a) {
  var e = null;
  typeof a > "u" && (a = ["web", "flash"]);
  var n, o = !1, c = null;
  for (var l in a) {
    n = a[l];
    try {
      if (n === "flash" || n === "both") {
        if (r[0] === null)
          throw new Error("Flash local storage not available.");
        e = u.apply(this, r), o = n === "flash";
      }
      (n === "web" || n === "both") && (r[0] = localStorage, e = u.apply(this, r), o = !0);
    } catch (d) {
      c = d;
    }
    if (o)
      break;
  }
  if (!o)
    throw c;
  return e;
};
util$1.setItem = function(u, r, a, e, n) {
  _callStorageFunction(_setItem, arguments, n);
};
util$1.getItem = function(u, r, a, e) {
  return _callStorageFunction(_getItem, arguments, e);
};
util$1.removeItem = function(u, r, a, e) {
  _callStorageFunction(_removeItem, arguments, e);
};
util$1.clearItems = function(u, r, a) {
  _callStorageFunction(_clearItems, arguments, a);
};
util$1.isEmpty = function(u) {
  for (var r in u)
    if (u.hasOwnProperty(r))
      return !1;
  return !0;
};
util$1.format = function(u) {
  for (var r = /%./g, a, e, n = 0, o = [], c = 0; a = r.exec(u); ) {
    e = u.substring(c, r.lastIndex - 2), e.length > 0 && o.push(e), c = r.lastIndex;
    var l = a[0][1];
    switch (l) {
      case "s":
      case "o":
        n < arguments.length ? o.push(arguments[n++ + 1]) : o.push("<?>");
        break;
      case "%":
        o.push("%");
        break;
      default:
        o.push("<%" + l + "?>");
    }
  }
  return o.push(u.substring(c)), o.join("");
};
util$1.formatNumber = function(u, r, a, e) {
  var n = u, o = isNaN(r = Math.abs(r)) ? 2 : r, c = a === void 0 ? "," : a, l = e === void 0 ? "." : e, d = n < 0 ? "-" : "", p = parseInt(n = Math.abs(+n || 0).toFixed(o), 10) + "", h = p.length > 3 ? p.length % 3 : 0;
  return d + (h ? p.substr(0, h) + l : "") + p.substr(h).replace(/(\d{3})(?=\d)/g, "$1" + l) + (o ? c + Math.abs(n - p).toFixed(o).slice(2) : "");
};
util$1.formatSize = function(u) {
  return u >= 1073741824 ? u = util$1.formatNumber(u / 1073741824, 2, ".", "") + " GiB" : u >= 1048576 ? u = util$1.formatNumber(u / 1048576, 2, ".", "") + " MiB" : u >= 1024 ? u = util$1.formatNumber(u / 1024, 0) + " KiB" : u = util$1.formatNumber(u, 0) + " bytes", u;
};
util$1.bytesFromIP = function(u) {
  return u.indexOf(".") !== -1 ? util$1.bytesFromIPv4(u) : u.indexOf(":") !== -1 ? util$1.bytesFromIPv6(u) : null;
};
util$1.bytesFromIPv4 = function(u) {
  if (u = u.split("."), u.length !== 4)
    return null;
  for (var r = util$1.createBuffer(), a = 0; a < u.length; ++a) {
    var e = parseInt(u[a], 10);
    if (isNaN(e))
      return null;
    r.putByte(e);
  }
  return r.getBytes();
};
util$1.bytesFromIPv6 = function(u) {
  var r = 0;
  u = u.split(":").filter(function(c) {
    return c.length === 0 && ++r, !0;
  });
  for (var a = (8 - u.length + r) * 2, e = util$1.createBuffer(), n = 0; n < 8; ++n) {
    if (!u[n] || u[n].length === 0) {
      e.fillWithByte(0, a), a = 0;
      continue;
    }
    var o = util$1.hexToBytes(u[n]);
    o.length < 2 && e.putByte(0), e.putBytes(o);
  }
  return e.getBytes();
};
util$1.bytesToIP = function(u) {
  return u.length === 4 ? util$1.bytesToIPv4(u) : u.length === 16 ? util$1.bytesToIPv6(u) : null;
};
util$1.bytesToIPv4 = function(u) {
  if (u.length !== 4)
    return null;
  for (var r = [], a = 0; a < u.length; ++a)
    r.push(u.charCodeAt(a));
  return r.join(".");
};
util$1.bytesToIPv6 = function(u) {
  if (u.length !== 16)
    return null;
  for (var r = [], a = [], e = 0, n = 0; n < u.length; n += 2) {
    for (var o = util$1.bytesToHex(u[n] + u[n + 1]); o[0] === "0" && o !== "0"; )
      o = o.substr(1);
    if (o === "0") {
      var c = a[a.length - 1], l = r.length;
      !c || l !== c.end + 1 ? a.push({ start: l, end: l }) : (c.end = l, c.end - c.start > a[e].end - a[e].start && (e = a.length - 1));
    }
    r.push(o);
  }
  if (a.length > 0) {
    var d = a[e];
    d.end - d.start > 0 && (r.splice(d.start, d.end - d.start + 1, ""), d.start === 0 && r.unshift(""), d.end === 7 && r.push(""));
  }
  return r.join(":");
};
util$1.estimateCores = function(u, r) {
  if (typeof u == "function" && (r = u, u = {}), u = u || {}, "cores" in util$1 && !u.update)
    return r(null, util$1.cores);
  if (typeof navigator < "u" && "hardwareConcurrency" in navigator && navigator.hardwareConcurrency > 0)
    return util$1.cores = navigator.hardwareConcurrency, r(null, util$1.cores);
  if (typeof Worker > "u")
    return util$1.cores = 1, r(null, util$1.cores);
  if (typeof Blob > "u")
    return util$1.cores = 2, r(null, util$1.cores);
  var a = URL.createObjectURL(new Blob([
    "(",
    function() {
      self.addEventListener("message", function(c) {
        var l = Date.now(), d = l + 4;
        self.postMessage({ st: l, et: d });
      });
    }.toString(),
    ")()"
  ], { type: "application/javascript" }));
  e([], 5, 16);
  function e(c, l, d) {
    if (l === 0) {
      var p = Math.floor(c.reduce(function(h, g) {
        return h + g;
      }, 0) / c.length);
      return util$1.cores = Math.max(1, p), URL.revokeObjectURL(a), r(null, util$1.cores);
    }
    n(d, function(h, g) {
      c.push(o(d, g)), e(c, l - 1, d);
    });
  }
  function n(c, l) {
    for (var d = [], p = [], h = 0; h < c; ++h) {
      var g = new Worker(a);
      g.addEventListener("message", function(y) {
        if (p.push(y.data), p.length === c) {
          for (var v = 0; v < c; ++v)
            d[v].terminate();
          l(null, p);
        }
      }), d.push(g);
    }
    for (var h = 0; h < c; ++h)
      d[h].postMessage(h);
  }
  function o(c, l) {
    for (var d = [], p = 0; p < c; ++p)
      for (var h = l[p], g = d[p] = [], y = 0; y < c; ++y)
        if (p !== y) {
          var v = l[y];
          (h.st > v.st && h.st < v.et || v.st > h.st && v.st < h.et) && g.push(y);
        }
    return d.reduce(function(m, b) {
      return Math.max(m, b.length);
    }, 0);
  }
};
var forge$A = forge$C;
forge$A.cipher = forge$A.cipher || {};
forge$A.cipher.algorithms = forge$A.cipher.algorithms || {};
forge$A.cipher.createCipher = function(u, r) {
  var a = u;
  if (typeof a == "string" && (a = forge$A.cipher.getAlgorithm(a), a && (a = a())), !a)
    throw new Error("Unsupported algorithm: " + u);
  return new forge$A.cipher.BlockCipher({
    algorithm: a,
    key: r,
    decrypt: !1
  });
};
forge$A.cipher.createDecipher = function(u, r) {
  var a = u;
  if (typeof a == "string" && (a = forge$A.cipher.getAlgorithm(a), a && (a = a())), !a)
    throw new Error("Unsupported algorithm: " + u);
  return new forge$A.cipher.BlockCipher({
    algorithm: a,
    key: r,
    decrypt: !0
  });
};
forge$A.cipher.registerAlgorithm = function(u, r) {
  u = u.toUpperCase(), forge$A.cipher.algorithms[u] = r;
};
forge$A.cipher.getAlgorithm = function(u) {
  return u = u.toUpperCase(), u in forge$A.cipher.algorithms ? forge$A.cipher.algorithms[u] : null;
};
var BlockCipher = forge$A.cipher.BlockCipher = function(u) {
  this.algorithm = u.algorithm, this.mode = this.algorithm.mode, this.blockSize = this.mode.blockSize, this._finish = !1, this._input = null, this.output = null, this._op = u.decrypt ? this.mode.decrypt : this.mode.encrypt, this._decrypt = u.decrypt, this.algorithm.initialize(u);
};
BlockCipher.prototype.start = function(u) {
  u = u || {};
  var r = {};
  for (var a in u)
    r[a] = u[a];
  r.decrypt = this._decrypt, this._finish = !1, this._input = forge$A.util.createBuffer(), this.output = u.output || forge$A.util.createBuffer(), this.mode.start(r);
};
BlockCipher.prototype.update = function(u) {
  for (u && this._input.putBuffer(u); !this._op.call(this.mode, this._input, this.output, this._finish) && !this._finish; )
    ;
  this._input.compact();
};
BlockCipher.prototype.finish = function(u) {
  u && (this.mode.name === "ECB" || this.mode.name === "CBC") && (this.mode.pad = function(a) {
    return u(this.blockSize, a, !1);
  }, this.mode.unpad = function(a) {
    return u(this.blockSize, a, !0);
  });
  var r = {};
  return r.decrypt = this._decrypt, r.overflow = this._input.length() % this.blockSize, !(!this._decrypt && this.mode.pad && !this.mode.pad(this._input, r) || (this._finish = !0, this.update(), this._decrypt && this.mode.unpad && !this.mode.unpad(this.output, r)) || this.mode.afterFinish && !this.mode.afterFinish(this.output, r));
};
var forge$z = forge$C;
forge$z.cipher = forge$z.cipher || {};
var modes = forge$z.cipher.modes = forge$z.cipher.modes || {};
modes.ecb = function(u) {
  u = u || {}, this.name = "ECB", this.cipher = u.cipher, this.blockSize = u.blockSize || 16, this._ints = this.blockSize / 4, this._inBlock = new Array(this._ints), this._outBlock = new Array(this._ints);
};
modes.ecb.prototype.start = function(u) {
};
modes.ecb.prototype.encrypt = function(u, r, a) {
  if (u.length() < this.blockSize && !(a && u.length() > 0))
    return !0;
  for (var e = 0; e < this._ints; ++e)
    this._inBlock[e] = u.getInt32();
  this.cipher.encrypt(this._inBlock, this._outBlock);
  for (var e = 0; e < this._ints; ++e)
    r.putInt32(this._outBlock[e]);
};
modes.ecb.prototype.decrypt = function(u, r, a) {
  if (u.length() < this.blockSize && !(a && u.length() > 0))
    return !0;
  for (var e = 0; e < this._ints; ++e)
    this._inBlock[e] = u.getInt32();
  this.cipher.decrypt(this._inBlock, this._outBlock);
  for (var e = 0; e < this._ints; ++e)
    r.putInt32(this._outBlock[e]);
};
modes.ecb.prototype.pad = function(u, r) {
  var a = u.length() === this.blockSize ? this.blockSize : this.blockSize - u.length();
  return u.fillWithByte(a, a), !0;
};
modes.ecb.prototype.unpad = function(u, r) {
  if (r.overflow > 0)
    return !1;
  var a = u.length(), e = u.at(a - 1);
  return e > this.blockSize << 2 ? !1 : (u.truncate(e), !0);
};
modes.cbc = function(u) {
  u = u || {}, this.name = "CBC", this.cipher = u.cipher, this.blockSize = u.blockSize || 16, this._ints = this.blockSize / 4, this._inBlock = new Array(this._ints), this._outBlock = new Array(this._ints);
};
modes.cbc.prototype.start = function(u) {
  if (u.iv === null) {
    if (!this._prev)
      throw new Error("Invalid IV parameter.");
    this._iv = this._prev.slice(0);
  } else if ("iv" in u)
    this._iv = transformIV(u.iv, this.blockSize), this._prev = this._iv.slice(0);
  else
    throw new Error("Invalid IV parameter.");
};
modes.cbc.prototype.encrypt = function(u, r, a) {
  if (u.length() < this.blockSize && !(a && u.length() > 0))
    return !0;
  for (var e = 0; e < this._ints; ++e)
    this._inBlock[e] = this._prev[e] ^ u.getInt32();
  this.cipher.encrypt(this._inBlock, this._outBlock);
  for (var e = 0; e < this._ints; ++e)
    r.putInt32(this._outBlock[e]);
  this._prev = this._outBlock;
};
modes.cbc.prototype.decrypt = function(u, r, a) {
  if (u.length() < this.blockSize && !(a && u.length() > 0))
    return !0;
  for (var e = 0; e < this._ints; ++e)
    this._inBlock[e] = u.getInt32();
  this.cipher.decrypt(this._inBlock, this._outBlock);
  for (var e = 0; e < this._ints; ++e)
    r.putInt32(this._prev[e] ^ this._outBlock[e]);
  this._prev = this._inBlock.slice(0);
};
modes.cbc.prototype.pad = function(u, r) {
  var a = u.length() === this.blockSize ? this.blockSize : this.blockSize - u.length();
  return u.fillWithByte(a, a), !0;
};
modes.cbc.prototype.unpad = function(u, r) {
  if (r.overflow > 0)
    return !1;
  var a = u.length(), e = u.at(a - 1);
  return e > this.blockSize << 2 ? !1 : (u.truncate(e), !0);
};
modes.cfb = function(u) {
  u = u || {}, this.name = "CFB", this.cipher = u.cipher, this.blockSize = u.blockSize || 16, this._ints = this.blockSize / 4, this._inBlock = null, this._outBlock = new Array(this._ints), this._partialBlock = new Array(this._ints), this._partialOutput = forge$z.util.createBuffer(), this._partialBytes = 0;
};
modes.cfb.prototype.start = function(u) {
  if (!("iv" in u))
    throw new Error("Invalid IV parameter.");
  this._iv = transformIV(u.iv, this.blockSize), this._inBlock = this._iv.slice(0), this._partialBytes = 0;
};
modes.cfb.prototype.encrypt = function(u, r, a) {
  var e = u.length();
  if (e === 0)
    return !0;
  if (this.cipher.encrypt(this._inBlock, this._outBlock), this._partialBytes === 0 && e >= this.blockSize) {
    for (var n = 0; n < this._ints; ++n)
      this._inBlock[n] = u.getInt32() ^ this._outBlock[n], r.putInt32(this._inBlock[n]);
    return;
  }
  var o = (this.blockSize - e) % this.blockSize;
  o > 0 && (o = this.blockSize - o), this._partialOutput.clear();
  for (var n = 0; n < this._ints; ++n)
    this._partialBlock[n] = u.getInt32() ^ this._outBlock[n], this._partialOutput.putInt32(this._partialBlock[n]);
  if (o > 0)
    u.read -= this.blockSize;
  else
    for (var n = 0; n < this._ints; ++n)
      this._inBlock[n] = this._partialBlock[n];
  if (this._partialBytes > 0 && this._partialOutput.getBytes(this._partialBytes), o > 0 && !a)
    return r.putBytes(this._partialOutput.getBytes(
      o - this._partialBytes
    )), this._partialBytes = o, !0;
  r.putBytes(this._partialOutput.getBytes(
    e - this._partialBytes
  )), this._partialBytes = 0;
};
modes.cfb.prototype.decrypt = function(u, r, a) {
  var e = u.length();
  if (e === 0)
    return !0;
  if (this.cipher.encrypt(this._inBlock, this._outBlock), this._partialBytes === 0 && e >= this.blockSize) {
    for (var n = 0; n < this._ints; ++n)
      this._inBlock[n] = u.getInt32(), r.putInt32(this._inBlock[n] ^ this._outBlock[n]);
    return;
  }
  var o = (this.blockSize - e) % this.blockSize;
  o > 0 && (o = this.blockSize - o), this._partialOutput.clear();
  for (var n = 0; n < this._ints; ++n)
    this._partialBlock[n] = u.getInt32(), this._partialOutput.putInt32(this._partialBlock[n] ^ this._outBlock[n]);
  if (o > 0)
    u.read -= this.blockSize;
  else
    for (var n = 0; n < this._ints; ++n)
      this._inBlock[n] = this._partialBlock[n];
  if (this._partialBytes > 0 && this._partialOutput.getBytes(this._partialBytes), o > 0 && !a)
    return r.putBytes(this._partialOutput.getBytes(
      o - this._partialBytes
    )), this._partialBytes = o, !0;
  r.putBytes(this._partialOutput.getBytes(
    e - this._partialBytes
  )), this._partialBytes = 0;
};
modes.ofb = function(u) {
  u = u || {}, this.name = "OFB", this.cipher = u.cipher, this.blockSize = u.blockSize || 16, this._ints = this.blockSize / 4, this._inBlock = null, this._outBlock = new Array(this._ints), this._partialOutput = forge$z.util.createBuffer(), this._partialBytes = 0;
};
modes.ofb.prototype.start = function(u) {
  if (!("iv" in u))
    throw new Error("Invalid IV parameter.");
  this._iv = transformIV(u.iv, this.blockSize), this._inBlock = this._iv.slice(0), this._partialBytes = 0;
};
modes.ofb.prototype.encrypt = function(u, r, a) {
  var e = u.length();
  if (u.length() === 0)
    return !0;
  if (this.cipher.encrypt(this._inBlock, this._outBlock), this._partialBytes === 0 && e >= this.blockSize) {
    for (var n = 0; n < this._ints; ++n)
      r.putInt32(u.getInt32() ^ this._outBlock[n]), this._inBlock[n] = this._outBlock[n];
    return;
  }
  var o = (this.blockSize - e) % this.blockSize;
  o > 0 && (o = this.blockSize - o), this._partialOutput.clear();
  for (var n = 0; n < this._ints; ++n)
    this._partialOutput.putInt32(u.getInt32() ^ this._outBlock[n]);
  if (o > 0)
    u.read -= this.blockSize;
  else
    for (var n = 0; n < this._ints; ++n)
      this._inBlock[n] = this._outBlock[n];
  if (this._partialBytes > 0 && this._partialOutput.getBytes(this._partialBytes), o > 0 && !a)
    return r.putBytes(this._partialOutput.getBytes(
      o - this._partialBytes
    )), this._partialBytes = o, !0;
  r.putBytes(this._partialOutput.getBytes(
    e - this._partialBytes
  )), this._partialBytes = 0;
};
modes.ofb.prototype.decrypt = modes.ofb.prototype.encrypt;
modes.ctr = function(u) {
  u = u || {}, this.name = "CTR", this.cipher = u.cipher, this.blockSize = u.blockSize || 16, this._ints = this.blockSize / 4, this._inBlock = null, this._outBlock = new Array(this._ints), this._partialOutput = forge$z.util.createBuffer(), this._partialBytes = 0;
};
modes.ctr.prototype.start = function(u) {
  if (!("iv" in u))
    throw new Error("Invalid IV parameter.");
  this._iv = transformIV(u.iv, this.blockSize), this._inBlock = this._iv.slice(0), this._partialBytes = 0;
};
modes.ctr.prototype.encrypt = function(u, r, a) {
  var e = u.length();
  if (e === 0)
    return !0;
  if (this.cipher.encrypt(this._inBlock, this._outBlock), this._partialBytes === 0 && e >= this.blockSize)
    for (var n = 0; n < this._ints; ++n)
      r.putInt32(u.getInt32() ^ this._outBlock[n]);
  else {
    var o = (this.blockSize - e) % this.blockSize;
    o > 0 && (o = this.blockSize - o), this._partialOutput.clear();
    for (var n = 0; n < this._ints; ++n)
      this._partialOutput.putInt32(u.getInt32() ^ this._outBlock[n]);
    if (o > 0 && (u.read -= this.blockSize), this._partialBytes > 0 && this._partialOutput.getBytes(this._partialBytes), o > 0 && !a)
      return r.putBytes(this._partialOutput.getBytes(
        o - this._partialBytes
      )), this._partialBytes = o, !0;
    r.putBytes(this._partialOutput.getBytes(
      e - this._partialBytes
    )), this._partialBytes = 0;
  }
  inc32(this._inBlock);
};
modes.ctr.prototype.decrypt = modes.ctr.prototype.encrypt;
modes.gcm = function(u) {
  u = u || {}, this.name = "GCM", this.cipher = u.cipher, this.blockSize = u.blockSize || 16, this._ints = this.blockSize / 4, this._inBlock = new Array(this._ints), this._outBlock = new Array(this._ints), this._partialOutput = forge$z.util.createBuffer(), this._partialBytes = 0, this._R = 3774873600;
};
modes.gcm.prototype.start = function(u) {
  if (!("iv" in u))
    throw new Error("Invalid IV parameter.");
  var r = forge$z.util.createBuffer(u.iv);
  this._cipherLength = 0;
  var a;
  if ("additionalData" in u ? a = forge$z.util.createBuffer(u.additionalData) : a = forge$z.util.createBuffer(), "tagLength" in u ? this._tagLength = u.tagLength : this._tagLength = 128, this._tag = null, u.decrypt && (this._tag = forge$z.util.createBuffer(u.tag).getBytes(), this._tag.length !== this._tagLength / 8))
    throw new Error("Authentication tag does not match tag length.");
  this._hashBlock = new Array(this._ints), this.tag = null, this._hashSubkey = new Array(this._ints), this.cipher.encrypt([0, 0, 0, 0], this._hashSubkey), this.componentBits = 4, this._m = this.generateHashTable(this._hashSubkey, this.componentBits);
  var e = r.length();
  if (e === 12)
    this._j0 = [r.getInt32(), r.getInt32(), r.getInt32(), 1];
  else {
    for (this._j0 = [0, 0, 0, 0]; r.length() > 0; )
      this._j0 = this.ghash(
        this._hashSubkey,
        this._j0,
        [r.getInt32(), r.getInt32(), r.getInt32(), r.getInt32()]
      );
    this._j0 = this.ghash(
      this._hashSubkey,
      this._j0,
      [0, 0].concat(from64To32(e * 8))
    );
  }
  this._inBlock = this._j0.slice(0), inc32(this._inBlock), this._partialBytes = 0, a = forge$z.util.createBuffer(a), this._aDataLength = from64To32(a.length() * 8);
  var n = a.length() % this.blockSize;
  for (n && a.fillWithByte(0, this.blockSize - n), this._s = [0, 0, 0, 0]; a.length() > 0; )
    this._s = this.ghash(this._hashSubkey, this._s, [
      a.getInt32(),
      a.getInt32(),
      a.getInt32(),
      a.getInt32()
    ]);
};
modes.gcm.prototype.encrypt = function(u, r, a) {
  var e = u.length();
  if (e === 0)
    return !0;
  if (this.cipher.encrypt(this._inBlock, this._outBlock), this._partialBytes === 0 && e >= this.blockSize) {
    for (var n = 0; n < this._ints; ++n)
      r.putInt32(this._outBlock[n] ^= u.getInt32());
    this._cipherLength += this.blockSize;
  } else {
    var o = (this.blockSize - e) % this.blockSize;
    o > 0 && (o = this.blockSize - o), this._partialOutput.clear();
    for (var n = 0; n < this._ints; ++n)
      this._partialOutput.putInt32(u.getInt32() ^ this._outBlock[n]);
    if (o <= 0 || a) {
      if (a) {
        var c = e % this.blockSize;
        this._cipherLength += c, this._partialOutput.truncate(this.blockSize - c);
      } else
        this._cipherLength += this.blockSize;
      for (var n = 0; n < this._ints; ++n)
        this._outBlock[n] = this._partialOutput.getInt32();
      this._partialOutput.read -= this.blockSize;
    }
    if (this._partialBytes > 0 && this._partialOutput.getBytes(this._partialBytes), o > 0 && !a)
      return u.read -= this.blockSize, r.putBytes(this._partialOutput.getBytes(
        o - this._partialBytes
      )), this._partialBytes = o, !0;
    r.putBytes(this._partialOutput.getBytes(
      e - this._partialBytes
    )), this._partialBytes = 0;
  }
  this._s = this.ghash(this._hashSubkey, this._s, this._outBlock), inc32(this._inBlock);
};
modes.gcm.prototype.decrypt = function(u, r, a) {
  var e = u.length();
  if (e < this.blockSize && !(a && e > 0))
    return !0;
  this.cipher.encrypt(this._inBlock, this._outBlock), inc32(this._inBlock), this._hashBlock[0] = u.getInt32(), this._hashBlock[1] = u.getInt32(), this._hashBlock[2] = u.getInt32(), this._hashBlock[3] = u.getInt32(), this._s = this.ghash(this._hashSubkey, this._s, this._hashBlock);
  for (var n = 0; n < this._ints; ++n)
    r.putInt32(this._outBlock[n] ^ this._hashBlock[n]);
  e < this.blockSize ? this._cipherLength += e % this.blockSize : this._cipherLength += this.blockSize;
};
modes.gcm.prototype.afterFinish = function(u, r) {
  var a = !0;
  r.decrypt && r.overflow && u.truncate(this.blockSize - r.overflow), this.tag = forge$z.util.createBuffer();
  var e = this._aDataLength.concat(from64To32(this._cipherLength * 8));
  this._s = this.ghash(this._hashSubkey, this._s, e);
  var n = [];
  this.cipher.encrypt(this._j0, n);
  for (var o = 0; o < this._ints; ++o)
    this.tag.putInt32(this._s[o] ^ n[o]);
  return this.tag.truncate(this.tag.length() % (this._tagLength / 8)), r.decrypt && this.tag.bytes() !== this._tag && (a = !1), a;
};
modes.gcm.prototype.multiply = function(u, r) {
  for (var a = [0, 0, 0, 0], e = r.slice(0), n = 0; n < 128; ++n) {
    var o = u[n / 32 | 0] & 1 << 31 - n % 32;
    o && (a[0] ^= e[0], a[1] ^= e[1], a[2] ^= e[2], a[3] ^= e[3]), this.pow(e, e);
  }
  return a;
};
modes.gcm.prototype.pow = function(u, r) {
  for (var a = u[3] & 1, e = 3; e > 0; --e)
    r[e] = u[e] >>> 1 | (u[e - 1] & 1) << 31;
  r[0] = u[0] >>> 1, a && (r[0] ^= this._R);
};
modes.gcm.prototype.tableMultiply = function(u) {
  for (var r = [0, 0, 0, 0], a = 0; a < 32; ++a) {
    var e = a / 8 | 0, n = u[e] >>> (7 - a % 8) * 4 & 15, o = this._m[a][n];
    r[0] ^= o[0], r[1] ^= o[1], r[2] ^= o[2], r[3] ^= o[3];
  }
  return r;
};
modes.gcm.prototype.ghash = function(u, r, a) {
  return r[0] ^= a[0], r[1] ^= a[1], r[2] ^= a[2], r[3] ^= a[3], this.tableMultiply(r);
};
modes.gcm.prototype.generateHashTable = function(u, r) {
  for (var a = 8 / r, e = 4 * a, n = 16 * a, o = new Array(n), c = 0; c < n; ++c) {
    var l = [0, 0, 0, 0], d = c / e | 0, p = (e - 1 - c % e) * r;
    l[d] = 1 << r - 1 << p, o[c] = this.generateSubHashTable(this.multiply(l, u), r);
  }
  return o;
};
modes.gcm.prototype.generateSubHashTable = function(u, r) {
  var a = 1 << r, e = a >>> 1, n = new Array(a);
  n[e] = u.slice(0);
  for (var o = e >>> 1; o > 0; )
    this.pow(n[2 * o], n[o] = []), o >>= 1;
  for (o = 2; o < e; ) {
    for (var c = 1; c < o; ++c) {
      var l = n[o], d = n[c];
      n[o + c] = [
        l[0] ^ d[0],
        l[1] ^ d[1],
        l[2] ^ d[2],
        l[3] ^ d[3]
      ];
    }
    o *= 2;
  }
  for (n[0] = [0, 0, 0, 0], o = e + 1; o < a; ++o) {
    var p = n[o ^ e];
    n[o] = [u[0] ^ p[0], u[1] ^ p[1], u[2] ^ p[2], u[3] ^ p[3]];
  }
  return n;
};
function transformIV(u, r) {
  if (typeof u == "string" && (u = forge$z.util.createBuffer(u)), forge$z.util.isArray(u) && u.length > 4) {
    var a = u;
    u = forge$z.util.createBuffer();
    for (var e = 0; e < a.length; ++e)
      u.putByte(a[e]);
  }
  if (u.length() < r)
    throw new Error(
      "Invalid IV length; got " + u.length() + " bytes and expected " + r + " bytes."
    );
  if (!forge$z.util.isArray(u)) {
    for (var n = [], o = r / 4, e = 0; e < o; ++e)
      n.push(u.getInt32());
    u = n;
  }
  return u;
}
function inc32(u) {
  u[u.length - 1] = u[u.length - 1] + 1 & 4294967295;
}
function from64To32(u) {
  return [u / 4294967296 | 0, u & 4294967295];
}
var forge$y = forge$C;
forge$y.aes = forge$y.aes || {};
forge$y.aes.startEncrypting = function(u, r, a, e) {
  var n = _createCipher$1({
    key: u,
    output: a,
    decrypt: !1,
    mode: e
  });
  return n.start(r), n;
};
forge$y.aes.createEncryptionCipher = function(u, r) {
  return _createCipher$1({
    key: u,
    output: null,
    decrypt: !1,
    mode: r
  });
};
forge$y.aes.startDecrypting = function(u, r, a, e) {
  var n = _createCipher$1({
    key: u,
    output: a,
    decrypt: !0,
    mode: e
  });
  return n.start(r), n;
};
forge$y.aes.createDecryptionCipher = function(u, r) {
  return _createCipher$1({
    key: u,
    output: null,
    decrypt: !0,
    mode: r
  });
};
forge$y.aes.Algorithm = function(u, r) {
  init || initialize();
  var a = this;
  a.name = u, a.mode = new r({
    blockSize: 16,
    cipher: {
      encrypt: function(e, n) {
        return _updateBlock$1(a._w, e, n, !1);
      },
      decrypt: function(e, n) {
        return _updateBlock$1(a._w, e, n, !0);
      }
    }
  }), a._init = !1;
};
forge$y.aes.Algorithm.prototype.initialize = function(u) {
  if (!this._init) {
    var r = u.key, a;
    if (typeof r == "string" && (r.length === 16 || r.length === 24 || r.length === 32))
      r = forge$y.util.createBuffer(r);
    else if (forge$y.util.isArray(r) && (r.length === 16 || r.length === 24 || r.length === 32)) {
      a = r, r = forge$y.util.createBuffer();
      for (var e = 0; e < a.length; ++e)
        r.putByte(a[e]);
    }
    if (!forge$y.util.isArray(r)) {
      a = r, r = [];
      var n = a.length();
      if (n === 16 || n === 24 || n === 32) {
        n = n >>> 2;
        for (var e = 0; e < n; ++e)
          r.push(a.getInt32());
      }
    }
    if (!forge$y.util.isArray(r) || !(r.length === 4 || r.length === 6 || r.length === 8))
      throw new Error("Invalid key parameter.");
    var o = this.mode.name, c = ["CFB", "OFB", "CTR", "GCM"].indexOf(o) !== -1;
    this._w = _expandKey(r, u.decrypt && !c), this._init = !0;
  }
};
forge$y.aes._expandKey = function(u, r) {
  return init || initialize(), _expandKey(u, r);
};
forge$y.aes._updateBlock = _updateBlock$1;
registerAlgorithm$1("AES-ECB", forge$y.cipher.modes.ecb);
registerAlgorithm$1("AES-CBC", forge$y.cipher.modes.cbc);
registerAlgorithm$1("AES-CFB", forge$y.cipher.modes.cfb);
registerAlgorithm$1("AES-OFB", forge$y.cipher.modes.ofb);
registerAlgorithm$1("AES-CTR", forge$y.cipher.modes.ctr);
registerAlgorithm$1("AES-GCM", forge$y.cipher.modes.gcm);
function registerAlgorithm$1(u, r) {
  var a = function() {
    return new forge$y.aes.Algorithm(u, r);
  };
  forge$y.cipher.registerAlgorithm(u, a);
}
var init = !1, Nb = 4, sbox, isbox, rcon, mix, imix;
function initialize() {
  init = !0, rcon = [0, 1, 2, 4, 8, 16, 32, 64, 128, 27, 54];
  for (var u = new Array(256), r = 0; r < 128; ++r)
    u[r] = r << 1, u[r + 128] = r + 128 << 1 ^ 283;
  sbox = new Array(256), isbox = new Array(256), mix = new Array(4), imix = new Array(4);
  for (var r = 0; r < 4; ++r)
    mix[r] = new Array(256), imix[r] = new Array(256);
  for (var a = 0, e = 0, n, o, c, l, d, p, h, r = 0; r < 256; ++r) {
    l = e ^ e << 1 ^ e << 2 ^ e << 3 ^ e << 4, l = l >> 8 ^ l & 255 ^ 99, sbox[a] = l, isbox[l] = a, d = u[l], n = u[a], o = u[n], c = u[o], p = d << 24 ^ // 2
    l << 16 ^ // 1
    l << 8 ^ // 1
    (l ^ d), h = (n ^ o ^ c) << 24 ^ // E (14)
    (a ^ c) << 16 ^ // 9
    (a ^ o ^ c) << 8 ^ // D (13)
    (a ^ n ^ c);
    for (var g = 0; g < 4; ++g)
      mix[g][a] = p, imix[g][l] = h, p = p << 24 | p >>> 8, h = h << 24 | h >>> 8;
    a === 0 ? a = e = 1 : (a = n ^ u[u[u[n ^ c]]], e ^= u[u[e]]);
  }
}
function _expandKey(u, r) {
  for (var a = u.slice(0), e, n = 1, o = a.length, c = o + 6 + 1, l = Nb * c, d = o; d < l; ++d)
    e = a[d - 1], d % o === 0 ? (e = sbox[e >>> 16 & 255] << 24 ^ sbox[e >>> 8 & 255] << 16 ^ sbox[e & 255] << 8 ^ sbox[e >>> 24] ^ rcon[n] << 24, n++) : o > 6 && d % o === 4 && (e = sbox[e >>> 24] << 24 ^ sbox[e >>> 16 & 255] << 16 ^ sbox[e >>> 8 & 255] << 8 ^ sbox[e & 255]), a[d] = a[d - o] ^ e;
  if (r) {
    var p, h = imix[0], g = imix[1], y = imix[2], v = imix[3], m = a.slice(0);
    l = a.length;
    for (var d = 0, b = l - Nb; d < l; d += Nb, b -= Nb)
      if (d === 0 || d === l - Nb)
        m[d] = a[b], m[d + 1] = a[b + 3], m[d + 2] = a[b + 2], m[d + 3] = a[b + 1];
      else
        for (var R = 0; R < Nb; ++R)
          p = a[b + R], m[d + (3 & -R)] = h[sbox[p >>> 24]] ^ g[sbox[p >>> 16 & 255]] ^ y[sbox[p >>> 8 & 255]] ^ v[sbox[p & 255]];
    a = m;
  }
  return a;
}
function _updateBlock$1(u, r, a, e) {
  var n = u.length / 4 - 1, o, c, l, d, p;
  e ? (o = imix[0], c = imix[1], l = imix[2], d = imix[3], p = isbox) : (o = mix[0], c = mix[1], l = mix[2], d = mix[3], p = sbox);
  var h, g, y, v, m, b, R;
  h = r[0] ^ u[0], g = r[e ? 3 : 1] ^ u[1], y = r[2] ^ u[2], v = r[e ? 1 : 3] ^ u[3];
  for (var $ = 3, x = 1; x < n; ++x)
    m = o[h >>> 24] ^ c[g >>> 16 & 255] ^ l[y >>> 8 & 255] ^ d[v & 255] ^ u[++$], b = o[g >>> 24] ^ c[y >>> 16 & 255] ^ l[v >>> 8 & 255] ^ d[h & 255] ^ u[++$], R = o[y >>> 24] ^ c[v >>> 16 & 255] ^ l[h >>> 8 & 255] ^ d[g & 255] ^ u[++$], v = o[v >>> 24] ^ c[h >>> 16 & 255] ^ l[g >>> 8 & 255] ^ d[y & 255] ^ u[++$], h = m, g = b, y = R;
  a[0] = p[h >>> 24] << 24 ^ p[g >>> 16 & 255] << 16 ^ p[y >>> 8 & 255] << 8 ^ p[v & 255] ^ u[++$], a[e ? 3 : 1] = p[g >>> 24] << 24 ^ p[y >>> 16 & 255] << 16 ^ p[v >>> 8 & 255] << 8 ^ p[h & 255] ^ u[++$], a[2] = p[y >>> 24] << 24 ^ p[v >>> 16 & 255] << 16 ^ p[h >>> 8 & 255] << 8 ^ p[g & 255] ^ u[++$], a[e ? 1 : 3] = p[v >>> 24] << 24 ^ p[h >>> 16 & 255] << 16 ^ p[g >>> 8 & 255] << 8 ^ p[y & 255] ^ u[++$];
}
function _createCipher$1(u) {
  u = u || {};
  var r = (u.mode || "CBC").toUpperCase(), a = "AES-" + r, e;
  u.decrypt ? e = forge$y.cipher.createDecipher(a, u.key) : e = forge$y.cipher.createCipher(a, u.key);
  var n = e.start;
  return e.start = function(o, c) {
    var l = null;
    c instanceof forge$y.util.ByteBuffer && (l = c, c = {}), c = c || {}, c.output = l, c.iv = o, n.call(e, c);
  }, e;
}
var forge$x = forge$C;
forge$x.pki = forge$x.pki || {};
var oids$2 = forge$x.pki.oids = forge$x.oids = forge$x.oids || {};
function _IN(u, r) {
  oids$2[u] = r, oids$2[r] = u;
}
function _I_(u, r) {
  oids$2[u] = r;
}
_IN("1.2.840.113549.1.1.1", "rsaEncryption");
_IN("1.2.840.113549.1.1.4", "md5WithRSAEncryption");
_IN("1.2.840.113549.1.1.5", "sha1WithRSAEncryption");
_IN("1.2.840.113549.1.1.7", "RSAES-OAEP");
_IN("1.2.840.113549.1.1.8", "mgf1");
_IN("1.2.840.113549.1.1.9", "pSpecified");
_IN("1.2.840.113549.1.1.10", "RSASSA-PSS");
_IN("1.2.840.113549.1.1.11", "sha256WithRSAEncryption");
_IN("1.2.840.113549.1.1.12", "sha384WithRSAEncryption");
_IN("1.2.840.113549.1.1.13", "sha512WithRSAEncryption");
_IN("1.3.101.112", "EdDSA25519");
_IN("1.2.840.10040.4.3", "dsa-with-sha1");
_IN("1.3.14.3.2.7", "desCBC");
_IN("1.3.14.3.2.26", "sha1");
_IN("1.3.14.3.2.29", "sha1WithRSASignature");
_IN("2.16.840.1.101.3.4.2.1", "sha256");
_IN("2.16.840.1.101.3.4.2.2", "sha384");
_IN("2.16.840.1.101.3.4.2.3", "sha512");
_IN("2.16.840.1.101.3.4.2.4", "sha224");
_IN("2.16.840.1.101.3.4.2.5", "sha512-224");
_IN("2.16.840.1.101.3.4.2.6", "sha512-256");
_IN("1.2.840.113549.2.2", "md2");
_IN("1.2.840.113549.2.5", "md5");
_IN("1.2.840.113549.1.7.1", "data");
_IN("1.2.840.113549.1.7.2", "signedData");
_IN("1.2.840.113549.1.7.3", "envelopedData");
_IN("1.2.840.113549.1.7.4", "signedAndEnvelopedData");
_IN("1.2.840.113549.1.7.5", "digestedData");
_IN("1.2.840.113549.1.7.6", "encryptedData");
_IN("1.2.840.113549.1.9.1", "emailAddress");
_IN("1.2.840.113549.1.9.2", "unstructuredName");
_IN("1.2.840.113549.1.9.3", "contentType");
_IN("1.2.840.113549.1.9.4", "messageDigest");
_IN("1.2.840.113549.1.9.5", "signingTime");
_IN("1.2.840.113549.1.9.6", "counterSignature");
_IN("1.2.840.113549.1.9.7", "challengePassword");
_IN("1.2.840.113549.1.9.8", "unstructuredAddress");
_IN("1.2.840.113549.1.9.14", "extensionRequest");
_IN("1.2.840.113549.1.9.20", "friendlyName");
_IN("1.2.840.113549.1.9.21", "localKeyId");
_IN("1.2.840.113549.1.9.22.1", "x509Certificate");
_IN("1.2.840.113549.1.12.10.1.1", "keyBag");
_IN("1.2.840.113549.1.12.10.1.2", "pkcs8ShroudedKeyBag");
_IN("1.2.840.113549.1.12.10.1.3", "certBag");
_IN("1.2.840.113549.1.12.10.1.4", "crlBag");
_IN("1.2.840.113549.1.12.10.1.5", "secretBag");
_IN("1.2.840.113549.1.12.10.1.6", "safeContentsBag");
_IN("1.2.840.113549.1.5.13", "pkcs5PBES2");
_IN("1.2.840.113549.1.5.12", "pkcs5PBKDF2");
_IN("1.2.840.113549.1.12.1.1", "pbeWithSHAAnd128BitRC4");
_IN("1.2.840.113549.1.12.1.2", "pbeWithSHAAnd40BitRC4");
_IN("1.2.840.113549.1.12.1.3", "pbeWithSHAAnd3-KeyTripleDES-CBC");
_IN("1.2.840.113549.1.12.1.4", "pbeWithSHAAnd2-KeyTripleDES-CBC");
_IN("1.2.840.113549.1.12.1.5", "pbeWithSHAAnd128BitRC2-CBC");
_IN("1.2.840.113549.1.12.1.6", "pbewithSHAAnd40BitRC2-CBC");
_IN("1.2.840.113549.2.7", "hmacWithSHA1");
_IN("1.2.840.113549.2.8", "hmacWithSHA224");
_IN("1.2.840.113549.2.9", "hmacWithSHA256");
_IN("1.2.840.113549.2.10", "hmacWithSHA384");
_IN("1.2.840.113549.2.11", "hmacWithSHA512");
_IN("1.2.840.113549.3.7", "des-EDE3-CBC");
_IN("2.16.840.1.101.3.4.1.2", "aes128-CBC");
_IN("2.16.840.1.101.3.4.1.22", "aes192-CBC");
_IN("2.16.840.1.101.3.4.1.42", "aes256-CBC");
_IN("2.5.4.3", "commonName");
_IN("2.5.4.4", "surname");
_IN("2.5.4.5", "serialNumber");
_IN("2.5.4.6", "countryName");
_IN("2.5.4.7", "localityName");
_IN("2.5.4.8", "stateOrProvinceName");
_IN("2.5.4.9", "streetAddress");
_IN("2.5.4.10", "organizationName");
_IN("2.5.4.11", "organizationalUnitName");
_IN("2.5.4.12", "title");
_IN("2.5.4.13", "description");
_IN("2.5.4.15", "businessCategory");
_IN("2.5.4.17", "postalCode");
_IN("2.5.4.42", "givenName");
_IN("1.3.6.1.4.1.311.60.2.1.2", "jurisdictionOfIncorporationStateOrProvinceName");
_IN("1.3.6.1.4.1.311.60.2.1.3", "jurisdictionOfIncorporationCountryName");
_IN("2.16.840.1.113730.1.1", "nsCertType");
_IN("2.16.840.1.113730.1.13", "nsComment");
_I_("2.5.29.1", "authorityKeyIdentifier");
_I_("2.5.29.2", "keyAttributes");
_I_("2.5.29.3", "certificatePolicies");
_I_("2.5.29.4", "keyUsageRestriction");
_I_("2.5.29.5", "policyMapping");
_I_("2.5.29.6", "subtreesConstraint");
_I_("2.5.29.7", "subjectAltName");
_I_("2.5.29.8", "issuerAltName");
_I_("2.5.29.9", "subjectDirectoryAttributes");
_I_("2.5.29.10", "basicConstraints");
_I_("2.5.29.11", "nameConstraints");
_I_("2.5.29.12", "policyConstraints");
_I_("2.5.29.13", "basicConstraints");
_IN("2.5.29.14", "subjectKeyIdentifier");
_IN("2.5.29.15", "keyUsage");
_I_("2.5.29.16", "privateKeyUsagePeriod");
_IN("2.5.29.17", "subjectAltName");
_IN("2.5.29.18", "issuerAltName");
_IN("2.5.29.19", "basicConstraints");
_I_("2.5.29.20", "cRLNumber");
_I_("2.5.29.21", "cRLReason");
_I_("2.5.29.22", "expirationDate");
_I_("2.5.29.23", "instructionCode");
_I_("2.5.29.24", "invalidityDate");
_I_("2.5.29.25", "cRLDistributionPoints");
_I_("2.5.29.26", "issuingDistributionPoint");
_I_("2.5.29.27", "deltaCRLIndicator");
_I_("2.5.29.28", "issuingDistributionPoint");
_I_("2.5.29.29", "certificateIssuer");
_I_("2.5.29.30", "nameConstraints");
_IN("2.5.29.31", "cRLDistributionPoints");
_IN("2.5.29.32", "certificatePolicies");
_I_("2.5.29.33", "policyMappings");
_I_("2.5.29.34", "policyConstraints");
_IN("2.5.29.35", "authorityKeyIdentifier");
_I_("2.5.29.36", "policyConstraints");
_IN("2.5.29.37", "extKeyUsage");
_I_("2.5.29.46", "freshestCRL");
_I_("2.5.29.54", "inhibitAnyPolicy");
_IN("1.3.6.1.4.1.11129.2.4.2", "timestampList");
_IN("1.3.6.1.5.5.7.1.1", "authorityInfoAccess");
_IN("1.3.6.1.5.5.7.3.1", "serverAuth");
_IN("1.3.6.1.5.5.7.3.2", "clientAuth");
_IN("1.3.6.1.5.5.7.3.3", "codeSigning");
_IN("1.3.6.1.5.5.7.3.4", "emailProtection");
_IN("1.3.6.1.5.5.7.3.8", "timeStamping");
var forge$w = forge$C, asn1$8 = forge$w.asn1 = forge$w.asn1 || {};
asn1$8.Class = {
  UNIVERSAL: 0,
  APPLICATION: 64,
  CONTEXT_SPECIFIC: 128,
  PRIVATE: 192
};
asn1$8.Type = {
  NONE: 0,
  BOOLEAN: 1,
  INTEGER: 2,
  BITSTRING: 3,
  OCTETSTRING: 4,
  NULL: 5,
  OID: 6,
  ODESC: 7,
  EXTERNAL: 8,
  REAL: 9,
  ENUMERATED: 10,
  EMBEDDED: 11,
  UTF8: 12,
  ROID: 13,
  SEQUENCE: 16,
  SET: 17,
  PRINTABLESTRING: 19,
  IA5STRING: 22,
  UTCTIME: 23,
  GENERALIZEDTIME: 24,
  BMPSTRING: 30
};
asn1$8.create = function(u, r, a, e, n) {
  if (forge$w.util.isArray(e)) {
    for (var o = [], c = 0; c < e.length; ++c)
      e[c] !== void 0 && o.push(e[c]);
    e = o;
  }
  var l = {
    tagClass: u,
    type: r,
    constructed: a,
    composed: a || forge$w.util.isArray(e),
    value: e
  };
  return n && "bitStringContents" in n && (l.bitStringContents = n.bitStringContents, l.original = asn1$8.copy(l)), l;
};
asn1$8.copy = function(u, r) {
  var a;
  if (forge$w.util.isArray(u)) {
    a = [];
    for (var e = 0; e < u.length; ++e)
      a.push(asn1$8.copy(u[e], r));
    return a;
  }
  return typeof u == "string" ? u : (a = {
    tagClass: u.tagClass,
    type: u.type,
    constructed: u.constructed,
    composed: u.composed,
    value: asn1$8.copy(u.value, r)
  }, r && !r.excludeBitStringContents && (a.bitStringContents = u.bitStringContents), a);
};
asn1$8.equals = function(u, r, a) {
  if (forge$w.util.isArray(u)) {
    if (!forge$w.util.isArray(r) || u.length !== r.length)
      return !1;
    for (var e = 0; e < u.length; ++e)
      if (!asn1$8.equals(u[e], r[e]))
        return !1;
    return !0;
  }
  if (typeof u != typeof r)
    return !1;
  if (typeof u == "string")
    return u === r;
  var n = u.tagClass === r.tagClass && u.type === r.type && u.constructed === r.constructed && u.composed === r.composed && asn1$8.equals(u.value, r.value);
  return a && a.includeBitStringContents && (n = n && u.bitStringContents === r.bitStringContents), n;
};
asn1$8.getBerValueLength = function(u) {
  var r = u.getByte();
  if (r !== 128) {
    var a, e = r & 128;
    return e ? a = u.getInt((r & 127) << 3) : a = r, a;
  }
};
function _checkBufferLength(u, r, a) {
  if (a > r) {
    var e = new Error("Too few bytes to parse DER.");
    throw e.available = u.length(), e.remaining = r, e.requested = a, e;
  }
}
var _getValueLength = function(u, r) {
  var a = u.getByte();
  if (r--, a !== 128) {
    var e, n = a & 128;
    if (!n)
      e = a;
    else {
      var o = a & 127;
      _checkBufferLength(u, r, o), e = u.getInt(o << 3);
    }
    if (e < 0)
      throw new Error("Negative length: " + e);
    return e;
  }
};
asn1$8.fromDer = function(u, r) {
  r === void 0 && (r = {
    strict: !0,
    parseAllBytes: !0,
    decodeBitStrings: !0
  }), typeof r == "boolean" && (r = {
    strict: r,
    parseAllBytes: !0,
    decodeBitStrings: !0
  }), "strict" in r || (r.strict = !0), "parseAllBytes" in r || (r.parseAllBytes = !0), "decodeBitStrings" in r || (r.decodeBitStrings = !0), typeof u == "string" && (u = forge$w.util.createBuffer(u));
  var a = u.length(), e = _fromDer(u, u.length(), 0, r);
  if (r.parseAllBytes && u.length() !== 0) {
    var n = new Error("Unparsed DER bytes remain after ASN.1 parsing.");
    throw n.byteCount = a, n.remaining = u.length(), n;
  }
  return e;
};
function _fromDer(u, r, a, e) {
  var n;
  _checkBufferLength(u, r, 2);
  var o = u.getByte();
  r--;
  var c = o & 192, l = o & 31;
  n = u.length();
  var d = _getValueLength(u, r);
  if (r -= n - u.length(), d !== void 0 && d > r) {
    if (e.strict) {
      var p = new Error("Too few bytes to read ASN.1 value.");
      throw p.available = u.length(), p.remaining = r, p.requested = d, p;
    }
    d = r;
  }
  var h, g, y = (o & 32) === 32;
  if (y)
    if (h = [], d === void 0)
      for (; ; ) {
        if (_checkBufferLength(u, r, 2), u.bytes(2) === "\0\0") {
          u.getBytes(2), r -= 2;
          break;
        }
        n = u.length(), h.push(_fromDer(u, r, a + 1, e)), r -= n - u.length();
      }
    else
      for (; d > 0; )
        n = u.length(), h.push(_fromDer(u, d, a + 1, e)), r -= n - u.length(), d -= n - u.length();
  if (h === void 0 && c === asn1$8.Class.UNIVERSAL && l === asn1$8.Type.BITSTRING && (g = u.bytes(d)), h === void 0 && e.decodeBitStrings && c === asn1$8.Class.UNIVERSAL && // FIXME: OCTET STRINGs not yet supported here
  // .. other parts of forge expect to decode OCTET STRINGs manually
  l === asn1$8.Type.BITSTRING && d > 1) {
    var v = u.read, m = r, b = 0;
    if (l === asn1$8.Type.BITSTRING && (_checkBufferLength(u, r, 1), b = u.getByte(), r--), b === 0)
      try {
        n = u.length();
        var R = {
          // enforce strict mode to avoid parsing ASN.1 from plain data
          strict: !0,
          decodeBitStrings: !0
        }, $ = _fromDer(u, r, a + 1, R), x = n - u.length();
        r -= x, l == asn1$8.Type.BITSTRING && x++;
        var E = $.tagClass;
        x === d && (E === asn1$8.Class.UNIVERSAL || E === asn1$8.Class.CONTEXT_SPECIFIC) && (h = [$]);
      } catch {
      }
    h === void 0 && (u.read = v, r = m);
  }
  if (h === void 0) {
    if (d === void 0) {
      if (e.strict)
        throw new Error("Non-constructed ASN.1 object of indefinite length.");
      d = r;
    }
    if (l === asn1$8.Type.BMPSTRING)
      for (h = ""; d > 0; d -= 2)
        _checkBufferLength(u, r, 2), h += String.fromCharCode(u.getInt16()), r -= 2;
    else
      h = u.getBytes(d), r -= d;
  }
  var T = g === void 0 ? null : {
    bitStringContents: g
  };
  return asn1$8.create(c, l, y, h, T);
}
asn1$8.toDer = function(u) {
  var r = forge$w.util.createBuffer(), a = u.tagClass | u.type, e = forge$w.util.createBuffer(), n = !1;
  if ("bitStringContents" in u && (n = !0, u.original && (n = asn1$8.equals(u, u.original))), n)
    e.putBytes(u.bitStringContents);
  else if (u.composed) {
    u.constructed ? a |= 32 : e.putByte(0);
    for (var o = 0; o < u.value.length; ++o)
      u.value[o] !== void 0 && e.putBuffer(asn1$8.toDer(u.value[o]));
  } else if (u.type === asn1$8.Type.BMPSTRING)
    for (var o = 0; o < u.value.length; ++o)
      e.putInt16(u.value.charCodeAt(o));
  else
    u.type === asn1$8.Type.INTEGER && u.value.length > 1 && // leading 0x00 for positive integer
    (u.value.charCodeAt(0) === 0 && !(u.value.charCodeAt(1) & 128) || // leading 0xFF for negative integer
    u.value.charCodeAt(0) === 255 && (u.value.charCodeAt(1) & 128) === 128) ? e.putBytes(u.value.substr(1)) : e.putBytes(u.value);
  if (r.putByte(a), e.length() <= 127)
    r.putByte(e.length() & 127);
  else {
    var c = e.length(), l = "";
    do
      l += String.fromCharCode(c & 255), c = c >>> 8;
    while (c > 0);
    r.putByte(l.length | 128);
    for (var o = l.length - 1; o >= 0; --o)
      r.putByte(l.charCodeAt(o));
  }
  return r.putBuffer(e), r;
};
asn1$8.oidToDer = function(u) {
  var r = u.split("."), a = forge$w.util.createBuffer();
  a.putByte(40 * parseInt(r[0], 10) + parseInt(r[1], 10));
  for (var e, n, o, c, l = 2; l < r.length; ++l) {
    e = !0, n = [], o = parseInt(r[l], 10);
    do
      c = o & 127, o = o >>> 7, e || (c |= 128), n.push(c), e = !1;
    while (o > 0);
    for (var d = n.length - 1; d >= 0; --d)
      a.putByte(n[d]);
  }
  return a;
};
asn1$8.derToOid = function(u) {
  var r;
  typeof u == "string" && (u = forge$w.util.createBuffer(u));
  var a = u.getByte();
  r = Math.floor(a / 40) + "." + a % 40;
  for (var e = 0; u.length() > 0; )
    a = u.getByte(), e = e << 7, a & 128 ? e += a & 127 : (r += "." + (e + a), e = 0);
  return r;
};
asn1$8.utcTimeToDate = function(u) {
  var r = /* @__PURE__ */ new Date(), a = parseInt(u.substr(0, 2), 10);
  a = a >= 50 ? 1900 + a : 2e3 + a;
  var e = parseInt(u.substr(2, 2), 10) - 1, n = parseInt(u.substr(4, 2), 10), o = parseInt(u.substr(6, 2), 10), c = parseInt(u.substr(8, 2), 10), l = 0;
  if (u.length > 11) {
    var d = u.charAt(10), p = 10;
    d !== "+" && d !== "-" && (l = parseInt(u.substr(10, 2), 10), p += 2);
  }
  if (r.setUTCFullYear(a, e, n), r.setUTCHours(o, c, l, 0), p && (d = u.charAt(p), d === "+" || d === "-")) {
    var h = parseInt(u.substr(p + 1, 2), 10), g = parseInt(u.substr(p + 4, 2), 10), y = h * 60 + g;
    y *= 6e4, d === "+" ? r.setTime(+r - y) : r.setTime(+r + y);
  }
  return r;
};
asn1$8.generalizedTimeToDate = function(u) {
  var r = /* @__PURE__ */ new Date(), a = parseInt(u.substr(0, 4), 10), e = parseInt(u.substr(4, 2), 10) - 1, n = parseInt(u.substr(6, 2), 10), o = parseInt(u.substr(8, 2), 10), c = parseInt(u.substr(10, 2), 10), l = parseInt(u.substr(12, 2), 10), d = 0, p = 0, h = !1;
  u.charAt(u.length - 1) === "Z" && (h = !0);
  var g = u.length - 5, y = u.charAt(g);
  if (y === "+" || y === "-") {
    var v = parseInt(u.substr(g + 1, 2), 10), m = parseInt(u.substr(g + 4, 2), 10);
    p = v * 60 + m, p *= 6e4, y === "+" && (p *= -1), h = !0;
  }
  return u.charAt(14) === "." && (d = parseFloat(u.substr(14), 10) * 1e3), h ? (r.setUTCFullYear(a, e, n), r.setUTCHours(o, c, l, d), r.setTime(+r + p)) : (r.setFullYear(a, e, n), r.setHours(o, c, l, d)), r;
};
asn1$8.dateToUtcTime = function(u) {
  if (typeof u == "string")
    return u;
  var r = "", a = [];
  a.push(("" + u.getUTCFullYear()).substr(2)), a.push("" + (u.getUTCMonth() + 1)), a.push("" + u.getUTCDate()), a.push("" + u.getUTCHours()), a.push("" + u.getUTCMinutes()), a.push("" + u.getUTCSeconds());
  for (var e = 0; e < a.length; ++e)
    a[e].length < 2 && (r += "0"), r += a[e];
  return r += "Z", r;
};
asn1$8.dateToGeneralizedTime = function(u) {
  if (typeof u == "string")
    return u;
  var r = "", a = [];
  a.push("" + u.getUTCFullYear()), a.push("" + (u.getUTCMonth() + 1)), a.push("" + u.getUTCDate()), a.push("" + u.getUTCHours()), a.push("" + u.getUTCMinutes()), a.push("" + u.getUTCSeconds());
  for (var e = 0; e < a.length; ++e)
    a[e].length < 2 && (r += "0"), r += a[e];
  return r += "Z", r;
};
asn1$8.integerToDer = function(u) {
  var r = forge$w.util.createBuffer();
  if (u >= -128 && u < 128)
    return r.putSignedInt(u, 8);
  if (u >= -32768 && u < 32768)
    return r.putSignedInt(u, 16);
  if (u >= -8388608 && u < 8388608)
    return r.putSignedInt(u, 24);
  if (u >= -2147483648 && u < 2147483648)
    return r.putSignedInt(u, 32);
  var a = new Error("Integer too large; max is 32-bits.");
  throw a.integer = u, a;
};
asn1$8.derToInteger = function(u) {
  typeof u == "string" && (u = forge$w.util.createBuffer(u));
  var r = u.length() * 8;
  if (r > 32)
    throw new Error("Integer too large; max is 32-bits.");
  return u.getSignedInt(r);
};
asn1$8.validate = function(u, r, a, e) {
  var n = !1;
  if ((u.tagClass === r.tagClass || typeof r.tagClass > "u") && (u.type === r.type || typeof r.type > "u"))
    if (u.constructed === r.constructed || typeof r.constructed > "u") {
      if (n = !0, r.value && forge$w.util.isArray(r.value))
        for (var o = 0, c = 0; n && c < r.value.length; ++c)
          n = r.value[c].optional || !1, u.value[o] && (n = asn1$8.validate(u.value[o], r.value[c], a, e), n ? ++o : r.value[c].optional && (n = !0)), !n && e && e.push(
            "[" + r.name + '] Tag class "' + r.tagClass + '", type "' + r.type + '" expected value length "' + r.value.length + '", got "' + u.value.length + '"'
          );
      if (n && a && (r.capture && (a[r.capture] = u.value), r.captureAsn1 && (a[r.captureAsn1] = u), r.captureBitStringContents && "bitStringContents" in u && (a[r.captureBitStringContents] = u.bitStringContents), r.captureBitStringValue && "bitStringContents" in u))
        if (u.bitStringContents.length < 2)
          a[r.captureBitStringValue] = "";
        else {
          var l = u.bitStringContents.charCodeAt(0);
          if (l !== 0)
            throw new Error(
              "captureBitStringValue only supported for zero unused bits"
            );
          a[r.captureBitStringValue] = u.bitStringContents.slice(1);
        }
    } else
      e && e.push(
        "[" + r.name + '] Expected constructed "' + r.constructed + '", got "' + u.constructed + '"'
      );
  else
    e && (u.tagClass !== r.tagClass && e.push(
      "[" + r.name + '] Expected tag class "' + r.tagClass + '", got "' + u.tagClass + '"'
    ), u.type !== r.type && e.push(
      "[" + r.name + '] Expected type "' + r.type + '", got "' + u.type + '"'
    ));
  return n;
};
var _nonLatinRegex = /[^\\u0000-\\u00ff]/;
asn1$8.prettyPrint = function(u, r, a) {
  var e = "";
  r = r || 0, a = a || 2, r > 0 && (e += `
`);
  for (var n = "", o = 0; o < r * a; ++o)
    n += " ";
  switch (e += n + "Tag: ", u.tagClass) {
    case asn1$8.Class.UNIVERSAL:
      e += "Universal:";
      break;
    case asn1$8.Class.APPLICATION:
      e += "Application:";
      break;
    case asn1$8.Class.CONTEXT_SPECIFIC:
      e += "Context-Specific:";
      break;
    case asn1$8.Class.PRIVATE:
      e += "Private:";
      break;
  }
  if (u.tagClass === asn1$8.Class.UNIVERSAL)
    switch (e += u.type, u.type) {
      case asn1$8.Type.NONE:
        e += " (None)";
        break;
      case asn1$8.Type.BOOLEAN:
        e += " (Boolean)";
        break;
      case asn1$8.Type.INTEGER:
        e += " (Integer)";
        break;
      case asn1$8.Type.BITSTRING:
        e += " (Bit string)";
        break;
      case asn1$8.Type.OCTETSTRING:
        e += " (Octet string)";
        break;
      case asn1$8.Type.NULL:
        e += " (Null)";
        break;
      case asn1$8.Type.OID:
        e += " (Object Identifier)";
        break;
      case asn1$8.Type.ODESC:
        e += " (Object Descriptor)";
        break;
      case asn1$8.Type.EXTERNAL:
        e += " (External or Instance of)";
        break;
      case asn1$8.Type.REAL:
        e += " (Real)";
        break;
      case asn1$8.Type.ENUMERATED:
        e += " (Enumerated)";
        break;
      case asn1$8.Type.EMBEDDED:
        e += " (Embedded PDV)";
        break;
      case asn1$8.Type.UTF8:
        e += " (UTF8)";
        break;
      case asn1$8.Type.ROID:
        e += " (Relative Object Identifier)";
        break;
      case asn1$8.Type.SEQUENCE:
        e += " (Sequence)";
        break;
      case asn1$8.Type.SET:
        e += " (Set)";
        break;
      case asn1$8.Type.PRINTABLESTRING:
        e += " (Printable String)";
        break;
      case asn1$8.Type.IA5String:
        e += " (IA5String (ASCII))";
        break;
      case asn1$8.Type.UTCTIME:
        e += " (UTC time)";
        break;
      case asn1$8.Type.GENERALIZEDTIME:
        e += " (Generalized time)";
        break;
      case asn1$8.Type.BMPSTRING:
        e += " (BMP String)";
        break;
    }
  else
    e += u.type;
  if (e += `
`, e += n + "Constructed: " + u.constructed + `
`, u.composed) {
    for (var c = 0, l = "", o = 0; o < u.value.length; ++o)
      u.value[o] !== void 0 && (c += 1, l += asn1$8.prettyPrint(u.value[o], r + 1, a), o + 1 < u.value.length && (l += ","));
    e += n + "Sub values: " + c + l;
  } else {
    if (e += n + "Value: ", u.type === asn1$8.Type.OID) {
      var d = asn1$8.derToOid(u.value);
      e += d, forge$w.pki && forge$w.pki.oids && d in forge$w.pki.oids && (e += " (" + forge$w.pki.oids[d] + ") ");
    }
    if (u.type === asn1$8.Type.INTEGER)
      try {
        e += asn1$8.derToInteger(u.value);
      } catch {
        e += "0x" + forge$w.util.bytesToHex(u.value);
      }
    else if (u.type === asn1$8.Type.BITSTRING) {
      if (u.value.length > 1 ? e += "0x" + forge$w.util.bytesToHex(u.value.slice(1)) : e += "(none)", u.value.length > 0) {
        var p = u.value.charCodeAt(0);
        p == 1 ? e += " (1 unused bit shown)" : p > 1 && (e += " (" + p + " unused bits shown)");
      }
    } else if (u.type === asn1$8.Type.OCTETSTRING)
      _nonLatinRegex.test(u.value) || (e += "(" + u.value + ") "), e += "0x" + forge$w.util.bytesToHex(u.value);
    else if (u.type === asn1$8.Type.UTF8)
      try {
        e += forge$w.util.decodeUtf8(u.value);
      } catch (h) {
        if (h.message === "URI malformed")
          e += "0x" + forge$w.util.bytesToHex(u.value) + " (malformed UTF8)";
        else
          throw h;
      }
    else
      u.type === asn1$8.Type.PRINTABLESTRING || u.type === asn1$8.Type.IA5String ? e += u.value : _nonLatinRegex.test(u.value) ? e += "0x" + forge$w.util.bytesToHex(u.value) : u.value.length === 0 ? e += "[null]" : e += u.value;
  }
  return e;
};
var forge$v = forge$C;
forge$v.md = forge$v.md || {};
forge$v.md.algorithms = forge$v.md.algorithms || {};
var forge$u = forge$C, hmac = forge$u.hmac = forge$u.hmac || {};
hmac.create = function() {
  var u = null, r = null, a = null, e = null, n = {};
  return n.start = function(o, c) {
    if (o !== null)
      if (typeof o == "string")
        if (o = o.toLowerCase(), o in forge$u.md.algorithms)
          r = forge$u.md.algorithms[o].create();
        else
          throw new Error('Unknown hash algorithm "' + o + '"');
      else
        r = o;
    if (c === null)
      c = u;
    else {
      if (typeof c == "string")
        c = forge$u.util.createBuffer(c);
      else if (forge$u.util.isArray(c)) {
        var l = c;
        c = forge$u.util.createBuffer();
        for (var d = 0; d < l.length; ++d)
          c.putByte(l[d]);
      }
      var p = c.length();
      p > r.blockLength && (r.start(), r.update(c.bytes()), c = r.digest()), a = forge$u.util.createBuffer(), e = forge$u.util.createBuffer(), p = c.length();
      for (var d = 0; d < p; ++d) {
        var l = c.at(d);
        a.putByte(54 ^ l), e.putByte(92 ^ l);
      }
      if (p < r.blockLength)
        for (var l = r.blockLength - p, d = 0; d < l; ++d)
          a.putByte(54), e.putByte(92);
      u = c, a = a.bytes(), e = e.bytes();
    }
    r.start(), r.update(a);
  }, n.update = function(o) {
    r.update(o);
  }, n.getMac = function() {
    var o = r.digest().bytes();
    return r.start(), r.update(e), r.update(o), r.digest();
  }, n.digest = n.getMac, n;
};
var forge$t = forge$C, md5 = forge$t.md5 = forge$t.md5 || {};
forge$t.md.md5 = forge$t.md.algorithms.md5 = md5;
md5.create = function() {
  _initialized$3 || _init$3();
  var u = null, r = forge$t.util.createBuffer(), a = new Array(16), e = {
    algorithm: "md5",
    blockLength: 64,
    digestLength: 16,
    // 56-bit length of message so far (does not including padding)
    messageLength: 0,
    // true message length
    fullMessageLength: null,
    // size of message length in bytes
    messageLengthSize: 8
  };
  return e.start = function() {
    e.messageLength = 0, e.fullMessageLength = e.messageLength64 = [];
    for (var n = e.messageLengthSize / 4, o = 0; o < n; ++o)
      e.fullMessageLength.push(0);
    return r = forge$t.util.createBuffer(), u = {
      h0: 1732584193,
      h1: 4023233417,
      h2: 2562383102,
      h3: 271733878
    }, e;
  }, e.start(), e.update = function(n, o) {
    o === "utf8" && (n = forge$t.util.encodeUtf8(n));
    var c = n.length;
    e.messageLength += c, c = [c / 4294967296 >>> 0, c >>> 0];
    for (var l = e.fullMessageLength.length - 1; l >= 0; --l)
      e.fullMessageLength[l] += c[1], c[1] = c[0] + (e.fullMessageLength[l] / 4294967296 >>> 0), e.fullMessageLength[l] = e.fullMessageLength[l] >>> 0, c[0] = c[1] / 4294967296 >>> 0;
    return r.putBytes(n), _update$3(u, a, r), (r.read > 2048 || r.length() === 0) && r.compact(), e;
  }, e.digest = function() {
    var n = forge$t.util.createBuffer();
    n.putBytes(r.bytes());
    var o = e.fullMessageLength[e.fullMessageLength.length - 1] + e.messageLengthSize, c = o & e.blockLength - 1;
    n.putBytes(_padding$3.substr(0, e.blockLength - c));
    for (var l, d = 0, p = e.fullMessageLength.length - 1; p >= 0; --p)
      l = e.fullMessageLength[p] * 8 + d, d = l / 4294967296 >>> 0, n.putInt32Le(l >>> 0);
    var h = {
      h0: u.h0,
      h1: u.h1,
      h2: u.h2,
      h3: u.h3
    };
    _update$3(h, a, n);
    var g = forge$t.util.createBuffer();
    return g.putInt32Le(h.h0), g.putInt32Le(h.h1), g.putInt32Le(h.h2), g.putInt32Le(h.h3), g;
  }, e;
};
var _padding$3 = null, _g = null, _r = null, _k$2 = null, _initialized$3 = !1;
function _init$3() {
  _padding$3 = "", _padding$3 += forge$t.util.fillString("\0", 64), _g = [
    0,
    1,
    2,
    3,
    4,
    5,
    6,
    7,
    8,
    9,
    10,
    11,
    12,
    13,
    14,
    15,
    1,
    6,
    11,
    0,
    5,
    10,
    15,
    4,
    9,
    14,
    3,
    8,
    13,
    2,
    7,
    12,
    5,
    8,
    11,
    14,
    1,
    4,
    7,
    10,
    13,
    0,
    3,
    6,
    9,
    12,
    15,
    2,
    0,
    7,
    14,
    5,
    12,
    3,
    10,
    1,
    8,
    15,
    6,
    13,
    4,
    11,
    2,
    9
  ], _r = [
    7,
    12,
    17,
    22,
    7,
    12,
    17,
    22,
    7,
    12,
    17,
    22,
    7,
    12,
    17,
    22,
    5,
    9,
    14,
    20,
    5,
    9,
    14,
    20,
    5,
    9,
    14,
    20,
    5,
    9,
    14,
    20,
    4,
    11,
    16,
    23,
    4,
    11,
    16,
    23,
    4,
    11,
    16,
    23,
    4,
    11,
    16,
    23,
    6,
    10,
    15,
    21,
    6,
    10,
    15,
    21,
    6,
    10,
    15,
    21,
    6,
    10,
    15,
    21
  ], _k$2 = new Array(64);
  for (var u = 0; u < 64; ++u)
    _k$2[u] = Math.floor(Math.abs(Math.sin(u + 1)) * 4294967296);
  _initialized$3 = !0;
}
function _update$3(u, r, a) {
  for (var e, n, o, c, l, d, p, h, g = a.length(); g >= 64; ) {
    for (n = u.h0, o = u.h1, c = u.h2, l = u.h3, h = 0; h < 16; ++h)
      r[h] = a.getInt32Le(), d = l ^ o & (c ^ l), e = n + d + _k$2[h] + r[h], p = _r[h], n = l, l = c, c = o, o += e << p | e >>> 32 - p;
    for (; h < 32; ++h)
      d = c ^ l & (o ^ c), e = n + d + _k$2[h] + r[_g[h]], p = _r[h], n = l, l = c, c = o, o += e << p | e >>> 32 - p;
    for (; h < 48; ++h)
      d = o ^ c ^ l, e = n + d + _k$2[h] + r[_g[h]], p = _r[h], n = l, l = c, c = o, o += e << p | e >>> 32 - p;
    for (; h < 64; ++h)
      d = c ^ (o | ~l), e = n + d + _k$2[h] + r[_g[h]], p = _r[h], n = l, l = c, c = o, o += e << p | e >>> 32 - p;
    u.h0 = u.h0 + n | 0, u.h1 = u.h1 + o | 0, u.h2 = u.h2 + c | 0, u.h3 = u.h3 + l | 0, g -= 64;
  }
}
var forge$s = forge$C, pem = forge$s.pem = forge$s.pem || {};
pem.encode = function(u, r) {
  r = r || {};
  var a = "-----BEGIN " + u.type + `-----\r
`, e;
  if (u.procType && (e = {
    name: "Proc-Type",
    values: [String(u.procType.version), u.procType.type]
  }, a += foldHeader(e)), u.contentDomain && (e = { name: "Content-Domain", values: [u.contentDomain] }, a += foldHeader(e)), u.dekInfo && (e = { name: "DEK-Info", values: [u.dekInfo.algorithm] }, u.dekInfo.parameters && e.values.push(u.dekInfo.parameters), a += foldHeader(e)), u.headers)
    for (var n = 0; n < u.headers.length; ++n)
      a += foldHeader(u.headers[n]);
  return u.procType && (a += `\r
`), a += forge$s.util.encode64(u.body, r.maxline || 64) + `\r
`, a += "-----END " + u.type + `-----\r
`, a;
};
pem.decode = function(u) {
  for (var r = [], a = /\s*-----BEGIN ([A-Z0-9- ]+)-----\r?\n?([\x21-\x7e\s]+?(?:\r?\n\r?\n))?([:A-Za-z0-9+\/=\s]+?)-----END \1-----/g, e = /([\x21-\x7e]+):\s*([\x21-\x7e\s^:]+)/, n = /\r?\n/, o; o = a.exec(u), !!o; ) {
    var c = o[1];
    c === "NEW CERTIFICATE REQUEST" && (c = "CERTIFICATE REQUEST");
    var l = {
      type: c,
      procType: null,
      contentDomain: null,
      dekInfo: null,
      headers: [],
      body: forge$s.util.decode64(o[3])
    };
    if (r.push(l), !!o[2]) {
      for (var d = o[2].split(n), p = 0; o && p < d.length; ) {
        for (var h = d[p].replace(/\s+$/, ""), g = p + 1; g < d.length; ++g) {
          var y = d[g];
          if (!/\s/.test(y[0]))
            break;
          h += y, p = g;
        }
        if (o = h.match(e), o) {
          for (var v = { name: o[1], values: [] }, m = o[2].split(","), b = 0; b < m.length; ++b)
            v.values.push(ltrim(m[b]));
          if (l.procType)
            if (!l.contentDomain && v.name === "Content-Domain")
              l.contentDomain = m[0] || "";
            else if (!l.dekInfo && v.name === "DEK-Info") {
              if (v.values.length === 0)
                throw new Error('Invalid PEM formatted message. The "DEK-Info" header must have at least one subfield.');
              l.dekInfo = { algorithm: m[0], parameters: m[1] || null };
            } else
              l.headers.push(v);
          else {
            if (v.name !== "Proc-Type")
              throw new Error('Invalid PEM formatted message. The first encapsulated header must be "Proc-Type".');
            if (v.values.length !== 2)
              throw new Error('Invalid PEM formatted message. The "Proc-Type" header must have two subfields.');
            l.procType = { version: m[0], type: m[1] };
          }
        }
        ++p;
      }
      if (l.procType === "ENCRYPTED" && !l.dekInfo)
        throw new Error('Invalid PEM formatted message. The "DEK-Info" header must be present if "Proc-Type" is "ENCRYPTED".');
    }
  }
  if (r.length === 0)
    throw new Error("Invalid PEM formatted message.");
  return r;
};
function foldHeader(u) {
  for (var r = u.name + ": ", a = [], e = function(d, p) {
    return " " + p;
  }, n = 0; n < u.values.length; ++n)
    a.push(u.values[n].replace(/^(\S+\r\n)/, e));
  r += a.join(",") + `\r
`;
  for (var o = 0, c = -1, n = 0; n < r.length; ++n, ++o)
    if (o > 65 && c !== -1) {
      var l = r[c];
      l === "," ? (++c, r = r.substr(0, c) + `\r
 ` + r.substr(c)) : r = r.substr(0, c) + `\r
` + l + r.substr(c + 1), o = n - c - 1, c = -1, ++n;
    } else
      (r[n] === " " || r[n] === "	" || r[n] === ",") && (c = n);
  return r;
}
function ltrim(u) {
  return u.replace(/^\s+/, "");
}
var forge$r = forge$C;
forge$r.des = forge$r.des || {};
forge$r.des.startEncrypting = function(u, r, a, e) {
  var n = _createCipher({
    key: u,
    output: a,
    decrypt: !1,
    mode: e || (r === null ? "ECB" : "CBC")
  });
  return n.start(r), n;
};
forge$r.des.createEncryptionCipher = function(u, r) {
  return _createCipher({
    key: u,
    output: null,
    decrypt: !1,
    mode: r
  });
};
forge$r.des.startDecrypting = function(u, r, a, e) {
  var n = _createCipher({
    key: u,
    output: a,
    decrypt: !0,
    mode: e || (r === null ? "ECB" : "CBC")
  });
  return n.start(r), n;
};
forge$r.des.createDecryptionCipher = function(u, r) {
  return _createCipher({
    key: u,
    output: null,
    decrypt: !0,
    mode: r
  });
};
forge$r.des.Algorithm = function(u, r) {
  var a = this;
  a.name = u, a.mode = new r({
    blockSize: 8,
    cipher: {
      encrypt: function(e, n) {
        return _updateBlock(a._keys, e, n, !1);
      },
      decrypt: function(e, n) {
        return _updateBlock(a._keys, e, n, !0);
      }
    }
  }), a._init = !1;
};
forge$r.des.Algorithm.prototype.initialize = function(u) {
  if (!this._init) {
    var r = forge$r.util.createBuffer(u.key);
    if (this.name.indexOf("3DES") === 0 && r.length() !== 24)
      throw new Error("Invalid Triple-DES key size: " + r.length() * 8);
    this._keys = _createKeys(r), this._init = !0;
  }
};
registerAlgorithm("DES-ECB", forge$r.cipher.modes.ecb);
registerAlgorithm("DES-CBC", forge$r.cipher.modes.cbc);
registerAlgorithm("DES-CFB", forge$r.cipher.modes.cfb);
registerAlgorithm("DES-OFB", forge$r.cipher.modes.ofb);
registerAlgorithm("DES-CTR", forge$r.cipher.modes.ctr);
registerAlgorithm("3DES-ECB", forge$r.cipher.modes.ecb);
registerAlgorithm("3DES-CBC", forge$r.cipher.modes.cbc);
registerAlgorithm("3DES-CFB", forge$r.cipher.modes.cfb);
registerAlgorithm("3DES-OFB", forge$r.cipher.modes.ofb);
registerAlgorithm("3DES-CTR", forge$r.cipher.modes.ctr);
function registerAlgorithm(u, r) {
  var a = function() {
    return new forge$r.des.Algorithm(u, r);
  };
  forge$r.cipher.registerAlgorithm(u, a);
}
var spfunction1 = [16843776, 0, 65536, 16843780, 16842756, 66564, 4, 65536, 1024, 16843776, 16843780, 1024, 16778244, 16842756, 16777216, 4, 1028, 16778240, 16778240, 66560, 66560, 16842752, 16842752, 16778244, 65540, 16777220, 16777220, 65540, 0, 1028, 66564, 16777216, 65536, 16843780, 4, 16842752, 16843776, 16777216, 16777216, 1024, 16842756, 65536, 66560, 16777220, 1024, 4, 16778244, 66564, 16843780, 65540, 16842752, 16778244, 16777220, 1028, 66564, 16843776, 1028, 16778240, 16778240, 0, 65540, 66560, 0, 16842756], spfunction2 = [-2146402272, -2147450880, 32768, 1081376, 1048576, 32, -2146435040, -2147450848, -2147483616, -2146402272, -2146402304, -2147483648, -2147450880, 1048576, 32, -2146435040, 1081344, 1048608, -2147450848, 0, -2147483648, 32768, 1081376, -2146435072, 1048608, -2147483616, 0, 1081344, 32800, -2146402304, -2146435072, 32800, 0, 1081376, -2146435040, 1048576, -2147450848, -2146435072, -2146402304, 32768, -2146435072, -2147450880, 32, -2146402272, 1081376, 32, 32768, -2147483648, 32800, -2146402304, 1048576, -2147483616, 1048608, -2147450848, -2147483616, 1048608, 1081344, 0, -2147450880, 32800, -2147483648, -2146435040, -2146402272, 1081344], spfunction3 = [520, 134349312, 0, 134348808, 134218240, 0, 131592, 134218240, 131080, 134217736, 134217736, 131072, 134349320, 131080, 134348800, 520, 134217728, 8, 134349312, 512, 131584, 134348800, 134348808, 131592, 134218248, 131584, 131072, 134218248, 8, 134349320, 512, 134217728, 134349312, 134217728, 131080, 520, 131072, 134349312, 134218240, 0, 512, 131080, 134349320, 134218240, 134217736, 512, 0, 134348808, 134218248, 131072, 134217728, 134349320, 8, 131592, 131584, 134217736, 134348800, 134218248, 520, 134348800, 131592, 8, 134348808, 131584], spfunction4 = [8396801, 8321, 8321, 128, 8396928, 8388737, 8388609, 8193, 0, 8396800, 8396800, 8396929, 129, 0, 8388736, 8388609, 1, 8192, 8388608, 8396801, 128, 8388608, 8193, 8320, 8388737, 1, 8320, 8388736, 8192, 8396928, 8396929, 129, 8388736, 8388609, 8396800, 8396929, 129, 0, 0, 8396800, 8320, 8388736, 8388737, 1, 8396801, 8321, 8321, 128, 8396929, 129, 1, 8192, 8388609, 8193, 8396928, 8388737, 8193, 8320, 8388608, 8396801, 128, 8388608, 8192, 8396928], spfunction5 = [256, 34078976, 34078720, 1107296512, 524288, 256, 1073741824, 34078720, 1074266368, 524288, 33554688, 1074266368, 1107296512, 1107820544, 524544, 1073741824, 33554432, 1074266112, 1074266112, 0, 1073742080, 1107820800, 1107820800, 33554688, 1107820544, 1073742080, 0, 1107296256, 34078976, 33554432, 1107296256, 524544, 524288, 1107296512, 256, 33554432, 1073741824, 34078720, 1107296512, 1074266368, 33554688, 1073741824, 1107820544, 34078976, 1074266368, 256, 33554432, 1107820544, 1107820800, 524544, 1107296256, 1107820800, 34078720, 0, 1074266112, 1107296256, 524544, 33554688, 1073742080, 524288, 0, 1074266112, 34078976, 1073742080], spfunction6 = [536870928, 541065216, 16384, 541081616, 541065216, 16, 541081616, 4194304, 536887296, 4210704, 4194304, 536870928, 4194320, 536887296, 536870912, 16400, 0, 4194320, 536887312, 16384, 4210688, 536887312, 16, 541065232, 541065232, 0, 4210704, 541081600, 16400, 4210688, 541081600, 536870912, 536887296, 16, 541065232, 4210688, 541081616, 4194304, 16400, 536870928, 4194304, 536887296, 536870912, 16400, 536870928, 541081616, 4210688, 541065216, 4210704, 541081600, 0, 541065232, 16, 16384, 541065216, 4210704, 16384, 4194320, 536887312, 0, 541081600, 536870912, 4194320, 536887312], spfunction7 = [2097152, 69206018, 67110914, 0, 2048, 67110914, 2099202, 69208064, 69208066, 2097152, 0, 67108866, 2, 67108864, 69206018, 2050, 67110912, 2099202, 2097154, 67110912, 67108866, 69206016, 69208064, 2097154, 69206016, 2048, 2050, 69208066, 2099200, 2, 67108864, 2099200, 67108864, 2099200, 2097152, 67110914, 67110914, 69206018, 69206018, 2, 2097154, 67108864, 67110912, 2097152, 69208064, 2050, 2099202, 69208064, 2050, 67108866, 69208066, 69206016, 2099200, 0, 2, 69208066, 0, 2099202, 69206016, 2048, 67108866, 67110912, 2048, 2097154], spfunction8 = [268439616, 4096, 262144, 268701760, 268435456, 268439616, 64, 268435456, 262208, 268697600, 268701760, 266240, 268701696, 266304, 4096, 64, 268697600, 268435520, 268439552, 4160, 266240, 262208, 268697664, 268701696, 4160, 0, 0, 268697664, 268435520, 268439552, 266304, 262144, 266304, 262144, 268701696, 4096, 64, 268697664, 4096, 266304, 268439552, 64, 268435520, 268697600, 268697664, 268435456, 262144, 268439616, 0, 268701760, 262208, 268435520, 268697600, 268439552, 268439616, 0, 268701760, 266240, 266240, 4160, 4160, 262208, 268435456, 268701696];
function _createKeys(u) {
  for (var r = [0, 4, 536870912, 536870916, 65536, 65540, 536936448, 536936452, 512, 516, 536871424, 536871428, 66048, 66052, 536936960, 536936964], a = [0, 1, 1048576, 1048577, 67108864, 67108865, 68157440, 68157441, 256, 257, 1048832, 1048833, 67109120, 67109121, 68157696, 68157697], e = [0, 8, 2048, 2056, 16777216, 16777224, 16779264, 16779272, 0, 8, 2048, 2056, 16777216, 16777224, 16779264, 16779272], n = [0, 2097152, 134217728, 136314880, 8192, 2105344, 134225920, 136323072, 131072, 2228224, 134348800, 136445952, 139264, 2236416, 134356992, 136454144], o = [0, 262144, 16, 262160, 0, 262144, 16, 262160, 4096, 266240, 4112, 266256, 4096, 266240, 4112, 266256], c = [0, 1024, 32, 1056, 0, 1024, 32, 1056, 33554432, 33555456, 33554464, 33555488, 33554432, 33555456, 33554464, 33555488], l = [0, 268435456, 524288, 268959744, 2, 268435458, 524290, 268959746, 0, 268435456, 524288, 268959744, 2, 268435458, 524290, 268959746], d = [0, 65536, 2048, 67584, 536870912, 536936448, 536872960, 536938496, 131072, 196608, 133120, 198656, 537001984, 537067520, 537004032, 537069568], p = [0, 262144, 0, 262144, 2, 262146, 2, 262146, 33554432, 33816576, 33554432, 33816576, 33554434, 33816578, 33554434, 33816578], h = [0, 268435456, 8, 268435464, 0, 268435456, 8, 268435464, 1024, 268436480, 1032, 268436488, 1024, 268436480, 1032, 268436488], g = [0, 32, 0, 32, 1048576, 1048608, 1048576, 1048608, 8192, 8224, 8192, 8224, 1056768, 1056800, 1056768, 1056800], y = [0, 16777216, 512, 16777728, 2097152, 18874368, 2097664, 18874880, 67108864, 83886080, 67109376, 83886592, 69206016, 85983232, 69206528, 85983744], v = [0, 4096, 134217728, 134221824, 524288, 528384, 134742016, 134746112, 16, 4112, 134217744, 134221840, 524304, 528400, 134742032, 134746128], m = [0, 4, 256, 260, 0, 4, 256, 260, 1, 5, 257, 261, 1, 5, 257, 261], b = u.length() > 8 ? 3 : 1, R = [], $ = [0, 0, 1, 1, 1, 1, 1, 1, 0, 1, 1, 1, 1, 1, 1, 0], x = 0, E, T = 0; T < b; T++) {
    var P = u.getInt32(), O = u.getInt32();
    E = (P >>> 4 ^ O) & 252645135, O ^= E, P ^= E << 4, E = (O >>> -16 ^ P) & 65535, P ^= E, O ^= E << -16, E = (P >>> 2 ^ O) & 858993459, O ^= E, P ^= E << 2, E = (O >>> -16 ^ P) & 65535, P ^= E, O ^= E << -16, E = (P >>> 1 ^ O) & 1431655765, O ^= E, P ^= E << 1, E = (O >>> 8 ^ P) & 16711935, P ^= E, O ^= E << 8, E = (P >>> 1 ^ O) & 1431655765, O ^= E, P ^= E << 1, E = P << 8 | O >>> 20 & 240, P = O << 24 | O << 8 & 16711680 | O >>> 8 & 65280 | O >>> 24 & 240, O = E;
    for (var w = 0; w < $.length; ++w) {
      $[w] ? (P = P << 2 | P >>> 26, O = O << 2 | O >>> 26) : (P = P << 1 | P >>> 27, O = O << 1 | O >>> 27), P &= -15, O &= -15;
      var _ = r[P >>> 28] | a[P >>> 24 & 15] | e[P >>> 20 & 15] | n[P >>> 16 & 15] | o[P >>> 12 & 15] | c[P >>> 8 & 15] | l[P >>> 4 & 15], C = d[O >>> 28] | p[O >>> 24 & 15] | h[O >>> 20 & 15] | g[O >>> 16 & 15] | y[O >>> 12 & 15] | v[O >>> 8 & 15] | m[O >>> 4 & 15];
      E = (C >>> 16 ^ _) & 65535, R[x++] = _ ^ E, R[x++] = C ^ E << 16;
    }
  }
  return R;
}
function _updateBlock(u, r, a, e) {
  var n = u.length === 32 ? 3 : 9, o;
  n === 3 ? o = e ? [30, -2, -2] : [0, 32, 2] : o = e ? [94, 62, -2, 32, 64, 2, 30, -2, -2] : [0, 32, 2, 62, 30, -2, 64, 96, 2];
  var c, l = r[0], d = r[1];
  c = (l >>> 4 ^ d) & 252645135, d ^= c, l ^= c << 4, c = (l >>> 16 ^ d) & 65535, d ^= c, l ^= c << 16, c = (d >>> 2 ^ l) & 858993459, l ^= c, d ^= c << 2, c = (d >>> 8 ^ l) & 16711935, l ^= c, d ^= c << 8, c = (l >>> 1 ^ d) & 1431655765, d ^= c, l ^= c << 1, l = l << 1 | l >>> 31, d = d << 1 | d >>> 31;
  for (var p = 0; p < n; p += 3) {
    for (var h = o[p + 1], g = o[p + 2], y = o[p]; y != h; y += g) {
      var v = d ^ u[y], m = (d >>> 4 | d << 28) ^ u[y + 1];
      c = l, l = d, d = c ^ (spfunction2[v >>> 24 & 63] | spfunction4[v >>> 16 & 63] | spfunction6[v >>> 8 & 63] | spfunction8[v & 63] | spfunction1[m >>> 24 & 63] | spfunction3[m >>> 16 & 63] | spfunction5[m >>> 8 & 63] | spfunction7[m & 63]);
    }
    c = l, l = d, d = c;
  }
  l = l >>> 1 | l << 31, d = d >>> 1 | d << 31, c = (l >>> 1 ^ d) & 1431655765, d ^= c, l ^= c << 1, c = (d >>> 8 ^ l) & 16711935, l ^= c, d ^= c << 8, c = (d >>> 2 ^ l) & 858993459, l ^= c, d ^= c << 2, c = (l >>> 16 ^ d) & 65535, d ^= c, l ^= c << 16, c = (l >>> 4 ^ d) & 252645135, d ^= c, l ^= c << 4, a[0] = l, a[1] = d;
}
function _createCipher(u) {
  u = u || {};
  var r = (u.mode || "CBC").toUpperCase(), a = "DES-" + r, e;
  u.decrypt ? e = forge$r.cipher.createDecipher(a, u.key) : e = forge$r.cipher.createCipher(a, u.key);
  var n = e.start;
  return e.start = function(o, c) {
    var l = null;
    c instanceof forge$r.util.ByteBuffer && (l = c, c = {}), c = c || {}, c.output = l, c.iv = o, n.call(e, c);
  }, e;
}
var forge$q = forge$C, pkcs5 = forge$q.pkcs5 = forge$q.pkcs5 || {}, crypto$1;
forge$q.util.isNodejs && (crypto$1 = require$$4);
forge$q.pbkdf2 = pkcs5.pbkdf2 = function(u, r, a, e, n, o) {
  if (typeof n == "function" && (o = n, n = null), forge$q.util.isNodejs && crypto$1.pbkdf2 && (n === null || typeof n != "object") && (crypto$1.pbkdf2Sync.length > 4 || !n || n === "sha1"))
    return typeof n != "string" && (n = "sha1"), u = Buffer.from(u, "binary"), r = Buffer.from(r, "binary"), o ? crypto$1.pbkdf2Sync.length === 4 ? crypto$1.pbkdf2(u, r, a, e, function(E, T) {
      if (E)
        return o(E);
      o(null, T.toString("binary"));
    }) : crypto$1.pbkdf2(u, r, a, e, n, function(E, T) {
      if (E)
        return o(E);
      o(null, T.toString("binary"));
    }) : crypto$1.pbkdf2Sync.length === 4 ? crypto$1.pbkdf2Sync(u, r, a, e).toString("binary") : crypto$1.pbkdf2Sync(u, r, a, e, n).toString("binary");
  if ((typeof n > "u" || n === null) && (n = "sha1"), typeof n == "string") {
    if (!(n in forge$q.md.algorithms))
      throw new Error("Unknown hash algorithm: " + n);
    n = forge$q.md[n].create();
  }
  var c = n.digestLength;
  if (e > 4294967295 * c) {
    var l = new Error("Derived key is too long.");
    if (o)
      return o(l);
    throw l;
  }
  var d = Math.ceil(e / c), p = e - (d - 1) * c, h = forge$q.hmac.create();
  h.start(n, u);
  var g = "", y, v, m;
  if (!o) {
    for (var b = 1; b <= d; ++b) {
      h.start(null, null), h.update(r), h.update(forge$q.util.int32ToBytes(b)), y = m = h.digest().getBytes();
      for (var R = 2; R <= a; ++R)
        h.start(null, null), h.update(m), v = h.digest().getBytes(), y = forge$q.util.xorBytes(y, v, c), m = v;
      g += b < d ? y : y.substr(0, p);
    }
    return g;
  }
  var b = 1, R;
  function $() {
    if (b > d)
      return o(null, g);
    h.start(null, null), h.update(r), h.update(forge$q.util.int32ToBytes(b)), y = m = h.digest().getBytes(), R = 2, x();
  }
  function x() {
    if (R <= a)
      return h.start(null, null), h.update(m), v = h.digest().getBytes(), y = forge$q.util.xorBytes(y, v, c), m = v, ++R, forge$q.util.setImmediate(x);
    g += b < d ? y : y.substr(0, p), ++b, $();
  }
  $();
};
var forge$p = forge$C, sha256 = forge$p.sha256 = forge$p.sha256 || {};
forge$p.md.sha256 = forge$p.md.algorithms.sha256 = sha256;
sha256.create = function() {
  _initialized$2 || _init$2();
  var u = null, r = forge$p.util.createBuffer(), a = new Array(64), e = {
    algorithm: "sha256",
    blockLength: 64,
    digestLength: 32,
    // 56-bit length of message so far (does not including padding)
    messageLength: 0,
    // true message length
    fullMessageLength: null,
    // size of message length in bytes
    messageLengthSize: 8
  };
  return e.start = function() {
    e.messageLength = 0, e.fullMessageLength = e.messageLength64 = [];
    for (var n = e.messageLengthSize / 4, o = 0; o < n; ++o)
      e.fullMessageLength.push(0);
    return r = forge$p.util.createBuffer(), u = {
      h0: 1779033703,
      h1: 3144134277,
      h2: 1013904242,
      h3: 2773480762,
      h4: 1359893119,
      h5: 2600822924,
      h6: 528734635,
      h7: 1541459225
    }, e;
  }, e.start(), e.update = function(n, o) {
    o === "utf8" && (n = forge$p.util.encodeUtf8(n));
    var c = n.length;
    e.messageLength += c, c = [c / 4294967296 >>> 0, c >>> 0];
    for (var l = e.fullMessageLength.length - 1; l >= 0; --l)
      e.fullMessageLength[l] += c[1], c[1] = c[0] + (e.fullMessageLength[l] / 4294967296 >>> 0), e.fullMessageLength[l] = e.fullMessageLength[l] >>> 0, c[0] = c[1] / 4294967296 >>> 0;
    return r.putBytes(n), _update$2(u, a, r), (r.read > 2048 || r.length() === 0) && r.compact(), e;
  }, e.digest = function() {
    var n = forge$p.util.createBuffer();
    n.putBytes(r.bytes());
    var o = e.fullMessageLength[e.fullMessageLength.length - 1] + e.messageLengthSize, c = o & e.blockLength - 1;
    n.putBytes(_padding$2.substr(0, e.blockLength - c));
    for (var l, d, p = e.fullMessageLength[0] * 8, h = 0; h < e.fullMessageLength.length - 1; ++h)
      l = e.fullMessageLength[h + 1] * 8, d = l / 4294967296 >>> 0, p += d, n.putInt32(p >>> 0), p = l >>> 0;
    n.putInt32(p);
    var g = {
      h0: u.h0,
      h1: u.h1,
      h2: u.h2,
      h3: u.h3,
      h4: u.h4,
      h5: u.h5,
      h6: u.h6,
      h7: u.h7
    };
    _update$2(g, a, n);
    var y = forge$p.util.createBuffer();
    return y.putInt32(g.h0), y.putInt32(g.h1), y.putInt32(g.h2), y.putInt32(g.h3), y.putInt32(g.h4), y.putInt32(g.h5), y.putInt32(g.h6), y.putInt32(g.h7), y;
  }, e;
};
var _padding$2 = null, _initialized$2 = !1, _k$1 = null;
function _init$2() {
  _padding$2 = "", _padding$2 += forge$p.util.fillString("\0", 64), _k$1 = [
    1116352408,
    1899447441,
    3049323471,
    3921009573,
    961987163,
    1508970993,
    2453635748,
    2870763221,
    3624381080,
    310598401,
    607225278,
    1426881987,
    1925078388,
    2162078206,
    2614888103,
    3248222580,
    3835390401,
    4022224774,
    264347078,
    604807628,
    770255983,
    1249150122,
    1555081692,
    1996064986,
    2554220882,
    2821834349,
    2952996808,
    3210313671,
    3336571891,
    3584528711,
    113926993,
    338241895,
    666307205,
    773529912,
    1294757372,
    1396182291,
    1695183700,
    1986661051,
    2177026350,
    2456956037,
    2730485921,
    2820302411,
    3259730800,
    3345764771,
    3516065817,
    3600352804,
    4094571909,
    275423344,
    430227734,
    506948616,
    659060556,
    883997877,
    958139571,
    1322822218,
    1537002063,
    1747873779,
    1955562222,
    2024104815,
    2227730452,
    2361852424,
    2428436474,
    2756734187,
    3204031479,
    3329325298
  ], _initialized$2 = !0;
}
function _update$2(u, r, a) {
  for (var e, n, o, c, l, d, p, h, g, y, v, m, b, R, $, x = a.length(); x >= 64; ) {
    for (p = 0; p < 16; ++p)
      r[p] = a.getInt32();
    for (; p < 64; ++p)
      e = r[p - 2], e = (e >>> 17 | e << 15) ^ (e >>> 19 | e << 13) ^ e >>> 10, n = r[p - 15], n = (n >>> 7 | n << 25) ^ (n >>> 18 | n << 14) ^ n >>> 3, r[p] = e + r[p - 7] + n + r[p - 16] | 0;
    for (h = u.h0, g = u.h1, y = u.h2, v = u.h3, m = u.h4, b = u.h5, R = u.h6, $ = u.h7, p = 0; p < 64; ++p)
      c = (m >>> 6 | m << 26) ^ (m >>> 11 | m << 21) ^ (m >>> 25 | m << 7), l = R ^ m & (b ^ R), o = (h >>> 2 | h << 30) ^ (h >>> 13 | h << 19) ^ (h >>> 22 | h << 10), d = h & g | y & (h ^ g), e = $ + c + l + _k$1[p] + r[p], n = o + d, $ = R, R = b, b = m, m = v + e >>> 0, v = y, y = g, g = h, h = e + n >>> 0;
    u.h0 = u.h0 + h | 0, u.h1 = u.h1 + g | 0, u.h2 = u.h2 + y | 0, u.h3 = u.h3 + v | 0, u.h4 = u.h4 + m | 0, u.h5 = u.h5 + b | 0, u.h6 = u.h6 + R | 0, u.h7 = u.h7 + $ | 0, x -= 64;
  }
}
var forge$o = forge$C, _crypto$1 = null;
forge$o.util.isNodejs && !process.versions["node-webkit"] && (_crypto$1 = require$$4);
var prng = forge$o.prng = forge$o.prng || {};
prng.create = function(u) {
  for (var r = {
    plugin: u,
    key: null,
    seed: null,
    time: null,
    // number of reseeds so far
    reseeds: 0,
    // amount of data generated so far
    generated: 0,
    // no initial key bytes
    keyBytes: ""
  }, a = u.md, e = new Array(32), n = 0; n < 32; ++n)
    e[n] = a.create();
  r.pools = e, r.pool = 0, r.generate = function(p, h) {
    if (!h)
      return r.generateSync(p);
    var g = r.plugin.cipher, y = r.plugin.increment, v = r.plugin.formatKey, m = r.plugin.formatSeed, b = forge$o.util.createBuffer();
    r.key = null, R();
    function R($) {
      if ($)
        return h($);
      if (b.length() >= p)
        return h(null, b.getBytes(p));
      if (r.generated > 1048575 && (r.key = null), r.key === null)
        return forge$o.util.nextTick(function() {
          o(R);
        });
      var x = g(r.key, r.seed);
      r.generated += x.length, b.putBytes(x), r.key = v(g(r.key, y(r.seed))), r.seed = m(g(r.key, r.seed)), forge$o.util.setImmediate(R);
    }
  }, r.generateSync = function(p) {
    var h = r.plugin.cipher, g = r.plugin.increment, y = r.plugin.formatKey, v = r.plugin.formatSeed;
    r.key = null;
    for (var m = forge$o.util.createBuffer(); m.length() < p; ) {
      r.generated > 1048575 && (r.key = null), r.key === null && c();
      var b = h(r.key, r.seed);
      r.generated += b.length, m.putBytes(b), r.key = y(h(r.key, g(r.seed))), r.seed = v(h(r.key, r.seed));
    }
    return m.getBytes(p);
  };
  function o(p) {
    if (r.pools[0].messageLength >= 32)
      return l(), p();
    var h = 32 - r.pools[0].messageLength << 5;
    r.seedFile(h, function(g, y) {
      if (g)
        return p(g);
      r.collect(y), l(), p();
    });
  }
  function c() {
    if (r.pools[0].messageLength >= 32)
      return l();
    var p = 32 - r.pools[0].messageLength << 5;
    r.collect(r.seedFileSync(p)), l();
  }
  function l() {
    r.reseeds = r.reseeds === 4294967295 ? 0 : r.reseeds + 1;
    var p = r.plugin.md.create();
    p.update(r.keyBytes);
    for (var h = 1, g = 0; g < 32; ++g)
      r.reseeds % h === 0 && (p.update(r.pools[g].digest().getBytes()), r.pools[g].start()), h = h << 1;
    r.keyBytes = p.digest().getBytes(), p.start(), p.update(r.keyBytes);
    var y = p.digest().getBytes();
    r.key = r.plugin.formatKey(r.keyBytes), r.seed = r.plugin.formatSeed(y), r.generated = 0;
  }
  function d(p) {
    var h = null, g = forge$o.util.globalScope, y = g.crypto || g.msCrypto;
    y && y.getRandomValues && (h = function(P) {
      return y.getRandomValues(P);
    });
    var v = forge$o.util.createBuffer();
    if (h)
      for (; v.length() < p; ) {
        var m = Math.max(1, Math.min(p - v.length(), 65536) / 4), b = new Uint32Array(Math.floor(m));
        try {
          h(b);
          for (var R = 0; R < b.length; ++R)
            v.putInt32(b[R]);
        } catch (P) {
          if (!(typeof QuotaExceededError < "u" && P instanceof QuotaExceededError))
            throw P;
        }
      }
    if (v.length() < p)
      for (var $, x, E, T = Math.floor(Math.random() * 65536); v.length() < p; ) {
        x = 16807 * (T & 65535), $ = 16807 * (T >> 16), x += ($ & 32767) << 16, x += $ >> 15, x = (x & 2147483647) + (x >> 31), T = x & 4294967295;
        for (var R = 0; R < 3; ++R)
          E = T >>> (R << 3), E ^= Math.floor(Math.random() * 256), v.putByte(E & 255);
      }
    return v.getBytes(p);
  }
  return _crypto$1 ? (r.seedFile = function(p, h) {
    _crypto$1.randomBytes(p, function(g, y) {
      if (g)
        return h(g);
      h(null, y.toString());
    });
  }, r.seedFileSync = function(p) {
    return _crypto$1.randomBytes(p).toString();
  }) : (r.seedFile = function(p, h) {
    try {
      h(null, d(p));
    } catch (g) {
      h(g);
    }
  }, r.seedFileSync = d), r.collect = function(p) {
    for (var h = p.length, g = 0; g < h; ++g)
      r.pools[r.pool].update(p.substr(g, 1)), r.pool = r.pool === 31 ? 0 : r.pool + 1;
  }, r.collectInt = function(p, h) {
    for (var g = "", y = 0; y < h; y += 8)
      g += String.fromCharCode(p >> y & 255);
    r.collect(g);
  }, r.registerWorker = function(p) {
    if (p === self)
      r.seedFile = function(g, y) {
        function v(m) {
          var b = m.data;
          b.forge && b.forge.prng && (self.removeEventListener("message", v), y(b.forge.prng.err, b.forge.prng.bytes));
        }
        self.addEventListener("message", v), self.postMessage({ forge: { prng: { needed: g } } });
      };
    else {
      var h = function(g) {
        var y = g.data;
        y.forge && y.forge.prng && r.seedFile(y.forge.prng.needed, function(v, m) {
          p.postMessage({ forge: { prng: { err: v, bytes: m } } });
        });
      };
      p.addEventListener("message", h);
    }
  }, r;
};
var forge$n = forge$C;
(function() {
  forge$n.random && forge$n.random.getBytes || function(u) {
    var r = {}, a = new Array(4), e = forge$n.util.createBuffer();
    r.formatKey = function(g) {
      var y = forge$n.util.createBuffer(g);
      return g = new Array(4), g[0] = y.getInt32(), g[1] = y.getInt32(), g[2] = y.getInt32(), g[3] = y.getInt32(), forge$n.aes._expandKey(g, !1);
    }, r.formatSeed = function(g) {
      var y = forge$n.util.createBuffer(g);
      return g = new Array(4), g[0] = y.getInt32(), g[1] = y.getInt32(), g[2] = y.getInt32(), g[3] = y.getInt32(), g;
    }, r.cipher = function(g, y) {
      return forge$n.aes._updateBlock(g, y, a, !1), e.putInt32(a[0]), e.putInt32(a[1]), e.putInt32(a[2]), e.putInt32(a[3]), e.getBytes();
    }, r.increment = function(g) {
      return ++g[3], g;
    }, r.md = forge$n.md.sha256;
    function n() {
      var g = forge$n.prng.create(r);
      return g.getBytes = function(y, v) {
        return g.generate(y, v);
      }, g.getBytesSync = function(y) {
        return g.generate(y);
      }, g;
    }
    var o = n(), c = null, l = forge$n.util.globalScope, d = l.crypto || l.msCrypto;
    if (d && d.getRandomValues && (c = function(g) {
      return d.getRandomValues(g);
    }), !forge$n.util.isNodejs && !c) {
      if (o.collectInt(+/* @__PURE__ */ new Date(), 32), typeof navigator < "u") {
        var p = "";
        for (var h in navigator)
          try {
            typeof navigator[h] == "string" && (p += navigator[h]);
          } catch {
          }
        o.collect(p), p = null;
      }
      u && (u().mousemove(function(g) {
        o.collectInt(g.clientX, 16), o.collectInt(g.clientY, 16);
      }), u().keypress(function(g) {
        o.collectInt(g.charCode, 8);
      }));
    }
    if (!forge$n.random)
      forge$n.random = o;
    else
      for (var h in o)
        forge$n.random[h] = o[h];
    forge$n.random.createInstance = n;
  }(typeof jQuery < "u" ? jQuery : null);
})();
var forge$m = forge$C, piTable = [
  217,
  120,
  249,
  196,
  25,
  221,
  181,
  237,
  40,
  233,
  253,
  121,
  74,
  160,
  216,
  157,
  198,
  126,
  55,
  131,
  43,
  118,
  83,
  142,
  98,
  76,
  100,
  136,
  68,
  139,
  251,
  162,
  23,
  154,
  89,
  245,
  135,
  179,
  79,
  19,
  97,
  69,
  109,
  141,
  9,
  129,
  125,
  50,
  189,
  143,
  64,
  235,
  134,
  183,
  123,
  11,
  240,
  149,
  33,
  34,
  92,
  107,
  78,
  130,
  84,
  214,
  101,
  147,
  206,
  96,
  178,
  28,
  115,
  86,
  192,
  20,
  167,
  140,
  241,
  220,
  18,
  117,
  202,
  31,
  59,
  190,
  228,
  209,
  66,
  61,
  212,
  48,
  163,
  60,
  182,
  38,
  111,
  191,
  14,
  218,
  70,
  105,
  7,
  87,
  39,
  242,
  29,
  155,
  188,
  148,
  67,
  3,
  248,
  17,
  199,
  246,
  144,
  239,
  62,
  231,
  6,
  195,
  213,
  47,
  200,
  102,
  30,
  215,
  8,
  232,
  234,
  222,
  128,
  82,
  238,
  247,
  132,
  170,
  114,
  172,
  53,
  77,
  106,
  42,
  150,
  26,
  210,
  113,
  90,
  21,
  73,
  116,
  75,
  159,
  208,
  94,
  4,
  24,
  164,
  236,
  194,
  224,
  65,
  110,
  15,
  81,
  203,
  204,
  36,
  145,
  175,
  80,
  161,
  244,
  112,
  57,
  153,
  124,
  58,
  133,
  35,
  184,
  180,
  122,
  252,
  2,
  54,
  91,
  37,
  85,
  151,
  49,
  45,
  93,
  250,
  152,
  227,
  138,
  146,
  174,
  5,
  223,
  41,
  16,
  103,
  108,
  186,
  201,
  211,
  0,
  230,
  207,
  225,
  158,
  168,
  44,
  99,
  22,
  1,
  63,
  88,
  226,
  137,
  169,
  13,
  56,
  52,
  27,
  171,
  51,
  255,
  176,
  187,
  72,
  12,
  95,
  185,
  177,
  205,
  46,
  197,
  243,
  219,
  71,
  229,
  165,
  156,
  119,
  10,
  166,
  32,
  104,
  254,
  127,
  193,
  173
], s = [1, 2, 3, 5], rol = function(u, r) {
  return u << r & 65535 | (u & 65535) >> 16 - r;
}, ror = function(u, r) {
  return (u & 65535) >> r | u << 16 - r & 65535;
};
forge$m.rc2 = forge$m.rc2 || {};
forge$m.rc2.expandKey = function(u, r) {
  typeof u == "string" && (u = forge$m.util.createBuffer(u)), r = r || 128;
  var a = u, e = u.length(), n = r, o = Math.ceil(n / 8), c = 255 >> (n & 7), l;
  for (l = e; l < 128; l++)
    a.putByte(piTable[a.at(l - 1) + a.at(l - e) & 255]);
  for (a.setAt(128 - o, piTable[a.at(128 - o) & c]), l = 127 - o; l >= 0; l--)
    a.setAt(l, piTable[a.at(l + 1) ^ a.at(l + o)]);
  return a;
};
var createCipher = function(u, r, a) {
  var e = !1, n = null, o = null, c = null, l, d, p, h, g = [];
  for (u = forge$m.rc2.expandKey(u, r), p = 0; p < 64; p++)
    g.push(u.getInt16Le());
  a ? (l = function(m) {
    for (p = 0; p < 4; p++)
      m[p] += g[h] + (m[(p + 3) % 4] & m[(p + 2) % 4]) + (~m[(p + 3) % 4] & m[(p + 1) % 4]), m[p] = rol(m[p], s[p]), h++;
  }, d = function(m) {
    for (p = 0; p < 4; p++)
      m[p] += g[m[(p + 3) % 4] & 63];
  }) : (l = function(m) {
    for (p = 3; p >= 0; p--)
      m[p] = ror(m[p], s[p]), m[p] -= g[h] + (m[(p + 3) % 4] & m[(p + 2) % 4]) + (~m[(p + 3) % 4] & m[(p + 1) % 4]), h--;
  }, d = function(m) {
    for (p = 3; p >= 0; p--)
      m[p] -= g[m[(p + 3) % 4] & 63];
  });
  var y = function(m) {
    var b = [];
    for (p = 0; p < 4; p++) {
      var R = n.getInt16Le();
      c !== null && (a ? R ^= c.getInt16Le() : c.putInt16Le(R)), b.push(R & 65535);
    }
    h = a ? 0 : 63;
    for (var $ = 0; $ < m.length; $++)
      for (var x = 0; x < m[$][0]; x++)
        m[$][1](b);
    for (p = 0; p < 4; p++)
      c !== null && (a ? c.putInt16Le(b[p]) : b[p] ^= c.getInt16Le()), o.putInt16Le(b[p]);
  }, v = null;
  return v = {
    /**
     * Starts or restarts the encryption or decryption process, whichever
     * was previously configured.
     *
     * To use the cipher in CBC mode, iv may be given either as a string
     * of bytes, or as a byte buffer.  For ECB mode, give null as iv.
     *
     * @param iv the initialization vector to use, null for ECB mode.
     * @param output the output the buffer to write to, null to create one.
     */
    start: function(m, b) {
      m && typeof m == "string" && (m = forge$m.util.createBuffer(m)), e = !1, n = forge$m.util.createBuffer(), o = b || new forge$m.util.createBuffer(), c = m, v.output = o;
    },
    /**
     * Updates the next block.
     *
     * @param input the buffer to read from.
     */
    update: function(m) {
      for (e || n.putBuffer(m); n.length() >= 8; )
        y([
          [5, l],
          [1, d],
          [6, l],
          [1, d],
          [5, l]
        ]);
    },
    /**
     * Finishes encrypting or decrypting.
     *
     * @param pad a padding function to use, null for PKCS#7 padding,
     *           signature(blockSize, buffer, decrypt).
     *
     * @return true if successful, false on error.
     */
    finish: function(m) {
      var b = !0;
      if (a)
        if (m)
          b = m(8, n, !a);
        else {
          var R = n.length() === 8 ? 8 : 8 - n.length();
          n.fillWithByte(R, R);
        }
      if (b && (e = !0, v.update()), !a && (b = n.length() === 0, b))
        if (m)
          b = m(8, o, !a);
        else {
          var $ = o.length(), x = o.at($ - 1);
          x > $ ? b = !1 : o.truncate(x);
        }
      return b;
    }
  }, v;
};
forge$m.rc2.startEncrypting = function(u, r, a) {
  var e = forge$m.rc2.createEncryptionCipher(u, 128);
  return e.start(r, a), e;
};
forge$m.rc2.createEncryptionCipher = function(u, r) {
  return createCipher(u, r, !0);
};
forge$m.rc2.startDecrypting = function(u, r, a) {
  var e = forge$m.rc2.createDecryptionCipher(u, 128);
  return e.start(r, a), e;
};
forge$m.rc2.createDecryptionCipher = function(u, r) {
  return createCipher(u, r, !1);
};
var forge$l = forge$C;
forge$l.jsbn = forge$l.jsbn || {};
var dbits;
function BigInteger$4(u, r, a) {
  this.data = [], u != null && (typeof u == "number" ? this.fromNumber(u, r, a) : r == null && typeof u != "string" ? this.fromString(u, 256) : this.fromString(u, r));
}
forge$l.jsbn.BigInteger = BigInteger$4;
function nbi() {
  return new BigInteger$4(null);
}
function am1(u, r, a, e, n, o) {
  for (; --o >= 0; ) {
    var c = r * this.data[u++] + a.data[e] + n;
    n = Math.floor(c / 67108864), a.data[e++] = c & 67108863;
  }
  return n;
}
function am2(u, r, a, e, n, o) {
  for (var c = r & 32767, l = r >> 15; --o >= 0; ) {
    var d = this.data[u] & 32767, p = this.data[u++] >> 15, h = l * d + p * c;
    d = c * d + ((h & 32767) << 15) + a.data[e] + (n & 1073741823), n = (d >>> 30) + (h >>> 15) + l * p + (n >>> 30), a.data[e++] = d & 1073741823;
  }
  return n;
}
function am3(u, r, a, e, n, o) {
  for (var c = r & 16383, l = r >> 14; --o >= 0; ) {
    var d = this.data[u] & 16383, p = this.data[u++] >> 14, h = l * d + p * c;
    d = c * d + ((h & 16383) << 14) + a.data[e] + n, n = (d >> 28) + (h >> 14) + l * p, a.data[e++] = d & 268435455;
  }
  return n;
}
typeof navigator > "u" ? (BigInteger$4.prototype.am = am3, dbits = 28) : navigator.appName == "Microsoft Internet Explorer" ? (BigInteger$4.prototype.am = am2, dbits = 30) : navigator.appName != "Netscape" ? (BigInteger$4.prototype.am = am1, dbits = 26) : (BigInteger$4.prototype.am = am3, dbits = 28);
BigInteger$4.prototype.DB = dbits;
BigInteger$4.prototype.DM = (1 << dbits) - 1;
BigInteger$4.prototype.DV = 1 << dbits;
var BI_FP = 52;
BigInteger$4.prototype.FV = Math.pow(2, BI_FP);
BigInteger$4.prototype.F1 = BI_FP - dbits;
BigInteger$4.prototype.F2 = 2 * dbits - BI_FP;
var BI_RM = "0123456789abcdefghijklmnopqrstuvwxyz", BI_RC = new Array(), rr, vv;
rr = 48;
for (vv = 0; vv <= 9; ++vv)
  BI_RC[rr++] = vv;
rr = 97;
for (vv = 10; vv < 36; ++vv)
  BI_RC[rr++] = vv;
rr = 65;
for (vv = 10; vv < 36; ++vv)
  BI_RC[rr++] = vv;
function int2char(u) {
  return BI_RM.charAt(u);
}
function intAt(u, r) {
  var a = BI_RC[u.charCodeAt(r)];
  return a ?? -1;
}
function bnpCopyTo(u) {
  for (var r = this.t - 1; r >= 0; --r)
    u.data[r] = this.data[r];
  u.t = this.t, u.s = this.s;
}
function bnpFromInt(u) {
  this.t = 1, this.s = u < 0 ? -1 : 0, u > 0 ? this.data[0] = u : u < -1 ? this.data[0] = u + this.DV : this.t = 0;
}
function nbv(u) {
  var r = nbi();
  return r.fromInt(u), r;
}
function bnpFromString(u, r) {
  var a;
  if (r == 16)
    a = 4;
  else if (r == 8)
    a = 3;
  else if (r == 256)
    a = 8;
  else if (r == 2)
    a = 1;
  else if (r == 32)
    a = 5;
  else if (r == 4)
    a = 2;
  else {
    this.fromRadix(u, r);
    return;
  }
  this.t = 0, this.s = 0;
  for (var e = u.length, n = !1, o = 0; --e >= 0; ) {
    var c = a == 8 ? u[e] & 255 : intAt(u, e);
    if (c < 0) {
      u.charAt(e) == "-" && (n = !0);
      continue;
    }
    n = !1, o == 0 ? this.data[this.t++] = c : o + a > this.DB ? (this.data[this.t - 1] |= (c & (1 << this.DB - o) - 1) << o, this.data[this.t++] = c >> this.DB - o) : this.data[this.t - 1] |= c << o, o += a, o >= this.DB && (o -= this.DB);
  }
  a == 8 && u[0] & 128 && (this.s = -1, o > 0 && (this.data[this.t - 1] |= (1 << this.DB - o) - 1 << o)), this.clamp(), n && BigInteger$4.ZERO.subTo(this, this);
}
function bnpClamp() {
  for (var u = this.s & this.DM; this.t > 0 && this.data[this.t - 1] == u; )
    --this.t;
}
function bnToString(u) {
  if (this.s < 0)
    return "-" + this.negate().toString(u);
  var r;
  if (u == 16)
    r = 4;
  else if (u == 8)
    r = 3;
  else if (u == 2)
    r = 1;
  else if (u == 32)
    r = 5;
  else if (u == 4)
    r = 2;
  else
    return this.toRadix(u);
  var a = (1 << r) - 1, e, n = !1, o = "", c = this.t, l = this.DB - c * this.DB % r;
  if (c-- > 0)
    for (l < this.DB && (e = this.data[c] >> l) > 0 && (n = !0, o = int2char(e)); c >= 0; )
      l < r ? (e = (this.data[c] & (1 << l) - 1) << r - l, e |= this.data[--c] >> (l += this.DB - r)) : (e = this.data[c] >> (l -= r) & a, l <= 0 && (l += this.DB, --c)), e > 0 && (n = !0), n && (o += int2char(e));
  return n ? o : "0";
}
function bnNegate() {
  var u = nbi();
  return BigInteger$4.ZERO.subTo(this, u), u;
}
function bnAbs() {
  return this.s < 0 ? this.negate() : this;
}
function bnCompareTo(u) {
  var r = this.s - u.s;
  if (r != 0)
    return r;
  var a = this.t;
  if (r = a - u.t, r != 0)
    return this.s < 0 ? -r : r;
  for (; --a >= 0; )
    if ((r = this.data[a] - u.data[a]) != 0)
      return r;
  return 0;
}
function nbits(u) {
  var r = 1, a;
  return (a = u >>> 16) != 0 && (u = a, r += 16), (a = u >> 8) != 0 && (u = a, r += 8), (a = u >> 4) != 0 && (u = a, r += 4), (a = u >> 2) != 0 && (u = a, r += 2), (a = u >> 1) != 0 && (u = a, r += 1), r;
}
function bnBitLength() {
  return this.t <= 0 ? 0 : this.DB * (this.t - 1) + nbits(this.data[this.t - 1] ^ this.s & this.DM);
}
function bnpDLShiftTo(u, r) {
  var a;
  for (a = this.t - 1; a >= 0; --a)
    r.data[a + u] = this.data[a];
  for (a = u - 1; a >= 0; --a)
    r.data[a] = 0;
  r.t = this.t + u, r.s = this.s;
}
function bnpDRShiftTo(u, r) {
  for (var a = u; a < this.t; ++a)
    r.data[a - u] = this.data[a];
  r.t = Math.max(this.t - u, 0), r.s = this.s;
}
function bnpLShiftTo(u, r) {
  var a = u % this.DB, e = this.DB - a, n = (1 << e) - 1, o = Math.floor(u / this.DB), c = this.s << a & this.DM, l;
  for (l = this.t - 1; l >= 0; --l)
    r.data[l + o + 1] = this.data[l] >> e | c, c = (this.data[l] & n) << a;
  for (l = o - 1; l >= 0; --l)
    r.data[l] = 0;
  r.data[o] = c, r.t = this.t + o + 1, r.s = this.s, r.clamp();
}
function bnpRShiftTo(u, r) {
  r.s = this.s;
  var a = Math.floor(u / this.DB);
  if (a >= this.t) {
    r.t = 0;
    return;
  }
  var e = u % this.DB, n = this.DB - e, o = (1 << e) - 1;
  r.data[0] = this.data[a] >> e;
  for (var c = a + 1; c < this.t; ++c)
    r.data[c - a - 1] |= (this.data[c] & o) << n, r.data[c - a] = this.data[c] >> e;
  e > 0 && (r.data[this.t - a - 1] |= (this.s & o) << n), r.t = this.t - a, r.clamp();
}
function bnpSubTo(u, r) {
  for (var a = 0, e = 0, n = Math.min(u.t, this.t); a < n; )
    e += this.data[a] - u.data[a], r.data[a++] = e & this.DM, e >>= this.DB;
  if (u.t < this.t) {
    for (e -= u.s; a < this.t; )
      e += this.data[a], r.data[a++] = e & this.DM, e >>= this.DB;
    e += this.s;
  } else {
    for (e += this.s; a < u.t; )
      e -= u.data[a], r.data[a++] = e & this.DM, e >>= this.DB;
    e -= u.s;
  }
  r.s = e < 0 ? -1 : 0, e < -1 ? r.data[a++] = this.DV + e : e > 0 && (r.data[a++] = e), r.t = a, r.clamp();
}
function bnpMultiplyTo(u, r) {
  var a = this.abs(), e = u.abs(), n = a.t;
  for (r.t = n + e.t; --n >= 0; )
    r.data[n] = 0;
  for (n = 0; n < e.t; ++n)
    r.data[n + a.t] = a.am(0, e.data[n], r, n, 0, a.t);
  r.s = 0, r.clamp(), this.s != u.s && BigInteger$4.ZERO.subTo(r, r);
}
function bnpSquareTo(u) {
  for (var r = this.abs(), a = u.t = 2 * r.t; --a >= 0; )
    u.data[a] = 0;
  for (a = 0; a < r.t - 1; ++a) {
    var e = r.am(a, r.data[a], u, 2 * a, 0, 1);
    (u.data[a + r.t] += r.am(a + 1, 2 * r.data[a], u, 2 * a + 1, e, r.t - a - 1)) >= r.DV && (u.data[a + r.t] -= r.DV, u.data[a + r.t + 1] = 1);
  }
  u.t > 0 && (u.data[u.t - 1] += r.am(a, r.data[a], u, 2 * a, 0, 1)), u.s = 0, u.clamp();
}
function bnpDivRemTo(u, r, a) {
  var e = u.abs();
  if (!(e.t <= 0)) {
    var n = this.abs();
    if (n.t < e.t) {
      r?.fromInt(0), a != null && this.copyTo(a);
      return;
    }
    a == null && (a = nbi());
    var o = nbi(), c = this.s, l = u.s, d = this.DB - nbits(e.data[e.t - 1]);
    d > 0 ? (e.lShiftTo(d, o), n.lShiftTo(d, a)) : (e.copyTo(o), n.copyTo(a));
    var p = o.t, h = o.data[p - 1];
    if (h != 0) {
      var g = h * (1 << this.F1) + (p > 1 ? o.data[p - 2] >> this.F2 : 0), y = this.FV / g, v = (1 << this.F1) / g, m = 1 << this.F2, b = a.t, R = b - p, $ = r ?? nbi();
      for (o.dlShiftTo(R, $), a.compareTo($) >= 0 && (a.data[a.t++] = 1, a.subTo($, a)), BigInteger$4.ONE.dlShiftTo(p, $), $.subTo(o, o); o.t < p; )
        o.data[o.t++] = 0;
      for (; --R >= 0; ) {
        var x = a.data[--b] == h ? this.DM : Math.floor(a.data[b] * y + (a.data[b - 1] + m) * v);
        if ((a.data[b] += o.am(0, x, a, R, 0, p)) < x)
          for (o.dlShiftTo(R, $), a.subTo($, a); a.data[b] < --x; )
            a.subTo($, a);
      }
      r != null && (a.drShiftTo(p, r), c != l && BigInteger$4.ZERO.subTo(r, r)), a.t = p, a.clamp(), d > 0 && a.rShiftTo(d, a), c < 0 && BigInteger$4.ZERO.subTo(a, a);
    }
  }
}
function bnMod(u) {
  var r = nbi();
  return this.abs().divRemTo(u, null, r), this.s < 0 && r.compareTo(BigInteger$4.ZERO) > 0 && u.subTo(r, r), r;
}
function Classic(u) {
  this.m = u;
}
function cConvert(u) {
  return u.s < 0 || u.compareTo(this.m) >= 0 ? u.mod(this.m) : u;
}
function cRevert(u) {
  return u;
}
function cReduce(u) {
  u.divRemTo(this.m, null, u);
}
function cMulTo(u, r, a) {
  u.multiplyTo(r, a), this.reduce(a);
}
function cSqrTo(u, r) {
  u.squareTo(r), this.reduce(r);
}
Classic.prototype.convert = cConvert;
Classic.prototype.revert = cRevert;
Classic.prototype.reduce = cReduce;
Classic.prototype.mulTo = cMulTo;
Classic.prototype.sqrTo = cSqrTo;
function bnpInvDigit() {
  if (this.t < 1)
    return 0;
  var u = this.data[0];
  if (!(u & 1))
    return 0;
  var r = u & 3;
  return r = r * (2 - (u & 15) * r) & 15, r = r * (2 - (u & 255) * r) & 255, r = r * (2 - ((u & 65535) * r & 65535)) & 65535, r = r * (2 - u * r % this.DV) % this.DV, r > 0 ? this.DV - r : -r;
}
function Montgomery(u) {
  this.m = u, this.mp = u.invDigit(), this.mpl = this.mp & 32767, this.mph = this.mp >> 15, this.um = (1 << u.DB - 15) - 1, this.mt2 = 2 * u.t;
}
function montConvert(u) {
  var r = nbi();
  return u.abs().dlShiftTo(this.m.t, r), r.divRemTo(this.m, null, r), u.s < 0 && r.compareTo(BigInteger$4.ZERO) > 0 && this.m.subTo(r, r), r;
}
function montRevert(u) {
  var r = nbi();
  return u.copyTo(r), this.reduce(r), r;
}
function montReduce(u) {
  for (; u.t <= this.mt2; )
    u.data[u.t++] = 0;
  for (var r = 0; r < this.m.t; ++r) {
    var a = u.data[r] & 32767, e = a * this.mpl + ((a * this.mph + (u.data[r] >> 15) * this.mpl & this.um) << 15) & u.DM;
    for (a = r + this.m.t, u.data[a] += this.m.am(0, e, u, r, 0, this.m.t); u.data[a] >= u.DV; )
      u.data[a] -= u.DV, u.data[++a]++;
  }
  u.clamp(), u.drShiftTo(this.m.t, u), u.compareTo(this.m) >= 0 && u.subTo(this.m, u);
}
function montSqrTo(u, r) {
  u.squareTo(r), this.reduce(r);
}
function montMulTo(u, r, a) {
  u.multiplyTo(r, a), this.reduce(a);
}
Montgomery.prototype.convert = montConvert;
Montgomery.prototype.revert = montRevert;
Montgomery.prototype.reduce = montReduce;
Montgomery.prototype.mulTo = montMulTo;
Montgomery.prototype.sqrTo = montSqrTo;
function bnpIsEven() {
  return (this.t > 0 ? this.data[0] & 1 : this.s) == 0;
}
function bnpExp(u, r) {
  if (u > 4294967295 || u < 1)
    return BigInteger$4.ONE;
  var a = nbi(), e = nbi(), n = r.convert(this), o = nbits(u) - 1;
  for (n.copyTo(a); --o >= 0; )
    if (r.sqrTo(a, e), (u & 1 << o) > 0)
      r.mulTo(e, n, a);
    else {
      var c = a;
      a = e, e = c;
    }
  return r.revert(a);
}
function bnModPowInt(u, r) {
  var a;
  return u < 256 || r.isEven() ? a = new Classic(r) : a = new Montgomery(r), this.exp(u, a);
}
BigInteger$4.prototype.copyTo = bnpCopyTo;
BigInteger$4.prototype.fromInt = bnpFromInt;
BigInteger$4.prototype.fromString = bnpFromString;
BigInteger$4.prototype.clamp = bnpClamp;
BigInteger$4.prototype.dlShiftTo = bnpDLShiftTo;
BigInteger$4.prototype.drShiftTo = bnpDRShiftTo;
BigInteger$4.prototype.lShiftTo = bnpLShiftTo;
BigInteger$4.prototype.rShiftTo = bnpRShiftTo;
BigInteger$4.prototype.subTo = bnpSubTo;
BigInteger$4.prototype.multiplyTo = bnpMultiplyTo;
BigInteger$4.prototype.squareTo = bnpSquareTo;
BigInteger$4.prototype.divRemTo = bnpDivRemTo;
BigInteger$4.prototype.invDigit = bnpInvDigit;
BigInteger$4.prototype.isEven = bnpIsEven;
BigInteger$4.prototype.exp = bnpExp;
BigInteger$4.prototype.toString = bnToString;
BigInteger$4.prototype.negate = bnNegate;
BigInteger$4.prototype.abs = bnAbs;
BigInteger$4.prototype.compareTo = bnCompareTo;
BigInteger$4.prototype.bitLength = bnBitLength;
BigInteger$4.prototype.mod = bnMod;
BigInteger$4.prototype.modPowInt = bnModPowInt;
BigInteger$4.ZERO = nbv(0);
BigInteger$4.ONE = nbv(1);
function bnClone() {
  var u = nbi();
  return this.copyTo(u), u;
}
function bnIntValue() {
  if (this.s < 0) {
    if (this.t == 1)
      return this.data[0] - this.DV;
    if (this.t == 0)
      return -1;
  } else {
    if (this.t == 1)
      return this.data[0];
    if (this.t == 0)
      return 0;
  }
  return (this.data[1] & (1 << 32 - this.DB) - 1) << this.DB | this.data[0];
}
function bnByteValue() {
  return this.t == 0 ? this.s : this.data[0] << 24 >> 24;
}
function bnShortValue() {
  return this.t == 0 ? this.s : this.data[0] << 16 >> 16;
}
function bnpChunkSize(u) {
  return Math.floor(Math.LN2 * this.DB / Math.log(u));
}
function bnSigNum() {
  return this.s < 0 ? -1 : this.t <= 0 || this.t == 1 && this.data[0] <= 0 ? 0 : 1;
}
function bnpToRadix(u) {
  if (u == null && (u = 10), this.signum() == 0 || u < 2 || u > 36)
    return "0";
  var r = this.chunkSize(u), a = Math.pow(u, r), e = nbv(a), n = nbi(), o = nbi(), c = "";
  for (this.divRemTo(e, n, o); n.signum() > 0; )
    c = (a + o.intValue()).toString(u).substr(1) + c, n.divRemTo(e, n, o);
  return o.intValue().toString(u) + c;
}
function bnpFromRadix(u, r) {
  this.fromInt(0), r == null && (r = 10);
  for (var a = this.chunkSize(r), e = Math.pow(r, a), n = !1, o = 0, c = 0, l = 0; l < u.length; ++l) {
    var d = intAt(u, l);
    if (d < 0) {
      u.charAt(l) == "-" && this.signum() == 0 && (n = !0);
      continue;
    }
    c = r * c + d, ++o >= a && (this.dMultiply(e), this.dAddOffset(c, 0), o = 0, c = 0);
  }
  o > 0 && (this.dMultiply(Math.pow(r, o)), this.dAddOffset(c, 0)), n && BigInteger$4.ZERO.subTo(this, this);
}
function bnpFromNumber(u, r, a) {
  if (typeof r == "number")
    if (u < 2)
      this.fromInt(1);
    else
      for (this.fromNumber(u, a), this.testBit(u - 1) || this.bitwiseTo(BigInteger$4.ONE.shiftLeft(u - 1), op_or, this), this.isEven() && this.dAddOffset(1, 0); !this.isProbablePrime(r); )
        this.dAddOffset(2, 0), this.bitLength() > u && this.subTo(BigInteger$4.ONE.shiftLeft(u - 1), this);
  else {
    var e = new Array(), n = u & 7;
    e.length = (u >> 3) + 1, r.nextBytes(e), n > 0 ? e[0] &= (1 << n) - 1 : e[0] = 0, this.fromString(e, 256);
  }
}
function bnToByteArray() {
  var u = this.t, r = new Array();
  r[0] = this.s;
  var a = this.DB - u * this.DB % 8, e, n = 0;
  if (u-- > 0)
    for (a < this.DB && (e = this.data[u] >> a) != (this.s & this.DM) >> a && (r[n++] = e | this.s << this.DB - a); u >= 0; )
      a < 8 ? (e = (this.data[u] & (1 << a) - 1) << 8 - a, e |= this.data[--u] >> (a += this.DB - 8)) : (e = this.data[u] >> (a -= 8) & 255, a <= 0 && (a += this.DB, --u)), e & 128 && (e |= -256), n == 0 && (this.s & 128) != (e & 128) && ++n, (n > 0 || e != this.s) && (r[n++] = e);
  return r;
}
function bnEquals(u) {
  return this.compareTo(u) == 0;
}
function bnMin(u) {
  return this.compareTo(u) < 0 ? this : u;
}
function bnMax(u) {
  return this.compareTo(u) > 0 ? this : u;
}
function bnpBitwiseTo(u, r, a) {
  var e, n, o = Math.min(u.t, this.t);
  for (e = 0; e < o; ++e)
    a.data[e] = r(this.data[e], u.data[e]);
  if (u.t < this.t) {
    for (n = u.s & this.DM, e = o; e < this.t; ++e)
      a.data[e] = r(this.data[e], n);
    a.t = this.t;
  } else {
    for (n = this.s & this.DM, e = o; e < u.t; ++e)
      a.data[e] = r(n, u.data[e]);
    a.t = u.t;
  }
  a.s = r(this.s, u.s), a.clamp();
}
function op_and(u, r) {
  return u & r;
}
function bnAnd(u) {
  var r = nbi();
  return this.bitwiseTo(u, op_and, r), r;
}
function op_or(u, r) {
  return u | r;
}
function bnOr(u) {
  var r = nbi();
  return this.bitwiseTo(u, op_or, r), r;
}
function op_xor(u, r) {
  return u ^ r;
}
function bnXor(u) {
  var r = nbi();
  return this.bitwiseTo(u, op_xor, r), r;
}
function op_andnot(u, r) {
  return u & ~r;
}
function bnAndNot(u) {
  var r = nbi();
  return this.bitwiseTo(u, op_andnot, r), r;
}
function bnNot() {
  for (var u = nbi(), r = 0; r < this.t; ++r)
    u.data[r] = this.DM & ~this.data[r];
  return u.t = this.t, u.s = ~this.s, u;
}
function bnShiftLeft(u) {
  var r = nbi();
  return u < 0 ? this.rShiftTo(-u, r) : this.lShiftTo(u, r), r;
}
function bnShiftRight(u) {
  var r = nbi();
  return u < 0 ? this.lShiftTo(-u, r) : this.rShiftTo(u, r), r;
}
function lbit(u) {
  if (u == 0)
    return -1;
  var r = 0;
  return u & 65535 || (u >>= 16, r += 16), u & 255 || (u >>= 8, r += 8), u & 15 || (u >>= 4, r += 4), u & 3 || (u >>= 2, r += 2), u & 1 || ++r, r;
}
function bnGetLowestSetBit() {
  for (var u = 0; u < this.t; ++u)
    if (this.data[u] != 0)
      return u * this.DB + lbit(this.data[u]);
  return this.s < 0 ? this.t * this.DB : -1;
}
function cbit(u) {
  for (var r = 0; u != 0; )
    u &= u - 1, ++r;
  return r;
}
function bnBitCount() {
  for (var u = 0, r = this.s & this.DM, a = 0; a < this.t; ++a)
    u += cbit(this.data[a] ^ r);
  return u;
}
function bnTestBit(u) {
  var r = Math.floor(u / this.DB);
  return r >= this.t ? this.s != 0 : (this.data[r] & 1 << u % this.DB) != 0;
}
function bnpChangeBit(u, r) {
  var a = BigInteger$4.ONE.shiftLeft(u);
  return this.bitwiseTo(a, r, a), a;
}
function bnSetBit(u) {
  return this.changeBit(u, op_or);
}
function bnClearBit(u) {
  return this.changeBit(u, op_andnot);
}
function bnFlipBit(u) {
  return this.changeBit(u, op_xor);
}
function bnpAddTo(u, r) {
  for (var a = 0, e = 0, n = Math.min(u.t, this.t); a < n; )
    e += this.data[a] + u.data[a], r.data[a++] = e & this.DM, e >>= this.DB;
  if (u.t < this.t) {
    for (e += u.s; a < this.t; )
      e += this.data[a], r.data[a++] = e & this.DM, e >>= this.DB;
    e += this.s;
  } else {
    for (e += this.s; a < u.t; )
      e += u.data[a], r.data[a++] = e & this.DM, e >>= this.DB;
    e += u.s;
  }
  r.s = e < 0 ? -1 : 0, e > 0 ? r.data[a++] = e : e < -1 && (r.data[a++] = this.DV + e), r.t = a, r.clamp();
}
function bnAdd(u) {
  var r = nbi();
  return this.addTo(u, r), r;
}
function bnSubtract(u) {
  var r = nbi();
  return this.subTo(u, r), r;
}
function bnMultiply(u) {
  var r = nbi();
  return this.multiplyTo(u, r), r;
}
function bnDivide(u) {
  var r = nbi();
  return this.divRemTo(u, r, null), r;
}
function bnRemainder(u) {
  var r = nbi();
  return this.divRemTo(u, null, r), r;
}
function bnDivideAndRemainder(u) {
  var r = nbi(), a = nbi();
  return this.divRemTo(u, r, a), new Array(r, a);
}
function bnpDMultiply(u) {
  this.data[this.t] = this.am(0, u - 1, this, 0, 0, this.t), ++this.t, this.clamp();
}
function bnpDAddOffset(u, r) {
  if (u != 0) {
    for (; this.t <= r; )
      this.data[this.t++] = 0;
    for (this.data[r] += u; this.data[r] >= this.DV; )
      this.data[r] -= this.DV, ++r >= this.t && (this.data[this.t++] = 0), ++this.data[r];
  }
}
function NullExp() {
}
function nNop(u) {
  return u;
}
function nMulTo(u, r, a) {
  u.multiplyTo(r, a);
}
function nSqrTo(u, r) {
  u.squareTo(r);
}
NullExp.prototype.convert = nNop;
NullExp.prototype.revert = nNop;
NullExp.prototype.mulTo = nMulTo;
NullExp.prototype.sqrTo = nSqrTo;
function bnPow(u) {
  return this.exp(u, new NullExp());
}
function bnpMultiplyLowerTo(u, r, a) {
  var e = Math.min(this.t + u.t, r);
  for (a.s = 0, a.t = e; e > 0; )
    a.data[--e] = 0;
  var n;
  for (n = a.t - this.t; e < n; ++e)
    a.data[e + this.t] = this.am(0, u.data[e], a, e, 0, this.t);
  for (n = Math.min(u.t, r); e < n; ++e)
    this.am(0, u.data[e], a, e, 0, r - e);
  a.clamp();
}
function bnpMultiplyUpperTo(u, r, a) {
  --r;
  var e = a.t = this.t + u.t - r;
  for (a.s = 0; --e >= 0; )
    a.data[e] = 0;
  for (e = Math.max(r - this.t, 0); e < u.t; ++e)
    a.data[this.t + e - r] = this.am(r - e, u.data[e], a, 0, 0, this.t + e - r);
  a.clamp(), a.drShiftTo(1, a);
}
function Barrett(u) {
  this.r2 = nbi(), this.q3 = nbi(), BigInteger$4.ONE.dlShiftTo(2 * u.t, this.r2), this.mu = this.r2.divide(u), this.m = u;
}
function barrettConvert(u) {
  if (u.s < 0 || u.t > 2 * this.m.t)
    return u.mod(this.m);
  if (u.compareTo(this.m) < 0)
    return u;
  var r = nbi();
  return u.copyTo(r), this.reduce(r), r;
}
function barrettRevert(u) {
  return u;
}
function barrettReduce(u) {
  for (u.drShiftTo(this.m.t - 1, this.r2), u.t > this.m.t + 1 && (u.t = this.m.t + 1, u.clamp()), this.mu.multiplyUpperTo(this.r2, this.m.t + 1, this.q3), this.m.multiplyLowerTo(this.q3, this.m.t + 1, this.r2); u.compareTo(this.r2) < 0; )
    u.dAddOffset(1, this.m.t + 1);
  for (u.subTo(this.r2, u); u.compareTo(this.m) >= 0; )
    u.subTo(this.m, u);
}
function barrettSqrTo(u, r) {
  u.squareTo(r), this.reduce(r);
}
function barrettMulTo(u, r, a) {
  u.multiplyTo(r, a), this.reduce(a);
}
Barrett.prototype.convert = barrettConvert;
Barrett.prototype.revert = barrettRevert;
Barrett.prototype.reduce = barrettReduce;
Barrett.prototype.mulTo = barrettMulTo;
Barrett.prototype.sqrTo = barrettSqrTo;
function bnModPow(u, r) {
  var a = u.bitLength(), e, n = nbv(1), o;
  if (a <= 0)
    return n;
  a < 18 ? e = 1 : a < 48 ? e = 3 : a < 144 ? e = 4 : a < 768 ? e = 5 : e = 6, a < 8 ? o = new Classic(r) : r.isEven() ? o = new Barrett(r) : o = new Montgomery(r);
  var c = new Array(), l = 3, d = e - 1, p = (1 << e) - 1;
  if (c[1] = o.convert(this), e > 1) {
    var h = nbi();
    for (o.sqrTo(c[1], h); l <= p; )
      c[l] = nbi(), o.mulTo(h, c[l - 2], c[l]), l += 2;
  }
  var g = u.t - 1, y, v = !0, m = nbi(), b;
  for (a = nbits(u.data[g]) - 1; g >= 0; ) {
    for (a >= d ? y = u.data[g] >> a - d & p : (y = (u.data[g] & (1 << a + 1) - 1) << d - a, g > 0 && (y |= u.data[g - 1] >> this.DB + a - d)), l = e; !(y & 1); )
      y >>= 1, --l;
    if ((a -= l) < 0 && (a += this.DB, --g), v)
      c[y].copyTo(n), v = !1;
    else {
      for (; l > 1; )
        o.sqrTo(n, m), o.sqrTo(m, n), l -= 2;
      l > 0 ? o.sqrTo(n, m) : (b = n, n = m, m = b), o.mulTo(m, c[y], n);
    }
    for (; g >= 0 && !(u.data[g] & 1 << a); )
      o.sqrTo(n, m), b = n, n = m, m = b, --a < 0 && (a = this.DB - 1, --g);
  }
  return o.revert(n);
}
function bnGCD(u) {
  var r = this.s < 0 ? this.negate() : this.clone(), a = u.s < 0 ? u.negate() : u.clone();
  if (r.compareTo(a) < 0) {
    var e = r;
    r = a, a = e;
  }
  var n = r.getLowestSetBit(), o = a.getLowestSetBit();
  if (o < 0)
    return r;
  for (n < o && (o = n), o > 0 && (r.rShiftTo(o, r), a.rShiftTo(o, a)); r.signum() > 0; )
    (n = r.getLowestSetBit()) > 0 && r.rShiftTo(n, r), (n = a.getLowestSetBit()) > 0 && a.rShiftTo(n, a), r.compareTo(a) >= 0 ? (r.subTo(a, r), r.rShiftTo(1, r)) : (a.subTo(r, a), a.rShiftTo(1, a));
  return o > 0 && a.lShiftTo(o, a), a;
}
function bnpModInt(u) {
  if (u <= 0)
    return 0;
  var r = this.DV % u, a = this.s < 0 ? u - 1 : 0;
  if (this.t > 0)
    if (r == 0)
      a = this.data[0] % u;
    else
      for (var e = this.t - 1; e >= 0; --e)
        a = (r * a + this.data[e]) % u;
  return a;
}
function bnModInverse(u) {
  var r = u.isEven();
  if (this.isEven() && r || u.signum() == 0)
    return BigInteger$4.ZERO;
  for (var a = u.clone(), e = this.clone(), n = nbv(1), o = nbv(0), c = nbv(0), l = nbv(1); a.signum() != 0; ) {
    for (; a.isEven(); )
      a.rShiftTo(1, a), r ? ((!n.isEven() || !o.isEven()) && (n.addTo(this, n), o.subTo(u, o)), n.rShiftTo(1, n)) : o.isEven() || o.subTo(u, o), o.rShiftTo(1, o);
    for (; e.isEven(); )
      e.rShiftTo(1, e), r ? ((!c.isEven() || !l.isEven()) && (c.addTo(this, c), l.subTo(u, l)), c.rShiftTo(1, c)) : l.isEven() || l.subTo(u, l), l.rShiftTo(1, l);
    a.compareTo(e) >= 0 ? (a.subTo(e, a), r && n.subTo(c, n), o.subTo(l, o)) : (e.subTo(a, e), r && c.subTo(n, c), l.subTo(o, l));
  }
  if (e.compareTo(BigInteger$4.ONE) != 0)
    return BigInteger$4.ZERO;
  if (l.compareTo(u) >= 0)
    return l.subtract(u);
  if (l.signum() < 0)
    l.addTo(u, l);
  else
    return l;
  return l.signum() < 0 ? l.add(u) : l;
}
var lowprimes = [2, 3, 5, 7, 11, 13, 17, 19, 23, 29, 31, 37, 41, 43, 47, 53, 59, 61, 67, 71, 73, 79, 83, 89, 97, 101, 103, 107, 109, 113, 127, 131, 137, 139, 149, 151, 157, 163, 167, 173, 179, 181, 191, 193, 197, 199, 211, 223, 227, 229, 233, 239, 241, 251, 257, 263, 269, 271, 277, 281, 283, 293, 307, 311, 313, 317, 331, 337, 347, 349, 353, 359, 367, 373, 379, 383, 389, 397, 401, 409, 419, 421, 431, 433, 439, 443, 449, 457, 461, 463, 467, 479, 487, 491, 499, 503, 509], lplim = (1 << 26) / lowprimes[lowprimes.length - 1];
function bnIsProbablePrime(u) {
  var r, a = this.abs();
  if (a.t == 1 && a.data[0] <= lowprimes[lowprimes.length - 1]) {
    for (r = 0; r < lowprimes.length; ++r)
      if (a.data[0] == lowprimes[r])
        return !0;
    return !1;
  }
  if (a.isEven())
    return !1;
  for (r = 1; r < lowprimes.length; ) {
    for (var e = lowprimes[r], n = r + 1; n < lowprimes.length && e < lplim; )
      e *= lowprimes[n++];
    for (e = a.modInt(e); r < n; )
      if (e % lowprimes[r++] == 0)
        return !1;
  }
  return a.millerRabin(u);
}
function bnpMillerRabin(u) {
  var r = this.subtract(BigInteger$4.ONE), a = r.getLowestSetBit();
  if (a <= 0)
    return !1;
  for (var e = r.shiftRight(a), n = bnGetPrng(), o, c = 0; c < u; ++c) {
    do
      o = new BigInteger$4(this.bitLength(), n);
    while (o.compareTo(BigInteger$4.ONE) <= 0 || o.compareTo(r) >= 0);
    var l = o.modPow(e, this);
    if (l.compareTo(BigInteger$4.ONE) != 0 && l.compareTo(r) != 0) {
      for (var d = 1; d++ < a && l.compareTo(r) != 0; )
        if (l = l.modPowInt(2, this), l.compareTo(BigInteger$4.ONE) == 0)
          return !1;
      if (l.compareTo(r) != 0)
        return !1;
    }
  }
  return !0;
}
function bnGetPrng() {
  return {
    // x is an array to fill with bytes
    nextBytes: function(u) {
      for (var r = 0; r < u.length; ++r)
        u[r] = Math.floor(Math.random() * 256);
    }
  };
}
BigInteger$4.prototype.chunkSize = bnpChunkSize;
BigInteger$4.prototype.toRadix = bnpToRadix;
BigInteger$4.prototype.fromRadix = bnpFromRadix;
BigInteger$4.prototype.fromNumber = bnpFromNumber;
BigInteger$4.prototype.bitwiseTo = bnpBitwiseTo;
BigInteger$4.prototype.changeBit = bnpChangeBit;
BigInteger$4.prototype.addTo = bnpAddTo;
BigInteger$4.prototype.dMultiply = bnpDMultiply;
BigInteger$4.prototype.dAddOffset = bnpDAddOffset;
BigInteger$4.prototype.multiplyLowerTo = bnpMultiplyLowerTo;
BigInteger$4.prototype.multiplyUpperTo = bnpMultiplyUpperTo;
BigInteger$4.prototype.modInt = bnpModInt;
BigInteger$4.prototype.millerRabin = bnpMillerRabin;
BigInteger$4.prototype.clone = bnClone;
BigInteger$4.prototype.intValue = bnIntValue;
BigInteger$4.prototype.byteValue = bnByteValue;
BigInteger$4.prototype.shortValue = bnShortValue;
BigInteger$4.prototype.signum = bnSigNum;
BigInteger$4.prototype.toByteArray = bnToByteArray;
BigInteger$4.prototype.equals = bnEquals;
BigInteger$4.prototype.min = bnMin;
BigInteger$4.prototype.max = bnMax;
BigInteger$4.prototype.and = bnAnd;
BigInteger$4.prototype.or = bnOr;
BigInteger$4.prototype.xor = bnXor;
BigInteger$4.prototype.andNot = bnAndNot;
BigInteger$4.prototype.not = bnNot;
BigInteger$4.prototype.shiftLeft = bnShiftLeft;
BigInteger$4.prototype.shiftRight = bnShiftRight;
BigInteger$4.prototype.getLowestSetBit = bnGetLowestSetBit;
BigInteger$4.prototype.bitCount = bnBitCount;
BigInteger$4.prototype.testBit = bnTestBit;
BigInteger$4.prototype.setBit = bnSetBit;
BigInteger$4.prototype.clearBit = bnClearBit;
BigInteger$4.prototype.flipBit = bnFlipBit;
BigInteger$4.prototype.add = bnAdd;
BigInteger$4.prototype.subtract = bnSubtract;
BigInteger$4.prototype.multiply = bnMultiply;
BigInteger$4.prototype.divide = bnDivide;
BigInteger$4.prototype.remainder = bnRemainder;
BigInteger$4.prototype.divideAndRemainder = bnDivideAndRemainder;
BigInteger$4.prototype.modPow = bnModPow;
BigInteger$4.prototype.modInverse = bnModInverse;
BigInteger$4.prototype.pow = bnPow;
BigInteger$4.prototype.gcd = bnGCD;
BigInteger$4.prototype.isProbablePrime = bnIsProbablePrime;
var forge$k = forge$C, sha1 = forge$k.sha1 = forge$k.sha1 || {};
forge$k.md.sha1 = forge$k.md.algorithms.sha1 = sha1;
sha1.create = function() {
  _initialized$1 || _init$1();
  var u = null, r = forge$k.util.createBuffer(), a = new Array(80), e = {
    algorithm: "sha1",
    blockLength: 64,
    digestLength: 20,
    // 56-bit length of message so far (does not including padding)
    messageLength: 0,
    // true message length
    fullMessageLength: null,
    // size of message length in bytes
    messageLengthSize: 8
  };
  return e.start = function() {
    e.messageLength = 0, e.fullMessageLength = e.messageLength64 = [];
    for (var n = e.messageLengthSize / 4, o = 0; o < n; ++o)
      e.fullMessageLength.push(0);
    return r = forge$k.util.createBuffer(), u = {
      h0: 1732584193,
      h1: 4023233417,
      h2: 2562383102,
      h3: 271733878,
      h4: 3285377520
    }, e;
  }, e.start(), e.update = function(n, o) {
    o === "utf8" && (n = forge$k.util.encodeUtf8(n));
    var c = n.length;
    e.messageLength += c, c = [c / 4294967296 >>> 0, c >>> 0];
    for (var l = e.fullMessageLength.length - 1; l >= 0; --l)
      e.fullMessageLength[l] += c[1], c[1] = c[0] + (e.fullMessageLength[l] / 4294967296 >>> 0), e.fullMessageLength[l] = e.fullMessageLength[l] >>> 0, c[0] = c[1] / 4294967296 >>> 0;
    return r.putBytes(n), _update$1(u, a, r), (r.read > 2048 || r.length() === 0) && r.compact(), e;
  }, e.digest = function() {
    var n = forge$k.util.createBuffer();
    n.putBytes(r.bytes());
    var o = e.fullMessageLength[e.fullMessageLength.length - 1] + e.messageLengthSize, c = o & e.blockLength - 1;
    n.putBytes(_padding$1.substr(0, e.blockLength - c));
    for (var l, d, p = e.fullMessageLength[0] * 8, h = 0; h < e.fullMessageLength.length - 1; ++h)
      l = e.fullMessageLength[h + 1] * 8, d = l / 4294967296 >>> 0, p += d, n.putInt32(p >>> 0), p = l >>> 0;
    n.putInt32(p);
    var g = {
      h0: u.h0,
      h1: u.h1,
      h2: u.h2,
      h3: u.h3,
      h4: u.h4
    };
    _update$1(g, a, n);
    var y = forge$k.util.createBuffer();
    return y.putInt32(g.h0), y.putInt32(g.h1), y.putInt32(g.h2), y.putInt32(g.h3), y.putInt32(g.h4), y;
  }, e;
};
var _padding$1 = null, _initialized$1 = !1;
function _init$1() {
  _padding$1 = "", _padding$1 += forge$k.util.fillString("\0", 64), _initialized$1 = !0;
}
function _update$1(u, r, a) {
  for (var e, n, o, c, l, d, p, h, g = a.length(); g >= 64; ) {
    for (n = u.h0, o = u.h1, c = u.h2, l = u.h3, d = u.h4, h = 0; h < 16; ++h)
      e = a.getInt32(), r[h] = e, p = l ^ o & (c ^ l), e = (n << 5 | n >>> 27) + p + d + 1518500249 + e, d = l, l = c, c = (o << 30 | o >>> 2) >>> 0, o = n, n = e;
    for (; h < 20; ++h)
      e = r[h - 3] ^ r[h - 8] ^ r[h - 14] ^ r[h - 16], e = e << 1 | e >>> 31, r[h] = e, p = l ^ o & (c ^ l), e = (n << 5 | n >>> 27) + p + d + 1518500249 + e, d = l, l = c, c = (o << 30 | o >>> 2) >>> 0, o = n, n = e;
    for (; h < 32; ++h)
      e = r[h - 3] ^ r[h - 8] ^ r[h - 14] ^ r[h - 16], e = e << 1 | e >>> 31, r[h] = e, p = o ^ c ^ l, e = (n << 5 | n >>> 27) + p + d + 1859775393 + e, d = l, l = c, c = (o << 30 | o >>> 2) >>> 0, o = n, n = e;
    for (; h < 40; ++h)
      e = r[h - 6] ^ r[h - 16] ^ r[h - 28] ^ r[h - 32], e = e << 2 | e >>> 30, r[h] = e, p = o ^ c ^ l, e = (n << 5 | n >>> 27) + p + d + 1859775393 + e, d = l, l = c, c = (o << 30 | o >>> 2) >>> 0, o = n, n = e;
    for (; h < 60; ++h)
      e = r[h - 6] ^ r[h - 16] ^ r[h - 28] ^ r[h - 32], e = e << 2 | e >>> 30, r[h] = e, p = o & c | l & (o ^ c), e = (n << 5 | n >>> 27) + p + d + 2400959708 + e, d = l, l = c, c = (o << 30 | o >>> 2) >>> 0, o = n, n = e;
    for (; h < 80; ++h)
      e = r[h - 6] ^ r[h - 16] ^ r[h - 28] ^ r[h - 32], e = e << 2 | e >>> 30, r[h] = e, p = o ^ c ^ l, e = (n << 5 | n >>> 27) + p + d + 3395469782 + e, d = l, l = c, c = (o << 30 | o >>> 2) >>> 0, o = n, n = e;
    u.h0 = u.h0 + n | 0, u.h1 = u.h1 + o | 0, u.h2 = u.h2 + c | 0, u.h3 = u.h3 + l | 0, u.h4 = u.h4 + d | 0, g -= 64;
  }
}
var forge$j = forge$C, pkcs1 = forge$j.pkcs1 = forge$j.pkcs1 || {};
pkcs1.encode_rsa_oaep = function(u, r, a) {
  var e, n, o, c;
  typeof a == "string" ? (e = a, n = arguments[3] || void 0, o = arguments[4] || void 0) : a && (e = a.label || void 0, n = a.seed || void 0, o = a.md || void 0, a.mgf1 && a.mgf1.md && (c = a.mgf1.md)), o ? o.start() : o = forge$j.md.sha1.create(), c || (c = o);
  var l = Math.ceil(u.n.bitLength() / 8), d = l - 2 * o.digestLength - 2;
  if (r.length > d) {
    var p = new Error("RSAES-OAEP input message length is too long.");
    throw p.length = r.length, p.maxLength = d, p;
  }
  e || (e = ""), o.update(e, "raw");
  for (var h = o.digest(), g = "", y = d - r.length, v = 0; v < y; v++)
    g += "\0";
  var m = h.getBytes() + g + "" + r;
  if (!n)
    n = forge$j.random.getBytes(o.digestLength);
  else if (n.length !== o.digestLength) {
    var p = new Error("Invalid RSAES-OAEP seed. The seed length must match the digest length.");
    throw p.seedLength = n.length, p.digestLength = o.digestLength, p;
  }
  var b = rsa_mgf1(n, l - o.digestLength - 1, c), R = forge$j.util.xorBytes(m, b, m.length), $ = rsa_mgf1(R, o.digestLength, c), x = forge$j.util.xorBytes(n, $, n.length);
  return "\0" + x + R;
};
pkcs1.decode_rsa_oaep = function(u, r, a) {
  var e, n, o;
  typeof a == "string" ? (e = a, n = arguments[3] || void 0) : a && (e = a.label || void 0, n = a.md || void 0, a.mgf1 && a.mgf1.md && (o = a.mgf1.md));
  var c = Math.ceil(u.n.bitLength() / 8);
  if (r.length !== c) {
    var R = new Error("RSAES-OAEP encoded message length is invalid.");
    throw R.length = r.length, R.expectedLength = c, R;
  }
  if (n === void 0 ? n = forge$j.md.sha1.create() : n.start(), o || (o = n), c < 2 * n.digestLength + 2)
    throw new Error("RSAES-OAEP key is too short for the hash function.");
  e || (e = ""), n.update(e, "raw");
  for (var l = n.digest().getBytes(), d = r.charAt(0), p = r.substring(1, n.digestLength + 1), h = r.substring(1 + n.digestLength), g = rsa_mgf1(h, n.digestLength, o), y = forge$j.util.xorBytes(p, g, p.length), v = rsa_mgf1(y, c - n.digestLength - 1, o), m = forge$j.util.xorBytes(h, v, h.length), b = m.substring(0, n.digestLength), R = d !== "\0", $ = 0; $ < n.digestLength; ++$)
    R |= l.charAt($) !== b.charAt($);
  for (var x = 1, E = n.digestLength, T = n.digestLength; T < m.length; T++) {
    var P = m.charCodeAt(T), O = P & 1 ^ 1, w = x ? 65534 : 0;
    R |= P & w, x = x & O, E += x;
  }
  if (R || m.charCodeAt(E) !== 1)
    throw new Error("Invalid RSAES-OAEP padding.");
  return m.substring(E + 1);
};
function rsa_mgf1(u, r, a) {
  a || (a = forge$j.md.sha1.create());
  for (var e = "", n = Math.ceil(r / a.digestLength), o = 0; o < n; ++o) {
    var c = String.fromCharCode(
      o >> 24 & 255,
      o >> 16 & 255,
      o >> 8 & 255,
      o & 255
    );
    a.start(), a.update(u + c), e += a.digest().getBytes();
  }
  return e.substring(0, r);
}
var forge$i = forge$C;
(function() {
  if (forge$i.prime)
    return;
  var u = forge$i.prime = forge$i.prime || {}, r = forge$i.jsbn.BigInteger, a = [6, 4, 2, 4, 2, 4, 6, 2], e = new r(null);
  e.fromInt(30);
  var n = function(g, y) {
    return g | y;
  };
  u.generateProbablePrime = function(g, y, v) {
    typeof y == "function" && (v = y, y = {}), y = y || {};
    var m = y.algorithm || "PRIMEINC";
    typeof m == "string" && (m = { name: m }), m.options = m.options || {};
    var b = y.prng || forge$i.random, R = {
      // x is an array to fill with bytes
      nextBytes: function($) {
        for (var x = b.getBytesSync($.length), E = 0; E < $.length; ++E)
          $[E] = x.charCodeAt(E);
      }
    };
    if (m.name === "PRIMEINC")
      return o(g, R, m.options, v);
    throw new Error("Invalid prime generation algorithm: " + m.name);
  };
  function o(g, y, v, m) {
    return "workers" in v ? d(g, y, v, m) : c(g, y, v, m);
  }
  function c(g, y, v, m) {
    var b = p(g, y), R = 0, $ = h(b.bitLength());
    "millerRabinTests" in v && ($ = v.millerRabinTests);
    var x = 10;
    "maxBlockTime" in v && (x = v.maxBlockTime), l(b, g, y, R, $, x, m);
  }
  function l(g, y, v, m, b, R, $) {
    var x = +/* @__PURE__ */ new Date();
    do {
      if (g.bitLength() > y && (g = p(y, v)), g.isProbablePrime(b))
        return $(null, g);
      g.dAddOffset(a[m++ % 8], 0);
    } while (R < 0 || +/* @__PURE__ */ new Date() - x < R);
    forge$i.util.setImmediate(function() {
      l(g, y, v, m, b, R, $);
    });
  }
  function d(g, y, v, m) {
    if (typeof Worker > "u")
      return c(g, y, v, m);
    var b = p(g, y), R = v.workers, $ = v.workLoad || 100, x = $ * 30 / 8, E = v.workerScript || "forge/prime.worker.js";
    if (R === -1)
      return forge$i.util.estimateCores(function(P, O) {
        P && (O = 2), R = O - 1, T();
      });
    T();
    function T() {
      R = Math.max(1, R);
      for (var P = [], O = 0; O < R; ++O)
        P[O] = new Worker(E);
      for (var O = 0; O < R; ++O)
        P[O].addEventListener("message", _);
      var w = !1;
      function _(C) {
        if (!w) {
          var k = C.data;
          if (k.found) {
            for (var B = 0; B < P.length; ++B)
              P[B].terminate();
            return w = !0, m(null, new r(k.prime, 16));
          }
          b.bitLength() > g && (b = p(g, y));
          var j = b.toString(16);
          C.target.postMessage({
            hex: j,
            workLoad: $
          }), b.dAddOffset(x, 0);
        }
      }
    }
  }
  function p(g, y) {
    var v = new r(g, y), m = g - 1;
    return v.testBit(m) || v.bitwiseTo(r.ONE.shiftLeft(m), n, v), v.dAddOffset(31 - v.mod(e).byteValue(), 0), v;
  }
  function h(g) {
    return g <= 100 ? 27 : g <= 150 ? 18 : g <= 200 ? 15 : g <= 250 ? 12 : g <= 300 ? 9 : g <= 350 ? 8 : g <= 400 ? 7 : g <= 500 ? 6 : g <= 600 ? 5 : g <= 800 ? 4 : g <= 1250 ? 3 : 2;
  }
})();
var forge$h = forge$C;
if (typeof BigInteger$3 > "u")
  var BigInteger$3 = forge$h.jsbn.BigInteger;
var _crypto = forge$h.util.isNodejs ? require$$4 : null, asn1$7 = forge$h.asn1, util = forge$h.util;
forge$h.pki = forge$h.pki || {};
forge$h.pki.rsa = forge$h.rsa = forge$h.rsa || {};
var pki$4 = forge$h.pki, GCD_30_DELTA = [6, 4, 2, 4, 2, 4, 6, 2], privateKeyValidator$1 = {
  // PrivateKeyInfo
  name: "PrivateKeyInfo",
  tagClass: asn1$7.Class.UNIVERSAL,
  type: asn1$7.Type.SEQUENCE,
  constructed: !0,
  value: [{
    // Version (INTEGER)
    name: "PrivateKeyInfo.version",
    tagClass: asn1$7.Class.UNIVERSAL,
    type: asn1$7.Type.INTEGER,
    constructed: !1,
    capture: "privateKeyVersion"
  }, {
    // privateKeyAlgorithm
    name: "PrivateKeyInfo.privateKeyAlgorithm",
    tagClass: asn1$7.Class.UNIVERSAL,
    type: asn1$7.Type.SEQUENCE,
    constructed: !0,
    value: [{
      name: "AlgorithmIdentifier.algorithm",
      tagClass: asn1$7.Class.UNIVERSAL,
      type: asn1$7.Type.OID,
      constructed: !1,
      capture: "privateKeyOid"
    }]
  }, {
    // PrivateKey
    name: "PrivateKeyInfo",
    tagClass: asn1$7.Class.UNIVERSAL,
    type: asn1$7.Type.OCTETSTRING,
    constructed: !1,
    capture: "privateKey"
  }]
}, rsaPrivateKeyValidator = {
  // RSAPrivateKey
  name: "RSAPrivateKey",
  tagClass: asn1$7.Class.UNIVERSAL,
  type: asn1$7.Type.SEQUENCE,
  constructed: !0,
  value: [{
    // Version (INTEGER)
    name: "RSAPrivateKey.version",
    tagClass: asn1$7.Class.UNIVERSAL,
    type: asn1$7.Type.INTEGER,
    constructed: !1,
    capture: "privateKeyVersion"
  }, {
    // modulus (n)
    name: "RSAPrivateKey.modulus",
    tagClass: asn1$7.Class.UNIVERSAL,
    type: asn1$7.Type.INTEGER,
    constructed: !1,
    capture: "privateKeyModulus"
  }, {
    // publicExponent (e)
    name: "RSAPrivateKey.publicExponent",
    tagClass: asn1$7.Class.UNIVERSAL,
    type: asn1$7.Type.INTEGER,
    constructed: !1,
    capture: "privateKeyPublicExponent"
  }, {
    // privateExponent (d)
    name: "RSAPrivateKey.privateExponent",
    tagClass: asn1$7.Class.UNIVERSAL,
    type: asn1$7.Type.INTEGER,
    constructed: !1,
    capture: "privateKeyPrivateExponent"
  }, {
    // prime1 (p)
    name: "RSAPrivateKey.prime1",
    tagClass: asn1$7.Class.UNIVERSAL,
    type: asn1$7.Type.INTEGER,
    constructed: !1,
    capture: "privateKeyPrime1"
  }, {
    // prime2 (q)
    name: "RSAPrivateKey.prime2",
    tagClass: asn1$7.Class.UNIVERSAL,
    type: asn1$7.Type.INTEGER,
    constructed: !1,
    capture: "privateKeyPrime2"
  }, {
    // exponent1 (d mod (p-1))
    name: "RSAPrivateKey.exponent1",
    tagClass: asn1$7.Class.UNIVERSAL,
    type: asn1$7.Type.INTEGER,
    constructed: !1,
    capture: "privateKeyExponent1"
  }, {
    // exponent2 (d mod (q-1))
    name: "RSAPrivateKey.exponent2",
    tagClass: asn1$7.Class.UNIVERSAL,
    type: asn1$7.Type.INTEGER,
    constructed: !1,
    capture: "privateKeyExponent2"
  }, {
    // coefficient ((inverse of q) mod p)
    name: "RSAPrivateKey.coefficient",
    tagClass: asn1$7.Class.UNIVERSAL,
    type: asn1$7.Type.INTEGER,
    constructed: !1,
    capture: "privateKeyCoefficient"
  }]
}, rsaPublicKeyValidator = {
  // RSAPublicKey
  name: "RSAPublicKey",
  tagClass: asn1$7.Class.UNIVERSAL,
  type: asn1$7.Type.SEQUENCE,
  constructed: !0,
  value: [{
    // modulus (n)
    name: "RSAPublicKey.modulus",
    tagClass: asn1$7.Class.UNIVERSAL,
    type: asn1$7.Type.INTEGER,
    constructed: !1,
    capture: "publicKeyModulus"
  }, {
    // publicExponent (e)
    name: "RSAPublicKey.exponent",
    tagClass: asn1$7.Class.UNIVERSAL,
    type: asn1$7.Type.INTEGER,
    constructed: !1,
    capture: "publicKeyExponent"
  }]
}, publicKeyValidator$2 = forge$h.pki.rsa.publicKeyValidator = {
  name: "SubjectPublicKeyInfo",
  tagClass: asn1$7.Class.UNIVERSAL,
  type: asn1$7.Type.SEQUENCE,
  constructed: !0,
  captureAsn1: "subjectPublicKeyInfo",
  value: [{
    name: "SubjectPublicKeyInfo.AlgorithmIdentifier",
    tagClass: asn1$7.Class.UNIVERSAL,
    type: asn1$7.Type.SEQUENCE,
    constructed: !0,
    value: [{
      name: "AlgorithmIdentifier.algorithm",
      tagClass: asn1$7.Class.UNIVERSAL,
      type: asn1$7.Type.OID,
      constructed: !1,
      capture: "publicKeyOid"
    }]
  }, {
    // subjectPublicKey
    name: "SubjectPublicKeyInfo.subjectPublicKey",
    tagClass: asn1$7.Class.UNIVERSAL,
    type: asn1$7.Type.BITSTRING,
    constructed: !1,
    value: [{
      // RSAPublicKey
      name: "SubjectPublicKeyInfo.subjectPublicKey.RSAPublicKey",
      tagClass: asn1$7.Class.UNIVERSAL,
      type: asn1$7.Type.SEQUENCE,
      constructed: !0,
      optional: !0,
      captureAsn1: "rsaPublicKey"
    }]
  }]
}, digestInfoValidator = {
  name: "DigestInfo",
  tagClass: asn1$7.Class.UNIVERSAL,
  type: asn1$7.Type.SEQUENCE,
  constructed: !0,
  value: [{
    name: "DigestInfo.DigestAlgorithm",
    tagClass: asn1$7.Class.UNIVERSAL,
    type: asn1$7.Type.SEQUENCE,
    constructed: !0,
    value: [{
      name: "DigestInfo.DigestAlgorithm.algorithmIdentifier",
      tagClass: asn1$7.Class.UNIVERSAL,
      type: asn1$7.Type.OID,
      constructed: !1,
      capture: "algorithmIdentifier"
    }, {
      // NULL paramters
      name: "DigestInfo.DigestAlgorithm.parameters",
      tagClass: asn1$7.Class.UNIVERSAL,
      type: asn1$7.Type.NULL,
      // captured only to check existence for md2 and md5
      capture: "parameters",
      optional: !0,
      constructed: !1
    }]
  }, {
    // digest
    name: "DigestInfo.digest",
    tagClass: asn1$7.Class.UNIVERSAL,
    type: asn1$7.Type.OCTETSTRING,
    constructed: !1,
    capture: "digest"
  }]
}, emsaPkcs1v15encode = function(u) {
  var r;
  if (u.algorithm in pki$4.oids)
    r = pki$4.oids[u.algorithm];
  else {
    var a = new Error("Unknown message digest algorithm.");
    throw a.algorithm = u.algorithm, a;
  }
  var e = asn1$7.oidToDer(r).getBytes(), n = asn1$7.create(
    asn1$7.Class.UNIVERSAL,
    asn1$7.Type.SEQUENCE,
    !0,
    []
  ), o = asn1$7.create(
    asn1$7.Class.UNIVERSAL,
    asn1$7.Type.SEQUENCE,
    !0,
    []
  );
  o.value.push(asn1$7.create(
    asn1$7.Class.UNIVERSAL,
    asn1$7.Type.OID,
    !1,
    e
  )), o.value.push(asn1$7.create(
    asn1$7.Class.UNIVERSAL,
    asn1$7.Type.NULL,
    !1,
    ""
  ));
  var c = asn1$7.create(
    asn1$7.Class.UNIVERSAL,
    asn1$7.Type.OCTETSTRING,
    !1,
    u.digest().getBytes()
  );
  return n.value.push(o), n.value.push(c), asn1$7.toDer(n).getBytes();
}, _modPow = function(u, r, a) {
  if (a)
    return u.modPow(r.e, r.n);
  if (!r.p || !r.q)
    return u.modPow(r.d, r.n);
  r.dP || (r.dP = r.d.mod(r.p.subtract(BigInteger$3.ONE))), r.dQ || (r.dQ = r.d.mod(r.q.subtract(BigInteger$3.ONE))), r.qInv || (r.qInv = r.q.modInverse(r.p));
  var e;
  do
    e = new BigInteger$3(
      forge$h.util.bytesToHex(forge$h.random.getBytes(r.n.bitLength() / 8)),
      16
    );
  while (e.compareTo(r.n) >= 0 || !e.gcd(r.n).equals(BigInteger$3.ONE));
  u = u.multiply(e.modPow(r.e, r.n)).mod(r.n);
  for (var n = u.mod(r.p).modPow(r.dP, r.p), o = u.mod(r.q).modPow(r.dQ, r.q); n.compareTo(o) < 0; )
    n = n.add(r.p);
  var c = n.subtract(o).multiply(r.qInv).mod(r.p).multiply(r.q).add(o);
  return c = c.multiply(e.modInverse(r.n)).mod(r.n), c;
};
pki$4.rsa.encrypt = function(u, r, a) {
  var e = a, n, o = Math.ceil(r.n.bitLength() / 8);
  a !== !1 && a !== !0 ? (e = a === 2, n = _encodePkcs1_v1_5(u, r, a)) : (n = forge$h.util.createBuffer(), n.putBytes(u));
  for (var c = new BigInteger$3(n.toHex(), 16), l = _modPow(c, r, e), d = l.toString(16), p = forge$h.util.createBuffer(), h = o - Math.ceil(d.length / 2); h > 0; )
    p.putByte(0), --h;
  return p.putBytes(forge$h.util.hexToBytes(d)), p.getBytes();
};
pki$4.rsa.decrypt = function(u, r, a, e) {
  var n = Math.ceil(r.n.bitLength() / 8);
  if (u.length !== n) {
    var o = new Error("Encrypted message length is invalid.");
    throw o.length = u.length, o.expected = n, o;
  }
  var c = new BigInteger$3(forge$h.util.createBuffer(u).toHex(), 16);
  if (c.compareTo(r.n) >= 0)
    throw new Error("Encrypted message is invalid.");
  for (var l = _modPow(c, r, a), d = l.toString(16), p = forge$h.util.createBuffer(), h = n - Math.ceil(d.length / 2); h > 0; )
    p.putByte(0), --h;
  return p.putBytes(forge$h.util.hexToBytes(d)), e !== !1 ? _decodePkcs1_v1_5(p.getBytes(), r, a) : p.getBytes();
};
pki$4.rsa.createKeyPairGenerationState = function(u, r, a) {
  typeof u == "string" && (u = parseInt(u, 10)), u = u || 2048, a = a || {};
  var e = a.prng || forge$h.random, n = {
    // x is an array to fill with bytes
    nextBytes: function(l) {
      for (var d = e.getBytesSync(l.length), p = 0; p < l.length; ++p)
        l[p] = d.charCodeAt(p);
    }
  }, o = a.algorithm || "PRIMEINC", c;
  if (o === "PRIMEINC")
    c = {
      algorithm: o,
      state: 0,
      bits: u,
      rng: n,
      eInt: r || 65537,
      e: new BigInteger$3(null),
      p: null,
      q: null,
      qBits: u >> 1,
      pBits: u - (u >> 1),
      pqState: 0,
      num: null,
      keys: null
    }, c.e.fromInt(c.eInt);
  else
    throw new Error("Invalid key generation algorithm: " + o);
  return c;
};
pki$4.rsa.stepKeyPairGenerationState = function(u, r) {
  "algorithm" in u || (u.algorithm = "PRIMEINC");
  var a = new BigInteger$3(null);
  a.fromInt(30);
  for (var e = 0, n = function(g, y) {
    return g | y;
  }, o = +/* @__PURE__ */ new Date(), c, l = 0; u.keys === null && (r <= 0 || l < r); ) {
    if (u.state === 0) {
      var d = u.p === null ? u.pBits : u.qBits, p = d - 1;
      u.pqState === 0 ? (u.num = new BigInteger$3(d, u.rng), u.num.testBit(p) || u.num.bitwiseTo(
        BigInteger$3.ONE.shiftLeft(p),
        n,
        u.num
      ), u.num.dAddOffset(31 - u.num.mod(a).byteValue(), 0), e = 0, ++u.pqState) : u.pqState === 1 ? u.num.bitLength() > d ? u.pqState = 0 : u.num.isProbablePrime(
        _getMillerRabinTests(u.num.bitLength())
      ) ? ++u.pqState : u.num.dAddOffset(GCD_30_DELTA[e++ % 8], 0) : u.pqState === 2 ? u.pqState = u.num.subtract(BigInteger$3.ONE).gcd(u.e).compareTo(BigInteger$3.ONE) === 0 ? 3 : 0 : u.pqState === 3 && (u.pqState = 0, u.p === null ? u.p = u.num : u.q = u.num, u.p !== null && u.q !== null && ++u.state, u.num = null);
    } else if (u.state === 1)
      u.p.compareTo(u.q) < 0 && (u.num = u.p, u.p = u.q, u.q = u.num), ++u.state;
    else if (u.state === 2)
      u.p1 = u.p.subtract(BigInteger$3.ONE), u.q1 = u.q.subtract(BigInteger$3.ONE), u.phi = u.p1.multiply(u.q1), ++u.state;
    else if (u.state === 3)
      u.phi.gcd(u.e).compareTo(BigInteger$3.ONE) === 0 ? ++u.state : (u.p = null, u.q = null, u.state = 0);
    else if (u.state === 4)
      u.n = u.p.multiply(u.q), u.n.bitLength() === u.bits ? ++u.state : (u.q = null, u.state = 0);
    else if (u.state === 5) {
      var h = u.e.modInverse(u.phi);
      u.keys = {
        privateKey: pki$4.rsa.setPrivateKey(
          u.n,
          u.e,
          h,
          u.p,
          u.q,
          h.mod(u.p1),
          h.mod(u.q1),
          u.q.modInverse(u.p)
        ),
        publicKey: pki$4.rsa.setPublicKey(u.n, u.e)
      };
    }
    c = +/* @__PURE__ */ new Date(), l += c - o, o = c;
  }
  return u.keys !== null;
};
pki$4.rsa.generateKeyPair = function(u, r, a, e) {
  if (arguments.length === 1 ? typeof u == "object" ? (a = u, u = void 0) : typeof u == "function" && (e = u, u = void 0) : arguments.length === 2 ? typeof u == "number" ? typeof r == "function" ? (e = r, r = void 0) : typeof r != "number" && (a = r, r = void 0) : (a = u, e = r, u = void 0, r = void 0) : arguments.length === 3 && (typeof r == "number" ? typeof a == "function" && (e = a, a = void 0) : (e = a, a = r, r = void 0)), a = a || {}, u === void 0 && (u = a.bits || 2048), r === void 0 && (r = a.e || 65537), !a.prng && u >= 256 && u <= 16384 && (r === 65537 || r === 3)) {
    if (e) {
      if (_detectNodeCrypto("generateKeyPair"))
        return _crypto.generateKeyPair("rsa", {
          modulusLength: u,
          publicExponent: r,
          publicKeyEncoding: {
            type: "spki",
            format: "pem"
          },
          privateKeyEncoding: {
            type: "pkcs8",
            format: "pem"
          }
        }, function(l, d, p) {
          if (l)
            return e(l);
          e(null, {
            privateKey: pki$4.privateKeyFromPem(p),
            publicKey: pki$4.publicKeyFromPem(d)
          });
        });
      if (_detectSubtleCrypto("generateKey") && _detectSubtleCrypto("exportKey"))
        return util.globalScope.crypto.subtle.generateKey({
          name: "RSASSA-PKCS1-v1_5",
          modulusLength: u,
          publicExponent: _intToUint8Array(r),
          hash: { name: "SHA-256" }
        }, !0, ["sign", "verify"]).then(function(l) {
          return util.globalScope.crypto.subtle.exportKey(
            "pkcs8",
            l.privateKey
          );
        }).then(void 0, function(l) {
          e(l);
        }).then(function(l) {
          if (l) {
            var d = pki$4.privateKeyFromAsn1(
              asn1$7.fromDer(forge$h.util.createBuffer(l))
            );
            e(null, {
              privateKey: d,
              publicKey: pki$4.setRsaPublicKey(d.n, d.e)
            });
          }
        });
      if (_detectSubtleMsCrypto("generateKey") && _detectSubtleMsCrypto("exportKey")) {
        var n = util.globalScope.msCrypto.subtle.generateKey({
          name: "RSASSA-PKCS1-v1_5",
          modulusLength: u,
          publicExponent: _intToUint8Array(r),
          hash: { name: "SHA-256" }
        }, !0, ["sign", "verify"]);
        n.oncomplete = function(l) {
          var d = l.target.result, p = util.globalScope.msCrypto.subtle.exportKey(
            "pkcs8",
            d.privateKey
          );
          p.oncomplete = function(h) {
            var g = h.target.result, y = pki$4.privateKeyFromAsn1(
              asn1$7.fromDer(forge$h.util.createBuffer(g))
            );
            e(null, {
              privateKey: y,
              publicKey: pki$4.setRsaPublicKey(y.n, y.e)
            });
          }, p.onerror = function(h) {
            e(h);
          };
        }, n.onerror = function(l) {
          e(l);
        };
        return;
      }
    } else if (_detectNodeCrypto("generateKeyPairSync")) {
      var o = _crypto.generateKeyPairSync("rsa", {
        modulusLength: u,
        publicExponent: r,
        publicKeyEncoding: {
          type: "spki",
          format: "pem"
        },
        privateKeyEncoding: {
          type: "pkcs8",
          format: "pem"
        }
      });
      return {
        privateKey: pki$4.privateKeyFromPem(o.privateKey),
        publicKey: pki$4.publicKeyFromPem(o.publicKey)
      };
    }
  }
  var c = pki$4.rsa.createKeyPairGenerationState(u, r, a);
  if (!e)
    return pki$4.rsa.stepKeyPairGenerationState(c, 0), c.keys;
  _generateKeyPair(c, a, e);
};
pki$4.setRsaPublicKey = pki$4.rsa.setPublicKey = function(u, r) {
  var a = {
    n: u,
    e: r
  };
  return a.encrypt = function(e, n, o) {
    if (typeof n == "string" ? n = n.toUpperCase() : n === void 0 && (n = "RSAES-PKCS1-V1_5"), n === "RSAES-PKCS1-V1_5")
      n = {
        encode: function(l, d, p) {
          return _encodePkcs1_v1_5(l, d, 2).getBytes();
        }
      };
    else if (n === "RSA-OAEP" || n === "RSAES-OAEP")
      n = {
        encode: function(l, d) {
          return forge$h.pkcs1.encode_rsa_oaep(d, l, o);
        }
      };
    else if (["RAW", "NONE", "NULL", null].indexOf(n) !== -1)
      n = { encode: function(l) {
        return l;
      } };
    else if (typeof n == "string")
      throw new Error('Unsupported encryption scheme: "' + n + '".');
    var c = n.encode(e, a, !0);
    return pki$4.rsa.encrypt(c, a, !0);
  }, a.verify = function(e, n, o, c) {
    typeof o == "string" ? o = o.toUpperCase() : o === void 0 && (o = "RSASSA-PKCS1-V1_5"), c === void 0 && (c = {
      _parseAllDigestBytes: !0
    }), "_parseAllDigestBytes" in c || (c._parseAllDigestBytes = !0), o === "RSASSA-PKCS1-V1_5" ? o = {
      verify: function(d, p) {
        p = _decodePkcs1_v1_5(p, a, !0);
        var h = asn1$7.fromDer(p, {
          parseAllBytes: c._parseAllDigestBytes
        }), g = {}, y = [];
        if (!asn1$7.validate(h, digestInfoValidator, g, y)) {
          var v = new Error(
            "ASN.1 object does not contain a valid RSASSA-PKCS1-v1_5 DigestInfo value."
          );
          throw v.errors = y, v;
        }
        var m = asn1$7.derToOid(g.algorithmIdentifier);
        if (!(m === forge$h.oids.md2 || m === forge$h.oids.md5 || m === forge$h.oids.sha1 || m === forge$h.oids.sha224 || m === forge$h.oids.sha256 || m === forge$h.oids.sha384 || m === forge$h.oids.sha512 || m === forge$h.oids["sha512-224"] || m === forge$h.oids["sha512-256"])) {
          var v = new Error(
            "Unknown RSASSA-PKCS1-v1_5 DigestAlgorithm identifier."
          );
          throw v.oid = m, v;
        }
        if ((m === forge$h.oids.md2 || m === forge$h.oids.md5) && !("parameters" in g))
          throw new Error(
            "ASN.1 object does not contain a valid RSASSA-PKCS1-v1_5 DigestInfo value. Missing algorithm identifer NULL parameters."
          );
        return d === g.digest;
      }
    } : (o === "NONE" || o === "NULL" || o === null) && (o = {
      verify: function(d, p) {
        return p = _decodePkcs1_v1_5(p, a, !0), d === p;
      }
    });
    var l = pki$4.rsa.decrypt(n, a, !0, !1);
    return o.verify(e, l, a.n.bitLength());
  }, a;
};
pki$4.setRsaPrivateKey = pki$4.rsa.setPrivateKey = function(u, r, a, e, n, o, c, l) {
  var d = {
    n: u,
    e: r,
    d: a,
    p: e,
    q: n,
    dP: o,
    dQ: c,
    qInv: l
  };
  return d.decrypt = function(p, h, g) {
    typeof h == "string" ? h = h.toUpperCase() : h === void 0 && (h = "RSAES-PKCS1-V1_5");
    var y = pki$4.rsa.decrypt(p, d, !1, !1);
    if (h === "RSAES-PKCS1-V1_5")
      h = { decode: _decodePkcs1_v1_5 };
    else if (h === "RSA-OAEP" || h === "RSAES-OAEP")
      h = {
        decode: function(v, m) {
          return forge$h.pkcs1.decode_rsa_oaep(m, v, g);
        }
      };
    else if (["RAW", "NONE", "NULL", null].indexOf(h) !== -1)
      h = { decode: function(v) {
        return v;
      } };
    else
      throw new Error('Unsupported encryption scheme: "' + h + '".');
    return h.decode(y, d, !1);
  }, d.sign = function(p, h) {
    var g = !1;
    typeof h == "string" && (h = h.toUpperCase()), h === void 0 || h === "RSASSA-PKCS1-V1_5" ? (h = { encode: emsaPkcs1v15encode }, g = 1) : (h === "NONE" || h === "NULL" || h === null) && (h = { encode: function() {
      return p;
    } }, g = 1);
    var y = h.encode(p, d.n.bitLength());
    return pki$4.rsa.encrypt(y, d, g);
  }, d;
};
pki$4.wrapRsaPrivateKey = function(u) {
  return asn1$7.create(asn1$7.Class.UNIVERSAL, asn1$7.Type.SEQUENCE, !0, [
    // version (0)
    asn1$7.create(
      asn1$7.Class.UNIVERSAL,
      asn1$7.Type.INTEGER,
      !1,
      asn1$7.integerToDer(0).getBytes()
    ),
    // privateKeyAlgorithm
    asn1$7.create(asn1$7.Class.UNIVERSAL, asn1$7.Type.SEQUENCE, !0, [
      asn1$7.create(
        asn1$7.Class.UNIVERSAL,
        asn1$7.Type.OID,
        !1,
        asn1$7.oidToDer(pki$4.oids.rsaEncryption).getBytes()
      ),
      asn1$7.create(asn1$7.Class.UNIVERSAL, asn1$7.Type.NULL, !1, "")
    ]),
    // PrivateKey
    asn1$7.create(
      asn1$7.Class.UNIVERSAL,
      asn1$7.Type.OCTETSTRING,
      !1,
      asn1$7.toDer(u).getBytes()
    )
  ]);
};
pki$4.privateKeyFromAsn1 = function(u) {
  var r = {}, a = [];
  if (asn1$7.validate(u, privateKeyValidator$1, r, a) && (u = asn1$7.fromDer(forge$h.util.createBuffer(r.privateKey))), r = {}, a = [], !asn1$7.validate(u, rsaPrivateKeyValidator, r, a)) {
    var e = new Error("Cannot read private key. ASN.1 object does not contain an RSAPrivateKey.");
    throw e.errors = a, e;
  }
  var n, o, c, l, d, p, h, g;
  return n = forge$h.util.createBuffer(r.privateKeyModulus).toHex(), o = forge$h.util.createBuffer(r.privateKeyPublicExponent).toHex(), c = forge$h.util.createBuffer(r.privateKeyPrivateExponent).toHex(), l = forge$h.util.createBuffer(r.privateKeyPrime1).toHex(), d = forge$h.util.createBuffer(r.privateKeyPrime2).toHex(), p = forge$h.util.createBuffer(r.privateKeyExponent1).toHex(), h = forge$h.util.createBuffer(r.privateKeyExponent2).toHex(), g = forge$h.util.createBuffer(r.privateKeyCoefficient).toHex(), pki$4.setRsaPrivateKey(
    new BigInteger$3(n, 16),
    new BigInteger$3(o, 16),
    new BigInteger$3(c, 16),
    new BigInteger$3(l, 16),
    new BigInteger$3(d, 16),
    new BigInteger$3(p, 16),
    new BigInteger$3(h, 16),
    new BigInteger$3(g, 16)
  );
};
pki$4.privateKeyToAsn1 = pki$4.privateKeyToRSAPrivateKey = function(u) {
  return asn1$7.create(asn1$7.Class.UNIVERSAL, asn1$7.Type.SEQUENCE, !0, [
    // version (0 = only 2 primes, 1 multiple primes)
    asn1$7.create(
      asn1$7.Class.UNIVERSAL,
      asn1$7.Type.INTEGER,
      !1,
      asn1$7.integerToDer(0).getBytes()
    ),
    // modulus (n)
    asn1$7.create(
      asn1$7.Class.UNIVERSAL,
      asn1$7.Type.INTEGER,
      !1,
      _bnToBytes(u.n)
    ),
    // publicExponent (e)
    asn1$7.create(
      asn1$7.Class.UNIVERSAL,
      asn1$7.Type.INTEGER,
      !1,
      _bnToBytes(u.e)
    ),
    // privateExponent (d)
    asn1$7.create(
      asn1$7.Class.UNIVERSAL,
      asn1$7.Type.INTEGER,
      !1,
      _bnToBytes(u.d)
    ),
    // privateKeyPrime1 (p)
    asn1$7.create(
      asn1$7.Class.UNIVERSAL,
      asn1$7.Type.INTEGER,
      !1,
      _bnToBytes(u.p)
    ),
    // privateKeyPrime2 (q)
    asn1$7.create(
      asn1$7.Class.UNIVERSAL,
      asn1$7.Type.INTEGER,
      !1,
      _bnToBytes(u.q)
    ),
    // privateKeyExponent1 (dP)
    asn1$7.create(
      asn1$7.Class.UNIVERSAL,
      asn1$7.Type.INTEGER,
      !1,
      _bnToBytes(u.dP)
    ),
    // privateKeyExponent2 (dQ)
    asn1$7.create(
      asn1$7.Class.UNIVERSAL,
      asn1$7.Type.INTEGER,
      !1,
      _bnToBytes(u.dQ)
    ),
    // coefficient (qInv)
    asn1$7.create(
      asn1$7.Class.UNIVERSAL,
      asn1$7.Type.INTEGER,
      !1,
      _bnToBytes(u.qInv)
    )
  ]);
};
pki$4.publicKeyFromAsn1 = function(u) {
  var r = {}, a = [];
  if (asn1$7.validate(u, publicKeyValidator$2, r, a)) {
    var e = asn1$7.derToOid(r.publicKeyOid);
    if (e !== pki$4.oids.rsaEncryption) {
      var n = new Error("Cannot read public key. Unknown OID.");
      throw n.oid = e, n;
    }
    u = r.rsaPublicKey;
  }
  if (a = [], !asn1$7.validate(u, rsaPublicKeyValidator, r, a)) {
    var n = new Error("Cannot read public key. ASN.1 object does not contain an RSAPublicKey.");
    throw n.errors = a, n;
  }
  var o = forge$h.util.createBuffer(r.publicKeyModulus).toHex(), c = forge$h.util.createBuffer(r.publicKeyExponent).toHex();
  return pki$4.setRsaPublicKey(
    new BigInteger$3(o, 16),
    new BigInteger$3(c, 16)
  );
};
pki$4.publicKeyToAsn1 = pki$4.publicKeyToSubjectPublicKeyInfo = function(u) {
  return asn1$7.create(asn1$7.Class.UNIVERSAL, asn1$7.Type.SEQUENCE, !0, [
    // AlgorithmIdentifier
    asn1$7.create(asn1$7.Class.UNIVERSAL, asn1$7.Type.SEQUENCE, !0, [
      // algorithm
      asn1$7.create(
        asn1$7.Class.UNIVERSAL,
        asn1$7.Type.OID,
        !1,
        asn1$7.oidToDer(pki$4.oids.rsaEncryption).getBytes()
      ),
      // parameters (null)
      asn1$7.create(asn1$7.Class.UNIVERSAL, asn1$7.Type.NULL, !1, "")
    ]),
    // subjectPublicKey
    asn1$7.create(asn1$7.Class.UNIVERSAL, asn1$7.Type.BITSTRING, !1, [
      pki$4.publicKeyToRSAPublicKey(u)
    ])
  ]);
};
pki$4.publicKeyToRSAPublicKey = function(u) {
  return asn1$7.create(asn1$7.Class.UNIVERSAL, asn1$7.Type.SEQUENCE, !0, [
    // modulus (n)
    asn1$7.create(
      asn1$7.Class.UNIVERSAL,
      asn1$7.Type.INTEGER,
      !1,
      _bnToBytes(u.n)
    ),
    // publicExponent (e)
    asn1$7.create(
      asn1$7.Class.UNIVERSAL,
      asn1$7.Type.INTEGER,
      !1,
      _bnToBytes(u.e)
    )
  ]);
};
function _encodePkcs1_v1_5(u, r, a) {
  var e = forge$h.util.createBuffer(), n = Math.ceil(r.n.bitLength() / 8);
  if (u.length > n - 11) {
    var o = new Error("Message is too long for PKCS#1 v1.5 padding.");
    throw o.length = u.length, o.max = n - 11, o;
  }
  e.putByte(0), e.putByte(a);
  var c = n - 3 - u.length, l;
  if (a === 0 || a === 1) {
    l = a === 0 ? 0 : 255;
    for (var d = 0; d < c; ++d)
      e.putByte(l);
  } else
    for (; c > 0; ) {
      for (var p = 0, h = forge$h.random.getBytes(c), d = 0; d < c; ++d)
        l = h.charCodeAt(d), l === 0 ? ++p : e.putByte(l);
      c = p;
    }
  return e.putByte(0), e.putBytes(u), e;
}
function _decodePkcs1_v1_5(u, r, a, e) {
  var n = Math.ceil(r.n.bitLength() / 8), o = forge$h.util.createBuffer(u), c = o.getByte(), l = o.getByte();
  if (c !== 0 || a && l !== 0 && l !== 1 || !a && l != 2 || a && l === 0 && typeof e > "u")
    throw new Error("Encryption block is invalid.");
  var d = 0;
  if (l === 0) {
    d = n - 3 - e;
    for (var p = 0; p < d; ++p)
      if (o.getByte() !== 0)
        throw new Error("Encryption block is invalid.");
  } else if (l === 1)
    for (d = 0; o.length() > 1; ) {
      if (o.getByte() !== 255) {
        --o.read;
        break;
      }
      ++d;
    }
  else if (l === 2)
    for (d = 0; o.length() > 1; ) {
      if (o.getByte() === 0) {
        --o.read;
        break;
      }
      ++d;
    }
  var h = o.getByte();
  if (h !== 0 || d !== n - 3 - o.length())
    throw new Error("Encryption block is invalid.");
  return o.getBytes();
}
function _generateKeyPair(u, r, a) {
  typeof r == "function" && (a = r, r = {}), r = r || {};
  var e = {
    algorithm: {
      name: r.algorithm || "PRIMEINC",
      options: {
        workers: r.workers || 2,
        workLoad: r.workLoad || 100,
        workerScript: r.workerScript
      }
    }
  };
  "prng" in r && (e.prng = r.prng), n();
  function n() {
    o(u.pBits, function(l, d) {
      if (l)
        return a(l);
      if (u.p = d, u.q !== null)
        return c(l, u.q);
      o(u.qBits, c);
    });
  }
  function o(l, d) {
    forge$h.prime.generateProbablePrime(l, e, d);
  }
  function c(l, d) {
    if (l)
      return a(l);
    if (u.q = d, u.p.compareTo(u.q) < 0) {
      var p = u.p;
      u.p = u.q, u.q = p;
    }
    if (u.p.subtract(BigInteger$3.ONE).gcd(u.e).compareTo(BigInteger$3.ONE) !== 0) {
      u.p = null, n();
      return;
    }
    if (u.q.subtract(BigInteger$3.ONE).gcd(u.e).compareTo(BigInteger$3.ONE) !== 0) {
      u.q = null, o(u.qBits, c);
      return;
    }
    if (u.p1 = u.p.subtract(BigInteger$3.ONE), u.q1 = u.q.subtract(BigInteger$3.ONE), u.phi = u.p1.multiply(u.q1), u.phi.gcd(u.e).compareTo(BigInteger$3.ONE) !== 0) {
      u.p = u.q = null, n();
      return;
    }
    if (u.n = u.p.multiply(u.q), u.n.bitLength() !== u.bits) {
      u.q = null, o(u.qBits, c);
      return;
    }
    var h = u.e.modInverse(u.phi);
    u.keys = {
      privateKey: pki$4.rsa.setPrivateKey(
        u.n,
        u.e,
        h,
        u.p,
        u.q,
        h.mod(u.p1),
        h.mod(u.q1),
        u.q.modInverse(u.p)
      ),
      publicKey: pki$4.rsa.setPublicKey(u.n, u.e)
    }, a(null, u.keys);
  }
}
function _bnToBytes(u) {
  var r = u.toString(16);
  r[0] >= "8" && (r = "00" + r);
  var a = forge$h.util.hexToBytes(r);
  return a.length > 1 && // leading 0x00 for positive integer
  (a.charCodeAt(0) === 0 && !(a.charCodeAt(1) & 128) || // leading 0xFF for negative integer
  a.charCodeAt(0) === 255 && (a.charCodeAt(1) & 128) === 128) ? a.substr(1) : a;
}
function _getMillerRabinTests(u) {
  return u <= 100 ? 27 : u <= 150 ? 18 : u <= 200 ? 15 : u <= 250 ? 12 : u <= 300 ? 9 : u <= 350 ? 8 : u <= 400 ? 7 : u <= 500 ? 6 : u <= 600 ? 5 : u <= 800 ? 4 : u <= 1250 ? 3 : 2;
}
function _detectNodeCrypto(u) {
  return forge$h.util.isNodejs && typeof _crypto[u] == "function";
}
function _detectSubtleCrypto(u) {
  return typeof util.globalScope < "u" && typeof util.globalScope.crypto == "object" && typeof util.globalScope.crypto.subtle == "object" && typeof util.globalScope.crypto.subtle[u] == "function";
}
function _detectSubtleMsCrypto(u) {
  return typeof util.globalScope < "u" && typeof util.globalScope.msCrypto == "object" && typeof util.globalScope.msCrypto.subtle == "object" && typeof util.globalScope.msCrypto.subtle[u] == "function";
}
function _intToUint8Array(u) {
  for (var r = forge$h.util.hexToBytes(u.toString(16)), a = new Uint8Array(r.length), e = 0; e < r.length; ++e)
    a[e] = r.charCodeAt(e);
  return a;
}
var forge$g = forge$C;
if (typeof BigInteger$2 > "u")
  var BigInteger$2 = forge$g.jsbn.BigInteger;
var asn1$6 = forge$g.asn1, pki$3 = forge$g.pki = forge$g.pki || {};
pki$3.pbe = forge$g.pbe = forge$g.pbe || {};
var oids$1 = pki$3.oids, encryptedPrivateKeyValidator = {
  name: "EncryptedPrivateKeyInfo",
  tagClass: asn1$6.Class.UNIVERSAL,
  type: asn1$6.Type.SEQUENCE,
  constructed: !0,
  value: [{
    name: "EncryptedPrivateKeyInfo.encryptionAlgorithm",
    tagClass: asn1$6.Class.UNIVERSAL,
    type: asn1$6.Type.SEQUENCE,
    constructed: !0,
    value: [{
      name: "AlgorithmIdentifier.algorithm",
      tagClass: asn1$6.Class.UNIVERSAL,
      type: asn1$6.Type.OID,
      constructed: !1,
      capture: "encryptionOid"
    }, {
      name: "AlgorithmIdentifier.parameters",
      tagClass: asn1$6.Class.UNIVERSAL,
      type: asn1$6.Type.SEQUENCE,
      constructed: !0,
      captureAsn1: "encryptionParams"
    }]
  }, {
    // encryptedData
    name: "EncryptedPrivateKeyInfo.encryptedData",
    tagClass: asn1$6.Class.UNIVERSAL,
    type: asn1$6.Type.OCTETSTRING,
    constructed: !1,
    capture: "encryptedData"
  }]
}, PBES2AlgorithmsValidator = {
  name: "PBES2Algorithms",
  tagClass: asn1$6.Class.UNIVERSAL,
  type: asn1$6.Type.SEQUENCE,
  constructed: !0,
  value: [{
    name: "PBES2Algorithms.keyDerivationFunc",
    tagClass: asn1$6.Class.UNIVERSAL,
    type: asn1$6.Type.SEQUENCE,
    constructed: !0,
    value: [{
      name: "PBES2Algorithms.keyDerivationFunc.oid",
      tagClass: asn1$6.Class.UNIVERSAL,
      type: asn1$6.Type.OID,
      constructed: !1,
      capture: "kdfOid"
    }, {
      name: "PBES2Algorithms.params",
      tagClass: asn1$6.Class.UNIVERSAL,
      type: asn1$6.Type.SEQUENCE,
      constructed: !0,
      value: [{
        name: "PBES2Algorithms.params.salt",
        tagClass: asn1$6.Class.UNIVERSAL,
        type: asn1$6.Type.OCTETSTRING,
        constructed: !1,
        capture: "kdfSalt"
      }, {
        name: "PBES2Algorithms.params.iterationCount",
        tagClass: asn1$6.Class.UNIVERSAL,
        type: asn1$6.Type.INTEGER,
        constructed: !1,
        capture: "kdfIterationCount"
      }, {
        name: "PBES2Algorithms.params.keyLength",
        tagClass: asn1$6.Class.UNIVERSAL,
        type: asn1$6.Type.INTEGER,
        constructed: !1,
        optional: !0,
        capture: "keyLength"
      }, {
        // prf
        name: "PBES2Algorithms.params.prf",
        tagClass: asn1$6.Class.UNIVERSAL,
        type: asn1$6.Type.SEQUENCE,
        constructed: !0,
        optional: !0,
        value: [{
          name: "PBES2Algorithms.params.prf.algorithm",
          tagClass: asn1$6.Class.UNIVERSAL,
          type: asn1$6.Type.OID,
          constructed: !1,
          capture: "prfOid"
        }]
      }]
    }]
  }, {
    name: "PBES2Algorithms.encryptionScheme",
    tagClass: asn1$6.Class.UNIVERSAL,
    type: asn1$6.Type.SEQUENCE,
    constructed: !0,
    value: [{
      name: "PBES2Algorithms.encryptionScheme.oid",
      tagClass: asn1$6.Class.UNIVERSAL,
      type: asn1$6.Type.OID,
      constructed: !1,
      capture: "encOid"
    }, {
      name: "PBES2Algorithms.encryptionScheme.iv",
      tagClass: asn1$6.Class.UNIVERSAL,
      type: asn1$6.Type.OCTETSTRING,
      constructed: !1,
      capture: "encIv"
    }]
  }]
}, pkcs12PbeParamsValidator = {
  name: "pkcs-12PbeParams",
  tagClass: asn1$6.Class.UNIVERSAL,
  type: asn1$6.Type.SEQUENCE,
  constructed: !0,
  value: [{
    name: "pkcs-12PbeParams.salt",
    tagClass: asn1$6.Class.UNIVERSAL,
    type: asn1$6.Type.OCTETSTRING,
    constructed: !1,
    capture: "salt"
  }, {
    name: "pkcs-12PbeParams.iterations",
    tagClass: asn1$6.Class.UNIVERSAL,
    type: asn1$6.Type.INTEGER,
    constructed: !1,
    capture: "iterations"
  }]
};
pki$3.encryptPrivateKeyInfo = function(u, r, a) {
  a = a || {}, a.saltSize = a.saltSize || 8, a.count = a.count || 2048, a.algorithm = a.algorithm || "aes128", a.prfAlgorithm = a.prfAlgorithm || "sha1";
  var e = forge$g.random.getBytesSync(a.saltSize), n = a.count, o = asn1$6.integerToDer(n), c, l, d;
  if (a.algorithm.indexOf("aes") === 0 || a.algorithm === "des") {
    var p, h, g;
    switch (a.algorithm) {
      case "aes128":
        c = 16, p = 16, h = oids$1["aes128-CBC"], g = forge$g.aes.createEncryptionCipher;
        break;
      case "aes192":
        c = 24, p = 16, h = oids$1["aes192-CBC"], g = forge$g.aes.createEncryptionCipher;
        break;
      case "aes256":
        c = 32, p = 16, h = oids$1["aes256-CBC"], g = forge$g.aes.createEncryptionCipher;
        break;
      case "des":
        c = 8, p = 8, h = oids$1.desCBC, g = forge$g.des.createEncryptionCipher;
        break;
      default:
        var y = new Error("Cannot encrypt private key. Unknown encryption algorithm.");
        throw y.algorithm = a.algorithm, y;
    }
    var v = "hmacWith" + a.prfAlgorithm.toUpperCase(), m = prfAlgorithmToMessageDigest(v), b = forge$g.pkcs5.pbkdf2(r, e, n, c, m), R = forge$g.random.getBytesSync(p), $ = g(b);
    $.start(R), $.update(asn1$6.toDer(u)), $.finish(), d = $.output.getBytes();
    var x = createPbkdf2Params(e, o, c, v);
    l = asn1$6.create(
      asn1$6.Class.UNIVERSAL,
      asn1$6.Type.SEQUENCE,
      !0,
      [
        asn1$6.create(
          asn1$6.Class.UNIVERSAL,
          asn1$6.Type.OID,
          !1,
          asn1$6.oidToDer(oids$1.pkcs5PBES2).getBytes()
        ),
        asn1$6.create(asn1$6.Class.UNIVERSAL, asn1$6.Type.SEQUENCE, !0, [
          // keyDerivationFunc
          asn1$6.create(asn1$6.Class.UNIVERSAL, asn1$6.Type.SEQUENCE, !0, [
            asn1$6.create(
              asn1$6.Class.UNIVERSAL,
              asn1$6.Type.OID,
              !1,
              asn1$6.oidToDer(oids$1.pkcs5PBKDF2).getBytes()
            ),
            // PBKDF2-params
            x
          ]),
          // encryptionScheme
          asn1$6.create(asn1$6.Class.UNIVERSAL, asn1$6.Type.SEQUENCE, !0, [
            asn1$6.create(
              asn1$6.Class.UNIVERSAL,
              asn1$6.Type.OID,
              !1,
              asn1$6.oidToDer(h).getBytes()
            ),
            // iv
            asn1$6.create(
              asn1$6.Class.UNIVERSAL,
              asn1$6.Type.OCTETSTRING,
              !1,
              R
            )
          ])
        ])
      ]
    );
  } else if (a.algorithm === "3des") {
    c = 24;
    var E = new forge$g.util.ByteBuffer(e), b = pki$3.pbe.generatePkcs12Key(r, E, 1, n, c), R = pki$3.pbe.generatePkcs12Key(r, E, 2, n, c), $ = forge$g.des.createEncryptionCipher(b);
    $.start(R), $.update(asn1$6.toDer(u)), $.finish(), d = $.output.getBytes(), l = asn1$6.create(
      asn1$6.Class.UNIVERSAL,
      asn1$6.Type.SEQUENCE,
      !0,
      [
        asn1$6.create(
          asn1$6.Class.UNIVERSAL,
          asn1$6.Type.OID,
          !1,
          asn1$6.oidToDer(oids$1["pbeWithSHAAnd3-KeyTripleDES-CBC"]).getBytes()
        ),
        // pkcs-12PbeParams
        asn1$6.create(asn1$6.Class.UNIVERSAL, asn1$6.Type.SEQUENCE, !0, [
          // salt
          asn1$6.create(asn1$6.Class.UNIVERSAL, asn1$6.Type.OCTETSTRING, !1, e),
          // iteration count
          asn1$6.create(
            asn1$6.Class.UNIVERSAL,
            asn1$6.Type.INTEGER,
            !1,
            o.getBytes()
          )
        ])
      ]
    );
  } else {
    var y = new Error("Cannot encrypt private key. Unknown encryption algorithm.");
    throw y.algorithm = a.algorithm, y;
  }
  var T = asn1$6.create(asn1$6.Class.UNIVERSAL, asn1$6.Type.SEQUENCE, !0, [
    // encryptionAlgorithm
    l,
    // encryptedData
    asn1$6.create(
      asn1$6.Class.UNIVERSAL,
      asn1$6.Type.OCTETSTRING,
      !1,
      d
    )
  ]);
  return T;
};
pki$3.decryptPrivateKeyInfo = function(u, r) {
  var a = null, e = {}, n = [];
  if (!asn1$6.validate(u, encryptedPrivateKeyValidator, e, n)) {
    var o = new Error("Cannot read encrypted private key. ASN.1 object is not a supported EncryptedPrivateKeyInfo.");
    throw o.errors = n, o;
  }
  var c = asn1$6.derToOid(e.encryptionOid), l = pki$3.pbe.getCipher(c, e.encryptionParams, r), d = forge$g.util.createBuffer(e.encryptedData);
  return l.update(d), l.finish() && (a = asn1$6.fromDer(l.output)), a;
};
pki$3.encryptedPrivateKeyToPem = function(u, r) {
  var a = {
    type: "ENCRYPTED PRIVATE KEY",
    body: asn1$6.toDer(u).getBytes()
  };
  return forge$g.pem.encode(a, { maxline: r });
};
pki$3.encryptedPrivateKeyFromPem = function(u) {
  var r = forge$g.pem.decode(u)[0];
  if (r.type !== "ENCRYPTED PRIVATE KEY") {
    var a = new Error('Could not convert encrypted private key from PEM; PEM header type is "ENCRYPTED PRIVATE KEY".');
    throw a.headerType = r.type, a;
  }
  if (r.procType && r.procType.type === "ENCRYPTED")
    throw new Error("Could not convert encrypted private key from PEM; PEM is encrypted.");
  return asn1$6.fromDer(r.body);
};
pki$3.encryptRsaPrivateKey = function(u, r, a) {
  if (a = a || {}, !a.legacy) {
    var e = pki$3.wrapRsaPrivateKey(pki$3.privateKeyToAsn1(u));
    return e = pki$3.encryptPrivateKeyInfo(e, r, a), pki$3.encryptedPrivateKeyToPem(e);
  }
  var n, o, c, l;
  switch (a.algorithm) {
    case "aes128":
      n = "AES-128-CBC", c = 16, o = forge$g.random.getBytesSync(16), l = forge$g.aes.createEncryptionCipher;
      break;
    case "aes192":
      n = "AES-192-CBC", c = 24, o = forge$g.random.getBytesSync(16), l = forge$g.aes.createEncryptionCipher;
      break;
    case "aes256":
      n = "AES-256-CBC", c = 32, o = forge$g.random.getBytesSync(16), l = forge$g.aes.createEncryptionCipher;
      break;
    case "3des":
      n = "DES-EDE3-CBC", c = 24, o = forge$g.random.getBytesSync(8), l = forge$g.des.createEncryptionCipher;
      break;
    case "des":
      n = "DES-CBC", c = 8, o = forge$g.random.getBytesSync(8), l = forge$g.des.createEncryptionCipher;
      break;
    default:
      var d = new Error('Could not encrypt RSA private key; unsupported encryption algorithm "' + a.algorithm + '".');
      throw d.algorithm = a.algorithm, d;
  }
  var p = forge$g.pbe.opensslDeriveBytes(r, o.substr(0, 8), c), h = l(p);
  h.start(o), h.update(asn1$6.toDer(pki$3.privateKeyToAsn1(u))), h.finish();
  var g = {
    type: "RSA PRIVATE KEY",
    procType: {
      version: "4",
      type: "ENCRYPTED"
    },
    dekInfo: {
      algorithm: n,
      parameters: forge$g.util.bytesToHex(o).toUpperCase()
    },
    body: h.output.getBytes()
  };
  return forge$g.pem.encode(g);
};
pki$3.decryptRsaPrivateKey = function(u, r) {
  var a = null, e = forge$g.pem.decode(u)[0];
  if (e.type !== "ENCRYPTED PRIVATE KEY" && e.type !== "PRIVATE KEY" && e.type !== "RSA PRIVATE KEY") {
    var n = new Error('Could not convert private key from PEM; PEM header type is not "ENCRYPTED PRIVATE KEY", "PRIVATE KEY", or "RSA PRIVATE KEY".');
    throw n.headerType = n, n;
  }
  if (e.procType && e.procType.type === "ENCRYPTED") {
    var o, c;
    switch (e.dekInfo.algorithm) {
      case "DES-CBC":
        o = 8, c = forge$g.des.createDecryptionCipher;
        break;
      case "DES-EDE3-CBC":
        o = 24, c = forge$g.des.createDecryptionCipher;
        break;
      case "AES-128-CBC":
        o = 16, c = forge$g.aes.createDecryptionCipher;
        break;
      case "AES-192-CBC":
        o = 24, c = forge$g.aes.createDecryptionCipher;
        break;
      case "AES-256-CBC":
        o = 32, c = forge$g.aes.createDecryptionCipher;
        break;
      case "RC2-40-CBC":
        o = 5, c = function(g) {
          return forge$g.rc2.createDecryptionCipher(g, 40);
        };
        break;
      case "RC2-64-CBC":
        o = 8, c = function(g) {
          return forge$g.rc2.createDecryptionCipher(g, 64);
        };
        break;
      case "RC2-128-CBC":
        o = 16, c = function(g) {
          return forge$g.rc2.createDecryptionCipher(g, 128);
        };
        break;
      default:
        var n = new Error('Could not decrypt private key; unsupported encryption algorithm "' + e.dekInfo.algorithm + '".');
        throw n.algorithm = e.dekInfo.algorithm, n;
    }
    var l = forge$g.util.hexToBytes(e.dekInfo.parameters), d = forge$g.pbe.opensslDeriveBytes(r, l.substr(0, 8), o), p = c(d);
    if (p.start(l), p.update(forge$g.util.createBuffer(e.body)), p.finish())
      a = p.output.getBytes();
    else
      return a;
  } else
    a = e.body;
  return e.type === "ENCRYPTED PRIVATE KEY" ? a = pki$3.decryptPrivateKeyInfo(asn1$6.fromDer(a), r) : a = asn1$6.fromDer(a), a !== null && (a = pki$3.privateKeyFromAsn1(a)), a;
};
pki$3.pbe.generatePkcs12Key = function(u, r, a, e, n, o) {
  var c, l;
  if (typeof o > "u" || o === null) {
    if (!("sha1" in forge$g.md))
      throw new Error('"sha1" hash algorithm unavailable.');
    o = forge$g.md.sha1.create();
  }
  var d = o.digestLength, p = o.blockLength, h = new forge$g.util.ByteBuffer(), g = new forge$g.util.ByteBuffer();
  if (u != null) {
    for (l = 0; l < u.length; l++)
      g.putInt16(u.charCodeAt(l));
    g.putInt16(0);
  }
  var y = g.length(), v = r.length(), m = new forge$g.util.ByteBuffer();
  m.fillWithByte(a, p);
  var b = p * Math.ceil(v / p), R = new forge$g.util.ByteBuffer();
  for (l = 0; l < b; l++)
    R.putByte(r.at(l % v));
  var $ = p * Math.ceil(y / p), x = new forge$g.util.ByteBuffer();
  for (l = 0; l < $; l++)
    x.putByte(g.at(l % y));
  var E = R;
  E.putBuffer(x);
  for (var T = Math.ceil(n / d), P = 1; P <= T; P++) {
    var O = new forge$g.util.ByteBuffer();
    O.putBytes(m.bytes()), O.putBytes(E.bytes());
    for (var w = 0; w < e; w++)
      o.start(), o.update(O.getBytes()), O = o.digest();
    var _ = new forge$g.util.ByteBuffer();
    for (l = 0; l < p; l++)
      _.putByte(O.at(l % d));
    var C = Math.ceil(v / p) + Math.ceil(y / p), k = new forge$g.util.ByteBuffer();
    for (c = 0; c < C; c++) {
      var B = new forge$g.util.ByteBuffer(E.getBytes(p)), j = 511;
      for (l = _.length() - 1; l >= 0; l--)
        j = j >> 8, j += _.at(l) + B.at(l), B.setAt(l, j & 255);
      k.putBuffer(B);
    }
    E = k, h.putBuffer(O);
  }
  return h.truncate(h.length() - n), h;
};
pki$3.pbe.getCipher = function(u, r, a) {
  switch (u) {
    case pki$3.oids.pkcs5PBES2:
      return pki$3.pbe.getCipherForPBES2(u, r, a);
    case pki$3.oids["pbeWithSHAAnd3-KeyTripleDES-CBC"]:
    case pki$3.oids["pbewithSHAAnd40BitRC2-CBC"]:
      return pki$3.pbe.getCipherForPKCS12PBE(u, r, a);
    default:
      var e = new Error("Cannot read encrypted PBE data block. Unsupported OID.");
      throw e.oid = u, e.supportedOids = [
        "pkcs5PBES2",
        "pbeWithSHAAnd3-KeyTripleDES-CBC",
        "pbewithSHAAnd40BitRC2-CBC"
      ], e;
  }
};
pki$3.pbe.getCipherForPBES2 = function(u, r, a) {
  var e = {}, n = [];
  if (!asn1$6.validate(r, PBES2AlgorithmsValidator, e, n)) {
    var o = new Error("Cannot read password-based-encryption algorithm parameters. ASN.1 object is not a supported EncryptedPrivateKeyInfo.");
    throw o.errors = n, o;
  }
  if (u = asn1$6.derToOid(e.kdfOid), u !== pki$3.oids.pkcs5PBKDF2) {
    var o = new Error("Cannot read encrypted private key. Unsupported key derivation function OID.");
    throw o.oid = u, o.supportedOids = ["pkcs5PBKDF2"], o;
  }
  if (u = asn1$6.derToOid(e.encOid), u !== pki$3.oids["aes128-CBC"] && u !== pki$3.oids["aes192-CBC"] && u !== pki$3.oids["aes256-CBC"] && u !== pki$3.oids["des-EDE3-CBC"] && u !== pki$3.oids.desCBC) {
    var o = new Error("Cannot read encrypted private key. Unsupported encryption scheme OID.");
    throw o.oid = u, o.supportedOids = [
      "aes128-CBC",
      "aes192-CBC",
      "aes256-CBC",
      "des-EDE3-CBC",
      "desCBC"
    ], o;
  }
  var c = e.kdfSalt, l = forge$g.util.createBuffer(e.kdfIterationCount);
  l = l.getInt(l.length() << 3);
  var d, p;
  switch (pki$3.oids[u]) {
    case "aes128-CBC":
      d = 16, p = forge$g.aes.createDecryptionCipher;
      break;
    case "aes192-CBC":
      d = 24, p = forge$g.aes.createDecryptionCipher;
      break;
    case "aes256-CBC":
      d = 32, p = forge$g.aes.createDecryptionCipher;
      break;
    case "des-EDE3-CBC":
      d = 24, p = forge$g.des.createDecryptionCipher;
      break;
    case "desCBC":
      d = 8, p = forge$g.des.createDecryptionCipher;
      break;
  }
  var h = prfOidToMessageDigest(e.prfOid), g = forge$g.pkcs5.pbkdf2(a, c, l, d, h), y = e.encIv, v = p(g);
  return v.start(y), v;
};
pki$3.pbe.getCipherForPKCS12PBE = function(u, r, a) {
  var e = {}, n = [];
  if (!asn1$6.validate(r, pkcs12PbeParamsValidator, e, n)) {
    var o = new Error("Cannot read password-based-encryption algorithm parameters. ASN.1 object is not a supported EncryptedPrivateKeyInfo.");
    throw o.errors = n, o;
  }
  var c = forge$g.util.createBuffer(e.salt), l = forge$g.util.createBuffer(e.iterations);
  l = l.getInt(l.length() << 3);
  var d, p, h;
  switch (u) {
    case pki$3.oids["pbeWithSHAAnd3-KeyTripleDES-CBC"]:
      d = 24, p = 8, h = forge$g.des.startDecrypting;
      break;
    case pki$3.oids["pbewithSHAAnd40BitRC2-CBC"]:
      d = 5, p = 8, h = function(b, R) {
        var $ = forge$g.rc2.createDecryptionCipher(b, 40);
        return $.start(R, null), $;
      };
      break;
    default:
      var o = new Error("Cannot read PKCS #12 PBE data block. Unsupported OID.");
      throw o.oid = u, o;
  }
  var g = prfOidToMessageDigest(e.prfOid), y = pki$3.pbe.generatePkcs12Key(a, c, 1, l, d, g);
  g.start();
  var v = pki$3.pbe.generatePkcs12Key(a, c, 2, l, p, g);
  return h(y, v);
};
pki$3.pbe.opensslDeriveBytes = function(u, r, a, e) {
  if (typeof e > "u" || e === null) {
    if (!("md5" in forge$g.md))
      throw new Error('"md5" hash algorithm unavailable.');
    e = forge$g.md.md5.create();
  }
  r === null && (r = "");
  for (var n = [hash(e, u + r)], o = 16, c = 1; o < a; ++c, o += 16)
    n.push(hash(e, n[c - 1] + u + r));
  return n.join("").substr(0, a);
};
function hash(u, r) {
  return u.start().update(r).digest().getBytes();
}
function prfOidToMessageDigest(u) {
  var r;
  if (!u)
    r = "hmacWithSHA1";
  else if (r = pki$3.oids[asn1$6.derToOid(u)], !r) {
    var a = new Error("Unsupported PRF OID.");
    throw a.oid = u, a.supported = [
      "hmacWithSHA1",
      "hmacWithSHA224",
      "hmacWithSHA256",
      "hmacWithSHA384",
      "hmacWithSHA512"
    ], a;
  }
  return prfAlgorithmToMessageDigest(r);
}
function prfAlgorithmToMessageDigest(u) {
  var r = forge$g.md;
  switch (u) {
    case "hmacWithSHA224":
      r = forge$g.md.sha512;
    case "hmacWithSHA1":
    case "hmacWithSHA256":
    case "hmacWithSHA384":
    case "hmacWithSHA512":
      u = u.substr(8).toLowerCase();
      break;
    default:
      var a = new Error("Unsupported PRF algorithm.");
      throw a.algorithm = u, a.supported = [
        "hmacWithSHA1",
        "hmacWithSHA224",
        "hmacWithSHA256",
        "hmacWithSHA384",
        "hmacWithSHA512"
      ], a;
  }
  if (!r || !(u in r))
    throw new Error("Unknown hash algorithm: " + u);
  return r[u].create();
}
function createPbkdf2Params(u, r, a, e) {
  var n = asn1$6.create(asn1$6.Class.UNIVERSAL, asn1$6.Type.SEQUENCE, !0, [
    // salt
    asn1$6.create(
      asn1$6.Class.UNIVERSAL,
      asn1$6.Type.OCTETSTRING,
      !1,
      u
    ),
    // iteration count
    asn1$6.create(
      asn1$6.Class.UNIVERSAL,
      asn1$6.Type.INTEGER,
      !1,
      r.getBytes()
    )
  ]);
  return e !== "hmacWithSHA1" && n.value.push(
    // key length
    asn1$6.create(
      asn1$6.Class.UNIVERSAL,
      asn1$6.Type.INTEGER,
      !1,
      forge$g.util.hexToBytes(a.toString(16))
    ),
    // AlgorithmIdentifier
    asn1$6.create(asn1$6.Class.UNIVERSAL, asn1$6.Type.SEQUENCE, !0, [
      // algorithm
      asn1$6.create(
        asn1$6.Class.UNIVERSAL,
        asn1$6.Type.OID,
        !1,
        asn1$6.oidToDer(pki$3.oids[e]).getBytes()
      ),
      // parameters (null)
      asn1$6.create(asn1$6.Class.UNIVERSAL, asn1$6.Type.NULL, !1, "")
    ])
  ), n;
}
var forge$f = forge$C, asn1$5 = forge$f.asn1, p7v = forge$f.pkcs7asn1 = forge$f.pkcs7asn1 || {};
forge$f.pkcs7 = forge$f.pkcs7 || {};
forge$f.pkcs7.asn1 = p7v;
var contentInfoValidator$1 = {
  name: "ContentInfo",
  tagClass: asn1$5.Class.UNIVERSAL,
  type: asn1$5.Type.SEQUENCE,
  constructed: !0,
  value: [{
    name: "ContentInfo.ContentType",
    tagClass: asn1$5.Class.UNIVERSAL,
    type: asn1$5.Type.OID,
    constructed: !1,
    capture: "contentType"
  }, {
    name: "ContentInfo.content",
    tagClass: asn1$5.Class.CONTEXT_SPECIFIC,
    type: 0,
    constructed: !0,
    optional: !0,
    captureAsn1: "content"
  }]
};
p7v.contentInfoValidator = contentInfoValidator$1;
var encryptedContentInfoValidator = {
  name: "EncryptedContentInfo",
  tagClass: asn1$5.Class.UNIVERSAL,
  type: asn1$5.Type.SEQUENCE,
  constructed: !0,
  value: [{
    name: "EncryptedContentInfo.contentType",
    tagClass: asn1$5.Class.UNIVERSAL,
    type: asn1$5.Type.OID,
    constructed: !1,
    capture: "contentType"
  }, {
    name: "EncryptedContentInfo.contentEncryptionAlgorithm",
    tagClass: asn1$5.Class.UNIVERSAL,
    type: asn1$5.Type.SEQUENCE,
    constructed: !0,
    value: [{
      name: "EncryptedContentInfo.contentEncryptionAlgorithm.algorithm",
      tagClass: asn1$5.Class.UNIVERSAL,
      type: asn1$5.Type.OID,
      constructed: !1,
      capture: "encAlgorithm"
    }, {
      name: "EncryptedContentInfo.contentEncryptionAlgorithm.parameter",
      tagClass: asn1$5.Class.UNIVERSAL,
      captureAsn1: "encParameter"
    }]
  }, {
    name: "EncryptedContentInfo.encryptedContent",
    tagClass: asn1$5.Class.CONTEXT_SPECIFIC,
    type: 0,
    /* The PKCS#7 structure output by OpenSSL somewhat differs from what
     * other implementations do generate.
     *
     * OpenSSL generates a structure like this:
     * SEQUENCE {
     *    ...
     *    [0]
     *       26 DA 67 D2 17 9C 45 3C B1 2A A8 59 2F 29 33 38
     *       C3 C3 DF 86 71 74 7A 19 9F 40 D0 29 BE 85 90 45
     *       ...
     * }
     *
     * Whereas other implementations (and this PKCS#7 module) generate:
     * SEQUENCE {
     *    ...
     *    [0] {
     *       OCTET STRING
     *          26 DA 67 D2 17 9C 45 3C B1 2A A8 59 2F 29 33 38
     *          C3 C3 DF 86 71 74 7A 19 9F 40 D0 29 BE 85 90 45
     *          ...
     *    }
     * }
     *
     * In order to support both, we just capture the context specific
     * field here.  The OCTET STRING bit is removed below.
     */
    capture: "encryptedContent",
    captureAsn1: "encryptedContentAsn1"
  }]
};
p7v.envelopedDataValidator = {
  name: "EnvelopedData",
  tagClass: asn1$5.Class.UNIVERSAL,
  type: asn1$5.Type.SEQUENCE,
  constructed: !0,
  value: [{
    name: "EnvelopedData.Version",
    tagClass: asn1$5.Class.UNIVERSAL,
    type: asn1$5.Type.INTEGER,
    constructed: !1,
    capture: "version"
  }, {
    name: "EnvelopedData.RecipientInfos",
    tagClass: asn1$5.Class.UNIVERSAL,
    type: asn1$5.Type.SET,
    constructed: !0,
    captureAsn1: "recipientInfos"
  }].concat(encryptedContentInfoValidator)
};
p7v.encryptedDataValidator = {
  name: "EncryptedData",
  tagClass: asn1$5.Class.UNIVERSAL,
  type: asn1$5.Type.SEQUENCE,
  constructed: !0,
  value: [{
    name: "EncryptedData.Version",
    tagClass: asn1$5.Class.UNIVERSAL,
    type: asn1$5.Type.INTEGER,
    constructed: !1,
    capture: "version"
  }].concat(encryptedContentInfoValidator)
};
var signerValidator = {
  name: "SignerInfo",
  tagClass: asn1$5.Class.UNIVERSAL,
  type: asn1$5.Type.SEQUENCE,
  constructed: !0,
  value: [{
    name: "SignerInfo.version",
    tagClass: asn1$5.Class.UNIVERSAL,
    type: asn1$5.Type.INTEGER,
    constructed: !1
  }, {
    name: "SignerInfo.issuerAndSerialNumber",
    tagClass: asn1$5.Class.UNIVERSAL,
    type: asn1$5.Type.SEQUENCE,
    constructed: !0,
    value: [{
      name: "SignerInfo.issuerAndSerialNumber.issuer",
      tagClass: asn1$5.Class.UNIVERSAL,
      type: asn1$5.Type.SEQUENCE,
      constructed: !0,
      captureAsn1: "issuer"
    }, {
      name: "SignerInfo.issuerAndSerialNumber.serialNumber",
      tagClass: asn1$5.Class.UNIVERSAL,
      type: asn1$5.Type.INTEGER,
      constructed: !1,
      capture: "serial"
    }]
  }, {
    name: "SignerInfo.digestAlgorithm",
    tagClass: asn1$5.Class.UNIVERSAL,
    type: asn1$5.Type.SEQUENCE,
    constructed: !0,
    value: [{
      name: "SignerInfo.digestAlgorithm.algorithm",
      tagClass: asn1$5.Class.UNIVERSAL,
      type: asn1$5.Type.OID,
      constructed: !1,
      capture: "digestAlgorithm"
    }, {
      name: "SignerInfo.digestAlgorithm.parameter",
      tagClass: asn1$5.Class.UNIVERSAL,
      constructed: !1,
      captureAsn1: "digestParameter",
      optional: !0
    }]
  }, {
    name: "SignerInfo.authenticatedAttributes",
    tagClass: asn1$5.Class.CONTEXT_SPECIFIC,
    type: 0,
    constructed: !0,
    optional: !0,
    capture: "authenticatedAttributes"
  }, {
    name: "SignerInfo.digestEncryptionAlgorithm",
    tagClass: asn1$5.Class.UNIVERSAL,
    type: asn1$5.Type.SEQUENCE,
    constructed: !0,
    capture: "signatureAlgorithm"
  }, {
    name: "SignerInfo.encryptedDigest",
    tagClass: asn1$5.Class.UNIVERSAL,
    type: asn1$5.Type.OCTETSTRING,
    constructed: !1,
    capture: "signature"
  }, {
    name: "SignerInfo.unauthenticatedAttributes",
    tagClass: asn1$5.Class.CONTEXT_SPECIFIC,
    type: 1,
    constructed: !0,
    optional: !0,
    capture: "unauthenticatedAttributes"
  }]
};
p7v.signedDataValidator = {
  name: "SignedData",
  tagClass: asn1$5.Class.UNIVERSAL,
  type: asn1$5.Type.SEQUENCE,
  constructed: !0,
  value: [
    {
      name: "SignedData.Version",
      tagClass: asn1$5.Class.UNIVERSAL,
      type: asn1$5.Type.INTEGER,
      constructed: !1,
      capture: "version"
    },
    {
      name: "SignedData.DigestAlgorithms",
      tagClass: asn1$5.Class.UNIVERSAL,
      type: asn1$5.Type.SET,
      constructed: !0,
      captureAsn1: "digestAlgorithms"
    },
    contentInfoValidator$1,
    {
      name: "SignedData.Certificates",
      tagClass: asn1$5.Class.CONTEXT_SPECIFIC,
      type: 0,
      optional: !0,
      captureAsn1: "certificates"
    },
    {
      name: "SignedData.CertificateRevocationLists",
      tagClass: asn1$5.Class.CONTEXT_SPECIFIC,
      type: 1,
      optional: !0,
      captureAsn1: "crls"
    },
    {
      name: "SignedData.SignerInfos",
      tagClass: asn1$5.Class.UNIVERSAL,
      type: asn1$5.Type.SET,
      capture: "signerInfos",
      optional: !0,
      value: [signerValidator]
    }
  ]
};
p7v.recipientInfoValidator = {
  name: "RecipientInfo",
  tagClass: asn1$5.Class.UNIVERSAL,
  type: asn1$5.Type.SEQUENCE,
  constructed: !0,
  value: [{
    name: "RecipientInfo.version",
    tagClass: asn1$5.Class.UNIVERSAL,
    type: asn1$5.Type.INTEGER,
    constructed: !1,
    capture: "version"
  }, {
    name: "RecipientInfo.issuerAndSerial",
    tagClass: asn1$5.Class.UNIVERSAL,
    type: asn1$5.Type.SEQUENCE,
    constructed: !0,
    value: [{
      name: "RecipientInfo.issuerAndSerial.issuer",
      tagClass: asn1$5.Class.UNIVERSAL,
      type: asn1$5.Type.SEQUENCE,
      constructed: !0,
      captureAsn1: "issuer"
    }, {
      name: "RecipientInfo.issuerAndSerial.serialNumber",
      tagClass: asn1$5.Class.UNIVERSAL,
      type: asn1$5.Type.INTEGER,
      constructed: !1,
      capture: "serial"
    }]
  }, {
    name: "RecipientInfo.keyEncryptionAlgorithm",
    tagClass: asn1$5.Class.UNIVERSAL,
    type: asn1$5.Type.SEQUENCE,
    constructed: !0,
    value: [{
      name: "RecipientInfo.keyEncryptionAlgorithm.algorithm",
      tagClass: asn1$5.Class.UNIVERSAL,
      type: asn1$5.Type.OID,
      constructed: !1,
      capture: "encAlgorithm"
    }, {
      name: "RecipientInfo.keyEncryptionAlgorithm.parameter",
      tagClass: asn1$5.Class.UNIVERSAL,
      constructed: !1,
      captureAsn1: "encParameter",
      optional: !0
    }]
  }, {
    name: "RecipientInfo.encryptedKey",
    tagClass: asn1$5.Class.UNIVERSAL,
    type: asn1$5.Type.OCTETSTRING,
    constructed: !1,
    capture: "encKey"
  }]
};
var forge$e = forge$C;
forge$e.mgf = forge$e.mgf || {};
var mgf1 = forge$e.mgf.mgf1 = forge$e.mgf1 = forge$e.mgf1 || {};
mgf1.create = function(u) {
  var r = {
    /**
     * Generate mask of specified length.
     *
     * @param {String} seed The seed for mask generation.
     * @param maskLen Number of bytes to generate.
     * @return {String} The generated mask.
     */
    generate: function(a, e) {
      for (var n = new forge$e.util.ByteBuffer(), o = Math.ceil(e / u.digestLength), c = 0; c < o; c++) {
        var l = new forge$e.util.ByteBuffer();
        l.putInt32(c), u.start(), u.update(a + l.getBytes()), n.putBuffer(u.digest());
      }
      return n.truncate(n.length() - e), n.getBytes();
    }
  };
  return r;
};
var forge$d = forge$C;
forge$d.mgf = forge$d.mgf || {};
forge$d.mgf.mgf1 = forge$d.mgf1;
var forge$c = forge$C, pss = forge$c.pss = forge$c.pss || {};
pss.create = function(u) {
  arguments.length === 3 && (u = {
    md: arguments[0],
    mgf: arguments[1],
    saltLength: arguments[2]
  });
  var r = u.md, a = u.mgf, e = r.digestLength, n = u.salt || null;
  typeof n == "string" && (n = forge$c.util.createBuffer(n));
  var o;
  if ("saltLength" in u)
    o = u.saltLength;
  else if (n !== null)
    o = n.length();
  else
    throw new Error("Salt length not specified or specific salt not given.");
  if (n !== null && n.length() !== o)
    throw new Error("Given salt length does not match length of given salt.");
  var c = u.prng || forge$c.random, l = {};
  return l.encode = function(d, p) {
    var h, g = p - 1, y = Math.ceil(g / 8), v = d.digest().getBytes();
    if (y < e + o + 2)
      throw new Error("Message is too long to encrypt.");
    var m;
    n === null ? m = c.getBytesSync(o) : m = n.bytes();
    var b = new forge$c.util.ByteBuffer();
    b.fillWithByte(0, 8), b.putBytes(v), b.putBytes(m), r.start(), r.update(b.getBytes());
    var R = r.digest().getBytes(), $ = new forge$c.util.ByteBuffer();
    $.fillWithByte(0, y - o - e - 2), $.putByte(1), $.putBytes(m);
    var x = $.getBytes(), E = y - e - 1, T = a.generate(R, E), P = "";
    for (h = 0; h < E; h++)
      P += String.fromCharCode(x.charCodeAt(h) ^ T.charCodeAt(h));
    var O = 65280 >> 8 * y - g & 255;
    return P = String.fromCharCode(P.charCodeAt(0) & ~O) + P.substr(1), P + R + "¼";
  }, l.verify = function(d, p, h) {
    var g, y = h - 1, v = Math.ceil(y / 8);
    if (p = p.substr(-v), v < e + o + 2)
      throw new Error("Inconsistent parameters to PSS signature verification.");
    if (p.charCodeAt(v - 1) !== 188)
      throw new Error("Encoded message does not end in 0xBC.");
    var m = v - e - 1, b = p.substr(0, m), R = p.substr(m, e), $ = 65280 >> 8 * v - y & 255;
    if (b.charCodeAt(0) & $)
      throw new Error("Bits beyond keysize not zero as expected.");
    var x = a.generate(R, m), E = "";
    for (g = 0; g < m; g++)
      E += String.fromCharCode(b.charCodeAt(g) ^ x.charCodeAt(g));
    E = String.fromCharCode(E.charCodeAt(0) & ~$) + E.substr(1);
    var T = v - e - o - 2;
    for (g = 0; g < T; g++)
      if (E.charCodeAt(g) !== 0)
        throw new Error("Leftmost octets not zero as expected");
    if (E.charCodeAt(T) !== 1)
      throw new Error("Inconsistent PSS signature, 0x01 marker not found");
    var P = E.substr(-o), O = new forge$c.util.ByteBuffer();
    O.fillWithByte(0, 8), O.putBytes(d), O.putBytes(P), r.start(), r.update(O.getBytes());
    var w = r.digest().getBytes();
    return R === w;
  }, l;
};
var forge$b = forge$C, asn1$4 = forge$b.asn1, pki$2 = forge$b.pki = forge$b.pki || {}, oids = pki$2.oids, _shortNames = {};
_shortNames.CN = oids.commonName;
_shortNames.commonName = "CN";
_shortNames.C = oids.countryName;
_shortNames.countryName = "C";
_shortNames.L = oids.localityName;
_shortNames.localityName = "L";
_shortNames.ST = oids.stateOrProvinceName;
_shortNames.stateOrProvinceName = "ST";
_shortNames.O = oids.organizationName;
_shortNames.organizationName = "O";
_shortNames.OU = oids.organizationalUnitName;
_shortNames.organizationalUnitName = "OU";
_shortNames.E = oids.emailAddress;
_shortNames.emailAddress = "E";
var publicKeyValidator$1 = forge$b.pki.rsa.publicKeyValidator, x509CertificateValidator = {
  name: "Certificate",
  tagClass: asn1$4.Class.UNIVERSAL,
  type: asn1$4.Type.SEQUENCE,
  constructed: !0,
  value: [{
    name: "Certificate.TBSCertificate",
    tagClass: asn1$4.Class.UNIVERSAL,
    type: asn1$4.Type.SEQUENCE,
    constructed: !0,
    captureAsn1: "tbsCertificate",
    value: [
      {
        name: "Certificate.TBSCertificate.version",
        tagClass: asn1$4.Class.CONTEXT_SPECIFIC,
        type: 0,
        constructed: !0,
        optional: !0,
        value: [{
          name: "Certificate.TBSCertificate.version.integer",
          tagClass: asn1$4.Class.UNIVERSAL,
          type: asn1$4.Type.INTEGER,
          constructed: !1,
          capture: "certVersion"
        }]
      },
      {
        name: "Certificate.TBSCertificate.serialNumber",
        tagClass: asn1$4.Class.UNIVERSAL,
        type: asn1$4.Type.INTEGER,
        constructed: !1,
        capture: "certSerialNumber"
      },
      {
        name: "Certificate.TBSCertificate.signature",
        tagClass: asn1$4.Class.UNIVERSAL,
        type: asn1$4.Type.SEQUENCE,
        constructed: !0,
        value: [{
          name: "Certificate.TBSCertificate.signature.algorithm",
          tagClass: asn1$4.Class.UNIVERSAL,
          type: asn1$4.Type.OID,
          constructed: !1,
          capture: "certinfoSignatureOid"
        }, {
          name: "Certificate.TBSCertificate.signature.parameters",
          tagClass: asn1$4.Class.UNIVERSAL,
          optional: !0,
          captureAsn1: "certinfoSignatureParams"
        }]
      },
      {
        name: "Certificate.TBSCertificate.issuer",
        tagClass: asn1$4.Class.UNIVERSAL,
        type: asn1$4.Type.SEQUENCE,
        constructed: !0,
        captureAsn1: "certIssuer"
      },
      {
        name: "Certificate.TBSCertificate.validity",
        tagClass: asn1$4.Class.UNIVERSAL,
        type: asn1$4.Type.SEQUENCE,
        constructed: !0,
        // Note: UTC and generalized times may both appear so the capture
        // names are based on their detected order, the names used below
        // are only for the common case, which validity time really means
        // "notBefore" and which means "notAfter" will be determined by order
        value: [{
          // notBefore (Time) (UTC time case)
          name: "Certificate.TBSCertificate.validity.notBefore (utc)",
          tagClass: asn1$4.Class.UNIVERSAL,
          type: asn1$4.Type.UTCTIME,
          constructed: !1,
          optional: !0,
          capture: "certValidity1UTCTime"
        }, {
          // notBefore (Time) (generalized time case)
          name: "Certificate.TBSCertificate.validity.notBefore (generalized)",
          tagClass: asn1$4.Class.UNIVERSAL,
          type: asn1$4.Type.GENERALIZEDTIME,
          constructed: !1,
          optional: !0,
          capture: "certValidity2GeneralizedTime"
        }, {
          // notAfter (Time) (only UTC time is supported)
          name: "Certificate.TBSCertificate.validity.notAfter (utc)",
          tagClass: asn1$4.Class.UNIVERSAL,
          type: asn1$4.Type.UTCTIME,
          constructed: !1,
          optional: !0,
          capture: "certValidity3UTCTime"
        }, {
          // notAfter (Time) (only UTC time is supported)
          name: "Certificate.TBSCertificate.validity.notAfter (generalized)",
          tagClass: asn1$4.Class.UNIVERSAL,
          type: asn1$4.Type.GENERALIZEDTIME,
          constructed: !1,
          optional: !0,
          capture: "certValidity4GeneralizedTime"
        }]
      },
      {
        // Name (subject) (RDNSequence)
        name: "Certificate.TBSCertificate.subject",
        tagClass: asn1$4.Class.UNIVERSAL,
        type: asn1$4.Type.SEQUENCE,
        constructed: !0,
        captureAsn1: "certSubject"
      },
      // SubjectPublicKeyInfo
      publicKeyValidator$1,
      {
        // issuerUniqueID (optional)
        name: "Certificate.TBSCertificate.issuerUniqueID",
        tagClass: asn1$4.Class.CONTEXT_SPECIFIC,
        type: 1,
        constructed: !0,
        optional: !0,
        value: [{
          name: "Certificate.TBSCertificate.issuerUniqueID.id",
          tagClass: asn1$4.Class.UNIVERSAL,
          type: asn1$4.Type.BITSTRING,
          constructed: !1,
          // TODO: support arbitrary bit length ids
          captureBitStringValue: "certIssuerUniqueId"
        }]
      },
      {
        // subjectUniqueID (optional)
        name: "Certificate.TBSCertificate.subjectUniqueID",
        tagClass: asn1$4.Class.CONTEXT_SPECIFIC,
        type: 2,
        constructed: !0,
        optional: !0,
        value: [{
          name: "Certificate.TBSCertificate.subjectUniqueID.id",
          tagClass: asn1$4.Class.UNIVERSAL,
          type: asn1$4.Type.BITSTRING,
          constructed: !1,
          // TODO: support arbitrary bit length ids
          captureBitStringValue: "certSubjectUniqueId"
        }]
      },
      {
        // Extensions (optional)
        name: "Certificate.TBSCertificate.extensions",
        tagClass: asn1$4.Class.CONTEXT_SPECIFIC,
        type: 3,
        constructed: !0,
        captureAsn1: "certExtensions",
        optional: !0
      }
    ]
  }, {
    // AlgorithmIdentifier (signature algorithm)
    name: "Certificate.signatureAlgorithm",
    tagClass: asn1$4.Class.UNIVERSAL,
    type: asn1$4.Type.SEQUENCE,
    constructed: !0,
    value: [{
      // algorithm
      name: "Certificate.signatureAlgorithm.algorithm",
      tagClass: asn1$4.Class.UNIVERSAL,
      type: asn1$4.Type.OID,
      constructed: !1,
      capture: "certSignatureOid"
    }, {
      name: "Certificate.TBSCertificate.signature.parameters",
      tagClass: asn1$4.Class.UNIVERSAL,
      optional: !0,
      captureAsn1: "certSignatureParams"
    }]
  }, {
    // SignatureValue
    name: "Certificate.signatureValue",
    tagClass: asn1$4.Class.UNIVERSAL,
    type: asn1$4.Type.BITSTRING,
    constructed: !1,
    captureBitStringValue: "certSignature"
  }]
}, rsassaPssParameterValidator = {
  name: "rsapss",
  tagClass: asn1$4.Class.UNIVERSAL,
  type: asn1$4.Type.SEQUENCE,
  constructed: !0,
  value: [{
    name: "rsapss.hashAlgorithm",
    tagClass: asn1$4.Class.CONTEXT_SPECIFIC,
    type: 0,
    constructed: !0,
    value: [{
      name: "rsapss.hashAlgorithm.AlgorithmIdentifier",
      tagClass: asn1$4.Class.UNIVERSAL,
      type: asn1$4.Class.SEQUENCE,
      constructed: !0,
      optional: !0,
      value: [{
        name: "rsapss.hashAlgorithm.AlgorithmIdentifier.algorithm",
        tagClass: asn1$4.Class.UNIVERSAL,
        type: asn1$4.Type.OID,
        constructed: !1,
        capture: "hashOid"
        /* parameter block omitted, for SHA1 NULL anyhow. */
      }]
    }]
  }, {
    name: "rsapss.maskGenAlgorithm",
    tagClass: asn1$4.Class.CONTEXT_SPECIFIC,
    type: 1,
    constructed: !0,
    value: [{
      name: "rsapss.maskGenAlgorithm.AlgorithmIdentifier",
      tagClass: asn1$4.Class.UNIVERSAL,
      type: asn1$4.Class.SEQUENCE,
      constructed: !0,
      optional: !0,
      value: [{
        name: "rsapss.maskGenAlgorithm.AlgorithmIdentifier.algorithm",
        tagClass: asn1$4.Class.UNIVERSAL,
        type: asn1$4.Type.OID,
        constructed: !1,
        capture: "maskGenOid"
      }, {
        name: "rsapss.maskGenAlgorithm.AlgorithmIdentifier.params",
        tagClass: asn1$4.Class.UNIVERSAL,
        type: asn1$4.Type.SEQUENCE,
        constructed: !0,
        value: [{
          name: "rsapss.maskGenAlgorithm.AlgorithmIdentifier.params.algorithm",
          tagClass: asn1$4.Class.UNIVERSAL,
          type: asn1$4.Type.OID,
          constructed: !1,
          capture: "maskGenHashOid"
          /* parameter block omitted, for SHA1 NULL anyhow. */
        }]
      }]
    }]
  }, {
    name: "rsapss.saltLength",
    tagClass: asn1$4.Class.CONTEXT_SPECIFIC,
    type: 2,
    optional: !0,
    value: [{
      name: "rsapss.saltLength.saltLength",
      tagClass: asn1$4.Class.UNIVERSAL,
      type: asn1$4.Class.INTEGER,
      constructed: !1,
      capture: "saltLength"
    }]
  }, {
    name: "rsapss.trailerField",
    tagClass: asn1$4.Class.CONTEXT_SPECIFIC,
    type: 3,
    optional: !0,
    value: [{
      name: "rsapss.trailer.trailer",
      tagClass: asn1$4.Class.UNIVERSAL,
      type: asn1$4.Class.INTEGER,
      constructed: !1,
      capture: "trailer"
    }]
  }]
}, certificationRequestInfoValidator = {
  name: "CertificationRequestInfo",
  tagClass: asn1$4.Class.UNIVERSAL,
  type: asn1$4.Type.SEQUENCE,
  constructed: !0,
  captureAsn1: "certificationRequestInfo",
  value: [
    {
      name: "CertificationRequestInfo.integer",
      tagClass: asn1$4.Class.UNIVERSAL,
      type: asn1$4.Type.INTEGER,
      constructed: !1,
      capture: "certificationRequestInfoVersion"
    },
    {
      // Name (subject) (RDNSequence)
      name: "CertificationRequestInfo.subject",
      tagClass: asn1$4.Class.UNIVERSAL,
      type: asn1$4.Type.SEQUENCE,
      constructed: !0,
      captureAsn1: "certificationRequestInfoSubject"
    },
    // SubjectPublicKeyInfo
    publicKeyValidator$1,
    {
      name: "CertificationRequestInfo.attributes",
      tagClass: asn1$4.Class.CONTEXT_SPECIFIC,
      type: 0,
      constructed: !0,
      optional: !0,
      capture: "certificationRequestInfoAttributes",
      value: [{
        name: "CertificationRequestInfo.attributes",
        tagClass: asn1$4.Class.UNIVERSAL,
        type: asn1$4.Type.SEQUENCE,
        constructed: !0,
        value: [{
          name: "CertificationRequestInfo.attributes.type",
          tagClass: asn1$4.Class.UNIVERSAL,
          type: asn1$4.Type.OID,
          constructed: !1
        }, {
          name: "CertificationRequestInfo.attributes.value",
          tagClass: asn1$4.Class.UNIVERSAL,
          type: asn1$4.Type.SET,
          constructed: !0
        }]
      }]
    }
  ]
}, certificationRequestValidator = {
  name: "CertificationRequest",
  tagClass: asn1$4.Class.UNIVERSAL,
  type: asn1$4.Type.SEQUENCE,
  constructed: !0,
  captureAsn1: "csr",
  value: [
    certificationRequestInfoValidator,
    {
      // AlgorithmIdentifier (signature algorithm)
      name: "CertificationRequest.signatureAlgorithm",
      tagClass: asn1$4.Class.UNIVERSAL,
      type: asn1$4.Type.SEQUENCE,
      constructed: !0,
      value: [{
        // algorithm
        name: "CertificationRequest.signatureAlgorithm.algorithm",
        tagClass: asn1$4.Class.UNIVERSAL,
        type: asn1$4.Type.OID,
        constructed: !1,
        capture: "csrSignatureOid"
      }, {
        name: "CertificationRequest.signatureAlgorithm.parameters",
        tagClass: asn1$4.Class.UNIVERSAL,
        optional: !0,
        captureAsn1: "csrSignatureParams"
      }]
    },
    {
      // signature
      name: "CertificationRequest.signature",
      tagClass: asn1$4.Class.UNIVERSAL,
      type: asn1$4.Type.BITSTRING,
      constructed: !1,
      captureBitStringValue: "csrSignature"
    }
  ]
};
pki$2.RDNAttributesAsArray = function(u, r) {
  for (var a = [], e, n, o, c = 0; c < u.value.length; ++c) {
    e = u.value[c];
    for (var l = 0; l < e.value.length; ++l)
      o = {}, n = e.value[l], o.type = asn1$4.derToOid(n.value[0].value), o.value = n.value[1].value, o.valueTagClass = n.value[1].type, o.type in oids && (o.name = oids[o.type], o.name in _shortNames && (o.shortName = _shortNames[o.name])), r && (r.update(o.type), r.update(o.value)), a.push(o);
  }
  return a;
};
pki$2.CRIAttributesAsArray = function(u) {
  for (var r = [], a = 0; a < u.length; ++a)
    for (var e = u[a], n = asn1$4.derToOid(e.value[0].value), o = e.value[1].value, c = 0; c < o.length; ++c) {
      var l = {};
      if (l.type = n, l.value = o[c].value, l.valueTagClass = o[c].type, l.type in oids && (l.name = oids[l.type], l.name in _shortNames && (l.shortName = _shortNames[l.name])), l.type === oids.extensionRequest) {
        l.extensions = [];
        for (var d = 0; d < l.value.length; ++d)
          l.extensions.push(pki$2.certificateExtensionFromAsn1(l.value[d]));
      }
      r.push(l);
    }
  return r;
};
function _getAttribute(u, r) {
  typeof r == "string" && (r = { shortName: r });
  for (var a = null, e, n = 0; a === null && n < u.attributes.length; ++n)
    e = u.attributes[n], (r.type && r.type === e.type || r.name && r.name === e.name || r.shortName && r.shortName === e.shortName) && (a = e);
  return a;
}
var _readSignatureParameters = function(u, r, a) {
  var e = {};
  if (u !== oids["RSASSA-PSS"])
    return e;
  a && (e = {
    hash: {
      algorithmOid: oids.sha1
    },
    mgf: {
      algorithmOid: oids.mgf1,
      hash: {
        algorithmOid: oids.sha1
      }
    },
    saltLength: 20
  });
  var n = {}, o = [];
  if (!asn1$4.validate(r, rsassaPssParameterValidator, n, o)) {
    var c = new Error("Cannot read RSASSA-PSS parameter block.");
    throw c.errors = o, c;
  }
  return n.hashOid !== void 0 && (e.hash = e.hash || {}, e.hash.algorithmOid = asn1$4.derToOid(n.hashOid)), n.maskGenOid !== void 0 && (e.mgf = e.mgf || {}, e.mgf.algorithmOid = asn1$4.derToOid(n.maskGenOid), e.mgf.hash = e.mgf.hash || {}, e.mgf.hash.algorithmOid = asn1$4.derToOid(n.maskGenHashOid)), n.saltLength !== void 0 && (e.saltLength = n.saltLength.charCodeAt(0)), e;
}, _createSignatureDigest = function(u) {
  switch (oids[u.signatureOid]) {
    case "sha1WithRSAEncryption":
    case "sha1WithRSASignature":
      return forge$b.md.sha1.create();
    case "md5WithRSAEncryption":
      return forge$b.md.md5.create();
    case "sha256WithRSAEncryption":
      return forge$b.md.sha256.create();
    case "sha384WithRSAEncryption":
      return forge$b.md.sha384.create();
    case "sha512WithRSAEncryption":
      return forge$b.md.sha512.create();
    case "RSASSA-PSS":
      return forge$b.md.sha256.create();
    default:
      var r = new Error(
        "Could not compute " + u.type + " digest. Unknown signature OID."
      );
      throw r.signatureOid = u.signatureOid, r;
  }
}, _verifySignature = function(u) {
  var r = u.certificate, a;
  switch (r.signatureOid) {
    case oids.sha1WithRSAEncryption:
    case oids.sha1WithRSASignature:
      break;
    case oids["RSASSA-PSS"]:
      var e, n;
      if (e = oids[r.signatureParameters.mgf.hash.algorithmOid], e === void 0 || forge$b.md[e] === void 0) {
        var o = new Error("Unsupported MGF hash function.");
        throw o.oid = r.signatureParameters.mgf.hash.algorithmOid, o.name = e, o;
      }
      if (n = oids[r.signatureParameters.mgf.algorithmOid], n === void 0 || forge$b.mgf[n] === void 0) {
        var o = new Error("Unsupported MGF function.");
        throw o.oid = r.signatureParameters.mgf.algorithmOid, o.name = n, o;
      }
      if (n = forge$b.mgf[n].create(forge$b.md[e].create()), e = oids[r.signatureParameters.hash.algorithmOid], e === void 0 || forge$b.md[e] === void 0) {
        var o = new Error("Unsupported RSASSA-PSS hash function.");
        throw o.oid = r.signatureParameters.hash.algorithmOid, o.name = e, o;
      }
      a = forge$b.pss.create(
        forge$b.md[e].create(),
        n,
        r.signatureParameters.saltLength
      );
      break;
  }
  return r.publicKey.verify(
    u.md.digest().getBytes(),
    u.signature,
    a
  );
};
pki$2.certificateFromPem = function(u, r, a) {
  var e = forge$b.pem.decode(u)[0];
  if (e.type !== "CERTIFICATE" && e.type !== "X509 CERTIFICATE" && e.type !== "TRUSTED CERTIFICATE") {
    var n = new Error(
      'Could not convert certificate from PEM; PEM header type is not "CERTIFICATE", "X509 CERTIFICATE", or "TRUSTED CERTIFICATE".'
    );
    throw n.headerType = e.type, n;
  }
  if (e.procType && e.procType.type === "ENCRYPTED")
    throw new Error(
      "Could not convert certificate from PEM; PEM is encrypted."
    );
  var o = asn1$4.fromDer(e.body, a);
  return pki$2.certificateFromAsn1(o, r);
};
pki$2.certificateToPem = function(u, r) {
  var a = {
    type: "CERTIFICATE",
    body: asn1$4.toDer(pki$2.certificateToAsn1(u)).getBytes()
  };
  return forge$b.pem.encode(a, { maxline: r });
};
pki$2.publicKeyFromPem = function(u) {
  var r = forge$b.pem.decode(u)[0];
  if (r.type !== "PUBLIC KEY" && r.type !== "RSA PUBLIC KEY") {
    var a = new Error('Could not convert public key from PEM; PEM header type is not "PUBLIC KEY" or "RSA PUBLIC KEY".');
    throw a.headerType = r.type, a;
  }
  if (r.procType && r.procType.type === "ENCRYPTED")
    throw new Error("Could not convert public key from PEM; PEM is encrypted.");
  var e = asn1$4.fromDer(r.body);
  return pki$2.publicKeyFromAsn1(e);
};
pki$2.publicKeyToPem = function(u, r) {
  var a = {
    type: "PUBLIC KEY",
    body: asn1$4.toDer(pki$2.publicKeyToAsn1(u)).getBytes()
  };
  return forge$b.pem.encode(a, { maxline: r });
};
pki$2.publicKeyToRSAPublicKeyPem = function(u, r) {
  var a = {
    type: "RSA PUBLIC KEY",
    body: asn1$4.toDer(pki$2.publicKeyToRSAPublicKey(u)).getBytes()
  };
  return forge$b.pem.encode(a, { maxline: r });
};
pki$2.getPublicKeyFingerprint = function(u, r) {
  r = r || {};
  var a = r.md || forge$b.md.sha1.create(), e = r.type || "RSAPublicKey", n;
  switch (e) {
    case "RSAPublicKey":
      n = asn1$4.toDer(pki$2.publicKeyToRSAPublicKey(u)).getBytes();
      break;
    case "SubjectPublicKeyInfo":
      n = asn1$4.toDer(pki$2.publicKeyToAsn1(u)).getBytes();
      break;
    default:
      throw new Error('Unknown fingerprint type "' + r.type + '".');
  }
  a.start(), a.update(n);
  var o = a.digest();
  if (r.encoding === "hex") {
    var c = o.toHex();
    return r.delimiter ? c.match(/.{2}/g).join(r.delimiter) : c;
  } else {
    if (r.encoding === "binary")
      return o.getBytes();
    if (r.encoding)
      throw new Error('Unknown encoding "' + r.encoding + '".');
  }
  return o;
};
pki$2.certificationRequestFromPem = function(u, r, a) {
  var e = forge$b.pem.decode(u)[0];
  if (e.type !== "CERTIFICATE REQUEST") {
    var n = new Error('Could not convert certification request from PEM; PEM header type is not "CERTIFICATE REQUEST".');
    throw n.headerType = e.type, n;
  }
  if (e.procType && e.procType.type === "ENCRYPTED")
    throw new Error("Could not convert certification request from PEM; PEM is encrypted.");
  var o = asn1$4.fromDer(e.body, a);
  return pki$2.certificationRequestFromAsn1(o, r);
};
pki$2.certificationRequestToPem = function(u, r) {
  var a = {
    type: "CERTIFICATE REQUEST",
    body: asn1$4.toDer(pki$2.certificationRequestToAsn1(u)).getBytes()
  };
  return forge$b.pem.encode(a, { maxline: r });
};
pki$2.createCertificate = function() {
  var u = {};
  return u.version = 2, u.serialNumber = "00", u.signatureOid = null, u.signature = null, u.siginfo = {}, u.siginfo.algorithmOid = null, u.validity = {}, u.validity.notBefore = /* @__PURE__ */ new Date(), u.validity.notAfter = /* @__PURE__ */ new Date(), u.issuer = {}, u.issuer.getField = function(r) {
    return _getAttribute(u.issuer, r);
  }, u.issuer.addField = function(r) {
    _fillMissingFields([r]), u.issuer.attributes.push(r);
  }, u.issuer.attributes = [], u.issuer.hash = null, u.subject = {}, u.subject.getField = function(r) {
    return _getAttribute(u.subject, r);
  }, u.subject.addField = function(r) {
    _fillMissingFields([r]), u.subject.attributes.push(r);
  }, u.subject.attributes = [], u.subject.hash = null, u.extensions = [], u.publicKey = null, u.md = null, u.setSubject = function(r, a) {
    _fillMissingFields(r), u.subject.attributes = r, delete u.subject.uniqueId, a && (u.subject.uniqueId = a), u.subject.hash = null;
  }, u.setIssuer = function(r, a) {
    _fillMissingFields(r), u.issuer.attributes = r, delete u.issuer.uniqueId, a && (u.issuer.uniqueId = a), u.issuer.hash = null;
  }, u.setExtensions = function(r) {
    for (var a = 0; a < r.length; ++a)
      _fillMissingExtensionFields(r[a], { cert: u });
    u.extensions = r;
  }, u.getExtension = function(r) {
    typeof r == "string" && (r = { name: r });
    for (var a = null, e, n = 0; a === null && n < u.extensions.length; ++n)
      e = u.extensions[n], (r.id && e.id === r.id || r.name && e.name === r.name) && (a = e);
    return a;
  }, u.sign = function(r, a) {
    u.md = a || forge$b.md.sha1.create();
    var e = oids[u.md.algorithm + "WithRSAEncryption"];
    if (!e) {
      var n = new Error("Could not compute certificate digest. Unknown message digest algorithm OID.");
      throw n.algorithm = u.md.algorithm, n;
    }
    u.signatureOid = u.siginfo.algorithmOid = e, u.tbsCertificate = pki$2.getTBSCertificate(u);
    var o = asn1$4.toDer(u.tbsCertificate);
    u.md.update(o.getBytes()), u.signature = r.sign(u.md);
  }, u.verify = function(r) {
    var a = !1;
    if (!u.issued(r)) {
      var e = r.issuer, n = u.subject, o = new Error(
        "The parent certificate did not issue the given child certificate; the child certificate's issuer does not match the parent's subject."
      );
      throw o.expectedIssuer = n.attributes, o.actualIssuer = e.attributes, o;
    }
    var c = r.md;
    if (c === null) {
      c = _createSignatureDigest({
        signatureOid: r.signatureOid,
        type: "certificate"
      });
      var l = r.tbsCertificate || pki$2.getTBSCertificate(r), d = asn1$4.toDer(l);
      c.update(d.getBytes());
    }
    return c !== null && (a = _verifySignature({
      certificate: u,
      md: c,
      signature: r.signature
    })), a;
  }, u.isIssuer = function(r) {
    var a = !1, e = u.issuer, n = r.subject;
    if (e.hash && n.hash)
      a = e.hash === n.hash;
    else if (e.attributes.length === n.attributes.length) {
      a = !0;
      for (var o, c, l = 0; a && l < e.attributes.length; ++l)
        o = e.attributes[l], c = n.attributes[l], (o.type !== c.type || o.value !== c.value) && (a = !1);
    }
    return a;
  }, u.issued = function(r) {
    return r.isIssuer(u);
  }, u.generateSubjectKeyIdentifier = function() {
    return pki$2.getPublicKeyFingerprint(u.publicKey, { type: "RSAPublicKey" });
  }, u.verifySubjectKeyIdentifier = function() {
    for (var r = oids.subjectKeyIdentifier, a = 0; a < u.extensions.length; ++a) {
      var e = u.extensions[a];
      if (e.id === r) {
        var n = u.generateSubjectKeyIdentifier().getBytes();
        return forge$b.util.hexToBytes(e.subjectKeyIdentifier) === n;
      }
    }
    return !1;
  }, u;
};
pki$2.certificateFromAsn1 = function(u, r) {
  var a = {}, e = [];
  if (!asn1$4.validate(u, x509CertificateValidator, a, e)) {
    var n = new Error("Cannot read X.509 certificate. ASN.1 object is not an X509v3 Certificate.");
    throw n.errors = e, n;
  }
  var o = asn1$4.derToOid(a.publicKeyOid);
  if (o !== pki$2.oids.rsaEncryption)
    throw new Error("Cannot read public key. OID is not RSA.");
  var c = pki$2.createCertificate();
  c.version = a.certVersion ? a.certVersion.charCodeAt(0) : 0;
  var l = forge$b.util.createBuffer(a.certSerialNumber);
  c.serialNumber = l.toHex(), c.signatureOid = forge$b.asn1.derToOid(a.certSignatureOid), c.signatureParameters = _readSignatureParameters(
    c.signatureOid,
    a.certSignatureParams,
    !0
  ), c.siginfo.algorithmOid = forge$b.asn1.derToOid(a.certinfoSignatureOid), c.siginfo.parameters = _readSignatureParameters(
    c.siginfo.algorithmOid,
    a.certinfoSignatureParams,
    !1
  ), c.signature = a.certSignature;
  var d = [];
  if (a.certValidity1UTCTime !== void 0 && d.push(asn1$4.utcTimeToDate(a.certValidity1UTCTime)), a.certValidity2GeneralizedTime !== void 0 && d.push(asn1$4.generalizedTimeToDate(
    a.certValidity2GeneralizedTime
  )), a.certValidity3UTCTime !== void 0 && d.push(asn1$4.utcTimeToDate(a.certValidity3UTCTime)), a.certValidity4GeneralizedTime !== void 0 && d.push(asn1$4.generalizedTimeToDate(
    a.certValidity4GeneralizedTime
  )), d.length > 2)
    throw new Error("Cannot read notBefore/notAfter validity times; more than two times were provided in the certificate.");
  if (d.length < 2)
    throw new Error("Cannot read notBefore/notAfter validity times; they were not provided as either UTCTime or GeneralizedTime.");
  if (c.validity.notBefore = d[0], c.validity.notAfter = d[1], c.tbsCertificate = a.tbsCertificate, r) {
    c.md = _createSignatureDigest({
      signatureOid: c.signatureOid,
      type: "certificate"
    });
    var p = asn1$4.toDer(c.tbsCertificate);
    c.md.update(p.getBytes());
  }
  var h = forge$b.md.sha1.create(), g = asn1$4.toDer(a.certIssuer);
  h.update(g.getBytes()), c.issuer.getField = function(m) {
    return _getAttribute(c.issuer, m);
  }, c.issuer.addField = function(m) {
    _fillMissingFields([m]), c.issuer.attributes.push(m);
  }, c.issuer.attributes = pki$2.RDNAttributesAsArray(a.certIssuer), a.certIssuerUniqueId && (c.issuer.uniqueId = a.certIssuerUniqueId), c.issuer.hash = h.digest().toHex();
  var y = forge$b.md.sha1.create(), v = asn1$4.toDer(a.certSubject);
  return y.update(v.getBytes()), c.subject.getField = function(m) {
    return _getAttribute(c.subject, m);
  }, c.subject.addField = function(m) {
    _fillMissingFields([m]), c.subject.attributes.push(m);
  }, c.subject.attributes = pki$2.RDNAttributesAsArray(a.certSubject), a.certSubjectUniqueId && (c.subject.uniqueId = a.certSubjectUniqueId), c.subject.hash = y.digest().toHex(), a.certExtensions ? c.extensions = pki$2.certificateExtensionsFromAsn1(a.certExtensions) : c.extensions = [], c.publicKey = pki$2.publicKeyFromAsn1(a.subjectPublicKeyInfo), c;
};
pki$2.certificateExtensionsFromAsn1 = function(u) {
  for (var r = [], a = 0; a < u.value.length; ++a)
    for (var e = u.value[a], n = 0; n < e.value.length; ++n)
      r.push(pki$2.certificateExtensionFromAsn1(e.value[n]));
  return r;
};
pki$2.certificateExtensionFromAsn1 = function(u) {
  var r = {};
  if (r.id = asn1$4.derToOid(u.value[0].value), r.critical = !1, u.value[1].type === asn1$4.Type.BOOLEAN ? (r.critical = u.value[1].value.charCodeAt(0) !== 0, r.value = u.value[2].value) : r.value = u.value[1].value, r.id in oids) {
    if (r.name = oids[r.id], r.name === "keyUsage") {
      var a = asn1$4.fromDer(r.value), e = 0, n = 0;
      a.value.length > 1 && (e = a.value.charCodeAt(1), n = a.value.length > 2 ? a.value.charCodeAt(2) : 0), r.digitalSignature = (e & 128) === 128, r.nonRepudiation = (e & 64) === 64, r.keyEncipherment = (e & 32) === 32, r.dataEncipherment = (e & 16) === 16, r.keyAgreement = (e & 8) === 8, r.keyCertSign = (e & 4) === 4, r.cRLSign = (e & 2) === 2, r.encipherOnly = (e & 1) === 1, r.decipherOnly = (n & 128) === 128;
    } else if (r.name === "basicConstraints") {
      var a = asn1$4.fromDer(r.value);
      a.value.length > 0 && a.value[0].type === asn1$4.Type.BOOLEAN ? r.cA = a.value[0].value.charCodeAt(0) !== 0 : r.cA = !1;
      var o = null;
      a.value.length > 0 && a.value[0].type === asn1$4.Type.INTEGER ? o = a.value[0].value : a.value.length > 1 && (o = a.value[1].value), o !== null && (r.pathLenConstraint = asn1$4.derToInteger(o));
    } else if (r.name === "extKeyUsage")
      for (var a = asn1$4.fromDer(r.value), c = 0; c < a.value.length; ++c) {
        var l = asn1$4.derToOid(a.value[c].value);
        l in oids ? r[oids[l]] = !0 : r[l] = !0;
      }
    else if (r.name === "nsCertType") {
      var a = asn1$4.fromDer(r.value), e = 0;
      a.value.length > 1 && (e = a.value.charCodeAt(1)), r.client = (e & 128) === 128, r.server = (e & 64) === 64, r.email = (e & 32) === 32, r.objsign = (e & 16) === 16, r.reserved = (e & 8) === 8, r.sslCA = (e & 4) === 4, r.emailCA = (e & 2) === 2, r.objCA = (e & 1) === 1;
    } else if (r.name === "subjectAltName" || r.name === "issuerAltName") {
      r.altNames = [];
      for (var d, a = asn1$4.fromDer(r.value), p = 0; p < a.value.length; ++p) {
        d = a.value[p];
        var h = {
          type: d.type,
          value: d.value
        };
        switch (r.altNames.push(h), d.type) {
          case 1:
          case 2:
          case 6:
            break;
          case 7:
            h.ip = forge$b.util.bytesToIP(d.value);
            break;
          case 8:
            h.oid = asn1$4.derToOid(d.value);
            break;
        }
      }
    } else if (r.name === "subjectKeyIdentifier") {
      var a = asn1$4.fromDer(r.value);
      r.subjectKeyIdentifier = forge$b.util.bytesToHex(a.value);
    }
  }
  return r;
};
pki$2.certificationRequestFromAsn1 = function(u, r) {
  var a = {}, e = [];
  if (!asn1$4.validate(u, certificationRequestValidator, a, e)) {
    var n = new Error("Cannot read PKCS#10 certificate request. ASN.1 object is not a PKCS#10 CertificationRequest.");
    throw n.errors = e, n;
  }
  var o = asn1$4.derToOid(a.publicKeyOid);
  if (o !== pki$2.oids.rsaEncryption)
    throw new Error("Cannot read public key. OID is not RSA.");
  var c = pki$2.createCertificationRequest();
  if (c.version = a.csrVersion ? a.csrVersion.charCodeAt(0) : 0, c.signatureOid = forge$b.asn1.derToOid(a.csrSignatureOid), c.signatureParameters = _readSignatureParameters(
    c.signatureOid,
    a.csrSignatureParams,
    !0
  ), c.siginfo.algorithmOid = forge$b.asn1.derToOid(a.csrSignatureOid), c.siginfo.parameters = _readSignatureParameters(
    c.siginfo.algorithmOid,
    a.csrSignatureParams,
    !1
  ), c.signature = a.csrSignature, c.certificationRequestInfo = a.certificationRequestInfo, r) {
    c.md = _createSignatureDigest({
      signatureOid: c.signatureOid,
      type: "certification request"
    });
    var l = asn1$4.toDer(c.certificationRequestInfo);
    c.md.update(l.getBytes());
  }
  var d = forge$b.md.sha1.create();
  return c.subject.getField = function(p) {
    return _getAttribute(c.subject, p);
  }, c.subject.addField = function(p) {
    _fillMissingFields([p]), c.subject.attributes.push(p);
  }, c.subject.attributes = pki$2.RDNAttributesAsArray(
    a.certificationRequestInfoSubject,
    d
  ), c.subject.hash = d.digest().toHex(), c.publicKey = pki$2.publicKeyFromAsn1(a.subjectPublicKeyInfo), c.getAttribute = function(p) {
    return _getAttribute(c, p);
  }, c.addAttribute = function(p) {
    _fillMissingFields([p]), c.attributes.push(p);
  }, c.attributes = pki$2.CRIAttributesAsArray(
    a.certificationRequestInfoAttributes || []
  ), c;
};
pki$2.createCertificationRequest = function() {
  var u = {};
  return u.version = 0, u.signatureOid = null, u.signature = null, u.siginfo = {}, u.siginfo.algorithmOid = null, u.subject = {}, u.subject.getField = function(r) {
    return _getAttribute(u.subject, r);
  }, u.subject.addField = function(r) {
    _fillMissingFields([r]), u.subject.attributes.push(r);
  }, u.subject.attributes = [], u.subject.hash = null, u.publicKey = null, u.attributes = [], u.getAttribute = function(r) {
    return _getAttribute(u, r);
  }, u.addAttribute = function(r) {
    _fillMissingFields([r]), u.attributes.push(r);
  }, u.md = null, u.setSubject = function(r) {
    _fillMissingFields(r), u.subject.attributes = r, u.subject.hash = null;
  }, u.setAttributes = function(r) {
    _fillMissingFields(r), u.attributes = r;
  }, u.sign = function(r, a) {
    u.md = a || forge$b.md.sha1.create();
    var e = oids[u.md.algorithm + "WithRSAEncryption"];
    if (!e) {
      var n = new Error("Could not compute certification request digest. Unknown message digest algorithm OID.");
      throw n.algorithm = u.md.algorithm, n;
    }
    u.signatureOid = u.siginfo.algorithmOid = e, u.certificationRequestInfo = pki$2.getCertificationRequestInfo(u);
    var o = asn1$4.toDer(u.certificationRequestInfo);
    u.md.update(o.getBytes()), u.signature = r.sign(u.md);
  }, u.verify = function() {
    var r = !1, a = u.md;
    if (a === null) {
      a = _createSignatureDigest({
        signatureOid: u.signatureOid,
        type: "certification request"
      });
      var e = u.certificationRequestInfo || pki$2.getCertificationRequestInfo(u), n = asn1$4.toDer(e);
      a.update(n.getBytes());
    }
    return a !== null && (r = _verifySignature({
      certificate: u,
      md: a,
      signature: u.signature
    })), r;
  }, u;
};
function _dnToAsn1(u) {
  for (var r = asn1$4.create(
    asn1$4.Class.UNIVERSAL,
    asn1$4.Type.SEQUENCE,
    !0,
    []
  ), a, e, n = u.attributes, o = 0; o < n.length; ++o) {
    a = n[o];
    var c = a.value, l = asn1$4.Type.PRINTABLESTRING;
    "valueTagClass" in a && (l = a.valueTagClass, l === asn1$4.Type.UTF8 && (c = forge$b.util.encodeUtf8(c))), e = asn1$4.create(asn1$4.Class.UNIVERSAL, asn1$4.Type.SET, !0, [
      asn1$4.create(asn1$4.Class.UNIVERSAL, asn1$4.Type.SEQUENCE, !0, [
        // AttributeType
        asn1$4.create(
          asn1$4.Class.UNIVERSAL,
          asn1$4.Type.OID,
          !1,
          asn1$4.oidToDer(a.type).getBytes()
        ),
        // AttributeValue
        asn1$4.create(asn1$4.Class.UNIVERSAL, l, !1, c)
      ])
    ]), r.value.push(e);
  }
  return r;
}
function _fillMissingFields(u) {
  for (var r, a = 0; a < u.length; ++a) {
    if (r = u[a], typeof r.name > "u" && (r.type && r.type in pki$2.oids ? r.name = pki$2.oids[r.type] : r.shortName && r.shortName in _shortNames && (r.name = pki$2.oids[_shortNames[r.shortName]])), typeof r.type > "u")
      if (r.name && r.name in pki$2.oids)
        r.type = pki$2.oids[r.name];
      else {
        var e = new Error("Attribute type not specified.");
        throw e.attribute = r, e;
      }
    if (typeof r.shortName > "u" && r.name && r.name in _shortNames && (r.shortName = _shortNames[r.name]), r.type === oids.extensionRequest && (r.valueConstructed = !0, r.valueTagClass = asn1$4.Type.SEQUENCE, !r.value && r.extensions)) {
      r.value = [];
      for (var n = 0; n < r.extensions.length; ++n)
        r.value.push(pki$2.certificateExtensionToAsn1(
          _fillMissingExtensionFields(r.extensions[n])
        ));
    }
    if (typeof r.value > "u") {
      var e = new Error("Attribute value not specified.");
      throw e.attribute = r, e;
    }
  }
}
function _fillMissingExtensionFields(u, r) {
  if (r = r || {}, typeof u.name > "u" && u.id && u.id in pki$2.oids && (u.name = pki$2.oids[u.id]), typeof u.id > "u")
    if (u.name && u.name in pki$2.oids)
      u.id = pki$2.oids[u.name];
    else {
      var a = new Error("Extension ID not specified.");
      throw a.extension = u, a;
    }
  if (typeof u.value < "u")
    return u;
  if (u.name === "keyUsage") {
    var e = 0, n = 0, o = 0;
    u.digitalSignature && (n |= 128, e = 7), u.nonRepudiation && (n |= 64, e = 6), u.keyEncipherment && (n |= 32, e = 5), u.dataEncipherment && (n |= 16, e = 4), u.keyAgreement && (n |= 8, e = 3), u.keyCertSign && (n |= 4, e = 2), u.cRLSign && (n |= 2, e = 1), u.encipherOnly && (n |= 1, e = 0), u.decipherOnly && (o |= 128, e = 7);
    var c = String.fromCharCode(e);
    o !== 0 ? c += String.fromCharCode(n) + String.fromCharCode(o) : n !== 0 && (c += String.fromCharCode(n)), u.value = asn1$4.create(
      asn1$4.Class.UNIVERSAL,
      asn1$4.Type.BITSTRING,
      !1,
      c
    );
  } else if (u.name === "basicConstraints")
    u.value = asn1$4.create(
      asn1$4.Class.UNIVERSAL,
      asn1$4.Type.SEQUENCE,
      !0,
      []
    ), u.cA && u.value.value.push(asn1$4.create(
      asn1$4.Class.UNIVERSAL,
      asn1$4.Type.BOOLEAN,
      !1,
      "ÿ"
    )), "pathLenConstraint" in u && u.value.value.push(asn1$4.create(
      asn1$4.Class.UNIVERSAL,
      asn1$4.Type.INTEGER,
      !1,
      asn1$4.integerToDer(u.pathLenConstraint).getBytes()
    ));
  else if (u.name === "extKeyUsage") {
    u.value = asn1$4.create(
      asn1$4.Class.UNIVERSAL,
      asn1$4.Type.SEQUENCE,
      !0,
      []
    );
    var l = u.value.value;
    for (var d in u)
      u[d] === !0 && (d in oids ? l.push(asn1$4.create(
        asn1$4.Class.UNIVERSAL,
        asn1$4.Type.OID,
        !1,
        asn1$4.oidToDer(oids[d]).getBytes()
      )) : d.indexOf(".") !== -1 && l.push(asn1$4.create(
        asn1$4.Class.UNIVERSAL,
        asn1$4.Type.OID,
        !1,
        asn1$4.oidToDer(d).getBytes()
      )));
  } else if (u.name === "nsCertType") {
    var e = 0, n = 0;
    u.client && (n |= 128, e = 7), u.server && (n |= 64, e = 6), u.email && (n |= 32, e = 5), u.objsign && (n |= 16, e = 4), u.reserved && (n |= 8, e = 3), u.sslCA && (n |= 4, e = 2), u.emailCA && (n |= 2, e = 1), u.objCA && (n |= 1, e = 0);
    var c = String.fromCharCode(e);
    n !== 0 && (c += String.fromCharCode(n)), u.value = asn1$4.create(
      asn1$4.Class.UNIVERSAL,
      asn1$4.Type.BITSTRING,
      !1,
      c
    );
  } else if (u.name === "subjectAltName" || u.name === "issuerAltName") {
    u.value = asn1$4.create(asn1$4.Class.UNIVERSAL, asn1$4.Type.SEQUENCE, !0, []);
    for (var p, h = 0; h < u.altNames.length; ++h) {
      p = u.altNames[h];
      var c = p.value;
      if (p.type === 7 && p.ip) {
        if (c = forge$b.util.bytesFromIP(p.ip), c === null) {
          var a = new Error(
            'Extension "ip" value is not a valid IPv4 or IPv6 address.'
          );
          throw a.extension = u, a;
        }
      } else
        p.type === 8 && (p.oid ? c = asn1$4.oidToDer(asn1$4.oidToDer(p.oid)) : c = asn1$4.oidToDer(c));
      u.value.value.push(asn1$4.create(
        asn1$4.Class.CONTEXT_SPECIFIC,
        p.type,
        !1,
        c
      ));
    }
  } else if (u.name === "nsComment" && r.cert) {
    if (!/^[\x00-\x7F]*$/.test(u.comment) || u.comment.length < 1 || u.comment.length > 128)
      throw new Error('Invalid "nsComment" content.');
    u.value = asn1$4.create(
      asn1$4.Class.UNIVERSAL,
      asn1$4.Type.IA5STRING,
      !1,
      u.comment
    );
  } else if (u.name === "subjectKeyIdentifier" && r.cert) {
    var g = r.cert.generateSubjectKeyIdentifier();
    u.subjectKeyIdentifier = g.toHex(), u.value = asn1$4.create(
      asn1$4.Class.UNIVERSAL,
      asn1$4.Type.OCTETSTRING,
      !1,
      g.getBytes()
    );
  } else if (u.name === "authorityKeyIdentifier" && r.cert) {
    u.value = asn1$4.create(asn1$4.Class.UNIVERSAL, asn1$4.Type.SEQUENCE, !0, []);
    var l = u.value.value;
    if (u.keyIdentifier) {
      var y = u.keyIdentifier === !0 ? r.cert.generateSubjectKeyIdentifier().getBytes() : u.keyIdentifier;
      l.push(
        asn1$4.create(asn1$4.Class.CONTEXT_SPECIFIC, 0, !1, y)
      );
    }
    if (u.authorityCertIssuer) {
      var v = [
        asn1$4.create(asn1$4.Class.CONTEXT_SPECIFIC, 4, !0, [
          _dnToAsn1(u.authorityCertIssuer === !0 ? r.cert.issuer : u.authorityCertIssuer)
        ])
      ];
      l.push(
        asn1$4.create(asn1$4.Class.CONTEXT_SPECIFIC, 1, !0, v)
      );
    }
    if (u.serialNumber) {
      var m = forge$b.util.hexToBytes(u.serialNumber === !0 ? r.cert.serialNumber : u.serialNumber);
      l.push(
        asn1$4.create(asn1$4.Class.CONTEXT_SPECIFIC, 2, !1, m)
      );
    }
  } else if (u.name === "cRLDistributionPoints") {
    u.value = asn1$4.create(asn1$4.Class.UNIVERSAL, asn1$4.Type.SEQUENCE, !0, []);
    for (var l = u.value.value, b = asn1$4.create(
      asn1$4.Class.UNIVERSAL,
      asn1$4.Type.SEQUENCE,
      !0,
      []
    ), R = asn1$4.create(
      asn1$4.Class.CONTEXT_SPECIFIC,
      0,
      !0,
      []
    ), p, h = 0; h < u.altNames.length; ++h) {
      p = u.altNames[h];
      var c = p.value;
      if (p.type === 7 && p.ip) {
        if (c = forge$b.util.bytesFromIP(p.ip), c === null) {
          var a = new Error(
            'Extension "ip" value is not a valid IPv4 or IPv6 address.'
          );
          throw a.extension = u, a;
        }
      } else
        p.type === 8 && (p.oid ? c = asn1$4.oidToDer(asn1$4.oidToDer(p.oid)) : c = asn1$4.oidToDer(c));
      R.value.push(asn1$4.create(
        asn1$4.Class.CONTEXT_SPECIFIC,
        p.type,
        !1,
        c
      ));
    }
    b.value.push(asn1$4.create(
      asn1$4.Class.CONTEXT_SPECIFIC,
      0,
      !0,
      [R]
    )), l.push(b);
  }
  if (typeof u.value > "u") {
    var a = new Error("Extension value not specified.");
    throw a.extension = u, a;
  }
  return u;
}
function _signatureParametersToAsn1(u, r) {
  switch (u) {
    case oids["RSASSA-PSS"]:
      var a = [];
      return r.hash.algorithmOid !== void 0 && a.push(asn1$4.create(asn1$4.Class.CONTEXT_SPECIFIC, 0, !0, [
        asn1$4.create(asn1$4.Class.UNIVERSAL, asn1$4.Type.SEQUENCE, !0, [
          asn1$4.create(
            asn1$4.Class.UNIVERSAL,
            asn1$4.Type.OID,
            !1,
            asn1$4.oidToDer(r.hash.algorithmOid).getBytes()
          ),
          asn1$4.create(asn1$4.Class.UNIVERSAL, asn1$4.Type.NULL, !1, "")
        ])
      ])), r.mgf.algorithmOid !== void 0 && a.push(asn1$4.create(asn1$4.Class.CONTEXT_SPECIFIC, 1, !0, [
        asn1$4.create(asn1$4.Class.UNIVERSAL, asn1$4.Type.SEQUENCE, !0, [
          asn1$4.create(
            asn1$4.Class.UNIVERSAL,
            asn1$4.Type.OID,
            !1,
            asn1$4.oidToDer(r.mgf.algorithmOid).getBytes()
          ),
          asn1$4.create(asn1$4.Class.UNIVERSAL, asn1$4.Type.SEQUENCE, !0, [
            asn1$4.create(
              asn1$4.Class.UNIVERSAL,
              asn1$4.Type.OID,
              !1,
              asn1$4.oidToDer(r.mgf.hash.algorithmOid).getBytes()
            ),
            asn1$4.create(asn1$4.Class.UNIVERSAL, asn1$4.Type.NULL, !1, "")
          ])
        ])
      ])), r.saltLength !== void 0 && a.push(asn1$4.create(asn1$4.Class.CONTEXT_SPECIFIC, 2, !0, [
        asn1$4.create(
          asn1$4.Class.UNIVERSAL,
          asn1$4.Type.INTEGER,
          !1,
          asn1$4.integerToDer(r.saltLength).getBytes()
        )
      ])), asn1$4.create(asn1$4.Class.UNIVERSAL, asn1$4.Type.SEQUENCE, !0, a);
    default:
      return asn1$4.create(asn1$4.Class.UNIVERSAL, asn1$4.Type.NULL, !1, "");
  }
}
function _CRIAttributesToAsn1(u) {
  var r = asn1$4.create(asn1$4.Class.CONTEXT_SPECIFIC, 0, !0, []);
  if (u.attributes.length === 0)
    return r;
  for (var a = u.attributes, e = 0; e < a.length; ++e) {
    var n = a[e], o = n.value, c = asn1$4.Type.UTF8;
    "valueTagClass" in n && (c = n.valueTagClass), c === asn1$4.Type.UTF8 && (o = forge$b.util.encodeUtf8(o));
    var l = !1;
    "valueConstructed" in n && (l = n.valueConstructed);
    var d = asn1$4.create(asn1$4.Class.UNIVERSAL, asn1$4.Type.SEQUENCE, !0, [
      // AttributeType
      asn1$4.create(
        asn1$4.Class.UNIVERSAL,
        asn1$4.Type.OID,
        !1,
        asn1$4.oidToDer(n.type).getBytes()
      ),
      asn1$4.create(asn1$4.Class.UNIVERSAL, asn1$4.Type.SET, !0, [
        // AttributeValue
        asn1$4.create(
          asn1$4.Class.UNIVERSAL,
          c,
          l,
          o
        )
      ])
    ]);
    r.value.push(d);
  }
  return r;
}
var jan_1_1950 = /* @__PURE__ */ new Date("1950-01-01T00:00:00Z"), jan_1_2050 = /* @__PURE__ */ new Date("2050-01-01T00:00:00Z");
function _dateToAsn1(u) {
  return u >= jan_1_1950 && u < jan_1_2050 ? asn1$4.create(
    asn1$4.Class.UNIVERSAL,
    asn1$4.Type.UTCTIME,
    !1,
    asn1$4.dateToUtcTime(u)
  ) : asn1$4.create(
    asn1$4.Class.UNIVERSAL,
    asn1$4.Type.GENERALIZEDTIME,
    !1,
    asn1$4.dateToGeneralizedTime(u)
  );
}
pki$2.getTBSCertificate = function(u) {
  var r = _dateToAsn1(u.validity.notBefore), a = _dateToAsn1(u.validity.notAfter), e = asn1$4.create(asn1$4.Class.UNIVERSAL, asn1$4.Type.SEQUENCE, !0, [
    // version
    asn1$4.create(asn1$4.Class.CONTEXT_SPECIFIC, 0, !0, [
      // integer
      asn1$4.create(
        asn1$4.Class.UNIVERSAL,
        asn1$4.Type.INTEGER,
        !1,
        asn1$4.integerToDer(u.version).getBytes()
      )
    ]),
    // serialNumber
    asn1$4.create(
      asn1$4.Class.UNIVERSAL,
      asn1$4.Type.INTEGER,
      !1,
      forge$b.util.hexToBytes(u.serialNumber)
    ),
    // signature
    asn1$4.create(asn1$4.Class.UNIVERSAL, asn1$4.Type.SEQUENCE, !0, [
      // algorithm
      asn1$4.create(
        asn1$4.Class.UNIVERSAL,
        asn1$4.Type.OID,
        !1,
        asn1$4.oidToDer(u.siginfo.algorithmOid).getBytes()
      ),
      // parameters
      _signatureParametersToAsn1(
        u.siginfo.algorithmOid,
        u.siginfo.parameters
      )
    ]),
    // issuer
    _dnToAsn1(u.issuer),
    // validity
    asn1$4.create(asn1$4.Class.UNIVERSAL, asn1$4.Type.SEQUENCE, !0, [
      r,
      a
    ]),
    // subject
    _dnToAsn1(u.subject),
    // SubjectPublicKeyInfo
    pki$2.publicKeyToAsn1(u.publicKey)
  ]);
  return u.issuer.uniqueId && e.value.push(
    asn1$4.create(asn1$4.Class.CONTEXT_SPECIFIC, 1, !0, [
      asn1$4.create(
        asn1$4.Class.UNIVERSAL,
        asn1$4.Type.BITSTRING,
        !1,
        // TODO: support arbitrary bit length ids
        "\0" + u.issuer.uniqueId
      )
    ])
  ), u.subject.uniqueId && e.value.push(
    asn1$4.create(asn1$4.Class.CONTEXT_SPECIFIC, 2, !0, [
      asn1$4.create(
        asn1$4.Class.UNIVERSAL,
        asn1$4.Type.BITSTRING,
        !1,
        // TODO: support arbitrary bit length ids
        "\0" + u.subject.uniqueId
      )
    ])
  ), u.extensions.length > 0 && e.value.push(pki$2.certificateExtensionsToAsn1(u.extensions)), e;
};
pki$2.getCertificationRequestInfo = function(u) {
  var r = asn1$4.create(asn1$4.Class.UNIVERSAL, asn1$4.Type.SEQUENCE, !0, [
    // version
    asn1$4.create(
      asn1$4.Class.UNIVERSAL,
      asn1$4.Type.INTEGER,
      !1,
      asn1$4.integerToDer(u.version).getBytes()
    ),
    // subject
    _dnToAsn1(u.subject),
    // SubjectPublicKeyInfo
    pki$2.publicKeyToAsn1(u.publicKey),
    // attributes
    _CRIAttributesToAsn1(u)
  ]);
  return r;
};
pki$2.distinguishedNameToAsn1 = function(u) {
  return _dnToAsn1(u);
};
pki$2.certificateToAsn1 = function(u) {
  var r = u.tbsCertificate || pki$2.getTBSCertificate(u);
  return asn1$4.create(asn1$4.Class.UNIVERSAL, asn1$4.Type.SEQUENCE, !0, [
    // TBSCertificate
    r,
    // AlgorithmIdentifier (signature algorithm)
    asn1$4.create(asn1$4.Class.UNIVERSAL, asn1$4.Type.SEQUENCE, !0, [
      // algorithm
      asn1$4.create(
        asn1$4.Class.UNIVERSAL,
        asn1$4.Type.OID,
        !1,
        asn1$4.oidToDer(u.signatureOid).getBytes()
      ),
      // parameters
      _signatureParametersToAsn1(u.signatureOid, u.signatureParameters)
    ]),
    // SignatureValue
    asn1$4.create(
      asn1$4.Class.UNIVERSAL,
      asn1$4.Type.BITSTRING,
      !1,
      "\0" + u.signature
    )
  ]);
};
pki$2.certificateExtensionsToAsn1 = function(u) {
  var r = asn1$4.create(asn1$4.Class.CONTEXT_SPECIFIC, 3, !0, []), a = asn1$4.create(asn1$4.Class.UNIVERSAL, asn1$4.Type.SEQUENCE, !0, []);
  r.value.push(a);
  for (var e = 0; e < u.length; ++e)
    a.value.push(pki$2.certificateExtensionToAsn1(u[e]));
  return r;
};
pki$2.certificateExtensionToAsn1 = function(u) {
  var r = asn1$4.create(asn1$4.Class.UNIVERSAL, asn1$4.Type.SEQUENCE, !0, []);
  r.value.push(asn1$4.create(
    asn1$4.Class.UNIVERSAL,
    asn1$4.Type.OID,
    !1,
    asn1$4.oidToDer(u.id).getBytes()
  )), u.critical && r.value.push(asn1$4.create(
    asn1$4.Class.UNIVERSAL,
    asn1$4.Type.BOOLEAN,
    !1,
    "ÿ"
  ));
  var a = u.value;
  return typeof u.value != "string" && (a = asn1$4.toDer(a).getBytes()), r.value.push(asn1$4.create(
    asn1$4.Class.UNIVERSAL,
    asn1$4.Type.OCTETSTRING,
    !1,
    a
  )), r;
};
pki$2.certificationRequestToAsn1 = function(u) {
  var r = u.certificationRequestInfo || pki$2.getCertificationRequestInfo(u);
  return asn1$4.create(asn1$4.Class.UNIVERSAL, asn1$4.Type.SEQUENCE, !0, [
    // CertificationRequestInfo
    r,
    // AlgorithmIdentifier (signature algorithm)
    asn1$4.create(asn1$4.Class.UNIVERSAL, asn1$4.Type.SEQUENCE, !0, [
      // algorithm
      asn1$4.create(
        asn1$4.Class.UNIVERSAL,
        asn1$4.Type.OID,
        !1,
        asn1$4.oidToDer(u.signatureOid).getBytes()
      ),
      // parameters
      _signatureParametersToAsn1(u.signatureOid, u.signatureParameters)
    ]),
    // signature
    asn1$4.create(
      asn1$4.Class.UNIVERSAL,
      asn1$4.Type.BITSTRING,
      !1,
      "\0" + u.signature
    )
  ]);
};
pki$2.createCaStore = function(u) {
  var r = {
    // stored certificates
    certs: {}
  };
  r.getIssuer = function(c) {
    var l = a(c.issuer);
    return l;
  }, r.addCertificate = function(c) {
    if (typeof c == "string" && (c = forge$b.pki.certificateFromPem(c)), e(c.subject), !r.hasCertificate(c))
      if (c.subject.hash in r.certs) {
        var l = r.certs[c.subject.hash];
        forge$b.util.isArray(l) || (l = [l]), l.push(c), r.certs[c.subject.hash] = l;
      } else
        r.certs[c.subject.hash] = c;
  }, r.hasCertificate = function(c) {
    typeof c == "string" && (c = forge$b.pki.certificateFromPem(c));
    var l = a(c.subject);
    if (!l)
      return !1;
    forge$b.util.isArray(l) || (l = [l]);
    for (var d = asn1$4.toDer(pki$2.certificateToAsn1(c)).getBytes(), p = 0; p < l.length; ++p) {
      var h = asn1$4.toDer(pki$2.certificateToAsn1(l[p])).getBytes();
      if (d === h)
        return !0;
    }
    return !1;
  }, r.listAllCertificates = function() {
    var c = [];
    for (var l in r.certs)
      if (r.certs.hasOwnProperty(l)) {
        var d = r.certs[l];
        if (!forge$b.util.isArray(d))
          c.push(d);
        else
          for (var p = 0; p < d.length; ++p)
            c.push(d[p]);
      }
    return c;
  }, r.removeCertificate = function(c) {
    var l;
    if (typeof c == "string" && (c = forge$b.pki.certificateFromPem(c)), e(c.subject), !r.hasCertificate(c))
      return null;
    var d = a(c.subject);
    if (!forge$b.util.isArray(d))
      return l = r.certs[c.subject.hash], delete r.certs[c.subject.hash], l;
    for (var p = asn1$4.toDer(pki$2.certificateToAsn1(c)).getBytes(), h = 0; h < d.length; ++h) {
      var g = asn1$4.toDer(pki$2.certificateToAsn1(d[h])).getBytes();
      p === g && (l = d[h], d.splice(h, 1));
    }
    return d.length === 0 && delete r.certs[c.subject.hash], l;
  };
  function a(c) {
    return e(c), r.certs[c.hash] || null;
  }
  function e(c) {
    if (!c.hash) {
      var l = forge$b.md.sha1.create();
      c.attributes = pki$2.RDNAttributesAsArray(_dnToAsn1(c), l), c.hash = l.digest().toHex();
    }
  }
  if (u)
    for (var n = 0; n < u.length; ++n) {
      var o = u[n];
      r.addCertificate(o);
    }
  return r;
};
pki$2.certificateError = {
  bad_certificate: "forge.pki.BadCertificate",
  unsupported_certificate: "forge.pki.UnsupportedCertificate",
  certificate_revoked: "forge.pki.CertificateRevoked",
  certificate_expired: "forge.pki.CertificateExpired",
  certificate_unknown: "forge.pki.CertificateUnknown",
  unknown_ca: "forge.pki.UnknownCertificateAuthority"
};
pki$2.verifyCertificateChain = function(u, r, a) {
  typeof a == "function" && (a = { verify: a }), a = a || {}, r = r.slice(0);
  var e = r.slice(0), n = a.validityCheckDate;
  typeof n > "u" && (n = /* @__PURE__ */ new Date());
  var o = !0, c = null, l = 0;
  do {
    var d = r.shift(), p = null, h = !1;
    if (n && (n < d.validity.notBefore || n > d.validity.notAfter) && (c = {
      message: "Certificate is not valid yet or has expired.",
      error: pki$2.certificateError.certificate_expired,
      notBefore: d.validity.notBefore,
      notAfter: d.validity.notAfter,
      // TODO: we might want to reconsider renaming 'now' to
      // 'validityCheckDate' should this API be changed in the future.
      now: n
    }), c === null) {
      if (p = r[0] || u.getIssuer(d), p === null && d.isIssuer(d) && (h = !0, p = d), p) {
        var g = p;
        forge$b.util.isArray(g) || (g = [g]);
        for (var y = !1; !y && g.length > 0; ) {
          p = g.shift();
          try {
            y = p.verify(d);
          } catch {
          }
        }
        y || (c = {
          message: "Certificate signature is invalid.",
          error: pki$2.certificateError.bad_certificate
        });
      }
      c === null && (!p || h) && !u.hasCertificate(d) && (c = {
        message: "Certificate is not trusted.",
        error: pki$2.certificateError.unknown_ca
      });
    }
    if (c === null && p && !d.isIssuer(p) && (c = {
      message: "Certificate issuer is invalid.",
      error: pki$2.certificateError.bad_certificate
    }), c === null)
      for (var v = {
        keyUsage: !0,
        basicConstraints: !0
      }, m = 0; c === null && m < d.extensions.length; ++m) {
        var b = d.extensions[m];
        b.critical && !(b.name in v) && (c = {
          message: "Certificate has an unsupported critical extension.",
          error: pki$2.certificateError.unsupported_certificate
        });
      }
    if (c === null && (!o || r.length === 0 && (!p || h))) {
      var R = d.getExtension("basicConstraints"), $ = d.getExtension("keyUsage");
      if ($ !== null && (!$.keyCertSign || R === null) && (c = {
        message: "Certificate keyUsage or basicConstraints conflict or indicate that the certificate is not a CA. If the certificate is the only one in the chain or isn't the first then the certificate must be a valid CA.",
        error: pki$2.certificateError.bad_certificate
      }), c === null && R !== null && !R.cA && (c = {
        message: "Certificate basicConstraints indicates the certificate is not a CA.",
        error: pki$2.certificateError.bad_certificate
      }), c === null && $ !== null && "pathLenConstraint" in R) {
        var x = l - 1;
        x > R.pathLenConstraint && (c = {
          message: "Certificate basicConstraints pathLenConstraint violated.",
          error: pki$2.certificateError.bad_certificate
        });
      }
    }
    var E = c === null ? !0 : c.error, T = a.verify ? a.verify(E, l, e) : E;
    if (T === !0)
      c = null;
    else
      throw E === !0 && (c = {
        message: "The application rejected the certificate.",
        error: pki$2.certificateError.bad_certificate
      }), (T || T === 0) && (typeof T == "object" && !forge$b.util.isArray(T) ? (T.message && (c.message = T.message), T.error && (c.error = T.error)) : typeof T == "string" && (c.error = T)), c;
    o = !1, ++l;
  } while (r.length > 0);
  return !0;
};
var forge$a = forge$C, asn1$3 = forge$a.asn1, pki$1 = forge$a.pki, p12 = forge$a.pkcs12 = forge$a.pkcs12 || {}, contentInfoValidator = {
  name: "ContentInfo",
  tagClass: asn1$3.Class.UNIVERSAL,
  type: asn1$3.Type.SEQUENCE,
  // a ContentInfo
  constructed: !0,
  value: [{
    name: "ContentInfo.contentType",
    tagClass: asn1$3.Class.UNIVERSAL,
    type: asn1$3.Type.OID,
    constructed: !1,
    capture: "contentType"
  }, {
    name: "ContentInfo.content",
    tagClass: asn1$3.Class.CONTEXT_SPECIFIC,
    constructed: !0,
    captureAsn1: "content"
  }]
}, pfxValidator = {
  name: "PFX",
  tagClass: asn1$3.Class.UNIVERSAL,
  type: asn1$3.Type.SEQUENCE,
  constructed: !0,
  value: [
    {
      name: "PFX.version",
      tagClass: asn1$3.Class.UNIVERSAL,
      type: asn1$3.Type.INTEGER,
      constructed: !1,
      capture: "version"
    },
    contentInfoValidator,
    {
      name: "PFX.macData",
      tagClass: asn1$3.Class.UNIVERSAL,
      type: asn1$3.Type.SEQUENCE,
      constructed: !0,
      optional: !0,
      captureAsn1: "mac",
      value: [{
        name: "PFX.macData.mac",
        tagClass: asn1$3.Class.UNIVERSAL,
        type: asn1$3.Type.SEQUENCE,
        // DigestInfo
        constructed: !0,
        value: [{
          name: "PFX.macData.mac.digestAlgorithm",
          tagClass: asn1$3.Class.UNIVERSAL,
          type: asn1$3.Type.SEQUENCE,
          // DigestAlgorithmIdentifier
          constructed: !0,
          value: [{
            name: "PFX.macData.mac.digestAlgorithm.algorithm",
            tagClass: asn1$3.Class.UNIVERSAL,
            type: asn1$3.Type.OID,
            constructed: !1,
            capture: "macAlgorithm"
          }, {
            name: "PFX.macData.mac.digestAlgorithm.parameters",
            tagClass: asn1$3.Class.UNIVERSAL,
            captureAsn1: "macAlgorithmParameters"
          }]
        }, {
          name: "PFX.macData.mac.digest",
          tagClass: asn1$3.Class.UNIVERSAL,
          type: asn1$3.Type.OCTETSTRING,
          constructed: !1,
          capture: "macDigest"
        }]
      }, {
        name: "PFX.macData.macSalt",
        tagClass: asn1$3.Class.UNIVERSAL,
        type: asn1$3.Type.OCTETSTRING,
        constructed: !1,
        capture: "macSalt"
      }, {
        name: "PFX.macData.iterations",
        tagClass: asn1$3.Class.UNIVERSAL,
        type: asn1$3.Type.INTEGER,
        constructed: !1,
        optional: !0,
        capture: "macIterations"
      }]
    }
  ]
}, safeBagValidator = {
  name: "SafeBag",
  tagClass: asn1$3.Class.UNIVERSAL,
  type: asn1$3.Type.SEQUENCE,
  constructed: !0,
  value: [{
    name: "SafeBag.bagId",
    tagClass: asn1$3.Class.UNIVERSAL,
    type: asn1$3.Type.OID,
    constructed: !1,
    capture: "bagId"
  }, {
    name: "SafeBag.bagValue",
    tagClass: asn1$3.Class.CONTEXT_SPECIFIC,
    constructed: !0,
    captureAsn1: "bagValue"
  }, {
    name: "SafeBag.bagAttributes",
    tagClass: asn1$3.Class.UNIVERSAL,
    type: asn1$3.Type.SET,
    constructed: !0,
    optional: !0,
    capture: "bagAttributes"
  }]
}, attributeValidator = {
  name: "Attribute",
  tagClass: asn1$3.Class.UNIVERSAL,
  type: asn1$3.Type.SEQUENCE,
  constructed: !0,
  value: [{
    name: "Attribute.attrId",
    tagClass: asn1$3.Class.UNIVERSAL,
    type: asn1$3.Type.OID,
    constructed: !1,
    capture: "oid"
  }, {
    name: "Attribute.attrValues",
    tagClass: asn1$3.Class.UNIVERSAL,
    type: asn1$3.Type.SET,
    constructed: !0,
    capture: "values"
  }]
}, certBagValidator = {
  name: "CertBag",
  tagClass: asn1$3.Class.UNIVERSAL,
  type: asn1$3.Type.SEQUENCE,
  constructed: !0,
  value: [{
    name: "CertBag.certId",
    tagClass: asn1$3.Class.UNIVERSAL,
    type: asn1$3.Type.OID,
    constructed: !1,
    capture: "certId"
  }, {
    name: "CertBag.certValue",
    tagClass: asn1$3.Class.CONTEXT_SPECIFIC,
    constructed: !0,
    /* So far we only support X.509 certificates (which are wrapped in
       an OCTET STRING, hence hard code that here). */
    value: [{
      name: "CertBag.certValue[0]",
      tagClass: asn1$3.Class.UNIVERSAL,
      type: asn1$3.Class.OCTETSTRING,
      constructed: !1,
      capture: "cert"
    }]
  }]
};
function _getBagsByAttribute(u, r, a, e) {
  for (var n = [], o = 0; o < u.length; o++)
    for (var c = 0; c < u[o].safeBags.length; c++) {
      var l = u[o].safeBags[c];
      if (!(e !== void 0 && l.type !== e)) {
        if (r === null) {
          n.push(l);
          continue;
        }
        l.attributes[r] !== void 0 && l.attributes[r].indexOf(a) >= 0 && n.push(l);
      }
    }
  return n;
}
p12.pkcs12FromAsn1 = function(u, r, a) {
  typeof r == "string" ? (a = r, r = !0) : r === void 0 && (r = !0);
  var e = {}, n = [];
  if (!asn1$3.validate(u, pfxValidator, e, n)) {
    var o = new Error("Cannot read PKCS#12 PFX. ASN.1 object is not an PKCS#12 PFX.");
    throw o.errors = o, o;
  }
  var c = {
    version: e.version.charCodeAt(0),
    safeContents: [],
    /**
     * Gets bags with matching attributes.
     *
     * @param filter the attributes to filter by:
     *          [localKeyId] the localKeyId to search for.
     *          [localKeyIdHex] the localKeyId in hex to search for.
     *          [friendlyName] the friendly name to search for.
     *          [bagType] bag type to narrow each attribute search by.
     *
     * @return a map of attribute type to an array of matching bags or, if no
     *           attribute was given but a bag type, the map key will be the
     *           bag type.
     */
    getBags: function(R) {
      var $ = {}, x;
      return "localKeyId" in R ? x = R.localKeyId : "localKeyIdHex" in R && (x = forge$a.util.hexToBytes(R.localKeyIdHex)), x === void 0 && !("friendlyName" in R) && "bagType" in R && ($[R.bagType] = _getBagsByAttribute(
        c.safeContents,
        null,
        null,
        R.bagType
      )), x !== void 0 && ($.localKeyId = _getBagsByAttribute(
        c.safeContents,
        "localKeyId",
        x,
        R.bagType
      )), "friendlyName" in R && ($.friendlyName = _getBagsByAttribute(
        c.safeContents,
        "friendlyName",
        R.friendlyName,
        R.bagType
      )), $;
    },
    /**
     * DEPRECATED: use getBags() instead.
     *
     * Get bags with matching friendlyName attribute.
     *
     * @param friendlyName the friendly name to search for.
     * @param [bagType] bag type to narrow search by.
     *
     * @return an array of bags with matching friendlyName attribute.
     */
    getBagsByFriendlyName: function(R, $) {
      return _getBagsByAttribute(
        c.safeContents,
        "friendlyName",
        R,
        $
      );
    },
    /**
     * DEPRECATED: use getBags() instead.
     *
     * Get bags with matching localKeyId attribute.
     *
     * @param localKeyId the localKeyId to search for.
     * @param [bagType] bag type to narrow search by.
     *
     * @return an array of bags with matching localKeyId attribute.
     */
    getBagsByLocalKeyId: function(R, $) {
      return _getBagsByAttribute(
        c.safeContents,
        "localKeyId",
        R,
        $
      );
    }
  };
  if (e.version.charCodeAt(0) !== 3) {
    var o = new Error("PKCS#12 PFX of version other than 3 not supported.");
    throw o.version = e.version.charCodeAt(0), o;
  }
  if (asn1$3.derToOid(e.contentType) !== pki$1.oids.data) {
    var o = new Error("Only PKCS#12 PFX in password integrity mode supported.");
    throw o.oid = asn1$3.derToOid(e.contentType), o;
  }
  var l = e.content.value[0];
  if (l.tagClass !== asn1$3.Class.UNIVERSAL || l.type !== asn1$3.Type.OCTETSTRING)
    throw new Error("PKCS#12 authSafe content data is not an OCTET STRING.");
  if (l = _decodePkcs7Data(l), e.mac) {
    var d = null, p = 0, h = asn1$3.derToOid(e.macAlgorithm);
    switch (h) {
      case pki$1.oids.sha1:
        d = forge$a.md.sha1.create(), p = 20;
        break;
      case pki$1.oids.sha256:
        d = forge$a.md.sha256.create(), p = 32;
        break;
      case pki$1.oids.sha384:
        d = forge$a.md.sha384.create(), p = 48;
        break;
      case pki$1.oids.sha512:
        d = forge$a.md.sha512.create(), p = 64;
        break;
      case pki$1.oids.md5:
        d = forge$a.md.md5.create(), p = 16;
        break;
    }
    if (d === null)
      throw new Error("PKCS#12 uses unsupported MAC algorithm: " + h);
    var g = new forge$a.util.ByteBuffer(e.macSalt), y = "macIterations" in e ? parseInt(forge$a.util.bytesToHex(e.macIterations), 16) : 1, v = p12.generateKey(
      a,
      g,
      3,
      y,
      p,
      d
    ), m = forge$a.hmac.create();
    m.start(d, v), m.update(l.value);
    var b = m.getMac();
    if (b.getBytes() !== e.macDigest)
      throw new Error("PKCS#12 MAC could not be verified. Invalid password?");
  }
  return _decodeAuthenticatedSafe(c, l.value, r, a), c;
};
function _decodePkcs7Data(u) {
  if (u.composed || u.constructed) {
    for (var r = forge$a.util.createBuffer(), a = 0; a < u.value.length; ++a)
      r.putBytes(u.value[a].value);
    u.composed = u.constructed = !1, u.value = r.getBytes();
  }
  return u;
}
function _decodeAuthenticatedSafe(u, r, a, e) {
  if (r = asn1$3.fromDer(r, a), r.tagClass !== asn1$3.Class.UNIVERSAL || r.type !== asn1$3.Type.SEQUENCE || r.constructed !== !0)
    throw new Error("PKCS#12 AuthenticatedSafe expected to be a SEQUENCE OF ContentInfo");
  for (var n = 0; n < r.value.length; n++) {
    var o = r.value[n], c = {}, l = [];
    if (!asn1$3.validate(o, contentInfoValidator, c, l)) {
      var d = new Error("Cannot read ContentInfo.");
      throw d.errors = l, d;
    }
    var p = {
      encrypted: !1
    }, h = null, g = c.content.value[0];
    switch (asn1$3.derToOid(c.contentType)) {
      case pki$1.oids.data:
        if (g.tagClass !== asn1$3.Class.UNIVERSAL || g.type !== asn1$3.Type.OCTETSTRING)
          throw new Error("PKCS#12 SafeContents Data is not an OCTET STRING.");
        h = _decodePkcs7Data(g).value;
        break;
      case pki$1.oids.encryptedData:
        h = _decryptSafeContents(g, e), p.encrypted = !0;
        break;
      default:
        var d = new Error("Unsupported PKCS#12 contentType.");
        throw d.contentType = asn1$3.derToOid(c.contentType), d;
    }
    p.safeBags = _decodeSafeContents(h, a, e), u.safeContents.push(p);
  }
}
function _decryptSafeContents(u, r) {
  var a = {}, e = [];
  if (!asn1$3.validate(
    u,
    forge$a.pkcs7.asn1.encryptedDataValidator,
    a,
    e
  )) {
    var n = new Error("Cannot read EncryptedContentInfo.");
    throw n.errors = e, n;
  }
  var o = asn1$3.derToOid(a.contentType);
  if (o !== pki$1.oids.data) {
    var n = new Error(
      "PKCS#12 EncryptedContentInfo ContentType is not Data."
    );
    throw n.oid = o, n;
  }
  o = asn1$3.derToOid(a.encAlgorithm);
  var c = pki$1.pbe.getCipher(o, a.encParameter, r), l = _decodePkcs7Data(a.encryptedContentAsn1), d = forge$a.util.createBuffer(l.value);
  if (c.update(d), !c.finish())
    throw new Error("Failed to decrypt PKCS#12 SafeContents.");
  return c.output.getBytes();
}
function _decodeSafeContents(u, r, a) {
  if (!r && u.length === 0)
    return [];
  if (u = asn1$3.fromDer(u, r), u.tagClass !== asn1$3.Class.UNIVERSAL || u.type !== asn1$3.Type.SEQUENCE || u.constructed !== !0)
    throw new Error(
      "PKCS#12 SafeContents expected to be a SEQUENCE OF SafeBag."
    );
  for (var e = [], n = 0; n < u.value.length; n++) {
    var o = u.value[n], c = {}, l = [];
    if (!asn1$3.validate(o, safeBagValidator, c, l)) {
      var d = new Error("Cannot read SafeBag.");
      throw d.errors = l, d;
    }
    var p = {
      type: asn1$3.derToOid(c.bagId),
      attributes: _decodeBagAttributes(c.bagAttributes)
    };
    e.push(p);
    var h, g, y = c.bagValue.value[0];
    switch (p.type) {
      case pki$1.oids.pkcs8ShroudedKeyBag:
        if (y = pki$1.decryptPrivateKeyInfo(y, a), y === null)
          throw new Error(
            "Unable to decrypt PKCS#8 ShroudedKeyBag, wrong password?"
          );
      case pki$1.oids.keyBag:
        try {
          p.key = pki$1.privateKeyFromAsn1(y);
        } catch {
          p.key = null, p.asn1 = y;
        }
        continue;
      case pki$1.oids.certBag:
        h = certBagValidator, g = function() {
          if (asn1$3.derToOid(c.certId) !== pki$1.oids.x509Certificate) {
            var m = new Error(
              "Unsupported certificate type, only X.509 supported."
            );
            throw m.oid = asn1$3.derToOid(c.certId), m;
          }
          var b = asn1$3.fromDer(c.cert, r);
          try {
            p.cert = pki$1.certificateFromAsn1(b, !0);
          } catch {
            p.cert = null, p.asn1 = b;
          }
        };
        break;
      default:
        var d = new Error("Unsupported PKCS#12 SafeBag type.");
        throw d.oid = p.type, d;
    }
    if (h !== void 0 && !asn1$3.validate(y, h, c, l)) {
      var d = new Error("Cannot read PKCS#12 " + h.name);
      throw d.errors = l, d;
    }
    g();
  }
  return e;
}
function _decodeBagAttributes(u) {
  var r = {};
  if (u !== void 0)
    for (var a = 0; a < u.length; ++a) {
      var e = {}, n = [];
      if (!asn1$3.validate(u[a], attributeValidator, e, n)) {
        var o = new Error("Cannot read PKCS#12 BagAttribute.");
        throw o.errors = n, o;
      }
      var c = asn1$3.derToOid(e.oid);
      if (pki$1.oids[c] !== void 0) {
        r[pki$1.oids[c]] = [];
        for (var l = 0; l < e.values.length; ++l)
          r[pki$1.oids[c]].push(e.values[l].value);
      }
    }
  return r;
}
p12.toPkcs12Asn1 = function(u, r, a, e) {
  e = e || {}, e.saltSize = e.saltSize || 8, e.count = e.count || 2048, e.algorithm = e.algorithm || e.encAlgorithm || "aes128", "useMac" in e || (e.useMac = !0), "localKeyId" in e || (e.localKeyId = null), "generateLocalKeyId" in e || (e.generateLocalKeyId = !0);
  var n = e.localKeyId, o;
  if (n !== null)
    n = forge$a.util.hexToBytes(n);
  else if (e.generateLocalKeyId)
    if (r) {
      var c = forge$a.util.isArray(r) ? r[0] : r;
      typeof c == "string" && (c = pki$1.certificateFromPem(c));
      var l = forge$a.md.sha1.create();
      l.update(asn1$3.toDer(pki$1.certificateToAsn1(c)).getBytes()), n = l.digest().getBytes();
    } else
      n = forge$a.random.getBytes(20);
  var d = [];
  n !== null && d.push(
    // localKeyID
    asn1$3.create(asn1$3.Class.UNIVERSAL, asn1$3.Type.SEQUENCE, !0, [
      // attrId
      asn1$3.create(
        asn1$3.Class.UNIVERSAL,
        asn1$3.Type.OID,
        !1,
        asn1$3.oidToDer(pki$1.oids.localKeyId).getBytes()
      ),
      // attrValues
      asn1$3.create(asn1$3.Class.UNIVERSAL, asn1$3.Type.SET, !0, [
        asn1$3.create(
          asn1$3.Class.UNIVERSAL,
          asn1$3.Type.OCTETSTRING,
          !1,
          n
        )
      ])
    ])
  ), "friendlyName" in e && d.push(
    // friendlyName
    asn1$3.create(asn1$3.Class.UNIVERSAL, asn1$3.Type.SEQUENCE, !0, [
      // attrId
      asn1$3.create(
        asn1$3.Class.UNIVERSAL,
        asn1$3.Type.OID,
        !1,
        asn1$3.oidToDer(pki$1.oids.friendlyName).getBytes()
      ),
      // attrValues
      asn1$3.create(asn1$3.Class.UNIVERSAL, asn1$3.Type.SET, !0, [
        asn1$3.create(
          asn1$3.Class.UNIVERSAL,
          asn1$3.Type.BMPSTRING,
          !1,
          e.friendlyName
        )
      ])
    ])
  ), d.length > 0 && (o = asn1$3.create(asn1$3.Class.UNIVERSAL, asn1$3.Type.SET, !0, d));
  var p = [], h = [];
  r !== null && (forge$a.util.isArray(r) ? h = r : h = [r]);
  for (var g = [], y = 0; y < h.length; ++y) {
    r = h[y], typeof r == "string" && (r = pki$1.certificateFromPem(r));
    var v = y === 0 ? o : void 0, m = pki$1.certificateToAsn1(r), b = asn1$3.create(asn1$3.Class.UNIVERSAL, asn1$3.Type.SEQUENCE, !0, [
      // bagId
      asn1$3.create(
        asn1$3.Class.UNIVERSAL,
        asn1$3.Type.OID,
        !1,
        asn1$3.oidToDer(pki$1.oids.certBag).getBytes()
      ),
      // bagValue
      asn1$3.create(asn1$3.Class.CONTEXT_SPECIFIC, 0, !0, [
        // CertBag
        asn1$3.create(asn1$3.Class.UNIVERSAL, asn1$3.Type.SEQUENCE, !0, [
          // certId
          asn1$3.create(
            asn1$3.Class.UNIVERSAL,
            asn1$3.Type.OID,
            !1,
            asn1$3.oidToDer(pki$1.oids.x509Certificate).getBytes()
          ),
          // certValue (x509Certificate)
          asn1$3.create(asn1$3.Class.CONTEXT_SPECIFIC, 0, !0, [
            asn1$3.create(
              asn1$3.Class.UNIVERSAL,
              asn1$3.Type.OCTETSTRING,
              !1,
              asn1$3.toDer(m).getBytes()
            )
          ])
        ])
      ]),
      // bagAttributes (OPTIONAL)
      v
    ]);
    g.push(b);
  }
  if (g.length > 0) {
    var R = asn1$3.create(
      asn1$3.Class.UNIVERSAL,
      asn1$3.Type.SEQUENCE,
      !0,
      g
    ), $ = (
      // PKCS#7 ContentInfo
      asn1$3.create(asn1$3.Class.UNIVERSAL, asn1$3.Type.SEQUENCE, !0, [
        // contentType
        asn1$3.create(
          asn1$3.Class.UNIVERSAL,
          asn1$3.Type.OID,
          !1,
          // OID for the content type is 'data'
          asn1$3.oidToDer(pki$1.oids.data).getBytes()
        ),
        // content
        asn1$3.create(asn1$3.Class.CONTEXT_SPECIFIC, 0, !0, [
          asn1$3.create(
            asn1$3.Class.UNIVERSAL,
            asn1$3.Type.OCTETSTRING,
            !1,
            asn1$3.toDer(R).getBytes()
          )
        ])
      ])
    );
    p.push($);
  }
  var x = null;
  if (u !== null) {
    var E = pki$1.wrapRsaPrivateKey(pki$1.privateKeyToAsn1(u));
    a === null ? x = asn1$3.create(asn1$3.Class.UNIVERSAL, asn1$3.Type.SEQUENCE, !0, [
      // bagId
      asn1$3.create(
        asn1$3.Class.UNIVERSAL,
        asn1$3.Type.OID,
        !1,
        asn1$3.oidToDer(pki$1.oids.keyBag).getBytes()
      ),
      // bagValue
      asn1$3.create(asn1$3.Class.CONTEXT_SPECIFIC, 0, !0, [
        // PrivateKeyInfo
        E
      ]),
      // bagAttributes (OPTIONAL)
      o
    ]) : x = asn1$3.create(asn1$3.Class.UNIVERSAL, asn1$3.Type.SEQUENCE, !0, [
      // bagId
      asn1$3.create(
        asn1$3.Class.UNIVERSAL,
        asn1$3.Type.OID,
        !1,
        asn1$3.oidToDer(pki$1.oids.pkcs8ShroudedKeyBag).getBytes()
      ),
      // bagValue
      asn1$3.create(asn1$3.Class.CONTEXT_SPECIFIC, 0, !0, [
        // EncryptedPrivateKeyInfo
        pki$1.encryptPrivateKeyInfo(E, a, e)
      ]),
      // bagAttributes (OPTIONAL)
      o
    ]);
    var T = asn1$3.create(asn1$3.Class.UNIVERSAL, asn1$3.Type.SEQUENCE, !0, [x]), P = (
      // PKCS#7 ContentInfo
      asn1$3.create(asn1$3.Class.UNIVERSAL, asn1$3.Type.SEQUENCE, !0, [
        // contentType
        asn1$3.create(
          asn1$3.Class.UNIVERSAL,
          asn1$3.Type.OID,
          !1,
          // OID for the content type is 'data'
          asn1$3.oidToDer(pki$1.oids.data).getBytes()
        ),
        // content
        asn1$3.create(asn1$3.Class.CONTEXT_SPECIFIC, 0, !0, [
          asn1$3.create(
            asn1$3.Class.UNIVERSAL,
            asn1$3.Type.OCTETSTRING,
            !1,
            asn1$3.toDer(T).getBytes()
          )
        ])
      ])
    );
    p.push(P);
  }
  var O = asn1$3.create(
    asn1$3.Class.UNIVERSAL,
    asn1$3.Type.SEQUENCE,
    !0,
    p
  ), w;
  if (e.useMac) {
    var l = forge$a.md.sha1.create(), _ = new forge$a.util.ByteBuffer(
      forge$a.random.getBytes(e.saltSize)
    ), C = e.count, u = p12.generateKey(a, _, 3, C, 20), k = forge$a.hmac.create();
    k.start(l, u), k.update(asn1$3.toDer(O).getBytes());
    var B = k.getMac();
    w = asn1$3.create(asn1$3.Class.UNIVERSAL, asn1$3.Type.SEQUENCE, !0, [
      // mac DigestInfo
      asn1$3.create(asn1$3.Class.UNIVERSAL, asn1$3.Type.SEQUENCE, !0, [
        // digestAlgorithm
        asn1$3.create(asn1$3.Class.UNIVERSAL, asn1$3.Type.SEQUENCE, !0, [
          // algorithm = SHA-1
          asn1$3.create(
            asn1$3.Class.UNIVERSAL,
            asn1$3.Type.OID,
            !1,
            asn1$3.oidToDer(pki$1.oids.sha1).getBytes()
          ),
          // parameters = Null
          asn1$3.create(asn1$3.Class.UNIVERSAL, asn1$3.Type.NULL, !1, "")
        ]),
        // digest
        asn1$3.create(
          asn1$3.Class.UNIVERSAL,
          asn1$3.Type.OCTETSTRING,
          !1,
          B.getBytes()
        )
      ]),
      // macSalt OCTET STRING
      asn1$3.create(
        asn1$3.Class.UNIVERSAL,
        asn1$3.Type.OCTETSTRING,
        !1,
        _.getBytes()
      ),
      // iterations INTEGER (XXX: Only support count < 65536)
      asn1$3.create(
        asn1$3.Class.UNIVERSAL,
        asn1$3.Type.INTEGER,
        !1,
        asn1$3.integerToDer(C).getBytes()
      )
    ]);
  }
  return asn1$3.create(asn1$3.Class.UNIVERSAL, asn1$3.Type.SEQUENCE, !0, [
    // version (3)
    asn1$3.create(
      asn1$3.Class.UNIVERSAL,
      asn1$3.Type.INTEGER,
      !1,
      asn1$3.integerToDer(3).getBytes()
    ),
    // PKCS#7 ContentInfo
    asn1$3.create(asn1$3.Class.UNIVERSAL, asn1$3.Type.SEQUENCE, !0, [
      // contentType
      asn1$3.create(
        asn1$3.Class.UNIVERSAL,
        asn1$3.Type.OID,
        !1,
        // OID for the content type is 'data'
        asn1$3.oidToDer(pki$1.oids.data).getBytes()
      ),
      // content
      asn1$3.create(asn1$3.Class.CONTEXT_SPECIFIC, 0, !0, [
        asn1$3.create(
          asn1$3.Class.UNIVERSAL,
          asn1$3.Type.OCTETSTRING,
          !1,
          asn1$3.toDer(O).getBytes()
        )
      ])
    ]),
    w
  ]);
};
p12.generateKey = forge$a.pbe.generatePkcs12Key;
var forge$9 = forge$C, asn1$2 = forge$9.asn1, pki = forge$9.pki = forge$9.pki || {};
pki.pemToDer = function(u) {
  var r = forge$9.pem.decode(u)[0];
  if (r.procType && r.procType.type === "ENCRYPTED")
    throw new Error("Could not convert PEM to DER; PEM is encrypted.");
  return forge$9.util.createBuffer(r.body);
};
pki.privateKeyFromPem = function(u) {
  var r = forge$9.pem.decode(u)[0];
  if (r.type !== "PRIVATE KEY" && r.type !== "RSA PRIVATE KEY") {
    var a = new Error('Could not convert private key from PEM; PEM header type is not "PRIVATE KEY" or "RSA PRIVATE KEY".');
    throw a.headerType = r.type, a;
  }
  if (r.procType && r.procType.type === "ENCRYPTED")
    throw new Error("Could not convert private key from PEM; PEM is encrypted.");
  var e = asn1$2.fromDer(r.body);
  return pki.privateKeyFromAsn1(e);
};
pki.privateKeyToPem = function(u, r) {
  var a = {
    type: "RSA PRIVATE KEY",
    body: asn1$2.toDer(pki.privateKeyToAsn1(u)).getBytes()
  };
  return forge$9.pem.encode(a, { maxline: r });
};
pki.privateKeyInfoToPem = function(u, r) {
  var a = {
    type: "PRIVATE KEY",
    body: asn1$2.toDer(u).getBytes()
  };
  return forge$9.pem.encode(a, { maxline: r });
};
var forge$8 = forge$C, prf_TLS1 = function(u, r, a, e) {
  var n = forge$8.util.createBuffer(), o = u.length >> 1, c = o + (u.length & 1), l = u.substr(0, c), d = u.substr(o, c), p = forge$8.util.createBuffer(), h = forge$8.hmac.create();
  a = r + a;
  var g = Math.ceil(e / 16), y = Math.ceil(e / 20);
  h.start("MD5", l);
  var v = forge$8.util.createBuffer();
  p.putBytes(a);
  for (var m = 0; m < g; ++m)
    h.start(null, null), h.update(p.getBytes()), p.putBuffer(h.digest()), h.start(null, null), h.update(p.bytes() + a), v.putBuffer(h.digest());
  h.start("SHA1", d);
  var b = forge$8.util.createBuffer();
  p.clear(), p.putBytes(a);
  for (var m = 0; m < y; ++m)
    h.start(null, null), h.update(p.getBytes()), p.putBuffer(h.digest()), h.start(null, null), h.update(p.bytes() + a), b.putBuffer(h.digest());
  return n.putBytes(forge$8.util.xorBytes(
    v.getBytes(),
    b.getBytes(),
    e
  )), n;
}, hmac_sha1 = function(u, r, a) {
  var e = forge$8.hmac.create();
  e.start("SHA1", u);
  var n = forge$8.util.createBuffer();
  return n.putInt32(r[0]), n.putInt32(r[1]), n.putByte(a.type), n.putByte(a.version.major), n.putByte(a.version.minor), n.putInt16(a.length), n.putBytes(a.fragment.bytes()), e.update(n.getBytes()), e.digest().getBytes();
}, deflate = function(u, r, a) {
  var e = !1;
  try {
    var n = u.deflate(r.fragment.getBytes());
    r.fragment = forge$8.util.createBuffer(n), r.length = n.length, e = !0;
  } catch {
  }
  return e;
}, inflate = function(u, r, a) {
  var e = !1;
  try {
    var n = u.inflate(r.fragment.getBytes());
    r.fragment = forge$8.util.createBuffer(n), r.length = n.length, e = !0;
  } catch {
  }
  return e;
}, readVector = function(u, r) {
  var a = 0;
  switch (r) {
    case 1:
      a = u.getByte();
      break;
    case 2:
      a = u.getInt16();
      break;
    case 3:
      a = u.getInt24();
      break;
    case 4:
      a = u.getInt32();
      break;
  }
  return forge$8.util.createBuffer(u.getBytes(a));
}, writeVector = function(u, r, a) {
  u.putInt(a.length(), r << 3), u.putBuffer(a);
}, tls$1 = {};
tls$1.Versions = {
  TLS_1_0: { major: 3, minor: 1 },
  TLS_1_1: { major: 3, minor: 2 },
  TLS_1_2: { major: 3, minor: 3 }
};
tls$1.SupportedVersions = [
  tls$1.Versions.TLS_1_1,
  tls$1.Versions.TLS_1_0
];
tls$1.Version = tls$1.SupportedVersions[0];
tls$1.MaxFragment = 15360;
tls$1.ConnectionEnd = {
  server: 0,
  client: 1
};
tls$1.PRFAlgorithm = {
  tls_prf_sha256: 0
};
tls$1.BulkCipherAlgorithm = {
  none: null,
  rc4: 0,
  des3: 1,
  aes: 2
};
tls$1.CipherType = {
  stream: 0,
  block: 1,
  aead: 2
};
tls$1.MACAlgorithm = {
  none: null,
  hmac_md5: 0,
  hmac_sha1: 1,
  hmac_sha256: 2,
  hmac_sha384: 3,
  hmac_sha512: 4
};
tls$1.CompressionMethod = {
  none: 0,
  deflate: 1
};
tls$1.ContentType = {
  change_cipher_spec: 20,
  alert: 21,
  handshake: 22,
  application_data: 23,
  heartbeat: 24
};
tls$1.HandshakeType = {
  hello_request: 0,
  client_hello: 1,
  server_hello: 2,
  certificate: 11,
  server_key_exchange: 12,
  certificate_request: 13,
  server_hello_done: 14,
  certificate_verify: 15,
  client_key_exchange: 16,
  finished: 20
};
tls$1.Alert = {};
tls$1.Alert.Level = {
  warning: 1,
  fatal: 2
};
tls$1.Alert.Description = {
  close_notify: 0,
  unexpected_message: 10,
  bad_record_mac: 20,
  decryption_failed: 21,
  record_overflow: 22,
  decompression_failure: 30,
  handshake_failure: 40,
  bad_certificate: 42,
  unsupported_certificate: 43,
  certificate_revoked: 44,
  certificate_expired: 45,
  certificate_unknown: 46,
  illegal_parameter: 47,
  unknown_ca: 48,
  access_denied: 49,
  decode_error: 50,
  decrypt_error: 51,
  export_restriction: 60,
  protocol_version: 70,
  insufficient_security: 71,
  internal_error: 80,
  user_canceled: 90,
  no_renegotiation: 100
};
tls$1.HeartbeatMessageType = {
  heartbeat_request: 1,
  heartbeat_response: 2
};
tls$1.CipherSuites = {};
tls$1.getCipherSuite = function(u) {
  var r = null;
  for (var a in tls$1.CipherSuites) {
    var e = tls$1.CipherSuites[a];
    if (e.id[0] === u.charCodeAt(0) && e.id[1] === u.charCodeAt(1)) {
      r = e;
      break;
    }
  }
  return r;
};
tls$1.handleUnexpected = function(u, r) {
  var a = !u.open && u.entity === tls$1.ConnectionEnd.client;
  a || u.error(u, {
    message: "Unexpected message. Received TLS record out of order.",
    send: !0,
    alert: {
      level: tls$1.Alert.Level.fatal,
      description: tls$1.Alert.Description.unexpected_message
    }
  });
};
tls$1.handleHelloRequest = function(u, r, a) {
  !u.handshaking && u.handshakes > 0 && (tls$1.queue(u, tls$1.createAlert(u, {
    level: tls$1.Alert.Level.warning,
    description: tls$1.Alert.Description.no_renegotiation
  })), tls$1.flush(u)), u.process();
};
tls$1.parseHelloMessage = function(u, r, a) {
  var e = null, n = u.entity === tls$1.ConnectionEnd.client;
  if (a < 38)
    u.error(u, {
      message: n ? "Invalid ServerHello message. Message too short." : "Invalid ClientHello message. Message too short.",
      send: !0,
      alert: {
        level: tls$1.Alert.Level.fatal,
        description: tls$1.Alert.Description.illegal_parameter
      }
    });
  else {
    var o = r.fragment, c = o.length();
    if (e = {
      version: {
        major: o.getByte(),
        minor: o.getByte()
      },
      random: forge$8.util.createBuffer(o.getBytes(32)),
      session_id: readVector(o, 1),
      extensions: []
    }, n ? (e.cipher_suite = o.getBytes(2), e.compression_method = o.getByte()) : (e.cipher_suites = readVector(o, 2), e.compression_methods = readVector(o, 1)), c = a - (c - o.length()), c > 0) {
      for (var l = readVector(o, 2); l.length() > 0; )
        e.extensions.push({
          type: [l.getByte(), l.getByte()],
          data: readVector(l, 2)
        });
      if (!n)
        for (var d = 0; d < e.extensions.length; ++d) {
          var p = e.extensions[d];
          if (p.type[0] === 0 && p.type[1] === 0)
            for (var h = readVector(p.data, 2); h.length() > 0; ) {
              var g = h.getByte();
              if (g !== 0)
                break;
              u.session.extensions.server_name.serverNameList.push(
                readVector(h, 2).getBytes()
              );
            }
        }
    }
    if (u.session.version && (e.version.major !== u.session.version.major || e.version.minor !== u.session.version.minor))
      return u.error(u, {
        message: "TLS version change is disallowed during renegotiation.",
        send: !0,
        alert: {
          level: tls$1.Alert.Level.fatal,
          description: tls$1.Alert.Description.protocol_version
        }
      });
    if (n)
      u.session.cipherSuite = tls$1.getCipherSuite(e.cipher_suite);
    else
      for (var y = forge$8.util.createBuffer(e.cipher_suites.bytes()); y.length() > 0 && (u.session.cipherSuite = tls$1.getCipherSuite(y.getBytes(2)), u.session.cipherSuite === null); )
        ;
    if (u.session.cipherSuite === null)
      return u.error(u, {
        message: "No cipher suites in common.",
        send: !0,
        alert: {
          level: tls$1.Alert.Level.fatal,
          description: tls$1.Alert.Description.handshake_failure
        },
        cipherSuite: forge$8.util.bytesToHex(e.cipher_suite)
      });
    n ? u.session.compressionMethod = e.compression_method : u.session.compressionMethod = tls$1.CompressionMethod.none;
  }
  return e;
};
tls$1.createSecurityParameters = function(u, r) {
  var a = u.entity === tls$1.ConnectionEnd.client, e = r.random.bytes(), n = a ? u.session.sp.client_random : e, o = a ? e : tls$1.createRandom().getBytes();
  u.session.sp = {
    entity: u.entity,
    prf_algorithm: tls$1.PRFAlgorithm.tls_prf_sha256,
    bulk_cipher_algorithm: null,
    cipher_type: null,
    enc_key_length: null,
    block_length: null,
    fixed_iv_length: null,
    record_iv_length: null,
    mac_algorithm: null,
    mac_length: null,
    mac_key_length: null,
    compression_algorithm: u.session.compressionMethod,
    pre_master_secret: null,
    master_secret: null,
    client_random: n,
    server_random: o
  };
};
tls$1.handleServerHello = function(u, r, a) {
  var e = tls$1.parseHelloMessage(u, r, a);
  if (!u.fail) {
    if (e.version.minor <= u.version.minor)
      u.version.minor = e.version.minor;
    else
      return u.error(u, {
        message: "Incompatible TLS version.",
        send: !0,
        alert: {
          level: tls$1.Alert.Level.fatal,
          description: tls$1.Alert.Description.protocol_version
        }
      });
    u.session.version = u.version;
    var n = e.session_id.bytes();
    n.length > 0 && n === u.session.id ? (u.expect = SCC, u.session.resuming = !0, u.session.sp.server_random = e.random.bytes()) : (u.expect = SCE, u.session.resuming = !1, tls$1.createSecurityParameters(u, e)), u.session.id = n, u.process();
  }
};
tls$1.handleClientHello = function(u, r, a) {
  var e = tls$1.parseHelloMessage(u, r, a);
  if (!u.fail) {
    var n = e.session_id.bytes(), o = null;
    if (u.sessionCache && (o = u.sessionCache.getSession(n), o === null ? n = "" : (o.version.major !== e.version.major || o.version.minor > e.version.minor) && (o = null, n = "")), n.length === 0 && (n = forge$8.random.getBytes(32)), u.session.id = n, u.session.clientHelloVersion = e.version, u.session.sp = {}, o)
      u.version = u.session.version = o.version, u.session.sp = o.sp;
    else {
      for (var c, l = 1; l < tls$1.SupportedVersions.length && (c = tls$1.SupportedVersions[l], !(c.minor <= e.version.minor)); ++l)
        ;
      u.version = { major: c.major, minor: c.minor }, u.session.version = u.version;
    }
    o !== null ? (u.expect = CCC, u.session.resuming = !0, u.session.sp.client_random = e.random.bytes()) : (u.expect = u.verifyClient !== !1 ? CCE : CKE, u.session.resuming = !1, tls$1.createSecurityParameters(u, e)), u.open = !0, tls$1.queue(u, tls$1.createRecord(u, {
      type: tls$1.ContentType.handshake,
      data: tls$1.createServerHello(u)
    })), u.session.resuming ? (tls$1.queue(u, tls$1.createRecord(u, {
      type: tls$1.ContentType.change_cipher_spec,
      data: tls$1.createChangeCipherSpec()
    })), u.state.pending = tls$1.createConnectionState(u), u.state.current.write = u.state.pending.write, tls$1.queue(u, tls$1.createRecord(u, {
      type: tls$1.ContentType.handshake,
      data: tls$1.createFinished(u)
    }))) : (tls$1.queue(u, tls$1.createRecord(u, {
      type: tls$1.ContentType.handshake,
      data: tls$1.createCertificate(u)
    })), u.fail || (tls$1.queue(u, tls$1.createRecord(u, {
      type: tls$1.ContentType.handshake,
      data: tls$1.createServerKeyExchange(u)
    })), u.verifyClient !== !1 && tls$1.queue(u, tls$1.createRecord(u, {
      type: tls$1.ContentType.handshake,
      data: tls$1.createCertificateRequest(u)
    })), tls$1.queue(u, tls$1.createRecord(u, {
      type: tls$1.ContentType.handshake,
      data: tls$1.createServerHelloDone(u)
    })))), tls$1.flush(u), u.process();
  }
};
tls$1.handleCertificate = function(u, r, a) {
  if (a < 3)
    return u.error(u, {
      message: "Invalid Certificate message. Message too short.",
      send: !0,
      alert: {
        level: tls$1.Alert.Level.fatal,
        description: tls$1.Alert.Description.illegal_parameter
      }
    });
  var e = r.fragment, n = {
    certificate_list: readVector(e, 3)
  }, o, c, l = [];
  try {
    for (; n.certificate_list.length() > 0; )
      o = readVector(n.certificate_list, 3), c = forge$8.asn1.fromDer(o), o = forge$8.pki.certificateFromAsn1(c, !0), l.push(o);
  } catch (p) {
    return u.error(u, {
      message: "Could not parse certificate list.",
      cause: p,
      send: !0,
      alert: {
        level: tls$1.Alert.Level.fatal,
        description: tls$1.Alert.Description.bad_certificate
      }
    });
  }
  var d = u.entity === tls$1.ConnectionEnd.client;
  (d || u.verifyClient === !0) && l.length === 0 ? u.error(u, {
    message: d ? "No server certificate provided." : "No client certificate provided.",
    send: !0,
    alert: {
      level: tls$1.Alert.Level.fatal,
      description: tls$1.Alert.Description.illegal_parameter
    }
  }) : l.length === 0 ? u.expect = d ? SKE : CKE : (d ? u.session.serverCertificate = l[0] : u.session.clientCertificate = l[0], tls$1.verifyCertificateChain(u, l) && (u.expect = d ? SKE : CKE)), u.process();
};
tls$1.handleServerKeyExchange = function(u, r, a) {
  if (a > 0)
    return u.error(u, {
      message: "Invalid key parameters. Only RSA is supported.",
      send: !0,
      alert: {
        level: tls$1.Alert.Level.fatal,
        description: tls$1.Alert.Description.unsupported_certificate
      }
    });
  u.expect = SCR, u.process();
};
tls$1.handleClientKeyExchange = function(u, r, a) {
  if (a < 48)
    return u.error(u, {
      message: "Invalid key parameters. Only RSA is supported.",
      send: !0,
      alert: {
        level: tls$1.Alert.Level.fatal,
        description: tls$1.Alert.Description.unsupported_certificate
      }
    });
  var e = r.fragment, n = {
    enc_pre_master_secret: readVector(e, 2).getBytes()
  }, o = null;
  if (u.getPrivateKey)
    try {
      o = u.getPrivateKey(u, u.session.serverCertificate), o = forge$8.pki.privateKeyFromPem(o);
    } catch (d) {
      u.error(u, {
        message: "Could not get private key.",
        cause: d,
        send: !0,
        alert: {
          level: tls$1.Alert.Level.fatal,
          description: tls$1.Alert.Description.internal_error
        }
      });
    }
  if (o === null)
    return u.error(u, {
      message: "No private key set.",
      send: !0,
      alert: {
        level: tls$1.Alert.Level.fatal,
        description: tls$1.Alert.Description.internal_error
      }
    });
  try {
    var c = u.session.sp;
    c.pre_master_secret = o.decrypt(n.enc_pre_master_secret);
    var l = u.session.clientHelloVersion;
    if (l.major !== c.pre_master_secret.charCodeAt(0) || l.minor !== c.pre_master_secret.charCodeAt(1))
      throw new Error("TLS version rollback attack detected.");
  } catch {
    c.pre_master_secret = forge$8.random.getBytes(48);
  }
  u.expect = CCC, u.session.clientCertificate !== null && (u.expect = CCV), u.process();
};
tls$1.handleCertificateRequest = function(u, r, a) {
  if (a < 3)
    return u.error(u, {
      message: "Invalid CertificateRequest. Message too short.",
      send: !0,
      alert: {
        level: tls$1.Alert.Level.fatal,
        description: tls$1.Alert.Description.illegal_parameter
      }
    });
  var e = r.fragment, n = {
    certificate_types: readVector(e, 1),
    certificate_authorities: readVector(e, 2)
  };
  u.session.certificateRequest = n, u.expect = SHD, u.process();
};
tls$1.handleCertificateVerify = function(u, r, a) {
  if (a < 2)
    return u.error(u, {
      message: "Invalid CertificateVerify. Message too short.",
      send: !0,
      alert: {
        level: tls$1.Alert.Level.fatal,
        description: tls$1.Alert.Description.illegal_parameter
      }
    });
  var e = r.fragment;
  e.read -= 4;
  var n = e.bytes();
  e.read += 4;
  var o = {
    signature: readVector(e, 2).getBytes()
  }, c = forge$8.util.createBuffer();
  c.putBuffer(u.session.md5.digest()), c.putBuffer(u.session.sha1.digest()), c = c.getBytes();
  try {
    var l = u.session.clientCertificate;
    if (!l.publicKey.verify(c, o.signature, "NONE"))
      throw new Error("CertificateVerify signature does not match.");
    u.session.md5.update(n), u.session.sha1.update(n);
  } catch {
    return u.error(u, {
      message: "Bad signature in CertificateVerify.",
      send: !0,
      alert: {
        level: tls$1.Alert.Level.fatal,
        description: tls$1.Alert.Description.handshake_failure
      }
    });
  }
  u.expect = CCC, u.process();
};
tls$1.handleServerHelloDone = function(u, r, a) {
  if (a > 0)
    return u.error(u, {
      message: "Invalid ServerHelloDone message. Invalid length.",
      send: !0,
      alert: {
        level: tls$1.Alert.Level.fatal,
        description: tls$1.Alert.Description.record_overflow
      }
    });
  if (u.serverCertificate === null) {
    var e = {
      message: "No server certificate provided. Not enough security.",
      send: !0,
      alert: {
        level: tls$1.Alert.Level.fatal,
        description: tls$1.Alert.Description.insufficient_security
      }
    }, n = 0, o = u.verify(u, e.alert.description, n, []);
    if (o !== !0)
      return (o || o === 0) && (typeof o == "object" && !forge$8.util.isArray(o) ? (o.message && (e.message = o.message), o.alert && (e.alert.description = o.alert)) : typeof o == "number" && (e.alert.description = o)), u.error(u, e);
  }
  u.session.certificateRequest !== null && (r = tls$1.createRecord(u, {
    type: tls$1.ContentType.handshake,
    data: tls$1.createCertificate(u)
  }), tls$1.queue(u, r)), r = tls$1.createRecord(u, {
    type: tls$1.ContentType.handshake,
    data: tls$1.createClientKeyExchange(u)
  }), tls$1.queue(u, r), u.expect = SER;
  var c = function(l, d) {
    l.session.certificateRequest !== null && l.session.clientCertificate !== null && tls$1.queue(l, tls$1.createRecord(l, {
      type: tls$1.ContentType.handshake,
      data: tls$1.createCertificateVerify(l, d)
    })), tls$1.queue(l, tls$1.createRecord(l, {
      type: tls$1.ContentType.change_cipher_spec,
      data: tls$1.createChangeCipherSpec()
    })), l.state.pending = tls$1.createConnectionState(l), l.state.current.write = l.state.pending.write, tls$1.queue(l, tls$1.createRecord(l, {
      type: tls$1.ContentType.handshake,
      data: tls$1.createFinished(l)
    })), l.expect = SCC, tls$1.flush(l), l.process();
  };
  if (u.session.certificateRequest === null || u.session.clientCertificate === null)
    return c(u, null);
  tls$1.getClientSignature(u, c);
};
tls$1.handleChangeCipherSpec = function(u, r) {
  if (r.fragment.getByte() !== 1)
    return u.error(u, {
      message: "Invalid ChangeCipherSpec message received.",
      send: !0,
      alert: {
        level: tls$1.Alert.Level.fatal,
        description: tls$1.Alert.Description.illegal_parameter
      }
    });
  var a = u.entity === tls$1.ConnectionEnd.client;
  (u.session.resuming && a || !u.session.resuming && !a) && (u.state.pending = tls$1.createConnectionState(u)), u.state.current.read = u.state.pending.read, (!u.session.resuming && a || u.session.resuming && !a) && (u.state.pending = null), u.expect = a ? SFI : CFI, u.process();
};
tls$1.handleFinished = function(u, r, a) {
  var e = r.fragment;
  e.read -= 4;
  var n = e.bytes();
  e.read += 4;
  var o = r.fragment.getBytes();
  e = forge$8.util.createBuffer(), e.putBuffer(u.session.md5.digest()), e.putBuffer(u.session.sha1.digest());
  var c = u.entity === tls$1.ConnectionEnd.client, l = c ? "server finished" : "client finished", d = u.session.sp, p = 12, h = prf_TLS1;
  if (e = h(d.master_secret, l, e.getBytes(), p), e.getBytes() !== o)
    return u.error(u, {
      message: "Invalid verify_data in Finished message.",
      send: !0,
      alert: {
        level: tls$1.Alert.Level.fatal,
        description: tls$1.Alert.Description.decrypt_error
      }
    });
  u.session.md5.update(n), u.session.sha1.update(n), (u.session.resuming && c || !u.session.resuming && !c) && (tls$1.queue(u, tls$1.createRecord(u, {
    type: tls$1.ContentType.change_cipher_spec,
    data: tls$1.createChangeCipherSpec()
  })), u.state.current.write = u.state.pending.write, u.state.pending = null, tls$1.queue(u, tls$1.createRecord(u, {
    type: tls$1.ContentType.handshake,
    data: tls$1.createFinished(u)
  }))), u.expect = c ? SAD : CAD, u.handshaking = !1, ++u.handshakes, u.peerCertificate = c ? u.session.serverCertificate : u.session.clientCertificate, tls$1.flush(u), u.isConnected = !0, u.connected(u), u.process();
};
tls$1.handleAlert = function(u, r) {
  var a = r.fragment, e = {
    level: a.getByte(),
    description: a.getByte()
  }, n;
  switch (e.description) {
    case tls$1.Alert.Description.close_notify:
      n = "Connection closed.";
      break;
    case tls$1.Alert.Description.unexpected_message:
      n = "Unexpected message.";
      break;
    case tls$1.Alert.Description.bad_record_mac:
      n = "Bad record MAC.";
      break;
    case tls$1.Alert.Description.decryption_failed:
      n = "Decryption failed.";
      break;
    case tls$1.Alert.Description.record_overflow:
      n = "Record overflow.";
      break;
    case tls$1.Alert.Description.decompression_failure:
      n = "Decompression failed.";
      break;
    case tls$1.Alert.Description.handshake_failure:
      n = "Handshake failure.";
      break;
    case tls$1.Alert.Description.bad_certificate:
      n = "Bad certificate.";
      break;
    case tls$1.Alert.Description.unsupported_certificate:
      n = "Unsupported certificate.";
      break;
    case tls$1.Alert.Description.certificate_revoked:
      n = "Certificate revoked.";
      break;
    case tls$1.Alert.Description.certificate_expired:
      n = "Certificate expired.";
      break;
    case tls$1.Alert.Description.certificate_unknown:
      n = "Certificate unknown.";
      break;
    case tls$1.Alert.Description.illegal_parameter:
      n = "Illegal parameter.";
      break;
    case tls$1.Alert.Description.unknown_ca:
      n = "Unknown certificate authority.";
      break;
    case tls$1.Alert.Description.access_denied:
      n = "Access denied.";
      break;
    case tls$1.Alert.Description.decode_error:
      n = "Decode error.";
      break;
    case tls$1.Alert.Description.decrypt_error:
      n = "Decrypt error.";
      break;
    case tls$1.Alert.Description.export_restriction:
      n = "Export restriction.";
      break;
    case tls$1.Alert.Description.protocol_version:
      n = "Unsupported protocol version.";
      break;
    case tls$1.Alert.Description.insufficient_security:
      n = "Insufficient security.";
      break;
    case tls$1.Alert.Description.internal_error:
      n = "Internal error.";
      break;
    case tls$1.Alert.Description.user_canceled:
      n = "User canceled.";
      break;
    case tls$1.Alert.Description.no_renegotiation:
      n = "Renegotiation not supported.";
      break;
    default:
      n = "Unknown error.";
      break;
  }
  if (e.description === tls$1.Alert.Description.close_notify)
    return u.close();
  u.error(u, {
    message: n,
    send: !1,
    // origin is the opposite end
    origin: u.entity === tls$1.ConnectionEnd.client ? "server" : "client",
    alert: e
  }), u.process();
};
tls$1.handleHandshake = function(u, r) {
  var a = r.fragment, e = a.getByte(), n = a.getInt24();
  if (n > a.length())
    return u.fragmented = r, r.fragment = forge$8.util.createBuffer(), a.read -= 4, u.process();
  u.fragmented = null, a.read -= 4;
  var o = a.bytes(n + 4);
  a.read += 4, e in hsTable[u.entity][u.expect] ? (u.entity === tls$1.ConnectionEnd.server && !u.open && !u.fail && (u.handshaking = !0, u.session = {
    version: null,
    extensions: {
      server_name: {
        serverNameList: []
      }
    },
    cipherSuite: null,
    compressionMethod: null,
    serverCertificate: null,
    clientCertificate: null,
    md5: forge$8.md.md5.create(),
    sha1: forge$8.md.sha1.create()
  }), e !== tls$1.HandshakeType.hello_request && e !== tls$1.HandshakeType.certificate_verify && e !== tls$1.HandshakeType.finished && (u.session.md5.update(o), u.session.sha1.update(o)), hsTable[u.entity][u.expect][e](u, r, n)) : tls$1.handleUnexpected(u, r);
};
tls$1.handleApplicationData = function(u, r) {
  u.data.putBuffer(r.fragment), u.dataReady(u), u.process();
};
tls$1.handleHeartbeat = function(u, r) {
  var a = r.fragment, e = a.getByte(), n = a.getInt16(), o = a.getBytes(n);
  if (e === tls$1.HeartbeatMessageType.heartbeat_request) {
    if (u.handshaking || n > o.length)
      return u.process();
    tls$1.queue(u, tls$1.createRecord(u, {
      type: tls$1.ContentType.heartbeat,
      data: tls$1.createHeartbeat(
        tls$1.HeartbeatMessageType.heartbeat_response,
        o
      )
    })), tls$1.flush(u);
  } else if (e === tls$1.HeartbeatMessageType.heartbeat_response) {
    if (o !== u.expectedHeartbeatPayload)
      return u.process();
    u.heartbeatReceived && u.heartbeatReceived(u, forge$8.util.createBuffer(o));
  }
  u.process();
};
var SHE = 0, SCE = 1, SKE = 2, SCR = 3, SHD = 4, SCC = 5, SFI = 6, SAD = 7, SER = 8, CHE = 0, CCE = 1, CKE = 2, CCV = 3, CCC = 4, CFI = 5, CAD = 6, __ = tls$1.handleUnexpected, R0 = tls$1.handleChangeCipherSpec, R1 = tls$1.handleAlert, R2 = tls$1.handleHandshake, R3 = tls$1.handleApplicationData, R4 = tls$1.handleHeartbeat, ctTable = [];
ctTable[tls$1.ConnectionEnd.client] = [
  //      CC,AL,HS,AD,HB
  /*SHE*/
  [__, R1, R2, __, R4],
  /*SCE*/
  [__, R1, R2, __, R4],
  /*SKE*/
  [__, R1, R2, __, R4],
  /*SCR*/
  [__, R1, R2, __, R4],
  /*SHD*/
  [__, R1, R2, __, R4],
  /*SCC*/
  [R0, R1, __, __, R4],
  /*SFI*/
  [__, R1, R2, __, R4],
  /*SAD*/
  [__, R1, R2, R3, R4],
  /*SER*/
  [__, R1, R2, __, R4]
];
ctTable[tls$1.ConnectionEnd.server] = [
  //      CC,AL,HS,AD
  /*CHE*/
  [__, R1, R2, __, R4],
  /*CCE*/
  [__, R1, R2, __, R4],
  /*CKE*/
  [__, R1, R2, __, R4],
  /*CCV*/
  [__, R1, R2, __, R4],
  /*CCC*/
  [R0, R1, __, __, R4],
  /*CFI*/
  [__, R1, R2, __, R4],
  /*CAD*/
  [__, R1, R2, R3, R4],
  /*CER*/
  [__, R1, R2, __, R4]
];
var H0 = tls$1.handleHelloRequest, H1 = tls$1.handleServerHello, H2 = tls$1.handleCertificate, H3 = tls$1.handleServerKeyExchange, H4 = tls$1.handleCertificateRequest, H5 = tls$1.handleServerHelloDone, H6 = tls$1.handleFinished, hsTable = [];
hsTable[tls$1.ConnectionEnd.client] = [
  //      HR,01,SH,03,04,05,06,07,08,09,10,SC,SK,CR,HD,15,CK,17,18,19,FI
  /*SHE*/
  [__, __, H1, __, __, __, __, __, __, __, __, __, __, __, __, __, __, __, __, __, __],
  /*SCE*/
  [H0, __, __, __, __, __, __, __, __, __, __, H2, H3, H4, H5, __, __, __, __, __, __],
  /*SKE*/
  [H0, __, __, __, __, __, __, __, __, __, __, __, H3, H4, H5, __, __, __, __, __, __],
  /*SCR*/
  [H0, __, __, __, __, __, __, __, __, __, __, __, __, H4, H5, __, __, __, __, __, __],
  /*SHD*/
  [H0, __, __, __, __, __, __, __, __, __, __, __, __, __, H5, __, __, __, __, __, __],
  /*SCC*/
  [H0, __, __, __, __, __, __, __, __, __, __, __, __, __, __, __, __, __, __, __, __],
  /*SFI*/
  [H0, __, __, __, __, __, __, __, __, __, __, __, __, __, __, __, __, __, __, __, H6],
  /*SAD*/
  [H0, __, __, __, __, __, __, __, __, __, __, __, __, __, __, __, __, __, __, __, __],
  /*SER*/
  [H0, __, __, __, __, __, __, __, __, __, __, __, __, __, __, __, __, __, __, __, __]
];
var H7 = tls$1.handleClientHello, H8 = tls$1.handleClientKeyExchange, H9 = tls$1.handleCertificateVerify;
hsTable[tls$1.ConnectionEnd.server] = [
  //      01,CH,02,03,04,05,06,07,08,09,10,CC,12,13,14,CV,CK,17,18,19,FI
  /*CHE*/
  [__, H7, __, __, __, __, __, __, __, __, __, __, __, __, __, __, __, __, __, __, __],
  /*CCE*/
  [__, __, __, __, __, __, __, __, __, __, __, H2, __, __, __, __, __, __, __, __, __],
  /*CKE*/
  [__, __, __, __, __, __, __, __, __, __, __, __, __, __, __, __, H8, __, __, __, __],
  /*CCV*/
  [__, __, __, __, __, __, __, __, __, __, __, __, __, __, __, H9, __, __, __, __, __],
  /*CCC*/
  [__, __, __, __, __, __, __, __, __, __, __, __, __, __, __, __, __, __, __, __, __],
  /*CFI*/
  [__, __, __, __, __, __, __, __, __, __, __, __, __, __, __, __, __, __, __, __, H6],
  /*CAD*/
  [__, __, __, __, __, __, __, __, __, __, __, __, __, __, __, __, __, __, __, __, __],
  /*CER*/
  [__, __, __, __, __, __, __, __, __, __, __, __, __, __, __, __, __, __, __, __, __]
];
tls$1.generateKeys = function(u, r) {
  var a = prf_TLS1, e = r.client_random + r.server_random;
  u.session.resuming || (r.master_secret = a(
    r.pre_master_secret,
    "master secret",
    e,
    48
  ).bytes(), r.pre_master_secret = null), e = r.server_random + r.client_random;
  var n = 2 * r.mac_key_length + 2 * r.enc_key_length, o = u.version.major === tls$1.Versions.TLS_1_0.major && u.version.minor === tls$1.Versions.TLS_1_0.minor;
  o && (n += 2 * r.fixed_iv_length);
  var c = a(r.master_secret, "key expansion", e, n), l = {
    client_write_MAC_key: c.getBytes(r.mac_key_length),
    server_write_MAC_key: c.getBytes(r.mac_key_length),
    client_write_key: c.getBytes(r.enc_key_length),
    server_write_key: c.getBytes(r.enc_key_length)
  };
  return o && (l.client_write_IV = c.getBytes(r.fixed_iv_length), l.server_write_IV = c.getBytes(r.fixed_iv_length)), l;
};
tls$1.createConnectionState = function(u) {
  var r = u.entity === tls$1.ConnectionEnd.client, a = function() {
    var o = {
      // two 32-bit numbers, first is most significant
      sequenceNumber: [0, 0],
      macKey: null,
      macLength: 0,
      macFunction: null,
      cipherState: null,
      cipherFunction: function(c) {
        return !0;
      },
      compressionState: null,
      compressFunction: function(c) {
        return !0;
      },
      updateSequenceNumber: function() {
        o.sequenceNumber[1] === 4294967295 ? (o.sequenceNumber[1] = 0, ++o.sequenceNumber[0]) : ++o.sequenceNumber[1];
      }
    };
    return o;
  }, e = {
    read: a(),
    write: a()
  };
  if (e.read.update = function(o, c) {
    return e.read.cipherFunction(c, e.read) ? e.read.compressFunction(o, c, e.read) || o.error(o, {
      message: "Could not decompress record.",
      send: !0,
      alert: {
        level: tls$1.Alert.Level.fatal,
        description: tls$1.Alert.Description.decompression_failure
      }
    }) : o.error(o, {
      message: "Could not decrypt record or bad MAC.",
      send: !0,
      alert: {
        level: tls$1.Alert.Level.fatal,
        // doesn't matter if decryption failed or MAC was
        // invalid, return the same error so as not to reveal
        // which one occurred
        description: tls$1.Alert.Description.bad_record_mac
      }
    }), !o.fail;
  }, e.write.update = function(o, c) {
    return e.write.compressFunction(o, c, e.write) ? e.write.cipherFunction(c, e.write) || o.error(o, {
      message: "Could not encrypt record.",
      send: !1,
      alert: {
        level: tls$1.Alert.Level.fatal,
        description: tls$1.Alert.Description.internal_error
      }
    }) : o.error(o, {
      message: "Could not compress record.",
      send: !1,
      alert: {
        level: tls$1.Alert.Level.fatal,
        description: tls$1.Alert.Description.internal_error
      }
    }), !o.fail;
  }, u.session) {
    var n = u.session.sp;
    switch (u.session.cipherSuite.initSecurityParameters(n), n.keys = tls$1.generateKeys(u, n), e.read.macKey = r ? n.keys.server_write_MAC_key : n.keys.client_write_MAC_key, e.write.macKey = r ? n.keys.client_write_MAC_key : n.keys.server_write_MAC_key, u.session.cipherSuite.initConnectionState(e, u, n), n.compression_algorithm) {
      case tls$1.CompressionMethod.none:
        break;
      case tls$1.CompressionMethod.deflate:
        e.read.compressFunction = inflate, e.write.compressFunction = deflate;
        break;
      default:
        throw new Error("Unsupported compression algorithm.");
    }
  }
  return e;
};
tls$1.createRandom = function() {
  var u = /* @__PURE__ */ new Date(), r = +u + u.getTimezoneOffset() * 6e4, a = forge$8.util.createBuffer();
  return a.putInt32(r), a.putBytes(forge$8.random.getBytes(28)), a;
};
tls$1.createRecord = function(u, r) {
  if (!r.data)
    return null;
  var a = {
    type: r.type,
    version: {
      major: u.version.major,
      minor: u.version.minor
    },
    length: r.data.length(),
    fragment: r.data
  };
  return a;
};
tls$1.createAlert = function(u, r) {
  var a = forge$8.util.createBuffer();
  return a.putByte(r.level), a.putByte(r.description), tls$1.createRecord(u, {
    type: tls$1.ContentType.alert,
    data: a
  });
};
tls$1.createClientHello = function(u) {
  u.session.clientHelloVersion = {
    major: u.version.major,
    minor: u.version.minor
  };
  for (var r = forge$8.util.createBuffer(), a = 0; a < u.cipherSuites.length; ++a) {
    var e = u.cipherSuites[a];
    r.putByte(e.id[0]), r.putByte(e.id[1]);
  }
  var n = r.length(), o = forge$8.util.createBuffer();
  o.putByte(tls$1.CompressionMethod.none);
  var c = o.length(), l = forge$8.util.createBuffer();
  if (u.virtualHost) {
    var d = forge$8.util.createBuffer();
    d.putByte(0), d.putByte(0);
    var p = forge$8.util.createBuffer();
    p.putByte(0), writeVector(p, 2, forge$8.util.createBuffer(u.virtualHost));
    var h = forge$8.util.createBuffer();
    writeVector(h, 2, p), writeVector(d, 2, h), l.putBuffer(d);
  }
  var g = l.length();
  g > 0 && (g += 2);
  var y = u.session.id, v = y.length + 1 + // session ID vector
  2 + // version (major + minor)
  4 + 28 + // random time and random bytes
  2 + n + // cipher suites vector
  1 + c + // compression methods vector
  g, m = forge$8.util.createBuffer();
  return m.putByte(tls$1.HandshakeType.client_hello), m.putInt24(v), m.putByte(u.version.major), m.putByte(u.version.minor), m.putBytes(u.session.sp.client_random), writeVector(m, 1, forge$8.util.createBuffer(y)), writeVector(m, 2, r), writeVector(m, 1, o), g > 0 && writeVector(m, 2, l), m;
};
tls$1.createServerHello = function(u) {
  var r = u.session.id, a = r.length + 1 + // session ID vector
  2 + // version (major + minor)
  4 + 28 + // random time and random bytes
  2 + // chosen cipher suite
  1, e = forge$8.util.createBuffer();
  return e.putByte(tls$1.HandshakeType.server_hello), e.putInt24(a), e.putByte(u.version.major), e.putByte(u.version.minor), e.putBytes(u.session.sp.server_random), writeVector(e, 1, forge$8.util.createBuffer(r)), e.putByte(u.session.cipherSuite.id[0]), e.putByte(u.session.cipherSuite.id[1]), e.putByte(u.session.compressionMethod), e;
};
tls$1.createCertificate = function(u) {
  var r = u.entity === tls$1.ConnectionEnd.client, a = null;
  if (u.getCertificate) {
    var e;
    r ? e = u.session.certificateRequest : e = u.session.extensions.server_name.serverNameList, a = u.getCertificate(u, e);
  }
  var n = forge$8.util.createBuffer();
  if (a !== null)
    try {
      forge$8.util.isArray(a) || (a = [a]);
      for (var o = null, c = 0; c < a.length; ++c) {
        var l = forge$8.pem.decode(a[c])[0];
        if (l.type !== "CERTIFICATE" && l.type !== "X509 CERTIFICATE" && l.type !== "TRUSTED CERTIFICATE") {
          var d = new Error('Could not convert certificate from PEM; PEM header type is not "CERTIFICATE", "X509 CERTIFICATE", or "TRUSTED CERTIFICATE".');
          throw d.headerType = l.type, d;
        }
        if (l.procType && l.procType.type === "ENCRYPTED")
          throw new Error("Could not convert certificate from PEM; PEM is encrypted.");
        var p = forge$8.util.createBuffer(l.body);
        o === null && (o = forge$8.asn1.fromDer(p.bytes(), !1));
        var h = forge$8.util.createBuffer();
        writeVector(h, 3, p), n.putBuffer(h);
      }
      a = forge$8.pki.certificateFromAsn1(o), r ? u.session.clientCertificate = a : u.session.serverCertificate = a;
    } catch (v) {
      return u.error(u, {
        message: "Could not send certificate list.",
        cause: v,
        send: !0,
        alert: {
          level: tls$1.Alert.Level.fatal,
          description: tls$1.Alert.Description.bad_certificate
        }
      });
    }
  var g = 3 + n.length(), y = forge$8.util.createBuffer();
  return y.putByte(tls$1.HandshakeType.certificate), y.putInt24(g), writeVector(y, 3, n), y;
};
tls$1.createClientKeyExchange = function(u) {
  var r = forge$8.util.createBuffer();
  r.putByte(u.session.clientHelloVersion.major), r.putByte(u.session.clientHelloVersion.minor), r.putBytes(forge$8.random.getBytes(46));
  var a = u.session.sp;
  a.pre_master_secret = r.getBytes();
  var e = u.session.serverCertificate.publicKey;
  r = e.encrypt(a.pre_master_secret);
  var n = r.length + 2, o = forge$8.util.createBuffer();
  return o.putByte(tls$1.HandshakeType.client_key_exchange), o.putInt24(n), o.putInt16(r.length), o.putBytes(r), o;
};
tls$1.createServerKeyExchange = function(u) {
  var r = forge$8.util.createBuffer();
  return r;
};
tls$1.getClientSignature = function(u, r) {
  var a = forge$8.util.createBuffer();
  a.putBuffer(u.session.md5.digest()), a.putBuffer(u.session.sha1.digest()), a = a.getBytes(), u.getSignature = u.getSignature || function(e, n, o) {
    var c = null;
    if (e.getPrivateKey)
      try {
        c = e.getPrivateKey(e, e.session.clientCertificate), c = forge$8.pki.privateKeyFromPem(c);
      } catch (l) {
        e.error(e, {
          message: "Could not get private key.",
          cause: l,
          send: !0,
          alert: {
            level: tls$1.Alert.Level.fatal,
            description: tls$1.Alert.Description.internal_error
          }
        });
      }
    c === null ? e.error(e, {
      message: "No private key set.",
      send: !0,
      alert: {
        level: tls$1.Alert.Level.fatal,
        description: tls$1.Alert.Description.internal_error
      }
    }) : n = c.sign(n, null), o(e, n);
  }, u.getSignature(u, a, r);
};
tls$1.createCertificateVerify = function(u, r) {
  var a = r.length + 2, e = forge$8.util.createBuffer();
  return e.putByte(tls$1.HandshakeType.certificate_verify), e.putInt24(a), e.putInt16(r.length), e.putBytes(r), e;
};
tls$1.createCertificateRequest = function(u) {
  var r = forge$8.util.createBuffer();
  r.putByte(1);
  var a = forge$8.util.createBuffer();
  for (var e in u.caStore.certs) {
    var n = u.caStore.certs[e], o = forge$8.pki.distinguishedNameToAsn1(n.subject), c = forge$8.asn1.toDer(o);
    a.putInt16(c.length()), a.putBuffer(c);
  }
  var l = 1 + r.length() + 2 + a.length(), d = forge$8.util.createBuffer();
  return d.putByte(tls$1.HandshakeType.certificate_request), d.putInt24(l), writeVector(d, 1, r), writeVector(d, 2, a), d;
};
tls$1.createServerHelloDone = function(u) {
  var r = forge$8.util.createBuffer();
  return r.putByte(tls$1.HandshakeType.server_hello_done), r.putInt24(0), r;
};
tls$1.createChangeCipherSpec = function() {
  var u = forge$8.util.createBuffer();
  return u.putByte(1), u;
};
tls$1.createFinished = function(u) {
  var r = forge$8.util.createBuffer();
  r.putBuffer(u.session.md5.digest()), r.putBuffer(u.session.sha1.digest());
  var a = u.entity === tls$1.ConnectionEnd.client, e = u.session.sp, n = 12, o = prf_TLS1, c = a ? "client finished" : "server finished";
  r = o(e.master_secret, c, r.getBytes(), n);
  var l = forge$8.util.createBuffer();
  return l.putByte(tls$1.HandshakeType.finished), l.putInt24(r.length()), l.putBuffer(r), l;
};
tls$1.createHeartbeat = function(u, r, a) {
  typeof a > "u" && (a = r.length);
  var e = forge$8.util.createBuffer();
  e.putByte(u), e.putInt16(a), e.putBytes(r);
  var n = e.length(), o = Math.max(16, n - a - 3);
  return e.putBytes(forge$8.random.getBytes(o)), e;
};
tls$1.queue = function(u, r) {
  if (r && !(r.fragment.length() === 0 && (r.type === tls$1.ContentType.handshake || r.type === tls$1.ContentType.alert || r.type === tls$1.ContentType.change_cipher_spec))) {
    if (r.type === tls$1.ContentType.handshake) {
      var a = r.fragment.bytes();
      u.session.md5.update(a), u.session.sha1.update(a), a = null;
    }
    var e;
    if (r.fragment.length() <= tls$1.MaxFragment)
      e = [r];
    else {
      e = [];
      for (var n = r.fragment.bytes(); n.length > tls$1.MaxFragment; )
        e.push(tls$1.createRecord(u, {
          type: r.type,
          data: forge$8.util.createBuffer(n.slice(0, tls$1.MaxFragment))
        })), n = n.slice(tls$1.MaxFragment);
      n.length > 0 && e.push(tls$1.createRecord(u, {
        type: r.type,
        data: forge$8.util.createBuffer(n)
      }));
    }
    for (var o = 0; o < e.length && !u.fail; ++o) {
      var c = e[o], l = u.state.current.write;
      l.update(u, c) && u.records.push(c);
    }
  }
};
tls$1.flush = function(u) {
  for (var r = 0; r < u.records.length; ++r) {
    var a = u.records[r];
    u.tlsData.putByte(a.type), u.tlsData.putByte(a.version.major), u.tlsData.putByte(a.version.minor), u.tlsData.putInt16(a.fragment.length()), u.tlsData.putBuffer(u.records[r].fragment);
  }
  return u.records = [], u.tlsDataReady(u);
};
var _certErrorToAlertDesc = function(u) {
  switch (u) {
    case !0:
      return !0;
    case forge$8.pki.certificateError.bad_certificate:
      return tls$1.Alert.Description.bad_certificate;
    case forge$8.pki.certificateError.unsupported_certificate:
      return tls$1.Alert.Description.unsupported_certificate;
    case forge$8.pki.certificateError.certificate_revoked:
      return tls$1.Alert.Description.certificate_revoked;
    case forge$8.pki.certificateError.certificate_expired:
      return tls$1.Alert.Description.certificate_expired;
    case forge$8.pki.certificateError.certificate_unknown:
      return tls$1.Alert.Description.certificate_unknown;
    case forge$8.pki.certificateError.unknown_ca:
      return tls$1.Alert.Description.unknown_ca;
    default:
      return tls$1.Alert.Description.bad_certificate;
  }
}, _alertDescToCertError = function(u) {
  switch (u) {
    case !0:
      return !0;
    case tls$1.Alert.Description.bad_certificate:
      return forge$8.pki.certificateError.bad_certificate;
    case tls$1.Alert.Description.unsupported_certificate:
      return forge$8.pki.certificateError.unsupported_certificate;
    case tls$1.Alert.Description.certificate_revoked:
      return forge$8.pki.certificateError.certificate_revoked;
    case tls$1.Alert.Description.certificate_expired:
      return forge$8.pki.certificateError.certificate_expired;
    case tls$1.Alert.Description.certificate_unknown:
      return forge$8.pki.certificateError.certificate_unknown;
    case tls$1.Alert.Description.unknown_ca:
      return forge$8.pki.certificateError.unknown_ca;
    default:
      return forge$8.pki.certificateError.bad_certificate;
  }
};
tls$1.verifyCertificateChain = function(u, r) {
  try {
    var a = {};
    for (var e in u.verifyOptions)
      a[e] = u.verifyOptions[e];
    a.verify = function(o, c, l) {
      var d = _certErrorToAlertDesc(o), p = u.verify(u, o, c, l);
      if (p !== !0) {
        if (typeof p == "object" && !forge$8.util.isArray(p)) {
          var h = new Error("The application rejected the certificate.");
          throw h.send = !0, h.alert = {
            level: tls$1.Alert.Level.fatal,
            description: tls$1.Alert.Description.bad_certificate
          }, p.message && (h.message = p.message), p.alert && (h.alert.description = p.alert), h;
        }
        p !== o && (p = _alertDescToCertError(p));
      }
      return p;
    }, forge$8.pki.verifyCertificateChain(u.caStore, r, a);
  } catch (o) {
    var n = o;
    (typeof n != "object" || forge$8.util.isArray(n)) && (n = {
      send: !0,
      alert: {
        level: tls$1.Alert.Level.fatal,
        description: _certErrorToAlertDesc(o)
      }
    }), "send" in n || (n.send = !0), "alert" in n || (n.alert = {
      level: tls$1.Alert.Level.fatal,
      description: _certErrorToAlertDesc(n.error)
    }), u.error(u, n);
  }
  return !u.fail;
};
tls$1.createSessionCache = function(u, r) {
  var a = null;
  if (u && u.getSession && u.setSession && u.order)
    a = u;
  else {
    a = {}, a.cache = u || {}, a.capacity = Math.max(r || 100, 1), a.order = [];
    for (var e in u)
      a.order.length <= r ? a.order.push(e) : delete u[e];
    a.getSession = function(n) {
      var o = null, c = null;
      if (n ? c = forge$8.util.bytesToHex(n) : a.order.length > 0 && (c = a.order[0]), c !== null && c in a.cache) {
        o = a.cache[c], delete a.cache[c];
        for (var l in a.order)
          if (a.order[l] === c) {
            a.order.splice(l, 1);
            break;
          }
      }
      return o;
    }, a.setSession = function(n, o) {
      if (a.order.length === a.capacity) {
        var c = a.order.shift();
        delete a.cache[c];
      }
      var c = forge$8.util.bytesToHex(n);
      a.order.push(c), a.cache[c] = o;
    };
  }
  return a;
};
tls$1.createConnection = function(u) {
  var r = null;
  u.caStore ? forge$8.util.isArray(u.caStore) ? r = forge$8.pki.createCaStore(u.caStore) : r = u.caStore : r = forge$8.pki.createCaStore();
  var a = u.cipherSuites || null;
  if (a === null) {
    a = [];
    for (var e in tls$1.CipherSuites)
      a.push(tls$1.CipherSuites[e]);
  }
  var n = u.server ? tls$1.ConnectionEnd.server : tls$1.ConnectionEnd.client, o = u.sessionCache ? tls$1.createSessionCache(u.sessionCache) : null, c = {
    version: { major: tls$1.Version.major, minor: tls$1.Version.minor },
    entity: n,
    sessionId: u.sessionId,
    caStore: r,
    sessionCache: o,
    cipherSuites: a,
    connected: u.connected,
    virtualHost: u.virtualHost || null,
    verifyClient: u.verifyClient || !1,
    verify: u.verify || function(h, g, y, v) {
      return g;
    },
    verifyOptions: u.verifyOptions || {},
    getCertificate: u.getCertificate || null,
    getPrivateKey: u.getPrivateKey || null,
    getSignature: u.getSignature || null,
    input: forge$8.util.createBuffer(),
    tlsData: forge$8.util.createBuffer(),
    data: forge$8.util.createBuffer(),
    tlsDataReady: u.tlsDataReady,
    dataReady: u.dataReady,
    heartbeatReceived: u.heartbeatReceived,
    closed: u.closed,
    error: function(h, g) {
      g.origin = g.origin || (h.entity === tls$1.ConnectionEnd.client ? "client" : "server"), g.send && (tls$1.queue(h, tls$1.createAlert(h, g.alert)), tls$1.flush(h));
      var y = g.fatal !== !1;
      y && (h.fail = !0), u.error(h, g), y && h.close(!1);
    },
    deflate: u.deflate || null,
    inflate: u.inflate || null
  };
  c.reset = function(h) {
    c.version = { major: tls$1.Version.major, minor: tls$1.Version.minor }, c.record = null, c.session = null, c.peerCertificate = null, c.state = {
      pending: null,
      current: null
    }, c.expect = c.entity === tls$1.ConnectionEnd.client ? SHE : CHE, c.fragmented = null, c.records = [], c.open = !1, c.handshakes = 0, c.handshaking = !1, c.isConnected = !1, c.fail = !(h || typeof h > "u"), c.input.clear(), c.tlsData.clear(), c.data.clear(), c.state.current = tls$1.createConnectionState(c);
  }, c.reset();
  var l = function(h, g) {
    var y = g.type - tls$1.ContentType.change_cipher_spec, v = ctTable[h.entity][h.expect];
    y in v ? v[y](h, g) : tls$1.handleUnexpected(h, g);
  }, d = function(h) {
    var g = 0, y = h.input, v = y.length();
    if (v < 5)
      g = 5 - v;
    else {
      h.record = {
        type: y.getByte(),
        version: {
          major: y.getByte(),
          minor: y.getByte()
        },
        length: y.getInt16(),
        fragment: forge$8.util.createBuffer(),
        ready: !1
      };
      var m = h.record.version.major === h.version.major;
      m && h.session && h.session.version && (m = h.record.version.minor === h.version.minor), m || h.error(h, {
        message: "Incompatible TLS version.",
        send: !0,
        alert: {
          level: tls$1.Alert.Level.fatal,
          description: tls$1.Alert.Description.protocol_version
        }
      });
    }
    return g;
  }, p = function(h) {
    var g = 0, y = h.input, v = y.length();
    if (v < h.record.length)
      g = h.record.length - v;
    else {
      h.record.fragment.putBytes(y.getBytes(h.record.length)), y.compact();
      var m = h.state.current.read;
      m.update(h, h.record) && (h.fragmented !== null && (h.fragmented.type === h.record.type ? (h.fragmented.fragment.putBuffer(h.record.fragment), h.record = h.fragmented) : h.error(h, {
        message: "Invalid fragmented record.",
        send: !0,
        alert: {
          level: tls$1.Alert.Level.fatal,
          description: tls$1.Alert.Description.unexpected_message
        }
      })), h.record.ready = !0);
    }
    return g;
  };
  return c.handshake = function(h) {
    if (c.entity !== tls$1.ConnectionEnd.client)
      c.error(c, {
        message: "Cannot initiate handshake as a server.",
        fatal: !1
      });
    else if (c.handshaking)
      c.error(c, {
        message: "Handshake already in progress.",
        fatal: !1
      });
    else {
      c.fail && !c.open && c.handshakes === 0 && (c.fail = !1), c.handshaking = !0, h = h || "";
      var g = null;
      h.length > 0 && (c.sessionCache && (g = c.sessionCache.getSession(h)), g === null && (h = "")), h.length === 0 && c.sessionCache && (g = c.sessionCache.getSession(), g !== null && (h = g.id)), c.session = {
        id: h,
        version: null,
        cipherSuite: null,
        compressionMethod: null,
        serverCertificate: null,
        certificateRequest: null,
        clientCertificate: null,
        sp: {},
        md5: forge$8.md.md5.create(),
        sha1: forge$8.md.sha1.create()
      }, g && (c.version = g.version, c.session.sp = g.sp), c.session.sp.client_random = tls$1.createRandom().getBytes(), c.open = !0, tls$1.queue(c, tls$1.createRecord(c, {
        type: tls$1.ContentType.handshake,
        data: tls$1.createClientHello(c)
      })), tls$1.flush(c);
    }
  }, c.process = function(h) {
    var g = 0;
    return h && c.input.putBytes(h), c.fail || (c.record !== null && c.record.ready && c.record.fragment.isEmpty() && (c.record = null), c.record === null && (g = d(c)), !c.fail && c.record !== null && !c.record.ready && (g = p(c)), !c.fail && c.record !== null && c.record.ready && l(c, c.record)), g;
  }, c.prepare = function(h) {
    return tls$1.queue(c, tls$1.createRecord(c, {
      type: tls$1.ContentType.application_data,
      data: forge$8.util.createBuffer(h)
    })), tls$1.flush(c);
  }, c.prepareHeartbeatRequest = function(h, g) {
    return h instanceof forge$8.util.ByteBuffer && (h = h.bytes()), typeof g > "u" && (g = h.length), c.expectedHeartbeatPayload = h, tls$1.queue(c, tls$1.createRecord(c, {
      type: tls$1.ContentType.heartbeat,
      data: tls$1.createHeartbeat(
        tls$1.HeartbeatMessageType.heartbeat_request,
        h,
        g
      )
    })), tls$1.flush(c);
  }, c.close = function(h) {
    if (!c.fail && c.sessionCache && c.session) {
      var g = {
        id: c.session.id,
        version: c.session.version,
        sp: c.session.sp
      };
      g.sp.keys = null, c.sessionCache.setSession(g.id, g);
    }
    c.open && (c.open = !1, c.input.clear(), (c.isConnected || c.handshaking) && (c.isConnected = c.handshaking = !1, tls$1.queue(c, tls$1.createAlert(c, {
      level: tls$1.Alert.Level.warning,
      description: tls$1.Alert.Description.close_notify
    })), tls$1.flush(c)), c.closed(c)), c.reset(h);
  }, c;
};
forge$8.tls = forge$8.tls || {};
for (var key in tls$1)
  typeof tls$1[key] != "function" && (forge$8.tls[key] = tls$1[key]);
forge$8.tls.prf_tls1 = prf_TLS1;
forge$8.tls.hmac_sha1 = hmac_sha1;
forge$8.tls.createSessionCache = tls$1.createSessionCache;
forge$8.tls.createConnection = tls$1.createConnection;
var forge$7 = forge$C, tls = forge$7.tls;
tls.CipherSuites.TLS_RSA_WITH_AES_128_CBC_SHA = {
  id: [0, 47],
  name: "TLS_RSA_WITH_AES_128_CBC_SHA",
  initSecurityParameters: function(u) {
    u.bulk_cipher_algorithm = tls.BulkCipherAlgorithm.aes, u.cipher_type = tls.CipherType.block, u.enc_key_length = 16, u.block_length = 16, u.fixed_iv_length = 16, u.record_iv_length = 16, u.mac_algorithm = tls.MACAlgorithm.hmac_sha1, u.mac_length = 20, u.mac_key_length = 20;
  },
  initConnectionState
};
tls.CipherSuites.TLS_RSA_WITH_AES_256_CBC_SHA = {
  id: [0, 53],
  name: "TLS_RSA_WITH_AES_256_CBC_SHA",
  initSecurityParameters: function(u) {
    u.bulk_cipher_algorithm = tls.BulkCipherAlgorithm.aes, u.cipher_type = tls.CipherType.block, u.enc_key_length = 32, u.block_length = 16, u.fixed_iv_length = 16, u.record_iv_length = 16, u.mac_algorithm = tls.MACAlgorithm.hmac_sha1, u.mac_length = 20, u.mac_key_length = 20;
  },
  initConnectionState
};
function initConnectionState(u, r, a) {
  var e = r.entity === forge$7.tls.ConnectionEnd.client;
  u.read.cipherState = {
    init: !1,
    cipher: forge$7.cipher.createDecipher("AES-CBC", e ? a.keys.server_write_key : a.keys.client_write_key),
    iv: e ? a.keys.server_write_IV : a.keys.client_write_IV
  }, u.write.cipherState = {
    init: !1,
    cipher: forge$7.cipher.createCipher("AES-CBC", e ? a.keys.client_write_key : a.keys.server_write_key),
    iv: e ? a.keys.client_write_IV : a.keys.server_write_IV
  }, u.read.cipherFunction = decrypt_aes_cbc_sha1, u.write.cipherFunction = encrypt_aes_cbc_sha1, u.read.macLength = u.write.macLength = a.mac_length, u.read.macFunction = u.write.macFunction = tls.hmac_sha1;
}
function encrypt_aes_cbc_sha1(u, r) {
  var a = !1, e = r.macFunction(r.macKey, r.sequenceNumber, u);
  u.fragment.putBytes(e), r.updateSequenceNumber();
  var n;
  u.version.minor === tls.Versions.TLS_1_0.minor ? n = r.cipherState.init ? null : r.cipherState.iv : n = forge$7.random.getBytesSync(16), r.cipherState.init = !0;
  var o = r.cipherState.cipher;
  return o.start({ iv: n }), u.version.minor >= tls.Versions.TLS_1_1.minor && o.output.putBytes(n), o.update(u.fragment), o.finish(encrypt_aes_cbc_sha1_padding) && (u.fragment = o.output, u.length = u.fragment.length(), a = !0), a;
}
function encrypt_aes_cbc_sha1_padding(u, r, a) {
  if (!a) {
    var e = u - r.length() % u;
    r.fillWithByte(e - 1, e);
  }
  return !0;
}
function decrypt_aes_cbc_sha1_padding(u, r, a) {
  var e = !0;
  if (a) {
    for (var n = r.length(), o = r.last(), c = n - 1 - o; c < n - 1; ++c)
      e = e && r.at(c) == o;
    e && r.truncate(o + 1);
  }
  return e;
}
function decrypt_aes_cbc_sha1(u, r) {
  var a = !1, e;
  u.version.minor === tls.Versions.TLS_1_0.minor ? e = r.cipherState.init ? null : r.cipherState.iv : e = u.fragment.getBytes(16), r.cipherState.init = !0;
  var n = r.cipherState.cipher;
  n.start({ iv: e }), n.update(u.fragment), a = n.finish(decrypt_aes_cbc_sha1_padding);
  var o = r.macLength, c = forge$7.random.getBytesSync(o), l = n.output.length();
  l >= o ? (u.fragment = n.output.getBytes(l - o), c = n.output.getBytes(o)) : u.fragment = n.output.getBytes(), u.fragment = forge$7.util.createBuffer(u.fragment), u.length = u.fragment.length();
  var d = r.macFunction(r.macKey, r.sequenceNumber, u);
  return r.updateSequenceNumber(), a = compareMacs(r.macKey, c, d) && a, a;
}
function compareMacs(u, r, a) {
  var e = forge$7.hmac.create();
  return e.start("SHA1", u), e.update(r), r = e.digest().getBytes(), e.start(null, null), e.update(a), a = e.digest().getBytes(), r === a;
}
var forge$6 = forge$C, sha512$1 = forge$6.sha512 = forge$6.sha512 || {};
forge$6.md.sha512 = forge$6.md.algorithms.sha512 = sha512$1;
var sha384 = forge$6.sha384 = forge$6.sha512.sha384 = forge$6.sha512.sha384 || {};
sha384.create = function() {
  return sha512$1.create("SHA-384");
};
forge$6.md.sha384 = forge$6.md.algorithms.sha384 = sha384;
forge$6.sha512.sha256 = forge$6.sha512.sha256 || {
  create: function() {
    return sha512$1.create("SHA-512/256");
  }
};
forge$6.md["sha512/256"] = forge$6.md.algorithms["sha512/256"] = forge$6.sha512.sha256;
forge$6.sha512.sha224 = forge$6.sha512.sha224 || {
  create: function() {
    return sha512$1.create("SHA-512/224");
  }
};
forge$6.md["sha512/224"] = forge$6.md.algorithms["sha512/224"] = forge$6.sha512.sha224;
sha512$1.create = function(u) {
  if (_initialized || _init(), typeof u > "u" && (u = "SHA-512"), !(u in _states))
    throw new Error("Invalid SHA-512 algorithm: " + u);
  for (var r = _states[u], a = null, e = forge$6.util.createBuffer(), n = new Array(80), o = 0; o < 80; ++o)
    n[o] = new Array(2);
  var c = 64;
  switch (u) {
    case "SHA-384":
      c = 48;
      break;
    case "SHA-512/256":
      c = 32;
      break;
    case "SHA-512/224":
      c = 28;
      break;
  }
  var l = {
    // SHA-512 => sha512
    algorithm: u.replace("-", "").toLowerCase(),
    blockLength: 128,
    digestLength: c,
    // 56-bit length of message so far (does not including padding)
    messageLength: 0,
    // true message length
    fullMessageLength: null,
    // size of message length in bytes
    messageLengthSize: 16
  };
  return l.start = function() {
    l.messageLength = 0, l.fullMessageLength = l.messageLength128 = [];
    for (var d = l.messageLengthSize / 4, p = 0; p < d; ++p)
      l.fullMessageLength.push(0);
    e = forge$6.util.createBuffer(), a = new Array(r.length);
    for (var p = 0; p < r.length; ++p)
      a[p] = r[p].slice(0);
    return l;
  }, l.start(), l.update = function(d, p) {
    p === "utf8" && (d = forge$6.util.encodeUtf8(d));
    var h = d.length;
    l.messageLength += h, h = [h / 4294967296 >>> 0, h >>> 0];
    for (var g = l.fullMessageLength.length - 1; g >= 0; --g)
      l.fullMessageLength[g] += h[1], h[1] = h[0] + (l.fullMessageLength[g] / 4294967296 >>> 0), l.fullMessageLength[g] = l.fullMessageLength[g] >>> 0, h[0] = h[1] / 4294967296 >>> 0;
    return e.putBytes(d), _update(a, n, e), (e.read > 2048 || e.length() === 0) && e.compact(), l;
  }, l.digest = function() {
    var d = forge$6.util.createBuffer();
    d.putBytes(e.bytes());
    var p = l.fullMessageLength[l.fullMessageLength.length - 1] + l.messageLengthSize, h = p & l.blockLength - 1;
    d.putBytes(_padding.substr(0, l.blockLength - h));
    for (var g, y, v = l.fullMessageLength[0] * 8, m = 0; m < l.fullMessageLength.length - 1; ++m)
      g = l.fullMessageLength[m + 1] * 8, y = g / 4294967296 >>> 0, v += y, d.putInt32(v >>> 0), v = g >>> 0;
    d.putInt32(v);
    for (var b = new Array(a.length), m = 0; m < a.length; ++m)
      b[m] = a[m].slice(0);
    _update(b, n, d);
    var R = forge$6.util.createBuffer(), $;
    u === "SHA-512" ? $ = b.length : u === "SHA-384" ? $ = b.length - 2 : $ = b.length - 4;
    for (var m = 0; m < $; ++m)
      R.putInt32(b[m][0]), (m !== $ - 1 || u !== "SHA-512/224") && R.putInt32(b[m][1]);
    return R;
  }, l;
};
var _padding = null, _initialized = !1, _k = null, _states = null;
function _init() {
  _padding = "", _padding += forge$6.util.fillString("\0", 128), _k = [
    [1116352408, 3609767458],
    [1899447441, 602891725],
    [3049323471, 3964484399],
    [3921009573, 2173295548],
    [961987163, 4081628472],
    [1508970993, 3053834265],
    [2453635748, 2937671579],
    [2870763221, 3664609560],
    [3624381080, 2734883394],
    [310598401, 1164996542],
    [607225278, 1323610764],
    [1426881987, 3590304994],
    [1925078388, 4068182383],
    [2162078206, 991336113],
    [2614888103, 633803317],
    [3248222580, 3479774868],
    [3835390401, 2666613458],
    [4022224774, 944711139],
    [264347078, 2341262773],
    [604807628, 2007800933],
    [770255983, 1495990901],
    [1249150122, 1856431235],
    [1555081692, 3175218132],
    [1996064986, 2198950837],
    [2554220882, 3999719339],
    [2821834349, 766784016],
    [2952996808, 2566594879],
    [3210313671, 3203337956],
    [3336571891, 1034457026],
    [3584528711, 2466948901],
    [113926993, 3758326383],
    [338241895, 168717936],
    [666307205, 1188179964],
    [773529912, 1546045734],
    [1294757372, 1522805485],
    [1396182291, 2643833823],
    [1695183700, 2343527390],
    [1986661051, 1014477480],
    [2177026350, 1206759142],
    [2456956037, 344077627],
    [2730485921, 1290863460],
    [2820302411, 3158454273],
    [3259730800, 3505952657],
    [3345764771, 106217008],
    [3516065817, 3606008344],
    [3600352804, 1432725776],
    [4094571909, 1467031594],
    [275423344, 851169720],
    [430227734, 3100823752],
    [506948616, 1363258195],
    [659060556, 3750685593],
    [883997877, 3785050280],
    [958139571, 3318307427],
    [1322822218, 3812723403],
    [1537002063, 2003034995],
    [1747873779, 3602036899],
    [1955562222, 1575990012],
    [2024104815, 1125592928],
    [2227730452, 2716904306],
    [2361852424, 442776044],
    [2428436474, 593698344],
    [2756734187, 3733110249],
    [3204031479, 2999351573],
    [3329325298, 3815920427],
    [3391569614, 3928383900],
    [3515267271, 566280711],
    [3940187606, 3454069534],
    [4118630271, 4000239992],
    [116418474, 1914138554],
    [174292421, 2731055270],
    [289380356, 3203993006],
    [460393269, 320620315],
    [685471733, 587496836],
    [852142971, 1086792851],
    [1017036298, 365543100],
    [1126000580, 2618297676],
    [1288033470, 3409855158],
    [1501505948, 4234509866],
    [1607167915, 987167468],
    [1816402316, 1246189591]
  ], _states = {}, _states["SHA-512"] = [
    [1779033703, 4089235720],
    [3144134277, 2227873595],
    [1013904242, 4271175723],
    [2773480762, 1595750129],
    [1359893119, 2917565137],
    [2600822924, 725511199],
    [528734635, 4215389547],
    [1541459225, 327033209]
  ], _states["SHA-384"] = [
    [3418070365, 3238371032],
    [1654270250, 914150663],
    [2438529370, 812702999],
    [355462360, 4144912697],
    [1731405415, 4290775857],
    [2394180231, 1750603025],
    [3675008525, 1694076839],
    [1203062813, 3204075428]
  ], _states["SHA-512/256"] = [
    [573645204, 4230739756],
    [2673172387, 3360449730],
    [596883563, 1867755857],
    [2520282905, 1497426621],
    [2519219938, 2827943907],
    [3193839141, 1401305490],
    [721525244, 746961066],
    [246885852, 2177182882]
  ], _states["SHA-512/224"] = [
    [2352822216, 424955298],
    [1944164710, 2312950998],
    [502970286, 855612546],
    [1738396948, 1479516111],
    [258812777, 2077511080],
    [2011393907, 79989058],
    [1067287976, 1780299464],
    [286451373, 2446758561]
  ], _initialized = !0;
}
function _update(u, r, a) {
  for (var e, n, o, c, l, d, p, h, g, y, v, m, b, R, $, x, E, T, P, O, w, _, C, k, B, j, J, N, F, U, K, ve, he, te, W, ae = a.length(); ae >= 128; ) {
    for (F = 0; F < 16; ++F)
      r[F][0] = a.getInt32() >>> 0, r[F][1] = a.getInt32() >>> 0;
    for (; F < 80; ++F)
      ve = r[F - 2], U = ve[0], K = ve[1], e = ((U >>> 19 | K << 13) ^ // ROTR 19
      (K >>> 29 | U << 3) ^ // ROTR 61/(swap + ROTR 29)
      U >>> 6) >>> 0, n = ((U << 13 | K >>> 19) ^ // ROTR 19
      (K << 3 | U >>> 29) ^ // ROTR 61/(swap + ROTR 29)
      (U << 26 | K >>> 6)) >>> 0, te = r[F - 15], U = te[0], K = te[1], o = ((U >>> 1 | K << 31) ^ // ROTR 1
      (U >>> 8 | K << 24) ^ // ROTR 8
      U >>> 7) >>> 0, c = ((U << 31 | K >>> 1) ^ // ROTR 1
      (U << 24 | K >>> 8) ^ // ROTR 8
      (U << 25 | K >>> 7)) >>> 0, he = r[F - 7], W = r[F - 16], K = n + he[1] + c + W[1], r[F][0] = e + he[0] + o + W[0] + (K / 4294967296 >>> 0) >>> 0, r[F][1] = K >>> 0;
    for (b = u[0][0], R = u[0][1], $ = u[1][0], x = u[1][1], E = u[2][0], T = u[2][1], P = u[3][0], O = u[3][1], w = u[4][0], _ = u[4][1], C = u[5][0], k = u[5][1], B = u[6][0], j = u[6][1], J = u[7][0], N = u[7][1], F = 0; F < 80; ++F)
      p = ((w >>> 14 | _ << 18) ^ // ROTR 14
      (w >>> 18 | _ << 14) ^ // ROTR 18
      (_ >>> 9 | w << 23)) >>> 0, h = ((w << 18 | _ >>> 14) ^ // ROTR 14
      (w << 14 | _ >>> 18) ^ // ROTR 18
      (_ << 23 | w >>> 9)) >>> 0, g = (B ^ w & (C ^ B)) >>> 0, y = (j ^ _ & (k ^ j)) >>> 0, l = ((b >>> 28 | R << 4) ^ // ROTR 28
      (R >>> 2 | b << 30) ^ // ROTR 34/(swap + ROTR 2)
      (R >>> 7 | b << 25)) >>> 0, d = ((b << 4 | R >>> 28) ^ // ROTR 28
      (R << 30 | b >>> 2) ^ // ROTR 34/(swap + ROTR 2)
      (R << 25 | b >>> 7)) >>> 0, v = (b & $ | E & (b ^ $)) >>> 0, m = (R & x | T & (R ^ x)) >>> 0, K = N + h + y + _k[F][1] + r[F][1], e = J + p + g + _k[F][0] + r[F][0] + (K / 4294967296 >>> 0) >>> 0, n = K >>> 0, K = d + m, o = l + v + (K / 4294967296 >>> 0) >>> 0, c = K >>> 0, J = B, N = j, B = C, j = k, C = w, k = _, K = O + n, w = P + e + (K / 4294967296 >>> 0) >>> 0, _ = K >>> 0, P = E, O = T, E = $, T = x, $ = b, x = R, K = n + c, b = e + o + (K / 4294967296 >>> 0) >>> 0, R = K >>> 0;
    K = u[0][1] + R, u[0][0] = u[0][0] + b + (K / 4294967296 >>> 0) >>> 0, u[0][1] = K >>> 0, K = u[1][1] + x, u[1][0] = u[1][0] + $ + (K / 4294967296 >>> 0) >>> 0, u[1][1] = K >>> 0, K = u[2][1] + T, u[2][0] = u[2][0] + E + (K / 4294967296 >>> 0) >>> 0, u[2][1] = K >>> 0, K = u[3][1] + O, u[3][0] = u[3][0] + P + (K / 4294967296 >>> 0) >>> 0, u[3][1] = K >>> 0, K = u[4][1] + _, u[4][0] = u[4][0] + w + (K / 4294967296 >>> 0) >>> 0, u[4][1] = K >>> 0, K = u[5][1] + k, u[5][0] = u[5][0] + C + (K / 4294967296 >>> 0) >>> 0, u[5][1] = K >>> 0, K = u[6][1] + j, u[6][0] = u[6][0] + B + (K / 4294967296 >>> 0) >>> 0, u[6][1] = K >>> 0, K = u[7][1] + N, u[7][0] = u[7][0] + J + (K / 4294967296 >>> 0) >>> 0, u[7][1] = K >>> 0, ae -= 128;
  }
}
var asn1Validator$1 = {}, forge$5 = forge$C, asn1$1 = forge$5.asn1;
asn1Validator$1.privateKeyValidator = {
  // PrivateKeyInfo
  name: "PrivateKeyInfo",
  tagClass: asn1$1.Class.UNIVERSAL,
  type: asn1$1.Type.SEQUENCE,
  constructed: !0,
  value: [{
    // Version (INTEGER)
    name: "PrivateKeyInfo.version",
    tagClass: asn1$1.Class.UNIVERSAL,
    type: asn1$1.Type.INTEGER,
    constructed: !1,
    capture: "privateKeyVersion"
  }, {
    // privateKeyAlgorithm
    name: "PrivateKeyInfo.privateKeyAlgorithm",
    tagClass: asn1$1.Class.UNIVERSAL,
    type: asn1$1.Type.SEQUENCE,
    constructed: !0,
    value: [{
      name: "AlgorithmIdentifier.algorithm",
      tagClass: asn1$1.Class.UNIVERSAL,
      type: asn1$1.Type.OID,
      constructed: !1,
      capture: "privateKeyOid"
    }]
  }, {
    // PrivateKey
    name: "PrivateKeyInfo",
    tagClass: asn1$1.Class.UNIVERSAL,
    type: asn1$1.Type.OCTETSTRING,
    constructed: !1,
    capture: "privateKey"
  }]
};
asn1Validator$1.publicKeyValidator = {
  name: "SubjectPublicKeyInfo",
  tagClass: asn1$1.Class.UNIVERSAL,
  type: asn1$1.Type.SEQUENCE,
  constructed: !0,
  captureAsn1: "subjectPublicKeyInfo",
  value: [
    {
      name: "SubjectPublicKeyInfo.AlgorithmIdentifier",
      tagClass: asn1$1.Class.UNIVERSAL,
      type: asn1$1.Type.SEQUENCE,
      constructed: !0,
      value: [{
        name: "AlgorithmIdentifier.algorithm",
        tagClass: asn1$1.Class.UNIVERSAL,
        type: asn1$1.Type.OID,
        constructed: !1,
        capture: "publicKeyOid"
      }]
    },
    // capture group for ed25519PublicKey
    {
      tagClass: asn1$1.Class.UNIVERSAL,
      type: asn1$1.Type.BITSTRING,
      constructed: !1,
      composed: !0,
      captureBitStringValue: "ed25519PublicKey"
    }
    // FIXME: this is capture group for rsaPublicKey, use it in this API or
    // discard?
    /* {
      // subjectPublicKey
      name: 'SubjectPublicKeyInfo.subjectPublicKey',
      tagClass: asn1.Class.UNIVERSAL,
      type: asn1.Type.BITSTRING,
      constructed: false,
      value: [{
        // RSAPublicKey
        name: 'SubjectPublicKeyInfo.subjectPublicKey.RSAPublicKey',
        tagClass: asn1.Class.UNIVERSAL,
        type: asn1.Type.SEQUENCE,
        constructed: true,
        optional: true,
        captureAsn1: 'rsaPublicKey'
      }]
    } */
  ]
};
var forge$4 = forge$C, asn1Validator = asn1Validator$1, publicKeyValidator = asn1Validator.publicKeyValidator, privateKeyValidator = asn1Validator.privateKeyValidator;
if (typeof BigInteger$1 > "u")
  var BigInteger$1 = forge$4.jsbn.BigInteger;
var ByteBuffer = forge$4.util.ByteBuffer, NativeBuffer = typeof Buffer > "u" ? Uint8Array : Buffer;
forge$4.pki = forge$4.pki || {};
forge$4.pki.ed25519 = forge$4.ed25519 = forge$4.ed25519 || {};
var ed25519 = forge$4.ed25519;
ed25519.constants = {};
ed25519.constants.PUBLIC_KEY_BYTE_LENGTH = 32;
ed25519.constants.PRIVATE_KEY_BYTE_LENGTH = 64;
ed25519.constants.SEED_BYTE_LENGTH = 32;
ed25519.constants.SIGN_BYTE_LENGTH = 64;
ed25519.constants.HASH_BYTE_LENGTH = 64;
ed25519.generateKeyPair = function(u) {
  u = u || {};
  var r = u.seed;
  if (r === void 0)
    r = forge$4.random.getBytesSync(ed25519.constants.SEED_BYTE_LENGTH);
  else if (typeof r == "string") {
    if (r.length !== ed25519.constants.SEED_BYTE_LENGTH)
      throw new TypeError(
        '"seed" must be ' + ed25519.constants.SEED_BYTE_LENGTH + " bytes in length."
      );
  } else if (!(r instanceof Uint8Array))
    throw new TypeError(
      '"seed" must be a node.js Buffer, Uint8Array, or a binary string.'
    );
  r = messageToNativeBuffer({ message: r, encoding: "binary" });
  for (var a = new NativeBuffer(ed25519.constants.PUBLIC_KEY_BYTE_LENGTH), e = new NativeBuffer(ed25519.constants.PRIVATE_KEY_BYTE_LENGTH), n = 0; n < 32; ++n)
    e[n] = r[n];
  return crypto_sign_keypair(a, e), { publicKey: a, privateKey: e };
};
ed25519.privateKeyFromAsn1 = function(u) {
  var r = {}, a = [], e = forge$4.asn1.validate(u, privateKeyValidator, r, a);
  if (!e) {
    var n = new Error("Invalid Key.");
    throw n.errors = a, n;
  }
  var o = forge$4.asn1.derToOid(r.privateKeyOid), c = forge$4.oids.EdDSA25519;
  if (o !== c)
    throw new Error('Invalid OID "' + o + '"; OID must be "' + c + '".');
  var l = r.privateKey, d = messageToNativeBuffer({
    message: forge$4.asn1.fromDer(l).value,
    encoding: "binary"
  });
  return { privateKeyBytes: d };
};
ed25519.publicKeyFromAsn1 = function(u) {
  var r = {}, a = [], e = forge$4.asn1.validate(u, publicKeyValidator, r, a);
  if (!e) {
    var n = new Error("Invalid Key.");
    throw n.errors = a, n;
  }
  var o = forge$4.asn1.derToOid(r.publicKeyOid), c = forge$4.oids.EdDSA25519;
  if (o !== c)
    throw new Error('Invalid OID "' + o + '"; OID must be "' + c + '".');
  var l = r.ed25519PublicKey;
  if (l.length !== ed25519.constants.PUBLIC_KEY_BYTE_LENGTH)
    throw new Error("Key length is invalid.");
  return messageToNativeBuffer({
    message: l,
    encoding: "binary"
  });
};
ed25519.publicKeyFromPrivateKey = function(u) {
  u = u || {};
  var r = messageToNativeBuffer({
    message: u.privateKey,
    encoding: "binary"
  });
  if (r.length !== ed25519.constants.PRIVATE_KEY_BYTE_LENGTH)
    throw new TypeError(
      '"options.privateKey" must have a byte length of ' + ed25519.constants.PRIVATE_KEY_BYTE_LENGTH
    );
  for (var a = new NativeBuffer(ed25519.constants.PUBLIC_KEY_BYTE_LENGTH), e = 0; e < a.length; ++e)
    a[e] = r[32 + e];
  return a;
};
ed25519.sign = function(u) {
  u = u || {};
  var r = messageToNativeBuffer(u), a = messageToNativeBuffer({
    message: u.privateKey,
    encoding: "binary"
  });
  if (a.length === ed25519.constants.SEED_BYTE_LENGTH) {
    var e = ed25519.generateKeyPair({ seed: a });
    a = e.privateKey;
  } else if (a.length !== ed25519.constants.PRIVATE_KEY_BYTE_LENGTH)
    throw new TypeError(
      '"options.privateKey" must have a byte length of ' + ed25519.constants.SEED_BYTE_LENGTH + " or " + ed25519.constants.PRIVATE_KEY_BYTE_LENGTH
    );
  var n = new NativeBuffer(
    ed25519.constants.SIGN_BYTE_LENGTH + r.length
  );
  crypto_sign(n, r, r.length, a);
  for (var o = new NativeBuffer(ed25519.constants.SIGN_BYTE_LENGTH), c = 0; c < o.length; ++c)
    o[c] = n[c];
  return o;
};
ed25519.verify = function(u) {
  u = u || {};
  var r = messageToNativeBuffer(u);
  if (u.signature === void 0)
    throw new TypeError(
      '"options.signature" must be a node.js Buffer, a Uint8Array, a forge ByteBuffer, or a binary string.'
    );
  var a = messageToNativeBuffer({
    message: u.signature,
    encoding: "binary"
  });
  if (a.length !== ed25519.constants.SIGN_BYTE_LENGTH)
    throw new TypeError(
      '"options.signature" must have a byte length of ' + ed25519.constants.SIGN_BYTE_LENGTH
    );
  var e = messageToNativeBuffer({
    message: u.publicKey,
    encoding: "binary"
  });
  if (e.length !== ed25519.constants.PUBLIC_KEY_BYTE_LENGTH)
    throw new TypeError(
      '"options.publicKey" must have a byte length of ' + ed25519.constants.PUBLIC_KEY_BYTE_LENGTH
    );
  var n = new NativeBuffer(ed25519.constants.SIGN_BYTE_LENGTH + r.length), o = new NativeBuffer(ed25519.constants.SIGN_BYTE_LENGTH + r.length), c;
  for (c = 0; c < ed25519.constants.SIGN_BYTE_LENGTH; ++c)
    n[c] = a[c];
  for (c = 0; c < r.length; ++c)
    n[c + ed25519.constants.SIGN_BYTE_LENGTH] = r[c];
  return crypto_sign_open(o, n, n.length, e) >= 0;
};
function messageToNativeBuffer(u) {
  var r = u.message;
  if (r instanceof Uint8Array || r instanceof NativeBuffer)
    return r;
  var a = u.encoding;
  if (r === void 0)
    if (u.md)
      r = u.md.digest().getBytes(), a = "binary";
    else
      throw new TypeError('"options.message" or "options.md" not specified.');
  if (typeof r == "string" && !a)
    throw new TypeError('"options.encoding" must be "binary" or "utf8".');
  if (typeof r == "string") {
    if (typeof Buffer < "u")
      return Buffer.from(r, a);
    r = new ByteBuffer(r, a);
  } else if (!(r instanceof ByteBuffer))
    throw new TypeError(
      '"options.message" must be a node.js Buffer, a Uint8Array, a forge ByteBuffer, or a string with "options.encoding" specifying its encoding.'
    );
  for (var e = new NativeBuffer(r.length()), n = 0; n < e.length; ++n)
    e[n] = r.at(n);
  return e;
}
var gf0 = gf(), gf1 = gf([1]), D = gf([
  30883,
  4953,
  19914,
  30187,
  55467,
  16705,
  2637,
  112,
  59544,
  30585,
  16505,
  36039,
  65139,
  11119,
  27886,
  20995
]), D2 = gf([
  61785,
  9906,
  39828,
  60374,
  45398,
  33411,
  5274,
  224,
  53552,
  61171,
  33010,
  6542,
  64743,
  22239,
  55772,
  9222
]), X = gf([
  54554,
  36645,
  11616,
  51542,
  42930,
  38181,
  51040,
  26924,
  56412,
  64982,
  57905,
  49316,
  21502,
  52590,
  14035,
  8553
]), Y = gf([
  26200,
  26214,
  26214,
  26214,
  26214,
  26214,
  26214,
  26214,
  26214,
  26214,
  26214,
  26214,
  26214,
  26214,
  26214,
  26214
]), L = new Float64Array([
  237,
  211,
  245,
  92,
  26,
  99,
  18,
  88,
  214,
  156,
  247,
  162,
  222,
  249,
  222,
  20,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  16
]), I = gf([
  41136,
  18958,
  6951,
  50414,
  58488,
  44335,
  6150,
  12099,
  55207,
  15867,
  153,
  11085,
  57099,
  20417,
  9344,
  11139
]);
function sha512(u, r) {
  var a = forge$4.md.sha512.create(), e = new ByteBuffer(u);
  a.update(e.getBytes(r), "binary");
  var n = a.digest().getBytes();
  if (typeof Buffer < "u")
    return Buffer.from(n, "binary");
  for (var o = new NativeBuffer(ed25519.constants.HASH_BYTE_LENGTH), c = 0; c < 64; ++c)
    o[c] = n.charCodeAt(c);
  return o;
}
function crypto_sign_keypair(u, r) {
  var a = [gf(), gf(), gf(), gf()], e, n = sha512(r, 32);
  for (n[0] &= 248, n[31] &= 127, n[31] |= 64, scalarbase(a, n), pack(u, a), e = 0; e < 32; ++e)
    r[e + 32] = u[e];
  return 0;
}
function crypto_sign(u, r, a, e) {
  var n, o, c = new Float64Array(64), l = [gf(), gf(), gf(), gf()], d = sha512(e, 32);
  d[0] &= 248, d[31] &= 127, d[31] |= 64;
  var p = a + 64;
  for (n = 0; n < a; ++n)
    u[64 + n] = r[n];
  for (n = 0; n < 32; ++n)
    u[32 + n] = d[32 + n];
  var h = sha512(u.subarray(32), a + 32);
  for (reduce(h), scalarbase(l, h), pack(u, l), n = 32; n < 64; ++n)
    u[n] = e[n];
  var g = sha512(u, a + 64);
  for (reduce(g), n = 32; n < 64; ++n)
    c[n] = 0;
  for (n = 0; n < 32; ++n)
    c[n] = h[n];
  for (n = 0; n < 32; ++n)
    for (o = 0; o < 32; o++)
      c[n + o] += g[n] * d[o];
  return modL(u.subarray(32), c), p;
}
function crypto_sign_open(u, r, a, e) {
  var n, o, c = new NativeBuffer(32), l = [gf(), gf(), gf(), gf()], d = [gf(), gf(), gf(), gf()];
  if (o = -1, a < 64 || unpackneg(d, e))
    return -1;
  for (n = 0; n < a; ++n)
    u[n] = r[n];
  for (n = 0; n < 32; ++n)
    u[n + 32] = e[n];
  var p = sha512(u, a);
  if (reduce(p), scalarmult(l, d, p), scalarbase(d, r.subarray(32)), add(l, d), pack(c, l), a -= 64, crypto_verify_32(r, 0, c, 0)) {
    for (n = 0; n < a; ++n)
      u[n] = 0;
    return -1;
  }
  for (n = 0; n < a; ++n)
    u[n] = r[n + 64];
  return o = a, o;
}
function modL(u, r) {
  var a, e, n, o;
  for (e = 63; e >= 32; --e) {
    for (a = 0, n = e - 32, o = e - 12; n < o; ++n)
      r[n] += a - 16 * r[e] * L[n - (e - 32)], a = r[n] + 128 >> 8, r[n] -= a * 256;
    r[n] += a, r[e] = 0;
  }
  for (a = 0, n = 0; n < 32; ++n)
    r[n] += a - (r[31] >> 4) * L[n], a = r[n] >> 8, r[n] &= 255;
  for (n = 0; n < 32; ++n)
    r[n] -= a * L[n];
  for (e = 0; e < 32; ++e)
    r[e + 1] += r[e] >> 8, u[e] = r[e] & 255;
}
function reduce(u) {
  for (var r = new Float64Array(64), a = 0; a < 64; ++a)
    r[a] = u[a], u[a] = 0;
  modL(u, r);
}
function add(u, r) {
  var a = gf(), e = gf(), n = gf(), o = gf(), c = gf(), l = gf(), d = gf(), p = gf(), h = gf();
  Z(a, u[1], u[0]), Z(h, r[1], r[0]), M(a, a, h), A(e, u[0], u[1]), A(h, r[0], r[1]), M(e, e, h), M(n, u[3], r[3]), M(n, n, D2), M(o, u[2], r[2]), A(o, o, o), Z(c, e, a), Z(l, o, n), A(d, o, n), A(p, e, a), M(u[0], c, l), M(u[1], p, d), M(u[2], d, l), M(u[3], c, p);
}
function cswap(u, r, a) {
  for (var e = 0; e < 4; ++e)
    sel25519(u[e], r[e], a);
}
function pack(u, r) {
  var a = gf(), e = gf(), n = gf();
  inv25519(n, r[2]), M(a, r[0], n), M(e, r[1], n), pack25519(u, e), u[31] ^= par25519(a) << 7;
}
function pack25519(u, r) {
  var a, e, n, o = gf(), c = gf();
  for (a = 0; a < 16; ++a)
    c[a] = r[a];
  for (car25519(c), car25519(c), car25519(c), e = 0; e < 2; ++e) {
    for (o[0] = c[0] - 65517, a = 1; a < 15; ++a)
      o[a] = c[a] - 65535 - (o[a - 1] >> 16 & 1), o[a - 1] &= 65535;
    o[15] = c[15] - 32767 - (o[14] >> 16 & 1), n = o[15] >> 16 & 1, o[14] &= 65535, sel25519(c, o, 1 - n);
  }
  for (a = 0; a < 16; a++)
    u[2 * a] = c[a] & 255, u[2 * a + 1] = c[a] >> 8;
}
function unpackneg(u, r) {
  var a = gf(), e = gf(), n = gf(), o = gf(), c = gf(), l = gf(), d = gf();
  return set25519(u[2], gf1), unpack25519(u[1], r), S(n, u[1]), M(o, n, D), Z(n, n, u[2]), A(o, u[2], o), S(c, o), S(l, c), M(d, l, c), M(a, d, n), M(a, a, o), pow2523(a, a), M(a, a, n), M(a, a, o), M(a, a, o), M(u[0], a, o), S(e, u[0]), M(e, e, o), neq25519(e, n) && M(u[0], u[0], I), S(e, u[0]), M(e, e, o), neq25519(e, n) ? -1 : (par25519(u[0]) === r[31] >> 7 && Z(u[0], gf0, u[0]), M(u[3], u[0], u[1]), 0);
}
function unpack25519(u, r) {
  var a;
  for (a = 0; a < 16; ++a)
    u[a] = r[2 * a] + (r[2 * a + 1] << 8);
  u[15] &= 32767;
}
function pow2523(u, r) {
  var a = gf(), e;
  for (e = 0; e < 16; ++e)
    a[e] = r[e];
  for (e = 250; e >= 0; --e)
    S(a, a), e !== 1 && M(a, a, r);
  for (e = 0; e < 16; ++e)
    u[e] = a[e];
}
function neq25519(u, r) {
  var a = new NativeBuffer(32), e = new NativeBuffer(32);
  return pack25519(a, u), pack25519(e, r), crypto_verify_32(a, 0, e, 0);
}
function crypto_verify_32(u, r, a, e) {
  return vn(u, r, a, e, 32);
}
function vn(u, r, a, e, n) {
  var o, c = 0;
  for (o = 0; o < n; ++o)
    c |= u[r + o] ^ a[e + o];
  return (1 & c - 1 >>> 8) - 1;
}
function par25519(u) {
  var r = new NativeBuffer(32);
  return pack25519(r, u), r[0] & 1;
}
function scalarmult(u, r, a) {
  var e, n;
  for (set25519(u[0], gf0), set25519(u[1], gf1), set25519(u[2], gf1), set25519(u[3], gf0), n = 255; n >= 0; --n)
    e = a[n / 8 | 0] >> (n & 7) & 1, cswap(u, r, e), add(r, u), add(u, u), cswap(u, r, e);
}
function scalarbase(u, r) {
  var a = [gf(), gf(), gf(), gf()];
  set25519(a[0], X), set25519(a[1], Y), set25519(a[2], gf1), M(a[3], X, Y), scalarmult(u, a, r);
}
function set25519(u, r) {
  var a;
  for (a = 0; a < 16; a++)
    u[a] = r[a] | 0;
}
function inv25519(u, r) {
  var a = gf(), e;
  for (e = 0; e < 16; ++e)
    a[e] = r[e];
  for (e = 253; e >= 0; --e)
    S(a, a), e !== 2 && e !== 4 && M(a, a, r);
  for (e = 0; e < 16; ++e)
    u[e] = a[e];
}
function car25519(u) {
  var r, a, e = 1;
  for (r = 0; r < 16; ++r)
    a = u[r] + e + 65535, e = Math.floor(a / 65536), u[r] = a - e * 65536;
  u[0] += e - 1 + 37 * (e - 1);
}
function sel25519(u, r, a) {
  for (var e, n = ~(a - 1), o = 0; o < 16; ++o)
    e = n & (u[o] ^ r[o]), u[o] ^= e, r[o] ^= e;
}
function gf(u) {
  var r, a = new Float64Array(16);
  if (u)
    for (r = 0; r < u.length; ++r)
      a[r] = u[r];
  return a;
}
function A(u, r, a) {
  for (var e = 0; e < 16; ++e)
    u[e] = r[e] + a[e];
}
function Z(u, r, a) {
  for (var e = 0; e < 16; ++e)
    u[e] = r[e] - a[e];
}
function S(u, r) {
  M(u, r, r);
}
function M(u, r, a) {
  var e, n, o = 0, c = 0, l = 0, d = 0, p = 0, h = 0, g = 0, y = 0, v = 0, m = 0, b = 0, R = 0, $ = 0, x = 0, E = 0, T = 0, P = 0, O = 0, w = 0, _ = 0, C = 0, k = 0, B = 0, j = 0, J = 0, N = 0, F = 0, U = 0, K = 0, ve = 0, he = 0, te = a[0], W = a[1], ae = a[2], fe = a[3], ee = a[4], Se = a[5], pe = a[6], Q = a[7], oe = a[8], ne = a[9], se = a[10], de = a[11], ue = a[12], Re = a[13], be = a[14], me = a[15];
  e = r[0], o += e * te, c += e * W, l += e * ae, d += e * fe, p += e * ee, h += e * Se, g += e * pe, y += e * Q, v += e * oe, m += e * ne, b += e * se, R += e * de, $ += e * ue, x += e * Re, E += e * be, T += e * me, e = r[1], c += e * te, l += e * W, d += e * ae, p += e * fe, h += e * ee, g += e * Se, y += e * pe, v += e * Q, m += e * oe, b += e * ne, R += e * se, $ += e * de, x += e * ue, E += e * Re, T += e * be, P += e * me, e = r[2], l += e * te, d += e * W, p += e * ae, h += e * fe, g += e * ee, y += e * Se, v += e * pe, m += e * Q, b += e * oe, R += e * ne, $ += e * se, x += e * de, E += e * ue, T += e * Re, P += e * be, O += e * me, e = r[3], d += e * te, p += e * W, h += e * ae, g += e * fe, y += e * ee, v += e * Se, m += e * pe, b += e * Q, R += e * oe, $ += e * ne, x += e * se, E += e * de, T += e * ue, P += e * Re, O += e * be, w += e * me, e = r[4], p += e * te, h += e * W, g += e * ae, y += e * fe, v += e * ee, m += e * Se, b += e * pe, R += e * Q, $ += e * oe, x += e * ne, E += e * se, T += e * de, P += e * ue, O += e * Re, w += e * be, _ += e * me, e = r[5], h += e * te, g += e * W, y += e * ae, v += e * fe, m += e * ee, b += e * Se, R += e * pe, $ += e * Q, x += e * oe, E += e * ne, T += e * se, P += e * de, O += e * ue, w += e * Re, _ += e * be, C += e * me, e = r[6], g += e * te, y += e * W, v += e * ae, m += e * fe, b += e * ee, R += e * Se, $ += e * pe, x += e * Q, E += e * oe, T += e * ne, P += e * se, O += e * de, w += e * ue, _ += e * Re, C += e * be, k += e * me, e = r[7], y += e * te, v += e * W, m += e * ae, b += e * fe, R += e * ee, $ += e * Se, x += e * pe, E += e * Q, T += e * oe, P += e * ne, O += e * se, w += e * de, _ += e * ue, C += e * Re, k += e * be, B += e * me, e = r[8], v += e * te, m += e * W, b += e * ae, R += e * fe, $ += e * ee, x += e * Se, E += e * pe, T += e * Q, P += e * oe, O += e * ne, w += e * se, _ += e * de, C += e * ue, k += e * Re, B += e * be, j += e * me, e = r[9], m += e * te, b += e * W, R += e * ae, $ += e * fe, x += e * ee, E += e * Se, T += e * pe, P += e * Q, O += e * oe, w += e * ne, _ += e * se, C += e * de, k += e * ue, B += e * Re, j += e * be, J += e * me, e = r[10], b += e * te, R += e * W, $ += e * ae, x += e * fe, E += e * ee, T += e * Se, P += e * pe, O += e * Q, w += e * oe, _ += e * ne, C += e * se, k += e * de, B += e * ue, j += e * Re, J += e * be, N += e * me, e = r[11], R += e * te, $ += e * W, x += e * ae, E += e * fe, T += e * ee, P += e * Se, O += e * pe, w += e * Q, _ += e * oe, C += e * ne, k += e * se, B += e * de, j += e * ue, J += e * Re, N += e * be, F += e * me, e = r[12], $ += e * te, x += e * W, E += e * ae, T += e * fe, P += e * ee, O += e * Se, w += e * pe, _ += e * Q, C += e * oe, k += e * ne, B += e * se, j += e * de, J += e * ue, N += e * Re, F += e * be, U += e * me, e = r[13], x += e * te, E += e * W, T += e * ae, P += e * fe, O += e * ee, w += e * Se, _ += e * pe, C += e * Q, k += e * oe, B += e * ne, j += e * se, J += e * de, N += e * ue, F += e * Re, U += e * be, K += e * me, e = r[14], E += e * te, T += e * W, P += e * ae, O += e * fe, w += e * ee, _ += e * Se, C += e * pe, k += e * Q, B += e * oe, j += e * ne, J += e * se, N += e * de, F += e * ue, U += e * Re, K += e * be, ve += e * me, e = r[15], T += e * te, P += e * W, O += e * ae, w += e * fe, _ += e * ee, C += e * Se, k += e * pe, B += e * Q, j += e * oe, J += e * ne, N += e * se, F += e * de, U += e * ue, K += e * Re, ve += e * be, he += e * me, o += 38 * P, c += 38 * O, l += 38 * w, d += 38 * _, p += 38 * C, h += 38 * k, g += 38 * B, y += 38 * j, v += 38 * J, m += 38 * N, b += 38 * F, R += 38 * U, $ += 38 * K, x += 38 * ve, E += 38 * he, n = 1, e = o + n + 65535, n = Math.floor(e / 65536), o = e - n * 65536, e = c + n + 65535, n = Math.floor(e / 65536), c = e - n * 65536, e = l + n + 65535, n = Math.floor(e / 65536), l = e - n * 65536, e = d + n + 65535, n = Math.floor(e / 65536), d = e - n * 65536, e = p + n + 65535, n = Math.floor(e / 65536), p = e - n * 65536, e = h + n + 65535, n = Math.floor(e / 65536), h = e - n * 65536, e = g + n + 65535, n = Math.floor(e / 65536), g = e - n * 65536, e = y + n + 65535, n = Math.floor(e / 65536), y = e - n * 65536, e = v + n + 65535, n = Math.floor(e / 65536), v = e - n * 65536, e = m + n + 65535, n = Math.floor(e / 65536), m = e - n * 65536, e = b + n + 65535, n = Math.floor(e / 65536), b = e - n * 65536, e = R + n + 65535, n = Math.floor(e / 65536), R = e - n * 65536, e = $ + n + 65535, n = Math.floor(e / 65536), $ = e - n * 65536, e = x + n + 65535, n = Math.floor(e / 65536), x = e - n * 65536, e = E + n + 65535, n = Math.floor(e / 65536), E = e - n * 65536, e = T + n + 65535, n = Math.floor(e / 65536), T = e - n * 65536, o += n - 1 + 37 * (n - 1), n = 1, e = o + n + 65535, n = Math.floor(e / 65536), o = e - n * 65536, e = c + n + 65535, n = Math.floor(e / 65536), c = e - n * 65536, e = l + n + 65535, n = Math.floor(e / 65536), l = e - n * 65536, e = d + n + 65535, n = Math.floor(e / 65536), d = e - n * 65536, e = p + n + 65535, n = Math.floor(e / 65536), p = e - n * 65536, e = h + n + 65535, n = Math.floor(e / 65536), h = e - n * 65536, e = g + n + 65535, n = Math.floor(e / 65536), g = e - n * 65536, e = y + n + 65535, n = Math.floor(e / 65536), y = e - n * 65536, e = v + n + 65535, n = Math.floor(e / 65536), v = e - n * 65536, e = m + n + 65535, n = Math.floor(e / 65536), m = e - n * 65536, e = b + n + 65535, n = Math.floor(e / 65536), b = e - n * 65536, e = R + n + 65535, n = Math.floor(e / 65536), R = e - n * 65536, e = $ + n + 65535, n = Math.floor(e / 65536), $ = e - n * 65536, e = x + n + 65535, n = Math.floor(e / 65536), x = e - n * 65536, e = E + n + 65535, n = Math.floor(e / 65536), E = e - n * 65536, e = T + n + 65535, n = Math.floor(e / 65536), T = e - n * 65536, o += n - 1 + 37 * (n - 1), u[0] = o, u[1] = c, u[2] = l, u[3] = d, u[4] = p, u[5] = h, u[6] = g, u[7] = y, u[8] = v, u[9] = m, u[10] = b, u[11] = R, u[12] = $, u[13] = x, u[14] = E, u[15] = T;
}
var forge$3 = forge$C;
forge$3.kem = forge$3.kem || {};
var BigInteger = forge$3.jsbn.BigInteger;
forge$3.kem.rsa = {};
forge$3.kem.rsa.create = function(u, r) {
  r = r || {};
  var a = r.prng || forge$3.random, e = {};
  return e.encrypt = function(n, o) {
    var c = Math.ceil(n.n.bitLength() / 8), l;
    do
      l = new BigInteger(
        forge$3.util.bytesToHex(a.getBytesSync(c)),
        16
      ).mod(n.n);
    while (l.compareTo(BigInteger.ONE) <= 0);
    l = forge$3.util.hexToBytes(l.toString(16));
    var d = c - l.length;
    d > 0 && (l = forge$3.util.fillString("\0", d) + l);
    var p = n.encrypt(l, "NONE"), h = u.generate(l, o);
    return { encapsulation: p, key: h };
  }, e.decrypt = function(n, o, c) {
    var l = n.decrypt(o, "NONE");
    return u.generate(l, c);
  }, e;
};
forge$3.kem.kdf1 = function(u, r) {
  _createKDF(this, u, 0, r || u.digestLength);
};
forge$3.kem.kdf2 = function(u, r) {
  _createKDF(this, u, 1, r || u.digestLength);
};
function _createKDF(u, r, a, e) {
  u.generate = function(n, o) {
    for (var c = new forge$3.util.ByteBuffer(), l = Math.ceil(o / e) + a, d = new forge$3.util.ByteBuffer(), p = a; p < l; ++p) {
      d.putInt32(p), r.start(), r.update(n + d.getBytes());
      var h = r.digest();
      c.putBytes(h.getBytes(e));
    }
    return c.truncate(c.length() - o), c.getBytes();
  };
}
var forge$2 = forge$C;
forge$2.log = forge$2.log || {};
forge$2.log.levels = [
  "none",
  "error",
  "warning",
  "info",
  "debug",
  "verbose",
  "max"
];
var sLevelInfo = {}, sLoggers = [], sConsoleLogger = null;
forge$2.log.LEVEL_LOCKED = 2;
forge$2.log.NO_LEVEL_CHECK = 4;
forge$2.log.INTERPOLATE = 8;
for (var i = 0; i < forge$2.log.levels.length; ++i) {
  var level = forge$2.log.levels[i];
  sLevelInfo[level] = {
    index: i,
    name: level.toUpperCase()
  };
}
forge$2.log.logMessage = function(u) {
  for (var r = sLevelInfo[u.level].index, a = 0; a < sLoggers.length; ++a) {
    var e = sLoggers[a];
    if (e.flags & forge$2.log.NO_LEVEL_CHECK)
      e.f(u);
    else {
      var n = sLevelInfo[e.level].index;
      r <= n && e.f(e, u);
    }
  }
};
forge$2.log.prepareStandard = function(u) {
  "standard" in u || (u.standard = sLevelInfo[u.level].name + //' ' + +message.timestamp +
  " [" + u.category + "] " + u.message);
};
forge$2.log.prepareFull = function(u) {
  if (!("full" in u)) {
    var r = [u.message];
    r = r.concat([]), u.full = forge$2.util.format.apply(this, r);
  }
};
forge$2.log.prepareStandardFull = function(u) {
  "standardFull" in u || (forge$2.log.prepareStandard(u), u.standardFull = u.standard);
};
for (var levels = ["error", "warning", "info", "debug", "verbose"], i = 0; i < levels.length; ++i)
  (function(r) {
    forge$2.log[r] = function(a, e) {
      var n = Array.prototype.slice.call(arguments).slice(2), o = {
        timestamp: /* @__PURE__ */ new Date(),
        level: r,
        category: a,
        message: e,
        arguments: n
        /*standard*/
        /*full*/
        /*fullMessage*/
      };
      forge$2.log.logMessage(o);
    };
  })(levels[i]);
forge$2.log.makeLogger = function(u) {
  var r = {
    flags: 0,
    f: u
  };
  return forge$2.log.setLevel(r, "none"), r;
};
forge$2.log.setLevel = function(u, r) {
  var a = !1;
  if (u && !(u.flags & forge$2.log.LEVEL_LOCKED))
    for (var e = 0; e < forge$2.log.levels.length; ++e) {
      var n = forge$2.log.levels[e];
      if (r == n) {
        u.level = r, a = !0;
        break;
      }
    }
  return a;
};
forge$2.log.lock = function(u, r) {
  typeof r > "u" || r ? u.flags |= forge$2.log.LEVEL_LOCKED : u.flags &= ~forge$2.log.LEVEL_LOCKED;
};
forge$2.log.addLogger = function(u) {
  sLoggers.push(u);
};
if (typeof console < "u" && "log" in console) {
  var logger;
  if (console.error && console.warn && console.info && console.debug) {
    var levelHandlers = {
      error: console.error,
      warning: console.warn,
      info: console.info,
      debug: console.debug,
      verbose: console.debug
    }, f = function(u, r) {
      forge$2.log.prepareStandard(r);
      var a = levelHandlers[r.level], e = [r.standard];
      e = e.concat(r.arguments.slice()), a.apply(console, e);
    };
    logger = forge$2.log.makeLogger(f);
  } else {
    var f = function(r, a) {
      forge$2.log.prepareStandardFull(a), console.log(a.standardFull);
    };
    logger = forge$2.log.makeLogger(f);
  }
  forge$2.log.setLevel(logger, "debug"), forge$2.log.addLogger(logger), sConsoleLogger = logger;
} else
  console = {
    log: function() {
    }
  };
if (sConsoleLogger !== null && typeof window < "u" && window.location) {
  var query = new URL(window.location.href).searchParams;
  if (query.has("console.level") && forge$2.log.setLevel(
    sConsoleLogger,
    query.get("console.level").slice(-1)[0]
  ), query.has("console.lock")) {
    var lock = query.get("console.lock").slice(-1)[0];
    lock == "true" && forge$2.log.lock(sConsoleLogger);
  }
}
forge$2.log.consoleLogger = sConsoleLogger;
var forge$1 = forge$C, asn1 = forge$1.asn1, p7 = forge$1.pkcs7 = forge$1.pkcs7 || {};
p7.messageFromPem = function(u) {
  var r = forge$1.pem.decode(u)[0];
  if (r.type !== "PKCS7") {
    var a = new Error('Could not convert PKCS#7 message from PEM; PEM header type is not "PKCS#7".');
    throw a.headerType = r.type, a;
  }
  if (r.procType && r.procType.type === "ENCRYPTED")
    throw new Error("Could not convert PKCS#7 message from PEM; PEM is encrypted.");
  var e = asn1.fromDer(r.body);
  return p7.messageFromAsn1(e);
};
p7.messageToPem = function(u, r) {
  var a = {
    type: "PKCS7",
    body: asn1.toDer(u.toAsn1()).getBytes()
  };
  return forge$1.pem.encode(a, { maxline: r });
};
p7.messageFromAsn1 = function(u) {
  var r = {}, a = [];
  if (!asn1.validate(u, p7.asn1.contentInfoValidator, r, a)) {
    var e = new Error("Cannot read PKCS#7 message. ASN.1 object is not an PKCS#7 ContentInfo.");
    throw e.errors = a, e;
  }
  var n = asn1.derToOid(r.contentType), o;
  switch (n) {
    case forge$1.pki.oids.envelopedData:
      o = p7.createEnvelopedData();
      break;
    case forge$1.pki.oids.encryptedData:
      o = p7.createEncryptedData();
      break;
    case forge$1.pki.oids.signedData:
      o = p7.createSignedData();
      break;
    default:
      throw new Error("Cannot read PKCS#7 message. ContentType with OID " + n + " is not (yet) supported.");
  }
  return o.fromAsn1(r.content.value[0]), o;
};
p7.createSignedData = function() {
  var u = null;
  return u = {
    type: forge$1.pki.oids.signedData,
    version: 1,
    certificates: [],
    crls: [],
    // TODO: add json-formatted signer stuff here?
    signers: [],
    // populated during sign()
    digestAlgorithmIdentifiers: [],
    contentInfo: null,
    signerInfos: [],
    fromAsn1: function(e) {
      if (_fromAsn1(u, e, p7.asn1.signedDataValidator), u.certificates = [], u.crls = [], u.digestAlgorithmIdentifiers = [], u.contentInfo = null, u.signerInfos = [], u.rawCapture.certificates)
        for (var n = u.rawCapture.certificates.value, o = 0; o < n.length; ++o)
          u.certificates.push(forge$1.pki.certificateFromAsn1(n[o]));
    },
    toAsn1: function() {
      u.contentInfo || u.sign();
      for (var e = [], n = 0; n < u.certificates.length; ++n)
        e.push(forge$1.pki.certificateToAsn1(u.certificates[n]));
      var o = [], c = asn1.create(asn1.Class.CONTEXT_SPECIFIC, 0, !0, [
        asn1.create(asn1.Class.UNIVERSAL, asn1.Type.SEQUENCE, !0, [
          // Version
          asn1.create(
            asn1.Class.UNIVERSAL,
            asn1.Type.INTEGER,
            !1,
            asn1.integerToDer(u.version).getBytes()
          ),
          // DigestAlgorithmIdentifiers
          asn1.create(
            asn1.Class.UNIVERSAL,
            asn1.Type.SET,
            !0,
            u.digestAlgorithmIdentifiers
          ),
          // ContentInfo
          u.contentInfo
        ])
      ]);
      return e.length > 0 && c.value[0].value.push(
        asn1.create(asn1.Class.CONTEXT_SPECIFIC, 0, !0, e)
      ), o.length > 0 && c.value[0].value.push(
        asn1.create(asn1.Class.CONTEXT_SPECIFIC, 1, !0, o)
      ), c.value[0].value.push(
        asn1.create(
          asn1.Class.UNIVERSAL,
          asn1.Type.SET,
          !0,
          u.signerInfos
        )
      ), asn1.create(
        asn1.Class.UNIVERSAL,
        asn1.Type.SEQUENCE,
        !0,
        [
          // ContentType
          asn1.create(
            asn1.Class.UNIVERSAL,
            asn1.Type.OID,
            !1,
            asn1.oidToDer(u.type).getBytes()
          ),
          // [0] SignedData
          c
        ]
      );
    },
    /**
     * Add (another) entity to list of signers.
     *
     * Note: If authenticatedAttributes are provided, then, per RFC 2315,
     * they must include at least two attributes: content type and
     * message digest. The message digest attribute value will be
     * auto-calculated during signing and will be ignored if provided.
     *
     * Here's an example of providing these two attributes:
     *
     * forge.pkcs7.createSignedData();
     * p7.addSigner({
     *   issuer: cert.issuer.attributes,
     *   serialNumber: cert.serialNumber,
     *   key: privateKey,
     *   digestAlgorithm: forge.pki.oids.sha1,
     *   authenticatedAttributes: [{
     *     type: forge.pki.oids.contentType,
     *     value: forge.pki.oids.data
     *   }, {
     *     type: forge.pki.oids.messageDigest
     *   }]
     * });
     *
     * TODO: Support [subjectKeyIdentifier] as signer's ID.
     *
     * @param signer the signer information:
     *          key the signer's private key.
     *          [certificate] a certificate containing the public key
     *            associated with the signer's private key; use this option as
     *            an alternative to specifying signer.issuer and
     *            signer.serialNumber.
     *          [issuer] the issuer attributes (eg: cert.issuer.attributes).
     *          [serialNumber] the signer's certificate's serial number in
     *           hexadecimal (eg: cert.serialNumber).
     *          [digestAlgorithm] the message digest OID, as a string, to use
     *            (eg: forge.pki.oids.sha1).
     *          [authenticatedAttributes] an optional array of attributes
     *            to also sign along with the content.
     */
    addSigner: function(e) {
      var n = e.issuer, o = e.serialNumber;
      if (e.certificate) {
        var c = e.certificate;
        typeof c == "string" && (c = forge$1.pki.certificateFromPem(c)), n = c.issuer.attributes, o = c.serialNumber;
      }
      var l = e.key;
      if (!l)
        throw new Error(
          "Could not add PKCS#7 signer; no private key specified."
        );
      typeof l == "string" && (l = forge$1.pki.privateKeyFromPem(l));
      var d = e.digestAlgorithm || forge$1.pki.oids.sha1;
      switch (d) {
        case forge$1.pki.oids.sha1:
        case forge$1.pki.oids.sha256:
        case forge$1.pki.oids.sha384:
        case forge$1.pki.oids.sha512:
        case forge$1.pki.oids.md5:
          break;
        default:
          throw new Error(
            "Could not add PKCS#7 signer; unknown message digest algorithm: " + d
          );
      }
      var p = e.authenticatedAttributes || [];
      if (p.length > 0) {
        for (var h = !1, g = !1, y = 0; y < p.length; ++y) {
          var v = p[y];
          if (!h && v.type === forge$1.pki.oids.contentType) {
            if (h = !0, g)
              break;
            continue;
          }
          if (!g && v.type === forge$1.pki.oids.messageDigest) {
            if (g = !0, h)
              break;
            continue;
          }
        }
        if (!h || !g)
          throw new Error("Invalid signer.authenticatedAttributes. If signer.authenticatedAttributes is specified, then it must contain at least two attributes, PKCS #9 content-type and PKCS #9 message-digest.");
      }
      u.signers.push({
        key: l,
        version: 1,
        issuer: n,
        serialNumber: o,
        digestAlgorithm: d,
        signatureAlgorithm: forge$1.pki.oids.rsaEncryption,
        signature: null,
        authenticatedAttributes: p,
        unauthenticatedAttributes: []
      });
    },
    /**
     * Signs the content.
     * @param options Options to apply when signing:
     *    [detached] boolean. If signing should be done in detached mode. Defaults to false.
     */
    sign: function(e) {
      if (e = e || {}, (typeof u.content != "object" || u.contentInfo === null) && (u.contentInfo = asn1.create(
        asn1.Class.UNIVERSAL,
        asn1.Type.SEQUENCE,
        !0,
        [
          // ContentType
          asn1.create(
            asn1.Class.UNIVERSAL,
            asn1.Type.OID,
            !1,
            asn1.oidToDer(forge$1.pki.oids.data).getBytes()
          )
        ]
      ), "content" in u)) {
        var n;
        u.content instanceof forge$1.util.ByteBuffer ? n = u.content.bytes() : typeof u.content == "string" && (n = forge$1.util.encodeUtf8(u.content)), e.detached ? u.detachedContent = asn1.create(asn1.Class.UNIVERSAL, asn1.Type.OCTETSTRING, !1, n) : u.contentInfo.value.push(
          // [0] EXPLICIT content
          asn1.create(asn1.Class.CONTEXT_SPECIFIC, 0, !0, [
            asn1.create(
              asn1.Class.UNIVERSAL,
              asn1.Type.OCTETSTRING,
              !1,
              n
            )
          ])
        );
      }
      if (u.signers.length !== 0) {
        var o = r();
        a(o);
      }
    },
    verify: function() {
      throw new Error("PKCS#7 signature verification not yet implemented.");
    },
    /**
     * Add a certificate.
     *
     * @param cert the certificate to add.
     */
    addCertificate: function(e) {
      typeof e == "string" && (e = forge$1.pki.certificateFromPem(e)), u.certificates.push(e);
    },
    /**
     * Add a certificate revokation list.
     *
     * @param crl the certificate revokation list to add.
     */
    addCertificateRevokationList: function(e) {
      throw new Error("PKCS#7 CRL support not yet implemented.");
    }
  }, u;
  function r() {
    for (var e = {}, n = 0; n < u.signers.length; ++n) {
      var o = u.signers[n], c = o.digestAlgorithm;
      c in e || (e[c] = forge$1.md[forge$1.pki.oids[c]].create()), o.authenticatedAttributes.length === 0 ? o.md = e[c] : o.md = forge$1.md[forge$1.pki.oids[c]].create();
    }
    u.digestAlgorithmIdentifiers = [];
    for (var c in e)
      u.digestAlgorithmIdentifiers.push(
        // AlgorithmIdentifier
        asn1.create(asn1.Class.UNIVERSAL, asn1.Type.SEQUENCE, !0, [
          // algorithm
          asn1.create(
            asn1.Class.UNIVERSAL,
            asn1.Type.OID,
            !1,
            asn1.oidToDer(c).getBytes()
          ),
          // parameters (null)
          asn1.create(asn1.Class.UNIVERSAL, asn1.Type.NULL, !1, "")
        ])
      );
    return e;
  }
  function a(e) {
    var n;
    if (u.detachedContent ? n = u.detachedContent : (n = u.contentInfo.value[1], n = n.value[0]), !n)
      throw new Error(
        "Could not sign PKCS#7 message; there is no content to sign."
      );
    var o = asn1.derToOid(u.contentInfo.value[0].value), c = asn1.toDer(n);
    c.getByte(), asn1.getBerValueLength(c), c = c.getBytes();
    for (var l in e)
      e[l].start().update(c);
    for (var d = /* @__PURE__ */ new Date(), p = 0; p < u.signers.length; ++p) {
      var h = u.signers[p];
      if (h.authenticatedAttributes.length === 0) {
        if (o !== forge$1.pki.oids.data)
          throw new Error(
            "Invalid signer; authenticatedAttributes must be present when the ContentInfo content type is not PKCS#7 Data."
          );
      } else {
        h.authenticatedAttributesAsn1 = asn1.create(
          asn1.Class.CONTEXT_SPECIFIC,
          0,
          !0,
          []
        );
        for (var g = asn1.create(
          asn1.Class.UNIVERSAL,
          asn1.Type.SET,
          !0,
          []
        ), y = 0; y < h.authenticatedAttributes.length; ++y) {
          var v = h.authenticatedAttributes[y];
          v.type === forge$1.pki.oids.messageDigest ? v.value = e[h.digestAlgorithm].digest() : v.type === forge$1.pki.oids.signingTime && (v.value || (v.value = d)), g.value.push(_attributeToAsn1(v)), h.authenticatedAttributesAsn1.value.push(_attributeToAsn1(v));
        }
        c = asn1.toDer(g).getBytes(), h.md.start().update(c);
      }
      h.signature = h.key.sign(h.md, "RSASSA-PKCS1-V1_5");
    }
    u.signerInfos = _signersToAsn1(u.signers);
  }
};
p7.createEncryptedData = function() {
  var u = null;
  return u = {
    type: forge$1.pki.oids.encryptedData,
    version: 0,
    encryptedContent: {
      algorithm: forge$1.pki.oids["aes256-CBC"]
    },
    /**
     * Reads an EncryptedData content block (in ASN.1 format)
     *
     * @param obj The ASN.1 representation of the EncryptedData content block
     */
    fromAsn1: function(r) {
      _fromAsn1(u, r, p7.asn1.encryptedDataValidator);
    },
    /**
     * Decrypt encrypted content
     *
     * @param key The (symmetric) key as a byte buffer
     */
    decrypt: function(r) {
      r !== void 0 && (u.encryptedContent.key = r), _decryptContent(u);
    }
  }, u;
};
p7.createEnvelopedData = function() {
  var u = null;
  return u = {
    type: forge$1.pki.oids.envelopedData,
    version: 0,
    recipients: [],
    encryptedContent: {
      algorithm: forge$1.pki.oids["aes256-CBC"]
    },
    /**
     * Reads an EnvelopedData content block (in ASN.1 format)
     *
     * @param obj the ASN.1 representation of the EnvelopedData content block.
     */
    fromAsn1: function(r) {
      var a = _fromAsn1(u, r, p7.asn1.envelopedDataValidator);
      u.recipients = _recipientsFromAsn1(a.recipientInfos.value);
    },
    toAsn1: function() {
      return asn1.create(asn1.Class.UNIVERSAL, asn1.Type.SEQUENCE, !0, [
        // ContentType
        asn1.create(
          asn1.Class.UNIVERSAL,
          asn1.Type.OID,
          !1,
          asn1.oidToDer(u.type).getBytes()
        ),
        // [0] EnvelopedData
        asn1.create(asn1.Class.CONTEXT_SPECIFIC, 0, !0, [
          asn1.create(asn1.Class.UNIVERSAL, asn1.Type.SEQUENCE, !0, [
            // Version
            asn1.create(
              asn1.Class.UNIVERSAL,
              asn1.Type.INTEGER,
              !1,
              asn1.integerToDer(u.version).getBytes()
            ),
            // RecipientInfos
            asn1.create(
              asn1.Class.UNIVERSAL,
              asn1.Type.SET,
              !0,
              _recipientsToAsn1(u.recipients)
            ),
            // EncryptedContentInfo
            asn1.create(
              asn1.Class.UNIVERSAL,
              asn1.Type.SEQUENCE,
              !0,
              _encryptedContentToAsn1(u.encryptedContent)
            )
          ])
        ])
      ]);
    },
    /**
     * Find recipient by X.509 certificate's issuer.
     *
     * @param cert the certificate with the issuer to look for.
     *
     * @return the recipient object.
     */
    findRecipient: function(r) {
      for (var a = r.issuer.attributes, e = 0; e < u.recipients.length; ++e) {
        var n = u.recipients[e], o = n.issuer;
        if (n.serialNumber === r.serialNumber && o.length === a.length) {
          for (var c = !0, l = 0; l < a.length; ++l)
            if (o[l].type !== a[l].type || o[l].value !== a[l].value) {
              c = !1;
              break;
            }
          if (c)
            return n;
        }
      }
      return null;
    },
    /**
     * Decrypt enveloped content
     *
     * @param recipient The recipient object related to the private key
     * @param privKey The (RSA) private key object
     */
    decrypt: function(r, a) {
      if (u.encryptedContent.key === void 0 && r !== void 0 && a !== void 0)
        switch (r.encryptedContent.algorithm) {
          case forge$1.pki.oids.rsaEncryption:
          case forge$1.pki.oids.desCBC:
            var e = a.decrypt(r.encryptedContent.content);
            u.encryptedContent.key = forge$1.util.createBuffer(e);
            break;
          default:
            throw new Error("Unsupported asymmetric cipher, OID " + r.encryptedContent.algorithm);
        }
      _decryptContent(u);
    },
    /**
     * Add (another) entity to list of recipients.
     *
     * @param cert The certificate of the entity to add.
     */
    addRecipient: function(r) {
      u.recipients.push({
        version: 0,
        issuer: r.issuer.attributes,
        serialNumber: r.serialNumber,
        encryptedContent: {
          // We simply assume rsaEncryption here, since forge.pki only
          // supports RSA so far.  If the PKI module supports other
          // ciphers one day, we need to modify this one as well.
          algorithm: forge$1.pki.oids.rsaEncryption,
          key: r.publicKey
        }
      });
    },
    /**
     * Encrypt enveloped content.
     *
     * This function supports two optional arguments, cipher and key, which
     * can be used to influence symmetric encryption.  Unless cipher is
     * provided, the cipher specified in encryptedContent.algorithm is used
     * (defaults to AES-256-CBC).  If no key is provided, encryptedContent.key
     * is (re-)used.  If that one's not set, a random key will be generated
     * automatically.
     *
     * @param [key] The key to be used for symmetric encryption.
     * @param [cipher] The OID of the symmetric cipher to use.
     */
    encrypt: function(r, a) {
      if (u.encryptedContent.content === void 0) {
        a = a || u.encryptedContent.algorithm, r = r || u.encryptedContent.key;
        var e, n, o;
        switch (a) {
          case forge$1.pki.oids["aes128-CBC"]:
            e = 16, n = 16, o = forge$1.aes.createEncryptionCipher;
            break;
          case forge$1.pki.oids["aes192-CBC"]:
            e = 24, n = 16, o = forge$1.aes.createEncryptionCipher;
            break;
          case forge$1.pki.oids["aes256-CBC"]:
            e = 32, n = 16, o = forge$1.aes.createEncryptionCipher;
            break;
          case forge$1.pki.oids["des-EDE3-CBC"]:
            e = 24, n = 8, o = forge$1.des.createEncryptionCipher;
            break;
          default:
            throw new Error("Unsupported symmetric cipher, OID " + a);
        }
        if (r === void 0)
          r = forge$1.util.createBuffer(forge$1.random.getBytes(e));
        else if (r.length() != e)
          throw new Error("Symmetric key has wrong length; got " + r.length() + " bytes, expected " + e + ".");
        u.encryptedContent.algorithm = a, u.encryptedContent.key = r, u.encryptedContent.parameter = forge$1.util.createBuffer(
          forge$1.random.getBytes(n)
        );
        var c = o(r);
        if (c.start(u.encryptedContent.parameter.copy()), c.update(u.content), !c.finish())
          throw new Error("Symmetric encryption failed.");
        u.encryptedContent.content = c.output;
      }
      for (var l = 0; l < u.recipients.length; ++l) {
        var d = u.recipients[l];
        if (d.encryptedContent.content === void 0)
          switch (d.encryptedContent.algorithm) {
            case forge$1.pki.oids.rsaEncryption:
              d.encryptedContent.content = d.encryptedContent.key.encrypt(
                u.encryptedContent.key.data
              );
              break;
            default:
              throw new Error("Unsupported asymmetric cipher, OID " + d.encryptedContent.algorithm);
          }
      }
    }
  }, u;
};
function _recipientFromAsn1(u) {
  var r = {}, a = [];
  if (!asn1.validate(u, p7.asn1.recipientInfoValidator, r, a)) {
    var e = new Error("Cannot read PKCS#7 RecipientInfo. ASN.1 object is not an PKCS#7 RecipientInfo.");
    throw e.errors = a, e;
  }
  return {
    version: r.version.charCodeAt(0),
    issuer: forge$1.pki.RDNAttributesAsArray(r.issuer),
    serialNumber: forge$1.util.createBuffer(r.serial).toHex(),
    encryptedContent: {
      algorithm: asn1.derToOid(r.encAlgorithm),
      parameter: r.encParameter ? r.encParameter.value : void 0,
      content: r.encKey
    }
  };
}
function _recipientToAsn1(u) {
  return asn1.create(asn1.Class.UNIVERSAL, asn1.Type.SEQUENCE, !0, [
    // Version
    asn1.create(
      asn1.Class.UNIVERSAL,
      asn1.Type.INTEGER,
      !1,
      asn1.integerToDer(u.version).getBytes()
    ),
    // IssuerAndSerialNumber
    asn1.create(asn1.Class.UNIVERSAL, asn1.Type.SEQUENCE, !0, [
      // Name
      forge$1.pki.distinguishedNameToAsn1({ attributes: u.issuer }),
      // Serial
      asn1.create(
        asn1.Class.UNIVERSAL,
        asn1.Type.INTEGER,
        !1,
        forge$1.util.hexToBytes(u.serialNumber)
      )
    ]),
    // KeyEncryptionAlgorithmIdentifier
    asn1.create(asn1.Class.UNIVERSAL, asn1.Type.SEQUENCE, !0, [
      // Algorithm
      asn1.create(
        asn1.Class.UNIVERSAL,
        asn1.Type.OID,
        !1,
        asn1.oidToDer(u.encryptedContent.algorithm).getBytes()
      ),
      // Parameter, force NULL, only RSA supported for now.
      asn1.create(asn1.Class.UNIVERSAL, asn1.Type.NULL, !1, "")
    ]),
    // EncryptedKey
    asn1.create(
      asn1.Class.UNIVERSAL,
      asn1.Type.OCTETSTRING,
      !1,
      u.encryptedContent.content
    )
  ]);
}
function _recipientsFromAsn1(u) {
  for (var r = [], a = 0; a < u.length; ++a)
    r.push(_recipientFromAsn1(u[a]));
  return r;
}
function _recipientsToAsn1(u) {
  for (var r = [], a = 0; a < u.length; ++a)
    r.push(_recipientToAsn1(u[a]));
  return r;
}
function _signerToAsn1(u) {
  var r = asn1.create(asn1.Class.UNIVERSAL, asn1.Type.SEQUENCE, !0, [
    // version
    asn1.create(
      asn1.Class.UNIVERSAL,
      asn1.Type.INTEGER,
      !1,
      asn1.integerToDer(u.version).getBytes()
    ),
    // issuerAndSerialNumber
    asn1.create(asn1.Class.UNIVERSAL, asn1.Type.SEQUENCE, !0, [
      // name
      forge$1.pki.distinguishedNameToAsn1({ attributes: u.issuer }),
      // serial
      asn1.create(
        asn1.Class.UNIVERSAL,
        asn1.Type.INTEGER,
        !1,
        forge$1.util.hexToBytes(u.serialNumber)
      )
    ]),
    // digestAlgorithm
    asn1.create(asn1.Class.UNIVERSAL, asn1.Type.SEQUENCE, !0, [
      // algorithm
      asn1.create(
        asn1.Class.UNIVERSAL,
        asn1.Type.OID,
        !1,
        asn1.oidToDer(u.digestAlgorithm).getBytes()
      ),
      // parameters (null)
      asn1.create(asn1.Class.UNIVERSAL, asn1.Type.NULL, !1, "")
    ])
  ]);
  if (u.authenticatedAttributesAsn1 && r.value.push(u.authenticatedAttributesAsn1), r.value.push(asn1.create(asn1.Class.UNIVERSAL, asn1.Type.SEQUENCE, !0, [
    // algorithm
    asn1.create(
      asn1.Class.UNIVERSAL,
      asn1.Type.OID,
      !1,
      asn1.oidToDer(u.signatureAlgorithm).getBytes()
    ),
    // parameters (null)
    asn1.create(asn1.Class.UNIVERSAL, asn1.Type.NULL, !1, "")
  ])), r.value.push(asn1.create(
    asn1.Class.UNIVERSAL,
    asn1.Type.OCTETSTRING,
    !1,
    u.signature
  )), u.unauthenticatedAttributes.length > 0) {
    for (var a = asn1.create(asn1.Class.CONTEXT_SPECIFIC, 1, !0, []), e = 0; e < u.unauthenticatedAttributes.length; ++e) {
      var n = u.unauthenticatedAttributes[e];
      a.values.push(_attributeToAsn1(n));
    }
    r.value.push(a);
  }
  return r;
}
function _signersToAsn1(u) {
  for (var r = [], a = 0; a < u.length; ++a)
    r.push(_signerToAsn1(u[a]));
  return r;
}
function _attributeToAsn1(u) {
  var r;
  if (u.type === forge$1.pki.oids.contentType)
    r = asn1.create(
      asn1.Class.UNIVERSAL,
      asn1.Type.OID,
      !1,
      asn1.oidToDer(u.value).getBytes()
    );
  else if (u.type === forge$1.pki.oids.messageDigest)
    r = asn1.create(
      asn1.Class.UNIVERSAL,
      asn1.Type.OCTETSTRING,
      !1,
      u.value.bytes()
    );
  else if (u.type === forge$1.pki.oids.signingTime) {
    var a = /* @__PURE__ */ new Date("1950-01-01T00:00:00Z"), e = /* @__PURE__ */ new Date("2050-01-01T00:00:00Z"), n = u.value;
    if (typeof n == "string") {
      var o = Date.parse(n);
      isNaN(o) ? n.length === 13 ? n = asn1.utcTimeToDate(n) : n = asn1.generalizedTimeToDate(n) : n = new Date(o);
    }
    n >= a && n < e ? r = asn1.create(
      asn1.Class.UNIVERSAL,
      asn1.Type.UTCTIME,
      !1,
      asn1.dateToUtcTime(n)
    ) : r = asn1.create(
      asn1.Class.UNIVERSAL,
      asn1.Type.GENERALIZEDTIME,
      !1,
      asn1.dateToGeneralizedTime(n)
    );
  }
  return asn1.create(asn1.Class.UNIVERSAL, asn1.Type.SEQUENCE, !0, [
    // AttributeType
    asn1.create(
      asn1.Class.UNIVERSAL,
      asn1.Type.OID,
      !1,
      asn1.oidToDer(u.type).getBytes()
    ),
    asn1.create(asn1.Class.UNIVERSAL, asn1.Type.SET, !0, [
      // AttributeValue
      r
    ])
  ]);
}
function _encryptedContentToAsn1(u) {
  return [
    // ContentType, always Data for the moment
    asn1.create(
      asn1.Class.UNIVERSAL,
      asn1.Type.OID,
      !1,
      asn1.oidToDer(forge$1.pki.oids.data).getBytes()
    ),
    // ContentEncryptionAlgorithmIdentifier
    asn1.create(asn1.Class.UNIVERSAL, asn1.Type.SEQUENCE, !0, [
      // Algorithm
      asn1.create(
        asn1.Class.UNIVERSAL,
        asn1.Type.OID,
        !1,
        asn1.oidToDer(u.algorithm).getBytes()
      ),
      // Parameters (IV)
      u.parameter ? asn1.create(
        asn1.Class.UNIVERSAL,
        asn1.Type.OCTETSTRING,
        !1,
        u.parameter.getBytes()
      ) : void 0
    ]),
    // [0] EncryptedContent
    asn1.create(asn1.Class.CONTEXT_SPECIFIC, 0, !0, [
      asn1.create(
        asn1.Class.UNIVERSAL,
        asn1.Type.OCTETSTRING,
        !1,
        u.content.getBytes()
      )
    ])
  ];
}
function _fromAsn1(u, r, a) {
  var e = {}, n = [];
  if (!asn1.validate(r, a, e, n)) {
    var o = new Error("Cannot read PKCS#7 message. ASN.1 object is not a supported PKCS#7 message.");
    throw o.errors = o, o;
  }
  var c = asn1.derToOid(e.contentType);
  if (c !== forge$1.pki.oids.data)
    throw new Error("Unsupported PKCS#7 message. Only wrapped ContentType Data supported.");
  if (e.encryptedContent) {
    var l = "";
    if (forge$1.util.isArray(e.encryptedContent))
      for (var d = 0; d < e.encryptedContent.length; ++d) {
        if (e.encryptedContent[d].type !== asn1.Type.OCTETSTRING)
          throw new Error("Malformed PKCS#7 message, expecting encrypted content constructed of only OCTET STRING objects.");
        l += e.encryptedContent[d].value;
      }
    else
      l = e.encryptedContent;
    u.encryptedContent = {
      algorithm: asn1.derToOid(e.encAlgorithm),
      parameter: forge$1.util.createBuffer(e.encParameter.value),
      content: forge$1.util.createBuffer(l)
    };
  }
  if (e.content) {
    var l = "";
    if (forge$1.util.isArray(e.content))
      for (var d = 0; d < e.content.length; ++d) {
        if (e.content[d].type !== asn1.Type.OCTETSTRING)
          throw new Error("Malformed PKCS#7 message, expecting content constructed of only OCTET STRING objects.");
        l += e.content[d].value;
      }
    else
      l = e.content;
    u.content = forge$1.util.createBuffer(l);
  }
  return u.version = e.version.charCodeAt(0), u.rawCapture = e, e;
}
function _decryptContent(u) {
  if (u.encryptedContent.key === void 0)
    throw new Error("Symmetric key not available.");
  if (u.content === void 0) {
    var r;
    switch (u.encryptedContent.algorithm) {
      case forge$1.pki.oids["aes128-CBC"]:
      case forge$1.pki.oids["aes192-CBC"]:
      case forge$1.pki.oids["aes256-CBC"]:
        r = forge$1.aes.createDecryptionCipher(u.encryptedContent.key);
        break;
      case forge$1.pki.oids.desCBC:
      case forge$1.pki.oids["des-EDE3-CBC"]:
        r = forge$1.des.createDecryptionCipher(u.encryptedContent.key);
        break;
      default:
        throw new Error("Unsupported symmetric cipher, OID " + u.encryptedContent.algorithm);
    }
    if (r.start(u.encryptedContent.parameter), r.update(u.encryptedContent.content), !r.finish())
      throw new Error("Symmetric decryption failed.");
    u.content = r.output;
  }
}
var forge = forge$C, ssh = forge.ssh = forge.ssh || {};
ssh.privateKeyToPutty = function(u, r, a) {
  a = a || "", r = r || "";
  var e = "ssh-rsa", n = r === "" ? "none" : "aes256-cbc", o = "PuTTY-User-Key-File-2: " + e + `\r
`;
  o += "Encryption: " + n + `\r
`, o += "Comment: " + a + `\r
`;
  var c = forge.util.createBuffer();
  _addStringToBuffer(c, e), _addBigIntegerToBuffer(c, u.e), _addBigIntegerToBuffer(c, u.n);
  var l = forge.util.encode64(c.bytes(), 64), d = Math.floor(l.length / 66) + 1;
  o += "Public-Lines: " + d + `\r
`, o += l;
  var p = forge.util.createBuffer();
  _addBigIntegerToBuffer(p, u.d), _addBigIntegerToBuffer(p, u.p), _addBigIntegerToBuffer(p, u.q), _addBigIntegerToBuffer(p, u.qInv);
  var h;
  if (!r)
    h = forge.util.encode64(p.bytes(), 64);
  else {
    var g = p.length() + 16 - 1;
    g -= g % 16;
    var y = _sha1(p.bytes());
    y.truncate(y.length() - g + p.length()), p.putBuffer(y);
    var v = forge.util.createBuffer();
    v.putBuffer(_sha1("\0\0\0\0", r)), v.putBuffer(_sha1("\0\0\0", r));
    var m = forge.aes.createEncryptionCipher(v.truncate(8), "CBC");
    m.start(forge.util.createBuffer().fillWithByte(0, 16)), m.update(p.copy()), m.finish();
    var b = m.output;
    b.truncate(16), h = forge.util.encode64(b.bytes(), 64);
  }
  d = Math.floor(h.length / 66) + 1, o += `\r
Private-Lines: ` + d + `\r
`, o += h;
  var R = _sha1("putty-private-key-file-mac-key", r), $ = forge.util.createBuffer();
  _addStringToBuffer($, e), _addStringToBuffer($, n), _addStringToBuffer($, a), $.putInt32(c.length()), $.putBuffer(c), $.putInt32(p.length()), $.putBuffer(p);
  var x = forge.hmac.create();
  return x.start("sha1", R), x.update($.bytes()), o += `\r
Private-MAC: ` + x.digest().toHex() + `\r
`, o;
};
ssh.publicKeyToOpenSSH = function(u, r) {
  var a = "ssh-rsa";
  r = r || "";
  var e = forge.util.createBuffer();
  return _addStringToBuffer(e, a), _addBigIntegerToBuffer(e, u.e), _addBigIntegerToBuffer(e, u.n), a + " " + forge.util.encode64(e.bytes()) + " " + r;
};
ssh.privateKeyToOpenSSH = function(u, r) {
  return r ? forge.pki.encryptRsaPrivateKey(
    u,
    r,
    { legacy: !0, algorithm: "aes128" }
  ) : forge.pki.privateKeyToPem(u);
};
ssh.getPublicKeyFingerprint = function(u, r) {
  r = r || {};
  var a = r.md || forge.md.md5.create(), e = "ssh-rsa", n = forge.util.createBuffer();
  _addStringToBuffer(n, e), _addBigIntegerToBuffer(n, u.e), _addBigIntegerToBuffer(n, u.n), a.start(), a.update(n.getBytes());
  var o = a.digest();
  if (r.encoding === "hex") {
    var c = o.toHex();
    return r.delimiter ? c.match(/.{2}/g).join(r.delimiter) : c;
  } else {
    if (r.encoding === "binary")
      return o.getBytes();
    if (r.encoding)
      throw new Error('Unknown encoding "' + r.encoding + '".');
  }
  return o;
};
function _addBigIntegerToBuffer(u, r) {
  var a = r.toString(16);
  a[0] >= "8" && (a = "00" + a);
  var e = forge.util.hexToBytes(a);
  u.putInt32(e.length), u.putBytes(e);
}
function _addStringToBuffer(u, r) {
  u.putInt32(r.length), u.putString(r);
}
function _sha1() {
  for (var u = forge.md.sha1.create(), r = arguments.length, a = 0; a < r; ++a)
    u.update(arguments[a]);
  return u.digest();
}
var lib = forge$C;
const intelDcapRootCaPem = `-----BEGIN CERTIFICATE-----
MIICjzCCAjSgAwIBAgIUImUM1lqdNInzg7SVUr9QGzknBqwwCgYIKoZIzj0EAwIw
aDEaMBgGA1UEAwwRSW50ZWwgU0dYIFJvb3QgQ0ExGjAYBgNVBAoMEUludGVsIENv
cnBvcmF0aW9uMRQwEgYDVQQHDAtTYW50YSBDbGFyYTELMAkGA1UECAwCQ0ExCzAJ
BgNVBAYTAlVTMB4XDTE4MDUyMTEwNDUxMFoXDTQ5MTIzMTIzNTk1OVowaDEaMBgG
A1UEAwwRSW50ZWwgU0dYIFJvb3QgQ0ExGjAYBgNVBAoMEUludGVsIENvcnBvcmF0
aW9uMRQwEgYDVQQHDAtTYW50YSBDbGFyYTELMAkGA1UECAwCQ0ExCzAJBgNVBAYT
AlVTMFkwEwYHKoZIzj0CAQYIKoZIzj0DAQcDQgAEC6nEwMDIYZOj/iPWsCzaEKi7
1OiOSLRFhWGjbnBVJfVnkY4u3IjkDYYL0MxO4mqsyYjlBalTVYxFP2sJBK5zlKOB
uzCBuDAfBgNVHSMEGDAWgBQiZQzWWp00ifODtJVSv1AbOScGrDBSBgNVHR8ESzBJ
MEegRaBDhkFodHRwczovL2NlcnRpZmljYXRlcy50cnVzdGVkc2VydmljZXMuaW50
ZWwuY29tL0ludGVsU0dYUm9vdENBLmRlcjAdBgNVHQ4EFgQUImUM1lqdNInzg7SV
Ur9QGzknBqwwDgYDVR0PAQH/BAQDAgEGMBIGA1UdEwEB/wQIMAYBAf8CAQEwCgYI
KoZIzj0EAwIDSQAwRgIhAOW/5QkR+S9CiSDcNoowLuPRLsWGf/Yi7GSX94BgwTwg
AiEA4J0lrHoMs+Xo5o/sX6O9QWxHRAvZUGOdRQ7cvqRXaqI=
-----END CERTIFICATE-----
`, intelIasRootCaPem = `-----BEGIN CERTIFICATE-----
MIIFSzCCA7OgAwIBAgIJANEHdl0yo7CUMA0GCSqGSIb3DQEBCwUAMH4xCzAJBgNV
BAYTAlVTMQswCQYDVQQIDAJDQTEUMBIGA1UEBwwLU2FudGEgQ2xhcmExGjAYBgNV
BAoMEUludGVsIENvcnBvcmF0aW9uMTAwLgYDVQQDDCdJbnRlbCBTR1ggQXR0ZXN0
YXRpb24gUmVwb3J0IFNpZ25pbmcgQ0EwIBcNMTYxMTE0MTUzNzMxWhgPMjA0OTEy
MzEyMzU5NTlaMH4xCzAJBgNVBAYTAlVTMQswCQYDVQQIDAJDQTEUMBIGA1UEBwwL
U2FudGEgQ2xhcmExGjAYBgNVBAoMEUludGVsIENvcnBvcmF0aW9uMTAwLgYDVQQD
DCdJbnRlbCBTR1ggQXR0ZXN0YXRpb24gUmVwb3J0IFNpZ25pbmcgQ0EwggGiMA0G
CSqGSIb3DQEBAQUAA4IBjwAwggGKAoIBgQCfPGR+tXc8u1EtJzLA10Feu1Wg+p7e
LmSRmeaCHbkQ1TF3Nwl3RmpqXkeGzNLd69QUnWovYyVSndEMyYc3sHecGgfinEeh
rgBJSEdsSJ9FpaFdesjsxqzGRa20PYdnnfWcCTvFoulpbFR4VBuXnnVLVzkUvlXT
L/TAnd8nIZk0zZkFJ7P5LtePvykkar7LcSQO85wtcQe0R1Raf/sQ6wYKaKmFgCGe
NpEJUmg4ktal4qgIAxk+QHUxQE42sxViN5mqglB0QJdUot/o9a/V/mMeH8KvOAiQ
byinkNndn+Bgk5sSV5DFgF0DffVqmVMblt5p3jPtImzBIH0QQrXJq39AT8cRwP5H
afuVeLHcDsRp6hol4P+ZFIhu8mmbI1u0hH3W/0C2BuYXB5PC+5izFFh/nP0lc2Lf
6rELO9LZdnOhpL1ExFOq9H/B8tPQ84T3Sgb4nAifDabNt/zu6MmCGo5U8lwEFtGM
RoOaX4AS+909x00lYnmtwsDVWv9vBiJCXRsCAwEAAaOByTCBxjBgBgNVHR8EWTBX
MFWgU6BRhk9odHRwOi8vdHJ1c3RlZHNlcnZpY2VzLmludGVsLmNvbS9jb250ZW50
L0NSTC9TR1gvQXR0ZXN0YXRpb25SZXBvcnRTaWduaW5nQ0EuY3JsMB0GA1UdDgQW
BBR4Q3t2pn680K9+QjfrNXw7hwFRPDAfBgNVHSMEGDAWgBR4Q3t2pn680K9+Qjfr
NXw7hwFRPDAOBgNVHQ8BAf8EBAMCAQYwEgYDVR0TAQH/BAgwBgEB/wIBADANBgkq
hkiG9w0BAQsFAAOCAYEAeF8tYMXICvQqeXYQITkV2oLJsp6J4JAqJabHWxYJHGir
IEqucRiJSSx+HjIJEUVaj8E0QjEud6Y5lNmXlcjqRXaCPOqK0eGRz6hi+ripMtPZ
sFNaBwLQVV905SDjAzDzNIDnrcnXyB4gcDFCvwDFKKgLRjOB/WAqgscDUoGq5ZVi
zLUzTqiQPmULAQaB9c6Oti6snEFJiCQ67JLyW/E83/frzCmO5Ru6WjU4tmsmy8Ra
Ud4APK0wZTGtfPXU7w+IBdG5Ez0kE1qzxGQaL4gINJ1zMyleDnbuS8UicjJijvqA
152Sq049ESDz+1rRGc2NVEqh1KaGXmtXvqxXcTB+Ljy5Bw2ke0v8iGngFBPqCTVB
3op5KBG3RjbF6RRSzwzuWfL7QErNC8WEy5yDVARzTA5+xmBc388v9Dm21HGfcC8O
DD+gT9sSpssq0ascmvH49MOgjt1yoysLtdCtJW/9FZpoOypaHx0R+mJTLwPXVMrv
DaVzWh5aiEx+idkSGMnX
-----END CERTIFICATE-----
`;
function getU8Slice(u, r, a) {
  const e = new Uint8Array(a);
  for (let n = 0; n < a; n++)
    e[n] = u.getUint8(r + n);
  return e;
}
function verifyECDSASignature(u, r, a) {
  if (r.length !== 64)
    throw new Error("Invalid signature length");
  const e = new KJUR_1.crypto.Signature({
    alg: "SHA256withECDSA"
  });
  e.init(u), e.updateHex(lib.util.binary.hex.encode(a));
  const n = KJUR_1.crypto.ECDSA.hexRSSigToASN1Sig(
    lib.util.binary.hex.encode(r.slice(0, 32)),
    lib.util.binary.hex.encode(r.slice(32, 64))
  );
  return e.verify(n);
}
class Quote {
  quoteBasename;
  quoteEpidGroupId;
  quotePceSvn;
  quoteQeSvn;
  quoteSignType;
  quoteVersion;
  quoteXeid;
  reportCpusvn;
  reportData;
  reportFlags;
  reportIsvprodid;
  reportIsvsvn;
  reportMrenclave;
  reportMrsigner;
  constructor(r) {
    const a = lib.util.binary.base64.decode(r), e = a.buffer.slice(
      a.byteOffset,
      a.byteOffset + a.byteLength
    ), n = new DataView(e);
    this.quoteVersion = n.getUint16(0, !0), this.quoteSignType = n.getUint16(2, !0), this.quoteEpidGroupId = getU8Slice(n, 4, 4), this.quoteQeSvn = n.getUint16(8, !0), this.quotePceSvn = n.getUint16(10, !0), this.quoteXeid = n.getUint32(12, !0), this.quoteBasename = getU8Slice(n, 16, 32);
    const o = a.buffer.slice(
      a.byteOffset + 48,
      a.byteOffset + 48 + 384
    ), c = new DataView(o);
    this.reportCpusvn = getU8Slice(c, 0, 16), this.reportFlags = c.getUint32(48, !0), this.reportMrenclave = getU8Slice(c, 64, 32), this.reportMrsigner = getU8Slice(c, 128, 32), this.reportIsvprodid = c.getUint16(256, !0), this.reportIsvsvn = c.getUint16(258, !0), this.reportData = getU8Slice(c, 320, 64);
  }
}
class BitFlags {
  static fromBigInt(r, a) {
    let e = r.toString(2);
    for (; e.length < (a || 2); )
      e = "0" + e;
    return e = e.split("").reverse().join(""), new BitFlags(e, a);
  }
  flags;
  size;
  constructor(r, a) {
    this.flags = r, this.size = a;
  }
  contains(r) {
    return this.flags[r] !== "0";
  }
}
var IASAttributeFlags = /* @__PURE__ */ ((u) => (u[u.INIT = 0] = "INIT", u[u.DEBUG = 1] = "DEBUG", u[u.MODE64BIT = 2] = "MODE64BIT", u[u.PROVISIONKEY = 3] = "PROVISIONKEY", u[u.EINITTOKENKEY = 4] = "EINITTOKENKEY", u))(IASAttributeFlags || {});
class Verification {
  attestationSpecification;
  checkKnownRootCa;
  constructor(r) {
    this.attestationSpecification = r, this.checkKnownRootCa = !0;
  }
  /**
   * Warning: this is unsafe to do, only do this if you deliberately want to test fake roots (e.g. for mocked enclaves)
   */
  disableKnownRootCaCheck() {
    this.checkKnownRootCa = !1;
  }
  /**
   * Throws if verification fails
   * @param  {string} certificate
   * @param  {string} iasOkResp
   * @param  {string} iasOkSig
   * @returns Quote
   */
  verifyEpid(r) {
    if (!this.attestationSpecification.intelEpid)
      throw new Error("Incompatible attestation specification, expected EPID");
    const a = this.attestationSpecification.intelEpid, e = lib.util.binary.raw.encode(r.iasCertificate), n = r.iasSignature, o = lib.util.binary.raw.encode(r.iasResponseBody), c = lib.pki.certificateFromAsn1(
      lib.asn1.fromDer(lib.util.binary.raw.encode(r.iasRootCaDer))
    ), l = lib.pki.createCaStore();
    l.addCertificate(c);
    const d = lib.pki.certificateFromPem(e);
    if (!lib.pki.verifyCertificateChain(l, [d]))
      throw new Error("Could not verify certificate");
    const h = d.publicKey, g = lib.md.sha256.create();
    if (g.update(o), !h.verify(
      g.digest().bytes(),
      lib.util.binary.raw.encode(n)
    ))
      throw new Error("Could not verify signature");
    const v = JSON.parse(o), m = new Quote(v.isvEnclaveQuoteBody), b = v.isvEnclaveQuoteStatus;
    switch (b) {
      case "OK":
        break;
      case "CONFIGURATION_NEEDED":
        if (!a.acceptConfigurationNeeded)
          throw new Error("Status CONFIGURATION_NEEDED not accepted");
        break;
      case "GROUP_OUT_OF_DATE":
        if (!a.acceptGroupOutOfDate)
          throw new Error("Status GROUP_OUT_OF_DATE not accepted");
        break;
      default:
        throw new Error(
          `Status ${b} not accepted. Check: https://api.trustedservices.intel.com/documents/sgx-attestation-api-spec.pdf`
        );
    }
    const R = BitFlags.fromBigInt(BigInt(m.reportFlags), 8);
    if (!R.contains(
      0
      /* INIT */
    ))
      throw new Error("INIT flat not set in report");
    if (!R.contains(
      2
      /* MODE64BIT */
    ))
      throw new Error("32bit report not accepted");
    if (R.contains(
      1
      /* DEBUG */
    ) && !a.acceptDebug)
      throw new Error("DEBUG flag set in report. Not accepted");
    if (a.mrenclave) {
      const $ = lib.util.binary.hex.encode(
        m.reportMrenclave
      );
      if ($ !== lib.util.binary.hex.encode(a.mrenclave))
        throw new Error(
          `Wrong measurement, expected measurement: ${a.mrenclave}, actual measurement: ${$}`
        );
    } else
      throw new Error("MRENCLAVE missing");
    return m.reportData.slice(0, 32);
  }
  get_cert(r) {
    const e = new DataView(r.buffer, r.byteOffset, r.byteLength).getUint16(1012, !0), n = r.slice(1014 + e + 2 + 4);
    return new TextDecoder("utf-8").decode(n);
  }
  get_cpusvn(r) {
    return [
      r.sgxtcbcomp01svn,
      r.sgxtcbcomp02svn,
      r.sgxtcbcomp03svn,
      r.sgxtcbcomp04svn,
      r.sgxtcbcomp05svn,
      r.sgxtcbcomp06svn,
      r.sgxtcbcomp07svn,
      r.sgxtcbcomp08svn,
      r.sgxtcbcomp09svn,
      r.sgxtcbcomp10svn,
      r.sgxtcbcomp11svn,
      r.sgxtcbcomp12svn,
      r.sgxtcbcomp13svn,
      r.sgxtcbcomp14svn,
      r.sgxtcbcomp15svn,
      r.sgxtcbcomp16svn
    ];
  }
  compare_cpusvns(r, a) {
    if (r.length !== a.length)
      throw new Error("cpu svn lenghts don't match");
    const e = r.length;
    for (let n = 0; n < e; n++)
      if (r[n] < a[n])
        return !1;
    return !0;
  }
  dcapCheckStatus(r, a) {
    if (!(r === "UpToDate" || r === "SWHardeningNeeded") && !(a.acceptOutOfDate && (r === "OutOfDate" || r === "OutOfDateConfigurationNeeded")) && !(a.acceptConfigurationNeeded && (r === "ConfigurationNeeded" || r === "OutOfDateConfigurationNeeded" || r === "ConfigurationAndSWHardeningNeeded")) && !(a.acceptRevoked && r === "Revoked"))
      throw new Error(`TCB status ${r} not accepted`);
  }
  async verifyDcapInner(r, a) {
    const e = new X509Certificate(
      lib.util.binary.base64.encode(a.dcapRootCaDer)
    ).toString(), n = r.dcapQuote, o = lib.util.binary.raw.encode(r.tcbInfo), c = lib.util.binary.raw.encode(r.qeIdentity), l = new TextDecoder().decode(r.tcbSignCert), d = lib.util.binary.raw.encode(r.qeSignCert), p = this.get_cert(n), h = PemConverter.decode(p), g = new X509Certificate(h[0]), y = [];
    for (let N = h.length - 1; N > 0; N -= 1)
      y.push(new X509Certificate(h[N]));
    const v = new X509ChainBuilder({
      certificates: y
    });
    try {
      const N = await v.build(g);
      if (N.length == 0 || N[N.length - 1].toString() != e)
        throw new Error("PCK certificate chain is invalid");
    } catch (N) {
      throw new Error(`Could not verify PCK certificate: ${N}`);
    }
    if (!verifyECDSASignature(
      g.publicKey.toString("pem"),
      n.slice(948, 1012),
      n.slice(564, 948)
    ))
      throw new Error("Could not verify PCK signature");
    const m = BitFlags.fromBigInt(BigInt(n[96]), 8);
    if (!m.contains(
      0
      /* INIT */
    ))
      throw new Error("INIT flat not set in report");
    if (!m.contains(
      2
      /* MODE64BIT */
    ))
      throw new Error("32bit report not accepted");
    if (m.contains(
      1
      /* DEBUG */
    ) && !a.acceptDebug)
      throw new Error("DEBUG flag set in report. Not accepted");
    const b = JSON.parse(o), R = b.tcbInfo, $ = b.signature, x = new X509Certificate(l);
    try {
      const N = await v.build(x);
      if (N.length == 0 || N[N.length - 1].toString() != e)
        throw new Error("TCBInfo certificate chain is invalid");
    } catch {
      throw new Error("Could not verify TCBInfo certificate");
    }
    if (!verifyECDSASignature(
      x.publicKey.toString("pem"),
      lib.util.binary.hex.decode($),
      new TextEncoder().encode(JSON.stringify(R))
    ))
      throw new Error("Could not verify TCBInfo signature");
    let E = !1;
    const T = Array.from(n.slice(48, 64)), P = new DataView(n.buffer).getInt16(
      n.byteOffset + 10,
      !0
    );
    for (const N of R.tcbLevels) {
      const F = this.get_cpusvn(N.tcb);
      if (this.compare_cpusvns(T, F) && P >= N.tcb.pcesvn) {
        E = !0, this.dcapCheckStatus(N.tcbStatus, a);
        break;
      }
    }
    if (!E)
      throw new Error("TCB Level Out of Date");
    const O = JSON.parse(c), w = O.enclaveIdentity, _ = O.signature, C = new X509Certificate(d);
    try {
      const N = await v.build(C);
      if (N.length == 0 || N[N.length - 1].toString() != e)
        throw new Error("QE Identity certificate chain is invalid");
    } catch {
      throw new Error("Could not verify QE Identity certificate");
    }
    if (!verifyECDSASignature(
      C.publicKey.toString("pem"),
      lib.util.binary.hex.decode(_),
      new TextEncoder().encode(JSON.stringify(w))
    ))
      throw new Error("Could not verify QE Identity signature");
    if (lib.util.binary.hex.encode(n.slice(692, 724)).toUpperCase() !== w.mrsigner)
      throw new Error("Different mrsigner values for Quoting Enclave Identity");
    if (n[820] + n[821] * 256 !== w.isvprodid)
      throw new Error(
        "Different isvprodid values for Quoting Enclave Identity"
      );
    let j = !1;
    const J = n[822] + n[823] * 256;
    for (const N of w.tcbLevels)
      if (N.tcb.isvsvn <= J) {
        if (j = !0, N.tcbStatus !== "UpToDate")
          throw new Error(
            `Quoting Enclave TCB status ${N.tcbStatus} not accepted`
          );
        break;
      }
    if (!j)
      throw new Error("QE TCB Level Out of Date");
    return n;
  }
  async verifyDcap(r) {
    if (!this.attestationSpecification.intelDcap)
      throw new Error("Incompatible attestation specification, expected DCAP");
    const a = this.attestationSpecification.intelDcap, e = await this.verifyDcapInner(r, a);
    if (a.mrenclave) {
      const n = lib.util.binary.hex.encode(e.slice(112, 144));
      if (n !== lib.util.binary.hex.encode(a.mrenclave))
        throw new Error(
          `Wrong measurement, expected measurement: ${a.mrenclave}, actual measurement: ${n}`
        );
    } else
      throw new Error("MRENCLAVE missing");
    return e.slice(368, 400);
  }
  async verifyDcapMrsigner(r) {
    if (!this.attestationSpecification.intelDcapMrsigner)
      throw new Error(
        "Incompatible attestation specification, expected DcapMrsigner"
      );
    const a = this.attestationSpecification.intelDcapMrsigner, e = await this.verifyDcapInner(r, a);
    if (a.mrsigner) {
      const y = lib.util.binary.hex.encode(e.slice(176, 208));
      if (y !== lib.util.binary.hex.encode(a.mrsigner))
        throw new Error(
          `Wrong mrsigner, expected mrsigner: ${a.mrsigner}, actual mrsigner: ${y}`
        );
    } else
      throw new Error("MRSIGNER missing");
    const n = a.isvprodid ? a.isvprodid : 0, d = new DataView(e.buffer, e.byteOffset, e.byteLength).getUint16(304, !0);
    if (d !== n)
      throw new Error(
        `Wrong isvprodid, expected isvprodid: ${a.isvprodid}, actual isvprodid: ${d}`
      );
    if (a.sigstoreRootOlpcJson == null)
      throw new Error("sigstoreRootOlpcJson not set in attestation spec");
    if (r.sigstoreEvidence == null)
      throw new Error("sigstoreEvidence not set in fatquote");
    const p = a.sigstoreRootOlpcJson, h = attestation.SigstoreEvidence.encodeDelimited(
      r.sigstoreEvidence
    ).finish(), g = e.slice(112, 144);
    return verify_measurement_transparency(
      h,
      p,
      g
    ), e.slice(368, 400);
  }
  async verify(r) {
    if (this.checkKnownRootCa)
      if (r.epid) {
        const a = lib.util.binary.raw.encode(
          r.epid.iasRootCaDer
        ), e = lib.util.binary.raw.encode(
          new Uint8Array(new X509Certificate(intelIasRootCaPem).rawData)
        );
        if (a !== e)
          throw new Error(
            "Intel IAS Root CA in fatquote does not match known value"
          );
      } else if (r.dcap) {
        const a = lib.util.binary.raw.encode(
          r.dcap.dcapRootCaDer
        ), e = lib.util.binary.raw.encode(
          new Uint8Array(new X509Certificate(intelDcapRootCaPem).rawData)
        );
        if (a !== e)
          throw new Error(
            "Intel DCAP Root CA in fatquote does not match known value"
          );
      } else if (r.dcapMrsigner) {
        const a = lib.util.binary.raw.encode(
          r.dcapMrsigner.dcapRootCaDer
        ), e = lib.util.binary.raw.encode(
          new Uint8Array(new X509Certificate(intelDcapRootCaPem).rawData)
        );
        if (a !== e)
          throw new Error(
            "Intel DCAP Root CA in fatquote does not match known value"
          );
      } else
        throw new Error(`Unknown fatquote type: ${r}`);
    else
      console.warn(
        "!!!WARNING!!! MOCKED QUOTE is being accepted, quote is NOT to be trusted !!!WARNING!!!"
      );
    if (r.epid)
      return this.verifyEpid(r.epid);
    if (r.dcap)
      return this.verifyDcap(r.dcap);
    if (r.dcapMrsigner)
      return this.verifyDcapMrsigner(r.dcapMrsigner);
    throw new Error(`Unknown fatquote type: ${r}`);
  }
}
export {
  IASAttributeFlags,
  Quote,
  Verification,
  intelDcapRootCaPem,
  intelIasRootCaPem
};
//# sourceMappingURL=index.js.map
